
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec400"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec400"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gBhAd", function(module, exports) {

$parcel$export(module.exports, "extend", function () { return extend; });
$parcel$export(module.exports, "Color", function () { return Color; });
$parcel$export(module.exports, "Point", function () { return Point; });
$parcel$export(module.exports, "Matrix", function () { return Matrix; });
$parcel$export(module.exports, "Element", function () { return Element; });
$parcel$export(module.exports, "Box", function () { return Box; });
$parcel$export(module.exports, "on", function () { return on; });
$parcel$export(module.exports, "off", function () { return off; });
$parcel$export(module.exports, "Number", function () { return SVGNumber; });
$parcel$export(module.exports, "Defs", function () { return Defs; });
$parcel$export(module.exports, "PointArray", function () { return PointArray; });
$parcel$export(module.exports, "Line", function () { return Line; });
$parcel$export(module.exports, "Svg", function () { return Svg; });
$parcel$export(module.exports, "Symbol", function () { return Symbol; });
$parcel$export(module.exports, "Text", function () { return Text; });
$parcel$export(module.exports, "G", function () { return G; });
$parcel$export(module.exports, "SVG", function () { return SVG; });
const methods$1 = {};
const names = [];
function registerMethods(name, m) {
    if (Array.isArray(name)) {
        for (const _name of name)registerMethods(_name, m);
        return;
    }
    if (typeof name === "object") {
        for(const _name in name)registerMethods(_name, name[_name]);
        return;
    }
    addMethodNames(Object.getOwnPropertyNames(m));
    methods$1[name] = Object.assign(methods$1[name] || {}, m);
}
function getMethodsFor(name) {
    return methods$1[name] || {};
}
function getMethodNames() {
    return [
        ...new Set(names)
    ];
}
function addMethodNames(_names) {
    names.push(..._names);
}
// Map function
function map(array, block) {
    let i;
    const il = array.length;
    const result = [];
    for(i = 0; i < il; i++)result.push(block(array[i]));
    return result;
}
// Filter function
function filter(array, block) {
    let i;
    const il = array.length;
    const result = [];
    for(i = 0; i < il; i++)if (block(array[i])) result.push(array[i]);
    return result;
}
// Degrees to radians
function radians(d) {
    return d % 360 * Math.PI / 180;
}
// Radians to degrees
function degrees(r) {
    return r * 180 / Math.PI % 360;
}
// Convert camel cased string to dash separated
function unCamelCase(s) {
    return s.replace(/([A-Z])/g, function(m, g) {
        return "-" + g.toLowerCase();
    });
}
// Capitalize first letter of a string
function capitalize(s) {
    return s.charAt(0).toUpperCase() + s.slice(1);
}
// Calculate proportional width and height values when necessary
function proportionalSize(element, width, height, box) {
    if (width == null || height == null) {
        box = box || element.bbox();
        if (width == null) width = box.width / box.height * height;
        else if (height == null) height = box.height / box.width * width;
    }
    return {
        width: width,
        height: height
    };
}
/**
 * This function adds support for string origins.
 * It searches for an origin in o.origin o.ox and o.originX.
 * This way, origin: {x: 'center', y: 50} can be passed as well as ox: 'center', oy: 50
 **/ function getOrigin(o, element) {
    const origin = o.origin;
    // First check if origin is in ox or originX
    let ox = o.ox != null ? o.ox : o.originX != null ? o.originX : "center";
    let oy = o.oy != null ? o.oy : o.originY != null ? o.originY : "center";
    // Then check if origin was used and overwrite in that case
    if (origin != null) [ox, oy] = Array.isArray(origin) ? origin : typeof origin === "object" ? [
        origin.x,
        origin.y
    ] : [
        origin,
        origin
    ];
    // Make sure to only call bbox when actually needed
    const condX = typeof ox === "string";
    const condY = typeof oy === "string";
    if (condX || condY) {
        const { height, width, x, y } = element.bbox();
        // And only overwrite if string was passed for this specific axis
        if (condX) ox = ox.includes("left") ? x : ox.includes("right") ? x + width : x + width / 2;
        if (condY) oy = oy.includes("top") ? y : oy.includes("bottom") ? y + height : y + height / 2;
    }
    // Return the origin as it is if it wasn't a string
    return [
        ox,
        oy
    ];
}
const descriptiveElements = new Set([
    "desc",
    "metadata",
    "title"
]);
const isDescriptive = (element)=>descriptiveElements.has(element.nodeName);
const writeDataToDom = (element, data, defaults = {})=>{
    const cloned = {
        ...data
    };
    for(const key in cloned)if (cloned[key].valueOf() === defaults[key]) delete cloned[key];
    if (Object.keys(cloned).length) element.node.setAttribute("data-svgjs", JSON.stringify(cloned)); // see #428
    else {
        element.node.removeAttribute("data-svgjs");
        element.node.removeAttribute("svgjs:data");
    }
};
var utils = {
    __proto__: null,
    capitalize: capitalize,
    degrees: degrees,
    filter: filter,
    getOrigin: getOrigin,
    isDescriptive: isDescriptive,
    map: map,
    proportionalSize: proportionalSize,
    radians: radians,
    unCamelCase: unCamelCase,
    writeDataToDom: writeDataToDom
};
// Default namespaces
const svg = "http://www.w3.org/2000/svg";
const html = "http://www.w3.org/1999/xhtml";
const xmlns = "http://www.w3.org/2000/xmlns/";
const xlink = "http://www.w3.org/1999/xlink";
var namespaces = {
    __proto__: null,
    html: html,
    svg: svg,
    xlink: xlink,
    xmlns: xmlns
};
const globals = {
    window: typeof window === "undefined" ? null : window,
    document: typeof document === "undefined" ? null : document
};
function registerWindow(win = null, doc = null) {
    globals.window = win;
    globals.document = doc;
}
const save = {};
function saveWindow() {
    save.window = globals.window;
    save.document = globals.document;
}
function restoreWindow() {
    globals.window = save.window;
    globals.document = save.document;
}
function withWindow(win, fn) {
    saveWindow();
    registerWindow(win, win.document);
    fn(win, win.document);
    restoreWindow();
}
function getWindow() {
    return globals.window;
}
class Base {
}
const elements = {};
const root = "___SYMBOL___ROOT___";
// Method for element creation
function create(name, ns = svg) {
    // create element
    return globals.document.createElementNS(ns, name);
}
function makeInstance(element, isHTML = false) {
    if (element instanceof Base) return element;
    if (typeof element === "object") return adopter(element);
    if (element == null) return new elements[root]();
    if (typeof element === "string" && element.charAt(0) !== "<") return adopter(globals.document.querySelector(element));
    // Make sure, that HTML elements are created with the correct namespace
    const wrapper = isHTML ? globals.document.createElement("div") : create("svg");
    wrapper.innerHTML = element;
    // We can use firstChild here because we know,
    // that the first char is < and thus an element
    element = adopter(wrapper.firstChild);
    // make sure, that element doesn't have its wrapper attached
    wrapper.removeChild(wrapper.firstChild);
    return element;
}
function nodeOrNew(name, node) {
    return node && (node instanceof globals.window.Node || node.ownerDocument && node instanceof node.ownerDocument.defaultView.Node) ? node : create(name);
}
// Adopt existing svg elements
function adopt(node) {
    // check for presence of node
    if (!node) return null;
    // make sure a node isn't already adopted
    if (node.instance instanceof Base) return node.instance;
    if (node.nodeName === "#document-fragment") return new elements.Fragment(node);
    // initialize variables
    let className = capitalize(node.nodeName || "Dom");
    // Make sure that gradients are adopted correctly
    if (className === "LinearGradient" || className === "RadialGradient") className = "Gradient";
    else if (!elements[className]) className = "Dom";
    return new elements[className](node);
}
let adopter = adopt;
function mockAdopt(mock = adopt) {
    adopter = mock;
}
function register(element, name = element.name, asRoot = false) {
    elements[name] = element;
    if (asRoot) elements[root] = element;
    addMethodNames(Object.getOwnPropertyNames(element.prototype));
    return element;
}
function getClass(name) {
    return elements[name];
}
// Element id sequence
let did = 1000;
// Get next named element id
function eid(name) {
    return "Svgjs" + capitalize(name) + did++;
}
// Deep new id assignment
function assignNewId(node) {
    // do the same for SVG child nodes as well
    for(let i = node.children.length - 1; i >= 0; i--)assignNewId(node.children[i]);
    if (node.id) {
        node.id = eid(node.nodeName);
        return node;
    }
    return node;
}
// Method for extending objects
function extend(modules, methods) {
    let key, i;
    modules = Array.isArray(modules) ? modules : [
        modules
    ];
    for(i = modules.length - 1; i >= 0; i--)for(key in methods)modules[i].prototype[key] = methods[key];
}
function wrapWithAttrCheck(fn) {
    return function(...args) {
        const o = args[args.length - 1];
        if (o && o.constructor === Object && !(o instanceof Array)) return fn.apply(this, args.slice(0, -1)).attr(o);
        else return fn.apply(this, args);
    };
}
// Get all siblings, including myself
function siblings() {
    return this.parent().children();
}
// Get the current position siblings
function position() {
    return this.parent().index(this);
}
// Get the next element (will return null if there is none)
function next() {
    return this.siblings()[this.position() + 1];
}
// Get the next element (will return null if there is none)
function prev() {
    return this.siblings()[this.position() - 1];
}
// Send given element one step forward
function forward() {
    const i = this.position();
    const p = this.parent();
    // move node one step forward
    p.add(this.remove(), i + 1);
    return this;
}
// Send given element one step backward
function backward() {
    const i = this.position();
    const p = this.parent();
    p.add(this.remove(), i ? i - 1 : 0);
    return this;
}
// Send given element all the way to the front
function front() {
    const p = this.parent();
    // Move node forward
    p.add(this.remove());
    return this;
}
// Send given element all the way to the back
function back() {
    const p = this.parent();
    // Move node back
    p.add(this.remove(), 0);
    return this;
}
// Inserts a given element before the targeted element
function before(element) {
    element = makeInstance(element);
    element.remove();
    const i = this.position();
    this.parent().add(element, i);
    return this;
}
// Inserts a given element after the targeted element
function after(element) {
    element = makeInstance(element);
    element.remove();
    const i = this.position();
    this.parent().add(element, i + 1);
    return this;
}
function insertBefore(element) {
    element = makeInstance(element);
    element.before(this);
    return this;
}
function insertAfter(element) {
    element = makeInstance(element);
    element.after(this);
    return this;
}
registerMethods("Dom", {
    siblings: siblings,
    position: position,
    next: next,
    prev: prev,
    forward: forward,
    backward: backward,
    front: front,
    back: back,
    before: before,
    after: after,
    insertBefore: insertBefore,
    insertAfter: insertAfter
});
// Parse unit value
const numberAndUnit = /^([+-]?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?)([a-z%]*)$/i;
// Parse hex value
const hex = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i;
// Parse rgb value
const rgb = /rgb\((\d+),(\d+),(\d+)\)/;
// Parse reference id
const reference = /(#[a-z_][a-z0-9\-_]*)/i;
// splits a transformation chain
const transforms = /\)\s*,?\s*/;
// Whitespace
const whitespace = /\s/g;
// Test hex value
const isHex = /^#[a-f0-9]{3}$|^#[a-f0-9]{6}$/i;
// Test rgb value
const isRgb = /^rgb\(/;
// Test for blank string
const isBlank = /^(\s+)?$/;
// Test for numeric string
const isNumber = /^[+-]?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i;
// Test for image url
const isImage = /\.(jpg|jpeg|png|gif|svg)(\?[^=]+.*)?/i;
// split at whitespace and comma
const delimiter = /[\s,]+/;
// Test for path letter
const isPathLetter = /[MLHVCSQTAZ]/i;
var regex = {
    __proto__: null,
    delimiter: delimiter,
    hex: hex,
    isBlank: isBlank,
    isHex: isHex,
    isImage: isImage,
    isNumber: isNumber,
    isPathLetter: isPathLetter,
    isRgb: isRgb,
    numberAndUnit: numberAndUnit,
    reference: reference,
    rgb: rgb,
    transforms: transforms,
    whitespace: whitespace
};
// Return array of classes on the node
function classes() {
    const attr = this.attr("class");
    return attr == null ? [] : attr.trim().split(delimiter);
}
// Return true if class exists on the node, false otherwise
function hasClass(name) {
    return this.classes().indexOf(name) !== -1;
}
// Add class to the node
function addClass(name) {
    if (!this.hasClass(name)) {
        const array = this.classes();
        array.push(name);
        this.attr("class", array.join(" "));
    }
    return this;
}
// Remove class from the node
function removeClass(name) {
    if (this.hasClass(name)) this.attr("class", this.classes().filter(function(c) {
        return c !== name;
    }).join(" "));
    return this;
}
// Toggle the presence of a class on the node
function toggleClass(name) {
    return this.hasClass(name) ? this.removeClass(name) : this.addClass(name);
}
registerMethods("Dom", {
    classes: classes,
    hasClass: hasClass,
    addClass: addClass,
    removeClass: removeClass,
    toggleClass: toggleClass
});
// Dynamic style generator
function css(style, val) {
    const ret = {};
    if (arguments.length === 0) {
        // get full style as object
        this.node.style.cssText.split(/\s*;\s*/).filter(function(el) {
            return !!el.length;
        }).forEach(function(el) {
            const t = el.split(/\s*:\s*/);
            ret[t[0]] = t[1];
        });
        return ret;
    }
    if (arguments.length < 2) {
        // get style properties as array
        if (Array.isArray(style)) {
            for (const name of style){
                const cased = name;
                ret[name] = this.node.style.getPropertyValue(cased);
            }
            return ret;
        }
        // get style for property
        if (typeof style === "string") return this.node.style.getPropertyValue(style);
        // set styles in object
        if (typeof style === "object") for(const name in style)// set empty string if null/undefined/'' was given
        this.node.style.setProperty(name, style[name] == null || isBlank.test(style[name]) ? "" : style[name]);
    }
    // set style for property
    if (arguments.length === 2) this.node.style.setProperty(style, val == null || isBlank.test(val) ? "" : val);
    return this;
}
// Show element
function show() {
    return this.css("display", "");
}
// Hide element
function hide() {
    return this.css("display", "none");
}
// Is element visible?
function visible() {
    return this.css("display") !== "none";
}
registerMethods("Dom", {
    css: css,
    show: show,
    hide: hide,
    visible: visible
});
// Store data values on svg nodes
function data(a, v, r) {
    if (a == null) // get an object of attributes
    return this.data(map(filter(this.node.attributes, (el)=>el.nodeName.indexOf("data-") === 0), (el)=>el.nodeName.slice(5)));
    else if (a instanceof Array) {
        const data = {};
        for (const key of a)data[key] = this.data(key);
        return data;
    } else if (typeof a === "object") for(v in a)this.data(v, a[v]);
    else if (arguments.length < 2) try {
        return JSON.parse(this.attr("data-" + a));
    } catch (e) {
        return this.attr("data-" + a);
    }
    else this.attr("data-" + a, v === null ? null : r === true || typeof v === "string" || typeof v === "number" ? v : JSON.stringify(v));
    return this;
}
registerMethods("Dom", {
    data: data
});
// Remember arbitrary data
function remember(k, v) {
    // remember every item in an object individually
    if (typeof arguments[0] === "object") for(const key in k)this.remember(key, k[key]);
    else if (arguments.length === 1) // retrieve memory
    return this.memory()[k];
    else // store memory
    this.memory()[k] = v;
    return this;
}
// Erase a given memory
function forget() {
    if (arguments.length === 0) this._memory = {};
    else for(let i = arguments.length - 1; i >= 0; i--)delete this.memory()[arguments[i]];
    return this;
}
// This triggers creation of a new hidden class which is not performant
// However, this function is not rarely used so it will not happen frequently
// Return local memory object
function memory() {
    return this._memory = this._memory || {};
}
registerMethods("Dom", {
    remember: remember,
    forget: forget,
    memory: memory
});
function sixDigitHex(hex) {
    return hex.length === 4 ? [
        "#",
        hex.substring(1, 2),
        hex.substring(1, 2),
        hex.substring(2, 3),
        hex.substring(2, 3),
        hex.substring(3, 4),
        hex.substring(3, 4)
    ].join("") : hex;
}
function componentHex(component) {
    const integer = Math.round(component);
    const bounded = Math.max(0, Math.min(255, integer));
    const hex = bounded.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
}
function is(object, space) {
    for(let i = space.length; i--;){
        if (object[space[i]] == null) return false;
    }
    return true;
}
function getParameters(a, b) {
    const params = is(a, "rgb") ? {
        _a: a.r,
        _b: a.g,
        _c: a.b,
        _d: 0,
        space: "rgb"
    } : is(a, "xyz") ? {
        _a: a.x,
        _b: a.y,
        _c: a.z,
        _d: 0,
        space: "xyz"
    } : is(a, "hsl") ? {
        _a: a.h,
        _b: a.s,
        _c: a.l,
        _d: 0,
        space: "hsl"
    } : is(a, "lab") ? {
        _a: a.l,
        _b: a.a,
        _c: a.b,
        _d: 0,
        space: "lab"
    } : is(a, "lch") ? {
        _a: a.l,
        _b: a.c,
        _c: a.h,
        _d: 0,
        space: "lch"
    } : is(a, "cmyk") ? {
        _a: a.c,
        _b: a.m,
        _c: a.y,
        _d: a.k,
        space: "cmyk"
    } : {
        _a: 0,
        _b: 0,
        _c: 0,
        space: "rgb"
    };
    params.space = b || params.space;
    return params;
}
function cieSpace(space) {
    if (space === "lab" || space === "xyz" || space === "lch") return true;
    else return false;
}
function hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
class Color {
    constructor(...inputs){
        this.init(...inputs);
    }
    // Test if given value is a color
    static isColor(color) {
        return color && (color instanceof Color || this.isRgb(color) || this.test(color));
    }
    // Test if given value is an rgb object
    static isRgb(color) {
        return color && typeof color.r === "number" && typeof color.g === "number" && typeof color.b === "number";
    }
    /*
  Generating random colors
  */ static random(mode = "vibrant", t) {
        // Get the math modules
        const { random, round, sin, PI: pi } = Math;
        // Run the correct generator
        if (mode === "vibrant") {
            const l = 24 * random() + 57;
            const c = 38 * random() + 45;
            const h = 360 * random();
            const color = new Color(l, c, h, "lch");
            return color;
        } else if (mode === "sine") {
            t = t == null ? random() : t;
            const r = round(80 * sin(2 * pi * t / 0.5 + 0.01) + 150);
            const g = round(50 * sin(2 * pi * t / 0.5 + 4.6) + 200);
            const b = round(100 * sin(2 * pi * t / 0.5 + 2.3) + 150);
            const color = new Color(r, g, b);
            return color;
        } else if (mode === "pastel") {
            const l = 8 * random() + 86;
            const c = 17 * random() + 9;
            const h = 360 * random();
            const color = new Color(l, c, h, "lch");
            return color;
        } else if (mode === "dark") {
            const l = 10 + 10 * random();
            const c = 50 * random() + 86;
            const h = 360 * random();
            const color = new Color(l, c, h, "lch");
            return color;
        } else if (mode === "rgb") {
            const r = 255 * random();
            const g = 255 * random();
            const b = 255 * random();
            const color = new Color(r, g, b);
            return color;
        } else if (mode === "lab") {
            const l = 100 * random();
            const a = 256 * random() - 128;
            const b = 256 * random() - 128;
            const color = new Color(l, a, b, "lab");
            return color;
        } else if (mode === "grey") {
            const grey = 255 * random();
            const color = new Color(grey, grey, grey);
            return color;
        } else throw new Error("Unsupported random color mode");
    }
    // Test if given value is a color string
    static test(color) {
        return typeof color === "string" && (isHex.test(color) || isRgb.test(color));
    }
    cmyk() {
        // Get the rgb values for the current color
        const { _a, _b, _c } = this.rgb();
        const [r, g, b] = [
            _a,
            _b,
            _c
        ].map((v)=>v / 255);
        // Get the cmyk values in an unbounded format
        const k = Math.min(1 - r, 1 - g, 1 - b);
        if (k === 1) // Catch the black case
        return new Color(0, 0, 0, 1, "cmyk");
        const c = (1 - r - k) / (1 - k);
        const m = (1 - g - k) / (1 - k);
        const y = (1 - b - k) / (1 - k);
        // Construct the new color
        const color = new Color(c, m, y, k, "cmyk");
        return color;
    }
    hsl() {
        // Get the rgb values
        const { _a, _b, _c } = this.rgb();
        const [r, g, b] = [
            _a,
            _b,
            _c
        ].map((v)=>v / 255);
        // Find the maximum and minimum values to get the lightness
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        const l = (max + min) / 2;
        // If the r, g, v values are identical then we are grey
        const isGrey = max === min;
        // Calculate the hue and saturation
        const delta = max - min;
        const s = isGrey ? 0 : l > 0.5 ? delta / (2 - max - min) : delta / (max + min);
        const h = isGrey ? 0 : max === r ? ((g - b) / delta + (g < b ? 6 : 0)) / 6 : max === g ? ((b - r) / delta + 2) / 6 : max === b ? ((r - g) / delta + 4) / 6 : 0;
        // Construct and return the new color
        const color = new Color(360 * h, 100 * s, 100 * l, "hsl");
        return color;
    }
    init(a = 0, b = 0, c = 0, d = 0, space = "rgb") {
        // This catches the case when a falsy value is passed like ''
        a = !a ? 0 : a;
        // Reset all values in case the init function is rerun with new color space
        if (this.space) for(const component in this.space)delete this[this.space[component]];
        if (typeof a === "number") {
            // Allow for the case that we don't need d...
            space = typeof d === "string" ? d : space;
            d = typeof d === "string" ? 0 : d;
            // Assign the values straight to the color
            Object.assign(this, {
                _a: a,
                _b: b,
                _c: c,
                _d: d,
                space: space
            });
        // If the user gave us an array, make the color from it
        } else if (a instanceof Array) {
            this.space = b || (typeof a[3] === "string" ? a[3] : a[4]) || "rgb";
            Object.assign(this, {
                _a: a[0],
                _b: a[1],
                _c: a[2],
                _d: a[3] || 0
            });
        } else if (a instanceof Object) {
            // Set the object up and assign its values directly
            const values = getParameters(a, b);
            Object.assign(this, values);
        } else if (typeof a === "string") {
            if (isRgb.test(a)) {
                const noWhitespace = a.replace(whitespace, "");
                const [_a, _b, _c] = rgb.exec(noWhitespace).slice(1, 4).map((v)=>parseInt(v));
                Object.assign(this, {
                    _a: _a,
                    _b: _b,
                    _c: _c,
                    _d: 0,
                    space: "rgb"
                });
            } else if (isHex.test(a)) {
                const hexParse = (v)=>parseInt(v, 16);
                const [, _a, _b, _c] = hex.exec(sixDigitHex(a)).map(hexParse);
                Object.assign(this, {
                    _a: _a,
                    _b: _b,
                    _c: _c,
                    _d: 0,
                    space: "rgb"
                });
            } else throw Error("Unsupported string format, can't construct Color");
        }
        // Now add the components as a convenience
        const { _a, _b, _c, _d } = this;
        const components = this.space === "rgb" ? {
            r: _a,
            g: _b,
            b: _c
        } : this.space === "xyz" ? {
            x: _a,
            y: _b,
            z: _c
        } : this.space === "hsl" ? {
            h: _a,
            s: _b,
            l: _c
        } : this.space === "lab" ? {
            l: _a,
            a: _b,
            b: _c
        } : this.space === "lch" ? {
            l: _a,
            c: _b,
            h: _c
        } : this.space === "cmyk" ? {
            c: _a,
            m: _b,
            y: _c,
            k: _d
        } : {};
        Object.assign(this, components);
    }
    lab() {
        // Get the xyz color
        const { x, y, z } = this.xyz();
        // Get the lab components
        const l = 116 * y - 16;
        const a = 500 * (x - y);
        const b = 200 * (y - z);
        // Construct and return a new color
        const color = new Color(l, a, b, "lab");
        return color;
    }
    lch() {
        // Get the lab color directly
        const { l, a, b } = this.lab();
        // Get the chromaticity and the hue using polar coordinates
        const c = Math.sqrt(a ** 2 + b ** 2);
        let h = 180 * Math.atan2(b, a) / Math.PI;
        if (h < 0) {
            h *= -1;
            h = 360 - h;
        }
        // Make a new color and return it
        const color = new Color(l, c, h, "lch");
        return color;
    }
    /*
  Conversion Methods
  */ rgb() {
        if (this.space === "rgb") return this;
        else if (cieSpace(this.space)) {
            // Convert to the xyz color space
            let { x, y, z } = this;
            if (this.space === "lab" || this.space === "lch") {
                // Get the values in the lab space
                let { l, a, b } = this;
                if (this.space === "lch") {
                    const { c, h } = this;
                    const dToR = Math.PI / 180;
                    a = c * Math.cos(dToR * h);
                    b = c * Math.sin(dToR * h);
                }
                // Undo the nonlinear function
                const yL = (l + 16) / 116;
                const xL = a / 500 + yL;
                const zL = yL - b / 200;
                // Get the xyz values
                const ct = 16 / 116;
                const mx = 0.008856;
                const nm = 7.787;
                x = 0.95047 * (xL ** 3 > mx ? xL ** 3 : (xL - ct) / nm);
                y = 1.0 * (yL ** 3 > mx ? yL ** 3 : (yL - ct) / nm);
                z = 1.08883 * (zL ** 3 > mx ? zL ** 3 : (zL - ct) / nm);
            }
            // Convert xyz to unbounded rgb values
            const rU = x * 3.2406 + y * -1.5372 + z * -0.4986;
            const gU = x * -0.9689 + y * 1.8758 + z * 0.0415;
            const bU = x * 0.0557 + y * -0.204 + z * 1.057;
            // Convert the values to true rgb values
            const pow = Math.pow;
            const bd = 0.0031308;
            const r = rU > bd ? 1.055 * pow(rU, 1 / 2.4) - 0.055 : 12.92 * rU;
            const g = gU > bd ? 1.055 * pow(gU, 1 / 2.4) - 0.055 : 12.92 * gU;
            const b = bU > bd ? 1.055 * pow(bU, 1 / 2.4) - 0.055 : 12.92 * bU;
            // Make and return the color
            const color = new Color(255 * r, 255 * g, 255 * b);
            return color;
        } else if (this.space === "hsl") {
            // https://bgrins.github.io/TinyColor/docs/tinycolor.html
            // Get the current hsl values
            let { h, s, l } = this;
            h /= 360;
            s /= 100;
            l /= 100;
            // If we are grey, then just make the color directly
            if (s === 0) {
                l *= 255;
                const color = new Color(l, l, l);
                return color;
            }
            // TODO I have no idea what this does :D If you figure it out, tell me!
            const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            const p = 2 * l - q;
            // Get the rgb values
            const r = 255 * hueToRgb(p, q, h + 1 / 3);
            const g = 255 * hueToRgb(p, q, h);
            const b = 255 * hueToRgb(p, q, h - 1 / 3);
            // Make a new color
            const color = new Color(r, g, b);
            return color;
        } else if (this.space === "cmyk") {
            // https://gist.github.com/felipesabino/5066336
            // Get the normalised cmyk values
            const { c, m, y, k } = this;
            // Get the rgb values
            const r = 255 * (1 - Math.min(1, c * (1 - k) + k));
            const g = 255 * (1 - Math.min(1, m * (1 - k) + k));
            const b = 255 * (1 - Math.min(1, y * (1 - k) + k));
            // Form the color and return it
            const color = new Color(r, g, b);
            return color;
        } else return this;
    }
    toArray() {
        const { _a, _b, _c, _d, space } = this;
        return [
            _a,
            _b,
            _c,
            _d,
            space
        ];
    }
    toHex() {
        const [r, g, b] = this._clamped().map(componentHex);
        return `#${r}${g}${b}`;
    }
    toRgb() {
        const [rV, gV, bV] = this._clamped();
        const string = `rgb(${rV},${gV},${bV})`;
        return string;
    }
    toString() {
        return this.toHex();
    }
    xyz() {
        // Normalise the red, green and blue values
        const { _a: r255, _b: g255, _c: b255 } = this.rgb();
        const [r, g, b] = [
            r255,
            g255,
            b255
        ].map((v)=>v / 255);
        // Convert to the lab rgb space
        const rL = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
        const gL = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
        const bL = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
        // Convert to the xyz color space without bounding the values
        const xU = (rL * 0.4124 + gL * 0.3576 + bL * 0.1805) / 0.95047;
        const yU = (rL * 0.2126 + gL * 0.7152 + bL * 0.0722) / 1.0;
        const zU = (rL * 0.0193 + gL * 0.1192 + bL * 0.9505) / 1.08883;
        // Get the proper xyz values by applying the bounding
        const x = xU > 0.008856 ? Math.pow(xU, 1 / 3) : 7.787 * xU + 16 / 116;
        const y = yU > 0.008856 ? Math.pow(yU, 1 / 3) : 7.787 * yU + 16 / 116;
        const z = zU > 0.008856 ? Math.pow(zU, 1 / 3) : 7.787 * zU + 16 / 116;
        // Make and return the color
        const color = new Color(x, y, z, "xyz");
        return color;
    }
    /*
  Input and Output methods
  */ _clamped() {
        const { _a, _b, _c } = this.rgb();
        const { max, min, round } = Math;
        const format = (v)=>max(0, min(round(v), 255));
        return [
            _a,
            _b,
            _c
        ].map(format);
    }
}
class Point {
    // Initialize
    constructor(...args){
        this.init(...args);
    }
    // Clone point
    clone() {
        return new Point(this);
    }
    init(x, y) {
        const base = {
            x: 0,
            y: 0
        };
        // ensure source as object
        const source = Array.isArray(x) ? {
            x: x[0],
            y: x[1]
        } : typeof x === "object" ? {
            x: x.x,
            y: x.y
        } : {
            x: x,
            y: y
        };
        // merge source
        this.x = source.x == null ? base.x : source.x;
        this.y = source.y == null ? base.y : source.y;
        return this;
    }
    toArray() {
        return [
            this.x,
            this.y
        ];
    }
    transform(m) {
        return this.clone().transformO(m);
    }
    // Transform point with matrix
    transformO(m) {
        if (!Matrix.isMatrixLike(m)) m = new Matrix(m);
        const { x, y } = this;
        // Perform the matrix multiplication
        this.x = m.a * x + m.c * y + m.e;
        this.y = m.b * x + m.d * y + m.f;
        return this;
    }
}
function point(x, y) {
    return new Point(x, y).transformO(this.screenCTM().inverseO());
}
function closeEnough(a, b, threshold) {
    return Math.abs(b - a) < 1e-6;
}
class Matrix {
    constructor(...args){
        this.init(...args);
    }
    static formatTransforms(o) {
        // Get all of the parameters required to form the matrix
        const flipBoth = o.flip === "both" || o.flip === true;
        const flipX = o.flip && (flipBoth || o.flip === "x") ? -1 : 1;
        const flipY = o.flip && (flipBoth || o.flip === "y") ? -1 : 1;
        const skewX = o.skew && o.skew.length ? o.skew[0] : isFinite(o.skew) ? o.skew : isFinite(o.skewX) ? o.skewX : 0;
        const skewY = o.skew && o.skew.length ? o.skew[1] : isFinite(o.skew) ? o.skew : isFinite(o.skewY) ? o.skewY : 0;
        const scaleX = o.scale && o.scale.length ? o.scale[0] * flipX : isFinite(o.scale) ? o.scale * flipX : isFinite(o.scaleX) ? o.scaleX * flipX : flipX;
        const scaleY = o.scale && o.scale.length ? o.scale[1] * flipY : isFinite(o.scale) ? o.scale * flipY : isFinite(o.scaleY) ? o.scaleY * flipY : flipY;
        const shear = o.shear || 0;
        const theta = o.rotate || o.theta || 0;
        const origin = new Point(o.origin || o.around || o.ox || o.originX, o.oy || o.originY);
        const ox = origin.x;
        const oy = origin.y;
        // We need Point to be invalid if nothing was passed because we cannot default to 0 here. That is why NaN
        const position = new Point(o.position || o.px || o.positionX || NaN, o.py || o.positionY || NaN);
        const px = position.x;
        const py = position.y;
        const translate = new Point(o.translate || o.tx || o.translateX, o.ty || o.translateY);
        const tx = translate.x;
        const ty = translate.y;
        const relative = new Point(o.relative || o.rx || o.relativeX, o.ry || o.relativeY);
        const rx = relative.x;
        const ry = relative.y;
        // Populate all of the values
        return {
            scaleX: scaleX,
            scaleY: scaleY,
            skewX: skewX,
            skewY: skewY,
            shear: shear,
            theta: theta,
            rx: rx,
            ry: ry,
            tx: tx,
            ty: ty,
            ox: ox,
            oy: oy,
            px: px,
            py: py
        };
    }
    static fromArray(a) {
        return {
            a: a[0],
            b: a[1],
            c: a[2],
            d: a[3],
            e: a[4],
            f: a[5]
        };
    }
    static isMatrixLike(o) {
        return o.a != null || o.b != null || o.c != null || o.d != null || o.e != null || o.f != null;
    }
    // left matrix, right matrix, target matrix which is overwritten
    static matrixMultiply(l, r, o) {
        // Work out the product directly
        const a = l.a * r.a + l.c * r.b;
        const b = l.b * r.a + l.d * r.b;
        const c = l.a * r.c + l.c * r.d;
        const d = l.b * r.c + l.d * r.d;
        const e = l.e + l.a * r.e + l.c * r.f;
        const f = l.f + l.b * r.e + l.d * r.f;
        // make sure to use local variables because l/r and o could be the same
        o.a = a;
        o.b = b;
        o.c = c;
        o.d = d;
        o.e = e;
        o.f = f;
        return o;
    }
    around(cx, cy, matrix) {
        return this.clone().aroundO(cx, cy, matrix);
    }
    // Transform around a center point
    aroundO(cx, cy, matrix) {
        const dx = cx || 0;
        const dy = cy || 0;
        return this.translateO(-dx, -dy).lmultiplyO(matrix).translateO(dx, dy);
    }
    // Clones this matrix
    clone() {
        return new Matrix(this);
    }
    // Decomposes this matrix into its affine parameters
    decompose(cx = 0, cy = 0) {
        // Get the parameters from the matrix
        const a = this.a;
        const b = this.b;
        const c = this.c;
        const d = this.d;
        const e = this.e;
        const f = this.f;
        // Figure out if the winding direction is clockwise or counterclockwise
        const determinant = a * d - b * c;
        const ccw = determinant > 0 ? 1 : -1;
        // Since we only shear in x, we can use the x basis to get the x scale
        // and the rotation of the resulting matrix
        const sx = ccw * Math.sqrt(a * a + b * b);
        const thetaRad = Math.atan2(ccw * b, ccw * a);
        const theta = 180 / Math.PI * thetaRad;
        const ct = Math.cos(thetaRad);
        const st = Math.sin(thetaRad);
        // We can then solve the y basis vector simultaneously to get the other
        // two affine parameters directly from these parameters
        const lam = (a * c + b * d) / determinant;
        const sy = c * sx / (lam * a - b) || d * sx / (lam * b + a);
        // Use the translations
        const tx = e - cx + cx * ct * sx + cy * (lam * ct * sx - st * sy);
        const ty = f - cy + cx * st * sx + cy * (lam * st * sx + ct * sy);
        // Construct the decomposition and return it
        return {
            // Return the affine parameters
            scaleX: sx,
            scaleY: sy,
            shear: lam,
            rotate: theta,
            translateX: tx,
            translateY: ty,
            originX: cx,
            originY: cy,
            // Return the matrix parameters
            a: this.a,
            b: this.b,
            c: this.c,
            d: this.d,
            e: this.e,
            f: this.f
        };
    }
    // Check if two matrices are equal
    equals(other) {
        if (other === this) return true;
        const comp = new Matrix(other);
        return closeEnough(this.a, comp.a) && closeEnough(this.b, comp.b) && closeEnough(this.c, comp.c) && closeEnough(this.d, comp.d) && closeEnough(this.e, comp.e) && closeEnough(this.f, comp.f);
    }
    // Flip matrix on x or y, at a given offset
    flip(axis, around) {
        return this.clone().flipO(axis, around);
    }
    flipO(axis, around) {
        return axis === "x" ? this.scaleO(-1, 1, around, 0) : axis === "y" ? this.scaleO(1, -1, 0, around) : this.scaleO(-1, -1, axis, around || axis); // Define an x, y flip point
    }
    // Initialize
    init(source) {
        const base = Matrix.fromArray([
            1,
            0,
            0,
            1,
            0,
            0
        ]);
        // ensure source as object
        source = source instanceof Element ? source.matrixify() : typeof source === "string" ? Matrix.fromArray(source.split(delimiter).map(parseFloat)) : Array.isArray(source) ? Matrix.fromArray(source) : typeof source === "object" && Matrix.isMatrixLike(source) ? source : typeof source === "object" ? new Matrix().transform(source) : arguments.length === 6 ? Matrix.fromArray([].slice.call(arguments)) : base;
        // Merge the source matrix with the base matrix
        this.a = source.a != null ? source.a : base.a;
        this.b = source.b != null ? source.b : base.b;
        this.c = source.c != null ? source.c : base.c;
        this.d = source.d != null ? source.d : base.d;
        this.e = source.e != null ? source.e : base.e;
        this.f = source.f != null ? source.f : base.f;
        return this;
    }
    inverse() {
        return this.clone().inverseO();
    }
    // Inverses matrix
    inverseO() {
        // Get the current parameters out of the matrix
        const a = this.a;
        const b = this.b;
        const c = this.c;
        const d = this.d;
        const e = this.e;
        const f = this.f;
        // Invert the 2x2 matrix in the top left
        const det = a * d - b * c;
        if (!det) throw new Error("Cannot invert " + this);
        // Calculate the top 2x2 matrix
        const na = d / det;
        const nb = -b / det;
        const nc = -c / det;
        const nd = a / det;
        // Apply the inverted matrix to the top right
        const ne = -(na * e + nc * f);
        const nf = -(nb * e + nd * f);
        // Construct the inverted matrix
        this.a = na;
        this.b = nb;
        this.c = nc;
        this.d = nd;
        this.e = ne;
        this.f = nf;
        return this;
    }
    lmultiply(matrix) {
        return this.clone().lmultiplyO(matrix);
    }
    lmultiplyO(matrix) {
        const r = this;
        const l = matrix instanceof Matrix ? matrix : new Matrix(matrix);
        return Matrix.matrixMultiply(l, r, this);
    }
    // Left multiplies by the given matrix
    multiply(matrix) {
        return this.clone().multiplyO(matrix);
    }
    multiplyO(matrix) {
        // Get the matrices
        const l = this;
        const r = matrix instanceof Matrix ? matrix : new Matrix(matrix);
        return Matrix.matrixMultiply(l, r, this);
    }
    // Rotate matrix
    rotate(r, cx, cy) {
        return this.clone().rotateO(r, cx, cy);
    }
    rotateO(r, cx = 0, cy = 0) {
        // Convert degrees to radians
        r = radians(r);
        const cos = Math.cos(r);
        const sin = Math.sin(r);
        const { a, b, c, d, e, f } = this;
        this.a = a * cos - b * sin;
        this.b = b * cos + a * sin;
        this.c = c * cos - d * sin;
        this.d = d * cos + c * sin;
        this.e = e * cos - f * sin + cy * sin - cx * cos + cx;
        this.f = f * cos + e * sin - cx * sin - cy * cos + cy;
        return this;
    }
    // Scale matrix
    scale() {
        return this.clone().scaleO(...arguments);
    }
    scaleO(x, y = x, cx = 0, cy = 0) {
        // Support uniform scaling
        if (arguments.length === 3) {
            cy = cx;
            cx = y;
            y = x;
        }
        const { a, b, c, d, e, f } = this;
        this.a = a * x;
        this.b = b * y;
        this.c = c * x;
        this.d = d * y;
        this.e = e * x - cx * x + cx;
        this.f = f * y - cy * y + cy;
        return this;
    }
    // Shear matrix
    shear(a, cx, cy) {
        return this.clone().shearO(a, cx, cy);
    }
    // eslint-disable-next-line no-unused-vars
    shearO(lx, cx = 0, cy = 0) {
        const { a, b, c, d, e, f } = this;
        this.a = a + b * lx;
        this.c = c + d * lx;
        this.e = e + f * lx - cy * lx;
        return this;
    }
    // Skew Matrix
    skew() {
        return this.clone().skewO(...arguments);
    }
    skewO(x, y = x, cx = 0, cy = 0) {
        // support uniformal skew
        if (arguments.length === 3) {
            cy = cx;
            cx = y;
            y = x;
        }
        // Convert degrees to radians
        x = radians(x);
        y = radians(y);
        const lx = Math.tan(x);
        const ly = Math.tan(y);
        const { a, b, c, d, e, f } = this;
        this.a = a + b * lx;
        this.b = b + a * ly;
        this.c = c + d * lx;
        this.d = d + c * ly;
        this.e = e + f * lx - cy * lx;
        this.f = f + e * ly - cx * ly;
        return this;
    }
    // SkewX
    skewX(x, cx, cy) {
        return this.skew(x, 0, cx, cy);
    }
    // SkewY
    skewY(y, cx, cy) {
        return this.skew(0, y, cx, cy);
    }
    toArray() {
        return [
            this.a,
            this.b,
            this.c,
            this.d,
            this.e,
            this.f
        ];
    }
    // Convert matrix to string
    toString() {
        return "matrix(" + this.a + "," + this.b + "," + this.c + "," + this.d + "," + this.e + "," + this.f + ")";
    }
    // Transform a matrix into another matrix by manipulating the space
    transform(o) {
        // Check if o is a matrix and then left multiply it directly
        if (Matrix.isMatrixLike(o)) {
            const matrix = new Matrix(o);
            return matrix.multiplyO(this);
        }
        // Get the proposed transformations and the current transformations
        const t = Matrix.formatTransforms(o);
        const current = this;
        const { x: ox, y: oy } = new Point(t.ox, t.oy).transform(current);
        // Construct the resulting matrix
        const transformer = new Matrix().translateO(t.rx, t.ry).lmultiplyO(current).translateO(-ox, -oy).scaleO(t.scaleX, t.scaleY).skewO(t.skewX, t.skewY).shearO(t.shear).rotateO(t.theta).translateO(ox, oy);
        // If we want the origin at a particular place, we force it there
        if (isFinite(t.px) || isFinite(t.py)) {
            const origin = new Point(ox, oy).transform(transformer);
            // TODO: Replace t.px with isFinite(t.px)
            // Doesn't work because t.px is also 0 if it wasn't passed
            const dx = isFinite(t.px) ? t.px - origin.x : 0;
            const dy = isFinite(t.py) ? t.py - origin.y : 0;
            transformer.translateO(dx, dy);
        }
        // Translate now after positioning
        transformer.translateO(t.tx, t.ty);
        return transformer;
    }
    // Translate matrix
    translate(x, y) {
        return this.clone().translateO(x, y);
    }
    translateO(x, y) {
        this.e += x || 0;
        this.f += y || 0;
        return this;
    }
    valueOf() {
        return {
            a: this.a,
            b: this.b,
            c: this.c,
            d: this.d,
            e: this.e,
            f: this.f
        };
    }
}
function ctm() {
    return new Matrix(this.node.getCTM());
}
function screenCTM() {
    try {
        /* https://bugzilla.mozilla.org/show_bug.cgi?id=1344537
       This is needed because FF does not return the transformation matrix
       for the inner coordinate system when getScreenCTM() is called on nested svgs.
       However all other Browsers do that */ if (typeof this.isRoot === "function" && !this.isRoot()) {
            const rect = this.rect(1, 1);
            const m = rect.node.getScreenCTM();
            rect.remove();
            return new Matrix(m);
        }
        return new Matrix(this.node.getScreenCTM());
    } catch (e) {
        console.warn(`Cannot get CTM from SVG node ${this.node.nodeName}. Is the element rendered?`);
        return new Matrix();
    }
}
register(Matrix, "Matrix");
function parser() {
    // Reuse cached element if possible
    if (!parser.nodes) {
        const svg = makeInstance().size(2, 0);
        svg.node.style.cssText = [
            "opacity: 0",
            "position: absolute",
            "left: -100%",
            "top: -100%",
            "overflow: hidden"
        ].join(";");
        svg.attr("focusable", "false");
        svg.attr("aria-hidden", "true");
        const path = svg.path().node;
        parser.nodes = {
            svg: svg,
            path: path
        };
    }
    if (!parser.nodes.svg.node.parentNode) {
        const b = globals.document.body || globals.document.documentElement;
        parser.nodes.svg.addTo(b);
    }
    return parser.nodes;
}
function isNulledBox(box) {
    return !box.width && !box.height && !box.x && !box.y;
}
function domContains(node) {
    return node === globals.document || (globals.document.documentElement.contains || function(node) {
        // This is IE - it does not support contains() for top-level SVGs
        while(node.parentNode)node = node.parentNode;
        return node === globals.document;
    }).call(globals.document.documentElement, node);
}
class Box {
    constructor(...args){
        this.init(...args);
    }
    addOffset() {
        // offset by window scroll position, because getBoundingClientRect changes when window is scrolled
        this.x += globals.window.pageXOffset;
        this.y += globals.window.pageYOffset;
        return new Box(this);
    }
    init(source) {
        const base = [
            0,
            0,
            0,
            0
        ];
        source = typeof source === "string" ? source.split(delimiter).map(parseFloat) : Array.isArray(source) ? source : typeof source === "object" ? [
            source.left != null ? source.left : source.x,
            source.top != null ? source.top : source.y,
            source.width,
            source.height
        ] : arguments.length === 4 ? [].slice.call(arguments) : base;
        this.x = source[0] || 0;
        this.y = source[1] || 0;
        this.width = this.w = source[2] || 0;
        this.height = this.h = source[3] || 0;
        // Add more bounding box properties
        this.x2 = this.x + this.w;
        this.y2 = this.y + this.h;
        this.cx = this.x + this.w / 2;
        this.cy = this.y + this.h / 2;
        return this;
    }
    isNulled() {
        return isNulledBox(this);
    }
    // Merge rect box with another, return a new instance
    merge(box) {
        const x = Math.min(this.x, box.x);
        const y = Math.min(this.y, box.y);
        const width = Math.max(this.x + this.width, box.x + box.width) - x;
        const height = Math.max(this.y + this.height, box.y + box.height) - y;
        return new Box(x, y, width, height);
    }
    toArray() {
        return [
            this.x,
            this.y,
            this.width,
            this.height
        ];
    }
    toString() {
        return this.x + " " + this.y + " " + this.width + " " + this.height;
    }
    transform(m) {
        if (!(m instanceof Matrix)) m = new Matrix(m);
        let xMin = Infinity;
        let xMax = -Infinity;
        let yMin = Infinity;
        let yMax = -Infinity;
        const pts = [
            new Point(this.x, this.y),
            new Point(this.x2, this.y),
            new Point(this.x, this.y2),
            new Point(this.x2, this.y2)
        ];
        pts.forEach(function(p) {
            p = p.transform(m);
            xMin = Math.min(xMin, p.x);
            xMax = Math.max(xMax, p.x);
            yMin = Math.min(yMin, p.y);
            yMax = Math.max(yMax, p.y);
        });
        return new Box(xMin, yMin, xMax - xMin, yMax - yMin);
    }
}
function getBox(el, getBBoxFn, retry) {
    let box;
    try {
        // Try to get the box with the provided function
        box = getBBoxFn(el.node);
        // If the box is worthless and not even in the dom, retry
        // by throwing an error here...
        if (isNulledBox(box) && !domContains(el.node)) throw new Error("Element not in the dom");
    } catch (e) {
        // ... and calling the retry handler here
        box = retry(el);
    }
    return box;
}
function bbox() {
    // Function to get bbox is getBBox()
    const getBBox = (node)=>node.getBBox();
    // Take all measures so that a stupid browser renders the element
    // so we can get the bbox from it when we try again
    const retry = (el)=>{
        try {
            const clone = el.clone().addTo(parser().svg).show();
            const box = clone.node.getBBox();
            clone.remove();
            return box;
        } catch (e) {
            // We give up...
            throw new Error(`Getting bbox of element "${el.node.nodeName}" is not possible: ${e.toString()}`);
        }
    };
    const box = getBox(this, getBBox, retry);
    const bbox = new Box(box);
    return bbox;
}
function rbox(el) {
    const getRBox = (node)=>node.getBoundingClientRect();
    const retry = (el)=>{
        // There is no point in trying tricks here because if we insert the element into the dom ourselves
        // it obviously will be at the wrong position
        throw new Error(`Getting rbox of element "${el.node.nodeName}" is not possible`);
    };
    const box = getBox(this, getRBox, retry);
    const rbox = new Box(box);
    // If an element was passed, we want the bbox in the coordinate system of that element
    if (el) return rbox.transform(el.screenCTM().inverseO());
    // Else we want it in absolute screen coordinates
    // Therefore we need to add the scrollOffset
    return rbox.addOffset();
}
// Checks whether the given point is inside the bounding box
function inside(x, y) {
    const box = this.bbox();
    return x > box.x && y > box.y && x < box.x + box.width && y < box.y + box.height;
}
registerMethods({
    viewbox: {
        viewbox (x, y, width, height) {
            // act as getter
            if (x == null) return new Box(this.attr("viewBox"));
            // act as setter
            return this.attr("viewBox", new Box(x, y, width, height));
        },
        zoom (level, point) {
            // Its best to rely on the attributes here and here is why:
            // clientXYZ: Doesn't work on non-root svgs because they dont have a CSSBox (silly!)
            // getBoundingClientRect: Doesn't work because Chrome just ignores width and height of nested svgs completely
            //                        that means, their clientRect is always as big as the content.
            //                        Furthermore this size is incorrect if the element is further transformed by its parents
            // computedStyle: Only returns meaningful values if css was used with px. We dont go this route here!
            // getBBox: returns the bounding box of its content - that doesn't help!
            let { width, height } = this.attr([
                "width",
                "height"
            ]);
            // Width and height is a string when a number with a unit is present which we can't use
            // So we try clientXYZ
            if (!width && !height || typeof width === "string" || typeof height === "string") {
                width = this.node.clientWidth;
                height = this.node.clientHeight;
            }
            // Giving up...
            if (!width || !height) throw new Error("Impossible to get absolute width and height. Please provide an absolute width and height attribute on the zooming element");
            const v = this.viewbox();
            const zoomX = width / v.width;
            const zoomY = height / v.height;
            const zoom = Math.min(zoomX, zoomY);
            if (level == null) return zoom;
            let zoomAmount = zoom / level;
            // Set the zoomAmount to the highest value which is safe to process and recover from
            // The * 100 is a bit of wiggle room for the matrix transformation
            if (zoomAmount === Infinity) zoomAmount = Number.MAX_SAFE_INTEGER / 100;
            point = point || new Point(width / 2 / zoomX + v.x, height / 2 / zoomY + v.y);
            const box = new Box(v).transform(new Matrix({
                scale: zoomAmount,
                origin: point
            }));
            return this.viewbox(box);
        }
    }
});
register(Box, "Box");
// import { subClassArray } from './ArrayPolyfill.js'
class List extends Array {
    constructor(arr = [], ...args){
        super(arr, ...args);
        if (typeof arr === "number") return this;
        this.length = 0;
        this.push(...arr);
    }
}
extend([
    List
], {
    each (fnOrMethodName, ...args) {
        if (typeof fnOrMethodName === "function") return this.map((el, i, arr)=>{
            return fnOrMethodName.call(el, el, i, arr);
        });
        else return this.map((el)=>{
            return el[fnOrMethodName](...args);
        });
    },
    toArray () {
        return Array.prototype.concat.apply([], this);
    }
});
const reserved = [
    "toArray",
    "constructor",
    "each"
];
List.extend = function(methods) {
    methods = methods.reduce((obj, name)=>{
        // Don't overwrite own methods
        if (reserved.includes(name)) return obj;
        // Don't add private methods
        if (name[0] === "_") return obj;
        // Allow access to original Array methods through a prefix
        if (name in Array.prototype) obj["$" + name] = Array.prototype[name];
        // Relay every call to each()
        obj[name] = function(...attrs) {
            return this.each(name, ...attrs);
        };
        return obj;
    }, {});
    extend([
        List
    ], methods);
};
function baseFind(query, parent) {
    return new List(map((parent || globals.document).querySelectorAll(query), function(node) {
        return adopt(node);
    }));
}
// Scoped find method
function find(query) {
    return baseFind(query, this.node);
}
function findOne(query) {
    return adopt(this.node.querySelector(query));
}
let listenerId = 0;
const windowEvents = {};
function getEvents(instance) {
    let n = instance.getEventHolder();
    // We dont want to save events in global space
    if (n === globals.window) n = windowEvents;
    if (!n.events) n.events = {};
    return n.events;
}
function getEventTarget(instance) {
    return instance.getEventTarget();
}
function clearEvents(instance) {
    let n = instance.getEventHolder();
    if (n === globals.window) n = windowEvents;
    if (n.events) n.events = {};
}
// Add event binder in the SVG namespace
function on(node, events, listener, binding, options) {
    const l = listener.bind(binding || node);
    const instance = makeInstance(node);
    const bag = getEvents(instance);
    const n = getEventTarget(instance);
    // events can be an array of events or a string of events
    events = Array.isArray(events) ? events : events.split(delimiter);
    // add id to listener
    if (!listener._svgjsListenerId) listener._svgjsListenerId = ++listenerId;
    events.forEach(function(event) {
        const ev = event.split(".")[0];
        const ns = event.split(".")[1] || "*";
        // ensure valid object
        bag[ev] = bag[ev] || {};
        bag[ev][ns] = bag[ev][ns] || {};
        // reference listener
        bag[ev][ns][listener._svgjsListenerId] = l;
        // add listener
        n.addEventListener(ev, l, options || false);
    });
}
// Add event unbinder in the SVG namespace
function off(node, events, listener, options) {
    const instance = makeInstance(node);
    const bag = getEvents(instance);
    const n = getEventTarget(instance);
    // listener can be a function or a number
    if (typeof listener === "function") {
        listener = listener._svgjsListenerId;
        if (!listener) return;
    }
    // events can be an array of events or a string or undefined
    events = Array.isArray(events) ? events : (events || "").split(delimiter);
    events.forEach(function(event) {
        const ev = event && event.split(".")[0];
        const ns = event && event.split(".")[1];
        let namespace, l;
        if (listener) // remove listener reference
        {
            if (bag[ev] && bag[ev][ns || "*"]) {
                // removeListener
                n.removeEventListener(ev, bag[ev][ns || "*"][listener], options || false);
                delete bag[ev][ns || "*"][listener];
            }
        } else if (ev && ns) // remove all listeners for a namespaced event
        {
            if (bag[ev] && bag[ev][ns]) {
                for(l in bag[ev][ns])off(n, [
                    ev,
                    ns
                ].join("."), l);
                delete bag[ev][ns];
            }
        } else if (ns) // remove all listeners for a specific namespace
        for(event in bag){
            for(namespace in bag[event])if (ns === namespace) off(n, [
                event,
                ns
            ].join("."));
        }
        else if (ev) // remove all listeners for the event
        {
            if (bag[ev]) {
                for(namespace in bag[ev])off(n, [
                    ev,
                    namespace
                ].join("."));
                delete bag[ev];
            }
        } else {
            // remove all listeners on a given node
            for(event in bag)off(n, event);
            clearEvents(instance);
        }
    });
}
function dispatch(node, event, data, options) {
    const n = getEventTarget(node);
    // Dispatch event
    if (event instanceof globals.window.Event) n.dispatchEvent(event);
    else {
        event = new globals.window.CustomEvent(event, {
            detail: data,
            cancelable: true,
            ...options
        });
        n.dispatchEvent(event);
    }
    return event;
}
class EventTarget extends Base {
    addEventListener() {}
    dispatch(event, data, options) {
        return dispatch(this, event, data, options);
    }
    dispatchEvent(event) {
        const bag = this.getEventHolder().events;
        if (!bag) return true;
        const events = bag[event.type];
        for(const i in events)for(const j in events[i])events[i][j](event);
        return !event.defaultPrevented;
    }
    // Fire given event
    fire(event, data, options) {
        this.dispatch(event, data, options);
        return this;
    }
    getEventHolder() {
        return this;
    }
    getEventTarget() {
        return this;
    }
    // Unbind event from listener
    off(event, listener, options) {
        off(this, event, listener, options);
        return this;
    }
    // Bind given event to listener
    on(event, listener, binding, options) {
        on(this, event, listener, binding, options);
        return this;
    }
    removeEventListener() {}
}
register(EventTarget, "EventTarget");
function noop() {}
// Default animation values
const timeline = {
    duration: 400,
    ease: ">",
    delay: 0
};
// Default attribute values
const attrs = {
    // fill and stroke
    "fill-opacity": 1,
    "stroke-opacity": 1,
    "stroke-width": 0,
    "stroke-linejoin": "miter",
    "stroke-linecap": "butt",
    fill: "#000000",
    stroke: "#000000",
    opacity: 1,
    // position
    x: 0,
    y: 0,
    cx: 0,
    cy: 0,
    // size
    width: 0,
    height: 0,
    // radius
    r: 0,
    rx: 0,
    ry: 0,
    // gradient
    offset: 0,
    "stop-opacity": 1,
    "stop-color": "#000000",
    // text
    "text-anchor": "start"
};
var defaults = {
    __proto__: null,
    attrs: attrs,
    noop: noop,
    timeline: timeline
};
class SVGArray extends Array {
    constructor(...args){
        super(...args);
        this.init(...args);
    }
    clone() {
        return new this.constructor(this);
    }
    init(arr) {
        // This catches the case, that native map tries to create an array with new Array(1)
        if (typeof arr === "number") return this;
        this.length = 0;
        this.push(...this.parse(arr));
        return this;
    }
    // Parse whitespace separated string
    parse(array = []) {
        // If already is an array, no need to parse it
        if (array instanceof Array) return array;
        return array.trim().split(delimiter).map(parseFloat);
    }
    toArray() {
        return Array.prototype.concat.apply([], this);
    }
    toSet() {
        return new Set(this);
    }
    toString() {
        return this.join(" ");
    }
    // Flattens the array if needed
    valueOf() {
        const ret = [];
        ret.push(...this);
        return ret;
    }
}
// Module for unit conversions
class SVGNumber {
    // Initialize
    constructor(...args){
        this.init(...args);
    }
    convert(unit) {
        return new SVGNumber(this.value, unit);
    }
    // Divide number
    divide(number) {
        number = new SVGNumber(number);
        return new SVGNumber(this / number, this.unit || number.unit);
    }
    init(value, unit) {
        unit = Array.isArray(value) ? value[1] : unit;
        value = Array.isArray(value) ? value[0] : value;
        // initialize defaults
        this.value = 0;
        this.unit = unit || "";
        // parse value
        if (typeof value === "number") // ensure a valid numeric value
        this.value = isNaN(value) ? 0 : !isFinite(value) ? value < 0 ? -340000000000000000000000000000000000000 : 340000000000000000000000000000000000000 : value;
        else if (typeof value === "string") {
            unit = value.match(numberAndUnit);
            if (unit) {
                // make value numeric
                this.value = parseFloat(unit[1]);
                // normalize
                if (unit[5] === "%") this.value /= 100;
                else if (unit[5] === "s") this.value *= 1000;
                // store unit
                this.unit = unit[5];
            }
        } else if (value instanceof SVGNumber) {
            this.value = value.valueOf();
            this.unit = value.unit;
        }
        return this;
    }
    // Subtract number
    minus(number) {
        number = new SVGNumber(number);
        return new SVGNumber(this - number, this.unit || number.unit);
    }
    // Add number
    plus(number) {
        number = new SVGNumber(number);
        return new SVGNumber(this + number, this.unit || number.unit);
    }
    // Multiply number
    times(number) {
        number = new SVGNumber(number);
        return new SVGNumber(this * number, this.unit || number.unit);
    }
    toArray() {
        return [
            this.value,
            this.unit
        ];
    }
    toJSON() {
        return this.toString();
    }
    toString() {
        return (this.unit === "%" ? ~~(this.value * 1e8) / 1e6 : this.unit === "s" ? this.value / 1e3 : this.value) + this.unit;
    }
    valueOf() {
        return this.value;
    }
}
const colorAttributes = new Set([
    "fill",
    "stroke",
    "color",
    "bgcolor",
    "stop-color",
    "flood-color",
    "lighting-color"
]);
const hooks = [];
function registerAttrHook(fn) {
    hooks.push(fn);
}
// Set svg element attribute
function attr(attr, val, ns) {
    // act as full getter
    if (attr == null) {
        // get an object of attributes
        attr = {};
        val = this.node.attributes;
        for (const node of val)attr[node.nodeName] = isNumber.test(node.nodeValue) ? parseFloat(node.nodeValue) : node.nodeValue;
        return attr;
    } else if (attr instanceof Array) // loop through array and get all values
    return attr.reduce((last, curr)=>{
        last[curr] = this.attr(curr);
        return last;
    }, {});
    else if (typeof attr === "object" && attr.constructor === Object) // apply every attribute individually if an object is passed
    for(val in attr)this.attr(val, attr[val]);
    else if (val === null) // remove value
    this.node.removeAttribute(attr);
    else if (val == null) {
        // act as a getter if the first and only argument is not an object
        val = this.node.getAttribute(attr);
        return val == null ? attrs[attr] : isNumber.test(val) ? parseFloat(val) : val;
    } else {
        // Loop through hooks and execute them to convert value
        val = hooks.reduce((_val, hook)=>{
            return hook(attr, _val, this);
        }, val);
        // ensure correct numeric values (also accepts NaN and Infinity)
        if (typeof val === "number") val = new SVGNumber(val);
        else if (colorAttributes.has(attr) && Color.isColor(val)) // ensure full hex color
        val = new Color(val);
        else if (val.constructor === Array) // Check for plain arrays and parse array values
        val = new SVGArray(val);
        // if the passed attribute is leading...
        if (attr === "leading") // ... call the leading method instead
        {
            if (this.leading) this.leading(val);
        } else // set given attribute on node
        typeof ns === "string" ? this.node.setAttributeNS(ns, attr, val.toString()) : this.node.setAttribute(attr, val.toString());
        // rebuild if required
        if (this.rebuild && (attr === "font-size" || attr === "x")) this.rebuild();
    }
    return this;
}
class Dom extends EventTarget {
    constructor(node, attrs){
        super();
        this.node = node;
        this.type = node.nodeName;
        if (attrs && node !== attrs) this.attr(attrs);
    }
    // Add given element at a position
    add(element, i) {
        element = makeInstance(element);
        // If non-root svg nodes are added we have to remove their namespaces
        if (element.removeNamespace && this.node instanceof globals.window.SVGElement) element.removeNamespace();
        if (i == null) this.node.appendChild(element.node);
        else if (element.node !== this.node.childNodes[i]) this.node.insertBefore(element.node, this.node.childNodes[i]);
        return this;
    }
    // Add element to given container and return self
    addTo(parent, i) {
        return makeInstance(parent).put(this, i);
    }
    // Returns all child elements
    children() {
        return new List(map(this.node.children, function(node) {
            return adopt(node);
        }));
    }
    // Remove all elements in this container
    clear() {
        // remove children
        while(this.node.hasChildNodes())this.node.removeChild(this.node.lastChild);
        return this;
    }
    // Clone element
    clone(deep = true, assignNewIds = true) {
        // write dom data to the dom so the clone can pickup the data
        this.writeDataToDom();
        // clone element
        let nodeClone = this.node.cloneNode(deep);
        if (assignNewIds) // assign new id
        nodeClone = assignNewId(nodeClone);
        return new this.constructor(nodeClone);
    }
    // Iterates over all children and invokes a given block
    each(block, deep) {
        const children = this.children();
        let i, il;
        for(i = 0, il = children.length; i < il; i++){
            block.apply(children[i], [
                i,
                children
            ]);
            if (deep) children[i].each(block, deep);
        }
        return this;
    }
    element(nodeName, attrs) {
        return this.put(new Dom(create(nodeName), attrs));
    }
    // Get first child
    first() {
        return adopt(this.node.firstChild);
    }
    // Get a element at the given index
    get(i) {
        return adopt(this.node.childNodes[i]);
    }
    getEventHolder() {
        return this.node;
    }
    getEventTarget() {
        return this.node;
    }
    // Checks if the given element is a child
    has(element) {
        return this.index(element) >= 0;
    }
    html(htmlOrFn, outerHTML) {
        return this.xml(htmlOrFn, outerHTML, html);
    }
    // Get / set id
    id(id) {
        // generate new id if no id set
        if (typeof id === "undefined" && !this.node.id) this.node.id = eid(this.type);
        // don't set directly with this.node.id to make `null` work correctly
        return this.attr("id", id);
    }
    // Gets index of given element
    index(element) {
        return [].slice.call(this.node.childNodes).indexOf(element.node);
    }
    // Get the last child
    last() {
        return adopt(this.node.lastChild);
    }
    // matches the element vs a css selector
    matches(selector) {
        const el = this.node;
        const matcher = el.matches || el.matchesSelector || el.msMatchesSelector || el.mozMatchesSelector || el.webkitMatchesSelector || el.oMatchesSelector || null;
        return matcher && matcher.call(el, selector);
    }
    // Returns the parent element instance
    parent(type) {
        let parent = this;
        // check for parent
        if (!parent.node.parentNode) return null;
        // get parent element
        parent = adopt(parent.node.parentNode);
        if (!type) return parent;
        // loop through ancestors if type is given
        do {
            if (typeof type === "string" ? parent.matches(type) : parent instanceof type) return parent;
        }while (parent = adopt(parent.node.parentNode));
        return parent;
    }
    // Basically does the same as `add()` but returns the added element instead
    put(element, i) {
        element = makeInstance(element);
        this.add(element, i);
        return element;
    }
    // Add element to given container and return container
    putIn(parent, i) {
        return makeInstance(parent).add(this, i);
    }
    // Remove element
    remove() {
        if (this.parent()) this.parent().removeElement(this);
        return this;
    }
    // Remove a given child
    removeElement(element) {
        this.node.removeChild(element.node);
        return this;
    }
    // Replace this with element
    replace(element) {
        element = makeInstance(element);
        if (this.node.parentNode) this.node.parentNode.replaceChild(element.node, this.node);
        return element;
    }
    round(precision = 2, map = null) {
        const factor = 10 ** precision;
        const attrs = this.attr(map);
        for(const i in attrs)if (typeof attrs[i] === "number") attrs[i] = Math.round(attrs[i] * factor) / factor;
        this.attr(attrs);
        return this;
    }
    // Import / Export raw svg
    svg(svgOrFn, outerSVG) {
        return this.xml(svgOrFn, outerSVG, svg);
    }
    // Return id on string conversion
    toString() {
        return this.id();
    }
    words(text) {
        // This is faster than removing all children and adding a new one
        this.node.textContent = text;
        return this;
    }
    wrap(node) {
        const parent = this.parent();
        if (!parent) return this.addTo(node);
        const position = parent.index(this);
        return parent.put(node, position).put(this);
    }
    // write svgjs data to the dom
    writeDataToDom() {
        // dump variables recursively
        this.each(function() {
            this.writeDataToDom();
        });
        return this;
    }
    // Import / Export raw svg
    xml(xmlOrFn, outerXML, ns) {
        if (typeof xmlOrFn === "boolean") {
            ns = outerXML;
            outerXML = xmlOrFn;
            xmlOrFn = null;
        }
        // act as getter if no svg string is given
        if (xmlOrFn == null || typeof xmlOrFn === "function") {
            // The default for exports is, that the outerNode is included
            outerXML = outerXML == null ? true : outerXML;
            // write svgjs data to the dom
            this.writeDataToDom();
            let current = this;
            // An export modifier was passed
            if (xmlOrFn != null) {
                current = adopt(current.node.cloneNode(true));
                // If the user wants outerHTML we need to process this node, too
                if (outerXML) {
                    const result = xmlOrFn(current);
                    current = result || current;
                    // The user does not want this node? Well, then he gets nothing
                    if (result === false) return "";
                }
                // Deep loop through all children and apply modifier
                current.each(function() {
                    const result = xmlOrFn(this);
                    const _this = result || this;
                    // If modifier returns false, discard node
                    if (result === false) this.remove();
                    else if (result && this !== _this) this.replace(_this);
                }, true);
            }
            // Return outer or inner content
            return outerXML ? current.node.outerHTML : current.node.innerHTML;
        }
        // Act as setter if we got a string
        // The default for import is, that the current node is not replaced
        outerXML = outerXML == null ? false : outerXML;
        // Create temporary holder
        const well = create("wrapper", ns);
        const fragment = globals.document.createDocumentFragment();
        // Dump raw svg
        well.innerHTML = xmlOrFn;
        // Transplant nodes into the fragment
        for(let len = well.children.length; len--;)fragment.appendChild(well.firstElementChild);
        const parent = this.parent();
        // Add the whole fragment at once
        return outerXML ? this.replace(fragment) && parent : this.add(fragment);
    }
}
extend(Dom, {
    attr: attr,
    find: find,
    findOne: findOne
});
register(Dom, "Dom");
class Element extends Dom {
    constructor(node, attrs){
        super(node, attrs);
        // initialize data object
        this.dom = {};
        // create circular reference
        this.node.instance = this;
        if (node.hasAttribute("data-svgjs") || node.hasAttribute("svgjs:data")) // pull svgjs data from the dom (getAttributeNS doesn't work in html5)
        this.setData(JSON.parse(node.getAttribute("data-svgjs")) ?? JSON.parse(node.getAttribute("svgjs:data")) ?? {});
    }
    // Move element by its center
    center(x, y) {
        return this.cx(x).cy(y);
    }
    // Move by center over x-axis
    cx(x) {
        return x == null ? this.x() + this.width() / 2 : this.x(x - this.width() / 2);
    }
    // Move by center over y-axis
    cy(y) {
        return y == null ? this.y() + this.height() / 2 : this.y(y - this.height() / 2);
    }
    // Get defs
    defs() {
        const root = this.root();
        return root && root.defs();
    }
    // Relative move over x and y axes
    dmove(x, y) {
        return this.dx(x).dy(y);
    }
    // Relative move over x axis
    dx(x = 0) {
        return this.x(new SVGNumber(x).plus(this.x()));
    }
    // Relative move over y axis
    dy(y = 0) {
        return this.y(new SVGNumber(y).plus(this.y()));
    }
    getEventHolder() {
        return this;
    }
    // Set height of element
    height(height) {
        return this.attr("height", height);
    }
    // Move element to given x and y values
    move(x, y) {
        return this.x(x).y(y);
    }
    // return array of all ancestors of given type up to the root svg
    parents(until = this.root()) {
        const isSelector = typeof until === "string";
        if (!isSelector) until = makeInstance(until);
        const parents = new List();
        let parent = this;
        while((parent = parent.parent()) && parent.node !== globals.document && parent.nodeName !== "#document-fragment"){
            parents.push(parent);
            if (!isSelector && parent.node === until.node) break;
            if (isSelector && parent.matches(until)) break;
            if (parent.node === this.root().node) // We worked our way to the root and didn't match `until`
            return null;
        }
        return parents;
    }
    // Get referenced element form attribute value
    reference(attr) {
        attr = this.attr(attr);
        if (!attr) return null;
        const m = (attr + "").match(reference);
        return m ? makeInstance(m[1]) : null;
    }
    // Get parent document
    root() {
        const p = this.parent(getClass(root));
        return p && p.root();
    }
    // set given data to the elements data property
    setData(o) {
        this.dom = o;
        return this;
    }
    // Set element size to given width and height
    size(width, height) {
        const p = proportionalSize(this, width, height);
        return this.width(new SVGNumber(p.width)).height(new SVGNumber(p.height));
    }
    // Set width of element
    width(width) {
        return this.attr("width", width);
    }
    // write svgjs data to the dom
    writeDataToDom() {
        writeDataToDom(this, this.dom);
        return super.writeDataToDom();
    }
    // Move over x-axis
    x(x) {
        return this.attr("x", x);
    }
    // Move over y-axis
    y(y) {
        return this.attr("y", y);
    }
}
extend(Element, {
    bbox: bbox,
    rbox: rbox,
    inside: inside,
    point: point,
    ctm: ctm,
    screenCTM: screenCTM
});
register(Element, "Element");
// Define list of available attributes for stroke and fill
const sugar = {
    stroke: [
        "color",
        "width",
        "opacity",
        "linecap",
        "linejoin",
        "miterlimit",
        "dasharray",
        "dashoffset"
    ],
    fill: [
        "color",
        "opacity",
        "rule"
    ],
    prefix: function(t, a) {
        return a === "color" ? t : t + "-" + a;
    }
};
[
    "fill",
    "stroke"
].forEach(function(m) {
    const extension = {};
    let i;
    extension[m] = function(o) {
        if (typeof o === "undefined") return this.attr(m);
        if (typeof o === "string" || o instanceof Color || Color.isRgb(o) || o instanceof Element) this.attr(m, o);
        else {
            // set all attributes from sugar.fill and sugar.stroke list
            for(i = sugar[m].length - 1; i >= 0; i--)if (o[sugar[m][i]] != null) this.attr(sugar.prefix(m, sugar[m][i]), o[sugar[m][i]]);
        }
        return this;
    };
    registerMethods([
        "Element",
        "Runner"
    ], extension);
});
registerMethods([
    "Element",
    "Runner"
], {
    // Let the user set the matrix directly
    matrix: function(mat, b, c, d, e, f) {
        // Act as a getter
        if (mat == null) return new Matrix(this);
        // Act as a setter, the user can pass a matrix or a set of numbers
        return this.attr("transform", new Matrix(mat, b, c, d, e, f));
    },
    // Map rotation to transform
    rotate: function(angle, cx, cy) {
        return this.transform({
            rotate: angle,
            ox: cx,
            oy: cy
        }, true);
    },
    // Map skew to transform
    skew: function(x, y, cx, cy) {
        return arguments.length === 1 || arguments.length === 3 ? this.transform({
            skew: x,
            ox: y,
            oy: cx
        }, true) : this.transform({
            skew: [
                x,
                y
            ],
            ox: cx,
            oy: cy
        }, true);
    },
    shear: function(lam, cx, cy) {
        return this.transform({
            shear: lam,
            ox: cx,
            oy: cy
        }, true);
    },
    // Map scale to transform
    scale: function(x, y, cx, cy) {
        return arguments.length === 1 || arguments.length === 3 ? this.transform({
            scale: x,
            ox: y,
            oy: cx
        }, true) : this.transform({
            scale: [
                x,
                y
            ],
            ox: cx,
            oy: cy
        }, true);
    },
    // Map translate to transform
    translate: function(x, y) {
        return this.transform({
            translate: [
                x,
                y
            ]
        }, true);
    },
    // Map relative translations to transform
    relative: function(x, y) {
        return this.transform({
            relative: [
                x,
                y
            ]
        }, true);
    },
    // Map flip to transform
    flip: function(direction = "both", origin = "center") {
        if ("xybothtrue".indexOf(direction) === -1) {
            origin = direction;
            direction = "both";
        }
        return this.transform({
            flip: direction,
            origin: origin
        }, true);
    },
    // Opacity
    opacity: function(value) {
        return this.attr("opacity", value);
    }
});
registerMethods("radius", {
    // Add x and y radius
    radius: function(x, y = x) {
        const type = (this._element || this).type;
        return type === "radialGradient" ? this.attr("r", new SVGNumber(x)) : this.rx(x).ry(y);
    }
});
registerMethods("Path", {
    // Get path length
    length: function() {
        return this.node.getTotalLength();
    },
    // Get point at length
    pointAt: function(length) {
        return new Point(this.node.getPointAtLength(length));
    }
});
registerMethods([
    "Element",
    "Runner"
], {
    // Set font
    font: function(a, v) {
        if (typeof a === "object") {
            for(v in a)this.font(v, a[v]);
            return this;
        }
        return a === "leading" ? this.leading(v) : a === "anchor" ? this.attr("text-anchor", v) : a === "size" || a === "family" || a === "weight" || a === "stretch" || a === "variant" || a === "style" ? this.attr("font-" + a, v) : this.attr(a, v);
    }
});
// Add events to elements
const methods = [
    "click",
    "dblclick",
    "mousedown",
    "mouseup",
    "mouseover",
    "mouseout",
    "mousemove",
    "mouseenter",
    "mouseleave",
    "touchstart",
    "touchmove",
    "touchleave",
    "touchend",
    "touchcancel",
    "contextmenu",
    "wheel",
    "pointerdown",
    "pointermove",
    "pointerup",
    "pointerleave",
    "pointercancel"
].reduce(function(last, event) {
    // add event to Element
    const fn = function(f) {
        if (f === null) this.off(event);
        else this.on(event, f);
        return this;
    };
    last[event] = fn;
    return last;
}, {});
registerMethods("Element", methods);
// Reset all transformations
function untransform() {
    return this.attr("transform", null);
}
// merge the whole transformation chain into one matrix and returns it
function matrixify() {
    const matrix = (this.attr("transform") || "").split(transforms).slice(0, -1).map(function(str) {
        // generate key => value pairs
        const kv = str.trim().split("(");
        return [
            kv[0],
            kv[1].split(delimiter).map(function(str) {
                return parseFloat(str);
            })
        ];
    }).reverse()// merge every transformation into one matrix
    .reduce(function(matrix, transform) {
        if (transform[0] === "matrix") return matrix.lmultiply(Matrix.fromArray(transform[1]));
        return matrix[transform[0]].apply(matrix, transform[1]);
    }, new Matrix());
    return matrix;
}
// add an element to another parent without changing the visual representation on the screen
function toParent(parent, i) {
    if (this === parent) return this;
    if (isDescriptive(this.node)) return this.addTo(parent, i);
    const ctm = this.screenCTM();
    const pCtm = parent.screenCTM().inverse();
    this.addTo(parent, i).untransform().transform(pCtm.multiply(ctm));
    return this;
}
// same as above with parent equals root-svg
function toRoot(i) {
    return this.toParent(this.root(), i);
}
// Add transformations
function transform(o, relative) {
    // Act as a getter if no object was passed
    if (o == null || typeof o === "string") {
        const decomposed = new Matrix(this).decompose();
        return o == null ? decomposed : decomposed[o];
    }
    if (!Matrix.isMatrixLike(o)) // Set the origin according to the defined transform
    o = {
        ...o,
        origin: getOrigin(o, this)
    };
    // The user can pass a boolean, an Element or an Matrix or nothing
    const cleanRelative = relative === true ? this : relative || false;
    const result = new Matrix(cleanRelative).transform(o);
    return this.attr("transform", result);
}
registerMethods("Element", {
    untransform: untransform,
    matrixify: matrixify,
    toParent: toParent,
    toRoot: toRoot,
    transform: transform
});
class Container extends Element {
    flatten() {
        this.each(function() {
            if (this instanceof Container) return this.flatten().ungroup();
        });
        return this;
    }
    ungroup(parent = this.parent(), index = parent.index(this)) {
        // when parent != this, we want append all elements to the end
        index = index === -1 ? parent.children().length : index;
        this.each(function(i, children) {
            // reverse each
            return children[children.length - i - 1].toParent(parent, index);
        });
        return this.remove();
    }
}
register(Container, "Container");
class Defs extends Container {
    constructor(node, attrs = node){
        super(nodeOrNew("defs", node), attrs);
    }
    flatten() {
        return this;
    }
    ungroup() {
        return this;
    }
}
register(Defs, "Defs");
class Shape extends Element {
}
register(Shape, "Shape");
// Radius x value
function rx(rx) {
    return this.attr("rx", rx);
}
// Radius y value
function ry(ry) {
    return this.attr("ry", ry);
}
// Move over x-axis
function x$3(x) {
    return x == null ? this.cx() - this.rx() : this.cx(x + this.rx());
}
// Move over y-axis
function y$3(y) {
    return y == null ? this.cy() - this.ry() : this.cy(y + this.ry());
}
// Move by center over x-axis
function cx$1(x) {
    return this.attr("cx", x);
}
// Move by center over y-axis
function cy$1(y) {
    return this.attr("cy", y);
}
// Set width of element
function width$2(width) {
    return width == null ? this.rx() * 2 : this.rx(new SVGNumber(width).divide(2));
}
// Set height of element
function height$2(height) {
    return height == null ? this.ry() * 2 : this.ry(new SVGNumber(height).divide(2));
}
var circled = {
    __proto__: null,
    cx: cx$1,
    cy: cy$1,
    height: height$2,
    rx: rx,
    ry: ry,
    width: width$2,
    x: x$3,
    y: y$3
};
class Ellipse extends Shape {
    constructor(node, attrs = node){
        super(nodeOrNew("ellipse", node), attrs);
    }
    size(width, height) {
        const p = proportionalSize(this, width, height);
        return this.rx(new SVGNumber(p.width).divide(2)).ry(new SVGNumber(p.height).divide(2));
    }
}
extend(Ellipse, circled);
registerMethods("Container", {
    // Create an ellipse
    ellipse: wrapWithAttrCheck(function(width = 0, height = width) {
        return this.put(new Ellipse()).size(width, height).move(0, 0);
    })
});
register(Ellipse, "Ellipse");
class Fragment extends Dom {
    constructor(node = globals.document.createDocumentFragment()){
        super(node);
    }
    // Import / Export raw xml
    xml(xmlOrFn, outerXML, ns) {
        if (typeof xmlOrFn === "boolean") {
            ns = outerXML;
            outerXML = xmlOrFn;
            xmlOrFn = null;
        }
        // because this is a fragment we have to put all elements into a wrapper first
        // before we can get the innerXML from it
        if (xmlOrFn == null || typeof xmlOrFn === "function") {
            const wrapper = new Dom(create("wrapper", ns));
            wrapper.add(this.node.cloneNode(true));
            return wrapper.xml(false, ns);
        }
        // Act as setter if we got a string
        return super.xml(xmlOrFn, false, ns);
    }
}
register(Fragment, "Fragment");
function from(x, y) {
    return (this._element || this).type === "radialGradient" ? this.attr({
        fx: new SVGNumber(x),
        fy: new SVGNumber(y)
    }) : this.attr({
        x1: new SVGNumber(x),
        y1: new SVGNumber(y)
    });
}
function to(x, y) {
    return (this._element || this).type === "radialGradient" ? this.attr({
        cx: new SVGNumber(x),
        cy: new SVGNumber(y)
    }) : this.attr({
        x2: new SVGNumber(x),
        y2: new SVGNumber(y)
    });
}
var gradiented = {
    __proto__: null,
    from: from,
    to: to
};
class Gradient extends Container {
    constructor(type, attrs){
        super(nodeOrNew(type + "Gradient", typeof type === "string" ? null : type), attrs);
    }
    // custom attr to handle transform
    attr(a, b, c) {
        if (a === "transform") a = "gradientTransform";
        return super.attr(a, b, c);
    }
    bbox() {
        return new Box();
    }
    targets() {
        return baseFind("svg [fill*=" + this.id() + "]");
    }
    // Alias string conversion to fill
    toString() {
        return this.url();
    }
    // Update gradient
    update(block) {
        // remove all stops
        this.clear();
        // invoke passed block
        if (typeof block === "function") block.call(this, this);
        return this;
    }
    // Return the fill id
    url() {
        return "url(#" + this.id() + ")";
    }
}
extend(Gradient, gradiented);
registerMethods({
    Container: {
        // Create gradient element in defs
        gradient (...args) {
            return this.defs().gradient(...args);
        }
    },
    // define gradient
    Defs: {
        gradient: wrapWithAttrCheck(function(type, block) {
            return this.put(new Gradient(type)).update(block);
        })
    }
});
register(Gradient, "Gradient");
class Pattern extends Container {
    // Initialize node
    constructor(node, attrs = node){
        super(nodeOrNew("pattern", node), attrs);
    }
    // custom attr to handle transform
    attr(a, b, c) {
        if (a === "transform") a = "patternTransform";
        return super.attr(a, b, c);
    }
    bbox() {
        return new Box();
    }
    targets() {
        return baseFind("svg [fill*=" + this.id() + "]");
    }
    // Alias string conversion to fill
    toString() {
        return this.url();
    }
    // Update pattern by rebuilding
    update(block) {
        // remove content
        this.clear();
        // invoke passed block
        if (typeof block === "function") block.call(this, this);
        return this;
    }
    // Return the fill id
    url() {
        return "url(#" + this.id() + ")";
    }
}
registerMethods({
    Container: {
        // Create pattern element in defs
        pattern (...args) {
            return this.defs().pattern(...args);
        }
    },
    Defs: {
        pattern: wrapWithAttrCheck(function(width, height, block) {
            return this.put(new Pattern()).update(block).attr({
                x: 0,
                y: 0,
                width: width,
                height: height,
                patternUnits: "userSpaceOnUse"
            });
        })
    }
});
register(Pattern, "Pattern");
class Image extends Shape {
    constructor(node, attrs = node){
        super(nodeOrNew("image", node), attrs);
    }
    // (re)load image
    load(url, callback) {
        if (!url) return this;
        const img = new globals.window.Image();
        on(img, "load", function(e) {
            const p = this.parent(Pattern);
            // ensure image size
            if (this.width() === 0 && this.height() === 0) this.size(img.width, img.height);
            if (p instanceof Pattern) // ensure pattern size if not set
            {
                if (p.width() === 0 && p.height() === 0) p.size(this.width(), this.height());
            }
            if (typeof callback === "function") callback.call(this, e);
        }, this);
        on(img, "load error", function() {
            // dont forget to unbind memory leaking events
            off(img);
        });
        return this.attr("href", img.src = url, xlink);
    }
}
registerAttrHook(function(attr, val, _this) {
    // convert image fill and stroke to patterns
    if (attr === "fill" || attr === "stroke") {
        if (isImage.test(val)) val = _this.root().defs().image(val);
    }
    if (val instanceof Image) val = _this.root().defs().pattern(0, 0, (pattern)=>{
        pattern.add(val);
    });
    return val;
});
registerMethods({
    Container: {
        // create image element, load image and set its size
        image: wrapWithAttrCheck(function(source, callback) {
            return this.put(new Image()).size(0, 0).load(source, callback);
        })
    }
});
register(Image, "Image");
class PointArray extends SVGArray {
    // Get bounding box of points
    bbox() {
        let maxX = -Infinity;
        let maxY = -Infinity;
        let minX = Infinity;
        let minY = Infinity;
        this.forEach(function(el) {
            maxX = Math.max(el[0], maxX);
            maxY = Math.max(el[1], maxY);
            minX = Math.min(el[0], minX);
            minY = Math.min(el[1], minY);
        });
        return new Box(minX, minY, maxX - minX, maxY - minY);
    }
    // Move point string
    move(x, y) {
        const box = this.bbox();
        // get relative offset
        x -= box.x;
        y -= box.y;
        // move every point
        if (!isNaN(x) && !isNaN(y)) for(let i = this.length - 1; i >= 0; i--)this[i] = [
            this[i][0] + x,
            this[i][1] + y
        ];
        return this;
    }
    // Parse point string and flat array
    parse(array = [
        0,
        0
    ]) {
        const points = [];
        // if it is an array, we flatten it and therefore clone it to 1 depths
        if (array instanceof Array) array = Array.prototype.concat.apply([], array);
        else // Else, it is considered as a string
        // parse points
        array = array.trim().split(delimiter).map(parseFloat);
        // validate points - https://svgwg.org/svg2-draft/shapes.html#DataTypePoints
        // Odd number of coordinates is an error. In such cases, drop the last odd coordinate.
        if (array.length % 2 !== 0) array.pop();
        // wrap points in two-tuples
        for(let i = 0, len = array.length; i < len; i = i + 2)points.push([
            array[i],
            array[i + 1]
        ]);
        return points;
    }
    // Resize poly string
    size(width, height) {
        let i;
        const box = this.bbox();
        // recalculate position of all points according to new size
        for(i = this.length - 1; i >= 0; i--){
            if (box.width) this[i][0] = (this[i][0] - box.x) * width / box.width + box.x;
            if (box.height) this[i][1] = (this[i][1] - box.y) * height / box.height + box.y;
        }
        return this;
    }
    // Convert array to line object
    toLine() {
        return {
            x1: this[0][0],
            y1: this[0][1],
            x2: this[1][0],
            y2: this[1][1]
        };
    }
    // Convert array to string
    toString() {
        const array = [];
        // convert to a poly point string
        for(let i = 0, il = this.length; i < il; i++)array.push(this[i].join(","));
        return array.join(" ");
    }
    transform(m) {
        return this.clone().transformO(m);
    }
    // transform points with matrix (similar to Point.transform)
    transformO(m) {
        if (!Matrix.isMatrixLike(m)) m = new Matrix(m);
        for(let i = this.length; i--;){
            // Perform the matrix multiplication
            const [x, y] = this[i];
            this[i][0] = m.a * x + m.c * y + m.e;
            this[i][1] = m.b * x + m.d * y + m.f;
        }
        return this;
    }
}
const MorphArray = PointArray;
// Move by left top corner over x-axis
function x$2(x) {
    return x == null ? this.bbox().x : this.move(x, this.bbox().y);
}
// Move by left top corner over y-axis
function y$2(y) {
    return y == null ? this.bbox().y : this.move(this.bbox().x, y);
}
// Set width of element
function width$1(width) {
    const b = this.bbox();
    return width == null ? b.width : this.size(width, b.height);
}
// Set height of element
function height$1(height) {
    const b = this.bbox();
    return height == null ? b.height : this.size(b.width, height);
}
var pointed = {
    __proto__: null,
    MorphArray: MorphArray,
    height: height$1,
    width: width$1,
    x: x$2,
    y: y$2
};
class Line extends Shape {
    // Initialize node
    constructor(node, attrs = node){
        super(nodeOrNew("line", node), attrs);
    }
    // Get array
    array() {
        return new PointArray([
            [
                this.attr("x1"),
                this.attr("y1")
            ],
            [
                this.attr("x2"),
                this.attr("y2")
            ]
        ]);
    }
    // Move by left top corner
    move(x, y) {
        return this.attr(this.array().move(x, y).toLine());
    }
    // Overwrite native plot() method
    plot(x1, y1, x2, y2) {
        if (x1 == null) return this.array();
        else if (typeof y1 !== "undefined") x1 = {
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2
        };
        else x1 = new PointArray(x1).toLine();
        return this.attr(x1);
    }
    // Set element size to given width and height
    size(width, height) {
        const p = proportionalSize(this, width, height);
        return this.attr(this.array().size(p.width, p.height).toLine());
    }
}
extend(Line, pointed);
registerMethods({
    Container: {
        // Create a line element
        line: wrapWithAttrCheck(function(...args) {
            // make sure plot is called as a setter
            // x1 is not necessarily a number, it can also be an array, a string and a PointArray
            return Line.prototype.plot.apply(this.put(new Line()), args[0] != null ? args : [
                0,
                0,
                0,
                0
            ]);
        })
    }
});
register(Line, "Line");
class Marker extends Container {
    // Initialize node
    constructor(node, attrs = node){
        super(nodeOrNew("marker", node), attrs);
    }
    // Set height of element
    height(height) {
        return this.attr("markerHeight", height);
    }
    orient(orient) {
        return this.attr("orient", orient);
    }
    // Set marker refX and refY
    ref(x, y) {
        return this.attr("refX", x).attr("refY", y);
    }
    // Return the fill id
    toString() {
        return "url(#" + this.id() + ")";
    }
    // Update marker
    update(block) {
        // remove all content
        this.clear();
        // invoke passed block
        if (typeof block === "function") block.call(this, this);
        return this;
    }
    // Set width of element
    width(width) {
        return this.attr("markerWidth", width);
    }
}
registerMethods({
    Container: {
        marker (...args) {
            // Create marker element in defs
            return this.defs().marker(...args);
        }
    },
    Defs: {
        // Create marker
        marker: wrapWithAttrCheck(function(width, height, block) {
            // Set default viewbox to match the width and height, set ref to cx and cy and set orient to auto
            return this.put(new Marker()).size(width, height).ref(width / 2, height / 2).viewbox(0, 0, width, height).attr("orient", "auto").update(block);
        })
    },
    marker: {
        // Create and attach markers
        marker (marker, width, height, block) {
            let attr = [
                "marker"
            ];
            // Build attribute name
            if (marker !== "all") attr.push(marker);
            attr = attr.join("-");
            // Set marker attribute
            marker = arguments[1] instanceof Marker ? arguments[1] : this.defs().marker(width, height, block);
            return this.attr(attr, marker);
        }
    }
});
register(Marker, "Marker");
/***
Base Class
==========
The base stepper class that will be
***/ function makeSetterGetter(k, f) {
    return function(v) {
        if (v == null) return this[k];
        this[k] = v;
        if (f) f.call(this);
        return this;
    };
}
const easing = {
    "-": function(pos) {
        return pos;
    },
    "<>": function(pos) {
        return -Math.cos(pos * Math.PI) / 2 + 0.5;
    },
    ">": function(pos) {
        return Math.sin(pos * Math.PI / 2);
    },
    "<": function(pos) {
        return -Math.cos(pos * Math.PI / 2) + 1;
    },
    bezier: function(x1, y1, x2, y2) {
        // see https://www.w3.org/TR/css-easing-1/#cubic-bezier-algo
        return function(t) {
            if (t < 0) {
                if (x1 > 0) return y1 / x1 * t;
                else if (x2 > 0) return y2 / x2 * t;
                else return 0;
            } else if (t > 1) {
                if (x2 < 1) return (1 - y2) / (1 - x2) * t + (y2 - x2) / (1 - x2);
                else if (x1 < 1) return (1 - y1) / (1 - x1) * t + (y1 - x1) / (1 - x1);
                else return 1;
            } else return 3 * t * (1 - t) ** 2 * y1 + 3 * t ** 2 * (1 - t) * y2 + t ** 3;
        };
    },
    // see https://www.w3.org/TR/css-easing-1/#step-timing-function-algo
    steps: function(steps, stepPosition = "end") {
        // deal with "jump-" prefix
        stepPosition = stepPosition.split("-").reverse()[0];
        let jumps = steps;
        if (stepPosition === "none") --jumps;
        else if (stepPosition === "both") ++jumps;
        // The beforeFlag is essentially useless
        return (t, beforeFlag = false)=>{
            // Step is called currentStep in referenced url
            let step = Math.floor(t * steps);
            const jumping = t * step % 1 === 0;
            if (stepPosition === "start" || stepPosition === "both") ++step;
            if (beforeFlag && jumping) --step;
            if (t >= 0 && step < 0) step = 0;
            if (t <= 1 && step > jumps) step = jumps;
            return step / jumps;
        };
    }
};
class Stepper {
    done() {
        return false;
    }
}
/***
Easing Functions
================
***/ class Ease extends Stepper {
    constructor(fn = timeline.ease){
        super();
        this.ease = easing[fn] || fn;
    }
    step(from, to, pos) {
        if (typeof from !== "number") return pos < 1 ? from : to;
        return from + (to - from) * this.ease(pos);
    }
}
/***
Controller Types
================
***/ class Controller extends Stepper {
    constructor(fn){
        super();
        this.stepper = fn;
    }
    done(c) {
        return c.done;
    }
    step(current, target, dt, c) {
        return this.stepper(current, target, dt, c);
    }
}
function recalculate() {
    // Apply the default parameters
    const duration = (this._duration || 500) / 1000;
    const overshoot = this._overshoot || 0;
    // Calculate the PID natural response
    const eps = 1e-10;
    const pi = Math.PI;
    const os = Math.log(overshoot / 100 + eps);
    const zeta = -os / Math.sqrt(pi * pi + os * os);
    const wn = 3.9 / (zeta * duration);
    // Calculate the Spring values
    this.d = 2 * zeta * wn;
    this.k = wn * wn;
}
class Spring extends Controller {
    constructor(duration = 500, overshoot = 0){
        super();
        this.duration(duration).overshoot(overshoot);
    }
    step(current, target, dt, c) {
        if (typeof current === "string") return current;
        c.done = dt === Infinity;
        if (dt === Infinity) return target;
        if (dt === 0) return current;
        if (dt > 100) dt = 16;
        dt /= 1000;
        // Get the previous velocity
        const velocity = c.velocity || 0;
        // Apply the control to get the new position and store it
        const acceleration = -this.d * velocity - this.k * (current - target);
        const newPosition = current + velocity * dt + acceleration * dt * dt / 2;
        // Store the velocity
        c.velocity = velocity + acceleration * dt;
        // Figure out if we have converged, and if so, pass the value
        c.done = Math.abs(target - newPosition) + Math.abs(velocity) < 0.002;
        return c.done ? target : newPosition;
    }
}
extend(Spring, {
    duration: makeSetterGetter("_duration", recalculate),
    overshoot: makeSetterGetter("_overshoot", recalculate)
});
class PID extends Controller {
    constructor(p = 0.1, i = 0.01, d = 0, windup = 1000){
        super();
        this.p(p).i(i).d(d).windup(windup);
    }
    step(current, target, dt, c) {
        if (typeof current === "string") return current;
        c.done = dt === Infinity;
        if (dt === Infinity) return target;
        if (dt === 0) return current;
        const p = target - current;
        let i = (c.integral || 0) + p * dt;
        const d = (p - (c.error || 0)) / dt;
        const windup = this._windup;
        // antiwindup
        if (windup !== false) i = Math.max(-windup, Math.min(i, windup));
        c.error = p;
        c.integral = i;
        c.done = Math.abs(p) < 0.001;
        return c.done ? target : current + (this.P * p + this.I * i + this.D * d);
    }
}
extend(PID, {
    windup: makeSetterGetter("_windup"),
    p: makeSetterGetter("P"),
    i: makeSetterGetter("I"),
    d: makeSetterGetter("D")
});
const segmentParameters = {
    M: 2,
    L: 2,
    H: 1,
    V: 1,
    C: 6,
    S: 4,
    Q: 4,
    T: 2,
    A: 7,
    Z: 0
};
const pathHandlers = {
    M: function(c, p, p0) {
        p.x = p0.x = c[0];
        p.y = p0.y = c[1];
        return [
            "M",
            p.x,
            p.y
        ];
    },
    L: function(c, p) {
        p.x = c[0];
        p.y = c[1];
        return [
            "L",
            c[0],
            c[1]
        ];
    },
    H: function(c, p) {
        p.x = c[0];
        return [
            "H",
            c[0]
        ];
    },
    V: function(c, p) {
        p.y = c[0];
        return [
            "V",
            c[0]
        ];
    },
    C: function(c, p) {
        p.x = c[4];
        p.y = c[5];
        return [
            "C",
            c[0],
            c[1],
            c[2],
            c[3],
            c[4],
            c[5]
        ];
    },
    S: function(c, p) {
        p.x = c[2];
        p.y = c[3];
        return [
            "S",
            c[0],
            c[1],
            c[2],
            c[3]
        ];
    },
    Q: function(c, p) {
        p.x = c[2];
        p.y = c[3];
        return [
            "Q",
            c[0],
            c[1],
            c[2],
            c[3]
        ];
    },
    T: function(c, p) {
        p.x = c[0];
        p.y = c[1];
        return [
            "T",
            c[0],
            c[1]
        ];
    },
    Z: function(c, p, p0) {
        p.x = p0.x;
        p.y = p0.y;
        return [
            "Z"
        ];
    },
    A: function(c, p) {
        p.x = c[5];
        p.y = c[6];
        return [
            "A",
            c[0],
            c[1],
            c[2],
            c[3],
            c[4],
            c[5],
            c[6]
        ];
    }
};
const mlhvqtcsaz = "mlhvqtcsaz".split("");
for(let i = 0, il = mlhvqtcsaz.length; i < il; ++i)pathHandlers[mlhvqtcsaz[i]] = function(i) {
    return function(c, p, p0) {
        if (i === "H") c[0] = c[0] + p.x;
        else if (i === "V") c[0] = c[0] + p.y;
        else if (i === "A") {
            c[5] = c[5] + p.x;
            c[6] = c[6] + p.y;
        } else for(let j = 0, jl = c.length; j < jl; ++j)c[j] = c[j] + (j % 2 ? p.y : p.x);
        return pathHandlers[i](c, p, p0);
    };
}(mlhvqtcsaz[i].toUpperCase());
function makeAbsolut(parser) {
    const command = parser.segment[0];
    return pathHandlers[command](parser.segment.slice(1), parser.p, parser.p0);
}
function segmentComplete(parser) {
    return parser.segment.length && parser.segment.length - 1 === segmentParameters[parser.segment[0].toUpperCase()];
}
function startNewSegment(parser, token) {
    parser.inNumber && finalizeNumber(parser, false);
    const pathLetter = isPathLetter.test(token);
    if (pathLetter) parser.segment = [
        token
    ];
    else {
        const lastCommand = parser.lastCommand;
        const small = lastCommand.toLowerCase();
        const isSmall = lastCommand === small;
        parser.segment = [
            small === "m" ? isSmall ? "l" : "L" : lastCommand
        ];
    }
    parser.inSegment = true;
    parser.lastCommand = parser.segment[0];
    return pathLetter;
}
function finalizeNumber(parser, inNumber) {
    if (!parser.inNumber) throw new Error("Parser Error");
    parser.number && parser.segment.push(parseFloat(parser.number));
    parser.inNumber = inNumber;
    parser.number = "";
    parser.pointSeen = false;
    parser.hasExponent = false;
    if (segmentComplete(parser)) finalizeSegment(parser);
}
function finalizeSegment(parser) {
    parser.inSegment = false;
    if (parser.absolute) parser.segment = makeAbsolut(parser);
    parser.segments.push(parser.segment);
}
function isArcFlag(parser) {
    if (!parser.segment.length) return false;
    const isArc = parser.segment[0].toUpperCase() === "A";
    const length = parser.segment.length;
    return isArc && (length === 4 || length === 5);
}
function isExponential(parser) {
    return parser.lastToken.toUpperCase() === "E";
}
const pathDelimiters = new Set([
    " ",
    ",",
    "	",
    "\n",
    "\r",
    "\f"
]);
function pathParser(d, toAbsolute = true) {
    let index = 0;
    let token = "";
    const parser = {
        segment: [],
        inNumber: false,
        number: "",
        lastToken: "",
        inSegment: false,
        segments: [],
        pointSeen: false,
        hasExponent: false,
        absolute: toAbsolute,
        p0: new Point(),
        p: new Point()
    };
    while(parser.lastToken = token, token = d.charAt(index++)){
        if (!parser.inSegment) {
            if (startNewSegment(parser, token)) continue;
        }
        if (token === ".") {
            if (parser.pointSeen || parser.hasExponent) {
                finalizeNumber(parser, false);
                --index;
                continue;
            }
            parser.inNumber = true;
            parser.pointSeen = true;
            parser.number += token;
            continue;
        }
        if (!isNaN(parseInt(token))) {
            if (parser.number === "0" || isArcFlag(parser)) {
                parser.inNumber = true;
                parser.number = token;
                finalizeNumber(parser, true);
                continue;
            }
            parser.inNumber = true;
            parser.number += token;
            continue;
        }
        if (pathDelimiters.has(token)) {
            if (parser.inNumber) finalizeNumber(parser, false);
            continue;
        }
        if (token === "-" || token === "+") {
            if (parser.inNumber && !isExponential(parser)) {
                finalizeNumber(parser, false);
                --index;
                continue;
            }
            parser.number += token;
            parser.inNumber = true;
            continue;
        }
        if (token.toUpperCase() === "E") {
            parser.number += token;
            parser.hasExponent = true;
            continue;
        }
        if (isPathLetter.test(token)) {
            if (parser.inNumber) finalizeNumber(parser, false);
            else if (!segmentComplete(parser)) throw new Error("parser Error");
            else finalizeSegment(parser);
            --index;
        }
    }
    if (parser.inNumber) finalizeNumber(parser, false);
    if (parser.inSegment && segmentComplete(parser)) finalizeSegment(parser);
    return parser.segments;
}
function arrayToString(a) {
    let s = "";
    for(let i = 0, il = a.length; i < il; i++){
        s += a[i][0];
        if (a[i][1] != null) {
            s += a[i][1];
            if (a[i][2] != null) {
                s += " ";
                s += a[i][2];
                if (a[i][3] != null) {
                    s += " ";
                    s += a[i][3];
                    s += " ";
                    s += a[i][4];
                    if (a[i][5] != null) {
                        s += " ";
                        s += a[i][5];
                        s += " ";
                        s += a[i][6];
                        if (a[i][7] != null) {
                            s += " ";
                            s += a[i][7];
                        }
                    }
                }
            }
        }
    }
    return s + " ";
}
class PathArray extends SVGArray {
    // Get bounding box of path
    bbox() {
        parser().path.setAttribute("d", this.toString());
        return new Box(parser.nodes.path.getBBox());
    }
    // Move path string
    move(x, y) {
        // get bounding box of current situation
        const box = this.bbox();
        // get relative offset
        x -= box.x;
        y -= box.y;
        if (!isNaN(x) && !isNaN(y)) // move every point
        for(let l, i = this.length - 1; i >= 0; i--){
            l = this[i][0];
            if (l === "M" || l === "L" || l === "T") {
                this[i][1] += x;
                this[i][2] += y;
            } else if (l === "H") this[i][1] += x;
            else if (l === "V") this[i][1] += y;
            else if (l === "C" || l === "S" || l === "Q") {
                this[i][1] += x;
                this[i][2] += y;
                this[i][3] += x;
                this[i][4] += y;
                if (l === "C") {
                    this[i][5] += x;
                    this[i][6] += y;
                }
            } else if (l === "A") {
                this[i][6] += x;
                this[i][7] += y;
            }
        }
        return this;
    }
    // Absolutize and parse path to array
    parse(d = "M0 0") {
        if (Array.isArray(d)) d = Array.prototype.concat.apply([], d).toString();
        return pathParser(d);
    }
    // Resize path string
    size(width, height) {
        // get bounding box of current situation
        const box = this.bbox();
        let i, l;
        // If the box width or height is 0 then we ignore
        // transformations on the respective axis
        box.width = box.width === 0 ? 1 : box.width;
        box.height = box.height === 0 ? 1 : box.height;
        // recalculate position of all points according to new size
        for(i = this.length - 1; i >= 0; i--){
            l = this[i][0];
            if (l === "M" || l === "L" || l === "T") {
                this[i][1] = (this[i][1] - box.x) * width / box.width + box.x;
                this[i][2] = (this[i][2] - box.y) * height / box.height + box.y;
            } else if (l === "H") this[i][1] = (this[i][1] - box.x) * width / box.width + box.x;
            else if (l === "V") this[i][1] = (this[i][1] - box.y) * height / box.height + box.y;
            else if (l === "C" || l === "S" || l === "Q") {
                this[i][1] = (this[i][1] - box.x) * width / box.width + box.x;
                this[i][2] = (this[i][2] - box.y) * height / box.height + box.y;
                this[i][3] = (this[i][3] - box.x) * width / box.width + box.x;
                this[i][4] = (this[i][4] - box.y) * height / box.height + box.y;
                if (l === "C") {
                    this[i][5] = (this[i][5] - box.x) * width / box.width + box.x;
                    this[i][6] = (this[i][6] - box.y) * height / box.height + box.y;
                }
            } else if (l === "A") {
                // resize radii
                this[i][1] = this[i][1] * width / box.width;
                this[i][2] = this[i][2] * height / box.height;
                // move position values
                this[i][6] = (this[i][6] - box.x) * width / box.width + box.x;
                this[i][7] = (this[i][7] - box.y) * height / box.height + box.y;
            }
        }
        return this;
    }
    // Convert array to string
    toString() {
        return arrayToString(this);
    }
}
const getClassForType = (value)=>{
    const type = typeof value;
    if (type === "number") return SVGNumber;
    else if (type === "string") {
        if (Color.isColor(value)) return Color;
        else if (delimiter.test(value)) return isPathLetter.test(value) ? PathArray : SVGArray;
        else if (numberAndUnit.test(value)) return SVGNumber;
        else return NonMorphable;
    } else if (morphableTypes.indexOf(value.constructor) > -1) return value.constructor;
    else if (Array.isArray(value)) return SVGArray;
    else if (type === "object") return ObjectBag;
    else return NonMorphable;
};
class Morphable {
    constructor(stepper){
        this._stepper = stepper || new Ease("-");
        this._from = null;
        this._to = null;
        this._type = null;
        this._context = null;
        this._morphObj = null;
    }
    at(pos) {
        return this._morphObj.morph(this._from, this._to, pos, this._stepper, this._context);
    }
    done() {
        const complete = this._context.map(this._stepper.done).reduce(function(last, curr) {
            return last && curr;
        }, true);
        return complete;
    }
    from(val) {
        if (val == null) return this._from;
        this._from = this._set(val);
        return this;
    }
    stepper(stepper) {
        if (stepper == null) return this._stepper;
        this._stepper = stepper;
        return this;
    }
    to(val) {
        if (val == null) return this._to;
        this._to = this._set(val);
        return this;
    }
    type(type) {
        // getter
        if (type == null) return this._type;
        // setter
        this._type = type;
        return this;
    }
    _set(value) {
        if (!this._type) this.type(getClassForType(value));
        let result = new this._type(value);
        if (this._type === Color) result = this._to ? result[this._to[4]]() : this._from ? result[this._from[4]]() : result;
        if (this._type === ObjectBag) result = this._to ? result.align(this._to) : this._from ? result.align(this._from) : result;
        result = result.toConsumable();
        this._morphObj = this._morphObj || new this._type();
        this._context = this._context || Array.apply(null, Array(result.length)).map(Object).map(function(o) {
            o.done = true;
            return o;
        });
        return result;
    }
}
class NonMorphable {
    constructor(...args){
        this.init(...args);
    }
    init(val) {
        val = Array.isArray(val) ? val[0] : val;
        this.value = val;
        return this;
    }
    toArray() {
        return [
            this.value
        ];
    }
    valueOf() {
        return this.value;
    }
}
class TransformBag {
    constructor(...args){
        this.init(...args);
    }
    init(obj) {
        if (Array.isArray(obj)) obj = {
            scaleX: obj[0],
            scaleY: obj[1],
            shear: obj[2],
            rotate: obj[3],
            translateX: obj[4],
            translateY: obj[5],
            originX: obj[6],
            originY: obj[7]
        };
        Object.assign(this, TransformBag.defaults, obj);
        return this;
    }
    toArray() {
        const v = this;
        return [
            v.scaleX,
            v.scaleY,
            v.shear,
            v.rotate,
            v.translateX,
            v.translateY,
            v.originX,
            v.originY
        ];
    }
}
TransformBag.defaults = {
    scaleX: 1,
    scaleY: 1,
    shear: 0,
    rotate: 0,
    translateX: 0,
    translateY: 0,
    originX: 0,
    originY: 0
};
const sortByKey = (a, b)=>{
    return a[0] < b[0] ? -1 : a[0] > b[0] ? 1 : 0;
};
class ObjectBag {
    constructor(...args){
        this.init(...args);
    }
    align(other) {
        const values = this.values;
        for(let i = 0, il = values.length; i < il; ++i){
            // If the type is the same we only need to check if the color is in the correct format
            if (values[i + 1] === other[i + 1]) {
                if (values[i + 1] === Color && other[i + 7] !== values[i + 7]) {
                    const space = other[i + 7];
                    const color = new Color(this.values.splice(i + 3, 5))[space]().toArray();
                    this.values.splice(i + 3, 0, ...color);
                }
                i += values[i + 2] + 2;
                continue;
            }
            if (!other[i + 1]) return this;
            // The types differ, so we overwrite the new type with the old one
            // And initialize it with the types default (e.g. black for color or 0 for number)
            const defaultObject = new other[i + 1]().toArray();
            // Than we fix the values array
            const toDelete = values[i + 2] + 3;
            values.splice(i, toDelete, other[i], other[i + 1], other[i + 2], ...defaultObject);
            i += values[i + 2] + 2;
        }
        return this;
    }
    init(objOrArr) {
        this.values = [];
        if (Array.isArray(objOrArr)) {
            this.values = objOrArr.slice();
            return;
        }
        objOrArr = objOrArr || {};
        const entries = [];
        for(const i in objOrArr){
            const Type = getClassForType(objOrArr[i]);
            const val = new Type(objOrArr[i]).toArray();
            entries.push([
                i,
                Type,
                val.length,
                ...val
            ]);
        }
        entries.sort(sortByKey);
        this.values = entries.reduce((last, curr)=>last.concat(curr), []);
        return this;
    }
    toArray() {
        return this.values;
    }
    valueOf() {
        const obj = {};
        const arr = this.values;
        // for (var i = 0, len = arr.length; i < len; i += 2) {
        while(arr.length){
            const key = arr.shift();
            const Type = arr.shift();
            const num = arr.shift();
            const values = arr.splice(0, num);
            obj[key] = new Type(values); // .valueOf()
        }
        return obj;
    }
}
const morphableTypes = [
    NonMorphable,
    TransformBag,
    ObjectBag
];
function registerMorphableType(type = []) {
    morphableTypes.push(...[].concat(type));
}
function makeMorphable() {
    extend(morphableTypes, {
        to (val) {
            return new Morphable().type(this.constructor).from(this.toArray()) // this.valueOf())
            .to(val);
        },
        fromArray (arr) {
            this.init(arr);
            return this;
        },
        toConsumable () {
            return this.toArray();
        },
        morph (from, to, pos, stepper, context) {
            const mapper = function(i, index) {
                return stepper.step(i, to[index], pos, context[index], context);
            };
            return this.fromArray(from.map(mapper));
        }
    });
}
class Path extends Shape {
    // Initialize node
    constructor(node, attrs = node){
        super(nodeOrNew("path", node), attrs);
    }
    // Get array
    array() {
        return this._array || (this._array = new PathArray(this.attr("d")));
    }
    // Clear array cache
    clear() {
        delete this._array;
        return this;
    }
    // Set height of element
    height(height) {
        return height == null ? this.bbox().height : this.size(this.bbox().width, height);
    }
    // Move by left top corner
    move(x, y) {
        return this.attr("d", this.array().move(x, y));
    }
    // Plot new path
    plot(d) {
        return d == null ? this.array() : this.clear().attr("d", typeof d === "string" ? d : this._array = new PathArray(d));
    }
    // Set element size to given width and height
    size(width, height) {
        const p = proportionalSize(this, width, height);
        return this.attr("d", this.array().size(p.width, p.height));
    }
    // Set width of element
    width(width) {
        return width == null ? this.bbox().width : this.size(width, this.bbox().height);
    }
    // Move by left top corner over x-axis
    x(x) {
        return x == null ? this.bbox().x : this.move(x, this.bbox().y);
    }
    // Move by left top corner over y-axis
    y(y) {
        return y == null ? this.bbox().y : this.move(this.bbox().x, y);
    }
}
// Define morphable array
Path.prototype.MorphArray = PathArray;
// Add parent method
registerMethods({
    Container: {
        // Create a wrapped path element
        path: wrapWithAttrCheck(function(d) {
            // make sure plot is called as a setter
            return this.put(new Path()).plot(d || new PathArray());
        })
    }
});
register(Path, "Path");
// Get array
function array() {
    return this._array || (this._array = new PointArray(this.attr("points")));
}
// Clear array cache
function clear() {
    delete this._array;
    return this;
}
// Move by left top corner
function move$2(x, y) {
    return this.attr("points", this.array().move(x, y));
}
// Plot new path
function plot(p) {
    return p == null ? this.array() : this.clear().attr("points", typeof p === "string" ? p : this._array = new PointArray(p));
}
// Set element size to given width and height
function size$1(width, height) {
    const p = proportionalSize(this, width, height);
    return this.attr("points", this.array().size(p.width, p.height));
}
var poly = {
    __proto__: null,
    array: array,
    clear: clear,
    move: move$2,
    plot: plot,
    size: size$1
};
class Polygon extends Shape {
    // Initialize node
    constructor(node, attrs = node){
        super(nodeOrNew("polygon", node), attrs);
    }
}
registerMethods({
    Container: {
        // Create a wrapped polygon element
        polygon: wrapWithAttrCheck(function(p) {
            // make sure plot is called as a setter
            return this.put(new Polygon()).plot(p || new PointArray());
        })
    }
});
extend(Polygon, pointed);
extend(Polygon, poly);
register(Polygon, "Polygon");
class Polyline extends Shape {
    // Initialize node
    constructor(node, attrs = node){
        super(nodeOrNew("polyline", node), attrs);
    }
}
registerMethods({
    Container: {
        // Create a wrapped polygon element
        polyline: wrapWithAttrCheck(function(p) {
            // make sure plot is called as a setter
            return this.put(new Polyline()).plot(p || new PointArray());
        })
    }
});
extend(Polyline, pointed);
extend(Polyline, poly);
register(Polyline, "Polyline");
class Rect extends Shape {
    // Initialize node
    constructor(node, attrs = node){
        super(nodeOrNew("rect", node), attrs);
    }
}
extend(Rect, {
    rx: rx,
    ry: ry
});
registerMethods({
    Container: {
        // Create a rect element
        rect: wrapWithAttrCheck(function(width, height) {
            return this.put(new Rect()).size(width, height);
        })
    }
});
register(Rect, "Rect");
class Queue {
    constructor(){
        this._first = null;
        this._last = null;
    }
    // Shows us the first item in the list
    first() {
        return this._first && this._first.value;
    }
    // Shows us the last item in the list
    last() {
        return this._last && this._last.value;
    }
    push(value) {
        // An item stores an id and the provided value
        const item = typeof value.next !== "undefined" ? value : {
            value: value,
            next: null,
            prev: null
        };
        // Deal with the queue being empty or populated
        if (this._last) {
            item.prev = this._last;
            this._last.next = item;
            this._last = item;
        } else {
            this._last = item;
            this._first = item;
        }
        // Return the current item
        return item;
    }
    // Removes the item that was returned from the push
    remove(item) {
        // Relink the previous item
        if (item.prev) item.prev.next = item.next;
        if (item.next) item.next.prev = item.prev;
        if (item === this._last) this._last = item.prev;
        if (item === this._first) this._first = item.next;
        // Invalidate item
        item.prev = null;
        item.next = null;
    }
    shift() {
        // Check if we have a value
        const remove = this._first;
        if (!remove) return null;
        // If we do, remove it and relink things
        this._first = remove.next;
        if (this._first) this._first.prev = null;
        this._last = this._first ? this._last : null;
        return remove.value;
    }
}
const Animator = {
    nextDraw: null,
    frames: new Queue(),
    timeouts: new Queue(),
    immediates: new Queue(),
    timer: ()=>globals.window.performance || globals.window.Date,
    transforms: [],
    frame (fn) {
        // Store the node
        const node = Animator.frames.push({
            run: fn
        });
        // Request an animation frame if we don't have one
        if (Animator.nextDraw === null) Animator.nextDraw = globals.window.requestAnimationFrame(Animator._draw);
        // Return the node so we can remove it easily
        return node;
    },
    timeout (fn, delay) {
        delay = delay || 0;
        // Work out when the event should fire
        const time = Animator.timer().now() + delay;
        // Add the timeout to the end of the queue
        const node = Animator.timeouts.push({
            run: fn,
            time: time
        });
        // Request another animation frame if we need one
        if (Animator.nextDraw === null) Animator.nextDraw = globals.window.requestAnimationFrame(Animator._draw);
        return node;
    },
    immediate (fn) {
        // Add the immediate fn to the end of the queue
        const node = Animator.immediates.push(fn);
        // Request another animation frame if we need one
        if (Animator.nextDraw === null) Animator.nextDraw = globals.window.requestAnimationFrame(Animator._draw);
        return node;
    },
    cancelFrame (node) {
        node != null && Animator.frames.remove(node);
    },
    clearTimeout (node) {
        node != null && Animator.timeouts.remove(node);
    },
    cancelImmediate (node) {
        node != null && Animator.immediates.remove(node);
    },
    _draw (now) {
        // Run all the timeouts we can run, if they are not ready yet, add them
        // to the end of the queue immediately! (bad timeouts!!! [sarcasm])
        let nextTimeout = null;
        const lastTimeout = Animator.timeouts.last();
        while(nextTimeout = Animator.timeouts.shift()){
            // Run the timeout if its time, or push it to the end
            if (now >= nextTimeout.time) nextTimeout.run();
            else Animator.timeouts.push(nextTimeout);
            // If we hit the last item, we should stop shifting out more items
            if (nextTimeout === lastTimeout) break;
        }
        // Run all of the animation frames
        let nextFrame = null;
        const lastFrame = Animator.frames.last();
        while(nextFrame !== lastFrame && (nextFrame = Animator.frames.shift()))nextFrame.run(now);
        let nextImmediate = null;
        while(nextImmediate = Animator.immediates.shift())nextImmediate();
        // If we have remaining timeouts or frames, draw until we don't anymore
        Animator.nextDraw = Animator.timeouts.first() || Animator.frames.first() ? globals.window.requestAnimationFrame(Animator._draw) : null;
    }
};
const makeSchedule = function(runnerInfo) {
    const start = runnerInfo.start;
    const duration = runnerInfo.runner.duration();
    const end = start + duration;
    return {
        start: start,
        duration: duration,
        end: end,
        runner: runnerInfo.runner
    };
};
const defaultSource = function() {
    const w = globals.window;
    return (w.performance || w.Date).now();
};
class Timeline extends EventTarget {
    // Construct a new timeline on the given element
    constructor(timeSource = defaultSource){
        super();
        this._timeSource = timeSource;
        // terminate resets all variables to their initial state
        this.terminate();
    }
    active() {
        return !!this._nextFrame;
    }
    finish() {
        // Go to end and pause
        this.time(this.getEndTimeOfTimeline() + 1);
        return this.pause();
    }
    // Calculates the end of the timeline
    getEndTime() {
        const lastRunnerInfo = this.getLastRunnerInfo();
        const lastDuration = lastRunnerInfo ? lastRunnerInfo.runner.duration() : 0;
        const lastStartTime = lastRunnerInfo ? lastRunnerInfo.start : this._time;
        return lastStartTime + lastDuration;
    }
    getEndTimeOfTimeline() {
        const endTimes = this._runners.map((i)=>i.start + i.runner.duration());
        return Math.max(0, ...endTimes);
    }
    getLastRunnerInfo() {
        return this.getRunnerInfoById(this._lastRunnerId);
    }
    getRunnerInfoById(id) {
        return this._runners[this._runnerIds.indexOf(id)] || null;
    }
    pause() {
        this._paused = true;
        return this._continue();
    }
    persist(dtOrForever) {
        if (dtOrForever == null) return this._persist;
        this._persist = dtOrForever;
        return this;
    }
    play() {
        // Now make sure we are not paused and continue the animation
        this._paused = false;
        return this.updateTime()._continue();
    }
    reverse(yes) {
        const currentSpeed = this.speed();
        if (yes == null) return this.speed(-currentSpeed);
        const positive = Math.abs(currentSpeed);
        return this.speed(yes ? -positive : positive);
    }
    // schedules a runner on the timeline
    schedule(runner, delay, when) {
        if (runner == null) return this._runners.map(makeSchedule);
        // The start time for the next animation can either be given explicitly,
        // derived from the current timeline time or it can be relative to the
        // last start time to chain animations directly
        let absoluteStartTime = 0;
        const endTime = this.getEndTime();
        delay = delay || 0;
        // Work out when to start the animation
        if (when == null || when === "last" || when === "after") // Take the last time and increment
        absoluteStartTime = endTime;
        else if (when === "absolute" || when === "start") {
            absoluteStartTime = delay;
            delay = 0;
        } else if (when === "now") absoluteStartTime = this._time;
        else if (when === "relative") {
            const runnerInfo = this.getRunnerInfoById(runner.id);
            if (runnerInfo) {
                absoluteStartTime = runnerInfo.start + delay;
                delay = 0;
            }
        } else if (when === "with-last") {
            const lastRunnerInfo = this.getLastRunnerInfo();
            const lastStartTime = lastRunnerInfo ? lastRunnerInfo.start : this._time;
            absoluteStartTime = lastStartTime;
        } else throw new Error('Invalid value for the "when" parameter');
        // Manage runner
        runner.unschedule();
        runner.timeline(this);
        const persist = runner.persist();
        const runnerInfo = {
            persist: persist === null ? this._persist : persist,
            start: absoluteStartTime + delay,
            runner: runner
        };
        this._lastRunnerId = runner.id;
        this._runners.push(runnerInfo);
        this._runners.sort((a, b)=>a.start - b.start);
        this._runnerIds = this._runners.map((info)=>info.runner.id);
        this.updateTime()._continue();
        return this;
    }
    seek(dt) {
        return this.time(this._time + dt);
    }
    source(fn) {
        if (fn == null) return this._timeSource;
        this._timeSource = fn;
        return this;
    }
    speed(speed) {
        if (speed == null) return this._speed;
        this._speed = speed;
        return this;
    }
    stop() {
        // Go to start and pause
        this.time(0);
        return this.pause();
    }
    time(time) {
        if (time == null) return this._time;
        this._time = time;
        return this._continue(true);
    }
    // Remove the runner from this timeline
    unschedule(runner) {
        const index = this._runnerIds.indexOf(runner.id);
        if (index < 0) return this;
        this._runners.splice(index, 1);
        this._runnerIds.splice(index, 1);
        runner.timeline(null);
        return this;
    }
    // Makes sure, that after pausing the time doesn't jump
    updateTime() {
        if (!this.active()) this._lastSourceTime = this._timeSource();
        return this;
    }
    // Checks if we are running and continues the animation
    _continue(immediateStep = false) {
        Animator.cancelFrame(this._nextFrame);
        this._nextFrame = null;
        if (immediateStep) return this._stepImmediate();
        if (this._paused) return this;
        this._nextFrame = Animator.frame(this._step);
        return this;
    }
    _stepFn(immediateStep = false) {
        // Get the time delta from the last time and update the time
        const time = this._timeSource();
        let dtSource = time - this._lastSourceTime;
        if (immediateStep) dtSource = 0;
        const dtTime = this._speed * dtSource + (this._time - this._lastStepTime);
        this._lastSourceTime = time;
        // Only update the time if we use the timeSource.
        // Otherwise use the current time
        if (!immediateStep) {
            // Update the time
            this._time += dtTime;
            this._time = this._time < 0 ? 0 : this._time;
        }
        this._lastStepTime = this._time;
        this.fire("time", this._time);
        // This is for the case that the timeline was seeked so that the time
        // is now before the startTime of the runner. That is why we need to set
        // the runner to position 0
        // FIXME:
        // However, resetting in insertion order leads to bugs. Considering the case,
        // where 2 runners change the same attribute but in different times,
        // resetting both of them will lead to the case where the later defined
        // runner always wins the reset even if the other runner started earlier
        // and therefore should win the attribute battle
        // this can be solved by resetting them backwards
        for(let k = this._runners.length; k--;){
            // Get and run the current runner and ignore it if its inactive
            const runnerInfo = this._runners[k];
            const runner = runnerInfo.runner;
            // Make sure that we give the actual difference
            // between runner start time and now
            const dtToStart = this._time - runnerInfo.start;
            // Dont run runner if not started yet
            // and try to reset it
            if (dtToStart <= 0) runner.reset();
        }
        // Run all of the runners directly
        let runnersLeft = false;
        for(let i = 0, len = this._runners.length; i < len; i++){
            // Get and run the current runner and ignore it if its inactive
            const runnerInfo = this._runners[i];
            const runner = runnerInfo.runner;
            let dt = dtTime;
            // Make sure that we give the actual difference
            // between runner start time and now
            const dtToStart = this._time - runnerInfo.start;
            // Dont run runner if not started yet
            if (dtToStart <= 0) {
                runnersLeft = true;
                continue;
            } else if (dtToStart < dt) // Adjust dt to make sure that animation is on point
            dt = dtToStart;
            if (!runner.active()) continue;
            // If this runner is still going, signal that we need another animation
            // frame, otherwise, remove the completed runner
            const finished = runner.step(dt).done;
            if (!finished) runnersLeft = true;
            else if (runnerInfo.persist !== true) {
                // runner is finished. And runner might get removed
                const endTime = runner.duration() - runner.time() + this._time;
                if (endTime + runnerInfo.persist < this._time) {
                    // Delete runner and correct index
                    runner.unschedule();
                    --i;
                    --len;
                }
            }
        }
        // Basically: we continue when there are runners right from us in time
        // when -->, and when runners are left from us when <--
        if (runnersLeft && !(this._speed < 0 && this._time === 0) || this._runnerIds.length && this._speed < 0 && this._time > 0) this._continue();
        else {
            this.pause();
            this.fire("finished");
        }
        return this;
    }
    terminate() {
        // cleanup memory
        // Store the timing variables
        this._startTime = 0;
        this._speed = 1.0;
        // Determines how long a runner is hold in memory. Can be a dt or true/false
        this._persist = 0;
        // Keep track of the running animations and their starting parameters
        this._nextFrame = null;
        this._paused = true;
        this._runners = [];
        this._runnerIds = [];
        this._lastRunnerId = -1;
        this._time = 0;
        this._lastSourceTime = 0;
        this._lastStepTime = 0;
        // Make sure that step is always called in class context
        this._step = this._stepFn.bind(this, false);
        this._stepImmediate = this._stepFn.bind(this, true);
    }
}
registerMethods({
    Element: {
        timeline: function(timeline) {
            if (timeline == null) {
                this._timeline = this._timeline || new Timeline();
                return this._timeline;
            } else {
                this._timeline = timeline;
                return this;
            }
        }
    }
});
class Runner extends EventTarget {
    constructor(options){
        super();
        // Store a unique id on the runner, so that we can identify it later
        this.id = Runner.id++;
        // Ensure a default value
        options = options == null ? timeline.duration : options;
        // Ensure that we get a controller
        options = typeof options === "function" ? new Controller(options) : options;
        // Declare all of the variables
        this._element = null;
        this._timeline = null;
        this.done = false;
        this._queue = [];
        // Work out the stepper and the duration
        this._duration = typeof options === "number" && options;
        this._isDeclarative = options instanceof Controller;
        this._stepper = this._isDeclarative ? options : new Ease();
        // We copy the current values from the timeline because they can change
        this._history = {};
        // Store the state of the runner
        this.enabled = true;
        this._time = 0;
        this._lastTime = 0;
        // At creation, the runner is in reset state
        this._reseted = true;
        // Save transforms applied to this runner
        this.transforms = new Matrix();
        this.transformId = 1;
        // Looping variables
        this._haveReversed = false;
        this._reverse = false;
        this._loopsDone = 0;
        this._swing = false;
        this._wait = 0;
        this._times = 1;
        this._frameId = null;
        // Stores how long a runner is stored after being done
        this._persist = this._isDeclarative ? true : null;
    }
    static sanitise(duration, delay, when) {
        // Initialise the default parameters
        let times = 1;
        let swing = false;
        let wait = 0;
        duration = duration ?? timeline.duration;
        delay = delay ?? timeline.delay;
        when = when || "last";
        // If we have an object, unpack the values
        if (typeof duration === "object" && !(duration instanceof Stepper)) {
            delay = duration.delay ?? delay;
            when = duration.when ?? when;
            swing = duration.swing || swing;
            times = duration.times ?? times;
            wait = duration.wait ?? wait;
            duration = duration.duration ?? timeline.duration;
        }
        return {
            duration: duration,
            delay: delay,
            swing: swing,
            times: times,
            wait: wait,
            when: when
        };
    }
    active(enabled) {
        if (enabled == null) return this.enabled;
        this.enabled = enabled;
        return this;
    }
    /*
  Private Methods
  ===============
  Methods that shouldn't be used externally
  */ addTransform(transform) {
        this.transforms.lmultiplyO(transform);
        return this;
    }
    after(fn) {
        return this.on("finished", fn);
    }
    animate(duration, delay, when) {
        const o = Runner.sanitise(duration, delay, when);
        const runner = new Runner(o.duration);
        if (this._timeline) runner.timeline(this._timeline);
        if (this._element) runner.element(this._element);
        return runner.loop(o).schedule(o.delay, o.when);
    }
    clearTransform() {
        this.transforms = new Matrix();
        return this;
    }
    // TODO: Keep track of all transformations so that deletion is faster
    clearTransformsFromQueue() {
        if (!this.done || !this._timeline || !this._timeline._runnerIds.includes(this.id)) this._queue = this._queue.filter((item)=>{
            return !item.isTransform;
        });
    }
    delay(delay) {
        return this.animate(0, delay);
    }
    duration() {
        return this._times * (this._wait + this._duration) - this._wait;
    }
    during(fn) {
        return this.queue(null, fn);
    }
    ease(fn) {
        this._stepper = new Ease(fn);
        return this;
    }
    /*
  Runner Definitions
  ==================
  These methods help us define the runtime behaviour of the Runner or they
  help us make new runners from the current runner
  */ element(element) {
        if (element == null) return this._element;
        this._element = element;
        element._prepareRunner();
        return this;
    }
    finish() {
        return this.step(Infinity);
    }
    loop(times, swing, wait) {
        // Deal with the user passing in an object
        if (typeof times === "object") {
            swing = times.swing;
            wait = times.wait;
            times = times.times;
        }
        // Sanitise the values and store them
        this._times = times || Infinity;
        this._swing = swing || false;
        this._wait = wait || 0;
        // Allow true to be passed
        if (this._times === true) this._times = Infinity;
        return this;
    }
    loops(p) {
        const loopDuration = this._duration + this._wait;
        if (p == null) {
            const loopsDone = Math.floor(this._time / loopDuration);
            const relativeTime = this._time - loopsDone * loopDuration;
            const position = relativeTime / this._duration;
            return Math.min(loopsDone + position, this._times);
        }
        const whole = Math.floor(p);
        const partial = p % 1;
        const time = loopDuration * whole + this._duration * partial;
        return this.time(time);
    }
    persist(dtOrForever) {
        if (dtOrForever == null) return this._persist;
        this._persist = dtOrForever;
        return this;
    }
    position(p) {
        // Get all of the variables we need
        const x = this._time;
        const d = this._duration;
        const w = this._wait;
        const t = this._times;
        const s = this._swing;
        const r = this._reverse;
        let position;
        if (p == null) {
            /*
      This function converts a time to a position in the range [0, 1]
      The full explanation can be found in this desmos demonstration
        https://www.desmos.com/calculator/u4fbavgche
      The logic is slightly simplified here because we can use booleans
      */ // Figure out the value without thinking about the start or end time
            const f = function(x) {
                const swinging = s * Math.floor(x % (2 * (w + d)) / (w + d));
                const backwards = swinging && !r || !swinging && r;
                const uncliped = Math.pow(-1, backwards) * (x % (w + d)) / d + backwards;
                const clipped = Math.max(Math.min(uncliped, 1), 0);
                return clipped;
            };
            // Figure out the value by incorporating the start time
            const endTime = t * (w + d) - w;
            position = x <= 0 ? Math.round(f(1e-5)) : x < endTime ? f(x) : Math.round(f(endTime - 1e-5));
            return position;
        }
        // Work out the loops done and add the position to the loops done
        const loopsDone = Math.floor(this.loops());
        const swingForward = s && loopsDone % 2 === 0;
        const forwards = swingForward && !r || r && swingForward;
        position = loopsDone + (forwards ? p : 1 - p);
        return this.loops(position);
    }
    progress(p) {
        if (p == null) return Math.min(1, this._time / this.duration());
        return this.time(p * this.duration());
    }
    /*
  Basic Functionality
  ===================
  These methods allow us to attach basic functions to the runner directly
  */ queue(initFn, runFn, retargetFn, isTransform) {
        this._queue.push({
            initialiser: initFn || noop,
            runner: runFn || noop,
            retarget: retargetFn,
            isTransform: isTransform,
            initialised: false,
            finished: false
        });
        const timeline = this.timeline();
        timeline && this.timeline()._continue();
        return this;
    }
    reset() {
        if (this._reseted) return this;
        this.time(0);
        this._reseted = true;
        return this;
    }
    reverse(reverse) {
        this._reverse = reverse == null ? !this._reverse : reverse;
        return this;
    }
    schedule(timeline, delay, when) {
        // The user doesn't need to pass a timeline if we already have one
        if (!(timeline instanceof Timeline)) {
            when = delay;
            delay = timeline;
            timeline = this.timeline();
        }
        // If there is no timeline, yell at the user...
        if (!timeline) throw Error("Runner cannot be scheduled without timeline");
        // Schedule the runner on the timeline provided
        timeline.schedule(this, delay, when);
        return this;
    }
    step(dt) {
        // If we are inactive, this stepper just gets skipped
        if (!this.enabled) return this;
        // Update the time and get the new position
        dt = dt == null ? 16 : dt;
        this._time += dt;
        const position = this.position();
        // Figure out if we need to run the stepper in this frame
        const running = this._lastPosition !== position && this._time >= 0;
        this._lastPosition = position;
        // Figure out if we just started
        const duration = this.duration();
        const justStarted = this._lastTime <= 0 && this._time > 0;
        const justFinished = this._lastTime < duration && this._time >= duration;
        this._lastTime = this._time;
        if (justStarted) this.fire("start", this);
        // Work out if the runner is finished set the done flag here so animations
        // know, that they are running in the last step (this is good for
        // transformations which can be merged)
        const declarative = this._isDeclarative;
        this.done = !declarative && !justFinished && this._time >= duration;
        // Runner is running. So its not in reset state anymore
        this._reseted = false;
        let converged = false;
        // Call initialise and the run function
        if (running || declarative) {
            this._initialise(running);
            // clear the transforms on this runner so they dont get added again and again
            this.transforms = new Matrix();
            converged = this._run(declarative ? dt : position);
            this.fire("step", this);
        }
        // correct the done flag here
        // declarative animations itself know when they converged
        this.done = this.done || converged && declarative;
        if (justFinished) this.fire("finished", this);
        return this;
    }
    /*
  Runner animation methods
  ========================
  Control how the animation plays
  */ time(time) {
        if (time == null) return this._time;
        const dt = time - this._time;
        this.step(dt);
        return this;
    }
    timeline(timeline) {
        // check explicitly for undefined so we can set the timeline to null
        if (typeof timeline === "undefined") return this._timeline;
        this._timeline = timeline;
        return this;
    }
    unschedule() {
        const timeline = this.timeline();
        timeline && timeline.unschedule(this);
        return this;
    }
    // Run each initialise function in the runner if required
    _initialise(running) {
        // If we aren't running, we shouldn't initialise when not declarative
        if (!running && !this._isDeclarative) return;
        // Loop through all of the initialisers
        for(let i = 0, len = this._queue.length; i < len; ++i){
            // Get the current initialiser
            const current = this._queue[i];
            // Determine whether we need to initialise
            const needsIt = this._isDeclarative || !current.initialised && running;
            running = !current.finished;
            // Call the initialiser if we need to
            if (needsIt && running) {
                current.initialiser.call(this);
                current.initialised = true;
            }
        }
    }
    // Save a morpher to the morpher list so that we can retarget it later
    _rememberMorpher(method, morpher) {
        this._history[method] = {
            morpher: morpher,
            caller: this._queue[this._queue.length - 1]
        };
        // We have to resume the timeline in case a controller
        // is already done without being ever run
        // This can happen when e.g. this is done:
        //    anim = el.animate(new SVG.Spring)
        // and later
        //    anim.move(...)
        if (this._isDeclarative) {
            const timeline = this.timeline();
            timeline && timeline.play();
        }
    }
    // Try to set the target for a morpher if the morpher exists, otherwise
    // Run each run function for the position or dt given
    _run(positionOrDt) {
        // Run all of the _queue directly
        let allfinished = true;
        for(let i = 0, len = this._queue.length; i < len; ++i){
            // Get the current function to run
            const current = this._queue[i];
            // Run the function if its not finished, we keep track of the finished
            // flag for the sake of declarative _queue
            const converged = current.runner.call(this, positionOrDt);
            current.finished = current.finished || converged === true;
            allfinished = allfinished && current.finished;
        }
        // We report when all of the constructors are finished
        return allfinished;
    }
    // do nothing and return false
    _tryRetarget(method, target, extra) {
        if (this._history[method]) {
            // if the last method wasn't even initialised, throw it away
            if (!this._history[method].caller.initialised) {
                const index = this._queue.indexOf(this._history[method].caller);
                this._queue.splice(index, 1);
                return false;
            }
            // for the case of transformations, we use the special retarget function
            // which has access to the outer scope
            if (this._history[method].caller.retarget) this._history[method].caller.retarget.call(this, target, extra);
            else this._history[method].morpher.to(target);
            this._history[method].caller.finished = false;
            const timeline = this.timeline();
            timeline && timeline.play();
            return true;
        }
        return false;
    }
}
Runner.id = 0;
class FakeRunner {
    constructor(transforms = new Matrix(), id = -1, done = true){
        this.transforms = transforms;
        this.id = id;
        this.done = done;
    }
    clearTransformsFromQueue() {}
}
extend([
    Runner,
    FakeRunner
], {
    mergeWith (runner) {
        return new FakeRunner(runner.transforms.lmultiply(this.transforms), runner.id);
    }
});
// FakeRunner.emptyRunner = new FakeRunner()
const lmultiply = (last, curr)=>last.lmultiplyO(curr);
const getRunnerTransform = (runner)=>runner.transforms;
function mergeTransforms() {
    // Find the matrix to apply to the element and apply it
    const runners = this._transformationRunners.runners;
    const netTransform = runners.map(getRunnerTransform).reduce(lmultiply, new Matrix());
    this.transform(netTransform);
    this._transformationRunners.merge();
    if (this._transformationRunners.length() === 1) this._frameId = null;
}
class RunnerArray {
    constructor(){
        this.runners = [];
        this.ids = [];
    }
    add(runner) {
        if (this.runners.includes(runner)) return;
        const id = runner.id + 1;
        this.runners.push(runner);
        this.ids.push(id);
        return this;
    }
    clearBefore(id) {
        const deleteCnt = this.ids.indexOf(id + 1) || 1;
        this.ids.splice(0, deleteCnt, 0);
        this.runners.splice(0, deleteCnt, new FakeRunner()).forEach((r)=>r.clearTransformsFromQueue());
        return this;
    }
    edit(id, newRunner) {
        const index = this.ids.indexOf(id + 1);
        this.ids.splice(index, 1, id + 1);
        this.runners.splice(index, 1, newRunner);
        return this;
    }
    getByID(id) {
        return this.runners[this.ids.indexOf(id + 1)];
    }
    length() {
        return this.ids.length;
    }
    merge() {
        let lastRunner = null;
        for(let i = 0; i < this.runners.length; ++i){
            const runner = this.runners[i];
            const condition = lastRunner && runner.done && lastRunner.done && // don't merge runner when persisted on timeline
            (!runner._timeline || !runner._timeline._runnerIds.includes(runner.id)) && (!lastRunner._timeline || !lastRunner._timeline._runnerIds.includes(lastRunner.id));
            if (condition) {
                // the +1 happens in the function
                this.remove(runner.id);
                const newRunner = runner.mergeWith(lastRunner);
                this.edit(lastRunner.id, newRunner);
                lastRunner = newRunner;
                --i;
            } else lastRunner = runner;
        }
        return this;
    }
    remove(id) {
        const index = this.ids.indexOf(id + 1);
        this.ids.splice(index, 1);
        this.runners.splice(index, 1);
        return this;
    }
}
registerMethods({
    Element: {
        animate (duration, delay, when) {
            const o = Runner.sanitise(duration, delay, when);
            const timeline = this.timeline();
            return new Runner(o.duration).loop(o).element(this).timeline(timeline.play()).schedule(o.delay, o.when);
        },
        delay (by, when) {
            return this.animate(0, by, when);
        },
        // this function searches for all runners on the element and deletes the ones
        // which run before the current one. This is because absolute transformations
        // overwrite anything anyway so there is no need to waste time computing
        // other runners
        _clearTransformRunnersBefore (currentRunner) {
            this._transformationRunners.clearBefore(currentRunner.id);
        },
        _currentTransform (current) {
            return this._transformationRunners.runners// we need the equal sign here to make sure, that also transformations
            // on the same runner which execute before the current transformation are
            // taken into account
            .filter((runner)=>runner.id <= current.id).map(getRunnerTransform).reduce(lmultiply, new Matrix());
        },
        _addRunner (runner) {
            this._transformationRunners.add(runner);
            // Make sure that the runner merge is executed at the very end of
            // all Animator functions. That is why we use immediate here to execute
            // the merge right after all frames are run
            Animator.cancelImmediate(this._frameId);
            this._frameId = Animator.immediate(mergeTransforms.bind(this));
        },
        _prepareRunner () {
            if (this._frameId == null) this._transformationRunners = new RunnerArray().add(new FakeRunner(new Matrix(this)));
        }
    }
});
// Will output the elements from array A that are not in the array B
const difference = (a, b)=>a.filter((x)=>!b.includes(x));
extend(Runner, {
    attr (a, v) {
        return this.styleAttr("attr", a, v);
    },
    // Add animatable styles
    css (s, v) {
        return this.styleAttr("css", s, v);
    },
    styleAttr (type, nameOrAttrs, val) {
        if (typeof nameOrAttrs === "string") return this.styleAttr(type, {
            [nameOrAttrs]: val
        });
        let attrs = nameOrAttrs;
        if (this._tryRetarget(type, attrs)) return this;
        let morpher = new Morphable(this._stepper).to(attrs);
        let keys = Object.keys(attrs);
        this.queue(function() {
            morpher = morpher.from(this.element()[type](keys));
        }, function(pos) {
            this.element()[type](morpher.at(pos).valueOf());
            return morpher.done();
        }, function(newToAttrs) {
            // Check if any new keys were added
            const newKeys = Object.keys(newToAttrs);
            const differences = difference(newKeys, keys);
            // If their are new keys, initialize them and add them to morpher
            if (differences.length) {
                // Get the values
                const addedFromAttrs = this.element()[type](differences);
                // Get the already initialized values
                const oldFromAttrs = new ObjectBag(morpher.from()).valueOf();
                // Merge old and new
                Object.assign(oldFromAttrs, addedFromAttrs);
                morpher.from(oldFromAttrs);
            }
            // Get the object from the morpher
            const oldToAttrs = new ObjectBag(morpher.to()).valueOf();
            // Merge in new attributes
            Object.assign(oldToAttrs, newToAttrs);
            // Change morpher target
            morpher.to(oldToAttrs);
            // Make sure that we save the work we did so we don't need it to do again
            keys = newKeys;
            attrs = newToAttrs;
        });
        this._rememberMorpher(type, morpher);
        return this;
    },
    zoom (level, point) {
        if (this._tryRetarget("zoom", level, point)) return this;
        let morpher = new Morphable(this._stepper).to(new SVGNumber(level));
        this.queue(function() {
            morpher = morpher.from(this.element().zoom());
        }, function(pos) {
            this.element().zoom(morpher.at(pos), point);
            return morpher.done();
        }, function(newLevel, newPoint) {
            point = newPoint;
            morpher.to(newLevel);
        });
        this._rememberMorpher("zoom", morpher);
        return this;
    },
    /**
   ** absolute transformations
   **/ //
    // M v -----|-----(D M v = F v)------|----->  T v
    //
    // 1. define the final state (T) and decompose it (once)
    //    t = [tx, ty, the, lam, sy, sx]
    // 2. on every frame: pull the current state of all previous transforms
    //    (M - m can change)
    //   and then write this as m = [tx0, ty0, the0, lam0, sy0, sx0]
    // 3. Find the interpolated matrix F(pos) = m + pos * (t - m)
    //   - Note F(0) = M
    //   - Note F(1) = T
    // 4. Now you get the delta matrix as a result: D = F * inv(M)
    transform (transforms, relative, affine) {
        // If we have a declarative function, we should retarget it if possible
        relative = transforms.relative || relative;
        if (this._isDeclarative && !relative && this._tryRetarget("transform", transforms)) return this;
        // Parse the parameters
        const isMatrix = Matrix.isMatrixLike(transforms);
        affine = transforms.affine != null ? transforms.affine : affine != null ? affine : !isMatrix;
        // Create a morpher and set its type
        const morpher = new Morphable(this._stepper).type(affine ? TransformBag : Matrix);
        let origin;
        let element;
        let current;
        let currentAngle;
        let startTransform;
        function setup() {
            // make sure element and origin is defined
            element = element || this.element();
            origin = origin || getOrigin(transforms, element);
            startTransform = new Matrix(relative ? undefined : element);
            // add the runner to the element so it can merge transformations
            element._addRunner(this);
            // Deactivate all transforms that have run so far if we are absolute
            if (!relative) element._clearTransformRunnersBefore(this);
        }
        function run(pos) {
            // clear all other transforms before this in case something is saved
            // on this runner. We are absolute. We dont need these!
            if (!relative) this.clearTransform();
            const { x, y } = new Point(origin).transform(element._currentTransform(this));
            let target = new Matrix({
                ...transforms,
                origin: [
                    x,
                    y
                ]
            });
            let start = this._isDeclarative && current ? current : startTransform;
            if (affine) {
                target = target.decompose(x, y);
                start = start.decompose(x, y);
                // Get the current and target angle as it was set
                const rTarget = target.rotate;
                const rCurrent = start.rotate;
                // Figure out the shortest path to rotate directly
                const possibilities = [
                    rTarget - 360,
                    rTarget,
                    rTarget + 360
                ];
                const distances = possibilities.map((a)=>Math.abs(a - rCurrent));
                const shortest = Math.min(...distances);
                const index = distances.indexOf(shortest);
                target.rotate = possibilities[index];
            }
            if (relative) {
                // we have to be careful here not to overwrite the rotation
                // with the rotate method of Matrix
                if (!isMatrix) target.rotate = transforms.rotate || 0;
                if (this._isDeclarative && currentAngle) start.rotate = currentAngle;
            }
            morpher.from(start);
            morpher.to(target);
            const affineParameters = morpher.at(pos);
            currentAngle = affineParameters.rotate;
            current = new Matrix(affineParameters);
            this.addTransform(current);
            element._addRunner(this);
            return morpher.done();
        }
        function retarget(newTransforms) {
            // only get a new origin if it changed since the last call
            if ((newTransforms.origin || "center").toString() !== (transforms.origin || "center").toString()) origin = getOrigin(newTransforms, element);
            // overwrite the old transformations with the new ones
            transforms = {
                ...newTransforms,
                origin: origin
            };
        }
        this.queue(setup, run, retarget, true);
        this._isDeclarative && this._rememberMorpher("transform", morpher);
        return this;
    },
    // Animatable x-axis
    x (x) {
        return this._queueNumber("x", x);
    },
    // Animatable y-axis
    y (y) {
        return this._queueNumber("y", y);
    },
    ax (x) {
        return this._queueNumber("ax", x);
    },
    ay (y) {
        return this._queueNumber("ay", y);
    },
    dx (x = 0) {
        return this._queueNumberDelta("x", x);
    },
    dy (y = 0) {
        return this._queueNumberDelta("y", y);
    },
    dmove (x, y) {
        return this.dx(x).dy(y);
    },
    _queueNumberDelta (method, to) {
        to = new SVGNumber(to);
        // Try to change the target if we have this method already registered
        if (this._tryRetarget(method, to)) return this;
        // Make a morpher and queue the animation
        const morpher = new Morphable(this._stepper).to(to);
        let from = null;
        this.queue(function() {
            from = this.element()[method]();
            morpher.from(from);
            morpher.to(from + to);
        }, function(pos) {
            this.element()[method](morpher.at(pos));
            return morpher.done();
        }, function(newTo) {
            morpher.to(from + new SVGNumber(newTo));
        });
        // Register the morpher so that if it is changed again, we can retarget it
        this._rememberMorpher(method, morpher);
        return this;
    },
    _queueObject (method, to) {
        // Try to change the target if we have this method already registered
        if (this._tryRetarget(method, to)) return this;
        // Make a morpher and queue the animation
        const morpher = new Morphable(this._stepper).to(to);
        this.queue(function() {
            morpher.from(this.element()[method]());
        }, function(pos) {
            this.element()[method](morpher.at(pos));
            return morpher.done();
        });
        // Register the morpher so that if it is changed again, we can retarget it
        this._rememberMorpher(method, morpher);
        return this;
    },
    _queueNumber (method, value) {
        return this._queueObject(method, new SVGNumber(value));
    },
    // Animatable center x-axis
    cx (x) {
        return this._queueNumber("cx", x);
    },
    // Animatable center y-axis
    cy (y) {
        return this._queueNumber("cy", y);
    },
    // Add animatable move
    move (x, y) {
        return this.x(x).y(y);
    },
    amove (x, y) {
        return this.ax(x).ay(y);
    },
    // Add animatable center
    center (x, y) {
        return this.cx(x).cy(y);
    },
    // Add animatable size
    size (width, height) {
        // animate bbox based size for all other elements
        let box;
        if (!width || !height) box = this._element.bbox();
        if (!width) width = box.width / box.height * height;
        if (!height) height = box.height / box.width * width;
        return this.width(width).height(height);
    },
    // Add animatable width
    width (width) {
        return this._queueNumber("width", width);
    },
    // Add animatable height
    height (height) {
        return this._queueNumber("height", height);
    },
    // Add animatable plot
    plot (a, b, c, d) {
        // Lines can be plotted with 4 arguments
        if (arguments.length === 4) return this.plot([
            a,
            b,
            c,
            d
        ]);
        if (this._tryRetarget("plot", a)) return this;
        const morpher = new Morphable(this._stepper).type(this._element.MorphArray).to(a);
        this.queue(function() {
            morpher.from(this._element.array());
        }, function(pos) {
            this._element.plot(morpher.at(pos));
            return morpher.done();
        });
        this._rememberMorpher("plot", morpher);
        return this;
    },
    // Add leading method
    leading (value) {
        return this._queueNumber("leading", value);
    },
    // Add animatable viewbox
    viewbox (x, y, width, height) {
        return this._queueObject("viewbox", new Box(x, y, width, height));
    },
    update (o) {
        if (typeof o !== "object") return this.update({
            offset: arguments[0],
            color: arguments[1],
            opacity: arguments[2]
        });
        if (o.opacity != null) this.attr("stop-opacity", o.opacity);
        if (o.color != null) this.attr("stop-color", o.color);
        if (o.offset != null) this.attr("offset", o.offset);
        return this;
    }
});
extend(Runner, {
    rx: rx,
    ry: ry,
    from: from,
    to: to
});
register(Runner, "Runner");
class Svg extends Container {
    constructor(node, attrs = node){
        super(nodeOrNew("svg", node), attrs);
        this.namespace();
    }
    // Creates and returns defs element
    defs() {
        if (!this.isRoot()) return this.root().defs();
        return adopt(this.node.querySelector("defs")) || this.put(new Defs());
    }
    isRoot() {
        return !this.node.parentNode || !(this.node.parentNode instanceof globals.window.SVGElement) && this.node.parentNode.nodeName !== "#document-fragment";
    }
    // Add namespaces
    namespace() {
        if (!this.isRoot()) return this.root().namespace();
        return this.attr({
            xmlns: svg,
            version: "1.1"
        }).attr("xmlns:xlink", xlink, xmlns);
    }
    removeNamespace() {
        return this.attr({
            xmlns: null,
            version: null
        }).attr("xmlns:xlink", null, xmlns).attr("xmlns:svgjs", null, xmlns);
    }
    // Check if this is a root svg
    // If not, call root() from this element
    root() {
        if (this.isRoot()) return this;
        return super.root();
    }
}
registerMethods({
    Container: {
        // Create nested svg document
        nested: wrapWithAttrCheck(function() {
            return this.put(new Svg());
        })
    }
});
register(Svg, "Svg", true);
class Symbol extends Container {
    // Initialize node
    constructor(node, attrs = node){
        super(nodeOrNew("symbol", node), attrs);
    }
}
registerMethods({
    Container: {
        symbol: wrapWithAttrCheck(function() {
            return this.put(new Symbol());
        })
    }
});
register(Symbol, "Symbol");
// Create plain text node
function plain(text) {
    // clear if build mode is disabled
    if (this._build === false) this.clear();
    // create text node
    this.node.appendChild(globals.document.createTextNode(text));
    return this;
}
// Get length of text element
function length() {
    return this.node.getComputedTextLength();
}
// Move over x-axis
// Text is moved by its bounding box
// text-anchor does NOT matter
function x$1(x, box = this.bbox()) {
    if (x == null) return box.x;
    return this.attr("x", this.attr("x") + x - box.x);
}
// Move over y-axis
function y$1(y, box = this.bbox()) {
    if (y == null) return box.y;
    return this.attr("y", this.attr("y") + y - box.y);
}
function move$1(x, y, box = this.bbox()) {
    return this.x(x, box).y(y, box);
}
// Move center over x-axis
function cx(x, box = this.bbox()) {
    if (x == null) return box.cx;
    return this.attr("x", this.attr("x") + x - box.cx);
}
// Move center over y-axis
function cy(y, box = this.bbox()) {
    if (y == null) return box.cy;
    return this.attr("y", this.attr("y") + y - box.cy);
}
function center(x, y, box = this.bbox()) {
    return this.cx(x, box).cy(y, box);
}
function ax(x) {
    return this.attr("x", x);
}
function ay(y) {
    return this.attr("y", y);
}
function amove(x, y) {
    return this.ax(x).ay(y);
}
// Enable / disable build mode
function build(build) {
    this._build = !!build;
    return this;
}
var textable = {
    __proto__: null,
    amove: amove,
    ax: ax,
    ay: ay,
    build: build,
    center: center,
    cx: cx,
    cy: cy,
    length: length,
    move: move$1,
    plain: plain,
    x: x$1,
    y: y$1
};
class Text extends Shape {
    // Initialize node
    constructor(node, attrs = node){
        super(nodeOrNew("text", node), attrs);
        this.dom.leading = this.dom.leading ?? new SVGNumber(1.3); // store leading value for rebuilding
        this._rebuild = true; // enable automatic updating of dy values
        this._build = false; // disable build mode for adding multiple lines
    }
    // Set / get leading
    leading(value) {
        // act as getter
        if (value == null) return this.dom.leading;
        // act as setter
        this.dom.leading = new SVGNumber(value);
        return this.rebuild();
    }
    // Rebuild appearance type
    rebuild(rebuild) {
        // store new rebuild flag if given
        if (typeof rebuild === "boolean") this._rebuild = rebuild;
        // define position of all lines
        if (this._rebuild) {
            const self = this;
            let blankLineOffset = 0;
            const leading = this.dom.leading;
            this.each(function(i) {
                if (isDescriptive(this.node)) return;
                const fontSize = globals.window.getComputedStyle(this.node).getPropertyValue("font-size");
                const dy = leading * new SVGNumber(fontSize);
                if (this.dom.newLined) {
                    this.attr("x", self.attr("x"));
                    if (this.text() === "\n") blankLineOffset += dy;
                    else {
                        this.attr("dy", i ? dy + blankLineOffset : 0);
                        blankLineOffset = 0;
                    }
                }
            });
            this.fire("rebuild");
        }
        return this;
    }
    // overwrite method from parent to set data properly
    setData(o) {
        this.dom = o;
        this.dom.leading = new SVGNumber(o.leading || 1.3);
        return this;
    }
    writeDataToDom() {
        writeDataToDom(this, this.dom, {
            leading: 1.3
        });
        return this;
    }
    // Set the text content
    text(text) {
        // act as getter
        if (text === undefined) {
            const children = this.node.childNodes;
            let firstLine = 0;
            text = "";
            for(let i = 0, len = children.length; i < len; ++i){
                // skip textPaths - they are no lines
                if (children[i].nodeName === "textPath" || isDescriptive(children[i])) {
                    if (i === 0) firstLine = i + 1;
                    continue;
                }
                // add newline if its not the first child and newLined is set to true
                if (i !== firstLine && children[i].nodeType !== 3 && adopt(children[i]).dom.newLined === true) text += "\n";
                // add content of this node
                text += children[i].textContent;
            }
            return text;
        }
        // remove existing content
        this.clear().build(true);
        if (typeof text === "function") // call block
        text.call(this, this);
        else {
            // store text and make sure text is not blank
            text = (text + "").split("\n");
            // build new lines
            for(let j = 0, jl = text.length; j < jl; j++)this.newLine(text[j]);
        }
        // disable build mode and rebuild lines
        return this.build(false).rebuild();
    }
}
extend(Text, textable);
registerMethods({
    Container: {
        // Create text element
        text: wrapWithAttrCheck(function(text = "") {
            return this.put(new Text()).text(text);
        }),
        // Create plain text element
        plain: wrapWithAttrCheck(function(text = "") {
            return this.put(new Text()).plain(text);
        })
    }
});
register(Text, "Text");
class Tspan extends Shape {
    // Initialize node
    constructor(node, attrs = node){
        super(nodeOrNew("tspan", node), attrs);
        this._build = false; // disable build mode for adding multiple lines
    }
    // Shortcut dx
    dx(dx) {
        return this.attr("dx", dx);
    }
    // Shortcut dy
    dy(dy) {
        return this.attr("dy", dy);
    }
    // Create new line
    newLine() {
        // mark new line
        this.dom.newLined = true;
        // fetch parent
        const text = this.parent();
        // early return in case we are not in a text element
        if (!(text instanceof Text)) return this;
        const i = text.index(this);
        const fontSize = globals.window.getComputedStyle(this.node).getPropertyValue("font-size");
        const dy = text.dom.leading * new SVGNumber(fontSize);
        // apply new position
        return this.dy(i ? dy : 0).attr("x", text.x());
    }
    // Set text content
    text(text) {
        if (text == null) return this.node.textContent + (this.dom.newLined ? "\n" : "");
        if (typeof text === "function") {
            this.clear().build(true);
            text.call(this, this);
            this.build(false);
        } else this.plain(text);
        return this;
    }
}
extend(Tspan, textable);
registerMethods({
    Tspan: {
        tspan: wrapWithAttrCheck(function(text = "") {
            const tspan = new Tspan();
            // clear if build mode is disabled
            if (!this._build) this.clear();
            // add new tspan
            return this.put(tspan).text(text);
        })
    },
    Text: {
        newLine: function(text = "") {
            return this.tspan(text).newLine();
        }
    }
});
register(Tspan, "Tspan");
class Circle extends Shape {
    constructor(node, attrs = node){
        super(nodeOrNew("circle", node), attrs);
    }
    radius(r) {
        return this.attr("r", r);
    }
    // Radius x value
    rx(rx) {
        return this.attr("r", rx);
    }
    // Alias radius x value
    ry(ry) {
        return this.rx(ry);
    }
    size(size) {
        return this.radius(new SVGNumber(size).divide(2));
    }
}
extend(Circle, {
    x: x$3,
    y: y$3,
    cx: cx$1,
    cy: cy$1,
    width: width$2,
    height: height$2
});
registerMethods({
    Container: {
        // Create circle element
        circle: wrapWithAttrCheck(function(size = 0) {
            return this.put(new Circle()).size(size).move(0, 0);
        })
    }
});
register(Circle, "Circle");
class ClipPath extends Container {
    constructor(node, attrs = node){
        super(nodeOrNew("clipPath", node), attrs);
    }
    // Unclip all clipped elements and remove itself
    remove() {
        // unclip all targets
        this.targets().forEach(function(el) {
            el.unclip();
        });
        // remove clipPath from parent
        return super.remove();
    }
    targets() {
        return baseFind("svg [clip-path*=" + this.id() + "]");
    }
}
registerMethods({
    Container: {
        // Create clipping element
        clip: wrapWithAttrCheck(function() {
            return this.defs().put(new ClipPath());
        })
    },
    Element: {
        // Distribute clipPath to svg element
        clipper () {
            return this.reference("clip-path");
        },
        clipWith (element) {
            // use given clip or create a new one
            const clipper = element instanceof ClipPath ? element : this.parent().clip().add(element);
            // apply mask
            return this.attr("clip-path", "url(#" + clipper.id() + ")");
        },
        // Unclip element
        unclip () {
            return this.attr("clip-path", null);
        }
    }
});
register(ClipPath, "ClipPath");
class ForeignObject extends Element {
    constructor(node, attrs = node){
        super(nodeOrNew("foreignObject", node), attrs);
    }
}
registerMethods({
    Container: {
        foreignObject: wrapWithAttrCheck(function(width, height) {
            return this.put(new ForeignObject()).size(width, height);
        })
    }
});
register(ForeignObject, "ForeignObject");
function dmove(dx, dy) {
    this.children().forEach((child)=>{
        let bbox;
        // We have to wrap this for elements that dont have a bbox
        // e.g. title and other descriptive elements
        try {
            // Get the childs bbox
            // Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=1905039
            // Because bbox for nested svgs returns the contents bbox in the coordinate space of the svg itself (weird!), we cant use bbox for svgs
            // Therefore we have to use getBoundingClientRect. But THAT is broken (as explained in the bug).
            // Funnily enough the broken behavior would work for us but that breaks it in chrome
            // So we have to replicate the broken behavior of FF by just reading the attributes of the svg itself
            bbox = child.node instanceof getWindow().SVGSVGElement ? new Box(child.attr([
                "x",
                "y",
                "width",
                "height"
            ])) : child.bbox();
        } catch (e) {
            return;
        }
        // Get childs matrix
        const m = new Matrix(child);
        // Translate childs matrix by amount and
        // transform it back into parents space
        const matrix = m.translate(dx, dy).transform(m.inverse());
        // Calculate new x and y from old box
        const p = new Point(bbox.x, bbox.y).transform(matrix);
        // Move element
        child.move(p.x, p.y);
    });
    return this;
}
function dx(dx) {
    return this.dmove(dx, 0);
}
function dy(dy) {
    return this.dmove(0, dy);
}
function height(height, box = this.bbox()) {
    if (height == null) return box.height;
    return this.size(box.width, height, box);
}
function move(x = 0, y = 0, box = this.bbox()) {
    const dx = x - box.x;
    const dy = y - box.y;
    return this.dmove(dx, dy);
}
function size(width, height, box = this.bbox()) {
    const p = proportionalSize(this, width, height, box);
    const scaleX = p.width / box.width;
    const scaleY = p.height / box.height;
    this.children().forEach((child)=>{
        const o = new Point(box).transform(new Matrix(child).inverse());
        child.scale(scaleX, scaleY, o.x, o.y);
    });
    return this;
}
function width(width, box = this.bbox()) {
    if (width == null) return box.width;
    return this.size(width, box.height, box);
}
function x(x, box = this.bbox()) {
    if (x == null) return box.x;
    return this.move(x, box.y, box);
}
function y(y, box = this.bbox()) {
    if (y == null) return box.y;
    return this.move(box.x, y, box);
}
var containerGeometry = {
    __proto__: null,
    dmove: dmove,
    dx: dx,
    dy: dy,
    height: height,
    move: move,
    size: size,
    width: width,
    x: x,
    y: y
};
class G extends Container {
    constructor(node, attrs = node){
        super(nodeOrNew("g", node), attrs);
    }
}
extend(G, containerGeometry);
registerMethods({
    Container: {
        // Create a group element
        group: wrapWithAttrCheck(function() {
            return this.put(new G());
        })
    }
});
register(G, "G");
class A extends Container {
    constructor(node, attrs = node){
        super(nodeOrNew("a", node), attrs);
    }
    // Link target attribute
    target(target) {
        return this.attr("target", target);
    }
    // Link url
    to(url) {
        return this.attr("href", url, xlink);
    }
}
extend(A, containerGeometry);
registerMethods({
    Container: {
        // Create a hyperlink element
        link: wrapWithAttrCheck(function(url) {
            return this.put(new A()).to(url);
        })
    },
    Element: {
        unlink () {
            const link = this.linker();
            if (!link) return this;
            const parent = link.parent();
            if (!parent) return this.remove();
            const index = parent.index(link);
            parent.add(this, index);
            link.remove();
            return this;
        },
        linkTo (url) {
            // reuse old link if possible
            let link = this.linker();
            if (!link) {
                link = new A();
                this.wrap(link);
            }
            if (typeof url === "function") url.call(link, link);
            else link.to(url);
            return this;
        },
        linker () {
            const link = this.parent();
            if (link && link.node.nodeName.toLowerCase() === "a") return link;
            return null;
        }
    }
});
register(A, "A");
class Mask extends Container {
    // Initialize node
    constructor(node, attrs = node){
        super(nodeOrNew("mask", node), attrs);
    }
    // Unmask all masked elements and remove itself
    remove() {
        // unmask all targets
        this.targets().forEach(function(el) {
            el.unmask();
        });
        // remove mask from parent
        return super.remove();
    }
    targets() {
        return baseFind("svg [mask*=" + this.id() + "]");
    }
}
registerMethods({
    Container: {
        mask: wrapWithAttrCheck(function() {
            return this.defs().put(new Mask());
        })
    },
    Element: {
        // Distribute mask to svg element
        masker () {
            return this.reference("mask");
        },
        maskWith (element) {
            // use given mask or create a new one
            const masker = element instanceof Mask ? element : this.parent().mask().add(element);
            // apply mask
            return this.attr("mask", "url(#" + masker.id() + ")");
        },
        // Unmask element
        unmask () {
            return this.attr("mask", null);
        }
    }
});
register(Mask, "Mask");
class Stop extends Element {
    constructor(node, attrs = node){
        super(nodeOrNew("stop", node), attrs);
    }
    // add color stops
    update(o) {
        if (typeof o === "number" || o instanceof SVGNumber) o = {
            offset: arguments[0],
            color: arguments[1],
            opacity: arguments[2]
        };
        // set attributes
        if (o.opacity != null) this.attr("stop-opacity", o.opacity);
        if (o.color != null) this.attr("stop-color", o.color);
        if (o.offset != null) this.attr("offset", new SVGNumber(o.offset));
        return this;
    }
}
registerMethods({
    Gradient: {
        // Add a color stop
        stop: function(offset, color, opacity) {
            return this.put(new Stop()).update(offset, color, opacity);
        }
    }
});
register(Stop, "Stop");
function cssRule(selector, rule) {
    if (!selector) return "";
    if (!rule) return selector;
    let ret = selector + "{";
    for(const i in rule)ret += unCamelCase(i) + ":" + rule[i] + ";";
    ret += "}";
    return ret;
}
class Style extends Element {
    constructor(node, attrs = node){
        super(nodeOrNew("style", node), attrs);
    }
    addText(w = "") {
        this.node.textContent += w;
        return this;
    }
    font(name, src, params = {}) {
        return this.rule("@font-face", {
            fontFamily: name,
            src: src,
            ...params
        });
    }
    rule(selector, obj) {
        return this.addText(cssRule(selector, obj));
    }
}
registerMethods("Dom", {
    style (selector, obj) {
        return this.put(new Style()).rule(selector, obj);
    },
    fontface (name, src, params) {
        return this.put(new Style()).font(name, src, params);
    }
});
register(Style, "Style");
class TextPath extends Text {
    // Initialize node
    constructor(node, attrs = node){
        super(nodeOrNew("textPath", node), attrs);
    }
    // return the array of the path track element
    array() {
        const track = this.track();
        return track ? track.array() : null;
    }
    // Plot path if any
    plot(d) {
        const track = this.track();
        let pathArray = null;
        if (track) pathArray = track.plot(d);
        return d == null ? pathArray : this;
    }
    // Get the path element
    track() {
        return this.reference("href");
    }
}
registerMethods({
    Container: {
        textPath: wrapWithAttrCheck(function(text, path) {
            // Convert text to instance if needed
            if (!(text instanceof Text)) text = this.text(text);
            return text.path(path);
        })
    },
    Text: {
        // Create path for text to run on
        path: wrapWithAttrCheck(function(track, importNodes = true) {
            const textPath = new TextPath();
            // if track is a path, reuse it
            if (!(track instanceof Path)) // create path element
            track = this.defs().path(track);
            // link textPath to path and add content
            textPath.attr("href", "#" + track, xlink);
            // Transplant all nodes from text to textPath
            let node;
            if (importNodes) while(node = this.node.firstChild)textPath.node.appendChild(node);
            // add textPath element as child node and return textPath
            return this.put(textPath);
        }),
        // Get the textPath children
        textPath () {
            return this.findOne("textPath");
        }
    },
    Path: {
        // creates a textPath from this path
        text: wrapWithAttrCheck(function(text) {
            // Convert text to instance if needed
            if (!(text instanceof Text)) text = new Text().addTo(this.parent()).text(text);
            // Create textPath from text and path and return
            return text.path(this);
        }),
        targets () {
            return baseFind("svg textPath").filter((node)=>{
                return (node.attr("href") || "").includes(this.id());
            });
        // Does not work in IE11. Use when IE support is dropped
        // return baseFind('svg textPath[*|href*=' + this.id() + ']')
        }
    }
});
TextPath.prototype.MorphArray = PathArray;
register(TextPath, "TextPath");
class Use extends Shape {
    constructor(node, attrs = node){
        super(nodeOrNew("use", node), attrs);
    }
    // Use element as a reference
    use(element, file) {
        // Set lined element
        return this.attr("href", (file || "") + "#" + element, xlink);
    }
}
registerMethods({
    Container: {
        // Create a use element
        use: wrapWithAttrCheck(function(element, file) {
            return this.put(new Use()).use(element, file);
        })
    }
});
register(Use, "Use");
/* Optional Modules */ const SVG = makeInstance;
extend([
    Svg,
    Symbol,
    Image,
    Pattern,
    Marker
], getMethodsFor("viewbox"));
extend([
    Line,
    Polyline,
    Polygon,
    Path
], getMethodsFor("marker"));
extend(Text, getMethodsFor("Text"));
extend(Path, getMethodsFor("Path"));
extend(Defs, getMethodsFor("Defs"));
extend([
    Text,
    Tspan
], getMethodsFor("Tspan"));
extend([
    Rect,
    Ellipse,
    Gradient,
    Runner
], getMethodsFor("radius"));
extend(EventTarget, getMethodsFor("EventTarget"));
extend(Dom, getMethodsFor("Dom"));
extend(Element, getMethodsFor("Element"));
extend(Shape, getMethodsFor("Shape"));
extend([
    Container,
    Fragment
], getMethodsFor("Container"));
extend(Gradient, getMethodsFor("Gradient"));
extend(Runner, getMethodsFor("Runner"));
List.extend(getMethodNames());
registerMorphableType([
    SVGNumber,
    Color,
    Box,
    Matrix,
    SVGArray,
    PointArray,
    PathArray,
    Point
]);
makeMorphable();

});

parcelRegister("33Mmf", function(module, exports) {

$parcel$export(module.exports, "clearCache", function () { return $23a729c1be10d33d$export$d2adf65b87e47523; });
$parcel$export(module.exports, "Parser", function () { return $23a729c1be10d33d$export$7acfa6ed01010e37; });
$parcel$export(module.exports, "VERSION", function () { return (parcelRequire("eMKuy")).VERSION; });
$parcel$export(module.exports, "CstParser", function () { return (parcelRequire("5qjkp")).CstParser; });
$parcel$export(module.exports, "EmbeddedActionsParser", function () { return (parcelRequire("5qjkp")).EmbeddedActionsParser; });
$parcel$export(module.exports, "ParserDefinitionErrorType", function () { return (parcelRequire("5qjkp")).ParserDefinitionErrorType; });
$parcel$export(module.exports, "EMPTY_ALT", function () { return (parcelRequire("5qjkp")).EMPTY_ALT; });
$parcel$export(module.exports, "Lexer", function () { return (parcelRequire("eSJX3")).Lexer; });
$parcel$export(module.exports, "LexerDefinitionErrorType", function () { return (parcelRequire("eSJX3")).LexerDefinitionErrorType; });
$parcel$export(module.exports, "createToken", function () { return (parcelRequire("hvAWv")).createToken; });
$parcel$export(module.exports, "createTokenInstance", function () { return (parcelRequire("hvAWv")).createTokenInstance; });
$parcel$export(module.exports, "EOF", function () { return (parcelRequire("hvAWv")).EOF; });
$parcel$export(module.exports, "tokenLabel", function () { return (parcelRequire("hvAWv")).tokenLabel; });
$parcel$export(module.exports, "tokenMatcher", function () { return (parcelRequire("hvAWv")).tokenMatcher; });
$parcel$export(module.exports, "tokenName", function () { return (parcelRequire("hvAWv")).tokenName; });
$parcel$export(module.exports, "defaultGrammarResolverErrorProvider", function () { return (parcelRequire("hUgka")).defaultGrammarResolverErrorProvider; });
$parcel$export(module.exports, "defaultGrammarValidatorErrorProvider", function () { return (parcelRequire("hUgka")).defaultGrammarValidatorErrorProvider; });
$parcel$export(module.exports, "defaultParserErrorProvider", function () { return (parcelRequire("hUgka")).defaultParserErrorProvider; });
$parcel$export(module.exports, "EarlyExitException", function () { return (parcelRequire("czA2c")).EarlyExitException; });
$parcel$export(module.exports, "isRecognitionException", function () { return (parcelRequire("czA2c")).isRecognitionException; });
$parcel$export(module.exports, "MismatchedTokenException", function () { return (parcelRequire("czA2c")).MismatchedTokenException; });
$parcel$export(module.exports, "NotAllInputParsedException", function () { return (parcelRequire("czA2c")).NotAllInputParsedException; });
$parcel$export(module.exports, "NoViableAltException", function () { return (parcelRequire("czA2c")).NoViableAltException; });
$parcel$export(module.exports, "defaultLexerErrorProvider", function () { return (parcelRequire("lMxRC")).defaultLexerErrorProvider; });
$parcel$export(module.exports, "Alternation", function () { return (parcelRequire("bbUHG")).Alternation; });
$parcel$export(module.exports, "Alternative", function () { return (parcelRequire("bbUHG")).Alternative; });
$parcel$export(module.exports, "NonTerminal", function () { return (parcelRequire("bbUHG")).NonTerminal; });
$parcel$export(module.exports, "Option", function () { return (parcelRequire("bbUHG")).Option; });
$parcel$export(module.exports, "Repetition", function () { return (parcelRequire("bbUHG")).Repetition; });
$parcel$export(module.exports, "RepetitionMandatory", function () { return (parcelRequire("bbUHG")).RepetitionMandatory; });
$parcel$export(module.exports, "RepetitionMandatoryWithSeparator", function () { return (parcelRequire("bbUHG")).RepetitionMandatoryWithSeparator; });
$parcel$export(module.exports, "RepetitionWithSeparator", function () { return (parcelRequire("bbUHG")).RepetitionWithSeparator; });
$parcel$export(module.exports, "Rule", function () { return (parcelRequire("bbUHG")).Rule; });
$parcel$export(module.exports, "Terminal", function () { return (parcelRequire("bbUHG")).Terminal; });
$parcel$export(module.exports, "serializeGrammar", function () { return (parcelRequire("bbUHG")).serializeGrammar; });
$parcel$export(module.exports, "serializeProduction", function () { return (parcelRequire("bbUHG")).serializeProduction; });
$parcel$export(module.exports, "GAstVisitor", function () { return (parcelRequire("1bKra")).GAstVisitor; });
$parcel$export(module.exports, "assignOccurrenceIndices", function () { return (parcelRequire("ciB86")).assignOccurrenceIndices; });
$parcel$export(module.exports, "resolveGrammar", function () { return (parcelRequire("ciB86")).resolveGrammar; });
$parcel$export(module.exports, "validateGrammar", function () { return (parcelRequire("ciB86")).validateGrammar; });
$parcel$export(module.exports, "createSyntaxDiagramsCode", function () { return (parcelRequire("IrQ3e")).createSyntaxDiagramsCode; });
$parcel$export(module.exports, "generateParserFactory", function () { return (parcelRequire("an09V")).generateParserFactory; });
$parcel$export(module.exports, "generateParserModule", function () { return (parcelRequire("an09V")).generateParserModule; });
/* istanbul ignore file - tricky to import some things from this module during testing */ // semantic version

var $eMKuy = parcelRequire("eMKuy");

var $5qjkp = parcelRequire("5qjkp");

var $eSJX3 = parcelRequire("eSJX3");

var $hvAWv = parcelRequire("hvAWv");

var $hUgka = parcelRequire("hUgka");

var $czA2c = parcelRequire("czA2c");

var $lMxRC = parcelRequire("lMxRC");

var $bbUHG = parcelRequire("bbUHG");

var $1bKra = parcelRequire("1bKra");

var $ciB86 = parcelRequire("ciB86");

var $IrQ3e = parcelRequire("IrQ3e");

var $an09V = parcelRequire("an09V");
function $23a729c1be10d33d$export$d2adf65b87e47523() {
    console.warn("The clearCache function was 'soft' removed from the Chevrotain API.\n	 It performs no action other than printing this message.\n	 Please avoid using it as it will be completely removed in the future");
}
var $23a729c1be10d33d$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser() {
        throw new Error("The Parser class has been deprecated, use CstParser or EmbeddedActionsParser instead.	\nSee: https://sap.github.io/chevrotain/docs/changes/BREAKING_CHANGES.html#_7-0-0");
    }
    return Parser;
}();

});
parcelRegister("eMKuy", function(module, exports) {

$parcel$export(module.exports, "VERSION", function () { return $ac399cb1ca6709bc$export$a4ad2735b021c132; });
// needs a separate module as this is required inside chevrotain productive code
// and also in the entry point for webpack(api.ts).
// A separate file avoids cyclic dependencies and webpack errors.
var $ac399cb1ca6709bc$export$a4ad2735b021c132 = "7.1.1";

});

parcelRegister("5qjkp", function(module, exports) {

$parcel$export(module.exports, "END_OF_FILE", function () { return $3f2e5fa27a80e71d$export$1cb34a082d73b5a4; });
$parcel$export(module.exports, "DEFAULT_PARSER_CONFIG", function () { return $3f2e5fa27a80e71d$export$8396fa8bfa292fca; });
$parcel$export(module.exports, "DEFAULT_RULE_CONFIG", function () { return $3f2e5fa27a80e71d$export$7b99502c28ab7c7b; });
$parcel$export(module.exports, "ParserDefinitionErrorType", function () { return $3f2e5fa27a80e71d$export$86bd3f602f298cb6; });
$parcel$export(module.exports, "EMPTY_ALT", function () { return $3f2e5fa27a80e71d$export$ce9c850516ba763e; });
$parcel$export(module.exports, "CstParser", function () { return $3f2e5fa27a80e71d$export$3ee4bf74abf432cd; });
$parcel$export(module.exports, "EmbeddedActionsParser", function () { return $3f2e5fa27a80e71d$export$e1a5f464f819d888; });

var $5mLYn = parcelRequire("5mLYn");

var $b8PtM = parcelRequire("b8PtM");

var $hvAWv = parcelRequire("hvAWv");

var $hUgka = parcelRequire("hUgka");

var $ciB86 = parcelRequire("ciB86");

var $8VG34 = parcelRequire("8VG34");

var $32FQp = parcelRequire("32FQp");

var $8zxTb = parcelRequire("8zxTb");

var $awxar = parcelRequire("awxar");

var $lzzFw = parcelRequire("lzzFw");

var $1gH4Q = parcelRequire("1gH4Q");

var $dBSuc = parcelRequire("dBSuc");

var $e17bs = parcelRequire("e17bs");

var $hsTas = parcelRequire("hsTas");

var $dBicR = parcelRequire("dBicR");
var $3f2e5fa27a80e71d$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $3f2e5fa27a80e71d$export$1cb34a082d73b5a4 = (0, $hvAWv.createTokenInstance)((0, $hvAWv.EOF), "", NaN, NaN, NaN, NaN, NaN, NaN);
Object.freeze($3f2e5fa27a80e71d$export$1cb34a082d73b5a4);
var $3f2e5fa27a80e71d$export$8396fa8bfa292fca = Object.freeze({
    recoveryEnabled: false,
    maxLookahead: 3,
    dynamicTokensEnabled: false,
    outputCst: true,
    errorMessageProvider: (0, $hUgka.defaultParserErrorProvider),
    nodeLocationTracking: "none",
    traceInitPerf: false,
    skipValidations: false
});
var $3f2e5fa27a80e71d$export$7b99502c28ab7c7b = Object.freeze({
    recoveryValueFunc: function() {
        return undefined;
    },
    resyncEnabled: true
});
var $3f2e5fa27a80e71d$export$86bd3f602f298cb6;
(function(ParserDefinitionErrorType) {
    ParserDefinitionErrorType[ParserDefinitionErrorType["INVALID_RULE_NAME"] = 0] = "INVALID_RULE_NAME";
    ParserDefinitionErrorType[ParserDefinitionErrorType["DUPLICATE_RULE_NAME"] = 1] = "DUPLICATE_RULE_NAME";
    ParserDefinitionErrorType[ParserDefinitionErrorType["INVALID_RULE_OVERRIDE"] = 2] = "INVALID_RULE_OVERRIDE";
    ParserDefinitionErrorType[ParserDefinitionErrorType["DUPLICATE_PRODUCTIONS"] = 3] = "DUPLICATE_PRODUCTIONS";
    ParserDefinitionErrorType[ParserDefinitionErrorType["UNRESOLVED_SUBRULE_REF"] = 4] = "UNRESOLVED_SUBRULE_REF";
    ParserDefinitionErrorType[ParserDefinitionErrorType["LEFT_RECURSION"] = 5] = "LEFT_RECURSION";
    ParserDefinitionErrorType[ParserDefinitionErrorType["NONE_LAST_EMPTY_ALT"] = 6] = "NONE_LAST_EMPTY_ALT";
    ParserDefinitionErrorType[ParserDefinitionErrorType["AMBIGUOUS_ALTS"] = 7] = "AMBIGUOUS_ALTS";
    ParserDefinitionErrorType[ParserDefinitionErrorType["CONFLICT_TOKENS_RULES_NAMESPACE"] = 8] = "CONFLICT_TOKENS_RULES_NAMESPACE";
    ParserDefinitionErrorType[ParserDefinitionErrorType["INVALID_TOKEN_NAME"] = 9] = "INVALID_TOKEN_NAME";
    ParserDefinitionErrorType[ParserDefinitionErrorType["NO_NON_EMPTY_LOOKAHEAD"] = 10] = "NO_NON_EMPTY_LOOKAHEAD";
    ParserDefinitionErrorType[ParserDefinitionErrorType["AMBIGUOUS_PREFIX_ALTS"] = 11] = "AMBIGUOUS_PREFIX_ALTS";
    ParserDefinitionErrorType[ParserDefinitionErrorType["TOO_MANY_ALTS"] = 12] = "TOO_MANY_ALTS";
})($3f2e5fa27a80e71d$export$86bd3f602f298cb6 || ($3f2e5fa27a80e71d$export$86bd3f602f298cb6 = {}));
function $3f2e5fa27a80e71d$export$ce9c850516ba763e(value) {
    if (value === void 0) value = undefined;
    return function() {
        return value;
    };
}
var $3f2e5fa27a80e71d$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(tokenVocabulary, config) {
        this.definitionErrors = [];
        this.selfAnalysisDone = false;
        var that = this;
        that.initErrorHandler(config);
        that.initLexerAdapter();
        that.initLooksAhead(config);
        that.initRecognizerEngine(tokenVocabulary, config);
        that.initRecoverable(config);
        that.initTreeBuilder(config);
        that.initContentAssist();
        that.initGastRecorder(config);
        that.initPerformanceTracer(config);
        if ((0, $5mLYn.has)(config, "ignoredIssues")) throw new Error("The <ignoredIssues> IParserConfig property has been deprecated.\n	Please use the <IGNORE_AMBIGUITIES> flag on the relevant DSL method instead.\n	See: https://sap.github.io/chevrotain/docs/guide/resolving_grammar_errors.html#IGNORING_AMBIGUITIES\n	For further details.");
        this.skipValidations = (0, $5mLYn.has)(config, "skipValidations") ? config.skipValidations : $3f2e5fa27a80e71d$export$8396fa8bfa292fca.skipValidations;
    }
    /**
     *  @deprecated use the **instance** method with the same name instead
     */ Parser.performSelfAnalysis = function(parserInstance) {
        throw Error("The **static** `performSelfAnalysis` method has been deprecated.	\nUse the **instance** method with the same name instead.");
    };
    Parser.prototype.performSelfAnalysis = function() {
        var _this = this;
        this.TRACE_INIT("performSelfAnalysis", function() {
            var defErrorsMsgs;
            _this.selfAnalysisDone = true;
            var className = _this.className;
            _this.TRACE_INIT("toFastProps", function() {
                // Without this voodoo magic the parser would be x3-x4 slower
                // It seems it is better to invoke `toFastProperties` **before**
                // Any manipulations of the `this` object done during the recording phase.
                (0, $5mLYn.toFastProperties)(_this);
            });
            _this.TRACE_INIT("Grammar Recording", function() {
                try {
                    _this.enableRecording();
                    // Building the GAST
                    (0, $5mLYn.forEach)(_this.definedRulesNames, function(currRuleName) {
                        var wrappedRule = _this[currRuleName];
                        var originalGrammarAction = wrappedRule["originalGrammarAction"];
                        var recordedRuleGast = undefined;
                        _this.TRACE_INIT(currRuleName + " Rule", function() {
                            recordedRuleGast = _this.topLevelRuleRecord(currRuleName, originalGrammarAction);
                        });
                        _this.gastProductionsCache[currRuleName] = recordedRuleGast;
                    });
                } finally{
                    _this.disableRecording();
                }
            });
            var resolverErrors = [];
            _this.TRACE_INIT("Grammar Resolving", function() {
                resolverErrors = (0, $ciB86.resolveGrammar)({
                    rules: (0, $5mLYn.values)(_this.gastProductionsCache)
                });
                _this.definitionErrors.push.apply(_this.definitionErrors, resolverErrors); // mutability for the win?
            });
            _this.TRACE_INIT("Grammar Validations", function() {
                // only perform additional grammar validations IFF no resolving errors have occurred.
                // as unresolved grammar may lead to unhandled runtime exceptions in the follow up validations.
                if ((0, $5mLYn.isEmpty)(resolverErrors) && _this.skipValidations === false) {
                    var validationErrors = (0, $ciB86.validateGrammar)({
                        rules: (0, $5mLYn.values)(_this.gastProductionsCache),
                        maxLookahead: _this.maxLookahead,
                        tokenTypes: (0, $5mLYn.values)(_this.tokensMap),
                        errMsgProvider: (0, $hUgka.defaultGrammarValidatorErrorProvider),
                        grammarName: className
                    });
                    _this.definitionErrors.push.apply(_this.definitionErrors, validationErrors); // mutability for the win?
                }
            });
            // this analysis may fail if the grammar is not perfectly valid
            if ((0, $5mLYn.isEmpty)(_this.definitionErrors)) {
                // The results of these computations are not needed unless error recovery is enabled.
                if (_this.recoveryEnabled) _this.TRACE_INIT("computeAllProdsFollows", function() {
                    var allFollows = (0, $b8PtM.computeAllProdsFollows)((0, $5mLYn.values)(_this.gastProductionsCache));
                    _this.resyncFollows = allFollows;
                });
                _this.TRACE_INIT("ComputeLookaheadFunctions", function() {
                    _this.preComputeLookaheadFunctions((0, $5mLYn.values)(_this.gastProductionsCache));
                });
            }
            if (!Parser.DEFER_DEFINITION_ERRORS_HANDLING && !(0, $5mLYn.isEmpty)(_this.definitionErrors)) {
                defErrorsMsgs = (0, $5mLYn.map)(_this.definitionErrors, function(defError) {
                    return defError.message;
                });
                throw new Error("Parser Definition Errors detected:\n " + defErrorsMsgs.join("\n-------------------------------\n"));
            }
        });
    };
    // Set this flag to true if you don't want the Parser to throw error when problems in it's definition are detected.
    // (normally during the parser's constructor).
    // This is a design time flag, it will not affect the runtime error handling of the parser, just design time errors,
    // for example: duplicate rule names, referencing an unresolved subrule, ect...
    // This flag should not be enabled during normal usage, it is used in special situations, for example when
    // needing to display the parser definition errors in some GUI(online playground).
    Parser.DEFER_DEFINITION_ERRORS_HANDLING = false;
    return Parser;
}();
(0, $5mLYn.applyMixins)($3f2e5fa27a80e71d$export$7acfa6ed01010e37, [
    (0, $8VG34.Recoverable),
    (0, $32FQp.LooksAhead),
    (0, $8zxTb.TreeBuilder),
    (0, $awxar.LexerAdapter),
    (0, $1gH4Q.RecognizerEngine),
    (0, $lzzFw.RecognizerApi),
    (0, $dBSuc.ErrorHandler),
    (0, $e17bs.ContentAssist),
    (0, $hsTas.GastRecorder),
    (0, $dBicR.PerformanceTracer)
]);
var $3f2e5fa27a80e71d$export$3ee4bf74abf432cd = /** @class */ function(_super) {
    $3f2e5fa27a80e71d$var$__extends(CstParser, _super);
    function CstParser(tokenVocabulary, config) {
        if (config === void 0) config = $3f2e5fa27a80e71d$export$8396fa8bfa292fca;
        var _this = this;
        var configClone = (0, $5mLYn.cloneObj)(config);
        configClone.outputCst = true;
        _this = _super.call(this, tokenVocabulary, configClone) || this;
        return _this;
    }
    return CstParser;
}($3f2e5fa27a80e71d$export$7acfa6ed01010e37);
var $3f2e5fa27a80e71d$export$e1a5f464f819d888 = /** @class */ function(_super) {
    $3f2e5fa27a80e71d$var$__extends(EmbeddedActionsParser, _super);
    function EmbeddedActionsParser(tokenVocabulary, config) {
        if (config === void 0) config = $3f2e5fa27a80e71d$export$8396fa8bfa292fca;
        var _this = this;
        var configClone = (0, $5mLYn.cloneObj)(config);
        configClone.outputCst = false;
        _this = _super.call(this, tokenVocabulary, configClone) || this;
        return _this;
    }
    return EmbeddedActionsParser;
}($3f2e5fa27a80e71d$export$7acfa6ed01010e37);

});
parcelRegister("5mLYn", function(module, exports) {

$parcel$export(module.exports, "isEmpty", function () { return $3e84383b053c878b$export$dd1bc94b04021eeb; });
$parcel$export(module.exports, "keys", function () { return $3e84383b053c878b$export$ed97f33186d4b816; });
$parcel$export(module.exports, "values", function () { return $3e84383b053c878b$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "mapValues", function () { return $3e84383b053c878b$export$825e789796ab7275; });
$parcel$export(module.exports, "map", function () { return $3e84383b053c878b$export$871de8747c9eaa88; });
$parcel$export(module.exports, "flatten", function () { return $3e84383b053c878b$export$bffa455ba8c619a6; });
$parcel$export(module.exports, "first", function () { return $3e84383b053c878b$export$43128fadae87b74a; });
$parcel$export(module.exports, "last", function () { return $3e84383b053c878b$export$4c7897fafd92b108; });
$parcel$export(module.exports, "forEach", function () { return $3e84383b053c878b$export$4b80e395e36b5a56; });
$parcel$export(module.exports, "isObject", function () { return $3e84383b053c878b$export$a6cdc56e425d0d0a; });
$parcel$export(module.exports, "isString", function () { return $3e84383b053c878b$export$844ec244b1367d54; });
$parcel$export(module.exports, "isUndefined", function () { return $3e84383b053c878b$export$fce6876652108ab; });
$parcel$export(module.exports, "isFunction", function () { return $3e84383b053c878b$export$f6e2535fb5126e54; });
$parcel$export(module.exports, "drop", function () { return $3e84383b053c878b$export$663103110d94aac9; });
$parcel$export(module.exports, "dropRight", function () { return $3e84383b053c878b$export$6ba801e3e123536e; });
$parcel$export(module.exports, "filter", function () { return $3e84383b053c878b$export$3dea766d36a8935f; });
$parcel$export(module.exports, "reject", function () { return $3e84383b053c878b$export$2800f3ceda99eb84; });
$parcel$export(module.exports, "pick", function () { return $3e84383b053c878b$export$357523c63a2253b9; });
$parcel$export(module.exports, "has", function () { return $3e84383b053c878b$export$a4f4bb6b1453fff5; });
$parcel$export(module.exports, "contains", function () { return $3e84383b053c878b$export$2344b14b097df817; });
$parcel$export(module.exports, "find", function () { return $3e84383b053c878b$export$71aa6c912b956294; });
$parcel$export(module.exports, "cloneArr", function () { return $3e84383b053c878b$export$2bf3679b8294488e; });
$parcel$export(module.exports, "cloneObj", function () { return $3e84383b053c878b$export$2bddc7254d5a4249; });
$parcel$export(module.exports, "findAll", function () { return $3e84383b053c878b$export$18200ea6c8035394; });
$parcel$export(module.exports, "reduce", function () { return $3e84383b053c878b$export$533b26079ad0b4b; });
$parcel$export(module.exports, "compact", function () { return $3e84383b053c878b$export$8e16b83750b44988; });
$parcel$export(module.exports, "uniq", function () { return $3e84383b053c878b$export$f70730c3d1fc524e; });
$parcel$export(module.exports, "isArray", function () { return $3e84383b053c878b$export$43bee75e5e14138e; });
$parcel$export(module.exports, "isRegExp", function () { return $3e84383b053c878b$export$49841c62b9eff15; });
$parcel$export(module.exports, "every", function () { return $3e84383b053c878b$export$7ecc1a3b11b57dab; });
$parcel$export(module.exports, "difference", function () { return $3e84383b053c878b$export$acaf96a27438246b; });
$parcel$export(module.exports, "some", function () { return $3e84383b053c878b$export$ad14ef4001db2bcd; });
$parcel$export(module.exports, "indexOf", function () { return $3e84383b053c878b$export$305f7d4e9d4624f2; });
$parcel$export(module.exports, "assign", function () { return $3e84383b053c878b$export$e6e34fd1f2686227; });
$parcel$export(module.exports, "defaults", function () { return $3e84383b053c878b$export$ebe90cb607ad99e; });
$parcel$export(module.exports, "groupBy", function () { return $3e84383b053c878b$export$3f063810d7bf01bd; });
$parcel$export(module.exports, "merge", function () { return $3e84383b053c878b$export$4950aa0f605343fb; });
$parcel$export(module.exports, "NOOP", function () { return $3e84383b053c878b$export$5702a91a6f42969f; });
$parcel$export(module.exports, "IDENTITY", function () { return $3e84383b053c878b$export$76c0f2b8ecfc3d8a; });
$parcel$export(module.exports, "packArray", function () { return $3e84383b053c878b$export$786a3465ac127fd2; });
$parcel$export(module.exports, "PRINT_ERROR", function () { return $3e84383b053c878b$export$e358b702027bbb6f; });
$parcel$export(module.exports, "PRINT_WARNING", function () { return $3e84383b053c878b$export$9384e40e4c6faba7; });
$parcel$export(module.exports, "isES2015MapSupported", function () { return $3e84383b053c878b$export$e74f6e6a7e836a5d; });
$parcel$export(module.exports, "applyMixins", function () { return $3e84383b053c878b$export$6ccb92ce135089b4; });
$parcel$export(module.exports, "toFastProperties", function () { return $3e84383b053c878b$export$2793c6b15276bb03; });
$parcel$export(module.exports, "peek", function () { return $3e84383b053c878b$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "timer", function () { return $3e84383b053c878b$export$9dc4ecf953986f04; });
/*
 Utils using lodash style API. (not necessarily 100% compliant) for functional and other utils.
 These utils should replace usage of lodash in the production code base. not because they are any better...
 but for the purpose of being a dependency free library.

 The hotspots in the code are already written in imperative style for performance reasons.
 so writing several dozen utils which may be slower than the original lodash, does not matter as much
 considering they will not be invoked in hotspots...
 */ function $3e84383b053c878b$export$dd1bc94b04021eeb(arr) {
    return arr && arr.length === 0;
}
function $3e84383b053c878b$export$ed97f33186d4b816(obj) {
    if (obj === undefined || obj === null) return [];
    return Object.keys(obj);
}
function $3e84383b053c878b$export$68c286be0e7e55b7(obj) {
    var vals = [];
    var keys = Object.keys(obj);
    for(var i = 0; i < keys.length; i++)vals.push(obj[keys[i]]);
    return vals;
}
function $3e84383b053c878b$export$825e789796ab7275(obj, callback) {
    var result = [];
    var objKeys = $3e84383b053c878b$export$ed97f33186d4b816(obj);
    for(var idx = 0; idx < objKeys.length; idx++){
        var currKey = objKeys[idx];
        result.push(callback.call(null, obj[currKey], currKey));
    }
    return result;
}
function $3e84383b053c878b$export$871de8747c9eaa88(arr, callback) {
    var result = [];
    for(var idx = 0; idx < arr.length; idx++)result.push(callback.call(null, arr[idx], idx));
    return result;
}
function $3e84383b053c878b$export$bffa455ba8c619a6(arr) {
    var result = [];
    for(var idx = 0; idx < arr.length; idx++){
        var currItem = arr[idx];
        if (Array.isArray(currItem)) result = result.concat($3e84383b053c878b$export$bffa455ba8c619a6(currItem));
        else result.push(currItem);
    }
    return result;
}
function $3e84383b053c878b$export$43128fadae87b74a(arr) {
    return $3e84383b053c878b$export$dd1bc94b04021eeb(arr) ? undefined : arr[0];
}
function $3e84383b053c878b$export$4c7897fafd92b108(arr) {
    var len = arr && arr.length;
    return len ? arr[len - 1] : undefined;
}
function $3e84383b053c878b$export$4b80e395e36b5a56(collection, iteratorCallback) {
    /* istanbul ignore else */ if (Array.isArray(collection)) for(var i = 0; i < collection.length; i++)iteratorCallback.call(null, collection[i], i);
    else if ($3e84383b053c878b$export$a6cdc56e425d0d0a(collection)) {
        var colKeys = $3e84383b053c878b$export$ed97f33186d4b816(collection);
        for(var i = 0; i < colKeys.length; i++){
            var key = colKeys[i];
            var value = collection[key];
            iteratorCallback.call(null, value, key);
        }
    } else throw Error("non exhaustive match");
}
function $3e84383b053c878b$export$844ec244b1367d54(item) {
    return typeof item === "string";
}
function $3e84383b053c878b$export$fce6876652108ab(item) {
    return item === undefined;
}
function $3e84383b053c878b$export$f6e2535fb5126e54(item) {
    return item instanceof Function;
}
function $3e84383b053c878b$export$663103110d94aac9(arr, howMuch) {
    if (howMuch === void 0) howMuch = 1;
    return arr.slice(howMuch, arr.length);
}
function $3e84383b053c878b$export$6ba801e3e123536e(arr, howMuch) {
    if (howMuch === void 0) howMuch = 1;
    return arr.slice(0, arr.length - howMuch);
}
function $3e84383b053c878b$export$3dea766d36a8935f(arr, predicate) {
    var result = [];
    if (Array.isArray(arr)) for(var i = 0; i < arr.length; i++){
        var item = arr[i];
        if (predicate.call(null, item)) result.push(item);
    }
    return result;
}
function $3e84383b053c878b$export$2800f3ceda99eb84(arr, predicate) {
    return $3e84383b053c878b$export$3dea766d36a8935f(arr, function(item) {
        return !predicate(item);
    });
}
function $3e84383b053c878b$export$357523c63a2253b9(obj, predicate) {
    var keys = Object.keys(obj);
    var result = {};
    for(var i = 0; i < keys.length; i++){
        var currKey = keys[i];
        var currItem = obj[currKey];
        if (predicate(currItem)) result[currKey] = currItem;
    }
    return result;
}
function $3e84383b053c878b$export$a4f4bb6b1453fff5(obj, prop) {
    if ($3e84383b053c878b$export$a6cdc56e425d0d0a(obj)) return obj.hasOwnProperty(prop);
    return false;
}
function $3e84383b053c878b$export$2344b14b097df817(arr, item) {
    return $3e84383b053c878b$export$71aa6c912b956294(arr, function(currItem) {
        return currItem === item;
    }) !== undefined ? true : false;
}
function $3e84383b053c878b$export$2bf3679b8294488e(arr) {
    var newArr = [];
    for(var i = 0; i < arr.length; i++)newArr.push(arr[i]);
    return newArr;
}
function $3e84383b053c878b$export$2bddc7254d5a4249(obj) {
    var clonedObj = {};
    for(var key in obj)/* istanbul ignore else */ if (Object.prototype.hasOwnProperty.call(obj, key)) clonedObj[key] = obj[key];
    return clonedObj;
}
function $3e84383b053c878b$export$71aa6c912b956294(arr, predicate) {
    for(var i = 0; i < arr.length; i++){
        var item = arr[i];
        if (predicate.call(null, item)) return item;
    }
    return undefined;
}
function $3e84383b053c878b$export$18200ea6c8035394(arr, predicate) {
    var found = [];
    for(var i = 0; i < arr.length; i++){
        var item = arr[i];
        if (predicate.call(null, item)) found.push(item);
    }
    return found;
}
function $3e84383b053c878b$export$533b26079ad0b4b(arrOrObj, iterator, initial) {
    var isArr = Array.isArray(arrOrObj);
    var vals = isArr ? arrOrObj : $3e84383b053c878b$export$68c286be0e7e55b7(arrOrObj);
    var objKeys = isArr ? [] : $3e84383b053c878b$export$ed97f33186d4b816(arrOrObj);
    var accumulator = initial;
    for(var i = 0; i < vals.length; i++)accumulator = iterator.call(null, accumulator, vals[i], isArr ? i : objKeys[i]);
    return accumulator;
}
function $3e84383b053c878b$export$8e16b83750b44988(arr) {
    return $3e84383b053c878b$export$2800f3ceda99eb84(arr, function(item) {
        return item === null || item === undefined;
    });
}
function $3e84383b053c878b$export$f70730c3d1fc524e(arr, identity) {
    if (identity === void 0) identity = function(item) {
        return item;
    };
    var identities = [];
    return $3e84383b053c878b$export$533b26079ad0b4b(arr, function(result, currItem) {
        var currIdentity = identity(currItem);
        if ($3e84383b053c878b$export$2344b14b097df817(identities, currIdentity)) return result;
        else {
            identities.push(currIdentity);
            return result.concat(currItem);
        }
    }, []);
}
function $3e84383b053c878b$export$e45945969df8035a(func) {
    var restArgs = [];
    for(var _i = 1; _i < arguments.length; _i++)restArgs[_i - 1] = arguments[_i];
    var firstArg = [
        null
    ];
    var allArgs = firstArg.concat(restArgs);
    return Function.bind.apply(func, allArgs);
}
function $3e84383b053c878b$export$43bee75e5e14138e(obj) {
    return Array.isArray(obj);
}
function $3e84383b053c878b$export$49841c62b9eff15(obj) {
    return obj instanceof RegExp;
}
function $3e84383b053c878b$export$a6cdc56e425d0d0a(obj) {
    return obj instanceof Object;
}
function $3e84383b053c878b$export$7ecc1a3b11b57dab(arr, predicate) {
    for(var i = 0; i < arr.length; i++){
        if (!predicate(arr[i], i)) return false;
    }
    return true;
}
function $3e84383b053c878b$export$acaf96a27438246b(arr, values) {
    return $3e84383b053c878b$export$2800f3ceda99eb84(arr, function(item) {
        return $3e84383b053c878b$export$2344b14b097df817(values, item);
    });
}
function $3e84383b053c878b$export$ad14ef4001db2bcd(arr, predicate) {
    for(var i = 0; i < arr.length; i++){
        if (predicate(arr[i])) return true;
    }
    return false;
}
function $3e84383b053c878b$export$305f7d4e9d4624f2(arr, value) {
    for(var i = 0; i < arr.length; i++){
        if (arr[i] === value) return i;
    }
    return -1;
}
function $3e84383b053c878b$export$b035e44d7bb4278f(arr, orderFunc) {
    var result = $3e84383b053c878b$export$2bf3679b8294488e(arr);
    result.sort(function(a, b) {
        return orderFunc(a) - orderFunc(b);
    });
    return result;
}
function $3e84383b053c878b$export$918056458ccab0(keys, values) {
    if (keys.length !== values.length) throw Error("can't zipObject with different number of keys and values!");
    var result = {};
    for(var i = 0; i < keys.length; i++)result[keys[i]] = values[i];
    return result;
}
function $3e84383b053c878b$export$e6e34fd1f2686227(target) {
    var sources = [];
    for(var _i = 1; _i < arguments.length; _i++)sources[_i - 1] = arguments[_i];
    for(var i = 0; i < sources.length; i++){
        var curSource = sources[i];
        var currSourceKeys = $3e84383b053c878b$export$ed97f33186d4b816(curSource);
        for(var j = 0; j < currSourceKeys.length; j++){
            var currKey = currSourceKeys[j];
            target[currKey] = curSource[currKey];
        }
    }
    return target;
}
function $3e84383b053c878b$export$2b800c312c516d49(target) {
    var sources = [];
    for(var _i = 1; _i < arguments.length; _i++)sources[_i - 1] = arguments[_i];
    for(var i = 0; i < sources.length; i++){
        var curSource = sources[i];
        var currSourceKeys = $3e84383b053c878b$export$ed97f33186d4b816(curSource);
        for(var j = 0; j < currSourceKeys.length; j++){
            var currKey = currSourceKeys[j];
            if (!$3e84383b053c878b$export$a4f4bb6b1453fff5(target, currKey)) target[currKey] = curSource[currKey];
        }
    }
    return target;
}
function $3e84383b053c878b$export$ebe90cb607ad99e() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    return $3e84383b053c878b$export$2b800c312c516d49.apply(null, [
        {}
    ].concat(sources));
}
function $3e84383b053c878b$export$3f063810d7bf01bd(arr, groupKeyFunc) {
    var result = {};
    $3e84383b053c878b$export$4b80e395e36b5a56(arr, function(item) {
        var currGroupKey = groupKeyFunc(item);
        var currGroupArr = result[currGroupKey];
        if (currGroupArr) currGroupArr.push(item);
        else result[currGroupKey] = [
            item
        ];
    });
    return result;
}
function $3e84383b053c878b$export$4950aa0f605343fb(obj1, obj2) {
    var result = $3e84383b053c878b$export$2bddc7254d5a4249(obj1);
    var keys2 = $3e84383b053c878b$export$ed97f33186d4b816(obj2);
    for(var i = 0; i < keys2.length; i++){
        var key = keys2[i];
        var value = obj2[key];
        result[key] = value;
    }
    return result;
}
function $3e84383b053c878b$export$5702a91a6f42969f() {}
function $3e84383b053c878b$export$76c0f2b8ecfc3d8a(item) {
    return item;
}
function $3e84383b053c878b$export$786a3465ac127fd2(holeyArr) {
    var result = [];
    for(var i = 0; i < holeyArr.length; i++){
        var orgValue = holeyArr[i];
        result.push(orgValue !== undefined ? orgValue : undefined);
    }
    return result;
}
function $3e84383b053c878b$export$e358b702027bbb6f(msg) {
    /* istanbul ignore else - can't override global.console in node.js */ if (console && console.error) console.error("Error: " + msg);
}
function $3e84383b053c878b$export$9384e40e4c6faba7(msg) {
    /* istanbul ignore else - can't override global.console in node.js*/ if (console && console.warn) // TODO: modify docs accordingly
    console.warn("Warning: " + msg);
}
function $3e84383b053c878b$export$e74f6e6a7e836a5d() {
    return typeof Map === "function";
}
function $3e84383b053c878b$export$6ccb92ce135089b4(derivedCtor, baseCtors) {
    baseCtors.forEach(function(baseCtor) {
        var baseProto = baseCtor.prototype;
        Object.getOwnPropertyNames(baseProto).forEach(function(propName) {
            if (propName === "constructor") return;
            var basePropDescriptor = Object.getOwnPropertyDescriptor(baseProto, propName);
            // Handle Accessors
            if (basePropDescriptor && (basePropDescriptor.get || basePropDescriptor.set)) Object.defineProperty(derivedCtor.prototype, propName, basePropDescriptor);
            else derivedCtor.prototype[propName] = baseCtor.prototype[propName];
        });
    });
}
function $3e84383b053c878b$export$2793c6b15276bb03(toBecomeFast) {
    function FakeConstructor() {}
    // If our object is used as a constructor it would receive
    FakeConstructor.prototype = toBecomeFast;
    var fakeInstance = new FakeConstructor();
    function fakeAccess() {
        return typeof fakeInstance.bar;
    }
    // help V8 understand this is a "real" prototype by actually using
    // the fake instance.
    fakeAccess();
    fakeAccess();
    return toBecomeFast;
}
function $3e84383b053c878b$export$4d3fb11e950abb9e(arr) {
    return arr[arr.length - 1];
}
function $3e84383b053c878b$export$9dc4ecf953986f04(func) {
    var start = new Date().getTime();
    var val = func();
    var end = new Date().getTime();
    var total = end - start;
    return {
        time: total,
        value: val
    };
}

});

parcelRegister("b8PtM", function(module, exports) {

$parcel$export(module.exports, "computeAllProdsFollows", function () { return $81c85fc759f3694e$export$22b88652af4de4e1; });

var $ip5ou = parcelRequire("ip5ou");

var $6BL7Z = parcelRequire("6BL7Z");

var $5mLYn = parcelRequire("5mLYn");

var $kWjNL = parcelRequire("kWjNL");

var $bbUHG = parcelRequire("bbUHG");
var $81c85fc759f3694e$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
// This ResyncFollowsWalker computes all of the follows required for RESYNC
// (skipping reference production).
var $81c85fc759f3694e$export$6b2f4a578258c74c = /** @class */ function(_super) {
    $81c85fc759f3694e$var$__extends(ResyncFollowsWalker, _super);
    function ResyncFollowsWalker(topProd) {
        var _this = _super.call(this) || this;
        _this.topProd = topProd;
        _this.follows = {};
        return _this;
    }
    ResyncFollowsWalker.prototype.startWalking = function() {
        this.walk(this.topProd);
        return this.follows;
    };
    ResyncFollowsWalker.prototype.walkTerminal = function(terminal, currRest, prevRest) {
    // do nothing! just like in the public sector after 13:00
    };
    ResyncFollowsWalker.prototype.walkProdRef = function(refProd, currRest, prevRest) {
        var followName = $81c85fc759f3694e$export$58bc166168807698(refProd.referencedRule, refProd.idx) + this.topProd.name;
        var fullRest = currRest.concat(prevRest);
        var restProd = new (0, $bbUHG.Alternative)({
            definition: fullRest
        });
        var t_in_topProd_follows = (0, $6BL7Z.first)(restProd);
        this.follows[followName] = t_in_topProd_follows;
    };
    return ResyncFollowsWalker;
}((0, $ip5ou.RestWalker));
function $81c85fc759f3694e$export$22b88652af4de4e1(topProductions) {
    var reSyncFollows = {};
    (0, $5mLYn.forEach)(topProductions, function(topProd) {
        var currRefsFollow = new $81c85fc759f3694e$export$6b2f4a578258c74c(topProd).startWalking();
        (0, $5mLYn.assign)(reSyncFollows, currRefsFollow);
    });
    return reSyncFollows;
}
function $81c85fc759f3694e$export$58bc166168807698(inner, occurenceInParent) {
    return inner.name + occurenceInParent + (0, $kWjNL.IN);
}
function $81c85fc759f3694e$export$3d2ec49af3ed26a(terminal) {
    var terminalName = terminal.terminalType.name;
    return terminalName + terminal.idx + (0, $kWjNL.IN);
}

});
parcelRegister("ip5ou", function(module, exports) {

$parcel$export(module.exports, "RestWalker", function () { return $d65ebee854b57d9b$export$235ee187e7030d87; });

var $5mLYn = parcelRequire("5mLYn");

var $bbUHG = parcelRequire("bbUHG");
/**
 *  A Grammar Walker that computes the "remaining" grammar "after" a productions in the grammar.
 */ var $d65ebee854b57d9b$export$235ee187e7030d87 = /** @class */ function() {
    function RestWalker() {}
    RestWalker.prototype.walk = function(prod, prevRest) {
        var _this = this;
        if (prevRest === void 0) prevRest = [];
        (0, $5mLYn.forEach)(prod.definition, function(subProd, index) {
            var currRest = (0, $5mLYn.drop)(prod.definition, index + 1);
            /* istanbul ignore else */ if (subProd instanceof (0, $bbUHG.NonTerminal)) _this.walkProdRef(subProd, currRest, prevRest);
            else if (subProd instanceof (0, $bbUHG.Terminal)) _this.walkTerminal(subProd, currRest, prevRest);
            else if (subProd instanceof (0, $bbUHG.Alternative)) _this.walkFlat(subProd, currRest, prevRest);
            else if (subProd instanceof (0, $bbUHG.Option)) _this.walkOption(subProd, currRest, prevRest);
            else if (subProd instanceof (0, $bbUHG.RepetitionMandatory)) _this.walkAtLeastOne(subProd, currRest, prevRest);
            else if (subProd instanceof (0, $bbUHG.RepetitionMandatoryWithSeparator)) _this.walkAtLeastOneSep(subProd, currRest, prevRest);
            else if (subProd instanceof (0, $bbUHG.RepetitionWithSeparator)) _this.walkManySep(subProd, currRest, prevRest);
            else if (subProd instanceof (0, $bbUHG.Repetition)) _this.walkMany(subProd, currRest, prevRest);
            else if (subProd instanceof (0, $bbUHG.Alternation)) _this.walkOr(subProd, currRest, prevRest);
            else throw Error("non exhaustive match");
        });
    };
    RestWalker.prototype.walkTerminal = function(terminal, currRest, prevRest) {};
    RestWalker.prototype.walkProdRef = function(refProd, currRest, prevRest) {};
    RestWalker.prototype.walkFlat = function(flatProd, currRest, prevRest) {
        // ABCDEF => after the D the rest is EF
        var fullOrRest = currRest.concat(prevRest);
        this.walk(flatProd, fullOrRest);
    };
    RestWalker.prototype.walkOption = function(optionProd, currRest, prevRest) {
        // ABC(DE)?F => after the (DE)? the rest is F
        var fullOrRest = currRest.concat(prevRest);
        this.walk(optionProd, fullOrRest);
    };
    RestWalker.prototype.walkAtLeastOne = function(atLeastOneProd, currRest, prevRest) {
        // ABC(DE)+F => after the (DE)+ the rest is (DE)?F
        var fullAtLeastOneRest = [
            new (0, $bbUHG.Option)({
                definition: atLeastOneProd.definition
            })
        ].concat(currRest, prevRest);
        this.walk(atLeastOneProd, fullAtLeastOneRest);
    };
    RestWalker.prototype.walkAtLeastOneSep = function(atLeastOneSepProd, currRest, prevRest) {
        // ABC DE(,DE)* F => after the (,DE)+ the rest is (,DE)?F
        var fullAtLeastOneSepRest = $d65ebee854b57d9b$var$restForRepetitionWithSeparator(atLeastOneSepProd, currRest, prevRest);
        this.walk(atLeastOneSepProd, fullAtLeastOneSepRest);
    };
    RestWalker.prototype.walkMany = function(manyProd, currRest, prevRest) {
        // ABC(DE)*F => after the (DE)* the rest is (DE)?F
        var fullManyRest = [
            new (0, $bbUHG.Option)({
                definition: manyProd.definition
            })
        ].concat(currRest, prevRest);
        this.walk(manyProd, fullManyRest);
    };
    RestWalker.prototype.walkManySep = function(manySepProd, currRest, prevRest) {
        // ABC (DE(,DE)*)? F => after the (,DE)* the rest is (,DE)?F
        var fullManySepRest = $d65ebee854b57d9b$var$restForRepetitionWithSeparator(manySepProd, currRest, prevRest);
        this.walk(manySepProd, fullManySepRest);
    };
    RestWalker.prototype.walkOr = function(orProd, currRest, prevRest) {
        var _this = this;
        // ABC(D|E|F)G => when finding the (D|E|F) the rest is G
        var fullOrRest = currRest.concat(prevRest);
        // walk all different alternatives
        (0, $5mLYn.forEach)(orProd.definition, function(alt) {
            // wrapping each alternative in a single definition wrapper
            // to avoid errors in computing the rest of that alternative in the invocation to computeInProdFollows
            // (otherwise for OR([alt1,alt2]) alt2 will be considered in 'rest' of alt1
            var prodWrapper = new (0, $bbUHG.Alternative)({
                definition: [
                    alt
                ]
            });
            _this.walk(prodWrapper, fullOrRest);
        });
    };
    return RestWalker;
}();
function $d65ebee854b57d9b$var$restForRepetitionWithSeparator(repSepProd, currRest, prevRest) {
    var repSepRest = [
        new (0, $bbUHG.Option)({
            definition: [
                new (0, $bbUHG.Terminal)({
                    terminalType: repSepProd.separator
                })
            ].concat(repSepProd.definition)
        })
    ];
    var fullRepSepRest = repSepRest.concat(currRest, prevRest);
    return fullRepSepRest;
}

});
parcelRegister("bbUHG", function(module, exports) {

$parcel$export(module.exports, "AbstractProduction", function () { return $825cb4eee7cf5b55$export$fca9ad836418bbc; });
$parcel$export(module.exports, "NonTerminal", function () { return $825cb4eee7cf5b55$export$ab116ec58638c09; });
$parcel$export(module.exports, "Rule", function () { return $825cb4eee7cf5b55$export$f1ff2a90c38ff669; });
$parcel$export(module.exports, "Alternative", function () { return $825cb4eee7cf5b55$export$4acb47accde578d2; });
$parcel$export(module.exports, "Option", function () { return $825cb4eee7cf5b55$export$36d18380658d5d20; });
$parcel$export(module.exports, "RepetitionMandatory", function () { return $825cb4eee7cf5b55$export$d068cf3ccde3d9e8; });
$parcel$export(module.exports, "RepetitionMandatoryWithSeparator", function () { return $825cb4eee7cf5b55$export$da6c5580175e0214; });
$parcel$export(module.exports, "Repetition", function () { return $825cb4eee7cf5b55$export$adf7bc0a69b784e9; });
$parcel$export(module.exports, "RepetitionWithSeparator", function () { return $825cb4eee7cf5b55$export$856dea708c981fb8; });
$parcel$export(module.exports, "Alternation", function () { return $825cb4eee7cf5b55$export$d8895f7a7cf86415; });
$parcel$export(module.exports, "Terminal", function () { return $825cb4eee7cf5b55$export$8dd80f06eb58bfe1; });
$parcel$export(module.exports, "serializeGrammar", function () { return $825cb4eee7cf5b55$export$402033653bede0a9; });
$parcel$export(module.exports, "serializeProduction", function () { return $825cb4eee7cf5b55$export$d5097bfcf032db89; });

var $5mLYn = parcelRequire("5mLYn");

var $hvAWv = parcelRequire("hvAWv");
var $825cb4eee7cf5b55$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $825cb4eee7cf5b55$export$fca9ad836418bbc = /** @class */ function() {
    function AbstractProduction(_definition) {
        this._definition = _definition;
    }
    Object.defineProperty(AbstractProduction.prototype, "definition", {
        get: function() {
            return this._definition;
        },
        set: function(value) {
            this._definition = value;
        },
        enumerable: false,
        configurable: true
    });
    AbstractProduction.prototype.accept = function(visitor) {
        visitor.visit(this);
        (0, $5mLYn.forEach)(this.definition, function(prod) {
            prod.accept(visitor);
        });
    };
    return AbstractProduction;
}();
var $825cb4eee7cf5b55$export$ab116ec58638c09 = /** @class */ function(_super) {
    $825cb4eee7cf5b55$var$__extends(NonTerminal, _super);
    function NonTerminal(options) {
        var _this = _super.call(this, []) || this;
        _this.idx = 1;
        (0, $5mLYn.assign)(_this, (0, $5mLYn.pick)(options, function(v) {
            return v !== undefined;
        }));
        return _this;
    }
    Object.defineProperty(NonTerminal.prototype, "definition", {
        get: function() {
            if (this.referencedRule !== undefined) return this.referencedRule.definition;
            return [];
        },
        set: function(definition) {
        // immutable
        },
        enumerable: false,
        configurable: true
    });
    NonTerminal.prototype.accept = function(visitor) {
        visitor.visit(this);
    // don't visit children of a reference, we will get cyclic infinite loops if we do so
    };
    return NonTerminal;
}($825cb4eee7cf5b55$export$fca9ad836418bbc);
var $825cb4eee7cf5b55$export$f1ff2a90c38ff669 = /** @class */ function(_super) {
    $825cb4eee7cf5b55$var$__extends(Rule, _super);
    function Rule(options) {
        var _this = _super.call(this, options.definition) || this;
        _this.orgText = "";
        (0, $5mLYn.assign)(_this, (0, $5mLYn.pick)(options, function(v) {
            return v !== undefined;
        }));
        return _this;
    }
    return Rule;
}($825cb4eee7cf5b55$export$fca9ad836418bbc);
var $825cb4eee7cf5b55$export$4acb47accde578d2 = /** @class */ function(_super) {
    $825cb4eee7cf5b55$var$__extends(Alternative, _super);
    function Alternative(options) {
        var _this = _super.call(this, options.definition) || this;
        _this.ignoreAmbiguities = false;
        (0, $5mLYn.assign)(_this, (0, $5mLYn.pick)(options, function(v) {
            return v !== undefined;
        }));
        return _this;
    }
    return Alternative;
}($825cb4eee7cf5b55$export$fca9ad836418bbc);
var $825cb4eee7cf5b55$export$36d18380658d5d20 = /** @class */ function(_super) {
    $825cb4eee7cf5b55$var$__extends(Option, _super);
    function Option(options) {
        var _this = _super.call(this, options.definition) || this;
        _this.idx = 1;
        (0, $5mLYn.assign)(_this, (0, $5mLYn.pick)(options, function(v) {
            return v !== undefined;
        }));
        return _this;
    }
    return Option;
}($825cb4eee7cf5b55$export$fca9ad836418bbc);
var $825cb4eee7cf5b55$export$d068cf3ccde3d9e8 = /** @class */ function(_super) {
    $825cb4eee7cf5b55$var$__extends(RepetitionMandatory, _super);
    function RepetitionMandatory(options) {
        var _this = _super.call(this, options.definition) || this;
        _this.idx = 1;
        (0, $5mLYn.assign)(_this, (0, $5mLYn.pick)(options, function(v) {
            return v !== undefined;
        }));
        return _this;
    }
    return RepetitionMandatory;
}($825cb4eee7cf5b55$export$fca9ad836418bbc);
var $825cb4eee7cf5b55$export$da6c5580175e0214 = /** @class */ function(_super) {
    $825cb4eee7cf5b55$var$__extends(RepetitionMandatoryWithSeparator, _super);
    function RepetitionMandatoryWithSeparator(options) {
        var _this = _super.call(this, options.definition) || this;
        _this.idx = 1;
        (0, $5mLYn.assign)(_this, (0, $5mLYn.pick)(options, function(v) {
            return v !== undefined;
        }));
        return _this;
    }
    return RepetitionMandatoryWithSeparator;
}($825cb4eee7cf5b55$export$fca9ad836418bbc);
var $825cb4eee7cf5b55$export$adf7bc0a69b784e9 = /** @class */ function(_super) {
    $825cb4eee7cf5b55$var$__extends(Repetition, _super);
    function Repetition(options) {
        var _this = _super.call(this, options.definition) || this;
        _this.idx = 1;
        (0, $5mLYn.assign)(_this, (0, $5mLYn.pick)(options, function(v) {
            return v !== undefined;
        }));
        return _this;
    }
    return Repetition;
}($825cb4eee7cf5b55$export$fca9ad836418bbc);
var $825cb4eee7cf5b55$export$856dea708c981fb8 = /** @class */ function(_super) {
    $825cb4eee7cf5b55$var$__extends(RepetitionWithSeparator, _super);
    function RepetitionWithSeparator(options) {
        var _this = _super.call(this, options.definition) || this;
        _this.idx = 1;
        (0, $5mLYn.assign)(_this, (0, $5mLYn.pick)(options, function(v) {
            return v !== undefined;
        }));
        return _this;
    }
    return RepetitionWithSeparator;
}($825cb4eee7cf5b55$export$fca9ad836418bbc);
var $825cb4eee7cf5b55$export$d8895f7a7cf86415 = /** @class */ function(_super) {
    $825cb4eee7cf5b55$var$__extends(Alternation, _super);
    function Alternation(options) {
        var _this = _super.call(this, options.definition) || this;
        _this.idx = 1;
        _this.ignoreAmbiguities = false;
        _this.hasPredicates = false;
        (0, $5mLYn.assign)(_this, (0, $5mLYn.pick)(options, function(v) {
            return v !== undefined;
        }));
        return _this;
    }
    Object.defineProperty(Alternation.prototype, "definition", {
        get: function() {
            return this._definition;
        },
        set: function(value) {
            this._definition = value;
        },
        enumerable: false,
        configurable: true
    });
    return Alternation;
}($825cb4eee7cf5b55$export$fca9ad836418bbc);
var $825cb4eee7cf5b55$export$8dd80f06eb58bfe1 = /** @class */ function() {
    function Terminal(options) {
        this.idx = 1;
        (0, $5mLYn.assign)(this, (0, $5mLYn.pick)(options, function(v) {
            return v !== undefined;
        }));
    }
    Terminal.prototype.accept = function(visitor) {
        visitor.visit(this);
    };
    return Terminal;
}();
function $825cb4eee7cf5b55$export$402033653bede0a9(topRules) {
    return (0, $5mLYn.map)(topRules, $825cb4eee7cf5b55$export$d5097bfcf032db89);
}
function $825cb4eee7cf5b55$export$d5097bfcf032db89(node) {
    function convertDefinition(definition) {
        return (0, $5mLYn.map)(definition, $825cb4eee7cf5b55$export$d5097bfcf032db89);
    }
    /* istanbul ignore else */ if (node instanceof $825cb4eee7cf5b55$export$ab116ec58638c09) return {
        type: "NonTerminal",
        name: node.nonTerminalName,
        idx: node.idx
    };
    else if (node instanceof $825cb4eee7cf5b55$export$4acb47accde578d2) return {
        type: "Alternative",
        definition: convertDefinition(node.definition)
    };
    else if (node instanceof $825cb4eee7cf5b55$export$36d18380658d5d20) return {
        type: "Option",
        idx: node.idx,
        definition: convertDefinition(node.definition)
    };
    else if (node instanceof $825cb4eee7cf5b55$export$d068cf3ccde3d9e8) return {
        type: "RepetitionMandatory",
        idx: node.idx,
        definition: convertDefinition(node.definition)
    };
    else if (node instanceof $825cb4eee7cf5b55$export$da6c5580175e0214) return {
        type: "RepetitionMandatoryWithSeparator",
        idx: node.idx,
        separator: $825cb4eee7cf5b55$export$d5097bfcf032db89(new $825cb4eee7cf5b55$export$8dd80f06eb58bfe1({
            terminalType: node.separator
        })),
        definition: convertDefinition(node.definition)
    };
    else if (node instanceof $825cb4eee7cf5b55$export$856dea708c981fb8) return {
        type: "RepetitionWithSeparator",
        idx: node.idx,
        separator: $825cb4eee7cf5b55$export$d5097bfcf032db89(new $825cb4eee7cf5b55$export$8dd80f06eb58bfe1({
            terminalType: node.separator
        })),
        definition: convertDefinition(node.definition)
    };
    else if (node instanceof $825cb4eee7cf5b55$export$adf7bc0a69b784e9) return {
        type: "Repetition",
        idx: node.idx,
        definition: convertDefinition(node.definition)
    };
    else if (node instanceof $825cb4eee7cf5b55$export$d8895f7a7cf86415) return {
        type: "Alternation",
        idx: node.idx,
        definition: convertDefinition(node.definition)
    };
    else if (node instanceof $825cb4eee7cf5b55$export$8dd80f06eb58bfe1) {
        var serializedTerminal = {
            type: "Terminal",
            name: node.terminalType.name,
            label: (0, $hvAWv.tokenLabel)(node.terminalType),
            idx: node.idx
        };
        var pattern = node.terminalType.PATTERN;
        if (node.terminalType.PATTERN) serializedTerminal.pattern = (0, $5mLYn.isRegExp)(pattern) ? pattern.source : pattern;
        return serializedTerminal;
    } else if (node instanceof $825cb4eee7cf5b55$export$f1ff2a90c38ff669) return {
        type: "Rule",
        name: node.name,
        orgText: node.orgText,
        definition: convertDefinition(node.definition)
    };
    else throw Error("non exhaustive match");
}

});
parcelRegister("hvAWv", function(module, exports) {

$parcel$export(module.exports, "tokenLabel", function () { return $cbf1fcf9745b4adf$export$9e0160de4349ea3f; });
$parcel$export(module.exports, "hasTokenLabel", function () { return $cbf1fcf9745b4adf$export$d2d9052c5ce10e4b; });
$parcel$export(module.exports, "tokenName", function () { return $cbf1fcf9745b4adf$export$458bf7b07b21488f; });
$parcel$export(module.exports, "createToken", function () { return $cbf1fcf9745b4adf$export$c255480b061bd6aa; });
$parcel$export(module.exports, "EOF", function () { return $cbf1fcf9745b4adf$export$c1a09112320b1603; });
$parcel$export(module.exports, "createTokenInstance", function () { return $cbf1fcf9745b4adf$export$eaddf8d68927eada; });
$parcel$export(module.exports, "tokenMatcher", function () { return $cbf1fcf9745b4adf$export$4a18d31d63d8e922; });

var $5mLYn = parcelRequire("5mLYn");

var $eSJX3 = parcelRequire("eSJX3");

var $6UThq = parcelRequire("6UThq");
function $cbf1fcf9745b4adf$export$9e0160de4349ea3f(tokType) {
    if ($cbf1fcf9745b4adf$export$d2d9052c5ce10e4b(tokType)) return tokType.LABEL;
    else return tokType.name;
}
function $cbf1fcf9745b4adf$export$458bf7b07b21488f(tokType) {
    return tokType.name;
}
function $cbf1fcf9745b4adf$export$d2d9052c5ce10e4b(obj) {
    return (0, $5mLYn.isString)(obj.LABEL) && obj.LABEL !== "";
}
var $cbf1fcf9745b4adf$var$PARENT = "parent";
var $cbf1fcf9745b4adf$var$CATEGORIES = "categories";
var $cbf1fcf9745b4adf$var$LABEL = "label";
var $cbf1fcf9745b4adf$var$GROUP = "group";
var $cbf1fcf9745b4adf$var$PUSH_MODE = "push_mode";
var $cbf1fcf9745b4adf$var$POP_MODE = "pop_mode";
var $cbf1fcf9745b4adf$var$LONGER_ALT = "longer_alt";
var $cbf1fcf9745b4adf$var$LINE_BREAKS = "line_breaks";
var $cbf1fcf9745b4adf$var$START_CHARS_HINT = "start_chars_hint";
function $cbf1fcf9745b4adf$export$c255480b061bd6aa(config) {
    return $cbf1fcf9745b4adf$var$createTokenInternal(config);
}
function $cbf1fcf9745b4adf$var$createTokenInternal(config) {
    var pattern = config.pattern;
    var tokenType = {};
    tokenType.name = config.name;
    if (!(0, $5mLYn.isUndefined)(pattern)) tokenType.PATTERN = pattern;
    if ((0, $5mLYn.has)(config, $cbf1fcf9745b4adf$var$PARENT)) throw "The parent property is no longer supported.\nSee: https://github.com/SAP/chevrotain/issues/564#issuecomment-349062346 for details.";
    if ((0, $5mLYn.has)(config, $cbf1fcf9745b4adf$var$CATEGORIES)) // casting to ANY as this will be fixed inside `augmentTokenTypes``
    tokenType.CATEGORIES = config[$cbf1fcf9745b4adf$var$CATEGORIES];
    (0, $6UThq.augmentTokenTypes)([
        tokenType
    ]);
    if ((0, $5mLYn.has)(config, $cbf1fcf9745b4adf$var$LABEL)) tokenType.LABEL = config[$cbf1fcf9745b4adf$var$LABEL];
    if ((0, $5mLYn.has)(config, $cbf1fcf9745b4adf$var$GROUP)) tokenType.GROUP = config[$cbf1fcf9745b4adf$var$GROUP];
    if ((0, $5mLYn.has)(config, $cbf1fcf9745b4adf$var$POP_MODE)) tokenType.POP_MODE = config[$cbf1fcf9745b4adf$var$POP_MODE];
    if ((0, $5mLYn.has)(config, $cbf1fcf9745b4adf$var$PUSH_MODE)) tokenType.PUSH_MODE = config[$cbf1fcf9745b4adf$var$PUSH_MODE];
    if ((0, $5mLYn.has)(config, $cbf1fcf9745b4adf$var$LONGER_ALT)) tokenType.LONGER_ALT = config[$cbf1fcf9745b4adf$var$LONGER_ALT];
    if ((0, $5mLYn.has)(config, $cbf1fcf9745b4adf$var$LINE_BREAKS)) tokenType.LINE_BREAKS = config[$cbf1fcf9745b4adf$var$LINE_BREAKS];
    if ((0, $5mLYn.has)(config, $cbf1fcf9745b4adf$var$START_CHARS_HINT)) tokenType.START_CHARS_HINT = config[$cbf1fcf9745b4adf$var$START_CHARS_HINT];
    return tokenType;
}
var $cbf1fcf9745b4adf$export$c1a09112320b1603 = $cbf1fcf9745b4adf$export$c255480b061bd6aa({
    name: "EOF",
    pattern: (0, $eSJX3.Lexer).NA
});
(0, $6UThq.augmentTokenTypes)([
    $cbf1fcf9745b4adf$export$c1a09112320b1603
]);
function $cbf1fcf9745b4adf$export$eaddf8d68927eada(tokType, image, startOffset, endOffset, startLine, endLine, startColumn, endColumn) {
    return {
        image: image,
        startOffset: startOffset,
        endOffset: endOffset,
        startLine: startLine,
        endLine: endLine,
        startColumn: startColumn,
        endColumn: endColumn,
        tokenTypeIdx: tokType.tokenTypeIdx,
        tokenType: tokType
    };
}
function $cbf1fcf9745b4adf$export$4a18d31d63d8e922(token, tokType) {
    return (0, $6UThq.tokenStructuredMatcher)(token, tokType);
}

});
parcelRegister("eSJX3", function(module, exports) {

$parcel$export(module.exports, "LexerDefinitionErrorType", function () { return $ad59c0d2332ba319$export$75fe8082c000e4d9; });
$parcel$export(module.exports, "Lexer", function () { return $ad59c0d2332ba319$export$6168dc8908a6c652; });

var $22jE1 = parcelRequire("22jE1");

var $5mLYn = parcelRequire("5mLYn");

var $6UThq = parcelRequire("6UThq");

var $lMxRC = parcelRequire("lMxRC");

var $8VuTk = parcelRequire("8VuTk");
var $ad59c0d2332ba319$export$75fe8082c000e4d9;
(function(LexerDefinitionErrorType) {
    LexerDefinitionErrorType[LexerDefinitionErrorType["MISSING_PATTERN"] = 0] = "MISSING_PATTERN";
    LexerDefinitionErrorType[LexerDefinitionErrorType["INVALID_PATTERN"] = 1] = "INVALID_PATTERN";
    LexerDefinitionErrorType[LexerDefinitionErrorType["EOI_ANCHOR_FOUND"] = 2] = "EOI_ANCHOR_FOUND";
    LexerDefinitionErrorType[LexerDefinitionErrorType["UNSUPPORTED_FLAGS_FOUND"] = 3] = "UNSUPPORTED_FLAGS_FOUND";
    LexerDefinitionErrorType[LexerDefinitionErrorType["DUPLICATE_PATTERNS_FOUND"] = 4] = "DUPLICATE_PATTERNS_FOUND";
    LexerDefinitionErrorType[LexerDefinitionErrorType["INVALID_GROUP_TYPE_FOUND"] = 5] = "INVALID_GROUP_TYPE_FOUND";
    LexerDefinitionErrorType[LexerDefinitionErrorType["PUSH_MODE_DOES_NOT_EXIST"] = 6] = "PUSH_MODE_DOES_NOT_EXIST";
    LexerDefinitionErrorType[LexerDefinitionErrorType["MULTI_MODE_LEXER_WITHOUT_DEFAULT_MODE"] = 7] = "MULTI_MODE_LEXER_WITHOUT_DEFAULT_MODE";
    LexerDefinitionErrorType[LexerDefinitionErrorType["MULTI_MODE_LEXER_WITHOUT_MODES_PROPERTY"] = 8] = "MULTI_MODE_LEXER_WITHOUT_MODES_PROPERTY";
    LexerDefinitionErrorType[LexerDefinitionErrorType["MULTI_MODE_LEXER_DEFAULT_MODE_VALUE_DOES_NOT_EXIST"] = 9] = "MULTI_MODE_LEXER_DEFAULT_MODE_VALUE_DOES_NOT_EXIST";
    LexerDefinitionErrorType[LexerDefinitionErrorType["LEXER_DEFINITION_CANNOT_CONTAIN_UNDEFINED"] = 10] = "LEXER_DEFINITION_CANNOT_CONTAIN_UNDEFINED";
    LexerDefinitionErrorType[LexerDefinitionErrorType["SOI_ANCHOR_FOUND"] = 11] = "SOI_ANCHOR_FOUND";
    LexerDefinitionErrorType[LexerDefinitionErrorType["EMPTY_MATCH_PATTERN"] = 12] = "EMPTY_MATCH_PATTERN";
    LexerDefinitionErrorType[LexerDefinitionErrorType["NO_LINE_BREAKS_FLAGS"] = 13] = "NO_LINE_BREAKS_FLAGS";
    LexerDefinitionErrorType[LexerDefinitionErrorType["UNREACHABLE_PATTERN"] = 14] = "UNREACHABLE_PATTERN";
    LexerDefinitionErrorType[LexerDefinitionErrorType["IDENTIFY_TERMINATOR"] = 15] = "IDENTIFY_TERMINATOR";
    LexerDefinitionErrorType[LexerDefinitionErrorType["CUSTOM_LINE_BREAK"] = 16] = "CUSTOM_LINE_BREAK";
})($ad59c0d2332ba319$export$75fe8082c000e4d9 || ($ad59c0d2332ba319$export$75fe8082c000e4d9 = {}));
var $ad59c0d2332ba319$var$DEFAULT_LEXER_CONFIG = {
    deferDefinitionErrorsHandling: false,
    positionTracking: "full",
    lineTerminatorsPattern: /\n|\r\n?/g,
    lineTerminatorCharacters: [
        "\n",
        "\r"
    ],
    ensureOptimizations: false,
    safeMode: false,
    errorMessageProvider: (0, $lMxRC.defaultLexerErrorProvider),
    traceInitPerf: false,
    skipValidations: false
};
Object.freeze($ad59c0d2332ba319$var$DEFAULT_LEXER_CONFIG);
var $ad59c0d2332ba319$export$6168dc8908a6c652 = /** @class */ function() {
    function Lexer(lexerDefinition, config) {
        var _this = this;
        if (config === void 0) config = $ad59c0d2332ba319$var$DEFAULT_LEXER_CONFIG;
        this.lexerDefinition = lexerDefinition;
        this.lexerDefinitionErrors = [];
        this.lexerDefinitionWarning = [];
        this.patternIdxToConfig = {};
        this.charCodeToPatternIdxToConfig = {};
        this.modes = [];
        this.emptyGroups = {};
        this.config = undefined;
        this.trackStartLines = true;
        this.trackEndLines = true;
        this.hasCustom = false;
        this.canModeBeOptimized = {};
        if (typeof config === "boolean") throw Error("The second argument to the Lexer constructor is now an ILexerConfig Object.\na boolean 2nd argument is no longer supported");
        // todo: defaults func?
        this.config = (0, $5mLYn.merge)($ad59c0d2332ba319$var$DEFAULT_LEXER_CONFIG, config);
        var traceInitVal = this.config.traceInitPerf;
        if (traceInitVal === true) {
            this.traceInitMaxIdent = Infinity;
            this.traceInitPerf = true;
        } else if (typeof traceInitVal === "number") {
            this.traceInitMaxIdent = traceInitVal;
            this.traceInitPerf = true;
        }
        this.traceInitIndent = -1;
        this.TRACE_INIT("Lexer Constructor", function() {
            var actualDefinition;
            var hasOnlySingleMode = true;
            _this.TRACE_INIT("Lexer Config handling", function() {
                if (_this.config.lineTerminatorsPattern === $ad59c0d2332ba319$var$DEFAULT_LEXER_CONFIG.lineTerminatorsPattern) // optimized built-in implementation for the defaults definition of lineTerminators
                _this.config.lineTerminatorsPattern = (0, $22jE1.LineTerminatorOptimizedTester);
                else {
                    if (_this.config.lineTerminatorCharacters === $ad59c0d2332ba319$var$DEFAULT_LEXER_CONFIG.lineTerminatorCharacters) throw Error("Error: Missing <lineTerminatorCharacters> property on the Lexer config.\n	For details See: https://sap.github.io/chevrotain/docs/guide/resolving_lexer_errors.html#MISSING_LINE_TERM_CHARS");
                }
                if (config.safeMode && config.ensureOptimizations) throw Error('"safeMode" and "ensureOptimizations" flags are mutually exclusive.');
                _this.trackStartLines = /full|onlyStart/i.test(_this.config.positionTracking);
                _this.trackEndLines = /full/i.test(_this.config.positionTracking);
                // Convert SingleModeLexerDefinition into a IMultiModeLexerDefinition.
                if ((0, $5mLYn.isArray)(lexerDefinition)) {
                    actualDefinition = {
                        modes: {}
                    };
                    actualDefinition.modes[0, $22jE1.DEFAULT_MODE] = (0, $5mLYn.cloneArr)(lexerDefinition);
                    actualDefinition[0, $22jE1.DEFAULT_MODE] = (0, $22jE1.DEFAULT_MODE);
                } else {
                    // no conversion needed, input should already be a IMultiModeLexerDefinition
                    hasOnlySingleMode = false;
                    actualDefinition = (0, $5mLYn.cloneObj)(lexerDefinition);
                }
            });
            if (_this.config.skipValidations === false) {
                _this.TRACE_INIT("performRuntimeChecks", function() {
                    _this.lexerDefinitionErrors = _this.lexerDefinitionErrors.concat((0, $22jE1.performRuntimeChecks)(actualDefinition, _this.trackStartLines, _this.config.lineTerminatorCharacters));
                });
                _this.TRACE_INIT("performWarningRuntimeChecks", function() {
                    _this.lexerDefinitionWarning = _this.lexerDefinitionWarning.concat((0, $22jE1.performWarningRuntimeChecks)(actualDefinition, _this.trackStartLines, _this.config.lineTerminatorCharacters));
                });
            }
            // for extra robustness to avoid throwing an none informative error message
            actualDefinition.modes = actualDefinition.modes ? actualDefinition.modes : {};
            // an error of undefined TokenTypes will be detected in "performRuntimeChecks" above.
            // this transformation is to increase robustness in the case of partially invalid lexer definition.
            (0, $5mLYn.forEach)(actualDefinition.modes, function(currModeValue, currModeName) {
                actualDefinition.modes[currModeName] = (0, $5mLYn.reject)(currModeValue, function(currTokType) {
                    return (0, $5mLYn.isUndefined)(currTokType);
                });
            });
            var allModeNames = (0, $5mLYn.keys)(actualDefinition.modes);
            (0, $5mLYn.forEach)(actualDefinition.modes, function(currModDef, currModName) {
                _this.TRACE_INIT("Mode: <" + currModName + "> processing", function() {
                    _this.modes.push(currModName);
                    if (_this.config.skipValidations === false) _this.TRACE_INIT("validatePatterns", function() {
                        _this.lexerDefinitionErrors = _this.lexerDefinitionErrors.concat((0, $22jE1.validatePatterns)(currModDef, allModeNames));
                    });
                    // If definition errors were encountered, the analysis phase may fail unexpectedly/
                    // Considering a lexer with definition errors may never be used, there is no point
                    // to performing the analysis anyhow...
                    if ((0, $5mLYn.isEmpty)(_this.lexerDefinitionErrors)) {
                        (0, $6UThq.augmentTokenTypes)(currModDef);
                        var currAnalyzeResult_1;
                        _this.TRACE_INIT("analyzeTokenTypes", function() {
                            currAnalyzeResult_1 = (0, $22jE1.analyzeTokenTypes)(currModDef, {
                                lineTerminatorCharacters: _this.config.lineTerminatorCharacters,
                                positionTracking: config.positionTracking,
                                ensureOptimizations: config.ensureOptimizations,
                                safeMode: config.safeMode,
                                tracer: _this.TRACE_INIT.bind(_this)
                            });
                        });
                        _this.patternIdxToConfig[currModName] = currAnalyzeResult_1.patternIdxToConfig;
                        _this.charCodeToPatternIdxToConfig[currModName] = currAnalyzeResult_1.charCodeToPatternIdxToConfig;
                        _this.emptyGroups = (0, $5mLYn.merge)(_this.emptyGroups, currAnalyzeResult_1.emptyGroups);
                        _this.hasCustom = currAnalyzeResult_1.hasCustom || _this.hasCustom;
                        _this.canModeBeOptimized[currModName] = currAnalyzeResult_1.canBeOptimized;
                    }
                });
            });
            _this.defaultMode = actualDefinition.defaultMode;
            if (!(0, $5mLYn.isEmpty)(_this.lexerDefinitionErrors) && !_this.config.deferDefinitionErrorsHandling) {
                var allErrMessages = (0, $5mLYn.map)(_this.lexerDefinitionErrors, function(error) {
                    return error.message;
                });
                var allErrMessagesString = allErrMessages.join("-----------------------\n");
                throw new Error("Errors detected in definition of Lexer:\n" + allErrMessagesString);
            }
            // Only print warning if there are no errors, This will avoid pl
            (0, $5mLYn.forEach)(_this.lexerDefinitionWarning, function(warningDescriptor) {
                (0, $5mLYn.PRINT_WARNING)(warningDescriptor.message);
            });
            _this.TRACE_INIT("Choosing sub-methods implementations", function() {
                // Choose the relevant internal implementations for this specific parser.
                // These implementations should be in-lined by the JavaScript engine
                // to provide optimal performance in each scenario.
                if (0, $22jE1.SUPPORT_STICKY) {
                    _this.chopInput = (0, $5mLYn.IDENTITY);
                    _this.match = _this.matchWithTest;
                } else {
                    _this.updateLastIndex = (0, $5mLYn.NOOP);
                    _this.match = _this.matchWithExec;
                }
                if (hasOnlySingleMode) _this.handleModes = (0, $5mLYn.NOOP);
                if (_this.trackStartLines === false) _this.computeNewColumn = (0, $5mLYn.IDENTITY);
                if (_this.trackEndLines === false) _this.updateTokenEndLineColumnLocation = (0, $5mLYn.NOOP);
                if (/full/i.test(_this.config.positionTracking)) _this.createTokenInstance = _this.createFullToken;
                else if (/onlyStart/i.test(_this.config.positionTracking)) _this.createTokenInstance = _this.createStartOnlyToken;
                else if (/onlyOffset/i.test(_this.config.positionTracking)) _this.createTokenInstance = _this.createOffsetOnlyToken;
                else throw Error('Invalid <positionTracking> config option: "' + _this.config.positionTracking + '"');
                if (_this.hasCustom) {
                    _this.addToken = _this.addTokenUsingPush;
                    _this.handlePayload = _this.handlePayloadWithCustom;
                } else {
                    _this.addToken = _this.addTokenUsingMemberAccess;
                    _this.handlePayload = _this.handlePayloadNoCustom;
                }
            });
            _this.TRACE_INIT("Failed Optimization Warnings", function() {
                var unOptimizedModes = (0, $5mLYn.reduce)(_this.canModeBeOptimized, function(cannotBeOptimized, canBeOptimized, modeName) {
                    if (canBeOptimized === false) cannotBeOptimized.push(modeName);
                    return cannotBeOptimized;
                }, []);
                if (config.ensureOptimizations && !(0, $5mLYn.isEmpty)(unOptimizedModes)) throw Error("Lexer Modes: < " + unOptimizedModes.join(", ") + " > cannot be optimized.\n" + '	 Disable the "ensureOptimizations" lexer config flag to silently ignore this and run the lexer in an un-optimized mode.\n' + "	 Or inspect the console log for details on how to resolve these issues.");
            });
            _this.TRACE_INIT("clearRegExpParserCache", function() {
                (0, $8VuTk.clearRegExpParserCache)();
            });
            _this.TRACE_INIT("toFastProperties", function() {
                (0, $5mLYn.toFastProperties)(_this);
            });
        });
    }
    Lexer.prototype.tokenize = function(text, initialMode) {
        if (initialMode === void 0) initialMode = this.defaultMode;
        if (!(0, $5mLYn.isEmpty)(this.lexerDefinitionErrors)) {
            var allErrMessages = (0, $5mLYn.map)(this.lexerDefinitionErrors, function(error) {
                return error.message;
            });
            var allErrMessagesString = allErrMessages.join("-----------------------\n");
            throw new Error("Unable to Tokenize because Errors detected in definition of Lexer:\n" + allErrMessagesString);
        }
        var lexResult = this.tokenizeInternal(text, initialMode);
        return lexResult;
    };
    // There is quite a bit of duplication between this and "tokenizeInternalLazy"
    // This is intentional due to performance considerations.
    Lexer.prototype.tokenizeInternal = function(text, initialMode) {
        var _this = this;
        var i, j, matchAltImage, longerAltIdx, matchedImage, payload, altPayload, imageLength, group, tokType, newToken, errLength, droppedChar, msg, match;
        var orgText = text;
        var orgLength = orgText.length;
        var offset = 0;
        var matchedTokensIndex = 0;
        // initializing the tokensArray to the "guessed" size.
        // guessing too little will still reduce the number of array re-sizes on pushes.
        // guessing too large (Tested by guessing x4 too large) may cost a bit more of memory
        // but would still have a faster runtime by avoiding (All but one) array resizing.
        var guessedNumberOfTokens = this.hasCustom ? 0 // will break custom token pattern APIs the matchedTokens array will contain undefined elements.
         : Math.floor(text.length / 10);
        var matchedTokens = new Array(guessedNumberOfTokens);
        var errors = [];
        var line = this.trackStartLines ? 1 : undefined;
        var column = this.trackStartLines ? 1 : undefined;
        var groups = (0, $22jE1.cloneEmptyGroups)(this.emptyGroups);
        var trackLines = this.trackStartLines;
        var lineTerminatorPattern = this.config.lineTerminatorsPattern;
        var currModePatternsLength = 0;
        var patternIdxToConfig = [];
        var currCharCodeToPatternIdxToConfig = [];
        var modeStack = [];
        var emptyArray = [];
        Object.freeze(emptyArray);
        var getPossiblePatterns = undefined;
        function getPossiblePatternsSlow() {
            return patternIdxToConfig;
        }
        function getPossiblePatternsOptimized(charCode) {
            var optimizedCharIdx = (0, $22jE1.charCodeToOptimizedIndex)(charCode);
            var possiblePatterns = currCharCodeToPatternIdxToConfig[optimizedCharIdx];
            if (possiblePatterns === undefined) return emptyArray;
            else return possiblePatterns;
        }
        var pop_mode = function(popToken) {
            // TODO: perhaps avoid this error in the edge case there is no more input?
            if (modeStack.length === 1 && // if we have both a POP_MODE and a PUSH_MODE this is in-fact a "transition"
            // So no error should occur.
            popToken.tokenType.PUSH_MODE === undefined) {
                // if we try to pop the last mode there lexer will no longer have ANY mode.
                // thus the pop is ignored, an error will be created and the lexer will continue parsing in the previous mode.
                var msg_1 = _this.config.errorMessageProvider.buildUnableToPopLexerModeMessage(popToken);
                errors.push({
                    offset: popToken.startOffset,
                    line: popToken.startLine !== undefined ? popToken.startLine : undefined,
                    column: popToken.startColumn !== undefined ? popToken.startColumn : undefined,
                    length: popToken.image.length,
                    message: msg_1
                });
            } else {
                modeStack.pop();
                var newMode = (0, $5mLYn.last)(modeStack);
                patternIdxToConfig = _this.patternIdxToConfig[newMode];
                currCharCodeToPatternIdxToConfig = _this.charCodeToPatternIdxToConfig[newMode];
                currModePatternsLength = patternIdxToConfig.length;
                var modeCanBeOptimized = _this.canModeBeOptimized[newMode] && _this.config.safeMode === false;
                if (currCharCodeToPatternIdxToConfig && modeCanBeOptimized) getPossiblePatterns = getPossiblePatternsOptimized;
                else getPossiblePatterns = getPossiblePatternsSlow;
            }
        };
        function push_mode(newMode) {
            modeStack.push(newMode);
            currCharCodeToPatternIdxToConfig = this.charCodeToPatternIdxToConfig[newMode];
            patternIdxToConfig = this.patternIdxToConfig[newMode];
            currModePatternsLength = patternIdxToConfig.length;
            currModePatternsLength = patternIdxToConfig.length;
            var modeCanBeOptimized = this.canModeBeOptimized[newMode] && this.config.safeMode === false;
            if (currCharCodeToPatternIdxToConfig && modeCanBeOptimized) getPossiblePatterns = getPossiblePatternsOptimized;
            else getPossiblePatterns = getPossiblePatternsSlow;
        }
        // this pattern seems to avoid a V8 de-optimization, although that de-optimization does not
        // seem to matter performance wise.
        push_mode.call(this, initialMode);
        var currConfig;
        while(offset < orgLength){
            matchedImage = null;
            var nextCharCode = orgText.charCodeAt(offset);
            var chosenPatternIdxToConfig = getPossiblePatterns(nextCharCode);
            var chosenPatternsLength = chosenPatternIdxToConfig.length;
            for(i = 0; i < chosenPatternsLength; i++){
                currConfig = chosenPatternIdxToConfig[i];
                var currPattern = currConfig.pattern;
                payload = null;
                // manually in-lined because > 600 chars won't be in-lined in V8
                var singleCharCode = currConfig.short;
                if (singleCharCode !== false) {
                    if (nextCharCode === singleCharCode) // single character string
                    matchedImage = currPattern;
                } else if (currConfig.isCustom === true) {
                    match = currPattern.exec(orgText, offset, matchedTokens, groups);
                    if (match !== null) {
                        matchedImage = match[0];
                        if (match.payload !== undefined) payload = match.payload;
                    } else matchedImage = null;
                } else {
                    this.updateLastIndex(currPattern, offset);
                    matchedImage = this.match(currPattern, text, offset);
                }
                if (matchedImage !== null) {
                    // even though this pattern matched we must try a another longer alternative.
                    // this can be used to prioritize keywords over identifiers
                    longerAltIdx = currConfig.longerAlt;
                    if (longerAltIdx !== undefined) {
                        // TODO: micro optimize, avoid extra prop access
                        // by saving/linking longerAlt on the original config?
                        var longerAltConfig = patternIdxToConfig[longerAltIdx];
                        var longerAltPattern = longerAltConfig.pattern;
                        altPayload = null;
                        // single Char can never be a longer alt so no need to test it.
                        // manually in-lined because > 600 chars won't be in-lined in V8
                        if (longerAltConfig.isCustom === true) {
                            match = longerAltPattern.exec(orgText, offset, matchedTokens, groups);
                            if (match !== null) {
                                matchAltImage = match[0];
                                if (match.payload !== undefined) altPayload = match.payload;
                            } else matchAltImage = null;
                        } else {
                            this.updateLastIndex(longerAltPattern, offset);
                            matchAltImage = this.match(longerAltPattern, text, offset);
                        }
                        if (matchAltImage && matchAltImage.length > matchedImage.length) {
                            matchedImage = matchAltImage;
                            payload = altPayload;
                            currConfig = longerAltConfig;
                        }
                    }
                    break;
                }
            }
            // successful match
            if (matchedImage !== null) {
                imageLength = matchedImage.length;
                group = currConfig.group;
                if (group !== undefined) {
                    tokType = currConfig.tokenTypeIdx;
                    // TODO: "offset + imageLength" and the new column may be computed twice in case of "full" location information inside
                    // createFullToken method
                    newToken = this.createTokenInstance(matchedImage, offset, tokType, currConfig.tokenType, line, column, imageLength);
                    this.handlePayload(newToken, payload);
                    // TODO: optimize NOOP in case there are no special groups?
                    if (group === false) matchedTokensIndex = this.addToken(matchedTokens, matchedTokensIndex, newToken);
                    else groups[group].push(newToken);
                }
                text = this.chopInput(text, imageLength);
                offset = offset + imageLength;
                // TODO: with newlines the column may be assigned twice
                column = this.computeNewColumn(column, imageLength);
                if (trackLines === true && currConfig.canLineTerminator === true) {
                    var numOfLTsInMatch = 0;
                    var foundTerminator = void 0;
                    var lastLTEndOffset = void 0;
                    lineTerminatorPattern.lastIndex = 0;
                    do {
                        foundTerminator = lineTerminatorPattern.test(matchedImage);
                        if (foundTerminator === true) {
                            lastLTEndOffset = lineTerminatorPattern.lastIndex - 1;
                            numOfLTsInMatch++;
                        }
                    }while (foundTerminator === true);
                    if (numOfLTsInMatch !== 0) {
                        line = line + numOfLTsInMatch;
                        column = imageLength - lastLTEndOffset;
                        this.updateTokenEndLineColumnLocation(newToken, group, lastLTEndOffset, numOfLTsInMatch, line, column, imageLength);
                    }
                }
                // will be NOOP if no modes present
                this.handleModes(currConfig, pop_mode, push_mode, newToken);
            } else {
                // error recovery, drop characters until we identify a valid token's start point
                var errorStartOffset = offset;
                var errorLine = line;
                var errorColumn = column;
                var foundResyncPoint = false;
                while(!foundResyncPoint && offset < orgLength){
                    // drop chars until we succeed in matching something
                    droppedChar = orgText.charCodeAt(offset);
                    // Identity Func (when sticky flag is enabled)
                    text = this.chopInput(text, 1);
                    offset++;
                    for(j = 0; j < currModePatternsLength; j++){
                        var currConfig_1 = patternIdxToConfig[j];
                        var currPattern = currConfig_1.pattern;
                        // manually in-lined because > 600 chars won't be in-lined in V8
                        var singleCharCode = currConfig_1.short;
                        if (singleCharCode !== false) {
                            if (orgText.charCodeAt(offset) === singleCharCode) // single character string
                            foundResyncPoint = true;
                        } else if (currConfig_1.isCustom === true) foundResyncPoint = currPattern.exec(orgText, offset, matchedTokens, groups) !== null;
                        else {
                            this.updateLastIndex(currPattern, offset);
                            foundResyncPoint = currPattern.exec(text) !== null;
                        }
                        if (foundResyncPoint === true) break;
                    }
                }
                errLength = offset - errorStartOffset;
                // at this point we either re-synced or reached the end of the input text
                msg = this.config.errorMessageProvider.buildUnexpectedCharactersMessage(orgText, errorStartOffset, errLength, errorLine, errorColumn);
                errors.push({
                    offset: errorStartOffset,
                    line: errorLine,
                    column: errorColumn,
                    length: errLength,
                    message: msg
                });
            }
        }
        // if we do have custom patterns which push directly into the
        // TODO: custom tokens should not push directly??
        if (!this.hasCustom) // if we guessed a too large size for the tokens array this will shrink it to the right size.
        matchedTokens.length = matchedTokensIndex;
        return {
            tokens: matchedTokens,
            groups: groups,
            errors: errors
        };
    };
    Lexer.prototype.handleModes = function(config, pop_mode, push_mode, newToken) {
        if (config.pop === true) {
            // need to save the PUSH_MODE property as if the mode is popped
            // patternIdxToPopMode is updated to reflect the new mode after popping the stack
            var pushMode = config.push;
            pop_mode(newToken);
            if (pushMode !== undefined) push_mode.call(this, pushMode);
        } else if (config.push !== undefined) push_mode.call(this, config.push);
    };
    Lexer.prototype.chopInput = function(text, length) {
        return text.substring(length);
    };
    Lexer.prototype.updateLastIndex = function(regExp, newLastIndex) {
        regExp.lastIndex = newLastIndex;
    };
    // TODO: decrease this under 600 characters? inspect stripping comments option in TSC compiler
    Lexer.prototype.updateTokenEndLineColumnLocation = function(newToken, group, lastLTIdx, numOfLTsInMatch, line, column, imageLength) {
        var lastCharIsLT, fixForEndingInLT;
        if (group !== undefined) {
            // a none skipped multi line Token, need to update endLine/endColumn
            lastCharIsLT = lastLTIdx === imageLength - 1;
            fixForEndingInLT = lastCharIsLT ? -1 : 0;
            if (!(numOfLTsInMatch === 1 && lastCharIsLT === true)) {
                // if a token ends in a LT that last LT only affects the line numbering of following Tokens
                newToken.endLine = line + fixForEndingInLT;
                // the last LT in a token does not affect the endColumn either as the [columnStart ... columnEnd)
                // inclusive to exclusive range.
                newToken.endColumn = column - 1 + -fixForEndingInLT;
            }
        // else single LT in the last character of a token, no need to modify the endLine/EndColumn
        }
    };
    Lexer.prototype.computeNewColumn = function(oldColumn, imageLength) {
        return oldColumn + imageLength;
    };
    // Place holder, will be replaced by the correct variant according to the locationTracking option at runtime.
    /* istanbul ignore next - place holder */ Lexer.prototype.createTokenInstance = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return null;
    };
    Lexer.prototype.createOffsetOnlyToken = function(image, startOffset, tokenTypeIdx, tokenType) {
        return {
            image: image,
            startOffset: startOffset,
            tokenTypeIdx: tokenTypeIdx,
            tokenType: tokenType
        };
    };
    Lexer.prototype.createStartOnlyToken = function(image, startOffset, tokenTypeIdx, tokenType, startLine, startColumn) {
        return {
            image: image,
            startOffset: startOffset,
            startLine: startLine,
            startColumn: startColumn,
            tokenTypeIdx: tokenTypeIdx,
            tokenType: tokenType
        };
    };
    Lexer.prototype.createFullToken = function(image, startOffset, tokenTypeIdx, tokenType, startLine, startColumn, imageLength) {
        return {
            image: image,
            startOffset: startOffset,
            endOffset: startOffset + imageLength - 1,
            startLine: startLine,
            endLine: startLine,
            startColumn: startColumn,
            endColumn: startColumn + imageLength - 1,
            tokenTypeIdx: tokenTypeIdx,
            tokenType: tokenType
        };
    };
    // Place holder, will be replaced by the correct variant according to the locationTracking option at runtime.
    /* istanbul ignore next - place holder */ Lexer.prototype.addToken = function(tokenVector, index, tokenToAdd) {
        return 666;
    };
    Lexer.prototype.addTokenUsingPush = function(tokenVector, index, tokenToAdd) {
        tokenVector.push(tokenToAdd);
        return index;
    };
    Lexer.prototype.addTokenUsingMemberAccess = function(tokenVector, index, tokenToAdd) {
        tokenVector[index] = tokenToAdd;
        index++;
        return index;
    };
    // Place holder, will be replaced by the correct variant according to the hasCustom flag option at runtime.
    /* istanbul ignore next - place holder */ Lexer.prototype.handlePayload = function(token, payload) {};
    Lexer.prototype.handlePayloadNoCustom = function(token, payload) {};
    Lexer.prototype.handlePayloadWithCustom = function(token, payload) {
        if (payload !== null) token.payload = payload;
    };
    /* istanbul ignore next - place holder to be replaced with chosen alternative at runtime */ Lexer.prototype.match = function(pattern, text, offset) {
        return null;
    };
    Lexer.prototype.matchWithTest = function(pattern, text, offset) {
        var found = pattern.test(text);
        if (found === true) return text.substring(offset, pattern.lastIndex);
        return null;
    };
    Lexer.prototype.matchWithExec = function(pattern, text) {
        var regExpArray = pattern.exec(text);
        return regExpArray !== null ? regExpArray[0] : regExpArray;
    };
    // Duplicated from the parser's perf trace trait to allow future extraction
    // of the lexer to a separate package.
    Lexer.prototype.TRACE_INIT = function(phaseDesc, phaseImpl) {
        // No need to optimize this using NOOP pattern because
        // It is not called in a hot spot...
        if (this.traceInitPerf === true) {
            this.traceInitIndent++;
            var indent = new Array(this.traceInitIndent + 1).join("	");
            if (this.traceInitIndent < this.traceInitMaxIdent) console.log(indent + "--> <" + phaseDesc + ">");
            var _a = (0, $5mLYn.timer)(phaseImpl), time = _a.time, value = _a.value;
            /* istanbul ignore next - Difficult to reproduce specific performance behavior (>10ms) in tests */ var traceMethod = time > 10 ? console.warn : console.log;
            if (this.traceInitIndent < this.traceInitMaxIdent) traceMethod(indent + "<-- <" + phaseDesc + "> time: " + time + "ms");
            this.traceInitIndent--;
            return value;
        } else return phaseImpl();
    };
    Lexer.SKIPPED = "This marks a skipped Token pattern, this means each token identified by it willbe consumed and then thrown into oblivion, this can be used to for example to completely ignore whitespace.";
    Lexer.NA = /NOT_APPLICABLE/;
    return Lexer;
}();

});
parcelRegister("22jE1", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_MODE", function () { return $17bb01acf9d17ae5$export$d9dae51ac155a903; });
$parcel$export(module.exports, "SUPPORT_STICKY", function () { return $17bb01acf9d17ae5$export$a754995bde7f26; });
$parcel$export(module.exports, "analyzeTokenTypes", function () { return $17bb01acf9d17ae5$export$f0a045a920e18a1c; });
$parcel$export(module.exports, "charCodeToOptimizedIndex", function () { return $17bb01acf9d17ae5$export$6e0cad6ebae9f8f9; });
$parcel$export(module.exports, "validatePatterns", function () { return $17bb01acf9d17ae5$export$a8f3a45f221a9c6c; });
$parcel$export(module.exports, "performRuntimeChecks", function () { return $17bb01acf9d17ae5$export$d5653dbdd225d43d; });
$parcel$export(module.exports, "performWarningRuntimeChecks", function () { return $17bb01acf9d17ae5$export$6bf002249f609a38; });
$parcel$export(module.exports, "cloneEmptyGroups", function () { return $17bb01acf9d17ae5$export$4425dc103ce72034; });
$parcel$export(module.exports, "LineTerminatorOptimizedTester", function () { return $17bb01acf9d17ae5$export$1206eb2ecfb4b09a; });
$parcel$export(module.exports, "minOptimizationVal", function () { return $17bb01acf9d17ae5$export$ceaf0243db5272bd; });

var $dKV4H = parcelRequire("dKV4H");

var $eSJX3 = parcelRequire("eSJX3");

var $5mLYn = parcelRequire("5mLYn");

var $kdIKl = parcelRequire("kdIKl");

var $8VuTk = parcelRequire("8VuTk");
var $17bb01acf9d17ae5$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $17bb01acf9d17ae5$var$PATTERN = "PATTERN";
var $17bb01acf9d17ae5$export$d9dae51ac155a903 = "defaultMode";
var $17bb01acf9d17ae5$export$240b20df485e8ed6 = "modes";
var $17bb01acf9d17ae5$export$a754995bde7f26 = typeof new RegExp("(?:)").sticky === "boolean";
function $17bb01acf9d17ae5$export$399dd9f3926094c4() {
    $17bb01acf9d17ae5$export$a754995bde7f26 = false;
}
function $17bb01acf9d17ae5$export$de1cb73e9bab972f() {
    $17bb01acf9d17ae5$export$a754995bde7f26 = true;
}
function $17bb01acf9d17ae5$export$f0a045a920e18a1c(tokenTypes, options) {
    options = (0, $5mLYn.defaults)(options, {
        useSticky: $17bb01acf9d17ae5$export$a754995bde7f26,
        debug: false,
        safeMode: false,
        positionTracking: "full",
        lineTerminatorCharacters: [
            "\r",
            "\n"
        ],
        tracer: function(msg, action) {
            return action();
        }
    });
    var tracer = options.tracer;
    tracer("initCharCodeToOptimizedIndexMap", function() {
        $17bb01acf9d17ae5$var$initCharCodeToOptimizedIndexMap();
    });
    var onlyRelevantTypes;
    tracer("Reject Lexer.NA", function() {
        onlyRelevantTypes = (0, $5mLYn.reject)(tokenTypes, function(currType) {
            return currType[$17bb01acf9d17ae5$var$PATTERN] === (0, $eSJX3.Lexer).NA;
        });
    });
    var hasCustom = false;
    var allTransformedPatterns;
    tracer("Transform Patterns", function() {
        hasCustom = false;
        allTransformedPatterns = (0, $5mLYn.map)(onlyRelevantTypes, function(currType) {
            var currPattern = currType[$17bb01acf9d17ae5$var$PATTERN];
            /* istanbul ignore else */ if ((0, $5mLYn.isRegExp)(currPattern)) {
                var regExpSource = currPattern.source;
                if (regExpSource.length === 1 && // only these regExp meta characters which can appear in a length one regExp
                regExpSource !== "^" && regExpSource !== "$" && regExpSource !== "." && !currPattern.ignoreCase) return regExpSource;
                else if (regExpSource.length === 2 && regExpSource[0] === "\\" && // not a meta character
                !(0, $5mLYn.contains)([
                    "d",
                    "D",
                    "s",
                    "S",
                    "t",
                    "r",
                    "n",
                    "t",
                    "0",
                    "c",
                    "b",
                    "B",
                    "f",
                    "v",
                    "w",
                    "W"
                ], regExpSource[1])) // escaped meta Characters: /\+/ /\[/
                // or redundant escaping: /\a/
                // without the escaping "\"
                return regExpSource[1];
                else return options.useSticky ? $17bb01acf9d17ae5$export$4b159505a63834ba(currPattern) : $17bb01acf9d17ae5$export$7c9f7efc1e116ee7(currPattern);
            } else if ((0, $5mLYn.isFunction)(currPattern)) {
                hasCustom = true;
                // CustomPatternMatcherFunc - custom patterns do not require any transformations, only wrapping in a RegExp Like object
                return {
                    exec: currPattern
                };
            } else if ((0, $5mLYn.has)(currPattern, "exec")) {
                hasCustom = true;
                // ICustomPattern
                return currPattern;
            } else if (typeof currPattern === "string") {
                if (currPattern.length === 1) return currPattern;
                else {
                    var escapedRegExpString = currPattern.replace(/[\\^$.*+?()[\]{}|]/g, "\\$&");
                    var wrappedRegExp = new RegExp(escapedRegExpString);
                    return options.useSticky ? $17bb01acf9d17ae5$export$4b159505a63834ba(wrappedRegExp) : $17bb01acf9d17ae5$export$7c9f7efc1e116ee7(wrappedRegExp);
                }
            } else throw Error("non exhaustive match");
        });
    });
    var patternIdxToType;
    var patternIdxToGroup;
    var patternIdxToLongerAltIdx;
    var patternIdxToPushMode;
    var patternIdxToPopMode;
    tracer("misc mapping", function() {
        patternIdxToType = (0, $5mLYn.map)(onlyRelevantTypes, function(currType) {
            return currType.tokenTypeIdx;
        });
        patternIdxToGroup = (0, $5mLYn.map)(onlyRelevantTypes, function(clazz) {
            var groupName = clazz.GROUP;
            /* istanbul ignore next */ if (groupName === (0, $eSJX3.Lexer).SKIPPED) return undefined;
            else if ((0, $5mLYn.isString)(groupName)) return groupName;
            else if ((0, $5mLYn.isUndefined)(groupName)) return false;
            else throw Error("non exhaustive match");
        });
        patternIdxToLongerAltIdx = (0, $5mLYn.map)(onlyRelevantTypes, function(clazz) {
            var longerAltType = clazz.LONGER_ALT;
            if (longerAltType) {
                var longerAltIdx = (0, $5mLYn.indexOf)(onlyRelevantTypes, longerAltType);
                return longerAltIdx;
            }
        });
        patternIdxToPushMode = (0, $5mLYn.map)(onlyRelevantTypes, function(clazz) {
            return clazz.PUSH_MODE;
        });
        patternIdxToPopMode = (0, $5mLYn.map)(onlyRelevantTypes, function(clazz) {
            return (0, $5mLYn.has)(clazz, "POP_MODE");
        });
    });
    var patternIdxToCanLineTerminator;
    tracer("Line Terminator Handling", function() {
        var lineTerminatorCharCodes = $17bb01acf9d17ae5$var$getCharCodes(options.lineTerminatorCharacters);
        patternIdxToCanLineTerminator = (0, $5mLYn.map)(onlyRelevantTypes, function(tokType) {
            return false;
        });
        if (options.positionTracking !== "onlyOffset") patternIdxToCanLineTerminator = (0, $5mLYn.map)(onlyRelevantTypes, function(tokType) {
            if ((0, $5mLYn.has)(tokType, "LINE_BREAKS")) return tokType.LINE_BREAKS;
            else {
                if ($17bb01acf9d17ae5$var$checkLineBreaksIssues(tokType, lineTerminatorCharCodes) === false) return (0, $kdIKl.canMatchCharCode)(lineTerminatorCharCodes, tokType.PATTERN);
            }
        });
    });
    var patternIdxToIsCustom;
    var patternIdxToShort;
    var emptyGroups;
    var patternIdxToConfig;
    tracer("Misc Mapping #2", function() {
        patternIdxToIsCustom = (0, $5mLYn.map)(onlyRelevantTypes, $17bb01acf9d17ae5$export$26136b6f4ec31c52);
        patternIdxToShort = (0, $5mLYn.map)(allTransformedPatterns, $17bb01acf9d17ae5$export$f60842fb9057d787);
        emptyGroups = (0, $5mLYn.reduce)(onlyRelevantTypes, function(acc, clazz) {
            var groupName = clazz.GROUP;
            if ((0, $5mLYn.isString)(groupName) && !(groupName === (0, $eSJX3.Lexer).SKIPPED)) acc[groupName] = [];
            return acc;
        }, {});
        patternIdxToConfig = (0, $5mLYn.map)(allTransformedPatterns, function(x, idx) {
            return {
                pattern: allTransformedPatterns[idx],
                longerAlt: patternIdxToLongerAltIdx[idx],
                canLineTerminator: patternIdxToCanLineTerminator[idx],
                isCustom: patternIdxToIsCustom[idx],
                short: patternIdxToShort[idx],
                group: patternIdxToGroup[idx],
                push: patternIdxToPushMode[idx],
                pop: patternIdxToPopMode[idx],
                tokenTypeIdx: patternIdxToType[idx],
                tokenType: onlyRelevantTypes[idx]
            };
        });
    });
    var canBeOptimized = true;
    var charCodeToPatternIdxToConfig = [];
    if (!options.safeMode) tracer("First Char Optimization", function() {
        charCodeToPatternIdxToConfig = (0, $5mLYn.reduce)(onlyRelevantTypes, function(result, currTokType, idx) {
            if (typeof currTokType.PATTERN === "string") {
                var charCode = currTokType.PATTERN.charCodeAt(0);
                var optimizedIdx = $17bb01acf9d17ae5$export$6e0cad6ebae9f8f9(charCode);
                $17bb01acf9d17ae5$var$addToMapOfArrays(result, optimizedIdx, patternIdxToConfig[idx]);
            } else if ((0, $5mLYn.isArray)(currTokType.START_CHARS_HINT)) {
                var lastOptimizedIdx_1;
                (0, $5mLYn.forEach)(currTokType.START_CHARS_HINT, function(charOrInt) {
                    var charCode = typeof charOrInt === "string" ? charOrInt.charCodeAt(0) : charOrInt;
                    var currOptimizedIdx = $17bb01acf9d17ae5$export$6e0cad6ebae9f8f9(charCode);
                    // Avoid adding the config multiple times
                    /* istanbul ignore else */ // - Difficult to check this scenario effects as it is only a performance
                    //   optimization that does not change correctness
                    if (lastOptimizedIdx_1 !== currOptimizedIdx) {
                        lastOptimizedIdx_1 = currOptimizedIdx;
                        $17bb01acf9d17ae5$var$addToMapOfArrays(result, currOptimizedIdx, patternIdxToConfig[idx]);
                    }
                });
            } else if ((0, $5mLYn.isRegExp)(currTokType.PATTERN)) {
                if (currTokType.PATTERN.unicode) {
                    canBeOptimized = false;
                    if (options.ensureOptimizations) (0, $5mLYn.PRINT_ERROR)("" + (0, $kdIKl.failedOptimizationPrefixMsg) + ("	Unable to analyze < " + currTokType.PATTERN.toString() + " > pattern.\n") + "	The regexp unicode flag is not currently supported by the regexp-to-ast library.\n" + "	This will disable the lexer's first char optimizations.\n" + "	For details See: https://sap.github.io/chevrotain/docs/guide/resolving_lexer_errors.html#UNICODE_OPTIMIZE");
                } else {
                    var optimizedCodes = (0, $kdIKl.getOptimizedStartCodesIndices)(currTokType.PATTERN, options.ensureOptimizations);
                    /* istanbul ignore if */ // start code will only be empty given an empty regExp or failure of regexp-to-ast library
                    // the first should be a different validation and the second cannot be tested.
                    if ((0, $5mLYn.isEmpty)(optimizedCodes)) // we cannot understand what codes may start possible matches
                    // The optimization correctness requires knowing start codes for ALL patterns.
                    // Not actually sure this is an error, no debug message
                    canBeOptimized = false;
                    (0, $5mLYn.forEach)(optimizedCodes, function(code) {
                        $17bb01acf9d17ae5$var$addToMapOfArrays(result, code, patternIdxToConfig[idx]);
                    });
                }
            } else {
                if (options.ensureOptimizations) (0, $5mLYn.PRINT_ERROR)("" + (0, $kdIKl.failedOptimizationPrefixMsg) + ("	TokenType: <" + currTokType.name + "> is using a custom token pattern without providing <start_chars_hint> parameter.\n") + "	This will disable the lexer's first char optimizations.\n" + "	For details See: https://sap.github.io/chevrotain/docs/guide/resolving_lexer_errors.html#CUSTOM_OPTIMIZE");
                canBeOptimized = false;
            }
            return result;
        }, []);
    });
    tracer("ArrayPacking", function() {
        charCodeToPatternIdxToConfig = (0, $5mLYn.packArray)(charCodeToPatternIdxToConfig);
    });
    return {
        emptyGroups: emptyGroups,
        patternIdxToConfig: patternIdxToConfig,
        charCodeToPatternIdxToConfig: charCodeToPatternIdxToConfig,
        hasCustom: hasCustom,
        canBeOptimized: canBeOptimized
    };
}
function $17bb01acf9d17ae5$export$a8f3a45f221a9c6c(tokenTypes, validModesNames) {
    var errors = [];
    var missingResult = $17bb01acf9d17ae5$export$7dab0dd5a9a77445(tokenTypes);
    errors = errors.concat(missingResult.errors);
    var invalidResult = $17bb01acf9d17ae5$export$6f8f4930b5379da8(missingResult.valid);
    var validTokenTypes = invalidResult.valid;
    errors = errors.concat(invalidResult.errors);
    errors = errors.concat($17bb01acf9d17ae5$var$validateRegExpPattern(validTokenTypes));
    errors = errors.concat($17bb01acf9d17ae5$export$f23dad3f813c2e72(validTokenTypes));
    errors = errors.concat($17bb01acf9d17ae5$export$973a65578ab28af1(validTokenTypes, validModesNames));
    errors = errors.concat($17bb01acf9d17ae5$export$ccb647f1007ccaed(validTokenTypes));
    return errors;
}
function $17bb01acf9d17ae5$var$validateRegExpPattern(tokenTypes) {
    var errors = [];
    var withRegExpPatterns = (0, $5mLYn.filter)(tokenTypes, function(currTokType) {
        return (0, $5mLYn.isRegExp)(currTokType[$17bb01acf9d17ae5$var$PATTERN]);
    });
    errors = errors.concat($17bb01acf9d17ae5$export$a3f026c57cfd92ee(withRegExpPatterns));
    errors = errors.concat($17bb01acf9d17ae5$export$d5f87072b5239cfa(withRegExpPatterns));
    errors = errors.concat($17bb01acf9d17ae5$export$a8aa99c424fac453(withRegExpPatterns));
    errors = errors.concat($17bb01acf9d17ae5$export$f898599ecad8c2dc(withRegExpPatterns));
    errors = errors.concat($17bb01acf9d17ae5$export$8a33c49088c776ec(withRegExpPatterns));
    return errors;
}
function $17bb01acf9d17ae5$export$7dab0dd5a9a77445(tokenTypes) {
    var tokenTypesWithMissingPattern = (0, $5mLYn.filter)(tokenTypes, function(currType) {
        return !(0, $5mLYn.has)(currType, $17bb01acf9d17ae5$var$PATTERN);
    });
    var errors = (0, $5mLYn.map)(tokenTypesWithMissingPattern, function(currType) {
        return {
            message: "Token Type: ->" + currType.name + "<- missing static 'PATTERN' property",
            type: (0, $eSJX3.LexerDefinitionErrorType).MISSING_PATTERN,
            tokenTypes: [
                currType
            ]
        };
    });
    var valid = (0, $5mLYn.difference)(tokenTypes, tokenTypesWithMissingPattern);
    return {
        errors: errors,
        valid: valid
    };
}
function $17bb01acf9d17ae5$export$6f8f4930b5379da8(tokenTypes) {
    var tokenTypesWithInvalidPattern = (0, $5mLYn.filter)(tokenTypes, function(currType) {
        var pattern = currType[$17bb01acf9d17ae5$var$PATTERN];
        return !(0, $5mLYn.isRegExp)(pattern) && !(0, $5mLYn.isFunction)(pattern) && !(0, $5mLYn.has)(pattern, "exec") && !(0, $5mLYn.isString)(pattern);
    });
    var errors = (0, $5mLYn.map)(tokenTypesWithInvalidPattern, function(currType) {
        return {
            message: "Token Type: ->" + currType.name + "<- static 'PATTERN' can only be a RegExp, a" + " Function matching the {CustomPatternMatcherFunc} type or an Object matching the {ICustomPattern} interface.",
            type: (0, $eSJX3.LexerDefinitionErrorType).INVALID_PATTERN,
            tokenTypes: [
                currType
            ]
        };
    });
    var valid = (0, $5mLYn.difference)(tokenTypes, tokenTypesWithInvalidPattern);
    return {
        errors: errors,
        valid: valid
    };
}
var $17bb01acf9d17ae5$var$end_of_input = /[^\\][\$]/;
function $17bb01acf9d17ae5$export$a3f026c57cfd92ee(tokenTypes) {
    var EndAnchorFinder = /** @class */ function(_super) {
        $17bb01acf9d17ae5$var$__extends(EndAnchorFinder, _super);
        function EndAnchorFinder() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.found = false;
            return _this;
        }
        EndAnchorFinder.prototype.visitEndAnchor = function(node) {
            this.found = true;
        };
        return EndAnchorFinder;
    }((0, $dKV4H.BaseRegExpVisitor));
    var invalidRegex = (0, $5mLYn.filter)(tokenTypes, function(currType) {
        var pattern = currType[$17bb01acf9d17ae5$var$PATTERN];
        try {
            var regexpAst = (0, $8VuTk.getRegExpAst)(pattern);
            var endAnchorVisitor = new EndAnchorFinder();
            endAnchorVisitor.visit(regexpAst);
            return endAnchorVisitor.found;
        } catch (e) {
            // old behavior in case of runtime exceptions with regexp-to-ast.
            /* istanbul ignore next - cannot ensure an error in regexp-to-ast*/ return $17bb01acf9d17ae5$var$end_of_input.test(pattern.source);
        }
    });
    var errors = (0, $5mLYn.map)(invalidRegex, function(currType) {
        return {
            message: "Unexpected RegExp Anchor Error:\n	Token Type: ->" + currType.name + "<- static 'PATTERN' cannot contain end of input anchor '$'\n" + "	See sap.github.io/chevrotain/docs/guide/resolving_lexer_errors.html#ANCHORS" + "	for details.",
            type: (0, $eSJX3.LexerDefinitionErrorType).EOI_ANCHOR_FOUND,
            tokenTypes: [
                currType
            ]
        };
    });
    return errors;
}
function $17bb01acf9d17ae5$export$8a33c49088c776ec(tokenTypes) {
    var matchesEmptyString = (0, $5mLYn.filter)(tokenTypes, function(currType) {
        var pattern = currType[$17bb01acf9d17ae5$var$PATTERN];
        return pattern.test("");
    });
    var errors = (0, $5mLYn.map)(matchesEmptyString, function(currType) {
        return {
            message: "Token Type: ->" + currType.name + "<- static 'PATTERN' must not match an empty string",
            type: (0, $eSJX3.LexerDefinitionErrorType).EMPTY_MATCH_PATTERN,
            tokenTypes: [
                currType
            ]
        };
    });
    return errors;
}
var $17bb01acf9d17ae5$var$start_of_input = /[^\\[][\^]|^\^/;
function $17bb01acf9d17ae5$export$d5f87072b5239cfa(tokenTypes) {
    var StartAnchorFinder = /** @class */ function(_super) {
        $17bb01acf9d17ae5$var$__extends(StartAnchorFinder, _super);
        function StartAnchorFinder() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.found = false;
            return _this;
        }
        StartAnchorFinder.prototype.visitStartAnchor = function(node) {
            this.found = true;
        };
        return StartAnchorFinder;
    }((0, $dKV4H.BaseRegExpVisitor));
    var invalidRegex = (0, $5mLYn.filter)(tokenTypes, function(currType) {
        var pattern = currType[$17bb01acf9d17ae5$var$PATTERN];
        try {
            var regexpAst = (0, $8VuTk.getRegExpAst)(pattern);
            var startAnchorVisitor = new StartAnchorFinder();
            startAnchorVisitor.visit(regexpAst);
            return startAnchorVisitor.found;
        } catch (e) {
            // old behavior in case of runtime exceptions with regexp-to-ast.
            /* istanbul ignore next - cannot ensure an error in regexp-to-ast*/ return $17bb01acf9d17ae5$var$start_of_input.test(pattern.source);
        }
    });
    var errors = (0, $5mLYn.map)(invalidRegex, function(currType) {
        return {
            message: "Unexpected RegExp Anchor Error:\n	Token Type: ->" + currType.name + "<- static 'PATTERN' cannot contain start of input anchor '^'\n" + "	See https://sap.github.io/chevrotain/docs/guide/resolving_lexer_errors.html#ANCHORS" + "	for details.",
            type: (0, $eSJX3.LexerDefinitionErrorType).SOI_ANCHOR_FOUND,
            tokenTypes: [
                currType
            ]
        };
    });
    return errors;
}
function $17bb01acf9d17ae5$export$a8aa99c424fac453(tokenTypes) {
    var invalidFlags = (0, $5mLYn.filter)(tokenTypes, function(currType) {
        var pattern = currType[$17bb01acf9d17ae5$var$PATTERN];
        return pattern instanceof RegExp && (pattern.multiline || pattern.global);
    });
    var errors = (0, $5mLYn.map)(invalidFlags, function(currType) {
        return {
            message: "Token Type: ->" + currType.name + "<- static 'PATTERN' may NOT contain global('g') or multiline('m')",
            type: (0, $eSJX3.LexerDefinitionErrorType).UNSUPPORTED_FLAGS_FOUND,
            tokenTypes: [
                currType
            ]
        };
    });
    return errors;
}
function $17bb01acf9d17ae5$export$f898599ecad8c2dc(tokenTypes) {
    var found = [];
    var identicalPatterns = (0, $5mLYn.map)(tokenTypes, function(outerType) {
        return (0, $5mLYn.reduce)(tokenTypes, function(result, innerType) {
            if (outerType.PATTERN.source === innerType.PATTERN.source && !(0, $5mLYn.contains)(found, innerType) && innerType.PATTERN !== (0, $eSJX3.Lexer).NA) {
                // this avoids duplicates in the result, each Token Type may only appear in one "set"
                // in essence we are creating Equivalence classes on equality relation.
                found.push(innerType);
                result.push(innerType);
                return result;
            }
            return result;
        }, []);
    });
    identicalPatterns = (0, $5mLYn.compact)(identicalPatterns);
    var duplicatePatterns = (0, $5mLYn.filter)(identicalPatterns, function(currIdenticalSet) {
        return currIdenticalSet.length > 1;
    });
    var errors = (0, $5mLYn.map)(duplicatePatterns, function(setOfIdentical) {
        var tokenTypeNames = (0, $5mLYn.map)(setOfIdentical, function(currType) {
            return currType.name;
        });
        var dupPatternSrc = (0, $5mLYn.first)(setOfIdentical).PATTERN;
        return {
            message: "The same RegExp pattern ->" + dupPatternSrc + "<-" + ("has been used in all of the following Token Types: " + tokenTypeNames.join(", ") + " <-"),
            type: (0, $eSJX3.LexerDefinitionErrorType).DUPLICATE_PATTERNS_FOUND,
            tokenTypes: setOfIdentical
        };
    });
    return errors;
}
function $17bb01acf9d17ae5$export$f23dad3f813c2e72(tokenTypes) {
    var invalidTypes = (0, $5mLYn.filter)(tokenTypes, function(clazz) {
        if (!(0, $5mLYn.has)(clazz, "GROUP")) return false;
        var group = clazz.GROUP;
        return group !== (0, $eSJX3.Lexer).SKIPPED && group !== (0, $eSJX3.Lexer).NA && !(0, $5mLYn.isString)(group);
    });
    var errors = (0, $5mLYn.map)(invalidTypes, function(currType) {
        return {
            message: "Token Type: ->" + currType.name + "<- static 'GROUP' can only be Lexer.SKIPPED/Lexer.NA/A String",
            type: (0, $eSJX3.LexerDefinitionErrorType).INVALID_GROUP_TYPE_FOUND,
            tokenTypes: [
                currType
            ]
        };
    });
    return errors;
}
function $17bb01acf9d17ae5$export$973a65578ab28af1(tokenTypes, validModes) {
    var invalidModes = (0, $5mLYn.filter)(tokenTypes, function(clazz) {
        return clazz.PUSH_MODE !== undefined && !(0, $5mLYn.contains)(validModes, clazz.PUSH_MODE);
    });
    var errors = (0, $5mLYn.map)(invalidModes, function(tokType) {
        var msg = "Token Type: ->" + tokType.name + "<- static 'PUSH_MODE' value cannot refer to a Lexer Mode ->" + tokType.PUSH_MODE + "<-" + "which does not exist";
        return {
            message: msg,
            type: (0, $eSJX3.LexerDefinitionErrorType).PUSH_MODE_DOES_NOT_EXIST,
            tokenTypes: [
                tokType
            ]
        };
    });
    return errors;
}
function $17bb01acf9d17ae5$export$ccb647f1007ccaed(tokenTypes) {
    var errors = [];
    var canBeTested = (0, $5mLYn.reduce)(tokenTypes, function(result, tokType, idx) {
        var pattern = tokType.PATTERN;
        if (pattern === (0, $eSJX3.Lexer).NA) return result;
        // a more comprehensive validation for all forms of regExps would require
        // deeper regExp analysis capabilities
        if ((0, $5mLYn.isString)(pattern)) result.push({
            str: pattern,
            idx: idx,
            tokenType: tokType
        });
        else if ((0, $5mLYn.isRegExp)(pattern) && $17bb01acf9d17ae5$var$noMetaChar(pattern)) result.push({
            str: pattern.source,
            idx: idx,
            tokenType: tokType
        });
        return result;
    }, []);
    (0, $5mLYn.forEach)(tokenTypes, function(tokType, testIdx) {
        (0, $5mLYn.forEach)(canBeTested, function(_a) {
            var str = _a.str, idx = _a.idx, tokenType = _a.tokenType;
            if (testIdx < idx && $17bb01acf9d17ae5$var$testTokenType(str, tokType.PATTERN)) {
                var msg = "Token: ->" + tokenType.name + "<- can never be matched.\n" + ("Because it appears AFTER the Token Type ->" + tokType.name + "<-") + "in the lexer's definition.\n" + "See https://sap.github.io/chevrotain/docs/guide/resolving_lexer_errors.html#UNREACHABLE";
                errors.push({
                    message: msg,
                    type: (0, $eSJX3.LexerDefinitionErrorType).UNREACHABLE_PATTERN,
                    tokenTypes: [
                        tokType,
                        tokenType
                    ]
                });
            }
        });
    });
    return errors;
}
function $17bb01acf9d17ae5$var$testTokenType(str, pattern) {
    /* istanbul ignore else */ if ((0, $5mLYn.isRegExp)(pattern)) {
        var regExpArray = pattern.exec(str);
        return regExpArray !== null && regExpArray.index === 0;
    } else if ((0, $5mLYn.isFunction)(pattern)) // maintain the API of custom patterns
    return pattern(str, 0, [], {});
    else if ((0, $5mLYn.has)(pattern, "exec")) // maintain the API of custom patterns
    return pattern.exec(str, 0, [], {});
    else if (typeof pattern === "string") return pattern === str;
    else throw Error("non exhaustive match");
}
function $17bb01acf9d17ae5$var$noMetaChar(regExp) {
    //https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp
    var metaChars = [
        ".",
        "\\",
        "[",
        "]",
        "|",
        "^",
        "$",
        "(",
        ")",
        "?",
        "*",
        "+",
        "{"
    ];
    return (0, $5mLYn.find)(metaChars, function(char) {
        return regExp.source.indexOf(char) !== -1;
    }) === undefined;
}
function $17bb01acf9d17ae5$export$7c9f7efc1e116ee7(pattern) {
    var flags = pattern.ignoreCase ? "i" : "";
    // always wrapping in a none capturing group preceded by '^' to make sure matching can only work on start of input.
    // duplicate/redundant start of input markers have no meaning (/^^^^A/ === /^A/)
    return new RegExp("^(?:" + pattern.source + ")", flags);
}
function $17bb01acf9d17ae5$export$4b159505a63834ba(pattern) {
    var flags = pattern.ignoreCase ? "iy" : "y";
    // always wrapping in a none capturing group preceded by '^' to make sure matching can only work on start of input.
    // duplicate/redundant start of input markers have no meaning (/^^^^A/ === /^A/)
    return new RegExp("" + pattern.source, flags);
}
function $17bb01acf9d17ae5$export$d5653dbdd225d43d(lexerDefinition, trackLines, lineTerminatorCharacters) {
    var errors = [];
    // some run time checks to help the end users.
    if (!(0, $5mLYn.has)(lexerDefinition, $17bb01acf9d17ae5$export$d9dae51ac155a903)) errors.push({
        message: "A MultiMode Lexer cannot be initialized without a <" + $17bb01acf9d17ae5$export$d9dae51ac155a903 + "> property in its definition\n",
        type: (0, $eSJX3.LexerDefinitionErrorType).MULTI_MODE_LEXER_WITHOUT_DEFAULT_MODE
    });
    if (!(0, $5mLYn.has)(lexerDefinition, $17bb01acf9d17ae5$export$240b20df485e8ed6)) errors.push({
        message: "A MultiMode Lexer cannot be initialized without a <" + $17bb01acf9d17ae5$export$240b20df485e8ed6 + "> property in its definition\n",
        type: (0, $eSJX3.LexerDefinitionErrorType).MULTI_MODE_LEXER_WITHOUT_MODES_PROPERTY
    });
    if ((0, $5mLYn.has)(lexerDefinition, $17bb01acf9d17ae5$export$240b20df485e8ed6) && (0, $5mLYn.has)(lexerDefinition, $17bb01acf9d17ae5$export$d9dae51ac155a903) && !(0, $5mLYn.has)(lexerDefinition.modes, lexerDefinition.defaultMode)) errors.push({
        message: "A MultiMode Lexer cannot be initialized with a " + $17bb01acf9d17ae5$export$d9dae51ac155a903 + ": <" + lexerDefinition.defaultMode + ">" + "which does not exist\n",
        type: (0, $eSJX3.LexerDefinitionErrorType).MULTI_MODE_LEXER_DEFAULT_MODE_VALUE_DOES_NOT_EXIST
    });
    if ((0, $5mLYn.has)(lexerDefinition, $17bb01acf9d17ae5$export$240b20df485e8ed6)) (0, $5mLYn.forEach)(lexerDefinition.modes, function(currModeValue, currModeName) {
        (0, $5mLYn.forEach)(currModeValue, function(currTokType, currIdx) {
            if ((0, $5mLYn.isUndefined)(currTokType)) errors.push({
                message: "A Lexer cannot be initialized using an undefined Token Type. Mode:" + ("<" + currModeName + "> at index: <" + currIdx + ">\n"),
                type: (0, $eSJX3.LexerDefinitionErrorType).LEXER_DEFINITION_CANNOT_CONTAIN_UNDEFINED
            });
        });
    });
    return errors;
}
function $17bb01acf9d17ae5$export$6bf002249f609a38(lexerDefinition, trackLines, lineTerminatorCharacters) {
    var warnings = [];
    var hasAnyLineBreak = false;
    var allTokenTypes = (0, $5mLYn.compact)((0, $5mLYn.flatten)((0, $5mLYn.mapValues)(lexerDefinition.modes, function(tokTypes) {
        return tokTypes;
    })));
    var concreteTokenTypes = (0, $5mLYn.reject)(allTokenTypes, function(currType) {
        return currType[$17bb01acf9d17ae5$var$PATTERN] === (0, $eSJX3.Lexer).NA;
    });
    var terminatorCharCodes = $17bb01acf9d17ae5$var$getCharCodes(lineTerminatorCharacters);
    if (trackLines) (0, $5mLYn.forEach)(concreteTokenTypes, function(tokType) {
        var currIssue = $17bb01acf9d17ae5$var$checkLineBreaksIssues(tokType, terminatorCharCodes);
        if (currIssue !== false) {
            var message = $17bb01acf9d17ae5$export$fd9ce2a1328bc81b(tokType, currIssue);
            var warningDescriptor = {
                message: message,
                type: currIssue.issue,
                tokenType: tokType
            };
            warnings.push(warningDescriptor);
        } else {
            // we don't want to attempt to scan if the user explicitly specified the line_breaks option.
            if ((0, $5mLYn.has)(tokType, "LINE_BREAKS")) {
                if (tokType.LINE_BREAKS === true) hasAnyLineBreak = true;
            } else if ((0, $kdIKl.canMatchCharCode)(terminatorCharCodes, tokType.PATTERN)) hasAnyLineBreak = true;
        }
    });
    if (trackLines && !hasAnyLineBreak) warnings.push({
        message: "Warning: No LINE_BREAKS Found.\n	This Lexer has been defined to track line and column information,\n	But none of the Token Types can be identified as matching a line terminator.\n	See https://sap.github.io/chevrotain/docs/guide/resolving_lexer_errors.html#LINE_BREAKS \n	for details.",
        type: (0, $eSJX3.LexerDefinitionErrorType).NO_LINE_BREAKS_FLAGS
    });
    return warnings;
}
function $17bb01acf9d17ae5$export$4425dc103ce72034(emptyGroups) {
    var clonedResult = {};
    var groupKeys = (0, $5mLYn.keys)(emptyGroups);
    (0, $5mLYn.forEach)(groupKeys, function(currKey) {
        var currGroupValue = emptyGroups[currKey];
        /* istanbul ignore else */ if ((0, $5mLYn.isArray)(currGroupValue)) clonedResult[currKey] = [];
        else throw Error("non exhaustive match");
    });
    return clonedResult;
}
function $17bb01acf9d17ae5$export$26136b6f4ec31c52(tokenType) {
    var pattern = tokenType.PATTERN;
    /* istanbul ignore else */ if ((0, $5mLYn.isRegExp)(pattern)) return false;
    else if ((0, $5mLYn.isFunction)(pattern)) // CustomPatternMatcherFunc - custom patterns do not require any transformations, only wrapping in a RegExp Like object
    return true;
    else if ((0, $5mLYn.has)(pattern, "exec")) // ICustomPattern
    return true;
    else if ((0, $5mLYn.isString)(pattern)) return false;
    else throw Error("non exhaustive match");
}
function $17bb01acf9d17ae5$export$f60842fb9057d787(pattern) {
    if ((0, $5mLYn.isString)(pattern) && pattern.length === 1) return pattern.charCodeAt(0);
    else return false;
}
var $17bb01acf9d17ae5$export$1206eb2ecfb4b09a = {
    // implements /\n|\r\n?/g.test
    test: function(text) {
        var len = text.length;
        for(var i = this.lastIndex; i < len; i++){
            var c = text.charCodeAt(i);
            if (c === 10) {
                this.lastIndex = i + 1;
                return true;
            } else if (c === 13) {
                if (text.charCodeAt(i + 1) === 10) this.lastIndex = i + 2;
                else this.lastIndex = i + 1;
                return true;
            }
        }
        return false;
    },
    lastIndex: 0
};
function $17bb01acf9d17ae5$var$checkLineBreaksIssues(tokType, lineTerminatorCharCodes) {
    if ((0, $5mLYn.has)(tokType, "LINE_BREAKS")) // if the user explicitly declared the line_breaks option we will respect their choice
    // and assume it is correct.
    return false;
    else {
        /* istanbul ignore else */ if ((0, $5mLYn.isRegExp)(tokType.PATTERN)) {
            try {
                (0, $kdIKl.canMatchCharCode)(lineTerminatorCharCodes, tokType.PATTERN);
            } catch (e) {
                /* istanbul ignore next - to test this we would have to mock <canMatchCharCode> to throw an error */ return {
                    issue: (0, $eSJX3.LexerDefinitionErrorType).IDENTIFY_TERMINATOR,
                    errMsg: e.message
                };
            }
            return false;
        } else if ((0, $5mLYn.isString)(tokType.PATTERN)) // string literal patterns can always be analyzed to detect line terminator usage
        return false;
        else if ($17bb01acf9d17ae5$export$26136b6f4ec31c52(tokType)) // custom token types
        return {
            issue: (0, $eSJX3.LexerDefinitionErrorType).CUSTOM_LINE_BREAK
        };
        else throw Error("non exhaustive match");
    }
}
function $17bb01acf9d17ae5$export$fd9ce2a1328bc81b(tokType, details) {
    /* istanbul ignore else */ if (details.issue === (0, $eSJX3.LexerDefinitionErrorType).IDENTIFY_TERMINATOR) return "Warning: unable to identify line terminator usage in pattern.\n" + ("	The problem is in the <" + tokType.name + "> Token Type\n") + ("	 Root cause: " + details.errMsg + ".\n") + "	For details See: https://sap.github.io/chevrotain/docs/guide/resolving_lexer_errors.html#IDENTIFY_TERMINATOR";
    else if (details.issue === (0, $eSJX3.LexerDefinitionErrorType).CUSTOM_LINE_BREAK) return "Warning: A Custom Token Pattern should specify the <line_breaks> option.\n" + ("	The problem is in the <" + tokType.name + "> Token Type\n") + "	For details See: https://sap.github.io/chevrotain/docs/guide/resolving_lexer_errors.html#CUSTOM_LINE_BREAK";
    else throw Error("non exhaustive match");
}
function $17bb01acf9d17ae5$var$getCharCodes(charsOrCodes) {
    var charCodes = (0, $5mLYn.map)(charsOrCodes, function(numOrString) {
        if ((0, $5mLYn.isString)(numOrString) && numOrString.length > 0) return numOrString.charCodeAt(0);
        else return numOrString;
    });
    return charCodes;
}
function $17bb01acf9d17ae5$var$addToMapOfArrays(map, key, value) {
    if (map[key] === undefined) map[key] = [
        value
    ];
    else map[key].push(value);
}
var $17bb01acf9d17ae5$export$ceaf0243db5272bd = 256;
function $17bb01acf9d17ae5$export$6e0cad6ebae9f8f9(charCode) {
    return charCode < $17bb01acf9d17ae5$export$ceaf0243db5272bd ? charCode : $17bb01acf9d17ae5$var$charCodeToOptimizedIdxMap[charCode];
}
/**
 * This is a compromise between cold start / hot running performance
 * Creating this array takes ~3ms on a modern machine,
 * But if we perform the computation at runtime as needed the CSS Lexer benchmark
 * performance degrades by ~10%
 *
 * TODO: Perhaps it should be lazy initialized only if a charCode > 255 is used.
 */ var $17bb01acf9d17ae5$var$charCodeToOptimizedIdxMap = [];
function $17bb01acf9d17ae5$var$initCharCodeToOptimizedIndexMap() {
    if ((0, $5mLYn.isEmpty)($17bb01acf9d17ae5$var$charCodeToOptimizedIdxMap)) {
        $17bb01acf9d17ae5$var$charCodeToOptimizedIdxMap = new Array(65536);
        for(var i = 0; i < 65536; i++)/* tslint:disable */ $17bb01acf9d17ae5$var$charCodeToOptimizedIdxMap[i] = i > 255 ? 255 + ~~(i / 255) : i;
    }
}

});
parcelRegister("dKV4H", function(module, exports) {
(function(root, factory) {
    // istanbul ignore next
    if (typeof define === "function" && define.amd) // istanbul ignore next
    define([], factory);
    else if (0, module.exports) module.exports = factory();
    else // istanbul ignore next
    root.regexpToAst = factory();
})(typeof self !== "undefined" ? self : module.exports, function() {
    // references
    // https://hackernoon.com/the-madness-of-parsing-real-world-javascript-regexps-d9ee336df983
    // https://www.ecma-international.org/ecma-262/8.0/index.html#prod-Pattern
    function RegExpParser() {}
    RegExpParser.prototype.saveState = function() {
        return {
            idx: this.idx,
            input: this.input,
            groupIdx: this.groupIdx
        };
    };
    RegExpParser.prototype.restoreState = function(newState) {
        this.idx = newState.idx;
        this.input = newState.input;
        this.groupIdx = newState.groupIdx;
    };
    RegExpParser.prototype.pattern = function(input) {
        // parser state
        this.idx = 0;
        this.input = input;
        this.groupIdx = 0;
        this.consumeChar("/");
        var value = this.disjunction();
        this.consumeChar("/");
        var flags = {
            type: "Flags",
            loc: {
                begin: this.idx,
                end: input.length
            },
            global: false,
            ignoreCase: false,
            multiLine: false,
            unicode: false,
            sticky: false
        };
        while(this.isRegExpFlag())switch(this.popChar()){
            case "g":
                addFlag(flags, "global");
                break;
            case "i":
                addFlag(flags, "ignoreCase");
                break;
            case "m":
                addFlag(flags, "multiLine");
                break;
            case "u":
                addFlag(flags, "unicode");
                break;
            case "y":
                addFlag(flags, "sticky");
                break;
        }
        if (this.idx !== this.input.length) throw Error("Redundant input: " + this.input.substring(this.idx));
        return {
            type: "Pattern",
            flags: flags,
            value: value,
            loc: this.loc(0)
        };
    };
    RegExpParser.prototype.disjunction = function() {
        var alts = [];
        var begin = this.idx;
        alts.push(this.alternative());
        while(this.peekChar() === "|"){
            this.consumeChar("|");
            alts.push(this.alternative());
        }
        return {
            type: "Disjunction",
            value: alts,
            loc: this.loc(begin)
        };
    };
    RegExpParser.prototype.alternative = function() {
        var terms = [];
        var begin = this.idx;
        while(this.isTerm())terms.push(this.term());
        return {
            type: "Alternative",
            value: terms,
            loc: this.loc(begin)
        };
    };
    RegExpParser.prototype.term = function() {
        if (this.isAssertion()) return this.assertion();
        else return this.atom();
    };
    RegExpParser.prototype.assertion = function() {
        var begin = this.idx;
        switch(this.popChar()){
            case "^":
                return {
                    type: "StartAnchor",
                    loc: this.loc(begin)
                };
            case "$":
                return {
                    type: "EndAnchor",
                    loc: this.loc(begin)
                };
            // '\b' or '\B'
            case "\\":
                switch(this.popChar()){
                    case "b":
                        return {
                            type: "WordBoundary",
                            loc: this.loc(begin)
                        };
                    case "B":
                        return {
                            type: "NonWordBoundary",
                            loc: this.loc(begin)
                        };
                }
                // istanbul ignore next
                throw Error("Invalid Assertion Escape");
            // '(?=' or '(?!'
            case "(":
                this.consumeChar("?");
                var type;
                switch(this.popChar()){
                    case "=":
                        type = "Lookahead";
                        break;
                    case "!":
                        type = "NegativeLookahead";
                        break;
                }
                ASSERT_EXISTS(type);
                var disjunction = this.disjunction();
                this.consumeChar(")");
                return {
                    type: type,
                    value: disjunction,
                    loc: this.loc(begin)
                };
        }
        // istanbul ignore next
        ASSERT_NEVER_REACH_HERE();
    };
    RegExpParser.prototype.quantifier = function(isBacktracking) {
        var range;
        var begin = this.idx;
        switch(this.popChar()){
            case "*":
                range = {
                    atLeast: 0,
                    atMost: Infinity
                };
                break;
            case "+":
                range = {
                    atLeast: 1,
                    atMost: Infinity
                };
                break;
            case "?":
                range = {
                    atLeast: 0,
                    atMost: 1
                };
                break;
            case "{":
                var atLeast = this.integerIncludingZero();
                switch(this.popChar()){
                    case "}":
                        range = {
                            atLeast: atLeast,
                            atMost: atLeast
                        };
                        break;
                    case ",":
                        var atMost;
                        if (this.isDigit()) {
                            atMost = this.integerIncludingZero();
                            range = {
                                atLeast: atLeast,
                                atMost: atMost
                            };
                        } else range = {
                            atLeast: atLeast,
                            atMost: Infinity
                        };
                        this.consumeChar("}");
                        break;
                }
                // throwing exceptions from "ASSERT_EXISTS" during backtracking
                // causes severe performance degradations
                if (isBacktracking === true && range === undefined) return undefined;
                ASSERT_EXISTS(range);
                break;
        }
        // throwing exceptions from "ASSERT_EXISTS" during backtracking
        // causes severe performance degradations
        if (isBacktracking === true && range === undefined) return undefined;
        ASSERT_EXISTS(range);
        if (this.peekChar(0) === "?") {
            this.consumeChar("?");
            range.greedy = false;
        } else range.greedy = true;
        range.type = "Quantifier";
        range.loc = this.loc(begin);
        return range;
    };
    RegExpParser.prototype.atom = function() {
        var atom;
        var begin = this.idx;
        switch(this.peekChar()){
            case ".":
                atom = this.dotAll();
                break;
            case "\\":
                atom = this.atomEscape();
                break;
            case "[":
                atom = this.characterClass();
                break;
            case "(":
                atom = this.group();
                break;
        }
        if (atom === undefined && this.isPatternCharacter()) atom = this.patternCharacter();
        ASSERT_EXISTS(atom);
        atom.loc = this.loc(begin);
        if (this.isQuantifier()) atom.quantifier = this.quantifier();
        return atom;
    };
    RegExpParser.prototype.dotAll = function() {
        this.consumeChar(".");
        return {
            type: "Set",
            complement: true,
            value: [
                cc("\n"),
                cc("\r"),
                cc("\u2028"),
                cc("\u2029")
            ]
        };
    };
    RegExpParser.prototype.atomEscape = function() {
        this.consumeChar("\\");
        switch(this.peekChar()){
            case "1":
            case "2":
            case "3":
            case "4":
            case "5":
            case "6":
            case "7":
            case "8":
            case "9":
                return this.decimalEscapeAtom();
            case "d":
            case "D":
            case "s":
            case "S":
            case "w":
            case "W":
                return this.characterClassEscape();
            case "f":
            case "n":
            case "r":
            case "t":
            case "v":
                return this.controlEscapeAtom();
            case "c":
                return this.controlLetterEscapeAtom();
            case "0":
                return this.nulCharacterAtom();
            case "x":
                return this.hexEscapeSequenceAtom();
            case "u":
                return this.regExpUnicodeEscapeSequenceAtom();
            default:
                return this.identityEscapeAtom();
        }
    };
    RegExpParser.prototype.decimalEscapeAtom = function() {
        var value = this.positiveInteger();
        return {
            type: "GroupBackReference",
            value: value
        };
    };
    RegExpParser.prototype.characterClassEscape = function() {
        var set;
        var complement = false;
        switch(this.popChar()){
            case "d":
                set = digitsCharCodes;
                break;
            case "D":
                set = digitsCharCodes;
                complement = true;
                break;
            case "s":
                set = whitespaceCodes;
                break;
            case "S":
                set = whitespaceCodes;
                complement = true;
                break;
            case "w":
                set = wordCharCodes;
                break;
            case "W":
                set = wordCharCodes;
                complement = true;
                break;
        }
        ASSERT_EXISTS(set);
        return {
            type: "Set",
            value: set,
            complement: complement
        };
    };
    RegExpParser.prototype.controlEscapeAtom = function() {
        var escapeCode;
        switch(this.popChar()){
            case "f":
                escapeCode = cc("\f");
                break;
            case "n":
                escapeCode = cc("\n");
                break;
            case "r":
                escapeCode = cc("\r");
                break;
            case "t":
                escapeCode = cc("	");
                break;
            case "v":
                escapeCode = cc("\v");
                break;
        }
        ASSERT_EXISTS(escapeCode);
        return {
            type: "Character",
            value: escapeCode
        };
    };
    RegExpParser.prototype.controlLetterEscapeAtom = function() {
        this.consumeChar("c");
        var letter = this.popChar();
        if (/[a-zA-Z]/.test(letter) === false) throw Error("Invalid ");
        var letterCode = letter.toUpperCase().charCodeAt(0) - 64;
        return {
            type: "Character",
            value: letterCode
        };
    };
    RegExpParser.prototype.nulCharacterAtom = function() {
        // TODO implement '[lookahead ∉ DecimalDigit]'
        // TODO: for the deprecated octal escape sequence
        this.consumeChar("0");
        return {
            type: "Character",
            value: cc("\0")
        };
    };
    RegExpParser.prototype.hexEscapeSequenceAtom = function() {
        this.consumeChar("x");
        return this.parseHexDigits(2);
    };
    RegExpParser.prototype.regExpUnicodeEscapeSequenceAtom = function() {
        this.consumeChar("u");
        return this.parseHexDigits(4);
    };
    RegExpParser.prototype.identityEscapeAtom = function() {
        // TODO: implement "SourceCharacter but not UnicodeIDContinue"
        // // http://unicode.org/reports/tr31/#Specific_Character_Adjustments
        var escapedChar = this.popChar();
        return {
            type: "Character",
            value: cc(escapedChar)
        };
    };
    RegExpParser.prototype.classPatternCharacterAtom = function() {
        switch(this.peekChar()){
            // istanbul ignore next
            case "\n":
            // istanbul ignore next
            case "\r":
            // istanbul ignore next
            case "\u2028":
            // istanbul ignore next
            case "\u2029":
            // istanbul ignore next
            case "\\":
            // istanbul ignore next
            case "]":
                throw Error("TBD");
            default:
                var nextChar = this.popChar();
                return {
                    type: "Character",
                    value: cc(nextChar)
                };
        }
    };
    RegExpParser.prototype.characterClass = function() {
        var set = [];
        var complement = false;
        this.consumeChar("[");
        if (this.peekChar(0) === "^") {
            this.consumeChar("^");
            complement = true;
        }
        while(this.isClassAtom()){
            var from = this.classAtom();
            var isFromSingleChar = from.type === "Character";
            if (isFromSingleChar && this.isRangeDash()) {
                this.consumeChar("-");
                var to = this.classAtom();
                var isToSingleChar = to.type === "Character";
                // a range can only be used when both sides are single characters
                if (isToSingleChar) {
                    if (to.value < from.value) throw Error("Range out of order in character class");
                    set.push({
                        from: from.value,
                        to: to.value
                    });
                } else {
                    // literal dash
                    insertToSet(from.value, set);
                    set.push(cc("-"));
                    insertToSet(to.value, set);
                }
            } else insertToSet(from.value, set);
        }
        this.consumeChar("]");
        return {
            type: "Set",
            complement: complement,
            value: set
        };
    };
    RegExpParser.prototype.classAtom = function() {
        switch(this.peekChar()){
            // istanbul ignore next
            case "]":
            // istanbul ignore next
            case "\n":
            // istanbul ignore next
            case "\r":
            // istanbul ignore next
            case "\u2028":
            // istanbul ignore next
            case "\u2029":
                throw Error("TBD");
            case "\\":
                return this.classEscape();
            default:
                return this.classPatternCharacterAtom();
        }
    };
    RegExpParser.prototype.classEscape = function() {
        this.consumeChar("\\");
        switch(this.peekChar()){
            // Matches a backspace.
            // (Not to be confused with \b word boundary outside characterClass)
            case "b":
                this.consumeChar("b");
                return {
                    type: "Character",
                    value: cc("\b")
                };
            case "d":
            case "D":
            case "s":
            case "S":
            case "w":
            case "W":
                return this.characterClassEscape();
            case "f":
            case "n":
            case "r":
            case "t":
            case "v":
                return this.controlEscapeAtom();
            case "c":
                return this.controlLetterEscapeAtom();
            case "0":
                return this.nulCharacterAtom();
            case "x":
                return this.hexEscapeSequenceAtom();
            case "u":
                return this.regExpUnicodeEscapeSequenceAtom();
            default:
                return this.identityEscapeAtom();
        }
    };
    RegExpParser.prototype.group = function() {
        var capturing = true;
        this.consumeChar("(");
        switch(this.peekChar(0)){
            case "?":
                this.consumeChar("?");
                this.consumeChar(":");
                capturing = false;
                break;
            default:
                this.groupIdx++;
                break;
        }
        var value = this.disjunction();
        this.consumeChar(")");
        var groupAst = {
            type: "Group",
            capturing: capturing,
            value: value
        };
        if (capturing) groupAst.idx = this.groupIdx;
        return groupAst;
    };
    RegExpParser.prototype.positiveInteger = function() {
        var number = this.popChar();
        // istanbul ignore next - can't ever get here due to previous lookahead checks
        // still implementing this error checking in case this ever changes.
        if (decimalPatternNoZero.test(number) === false) throw Error("Expecting a positive integer");
        while(decimalPattern.test(this.peekChar(0)))number += this.popChar();
        return parseInt(number, 10);
    };
    RegExpParser.prototype.integerIncludingZero = function() {
        var number = this.popChar();
        if (decimalPattern.test(number) === false) throw Error("Expecting an integer");
        while(decimalPattern.test(this.peekChar(0)))number += this.popChar();
        return parseInt(number, 10);
    };
    RegExpParser.prototype.patternCharacter = function() {
        var nextChar = this.popChar();
        switch(nextChar){
            // istanbul ignore next
            case "\n":
            // istanbul ignore next
            case "\r":
            // istanbul ignore next
            case "\u2028":
            // istanbul ignore next
            case "\u2029":
            // istanbul ignore next
            case "^":
            // istanbul ignore next
            case "$":
            // istanbul ignore next
            case "\\":
            // istanbul ignore next
            case ".":
            // istanbul ignore next
            case "*":
            // istanbul ignore next
            case "+":
            // istanbul ignore next
            case "?":
            // istanbul ignore next
            case "(":
            // istanbul ignore next
            case ")":
            // istanbul ignore next
            case "[":
            // istanbul ignore next
            case "|":
                // istanbul ignore next
                throw Error("TBD");
            default:
                return {
                    type: "Character",
                    value: cc(nextChar)
                };
        }
    };
    RegExpParser.prototype.isRegExpFlag = function() {
        switch(this.peekChar(0)){
            case "g":
            case "i":
            case "m":
            case "u":
            case "y":
                return true;
            default:
                return false;
        }
    };
    RegExpParser.prototype.isRangeDash = function() {
        return this.peekChar() === "-" && this.isClassAtom(1);
    };
    RegExpParser.prototype.isDigit = function() {
        return decimalPattern.test(this.peekChar(0));
    };
    RegExpParser.prototype.isClassAtom = function(howMuch) {
        if (howMuch === undefined) howMuch = 0;
        switch(this.peekChar(howMuch)){
            case "]":
            case "\n":
            case "\r":
            case "\u2028":
            case "\u2029":
                return false;
            default:
                return true;
        }
    };
    RegExpParser.prototype.isTerm = function() {
        return this.isAtom() || this.isAssertion();
    };
    RegExpParser.prototype.isAtom = function() {
        if (this.isPatternCharacter()) return true;
        switch(this.peekChar(0)){
            case ".":
            case "\\":
            case "[":
            // TODO: isAtom must be called before isAssertion - disambiguate
            case "(":
                return true;
            default:
                return false;
        }
    };
    RegExpParser.prototype.isAssertion = function() {
        switch(this.peekChar(0)){
            case "^":
            case "$":
                return true;
            // '\b' or '\B'
            case "\\":
                switch(this.peekChar(1)){
                    case "b":
                    case "B":
                        return true;
                    default:
                        return false;
                }
            // '(?=' or '(?!'
            case "(":
                return this.peekChar(1) === "?" && (this.peekChar(2) === "=" || this.peekChar(2) === "!");
            default:
                return false;
        }
    };
    RegExpParser.prototype.isQuantifier = function() {
        var prevState = this.saveState();
        try {
            return this.quantifier(true) !== undefined;
        } catch (e) {
            return false;
        } finally{
            this.restoreState(prevState);
        }
    };
    RegExpParser.prototype.isPatternCharacter = function() {
        switch(this.peekChar()){
            case "^":
            case "$":
            case "\\":
            case ".":
            case "*":
            case "+":
            case "?":
            case "(":
            case ")":
            case "[":
            case "|":
            case "/":
            case "\n":
            case "\r":
            case "\u2028":
            case "\u2029":
                return false;
            default:
                return true;
        }
    };
    RegExpParser.prototype.parseHexDigits = function(howMany) {
        var hexString = "";
        for(var i = 0; i < howMany; i++){
            var hexChar = this.popChar();
            if (hexDigitPattern.test(hexChar) === false) throw Error("Expecting a HexDecimal digits");
            hexString += hexChar;
        }
        var charCode = parseInt(hexString, 16);
        return {
            type: "Character",
            value: charCode
        };
    };
    RegExpParser.prototype.peekChar = function(howMuch) {
        if (howMuch === undefined) howMuch = 0;
        return this.input[this.idx + howMuch];
    };
    RegExpParser.prototype.popChar = function() {
        var nextChar = this.peekChar(0);
        this.consumeChar();
        return nextChar;
    };
    RegExpParser.prototype.consumeChar = function(char) {
        if (char !== undefined && this.input[this.idx] !== char) throw Error("Expected: '" + char + "' but found: '" + this.input[this.idx] + "' at offset: " + this.idx);
        if (this.idx >= this.input.length) throw Error("Unexpected end of input");
        this.idx++;
    };
    RegExpParser.prototype.loc = function(begin) {
        return {
            begin: begin,
            end: this.idx
        };
    };
    // consts and utilities
    var hexDigitPattern = /[0-9a-fA-F]/;
    var decimalPattern = /[0-9]/;
    var decimalPatternNoZero = /[1-9]/;
    function cc(char) {
        return char.charCodeAt(0);
    }
    function insertToSet(item, set) {
        if (item.length !== undefined) item.forEach(function(subItem) {
            set.push(subItem);
        });
        else set.push(item);
    }
    function addFlag(flagObj, flagKey) {
        if (flagObj[flagKey] === true) throw "duplicate flag " + flagKey;
        flagObj[flagKey] = true;
    }
    function ASSERT_EXISTS(obj) {
        // istanbul ignore next
        if (obj === undefined) throw Error("Internal Error - Should never get here!");
    }
    // istanbul ignore next
    function ASSERT_NEVER_REACH_HERE() {
        throw Error("Internal Error - Should never get here!");
    }
    var i;
    var digitsCharCodes = [];
    for(i = cc("0"); i <= cc("9"); i++)digitsCharCodes.push(i);
    var wordCharCodes = [
        cc("_")
    ].concat(digitsCharCodes);
    for(i = cc("a"); i <= cc("z"); i++)wordCharCodes.push(i);
    for(i = cc("A"); i <= cc("Z"); i++)wordCharCodes.push(i);
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp#character-classes
    var whitespaceCodes = [
        cc(" "),
        cc("\f"),
        cc("\n"),
        cc("\r"),
        cc("	"),
        cc("\v"),
        cc("	"),
        cc("\xa0"),
        cc("\u1680"),
        cc("\u2000"),
        cc("\u2001"),
        cc("\u2002"),
        cc("\u2003"),
        cc("\u2004"),
        cc("\u2005"),
        cc("\u2006"),
        cc("\u2007"),
        cc("\u2008"),
        cc("\u2009"),
        cc("\u200A"),
        cc("\u2028"),
        cc("\u2029"),
        cc("\u202F"),
        cc("\u205F"),
        cc("\u3000"),
        cc("\uFEFF")
    ];
    function BaseRegExpVisitor() {}
    BaseRegExpVisitor.prototype.visitChildren = function(node) {
        for(var key in node){
            var child = node[key];
            /* istanbul ignore else */ if (node.hasOwnProperty(key)) {
                if (child.type !== undefined) this.visit(child);
                else if (Array.isArray(child)) child.forEach(function(subChild) {
                    this.visit(subChild);
                }, this);
            }
        }
    };
    BaseRegExpVisitor.prototype.visit = function(node) {
        switch(node.type){
            case "Pattern":
                this.visitPattern(node);
                break;
            case "Flags":
                this.visitFlags(node);
                break;
            case "Disjunction":
                this.visitDisjunction(node);
                break;
            case "Alternative":
                this.visitAlternative(node);
                break;
            case "StartAnchor":
                this.visitStartAnchor(node);
                break;
            case "EndAnchor":
                this.visitEndAnchor(node);
                break;
            case "WordBoundary":
                this.visitWordBoundary(node);
                break;
            case "NonWordBoundary":
                this.visitNonWordBoundary(node);
                break;
            case "Lookahead":
                this.visitLookahead(node);
                break;
            case "NegativeLookahead":
                this.visitNegativeLookahead(node);
                break;
            case "Character":
                this.visitCharacter(node);
                break;
            case "Set":
                this.visitSet(node);
                break;
            case "Group":
                this.visitGroup(node);
                break;
            case "GroupBackReference":
                this.visitGroupBackReference(node);
                break;
            case "Quantifier":
                this.visitQuantifier(node);
                break;
        }
        this.visitChildren(node);
    };
    BaseRegExpVisitor.prototype.visitPattern = function(node) {};
    BaseRegExpVisitor.prototype.visitFlags = function(node) {};
    BaseRegExpVisitor.prototype.visitDisjunction = function(node) {};
    BaseRegExpVisitor.prototype.visitAlternative = function(node) {};
    // Assertion
    BaseRegExpVisitor.prototype.visitStartAnchor = function(node) {};
    BaseRegExpVisitor.prototype.visitEndAnchor = function(node) {};
    BaseRegExpVisitor.prototype.visitWordBoundary = function(node) {};
    BaseRegExpVisitor.prototype.visitNonWordBoundary = function(node) {};
    BaseRegExpVisitor.prototype.visitLookahead = function(node) {};
    BaseRegExpVisitor.prototype.visitNegativeLookahead = function(node) {};
    // atoms
    BaseRegExpVisitor.prototype.visitCharacter = function(node) {};
    BaseRegExpVisitor.prototype.visitSet = function(node) {};
    BaseRegExpVisitor.prototype.visitGroup = function(node) {};
    BaseRegExpVisitor.prototype.visitGroupBackReference = function(node) {};
    BaseRegExpVisitor.prototype.visitQuantifier = function(node) {};
    return {
        RegExpParser: RegExpParser,
        BaseRegExpVisitor: BaseRegExpVisitor,
        VERSION: "0.5.0"
    };
});

});

parcelRegister("kdIKl", function(module, exports) {

$parcel$export(module.exports, "failedOptimizationPrefixMsg", function () { return $eb87bb3f89c1b314$export$df1e84246e4ae4db; });
$parcel$export(module.exports, "getOptimizedStartCodesIndices", function () { return $eb87bb3f89c1b314$export$c502a69ec1694bcb; });
$parcel$export(module.exports, "canMatchCharCode", function () { return $eb87bb3f89c1b314$export$4232ea90df515a4a; });

var $dKV4H = parcelRequire("dKV4H");

var $5mLYn = parcelRequire("5mLYn");

var $8VuTk = parcelRequire("8VuTk");

var $22jE1 = parcelRequire("22jE1");
var $eb87bb3f89c1b314$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $eb87bb3f89c1b314$var$complementErrorMessage = "Complement Sets are not supported for first char optimization";
var $eb87bb3f89c1b314$export$df1e84246e4ae4db = 'Unable to use "first char" lexer optimizations:\n';
function $eb87bb3f89c1b314$export$c502a69ec1694bcb(regExp, ensureOptimizations) {
    if (ensureOptimizations === void 0) ensureOptimizations = false;
    try {
        var ast = (0, $8VuTk.getRegExpAst)(regExp);
        var firstChars = $eb87bb3f89c1b314$export$6b11132c058d07b4(ast.value, {}, ast.flags.ignoreCase);
        return firstChars;
    } catch (e) {
        /* istanbul ignore next */ // Testing this relies on the regexp-to-ast library having a bug... */
        // TODO: only the else branch needs to be ignored, try to fix with newer prettier / tsc
        if (e.message === $eb87bb3f89c1b314$var$complementErrorMessage) {
            if (ensureOptimizations) (0, $5mLYn.PRINT_WARNING)("" + $eb87bb3f89c1b314$export$df1e84246e4ae4db + ("	Unable to optimize: < " + regExp.toString() + " >\n") + "	Complement Sets cannot be automatically optimized.\n" + "	This will disable the lexer's first char optimizations.\n" + "	See: https://sap.github.io/chevrotain/docs/guide/resolving_lexer_errors.html#COMPLEMENT for details.");
        } else {
            var msgSuffix = "";
            if (ensureOptimizations) msgSuffix = "\n	This will disable the lexer's first char optimizations.\n	See: https://sap.github.io/chevrotain/docs/guide/resolving_lexer_errors.html#REGEXP_PARSING for details.";
            (0, $5mLYn.PRINT_ERROR)($eb87bb3f89c1b314$export$df1e84246e4ae4db + "\n" + ("	Failed parsing: < " + regExp.toString() + " >\n") + ("	Using the regexp-to-ast library version: " + (0, $dKV4H.VERSION) + "\n") + "	Please open an issue at: https://github.com/bd82/regexp-to-ast/issues" + msgSuffix);
        }
    }
    return [];
}
function $eb87bb3f89c1b314$export$6b11132c058d07b4(ast, result, ignoreCase) {
    switch(ast.type){
        case "Disjunction":
            for(var i = 0; i < ast.value.length; i++)$eb87bb3f89c1b314$export$6b11132c058d07b4(ast.value[i], result, ignoreCase);
            break;
        case "Alternative":
            var terms = ast.value;
            for(var i = 0; i < terms.length; i++){
                var term = terms[i];
                // skip terms that cannot effect the first char results
                switch(term.type){
                    case "EndAnchor":
                    // A group back reference cannot affect potential starting char.
                    // because if a back reference is the first production than automatically
                    // the group being referenced has had to come BEFORE so its codes have already been added
                    case "GroupBackReference":
                    // assertions do not affect potential starting codes
                    case "Lookahead":
                    case "NegativeLookahead":
                    case "StartAnchor":
                    case "WordBoundary":
                    case "NonWordBoundary":
                        continue;
                }
                var atom = term;
                switch(atom.type){
                    case "Character":
                        $eb87bb3f89c1b314$var$addOptimizedIdxToResult(atom.value, result, ignoreCase);
                        break;
                    case "Set":
                        if (atom.complement === true) throw Error($eb87bb3f89c1b314$var$complementErrorMessage);
                        (0, $5mLYn.forEach)(atom.value, function(code) {
                            if (typeof code === "number") $eb87bb3f89c1b314$var$addOptimizedIdxToResult(code, result, ignoreCase);
                            else {
                                // range
                                var range = code;
                                // cannot optimize when ignoreCase is
                                if (ignoreCase === true) for(var rangeCode = range.from; rangeCode <= range.to; rangeCode++)$eb87bb3f89c1b314$var$addOptimizedIdxToResult(rangeCode, result, ignoreCase);
                                else {
                                    // handle unoptimized values
                                    for(var rangeCode = range.from; rangeCode <= range.to && rangeCode < (0, $22jE1.minOptimizationVal); rangeCode++)$eb87bb3f89c1b314$var$addOptimizedIdxToResult(rangeCode, result, ignoreCase);
                                    // Less common charCode where we optimize for faster init time, by using larger "buckets"
                                    if (range.to >= (0, $22jE1.minOptimizationVal)) {
                                        var minUnOptVal = range.from >= (0, $22jE1.minOptimizationVal) ? range.from : (0, $22jE1.minOptimizationVal);
                                        var maxUnOptVal = range.to;
                                        var minOptIdx = (0, $22jE1.charCodeToOptimizedIndex)(minUnOptVal);
                                        var maxOptIdx = (0, $22jE1.charCodeToOptimizedIndex)(maxUnOptVal);
                                        for(var currOptIdx = minOptIdx; currOptIdx <= maxOptIdx; currOptIdx++)result[currOptIdx] = currOptIdx;
                                    }
                                }
                            }
                        });
                        break;
                    case "Group":
                        $eb87bb3f89c1b314$export$6b11132c058d07b4(atom.value, result, ignoreCase);
                        break;
                    /* istanbul ignore next */ default:
                        throw Error("Non Exhaustive Match");
                }
                // reached a mandatory production, no more **start** codes can be found on this alternative
                var isOptionalQuantifier = atom.quantifier !== undefined && atom.quantifier.atLeast === 0;
                if (// A group may be optional due to empty contents /(?:)/
                // or if everything inside it is optional /((a)?)/
                atom.type === "Group" && $eb87bb3f89c1b314$var$isWholeOptional(atom) === false || // If this term is not a group it may only be optional if it has an optional quantifier
                atom.type !== "Group" && isOptionalQuantifier === false) break;
            }
            break;
        /* istanbul ignore next */ default:
            throw Error("non exhaustive match!");
    }
    // console.log(Object.keys(result).length)
    return (0, $5mLYn.values)(result);
}
function $eb87bb3f89c1b314$var$addOptimizedIdxToResult(code, result, ignoreCase) {
    var optimizedCharIdx = (0, $22jE1.charCodeToOptimizedIndex)(code);
    result[optimizedCharIdx] = optimizedCharIdx;
    if (ignoreCase === true) $eb87bb3f89c1b314$var$handleIgnoreCase(code, result);
}
function $eb87bb3f89c1b314$var$handleIgnoreCase(code, result) {
    var char = String.fromCharCode(code);
    var upperChar = char.toUpperCase();
    /* istanbul ignore else */ if (upperChar !== char) {
        var optimizedCharIdx = (0, $22jE1.charCodeToOptimizedIndex)(upperChar.charCodeAt(0));
        result[optimizedCharIdx] = optimizedCharIdx;
    } else {
        var lowerChar = char.toLowerCase();
        if (lowerChar !== char) {
            var optimizedCharIdx = (0, $22jE1.charCodeToOptimizedIndex)(lowerChar.charCodeAt(0));
            result[optimizedCharIdx] = optimizedCharIdx;
        }
    }
}
function $eb87bb3f89c1b314$var$findCode(setNode, targetCharCodes) {
    return (0, $5mLYn.find)(setNode.value, function(codeOrRange) {
        if (typeof codeOrRange === "number") return (0, $5mLYn.contains)(targetCharCodes, codeOrRange);
        else {
            // range
            var range_1 = codeOrRange;
            return (0, $5mLYn.find)(targetCharCodes, function(targetCode) {
                return range_1.from <= targetCode && targetCode <= range_1.to;
            }) !== undefined;
        }
    });
}
function $eb87bb3f89c1b314$var$isWholeOptional(ast) {
    if (ast.quantifier && ast.quantifier.atLeast === 0) return true;
    if (!ast.value) return false;
    return (0, $5mLYn.isArray)(ast.value) ? (0, $5mLYn.every)(ast.value, $eb87bb3f89c1b314$var$isWholeOptional) : $eb87bb3f89c1b314$var$isWholeOptional(ast.value);
}
var $eb87bb3f89c1b314$var$CharCodeFinder = /** @class */ function(_super) {
    $eb87bb3f89c1b314$var$__extends(CharCodeFinder, _super);
    function CharCodeFinder(targetCharCodes) {
        var _this = _super.call(this) || this;
        _this.targetCharCodes = targetCharCodes;
        _this.found = false;
        return _this;
    }
    CharCodeFinder.prototype.visitChildren = function(node) {
        // No need to keep looking...
        if (this.found === true) return;
        // switch lookaheads as they do not actually consume any characters thus
        // finding a charCode at lookahead context does not mean that regexp can actually contain it in a match.
        switch(node.type){
            case "Lookahead":
                this.visitLookahead(node);
                return;
            case "NegativeLookahead":
                this.visitNegativeLookahead(node);
                return;
        }
        _super.prototype.visitChildren.call(this, node);
    };
    CharCodeFinder.prototype.visitCharacter = function(node) {
        if ((0, $5mLYn.contains)(this.targetCharCodes, node.value)) this.found = true;
    };
    CharCodeFinder.prototype.visitSet = function(node) {
        if (node.complement) {
            if ($eb87bb3f89c1b314$var$findCode(node, this.targetCharCodes) === undefined) this.found = true;
        } else if ($eb87bb3f89c1b314$var$findCode(node, this.targetCharCodes) !== undefined) this.found = true;
    };
    return CharCodeFinder;
}((0, $dKV4H.BaseRegExpVisitor));
function $eb87bb3f89c1b314$export$4232ea90df515a4a(charCodes, pattern) {
    if (pattern instanceof RegExp) {
        var ast = (0, $8VuTk.getRegExpAst)(pattern);
        var charCodeFinder = new $eb87bb3f89c1b314$var$CharCodeFinder(charCodes);
        charCodeFinder.visit(ast);
        return charCodeFinder.found;
    } else return (0, $5mLYn.find)(pattern, function(char) {
        return (0, $5mLYn.contains)(charCodes, char.charCodeAt(0));
    }) !== undefined;
}

});
parcelRegister("8VuTk", function(module, exports) {

$parcel$export(module.exports, "getRegExpAst", function () { return $67fb9bf6e190424b$export$50be48a73033349c; });
$parcel$export(module.exports, "clearRegExpParserCache", function () { return $67fb9bf6e190424b$export$b8fbfdba45dee7b0; });

var $dKV4H = parcelRequire("dKV4H");
var $67fb9bf6e190424b$var$regExpAstCache = {};
var $67fb9bf6e190424b$var$regExpParser = new (0, $dKV4H.RegExpParser)();
function $67fb9bf6e190424b$export$50be48a73033349c(regExp) {
    var regExpStr = regExp.toString();
    if ($67fb9bf6e190424b$var$regExpAstCache.hasOwnProperty(regExpStr)) return $67fb9bf6e190424b$var$regExpAstCache[regExpStr];
    else {
        var regExpAst = $67fb9bf6e190424b$var$regExpParser.pattern(regExpStr);
        $67fb9bf6e190424b$var$regExpAstCache[regExpStr] = regExpAst;
        return regExpAst;
    }
}
function $67fb9bf6e190424b$export$b8fbfdba45dee7b0() {
    $67fb9bf6e190424b$var$regExpAstCache = {};
}

});



parcelRegister("6UThq", function(module, exports) {

$parcel$export(module.exports, "tokenStructuredMatcher", function () { return $5092da80fe3ecaa9$export$686464bf8420255; });
$parcel$export(module.exports, "tokenStructuredMatcherNoCategories", function () { return $5092da80fe3ecaa9$export$5abbe597e4a1bdf7; });
$parcel$export(module.exports, "augmentTokenTypes", function () { return $5092da80fe3ecaa9$export$955be7ec22c9ac34; });
$parcel$export(module.exports, "hasShortKeyProperty", function () { return $5092da80fe3ecaa9$export$dc2744f58744bad4; });
$parcel$export(module.exports, "isTokenType", function () { return $5092da80fe3ecaa9$export$36383bed146b2313; });

var $5mLYn = parcelRequire("5mLYn");
function $5092da80fe3ecaa9$export$686464bf8420255(tokInstance, tokConstructor) {
    var instanceType = tokInstance.tokenTypeIdx;
    if (instanceType === tokConstructor.tokenTypeIdx) return true;
    else return tokConstructor.isParent === true && tokConstructor.categoryMatchesMap[instanceType] === true;
}
function $5092da80fe3ecaa9$export$5abbe597e4a1bdf7(token, tokType) {
    return token.tokenTypeIdx === tokType.tokenTypeIdx;
}
var $5092da80fe3ecaa9$export$395b206fdd37728a = 1;
var $5092da80fe3ecaa9$export$467bb054c7187fec = {};
function $5092da80fe3ecaa9$export$955be7ec22c9ac34(tokenTypes) {
    // collect the parent Token Types as well.
    var tokenTypesAndParents = $5092da80fe3ecaa9$export$23567c1f57268f82(tokenTypes);
    // add required tokenType and categoryMatches properties
    $5092da80fe3ecaa9$export$238194b034810c90(tokenTypesAndParents);
    // fill up the categoryMatches
    $5092da80fe3ecaa9$export$fa1de6b2c5a1edf0(tokenTypesAndParents);
    $5092da80fe3ecaa9$export$bf2452f100f9aab7(tokenTypesAndParents);
    (0, $5mLYn.forEach)(tokenTypesAndParents, function(tokType) {
        tokType.isParent = tokType.categoryMatches.length > 0;
    });
}
function $5092da80fe3ecaa9$export$23567c1f57268f82(tokenTypes) {
    var result = (0, $5mLYn.cloneArr)(tokenTypes);
    var categories = tokenTypes;
    var searching = true;
    while(searching){
        categories = (0, $5mLYn.compact)((0, $5mLYn.flatten)((0, $5mLYn.map)(categories, function(currTokType) {
            return currTokType.CATEGORIES;
        })));
        var newCategories = (0, $5mLYn.difference)(categories, result);
        result = result.concat(newCategories);
        if ((0, $5mLYn.isEmpty)(newCategories)) searching = false;
        else categories = newCategories;
    }
    return result;
}
function $5092da80fe3ecaa9$export$238194b034810c90(tokenTypes) {
    (0, $5mLYn.forEach)(tokenTypes, function(currTokType) {
        if (!$5092da80fe3ecaa9$export$dc2744f58744bad4(currTokType)) {
            $5092da80fe3ecaa9$export$467bb054c7187fec[$5092da80fe3ecaa9$export$395b206fdd37728a] = currTokType;
            currTokType.tokenTypeIdx = $5092da80fe3ecaa9$export$395b206fdd37728a++;
        }
        // CATEGORIES? : TokenType | TokenType[]
        if ($5092da80fe3ecaa9$export$5d888a38d6580350(currTokType) && !(0, $5mLYn.isArray)(currTokType.CATEGORIES)) currTokType.CATEGORIES = [
            currTokType.CATEGORIES
        ];
        if (!$5092da80fe3ecaa9$export$5d888a38d6580350(currTokType)) currTokType.CATEGORIES = [];
        if (!$5092da80fe3ecaa9$export$f5c14fb6b9efde64(currTokType)) currTokType.categoryMatches = [];
        if (!$5092da80fe3ecaa9$export$7e8f28e66dafe7c9(currTokType)) currTokType.categoryMatchesMap = {};
    });
}
function $5092da80fe3ecaa9$export$bf2452f100f9aab7(tokenTypes) {
    (0, $5mLYn.forEach)(tokenTypes, function(currTokType) {
        // avoid duplications
        currTokType.categoryMatches = [];
        (0, $5mLYn.forEach)(currTokType.categoryMatchesMap, function(val, key) {
            currTokType.categoryMatches.push($5092da80fe3ecaa9$export$467bb054c7187fec[key].tokenTypeIdx);
        });
    });
}
function $5092da80fe3ecaa9$export$fa1de6b2c5a1edf0(tokenTypes) {
    (0, $5mLYn.forEach)(tokenTypes, function(currTokType) {
        $5092da80fe3ecaa9$export$879d2c1e6d3a5f98([], currTokType);
    });
}
function $5092da80fe3ecaa9$export$879d2c1e6d3a5f98(path, nextNode) {
    (0, $5mLYn.forEach)(path, function(pathNode) {
        nextNode.categoryMatchesMap[pathNode.tokenTypeIdx] = true;
    });
    (0, $5mLYn.forEach)(nextNode.CATEGORIES, function(nextCategory) {
        var newPath = path.concat(nextNode);
        // avoids infinite loops due to cyclic categories.
        if (!(0, $5mLYn.contains)(newPath, nextCategory)) $5092da80fe3ecaa9$export$879d2c1e6d3a5f98(newPath, nextCategory);
    });
}
function $5092da80fe3ecaa9$export$dc2744f58744bad4(tokType) {
    return (0, $5mLYn.has)(tokType, "tokenTypeIdx");
}
function $5092da80fe3ecaa9$export$5d888a38d6580350(tokType) {
    return (0, $5mLYn.has)(tokType, "CATEGORIES");
}
function $5092da80fe3ecaa9$export$f5c14fb6b9efde64(tokType) {
    return (0, $5mLYn.has)(tokType, "categoryMatches");
}
function $5092da80fe3ecaa9$export$7e8f28e66dafe7c9(tokType) {
    return (0, $5mLYn.has)(tokType, "categoryMatchesMap");
}
function $5092da80fe3ecaa9$export$36383bed146b2313(tokType) {
    return (0, $5mLYn.has)(tokType, "tokenTypeIdx");
}

});

parcelRegister("lMxRC", function(module, exports) {

$parcel$export(module.exports, "defaultLexerErrorProvider", function () { return $fdb8594b20639737$export$cc067353be7648a1; });
var $fdb8594b20639737$export$cc067353be7648a1 = {
    buildUnableToPopLexerModeMessage: function(token) {
        return "Unable to pop Lexer Mode after encountering Token ->" + token.image + "<- The Mode Stack is empty";
    },
    buildUnexpectedCharactersMessage: function(fullText, startOffset, length, line, column) {
        return "unexpected character: ->" + fullText.charAt(startOffset) + "<- at offset: " + startOffset + "," + (" skipped " + length + " characters.");
    }
};

});





parcelRegister("6BL7Z", function(module, exports) {

$parcel$export(module.exports, "first", function () { return $013dd9d447f7dcfe$export$43128fadae87b74a; });

var $5mLYn = parcelRequire("5mLYn");

var $bbUHG = parcelRequire("bbUHG");

var $h6YGr = parcelRequire("h6YGr");
function $013dd9d447f7dcfe$export$43128fadae87b74a(prod) {
    /* istanbul ignore else */ if (prod instanceof (0, $bbUHG.NonTerminal)) // this could in theory cause infinite loops if
    // (1) prod A refs prod B.
    // (2) prod B refs prod A
    // (3) AB can match the empty set
    // in other words a cycle where everything is optional so the first will keep
    // looking ahead for the next optional part and will never exit
    // currently there is no safeguard for this unique edge case because
    // (1) not sure a grammar in which this can happen is useful for anything (productive)
    return $013dd9d447f7dcfe$export$43128fadae87b74a(prod.referencedRule);
    else if (prod instanceof (0, $bbUHG.Terminal)) return $013dd9d447f7dcfe$export$e93ebe8553f6b241(prod);
    else if ((0, $h6YGr.isSequenceProd)(prod)) return $013dd9d447f7dcfe$export$44c45f276472698d(prod);
    else if ((0, $h6YGr.isBranchingProd)(prod)) return $013dd9d447f7dcfe$export$1b934867e094f381(prod);
    else throw Error("non exhaustive match");
}
function $013dd9d447f7dcfe$export$44c45f276472698d(prod) {
    var firstSet = [];
    var seq = prod.definition;
    var nextSubProdIdx = 0;
    var hasInnerProdsRemaining = seq.length > nextSubProdIdx;
    var currSubProd;
    // so we enter the loop at least once (if the definition is not empty
    var isLastInnerProdOptional = true;
    // scan a sequence until it's end or until we have found a NONE optional production in it
    while(hasInnerProdsRemaining && isLastInnerProdOptional){
        currSubProd = seq[nextSubProdIdx];
        isLastInnerProdOptional = (0, $h6YGr.isOptionalProd)(currSubProd);
        firstSet = firstSet.concat($013dd9d447f7dcfe$export$43128fadae87b74a(currSubProd));
        nextSubProdIdx = nextSubProdIdx + 1;
        hasInnerProdsRemaining = seq.length > nextSubProdIdx;
    }
    return (0, $5mLYn.uniq)(firstSet);
}
function $013dd9d447f7dcfe$export$1b934867e094f381(prod) {
    var allAlternativesFirsts = (0, $5mLYn.map)(prod.definition, function(innerProd) {
        return $013dd9d447f7dcfe$export$43128fadae87b74a(innerProd);
    });
    return (0, $5mLYn.uniq)((0, $5mLYn.flatten)(allAlternativesFirsts));
}
function $013dd9d447f7dcfe$export$e93ebe8553f6b241(terminal) {
    return [
        terminal.terminalType
    ];
}

});
parcelRegister("h6YGr", function(module, exports) {

$parcel$export(module.exports, "isSequenceProd", function () { return $c75211b6f4716763$export$cdb2b3085a6955e4; });
$parcel$export(module.exports, "isOptionalProd", function () { return $c75211b6f4716763$export$bad7712845839105; });
$parcel$export(module.exports, "isBranchingProd", function () { return $c75211b6f4716763$export$e42ba85154874f03; });
$parcel$export(module.exports, "getProductionDslName", function () { return $c75211b6f4716763$export$cd39c9cff0f2b826; });
$parcel$export(module.exports, "DslMethodsCollectorVisitor", function () { return $c75211b6f4716763$export$822affdd0af4d161; });
$parcel$export(module.exports, "collectMethods", function () { return $c75211b6f4716763$export$5d61e03e5251fd41; });

var $5mLYn = parcelRequire("5mLYn");

var $bbUHG = parcelRequire("bbUHG");

var $1bKra = parcelRequire("1bKra");
var $c75211b6f4716763$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
function $c75211b6f4716763$export$cdb2b3085a6955e4(prod) {
    return prod instanceof (0, $bbUHG.Alternative) || prod instanceof (0, $bbUHG.Option) || prod instanceof (0, $bbUHG.Repetition) || prod instanceof (0, $bbUHG.RepetitionMandatory) || prod instanceof (0, $bbUHG.RepetitionMandatoryWithSeparator) || prod instanceof (0, $bbUHG.RepetitionWithSeparator) || prod instanceof (0, $bbUHG.Terminal) || prod instanceof (0, $bbUHG.Rule);
}
function $c75211b6f4716763$export$bad7712845839105(prod, alreadyVisited) {
    if (alreadyVisited === void 0) alreadyVisited = [];
    var isDirectlyOptional = prod instanceof (0, $bbUHG.Option) || prod instanceof (0, $bbUHG.Repetition) || prod instanceof (0, $bbUHG.RepetitionWithSeparator);
    if (isDirectlyOptional) return true;
    // note that this can cause infinite loop if one optional empty TOP production has a cyclic dependency with another
    // empty optional top rule
    // may be indirectly optional ((A?B?C?) | (D?E?F?))
    if (prod instanceof (0, $bbUHG.Alternation)) // for OR its enough for just one of the alternatives to be optional
    return (0, $5mLYn.some)(prod.definition, function(subProd) {
        return $c75211b6f4716763$export$bad7712845839105(subProd, alreadyVisited);
    });
    else if (prod instanceof (0, $bbUHG.NonTerminal) && (0, $5mLYn.contains)(alreadyVisited, prod)) // avoiding stack overflow due to infinite recursion
    return false;
    else if (prod instanceof (0, $bbUHG.AbstractProduction)) {
        if (prod instanceof (0, $bbUHG.NonTerminal)) alreadyVisited.push(prod);
        return (0, $5mLYn.every)(prod.definition, function(subProd) {
            return $c75211b6f4716763$export$bad7712845839105(subProd, alreadyVisited);
        });
    } else return false;
}
function $c75211b6f4716763$export$e42ba85154874f03(prod) {
    return prod instanceof (0, $bbUHG.Alternation);
}
function $c75211b6f4716763$export$cd39c9cff0f2b826(prod) {
    /* istanbul ignore else */ if (prod instanceof (0, $bbUHG.NonTerminal)) return "SUBRULE";
    else if (prod instanceof (0, $bbUHG.Option)) return "OPTION";
    else if (prod instanceof (0, $bbUHG.Alternation)) return "OR";
    else if (prod instanceof (0, $bbUHG.RepetitionMandatory)) return "AT_LEAST_ONE";
    else if (prod instanceof (0, $bbUHG.RepetitionMandatoryWithSeparator)) return "AT_LEAST_ONE_SEP";
    else if (prod instanceof (0, $bbUHG.RepetitionWithSeparator)) return "MANY_SEP";
    else if (prod instanceof (0, $bbUHG.Repetition)) return "MANY";
    else if (prod instanceof (0, $bbUHG.Terminal)) return "CONSUME";
    else throw Error("non exhaustive match");
}
var $c75211b6f4716763$export$822affdd0af4d161 = /** @class */ function(_super) {
    $c75211b6f4716763$var$__extends(DslMethodsCollectorVisitor, _super);
    function DslMethodsCollectorVisitor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // A minus is never valid in an identifier name
        _this.separator = "-";
        _this.dslMethods = {
            option: [],
            alternation: [],
            repetition: [],
            repetitionWithSeparator: [],
            repetitionMandatory: [],
            repetitionMandatoryWithSeparator: []
        };
        return _this;
    }
    DslMethodsCollectorVisitor.prototype.reset = function() {
        this.dslMethods = {
            option: [],
            alternation: [],
            repetition: [],
            repetitionWithSeparator: [],
            repetitionMandatory: [],
            repetitionMandatoryWithSeparator: []
        };
    };
    DslMethodsCollectorVisitor.prototype.visitTerminal = function(terminal) {
        var key = terminal.terminalType.name + this.separator + "Terminal";
        if (!(0, $5mLYn.has)(this.dslMethods, key)) this.dslMethods[key] = [];
        this.dslMethods[key].push(terminal);
    };
    DslMethodsCollectorVisitor.prototype.visitNonTerminal = function(subrule) {
        var key = subrule.nonTerminalName + this.separator + "Terminal";
        if (!(0, $5mLYn.has)(this.dslMethods, key)) this.dslMethods[key] = [];
        this.dslMethods[key].push(subrule);
    };
    DslMethodsCollectorVisitor.prototype.visitOption = function(option) {
        this.dslMethods.option.push(option);
    };
    DslMethodsCollectorVisitor.prototype.visitRepetitionWithSeparator = function(manySep) {
        this.dslMethods.repetitionWithSeparator.push(manySep);
    };
    DslMethodsCollectorVisitor.prototype.visitRepetitionMandatory = function(atLeastOne) {
        this.dslMethods.repetitionMandatory.push(atLeastOne);
    };
    DslMethodsCollectorVisitor.prototype.visitRepetitionMandatoryWithSeparator = function(atLeastOneSep) {
        this.dslMethods.repetitionMandatoryWithSeparator.push(atLeastOneSep);
    };
    DslMethodsCollectorVisitor.prototype.visitRepetition = function(many) {
        this.dslMethods.repetition.push(many);
    };
    DslMethodsCollectorVisitor.prototype.visitAlternation = function(or) {
        this.dslMethods.alternation.push(or);
    };
    return DslMethodsCollectorVisitor;
}((0, $1bKra.GAstVisitor));
var $c75211b6f4716763$var$collectorVisitor = new $c75211b6f4716763$export$822affdd0af4d161();
function $c75211b6f4716763$export$5d61e03e5251fd41(rule) {
    $c75211b6f4716763$var$collectorVisitor.reset();
    rule.accept($c75211b6f4716763$var$collectorVisitor);
    var dslMethods = $c75211b6f4716763$var$collectorVisitor.dslMethods;
    // avoid uncleaned references
    $c75211b6f4716763$var$collectorVisitor.reset();
    return dslMethods;
}

});
parcelRegister("1bKra", function(module, exports) {

$parcel$export(module.exports, "GAstVisitor", function () { return $0ddad6f611a99798$export$341eb7a348fb5523; });

var $bbUHG = parcelRequire("bbUHG");
var $0ddad6f611a99798$export$341eb7a348fb5523 = /** @class */ function() {
    function GAstVisitor() {}
    GAstVisitor.prototype.visit = function(node) {
        var nodeAny = node;
        switch(nodeAny.constructor){
            case 0, $bbUHG.NonTerminal:
                return this.visitNonTerminal(nodeAny);
            case 0, $bbUHG.Alternative:
                return this.visitAlternative(nodeAny);
            case 0, $bbUHG.Option:
                return this.visitOption(nodeAny);
            case 0, $bbUHG.RepetitionMandatory:
                return this.visitRepetitionMandatory(nodeAny);
            case 0, $bbUHG.RepetitionMandatoryWithSeparator:
                return this.visitRepetitionMandatoryWithSeparator(nodeAny);
            case 0, $bbUHG.RepetitionWithSeparator:
                return this.visitRepetitionWithSeparator(nodeAny);
            case 0, $bbUHG.Repetition:
                return this.visitRepetition(nodeAny);
            case 0, $bbUHG.Alternation:
                return this.visitAlternation(nodeAny);
            case 0, $bbUHG.Terminal:
                return this.visitTerminal(nodeAny);
            case 0, $bbUHG.Rule:
                return this.visitRule(nodeAny);
            /* istanbul ignore next */ default:
                throw Error("non exhaustive match");
        }
    };
    GAstVisitor.prototype.visitNonTerminal = function(node) {};
    GAstVisitor.prototype.visitAlternative = function(node) {};
    GAstVisitor.prototype.visitOption = function(node) {};
    GAstVisitor.prototype.visitRepetition = function(node) {};
    GAstVisitor.prototype.visitRepetitionMandatory = function(node) {};
    GAstVisitor.prototype.visitRepetitionMandatoryWithSeparator = function(node) {};
    GAstVisitor.prototype.visitRepetitionWithSeparator = function(node) {};
    GAstVisitor.prototype.visitAlternation = function(node) {};
    GAstVisitor.prototype.visitTerminal = function(node) {};
    GAstVisitor.prototype.visitRule = function(node) {};
    return GAstVisitor;
}();

});



parcelRegister("kWjNL", function(module, exports) {

$parcel$export(module.exports, "IN", function () { return $f3e89599a3f945f9$export$70824c8942178d60; });
// TODO: can this be removed? where is it used?
var $f3e89599a3f945f9$export$70824c8942178d60 = "_~IN~_";

});


parcelRegister("hUgka", function(module, exports) {

$parcel$export(module.exports, "defaultParserErrorProvider", function () { return $d094544b6278592a$export$d0949d751bf6767; });
$parcel$export(module.exports, "defaultGrammarResolverErrorProvider", function () { return $d094544b6278592a$export$d8f9d4fb962dde3d; });
$parcel$export(module.exports, "defaultGrammarValidatorErrorProvider", function () { return $d094544b6278592a$export$75f00ca3a6e740bd; });

var $hvAWv = parcelRequire("hvAWv");

var $5mLYn = parcelRequire("5mLYn");

var $bbUHG = parcelRequire("bbUHG");

var $h6YGr = parcelRequire("h6YGr");
var $d094544b6278592a$export$d0949d751bf6767 = {
    buildMismatchTokenMessage: function(_a) {
        var expected = _a.expected, actual = _a.actual, previous = _a.previous, ruleName = _a.ruleName;
        var hasLabel = (0, $hvAWv.hasTokenLabel)(expected);
        var expectedMsg = hasLabel ? "--> " + (0, $hvAWv.tokenLabel)(expected) + " <--" : "token of type --> " + expected.name + " <--";
        var msg = "Expecting " + expectedMsg + " but found --> '" + actual.image + "' <--";
        return msg;
    },
    buildNotAllInputParsedMessage: function(_a) {
        var firstRedundant = _a.firstRedundant, ruleName = _a.ruleName;
        return "Redundant input, expecting EOF but found: " + firstRedundant.image;
    },
    buildNoViableAltMessage: function(_a) {
        var expectedPathsPerAlt = _a.expectedPathsPerAlt, actual = _a.actual, previous = _a.previous, customUserDescription = _a.customUserDescription, ruleName = _a.ruleName;
        var errPrefix = "Expecting: ";
        // TODO: issue: No Viable Alternative Error may have incomplete details. #502
        var actualText = (0, $5mLYn.first)(actual).image;
        var errSuffix = "\nbut found: '" + actualText + "'";
        if (customUserDescription) return errPrefix + customUserDescription + errSuffix;
        else {
            var allLookAheadPaths = (0, $5mLYn.reduce)(expectedPathsPerAlt, function(result, currAltPaths) {
                return result.concat(currAltPaths);
            }, []);
            var nextValidTokenSequences = (0, $5mLYn.map)(allLookAheadPaths, function(currPath) {
                return "[" + (0, $5mLYn.map)(currPath, function(currTokenType) {
                    return (0, $hvAWv.tokenLabel)(currTokenType);
                }).join(", ") + "]";
            });
            var nextValidSequenceItems = (0, $5mLYn.map)(nextValidTokenSequences, function(itemMsg, idx) {
                return "  " + (idx + 1) + ". " + itemMsg;
            });
            var calculatedDescription = "one of these possible Token sequences:\n" + nextValidSequenceItems.join("\n");
            return errPrefix + calculatedDescription + errSuffix;
        }
    },
    buildEarlyExitMessage: function(_a) {
        var expectedIterationPaths = _a.expectedIterationPaths, actual = _a.actual, customUserDescription = _a.customUserDescription, ruleName = _a.ruleName;
        var errPrefix = "Expecting: ";
        // TODO: issue: No Viable Alternative Error may have incomplete details. #502
        var actualText = (0, $5mLYn.first)(actual).image;
        var errSuffix = "\nbut found: '" + actualText + "'";
        if (customUserDescription) return errPrefix + customUserDescription + errSuffix;
        else {
            var nextValidTokenSequences = (0, $5mLYn.map)(expectedIterationPaths, function(currPath) {
                return "[" + (0, $5mLYn.map)(currPath, function(currTokenType) {
                    return (0, $hvAWv.tokenLabel)(currTokenType);
                }).join(",") + "]";
            });
            var calculatedDescription = "expecting at least one iteration which starts with one of these possible Token sequences::\n  " + ("<" + nextValidTokenSequences.join(" ,") + ">");
            return errPrefix + calculatedDescription + errSuffix;
        }
    }
};
Object.freeze($d094544b6278592a$export$d0949d751bf6767);
var $d094544b6278592a$export$d8f9d4fb962dde3d = {
    buildRuleNotFoundError: function(topLevelRule, undefinedRule) {
        var msg = "Invalid grammar, reference to a rule which is not defined: ->" + undefinedRule.nonTerminalName + "<-\n" + "inside top level rule: ->" + topLevelRule.name + "<-";
        return msg;
    }
};
var $d094544b6278592a$export$75f00ca3a6e740bd = {
    buildDuplicateFoundError: function(topLevelRule, duplicateProds) {
        function getExtraProductionArgument(prod) {
            if (prod instanceof (0, $bbUHG.Terminal)) return prod.terminalType.name;
            else if (prod instanceof (0, $bbUHG.NonTerminal)) return prod.nonTerminalName;
            else return "";
        }
        var topLevelName = topLevelRule.name;
        var duplicateProd = (0, $5mLYn.first)(duplicateProds);
        var index = duplicateProd.idx;
        var dslName = (0, $h6YGr.getProductionDslName)(duplicateProd);
        var extraArgument = getExtraProductionArgument(duplicateProd);
        var hasExplicitIndex = index > 0;
        var msg = "->" + dslName + (hasExplicitIndex ? index : "") + "<- " + (extraArgument ? "with argument: ->" + extraArgument + "<-" : "") + "\n                  appears more than once (" + duplicateProds.length + " times) in the top level rule: ->" + topLevelName + "<-.                  \n                  For further details see: https://sap.github.io/chevrotain/docs/FAQ.html#NUMERICAL_SUFFIXES \n                  ";
        // white space trimming time! better to trim afterwards as it allows to use WELL formatted multi line template strings...
        msg = msg.replace(/[ \t]+/g, " ");
        msg = msg.replace(/\s\s+/g, "\n");
        return msg;
    },
    buildNamespaceConflictError: function(rule) {
        var errMsg = "Namespace conflict found in grammar.\n" + ("The grammar has both a Terminal(Token) and a Non-Terminal(Rule) named: <" + rule.name + ">.\n") + "To resolve this make sure each Terminal and Non-Terminal names are unique\n" + "This is easy to accomplish by using the convention that Terminal names start with an uppercase letter\n" + "and Non-Terminal names start with a lower case letter.";
        return errMsg;
    },
    buildAlternationPrefixAmbiguityError: function(options) {
        var pathMsg = (0, $5mLYn.map)(options.prefixPath, function(currTok) {
            return (0, $hvAWv.tokenLabel)(currTok);
        }).join(", ");
        var occurrence = options.alternation.idx === 0 ? "" : options.alternation.idx;
        var errMsg = "Ambiguous alternatives: <" + options.ambiguityIndices.join(" ,") + "> due to common lookahead prefix\n" + ("in <OR" + occurrence + "> inside <" + options.topLevelRule.name + "> Rule,\n") + ("<" + pathMsg + "> may appears as a prefix path in all these alternatives.\n") + "See: https://sap.github.io/chevrotain/docs/guide/resolving_grammar_errors.html#COMMON_PREFIX\n" + "For Further details.";
        return errMsg;
    },
    buildAlternationAmbiguityError: function(options) {
        var pathMsg = (0, $5mLYn.map)(options.prefixPath, function(currtok) {
            return (0, $hvAWv.tokenLabel)(currtok);
        }).join(", ");
        var occurrence = options.alternation.idx === 0 ? "" : options.alternation.idx;
        var currMessage = "Ambiguous Alternatives Detected: <" + options.ambiguityIndices.join(" ,") + "> in <OR" + occurrence + ">" + (" inside <" + options.topLevelRule.name + "> Rule,\n") + ("<" + pathMsg + "> may appears as a prefix path in all these alternatives.\n");
        currMessage = currMessage + "See: https://sap.github.io/chevrotain/docs/guide/resolving_grammar_errors.html#AMBIGUOUS_ALTERNATIVES\n" + "For Further details.";
        return currMessage;
    },
    buildEmptyRepetitionError: function(options) {
        var dslName = (0, $h6YGr.getProductionDslName)(options.repetition);
        if (options.repetition.idx !== 0) dslName += options.repetition.idx;
        var errMsg = "The repetition <" + dslName + "> within Rule <" + options.topLevelRule.name + "> can never consume any tokens.\n" + "This could lead to an infinite loop.";
        return errMsg;
    },
    // TODO: remove - `errors_public` from nyc.config.js exclude
    //       once this method is fully removed from this file
    buildTokenNameError: function(options) {
        /* istanbul ignore next */ return "deprecated";
    },
    buildEmptyAlternationError: function(options) {
        var errMsg = "Ambiguous empty alternative: <" + (options.emptyChoiceIdx + 1) + ">" + (" in <OR" + options.alternation.idx + "> inside <" + options.topLevelRule.name + "> Rule.\n") + "Only the last alternative may be an empty alternative.";
        return errMsg;
    },
    buildTooManyAlternativesError: function(options) {
        var errMsg = "An Alternation cannot have more than 256 alternatives:\n" + ("<OR" + options.alternation.idx + "> inside <" + options.topLevelRule.name + "> Rule.\n has " + (options.alternation.definition.length + 1) + " alternatives.");
        return errMsg;
    },
    buildLeftRecursionError: function(options) {
        var ruleName = options.topLevelRule.name;
        var pathNames = $5mLYn.map(options.leftRecursionPath, function(currRule) {
            return currRule.name;
        });
        var leftRecursivePath = ruleName + " --> " + pathNames.concat([
            ruleName
        ]).join(" --> ");
        var errMsg = "Left Recursion found in grammar.\n" + ("rule: <" + ruleName + "> can be invoked from itself (directly or indirectly)\n") + ("without consuming any Tokens. The grammar path that causes this is: \n " + leftRecursivePath + "\n") + " To fix this refactor your grammar to remove the left recursion.\n" + "see: https://en.wikipedia.org/wiki/LL_parser#Left_Factoring.";
        return errMsg;
    },
    // TODO: remove - `errors_public` from nyc.config.js exclude
    //       once this method is fully removed from this file
    buildInvalidRuleNameError: function(options) {
        /* istanbul ignore next */ return "deprecated";
    },
    buildDuplicateRuleNameError: function(options) {
        var ruleName;
        if (options.topLevelRule instanceof (0, $bbUHG.Rule)) ruleName = options.topLevelRule.name;
        else ruleName = options.topLevelRule;
        var errMsg = "Duplicate definition, rule: ->" + ruleName + "<- is already defined in the grammar: ->" + options.grammarName + "<-";
        return errMsg;
    }
};

});

parcelRegister("ciB86", function(module, exports) {

$parcel$export(module.exports, "resolveGrammar", function () { return $8f43f7adef563af4$export$6bc9296d22a119b7; });
$parcel$export(module.exports, "validateGrammar", function () { return $8f43f7adef563af4$export$4bc9686aad3cdaa7; });
$parcel$export(module.exports, "assignOccurrenceIndices", function () { return $8f43f7adef563af4$export$f8afde7be15d1c1a; });

var $5mLYn = parcelRequire("5mLYn");

var $ldvNR = parcelRequire("ldvNR");

var $5hnkq = parcelRequire("5hnkq");

var $hUgka = parcelRequire("hUgka");

var $h6YGr = parcelRequire("h6YGr");
function $8f43f7adef563af4$export$6bc9296d22a119b7(options) {
    options = (0, $5mLYn.defaults)(options, {
        errMsgProvider: (0, $hUgka.defaultGrammarResolverErrorProvider)
    });
    var topRulesTable = {};
    (0, $5mLYn.forEach)(options.rules, function(rule) {
        topRulesTable[rule.name] = rule;
    });
    return (0, $ldvNR.resolveGrammar)(topRulesTable, options.errMsgProvider);
}
function $8f43f7adef563af4$export$4bc9686aad3cdaa7(options) {
    options = (0, $5mLYn.defaults)(options, {
        errMsgProvider: (0, $hUgka.defaultGrammarValidatorErrorProvider)
    });
    return (0, $5hnkq.validateGrammar)(options.rules, options.maxLookahead, options.tokenTypes, options.errMsgProvider, options.grammarName);
}
function $8f43f7adef563af4$export$f8afde7be15d1c1a(options) {
    (0, $5mLYn.forEach)(options.rules, function(currRule) {
        var methodsCollector = new (0, $h6YGr.DslMethodsCollectorVisitor)();
        currRule.accept(methodsCollector);
        (0, $5mLYn.forEach)(methodsCollector.dslMethods, function(methods) {
            (0, $5mLYn.forEach)(methods, function(currMethod, arrIdx) {
                currMethod.idx = arrIdx + 1;
            });
        });
    });
}

});
parcelRegister("ldvNR", function(module, exports) {

$parcel$export(module.exports, "resolveGrammar", function () { return $f7237b4d49d0eeb5$export$6bc9296d22a119b7; });

var $5qjkp = parcelRequire("5qjkp");

var $5mLYn = parcelRequire("5mLYn");

var $1bKra = parcelRequire("1bKra");
var $f7237b4d49d0eeb5$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
function $f7237b4d49d0eeb5$export$6bc9296d22a119b7(topLevels, errMsgProvider) {
    var refResolver = new $f7237b4d49d0eeb5$export$ec198c591822336a(topLevels, errMsgProvider);
    refResolver.resolveRefs();
    return refResolver.errors;
}
var $f7237b4d49d0eeb5$export$ec198c591822336a = /** @class */ function(_super) {
    $f7237b4d49d0eeb5$var$__extends(GastRefResolverVisitor, _super);
    function GastRefResolverVisitor(nameToTopRule, errMsgProvider) {
        var _this = _super.call(this) || this;
        _this.nameToTopRule = nameToTopRule;
        _this.errMsgProvider = errMsgProvider;
        _this.errors = [];
        return _this;
    }
    GastRefResolverVisitor.prototype.resolveRefs = function() {
        var _this = this;
        (0, $5mLYn.forEach)((0, $5mLYn.values)(this.nameToTopRule), function(prod) {
            _this.currTopLevel = prod;
            prod.accept(_this);
        });
    };
    GastRefResolverVisitor.prototype.visitNonTerminal = function(node) {
        var ref = this.nameToTopRule[node.nonTerminalName];
        if (!ref) {
            var msg = this.errMsgProvider.buildRuleNotFoundError(this.currTopLevel, node);
            this.errors.push({
                message: msg,
                type: (0, $5qjkp.ParserDefinitionErrorType).UNRESOLVED_SUBRULE_REF,
                ruleName: this.currTopLevel.name,
                unresolvedRefName: node.nonTerminalName
            });
        } else node.referencedRule = ref;
    };
    return GastRefResolverVisitor;
}((0, $1bKra.GAstVisitor));

});

parcelRegister("5hnkq", function(module, exports) {

$parcel$export(module.exports, "validateGrammar", function () { return $3d80a2cf86cd71d5$export$4bc9686aad3cdaa7; });
$parcel$export(module.exports, "validateRuleIsOverridden", function () { return $3d80a2cf86cd71d5$export$4d4dd9a728c5129b; });

var $5mLYn = parcelRequire("5mLYn");

var $5qjkp = parcelRequire("5qjkp");

var $h6YGr = parcelRequire("h6YGr");

var $1eoLt = parcelRequire("1eoLt");

var $ld8c4 = parcelRequire("ld8c4");

var $bbUHG = parcelRequire("bbUHG");

var $1bKra = parcelRequire("1bKra");
var $3d80a2cf86cd71d5$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
function $3d80a2cf86cd71d5$export$4bc9686aad3cdaa7(topLevels, globalMaxLookahead, tokenTypes, errMsgProvider, grammarName) {
    var duplicateErrors = $5mLYn.map(topLevels, function(currTopLevel) {
        return $3d80a2cf86cd71d5$var$validateDuplicateProductions(currTopLevel, errMsgProvider);
    });
    var leftRecursionErrors = $5mLYn.map(topLevels, function(currTopRule) {
        return $3d80a2cf86cd71d5$export$b147175d718f643b(currTopRule, currTopRule, errMsgProvider);
    });
    var emptyAltErrors = [];
    var ambiguousAltsErrors = [];
    var emptyRepetitionErrors = [];
    // left recursion could cause infinite loops in the following validations.
    // It is safest to first have the user fix the left recursion errors first and only then examine Further issues.
    if ((0, $5mLYn.every)(leftRecursionErrors, (0, $5mLYn.isEmpty))) {
        emptyAltErrors = (0, $5mLYn.map)(topLevels, function(currTopRule) {
            return $3d80a2cf86cd71d5$export$2f214286c44568bb(currTopRule, errMsgProvider);
        });
        ambiguousAltsErrors = (0, $5mLYn.map)(topLevels, function(currTopRule) {
            return $3d80a2cf86cd71d5$export$cd3d710571d2a098(currTopRule, globalMaxLookahead, errMsgProvider);
        });
        emptyRepetitionErrors = $3d80a2cf86cd71d5$export$a4873d1d63b44667(topLevels, globalMaxLookahead, errMsgProvider);
    }
    var termsNamespaceConflictErrors = $3d80a2cf86cd71d5$var$checkTerminalAndNoneTerminalsNameSpace(topLevels, tokenTypes, errMsgProvider);
    var tooManyAltsErrors = (0, $5mLYn.map)(topLevels, function(curRule) {
        return $3d80a2cf86cd71d5$export$4bd75116d621af7b(curRule, errMsgProvider);
    });
    var duplicateRulesError = (0, $5mLYn.map)(topLevels, function(curRule) {
        return $3d80a2cf86cd71d5$export$573945ebc948a81f(curRule, topLevels, grammarName, errMsgProvider);
    });
    return $5mLYn.flatten(duplicateErrors.concat(emptyRepetitionErrors, leftRecursionErrors, emptyAltErrors, ambiguousAltsErrors, termsNamespaceConflictErrors, tooManyAltsErrors, duplicateRulesError));
}
function $3d80a2cf86cd71d5$var$validateDuplicateProductions(topLevelRule, errMsgProvider) {
    var collectorVisitor = new $3d80a2cf86cd71d5$export$d886b72d7cccd2ca();
    topLevelRule.accept(collectorVisitor);
    var allRuleProductions = collectorVisitor.allProductions;
    var productionGroups = $5mLYn.groupBy(allRuleProductions, $3d80a2cf86cd71d5$export$16c136585429480e);
    var duplicates = $5mLYn.pick(productionGroups, function(currGroup) {
        return currGroup.length > 1;
    });
    var errors = $5mLYn.map($5mLYn.values(duplicates), function(currDuplicates) {
        var firstProd = $5mLYn.first(currDuplicates);
        var msg = errMsgProvider.buildDuplicateFoundError(topLevelRule, currDuplicates);
        var dslName = (0, $h6YGr.getProductionDslName)(firstProd);
        var defError = {
            message: msg,
            type: (0, $5qjkp.ParserDefinitionErrorType).DUPLICATE_PRODUCTIONS,
            ruleName: topLevelRule.name,
            dslName: dslName,
            occurrence: firstProd.idx
        };
        var param = $3d80a2cf86cd71d5$var$getExtraProductionArgument(firstProd);
        if (param) defError.parameter = param;
        return defError;
    });
    return errors;
}
function $3d80a2cf86cd71d5$export$16c136585429480e(prod) {
    return (0, $h6YGr.getProductionDslName)(prod) + "_#_" + prod.idx + "_#_" + $3d80a2cf86cd71d5$var$getExtraProductionArgument(prod);
}
function $3d80a2cf86cd71d5$var$getExtraProductionArgument(prod) {
    if (prod instanceof (0, $bbUHG.Terminal)) return prod.terminalType.name;
    else if (prod instanceof (0, $bbUHG.NonTerminal)) return prod.nonTerminalName;
    else return "";
}
var $3d80a2cf86cd71d5$export$d886b72d7cccd2ca = /** @class */ function(_super) {
    $3d80a2cf86cd71d5$var$__extends(OccurrenceValidationCollector, _super);
    function OccurrenceValidationCollector() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.allProductions = [];
        return _this;
    }
    OccurrenceValidationCollector.prototype.visitNonTerminal = function(subrule) {
        this.allProductions.push(subrule);
    };
    OccurrenceValidationCollector.prototype.visitOption = function(option) {
        this.allProductions.push(option);
    };
    OccurrenceValidationCollector.prototype.visitRepetitionWithSeparator = function(manySep) {
        this.allProductions.push(manySep);
    };
    OccurrenceValidationCollector.prototype.visitRepetitionMandatory = function(atLeastOne) {
        this.allProductions.push(atLeastOne);
    };
    OccurrenceValidationCollector.prototype.visitRepetitionMandatoryWithSeparator = function(atLeastOneSep) {
        this.allProductions.push(atLeastOneSep);
    };
    OccurrenceValidationCollector.prototype.visitRepetition = function(many) {
        this.allProductions.push(many);
    };
    OccurrenceValidationCollector.prototype.visitAlternation = function(or) {
        this.allProductions.push(or);
    };
    OccurrenceValidationCollector.prototype.visitTerminal = function(terminal) {
        this.allProductions.push(terminal);
    };
    return OccurrenceValidationCollector;
}((0, $1bKra.GAstVisitor));
function $3d80a2cf86cd71d5$export$573945ebc948a81f(rule, allRules, className, errMsgProvider) {
    var errors = [];
    var occurrences = (0, $5mLYn.reduce)(allRules, function(result, curRule) {
        if (curRule.name === rule.name) return result + 1;
        return result;
    }, 0);
    if (occurrences > 1) {
        var errMsg = errMsgProvider.buildDuplicateRuleNameError({
            topLevelRule: rule,
            grammarName: className
        });
        errors.push({
            message: errMsg,
            type: (0, $5qjkp.ParserDefinitionErrorType).DUPLICATE_RULE_NAME,
            ruleName: rule.name
        });
    }
    return errors;
}
function $3d80a2cf86cd71d5$export$4d4dd9a728c5129b(ruleName, definedRulesNames, className) {
    var errors = [];
    var errMsg;
    if (!$5mLYn.contains(definedRulesNames, ruleName)) {
        errMsg = "Invalid rule override, rule: ->" + ruleName + "<- cannot be overridden in the grammar: ->" + className + "<-" + "as it is not defined in any of the super grammars ";
        errors.push({
            message: errMsg,
            type: (0, $5qjkp.ParserDefinitionErrorType).INVALID_RULE_OVERRIDE,
            ruleName: ruleName
        });
    }
    return errors;
}
function $3d80a2cf86cd71d5$export$b147175d718f643b(topRule, currRule, errMsgProvider, path) {
    if (path === void 0) path = [];
    var errors = [];
    var nextNonTerminals = $3d80a2cf86cd71d5$export$bdf6f923ec9d5c51(currRule.definition);
    if ($5mLYn.isEmpty(nextNonTerminals)) return [];
    else {
        var ruleName = topRule.name;
        var foundLeftRecursion = $5mLYn.contains(nextNonTerminals, topRule);
        if (foundLeftRecursion) errors.push({
            message: errMsgProvider.buildLeftRecursionError({
                topLevelRule: topRule,
                leftRecursionPath: path
            }),
            type: (0, $5qjkp.ParserDefinitionErrorType).LEFT_RECURSION,
            ruleName: ruleName
        });
        // we are only looking for cyclic paths leading back to the specific topRule
        // other cyclic paths are ignored, we still need this difference to avoid infinite loops...
        var validNextSteps = $5mLYn.difference(nextNonTerminals, path.concat([
            topRule
        ]));
        var errorsFromNextSteps = $5mLYn.map(validNextSteps, function(currRefRule) {
            var newPath = $5mLYn.cloneArr(path);
            newPath.push(currRefRule);
            return $3d80a2cf86cd71d5$export$b147175d718f643b(topRule, currRefRule, errMsgProvider, newPath);
        });
        return errors.concat($5mLYn.flatten(errorsFromNextSteps));
    }
}
function $3d80a2cf86cd71d5$export$bdf6f923ec9d5c51(definition) {
    var result = [];
    if ($5mLYn.isEmpty(definition)) return result;
    var firstProd = $5mLYn.first(definition);
    /* istanbul ignore else */ if (firstProd instanceof (0, $bbUHG.NonTerminal)) result.push(firstProd.referencedRule);
    else if (firstProd instanceof (0, $bbUHG.Alternative) || firstProd instanceof (0, $bbUHG.Option) || firstProd instanceof (0, $bbUHG.RepetitionMandatory) || firstProd instanceof (0, $bbUHG.RepetitionMandatoryWithSeparator) || firstProd instanceof (0, $bbUHG.RepetitionWithSeparator) || firstProd instanceof (0, $bbUHG.Repetition)) result = result.concat($3d80a2cf86cd71d5$export$bdf6f923ec9d5c51(firstProd.definition));
    else if (firstProd instanceof (0, $bbUHG.Alternation)) // each sub definition in alternation is a FLAT
    result = $5mLYn.flatten($5mLYn.map(firstProd.definition, function(currSubDef) {
        return $3d80a2cf86cd71d5$export$bdf6f923ec9d5c51(currSubDef.definition);
    }));
    else if (firstProd instanceof (0, $bbUHG.Terminal)) ;
    else throw Error("non exhaustive match");
    var isFirstOptional = (0, $h6YGr.isOptionalProd)(firstProd);
    var hasMore = definition.length > 1;
    if (isFirstOptional && hasMore) {
        var rest = $5mLYn.drop(definition);
        return result.concat($3d80a2cf86cd71d5$export$bdf6f923ec9d5c51(rest));
    } else return result;
}
var $3d80a2cf86cd71d5$var$OrCollector = /** @class */ function(_super) {
    $3d80a2cf86cd71d5$var$__extends(OrCollector, _super);
    function OrCollector() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.alternations = [];
        return _this;
    }
    OrCollector.prototype.visitAlternation = function(node) {
        this.alternations.push(node);
    };
    return OrCollector;
}((0, $1bKra.GAstVisitor));
function $3d80a2cf86cd71d5$export$2f214286c44568bb(topLevelRule, errMsgProvider) {
    var orCollector = new $3d80a2cf86cd71d5$var$OrCollector();
    topLevelRule.accept(orCollector);
    var ors = orCollector.alternations;
    var errors = $5mLYn.reduce(ors, function(errors, currOr) {
        var exceptLast = $5mLYn.dropRight(currOr.definition);
        var currErrors = $5mLYn.map(exceptLast, function(currAlternative, currAltIdx) {
            var possibleFirstInAlt = (0, $ld8c4.nextPossibleTokensAfter)([
                currAlternative
            ], [], null, 1);
            if ($5mLYn.isEmpty(possibleFirstInAlt)) return {
                message: errMsgProvider.buildEmptyAlternationError({
                    topLevelRule: topLevelRule,
                    alternation: currOr,
                    emptyChoiceIdx: currAltIdx
                }),
                type: (0, $5qjkp.ParserDefinitionErrorType).NONE_LAST_EMPTY_ALT,
                ruleName: topLevelRule.name,
                occurrence: currOr.idx,
                alternative: currAltIdx + 1
            };
            else return null;
        });
        return errors.concat($5mLYn.compact(currErrors));
    }, []);
    return errors;
}
function $3d80a2cf86cd71d5$export$cd3d710571d2a098(topLevelRule, globalMaxLookahead, errMsgProvider) {
    var orCollector = new $3d80a2cf86cd71d5$var$OrCollector();
    topLevelRule.accept(orCollector);
    var ors = orCollector.alternations;
    // New Handling of ignoring ambiguities
    // - https://github.com/SAP/chevrotain/issues/869
    ors = (0, $5mLYn.reject)(ors, function(currOr) {
        return currOr.ignoreAmbiguities === true;
    });
    var errors = $5mLYn.reduce(ors, function(result, currOr) {
        var currOccurrence = currOr.idx;
        var actualMaxLookahead = currOr.maxLookahead || globalMaxLookahead;
        var alternatives = (0, $1eoLt.getLookaheadPathsForOr)(currOccurrence, topLevelRule, actualMaxLookahead, currOr);
        var altsAmbiguityErrors = $3d80a2cf86cd71d5$var$checkAlternativesAmbiguities(alternatives, currOr, topLevelRule, errMsgProvider);
        var altsPrefixAmbiguityErrors = $3d80a2cf86cd71d5$export$1a671bcd6a39572f(alternatives, currOr, topLevelRule, errMsgProvider);
        return result.concat(altsAmbiguityErrors, altsPrefixAmbiguityErrors);
    }, []);
    return errors;
}
var $3d80a2cf86cd71d5$export$bb36ea30a7b8d607 = /** @class */ function(_super) {
    $3d80a2cf86cd71d5$var$__extends(RepetionCollector, _super);
    function RepetionCollector() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.allProductions = [];
        return _this;
    }
    RepetionCollector.prototype.visitRepetitionWithSeparator = function(manySep) {
        this.allProductions.push(manySep);
    };
    RepetionCollector.prototype.visitRepetitionMandatory = function(atLeastOne) {
        this.allProductions.push(atLeastOne);
    };
    RepetionCollector.prototype.visitRepetitionMandatoryWithSeparator = function(atLeastOneSep) {
        this.allProductions.push(atLeastOneSep);
    };
    RepetionCollector.prototype.visitRepetition = function(many) {
        this.allProductions.push(many);
    };
    return RepetionCollector;
}((0, $1bKra.GAstVisitor));
function $3d80a2cf86cd71d5$export$4bd75116d621af7b(topLevelRule, errMsgProvider) {
    var orCollector = new $3d80a2cf86cd71d5$var$OrCollector();
    topLevelRule.accept(orCollector);
    var ors = orCollector.alternations;
    var errors = $5mLYn.reduce(ors, function(errors, currOr) {
        if (currOr.definition.length > 255) errors.push({
            message: errMsgProvider.buildTooManyAlternativesError({
                topLevelRule: topLevelRule,
                alternation: currOr
            }),
            type: (0, $5qjkp.ParserDefinitionErrorType).TOO_MANY_ALTS,
            ruleName: topLevelRule.name,
            occurrence: currOr.idx
        });
        return errors;
    }, []);
    return errors;
}
function $3d80a2cf86cd71d5$export$a4873d1d63b44667(topLevelRules, maxLookahead, errMsgProvider) {
    var errors = [];
    (0, $5mLYn.forEach)(topLevelRules, function(currTopRule) {
        var collectorVisitor = new $3d80a2cf86cd71d5$export$bb36ea30a7b8d607();
        currTopRule.accept(collectorVisitor);
        var allRuleProductions = collectorVisitor.allProductions;
        (0, $5mLYn.forEach)(allRuleProductions, function(currProd) {
            var prodType = (0, $1eoLt.getProdType)(currProd);
            var actualMaxLookahead = currProd.maxLookahead || maxLookahead;
            var currOccurrence = currProd.idx;
            var paths = (0, $1eoLt.getLookaheadPathsForOptionalProd)(currOccurrence, currTopRule, prodType, actualMaxLookahead);
            var pathsInsideProduction = paths[0];
            if ((0, $5mLYn.isEmpty)((0, $5mLYn.flatten)(pathsInsideProduction))) {
                var errMsg = errMsgProvider.buildEmptyRepetitionError({
                    topLevelRule: currTopRule,
                    repetition: currProd
                });
                errors.push({
                    message: errMsg,
                    type: (0, $5qjkp.ParserDefinitionErrorType).NO_NON_EMPTY_LOOKAHEAD,
                    ruleName: currTopRule.name
                });
            }
        });
    });
    return errors;
}
function $3d80a2cf86cd71d5$var$checkAlternativesAmbiguities(alternatives, alternation, rule, errMsgProvider) {
    var foundAmbiguousPaths = [];
    var identicalAmbiguities = (0, $5mLYn.reduce)(alternatives, function(result, currAlt, currAltIdx) {
        // ignore (skip) ambiguities with this alternative
        if (alternation.definition[currAltIdx].ignoreAmbiguities === true) return result;
        (0, $5mLYn.forEach)(currAlt, function(currPath) {
            var altsCurrPathAppearsIn = [
                currAltIdx
            ];
            (0, $5mLYn.forEach)(alternatives, function(currOtherAlt, currOtherAltIdx) {
                if (currAltIdx !== currOtherAltIdx && (0, $1eoLt.containsPath)(currOtherAlt, currPath) && // ignore (skip) ambiguities with this "other" alternative
                alternation.definition[currOtherAltIdx].ignoreAmbiguities !== true) altsCurrPathAppearsIn.push(currOtherAltIdx);
            });
            if (altsCurrPathAppearsIn.length > 1 && !(0, $1eoLt.containsPath)(foundAmbiguousPaths, currPath)) {
                foundAmbiguousPaths.push(currPath);
                result.push({
                    alts: altsCurrPathAppearsIn,
                    path: currPath
                });
            }
        });
        return result;
    }, []);
    var currErrors = $5mLYn.map(identicalAmbiguities, function(currAmbDescriptor) {
        var ambgIndices = (0, $5mLYn.map)(currAmbDescriptor.alts, function(currAltIdx) {
            return currAltIdx + 1;
        });
        var currMessage = errMsgProvider.buildAlternationAmbiguityError({
            topLevelRule: rule,
            alternation: alternation,
            ambiguityIndices: ambgIndices,
            prefixPath: currAmbDescriptor.path
        });
        return {
            message: currMessage,
            type: (0, $5qjkp.ParserDefinitionErrorType).AMBIGUOUS_ALTS,
            ruleName: rule.name,
            occurrence: alternation.idx,
            alternatives: [
                currAmbDescriptor.alts
            ]
        };
    });
    return currErrors;
}
function $3d80a2cf86cd71d5$export$1a671bcd6a39572f(alternatives, alternation, rule, errMsgProvider) {
    var errors = [];
    // flatten
    var pathsAndIndices = (0, $5mLYn.reduce)(alternatives, function(result, currAlt, idx) {
        var currPathsAndIdx = (0, $5mLYn.map)(currAlt, function(currPath) {
            return {
                idx: idx,
                path: currPath
            };
        });
        return result.concat(currPathsAndIdx);
    }, []);
    (0, $5mLYn.forEach)(pathsAndIndices, function(currPathAndIdx) {
        var alternativeGast = alternation.definition[currPathAndIdx.idx];
        // ignore (skip) ambiguities with this alternative
        if (alternativeGast.ignoreAmbiguities === true) return;
        var targetIdx = currPathAndIdx.idx;
        var targetPath = currPathAndIdx.path;
        var prefixAmbiguitiesPathsAndIndices = (0, $5mLYn.findAll)(pathsAndIndices, function(searchPathAndIdx) {
            // prefix ambiguity can only be created from lower idx (higher priority) path
            return(// ignore (skip) ambiguities with this "other" alternative
            alternation.definition[searchPathAndIdx.idx].ignoreAmbiguities !== true && searchPathAndIdx.idx < targetIdx && // checking for strict prefix because identical lookaheads
            // will be be detected using a different validation.
            (0, $1eoLt.isStrictPrefixOfPath)(searchPathAndIdx.path, targetPath));
        });
        var currPathPrefixErrors = (0, $5mLYn.map)(prefixAmbiguitiesPathsAndIndices, function(currAmbPathAndIdx) {
            var ambgIndices = [
                currAmbPathAndIdx.idx + 1,
                targetIdx + 1
            ];
            var occurrence = alternation.idx === 0 ? "" : alternation.idx;
            var message = errMsgProvider.buildAlternationPrefixAmbiguityError({
                topLevelRule: rule,
                alternation: alternation,
                ambiguityIndices: ambgIndices,
                prefixPath: currAmbPathAndIdx.path
            });
            return {
                message: message,
                type: (0, $5qjkp.ParserDefinitionErrorType).AMBIGUOUS_PREFIX_ALTS,
                ruleName: rule.name,
                occurrence: occurrence,
                alternatives: ambgIndices
            };
        });
        errors = errors.concat(currPathPrefixErrors);
    });
    return errors;
}
function $3d80a2cf86cd71d5$var$checkTerminalAndNoneTerminalsNameSpace(topLevels, tokenTypes, errMsgProvider) {
    var errors = [];
    var tokenNames = (0, $5mLYn.map)(tokenTypes, function(currToken) {
        return currToken.name;
    });
    (0, $5mLYn.forEach)(topLevels, function(currRule) {
        var currRuleName = currRule.name;
        if ((0, $5mLYn.contains)(tokenNames, currRuleName)) {
            var errMsg = errMsgProvider.buildNamespaceConflictError(currRule);
            errors.push({
                message: errMsg,
                type: (0, $5qjkp.ParserDefinitionErrorType).CONFLICT_TOKENS_RULES_NAMESPACE,
                ruleName: currRuleName
            });
        }
    });
    return errors;
}

});
parcelRegister("1eoLt", function(module, exports) {

$parcel$export(module.exports, "PROD_TYPE", function () { return $0e5a4efe98a39af2$export$c5892fe7b21ea3b0; });
$parcel$export(module.exports, "getProdType", function () { return $0e5a4efe98a39af2$export$a2eaa0062f0d8a0f; });
$parcel$export(module.exports, "buildLookaheadFuncForOr", function () { return $0e5a4efe98a39af2$export$369a5ca2931d4bf2; });
$parcel$export(module.exports, "getLookaheadPathsForOr", function () { return $0e5a4efe98a39af2$export$761fb7ef4b8838c8; });
$parcel$export(module.exports, "buildLookaheadFuncForOptionalProd", function () { return $0e5a4efe98a39af2$export$827f83776fbae060; });
$parcel$export(module.exports, "getLookaheadPathsForOptionalProd", function () { return $0e5a4efe98a39af2$export$840a61a016cd3543; });
$parcel$export(module.exports, "buildAlternativesLookAheadFunc", function () { return $0e5a4efe98a39af2$export$4144d5f8875e3b06; });
$parcel$export(module.exports, "buildSingleAlternativeLookaheadFunction", function () { return $0e5a4efe98a39af2$export$64153f68c28e5715; });
$parcel$export(module.exports, "containsPath", function () { return $0e5a4efe98a39af2$export$b17252458741aadd; });
$parcel$export(module.exports, "isStrictPrefixOfPath", function () { return $0e5a4efe98a39af2$export$a9842aa7df2f1bb8; });

var $5mLYn = parcelRequire("5mLYn");

var $ld8c4 = parcelRequire("ld8c4");

var $ip5ou = parcelRequire("ip5ou");

var $6UThq = parcelRequire("6UThq");

var $bbUHG = parcelRequire("bbUHG");

var $1bKra = parcelRequire("1bKra");
var $0e5a4efe98a39af2$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $0e5a4efe98a39af2$export$c5892fe7b21ea3b0;
(function(PROD_TYPE) {
    PROD_TYPE[PROD_TYPE["OPTION"] = 0] = "OPTION";
    PROD_TYPE[PROD_TYPE["REPETITION"] = 1] = "REPETITION";
    PROD_TYPE[PROD_TYPE["REPETITION_MANDATORY"] = 2] = "REPETITION_MANDATORY";
    PROD_TYPE[PROD_TYPE["REPETITION_MANDATORY_WITH_SEPARATOR"] = 3] = "REPETITION_MANDATORY_WITH_SEPARATOR";
    PROD_TYPE[PROD_TYPE["REPETITION_WITH_SEPARATOR"] = 4] = "REPETITION_WITH_SEPARATOR";
    PROD_TYPE[PROD_TYPE["ALTERNATION"] = 5] = "ALTERNATION";
})($0e5a4efe98a39af2$export$c5892fe7b21ea3b0 || ($0e5a4efe98a39af2$export$c5892fe7b21ea3b0 = {}));
function $0e5a4efe98a39af2$export$a2eaa0062f0d8a0f(prod) {
    /* istanbul ignore else */ if (prod instanceof (0, $bbUHG.Option)) return $0e5a4efe98a39af2$export$c5892fe7b21ea3b0.OPTION;
    else if (prod instanceof (0, $bbUHG.Repetition)) return $0e5a4efe98a39af2$export$c5892fe7b21ea3b0.REPETITION;
    else if (prod instanceof (0, $bbUHG.RepetitionMandatory)) return $0e5a4efe98a39af2$export$c5892fe7b21ea3b0.REPETITION_MANDATORY;
    else if (prod instanceof (0, $bbUHG.RepetitionMandatoryWithSeparator)) return $0e5a4efe98a39af2$export$c5892fe7b21ea3b0.REPETITION_MANDATORY_WITH_SEPARATOR;
    else if (prod instanceof (0, $bbUHG.RepetitionWithSeparator)) return $0e5a4efe98a39af2$export$c5892fe7b21ea3b0.REPETITION_WITH_SEPARATOR;
    else if (prod instanceof (0, $bbUHG.Alternation)) return $0e5a4efe98a39af2$export$c5892fe7b21ea3b0.ALTERNATION;
    else throw Error("non exhaustive match");
}
function $0e5a4efe98a39af2$export$369a5ca2931d4bf2(occurrence, ruleGrammar, maxLookahead, hasPredicates, dynamicTokensEnabled, laFuncBuilder) {
    var lookAheadPaths = $0e5a4efe98a39af2$export$761fb7ef4b8838c8(occurrence, ruleGrammar, maxLookahead);
    var tokenMatcher = $0e5a4efe98a39af2$export$c344443be8559a3d(lookAheadPaths) ? (0, $6UThq.tokenStructuredMatcherNoCategories) : (0, $6UThq.tokenStructuredMatcher);
    return laFuncBuilder(lookAheadPaths, hasPredicates, tokenMatcher, dynamicTokensEnabled);
}
function $0e5a4efe98a39af2$export$827f83776fbae060(occurrence, ruleGrammar, k, dynamicTokensEnabled, prodType, lookaheadBuilder) {
    var lookAheadPaths = $0e5a4efe98a39af2$export$840a61a016cd3543(occurrence, ruleGrammar, prodType, k);
    var tokenMatcher = $0e5a4efe98a39af2$export$c344443be8559a3d(lookAheadPaths) ? (0, $6UThq.tokenStructuredMatcherNoCategories) : (0, $6UThq.tokenStructuredMatcher);
    return lookaheadBuilder(lookAheadPaths[0], tokenMatcher, dynamicTokensEnabled);
}
function $0e5a4efe98a39af2$export$4144d5f8875e3b06(alts, hasPredicates, tokenMatcher, dynamicTokensEnabled) {
    var numOfAlts = alts.length;
    var areAllOneTokenLookahead = (0, $5mLYn.every)(alts, function(currAlt) {
        return (0, $5mLYn.every)(currAlt, function(currPath) {
            return currPath.length === 1;
        });
    });
    // This version takes into account the predicates as well.
    if (hasPredicates) /**
         * @returns {number} - The chosen alternative index
         */ return function(orAlts) {
        // unfortunately the predicates must be extracted every single time
        // as they cannot be cached due to references to parameters(vars) which are no longer valid.
        // note that in the common case of no predicates, no cpu time will be wasted on this (see else block)
        var predicates = (0, $5mLYn.map)(orAlts, function(currAlt) {
            return currAlt.GATE;
        });
        for(var t = 0; t < numOfAlts; t++){
            var currAlt = alts[t];
            var currNumOfPaths = currAlt.length;
            var currPredicate = predicates[t];
            if (currPredicate !== undefined && currPredicate.call(this) === false) continue;
            nextPath: for(var j = 0; j < currNumOfPaths; j++){
                var currPath = currAlt[j];
                var currPathLength = currPath.length;
                for(var i = 0; i < currPathLength; i++){
                    var nextToken = this.LA(i + 1);
                    if (tokenMatcher(nextToken, currPath[i]) === false) continue nextPath;
                }
                // found a full path that matches.
                // this will also work for an empty ALT as the loop will be skipped
                return t;
            }
        // none of the paths for the current alternative matched
        // try the next alternative
        }
        // none of the alternatives could be matched
        return undefined;
    };
    else if (areAllOneTokenLookahead && !dynamicTokensEnabled) {
        // optimized (common) case of all the lookaheads paths requiring only
        // a single token lookahead. These Optimizations cannot work if dynamically defined Tokens are used.
        var singleTokenAlts = (0, $5mLYn.map)(alts, function(currAlt) {
            return (0, $5mLYn.flatten)(currAlt);
        });
        var choiceToAlt_1 = (0, $5mLYn.reduce)(singleTokenAlts, function(result, currAlt, idx) {
            (0, $5mLYn.forEach)(currAlt, function(currTokType) {
                if (!(0, $5mLYn.has)(result, currTokType.tokenTypeIdx)) result[currTokType.tokenTypeIdx] = idx;
                (0, $5mLYn.forEach)(currTokType.categoryMatches, function(currExtendingType) {
                    if (!(0, $5mLYn.has)(result, currExtendingType)) result[currExtendingType] = idx;
                });
            });
            return result;
        }, []);
        /**
         * @returns {number} - The chosen alternative index
         */ return function() {
            var nextToken = this.LA(1);
            return choiceToAlt_1[nextToken.tokenTypeIdx];
        };
    } else // optimized lookahead without needing to check the predicates at all.
    // this causes code duplication which is intentional to improve performance.
    /**
         * @returns {number} - The chosen alternative index
         */ return function() {
        for(var t = 0; t < numOfAlts; t++){
            var currAlt = alts[t];
            var currNumOfPaths = currAlt.length;
            nextPath: for(var j = 0; j < currNumOfPaths; j++){
                var currPath = currAlt[j];
                var currPathLength = currPath.length;
                for(var i = 0; i < currPathLength; i++){
                    var nextToken = this.LA(i + 1);
                    if (tokenMatcher(nextToken, currPath[i]) === false) continue nextPath;
                }
                // found a full path that matches.
                // this will also work for an empty ALT as the loop will be skipped
                return t;
            }
        // none of the paths for the current alternative matched
        // try the next alternative
        }
        // none of the alternatives could be matched
        return undefined;
    };
}
function $0e5a4efe98a39af2$export$64153f68c28e5715(alt, tokenMatcher, dynamicTokensEnabled) {
    var areAllOneTokenLookahead = (0, $5mLYn.every)(alt, function(currPath) {
        return currPath.length === 1;
    });
    var numOfPaths = alt.length;
    // optimized (common) case of all the lookaheads paths requiring only
    // a single token lookahead.
    if (areAllOneTokenLookahead && !dynamicTokensEnabled) {
        var singleTokensTypes = (0, $5mLYn.flatten)(alt);
        if (singleTokensTypes.length === 1 && (0, $5mLYn.isEmpty)(singleTokensTypes[0].categoryMatches)) {
            var expectedTokenType = singleTokensTypes[0];
            var expectedTokenUniqueKey_1 = expectedTokenType.tokenTypeIdx;
            return function() {
                return this.LA(1).tokenTypeIdx === expectedTokenUniqueKey_1;
            };
        } else {
            var choiceToAlt_2 = (0, $5mLYn.reduce)(singleTokensTypes, function(result, currTokType, idx) {
                result[currTokType.tokenTypeIdx] = true;
                (0, $5mLYn.forEach)(currTokType.categoryMatches, function(currExtendingType) {
                    result[currExtendingType] = true;
                });
                return result;
            }, []);
            return function() {
                var nextToken = this.LA(1);
                return choiceToAlt_2[nextToken.tokenTypeIdx] === true;
            };
        }
    } else return function() {
        nextPath: for(var j = 0; j < numOfPaths; j++){
            var currPath = alt[j];
            var currPathLength = currPath.length;
            for(var i = 0; i < currPathLength; i++){
                var nextToken = this.LA(i + 1);
                if (tokenMatcher(nextToken, currPath[i]) === false) continue nextPath;
            }
            // found a full path that matches.
            return true;
        }
        // none of the paths matched
        return false;
    };
}
var $0e5a4efe98a39af2$var$RestDefinitionFinderWalker = /** @class */ function(_super) {
    $0e5a4efe98a39af2$var$__extends(RestDefinitionFinderWalker, _super);
    function RestDefinitionFinderWalker(topProd, targetOccurrence, targetProdType) {
        var _this = _super.call(this) || this;
        _this.topProd = topProd;
        _this.targetOccurrence = targetOccurrence;
        _this.targetProdType = targetProdType;
        return _this;
    }
    RestDefinitionFinderWalker.prototype.startWalking = function() {
        this.walk(this.topProd);
        return this.restDef;
    };
    RestDefinitionFinderWalker.prototype.checkIsTarget = function(node, expectedProdType, currRest, prevRest) {
        if (node.idx === this.targetOccurrence && this.targetProdType === expectedProdType) {
            this.restDef = currRest.concat(prevRest);
            return true;
        }
        // performance optimization, do not iterate over the entire Grammar ast after we have found the target
        return false;
    };
    RestDefinitionFinderWalker.prototype.walkOption = function(optionProd, currRest, prevRest) {
        if (!this.checkIsTarget(optionProd, $0e5a4efe98a39af2$export$c5892fe7b21ea3b0.OPTION, currRest, prevRest)) _super.prototype.walkOption.call(this, optionProd, currRest, prevRest);
    };
    RestDefinitionFinderWalker.prototype.walkAtLeastOne = function(atLeastOneProd, currRest, prevRest) {
        if (!this.checkIsTarget(atLeastOneProd, $0e5a4efe98a39af2$export$c5892fe7b21ea3b0.REPETITION_MANDATORY, currRest, prevRest)) _super.prototype.walkOption.call(this, atLeastOneProd, currRest, prevRest);
    };
    RestDefinitionFinderWalker.prototype.walkAtLeastOneSep = function(atLeastOneSepProd, currRest, prevRest) {
        if (!this.checkIsTarget(atLeastOneSepProd, $0e5a4efe98a39af2$export$c5892fe7b21ea3b0.REPETITION_MANDATORY_WITH_SEPARATOR, currRest, prevRest)) _super.prototype.walkOption.call(this, atLeastOneSepProd, currRest, prevRest);
    };
    RestDefinitionFinderWalker.prototype.walkMany = function(manyProd, currRest, prevRest) {
        if (!this.checkIsTarget(manyProd, $0e5a4efe98a39af2$export$c5892fe7b21ea3b0.REPETITION, currRest, prevRest)) _super.prototype.walkOption.call(this, manyProd, currRest, prevRest);
    };
    RestDefinitionFinderWalker.prototype.walkManySep = function(manySepProd, currRest, prevRest) {
        if (!this.checkIsTarget(manySepProd, $0e5a4efe98a39af2$export$c5892fe7b21ea3b0.REPETITION_WITH_SEPARATOR, currRest, prevRest)) _super.prototype.walkOption.call(this, manySepProd, currRest, prevRest);
    };
    return RestDefinitionFinderWalker;
}((0, $ip5ou.RestWalker));
/**
 * Returns the definition of a target production in a top level level rule.
 */ var $0e5a4efe98a39af2$var$InsideDefinitionFinderVisitor = /** @class */ function(_super) {
    $0e5a4efe98a39af2$var$__extends(InsideDefinitionFinderVisitor, _super);
    function InsideDefinitionFinderVisitor(targetOccurrence, targetProdType, targetRef) {
        var _this = _super.call(this) || this;
        _this.targetOccurrence = targetOccurrence;
        _this.targetProdType = targetProdType;
        _this.targetRef = targetRef;
        _this.result = [];
        return _this;
    }
    InsideDefinitionFinderVisitor.prototype.checkIsTarget = function(node, expectedProdName) {
        if (node.idx === this.targetOccurrence && this.targetProdType === expectedProdName && (this.targetRef === undefined || node === this.targetRef)) this.result = node.definition;
    };
    InsideDefinitionFinderVisitor.prototype.visitOption = function(node) {
        this.checkIsTarget(node, $0e5a4efe98a39af2$export$c5892fe7b21ea3b0.OPTION);
    };
    InsideDefinitionFinderVisitor.prototype.visitRepetition = function(node) {
        this.checkIsTarget(node, $0e5a4efe98a39af2$export$c5892fe7b21ea3b0.REPETITION);
    };
    InsideDefinitionFinderVisitor.prototype.visitRepetitionMandatory = function(node) {
        this.checkIsTarget(node, $0e5a4efe98a39af2$export$c5892fe7b21ea3b0.REPETITION_MANDATORY);
    };
    InsideDefinitionFinderVisitor.prototype.visitRepetitionMandatoryWithSeparator = function(node) {
        this.checkIsTarget(node, $0e5a4efe98a39af2$export$c5892fe7b21ea3b0.REPETITION_MANDATORY_WITH_SEPARATOR);
    };
    InsideDefinitionFinderVisitor.prototype.visitRepetitionWithSeparator = function(node) {
        this.checkIsTarget(node, $0e5a4efe98a39af2$export$c5892fe7b21ea3b0.REPETITION_WITH_SEPARATOR);
    };
    InsideDefinitionFinderVisitor.prototype.visitAlternation = function(node) {
        this.checkIsTarget(node, $0e5a4efe98a39af2$export$c5892fe7b21ea3b0.ALTERNATION);
    };
    return InsideDefinitionFinderVisitor;
}((0, $1bKra.GAstVisitor));
function $0e5a4efe98a39af2$var$initializeArrayOfArrays(size) {
    var result = new Array(size);
    for(var i = 0; i < size; i++)result[i] = [];
    return result;
}
/**
 * A sort of hash function between a Path in the grammar and a string.
 * Note that this returns multiple "hashes" to support the scenario of token categories.
 * -  A single path with categories may match multiple **actual** paths.
 */ function $0e5a4efe98a39af2$var$pathToHashKeys(path) {
    var keys = [
        ""
    ];
    for(var i = 0; i < path.length; i++){
        var tokType = path[i];
        var longerKeys = [];
        for(var j = 0; j < keys.length; j++){
            var currShorterKey = keys[j];
            longerKeys.push(currShorterKey + "_" + tokType.tokenTypeIdx);
            for(var t = 0; t < tokType.categoryMatches.length; t++){
                var categoriesKeySuffix = "_" + tokType.categoryMatches[t];
                longerKeys.push(currShorterKey + categoriesKeySuffix);
            }
        }
        keys = longerKeys;
    }
    return keys;
}
/**
 * Imperative style due to being called from a hot spot
 */ function $0e5a4efe98a39af2$var$isUniquePrefixHash(altKnownPathsKeys, searchPathKeys, idx) {
    for(var currAltIdx = 0; currAltIdx < altKnownPathsKeys.length; currAltIdx++){
        // We only want to test vs the other alternatives
        if (currAltIdx === idx) continue;
        var otherAltKnownPathsKeys = altKnownPathsKeys[currAltIdx];
        for(var searchIdx = 0; searchIdx < searchPathKeys.length; searchIdx++){
            var searchKey = searchPathKeys[searchIdx];
            if (otherAltKnownPathsKeys[searchKey] === true) return false;
        }
    }
    // None of the SearchPathKeys were found in any of the other alternatives
    return true;
}
function $0e5a4efe98a39af2$export$7e23ab4a647d0ef9(altsDefs, k) {
    var partialAlts = (0, $5mLYn.map)(altsDefs, function(currAlt) {
        return (0, $ld8c4.possiblePathsFrom)([
            currAlt
        ], 1);
    });
    var finalResult = $0e5a4efe98a39af2$var$initializeArrayOfArrays(partialAlts.length);
    var altsHashes = (0, $5mLYn.map)(partialAlts, function(currAltPaths) {
        var dict = {};
        (0, $5mLYn.forEach)(currAltPaths, function(item) {
            var keys = $0e5a4efe98a39af2$var$pathToHashKeys(item.partialPath);
            (0, $5mLYn.forEach)(keys, function(currKey) {
                dict[currKey] = true;
            });
        });
        return dict;
    });
    var newData = partialAlts;
    // maxLookahead loop
    for(var pathLength = 1; pathLength <= k; pathLength++){
        var currDataset = newData;
        newData = $0e5a4efe98a39af2$var$initializeArrayOfArrays(currDataset.length);
        var _loop_1 = function(altIdx) {
            var currAltPathsAndSuffixes = currDataset[altIdx];
            // paths in current alternative loop
            for(var currPathIdx = 0; currPathIdx < currAltPathsAndSuffixes.length; currPathIdx++){
                var currPathPrefix = currAltPathsAndSuffixes[currPathIdx].partialPath;
                var suffixDef = currAltPathsAndSuffixes[currPathIdx].suffixDef;
                var prefixKeys = $0e5a4efe98a39af2$var$pathToHashKeys(currPathPrefix);
                var isUnique = $0e5a4efe98a39af2$var$isUniquePrefixHash(altsHashes, prefixKeys, altIdx);
                // End of the line for this path.
                if (isUnique || (0, $5mLYn.isEmpty)(suffixDef) || currPathPrefix.length === k) {
                    var currAltResult = finalResult[altIdx];
                    // TODO: Can we implement a containsPath using Maps/Dictionaries?
                    if ($0e5a4efe98a39af2$export$b17252458741aadd(currAltResult, currPathPrefix) === false) {
                        currAltResult.push(currPathPrefix);
                        // Update all new  keys for the current path.
                        for(var j = 0; j < prefixKeys.length; j++){
                            var currKey = prefixKeys[j];
                            altsHashes[altIdx][currKey] = true;
                        }
                    }
                } else {
                    var newPartialPathsAndSuffixes = (0, $ld8c4.possiblePathsFrom)(suffixDef, pathLength + 1, currPathPrefix);
                    newData[altIdx] = newData[altIdx].concat(newPartialPathsAndSuffixes);
                    // Update keys for new known paths
                    (0, $5mLYn.forEach)(newPartialPathsAndSuffixes, function(item) {
                        var prefixKeys = $0e5a4efe98a39af2$var$pathToHashKeys(item.partialPath);
                        (0, $5mLYn.forEach)(prefixKeys, function(key) {
                            altsHashes[altIdx][key] = true;
                        });
                    });
                }
            }
        };
        // alternatives loop
        for(var altIdx = 0; altIdx < currDataset.length; altIdx++)_loop_1(altIdx);
    }
    return finalResult;
}
function $0e5a4efe98a39af2$export$761fb7ef4b8838c8(occurrence, ruleGrammar, k, orProd) {
    var visitor = new $0e5a4efe98a39af2$var$InsideDefinitionFinderVisitor(occurrence, $0e5a4efe98a39af2$export$c5892fe7b21ea3b0.ALTERNATION, orProd);
    ruleGrammar.accept(visitor);
    return $0e5a4efe98a39af2$export$7e23ab4a647d0ef9(visitor.result, k);
}
function $0e5a4efe98a39af2$export$840a61a016cd3543(occurrence, ruleGrammar, prodType, k) {
    var insideDefVisitor = new $0e5a4efe98a39af2$var$InsideDefinitionFinderVisitor(occurrence, prodType);
    ruleGrammar.accept(insideDefVisitor);
    var insideDef = insideDefVisitor.result;
    var afterDefWalker = new $0e5a4efe98a39af2$var$RestDefinitionFinderWalker(ruleGrammar, occurrence, prodType);
    var afterDef = afterDefWalker.startWalking();
    var insideFlat = new (0, $bbUHG.Alternative)({
        definition: insideDef
    });
    var afterFlat = new (0, $bbUHG.Alternative)({
        definition: afterDef
    });
    return $0e5a4efe98a39af2$export$7e23ab4a647d0ef9([
        insideFlat,
        afterFlat
    ], k);
}
function $0e5a4efe98a39af2$export$b17252458741aadd(alternative, searchPath) {
    compareOtherPath: for(var i = 0; i < alternative.length; i++){
        var otherPath = alternative[i];
        if (otherPath.length !== searchPath.length) continue;
        for(var j = 0; j < otherPath.length; j++){
            var searchTok = searchPath[j];
            var otherTok = otherPath[j];
            var matchingTokens = searchTok === otherTok || otherTok.categoryMatchesMap[searchTok.tokenTypeIdx] !== undefined;
            if (matchingTokens === false) continue compareOtherPath;
        }
        return true;
    }
    return false;
}
function $0e5a4efe98a39af2$export$a9842aa7df2f1bb8(prefix, other) {
    return prefix.length < other.length && (0, $5mLYn.every)(prefix, function(tokType, idx) {
        var otherTokType = other[idx];
        return tokType === otherTokType || otherTokType.categoryMatchesMap[tokType.tokenTypeIdx];
    });
}
function $0e5a4efe98a39af2$export$c344443be8559a3d(lookAheadPaths) {
    return (0, $5mLYn.every)(lookAheadPaths, function(singleAltPaths) {
        return (0, $5mLYn.every)(singleAltPaths, function(singlePath) {
            return (0, $5mLYn.every)(singlePath, function(token) {
                return (0, $5mLYn.isEmpty)(token.categoryMatches);
            });
        });
    });
}

});
parcelRegister("ld8c4", function(module, exports) {

$parcel$export(module.exports, "NextAfterTokenWalker", function () { return $f7112af260096fbd$export$287dc2095348d15a; });
$parcel$export(module.exports, "NextTerminalAfterManyWalker", function () { return $f7112af260096fbd$export$23f8615204bc8aa0; });
$parcel$export(module.exports, "NextTerminalAfterManySepWalker", function () { return $f7112af260096fbd$export$ea506e53a2caecbf; });
$parcel$export(module.exports, "NextTerminalAfterAtLeastOneWalker", function () { return $f7112af260096fbd$export$a30e822471328f54; });
$parcel$export(module.exports, "NextTerminalAfterAtLeastOneSepWalker", function () { return $f7112af260096fbd$export$c6400884b15aa7f0; });
$parcel$export(module.exports, "possiblePathsFrom", function () { return $f7112af260096fbd$export$20acfe6995dd951e; });
$parcel$export(module.exports, "nextPossibleTokensAfter", function () { return $f7112af260096fbd$export$1f40a8e796fbc732; });

var $ip5ou = parcelRequire("ip5ou");

var $5mLYn = parcelRequire("5mLYn");

var $6BL7Z = parcelRequire("6BL7Z");

var $bbUHG = parcelRequire("bbUHG");
var $f7112af260096fbd$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $f7112af260096fbd$export$d588b12caa690fb2 = /** @class */ function(_super) {
    $f7112af260096fbd$var$__extends(AbstractNextPossibleTokensWalker, _super);
    function AbstractNextPossibleTokensWalker(topProd, path) {
        var _this = _super.call(this) || this;
        _this.topProd = topProd;
        _this.path = path;
        _this.possibleTokTypes = [];
        _this.nextProductionName = "";
        _this.nextProductionOccurrence = 0;
        _this.found = false;
        _this.isAtEndOfPath = false;
        return _this;
    }
    AbstractNextPossibleTokensWalker.prototype.startWalking = function() {
        this.found = false;
        if (this.path.ruleStack[0] !== this.topProd.name) throw Error("The path does not start with the walker's top Rule!");
        // immutable for the win
        this.ruleStack = (0, $5mLYn.cloneArr)(this.path.ruleStack).reverse(); // intelij bug requires assertion
        this.occurrenceStack = (0, $5mLYn.cloneArr)(this.path.occurrenceStack).reverse(); // intelij bug requires assertion
        // already verified that the first production is valid, we now seek the 2nd production
        this.ruleStack.pop();
        this.occurrenceStack.pop();
        this.updateExpectedNext();
        this.walk(this.topProd);
        return this.possibleTokTypes;
    };
    AbstractNextPossibleTokensWalker.prototype.walk = function(prod, prevRest) {
        if (prevRest === void 0) prevRest = [];
        // stop scanning once we found the path
        if (!this.found) _super.prototype.walk.call(this, prod, prevRest);
    };
    AbstractNextPossibleTokensWalker.prototype.walkProdRef = function(refProd, currRest, prevRest) {
        // found the next production, need to keep walking in it
        if (refProd.referencedRule.name === this.nextProductionName && refProd.idx === this.nextProductionOccurrence) {
            var fullRest = currRest.concat(prevRest);
            this.updateExpectedNext();
            this.walk(refProd.referencedRule, fullRest);
        }
    };
    AbstractNextPossibleTokensWalker.prototype.updateExpectedNext = function() {
        // need to consume the Terminal
        if ((0, $5mLYn.isEmpty)(this.ruleStack)) {
            // must reset nextProductionXXX to avoid walking down another Top Level production while what we are
            // really seeking is the last Terminal...
            this.nextProductionName = "";
            this.nextProductionOccurrence = 0;
            this.isAtEndOfPath = true;
        } else {
            this.nextProductionName = this.ruleStack.pop();
            this.nextProductionOccurrence = this.occurrenceStack.pop();
        }
    };
    return AbstractNextPossibleTokensWalker;
}((0, $ip5ou.RestWalker));
var $f7112af260096fbd$export$287dc2095348d15a = /** @class */ function(_super) {
    $f7112af260096fbd$var$__extends(NextAfterTokenWalker, _super);
    function NextAfterTokenWalker(topProd, path) {
        var _this = _super.call(this, topProd, path) || this;
        _this.path = path;
        _this.nextTerminalName = "";
        _this.nextTerminalOccurrence = 0;
        _this.nextTerminalName = _this.path.lastTok.name;
        _this.nextTerminalOccurrence = _this.path.lastTokOccurrence;
        return _this;
    }
    NextAfterTokenWalker.prototype.walkTerminal = function(terminal, currRest, prevRest) {
        if (this.isAtEndOfPath && terminal.terminalType.name === this.nextTerminalName && terminal.idx === this.nextTerminalOccurrence && !this.found) {
            var fullRest = currRest.concat(prevRest);
            var restProd = new (0, $bbUHG.Alternative)({
                definition: fullRest
            });
            this.possibleTokTypes = (0, $6BL7Z.first)(restProd);
            this.found = true;
        }
    };
    return NextAfterTokenWalker;
}($f7112af260096fbd$export$d588b12caa690fb2);
/**
 * This walker only "walks" a single "TOP" level in the Grammar Ast, this means
 * it never "follows" production refs
 */ var $f7112af260096fbd$export$2bcc59369cf93bf6 = /** @class */ function(_super) {
    $f7112af260096fbd$var$__extends(AbstractNextTerminalAfterProductionWalker, _super);
    function AbstractNextTerminalAfterProductionWalker(topRule, occurrence) {
        var _this = _super.call(this) || this;
        _this.topRule = topRule;
        _this.occurrence = occurrence;
        _this.result = {
            token: undefined,
            occurrence: undefined,
            isEndOfRule: undefined
        };
        return _this;
    }
    AbstractNextTerminalAfterProductionWalker.prototype.startWalking = function() {
        this.walk(this.topRule);
        return this.result;
    };
    return AbstractNextTerminalAfterProductionWalker;
}((0, $ip5ou.RestWalker));
var $f7112af260096fbd$export$23f8615204bc8aa0 = /** @class */ function(_super) {
    $f7112af260096fbd$var$__extends(NextTerminalAfterManyWalker, _super);
    function NextTerminalAfterManyWalker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NextTerminalAfterManyWalker.prototype.walkMany = function(manyProd, currRest, prevRest) {
        if (manyProd.idx === this.occurrence) {
            var firstAfterMany = (0, $5mLYn.first)(currRest.concat(prevRest));
            this.result.isEndOfRule = firstAfterMany === undefined;
            if (firstAfterMany instanceof (0, $bbUHG.Terminal)) {
                this.result.token = firstAfterMany.terminalType;
                this.result.occurrence = firstAfterMany.idx;
            }
        } else _super.prototype.walkMany.call(this, manyProd, currRest, prevRest);
    };
    return NextTerminalAfterManyWalker;
}($f7112af260096fbd$export$2bcc59369cf93bf6);
var $f7112af260096fbd$export$ea506e53a2caecbf = /** @class */ function(_super) {
    $f7112af260096fbd$var$__extends(NextTerminalAfterManySepWalker, _super);
    function NextTerminalAfterManySepWalker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NextTerminalAfterManySepWalker.prototype.walkManySep = function(manySepProd, currRest, prevRest) {
        if (manySepProd.idx === this.occurrence) {
            var firstAfterManySep = (0, $5mLYn.first)(currRest.concat(prevRest));
            this.result.isEndOfRule = firstAfterManySep === undefined;
            if (firstAfterManySep instanceof (0, $bbUHG.Terminal)) {
                this.result.token = firstAfterManySep.terminalType;
                this.result.occurrence = firstAfterManySep.idx;
            }
        } else _super.prototype.walkManySep.call(this, manySepProd, currRest, prevRest);
    };
    return NextTerminalAfterManySepWalker;
}($f7112af260096fbd$export$2bcc59369cf93bf6);
var $f7112af260096fbd$export$a30e822471328f54 = /** @class */ function(_super) {
    $f7112af260096fbd$var$__extends(NextTerminalAfterAtLeastOneWalker, _super);
    function NextTerminalAfterAtLeastOneWalker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NextTerminalAfterAtLeastOneWalker.prototype.walkAtLeastOne = function(atLeastOneProd, currRest, prevRest) {
        if (atLeastOneProd.idx === this.occurrence) {
            var firstAfterAtLeastOne = (0, $5mLYn.first)(currRest.concat(prevRest));
            this.result.isEndOfRule = firstAfterAtLeastOne === undefined;
            if (firstAfterAtLeastOne instanceof (0, $bbUHG.Terminal)) {
                this.result.token = firstAfterAtLeastOne.terminalType;
                this.result.occurrence = firstAfterAtLeastOne.idx;
            }
        } else _super.prototype.walkAtLeastOne.call(this, atLeastOneProd, currRest, prevRest);
    };
    return NextTerminalAfterAtLeastOneWalker;
}($f7112af260096fbd$export$2bcc59369cf93bf6);
// TODO: reduce code duplication in the AfterWalkers
var $f7112af260096fbd$export$c6400884b15aa7f0 = /** @class */ function(_super) {
    $f7112af260096fbd$var$__extends(NextTerminalAfterAtLeastOneSepWalker, _super);
    function NextTerminalAfterAtLeastOneSepWalker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NextTerminalAfterAtLeastOneSepWalker.prototype.walkAtLeastOneSep = function(atleastOneSepProd, currRest, prevRest) {
        if (atleastOneSepProd.idx === this.occurrence) {
            var firstAfterfirstAfterAtLeastOneSep = (0, $5mLYn.first)(currRest.concat(prevRest));
            this.result.isEndOfRule = firstAfterfirstAfterAtLeastOneSep === undefined;
            if (firstAfterfirstAfterAtLeastOneSep instanceof (0, $bbUHG.Terminal)) {
                this.result.token = firstAfterfirstAfterAtLeastOneSep.terminalType;
                this.result.occurrence = firstAfterfirstAfterAtLeastOneSep.idx;
            }
        } else _super.prototype.walkAtLeastOneSep.call(this, atleastOneSepProd, currRest, prevRest);
    };
    return NextTerminalAfterAtLeastOneSepWalker;
}($f7112af260096fbd$export$2bcc59369cf93bf6);
function $f7112af260096fbd$export$20acfe6995dd951e(targetDef, maxLength, currPath) {
    if (currPath === void 0) currPath = [];
    // avoid side effects
    currPath = (0, $5mLYn.cloneArr)(currPath);
    var result = [];
    var i = 0;
    // TODO: avoid inner funcs
    function remainingPathWith(nextDef) {
        return nextDef.concat((0, $5mLYn.drop)(targetDef, i + 1));
    }
    // TODO: avoid inner funcs
    function getAlternativesForProd(definition) {
        var alternatives = $f7112af260096fbd$export$20acfe6995dd951e(remainingPathWith(definition), maxLength, currPath);
        return result.concat(alternatives);
    }
    /**
     * Mandatory productions will halt the loop as the paths computed from their recursive calls will already contain the
     * following (rest) of the targetDef.
     *
     * For optional productions (Option/Repetition/...) the loop will continue to represent the paths that do not include the
     * the optional production.
     */ while(currPath.length < maxLength && i < targetDef.length){
        var prod = targetDef[i];
        /* istanbul ignore else */ if (prod instanceof (0, $bbUHG.Alternative)) return getAlternativesForProd(prod.definition);
        else if (prod instanceof (0, $bbUHG.NonTerminal)) return getAlternativesForProd(prod.definition);
        else if (prod instanceof (0, $bbUHG.Option)) result = getAlternativesForProd(prod.definition);
        else if (prod instanceof (0, $bbUHG.RepetitionMandatory)) {
            var newDef = prod.definition.concat([
                new (0, $bbUHG.Repetition)({
                    definition: prod.definition
                })
            ]);
            return getAlternativesForProd(newDef);
        } else if (prod instanceof (0, $bbUHG.RepetitionMandatoryWithSeparator)) {
            var newDef = [
                new (0, $bbUHG.Alternative)({
                    definition: prod.definition
                }),
                new (0, $bbUHG.Repetition)({
                    definition: [
                        new (0, $bbUHG.Terminal)({
                            terminalType: prod.separator
                        })
                    ].concat(prod.definition)
                })
            ];
            return getAlternativesForProd(newDef);
        } else if (prod instanceof (0, $bbUHG.RepetitionWithSeparator)) {
            var newDef = prod.definition.concat([
                new (0, $bbUHG.Repetition)({
                    definition: [
                        new (0, $bbUHG.Terminal)({
                            terminalType: prod.separator
                        })
                    ].concat(prod.definition)
                })
            ]);
            result = getAlternativesForProd(newDef);
        } else if (prod instanceof (0, $bbUHG.Repetition)) {
            var newDef = prod.definition.concat([
                new (0, $bbUHG.Repetition)({
                    definition: prod.definition
                })
            ]);
            result = getAlternativesForProd(newDef);
        } else if (prod instanceof (0, $bbUHG.Alternation)) {
            (0, $5mLYn.forEach)(prod.definition, function(currAlt) {
                // TODO: this is a limited check for empty alternatives
                //   It would prevent a common case of infinite loops during parser initialization.
                //   However **in-directly** empty alternatives may still cause issues.
                if ((0, $5mLYn.isEmpty)(currAlt.definition) === false) result = getAlternativesForProd(currAlt.definition);
            });
            return result;
        } else if (prod instanceof (0, $bbUHG.Terminal)) currPath.push(prod.terminalType);
        else throw Error("non exhaustive match");
        i++;
    }
    result.push({
        partialPath: currPath,
        suffixDef: (0, $5mLYn.drop)(targetDef, i)
    });
    return result;
}
function $f7112af260096fbd$export$1f40a8e796fbc732(initialDef, tokenVector, tokMatcher, maxLookAhead) {
    var EXIT_NON_TERMINAL = "EXIT_NONE_TERMINAL";
    // to avoid creating a new Array each time.
    var EXIT_NON_TERMINAL_ARR = [
        EXIT_NON_TERMINAL
    ];
    var EXIT_ALTERNATIVE = "EXIT_ALTERNATIVE";
    var foundCompletePath = false;
    var tokenVectorLength = tokenVector.length;
    var minimalAlternativesIndex = tokenVectorLength - maxLookAhead - 1;
    var result = [];
    var possiblePaths = [];
    possiblePaths.push({
        idx: -1,
        def: initialDef,
        ruleStack: [],
        occurrenceStack: []
    });
    while(!(0, $5mLYn.isEmpty)(possiblePaths)){
        var currPath = possiblePaths.pop();
        // skip alternatives if no more results can be found (assuming deterministic grammar with fixed lookahead)
        if (currPath === EXIT_ALTERNATIVE) {
            if (foundCompletePath && (0, $5mLYn.last)(possiblePaths).idx <= minimalAlternativesIndex) // remove irrelevant alternative
            possiblePaths.pop();
            continue;
        }
        var currDef = currPath.def;
        var currIdx = currPath.idx;
        var currRuleStack = currPath.ruleStack;
        var currOccurrenceStack = currPath.occurrenceStack;
        // For Example: an empty path could exist in a valid grammar in the case of an EMPTY_ALT
        if ((0, $5mLYn.isEmpty)(currDef)) continue;
        var prod = currDef[0];
        /* istanbul ignore else */ if (prod === EXIT_NON_TERMINAL) {
            var nextPath = {
                idx: currIdx,
                def: (0, $5mLYn.drop)(currDef),
                ruleStack: (0, $5mLYn.dropRight)(currRuleStack),
                occurrenceStack: (0, $5mLYn.dropRight)(currOccurrenceStack)
            };
            possiblePaths.push(nextPath);
        } else if (prod instanceof (0, $bbUHG.Terminal)) {
            /* istanbul ignore else */ if (currIdx < tokenVectorLength - 1) {
                var nextIdx = currIdx + 1;
                var actualToken = tokenVector[nextIdx];
                if (tokMatcher(actualToken, prod.terminalType)) {
                    var nextPath = {
                        idx: nextIdx,
                        def: (0, $5mLYn.drop)(currDef),
                        ruleStack: currRuleStack,
                        occurrenceStack: currOccurrenceStack
                    };
                    possiblePaths.push(nextPath);
                }
            // end of the line
            } else if (currIdx === tokenVectorLength - 1) {
                // IGNORE ABOVE ELSE
                result.push({
                    nextTokenType: prod.terminalType,
                    nextTokenOccurrence: prod.idx,
                    ruleStack: currRuleStack,
                    occurrenceStack: currOccurrenceStack
                });
                foundCompletePath = true;
            } else throw Error("non exhaustive match");
        } else if (prod instanceof (0, $bbUHG.NonTerminal)) {
            var newRuleStack = (0, $5mLYn.cloneArr)(currRuleStack);
            newRuleStack.push(prod.nonTerminalName);
            var newOccurrenceStack = (0, $5mLYn.cloneArr)(currOccurrenceStack);
            newOccurrenceStack.push(prod.idx);
            var nextPath = {
                idx: currIdx,
                def: prod.definition.concat(EXIT_NON_TERMINAL_ARR, (0, $5mLYn.drop)(currDef)),
                ruleStack: newRuleStack,
                occurrenceStack: newOccurrenceStack
            };
            possiblePaths.push(nextPath);
        } else if (prod instanceof (0, $bbUHG.Option)) {
            // the order of alternatives is meaningful, FILO (Last path will be traversed first).
            var nextPathWithout = {
                idx: currIdx,
                def: (0, $5mLYn.drop)(currDef),
                ruleStack: currRuleStack,
                occurrenceStack: currOccurrenceStack
            };
            possiblePaths.push(nextPathWithout);
            // required marker to avoid backtracking paths whose higher priority alternatives already matched
            possiblePaths.push(EXIT_ALTERNATIVE);
            var nextPathWith = {
                idx: currIdx,
                def: prod.definition.concat((0, $5mLYn.drop)(currDef)),
                ruleStack: currRuleStack,
                occurrenceStack: currOccurrenceStack
            };
            possiblePaths.push(nextPathWith);
        } else if (prod instanceof (0, $bbUHG.RepetitionMandatory)) {
            // TODO:(THE NEW operators here take a while...) (convert once?)
            var secondIteration = new (0, $bbUHG.Repetition)({
                definition: prod.definition,
                idx: prod.idx
            });
            var nextDef = prod.definition.concat([
                secondIteration
            ], (0, $5mLYn.drop)(currDef));
            var nextPath = {
                idx: currIdx,
                def: nextDef,
                ruleStack: currRuleStack,
                occurrenceStack: currOccurrenceStack
            };
            possiblePaths.push(nextPath);
        } else if (prod instanceof (0, $bbUHG.RepetitionMandatoryWithSeparator)) {
            // TODO:(THE NEW operators here take a while...) (convert once?)
            var separatorGast = new (0, $bbUHG.Terminal)({
                terminalType: prod.separator
            });
            var secondIteration = new (0, $bbUHG.Repetition)({
                definition: [
                    separatorGast
                ].concat(prod.definition),
                idx: prod.idx
            });
            var nextDef = prod.definition.concat([
                secondIteration
            ], (0, $5mLYn.drop)(currDef));
            var nextPath = {
                idx: currIdx,
                def: nextDef,
                ruleStack: currRuleStack,
                occurrenceStack: currOccurrenceStack
            };
            possiblePaths.push(nextPath);
        } else if (prod instanceof (0, $bbUHG.RepetitionWithSeparator)) {
            // the order of alternatives is meaningful, FILO (Last path will be traversed first).
            var nextPathWithout = {
                idx: currIdx,
                def: (0, $5mLYn.drop)(currDef),
                ruleStack: currRuleStack,
                occurrenceStack: currOccurrenceStack
            };
            possiblePaths.push(nextPathWithout);
            // required marker to avoid backtracking paths whose higher priority alternatives already matched
            possiblePaths.push(EXIT_ALTERNATIVE);
            var separatorGast = new (0, $bbUHG.Terminal)({
                terminalType: prod.separator
            });
            var nthRepetition = new (0, $bbUHG.Repetition)({
                definition: [
                    separatorGast
                ].concat(prod.definition),
                idx: prod.idx
            });
            var nextDef = prod.definition.concat([
                nthRepetition
            ], (0, $5mLYn.drop)(currDef));
            var nextPathWith = {
                idx: currIdx,
                def: nextDef,
                ruleStack: currRuleStack,
                occurrenceStack: currOccurrenceStack
            };
            possiblePaths.push(nextPathWith);
        } else if (prod instanceof (0, $bbUHG.Repetition)) {
            // the order of alternatives is meaningful, FILO (Last path will be traversed first).
            var nextPathWithout = {
                idx: currIdx,
                def: (0, $5mLYn.drop)(currDef),
                ruleStack: currRuleStack,
                occurrenceStack: currOccurrenceStack
            };
            possiblePaths.push(nextPathWithout);
            // required marker to avoid backtracking paths whose higher priority alternatives already matched
            possiblePaths.push(EXIT_ALTERNATIVE);
            // TODO: an empty repetition will cause infinite loops here, will the parser detect this in selfAnalysis?
            var nthRepetition = new (0, $bbUHG.Repetition)({
                definition: prod.definition,
                idx: prod.idx
            });
            var nextDef = prod.definition.concat([
                nthRepetition
            ], (0, $5mLYn.drop)(currDef));
            var nextPathWith = {
                idx: currIdx,
                def: nextDef,
                ruleStack: currRuleStack,
                occurrenceStack: currOccurrenceStack
            };
            possiblePaths.push(nextPathWith);
        } else if (prod instanceof (0, $bbUHG.Alternation)) // the order of alternatives is meaningful, FILO (Last path will be traversed first).
        for(var i = prod.definition.length - 1; i >= 0; i--){
            var currAlt = prod.definition[i];
            var currAltPath = {
                idx: currIdx,
                def: currAlt.definition.concat((0, $5mLYn.drop)(currDef)),
                ruleStack: currRuleStack,
                occurrenceStack: currOccurrenceStack
            };
            possiblePaths.push(currAltPath);
            possiblePaths.push(EXIT_ALTERNATIVE);
        }
        else if (prod instanceof (0, $bbUHG.Alternative)) possiblePaths.push({
            idx: currIdx,
            def: prod.definition.concat((0, $5mLYn.drop)(currDef)),
            ruleStack: currRuleStack,
            occurrenceStack: currOccurrenceStack
        });
        else if (prod instanceof (0, $bbUHG.Rule)) // last because we should only encounter at most a single one of these per invocation.
        possiblePaths.push($f7112af260096fbd$var$expandTopLevelRule(prod, currIdx, currRuleStack, currOccurrenceStack));
        else throw Error("non exhaustive match");
    }
    return result;
}
function $f7112af260096fbd$var$expandTopLevelRule(topRule, currIdx, currRuleStack, currOccurrenceStack) {
    var newRuleStack = (0, $5mLYn.cloneArr)(currRuleStack);
    newRuleStack.push(topRule.name);
    var newCurrOccurrenceStack = (0, $5mLYn.cloneArr)(currOccurrenceStack);
    // top rule is always assumed to have been called with occurrence index 1
    newCurrOccurrenceStack.push(1);
    return {
        idx: currIdx,
        def: topRule.definition,
        ruleStack: newRuleStack,
        occurrenceStack: newCurrOccurrenceStack
    };
}

});




parcelRegister("8VG34", function(module, exports) {

$parcel$export(module.exports, "IN_RULE_RECOVERY_EXCEPTION", function () { return IN_RULE_RECOVERY_EXCEPTION; });
$parcel$export(module.exports, "Recoverable", function () { return Recoverable; });

var $hvAWv = parcelRequire("hvAWv");

var $5mLYn = parcelRequire("5mLYn");

var $czA2c = parcelRequire("czA2c");

var $kWjNL = parcelRequire("kWjNL");

var $5qjkp = parcelRequire("5qjkp");
var EOF_FOLLOW_KEY = {};
var IN_RULE_RECOVERY_EXCEPTION = "InRuleRecoveryException";
function InRuleRecoveryException(message) {
    this.name = IN_RULE_RECOVERY_EXCEPTION;
    this.message = message;
}
InRuleRecoveryException.prototype = Error.prototype;
/**
 * This trait is responsible for the error recovery and fault tolerant logic
 */ var Recoverable = /** @class */ function() {
    function Recoverable() {}
    Recoverable.prototype.initRecoverable = function(config) {
        this.firstAfterRepMap = {};
        this.resyncFollows = {};
        this.recoveryEnabled = (0, $5mLYn.has)(config, "recoveryEnabled") ? config.recoveryEnabled : (0, $5qjkp.DEFAULT_PARSER_CONFIG).recoveryEnabled;
        // performance optimization, NOOP will be inlined which
        // effectively means that this optional feature does not exist
        // when not used.
        if (this.recoveryEnabled) this.attemptInRepetitionRecovery = attemptInRepetitionRecovery;
    };
    Recoverable.prototype.getTokenToInsert = function(tokType) {
        var tokToInsert = (0, $hvAWv.createTokenInstance)(tokType, "", NaN, NaN, NaN, NaN, NaN, NaN);
        tokToInsert.isInsertedInRecovery = true;
        return tokToInsert;
    };
    Recoverable.prototype.canTokenTypeBeInsertedInRecovery = function(tokType) {
        return true;
    };
    Recoverable.prototype.tryInRepetitionRecovery = function(grammarRule, grammarRuleArgs, lookAheadFunc, expectedTokType) {
        var _this = this;
        // TODO: can the resyncTokenType be cached?
        var reSyncTokType = this.findReSyncTokenType();
        var savedLexerState = this.exportLexerState();
        var resyncedTokens = [];
        var passedResyncPoint = false;
        var nextTokenWithoutResync = this.LA(1);
        var currToken = this.LA(1);
        var generateErrorMessage = function() {
            var previousToken = _this.LA(0);
            // we are preemptively re-syncing before an error has been detected, therefor we must reproduce
            // the error that would have been thrown
            var msg = _this.errorMessageProvider.buildMismatchTokenMessage({
                expected: expectedTokType,
                actual: nextTokenWithoutResync,
                previous: previousToken,
                ruleName: _this.getCurrRuleFullName()
            });
            var error = new (0, $czA2c.MismatchedTokenException)(msg, nextTokenWithoutResync, _this.LA(0));
            // the first token here will be the original cause of the error, this is not part of the resyncedTokens property.
            error.resyncedTokens = (0, $5mLYn.dropRight)(resyncedTokens);
            _this.SAVE_ERROR(error);
        };
        while(!passedResyncPoint){
            // re-synced to a point where we can safely exit the repetition/
            if (this.tokenMatcher(currToken, expectedTokType)) {
                generateErrorMessage();
                return; // must return here to avoid reverting the inputIdx
            } else if (lookAheadFunc.call(this)) {
                // we skipped enough tokens so we can resync right back into another iteration of the repetition grammar rule
                generateErrorMessage();
                // recursive invocation in other to support multiple re-syncs in the same top level repetition grammar rule
                grammarRule.apply(this, grammarRuleArgs);
                return; // must return here to avoid reverting the inputIdx
            } else if (this.tokenMatcher(currToken, reSyncTokType)) passedResyncPoint = true;
            else {
                currToken = this.SKIP_TOKEN();
                this.addToResyncTokens(currToken, resyncedTokens);
            }
        }
        // we were unable to find a CLOSER point to resync inside the Repetition, reset the state.
        // The parsing exception we were trying to prevent will happen in the NEXT parsing step. it may be handled by
        // "between rules" resync recovery later in the flow.
        this.importLexerState(savedLexerState);
    };
    Recoverable.prototype.shouldInRepetitionRecoveryBeTried = function(expectTokAfterLastMatch, nextTokIdx, notStuck) {
        // Edge case of arriving from a MANY repetition which is stuck
        // Attempting recovery in this case could cause an infinite loop
        if (notStuck === false) return false;
        // arguments to try and perform resync into the next iteration of the many are missing
        if (expectTokAfterLastMatch === undefined || nextTokIdx === undefined) return false;
        // no need to recover, next token is what we expect...
        if (this.tokenMatcher(this.LA(1), expectTokAfterLastMatch)) return false;
        // error recovery is disabled during backtracking as it can make the parser ignore a valid grammar path
        // and prefer some backtracking path that includes recovered errors.
        if (this.isBackTracking()) return false;
        // if we can perform inRule recovery (single token insertion or deletion) we always prefer that recovery algorithm
        // because if it works, it makes the least amount of changes to the input stream (greedy algorithm)
        //noinspection RedundantIfStatementJS
        if (this.canPerformInRuleRecovery(expectTokAfterLastMatch, this.getFollowsForInRuleRecovery(expectTokAfterLastMatch, nextTokIdx))) return false;
        return true;
    };
    // Error Recovery functionality
    Recoverable.prototype.getFollowsForInRuleRecovery = function(tokType, tokIdxInRule) {
        var grammarPath = this.getCurrentGrammarPath(tokType, tokIdxInRule);
        var follows = this.getNextPossibleTokenTypes(grammarPath);
        return follows;
    };
    Recoverable.prototype.tryInRuleRecovery = function(expectedTokType, follows) {
        if (this.canRecoverWithSingleTokenInsertion(expectedTokType, follows)) {
            var tokToInsert = this.getTokenToInsert(expectedTokType);
            return tokToInsert;
        }
        if (this.canRecoverWithSingleTokenDeletion(expectedTokType)) {
            var nextTok = this.SKIP_TOKEN();
            this.consumeToken();
            return nextTok;
        }
        throw new InRuleRecoveryException("sad sad panda");
    };
    Recoverable.prototype.canPerformInRuleRecovery = function(expectedToken, follows) {
        return this.canRecoverWithSingleTokenInsertion(expectedToken, follows) || this.canRecoverWithSingleTokenDeletion(expectedToken);
    };
    Recoverable.prototype.canRecoverWithSingleTokenInsertion = function(expectedTokType, follows) {
        var _this = this;
        if (!this.canTokenTypeBeInsertedInRecovery(expectedTokType)) return false;
        // must know the possible following tokens to perform single token insertion
        if ((0, $5mLYn.isEmpty)(follows)) return false;
        var mismatchedTok = this.LA(1);
        var isMisMatchedTokInFollows = (0, $5mLYn.find)(follows, function(possibleFollowsTokType) {
            return _this.tokenMatcher(mismatchedTok, possibleFollowsTokType);
        }) !== undefined;
        return isMisMatchedTokInFollows;
    };
    Recoverable.prototype.canRecoverWithSingleTokenDeletion = function(expectedTokType) {
        var isNextTokenWhatIsExpected = this.tokenMatcher(this.LA(2), expectedTokType);
        return isNextTokenWhatIsExpected;
    };
    Recoverable.prototype.isInCurrentRuleReSyncSet = function(tokenTypeIdx) {
        var followKey = this.getCurrFollowKey();
        var currentRuleReSyncSet = this.getFollowSetFromFollowKey(followKey);
        return (0, $5mLYn.contains)(currentRuleReSyncSet, tokenTypeIdx);
    };
    Recoverable.prototype.findReSyncTokenType = function() {
        var allPossibleReSyncTokTypes = this.flattenFollowSet();
        // this loop will always terminate as EOF is always in the follow stack and also always (virtually) in the input
        var nextToken = this.LA(1);
        var k = 2;
        while(true){
            var nextTokenType = nextToken.tokenType;
            if ((0, $5mLYn.contains)(allPossibleReSyncTokTypes, nextTokenType)) return nextTokenType;
            nextToken = this.LA(k);
            k++;
        }
    };
    Recoverable.prototype.getCurrFollowKey = function() {
        // the length is at least one as we always add the ruleName to the stack before invoking the rule.
        if (this.RULE_STACK.length === 1) return EOF_FOLLOW_KEY;
        var currRuleShortName = this.getLastExplicitRuleShortName();
        var currRuleIdx = this.getLastExplicitRuleOccurrenceIndex();
        var prevRuleShortName = this.getPreviousExplicitRuleShortName();
        return {
            ruleName: this.shortRuleNameToFullName(currRuleShortName),
            idxInCallingRule: currRuleIdx,
            inRule: this.shortRuleNameToFullName(prevRuleShortName)
        };
    };
    Recoverable.prototype.buildFullFollowKeyStack = function() {
        var _this = this;
        var explicitRuleStack = this.RULE_STACK;
        var explicitOccurrenceStack = this.RULE_OCCURRENCE_STACK;
        return (0, $5mLYn.map)(explicitRuleStack, function(ruleName, idx) {
            if (idx === 0) return EOF_FOLLOW_KEY;
            return {
                ruleName: _this.shortRuleNameToFullName(ruleName),
                idxInCallingRule: explicitOccurrenceStack[idx],
                inRule: _this.shortRuleNameToFullName(explicitRuleStack[idx - 1])
            };
        });
    };
    Recoverable.prototype.flattenFollowSet = function() {
        var _this = this;
        var followStack = (0, $5mLYn.map)(this.buildFullFollowKeyStack(), function(currKey) {
            return _this.getFollowSetFromFollowKey(currKey);
        });
        return (0, $5mLYn.flatten)(followStack);
    };
    Recoverable.prototype.getFollowSetFromFollowKey = function(followKey) {
        if (followKey === EOF_FOLLOW_KEY) return [
            (0, $hvAWv.EOF)
        ];
        var followName = followKey.ruleName + followKey.idxInCallingRule + (0, $kWjNL.IN) + followKey.inRule;
        return this.resyncFollows[followName];
    };
    // It does not make any sense to include a virtual EOF token in the list of resynced tokens
    // as EOF does not really exist and thus does not contain any useful information (line/column numbers)
    Recoverable.prototype.addToResyncTokens = function(token, resyncTokens) {
        if (!this.tokenMatcher(token, (0, $hvAWv.EOF))) resyncTokens.push(token);
        return resyncTokens;
    };
    Recoverable.prototype.reSyncTo = function(tokType) {
        var resyncedTokens = [];
        var nextTok = this.LA(1);
        while(this.tokenMatcher(nextTok, tokType) === false){
            nextTok = this.SKIP_TOKEN();
            this.addToResyncTokens(nextTok, resyncedTokens);
        }
        // the last token is not part of the error.
        return (0, $5mLYn.dropRight)(resyncedTokens);
    };
    Recoverable.prototype.attemptInRepetitionRecovery = function(prodFunc, args, lookaheadFunc, dslMethodIdx, prodOccurrence, nextToksWalker, notStuck) {
    // by default this is a NO-OP
    // The actual implementation is with the function(not method) below
    };
    Recoverable.prototype.getCurrentGrammarPath = function(tokType, tokIdxInRule) {
        var pathRuleStack = this.getHumanReadableRuleStack();
        var pathOccurrenceStack = (0, $5mLYn.cloneArr)(this.RULE_OCCURRENCE_STACK);
        var grammarPath = {
            ruleStack: pathRuleStack,
            occurrenceStack: pathOccurrenceStack,
            lastTok: tokType,
            lastTokOccurrence: tokIdxInRule
        };
        return grammarPath;
    };
    Recoverable.prototype.getHumanReadableRuleStack = function() {
        var _this = this;
        return (0, $5mLYn.map)(this.RULE_STACK, function(currShortName) {
            return _this.shortRuleNameToFullName(currShortName);
        });
    };
    return Recoverable;
}();
function attemptInRepetitionRecovery(prodFunc, args, lookaheadFunc, dslMethodIdx, prodOccurrence, nextToksWalker, notStuck) {
    var key = this.getKeyForAutomaticLookahead(dslMethodIdx, prodOccurrence);
    var firstAfterRepInfo = this.firstAfterRepMap[key];
    if (firstAfterRepInfo === undefined) {
        var currRuleName = this.getCurrRuleFullName();
        var ruleGrammar = this.getGAstProductions()[currRuleName];
        var walker = new nextToksWalker(ruleGrammar, prodOccurrence);
        firstAfterRepInfo = walker.startWalking();
        this.firstAfterRepMap[key] = firstAfterRepInfo;
    }
    var expectTokAfterLastMatch = firstAfterRepInfo.token;
    var nextTokIdx = firstAfterRepInfo.occurrence;
    var isEndOfRule = firstAfterRepInfo.isEndOfRule;
    // special edge case of a TOP most repetition after which the input should END.
    // this will force an attempt for inRule recovery in that scenario.
    if (this.RULE_STACK.length === 1 && isEndOfRule && expectTokAfterLastMatch === undefined) {
        expectTokAfterLastMatch = (0, $hvAWv.EOF);
        nextTokIdx = 1;
    }
    if (this.shouldInRepetitionRecoveryBeTried(expectTokAfterLastMatch, nextTokIdx, notStuck)) // TODO: performance optimization: instead of passing the original args here, we modify
    // the args param (or create a new one) and make sure the lookahead func is explicitly provided
    // to avoid searching the cache for it once more.
    this.tryInRepetitionRecovery(prodFunc, args, lookaheadFunc, expectTokAfterLastMatch);
}

});
parcelRegister("czA2c", function(module, exports) {

$parcel$export(module.exports, "isRecognitionException", function () { return $9274b4a0b1f875a4$export$93d1e12f7a3ec65; });
$parcel$export(module.exports, "MismatchedTokenException", function () { return $9274b4a0b1f875a4$export$e052327bfb3cf890; });
$parcel$export(module.exports, "NoViableAltException", function () { return $9274b4a0b1f875a4$export$24170894ee7a3e61; });
$parcel$export(module.exports, "NotAllInputParsedException", function () { return $9274b4a0b1f875a4$export$3d36978a8da4a7e; });
$parcel$export(module.exports, "EarlyExitException", function () { return $9274b4a0b1f875a4$export$d9af24ca3761c042; });

var $5mLYn = parcelRequire("5mLYn");
var $9274b4a0b1f875a4$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $9274b4a0b1f875a4$var$MISMATCHED_TOKEN_EXCEPTION = "MismatchedTokenException";
var $9274b4a0b1f875a4$var$NO_VIABLE_ALT_EXCEPTION = "NoViableAltException";
var $9274b4a0b1f875a4$var$EARLY_EXIT_EXCEPTION = "EarlyExitException";
var $9274b4a0b1f875a4$var$NOT_ALL_INPUT_PARSED_EXCEPTION = "NotAllInputParsedException";
var $9274b4a0b1f875a4$var$RECOGNITION_EXCEPTION_NAMES = [
    $9274b4a0b1f875a4$var$MISMATCHED_TOKEN_EXCEPTION,
    $9274b4a0b1f875a4$var$NO_VIABLE_ALT_EXCEPTION,
    $9274b4a0b1f875a4$var$EARLY_EXIT_EXCEPTION,
    $9274b4a0b1f875a4$var$NOT_ALL_INPUT_PARSED_EXCEPTION
];
Object.freeze($9274b4a0b1f875a4$var$RECOGNITION_EXCEPTION_NAMES);
function $9274b4a0b1f875a4$export$93d1e12f7a3ec65(error) {
    // can't do instanceof on hacked custom js exceptions
    return (0, $5mLYn.contains)($9274b4a0b1f875a4$var$RECOGNITION_EXCEPTION_NAMES, error.name);
}
var $9274b4a0b1f875a4$var$RecognitionException = /** @class */ function(_super) {
    $9274b4a0b1f875a4$var$__extends(RecognitionException, _super);
    function RecognitionException(message, token) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.token = token;
        _this.resyncedTokens = [];
        // fix prototype chain when typescript target is ES5
        Object.setPrototypeOf(_this, _newTarget.prototype);
        /* istanbul ignore next - V8 workaround to remove constructor from stacktrace when typescript target is ES5 */ if (Error.captureStackTrace) Error.captureStackTrace(_this, _this.constructor);
        return _this;
    }
    return RecognitionException;
}(Error);
var $9274b4a0b1f875a4$export$e052327bfb3cf890 = /** @class */ function(_super) {
    $9274b4a0b1f875a4$var$__extends(MismatchedTokenException, _super);
    function MismatchedTokenException(message, token, previousToken) {
        var _this = _super.call(this, message, token) || this;
        _this.previousToken = previousToken;
        _this.name = $9274b4a0b1f875a4$var$MISMATCHED_TOKEN_EXCEPTION;
        return _this;
    }
    return MismatchedTokenException;
}($9274b4a0b1f875a4$var$RecognitionException);
var $9274b4a0b1f875a4$export$24170894ee7a3e61 = /** @class */ function(_super) {
    $9274b4a0b1f875a4$var$__extends(NoViableAltException, _super);
    function NoViableAltException(message, token, previousToken) {
        var _this = _super.call(this, message, token) || this;
        _this.previousToken = previousToken;
        _this.name = $9274b4a0b1f875a4$var$NO_VIABLE_ALT_EXCEPTION;
        return _this;
    }
    return NoViableAltException;
}($9274b4a0b1f875a4$var$RecognitionException);
var $9274b4a0b1f875a4$export$3d36978a8da4a7e = /** @class */ function(_super) {
    $9274b4a0b1f875a4$var$__extends(NotAllInputParsedException, _super);
    function NotAllInputParsedException(message, token) {
        var _this = _super.call(this, message, token) || this;
        _this.name = $9274b4a0b1f875a4$var$NOT_ALL_INPUT_PARSED_EXCEPTION;
        return _this;
    }
    return NotAllInputParsedException;
}($9274b4a0b1f875a4$var$RecognitionException);
var $9274b4a0b1f875a4$export$d9af24ca3761c042 = /** @class */ function(_super) {
    $9274b4a0b1f875a4$var$__extends(EarlyExitException, _super);
    function EarlyExitException(message, token, previousToken) {
        var _this = _super.call(this, message, token) || this;
        _this.previousToken = previousToken;
        _this.name = $9274b4a0b1f875a4$var$EARLY_EXIT_EXCEPTION;
        return _this;
    }
    return EarlyExitException;
}($9274b4a0b1f875a4$var$RecognitionException);

});


parcelRegister("32FQp", function(module, exports) {

$parcel$export(module.exports, "LooksAhead", function () { return $2372046b727735a6$export$5fce7ca30304ee90; });

var $1eoLt = parcelRequire("1eoLt");

var $5mLYn = parcelRequire("5mLYn");

var $5qjkp = parcelRequire("5qjkp");

var $ghJuf = parcelRequire("ghJuf");

var $h6YGr = parcelRequire("h6YGr");
/**
 * Trait responsible for the lookahead related utilities and optimizations.
 */ var $2372046b727735a6$export$5fce7ca30304ee90 = /** @class */ function() {
    function LooksAhead() {}
    LooksAhead.prototype.initLooksAhead = function(config) {
        this.dynamicTokensEnabled = (0, $5mLYn.has)(config, "dynamicTokensEnabled") ? config.dynamicTokensEnabled : (0, $5qjkp.DEFAULT_PARSER_CONFIG).dynamicTokensEnabled;
        this.maxLookahead = (0, $5mLYn.has)(config, "maxLookahead") ? config.maxLookahead : (0, $5qjkp.DEFAULT_PARSER_CONFIG).maxLookahead;
        /* istanbul ignore next - Using plain array as dictionary will be tested on older node.js versions and IE11 */ this.lookAheadFuncsCache = (0, $5mLYn.isES2015MapSupported)() ? new Map() : [];
        // Performance optimization on newer engines that support ES6 Map
        // For larger Maps this is slightly faster than using a plain object (array in our case).
        /* istanbul ignore else - The else branch will be tested on older node.js versions and IE11 */ if ((0, $5mLYn.isES2015MapSupported)()) {
            this.getLaFuncFromCache = this.getLaFuncFromMap;
            this.setLaFuncCache = this.setLaFuncCacheUsingMap;
        } else {
            this.getLaFuncFromCache = this.getLaFuncFromObj;
            this.setLaFuncCache = this.setLaFuncUsingObj;
        }
    };
    LooksAhead.prototype.preComputeLookaheadFunctions = function(rules) {
        var _this = this;
        (0, $5mLYn.forEach)(rules, function(currRule) {
            _this.TRACE_INIT(currRule.name + " Rule Lookahead", function() {
                var _a = (0, $h6YGr.collectMethods)(currRule), alternation = _a.alternation, repetition = _a.repetition, option = _a.option, repetitionMandatory = _a.repetitionMandatory, repetitionMandatoryWithSeparator = _a.repetitionMandatoryWithSeparator, repetitionWithSeparator = _a.repetitionWithSeparator;
                (0, $5mLYn.forEach)(alternation, function(currProd) {
                    var prodIdx = currProd.idx === 0 ? "" : currProd.idx;
                    _this.TRACE_INIT("" + (0, $h6YGr.getProductionDslName)(currProd) + prodIdx, function() {
                        var laFunc = (0, $1eoLt.buildLookaheadFuncForOr)(currProd.idx, currRule, currProd.maxLookahead || _this.maxLookahead, currProd.hasPredicates, _this.dynamicTokensEnabled, _this.lookAheadBuilderForAlternatives);
                        var key = (0, $ghJuf.getKeyForAutomaticLookahead)(_this.fullRuleNameToShort[currRule.name], (0, $ghJuf.OR_IDX), currProd.idx);
                        _this.setLaFuncCache(key, laFunc);
                    });
                });
                (0, $5mLYn.forEach)(repetition, function(currProd) {
                    _this.computeLookaheadFunc(currRule, currProd.idx, (0, $ghJuf.MANY_IDX), (0, $1eoLt.PROD_TYPE).REPETITION, currProd.maxLookahead, (0, $h6YGr.getProductionDslName)(currProd));
                });
                (0, $5mLYn.forEach)(option, function(currProd) {
                    _this.computeLookaheadFunc(currRule, currProd.idx, (0, $ghJuf.OPTION_IDX), (0, $1eoLt.PROD_TYPE).OPTION, currProd.maxLookahead, (0, $h6YGr.getProductionDslName)(currProd));
                });
                (0, $5mLYn.forEach)(repetitionMandatory, function(currProd) {
                    _this.computeLookaheadFunc(currRule, currProd.idx, (0, $ghJuf.AT_LEAST_ONE_IDX), (0, $1eoLt.PROD_TYPE).REPETITION_MANDATORY, currProd.maxLookahead, (0, $h6YGr.getProductionDslName)(currProd));
                });
                (0, $5mLYn.forEach)(repetitionMandatoryWithSeparator, function(currProd) {
                    _this.computeLookaheadFunc(currRule, currProd.idx, (0, $ghJuf.AT_LEAST_ONE_SEP_IDX), (0, $1eoLt.PROD_TYPE).REPETITION_MANDATORY_WITH_SEPARATOR, currProd.maxLookahead, (0, $h6YGr.getProductionDslName)(currProd));
                });
                (0, $5mLYn.forEach)(repetitionWithSeparator, function(currProd) {
                    _this.computeLookaheadFunc(currRule, currProd.idx, (0, $ghJuf.MANY_SEP_IDX), (0, $1eoLt.PROD_TYPE).REPETITION_WITH_SEPARATOR, currProd.maxLookahead, (0, $h6YGr.getProductionDslName)(currProd));
                });
            });
        });
    };
    LooksAhead.prototype.computeLookaheadFunc = function(rule, prodOccurrence, prodKey, prodType, prodMaxLookahead, dslMethodName) {
        var _this = this;
        this.TRACE_INIT("" + dslMethodName + (prodOccurrence === 0 ? "" : prodOccurrence), function() {
            var laFunc = (0, $1eoLt.buildLookaheadFuncForOptionalProd)(prodOccurrence, rule, prodMaxLookahead || _this.maxLookahead, _this.dynamicTokensEnabled, prodType, _this.lookAheadBuilderForOptional);
            var key = (0, $ghJuf.getKeyForAutomaticLookahead)(_this.fullRuleNameToShort[rule.name], prodKey, prodOccurrence);
            _this.setLaFuncCache(key, laFunc);
        });
    };
    LooksAhead.prototype.lookAheadBuilderForOptional = function(alt, tokenMatcher, dynamicTokensEnabled) {
        return (0, $1eoLt.buildSingleAlternativeLookaheadFunction)(alt, tokenMatcher, dynamicTokensEnabled);
    };
    LooksAhead.prototype.lookAheadBuilderForAlternatives = function(alts, hasPredicates, tokenMatcher, dynamicTokensEnabled) {
        return (0, $1eoLt.buildAlternativesLookAheadFunc)(alts, hasPredicates, tokenMatcher, dynamicTokensEnabled);
    };
    // this actually returns a number, but it is always used as a string (object prop key)
    LooksAhead.prototype.getKeyForAutomaticLookahead = function(dslMethodIdx, occurrence) {
        var currRuleShortName = this.getLastExplicitRuleShortName();
        return (0, $ghJuf.getKeyForAutomaticLookahead)(currRuleShortName, dslMethodIdx, occurrence);
    };
    /* istanbul ignore next */ LooksAhead.prototype.getLaFuncFromCache = function(key) {
        return undefined;
    };
    LooksAhead.prototype.getLaFuncFromMap = function(key) {
        return this.lookAheadFuncsCache.get(key);
    };
    /* istanbul ignore next - Using plain array as dictionary will be tested on older node.js versions and IE11 */ LooksAhead.prototype.getLaFuncFromObj = function(key) {
        return this.lookAheadFuncsCache[key];
    };
    /* istanbul ignore next */ LooksAhead.prototype.setLaFuncCache = function(key, value) {};
    LooksAhead.prototype.setLaFuncCacheUsingMap = function(key, value) {
        this.lookAheadFuncsCache.set(key, value);
    };
    /* istanbul ignore next - Using plain array as dictionary will be tested on older node.js versions and IE11 */ LooksAhead.prototype.setLaFuncUsingObj = function(key, value) {
        this.lookAheadFuncsCache[key] = value;
    };
    return LooksAhead;
}();

});
parcelRegister("ghJuf", function(module, exports) {

$parcel$export(module.exports, "BITS_FOR_METHOD_TYPE", function () { return $bdb184a3902b5e47$export$5e183b9237632fb0; });
$parcel$export(module.exports, "BITS_FOR_OCCURRENCE_IDX", function () { return $bdb184a3902b5e47$export$8ca859b92c75629e; });
$parcel$export(module.exports, "OR_IDX", function () { return $bdb184a3902b5e47$export$4fd82c2c3a6ad708; });
$parcel$export(module.exports, "OPTION_IDX", function () { return $bdb184a3902b5e47$export$968ae8e9df9ba24e; });
$parcel$export(module.exports, "MANY_IDX", function () { return $bdb184a3902b5e47$export$599490a8fb295307; });
$parcel$export(module.exports, "AT_LEAST_ONE_IDX", function () { return $bdb184a3902b5e47$export$c73e92093a00980a; });
$parcel$export(module.exports, "MANY_SEP_IDX", function () { return $bdb184a3902b5e47$export$3652de3f0352abe; });
$parcel$export(module.exports, "AT_LEAST_ONE_SEP_IDX", function () { return $bdb184a3902b5e47$export$5d8d72c4ccd413b7; });
$parcel$export(module.exports, "getKeyForAutomaticLookahead", function () { return $bdb184a3902b5e47$export$d5d60d41644f341c; });
// Lookahead keys are 32Bit integers in the form
// TTTTTTTT-ZZZZZZZZZZZZ-YYYY-XXXXXXXX
// XXXX -> Occurrence Index bitmap.
// YYYY -> DSL Method Type bitmap.
// ZZZZZZZZZZZZZZZ -> Rule short Index bitmap.
// TTTTTTTTT -> alternation alternative index bitmap
var $bdb184a3902b5e47$export$5e183b9237632fb0 = 4;
var $bdb184a3902b5e47$export$8ca859b92c75629e = 8;
var $bdb184a3902b5e47$export$f578bda4769e79ea = 12;
var $bdb184a3902b5e47$export$1b517d7e23367175 = 8;
var $bdb184a3902b5e47$export$4fd82c2c3a6ad708 = 1 << $bdb184a3902b5e47$export$8ca859b92c75629e;
var $bdb184a3902b5e47$export$968ae8e9df9ba24e = 2 << $bdb184a3902b5e47$export$8ca859b92c75629e;
var $bdb184a3902b5e47$export$599490a8fb295307 = 3 << $bdb184a3902b5e47$export$8ca859b92c75629e;
var $bdb184a3902b5e47$export$c73e92093a00980a = 4 << $bdb184a3902b5e47$export$8ca859b92c75629e;
var $bdb184a3902b5e47$export$3652de3f0352abe = 5 << $bdb184a3902b5e47$export$8ca859b92c75629e;
var $bdb184a3902b5e47$export$5d8d72c4ccd413b7 = 6 << $bdb184a3902b5e47$export$8ca859b92c75629e;
function $bdb184a3902b5e47$export$d5d60d41644f341c(ruleIdx, dslMethodIdx, occurrence) {
    /* tslint:disable */ return occurrence | dslMethodIdx | ruleIdx;
/* tslint:enable */ }
var $bdb184a3902b5e47$var$BITS_START_FOR_ALT_IDX = 32 - $bdb184a3902b5e47$export$1b517d7e23367175;

});


parcelRegister("8zxTb", function(module, exports) {

$parcel$export(module.exports, "TreeBuilder", function () { return $63dbe14a34847bb7$export$dffab5a81d5c7692; });

var $3QJ7L = parcelRequire("3QJ7L");

var $5mLYn = parcelRequire("5mLYn");

var $1ajIG = parcelRequire("1ajIG");

var $5qjkp = parcelRequire("5qjkp");
/**
 * This trait is responsible for the CST building logic.
 */ var $63dbe14a34847bb7$export$dffab5a81d5c7692 = /** @class */ function() {
    function TreeBuilder() {}
    TreeBuilder.prototype.initTreeBuilder = function(config) {
        this.CST_STACK = [];
        // outputCst is no longer exposed/defined in the pubic API
        this.outputCst = config.outputCst;
        this.nodeLocationTracking = (0, $5mLYn.has)(config, "nodeLocationTracking") ? config.nodeLocationTracking : (0, $5qjkp.DEFAULT_PARSER_CONFIG).nodeLocationTracking;
        if (!this.outputCst) {
            this.cstInvocationStateUpdate = (0, $5mLYn.NOOP);
            this.cstFinallyStateUpdate = (0, $5mLYn.NOOP);
            this.cstPostTerminal = (0, $5mLYn.NOOP);
            this.cstPostNonTerminal = (0, $5mLYn.NOOP);
            this.cstPostRule = (0, $5mLYn.NOOP);
        } else {
            if (/full/i.test(this.nodeLocationTracking)) {
                if (this.recoveryEnabled) {
                    this.setNodeLocationFromToken = (0, $3QJ7L.setNodeLocationFull);
                    this.setNodeLocationFromNode = (0, $3QJ7L.setNodeLocationFull);
                    this.cstPostRule = (0, $5mLYn.NOOP);
                    this.setInitialNodeLocation = this.setInitialNodeLocationFullRecovery;
                } else {
                    this.setNodeLocationFromToken = (0, $5mLYn.NOOP);
                    this.setNodeLocationFromNode = (0, $5mLYn.NOOP);
                    this.cstPostRule = this.cstPostRuleFull;
                    this.setInitialNodeLocation = this.setInitialNodeLocationFullRegular;
                }
            } else if (/onlyOffset/i.test(this.nodeLocationTracking)) {
                if (this.recoveryEnabled) {
                    this.setNodeLocationFromToken = (0, $3QJ7L.setNodeLocationOnlyOffset);
                    this.setNodeLocationFromNode = (0, $3QJ7L.setNodeLocationOnlyOffset);
                    this.cstPostRule = (0, $5mLYn.NOOP);
                    this.setInitialNodeLocation = this.setInitialNodeLocationOnlyOffsetRecovery;
                } else {
                    this.setNodeLocationFromToken = (0, $5mLYn.NOOP);
                    this.setNodeLocationFromNode = (0, $5mLYn.NOOP);
                    this.cstPostRule = this.cstPostRuleOnlyOffset;
                    this.setInitialNodeLocation = this.setInitialNodeLocationOnlyOffsetRegular;
                }
            } else if (/none/i.test(this.nodeLocationTracking)) {
                this.setNodeLocationFromToken = (0, $5mLYn.NOOP);
                this.setNodeLocationFromNode = (0, $5mLYn.NOOP);
                this.cstPostRule = (0, $5mLYn.NOOP);
                this.setInitialNodeLocation = (0, $5mLYn.NOOP);
            } else throw Error('Invalid <nodeLocationTracking> config option: "' + config.nodeLocationTracking + '"');
        }
    };
    TreeBuilder.prototype.setInitialNodeLocationOnlyOffsetRecovery = function(cstNode) {
        cstNode.location = {
            startOffset: NaN,
            endOffset: NaN
        };
    };
    TreeBuilder.prototype.setInitialNodeLocationOnlyOffsetRegular = function(cstNode) {
        cstNode.location = {
            // without error recovery the starting Location of a new CstNode is guaranteed
            // To be the next Token's startOffset (for valid inputs).
            // For invalid inputs there won't be any CSTOutput so this potential
            // inaccuracy does not matter
            startOffset: this.LA(1).startOffset,
            endOffset: NaN
        };
    };
    TreeBuilder.prototype.setInitialNodeLocationFullRecovery = function(cstNode) {
        cstNode.location = {
            startOffset: NaN,
            startLine: NaN,
            startColumn: NaN,
            endOffset: NaN,
            endLine: NaN,
            endColumn: NaN
        };
    };
    /**
       *  @see setInitialNodeLocationOnlyOffsetRegular for explanation why this work
  
       * @param cstNode
       */ TreeBuilder.prototype.setInitialNodeLocationFullRegular = function(cstNode) {
        var nextToken = this.LA(1);
        cstNode.location = {
            startOffset: nextToken.startOffset,
            startLine: nextToken.startLine,
            startColumn: nextToken.startColumn,
            endOffset: NaN,
            endLine: NaN,
            endColumn: NaN
        };
    };
    TreeBuilder.prototype.cstInvocationStateUpdate = function(fullRuleName, shortName) {
        var cstNode = {
            name: fullRuleName,
            children: {}
        };
        this.setInitialNodeLocation(cstNode);
        this.CST_STACK.push(cstNode);
    };
    TreeBuilder.prototype.cstFinallyStateUpdate = function() {
        this.CST_STACK.pop();
    };
    TreeBuilder.prototype.cstPostRuleFull = function(ruleCstNode) {
        var prevToken = this.LA(0);
        var loc = ruleCstNode.location;
        // If this condition is true it means we consumed at least one Token
        // In this CstNode.
        if (loc.startOffset <= prevToken.startOffset === true) {
            loc.endOffset = prevToken.endOffset;
            loc.endLine = prevToken.endLine;
            loc.endColumn = prevToken.endColumn;
        } else {
            loc.startOffset = NaN;
            loc.startLine = NaN;
            loc.startColumn = NaN;
        }
    };
    TreeBuilder.prototype.cstPostRuleOnlyOffset = function(ruleCstNode) {
        var prevToken = this.LA(0);
        var loc = ruleCstNode.location;
        // If this condition is true it means we consumed at least one Token
        // In this CstNode.
        if (loc.startOffset <= prevToken.startOffset === true) loc.endOffset = prevToken.endOffset;
        else loc.startOffset = NaN;
    };
    TreeBuilder.prototype.cstPostTerminal = function(key, consumedToken) {
        var rootCst = this.CST_STACK[this.CST_STACK.length - 1];
        (0, $3QJ7L.addTerminalToCst)(rootCst, consumedToken, key);
        // This is only used when **both** error recovery and CST Output are enabled.
        this.setNodeLocationFromToken(rootCst.location, consumedToken);
    };
    TreeBuilder.prototype.cstPostNonTerminal = function(ruleCstResult, ruleName) {
        var preCstNode = this.CST_STACK[this.CST_STACK.length - 1];
        (0, $3QJ7L.addNoneTerminalToCst)(preCstNode, ruleName, ruleCstResult);
        // This is only used when **both** error recovery and CST Output are enabled.
        this.setNodeLocationFromNode(preCstNode.location, ruleCstResult.location);
    };
    TreeBuilder.prototype.getBaseCstVisitorConstructor = function() {
        if ((0, $5mLYn.isUndefined)(this.baseCstVisitorConstructor)) {
            var newBaseCstVisitorConstructor = (0, $1ajIG.createBaseSemanticVisitorConstructor)(this.className, (0, $5mLYn.keys)(this.gastProductionsCache));
            this.baseCstVisitorConstructor = newBaseCstVisitorConstructor;
            return newBaseCstVisitorConstructor;
        }
        return this.baseCstVisitorConstructor;
    };
    TreeBuilder.prototype.getBaseCstVisitorConstructorWithDefaults = function() {
        if ((0, $5mLYn.isUndefined)(this.baseCstVisitorWithDefaultsConstructor)) {
            var newConstructor = (0, $1ajIG.createBaseVisitorConstructorWithDefaults)(this.className, (0, $5mLYn.keys)(this.gastProductionsCache), this.getBaseCstVisitorConstructor());
            this.baseCstVisitorWithDefaultsConstructor = newConstructor;
            return newConstructor;
        }
        return this.baseCstVisitorWithDefaultsConstructor;
    };
    TreeBuilder.prototype.getLastExplicitRuleShortName = function() {
        var ruleStack = this.RULE_STACK;
        return ruleStack[ruleStack.length - 1];
    };
    TreeBuilder.prototype.getPreviousExplicitRuleShortName = function() {
        var ruleStack = this.RULE_STACK;
        return ruleStack[ruleStack.length - 2];
    };
    TreeBuilder.prototype.getLastExplicitRuleOccurrenceIndex = function() {
        var occurrenceStack = this.RULE_OCCURRENCE_STACK;
        return occurrenceStack[occurrenceStack.length - 1];
    };
    return TreeBuilder;
}();

});
parcelRegister("3QJ7L", function(module, exports) {

$parcel$export(module.exports, "setNodeLocationOnlyOffset", function () { return $2cd93b24e5442c5d$export$7a1b2d015ea35ce5; });
$parcel$export(module.exports, "setNodeLocationFull", function () { return $2cd93b24e5442c5d$export$e22023f804d69ea7; });
$parcel$export(module.exports, "addTerminalToCst", function () { return $2cd93b24e5442c5d$export$ebea31084d5048a7; });
$parcel$export(module.exports, "addNoneTerminalToCst", function () { return $2cd93b24e5442c5d$export$f2bfe1cacb58e074; });
/**
 * This nodeLocation tracking is not efficient and should only be used
 * when error recovery is enabled or the Token Vector contains virtual Tokens
 * (e.g, Python Indent/Outdent)
 * As it executes the calculation for every single terminal/nonTerminal
 * and does not rely on the fact the token vector is **sorted**
 */ function $2cd93b24e5442c5d$export$7a1b2d015ea35ce5(currNodeLocation, newLocationInfo) {
    // First (valid) update for this cst node
    if (isNaN(currNodeLocation.startOffset) === true) {
        // assumption1: Token location information is either NaN or a valid number
        // assumption2: Token location information is fully valid if it exist
        // (both start/end offsets exist and are numbers).
        currNodeLocation.startOffset = newLocationInfo.startOffset;
        currNodeLocation.endOffset = newLocationInfo.endOffset;
    } else if (currNodeLocation.endOffset < newLocationInfo.endOffset === true) currNodeLocation.endOffset = newLocationInfo.endOffset;
}
function $2cd93b24e5442c5d$export$e22023f804d69ea7(currNodeLocation, newLocationInfo) {
    // First (valid) update for this cst node
    if (isNaN(currNodeLocation.startOffset) === true) {
        // assumption1: Token location information is either NaN or a valid number
        // assumption2: Token location information is fully valid if it exist
        // (all start/end props exist and are numbers).
        currNodeLocation.startOffset = newLocationInfo.startOffset;
        currNodeLocation.startColumn = newLocationInfo.startColumn;
        currNodeLocation.startLine = newLocationInfo.startLine;
        currNodeLocation.endOffset = newLocationInfo.endOffset;
        currNodeLocation.endColumn = newLocationInfo.endColumn;
        currNodeLocation.endLine = newLocationInfo.endLine;
    } else if (currNodeLocation.endOffset < newLocationInfo.endOffset === true) {
        currNodeLocation.endOffset = newLocationInfo.endOffset;
        currNodeLocation.endColumn = newLocationInfo.endColumn;
        currNodeLocation.endLine = newLocationInfo.endLine;
    }
}
function $2cd93b24e5442c5d$export$ebea31084d5048a7(node, token, tokenTypeName) {
    if (node.children[tokenTypeName] === undefined) node.children[tokenTypeName] = [
        token
    ];
    else node.children[tokenTypeName].push(token);
}
function $2cd93b24e5442c5d$export$f2bfe1cacb58e074(node, ruleName, ruleResult) {
    if (node.children[ruleName] === undefined) node.children[ruleName] = [
        ruleResult
    ];
    else node.children[ruleName].push(ruleResult);
}

});

parcelRegister("1ajIG", function(module, exports) {

$parcel$export(module.exports, "createBaseSemanticVisitorConstructor", function () { return $0d96058e6d4fdf60$export$bedc9ecc57361ce8; });
$parcel$export(module.exports, "createBaseVisitorConstructorWithDefaults", function () { return $0d96058e6d4fdf60$export$8ea66c63aac09bbc; });

var $5mLYn = parcelRequire("5mLYn");

var $25eU6 = parcelRequire("25eU6");
function $0d96058e6d4fdf60$export$899c01e57e57780c(ctx, param) {
    var childrenNames = (0, $5mLYn.keys)(ctx);
    var childrenNamesLength = childrenNames.length;
    for(var i = 0; i < childrenNamesLength; i++){
        var currChildName = childrenNames[i];
        var currChildArray = ctx[currChildName];
        var currChildArrayLength = currChildArray.length;
        for(var j = 0; j < currChildArrayLength; j++){
            var currChild = currChildArray[j];
            // distinction between Tokens Children and CstNode children
            if (currChild.tokenTypeIdx === undefined) this[currChild.name](currChild.children, param);
        }
    }
    // defaultVisit does not support generic out param
    return undefined;
}
function $0d96058e6d4fdf60$export$bedc9ecc57361ce8(grammarName, ruleNames) {
    var derivedConstructor = function() {};
    // can be overwritten according to:
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/
    // name?redirectlocale=en-US&redirectslug=JavaScript%2FReference%2FGlobal_Objects%2FFunction%2Fname
    (0, $25eU6.defineNameProp)(derivedConstructor, grammarName + "BaseSemantics");
    var semanticProto = {
        visit: function(cstNode, param) {
            // enables writing more concise visitor methods when CstNode has only a single child
            if ((0, $5mLYn.isArray)(cstNode)) // A CST Node's children dictionary can never have empty arrays as values
            // If a key is defined there will be at least one element in the corresponding value array.
            cstNode = cstNode[0];
            // enables passing optional CstNodes concisely.
            if ((0, $5mLYn.isUndefined)(cstNode)) return undefined;
            return this[cstNode.name](cstNode.children, param);
        },
        validateVisitor: function() {
            var semanticDefinitionErrors = $0d96058e6d4fdf60$export$4509375765ce59f3(this, ruleNames);
            if (!(0, $5mLYn.isEmpty)(semanticDefinitionErrors)) {
                var errorMessages = (0, $5mLYn.map)(semanticDefinitionErrors, function(currDefError) {
                    return currDefError.msg;
                });
                throw Error("Errors Detected in CST Visitor <" + (0, $25eU6.functionName)(this.constructor) + ">:\n	" + ("" + errorMessages.join("\n\n").replace(/\n/g, "\n	")));
            }
        }
    };
    derivedConstructor.prototype = semanticProto;
    derivedConstructor.prototype.constructor = derivedConstructor;
    derivedConstructor._RULE_NAMES = ruleNames;
    return derivedConstructor;
}
function $0d96058e6d4fdf60$export$8ea66c63aac09bbc(grammarName, ruleNames, baseConstructor) {
    var derivedConstructor = function() {};
    // can be overwritten according to:
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/
    // name?redirectlocale=en-US&redirectslug=JavaScript%2FReference%2FGlobal_Objects%2FFunction%2Fname
    (0, $25eU6.defineNameProp)(derivedConstructor, grammarName + "BaseSemanticsWithDefaults");
    var withDefaultsProto = Object.create(baseConstructor.prototype);
    (0, $5mLYn.forEach)(ruleNames, function(ruleName) {
        withDefaultsProto[ruleName] = $0d96058e6d4fdf60$export$899c01e57e57780c;
    });
    derivedConstructor.prototype = withDefaultsProto;
    derivedConstructor.prototype.constructor = derivedConstructor;
    return derivedConstructor;
}
var $0d96058e6d4fdf60$export$1aee55e0d12497e9;
(function(CstVisitorDefinitionError) {
    CstVisitorDefinitionError[CstVisitorDefinitionError["REDUNDANT_METHOD"] = 0] = "REDUNDANT_METHOD";
    CstVisitorDefinitionError[CstVisitorDefinitionError["MISSING_METHOD"] = 1] = "MISSING_METHOD";
})($0d96058e6d4fdf60$export$1aee55e0d12497e9 || ($0d96058e6d4fdf60$export$1aee55e0d12497e9 = {}));
function $0d96058e6d4fdf60$export$4509375765ce59f3(visitorInstance, ruleNames) {
    var missingErrors = $0d96058e6d4fdf60$export$e1a1adac9586a66c(visitorInstance, ruleNames);
    var redundantErrors = $0d96058e6d4fdf60$export$d3a9a1867125c2cd(visitorInstance, ruleNames);
    return missingErrors.concat(redundantErrors);
}
function $0d96058e6d4fdf60$export$e1a1adac9586a66c(visitorInstance, ruleNames) {
    var errors = (0, $5mLYn.map)(ruleNames, function(currRuleName) {
        if (!(0, $5mLYn.isFunction)(visitorInstance[currRuleName])) return {
            msg: "Missing visitor method: <" + currRuleName + "> on " + (0, $25eU6.functionName)(visitorInstance.constructor) + " CST Visitor.",
            type: $0d96058e6d4fdf60$export$1aee55e0d12497e9.MISSING_METHOD,
            methodName: currRuleName
        };
    });
    return (0, $5mLYn.compact)(errors);
}
var $0d96058e6d4fdf60$var$VALID_PROP_NAMES = [
    "constructor",
    "visit",
    "validateVisitor"
];
function $0d96058e6d4fdf60$export$d3a9a1867125c2cd(visitorInstance, ruleNames) {
    var errors = [];
    for(var prop in visitorInstance)if ((0, $5mLYn.isFunction)(visitorInstance[prop]) && !(0, $5mLYn.contains)($0d96058e6d4fdf60$var$VALID_PROP_NAMES, prop) && !(0, $5mLYn.contains)(ruleNames, prop)) errors.push({
        msg: "Redundant visitor method: <" + prop + "> on " + (0, $25eU6.functionName)(visitorInstance.constructor) + " CST Visitor\n" + "There is no Grammar Rule corresponding to this method's name.\n",
        type: $0d96058e6d4fdf60$export$1aee55e0d12497e9.REDUNDANT_METHOD,
        methodName: prop
    });
    return errors;
}

});
parcelRegister("25eU6", function(module, exports) {

$parcel$export(module.exports, "classNameFromInstance", function () { return $18479bfcf7d74476$export$752923150d956d97; });
$parcel$export(module.exports, "functionName", function () { return $18479bfcf7d74476$export$84c48ba556ba6f42; });
$parcel$export(module.exports, "defineNameProp", function () { return $18479bfcf7d74476$export$277f91cbe0231dcf; });

var $5mLYn = parcelRequire("5mLYn");
function $18479bfcf7d74476$export$752923150d956d97(instance) {
    return $18479bfcf7d74476$export$84c48ba556ba6f42(instance.constructor);
}
var $18479bfcf7d74476$var$NAME = "name";
function $18479bfcf7d74476$export$84c48ba556ba6f42(func) {
    // Engines that support Function.prototype.name OR the nth (n>1) time after
    // the name has been computed in the following else block.
    var existingNameProp = func.name;
    /* istanbul ignore else - too many hacks for IE/old versions of node.js here*/ if (existingNameProp) return existingNameProp;
    else return "anonymous";
}
function $18479bfcf7d74476$export$277f91cbe0231dcf(obj, nameValue) {
    var namePropDescriptor = Object.getOwnPropertyDescriptor(obj, $18479bfcf7d74476$var$NAME);
    /* istanbul ignore else -> will only run in old versions of node.js */ if ((0, $5mLYn.isUndefined)(namePropDescriptor) || namePropDescriptor.configurable) {
        Object.defineProperty(obj, $18479bfcf7d74476$var$NAME, {
            enumerable: false,
            configurable: true,
            writable: false,
            value: nameValue
        });
        return true;
    }
    /* istanbul ignore next -> will only run in old versions of node.js */ return false;
}

});



parcelRegister("awxar", function(module, exports) {

$parcel$export(module.exports, "LexerAdapter", function () { return $7a969eea8d29741a$export$13fc19cea200b41; });

var $5qjkp = parcelRequire("5qjkp");
/**
 * Trait responsible abstracting over the interaction with Lexer output (Token vector).
 *
 * This could be generalized to support other kinds of lexers, e.g.
 * - Just in Time Lexing / Lexer-Less parsing.
 * - Streaming Lexer.
 */ var $7a969eea8d29741a$export$13fc19cea200b41 = /** @class */ function() {
    function LexerAdapter() {}
    LexerAdapter.prototype.initLexerAdapter = function() {
        this.tokVector = [];
        this.tokVectorLength = 0;
        this.currIdx = -1;
    };
    Object.defineProperty(LexerAdapter.prototype, "input", {
        get: function() {
            return this.tokVector;
        },
        set: function(newInput) {
            // @ts-ignore - `this parameter` not supported in setters/getters
            //   - https://www.typescriptlang.org/docs/handbook/functions.html#this-parameters
            if (this.selfAnalysisDone !== true) throw Error("Missing <performSelfAnalysis> invocation at the end of the Parser's constructor.");
            // @ts-ignore - `this parameter` not supported in setters/getters
            //   - https://www.typescriptlang.org/docs/handbook/functions.html#this-parameters
            this.reset();
            this.tokVector = newInput;
            this.tokVectorLength = newInput.length;
        },
        enumerable: false,
        configurable: true
    });
    // skips a token and returns the next token
    LexerAdapter.prototype.SKIP_TOKEN = function() {
        if (this.currIdx <= this.tokVector.length - 2) {
            this.consumeToken();
            return this.LA(1);
        } else return 0, $5qjkp.END_OF_FILE;
    };
    // Lexer (accessing Token vector) related methods which can be overridden to implement lazy lexers
    // or lexers dependent on parser context.
    LexerAdapter.prototype.LA = function(howMuch) {
        var soughtIdx = this.currIdx + howMuch;
        if (soughtIdx < 0 || this.tokVectorLength <= soughtIdx) return 0, $5qjkp.END_OF_FILE;
        else return this.tokVector[soughtIdx];
    };
    LexerAdapter.prototype.consumeToken = function() {
        this.currIdx++;
    };
    LexerAdapter.prototype.exportLexerState = function() {
        return this.currIdx;
    };
    LexerAdapter.prototype.importLexerState = function(newState) {
        this.currIdx = newState;
    };
    LexerAdapter.prototype.resetLexerState = function() {
        this.currIdx = -1;
    };
    LexerAdapter.prototype.moveToTerminatedState = function() {
        this.currIdx = this.tokVector.length - 1;
    };
    LexerAdapter.prototype.getLexerPosition = function() {
        return this.exportLexerState();
    };
    return LexerAdapter;
}();

});

parcelRegister("lzzFw", function(module, exports) {

$parcel$export(module.exports, "RecognizerApi", function () { return $fb4888ed45c6f80b$export$48759acf3d590118; });

var $5mLYn = parcelRequire("5mLYn");

var $czA2c = parcelRequire("czA2c");

var $5qjkp = parcelRequire("5qjkp");

var $hUgka = parcelRequire("hUgka");

var $5hnkq = parcelRequire("5hnkq");

var $bbUHG = parcelRequire("bbUHG");
/**
 * This trait is responsible for implementing the public API
 * for defining Chevrotain parsers, i.e:
 * - CONSUME
 * - RULE
 * - OPTION
 * - ...
 */ var $fb4888ed45c6f80b$export$48759acf3d590118 = /** @class */ function() {
    function RecognizerApi() {}
    RecognizerApi.prototype.ACTION = function(impl) {
        return impl.call(this);
    };
    RecognizerApi.prototype.consume = function(idx, tokType, options) {
        return this.consumeInternal(tokType, idx, options);
    };
    RecognizerApi.prototype.subrule = function(idx, ruleToCall, options) {
        return this.subruleInternal(ruleToCall, idx, options);
    };
    RecognizerApi.prototype.option = function(idx, actionORMethodDef) {
        return this.optionInternal(actionORMethodDef, idx);
    };
    RecognizerApi.prototype.or = function(idx, altsOrOpts) {
        return this.orInternal(altsOrOpts, idx);
    };
    RecognizerApi.prototype.many = function(idx, actionORMethodDef) {
        return this.manyInternal(idx, actionORMethodDef);
    };
    RecognizerApi.prototype.atLeastOne = function(idx, actionORMethodDef) {
        return this.atLeastOneInternal(idx, actionORMethodDef);
    };
    RecognizerApi.prototype.CONSUME = function(tokType, options) {
        return this.consumeInternal(tokType, 0, options);
    };
    RecognizerApi.prototype.CONSUME1 = function(tokType, options) {
        return this.consumeInternal(tokType, 1, options);
    };
    RecognizerApi.prototype.CONSUME2 = function(tokType, options) {
        return this.consumeInternal(tokType, 2, options);
    };
    RecognizerApi.prototype.CONSUME3 = function(tokType, options) {
        return this.consumeInternal(tokType, 3, options);
    };
    RecognizerApi.prototype.CONSUME4 = function(tokType, options) {
        return this.consumeInternal(tokType, 4, options);
    };
    RecognizerApi.prototype.CONSUME5 = function(tokType, options) {
        return this.consumeInternal(tokType, 5, options);
    };
    RecognizerApi.prototype.CONSUME6 = function(tokType, options) {
        return this.consumeInternal(tokType, 6, options);
    };
    RecognizerApi.prototype.CONSUME7 = function(tokType, options) {
        return this.consumeInternal(tokType, 7, options);
    };
    RecognizerApi.prototype.CONSUME8 = function(tokType, options) {
        return this.consumeInternal(tokType, 8, options);
    };
    RecognizerApi.prototype.CONSUME9 = function(tokType, options) {
        return this.consumeInternal(tokType, 9, options);
    };
    RecognizerApi.prototype.SUBRULE = function(ruleToCall, options) {
        return this.subruleInternal(ruleToCall, 0, options);
    };
    RecognizerApi.prototype.SUBRULE1 = function(ruleToCall, options) {
        return this.subruleInternal(ruleToCall, 1, options);
    };
    RecognizerApi.prototype.SUBRULE2 = function(ruleToCall, options) {
        return this.subruleInternal(ruleToCall, 2, options);
    };
    RecognizerApi.prototype.SUBRULE3 = function(ruleToCall, options) {
        return this.subruleInternal(ruleToCall, 3, options);
    };
    RecognizerApi.prototype.SUBRULE4 = function(ruleToCall, options) {
        return this.subruleInternal(ruleToCall, 4, options);
    };
    RecognizerApi.prototype.SUBRULE5 = function(ruleToCall, options) {
        return this.subruleInternal(ruleToCall, 5, options);
    };
    RecognizerApi.prototype.SUBRULE6 = function(ruleToCall, options) {
        return this.subruleInternal(ruleToCall, 6, options);
    };
    RecognizerApi.prototype.SUBRULE7 = function(ruleToCall, options) {
        return this.subruleInternal(ruleToCall, 7, options);
    };
    RecognizerApi.prototype.SUBRULE8 = function(ruleToCall, options) {
        return this.subruleInternal(ruleToCall, 8, options);
    };
    RecognizerApi.prototype.SUBRULE9 = function(ruleToCall, options) {
        return this.subruleInternal(ruleToCall, 9, options);
    };
    RecognizerApi.prototype.OPTION = function(actionORMethodDef) {
        return this.optionInternal(actionORMethodDef, 0);
    };
    RecognizerApi.prototype.OPTION1 = function(actionORMethodDef) {
        return this.optionInternal(actionORMethodDef, 1);
    };
    RecognizerApi.prototype.OPTION2 = function(actionORMethodDef) {
        return this.optionInternal(actionORMethodDef, 2);
    };
    RecognizerApi.prototype.OPTION3 = function(actionORMethodDef) {
        return this.optionInternal(actionORMethodDef, 3);
    };
    RecognizerApi.prototype.OPTION4 = function(actionORMethodDef) {
        return this.optionInternal(actionORMethodDef, 4);
    };
    RecognizerApi.prototype.OPTION5 = function(actionORMethodDef) {
        return this.optionInternal(actionORMethodDef, 5);
    };
    RecognizerApi.prototype.OPTION6 = function(actionORMethodDef) {
        return this.optionInternal(actionORMethodDef, 6);
    };
    RecognizerApi.prototype.OPTION7 = function(actionORMethodDef) {
        return this.optionInternal(actionORMethodDef, 7);
    };
    RecognizerApi.prototype.OPTION8 = function(actionORMethodDef) {
        return this.optionInternal(actionORMethodDef, 8);
    };
    RecognizerApi.prototype.OPTION9 = function(actionORMethodDef) {
        return this.optionInternal(actionORMethodDef, 9);
    };
    RecognizerApi.prototype.OR = function(altsOrOpts) {
        return this.orInternal(altsOrOpts, 0);
    };
    RecognizerApi.prototype.OR1 = function(altsOrOpts) {
        return this.orInternal(altsOrOpts, 1);
    };
    RecognizerApi.prototype.OR2 = function(altsOrOpts) {
        return this.orInternal(altsOrOpts, 2);
    };
    RecognizerApi.prototype.OR3 = function(altsOrOpts) {
        return this.orInternal(altsOrOpts, 3);
    };
    RecognizerApi.prototype.OR4 = function(altsOrOpts) {
        return this.orInternal(altsOrOpts, 4);
    };
    RecognizerApi.prototype.OR5 = function(altsOrOpts) {
        return this.orInternal(altsOrOpts, 5);
    };
    RecognizerApi.prototype.OR6 = function(altsOrOpts) {
        return this.orInternal(altsOrOpts, 6);
    };
    RecognizerApi.prototype.OR7 = function(altsOrOpts) {
        return this.orInternal(altsOrOpts, 7);
    };
    RecognizerApi.prototype.OR8 = function(altsOrOpts) {
        return this.orInternal(altsOrOpts, 8);
    };
    RecognizerApi.prototype.OR9 = function(altsOrOpts) {
        return this.orInternal(altsOrOpts, 9);
    };
    RecognizerApi.prototype.MANY = function(actionORMethodDef) {
        this.manyInternal(0, actionORMethodDef);
    };
    RecognizerApi.prototype.MANY1 = function(actionORMethodDef) {
        this.manyInternal(1, actionORMethodDef);
    };
    RecognizerApi.prototype.MANY2 = function(actionORMethodDef) {
        this.manyInternal(2, actionORMethodDef);
    };
    RecognizerApi.prototype.MANY3 = function(actionORMethodDef) {
        this.manyInternal(3, actionORMethodDef);
    };
    RecognizerApi.prototype.MANY4 = function(actionORMethodDef) {
        this.manyInternal(4, actionORMethodDef);
    };
    RecognizerApi.prototype.MANY5 = function(actionORMethodDef) {
        this.manyInternal(5, actionORMethodDef);
    };
    RecognizerApi.prototype.MANY6 = function(actionORMethodDef) {
        this.manyInternal(6, actionORMethodDef);
    };
    RecognizerApi.prototype.MANY7 = function(actionORMethodDef) {
        this.manyInternal(7, actionORMethodDef);
    };
    RecognizerApi.prototype.MANY8 = function(actionORMethodDef) {
        this.manyInternal(8, actionORMethodDef);
    };
    RecognizerApi.prototype.MANY9 = function(actionORMethodDef) {
        this.manyInternal(9, actionORMethodDef);
    };
    RecognizerApi.prototype.MANY_SEP = function(options) {
        this.manySepFirstInternal(0, options);
    };
    RecognizerApi.prototype.MANY_SEP1 = function(options) {
        this.manySepFirstInternal(1, options);
    };
    RecognizerApi.prototype.MANY_SEP2 = function(options) {
        this.manySepFirstInternal(2, options);
    };
    RecognizerApi.prototype.MANY_SEP3 = function(options) {
        this.manySepFirstInternal(3, options);
    };
    RecognizerApi.prototype.MANY_SEP4 = function(options) {
        this.manySepFirstInternal(4, options);
    };
    RecognizerApi.prototype.MANY_SEP5 = function(options) {
        this.manySepFirstInternal(5, options);
    };
    RecognizerApi.prototype.MANY_SEP6 = function(options) {
        this.manySepFirstInternal(6, options);
    };
    RecognizerApi.prototype.MANY_SEP7 = function(options) {
        this.manySepFirstInternal(7, options);
    };
    RecognizerApi.prototype.MANY_SEP8 = function(options) {
        this.manySepFirstInternal(8, options);
    };
    RecognizerApi.prototype.MANY_SEP9 = function(options) {
        this.manySepFirstInternal(9, options);
    };
    RecognizerApi.prototype.AT_LEAST_ONE = function(actionORMethodDef) {
        this.atLeastOneInternal(0, actionORMethodDef);
    };
    RecognizerApi.prototype.AT_LEAST_ONE1 = function(actionORMethodDef) {
        return this.atLeastOneInternal(1, actionORMethodDef);
    };
    RecognizerApi.prototype.AT_LEAST_ONE2 = function(actionORMethodDef) {
        this.atLeastOneInternal(2, actionORMethodDef);
    };
    RecognizerApi.prototype.AT_LEAST_ONE3 = function(actionORMethodDef) {
        this.atLeastOneInternal(3, actionORMethodDef);
    };
    RecognizerApi.prototype.AT_LEAST_ONE4 = function(actionORMethodDef) {
        this.atLeastOneInternal(4, actionORMethodDef);
    };
    RecognizerApi.prototype.AT_LEAST_ONE5 = function(actionORMethodDef) {
        this.atLeastOneInternal(5, actionORMethodDef);
    };
    RecognizerApi.prototype.AT_LEAST_ONE6 = function(actionORMethodDef) {
        this.atLeastOneInternal(6, actionORMethodDef);
    };
    RecognizerApi.prototype.AT_LEAST_ONE7 = function(actionORMethodDef) {
        this.atLeastOneInternal(7, actionORMethodDef);
    };
    RecognizerApi.prototype.AT_LEAST_ONE8 = function(actionORMethodDef) {
        this.atLeastOneInternal(8, actionORMethodDef);
    };
    RecognizerApi.prototype.AT_LEAST_ONE9 = function(actionORMethodDef) {
        this.atLeastOneInternal(9, actionORMethodDef);
    };
    RecognizerApi.prototype.AT_LEAST_ONE_SEP = function(options) {
        this.atLeastOneSepFirstInternal(0, options);
    };
    RecognizerApi.prototype.AT_LEAST_ONE_SEP1 = function(options) {
        this.atLeastOneSepFirstInternal(1, options);
    };
    RecognizerApi.prototype.AT_LEAST_ONE_SEP2 = function(options) {
        this.atLeastOneSepFirstInternal(2, options);
    };
    RecognizerApi.prototype.AT_LEAST_ONE_SEP3 = function(options) {
        this.atLeastOneSepFirstInternal(3, options);
    };
    RecognizerApi.prototype.AT_LEAST_ONE_SEP4 = function(options) {
        this.atLeastOneSepFirstInternal(4, options);
    };
    RecognizerApi.prototype.AT_LEAST_ONE_SEP5 = function(options) {
        this.atLeastOneSepFirstInternal(5, options);
    };
    RecognizerApi.prototype.AT_LEAST_ONE_SEP6 = function(options) {
        this.atLeastOneSepFirstInternal(6, options);
    };
    RecognizerApi.prototype.AT_LEAST_ONE_SEP7 = function(options) {
        this.atLeastOneSepFirstInternal(7, options);
    };
    RecognizerApi.prototype.AT_LEAST_ONE_SEP8 = function(options) {
        this.atLeastOneSepFirstInternal(8, options);
    };
    RecognizerApi.prototype.AT_LEAST_ONE_SEP9 = function(options) {
        this.atLeastOneSepFirstInternal(9, options);
    };
    RecognizerApi.prototype.RULE = function(name, implementation, config) {
        if (config === void 0) config = (0, $5qjkp.DEFAULT_RULE_CONFIG);
        if ((0, $5mLYn.contains)(this.definedRulesNames, name)) {
            var errMsg = (0, $hUgka.defaultGrammarValidatorErrorProvider).buildDuplicateRuleNameError({
                topLevelRule: name,
                grammarName: this.className
            });
            var error = {
                message: errMsg,
                type: (0, $5qjkp.ParserDefinitionErrorType).DUPLICATE_RULE_NAME,
                ruleName: name
            };
            this.definitionErrors.push(error);
        }
        this.definedRulesNames.push(name);
        var ruleImplementation = this.defineRule(name, implementation, config);
        this[name] = ruleImplementation;
        return ruleImplementation;
    };
    RecognizerApi.prototype.OVERRIDE_RULE = function(name, impl, config) {
        if (config === void 0) config = (0, $5qjkp.DEFAULT_RULE_CONFIG);
        var ruleErrors = [];
        ruleErrors = ruleErrors.concat((0, $5hnkq.validateRuleIsOverridden)(name, this.definedRulesNames, this.className));
        this.definitionErrors.push.apply(this.definitionErrors, ruleErrors); // mutability for the win
        var ruleImplementation = this.defineRule(name, impl, config);
        this[name] = ruleImplementation;
        return ruleImplementation;
    };
    RecognizerApi.prototype.BACKTRACK = function(grammarRule, args) {
        return function() {
            // save org state
            this.isBackTrackingStack.push(1);
            var orgState = this.saveRecogState();
            try {
                grammarRule.apply(this, args);
                // if no exception was thrown we have succeed parsing the rule.
                return true;
            } catch (e) {
                if ((0, $czA2c.isRecognitionException)(e)) return false;
                else throw e;
            } finally{
                this.reloadRecogState(orgState);
                this.isBackTrackingStack.pop();
            }
        };
    };
    // GAST export APIs
    RecognizerApi.prototype.getGAstProductions = function() {
        return this.gastProductionsCache;
    };
    RecognizerApi.prototype.getSerializedGastProductions = function() {
        return (0, $bbUHG.serializeGrammar)((0, $5mLYn.values)(this.gastProductionsCache));
    };
    return RecognizerApi;
}();

});

parcelRegister("1gH4Q", function(module, exports) {

$parcel$export(module.exports, "RecognizerEngine", function () { return $0ec8b34cf55670e3$export$fe9aa5d8ef3859e1; });

var $5mLYn = parcelRequire("5mLYn");

var $ghJuf = parcelRequire("ghJuf");

var $czA2c = parcelRequire("czA2c");

var $1eoLt = parcelRequire("1eoLt");

var $ld8c4 = parcelRequire("ld8c4");

var $5qjkp = parcelRequire("5qjkp");

var $8VG34 = parcelRequire("8VG34");

var $hvAWv = parcelRequire("hvAWv");

var $6UThq = parcelRequire("6UThq");

var $25eU6 = parcelRequire("25eU6");
/**
 * This trait is responsible for the runtime parsing engine
 * Used by the official API (recognizer_api.ts)
 */ var $0ec8b34cf55670e3$export$fe9aa5d8ef3859e1 = /** @class */ function() {
    function RecognizerEngine() {}
    RecognizerEngine.prototype.initRecognizerEngine = function(tokenVocabulary, config) {
        this.className = (0, $25eU6.classNameFromInstance)(this);
        // TODO: would using an ES6 Map or plain object be faster (CST building scenario)
        this.shortRuleNameToFull = {};
        this.fullRuleNameToShort = {};
        this.ruleShortNameIdx = 256;
        this.tokenMatcher = (0, $6UThq.tokenStructuredMatcherNoCategories);
        this.definedRulesNames = [];
        this.tokensMap = {};
        this.isBackTrackingStack = [];
        this.RULE_STACK = [];
        this.RULE_OCCURRENCE_STACK = [];
        this.gastProductionsCache = {};
        if ((0, $5mLYn.has)(config, "serializedGrammar")) throw Error("The Parser's configuration can no longer contain a <serializedGrammar> property.\n	See: https://sap.github.io/chevrotain/docs/changes/BREAKING_CHANGES.html#_6-0-0\n	For Further details.");
        if ((0, $5mLYn.isArray)(tokenVocabulary)) {
            // This only checks for Token vocabularies provided as arrays.
            // That is good enough because the main objective is to detect users of pre-V4.0 APIs
            // rather than all edge cases of empty Token vocabularies.
            if ((0, $5mLYn.isEmpty)(tokenVocabulary)) throw Error("A Token Vocabulary cannot be empty.\n	Note that the first argument for the parser constructor\n	is no longer a Token vector (since v4.0).");
            if (typeof tokenVocabulary[0].startOffset === "number") throw Error("The Parser constructor no longer accepts a token vector as the first argument.\n	See: https://sap.github.io/chevrotain/docs/changes/BREAKING_CHANGES.html#_4-0-0\n	For Further details.");
        }
        if ((0, $5mLYn.isArray)(tokenVocabulary)) this.tokensMap = (0, $5mLYn.reduce)(tokenVocabulary, function(acc, tokType) {
            acc[tokType.name] = tokType;
            return acc;
        }, {});
        else if ((0, $5mLYn.has)(tokenVocabulary, "modes") && (0, $5mLYn.every)((0, $5mLYn.flatten)((0, $5mLYn.values)(tokenVocabulary.modes)), (0, $6UThq.isTokenType))) {
            var allTokenTypes = (0, $5mLYn.flatten)((0, $5mLYn.values)(tokenVocabulary.modes));
            var uniqueTokens = (0, $5mLYn.uniq)(allTokenTypes);
            this.tokensMap = (0, $5mLYn.reduce)(uniqueTokens, function(acc, tokType) {
                acc[tokType.name] = tokType;
                return acc;
            }, {});
        } else if ((0, $5mLYn.isObject)(tokenVocabulary)) this.tokensMap = (0, $5mLYn.cloneObj)(tokenVocabulary);
        else throw new Error("<tokensDictionary> argument must be An Array of Token constructors, A dictionary of Token constructors or an IMultiModeLexerDefinition");
        // always add EOF to the tokenNames -> constructors map. it is useful to assure all the input has been
        // parsed with a clear error message ("expecting EOF but found ...")
        /* tslint:disable */ this.tokensMap["EOF"] = (0, $hvAWv.EOF);
        // TODO: This check may not be accurate for multi mode lexers
        var noTokenCategoriesUsed = (0, $5mLYn.every)((0, $5mLYn.values)(tokenVocabulary), function(tokenConstructor) {
            return (0, $5mLYn.isEmpty)(tokenConstructor.categoryMatches);
        });
        this.tokenMatcher = noTokenCategoriesUsed ? (0, $6UThq.tokenStructuredMatcherNoCategories) : (0, $6UThq.tokenStructuredMatcher);
        // Because ES2015+ syntax should be supported for creating Token classes
        // We cannot assume that the Token classes were created using the "extendToken" utilities
        // Therefore we must augment the Token classes both on Lexer initialization and on Parser initialization
        (0, $6UThq.augmentTokenTypes)((0, $5mLYn.values)(this.tokensMap));
    };
    RecognizerEngine.prototype.defineRule = function(ruleName, impl, config) {
        if (this.selfAnalysisDone) throw Error("Grammar rule <" + ruleName + "> may not be defined after the 'performSelfAnalysis' method has been called'\n" + "Make sure that all grammar rule definitions are done before 'performSelfAnalysis' is called.");
        var resyncEnabled = (0, $5mLYn.has)(config, "resyncEnabled") ? config.resyncEnabled : (0, $5qjkp.DEFAULT_RULE_CONFIG).resyncEnabled;
        var recoveryValueFunc = (0, $5mLYn.has)(config, "recoveryValueFunc") ? config.recoveryValueFunc : (0, $5qjkp.DEFAULT_RULE_CONFIG).recoveryValueFunc;
        // performance optimization: Use small integers as keys for the longer human readable "full" rule names.
        // this greatly improves Map access time (as much as 8% for some performance benchmarks).
        /* tslint:disable */ var shortName = this.ruleShortNameIdx << (0, $ghJuf.BITS_FOR_METHOD_TYPE) + (0, $ghJuf.BITS_FOR_OCCURRENCE_IDX);
        /* tslint:enable */ this.ruleShortNameIdx++;
        this.shortRuleNameToFull[shortName] = ruleName;
        this.fullRuleNameToShort[ruleName] = shortName;
        function invokeRuleWithTry(args) {
            try {
                if (this.outputCst === true) {
                    impl.apply(this, args);
                    var cst = this.CST_STACK[this.CST_STACK.length - 1];
                    this.cstPostRule(cst);
                    return cst;
                } else return impl.apply(this, args);
            } catch (e) {
                return this.invokeRuleCatch(e, resyncEnabled, recoveryValueFunc);
            } finally{
                this.ruleFinallyStateUpdate();
            }
        }
        var wrappedGrammarRule;
        wrappedGrammarRule = function(idxInCallingRule, args) {
            if (idxInCallingRule === void 0) idxInCallingRule = 0;
            this.ruleInvocationStateUpdate(shortName, ruleName, idxInCallingRule);
            return invokeRuleWithTry.call(this, args);
        };
        var ruleNamePropName = "ruleName";
        wrappedGrammarRule[ruleNamePropName] = ruleName;
        wrappedGrammarRule["originalGrammarAction"] = impl;
        return wrappedGrammarRule;
    };
    RecognizerEngine.prototype.invokeRuleCatch = function(e, resyncEnabledConfig, recoveryValueFunc) {
        var isFirstInvokedRule = this.RULE_STACK.length === 1;
        // note the reSync is always enabled for the first rule invocation, because we must always be able to
        // reSync with EOF and just output some INVALID ParseTree
        // during backtracking reSync recovery is disabled, otherwise we can't be certain the backtracking
        // path is really the most valid one
        var reSyncEnabled = resyncEnabledConfig && !this.isBackTracking() && this.recoveryEnabled;
        if ((0, $czA2c.isRecognitionException)(e)) {
            var recogError = e;
            if (reSyncEnabled) {
                var reSyncTokType = this.findReSyncTokenType();
                if (this.isInCurrentRuleReSyncSet(reSyncTokType)) {
                    recogError.resyncedTokens = this.reSyncTo(reSyncTokType);
                    if (this.outputCst) {
                        var partialCstResult = this.CST_STACK[this.CST_STACK.length - 1];
                        partialCstResult.recoveredNode = true;
                        return partialCstResult;
                    } else return recoveryValueFunc();
                } else {
                    if (this.outputCst) {
                        var partialCstResult = this.CST_STACK[this.CST_STACK.length - 1];
                        partialCstResult.recoveredNode = true;
                        recogError.partialCstResult = partialCstResult;
                    }
                    // to be handled Further up the call stack
                    throw recogError;
                }
            } else if (isFirstInvokedRule) {
                // otherwise a Redundant input error will be created as well and we cannot guarantee that this is indeed the case
                this.moveToTerminatedState();
                // the parser should never throw one of its own errors outside its flow.
                // even if error recovery is disabled
                return recoveryValueFunc();
            } else // to be recovered Further up the call stack
            throw recogError;
        } else // some other Error type which we don't know how to handle (for example a built in JavaScript Error)
        throw e;
    };
    // Implementation of parsing DSL
    RecognizerEngine.prototype.optionInternal = function(actionORMethodDef, occurrence) {
        var key = this.getKeyForAutomaticLookahead((0, $ghJuf.OPTION_IDX), occurrence);
        return this.optionInternalLogic(actionORMethodDef, occurrence, key);
    };
    RecognizerEngine.prototype.optionInternalLogic = function(actionORMethodDef, occurrence, key) {
        var _this = this;
        var lookAheadFunc = this.getLaFuncFromCache(key);
        var action;
        var predicate;
        if (actionORMethodDef.DEF !== undefined) {
            action = actionORMethodDef.DEF;
            predicate = actionORMethodDef.GATE;
            // predicate present
            if (predicate !== undefined) {
                var orgLookaheadFunction_1 = lookAheadFunc;
                lookAheadFunc = function() {
                    return predicate.call(_this) && orgLookaheadFunction_1.call(_this);
                };
            }
        } else action = actionORMethodDef;
        if (lookAheadFunc.call(this) === true) return action.call(this);
        return undefined;
    };
    RecognizerEngine.prototype.atLeastOneInternal = function(prodOccurrence, actionORMethodDef) {
        var laKey = this.getKeyForAutomaticLookahead((0, $ghJuf.AT_LEAST_ONE_IDX), prodOccurrence);
        return this.atLeastOneInternalLogic(prodOccurrence, actionORMethodDef, laKey);
    };
    RecognizerEngine.prototype.atLeastOneInternalLogic = function(prodOccurrence, actionORMethodDef, key) {
        var _this = this;
        var lookAheadFunc = this.getLaFuncFromCache(key);
        var action;
        var predicate;
        if (actionORMethodDef.DEF !== undefined) {
            action = actionORMethodDef.DEF;
            predicate = actionORMethodDef.GATE;
            // predicate present
            if (predicate !== undefined) {
                var orgLookaheadFunction_2 = lookAheadFunc;
                lookAheadFunc = function() {
                    return predicate.call(_this) && orgLookaheadFunction_2.call(_this);
                };
            }
        } else action = actionORMethodDef;
        if (lookAheadFunc.call(this) === true) {
            var notStuck = this.doSingleRepetition(action);
            while(lookAheadFunc.call(this) === true && notStuck === true)notStuck = this.doSingleRepetition(action);
        } else throw this.raiseEarlyExitException(prodOccurrence, (0, $1eoLt.PROD_TYPE).REPETITION_MANDATORY, actionORMethodDef.ERR_MSG);
        // note that while it may seem that this can cause an error because by using a recursive call to
        // AT_LEAST_ONE we change the grammar to AT_LEAST_TWO, AT_LEAST_THREE ... , the possible recursive call
        // from the tryInRepetitionRecovery(...) will only happen IFF there really are TWO/THREE/.... items.
        // Performance optimization: "attemptInRepetitionRecovery" will be defined as NOOP unless recovery is enabled
        this.attemptInRepetitionRecovery(this.atLeastOneInternal, [
            prodOccurrence,
            actionORMethodDef
        ], lookAheadFunc, (0, $ghJuf.AT_LEAST_ONE_IDX), prodOccurrence, (0, $ld8c4.NextTerminalAfterAtLeastOneWalker));
    };
    RecognizerEngine.prototype.atLeastOneSepFirstInternal = function(prodOccurrence, options) {
        var laKey = this.getKeyForAutomaticLookahead((0, $ghJuf.AT_LEAST_ONE_SEP_IDX), prodOccurrence);
        this.atLeastOneSepFirstInternalLogic(prodOccurrence, options, laKey);
    };
    RecognizerEngine.prototype.atLeastOneSepFirstInternalLogic = function(prodOccurrence, options, key) {
        var _this = this;
        var action = options.DEF;
        var separator = options.SEP;
        var firstIterationLookaheadFunc = this.getLaFuncFromCache(key);
        // 1st iteration
        if (firstIterationLookaheadFunc.call(this) === true) {
            action.call(this);
            //  TODO: Optimization can move this function construction into "attemptInRepetitionRecovery"
            //  because it is only needed in error recovery scenarios.
            var separatorLookAheadFunc = function() {
                return _this.tokenMatcher(_this.LA(1), separator);
            };
            // 2nd..nth iterations
            while(this.tokenMatcher(this.LA(1), separator) === true){
                // note that this CONSUME will never enter recovery because
                // the separatorLookAheadFunc checks that the separator really does exist.
                this.CONSUME(separator);
                action.call(this);
            }
            // Performance optimization: "attemptInRepetitionRecovery" will be defined as NOOP unless recovery is enabled
            this.attemptInRepetitionRecovery(this.repetitionSepSecondInternal, [
                prodOccurrence,
                separator,
                separatorLookAheadFunc,
                action,
                (0, $ld8c4.NextTerminalAfterAtLeastOneSepWalker)
            ], separatorLookAheadFunc, (0, $ghJuf.AT_LEAST_ONE_SEP_IDX), prodOccurrence, (0, $ld8c4.NextTerminalAfterAtLeastOneSepWalker));
        } else throw this.raiseEarlyExitException(prodOccurrence, (0, $1eoLt.PROD_TYPE).REPETITION_MANDATORY_WITH_SEPARATOR, options.ERR_MSG);
    };
    RecognizerEngine.prototype.manyInternal = function(prodOccurrence, actionORMethodDef) {
        var laKey = this.getKeyForAutomaticLookahead((0, $ghJuf.MANY_IDX), prodOccurrence);
        return this.manyInternalLogic(prodOccurrence, actionORMethodDef, laKey);
    };
    RecognizerEngine.prototype.manyInternalLogic = function(prodOccurrence, actionORMethodDef, key) {
        var _this = this;
        var lookaheadFunction = this.getLaFuncFromCache(key);
        var action;
        var predicate;
        if (actionORMethodDef.DEF !== undefined) {
            action = actionORMethodDef.DEF;
            predicate = actionORMethodDef.GATE;
            // predicate present
            if (predicate !== undefined) {
                var orgLookaheadFunction_3 = lookaheadFunction;
                lookaheadFunction = function() {
                    return predicate.call(_this) && orgLookaheadFunction_3.call(_this);
                };
            }
        } else action = actionORMethodDef;
        var notStuck = true;
        while(lookaheadFunction.call(this) === true && notStuck === true)notStuck = this.doSingleRepetition(action);
        // Performance optimization: "attemptInRepetitionRecovery" will be defined as NOOP unless recovery is enabled
        this.attemptInRepetitionRecovery(this.manyInternal, [
            prodOccurrence,
            actionORMethodDef
        ], lookaheadFunction, (0, $ghJuf.MANY_IDX), prodOccurrence, (0, $ld8c4.NextTerminalAfterManyWalker), // The notStuck parameter is only relevant when "attemptInRepetitionRecovery"
        // is invoked from manyInternal, in the MANY_SEP case and AT_LEAST_ONE[_SEP]
        // An infinite loop cannot occur as:
        // - Either the lookahead is guaranteed to consume something (Single Token Separator)
        // - AT_LEAST_ONE by definition is guaranteed to consume something (or error out).
        notStuck);
    };
    RecognizerEngine.prototype.manySepFirstInternal = function(prodOccurrence, options) {
        var laKey = this.getKeyForAutomaticLookahead((0, $ghJuf.MANY_SEP_IDX), prodOccurrence);
        this.manySepFirstInternalLogic(prodOccurrence, options, laKey);
    };
    RecognizerEngine.prototype.manySepFirstInternalLogic = function(prodOccurrence, options, key) {
        var _this = this;
        var action = options.DEF;
        var separator = options.SEP;
        var firstIterationLaFunc = this.getLaFuncFromCache(key);
        // 1st iteration
        if (firstIterationLaFunc.call(this) === true) {
            action.call(this);
            var separatorLookAheadFunc = function() {
                return _this.tokenMatcher(_this.LA(1), separator);
            };
            // 2nd..nth iterations
            while(this.tokenMatcher(this.LA(1), separator) === true){
                // note that this CONSUME will never enter recovery because
                // the separatorLookAheadFunc checks that the separator really does exist.
                this.CONSUME(separator);
                // No need for checking infinite loop here due to consuming the separator.
                action.call(this);
            }
            // Performance optimization: "attemptInRepetitionRecovery" will be defined as NOOP unless recovery is enabled
            this.attemptInRepetitionRecovery(this.repetitionSepSecondInternal, [
                prodOccurrence,
                separator,
                separatorLookAheadFunc,
                action,
                (0, $ld8c4.NextTerminalAfterManySepWalker)
            ], separatorLookAheadFunc, (0, $ghJuf.MANY_SEP_IDX), prodOccurrence, (0, $ld8c4.NextTerminalAfterManySepWalker));
        }
    };
    RecognizerEngine.prototype.repetitionSepSecondInternal = function(prodOccurrence, separator, separatorLookAheadFunc, action, nextTerminalAfterWalker) {
        while(separatorLookAheadFunc()){
            // note that this CONSUME will never enter recovery because
            // the separatorLookAheadFunc checks that the separator really does exist.
            this.CONSUME(separator);
            action.call(this);
        }
        // we can only arrive to this function after an error
        // has occurred (hence the name 'second') so the following
        // IF will always be entered, its possible to remove it...
        // however it is kept to avoid confusion and be consistent.
        // Performance optimization: "attemptInRepetitionRecovery" will be defined as NOOP unless recovery is enabled
        /* istanbul ignore else */ this.attemptInRepetitionRecovery(this.repetitionSepSecondInternal, [
            prodOccurrence,
            separator,
            separatorLookAheadFunc,
            action,
            nextTerminalAfterWalker
        ], separatorLookAheadFunc, (0, $ghJuf.AT_LEAST_ONE_SEP_IDX), prodOccurrence, nextTerminalAfterWalker);
    };
    RecognizerEngine.prototype.doSingleRepetition = function(action) {
        var beforeIteration = this.getLexerPosition();
        action.call(this);
        var afterIteration = this.getLexerPosition();
        // This boolean will indicate if this repetition progressed
        // or if we are "stuck" (potential infinite loop in the repetition).
        return afterIteration > beforeIteration;
    };
    RecognizerEngine.prototype.orInternal = function(altsOrOpts, occurrence) {
        var laKey = this.getKeyForAutomaticLookahead((0, $ghJuf.OR_IDX), occurrence);
        var alts = (0, $5mLYn.isArray)(altsOrOpts) ? altsOrOpts : altsOrOpts.DEF;
        var laFunc = this.getLaFuncFromCache(laKey);
        var altIdxToTake = laFunc.call(this, alts);
        if (altIdxToTake !== undefined) {
            var chosenAlternative = alts[altIdxToTake];
            return chosenAlternative.ALT.call(this);
        }
        this.raiseNoAltException(occurrence, altsOrOpts.ERR_MSG);
    };
    RecognizerEngine.prototype.ruleFinallyStateUpdate = function() {
        this.RULE_STACK.pop();
        this.RULE_OCCURRENCE_STACK.pop();
        // NOOP when cst is disabled
        this.cstFinallyStateUpdate();
        if (this.RULE_STACK.length === 0 && this.isAtEndOfInput() === false) {
            var firstRedundantTok = this.LA(1);
            var errMsg = this.errorMessageProvider.buildNotAllInputParsedMessage({
                firstRedundant: firstRedundantTok,
                ruleName: this.getCurrRuleFullName()
            });
            this.SAVE_ERROR(new (0, $czA2c.NotAllInputParsedException)(errMsg, firstRedundantTok));
        }
    };
    RecognizerEngine.prototype.subruleInternal = function(ruleToCall, idx, options) {
        var ruleResult;
        try {
            var args = options !== undefined ? options.ARGS : undefined;
            ruleResult = ruleToCall.call(this, idx, args);
            this.cstPostNonTerminal(ruleResult, options !== undefined && options.LABEL !== undefined ? options.LABEL : ruleToCall.ruleName);
            return ruleResult;
        } catch (e) {
            this.subruleInternalError(e, options, ruleToCall.ruleName);
        }
    };
    RecognizerEngine.prototype.subruleInternalError = function(e, options, ruleName) {
        if ((0, $czA2c.isRecognitionException)(e) && e.partialCstResult !== undefined) {
            this.cstPostNonTerminal(e.partialCstResult, options !== undefined && options.LABEL !== undefined ? options.LABEL : ruleName);
            delete e.partialCstResult;
        }
        throw e;
    };
    RecognizerEngine.prototype.consumeInternal = function(tokType, idx, options) {
        var consumedToken;
        try {
            var nextToken = this.LA(1);
            if (this.tokenMatcher(nextToken, tokType) === true) {
                this.consumeToken();
                consumedToken = nextToken;
            } else this.consumeInternalError(tokType, nextToken, options);
        } catch (eFromConsumption) {
            consumedToken = this.consumeInternalRecovery(tokType, idx, eFromConsumption);
        }
        this.cstPostTerminal(options !== undefined && options.LABEL !== undefined ? options.LABEL : tokType.name, consumedToken);
        return consumedToken;
    };
    RecognizerEngine.prototype.consumeInternalError = function(tokType, nextToken, options) {
        var msg;
        var previousToken = this.LA(0);
        if (options !== undefined && options.ERR_MSG) msg = options.ERR_MSG;
        else msg = this.errorMessageProvider.buildMismatchTokenMessage({
            expected: tokType,
            actual: nextToken,
            previous: previousToken,
            ruleName: this.getCurrRuleFullName()
        });
        throw this.SAVE_ERROR(new (0, $czA2c.MismatchedTokenException)(msg, nextToken, previousToken));
    };
    RecognizerEngine.prototype.consumeInternalRecovery = function(tokType, idx, eFromConsumption) {
        // no recovery allowed during backtracking, otherwise backtracking may recover invalid syntax and accept it
        // but the original syntax could have been parsed successfully without any backtracking + recovery
        if (this.recoveryEnabled && // TODO: more robust checking of the exception type. Perhaps Typescript extending expressions?
        eFromConsumption.name === "MismatchedTokenException" && !this.isBackTracking()) {
            var follows = this.getFollowsForInRuleRecovery(tokType, idx);
            try {
                return this.tryInRuleRecovery(tokType, follows);
            } catch (eFromInRuleRecovery) {
                if (eFromInRuleRecovery.name === (0, $8VG34.IN_RULE_RECOVERY_EXCEPTION)) // failed in RuleRecovery.
                // throw the original error in order to trigger reSync error recovery
                throw eFromConsumption;
                else throw eFromInRuleRecovery;
            }
        } else throw eFromConsumption;
    };
    RecognizerEngine.prototype.saveRecogState = function() {
        // errors is a getter which will clone the errors array
        var savedErrors = this.errors;
        var savedRuleStack = (0, $5mLYn.cloneArr)(this.RULE_STACK);
        return {
            errors: savedErrors,
            lexerState: this.exportLexerState(),
            RULE_STACK: savedRuleStack,
            CST_STACK: this.CST_STACK
        };
    };
    RecognizerEngine.prototype.reloadRecogState = function(newState) {
        this.errors = newState.errors;
        this.importLexerState(newState.lexerState);
        this.RULE_STACK = newState.RULE_STACK;
    };
    RecognizerEngine.prototype.ruleInvocationStateUpdate = function(shortName, fullName, idxInCallingRule) {
        this.RULE_OCCURRENCE_STACK.push(idxInCallingRule);
        this.RULE_STACK.push(shortName);
        // NOOP when cst is disabled
        this.cstInvocationStateUpdate(fullName, shortName);
    };
    RecognizerEngine.prototype.isBackTracking = function() {
        return this.isBackTrackingStack.length !== 0;
    };
    RecognizerEngine.prototype.getCurrRuleFullName = function() {
        var shortName = this.getLastExplicitRuleShortName();
        return this.shortRuleNameToFull[shortName];
    };
    RecognizerEngine.prototype.shortRuleNameToFullName = function(shortName) {
        return this.shortRuleNameToFull[shortName];
    };
    RecognizerEngine.prototype.isAtEndOfInput = function() {
        return this.tokenMatcher(this.LA(1), (0, $hvAWv.EOF));
    };
    RecognizerEngine.prototype.reset = function() {
        this.resetLexerState();
        this.isBackTrackingStack = [];
        this.errors = [];
        this.RULE_STACK = [];
        // TODO: extract a specific reset for TreeBuilder trait
        this.CST_STACK = [];
        this.RULE_OCCURRENCE_STACK = [];
    };
    return RecognizerEngine;
}();

});

parcelRegister("dBSuc", function(module, exports) {

$parcel$export(module.exports, "ErrorHandler", function () { return $9e88fed8405dd586$export$f42bc933f51d0006; });

var $czA2c = parcelRequire("czA2c");

var $5mLYn = parcelRequire("5mLYn");

var $1eoLt = parcelRequire("1eoLt");

var $5qjkp = parcelRequire("5qjkp");
/**
 * Trait responsible for runtime parsing errors.
 */ var $9e88fed8405dd586$export$f42bc933f51d0006 = /** @class */ function() {
    function ErrorHandler() {}
    ErrorHandler.prototype.initErrorHandler = function(config) {
        this._errors = [];
        this.errorMessageProvider = (0, $5mLYn.has)(config, "errorMessageProvider") ? config.errorMessageProvider : (0, $5qjkp.DEFAULT_PARSER_CONFIG).errorMessageProvider;
    };
    ErrorHandler.prototype.SAVE_ERROR = function(error) {
        if ((0, $czA2c.isRecognitionException)(error)) {
            error.context = {
                ruleStack: this.getHumanReadableRuleStack(),
                ruleOccurrenceStack: (0, $5mLYn.cloneArr)(this.RULE_OCCURRENCE_STACK)
            };
            this._errors.push(error);
            return error;
        } else throw Error("Trying to save an Error which is not a RecognitionException");
    };
    Object.defineProperty(ErrorHandler.prototype, "errors", {
        get: function() {
            return (0, $5mLYn.cloneArr)(this._errors);
        },
        set: function(newErrors) {
            this._errors = newErrors;
        },
        enumerable: false,
        configurable: true
    });
    // TODO: consider caching the error message computed information
    ErrorHandler.prototype.raiseEarlyExitException = function(occurrence, prodType, userDefinedErrMsg) {
        var ruleName = this.getCurrRuleFullName();
        var ruleGrammar = this.getGAstProductions()[ruleName];
        var lookAheadPathsPerAlternative = (0, $1eoLt.getLookaheadPathsForOptionalProd)(occurrence, ruleGrammar, prodType, this.maxLookahead);
        var insideProdPaths = lookAheadPathsPerAlternative[0];
        var actualTokens = [];
        for(var i = 1; i <= this.maxLookahead; i++)actualTokens.push(this.LA(i));
        var msg = this.errorMessageProvider.buildEarlyExitMessage({
            expectedIterationPaths: insideProdPaths,
            actual: actualTokens,
            previous: this.LA(0),
            customUserDescription: userDefinedErrMsg,
            ruleName: ruleName
        });
        throw this.SAVE_ERROR(new (0, $czA2c.EarlyExitException)(msg, this.LA(1), this.LA(0)));
    };
    // TODO: consider caching the error message computed information
    ErrorHandler.prototype.raiseNoAltException = function(occurrence, errMsgTypes) {
        var ruleName = this.getCurrRuleFullName();
        var ruleGrammar = this.getGAstProductions()[ruleName];
        // TODO: getLookaheadPathsForOr can be slow for large enough maxLookahead and certain grammars, consider caching ?
        var lookAheadPathsPerAlternative = (0, $1eoLt.getLookaheadPathsForOr)(occurrence, ruleGrammar, this.maxLookahead);
        var actualTokens = [];
        for(var i = 1; i <= this.maxLookahead; i++)actualTokens.push(this.LA(i));
        var previousToken = this.LA(0);
        var errMsg = this.errorMessageProvider.buildNoViableAltMessage({
            expectedPathsPerAlt: lookAheadPathsPerAlternative,
            actual: actualTokens,
            previous: previousToken,
            customUserDescription: errMsgTypes,
            ruleName: this.getCurrRuleFullName()
        });
        throw this.SAVE_ERROR(new (0, $czA2c.NoViableAltException)(errMsg, this.LA(1), previousToken));
    };
    return ErrorHandler;
}();

});

parcelRegister("e17bs", function(module, exports) {

$parcel$export(module.exports, "ContentAssist", function () { return $a346bb3af54449de$export$8eba077897005550; });

var $ld8c4 = parcelRequire("ld8c4");

var $5mLYn = parcelRequire("5mLYn");
var $a346bb3af54449de$export$8eba077897005550 = /** @class */ function() {
    function ContentAssist() {}
    ContentAssist.prototype.initContentAssist = function() {};
    ContentAssist.prototype.computeContentAssist = function(startRuleName, precedingInput) {
        var startRuleGast = this.gastProductionsCache[startRuleName];
        if ((0, $5mLYn.isUndefined)(startRuleGast)) throw Error("Rule ->" + startRuleName + "<- does not exist in this grammar.");
        return (0, $ld8c4.nextPossibleTokensAfter)([
            startRuleGast
        ], precedingInput, this.tokenMatcher, this.maxLookahead);
    };
    // TODO: should this be a member method or a utility? it does not have any state or usage of 'this'...
    // TODO: should this be more explicitly part of the public API?
    ContentAssist.prototype.getNextPossibleTokenTypes = function(grammarPath) {
        var topRuleName = (0, $5mLYn.first)(grammarPath.ruleStack);
        var gastProductions = this.getGAstProductions();
        var topProduction = gastProductions[topRuleName];
        var nextPossibleTokenTypes = new (0, $ld8c4.NextAfterTokenWalker)(topProduction, grammarPath).startWalking();
        return nextPossibleTokenTypes;
    };
    return ContentAssist;
}();

});

parcelRegister("hsTas", function(module, exports) {

$parcel$export(module.exports, "GastRecorder", function () { return $cb6fd8569e631713$export$40dd2324944fb644; });

var $5mLYn = parcelRequire("5mLYn");

var $bbUHG = parcelRequire("bbUHG");

var $eSJX3 = parcelRequire("eSJX3");

var $6UThq = parcelRequire("6UThq");

var $hvAWv = parcelRequire("hvAWv");

var $5qjkp = parcelRequire("5qjkp");

var $ghJuf = parcelRequire("ghJuf");
var $cb6fd8569e631713$var$RECORDING_NULL_OBJECT = {
    description: "This Object indicates the Parser is during Recording Phase"
};
Object.freeze($cb6fd8569e631713$var$RECORDING_NULL_OBJECT);
var $cb6fd8569e631713$var$HANDLE_SEPARATOR = true;
var $cb6fd8569e631713$var$MAX_METHOD_IDX = Math.pow(2, (0, $ghJuf.BITS_FOR_OCCURRENCE_IDX)) - 1;
var $cb6fd8569e631713$var$RFT = (0, $hvAWv.createToken)({
    name: "RECORDING_PHASE_TOKEN",
    pattern: (0, $eSJX3.Lexer).NA
});
(0, $6UThq.augmentTokenTypes)([
    $cb6fd8569e631713$var$RFT
]);
var $cb6fd8569e631713$var$RECORDING_PHASE_TOKEN = (0, $hvAWv.createTokenInstance)($cb6fd8569e631713$var$RFT, "This IToken indicates the Parser is in Recording Phase\n	See: https://sap.github.io/chevrotain/docs/guide/internals.html#grammar-recording for details", // Using "-1" instead of NaN (as in EOF) because an actual number is less likely to
// cause errors if the output of LA or CONSUME would be (incorrectly) used during the recording phase.
-1, -1, -1, -1, -1, -1);
Object.freeze($cb6fd8569e631713$var$RECORDING_PHASE_TOKEN);
var $cb6fd8569e631713$var$RECORDING_PHASE_CSTNODE = {
    name: "This CSTNode indicates the Parser is in Recording Phase\n	See: https://sap.github.io/chevrotain/docs/guide/internals.html#grammar-recording for details",
    children: {}
};
/**
 * This trait handles the creation of the GAST structure for Chevrotain Grammars
 */ var $cb6fd8569e631713$export$40dd2324944fb644 = /** @class */ function() {
    function GastRecorder() {}
    GastRecorder.prototype.initGastRecorder = function(config) {
        this.recordingProdStack = [];
        this.RECORDING_PHASE = false;
    };
    GastRecorder.prototype.enableRecording = function() {
        var _this = this;
        this.RECORDING_PHASE = true;
        this.TRACE_INIT("Enable Recording", function() {
            var _loop_1 = function(i) {
                var idx = i > 0 ? i : "";
                _this["CONSUME" + idx] = function(arg1, arg2) {
                    return this.consumeInternalRecord(arg1, i, arg2);
                };
                _this["SUBRULE" + idx] = function(arg1, arg2) {
                    return this.subruleInternalRecord(arg1, i, arg2);
                };
                _this["OPTION" + idx] = function(arg1) {
                    return this.optionInternalRecord(arg1, i);
                };
                _this["OR" + idx] = function(arg1) {
                    return this.orInternalRecord(arg1, i);
                };
                _this["MANY" + idx] = function(arg1) {
                    this.manyInternalRecord(i, arg1);
                };
                _this["MANY_SEP" + idx] = function(arg1) {
                    this.manySepFirstInternalRecord(i, arg1);
                };
                _this["AT_LEAST_ONE" + idx] = function(arg1) {
                    this.atLeastOneInternalRecord(i, arg1);
                };
                _this["AT_LEAST_ONE_SEP" + idx] = function(arg1) {
                    this.atLeastOneSepFirstInternalRecord(i, arg1);
                };
            };
            /**
             * Warning Dark Voodoo Magic upcoming!
             * We are "replacing" the public parsing DSL methods API
             * With **new** alternative implementations on the Parser **instance**
             *
             * So far this is the only way I've found to avoid performance regressions during parsing time.
             * - Approx 30% performance regression was measured on Chrome 75 Canary when attempting to replace the "internal"
             *   implementations directly instead.
             */ for(var i = 0; i < 10; i++)_loop_1(i);
            // DSL methods with the idx(suffix) as an argument
            _this["consume"] = function(idx, arg1, arg2) {
                return this.consumeInternalRecord(arg1, idx, arg2);
            };
            _this["subrule"] = function(idx, arg1, arg2) {
                return this.subruleInternalRecord(arg1, idx, arg2);
            };
            _this["option"] = function(idx, arg1) {
                return this.optionInternalRecord(arg1, idx);
            };
            _this["or"] = function(idx, arg1) {
                return this.orInternalRecord(arg1, idx);
            };
            _this["many"] = function(idx, arg1) {
                this.manyInternalRecord(idx, arg1);
            };
            _this["atLeastOne"] = function(idx, arg1) {
                this.atLeastOneInternalRecord(idx, arg1);
            };
            _this.ACTION = _this.ACTION_RECORD;
            _this.BACKTRACK = _this.BACKTRACK_RECORD;
            _this.LA = _this.LA_RECORD;
        });
    };
    GastRecorder.prototype.disableRecording = function() {
        var _this = this;
        this.RECORDING_PHASE = false;
        // By deleting these **instance** properties, any future invocation
        // will be deferred to the original methods on the **prototype** object
        // This seems to get rid of any incorrect optimizations that V8 may
        // do during the recording phase.
        this.TRACE_INIT("Deleting Recording methods", function() {
            for(var i = 0; i < 10; i++){
                var idx = i > 0 ? i : "";
                delete _this["CONSUME" + idx];
                delete _this["SUBRULE" + idx];
                delete _this["OPTION" + idx];
                delete _this["OR" + idx];
                delete _this["MANY" + idx];
                delete _this["MANY_SEP" + idx];
                delete _this["AT_LEAST_ONE" + idx];
                delete _this["AT_LEAST_ONE_SEP" + idx];
            }
            delete _this["consume"];
            delete _this["subrule"];
            delete _this["option"];
            delete _this["or"];
            delete _this["many"];
            delete _this["atLeastOne"];
            delete _this.ACTION;
            delete _this.BACKTRACK;
            delete _this.LA;
        });
    };
    // TODO: is there any way to use this method to check no
    //   Parser methods are called inside an ACTION?
    //   Maybe try/catch/finally on ACTIONS while disabling the recorders state changes?
    GastRecorder.prototype.ACTION_RECORD = function(impl) {
        // NO-OP during recording
        return;
    };
    // Executing backtracking logic will break our recording logic assumptions
    GastRecorder.prototype.BACKTRACK_RECORD = function(grammarRule, args) {
        return function() {
            return true;
        };
    };
    // LA is part of the official API and may be used for custom lookahead logic
    // by end users who may forget to wrap it in ACTION or inside a GATE
    GastRecorder.prototype.LA_RECORD = function(howMuch) {
        // We cannot use the RECORD_PHASE_TOKEN here because someone may depend
        // On LA return EOF at the end of the input so an infinite loop may occur.
        return 0, $5qjkp.END_OF_FILE;
    };
    GastRecorder.prototype.topLevelRuleRecord = function(name, def) {
        try {
            var newTopLevelRule = new (0, $bbUHG.Rule)({
                definition: [],
                name: name
            });
            newTopLevelRule.name = name;
            this.recordingProdStack.push(newTopLevelRule);
            def.call(this);
            this.recordingProdStack.pop();
            return newTopLevelRule;
        } catch (originalError) {
            if (originalError.KNOWN_RECORDER_ERROR !== true) try {
                originalError.message = originalError.message + '\n	 This error was thrown during the "grammar recording phase" For more info see:\n	' + "https://sap.github.io/chevrotain/docs/guide/internals.html#grammar-recording";
            } catch (mutabilityError) {
                // We may not be able to modify the original error object
                throw originalError;
            }
            throw originalError;
        }
    };
    // Implementation of parsing DSL
    GastRecorder.prototype.optionInternalRecord = function(actionORMethodDef, occurrence) {
        return $cb6fd8569e631713$var$recordProd.call(this, (0, $bbUHG.Option), actionORMethodDef, occurrence);
    };
    GastRecorder.prototype.atLeastOneInternalRecord = function(occurrence, actionORMethodDef) {
        $cb6fd8569e631713$var$recordProd.call(this, (0, $bbUHG.RepetitionMandatory), actionORMethodDef, occurrence);
    };
    GastRecorder.prototype.atLeastOneSepFirstInternalRecord = function(occurrence, options) {
        $cb6fd8569e631713$var$recordProd.call(this, (0, $bbUHG.RepetitionMandatoryWithSeparator), options, occurrence, $cb6fd8569e631713$var$HANDLE_SEPARATOR);
    };
    GastRecorder.prototype.manyInternalRecord = function(occurrence, actionORMethodDef) {
        $cb6fd8569e631713$var$recordProd.call(this, (0, $bbUHG.Repetition), actionORMethodDef, occurrence);
    };
    GastRecorder.prototype.manySepFirstInternalRecord = function(occurrence, options) {
        $cb6fd8569e631713$var$recordProd.call(this, (0, $bbUHG.RepetitionWithSeparator), options, occurrence, $cb6fd8569e631713$var$HANDLE_SEPARATOR);
    };
    GastRecorder.prototype.orInternalRecord = function(altsOrOpts, occurrence) {
        return $cb6fd8569e631713$var$recordOrProd.call(this, altsOrOpts, occurrence);
    };
    GastRecorder.prototype.subruleInternalRecord = function(ruleToCall, occurrence, options) {
        $cb6fd8569e631713$var$assertMethodIdxIsValid(occurrence);
        if (!ruleToCall || (0, $5mLYn.has)(ruleToCall, "ruleName") === false) {
            var error = new Error("<SUBRULE" + $cb6fd8569e631713$var$getIdxSuffix(occurrence) + "> argument is invalid" + (" expecting a Parser method reference but got: <" + JSON.stringify(ruleToCall) + ">") + ("\n inside top level rule: <" + this.recordingProdStack[0].name + ">"));
            error.KNOWN_RECORDER_ERROR = true;
            throw error;
        }
        var prevProd = (0, $5mLYn.peek)(this.recordingProdStack);
        var ruleName = ruleToCall["ruleName"];
        var newNoneTerminal = new (0, $bbUHG.NonTerminal)({
            idx: occurrence,
            nonTerminalName: ruleName,
            // The resolving of the `referencedRule` property will be done once all the Rule's GASTs have been created
            referencedRule: undefined
        });
        prevProd.definition.push(newNoneTerminal);
        return this.outputCst ? $cb6fd8569e631713$var$RECORDING_PHASE_CSTNODE : $cb6fd8569e631713$var$RECORDING_NULL_OBJECT;
    };
    GastRecorder.prototype.consumeInternalRecord = function(tokType, occurrence, options) {
        $cb6fd8569e631713$var$assertMethodIdxIsValid(occurrence);
        if (!(0, $6UThq.hasShortKeyProperty)(tokType)) {
            var error = new Error("<CONSUME" + $cb6fd8569e631713$var$getIdxSuffix(occurrence) + "> argument is invalid" + (" expecting a TokenType reference but got: <" + JSON.stringify(tokType) + ">") + ("\n inside top level rule: <" + this.recordingProdStack[0].name + ">"));
            error.KNOWN_RECORDER_ERROR = true;
            throw error;
        }
        var prevProd = (0, $5mLYn.peek)(this.recordingProdStack);
        var newNoneTerminal = new (0, $bbUHG.Terminal)({
            idx: occurrence,
            terminalType: tokType
        });
        prevProd.definition.push(newNoneTerminal);
        return $cb6fd8569e631713$var$RECORDING_PHASE_TOKEN;
    };
    return GastRecorder;
}();
function $cb6fd8569e631713$var$recordProd(prodConstructor, mainProdArg, occurrence, handleSep) {
    if (handleSep === void 0) handleSep = false;
    $cb6fd8569e631713$var$assertMethodIdxIsValid(occurrence);
    var prevProd = (0, $5mLYn.peek)(this.recordingProdStack);
    var grammarAction = (0, $5mLYn.isFunction)(mainProdArg) ? mainProdArg : mainProdArg.DEF;
    var newProd = new prodConstructor({
        definition: [],
        idx: occurrence
    });
    if (handleSep) newProd.separator = mainProdArg.SEP;
    if ((0, $5mLYn.has)(mainProdArg, "MAX_LOOKAHEAD")) newProd.maxLookahead = mainProdArg.MAX_LOOKAHEAD;
    this.recordingProdStack.push(newProd);
    grammarAction.call(this);
    prevProd.definition.push(newProd);
    this.recordingProdStack.pop();
    return $cb6fd8569e631713$var$RECORDING_NULL_OBJECT;
}
function $cb6fd8569e631713$var$recordOrProd(mainProdArg, occurrence) {
    var _this = this;
    $cb6fd8569e631713$var$assertMethodIdxIsValid(occurrence);
    var prevProd = (0, $5mLYn.peek)(this.recordingProdStack);
    // Only an array of alternatives
    var hasOptions = (0, $5mLYn.isArray)(mainProdArg) === false;
    var alts = hasOptions === false ? mainProdArg : mainProdArg.DEF;
    var newOrProd = new (0, $bbUHG.Alternation)({
        definition: [],
        idx: occurrence,
        ignoreAmbiguities: hasOptions && mainProdArg.IGNORE_AMBIGUITIES === true
    });
    if ((0, $5mLYn.has)(mainProdArg, "MAX_LOOKAHEAD")) newOrProd.maxLookahead = mainProdArg.MAX_LOOKAHEAD;
    var hasPredicates = (0, $5mLYn.some)(alts, function(currAlt) {
        return (0, $5mLYn.isFunction)(currAlt.GATE);
    });
    newOrProd.hasPredicates = hasPredicates;
    prevProd.definition.push(newOrProd);
    (0, $5mLYn.forEach)(alts, function(currAlt) {
        var currAltFlat = new (0, $bbUHG.Alternative)({
            definition: []
        });
        newOrProd.definition.push(currAltFlat);
        if ((0, $5mLYn.has)(currAlt, "IGNORE_AMBIGUITIES")) currAltFlat.ignoreAmbiguities = currAlt.IGNORE_AMBIGUITIES;
        else if ((0, $5mLYn.has)(currAlt, "GATE")) currAltFlat.ignoreAmbiguities = true;
        _this.recordingProdStack.push(currAltFlat);
        currAlt.ALT.call(_this);
        _this.recordingProdStack.pop();
    });
    return $cb6fd8569e631713$var$RECORDING_NULL_OBJECT;
}
function $cb6fd8569e631713$var$getIdxSuffix(idx) {
    return idx === 0 ? "" : "" + idx;
}
function $cb6fd8569e631713$var$assertMethodIdxIsValid(idx) {
    if (idx < 0 || idx > $cb6fd8569e631713$var$MAX_METHOD_IDX) {
        var error = new Error(// The stack trace will contain all the needed details
        "Invalid DSL Method idx value: <" + idx + ">\n	" + ("Idx value must be a none negative value smaller than " + ($cb6fd8569e631713$var$MAX_METHOD_IDX + 1)));
        error.KNOWN_RECORDER_ERROR = true;
        throw error;
    }
}

});

parcelRegister("dBicR", function(module, exports) {

$parcel$export(module.exports, "PerformanceTracer", function () { return $9e6cda76d09a4f6b$export$bbcafe794c2fe257; });

var $5mLYn = parcelRequire("5mLYn");

var $5qjkp = parcelRequire("5qjkp");
/**
 * Trait responsible for runtime parsing errors.
 */ var $9e6cda76d09a4f6b$export$bbcafe794c2fe257 = /** @class */ function() {
    function PerformanceTracer() {}
    PerformanceTracer.prototype.initPerformanceTracer = function(config) {
        if ((0, $5mLYn.has)(config, "traceInitPerf")) {
            var userTraceInitPerf = config.traceInitPerf;
            var traceIsNumber = typeof userTraceInitPerf === "number";
            this.traceInitMaxIdent = traceIsNumber ? userTraceInitPerf : Infinity;
            this.traceInitPerf = traceIsNumber ? userTraceInitPerf > 0 : userTraceInitPerf;
        } else {
            this.traceInitMaxIdent = 0;
            this.traceInitPerf = (0, $5qjkp.DEFAULT_PARSER_CONFIG).traceInitPerf;
        }
        this.traceInitIndent = -1;
    };
    PerformanceTracer.prototype.TRACE_INIT = function(phaseDesc, phaseImpl) {
        // No need to optimize this using NOOP pattern because
        // It is not called in a hot spot...
        if (this.traceInitPerf === true) {
            this.traceInitIndent++;
            var indent = new Array(this.traceInitIndent + 1).join("	");
            if (this.traceInitIndent < this.traceInitMaxIdent) console.log(indent + "--> <" + phaseDesc + ">");
            var _a = (0, $5mLYn.timer)(phaseImpl), time = _a.time, value = _a.value;
            /* istanbul ignore next - Difficult to reproduce specific performance behavior (>10ms) in tests */ var traceMethod = time > 10 ? console.warn : console.log;
            if (this.traceInitIndent < this.traceInitMaxIdent) traceMethod(indent + "<-- <" + phaseDesc + "> time: " + time + "ms");
            this.traceInitIndent--;
            return value;
        } else return phaseImpl();
    };
    return PerformanceTracer;
}();

});


parcelRegister("IrQ3e", function(module, exports) {

$parcel$export(module.exports, "createSyntaxDiagramsCode", function () { return $0859b45427dced35$export$6aabac36f625c484; });

var $eMKuy = parcelRequire("eMKuy");
function $0859b45427dced35$export$6aabac36f625c484(grammar, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.resourceBase, resourceBase = _c === void 0 ? "https://unpkg.com/chevrotain@" + (0, $eMKuy.VERSION) + "/diagrams/" : _c, _d = _b.css, css = _d === void 0 ? "https://unpkg.com/chevrotain@" + (0, $eMKuy.VERSION) + "/diagrams/diagrams.css" : _d;
    var header = '\n<!-- This is a generated file -->\n<!DOCTYPE html>\n<meta charset="utf-8">\n<style>\n  body {\n    background-color: hsl(30, 20%, 95%)\n  }\n</style>\n\n';
    var cssHtml = "\n<link rel='stylesheet' href='" + css + "'>\n";
    var scripts = "\n<script src='" + resourceBase + "vendor/railroad-diagrams.js'></script>\n<script src='" + resourceBase + "src/diagrams_builder.js'></script>\n<script src='" + resourceBase + "src/diagrams_behavior.js'></script>\n<script src='" + resourceBase + "src/main.js'></script>\n";
    var diagramsDiv = '\n<div id="diagrams" align="center"></div>    \n';
    var serializedGrammar = "\n<script>\n    window.serializedGrammar = " + JSON.stringify(grammar, null, "  ") + ";\n</script>\n";
    var initLogic = '\n<script>\n    var diagramsDiv = document.getElementById("diagrams");\n    main.drawDiagramsFromSerializedGrammar(serializedGrammar, diagramsDiv);\n</script>\n';
    return header + cssHtml + scripts + diagramsDiv + serializedGrammar + initLogic;
}

});

parcelRegister("an09V", function(module, exports) {

$parcel$export(module.exports, "generateParserFactory", function () { return $78cc2cfa9a453fe9$export$13ec9963c661b5fe; });
$parcel$export(module.exports, "generateParserModule", function () { return $78cc2cfa9a453fe9$export$c2ebc70d6ab2de88; });

var $6PmUo = parcelRequire("6PmUo");

function $78cc2cfa9a453fe9$export$13ec9963c661b5fe(options) {
    var wrapperText = (0, $6PmUo.genWrapperFunction)({
        name: options.name,
        rules: options.rules
    });
    var constructorWrapper = new Function("tokenVocabulary", "config", "chevrotain", wrapperText);
    return function(config) {
        return constructorWrapper(options.tokenVocabulary, config, // TODO: check how the require is transpiled/webpacked
        (parcelRequire("33Mmf")));
    };
}
function $78cc2cfa9a453fe9$export$c2ebc70d6ab2de88(options) {
    return (0, $6PmUo.genUmdModule)({
        name: options.name,
        rules: options.rules
    });
}

});
parcelRegister("6PmUo", function(module, exports) {

$parcel$export(module.exports, "genUmdModule", function () { return $4f8946a3f82a3e39$export$ce86e25a22242f89; });
$parcel$export(module.exports, "genWrapperFunction", function () { return $4f8946a3f82a3e39$export$d1b63dc996b4fcb7; });

var $5mLYn = parcelRequire("5mLYn");

var $bbUHG = parcelRequire("bbUHG");
/**
 * Missing features
 * 1. Rule arguments
 * 2. Gates
 * 3. embedded actions
 */ var $4f8946a3f82a3e39$var$NL = "\n";
function $4f8946a3f82a3e39$export$ce86e25a22242f89(options) {
    return "\n(function (root, factory) {\n    if (typeof define === 'function' && define.amd) {\n        // AMD. Register as an anonymous module.\n        define(['chevrotain'], factory);\n    } else if (typeof module === 'object' && module.exports) {\n        // Node. Does not work with strict CommonJS, but\n        // only CommonJS-like environments that support module.exports,\n        // like Node.\n        module.exports = factory(require('chevrotain'));\n    } else {\n        // Browser globals (root is window)\n        root.returnExports = factory(root.b);\n    }\n}(typeof self !== 'undefined' ? self : this, function (chevrotain) {\n\n" + $4f8946a3f82a3e39$export$9b395464a472512d(options) + "\n    \nreturn {\n    " + options.name + ": " + options.name + " \n}\n}));\n";
}
function $4f8946a3f82a3e39$export$d1b63dc996b4fcb7(options) {
    return "    \n" + $4f8946a3f82a3e39$export$9b395464a472512d(options) + "\nreturn new " + options.name + "(tokenVocabulary, config)    \n";
}
function $4f8946a3f82a3e39$export$9b395464a472512d(options) {
    // TODO: how to pass the token vocabulary? Constructor? other?
    var result = "\nfunction " + options.name + "(tokenVocabulary, config) {\n    // invoke super constructor\n    // No support for embedded actions currently, so we can 'hardcode'\n    // The use of CstParser.\n    chevrotain.CstParser.call(this, tokenVocabulary, config)\n\n    const $ = this\n\n    " + $4f8946a3f82a3e39$export$d07ecdf7642a5fe6(options.rules) + "\n\n    // very important to call this after all the rules have been defined.\n    // otherwise the parser may not work correctly as it will lack information\n    // derived during the self analysis phase.\n    this.performSelfAnalysis(this)\n}\n\n// inheritance as implemented in javascript in the previous decade... :(\n" + options.name + ".prototype = Object.create(chevrotain.CstParser.prototype)\n" + options.name + ".prototype.constructor = " + options.name + "    \n    ";
    return result;
}
function $4f8946a3f82a3e39$export$d07ecdf7642a5fe6(rules) {
    var rulesText = (0, $5mLYn.map)(rules, function(currRule) {
        return $4f8946a3f82a3e39$export$27a9ab0c8471b44c(currRule, 1);
    });
    return rulesText.join("\n");
}
function $4f8946a3f82a3e39$export$27a9ab0c8471b44c(prod, n) {
    var result = $4f8946a3f82a3e39$var$indent(n, '$.RULE("' + prod.name + '", function() {') + $4f8946a3f82a3e39$var$NL;
    result += $4f8946a3f82a3e39$var$genDefinition(prod.definition, n + 1);
    result += $4f8946a3f82a3e39$var$indent(n + 1, "})") + $4f8946a3f82a3e39$var$NL;
    return result;
}
function $4f8946a3f82a3e39$export$1323404fe167e501(prod, n) {
    var name = prod.terminalType.name;
    // TODO: potential performance optimization, avoid tokenMap Dictionary access
    return $4f8946a3f82a3e39$var$indent(n, "$.CONSUME" + prod.idx + "(this.tokensMap." + name + ")" + $4f8946a3f82a3e39$var$NL);
}
function $4f8946a3f82a3e39$export$74948499e519320c(prod, n) {
    return $4f8946a3f82a3e39$var$indent(n, "$.SUBRULE" + prod.idx + "($." + prod.nonTerminalName + ")" + $4f8946a3f82a3e39$var$NL);
}
function $4f8946a3f82a3e39$export$ab713b1e3992ab7d(prod, n) {
    var result = $4f8946a3f82a3e39$var$indent(n, "$.OR" + prod.idx + "([") + $4f8946a3f82a3e39$var$NL;
    var alts = (0, $5mLYn.map)(prod.definition, function(altDef) {
        return $4f8946a3f82a3e39$export$6754a213644d79f7(altDef, n + 1);
    });
    result += alts.join("," + $4f8946a3f82a3e39$var$NL);
    result += $4f8946a3f82a3e39$var$NL + $4f8946a3f82a3e39$var$indent(n, "])" + $4f8946a3f82a3e39$var$NL);
    return result;
}
function $4f8946a3f82a3e39$export$6754a213644d79f7(prod, n) {
    var result = $4f8946a3f82a3e39$var$indent(n, "{") + $4f8946a3f82a3e39$var$NL;
    result += $4f8946a3f82a3e39$var$indent(n + 1, "ALT: function() {") + $4f8946a3f82a3e39$var$NL;
    result += $4f8946a3f82a3e39$var$genDefinition(prod.definition, n + 1);
    result += $4f8946a3f82a3e39$var$indent(n + 1, "}") + $4f8946a3f82a3e39$var$NL;
    result += $4f8946a3f82a3e39$var$indent(n, "}");
    return result;
}
function $4f8946a3f82a3e39$var$genProd(prod, n) {
    /* istanbul ignore else */ if (prod instanceof (0, $bbUHG.NonTerminal)) return $4f8946a3f82a3e39$export$74948499e519320c(prod, n);
    else if (prod instanceof (0, $bbUHG.Option)) return $4f8946a3f82a3e39$var$genDSLRule("OPTION", prod, n);
    else if (prod instanceof (0, $bbUHG.RepetitionMandatory)) return $4f8946a3f82a3e39$var$genDSLRule("AT_LEAST_ONE", prod, n);
    else if (prod instanceof (0, $bbUHG.RepetitionMandatoryWithSeparator)) return $4f8946a3f82a3e39$var$genDSLRule("AT_LEAST_ONE_SEP", prod, n);
    else if (prod instanceof (0, $bbUHG.RepetitionWithSeparator)) return $4f8946a3f82a3e39$var$genDSLRule("MANY_SEP", prod, n);
    else if (prod instanceof (0, $bbUHG.Repetition)) return $4f8946a3f82a3e39$var$genDSLRule("MANY", prod, n);
    else if (prod instanceof (0, $bbUHG.Alternation)) return $4f8946a3f82a3e39$export$ab713b1e3992ab7d(prod, n);
    else if (prod instanceof (0, $bbUHG.Terminal)) return $4f8946a3f82a3e39$export$1323404fe167e501(prod, n);
    else if (prod instanceof (0, $bbUHG.Alternative)) return $4f8946a3f82a3e39$var$genDefinition(prod.definition, n);
    else throw Error("non exhaustive match");
}
function $4f8946a3f82a3e39$var$genDSLRule(dslName, prod, n) {
    var result = $4f8946a3f82a3e39$var$indent(n, "$." + (dslName + prod.idx) + "(");
    if (prod.separator) {
        result += "{" + $4f8946a3f82a3e39$var$NL;
        result += $4f8946a3f82a3e39$var$indent(n + 1, "SEP: this.tokensMap." + prod.separator.name) + "," + $4f8946a3f82a3e39$var$NL;
        result += "DEF: " + $4f8946a3f82a3e39$var$genDefFunction(prod.definition, n + 2) + $4f8946a3f82a3e39$var$NL;
        result += $4f8946a3f82a3e39$var$indent(n, "}") + $4f8946a3f82a3e39$var$NL;
    } else result += $4f8946a3f82a3e39$var$genDefFunction(prod.definition, n + 1);
    result += $4f8946a3f82a3e39$var$indent(n, ")") + $4f8946a3f82a3e39$var$NL;
    return result;
}
function $4f8946a3f82a3e39$var$genDefFunction(definition, n) {
    var def = "function() {" + $4f8946a3f82a3e39$var$NL;
    def += $4f8946a3f82a3e39$var$genDefinition(definition, n);
    def += $4f8946a3f82a3e39$var$indent(n, "}") + $4f8946a3f82a3e39$var$NL;
    return def;
}
function $4f8946a3f82a3e39$var$genDefinition(def, n) {
    var result = "";
    (0, $5mLYn.forEach)(def, function(prod) {
        result += $4f8946a3f82a3e39$var$genProd(prod, n + 1);
    });
    return result;
}
function $4f8946a3f82a3e39$var$indent(howMuch, text) {
    var spaces = Array(howMuch * 4 + 1).join(" ");
    return spaces + text;
}

});



parcelRegister("3r7fb", function(module, exports) {
"use strict";
// Generated using scripts/write-decode-map.ts
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = new Uint16Array(// prettier-ignore
'\u1D41<\xd5\u0131\u028A\u049D\u057B\u05D0\u0675\u06DE\u07A2\u07D6\u080F\u0A4A\u0A91\u0DA1\u0E6D\u0F09\u0F26\u10CA\u1228\u12E1\u1415\u149D\u14C3\u14DF\u1525\0\0\0\0\0\0\u156B\u16CD\u198D\u1C12\u1DDD\u1F7E\u2060\u21B0\u228D\u23C0\u23FB\u2442\u2824\u2912\u2D08\u2E48\u2FCE\u3016\u32BA\u3639\u37AC\u38FE\u3A28\u3A71\u3AE0\u3B2E\u0800EMabcfglmnoprstu\\bfms\x7f\x84\x8b\x90\x95\x98\xa6\xb3\xb9\xc8\xcflig\u803B\xc6\u40C6P\u803B&\u4026cute\u803B\xc1\u40C1reve;\u4102\u0100iyx}rc\u803B\xc2\u40C2;\u4410r;\uC000\ud835\udd04rave\u803B\xc0\u40C0pha;\u4391acr;\u4100d;\u6A53\u0100gp\x9d\xa1on;\u4104f;\uC000\ud835\udd38plyFunction;\u6061ing\u803B\xc5\u40C5\u0100cs\xbe\xc3r;\uC000\ud835\udc9cign;\u6254ilde\u803B\xc3\u40C3ml\u803B\xc4\u40C4\u0400aceforsu\xe5\xfb\xfe\u0117\u011C\u0122\u0127\u012A\u0100cr\xea\xf2kslash;\u6216\u0176\xf6\xf8;\u6AE7ed;\u6306y;\u4411\u0180crt\u0105\u010B\u0114ause;\u6235noullis;\u612Ca;\u4392r;\uC000\ud835\udd05pf;\uC000\ud835\udd39eve;\u42D8c\xf2\u0113mpeq;\u624E\u0700HOacdefhilorsu\u014D\u0151\u0156\u0180\u019E\u01A2\u01B5\u01B7\u01BA\u01DC\u0215\u0273\u0278\u027Ecy;\u4427PY\u803B\xa9\u40A9\u0180cpy\u015D\u0162\u017Aute;\u4106\u0100;i\u0167\u0168\u62D2talDifferentialD;\u6145leys;\u612D\u0200aeio\u0189\u018E\u0194\u0198ron;\u410Cdil\u803B\xc7\u40C7rc;\u4108nint;\u6230ot;\u410A\u0100dn\u01A7\u01ADilla;\u40B8terDot;\u40B7\xf2\u017Fi;\u43A7rcle\u0200DMPT\u01C7\u01CB\u01D1\u01D6ot;\u6299inus;\u6296lus;\u6295imes;\u6297o\u0100cs\u01E2\u01F8kwiseContourIntegral;\u6232eCurly\u0100DQ\u0203\u020FoubleQuote;\u601Duote;\u6019\u0200lnpu\u021E\u0228\u0247\u0255on\u0100;e\u0225\u0226\u6237;\u6A74\u0180git\u022F\u0236\u023Aruent;\u6261nt;\u622FourIntegral;\u622E\u0100fr\u024C\u024E;\u6102oduct;\u6210nterClockwiseContourIntegral;\u6233oss;\u6A2Fcr;\uC000\ud835\udc9ep\u0100;C\u0284\u0285\u62D3ap;\u624D\u0580DJSZacefios\u02A0\u02AC\u02B0\u02B4\u02B8\u02CB\u02D7\u02E1\u02E6\u0333\u048D\u0100;o\u0179\u02A5trahd;\u6911cy;\u4402cy;\u4405cy;\u440F\u0180grs\u02BF\u02C4\u02C7ger;\u6021r;\u61A1hv;\u6AE4\u0100ay\u02D0\u02D5ron;\u410E;\u4414l\u0100;t\u02DD\u02DE\u6207a;\u4394r;\uC000\ud835\udd07\u0100af\u02EB\u0327\u0100cm\u02F0\u0322ritical\u0200ADGT\u0300\u0306\u0316\u031Ccute;\u40B4o\u0174\u030B\u030D;\u42D9bleAcute;\u42DDrave;\u4060ilde;\u42DCond;\u62C4ferentialD;\u6146\u0470\u033D\0\0\0\u0342\u0354\0\u0405f;\uC000\ud835\udd3b\u0180;DE\u0348\u0349\u034D\u40A8ot;\u60DCqual;\u6250ble\u0300CDLRUV\u0363\u0372\u0382\u03CF\u03E2\u03F8ontourIntegra\xec\u0239o\u0274\u0379\0\0\u037B\xbb\u0349nArrow;\u61D3\u0100eo\u0387\u03A4ft\u0180ART\u0390\u0396\u03A1rrow;\u61D0ightArrow;\u61D4e\xe5\u02CAng\u0100LR\u03AB\u03C4eft\u0100AR\u03B3\u03B9rrow;\u67F8ightArrow;\u67FAightArrow;\u67F9ight\u0100AT\u03D8\u03DErrow;\u61D2ee;\u62A8p\u0241\u03E9\0\0\u03EFrrow;\u61D1ownArrow;\u61D5erticalBar;\u6225n\u0300ABLRTa\u0412\u042A\u0430\u045E\u047F\u037Crrow\u0180;BU\u041D\u041E\u0422\u6193ar;\u6913pArrow;\u61F5reve;\u4311eft\u02D2\u043A\0\u0446\0\u0450ightVector;\u6950eeVector;\u695Eector\u0100;B\u0459\u045A\u61BDar;\u6956ight\u01D4\u0467\0\u0471eeVector;\u695Fector\u0100;B\u047A\u047B\u61C1ar;\u6957ee\u0100;A\u0486\u0487\u62A4rrow;\u61A7\u0100ct\u0492\u0497r;\uC000\ud835\udc9frok;\u4110\u0800NTacdfglmopqstux\u04BD\u04C0\u04C4\u04CB\u04DE\u04E2\u04E7\u04EE\u04F5\u0521\u052F\u0536\u0552\u055D\u0560\u0565G;\u414AH\u803B\xd0\u40D0cute\u803B\xc9\u40C9\u0180aiy\u04D2\u04D7\u04DCron;\u411Arc\u803B\xca\u40CA;\u442Dot;\u4116r;\uC000\ud835\udd08rave\u803B\xc8\u40C8ement;\u6208\u0100ap\u04FA\u04FEcr;\u4112ty\u0253\u0506\0\0\u0512mallSquare;\u65FBerySmallSquare;\u65AB\u0100gp\u0526\u052Aon;\u4118f;\uC000\ud835\udd3csilon;\u4395u\u0100ai\u053C\u0549l\u0100;T\u0542\u0543\u6A75ilde;\u6242librium;\u61CC\u0100ci\u0557\u055Ar;\u6130m;\u6A73a;\u4397ml\u803B\xcb\u40CB\u0100ip\u056A\u056Fsts;\u6203onentialE;\u6147\u0280cfios\u0585\u0588\u058D\u05B2\u05CCy;\u4424r;\uC000\ud835\udd09lled\u0253\u0597\0\0\u05A3mallSquare;\u65FCerySmallSquare;\u65AA\u0370\u05BA\0\u05BF\0\0\u05C4f;\uC000\ud835\udd3dAll;\u6200riertrf;\u6131c\xf2\u05CB\u0600JTabcdfgorst\u05E8\u05EC\u05EF\u05FA\u0600\u0612\u0616\u061B\u061D\u0623\u066C\u0672cy;\u4403\u803B>\u403Emma\u0100;d\u05F7\u05F8\u4393;\u43DCreve;\u411E\u0180eiy\u0607\u060C\u0610dil;\u4122rc;\u411C;\u4413ot;\u4120r;\uC000\ud835\udd0a;\u62D9pf;\uC000\ud835\udd3eeater\u0300EFGLST\u0635\u0644\u064E\u0656\u065B\u0666qual\u0100;L\u063E\u063F\u6265ess;\u62DBullEqual;\u6267reater;\u6AA2ess;\u6277lantEqual;\u6A7Eilde;\u6273cr;\uC000\ud835\udca2;\u626B\u0400Aacfiosu\u0685\u068B\u0696\u069B\u069E\u06AA\u06BE\u06CARDcy;\u442A\u0100ct\u0690\u0694ek;\u42C7;\u405Eirc;\u4124r;\u610ClbertSpace;\u610B\u01F0\u06AF\0\u06B2f;\u610DizontalLine;\u6500\u0100ct\u06C3\u06C5\xf2\u06A9rok;\u4126mp\u0144\u06D0\u06D8ownHum\xf0\u012Fqual;\u624F\u0700EJOacdfgmnostu\u06FA\u06FE\u0703\u0707\u070E\u071A\u071E\u0721\u0728\u0744\u0778\u078B\u078F\u0795cy;\u4415lig;\u4132cy;\u4401cute\u803B\xcd\u40CD\u0100iy\u0713\u0718rc\u803B\xce\u40CE;\u4418ot;\u4130r;\u6111rave\u803B\xcc\u40CC\u0180;ap\u0720\u072F\u073F\u0100cg\u0734\u0737r;\u412AinaryI;\u6148lie\xf3\u03DD\u01F4\u0749\0\u0762\u0100;e\u074D\u074E\u622C\u0100gr\u0753\u0758ral;\u622Bsection;\u62C2isible\u0100CT\u076C\u0772omma;\u6063imes;\u6062\u0180gpt\u077F\u0783\u0788on;\u412Ef;\uC000\ud835\udd40a;\u4399cr;\u6110ilde;\u4128\u01EB\u079A\0\u079Ecy;\u4406l\u803B\xcf\u40CF\u0280cfosu\u07AC\u07B7\u07BC\u07C2\u07D0\u0100iy\u07B1\u07B5rc;\u4134;\u4419r;\uC000\ud835\udd0dpf;\uC000\ud835\udd41\u01E3\u07C7\0\u07CCr;\uC000\ud835\udca5rcy;\u4408kcy;\u4404\u0380HJacfos\u07E4\u07E8\u07EC\u07F1\u07FD\u0802\u0808cy;\u4425cy;\u440Cppa;\u439A\u0100ey\u07F6\u07FBdil;\u4136;\u441Ar;\uC000\ud835\udd0epf;\uC000\ud835\udd42cr;\uC000\ud835\udca6\u0580JTaceflmost\u0825\u0829\u082C\u0850\u0863\u09B3\u09B8\u09C7\u09CD\u0A37\u0A47cy;\u4409\u803B<\u403C\u0280cmnpr\u0837\u083C\u0841\u0844\u084Dute;\u4139bda;\u439Bg;\u67EAlacetrf;\u6112r;\u619E\u0180aey\u0857\u085C\u0861ron;\u413Ddil;\u413B;\u441B\u0100fs\u0868\u0970t\u0500ACDFRTUVar\u087E\u08A9\u08B1\u08E0\u08E6\u08FC\u092F\u095B\u0390\u096A\u0100nr\u0883\u088FgleBracket;\u67E8row\u0180;BR\u0899\u089A\u089E\u6190ar;\u61E4ightArrow;\u61C6eiling;\u6308o\u01F5\u08B7\0\u08C3bleBracket;\u67E6n\u01D4\u08C8\0\u08D2eeVector;\u6961ector\u0100;B\u08DB\u08DC\u61C3ar;\u6959loor;\u630Aight\u0100AV\u08EF\u08F5rrow;\u6194ector;\u694E\u0100er\u0901\u0917e\u0180;AV\u0909\u090A\u0910\u62A3rrow;\u61A4ector;\u695Aiangle\u0180;BE\u0924\u0925\u0929\u62B2ar;\u69CFqual;\u62B4p\u0180DTV\u0937\u0942\u094CownVector;\u6951eeVector;\u6960ector\u0100;B\u0956\u0957\u61BFar;\u6958ector\u0100;B\u0965\u0966\u61BCar;\u6952ight\xe1\u039Cs\u0300EFGLST\u097E\u098B\u0995\u099D\u09A2\u09ADqualGreater;\u62DAullEqual;\u6266reater;\u6276ess;\u6AA1lantEqual;\u6A7Dilde;\u6272r;\uC000\ud835\udd0f\u0100;e\u09BD\u09BE\u62D8ftarrow;\u61DAidot;\u413F\u0180npw\u09D4\u0A16\u0A1Bg\u0200LRlr\u09DE\u09F7\u0A02\u0A10eft\u0100AR\u09E6\u09ECrrow;\u67F5ightArrow;\u67F7ightArrow;\u67F6eft\u0100ar\u03B3\u0A0Aight\xe1\u03BFight\xe1\u03CAf;\uC000\ud835\udd43er\u0100LR\u0A22\u0A2CeftArrow;\u6199ightArrow;\u6198\u0180cht\u0A3E\u0A40\u0A42\xf2\u084C;\u61B0rok;\u4141;\u626A\u0400acefiosu\u0A5A\u0A5D\u0A60\u0A77\u0A7C\u0A85\u0A8B\u0A8Ep;\u6905y;\u441C\u0100dl\u0A65\u0A6FiumSpace;\u605Flintrf;\u6133r;\uC000\ud835\udd10nusPlus;\u6213pf;\uC000\ud835\udd44c\xf2\u0A76;\u439C\u0480Jacefostu\u0AA3\u0AA7\u0AAD\u0AC0\u0B14\u0B19\u0D91\u0D97\u0D9Ecy;\u440Acute;\u4143\u0180aey\u0AB4\u0AB9\u0ABEron;\u4147dil;\u4145;\u441D\u0180gsw\u0AC7\u0AF0\u0B0Eative\u0180MTV\u0AD3\u0ADF\u0AE8ediumSpace;\u600Bhi\u0100cn\u0AE6\u0AD8\xeb\u0AD9eryThi\xee\u0AD9ted\u0100GL\u0AF8\u0B06reaterGreate\xf2\u0673essLes\xf3\u0A48Line;\u400Ar;\uC000\ud835\udd11\u0200Bnpt\u0B22\u0B28\u0B37\u0B3Areak;\u6060BreakingSpace;\u40A0f;\u6115\u0680;CDEGHLNPRSTV\u0B55\u0B56\u0B6A\u0B7C\u0BA1\u0BEB\u0C04\u0C5E\u0C84\u0CA6\u0CD8\u0D61\u0D85\u6AEC\u0100ou\u0B5B\u0B64ngruent;\u6262pCap;\u626DoubleVerticalBar;\u6226\u0180lqx\u0B83\u0B8A\u0B9Bement;\u6209ual\u0100;T\u0B92\u0B93\u6260ilde;\uC000\u2242\u0338ists;\u6204reater\u0380;EFGLST\u0BB6\u0BB7\u0BBD\u0BC9\u0BD3\u0BD8\u0BE5\u626Fqual;\u6271ullEqual;\uC000\u2267\u0338reater;\uC000\u226B\u0338ess;\u6279lantEqual;\uC000\u2A7E\u0338ilde;\u6275ump\u0144\u0BF2\u0BFDownHump;\uC000\u224E\u0338qual;\uC000\u224F\u0338e\u0100fs\u0C0A\u0C27tTriangle\u0180;BE\u0C1A\u0C1B\u0C21\u62EAar;\uC000\u29CF\u0338qual;\u62ECs\u0300;EGLST\u0C35\u0C36\u0C3C\u0C44\u0C4B\u0C58\u626Equal;\u6270reater;\u6278ess;\uC000\u226A\u0338lantEqual;\uC000\u2A7D\u0338ilde;\u6274ested\u0100GL\u0C68\u0C79reaterGreater;\uC000\u2AA2\u0338essLess;\uC000\u2AA1\u0338recedes\u0180;ES\u0C92\u0C93\u0C9B\u6280qual;\uC000\u2AAF\u0338lantEqual;\u62E0\u0100ei\u0CAB\u0CB9verseElement;\u620CghtTriangle\u0180;BE\u0CCB\u0CCC\u0CD2\u62EBar;\uC000\u29D0\u0338qual;\u62ED\u0100qu\u0CDD\u0D0CuareSu\u0100bp\u0CE8\u0CF9set\u0100;E\u0CF0\u0CF3\uC000\u228F\u0338qual;\u62E2erset\u0100;E\u0D03\u0D06\uC000\u2290\u0338qual;\u62E3\u0180bcp\u0D13\u0D24\u0D4Eset\u0100;E\u0D1B\u0D1E\uC000\u2282\u20D2qual;\u6288ceeds\u0200;EST\u0D32\u0D33\u0D3B\u0D46\u6281qual;\uC000\u2AB0\u0338lantEqual;\u62E1ilde;\uC000\u227F\u0338erset\u0100;E\u0D58\u0D5B\uC000\u2283\u20D2qual;\u6289ilde\u0200;EFT\u0D6E\u0D6F\u0D75\u0D7F\u6241qual;\u6244ullEqual;\u6247ilde;\u6249erticalBar;\u6224cr;\uC000\ud835\udca9ilde\u803B\xd1\u40D1;\u439D\u0700Eacdfgmoprstuv\u0DBD\u0DC2\u0DC9\u0DD5\u0DDB\u0DE0\u0DE7\u0DFC\u0E02\u0E20\u0E22\u0E32\u0E3F\u0E44lig;\u4152cute\u803B\xd3\u40D3\u0100iy\u0DCE\u0DD3rc\u803B\xd4\u40D4;\u441Eblac;\u4150r;\uC000\ud835\udd12rave\u803B\xd2\u40D2\u0180aei\u0DEE\u0DF2\u0DF6cr;\u414Cga;\u43A9cron;\u439Fpf;\uC000\ud835\udd46enCurly\u0100DQ\u0E0E\u0E1AoubleQuote;\u601Cuote;\u6018;\u6A54\u0100cl\u0E27\u0E2Cr;\uC000\ud835\udcaaash\u803B\xd8\u40D8i\u016C\u0E37\u0E3Cde\u803B\xd5\u40D5es;\u6A37ml\u803B\xd6\u40D6er\u0100BP\u0E4B\u0E60\u0100ar\u0E50\u0E53r;\u603Eac\u0100ek\u0E5A\u0E5C;\u63DEet;\u63B4arenthesis;\u63DC\u0480acfhilors\u0E7F\u0E87\u0E8A\u0E8F\u0E92\u0E94\u0E9D\u0EB0\u0EFCrtialD;\u6202y;\u441Fr;\uC000\ud835\udd13i;\u43A6;\u43A0usMinus;\u40B1\u0100ip\u0EA2\u0EADncareplan\xe5\u069Df;\u6119\u0200;eio\u0EB9\u0EBA\u0EE0\u0EE4\u6ABBcedes\u0200;EST\u0EC8\u0EC9\u0ECF\u0EDA\u627Aqual;\u6AAFlantEqual;\u627Cilde;\u627Eme;\u6033\u0100dp\u0EE9\u0EEEuct;\u620Fortion\u0100;a\u0225\u0EF9l;\u621D\u0100ci\u0F01\u0F06r;\uC000\ud835\udcab;\u43A8\u0200Ufos\u0F11\u0F16\u0F1B\u0F1FOT\u803B"\u4022r;\uC000\ud835\udd14pf;\u611Acr;\uC000\ud835\udcac\u0600BEacefhiorsu\u0F3E\u0F43\u0F47\u0F60\u0F73\u0FA7\u0FAA\u0FAD\u1096\u10A9\u10B4\u10BEarr;\u6910G\u803B\xae\u40AE\u0180cnr\u0F4E\u0F53\u0F56ute;\u4154g;\u67EBr\u0100;t\u0F5C\u0F5D\u61A0l;\u6916\u0180aey\u0F67\u0F6C\u0F71ron;\u4158dil;\u4156;\u4420\u0100;v\u0F78\u0F79\u611Cerse\u0100EU\u0F82\u0F99\u0100lq\u0F87\u0F8Eement;\u620Builibrium;\u61CBpEquilibrium;\u696Fr\xbb\u0F79o;\u43A1ght\u0400ACDFTUVa\u0FC1\u0FEB\u0FF3\u1022\u1028\u105B\u1087\u03D8\u0100nr\u0FC6\u0FD2gleBracket;\u67E9row\u0180;BL\u0FDC\u0FDD\u0FE1\u6192ar;\u61E5eftArrow;\u61C4eiling;\u6309o\u01F5\u0FF9\0\u1005bleBracket;\u67E7n\u01D4\u100A\0\u1014eeVector;\u695Dector\u0100;B\u101D\u101E\u61C2ar;\u6955loor;\u630B\u0100er\u102D\u1043e\u0180;AV\u1035\u1036\u103C\u62A2rrow;\u61A6ector;\u695Biangle\u0180;BE\u1050\u1051\u1055\u62B3ar;\u69D0qual;\u62B5p\u0180DTV\u1063\u106E\u1078ownVector;\u694FeeVector;\u695Cector\u0100;B\u1082\u1083\u61BEar;\u6954ector\u0100;B\u1091\u1092\u61C0ar;\u6953\u0100pu\u109B\u109Ef;\u611DndImplies;\u6970ightarrow;\u61DB\u0100ch\u10B9\u10BCr;\u611B;\u61B1leDelayed;\u69F4\u0680HOacfhimoqstu\u10E4\u10F1\u10F7\u10FD\u1119\u111E\u1151\u1156\u1161\u1167\u11B5\u11BB\u11BF\u0100Cc\u10E9\u10EEHcy;\u4429y;\u4428FTcy;\u442Ccute;\u415A\u0280;aeiy\u1108\u1109\u110E\u1113\u1117\u6ABCron;\u4160dil;\u415Erc;\u415C;\u4421r;\uC000\ud835\udd16ort\u0200DLRU\u112A\u1134\u113E\u1149ownArrow\xbb\u041EeftArrow\xbb\u089AightArrow\xbb\u0FDDpArrow;\u6191gma;\u43A3allCircle;\u6218pf;\uC000\ud835\udd4a\u0272\u116D\0\0\u1170t;\u621Aare\u0200;ISU\u117B\u117C\u1189\u11AF\u65A1ntersection;\u6293u\u0100bp\u118F\u119Eset\u0100;E\u1197\u1198\u628Fqual;\u6291erset\u0100;E\u11A8\u11A9\u6290qual;\u6292nion;\u6294cr;\uC000\ud835\udcaear;\u62C6\u0200bcmp\u11C8\u11DB\u1209\u120B\u0100;s\u11CD\u11CE\u62D0et\u0100;E\u11CD\u11D5qual;\u6286\u0100ch\u11E0\u1205eeds\u0200;EST\u11ED\u11EE\u11F4\u11FF\u627Bqual;\u6AB0lantEqual;\u627Dilde;\u627FTh\xe1\u0F8C;\u6211\u0180;es\u1212\u1213\u1223\u62D1rset\u0100;E\u121C\u121D\u6283qual;\u6287et\xbb\u1213\u0580HRSacfhiors\u123E\u1244\u1249\u1255\u125E\u1271\u1276\u129F\u12C2\u12C8\u12D1ORN\u803B\xde\u40DEADE;\u6122\u0100Hc\u124E\u1252cy;\u440By;\u4426\u0100bu\u125A\u125C;\u4009;\u43A4\u0180aey\u1265\u126A\u126Fron;\u4164dil;\u4162;\u4422r;\uC000\ud835\udd17\u0100ei\u127B\u1289\u01F2\u1280\0\u1287efore;\u6234a;\u4398\u0100cn\u128E\u1298kSpace;\uC000\u205F\u200ASpace;\u6009lde\u0200;EFT\u12AB\u12AC\u12B2\u12BC\u623Cqual;\u6243ullEqual;\u6245ilde;\u6248pf;\uC000\ud835\udd4bipleDot;\u60DB\u0100ct\u12D6\u12DBr;\uC000\ud835\udcafrok;\u4166\u0AE1\u12F7\u130E\u131A\u1326\0\u132C\u1331\0\0\0\0\0\u1338\u133D\u1377\u1385\0\u13FF\u1404\u140A\u1410\u0100cr\u12FB\u1301ute\u803B\xda\u40DAr\u0100;o\u1307\u1308\u619Fcir;\u6949r\u01E3\u1313\0\u1316y;\u440Eve;\u416C\u0100iy\u131E\u1323rc\u803B\xdb\u40DB;\u4423blac;\u4170r;\uC000\ud835\udd18rave\u803B\xd9\u40D9acr;\u416A\u0100di\u1341\u1369er\u0100BP\u1348\u135D\u0100ar\u134D\u1350r;\u405Fac\u0100ek\u1357\u1359;\u63DFet;\u63B5arenthesis;\u63DDon\u0100;P\u1370\u1371\u62C3lus;\u628E\u0100gp\u137B\u137Fon;\u4172f;\uC000\ud835\udd4c\u0400ADETadps\u1395\u13AE\u13B8\u13C4\u03E8\u13D2\u13D7\u13F3rrow\u0180;BD\u1150\u13A0\u13A4ar;\u6912ownArrow;\u61C5ownArrow;\u6195quilibrium;\u696Eee\u0100;A\u13CB\u13CC\u62A5rrow;\u61A5own\xe1\u03F3er\u0100LR\u13DE\u13E8eftArrow;\u6196ightArrow;\u6197i\u0100;l\u13F9\u13FA\u43D2on;\u43A5ing;\u416Ecr;\uC000\ud835\udcb0ilde;\u4168ml\u803B\xdc\u40DC\u0480Dbcdefosv\u1427\u142C\u1430\u1433\u143E\u1485\u148A\u1490\u1496ash;\u62ABar;\u6AEBy;\u4412ash\u0100;l\u143B\u143C\u62A9;\u6AE6\u0100er\u1443\u1445;\u62C1\u0180bty\u144C\u1450\u147Aar;\u6016\u0100;i\u144F\u1455cal\u0200BLST\u1461\u1465\u146A\u1474ar;\u6223ine;\u407Ceparator;\u6758ilde;\u6240ThinSpace;\u600Ar;\uC000\ud835\udd19pf;\uC000\ud835\udd4dcr;\uC000\ud835\udcb1dash;\u62AA\u0280cefos\u14A7\u14AC\u14B1\u14B6\u14BCirc;\u4174dge;\u62C0r;\uC000\ud835\udd1apf;\uC000\ud835\udd4ecr;\uC000\ud835\udcb2\u0200fios\u14CB\u14D0\u14D2\u14D8r;\uC000\ud835\udd1b;\u439Epf;\uC000\ud835\udd4fcr;\uC000\ud835\udcb3\u0480AIUacfosu\u14F1\u14F5\u14F9\u14FD\u1504\u150F\u1514\u151A\u1520cy;\u442Fcy;\u4407cy;\u442Ecute\u803B\xdd\u40DD\u0100iy\u1509\u150Drc;\u4176;\u442Br;\uC000\ud835\udd1cpf;\uC000\ud835\udd50cr;\uC000\ud835\udcb4ml;\u4178\u0400Hacdefos\u1535\u1539\u153F\u154B\u154F\u155D\u1560\u1564cy;\u4416cute;\u4179\u0100ay\u1544\u1549ron;\u417D;\u4417ot;\u417B\u01F2\u1554\0\u155BoWidt\xe8\u0AD9a;\u4396r;\u6128pf;\u6124cr;\uC000\ud835\udcb5\u0BE1\u1583\u158A\u1590\0\u15B0\u15B6\u15BF\0\0\0\0\u15C6\u15DB\u15EB\u165F\u166D\0\u1695\u169B\u16B2\u16B9\0\u16BEcute\u803B\xe1\u40E1reve;\u4103\u0300;Ediuy\u159C\u159D\u15A1\u15A3\u15A8\u15AD\u623E;\uC000\u223E\u0333;\u623Frc\u803B\xe2\u40E2te\u80BB\xb4\u0306;\u4430lig\u803B\xe6\u40E6\u0100;r\xb2\u15BA;\uC000\ud835\udd1erave\u803B\xe0\u40E0\u0100ep\u15CA\u15D6\u0100fp\u15CF\u15D4sym;\u6135\xe8\u15D3ha;\u43B1\u0100ap\u15DFc\u0100cl\u15E4\u15E7r;\u4101g;\u6A3F\u0264\u15F0\0\0\u160A\u0280;adsv\u15FA\u15FB\u15FF\u1601\u1607\u6227nd;\u6A55;\u6A5Clope;\u6A58;\u6A5A\u0380;elmrsz\u1618\u1619\u161B\u161E\u163F\u164F\u1659\u6220;\u69A4e\xbb\u1619sd\u0100;a\u1625\u1626\u6221\u0461\u1630\u1632\u1634\u1636\u1638\u163A\u163C\u163E;\u69A8;\u69A9;\u69AA;\u69AB;\u69AC;\u69AD;\u69AE;\u69AFt\u0100;v\u1645\u1646\u621Fb\u0100;d\u164C\u164D\u62BE;\u699D\u0100pt\u1654\u1657h;\u6222\xbb\xb9arr;\u637C\u0100gp\u1663\u1667on;\u4105f;\uC000\ud835\udd52\u0380;Eaeiop\u12C1\u167B\u167D\u1682\u1684\u1687\u168A;\u6A70cir;\u6A6F;\u624Ad;\u624Bs;\u4027rox\u0100;e\u12C1\u1692\xf1\u1683ing\u803B\xe5\u40E5\u0180cty\u16A1\u16A6\u16A8r;\uC000\ud835\udcb6;\u402Amp\u0100;e\u12C1\u16AF\xf1\u0288ilde\u803B\xe3\u40E3ml\u803B\xe4\u40E4\u0100ci\u16C2\u16C8onin\xf4\u0272nt;\u6A11\u0800Nabcdefiklnoprsu\u16ED\u16F1\u1730\u173C\u1743\u1748\u1778\u177D\u17E0\u17E6\u1839\u1850\u170D\u193D\u1948\u1970ot;\u6AED\u0100cr\u16F6\u171Ek\u0200ceps\u1700\u1705\u170D\u1713ong;\u624Cpsilon;\u43F6rime;\u6035im\u0100;e\u171A\u171B\u623Dq;\u62CD\u0176\u1722\u1726ee;\u62BDed\u0100;g\u172C\u172D\u6305e\xbb\u172Drk\u0100;t\u135C\u1737brk;\u63B6\u0100oy\u1701\u1741;\u4431quo;\u601E\u0280cmprt\u1753\u175B\u1761\u1764\u1768aus\u0100;e\u010A\u0109ptyv;\u69B0s\xe9\u170Cno\xf5\u0113\u0180ahw\u176F\u1771\u1773;\u43B2;\u6136een;\u626Cr;\uC000\ud835\udd1fg\u0380costuvw\u178D\u179D\u17B3\u17C1\u17D5\u17DB\u17DE\u0180aiu\u1794\u1796\u179A\xf0\u0760rc;\u65EFp\xbb\u1371\u0180dpt\u17A4\u17A8\u17ADot;\u6A00lus;\u6A01imes;\u6A02\u0271\u17B9\0\0\u17BEcup;\u6A06ar;\u6605riangle\u0100du\u17CD\u17D2own;\u65BDp;\u65B3plus;\u6A04e\xe5\u1444\xe5\u14ADarow;\u690D\u0180ako\u17ED\u1826\u1835\u0100cn\u17F2\u1823k\u0180lst\u17FA\u05AB\u1802ozenge;\u69EBriangle\u0200;dlr\u1812\u1813\u1818\u181D\u65B4own;\u65BEeft;\u65C2ight;\u65B8k;\u6423\u01B1\u182B\0\u1833\u01B2\u182F\0\u1831;\u6592;\u65914;\u6593ck;\u6588\u0100eo\u183E\u184D\u0100;q\u1843\u1846\uC000=\u20E5uiv;\uC000\u2261\u20E5t;\u6310\u0200ptwx\u1859\u185E\u1867\u186Cf;\uC000\ud835\udd53\u0100;t\u13CB\u1863om\xbb\u13CCtie;\u62C8\u0600DHUVbdhmptuv\u1885\u1896\u18AA\u18BB\u18D7\u18DB\u18EC\u18FF\u1905\u190A\u1910\u1921\u0200LRlr\u188E\u1890\u1892\u1894;\u6557;\u6554;\u6556;\u6553\u0280;DUdu\u18A1\u18A2\u18A4\u18A6\u18A8\u6550;\u6566;\u6569;\u6564;\u6567\u0200LRlr\u18B3\u18B5\u18B7\u18B9;\u655D;\u655A;\u655C;\u6559\u0380;HLRhlr\u18CA\u18CB\u18CD\u18CF\u18D1\u18D3\u18D5\u6551;\u656C;\u6563;\u6560;\u656B;\u6562;\u655Fox;\u69C9\u0200LRlr\u18E4\u18E6\u18E8\u18EA;\u6555;\u6552;\u6510;\u650C\u0280;DUdu\u06BD\u18F7\u18F9\u18FB\u18FD;\u6565;\u6568;\u652C;\u6534inus;\u629Flus;\u629Eimes;\u62A0\u0200LRlr\u1919\u191B\u191D\u191F;\u655B;\u6558;\u6518;\u6514\u0380;HLRhlr\u1930\u1931\u1933\u1935\u1937\u1939\u193B\u6502;\u656A;\u6561;\u655E;\u653C;\u6524;\u651C\u0100ev\u0123\u1942bar\u803B\xa6\u40A6\u0200ceio\u1951\u1956\u195A\u1960r;\uC000\ud835\udcb7mi;\u604Fm\u0100;e\u171A\u171Cl\u0180;bh\u1968\u1969\u196B\u405C;\u69C5sub;\u67C8\u016C\u1974\u197El\u0100;e\u1979\u197A\u6022t\xbb\u197Ap\u0180;Ee\u012F\u1985\u1987;\u6AAE\u0100;q\u06DC\u06DB\u0CE1\u19A7\0\u19E8\u1A11\u1A15\u1A32\0\u1A37\u1A50\0\0\u1AB4\0\0\u1AC1\0\0\u1B21\u1B2E\u1B4D\u1B52\0\u1BFD\0\u1C0C\u0180cpr\u19AD\u19B2\u19DDute;\u4107\u0300;abcds\u19BF\u19C0\u19C4\u19CA\u19D5\u19D9\u6229nd;\u6A44rcup;\u6A49\u0100au\u19CF\u19D2p;\u6A4Bp;\u6A47ot;\u6A40;\uC000\u2229\uFE00\u0100eo\u19E2\u19E5t;\u6041\xee\u0693\u0200aeiu\u19F0\u19FB\u1A01\u1A05\u01F0\u19F5\0\u19F8s;\u6A4Don;\u410Ddil\u803B\xe7\u40E7rc;\u4109ps\u0100;s\u1A0C\u1A0D\u6A4Cm;\u6A50ot;\u410B\u0180dmn\u1A1B\u1A20\u1A26il\u80BB\xb8\u01ADptyv;\u69B2t\u8100\xa2;e\u1A2D\u1A2E\u40A2r\xe4\u01B2r;\uC000\ud835\udd20\u0180cei\u1A3D\u1A40\u1A4Dy;\u4447ck\u0100;m\u1A47\u1A48\u6713ark\xbb\u1A48;\u43C7r\u0380;Ecefms\u1A5F\u1A60\u1A62\u1A6B\u1AA4\u1AAA\u1AAE\u65CB;\u69C3\u0180;el\u1A69\u1A6A\u1A6D\u42C6q;\u6257e\u0261\u1A74\0\0\u1A88rrow\u0100lr\u1A7C\u1A81eft;\u61BAight;\u61BB\u0280RSacd\u1A92\u1A94\u1A96\u1A9A\u1A9F\xbb\u0F47;\u64C8st;\u629Birc;\u629Aash;\u629Dnint;\u6A10id;\u6AEFcir;\u69C2ubs\u0100;u\u1ABB\u1ABC\u6663it\xbb\u1ABC\u02EC\u1AC7\u1AD4\u1AFA\0\u1B0Aon\u0100;e\u1ACD\u1ACE\u403A\u0100;q\xc7\xc6\u026D\u1AD9\0\0\u1AE2a\u0100;t\u1ADE\u1ADF\u402C;\u4040\u0180;fl\u1AE8\u1AE9\u1AEB\u6201\xee\u1160e\u0100mx\u1AF1\u1AF6ent\xbb\u1AE9e\xf3\u024D\u01E7\u1AFE\0\u1B07\u0100;d\u12BB\u1B02ot;\u6A6Dn\xf4\u0246\u0180fry\u1B10\u1B14\u1B17;\uC000\ud835\udd54o\xe4\u0254\u8100\xa9;s\u0155\u1B1Dr;\u6117\u0100ao\u1B25\u1B29rr;\u61B5ss;\u6717\u0100cu\u1B32\u1B37r;\uC000\ud835\udcb8\u0100bp\u1B3C\u1B44\u0100;e\u1B41\u1B42\u6ACF;\u6AD1\u0100;e\u1B49\u1B4A\u6AD0;\u6AD2dot;\u62EF\u0380delprvw\u1B60\u1B6C\u1B77\u1B82\u1BAC\u1BD4\u1BF9arr\u0100lr\u1B68\u1B6A;\u6938;\u6935\u0270\u1B72\0\0\u1B75r;\u62DEc;\u62DFarr\u0100;p\u1B7F\u1B80\u61B6;\u693D\u0300;bcdos\u1B8F\u1B90\u1B96\u1BA1\u1BA5\u1BA8\u622Arcap;\u6A48\u0100au\u1B9B\u1B9Ep;\u6A46p;\u6A4Aot;\u628Dr;\u6A45;\uC000\u222A\uFE00\u0200alrv\u1BB5\u1BBF\u1BDE\u1BE3rr\u0100;m\u1BBC\u1BBD\u61B7;\u693Cy\u0180evw\u1BC7\u1BD4\u1BD8q\u0270\u1BCE\0\0\u1BD2re\xe3\u1B73u\xe3\u1B75ee;\u62CEedge;\u62CFen\u803B\xa4\u40A4earrow\u0100lr\u1BEE\u1BF3eft\xbb\u1B80ight\xbb\u1BBDe\xe4\u1BDD\u0100ci\u1C01\u1C07onin\xf4\u01F7nt;\u6231lcty;\u632D\u0980AHabcdefhijlorstuwz\u1C38\u1C3B\u1C3F\u1C5D\u1C69\u1C75\u1C8A\u1C9E\u1CAC\u1CB7\u1CFB\u1CFF\u1D0D\u1D7B\u1D91\u1DAB\u1DBB\u1DC6\u1DCDr\xf2\u0381ar;\u6965\u0200glrs\u1C48\u1C4D\u1C52\u1C54ger;\u6020eth;\u6138\xf2\u1133h\u0100;v\u1C5A\u1C5B\u6010\xbb\u090A\u016B\u1C61\u1C67arow;\u690Fa\xe3\u0315\u0100ay\u1C6E\u1C73ron;\u410F;\u4434\u0180;ao\u0332\u1C7C\u1C84\u0100gr\u02BF\u1C81r;\u61CAtseq;\u6A77\u0180glm\u1C91\u1C94\u1C98\u803B\xb0\u40B0ta;\u43B4ptyv;\u69B1\u0100ir\u1CA3\u1CA8sht;\u697F;\uC000\ud835\udd21ar\u0100lr\u1CB3\u1CB5\xbb\u08DC\xbb\u101E\u0280aegsv\u1CC2\u0378\u1CD6\u1CDC\u1CE0m\u0180;os\u0326\u1CCA\u1CD4nd\u0100;s\u0326\u1CD1uit;\u6666amma;\u43DDin;\u62F2\u0180;io\u1CE7\u1CE8\u1CF8\u40F7de\u8100\xf7;o\u1CE7\u1CF0ntimes;\u62C7n\xf8\u1CF7cy;\u4452c\u026F\u1D06\0\0\u1D0Arn;\u631Eop;\u630D\u0280lptuw\u1D18\u1D1D\u1D22\u1D49\u1D55lar;\u4024f;\uC000\ud835\udd55\u0280;emps\u030B\u1D2D\u1D37\u1D3D\u1D42q\u0100;d\u0352\u1D33ot;\u6251inus;\u6238lus;\u6214quare;\u62A1blebarwedg\xe5\xfan\u0180adh\u112E\u1D5D\u1D67ownarrow\xf3\u1C83arpoon\u0100lr\u1D72\u1D76ef\xf4\u1CB4igh\xf4\u1CB6\u0162\u1D7F\u1D85karo\xf7\u0F42\u026F\u1D8A\0\0\u1D8Ern;\u631Fop;\u630C\u0180cot\u1D98\u1DA3\u1DA6\u0100ry\u1D9D\u1DA1;\uC000\ud835\udcb9;\u4455l;\u69F6rok;\u4111\u0100dr\u1DB0\u1DB4ot;\u62F1i\u0100;f\u1DBA\u1816\u65BF\u0100ah\u1DC0\u1DC3r\xf2\u0429a\xf2\u0FA6angle;\u69A6\u0100ci\u1DD2\u1DD5y;\u445Fgrarr;\u67FF\u0900Dacdefglmnopqrstux\u1E01\u1E09\u1E19\u1E38\u0578\u1E3C\u1E49\u1E61\u1E7E\u1EA5\u1EAF\u1EBD\u1EE1\u1F2A\u1F37\u1F44\u1F4E\u1F5A\u0100Do\u1E06\u1D34o\xf4\u1C89\u0100cs\u1E0E\u1E14ute\u803B\xe9\u40E9ter;\u6A6E\u0200aioy\u1E22\u1E27\u1E31\u1E36ron;\u411Br\u0100;c\u1E2D\u1E2E\u6256\u803B\xea\u40EAlon;\u6255;\u444Dot;\u4117\u0100Dr\u1E41\u1E45ot;\u6252;\uC000\ud835\udd22\u0180;rs\u1E50\u1E51\u1E57\u6A9Aave\u803B\xe8\u40E8\u0100;d\u1E5C\u1E5D\u6A96ot;\u6A98\u0200;ils\u1E6A\u1E6B\u1E72\u1E74\u6A99nters;\u63E7;\u6113\u0100;d\u1E79\u1E7A\u6A95ot;\u6A97\u0180aps\u1E85\u1E89\u1E97cr;\u4113ty\u0180;sv\u1E92\u1E93\u1E95\u6205et\xbb\u1E93p\u01001;\u1E9D\u1EA4\u0133\u1EA1\u1EA3;\u6004;\u6005\u6003\u0100gs\u1EAA\u1EAC;\u414Bp;\u6002\u0100gp\u1EB4\u1EB8on;\u4119f;\uC000\ud835\udd56\u0180als\u1EC4\u1ECE\u1ED2r\u0100;s\u1ECA\u1ECB\u62D5l;\u69E3us;\u6A71i\u0180;lv\u1EDA\u1EDB\u1EDF\u43B5on\xbb\u1EDB;\u43F5\u0200csuv\u1EEA\u1EF3\u1F0B\u1F23\u0100io\u1EEF\u1E31rc\xbb\u1E2E\u0269\u1EF9\0\0\u1EFB\xed\u0548ant\u0100gl\u1F02\u1F06tr\xbb\u1E5Dess\xbb\u1E7A\u0180aei\u1F12\u1F16\u1F1Als;\u403Dst;\u625Fv\u0100;D\u0235\u1F20D;\u6A78parsl;\u69E5\u0100Da\u1F2F\u1F33ot;\u6253rr;\u6971\u0180cdi\u1F3E\u1F41\u1EF8r;\u612Fo\xf4\u0352\u0100ah\u1F49\u1F4B;\u43B7\u803B\xf0\u40F0\u0100mr\u1F53\u1F57l\u803B\xeb\u40EBo;\u60AC\u0180cip\u1F61\u1F64\u1F67l;\u4021s\xf4\u056E\u0100eo\u1F6C\u1F74ctatio\xee\u0559nential\xe5\u0579\u09E1\u1F92\0\u1F9E\0\u1FA1\u1FA7\0\0\u1FC6\u1FCC\0\u1FD3\0\u1FE6\u1FEA\u2000\0\u2008\u205Allingdotse\xf1\u1E44y;\u4444male;\u6640\u0180ilr\u1FAD\u1FB3\u1FC1lig;\u8000\uFB03\u0269\u1FB9\0\0\u1FBDg;\u8000\uFB00ig;\u8000\uFB04;\uC000\ud835\udd23lig;\u8000\uFB01lig;\uC000fj\u0180alt\u1FD9\u1FDC\u1FE1t;\u666Dig;\u8000\uFB02ns;\u65B1of;\u4192\u01F0\u1FEE\0\u1FF3f;\uC000\ud835\udd57\u0100ak\u05BF\u1FF7\u0100;v\u1FFC\u1FFD\u62D4;\u6AD9artint;\u6A0D\u0100ao\u200C\u2055\u0100cs\u2011\u2052\u03B1\u201A\u2030\u2038\u2045\u2048\0\u2050\u03B2\u2022\u2025\u2027\u202A\u202C\0\u202E\u803B\xbd\u40BD;\u6153\u803B\xbc\u40BC;\u6155;\u6159;\u615B\u01B3\u2034\0\u2036;\u6154;\u6156\u02B4\u203E\u2041\0\0\u2043\u803B\xbe\u40BE;\u6157;\u615C5;\u6158\u01B6\u204C\0\u204E;\u615A;\u615D8;\u615El;\u6044wn;\u6322cr;\uC000\ud835\udcbb\u0880Eabcdefgijlnorstv\u2082\u2089\u209F\u20A5\u20B0\u20B4\u20F0\u20F5\u20FA\u20FF\u2103\u2112\u2138\u0317\u213E\u2152\u219E\u0100;l\u064D\u2087;\u6A8C\u0180cmp\u2090\u2095\u209Dute;\u41F5ma\u0100;d\u209C\u1CDA\u43B3;\u6A86reve;\u411F\u0100iy\u20AA\u20AErc;\u411D;\u4433ot;\u4121\u0200;lqs\u063E\u0642\u20BD\u20C9\u0180;qs\u063E\u064C\u20C4lan\xf4\u0665\u0200;cdl\u0665\u20D2\u20D5\u20E5c;\u6AA9ot\u0100;o\u20DC\u20DD\u6A80\u0100;l\u20E2\u20E3\u6A82;\u6A84\u0100;e\u20EA\u20ED\uC000\u22DB\uFE00s;\u6A94r;\uC000\ud835\udd24\u0100;g\u0673\u061Bmel;\u6137cy;\u4453\u0200;Eaj\u065A\u210C\u210E\u2110;\u6A92;\u6AA5;\u6AA4\u0200Eaes\u211B\u211D\u2129\u2134;\u6269p\u0100;p\u2123\u2124\u6A8Arox\xbb\u2124\u0100;q\u212E\u212F\u6A88\u0100;q\u212E\u211Bim;\u62E7pf;\uC000\ud835\udd58\u0100ci\u2143\u2146r;\u610Am\u0180;el\u066B\u214E\u2150;\u6A8E;\u6A90\u8300>;cdlqr\u05EE\u2160\u216A\u216E\u2173\u2179\u0100ci\u2165\u2167;\u6AA7r;\u6A7Aot;\u62D7Par;\u6995uest;\u6A7C\u0280adels\u2184\u216A\u2190\u0656\u219B\u01F0\u2189\0\u218Epro\xf8\u209Er;\u6978q\u0100lq\u063F\u2196les\xf3\u2088i\xed\u066B\u0100en\u21A3\u21ADrtneqq;\uC000\u2269\uFE00\xc5\u21AA\u0500Aabcefkosy\u21C4\u21C7\u21F1\u21F5\u21FA\u2218\u221D\u222F\u2268\u227Dr\xf2\u03A0\u0200ilmr\u21D0\u21D4\u21D7\u21DBrs\xf0\u1484f\xbb\u2024il\xf4\u06A9\u0100dr\u21E0\u21E4cy;\u444A\u0180;cw\u08F4\u21EB\u21EFir;\u6948;\u61ADar;\u610Firc;\u4125\u0180alr\u2201\u220E\u2213rts\u0100;u\u2209\u220A\u6665it\xbb\u220Alip;\u6026con;\u62B9r;\uC000\ud835\udd25s\u0100ew\u2223\u2229arow;\u6925arow;\u6926\u0280amopr\u223A\u223E\u2243\u225E\u2263rr;\u61FFtht;\u623Bk\u0100lr\u2249\u2253eftarrow;\u61A9ightarrow;\u61AAf;\uC000\ud835\udd59bar;\u6015\u0180clt\u226F\u2274\u2278r;\uC000\ud835\udcbdas\xe8\u21F4rok;\u4127\u0100bp\u2282\u2287ull;\u6043hen\xbb\u1C5B\u0AE1\u22A3\0\u22AA\0\u22B8\u22C5\u22CE\0\u22D5\u22F3\0\0\u22F8\u2322\u2367\u2362\u237F\0\u2386\u23AA\u23B4cute\u803B\xed\u40ED\u0180;iy\u0771\u22B0\u22B5rc\u803B\xee\u40EE;\u4438\u0100cx\u22BC\u22BFy;\u4435cl\u803B\xa1\u40A1\u0100fr\u039F\u22C9;\uC000\ud835\udd26rave\u803B\xec\u40EC\u0200;ino\u073E\u22DD\u22E9\u22EE\u0100in\u22E2\u22E6nt;\u6A0Ct;\u622Dfin;\u69DCta;\u6129lig;\u4133\u0180aop\u22FE\u231A\u231D\u0180cgt\u2305\u2308\u2317r;\u412B\u0180elp\u071F\u230F\u2313in\xe5\u078Ear\xf4\u0720h;\u4131f;\u62B7ed;\u41B5\u0280;cfot\u04F4\u232C\u2331\u233D\u2341are;\u6105in\u0100;t\u2338\u2339\u621Eie;\u69DDdo\xf4\u2319\u0280;celp\u0757\u234C\u2350\u235B\u2361al;\u62BA\u0100gr\u2355\u2359er\xf3\u1563\xe3\u234Darhk;\u6A17rod;\u6A3C\u0200cgpt\u236F\u2372\u2376\u237By;\u4451on;\u412Ff;\uC000\ud835\udd5aa;\u43B9uest\u803B\xbf\u40BF\u0100ci\u238A\u238Fr;\uC000\ud835\udcben\u0280;Edsv\u04F4\u239B\u239D\u23A1\u04F3;\u62F9ot;\u62F5\u0100;v\u23A6\u23A7\u62F4;\u62F3\u0100;i\u0777\u23AElde;\u4129\u01EB\u23B8\0\u23BCcy;\u4456l\u803B\xef\u40EF\u0300cfmosu\u23CC\u23D7\u23DC\u23E1\u23E7\u23F5\u0100iy\u23D1\u23D5rc;\u4135;\u4439r;\uC000\ud835\udd27ath;\u4237pf;\uC000\ud835\udd5b\u01E3\u23EC\0\u23F1r;\uC000\ud835\udcbfrcy;\u4458kcy;\u4454\u0400acfghjos\u240B\u2416\u2422\u2427\u242D\u2431\u2435\u243Bppa\u0100;v\u2413\u2414\u43BA;\u43F0\u0100ey\u241B\u2420dil;\u4137;\u443Ar;\uC000\ud835\udd28reen;\u4138cy;\u4445cy;\u445Cpf;\uC000\ud835\udd5ccr;\uC000\ud835\udcc0\u0B80ABEHabcdefghjlmnoprstuv\u2470\u2481\u2486\u248D\u2491\u250E\u253D\u255A\u2580\u264E\u265E\u2665\u2679\u267D\u269A\u26B2\u26D8\u275D\u2768\u278B\u27C0\u2801\u2812\u0180art\u2477\u247A\u247Cr\xf2\u09C6\xf2\u0395ail;\u691Barr;\u690E\u0100;g\u0994\u248B;\u6A8Bar;\u6962\u0963\u24A5\0\u24AA\0\u24B1\0\0\0\0\0\u24B5\u24BA\0\u24C6\u24C8\u24CD\0\u24F9ute;\u413Amptyv;\u69B4ra\xee\u084Cbda;\u43BBg\u0180;dl\u088E\u24C1\u24C3;\u6991\xe5\u088E;\u6A85uo\u803B\xab\u40ABr\u0400;bfhlpst\u0899\u24DE\u24E6\u24E9\u24EB\u24EE\u24F1\u24F5\u0100;f\u089D\u24E3s;\u691Fs;\u691D\xeb\u2252p;\u61ABl;\u6939im;\u6973l;\u61A2\u0180;ae\u24FF\u2500\u2504\u6AABil;\u6919\u0100;s\u2509\u250A\u6AAD;\uC000\u2AAD\uFE00\u0180abr\u2515\u2519\u251Drr;\u690Crk;\u6772\u0100ak\u2522\u252Cc\u0100ek\u2528\u252A;\u407B;\u405B\u0100es\u2531\u2533;\u698Bl\u0100du\u2539\u253B;\u698F;\u698D\u0200aeuy\u2546\u254B\u2556\u2558ron;\u413E\u0100di\u2550\u2554il;\u413C\xec\u08B0\xe2\u2529;\u443B\u0200cqrs\u2563\u2566\u256D\u257Da;\u6936uo\u0100;r\u0E19\u1746\u0100du\u2572\u2577har;\u6967shar;\u694Bh;\u61B2\u0280;fgqs\u258B\u258C\u0989\u25F3\u25FF\u6264t\u0280ahlrt\u2598\u25A4\u25B7\u25C2\u25E8rrow\u0100;t\u0899\u25A1a\xe9\u24F6arpoon\u0100du\u25AF\u25B4own\xbb\u045Ap\xbb\u0966eftarrows;\u61C7ight\u0180ahs\u25CD\u25D6\u25DErrow\u0100;s\u08F4\u08A7arpoon\xf3\u0F98quigarro\xf7\u21F0hreetimes;\u62CB\u0180;qs\u258B\u0993\u25FAlan\xf4\u09AC\u0280;cdgs\u09AC\u260A\u260D\u261D\u2628c;\u6AA8ot\u0100;o\u2614\u2615\u6A7F\u0100;r\u261A\u261B\u6A81;\u6A83\u0100;e\u2622\u2625\uC000\u22DA\uFE00s;\u6A93\u0280adegs\u2633\u2639\u263D\u2649\u264Bppro\xf8\u24C6ot;\u62D6q\u0100gq\u2643\u2645\xf4\u0989gt\xf2\u248C\xf4\u099Bi\xed\u09B2\u0180ilr\u2655\u08E1\u265Asht;\u697C;\uC000\ud835\udd29\u0100;E\u099C\u2663;\u6A91\u0161\u2669\u2676r\u0100du\u25B2\u266E\u0100;l\u0965\u2673;\u696Alk;\u6584cy;\u4459\u0280;acht\u0A48\u2688\u268B\u2691\u2696r\xf2\u25C1orne\xf2\u1D08ard;\u696Bri;\u65FA\u0100io\u269F\u26A4dot;\u4140ust\u0100;a\u26AC\u26AD\u63B0che\xbb\u26AD\u0200Eaes\u26BB\u26BD\u26C9\u26D4;\u6268p\u0100;p\u26C3\u26C4\u6A89rox\xbb\u26C4\u0100;q\u26CE\u26CF\u6A87\u0100;q\u26CE\u26BBim;\u62E6\u0400abnoptwz\u26E9\u26F4\u26F7\u271A\u272F\u2741\u2747\u2750\u0100nr\u26EE\u26F1g;\u67ECr;\u61FDr\xeb\u08C1g\u0180lmr\u26FF\u270D\u2714eft\u0100ar\u09E6\u2707ight\xe1\u09F2apsto;\u67FCight\xe1\u09FDparrow\u0100lr\u2725\u2729ef\xf4\u24EDight;\u61AC\u0180afl\u2736\u2739\u273Dr;\u6985;\uC000\ud835\udd5dus;\u6A2Dimes;\u6A34\u0161\u274B\u274Fst;\u6217\xe1\u134E\u0180;ef\u2757\u2758\u1800\u65CAnge\xbb\u2758ar\u0100;l\u2764\u2765\u4028t;\u6993\u0280achmt\u2773\u2776\u277C\u2785\u2787r\xf2\u08A8orne\xf2\u1D8Car\u0100;d\u0F98\u2783;\u696D;\u600Eri;\u62BF\u0300achiqt\u2798\u279D\u0A40\u27A2\u27AE\u27BBquo;\u6039r;\uC000\ud835\udcc1m\u0180;eg\u09B2\u27AA\u27AC;\u6A8D;\u6A8F\u0100bu\u252A\u27B3o\u0100;r\u0E1F\u27B9;\u601Arok;\u4142\u8400<;cdhilqr\u082B\u27D2\u2639\u27DC\u27E0\u27E5\u27EA\u27F0\u0100ci\u27D7\u27D9;\u6AA6r;\u6A79re\xe5\u25F2mes;\u62C9arr;\u6976uest;\u6A7B\u0100Pi\u27F5\u27F9ar;\u6996\u0180;ef\u2800\u092D\u181B\u65C3r\u0100du\u2807\u280Dshar;\u694Ahar;\u6966\u0100en\u2817\u2821rtneqq;\uC000\u2268\uFE00\xc5\u281E\u0700Dacdefhilnopsu\u2840\u2845\u2882\u288E\u2893\u28A0\u28A5\u28A8\u28DA\u28E2\u28E4\u0A83\u28F3\u2902Dot;\u623A\u0200clpr\u284E\u2852\u2863\u287Dr\u803B\xaf\u40AF\u0100et\u2857\u2859;\u6642\u0100;e\u285E\u285F\u6720se\xbb\u285F\u0100;s\u103B\u2868to\u0200;dlu\u103B\u2873\u2877\u287Bow\xee\u048Cef\xf4\u090F\xf0\u13D1ker;\u65AE\u0100oy\u2887\u288Cmma;\u6A29;\u443Cash;\u6014asuredangle\xbb\u1626r;\uC000\ud835\udd2ao;\u6127\u0180cdn\u28AF\u28B4\u28C9ro\u803B\xb5\u40B5\u0200;acd\u1464\u28BD\u28C0\u28C4s\xf4\u16A7ir;\u6AF0ot\u80BB\xb7\u01B5us\u0180;bd\u28D2\u1903\u28D3\u6212\u0100;u\u1D3C\u28D8;\u6A2A\u0163\u28DE\u28E1p;\u6ADB\xf2\u2212\xf0\u0A81\u0100dp\u28E9\u28EEels;\u62A7f;\uC000\ud835\udd5e\u0100ct\u28F8\u28FDr;\uC000\ud835\udcc2pos\xbb\u159D\u0180;lm\u2909\u290A\u290D\u43BCtimap;\u62B8\u0C00GLRVabcdefghijlmoprstuvw\u2942\u2953\u297E\u2989\u2998\u29DA\u29E9\u2A15\u2A1A\u2A58\u2A5D\u2A83\u2A95\u2AA4\u2AA8\u2B04\u2B07\u2B44\u2B7F\u2BAE\u2C34\u2C67\u2C7C\u2CE9\u0100gt\u2947\u294B;\uC000\u22D9\u0338\u0100;v\u2950\u0BCF\uC000\u226B\u20D2\u0180elt\u295A\u2972\u2976ft\u0100ar\u2961\u2967rrow;\u61CDightarrow;\u61CE;\uC000\u22D8\u0338\u0100;v\u297B\u0C47\uC000\u226A\u20D2ightarrow;\u61CF\u0100Dd\u298E\u2993ash;\u62AFash;\u62AE\u0280bcnpt\u29A3\u29A7\u29AC\u29B1\u29CCla\xbb\u02DEute;\u4144g;\uC000\u2220\u20D2\u0280;Eiop\u0D84\u29BC\u29C0\u29C5\u29C8;\uC000\u2A70\u0338d;\uC000\u224B\u0338s;\u4149ro\xf8\u0D84ur\u0100;a\u29D3\u29D4\u666El\u0100;s\u29D3\u0B38\u01F3\u29DF\0\u29E3p\u80BB\xa0\u0B37mp\u0100;e\u0BF9\u0C00\u0280aeouy\u29F4\u29FE\u2A03\u2A10\u2A13\u01F0\u29F9\0\u29FB;\u6A43on;\u4148dil;\u4146ng\u0100;d\u0D7E\u2A0Aot;\uC000\u2A6D\u0338p;\u6A42;\u443Dash;\u6013\u0380;Aadqsx\u0B92\u2A29\u2A2D\u2A3B\u2A41\u2A45\u2A50rr;\u61D7r\u0100hr\u2A33\u2A36k;\u6924\u0100;o\u13F2\u13F0ot;\uC000\u2250\u0338ui\xf6\u0B63\u0100ei\u2A4A\u2A4Ear;\u6928\xed\u0B98ist\u0100;s\u0BA0\u0B9Fr;\uC000\ud835\udd2b\u0200Eest\u0BC5\u2A66\u2A79\u2A7C\u0180;qs\u0BBC\u2A6D\u0BE1\u0180;qs\u0BBC\u0BC5\u2A74lan\xf4\u0BE2i\xed\u0BEA\u0100;r\u0BB6\u2A81\xbb\u0BB7\u0180Aap\u2A8A\u2A8D\u2A91r\xf2\u2971rr;\u61AEar;\u6AF2\u0180;sv\u0F8D\u2A9C\u0F8C\u0100;d\u2AA1\u2AA2\u62FC;\u62FAcy;\u445A\u0380AEadest\u2AB7\u2ABA\u2ABE\u2AC2\u2AC5\u2AF6\u2AF9r\xf2\u2966;\uC000\u2266\u0338rr;\u619Ar;\u6025\u0200;fqs\u0C3B\u2ACE\u2AE3\u2AEFt\u0100ar\u2AD4\u2AD9rro\xf7\u2AC1ightarro\xf7\u2A90\u0180;qs\u0C3B\u2ABA\u2AEAlan\xf4\u0C55\u0100;s\u0C55\u2AF4\xbb\u0C36i\xed\u0C5D\u0100;r\u0C35\u2AFEi\u0100;e\u0C1A\u0C25i\xe4\u0D90\u0100pt\u2B0C\u2B11f;\uC000\ud835\udd5f\u8180\xac;in\u2B19\u2B1A\u2B36\u40ACn\u0200;Edv\u0B89\u2B24\u2B28\u2B2E;\uC000\u22F9\u0338ot;\uC000\u22F5\u0338\u01E1\u0B89\u2B33\u2B35;\u62F7;\u62F6i\u0100;v\u0CB8\u2B3C\u01E1\u0CB8\u2B41\u2B43;\u62FE;\u62FD\u0180aor\u2B4B\u2B63\u2B69r\u0200;ast\u0B7B\u2B55\u2B5A\u2B5Flle\xec\u0B7Bl;\uC000\u2AFD\u20E5;\uC000\u2202\u0338lint;\u6A14\u0180;ce\u0C92\u2B70\u2B73u\xe5\u0CA5\u0100;c\u0C98\u2B78\u0100;e\u0C92\u2B7D\xf1\u0C98\u0200Aait\u2B88\u2B8B\u2B9D\u2BA7r\xf2\u2988rr\u0180;cw\u2B94\u2B95\u2B99\u619B;\uC000\u2933\u0338;\uC000\u219D\u0338ghtarrow\xbb\u2B95ri\u0100;e\u0CCB\u0CD6\u0380chimpqu\u2BBD\u2BCD\u2BD9\u2B04\u0B78\u2BE4\u2BEF\u0200;cer\u0D32\u2BC6\u0D37\u2BC9u\xe5\u0D45;\uC000\ud835\udcc3ort\u026D\u2B05\0\0\u2BD6ar\xe1\u2B56m\u0100;e\u0D6E\u2BDF\u0100;q\u0D74\u0D73su\u0100bp\u2BEB\u2BED\xe5\u0CF8\xe5\u0D0B\u0180bcp\u2BF6\u2C11\u2C19\u0200;Ees\u2BFF\u2C00\u0D22\u2C04\u6284;\uC000\u2AC5\u0338et\u0100;e\u0D1B\u2C0Bq\u0100;q\u0D23\u2C00c\u0100;e\u0D32\u2C17\xf1\u0D38\u0200;Ees\u2C22\u2C23\u0D5F\u2C27\u6285;\uC000\u2AC6\u0338et\u0100;e\u0D58\u2C2Eq\u0100;q\u0D60\u2C23\u0200gilr\u2C3D\u2C3F\u2C45\u2C47\xec\u0BD7lde\u803B\xf1\u40F1\xe7\u0C43iangle\u0100lr\u2C52\u2C5Ceft\u0100;e\u0C1A\u2C5A\xf1\u0C26ight\u0100;e\u0CCB\u2C65\xf1\u0CD7\u0100;m\u2C6C\u2C6D\u43BD\u0180;es\u2C74\u2C75\u2C79\u4023ro;\u6116p;\u6007\u0480DHadgilrs\u2C8F\u2C94\u2C99\u2C9E\u2CA3\u2CB0\u2CB6\u2CD3\u2CE3ash;\u62ADarr;\u6904p;\uC000\u224D\u20D2ash;\u62AC\u0100et\u2CA8\u2CAC;\uC000\u2265\u20D2;\uC000>\u20D2nfin;\u69DE\u0180Aet\u2CBD\u2CC1\u2CC5rr;\u6902;\uC000\u2264\u20D2\u0100;r\u2CCA\u2CCD\uC000<\u20D2ie;\uC000\u22B4\u20D2\u0100At\u2CD8\u2CDCrr;\u6903rie;\uC000\u22B5\u20D2im;\uC000\u223C\u20D2\u0180Aan\u2CF0\u2CF4\u2D02rr;\u61D6r\u0100hr\u2CFA\u2CFDk;\u6923\u0100;o\u13E7\u13E5ear;\u6927\u1253\u1A95\0\0\0\0\0\0\0\0\0\0\0\0\0\u2D2D\0\u2D38\u2D48\u2D60\u2D65\u2D72\u2D84\u1B07\0\0\u2D8D\u2DAB\0\u2DC8\u2DCE\0\u2DDC\u2E19\u2E2B\u2E3E\u2E43\u0100cs\u2D31\u1A97ute\u803B\xf3\u40F3\u0100iy\u2D3C\u2D45r\u0100;c\u1A9E\u2D42\u803B\xf4\u40F4;\u443E\u0280abios\u1AA0\u2D52\u2D57\u01C8\u2D5Alac;\u4151v;\u6A38old;\u69BClig;\u4153\u0100cr\u2D69\u2D6Dir;\u69BF;\uC000\ud835\udd2c\u036F\u2D79\0\0\u2D7C\0\u2D82n;\u42DBave\u803B\xf2\u40F2;\u69C1\u0100bm\u2D88\u0DF4ar;\u69B5\u0200acit\u2D95\u2D98\u2DA5\u2DA8r\xf2\u1A80\u0100ir\u2D9D\u2DA0r;\u69BEoss;\u69BBn\xe5\u0E52;\u69C0\u0180aei\u2DB1\u2DB5\u2DB9cr;\u414Dga;\u43C9\u0180cdn\u2DC0\u2DC5\u01CDron;\u43BF;\u69B6pf;\uC000\ud835\udd60\u0180ael\u2DD4\u2DD7\u01D2r;\u69B7rp;\u69B9\u0380;adiosv\u2DEA\u2DEB\u2DEE\u2E08\u2E0D\u2E10\u2E16\u6228r\xf2\u1A86\u0200;efm\u2DF7\u2DF8\u2E02\u2E05\u6A5Dr\u0100;o\u2DFE\u2DFF\u6134f\xbb\u2DFF\u803B\xaa\u40AA\u803B\xba\u40BAgof;\u62B6r;\u6A56lope;\u6A57;\u6A5B\u0180clo\u2E1F\u2E21\u2E27\xf2\u2E01ash\u803B\xf8\u40F8l;\u6298i\u016C\u2E2F\u2E34de\u803B\xf5\u40F5es\u0100;a\u01DB\u2E3As;\u6A36ml\u803B\xf6\u40F6bar;\u633D\u0AE1\u2E5E\0\u2E7D\0\u2E80\u2E9D\0\u2EA2\u2EB9\0\0\u2ECB\u0E9C\0\u2F13\0\0\u2F2B\u2FBC\0\u2FC8r\u0200;ast\u0403\u2E67\u2E72\u0E85\u8100\xb6;l\u2E6D\u2E6E\u40B6le\xec\u0403\u0269\u2E78\0\0\u2E7Bm;\u6AF3;\u6AFDy;\u443Fr\u0280cimpt\u2E8B\u2E8F\u2E93\u1865\u2E97nt;\u4025od;\u402Eil;\u6030enk;\u6031r;\uC000\ud835\udd2d\u0180imo\u2EA8\u2EB0\u2EB4\u0100;v\u2EAD\u2EAE\u43C6;\u43D5ma\xf4\u0A76ne;\u660E\u0180;tv\u2EBF\u2EC0\u2EC8\u43C0chfork\xbb\u1FFD;\u43D6\u0100au\u2ECF\u2EDFn\u0100ck\u2ED5\u2EDDk\u0100;h\u21F4\u2EDB;\u610E\xf6\u21F4s\u0480;abcdemst\u2EF3\u2EF4\u1908\u2EF9\u2EFD\u2F04\u2F06\u2F0A\u2F0E\u402Bcir;\u6A23ir;\u6A22\u0100ou\u1D40\u2F02;\u6A25;\u6A72n\u80BB\xb1\u0E9Dim;\u6A26wo;\u6A27\u0180ipu\u2F19\u2F20\u2F25ntint;\u6A15f;\uC000\ud835\udd61nd\u803B\xa3\u40A3\u0500;Eaceinosu\u0EC8\u2F3F\u2F41\u2F44\u2F47\u2F81\u2F89\u2F92\u2F7E\u2FB6;\u6AB3p;\u6AB7u\xe5\u0ED9\u0100;c\u0ECE\u2F4C\u0300;acens\u0EC8\u2F59\u2F5F\u2F66\u2F68\u2F7Eppro\xf8\u2F43urlye\xf1\u0ED9\xf1\u0ECE\u0180aes\u2F6F\u2F76\u2F7Approx;\u6AB9qq;\u6AB5im;\u62E8i\xed\u0EDFme\u0100;s\u2F88\u0EAE\u6032\u0180Eas\u2F78\u2F90\u2F7A\xf0\u2F75\u0180dfp\u0EEC\u2F99\u2FAF\u0180als\u2FA0\u2FA5\u2FAAlar;\u632Eine;\u6312urf;\u6313\u0100;t\u0EFB\u2FB4\xef\u0EFBrel;\u62B0\u0100ci\u2FC0\u2FC5r;\uC000\ud835\udcc5;\u43C8ncsp;\u6008\u0300fiopsu\u2FDA\u22E2\u2FDF\u2FE5\u2FEB\u2FF1r;\uC000\ud835\udd2epf;\uC000\ud835\udd62rime;\u6057cr;\uC000\ud835\udcc6\u0180aeo\u2FF8\u3009\u3013t\u0100ei\u2FFE\u3005rnion\xf3\u06B0nt;\u6A16st\u0100;e\u3010\u3011\u403F\xf1\u1F19\xf4\u0F14\u0A80ABHabcdefhilmnoprstux\u3040\u3051\u3055\u3059\u30E0\u310E\u312B\u3147\u3162\u3172\u318E\u3206\u3215\u3224\u3229\u3258\u326E\u3272\u3290\u32B0\u32B7\u0180art\u3047\u304A\u304Cr\xf2\u10B3\xf2\u03DDail;\u691Car\xf2\u1C65ar;\u6964\u0380cdenqrt\u3068\u3075\u3078\u307F\u308F\u3094\u30CC\u0100eu\u306D\u3071;\uC000\u223D\u0331te;\u4155i\xe3\u116Emptyv;\u69B3g\u0200;del\u0FD1\u3089\u308B\u308D;\u6992;\u69A5\xe5\u0FD1uo\u803B\xbb\u40BBr\u0580;abcfhlpstw\u0FDC\u30AC\u30AF\u30B7\u30B9\u30BC\u30BE\u30C0\u30C3\u30C7\u30CAp;\u6975\u0100;f\u0FE0\u30B4s;\u6920;\u6933s;\u691E\xeb\u225D\xf0\u272El;\u6945im;\u6974l;\u61A3;\u619D\u0100ai\u30D1\u30D5il;\u691Ao\u0100;n\u30DB\u30DC\u6236al\xf3\u0F1E\u0180abr\u30E7\u30EA\u30EEr\xf2\u17E5rk;\u6773\u0100ak\u30F3\u30FDc\u0100ek\u30F9\u30FB;\u407D;\u405D\u0100es\u3102\u3104;\u698Cl\u0100du\u310A\u310C;\u698E;\u6990\u0200aeuy\u3117\u311C\u3127\u3129ron;\u4159\u0100di\u3121\u3125il;\u4157\xec\u0FF2\xe2\u30FA;\u4440\u0200clqs\u3134\u3137\u313D\u3144a;\u6937dhar;\u6969uo\u0100;r\u020E\u020Dh;\u61B3\u0180acg\u314E\u315F\u0F44l\u0200;ips\u0F78\u3158\u315B\u109Cn\xe5\u10BBar\xf4\u0FA9t;\u65AD\u0180ilr\u3169\u1023\u316Esht;\u697D;\uC000\ud835\udd2f\u0100ao\u3177\u3186r\u0100du\u317D\u317F\xbb\u047B\u0100;l\u1091\u3184;\u696C\u0100;v\u318B\u318C\u43C1;\u43F1\u0180gns\u3195\u31F9\u31FCht\u0300ahlrst\u31A4\u31B0\u31C2\u31D8\u31E4\u31EErrow\u0100;t\u0FDC\u31ADa\xe9\u30C8arpoon\u0100du\u31BB\u31BFow\xee\u317Ep\xbb\u1092eft\u0100ah\u31CA\u31D0rrow\xf3\u0FEAarpoon\xf3\u0551ightarrows;\u61C9quigarro\xf7\u30CBhreetimes;\u62CCg;\u42DAingdotse\xf1\u1F32\u0180ahm\u320D\u3210\u3213r\xf2\u0FEAa\xf2\u0551;\u600Foust\u0100;a\u321E\u321F\u63B1che\xbb\u321Fmid;\u6AEE\u0200abpt\u3232\u323D\u3240\u3252\u0100nr\u3237\u323Ag;\u67EDr;\u61FEr\xeb\u1003\u0180afl\u3247\u324A\u324Er;\u6986;\uC000\ud835\udd63us;\u6A2Eimes;\u6A35\u0100ap\u325D\u3267r\u0100;g\u3263\u3264\u4029t;\u6994olint;\u6A12ar\xf2\u31E3\u0200achq\u327B\u3280\u10BC\u3285quo;\u603Ar;\uC000\ud835\udcc7\u0100bu\u30FB\u328Ao\u0100;r\u0214\u0213\u0180hir\u3297\u329B\u32A0re\xe5\u31F8mes;\u62CAi\u0200;efl\u32AA\u1059\u1821\u32AB\u65B9tri;\u69CEluhar;\u6968;\u611E\u0D61\u32D5\u32DB\u32DF\u332C\u3338\u3371\0\u337A\u33A4\0\0\u33EC\u33F0\0\u3428\u3448\u345A\u34AD\u34B1\u34CA\u34F1\0\u3616\0\0\u3633cute;\u415Bqu\xef\u27BA\u0500;Eaceinpsy\u11ED\u32F3\u32F5\u32FF\u3302\u330B\u330F\u331F\u3326\u3329;\u6AB4\u01F0\u32FA\0\u32FC;\u6AB8on;\u4161u\xe5\u11FE\u0100;d\u11F3\u3307il;\u415Frc;\u415D\u0180Eas\u3316\u3318\u331B;\u6AB6p;\u6ABAim;\u62E9olint;\u6A13i\xed\u1204;\u4441ot\u0180;be\u3334\u1D47\u3335\u62C5;\u6A66\u0380Aacmstx\u3346\u334A\u3357\u335B\u335E\u3363\u336Drr;\u61D8r\u0100hr\u3350\u3352\xeb\u2228\u0100;o\u0A36\u0A34t\u803B\xa7\u40A7i;\u403Bwar;\u6929m\u0100in\u3369\xf0nu\xf3\xf1t;\u6736r\u0100;o\u3376\u2055\uC000\ud835\udd30\u0200acoy\u3382\u3386\u3391\u33A0rp;\u666F\u0100hy\u338B\u338Fcy;\u4449;\u4448rt\u026D\u3399\0\0\u339Ci\xe4\u1464ara\xec\u2E6F\u803B\xad\u40AD\u0100gm\u33A8\u33B4ma\u0180;fv\u33B1\u33B2\u33B2\u43C3;\u43C2\u0400;deglnpr\u12AB\u33C5\u33C9\u33CE\u33D6\u33DE\u33E1\u33E6ot;\u6A6A\u0100;q\u12B1\u12B0\u0100;E\u33D3\u33D4\u6A9E;\u6AA0\u0100;E\u33DB\u33DC\u6A9D;\u6A9Fe;\u6246lus;\u6A24arr;\u6972ar\xf2\u113D\u0200aeit\u33F8\u3408\u340F\u3417\u0100ls\u33FD\u3404lsetm\xe9\u336Ahp;\u6A33parsl;\u69E4\u0100dl\u1463\u3414e;\u6323\u0100;e\u341C\u341D\u6AAA\u0100;s\u3422\u3423\u6AAC;\uC000\u2AAC\uFE00\u0180flp\u342E\u3433\u3442tcy;\u444C\u0100;b\u3438\u3439\u402F\u0100;a\u343E\u343F\u69C4r;\u633Ff;\uC000\ud835\udd64a\u0100dr\u344D\u0402es\u0100;u\u3454\u3455\u6660it\xbb\u3455\u0180csu\u3460\u3479\u349F\u0100au\u3465\u346Fp\u0100;s\u1188\u346B;\uC000\u2293\uFE00p\u0100;s\u11B4\u3475;\uC000\u2294\uFE00u\u0100bp\u347F\u348F\u0180;es\u1197\u119C\u3486et\u0100;e\u1197\u348D\xf1\u119D\u0180;es\u11A8\u11AD\u3496et\u0100;e\u11A8\u349D\xf1\u11AE\u0180;af\u117B\u34A6\u05B0r\u0165\u34AB\u05B1\xbb\u117Car\xf2\u1148\u0200cemt\u34B9\u34BE\u34C2\u34C5r;\uC000\ud835\udcc8tm\xee\xf1i\xec\u3415ar\xe6\u11BE\u0100ar\u34CE\u34D5r\u0100;f\u34D4\u17BF\u6606\u0100an\u34DA\u34EDight\u0100ep\u34E3\u34EApsilo\xee\u1EE0h\xe9\u2EAFs\xbb\u2852\u0280bcmnp\u34FB\u355E\u1209\u358B\u358E\u0480;Edemnprs\u350E\u350F\u3511\u3515\u351E\u3523\u352C\u3531\u3536\u6282;\u6AC5ot;\u6ABD\u0100;d\u11DA\u351Aot;\u6AC3ult;\u6AC1\u0100Ee\u3528\u352A;\u6ACB;\u628Alus;\u6ABFarr;\u6979\u0180eiu\u353D\u3552\u3555t\u0180;en\u350E\u3545\u354Bq\u0100;q\u11DA\u350Feq\u0100;q\u352B\u3528m;\u6AC7\u0100bp\u355A\u355C;\u6AD5;\u6AD3c\u0300;acens\u11ED\u356C\u3572\u3579\u357B\u3326ppro\xf8\u32FAurlye\xf1\u11FE\xf1\u11F3\u0180aes\u3582\u3588\u331Bppro\xf8\u331Aq\xf1\u3317g;\u666A\u0680123;Edehlmnps\u35A9\u35AC\u35AF\u121C\u35B2\u35B4\u35C0\u35C9\u35D5\u35DA\u35DF\u35E8\u35ED\u803B\xb9\u40B9\u803B\xb2\u40B2\u803B\xb3\u40B3;\u6AC6\u0100os\u35B9\u35BCt;\u6ABEub;\u6AD8\u0100;d\u1222\u35C5ot;\u6AC4s\u0100ou\u35CF\u35D2l;\u67C9b;\u6AD7arr;\u697Bult;\u6AC2\u0100Ee\u35E4\u35E6;\u6ACC;\u628Blus;\u6AC0\u0180eiu\u35F4\u3609\u360Ct\u0180;en\u121C\u35FC\u3602q\u0100;q\u1222\u35B2eq\u0100;q\u35E7\u35E4m;\u6AC8\u0100bp\u3611\u3613;\u6AD4;\u6AD6\u0180Aan\u361C\u3620\u362Drr;\u61D9r\u0100hr\u3626\u3628\xeb\u222E\u0100;o\u0A2B\u0A29war;\u692Alig\u803B\xdf\u40DF\u0BE1\u3651\u365D\u3660\u12CE\u3673\u3679\0\u367E\u36C2\0\0\0\0\0\u36DB\u3703\0\u3709\u376C\0\0\0\u3787\u0272\u3656\0\0\u365Bget;\u6316;\u43C4r\xeb\u0E5F\u0180aey\u3666\u366B\u3670ron;\u4165dil;\u4163;\u4442lrec;\u6315r;\uC000\ud835\udd31\u0200eiko\u3686\u369D\u36B5\u36BC\u01F2\u368B\0\u3691e\u01004f\u1284\u1281a\u0180;sv\u3698\u3699\u369B\u43B8ym;\u43D1\u0100cn\u36A2\u36B2k\u0100as\u36A8\u36AEppro\xf8\u12C1im\xbb\u12ACs\xf0\u129E\u0100as\u36BA\u36AE\xf0\u12C1rn\u803B\xfe\u40FE\u01EC\u031F\u36C6\u22E7es\u8180\xd7;bd\u36CF\u36D0\u36D8\u40D7\u0100;a\u190F\u36D5r;\u6A31;\u6A30\u0180eps\u36E1\u36E3\u3700\xe1\u2A4D\u0200;bcf\u0486\u36EC\u36F0\u36F4ot;\u6336ir;\u6AF1\u0100;o\u36F9\u36FC\uC000\ud835\udd65rk;\u6ADA\xe1\u3362rime;\u6034\u0180aip\u370F\u3712\u3764d\xe5\u1248\u0380adempst\u3721\u374D\u3740\u3751\u3757\u375C\u375Fngle\u0280;dlqr\u3730\u3731\u3736\u3740\u3742\u65B5own\xbb\u1DBBeft\u0100;e\u2800\u373E\xf1\u092E;\u625Cight\u0100;e\u32AA\u374B\xf1\u105Aot;\u65ECinus;\u6A3Alus;\u6A39b;\u69CDime;\u6A3Bezium;\u63E2\u0180cht\u3772\u377D\u3781\u0100ry\u3777\u377B;\uC000\ud835\udcc9;\u4446cy;\u445Brok;\u4167\u0100io\u378B\u378Ex\xf4\u1777head\u0100lr\u3797\u37A0eftarro\xf7\u084Fightarrow\xbb\u0F5D\u0900AHabcdfghlmoprstuw\u37D0\u37D3\u37D7\u37E4\u37F0\u37FC\u380E\u381C\u3823\u3834\u3851\u385D\u386B\u38A9\u38CC\u38D2\u38EA\u38F6r\xf2\u03EDar;\u6963\u0100cr\u37DC\u37E2ute\u803B\xfa\u40FA\xf2\u1150r\u01E3\u37EA\0\u37EDy;\u445Eve;\u416D\u0100iy\u37F5\u37FArc\u803B\xfb\u40FB;\u4443\u0180abh\u3803\u3806\u380Br\xf2\u13ADlac;\u4171a\xf2\u13C3\u0100ir\u3813\u3818sht;\u697E;\uC000\ud835\udd32rave\u803B\xf9\u40F9\u0161\u3827\u3831r\u0100lr\u382C\u382E\xbb\u0957\xbb\u1083lk;\u6580\u0100ct\u3839\u384D\u026F\u383F\0\0\u384Arn\u0100;e\u3845\u3846\u631Cr\xbb\u3846op;\u630Fri;\u65F8\u0100al\u3856\u385Acr;\u416B\u80BB\xa8\u0349\u0100gp\u3862\u3866on;\u4173f;\uC000\ud835\udd66\u0300adhlsu\u114B\u3878\u387D\u1372\u3891\u38A0own\xe1\u13B3arpoon\u0100lr\u3888\u388Cef\xf4\u382Digh\xf4\u382Fi\u0180;hl\u3899\u389A\u389C\u43C5\xbb\u13FAon\xbb\u389Aparrows;\u61C8\u0180cit\u38B0\u38C4\u38C8\u026F\u38B6\0\0\u38C1rn\u0100;e\u38BC\u38BD\u631Dr\xbb\u38BDop;\u630Eng;\u416Fri;\u65F9cr;\uC000\ud835\udcca\u0180dir\u38D9\u38DD\u38E2ot;\u62F0lde;\u4169i\u0100;f\u3730\u38E8\xbb\u1813\u0100am\u38EF\u38F2r\xf2\u38A8l\u803B\xfc\u40FCangle;\u69A7\u0780ABDacdeflnoprsz\u391C\u391F\u3929\u392D\u39B5\u39B8\u39BD\u39DF\u39E4\u39E8\u39F3\u39F9\u39FD\u3A01\u3A20r\xf2\u03F7ar\u0100;v\u3926\u3927\u6AE8;\u6AE9as\xe8\u03E1\u0100nr\u3932\u3937grt;\u699C\u0380eknprst\u34E3\u3946\u394B\u3952\u395D\u3964\u3996app\xe1\u2415othin\xe7\u1E96\u0180hir\u34EB\u2EC8\u3959op\xf4\u2FB5\u0100;h\u13B7\u3962\xef\u318D\u0100iu\u3969\u396Dgm\xe1\u33B3\u0100bp\u3972\u3984setneq\u0100;q\u397D\u3980\uC000\u228A\uFE00;\uC000\u2ACB\uFE00setneq\u0100;q\u398F\u3992\uC000\u228B\uFE00;\uC000\u2ACC\uFE00\u0100hr\u399B\u399Fet\xe1\u369Ciangle\u0100lr\u39AA\u39AFeft\xbb\u0925ight\xbb\u1051y;\u4432ash\xbb\u1036\u0180elr\u39C4\u39D2\u39D7\u0180;be\u2DEA\u39CB\u39CFar;\u62BBq;\u625Alip;\u62EE\u0100bt\u39DC\u1468a\xf2\u1469r;\uC000\ud835\udd33tr\xe9\u39AEsu\u0100bp\u39EF\u39F1\xbb\u0D1C\xbb\u0D59pf;\uC000\ud835\udd67ro\xf0\u0EFBtr\xe9\u39B4\u0100cu\u3A06\u3A0Br;\uC000\ud835\udccb\u0100bp\u3A10\u3A18n\u0100Ee\u3980\u3A16\xbb\u397En\u0100Ee\u3992\u3A1E\xbb\u3990igzag;\u699A\u0380cefoprs\u3A36\u3A3B\u3A56\u3A5B\u3A54\u3A61\u3A6Airc;\u4175\u0100di\u3A40\u3A51\u0100bg\u3A45\u3A49ar;\u6A5Fe\u0100;q\u15FA\u3A4F;\u6259erp;\u6118r;\uC000\ud835\udd34pf;\uC000\ud835\udd68\u0100;e\u1479\u3A66at\xe8\u1479cr;\uC000\ud835\udccc\u0AE3\u178E\u3A87\0\u3A8B\0\u3A90\u3A9B\0\0\u3A9D\u3AA8\u3AAB\u3AAF\0\0\u3AC3\u3ACE\0\u3AD8\u17DC\u17DFtr\xe9\u17D1r;\uC000\ud835\udd35\u0100Aa\u3A94\u3A97r\xf2\u03C3r\xf2\u09F6;\u43BE\u0100Aa\u3AA1\u3AA4r\xf2\u03B8r\xf2\u09EBa\xf0\u2713is;\u62FB\u0180dpt\u17A4\u3AB5\u3ABE\u0100fl\u3ABA\u17A9;\uC000\ud835\udd69im\xe5\u17B2\u0100Aa\u3AC7\u3ACAr\xf2\u03CEr\xf2\u0A01\u0100cq\u3AD2\u17B8r;\uC000\ud835\udccd\u0100pt\u17D6\u3ADCr\xe9\u17D4\u0400acefiosu\u3AF0\u3AFD\u3B08\u3B0C\u3B11\u3B15\u3B1B\u3B21c\u0100uy\u3AF6\u3AFBte\u803B\xfd\u40FD;\u444F\u0100iy\u3B02\u3B06rc;\u4177;\u444Bn\u803B\xa5\u40A5r;\uC000\ud835\udd36cy;\u4457pf;\uC000\ud835\udd6acr;\uC000\ud835\udcce\u0100cm\u3B26\u3B29y;\u444El\u803B\xff\u40FF\u0500acdefhiosw\u3B42\u3B48\u3B54\u3B58\u3B64\u3B69\u3B6D\u3B74\u3B7A\u3B80cute;\u417A\u0100ay\u3B4D\u3B52ron;\u417E;\u4437ot;\u417C\u0100et\u3B5D\u3B61tr\xe6\u155Fa;\u43B6r;\uC000\ud835\udd37cy;\u4436grarr;\u61DDpf;\uC000\ud835\udd6bcr;\uC000\ud835\udccf\u0100jn\u3B85\u3B87;\u600Dj;\u600C'.split("").map(function(c) {
    return c.charCodeAt(0);
}));

});

parcelRegister("l1aB5", function(module, exports) {
"use strict";
// Generated using scripts/write-decode-map.ts
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = new Uint16Array(// prettier-ignore
"\u0200aglq	\x15\x18\x1b\u026D\x0f\0\0\x12p;\u4026os;\u4027t;\u403Et;\u403Cuot;\u4022".split("").map(function(c) {
    return c.charCodeAt(0);
}));

});

parcelRegister("5Sc3b", function(module, exports) {
"use strict";
// Adapted from https://github.com/mathiasbynens/he/blob/36afe179392226cf1b6ccdb16ebbb7a5a844d93a/src/he.js#L106-L134
var $011a816ab9920cfe$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.replaceCodePoint = module.exports.fromCodePoint = void 0;
var $011a816ab9920cfe$var$decodeMap = new Map([
    [
        0,
        65533
    ],
    // C1 Unicode control character reference replacements
    [
        128,
        8364
    ],
    [
        130,
        8218
    ],
    [
        131,
        402
    ],
    [
        132,
        8222
    ],
    [
        133,
        8230
    ],
    [
        134,
        8224
    ],
    [
        135,
        8225
    ],
    [
        136,
        710
    ],
    [
        137,
        8240
    ],
    [
        138,
        352
    ],
    [
        139,
        8249
    ],
    [
        140,
        338
    ],
    [
        142,
        381
    ],
    [
        145,
        8216
    ],
    [
        146,
        8217
    ],
    [
        147,
        8220
    ],
    [
        148,
        8221
    ],
    [
        149,
        8226
    ],
    [
        150,
        8211
    ],
    [
        151,
        8212
    ],
    [
        152,
        732
    ],
    [
        153,
        8482
    ],
    [
        154,
        353
    ],
    [
        155,
        8250
    ],
    [
        156,
        339
    ],
    [
        158,
        382
    ],
    [
        159,
        376
    ]
]);
/**
 * Polyfill for `String.fromCodePoint`. It is used to create a string from a Unicode code point.
 */ module.exports.fromCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
($011a816ab9920cfe$var$_a = String.fromCodePoint) !== null && $011a816ab9920cfe$var$_a !== void 0 ? $011a816ab9920cfe$var$_a : function(codePoint) {
    var output = "";
    if (codePoint > 0xffff) {
        codePoint -= 0x10000;
        output += String.fromCharCode(codePoint >>> 10 & 0x3ff | 0xd800);
        codePoint = 0xdc00 | codePoint & 0x3ff;
    }
    output += String.fromCharCode(codePoint);
    return output;
};
/**
 * Replace the given code point with a replacement character if it is a
 * surrogate or is outside the valid range. Otherwise return the code
 * point unchanged.
 */ function $011a816ab9920cfe$var$replaceCodePoint(codePoint) {
    var _a;
    if (codePoint >= 0xd800 && codePoint <= 0xdfff || codePoint > 0x10ffff) return 0xfffd;
    return (_a = $011a816ab9920cfe$var$decodeMap.get(codePoint)) !== null && _a !== void 0 ? _a : codePoint;
}
module.exports.replaceCodePoint = $011a816ab9920cfe$var$replaceCodePoint;
/**
 * Replace the code point if relevant, then convert it to a string.
 *
 * @deprecated Use `fromCodePoint(replaceCodePoint(codePoint))` instead.
 * @param codePoint The code point to decode.
 * @returns The decoded code point.
 */ function $011a816ab9920cfe$var$decodeCodePoint(codePoint) {
    return (0, module.exports.fromCodePoint)($011a816ab9920cfe$var$replaceCodePoint(codePoint));
}
module.exports.default = $011a816ab9920cfe$var$decodeCodePoint;

});

/**
 * The main source file. Does only include {@link MainController}, which does the actual work.
 */ // controllers

var $gBhAd = parcelRequire("gBhAd");
/*!
  * Bootstrap v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ var $e2544cfeed0c9093$exports = {};

$parcel$export($e2544cfeed0c9093$exports, "popperGenerator", function () { return $b92f073993d3fb52$export$ed5e13716264f202; });
$parcel$export($e2544cfeed0c9093$exports, "detectOverflow", function () { return $400b79aa76081eef$export$2e2bcd8739ae039; });
$parcel$export($e2544cfeed0c9093$exports, "createPopperBase", function () { return $b92f073993d3fb52$export$8f7491d57c8f97a9; });
$parcel$export($e2544cfeed0c9093$exports, "createPopper", function () { return $ba40c8d2bf74e5cd$export$8f7491d57c8f97a9; });
$parcel$export($e2544cfeed0c9093$exports, "createPopperLite", function () { return $fb1de9e545b2d5d8$export$8f7491d57c8f97a9; });
var $3de679e4868fd918$exports = {};

$parcel$export($3de679e4868fd918$exports, "top", function () { return $3de679e4868fd918$export$1e95b668f3b82d; });
$parcel$export($3de679e4868fd918$exports, "bottom", function () { return $3de679e4868fd918$export$40e543e69a8b3fbb; });
$parcel$export($3de679e4868fd918$exports, "right", function () { return $3de679e4868fd918$export$79ffe56a765070d2; });
$parcel$export($3de679e4868fd918$exports, "left", function () { return $3de679e4868fd918$export$eabcd2c8791e7bf4; });
$parcel$export($3de679e4868fd918$exports, "auto", function () { return $3de679e4868fd918$export$dfb5619354ba860; });
$parcel$export($3de679e4868fd918$exports, "basePlacements", function () { return $3de679e4868fd918$export$aec2ce47c367b8c3; });
$parcel$export($3de679e4868fd918$exports, "start", function () { return $3de679e4868fd918$export$b3571188c770cc5a; });
$parcel$export($3de679e4868fd918$exports, "end", function () { return $3de679e4868fd918$export$bd5df0f255a350f8; });
$parcel$export($3de679e4868fd918$exports, "clippingParents", function () { return $3de679e4868fd918$export$390fd549c5303b4d; });
$parcel$export($3de679e4868fd918$exports, "viewport", function () { return $3de679e4868fd918$export$d7b7311ec04a3e8f; });
$parcel$export($3de679e4868fd918$exports, "popper", function () { return $3de679e4868fd918$export$ae5ab1c730825774; });
$parcel$export($3de679e4868fd918$exports, "reference", function () { return $3de679e4868fd918$export$ca50aac9f3ba507f; });
$parcel$export($3de679e4868fd918$exports, "variationPlacements", function () { return $3de679e4868fd918$export$368f9a87e87fa4e1; });
$parcel$export($3de679e4868fd918$exports, "placements", function () { return $3de679e4868fd918$export$803cd8101b6c182b; });
$parcel$export($3de679e4868fd918$exports, "beforeRead", function () { return $3de679e4868fd918$export$421679a7c3d56e; });
$parcel$export($3de679e4868fd918$exports, "read", function () { return $3de679e4868fd918$export$aafa59e2e03f2942; });
$parcel$export($3de679e4868fd918$exports, "afterRead", function () { return $3de679e4868fd918$export$6964f6c886723980; });
$parcel$export($3de679e4868fd918$exports, "beforeMain", function () { return $3de679e4868fd918$export$c65e99957a05207c; });
$parcel$export($3de679e4868fd918$exports, "main", function () { return $3de679e4868fd918$export$f22da7240b7add18; });
$parcel$export($3de679e4868fd918$exports, "afterMain", function () { return $3de679e4868fd918$export$bab79516f2d662fe; });
$parcel$export($3de679e4868fd918$exports, "beforeWrite", function () { return $3de679e4868fd918$export$8d4d2d70e7d46032; });
$parcel$export($3de679e4868fd918$exports, "write", function () { return $3de679e4868fd918$export$68d8715fc104d294; });
$parcel$export($3de679e4868fd918$exports, "afterWrite", function () { return $3de679e4868fd918$export$70a6e5159acce2e6; });
$parcel$export($3de679e4868fd918$exports, "modifierPhases", function () { return $3de679e4868fd918$export$d087d3878fdf71d5; });
var $3de679e4868fd918$export$1e95b668f3b82d = "top";
var $3de679e4868fd918$export$40e543e69a8b3fbb = "bottom";
var $3de679e4868fd918$export$79ffe56a765070d2 = "right";
var $3de679e4868fd918$export$eabcd2c8791e7bf4 = "left";
var $3de679e4868fd918$export$dfb5619354ba860 = "auto";
var $3de679e4868fd918$export$aec2ce47c367b8c3 = [
    $3de679e4868fd918$export$1e95b668f3b82d,
    $3de679e4868fd918$export$40e543e69a8b3fbb,
    $3de679e4868fd918$export$79ffe56a765070d2,
    $3de679e4868fd918$export$eabcd2c8791e7bf4
];
var $3de679e4868fd918$export$b3571188c770cc5a = "start";
var $3de679e4868fd918$export$bd5df0f255a350f8 = "end";
var $3de679e4868fd918$export$390fd549c5303b4d = "clippingParents";
var $3de679e4868fd918$export$d7b7311ec04a3e8f = "viewport";
var $3de679e4868fd918$export$ae5ab1c730825774 = "popper";
var $3de679e4868fd918$export$ca50aac9f3ba507f = "reference";
var $3de679e4868fd918$export$368f9a87e87fa4e1 = /*#__PURE__*/ $3de679e4868fd918$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $3de679e4868fd918$export$b3571188c770cc5a,
        placement + "-" + $3de679e4868fd918$export$bd5df0f255a350f8
    ]);
}, []);
var $3de679e4868fd918$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($3de679e4868fd918$export$aec2ce47c367b8c3, [
    $3de679e4868fd918$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $3de679e4868fd918$export$b3571188c770cc5a,
        placement + "-" + $3de679e4868fd918$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $3de679e4868fd918$export$421679a7c3d56e = "beforeRead";
var $3de679e4868fd918$export$aafa59e2e03f2942 = "read";
var $3de679e4868fd918$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $3de679e4868fd918$export$c65e99957a05207c = "beforeMain";
var $3de679e4868fd918$export$f22da7240b7add18 = "main";
var $3de679e4868fd918$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $3de679e4868fd918$export$8d4d2d70e7d46032 = "beforeWrite";
var $3de679e4868fd918$export$68d8715fc104d294 = "write";
var $3de679e4868fd918$export$70a6e5159acce2e6 = "afterWrite";
var $3de679e4868fd918$export$d087d3878fdf71d5 = [
    $3de679e4868fd918$export$421679a7c3d56e,
    $3de679e4868fd918$export$aafa59e2e03f2942,
    $3de679e4868fd918$export$6964f6c886723980,
    $3de679e4868fd918$export$c65e99957a05207c,
    $3de679e4868fd918$export$f22da7240b7add18,
    $3de679e4868fd918$export$bab79516f2d662fe,
    $3de679e4868fd918$export$8d4d2d70e7d46032,
    $3de679e4868fd918$export$68d8715fc104d294,
    $3de679e4868fd918$export$70a6e5159acce2e6
];


var $18b8feb87e84b268$exports = {};

$parcel$export($18b8feb87e84b268$exports, "applyStyles", function () { return $42eb8a49ca42db39$export$2e2bcd8739ae039; });
$parcel$export($18b8feb87e84b268$exports, "arrow", function () { return $59c92c1fc46a893e$export$2e2bcd8739ae039; });
$parcel$export($18b8feb87e84b268$exports, "computeStyles", function () { return $2186ca614d1914c5$export$2e2bcd8739ae039; });
$parcel$export($18b8feb87e84b268$exports, "eventListeners", function () { return $524d12f5e3f410b7$export$2e2bcd8739ae039; });
$parcel$export($18b8feb87e84b268$exports, "flip", function () { return $4419d659c5aee896$export$2e2bcd8739ae039; });
$parcel$export($18b8feb87e84b268$exports, "hide", function () { return $6b0f9068ca75a57d$export$2e2bcd8739ae039; });
$parcel$export($18b8feb87e84b268$exports, "offset", function () { return $a812a48e30738572$export$2e2bcd8739ae039; });
$parcel$export($18b8feb87e84b268$exports, "popperOffsets", function () { return $32cfbe7d0e900a5d$export$2e2bcd8739ae039; });
$parcel$export($18b8feb87e84b268$exports, "preventOverflow", function () { return $b988b9b26e42e386$export$2e2bcd8739ae039; });
function $75ccc39d2a806d7f$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}


function $b9b3413274c87e21$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $0dee4f2dddb22277$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $b9b3413274c87e21$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $0dee4f2dddb22277$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $b9b3413274c87e21$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $0dee4f2dddb22277$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $b9b3413274c87e21$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


// and applies them to the HTMLElements such as popper and arrow
function $42eb8a49ca42db39$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $0dee4f2dddb22277$export$1b3bfaa9684536aa)(element) || !(0, $75ccc39d2a806d7f$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $42eb8a49ca42db39$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $0dee4f2dddb22277$export$1b3bfaa9684536aa)(element) || !(0, $75ccc39d2a806d7f$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $42eb8a49ca42db39$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $42eb8a49ca42db39$var$applyStyles,
    effect: $42eb8a49ca42db39$var$effect,
    requires: [
        "computeStyles"
    ]
};



function $59c39fbf33d0fa38$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}



var $9598a69d154bbd1e$export$8960430cfd85939f = Math.max;
var $9598a69d154bbd1e$export$96ec731ed4dcb222 = Math.min;
var $9598a69d154bbd1e$export$2077e0241d6afd3c = Math.round;



function $aae20dd24c8de568$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $af244778ac85956c$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $aae20dd24c8de568$export$2e2bcd8739ae039)());
}


function $856f97fdf7a31786$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $0dee4f2dddb22277$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $9598a69d154bbd1e$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $9598a69d154bbd1e$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $0dee4f2dddb22277$export$45a5e7f76e0caa8d)(element) ? (0, $b9b3413274c87e21$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $af244778ac85956c$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $563728a12da0f86b$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $856f97fdf7a31786$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $e52f68d10ea05d88$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $0dee4f2dddb22277$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}





function $202256889fb084f4$export$2e2bcd8739ae039(element) {
    return (0, $b9b3413274c87e21$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $88967f4bf6e216d4$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $75ccc39d2a806d7f$export$2e2bcd8739ae039)(element)) >= 0;
}




function $04af344fb3b2461e$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $0dee4f2dddb22277$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $7ead366da1fe435a$export$2e2bcd8739ae039(element) {
    if ((0, $75ccc39d2a806d7f$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $0dee4f2dddb22277$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $04af344fb3b2461e$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $7cbf9f1a43b4b54b$var$getTrueOffsetParent(element) {
    if (!(0, $0dee4f2dddb22277$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $202256889fb084f4$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $7cbf9f1a43b4b54b$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $aae20dd24c8de568$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $aae20dd24c8de568$export$2e2bcd8739ae039)());
    if (isIE && (0, $0dee4f2dddb22277$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $202256889fb084f4$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $7ead366da1fe435a$export$2e2bcd8739ae039)(element);
    if ((0, $0dee4f2dddb22277$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $0dee4f2dddb22277$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $75ccc39d2a806d7f$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $202256889fb084f4$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $7cbf9f1a43b4b54b$export$2e2bcd8739ae039(element) {
    var window = (0, $b9b3413274c87e21$export$2e2bcd8739ae039)(element);
    var offsetParent = $7cbf9f1a43b4b54b$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $88967f4bf6e216d4$export$2e2bcd8739ae039)(offsetParent) && (0, $202256889fb084f4$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $7cbf9f1a43b4b54b$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $75ccc39d2a806d7f$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $75ccc39d2a806d7f$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $202256889fb084f4$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $7cbf9f1a43b4b54b$var$getContainingBlock(element) || window;
}


function $42c9e163adb38c23$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $0cd708593435dba4$export$f28d906d67a997f3(min, value, max) {
    return (0, $9598a69d154bbd1e$export$8960430cfd85939f)(min, (0, $9598a69d154bbd1e$export$96ec731ed4dcb222)(value, max));
}
function $0cd708593435dba4$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $0cd708593435dba4$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $f0f7e8fd5f6df53a$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $8ec94e005bd060d7$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $f0f7e8fd5f6df53a$export$2e2bcd8739ae039)(), paddingObject);
}


function $7ecd1ec68ebe7fbd$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}



var $59c92c1fc46a893e$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $8ec94e005bd060d7$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $7ecd1ec68ebe7fbd$export$2e2bcd8739ae039)(padding, (0, $3de679e4868fd918$export$aec2ce47c367b8c3)));
};
function $59c92c1fc46a893e$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $59c39fbf33d0fa38$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $42c9e163adb38c23$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $3de679e4868fd918$export$eabcd2c8791e7bf4),
        (0, $3de679e4868fd918$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $59c92c1fc46a893e$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $563728a12da0f86b$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $3de679e4868fd918$export$1e95b668f3b82d) : (0, $3de679e4868fd918$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $3de679e4868fd918$export$40e543e69a8b3fbb) : (0, $3de679e4868fd918$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $7cbf9f1a43b4b54b$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $0cd708593435dba4$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $59c92c1fc46a893e$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $e52f68d10ea05d88$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $59c92c1fc46a893e$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $59c92c1fc46a893e$var$arrow,
    effect: $59c92c1fc46a893e$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};








function $763358296bc7f0da$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}



var $2186ca614d1914c5$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $2186ca614d1914c5$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $9598a69d154bbd1e$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $9598a69d154bbd1e$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $2186ca614d1914c5$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $3de679e4868fd918$export$eabcd2c8791e7bf4);
    var sideY = (0, $3de679e4868fd918$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $7cbf9f1a43b4b54b$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $b9b3413274c87e21$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $04af344fb3b2461e$export$2e2bcd8739ae039)(popper);
            if ((0, $202256889fb084f4$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $3de679e4868fd918$export$1e95b668f3b82d) || (placement === (0, $3de679e4868fd918$export$eabcd2c8791e7bf4) || placement === (0, $3de679e4868fd918$export$79ffe56a765070d2)) && variation === (0, $3de679e4868fd918$export$bd5df0f255a350f8)) {
            sideY = (0, $3de679e4868fd918$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $3de679e4868fd918$export$eabcd2c8791e7bf4) || (placement === (0, $3de679e4868fd918$export$1e95b668f3b82d) || placement === (0, $3de679e4868fd918$export$40e543e69a8b3fbb)) && variation === (0, $3de679e4868fd918$export$bd5df0f255a350f8)) {
            sideX = (0, $3de679e4868fd918$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $2186ca614d1914c5$var$unsetSides);
    var _ref4 = roundOffsets === true ? $2186ca614d1914c5$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $b9b3413274c87e21$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $2186ca614d1914c5$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $59c39fbf33d0fa38$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $763358296bc7f0da$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $2186ca614d1914c5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $2186ca614d1914c5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $2186ca614d1914c5$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $2186ca614d1914c5$var$computeStyles,
    data: {}
};



var $524d12f5e3f410b7$var$passive = {
    passive: true
};
function $524d12f5e3f410b7$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $b9b3413274c87e21$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $524d12f5e3f410b7$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $524d12f5e3f410b7$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $524d12f5e3f410b7$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $524d12f5e3f410b7$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $524d12f5e3f410b7$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $524d12f5e3f410b7$var$effect,
    data: {}
};


var $10e68ca32d71e128$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $10e68ca32d71e128$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $10e68ca32d71e128$var$hash[matched];
    });
}



var $2cb407a558844daa$var$hash = {
    start: "end",
    end: "start"
};
function $2cb407a558844daa$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $2cb407a558844daa$var$hash[matched];
    });
}








function $4b98a3172bacf8ec$export$2e2bcd8739ae039(node) {
    var win = (0, $b9b3413274c87e21$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $1d3e8317bca2b13b$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $856f97fdf7a31786$export$2e2bcd8739ae039)((0, $04af344fb3b2461e$export$2e2bcd8739ae039)(element)).left + (0, $4b98a3172bacf8ec$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $2f53da607b3746be$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $b9b3413274c87e21$export$2e2bcd8739ae039)(element);
    var html = (0, $04af344fb3b2461e$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $af244778ac85956c$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $1d3e8317bca2b13b$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $11e1e16d619599d0$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $04af344fb3b2461e$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $4b98a3172bacf8ec$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $9598a69d154bbd1e$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $9598a69d154bbd1e$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $1d3e8317bca2b13b$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $202256889fb084f4$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $9598a69d154bbd1e$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $e3088d3b293d3951$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $202256889fb084f4$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $f56a03bea423dc7d$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $75ccc39d2a806d7f$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $0dee4f2dddb22277$export$1b3bfaa9684536aa)(node) && (0, $e3088d3b293d3951$export$2e2bcd8739ae039)(node)) return node;
    return $f56a03bea423dc7d$export$2e2bcd8739ae039((0, $7ead366da1fe435a$export$2e2bcd8739ae039)(node));
}





function $da4ba1ff29e25ddd$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $f56a03bea423dc7d$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $b9b3413274c87e21$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $e3088d3b293d3951$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($da4ba1ff29e25ddd$export$2e2bcd8739ae039((0, $7ead366da1fe435a$export$2e2bcd8739ae039)(target)));
}










function $e84261f8276e3310$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $d1e77b65493ae185$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $856f97fdf7a31786$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $d1e77b65493ae185$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $3de679e4868fd918$export$d7b7311ec04a3e8f) ? (0, $e84261f8276e3310$export$2e2bcd8739ae039)((0, $2f53da607b3746be$export$2e2bcd8739ae039)(element, strategy)) : (0, $0dee4f2dddb22277$export$45a5e7f76e0caa8d)(clippingParent) ? $d1e77b65493ae185$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $e84261f8276e3310$export$2e2bcd8739ae039)((0, $11e1e16d619599d0$export$2e2bcd8739ae039)((0, $04af344fb3b2461e$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $d1e77b65493ae185$var$getClippingParents(element) {
    var clippingParents = (0, $da4ba1ff29e25ddd$export$2e2bcd8739ae039)((0, $7ead366da1fe435a$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $202256889fb084f4$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $0dee4f2dddb22277$export$1b3bfaa9684536aa)(element) ? (0, $7cbf9f1a43b4b54b$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $0dee4f2dddb22277$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $0dee4f2dddb22277$export$45a5e7f76e0caa8d)(clippingParent) && (0, $e52f68d10ea05d88$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $75ccc39d2a806d7f$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $d1e77b65493ae185$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $d1e77b65493ae185$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $d1e77b65493ae185$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $9598a69d154bbd1e$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $9598a69d154bbd1e$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $9598a69d154bbd1e$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $9598a69d154bbd1e$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $d1e77b65493ae185$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $c7a335ce8d6c7e22$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $59c39fbf33d0fa38$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $763358296bc7f0da$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $3de679e4868fd918$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $3de679e4868fd918$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $3de679e4868fd918$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $3de679e4868fd918$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $42c9e163adb38c23$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $3de679e4868fd918$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $3de679e4868fd918$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $400b79aa76081eef$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $3de679e4868fd918$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $3de679e4868fd918$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $3de679e4868fd918$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $8ec94e005bd060d7$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $7ecd1ec68ebe7fbd$export$2e2bcd8739ae039)(padding, (0, $3de679e4868fd918$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $3de679e4868fd918$export$ae5ab1c730825774) ? (0, $3de679e4868fd918$export$ca50aac9f3ba507f) : (0, $3de679e4868fd918$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $d1e77b65493ae185$export$2e2bcd8739ae039)((0, $0dee4f2dddb22277$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $04af344fb3b2461e$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $856f97fdf7a31786$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $c7a335ce8d6c7e22$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $e84261f8276e3310$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $3de679e4868fd918$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $3de679e4868fd918$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $3de679e4868fd918$export$79ffe56a765070d2),
                (0, $3de679e4868fd918$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $3de679e4868fd918$export$1e95b668f3b82d),
                (0, $3de679e4868fd918$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $958040209c61c1c6$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $3de679e4868fd918$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $763358296bc7f0da$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $3de679e4868fd918$export$368f9a87e87fa4e1) : (0, $3de679e4868fd918$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $763358296bc7f0da$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $3de679e4868fd918$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $400b79aa76081eef$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $59c39fbf33d0fa38$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $4419d659c5aee896$var$getExpandedFallbackPlacements(placement) {
    if ((0, $59c39fbf33d0fa38$export$2e2bcd8739ae039)(placement) === (0, $3de679e4868fd918$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $10e68ca32d71e128$export$2e2bcd8739ae039)(placement);
    return [
        (0, $2cb407a558844daa$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $2cb407a558844daa$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $4419d659c5aee896$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $59c39fbf33d0fa38$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $10e68ca32d71e128$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $4419d659c5aee896$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $59c39fbf33d0fa38$export$2e2bcd8739ae039)(placement) === (0, $3de679e4868fd918$export$dfb5619354ba860) ? (0, $958040209c61c1c6$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $59c39fbf33d0fa38$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $763358296bc7f0da$export$2e2bcd8739ae039)(placement) === (0, $3de679e4868fd918$export$b3571188c770cc5a);
        var isVertical = [
            (0, $3de679e4868fd918$export$1e95b668f3b82d),
            (0, $3de679e4868fd918$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $400b79aa76081eef$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $3de679e4868fd918$export$79ffe56a765070d2) : (0, $3de679e4868fd918$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $3de679e4868fd918$export$40e543e69a8b3fbb) : (0, $3de679e4868fd918$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $10e68ca32d71e128$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $10e68ca32d71e128$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $4419d659c5aee896$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $4419d659c5aee896$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};




function $6b0f9068ca75a57d$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $6b0f9068ca75a57d$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $3de679e4868fd918$export$1e95b668f3b82d),
        (0, $3de679e4868fd918$export$79ffe56a765070d2),
        (0, $3de679e4868fd918$export$40e543e69a8b3fbb),
        (0, $3de679e4868fd918$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $6b0f9068ca75a57d$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $400b79aa76081eef$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $400b79aa76081eef$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $6b0f9068ca75a57d$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $6b0f9068ca75a57d$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $6b0f9068ca75a57d$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $6b0f9068ca75a57d$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $6b0f9068ca75a57d$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $6b0f9068ca75a57d$var$hide
};




function $a812a48e30738572$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $59c39fbf33d0fa38$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $3de679e4868fd918$export$eabcd2c8791e7bf4),
        (0, $3de679e4868fd918$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $3de679e4868fd918$export$eabcd2c8791e7bf4),
        (0, $3de679e4868fd918$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $a812a48e30738572$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $3de679e4868fd918$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $a812a48e30738572$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $a812a48e30738572$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $a812a48e30738572$var$offset
};



function $32cfbe7d0e900a5d$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $c7a335ce8d6c7e22$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $32cfbe7d0e900a5d$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $32cfbe7d0e900a5d$var$popperOffsets,
    data: {}
};





function $4d7aeda2d1cf8bc0$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}









function $b988b9b26e42e386$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $400b79aa76081eef$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $59c39fbf33d0fa38$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $763358296bc7f0da$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $42c9e163adb38c23$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $4d7aeda2d1cf8bc0$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $3de679e4868fd918$export$1e95b668f3b82d) : (0, $3de679e4868fd918$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $3de679e4868fd918$export$40e543e69a8b3fbb) : (0, $3de679e4868fd918$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $3de679e4868fd918$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $3de679e4868fd918$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $563728a12da0f86b$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $f0f7e8fd5f6df53a$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $0cd708593435dba4$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $7cbf9f1a43b4b54b$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $0cd708593435dba4$export$f28d906d67a997f3)(tether ? (0, $9598a69d154bbd1e$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $9598a69d154bbd1e$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $3de679e4868fd918$export$1e95b668f3b82d) : (0, $3de679e4868fd918$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $3de679e4868fd918$export$40e543e69a8b3fbb) : (0, $3de679e4868fd918$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $3de679e4868fd918$export$1e95b668f3b82d),
            (0, $3de679e4868fd918$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $0cd708593435dba4$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $0cd708593435dba4$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $b988b9b26e42e386$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $b988b9b26e42e386$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};








function $a4f89398deb81d5a$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $01f698b37b56f293$export$2e2bcd8739ae039(node) {
    if (node === (0, $b9b3413274c87e21$export$2e2bcd8739ae039)(node) || !(0, $0dee4f2dddb22277$export$1b3bfaa9684536aa)(node)) return (0, $4b98a3172bacf8ec$export$2e2bcd8739ae039)(node);
    else return (0, $a4f89398deb81d5a$export$2e2bcd8739ae039)(node);
}








function $1f83a3590a58ca81$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $9598a69d154bbd1e$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $9598a69d154bbd1e$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $1f83a3590a58ca81$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $0dee4f2dddb22277$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $0dee4f2dddb22277$export$1b3bfaa9684536aa)(offsetParent) && $1f83a3590a58ca81$var$isElementScaled(offsetParent);
    var documentElement = (0, $04af344fb3b2461e$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $856f97fdf7a31786$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $75ccc39d2a806d7f$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $e3088d3b293d3951$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $01f698b37b56f293$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $0dee4f2dddb22277$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $856f97fdf7a31786$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $1d3e8317bca2b13b$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $1fc6b88d850995f4$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $1fc6b88d850995f4$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $1fc6b88d850995f4$var$order(modifiers); // order based on phase
    return (0, $3de679e4868fd918$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $0ee7fe20308229e3$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $e334e679a8da4fd2$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $b92f073993d3fb52$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $b92f073993d3fb52$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $b92f073993d3fb52$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $b92f073993d3fb52$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $b92f073993d3fb52$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $0dee4f2dddb22277$export$45a5e7f76e0caa8d)(reference) ? (0, $da4ba1ff29e25ddd$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $da4ba1ff29e25ddd$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $da4ba1ff29e25ddd$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $1fc6b88d850995f4$export$2e2bcd8739ae039)((0, $e334e679a8da4fd2$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$b92f073993d3fb52$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $1f83a3590a58ca81$export$2e2bcd8739ae039)(reference, (0, $7cbf9f1a43b4b54b$export$2e2bcd8739ae039)(popper), state.options.strategy === "fixed"),
                    popper: (0, $563728a12da0f86b$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $0ee7fe20308229e3$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$b92f073993d3fb52$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $b92f073993d3fb52$export$8f7491d57c8f97a9 = /*#__PURE__*/ $b92f073993d3fb52$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules














var $ba40c8d2bf74e5cd$export$d34966752335dd47 = [
    (0, $524d12f5e3f410b7$export$2e2bcd8739ae039),
    (0, $32cfbe7d0e900a5d$export$2e2bcd8739ae039),
    (0, $2186ca614d1914c5$export$2e2bcd8739ae039),
    (0, $42eb8a49ca42db39$export$2e2bcd8739ae039),
    (0, $a812a48e30738572$export$2e2bcd8739ae039),
    (0, $4419d659c5aee896$export$2e2bcd8739ae039),
    (0, $b988b9b26e42e386$export$2e2bcd8739ae039),
    (0, $59c92c1fc46a893e$export$2e2bcd8739ae039),
    (0, $6b0f9068ca75a57d$export$2e2bcd8739ae039)
];
var $ba40c8d2bf74e5cd$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $b92f073993d3fb52$export$ed5e13716264f202)({
    defaultModifiers: $ba40c8d2bf74e5cd$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules







var $fb1de9e545b2d5d8$export$d34966752335dd47 = [
    (0, $524d12f5e3f410b7$export$2e2bcd8739ae039),
    (0, $32cfbe7d0e900a5d$export$2e2bcd8739ae039),
    (0, $2186ca614d1914c5$export$2e2bcd8739ae039),
    (0, $42eb8a49ca42db39$export$2e2bcd8739ae039)
];
var $fb1de9e545b2d5d8$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $b92f073993d3fb52$export$ed5e13716264f202)({
    defaultModifiers: $fb1de9e545b2d5d8$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


$parcel$exportWildcard($e2544cfeed0c9093$exports, $3de679e4868fd918$exports);
$parcel$exportWildcard($e2544cfeed0c9093$exports, $18b8feb87e84b268$exports);


/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/data.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $9c6c83c6a450e1f8$var$elementMap = new Map();
const $9c6c83c6a450e1f8$var$Data = {
    set (element, key, instance) {
        if (!$9c6c83c6a450e1f8$var$elementMap.has(element)) $9c6c83c6a450e1f8$var$elementMap.set(element, new Map());
        const instanceMap = $9c6c83c6a450e1f8$var$elementMap.get(element);
        // make it clear we only want one instance per element
        // can be removed later when multiple key/instances are fine to be used
        if (!instanceMap.has(key) && instanceMap.size !== 0) {
            // eslint-disable-next-line no-console
            console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(instanceMap.keys())[0]}.`);
            return;
        }
        instanceMap.set(key, instance);
    },
    get (element, key) {
        if ($9c6c83c6a450e1f8$var$elementMap.has(element)) return $9c6c83c6a450e1f8$var$elementMap.get(element).get(key) || null;
        return null;
    },
    remove (element, key) {
        if (!$9c6c83c6a450e1f8$var$elementMap.has(element)) return;
        const instanceMap = $9c6c83c6a450e1f8$var$elementMap.get(element);
        instanceMap.delete(key);
        // free up element references if there are no instances left for an element
        if (instanceMap.size === 0) $9c6c83c6a450e1f8$var$elementMap.delete(element);
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/index.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $9c6c83c6a450e1f8$var$MAX_UID = 1000000;
const $9c6c83c6a450e1f8$var$MILLISECONDS_MULTIPLIER = 1000;
const $9c6c83c6a450e1f8$var$TRANSITION_END = "transitionend";
/**
 * Properly escape IDs selectors to handle weird IDs
 * @param {string} selector
 * @returns {string}
 */ const $9c6c83c6a450e1f8$var$parseSelector = (selector)=>{
    if (selector && window.CSS && window.CSS.escape) // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
    selector = selector.replace(/#([^\s"#']+)/g, (match, id)=>`#${CSS.escape(id)}`);
    return selector;
};
// Shout-out Angus Croll (https://goo.gl/pxwQGp)
const $9c6c83c6a450e1f8$var$toType = (object)=>{
    if (object === null || object === undefined) return `${object}`;
    return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
};
/**
 * Public Util API
 */ const $9c6c83c6a450e1f8$var$getUID = (prefix)=>{
    do prefix += Math.floor(Math.random() * $9c6c83c6a450e1f8$var$MAX_UID);
    while (document.getElementById(prefix));
    return prefix;
};
const $9c6c83c6a450e1f8$var$getTransitionDurationFromElement = (element)=>{
    if (!element) return 0;
    // Get transition-duration of the element
    let { transitionDuration: transitionDuration, transitionDelay: transitionDelay } = window.getComputedStyle(element);
    const floatTransitionDuration = Number.parseFloat(transitionDuration);
    const floatTransitionDelay = Number.parseFloat(transitionDelay);
    // Return 0 if element or transition duration is not found
    if (!floatTransitionDuration && !floatTransitionDelay) return 0;
    // If multiple durations are defined, take the first
    transitionDuration = transitionDuration.split(",")[0];
    transitionDelay = transitionDelay.split(",")[0];
    return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * $9c6c83c6a450e1f8$var$MILLISECONDS_MULTIPLIER;
};
const $9c6c83c6a450e1f8$var$triggerTransitionEnd = (element)=>{
    element.dispatchEvent(new Event($9c6c83c6a450e1f8$var$TRANSITION_END));
};
const $9c6c83c6a450e1f8$var$isElement = (object)=>{
    if (!object || typeof object !== "object") return false;
    if (typeof object.jquery !== "undefined") object = object[0];
    return typeof object.nodeType !== "undefined";
};
const $9c6c83c6a450e1f8$var$getElement = (object)=>{
    // it's a jQuery object or a node element
    if ($9c6c83c6a450e1f8$var$isElement(object)) return object.jquery ? object[0] : object;
    if (typeof object === "string" && object.length > 0) return document.querySelector($9c6c83c6a450e1f8$var$parseSelector(object));
    return null;
};
const $9c6c83c6a450e1f8$var$isVisible = (element)=>{
    if (!$9c6c83c6a450e1f8$var$isElement(element) || element.getClientRects().length === 0) return false;
    const elementIsVisible = getComputedStyle(element).getPropertyValue("visibility") === "visible";
    // Handle `details` element as its content may falsie appear visible when it is closed
    const closedDetails = element.closest("details:not([open])");
    if (!closedDetails) return elementIsVisible;
    if (closedDetails !== element) {
        const summary = element.closest("summary");
        if (summary && summary.parentNode !== closedDetails) return false;
        if (summary === null) return false;
    }
    return elementIsVisible;
};
const $9c6c83c6a450e1f8$var$isDisabled = (element)=>{
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
    if (element.classList.contains("disabled")) return true;
    if (typeof element.disabled !== "undefined") return element.disabled;
    return element.hasAttribute("disabled") && element.getAttribute("disabled") !== "false";
};
const $9c6c83c6a450e1f8$var$findShadowRoot = (element)=>{
    if (!document.documentElement.attachShadow) return null;
    // Can find the shadow root otherwise it'll return the document
    if (typeof element.getRootNode === "function") {
        const root = element.getRootNode();
        return root instanceof ShadowRoot ? root : null;
    }
    if (element instanceof ShadowRoot) return element;
    // when we don't find a shadow root
    if (!element.parentNode) return null;
    return $9c6c83c6a450e1f8$var$findShadowRoot(element.parentNode);
};
const $9c6c83c6a450e1f8$var$noop = ()=>{};
/**
 * Trick to restart an element's animation
 *
 * @param {HTMLElement} element
 * @return void
 *
 * @see https://www.charistheo.io/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
 */ const $9c6c83c6a450e1f8$var$reflow = (element)=>{
    element.offsetHeight; // eslint-disable-line no-unused-expressions
};
const $9c6c83c6a450e1f8$var$getjQuery = ()=>{
    if (window.jQuery && !document.body.hasAttribute("data-bs-no-jquery")) return window.jQuery;
    return null;
};
const $9c6c83c6a450e1f8$var$DOMContentLoadedCallbacks = [];
const $9c6c83c6a450e1f8$var$onDOMContentLoaded = (callback)=>{
    if (document.readyState === "loading") {
        // add listener on the first call when the document is in loading state
        if (!$9c6c83c6a450e1f8$var$DOMContentLoadedCallbacks.length) document.addEventListener("DOMContentLoaded", ()=>{
            for (const callback of $9c6c83c6a450e1f8$var$DOMContentLoadedCallbacks)callback();
        });
        $9c6c83c6a450e1f8$var$DOMContentLoadedCallbacks.push(callback);
    } else callback();
};
const $9c6c83c6a450e1f8$var$isRTL = ()=>document.documentElement.dir === "rtl";
const $9c6c83c6a450e1f8$var$defineJQueryPlugin = (plugin)=>{
    $9c6c83c6a450e1f8$var$onDOMContentLoaded(()=>{
        const $ = $9c6c83c6a450e1f8$var$getjQuery();
        /* istanbul ignore if */ if ($) {
            const name = plugin.NAME;
            const JQUERY_NO_CONFLICT = $.fn[name];
            $.fn[name] = plugin.jQueryInterface;
            $.fn[name].Constructor = plugin;
            $.fn[name].noConflict = ()=>{
                $.fn[name] = JQUERY_NO_CONFLICT;
                return plugin.jQueryInterface;
            };
        }
    });
};
const $9c6c83c6a450e1f8$var$execute = (possibleCallback, args = [], defaultValue = possibleCallback)=>{
    return typeof possibleCallback === "function" ? possibleCallback(...args) : defaultValue;
};
const $9c6c83c6a450e1f8$var$executeAfterTransition = (callback, transitionElement, waitForTransition = true)=>{
    if (!waitForTransition) {
        $9c6c83c6a450e1f8$var$execute(callback);
        return;
    }
    const durationPadding = 5;
    const emulatedDuration = $9c6c83c6a450e1f8$var$getTransitionDurationFromElement(transitionElement) + durationPadding;
    let called = false;
    const handler = ({ target: target })=>{
        if (target !== transitionElement) return;
        called = true;
        transitionElement.removeEventListener($9c6c83c6a450e1f8$var$TRANSITION_END, handler);
        $9c6c83c6a450e1f8$var$execute(callback);
    };
    transitionElement.addEventListener($9c6c83c6a450e1f8$var$TRANSITION_END, handler);
    setTimeout(()=>{
        if (!called) $9c6c83c6a450e1f8$var$triggerTransitionEnd(transitionElement);
    }, emulatedDuration);
};
/**
 * Return the previous/next element of a list.
 *
 * @param {array} list    The list of elements
 * @param activeElement   The active element
 * @param shouldGetNext   Choose to get next or previous element
 * @param isCycleAllowed
 * @return {Element|elem} The proper element
 */ const $9c6c83c6a450e1f8$var$getNextActiveElement = (list, activeElement, shouldGetNext, isCycleAllowed)=>{
    const listLength = list.length;
    let index = list.indexOf(activeElement);
    // if the element does not exist in the list return an element
    // depending on the direction and if cycle is allowed
    if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
    index += shouldGetNext ? 1 : -1;
    if (isCycleAllowed) index = (index + listLength) % listLength;
    return list[Math.max(0, Math.min(index, listLength - 1))];
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/event-handler.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $9c6c83c6a450e1f8$var$namespaceRegex = /[^.]*(?=\..*)\.|.*/;
const $9c6c83c6a450e1f8$var$stripNameRegex = /\..*/;
const $9c6c83c6a450e1f8$var$stripUidRegex = /::\d+$/;
const $9c6c83c6a450e1f8$var$eventRegistry = {}; // Events storage
let $9c6c83c6a450e1f8$var$uidEvent = 1;
const $9c6c83c6a450e1f8$var$customEvents = {
    mouseenter: "mouseover",
    mouseleave: "mouseout"
};
const $9c6c83c6a450e1f8$var$nativeEvents = new Set([
    "click",
    "dblclick",
    "mouseup",
    "mousedown",
    "contextmenu",
    "mousewheel",
    "DOMMouseScroll",
    "mouseover",
    "mouseout",
    "mousemove",
    "selectstart",
    "selectend",
    "keydown",
    "keypress",
    "keyup",
    "orientationchange",
    "touchstart",
    "touchmove",
    "touchend",
    "touchcancel",
    "pointerdown",
    "pointermove",
    "pointerup",
    "pointerleave",
    "pointercancel",
    "gesturestart",
    "gesturechange",
    "gestureend",
    "focus",
    "blur",
    "change",
    "reset",
    "select",
    "submit",
    "focusin",
    "focusout",
    "load",
    "unload",
    "beforeunload",
    "resize",
    "move",
    "DOMContentLoaded",
    "readystatechange",
    "error",
    "abort",
    "scroll"
]);
/**
 * Private methods
 */ function $9c6c83c6a450e1f8$var$makeEventUid(element, uid) {
    return uid && `${uid}::${$9c6c83c6a450e1f8$var$uidEvent++}` || element.uidEvent || $9c6c83c6a450e1f8$var$uidEvent++;
}
function $9c6c83c6a450e1f8$var$getElementEvents(element) {
    const uid = $9c6c83c6a450e1f8$var$makeEventUid(element);
    element.uidEvent = uid;
    $9c6c83c6a450e1f8$var$eventRegistry[uid] = $9c6c83c6a450e1f8$var$eventRegistry[uid] || {};
    return $9c6c83c6a450e1f8$var$eventRegistry[uid];
}
function $9c6c83c6a450e1f8$var$bootstrapHandler(element, fn) {
    return function handler(event) {
        $9c6c83c6a450e1f8$var$hydrateObj(event, {
            delegateTarget: element
        });
        if (handler.oneOff) $9c6c83c6a450e1f8$var$EventHandler.off(element, event.type, fn);
        return fn.apply(element, [
            event
        ]);
    };
}
function $9c6c83c6a450e1f8$var$bootstrapDelegationHandler(element, selector, fn) {
    return function handler(event) {
        const domElements = element.querySelectorAll(selector);
        for(let { target: target } = event; target && target !== this; target = target.parentNode)for (const domElement of domElements){
            if (domElement !== target) continue;
            $9c6c83c6a450e1f8$var$hydrateObj(event, {
                delegateTarget: target
            });
            if (handler.oneOff) $9c6c83c6a450e1f8$var$EventHandler.off(element, event.type, selector, fn);
            return fn.apply(target, [
                event
            ]);
        }
    };
}
function $9c6c83c6a450e1f8$var$findHandler(events, callable, delegationSelector = null) {
    return Object.values(events).find((event)=>event.callable === callable && event.delegationSelector === delegationSelector);
}
function $9c6c83c6a450e1f8$var$normalizeParameters(originalTypeEvent, handler, delegationFunction) {
    const isDelegated = typeof handler === "string";
    // TODO: tooltip passes `false` instead of selector, so we need to check
    const callable = isDelegated ? delegationFunction : handler || delegationFunction;
    let typeEvent = $9c6c83c6a450e1f8$var$getTypeEvent(originalTypeEvent);
    if (!$9c6c83c6a450e1f8$var$nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
    return [
        isDelegated,
        callable,
        typeEvent
    ];
}
function $9c6c83c6a450e1f8$var$addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
    if (typeof originalTypeEvent !== "string" || !element) return;
    let [isDelegated, callable, typeEvent] = $9c6c83c6a450e1f8$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
    // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
    // this prevents the handler from being dispatched the same way as mouseover or mouseout does
    if (originalTypeEvent in $9c6c83c6a450e1f8$var$customEvents) {
        const wrapFunction = (fn)=>{
            return function(event) {
                if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
            };
        };
        callable = wrapFunction(callable);
    }
    const events = $9c6c83c6a450e1f8$var$getElementEvents(element);
    const handlers = events[typeEvent] || (events[typeEvent] = {});
    const previousFunction = $9c6c83c6a450e1f8$var$findHandler(handlers, callable, isDelegated ? handler : null);
    if (previousFunction) {
        previousFunction.oneOff = previousFunction.oneOff && oneOff;
        return;
    }
    const uid = $9c6c83c6a450e1f8$var$makeEventUid(callable, originalTypeEvent.replace($9c6c83c6a450e1f8$var$namespaceRegex, ""));
    const fn = isDelegated ? $9c6c83c6a450e1f8$var$bootstrapDelegationHandler(element, handler, callable) : $9c6c83c6a450e1f8$var$bootstrapHandler(element, callable);
    fn.delegationSelector = isDelegated ? handler : null;
    fn.callable = callable;
    fn.oneOff = oneOff;
    fn.uidEvent = uid;
    handlers[uid] = fn;
    element.addEventListener(typeEvent, fn, isDelegated);
}
function $9c6c83c6a450e1f8$var$removeHandler(element, events, typeEvent, handler, delegationSelector) {
    const fn = $9c6c83c6a450e1f8$var$findHandler(events[typeEvent], handler, delegationSelector);
    if (!fn) return;
    element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
    delete events[typeEvent][fn.uidEvent];
}
function $9c6c83c6a450e1f8$var$removeNamespacedHandlers(element, events, typeEvent, namespace) {
    const storeElementEvent = events[typeEvent] || {};
    for (const [handlerKey, event] of Object.entries(storeElementEvent))if (handlerKey.includes(namespace)) $9c6c83c6a450e1f8$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
}
function $9c6c83c6a450e1f8$var$getTypeEvent(event) {
    // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
    event = event.replace($9c6c83c6a450e1f8$var$stripNameRegex, "");
    return $9c6c83c6a450e1f8$var$customEvents[event] || event;
}
const $9c6c83c6a450e1f8$var$EventHandler = {
    on (element, event, handler, delegationFunction) {
        $9c6c83c6a450e1f8$var$addHandler(element, event, handler, delegationFunction, false);
    },
    one (element, event, handler, delegationFunction) {
        $9c6c83c6a450e1f8$var$addHandler(element, event, handler, delegationFunction, true);
    },
    off (element, originalTypeEvent, handler, delegationFunction) {
        if (typeof originalTypeEvent !== "string" || !element) return;
        const [isDelegated, callable, typeEvent] = $9c6c83c6a450e1f8$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
        const inNamespace = typeEvent !== originalTypeEvent;
        const events = $9c6c83c6a450e1f8$var$getElementEvents(element);
        const storeElementEvent = events[typeEvent] || {};
        const isNamespace = originalTypeEvent.startsWith(".");
        if (typeof callable !== "undefined") {
            // Simplest case: handler is passed, remove that listener ONLY.
            if (!Object.keys(storeElementEvent).length) return;
            $9c6c83c6a450e1f8$var$removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
            return;
        }
        if (isNamespace) for (const elementEvent of Object.keys(events))$9c6c83c6a450e1f8$var$removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
        for (const [keyHandlers, event] of Object.entries(storeElementEvent)){
            const handlerKey = keyHandlers.replace($9c6c83c6a450e1f8$var$stripUidRegex, "");
            if (!inNamespace || originalTypeEvent.includes(handlerKey)) $9c6c83c6a450e1f8$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
        }
    },
    trigger (element, event, args) {
        if (typeof event !== "string" || !element) return null;
        const $ = $9c6c83c6a450e1f8$var$getjQuery();
        const typeEvent = $9c6c83c6a450e1f8$var$getTypeEvent(event);
        const inNamespace = event !== typeEvent;
        let jQueryEvent = null;
        let bubbles = true;
        let nativeDispatch = true;
        let defaultPrevented = false;
        if (inNamespace && $) {
            jQueryEvent = $.Event(event, args);
            $(element).trigger(jQueryEvent);
            bubbles = !jQueryEvent.isPropagationStopped();
            nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
            defaultPrevented = jQueryEvent.isDefaultPrevented();
        }
        const evt = $9c6c83c6a450e1f8$var$hydrateObj(new Event(event, {
            bubbles: bubbles,
            cancelable: true
        }), args);
        if (defaultPrevented) evt.preventDefault();
        if (nativeDispatch) element.dispatchEvent(evt);
        if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
        return evt;
    }
};
function $9c6c83c6a450e1f8$var$hydrateObj(obj, meta = {}) {
    for (const [key, value] of Object.entries(meta))try {
        obj[key] = value;
    } catch (_unused) {
        Object.defineProperty(obj, key, {
            configurable: true,
            get () {
                return value;
            }
        });
    }
    return obj;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/manipulator.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ function $9c6c83c6a450e1f8$var$normalizeData(value) {
    if (value === "true") return true;
    if (value === "false") return false;
    if (value === Number(value).toString()) return Number(value);
    if (value === "" || value === "null") return null;
    if (typeof value !== "string") return value;
    try {
        return JSON.parse(decodeURIComponent(value));
    } catch (_unused) {
        return value;
    }
}
function $9c6c83c6a450e1f8$var$normalizeDataKey(key) {
    return key.replace(/[A-Z]/g, (chr)=>`-${chr.toLowerCase()}`);
}
const $9c6c83c6a450e1f8$var$Manipulator = {
    setDataAttribute (element, key, value) {
        element.setAttribute(`data-bs-${$9c6c83c6a450e1f8$var$normalizeDataKey(key)}`, value);
    },
    removeDataAttribute (element, key) {
        element.removeAttribute(`data-bs-${$9c6c83c6a450e1f8$var$normalizeDataKey(key)}`);
    },
    getDataAttributes (element) {
        if (!element) return {};
        const attributes = {};
        const bsKeys = Object.keys(element.dataset).filter((key)=>key.startsWith("bs") && !key.startsWith("bsConfig"));
        for (const key of bsKeys){
            let pureKey = key.replace(/^bs/, "");
            pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1, pureKey.length);
            attributes[pureKey] = $9c6c83c6a450e1f8$var$normalizeData(element.dataset[key]);
        }
        return attributes;
    },
    getDataAttribute (element, key) {
        return $9c6c83c6a450e1f8$var$normalizeData(element.getAttribute(`data-bs-${$9c6c83c6a450e1f8$var$normalizeDataKey(key)}`));
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/config.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Class definition
 */ class $9c6c83c6a450e1f8$var$Config {
    // Getters
    static get Default() {
        return {};
    }
    static get DefaultType() {
        return {};
    }
    static get NAME() {
        throw new Error('You have to implement the static method "NAME", for each component!');
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        return config;
    }
    _mergeConfigObj(config, element) {
        const jsonConfig = $9c6c83c6a450e1f8$var$isElement(element) ? $9c6c83c6a450e1f8$var$Manipulator.getDataAttribute(element, "config") : {}; // try to parse
        return {
            ...this.constructor.Default,
            ...typeof jsonConfig === "object" ? jsonConfig : {},
            ...$9c6c83c6a450e1f8$var$isElement(element) ? $9c6c83c6a450e1f8$var$Manipulator.getDataAttributes(element) : {},
            ...typeof config === "object" ? config : {}
        };
    }
    _typeCheckConfig(config, configTypes = this.constructor.DefaultType) {
        for (const [property, expectedTypes] of Object.entries(configTypes)){
            const value = config[property];
            const valueType = $9c6c83c6a450e1f8$var$isElement(value) ? "element" : $9c6c83c6a450e1f8$var$toType(value);
            if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
        }
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap base-component.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $9c6c83c6a450e1f8$var$VERSION = "5.3.3";
/**
 * Class definition
 */ class $9c6c83c6a450e1f8$var$BaseComponent extends $9c6c83c6a450e1f8$var$Config {
    constructor(element, config){
        super();
        element = $9c6c83c6a450e1f8$var$getElement(element);
        if (!element) return;
        this._element = element;
        this._config = this._getConfig(config);
        $9c6c83c6a450e1f8$var$Data.set(this._element, this.constructor.DATA_KEY, this);
    }
    // Public
    dispose() {
        $9c6c83c6a450e1f8$var$Data.remove(this._element, this.constructor.DATA_KEY);
        $9c6c83c6a450e1f8$var$EventHandler.off(this._element, this.constructor.EVENT_KEY);
        for (const propertyName of Object.getOwnPropertyNames(this))this[propertyName] = null;
    }
    _queueCallback(callback, element, isAnimated = true) {
        $9c6c83c6a450e1f8$var$executeAfterTransition(callback, element, isAnimated);
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config, this._element);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    // Static
    static getInstance(element) {
        return $9c6c83c6a450e1f8$var$Data.get($9c6c83c6a450e1f8$var$getElement(element), this.DATA_KEY);
    }
    static getOrCreateInstance(element, config = {}) {
        return this.getInstance(element) || new this(element, typeof config === "object" ? config : null);
    }
    static get VERSION() {
        return $9c6c83c6a450e1f8$var$VERSION;
    }
    static get DATA_KEY() {
        return `bs.${this.NAME}`;
    }
    static get EVENT_KEY() {
        return `.${this.DATA_KEY}`;
    }
    static eventName(name) {
        return `${name}${this.EVENT_KEY}`;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/selector-engine.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $9c6c83c6a450e1f8$var$getSelector = (element)=>{
    let selector = element.getAttribute("data-bs-target");
    if (!selector || selector === "#") {
        let hrefAttribute = element.getAttribute("href");
        // The only valid content that could double as a selector are IDs or classes,
        // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
        // `document.querySelector` will rightfully complain it is invalid.
        // See https://github.com/twbs/bootstrap/issues/32273
        if (!hrefAttribute || !hrefAttribute.includes("#") && !hrefAttribute.startsWith(".")) return null;
        // Just in case some CMS puts out a full URL with the anchor appended
        if (hrefAttribute.includes("#") && !hrefAttribute.startsWith("#")) hrefAttribute = `#${hrefAttribute.split("#")[1]}`;
        selector = hrefAttribute && hrefAttribute !== "#" ? hrefAttribute.trim() : null;
    }
    return selector ? selector.split(",").map((sel)=>$9c6c83c6a450e1f8$var$parseSelector(sel)).join(",") : null;
};
const $9c6c83c6a450e1f8$var$SelectorEngine = {
    find (selector, element = document.documentElement) {
        return [].concat(...Element.prototype.querySelectorAll.call(element, selector));
    },
    findOne (selector, element = document.documentElement) {
        return Element.prototype.querySelector.call(element, selector);
    },
    children (element, selector) {
        return [].concat(...element.children).filter((child)=>child.matches(selector));
    },
    parents (element, selector) {
        const parents = [];
        let ancestor = element.parentNode.closest(selector);
        while(ancestor){
            parents.push(ancestor);
            ancestor = ancestor.parentNode.closest(selector);
        }
        return parents;
    },
    prev (element, selector) {
        let previous = element.previousElementSibling;
        while(previous){
            if (previous.matches(selector)) return [
                previous
            ];
            previous = previous.previousElementSibling;
        }
        return [];
    },
    // TODO: this is now unused; remove later along with prev()
    next (element, selector) {
        let next = element.nextElementSibling;
        while(next){
            if (next.matches(selector)) return [
                next
            ];
            next = next.nextElementSibling;
        }
        return [];
    },
    focusableChildren (element) {
        const focusables = [
            "a",
            "button",
            "input",
            "textarea",
            "select",
            "details",
            "[tabindex]",
            '[contenteditable="true"]'
        ].map((selector)=>`${selector}:not([tabindex^="-"])`).join(",");
        return this.find(focusables, element).filter((el)=>!$9c6c83c6a450e1f8$var$isDisabled(el) && $9c6c83c6a450e1f8$var$isVisible(el));
    },
    getSelectorFromElement (element) {
        const selector = $9c6c83c6a450e1f8$var$getSelector(element);
        if (selector) return $9c6c83c6a450e1f8$var$SelectorEngine.findOne(selector) ? selector : null;
        return null;
    },
    getElementFromSelector (element) {
        const selector = $9c6c83c6a450e1f8$var$getSelector(element);
        return selector ? $9c6c83c6a450e1f8$var$SelectorEngine.findOne(selector) : null;
    },
    getMultipleElementsFromSelector (element) {
        const selector = $9c6c83c6a450e1f8$var$getSelector(element);
        return selector ? $9c6c83c6a450e1f8$var$SelectorEngine.find(selector) : [];
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/component-functions.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $9c6c83c6a450e1f8$var$enableDismissTrigger = (component, method = "hide")=>{
    const clickEvent = `click.dismiss${component.EVENT_KEY}`;
    const name = component.NAME;
    $9c6c83c6a450e1f8$var$EventHandler.on(document, clickEvent, `[data-bs-dismiss="${name}"]`, function(event) {
        if ([
            "A",
            "AREA"
        ].includes(this.tagName)) event.preventDefault();
        if ($9c6c83c6a450e1f8$var$isDisabled(this)) return;
        const target = $9c6c83c6a450e1f8$var$SelectorEngine.getElementFromSelector(this) || this.closest(`.${name}`);
        const instance = component.getOrCreateInstance(target);
        // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
        instance[method]();
    });
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap alert.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $9c6c83c6a450e1f8$var$NAME$f = "alert";
const $9c6c83c6a450e1f8$var$DATA_KEY$a = "bs.alert";
const $9c6c83c6a450e1f8$var$EVENT_KEY$b = `.${$9c6c83c6a450e1f8$var$DATA_KEY$a}`;
const $9c6c83c6a450e1f8$var$EVENT_CLOSE = `close${$9c6c83c6a450e1f8$var$EVENT_KEY$b}`;
const $9c6c83c6a450e1f8$var$EVENT_CLOSED = `closed${$9c6c83c6a450e1f8$var$EVENT_KEY$b}`;
const $9c6c83c6a450e1f8$var$CLASS_NAME_FADE$5 = "fade";
const $9c6c83c6a450e1f8$var$CLASS_NAME_SHOW$8 = "show";
/**
 * Class definition
 */ class $9c6c83c6a450e1f8$export$caec2af78bcc877f extends $9c6c83c6a450e1f8$var$BaseComponent {
    // Getters
    static get NAME() {
        return $9c6c83c6a450e1f8$var$NAME$f;
    }
    // Public
    close() {
        const closeEvent = $9c6c83c6a450e1f8$var$EventHandler.trigger(this._element, $9c6c83c6a450e1f8$var$EVENT_CLOSE);
        if (closeEvent.defaultPrevented) return;
        this._element.classList.remove($9c6c83c6a450e1f8$var$CLASS_NAME_SHOW$8);
        const isAnimated = this._element.classList.contains($9c6c83c6a450e1f8$var$CLASS_NAME_FADE$5);
        this._queueCallback(()=>this._destroyElement(), this._element, isAnimated);
    }
    // Private
    _destroyElement() {
        this._element.remove();
        $9c6c83c6a450e1f8$var$EventHandler.trigger(this._element, $9c6c83c6a450e1f8$var$EVENT_CLOSED);
        this.dispose();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $9c6c83c6a450e1f8$export$caec2af78bcc877f.getOrCreateInstance(this);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $9c6c83c6a450e1f8$var$enableDismissTrigger($9c6c83c6a450e1f8$export$caec2af78bcc877f, "close");
/**
 * jQuery
 */ $9c6c83c6a450e1f8$var$defineJQueryPlugin($9c6c83c6a450e1f8$export$caec2af78bcc877f);
/**
 * --------------------------------------------------------------------------
 * Bootstrap button.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $9c6c83c6a450e1f8$var$NAME$e = "button";
const $9c6c83c6a450e1f8$var$DATA_KEY$9 = "bs.button";
const $9c6c83c6a450e1f8$var$EVENT_KEY$a = `.${$9c6c83c6a450e1f8$var$DATA_KEY$9}`;
const $9c6c83c6a450e1f8$var$DATA_API_KEY$6 = ".data-api";
const $9c6c83c6a450e1f8$var$CLASS_NAME_ACTIVE$3 = "active";
const $9c6c83c6a450e1f8$var$SELECTOR_DATA_TOGGLE$5 = '[data-bs-toggle="button"]';
const $9c6c83c6a450e1f8$var$EVENT_CLICK_DATA_API$6 = `click${$9c6c83c6a450e1f8$var$EVENT_KEY$a}${$9c6c83c6a450e1f8$var$DATA_API_KEY$6}`;
/**
 * Class definition
 */ class $9c6c83c6a450e1f8$export$353f5b6fc5456de1 extends $9c6c83c6a450e1f8$var$BaseComponent {
    // Getters
    static get NAME() {
        return $9c6c83c6a450e1f8$var$NAME$e;
    }
    // Public
    toggle() {
        // Toggle class and sync the `aria-pressed` attribute with the return value of the `.toggle()` method
        this._element.setAttribute("aria-pressed", this._element.classList.toggle($9c6c83c6a450e1f8$var$CLASS_NAME_ACTIVE$3));
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $9c6c83c6a450e1f8$export$353f5b6fc5456de1.getOrCreateInstance(this);
            if (config === "toggle") data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $9c6c83c6a450e1f8$var$EventHandler.on(document, $9c6c83c6a450e1f8$var$EVENT_CLICK_DATA_API$6, $9c6c83c6a450e1f8$var$SELECTOR_DATA_TOGGLE$5, (event)=>{
    event.preventDefault();
    const button = event.target.closest($9c6c83c6a450e1f8$var$SELECTOR_DATA_TOGGLE$5);
    const data = $9c6c83c6a450e1f8$export$353f5b6fc5456de1.getOrCreateInstance(button);
    data.toggle();
});
/**
 * jQuery
 */ $9c6c83c6a450e1f8$var$defineJQueryPlugin($9c6c83c6a450e1f8$export$353f5b6fc5456de1);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/swipe.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $9c6c83c6a450e1f8$var$NAME$d = "swipe";
const $9c6c83c6a450e1f8$var$EVENT_KEY$9 = ".bs.swipe";
const $9c6c83c6a450e1f8$var$EVENT_TOUCHSTART = `touchstart${$9c6c83c6a450e1f8$var$EVENT_KEY$9}`;
const $9c6c83c6a450e1f8$var$EVENT_TOUCHMOVE = `touchmove${$9c6c83c6a450e1f8$var$EVENT_KEY$9}`;
const $9c6c83c6a450e1f8$var$EVENT_TOUCHEND = `touchend${$9c6c83c6a450e1f8$var$EVENT_KEY$9}`;
const $9c6c83c6a450e1f8$var$EVENT_POINTERDOWN = `pointerdown${$9c6c83c6a450e1f8$var$EVENT_KEY$9}`;
const $9c6c83c6a450e1f8$var$EVENT_POINTERUP = `pointerup${$9c6c83c6a450e1f8$var$EVENT_KEY$9}`;
const $9c6c83c6a450e1f8$var$POINTER_TYPE_TOUCH = "touch";
const $9c6c83c6a450e1f8$var$POINTER_TYPE_PEN = "pen";
const $9c6c83c6a450e1f8$var$CLASS_NAME_POINTER_EVENT = "pointer-event";
const $9c6c83c6a450e1f8$var$SWIPE_THRESHOLD = 40;
const $9c6c83c6a450e1f8$var$Default$c = {
    endCallback: null,
    leftCallback: null,
    rightCallback: null
};
const $9c6c83c6a450e1f8$var$DefaultType$c = {
    endCallback: "(function|null)",
    leftCallback: "(function|null)",
    rightCallback: "(function|null)"
};
/**
 * Class definition
 */ class $9c6c83c6a450e1f8$var$Swipe extends $9c6c83c6a450e1f8$var$Config {
    constructor(element, config){
        super();
        this._element = element;
        if (!element || !$9c6c83c6a450e1f8$var$Swipe.isSupported()) return;
        this._config = this._getConfig(config);
        this._deltaX = 0;
        this._supportPointerEvents = Boolean(window.PointerEvent);
        this._initEvents();
    }
    // Getters
    static get Default() {
        return $9c6c83c6a450e1f8$var$Default$c;
    }
    static get DefaultType() {
        return $9c6c83c6a450e1f8$var$DefaultType$c;
    }
    static get NAME() {
        return $9c6c83c6a450e1f8$var$NAME$d;
    }
    // Public
    dispose() {
        $9c6c83c6a450e1f8$var$EventHandler.off(this._element, $9c6c83c6a450e1f8$var$EVENT_KEY$9);
    }
    // Private
    _start(event) {
        if (!this._supportPointerEvents) {
            this._deltaX = event.touches[0].clientX;
            return;
        }
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX;
    }
    _end(event) {
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX - this._deltaX;
        this._handleSwipe();
        $9c6c83c6a450e1f8$var$execute(this._config.endCallback);
    }
    _move(event) {
        this._deltaX = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - this._deltaX;
    }
    _handleSwipe() {
        const absDeltaX = Math.abs(this._deltaX);
        if (absDeltaX <= $9c6c83c6a450e1f8$var$SWIPE_THRESHOLD) return;
        const direction = absDeltaX / this._deltaX;
        this._deltaX = 0;
        if (!direction) return;
        $9c6c83c6a450e1f8$var$execute(direction > 0 ? this._config.rightCallback : this._config.leftCallback);
    }
    _initEvents() {
        if (this._supportPointerEvents) {
            $9c6c83c6a450e1f8$var$EventHandler.on(this._element, $9c6c83c6a450e1f8$var$EVENT_POINTERDOWN, (event)=>this._start(event));
            $9c6c83c6a450e1f8$var$EventHandler.on(this._element, $9c6c83c6a450e1f8$var$EVENT_POINTERUP, (event)=>this._end(event));
            this._element.classList.add($9c6c83c6a450e1f8$var$CLASS_NAME_POINTER_EVENT);
        } else {
            $9c6c83c6a450e1f8$var$EventHandler.on(this._element, $9c6c83c6a450e1f8$var$EVENT_TOUCHSTART, (event)=>this._start(event));
            $9c6c83c6a450e1f8$var$EventHandler.on(this._element, $9c6c83c6a450e1f8$var$EVENT_TOUCHMOVE, (event)=>this._move(event));
            $9c6c83c6a450e1f8$var$EventHandler.on(this._element, $9c6c83c6a450e1f8$var$EVENT_TOUCHEND, (event)=>this._end(event));
        }
    }
    _eventIsPointerPenTouch(event) {
        return this._supportPointerEvents && (event.pointerType === $9c6c83c6a450e1f8$var$POINTER_TYPE_PEN || event.pointerType === $9c6c83c6a450e1f8$var$POINTER_TYPE_TOUCH);
    }
    // Static
    static isSupported() {
        return "ontouchstart" in document.documentElement || navigator.maxTouchPoints > 0;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap carousel.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $9c6c83c6a450e1f8$var$NAME$c = "carousel";
const $9c6c83c6a450e1f8$var$DATA_KEY$8 = "bs.carousel";
const $9c6c83c6a450e1f8$var$EVENT_KEY$8 = `.${$9c6c83c6a450e1f8$var$DATA_KEY$8}`;
const $9c6c83c6a450e1f8$var$DATA_API_KEY$5 = ".data-api";
const $9c6c83c6a450e1f8$var$ARROW_LEFT_KEY$1 = "ArrowLeft";
const $9c6c83c6a450e1f8$var$ARROW_RIGHT_KEY$1 = "ArrowRight";
const $9c6c83c6a450e1f8$var$TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
const $9c6c83c6a450e1f8$var$ORDER_NEXT = "next";
const $9c6c83c6a450e1f8$var$ORDER_PREV = "prev";
const $9c6c83c6a450e1f8$var$DIRECTION_LEFT = "left";
const $9c6c83c6a450e1f8$var$DIRECTION_RIGHT = "right";
const $9c6c83c6a450e1f8$var$EVENT_SLIDE = `slide${$9c6c83c6a450e1f8$var$EVENT_KEY$8}`;
const $9c6c83c6a450e1f8$var$EVENT_SLID = `slid${$9c6c83c6a450e1f8$var$EVENT_KEY$8}`;
const $9c6c83c6a450e1f8$var$EVENT_KEYDOWN$1 = `keydown${$9c6c83c6a450e1f8$var$EVENT_KEY$8}`;
const $9c6c83c6a450e1f8$var$EVENT_MOUSEENTER$1 = `mouseenter${$9c6c83c6a450e1f8$var$EVENT_KEY$8}`;
const $9c6c83c6a450e1f8$var$EVENT_MOUSELEAVE$1 = `mouseleave${$9c6c83c6a450e1f8$var$EVENT_KEY$8}`;
const $9c6c83c6a450e1f8$var$EVENT_DRAG_START = `dragstart${$9c6c83c6a450e1f8$var$EVENT_KEY$8}`;
const $9c6c83c6a450e1f8$var$EVENT_LOAD_DATA_API$3 = `load${$9c6c83c6a450e1f8$var$EVENT_KEY$8}${$9c6c83c6a450e1f8$var$DATA_API_KEY$5}`;
const $9c6c83c6a450e1f8$var$EVENT_CLICK_DATA_API$5 = `click${$9c6c83c6a450e1f8$var$EVENT_KEY$8}${$9c6c83c6a450e1f8$var$DATA_API_KEY$5}`;
const $9c6c83c6a450e1f8$var$CLASS_NAME_CAROUSEL = "carousel";
const $9c6c83c6a450e1f8$var$CLASS_NAME_ACTIVE$2 = "active";
const $9c6c83c6a450e1f8$var$CLASS_NAME_SLIDE = "slide";
const $9c6c83c6a450e1f8$var$CLASS_NAME_END = "carousel-item-end";
const $9c6c83c6a450e1f8$var$CLASS_NAME_START = "carousel-item-start";
const $9c6c83c6a450e1f8$var$CLASS_NAME_NEXT = "carousel-item-next";
const $9c6c83c6a450e1f8$var$CLASS_NAME_PREV = "carousel-item-prev";
const $9c6c83c6a450e1f8$var$SELECTOR_ACTIVE = ".active";
const $9c6c83c6a450e1f8$var$SELECTOR_ITEM = ".carousel-item";
const $9c6c83c6a450e1f8$var$SELECTOR_ACTIVE_ITEM = $9c6c83c6a450e1f8$var$SELECTOR_ACTIVE + $9c6c83c6a450e1f8$var$SELECTOR_ITEM;
const $9c6c83c6a450e1f8$var$SELECTOR_ITEM_IMG = ".carousel-item img";
const $9c6c83c6a450e1f8$var$SELECTOR_INDICATORS = ".carousel-indicators";
const $9c6c83c6a450e1f8$var$SELECTOR_DATA_SLIDE = "[data-bs-slide], [data-bs-slide-to]";
const $9c6c83c6a450e1f8$var$SELECTOR_DATA_RIDE = '[data-bs-ride="carousel"]';
const $9c6c83c6a450e1f8$var$KEY_TO_DIRECTION = {
    [$9c6c83c6a450e1f8$var$ARROW_LEFT_KEY$1]: $9c6c83c6a450e1f8$var$DIRECTION_RIGHT,
    [$9c6c83c6a450e1f8$var$ARROW_RIGHT_KEY$1]: $9c6c83c6a450e1f8$var$DIRECTION_LEFT
};
const $9c6c83c6a450e1f8$var$Default$b = {
    interval: 5000,
    keyboard: true,
    pause: "hover",
    ride: false,
    touch: true,
    wrap: true
};
const $9c6c83c6a450e1f8$var$DefaultType$b = {
    interval: "(number|boolean)",
    // TODO:v6 remove boolean support
    keyboard: "boolean",
    pause: "(string|boolean)",
    ride: "(boolean|string)",
    touch: "boolean",
    wrap: "boolean"
};
/**
 * Class definition
 */ class $9c6c83c6a450e1f8$export$144901db2ea8e967 extends $9c6c83c6a450e1f8$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._interval = null;
        this._activeElement = null;
        this._isSliding = false;
        this.touchTimeout = null;
        this._swipeHelper = null;
        this._indicatorsElement = $9c6c83c6a450e1f8$var$SelectorEngine.findOne($9c6c83c6a450e1f8$var$SELECTOR_INDICATORS, this._element);
        this._addEventListeners();
        if (this._config.ride === $9c6c83c6a450e1f8$var$CLASS_NAME_CAROUSEL) this.cycle();
    }
    // Getters
    static get Default() {
        return $9c6c83c6a450e1f8$var$Default$b;
    }
    static get DefaultType() {
        return $9c6c83c6a450e1f8$var$DefaultType$b;
    }
    static get NAME() {
        return $9c6c83c6a450e1f8$var$NAME$c;
    }
    // Public
    next() {
        this._slide($9c6c83c6a450e1f8$var$ORDER_NEXT);
    }
    nextWhenVisible() {
        // FIXME TODO use `document.visibilityState`
        // Don't call next when the page isn't visible
        // or the carousel or its parent isn't visible
        if (!document.hidden && $9c6c83c6a450e1f8$var$isVisible(this._element)) this.next();
    }
    prev() {
        this._slide($9c6c83c6a450e1f8$var$ORDER_PREV);
    }
    pause() {
        if (this._isSliding) $9c6c83c6a450e1f8$var$triggerTransitionEnd(this._element);
        this._clearInterval();
    }
    cycle() {
        this._clearInterval();
        this._updateInterval();
        this._interval = setInterval(()=>this.nextWhenVisible(), this._config.interval);
    }
    _maybeEnableCycle() {
        if (!this._config.ride) return;
        if (this._isSliding) {
            $9c6c83c6a450e1f8$var$EventHandler.one(this._element, $9c6c83c6a450e1f8$var$EVENT_SLID, ()=>this.cycle());
            return;
        }
        this.cycle();
    }
    to(index) {
        const items = this._getItems();
        if (index > items.length - 1 || index < 0) return;
        if (this._isSliding) {
            $9c6c83c6a450e1f8$var$EventHandler.one(this._element, $9c6c83c6a450e1f8$var$EVENT_SLID, ()=>this.to(index));
            return;
        }
        const activeIndex = this._getItemIndex(this._getActive());
        if (activeIndex === index) return;
        const order = index > activeIndex ? $9c6c83c6a450e1f8$var$ORDER_NEXT : $9c6c83c6a450e1f8$var$ORDER_PREV;
        this._slide(order, items[index]);
    }
    dispose() {
        if (this._swipeHelper) this._swipeHelper.dispose();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        config.defaultInterval = config.interval;
        return config;
    }
    _addEventListeners() {
        if (this._config.keyboard) $9c6c83c6a450e1f8$var$EventHandler.on(this._element, $9c6c83c6a450e1f8$var$EVENT_KEYDOWN$1, (event)=>this._keydown(event));
        if (this._config.pause === "hover") {
            $9c6c83c6a450e1f8$var$EventHandler.on(this._element, $9c6c83c6a450e1f8$var$EVENT_MOUSEENTER$1, ()=>this.pause());
            $9c6c83c6a450e1f8$var$EventHandler.on(this._element, $9c6c83c6a450e1f8$var$EVENT_MOUSELEAVE$1, ()=>this._maybeEnableCycle());
        }
        if (this._config.touch && $9c6c83c6a450e1f8$var$Swipe.isSupported()) this._addTouchEventListeners();
    }
    _addTouchEventListeners() {
        for (const img of $9c6c83c6a450e1f8$var$SelectorEngine.find($9c6c83c6a450e1f8$var$SELECTOR_ITEM_IMG, this._element))$9c6c83c6a450e1f8$var$EventHandler.on(img, $9c6c83c6a450e1f8$var$EVENT_DRAG_START, (event)=>event.preventDefault());
        const endCallBack = ()=>{
            if (this._config.pause !== "hover") return;
            // If it's a touch-enabled device, mouseenter/leave are fired as
            // part of the mouse compatibility events on first tap - the carousel
            // would stop cycling until user tapped out of it;
            // here, we listen for touchend, explicitly pause the carousel
            // (as if it's the second time we tap on it, mouseenter compat event
            // is NOT fired) and after a timeout (to allow for mouse compatibility
            // events to fire) we explicitly restart cycling
            this.pause();
            if (this.touchTimeout) clearTimeout(this.touchTimeout);
            this.touchTimeout = setTimeout(()=>this._maybeEnableCycle(), $9c6c83c6a450e1f8$var$TOUCHEVENT_COMPAT_WAIT + this._config.interval);
        };
        const swipeConfig = {
            leftCallback: ()=>this._slide(this._directionToOrder($9c6c83c6a450e1f8$var$DIRECTION_LEFT)),
            rightCallback: ()=>this._slide(this._directionToOrder($9c6c83c6a450e1f8$var$DIRECTION_RIGHT)),
            endCallback: endCallBack
        };
        this._swipeHelper = new $9c6c83c6a450e1f8$var$Swipe(this._element, swipeConfig);
    }
    _keydown(event) {
        if (/input|textarea/i.test(event.target.tagName)) return;
        const direction = $9c6c83c6a450e1f8$var$KEY_TO_DIRECTION[event.key];
        if (direction) {
            event.preventDefault();
            this._slide(this._directionToOrder(direction));
        }
    }
    _getItemIndex(element) {
        return this._getItems().indexOf(element);
    }
    _setActiveIndicatorElement(index) {
        if (!this._indicatorsElement) return;
        const activeIndicator = $9c6c83c6a450e1f8$var$SelectorEngine.findOne($9c6c83c6a450e1f8$var$SELECTOR_ACTIVE, this._indicatorsElement);
        activeIndicator.classList.remove($9c6c83c6a450e1f8$var$CLASS_NAME_ACTIVE$2);
        activeIndicator.removeAttribute("aria-current");
        const newActiveIndicator = $9c6c83c6a450e1f8$var$SelectorEngine.findOne(`[data-bs-slide-to="${index}"]`, this._indicatorsElement);
        if (newActiveIndicator) {
            newActiveIndicator.classList.add($9c6c83c6a450e1f8$var$CLASS_NAME_ACTIVE$2);
            newActiveIndicator.setAttribute("aria-current", "true");
        }
    }
    _updateInterval() {
        const element = this._activeElement || this._getActive();
        if (!element) return;
        const elementInterval = Number.parseInt(element.getAttribute("data-bs-interval"), 10);
        this._config.interval = elementInterval || this._config.defaultInterval;
    }
    _slide(order, element = null) {
        if (this._isSliding) return;
        const activeElement = this._getActive();
        const isNext = order === $9c6c83c6a450e1f8$var$ORDER_NEXT;
        const nextElement = element || $9c6c83c6a450e1f8$var$getNextActiveElement(this._getItems(), activeElement, isNext, this._config.wrap);
        if (nextElement === activeElement) return;
        const nextElementIndex = this._getItemIndex(nextElement);
        const triggerEvent = (eventName)=>{
            return $9c6c83c6a450e1f8$var$EventHandler.trigger(this._element, eventName, {
                relatedTarget: nextElement,
                direction: this._orderToDirection(order),
                from: this._getItemIndex(activeElement),
                to: nextElementIndex
            });
        };
        const slideEvent = triggerEvent($9c6c83c6a450e1f8$var$EVENT_SLIDE);
        if (slideEvent.defaultPrevented) return;
        if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
        // TODO: change tests that use empty divs to avoid this check
        return;
        const isCycling = Boolean(this._interval);
        this.pause();
        this._isSliding = true;
        this._setActiveIndicatorElement(nextElementIndex);
        this._activeElement = nextElement;
        const directionalClassName = isNext ? $9c6c83c6a450e1f8$var$CLASS_NAME_START : $9c6c83c6a450e1f8$var$CLASS_NAME_END;
        const orderClassName = isNext ? $9c6c83c6a450e1f8$var$CLASS_NAME_NEXT : $9c6c83c6a450e1f8$var$CLASS_NAME_PREV;
        nextElement.classList.add(orderClassName);
        $9c6c83c6a450e1f8$var$reflow(nextElement);
        activeElement.classList.add(directionalClassName);
        nextElement.classList.add(directionalClassName);
        const completeCallBack = ()=>{
            nextElement.classList.remove(directionalClassName, orderClassName);
            nextElement.classList.add($9c6c83c6a450e1f8$var$CLASS_NAME_ACTIVE$2);
            activeElement.classList.remove($9c6c83c6a450e1f8$var$CLASS_NAME_ACTIVE$2, orderClassName, directionalClassName);
            this._isSliding = false;
            triggerEvent($9c6c83c6a450e1f8$var$EVENT_SLID);
        };
        this._queueCallback(completeCallBack, activeElement, this._isAnimated());
        if (isCycling) this.cycle();
    }
    _isAnimated() {
        return this._element.classList.contains($9c6c83c6a450e1f8$var$CLASS_NAME_SLIDE);
    }
    _getActive() {
        return $9c6c83c6a450e1f8$var$SelectorEngine.findOne($9c6c83c6a450e1f8$var$SELECTOR_ACTIVE_ITEM, this._element);
    }
    _getItems() {
        return $9c6c83c6a450e1f8$var$SelectorEngine.find($9c6c83c6a450e1f8$var$SELECTOR_ITEM, this._element);
    }
    _clearInterval() {
        if (this._interval) {
            clearInterval(this._interval);
            this._interval = null;
        }
    }
    _directionToOrder(direction) {
        if ($9c6c83c6a450e1f8$var$isRTL()) return direction === $9c6c83c6a450e1f8$var$DIRECTION_LEFT ? $9c6c83c6a450e1f8$var$ORDER_PREV : $9c6c83c6a450e1f8$var$ORDER_NEXT;
        return direction === $9c6c83c6a450e1f8$var$DIRECTION_LEFT ? $9c6c83c6a450e1f8$var$ORDER_NEXT : $9c6c83c6a450e1f8$var$ORDER_PREV;
    }
    _orderToDirection(order) {
        if ($9c6c83c6a450e1f8$var$isRTL()) return order === $9c6c83c6a450e1f8$var$ORDER_PREV ? $9c6c83c6a450e1f8$var$DIRECTION_LEFT : $9c6c83c6a450e1f8$var$DIRECTION_RIGHT;
        return order === $9c6c83c6a450e1f8$var$ORDER_PREV ? $9c6c83c6a450e1f8$var$DIRECTION_RIGHT : $9c6c83c6a450e1f8$var$DIRECTION_LEFT;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $9c6c83c6a450e1f8$export$144901db2ea8e967.getOrCreateInstance(this, config);
            if (typeof config === "number") {
                data.to(config);
                return;
            }
            if (typeof config === "string") {
                if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $9c6c83c6a450e1f8$var$EventHandler.on(document, $9c6c83c6a450e1f8$var$EVENT_CLICK_DATA_API$5, $9c6c83c6a450e1f8$var$SELECTOR_DATA_SLIDE, function(event) {
    const target = $9c6c83c6a450e1f8$var$SelectorEngine.getElementFromSelector(this);
    if (!target || !target.classList.contains($9c6c83c6a450e1f8$var$CLASS_NAME_CAROUSEL)) return;
    event.preventDefault();
    const carousel = $9c6c83c6a450e1f8$export$144901db2ea8e967.getOrCreateInstance(target);
    const slideIndex = this.getAttribute("data-bs-slide-to");
    if (slideIndex) {
        carousel.to(slideIndex);
        carousel._maybeEnableCycle();
        return;
    }
    if ($9c6c83c6a450e1f8$var$Manipulator.getDataAttribute(this, "slide") === "next") {
        carousel.next();
        carousel._maybeEnableCycle();
        return;
    }
    carousel.prev();
    carousel._maybeEnableCycle();
});
$9c6c83c6a450e1f8$var$EventHandler.on(window, $9c6c83c6a450e1f8$var$EVENT_LOAD_DATA_API$3, ()=>{
    const carousels = $9c6c83c6a450e1f8$var$SelectorEngine.find($9c6c83c6a450e1f8$var$SELECTOR_DATA_RIDE);
    for (const carousel of carousels)$9c6c83c6a450e1f8$export$144901db2ea8e967.getOrCreateInstance(carousel);
});
/**
 * jQuery
 */ $9c6c83c6a450e1f8$var$defineJQueryPlugin($9c6c83c6a450e1f8$export$144901db2ea8e967);
/**
 * --------------------------------------------------------------------------
 * Bootstrap collapse.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $9c6c83c6a450e1f8$var$NAME$b = "collapse";
const $9c6c83c6a450e1f8$var$DATA_KEY$7 = "bs.collapse";
const $9c6c83c6a450e1f8$var$EVENT_KEY$7 = `.${$9c6c83c6a450e1f8$var$DATA_KEY$7}`;
const $9c6c83c6a450e1f8$var$DATA_API_KEY$4 = ".data-api";
const $9c6c83c6a450e1f8$var$EVENT_SHOW$6 = `show${$9c6c83c6a450e1f8$var$EVENT_KEY$7}`;
const $9c6c83c6a450e1f8$var$EVENT_SHOWN$6 = `shown${$9c6c83c6a450e1f8$var$EVENT_KEY$7}`;
const $9c6c83c6a450e1f8$var$EVENT_HIDE$6 = `hide${$9c6c83c6a450e1f8$var$EVENT_KEY$7}`;
const $9c6c83c6a450e1f8$var$EVENT_HIDDEN$6 = `hidden${$9c6c83c6a450e1f8$var$EVENT_KEY$7}`;
const $9c6c83c6a450e1f8$var$EVENT_CLICK_DATA_API$4 = `click${$9c6c83c6a450e1f8$var$EVENT_KEY$7}${$9c6c83c6a450e1f8$var$DATA_API_KEY$4}`;
const $9c6c83c6a450e1f8$var$CLASS_NAME_SHOW$7 = "show";
const $9c6c83c6a450e1f8$var$CLASS_NAME_COLLAPSE = "collapse";
const $9c6c83c6a450e1f8$var$CLASS_NAME_COLLAPSING = "collapsing";
const $9c6c83c6a450e1f8$var$CLASS_NAME_COLLAPSED = "collapsed";
const $9c6c83c6a450e1f8$var$CLASS_NAME_DEEPER_CHILDREN = `:scope .${$9c6c83c6a450e1f8$var$CLASS_NAME_COLLAPSE} .${$9c6c83c6a450e1f8$var$CLASS_NAME_COLLAPSE}`;
const $9c6c83c6a450e1f8$var$CLASS_NAME_HORIZONTAL = "collapse-horizontal";
const $9c6c83c6a450e1f8$var$WIDTH = "width";
const $9c6c83c6a450e1f8$var$HEIGHT = "height";
const $9c6c83c6a450e1f8$var$SELECTOR_ACTIVES = ".collapse.show, .collapse.collapsing";
const $9c6c83c6a450e1f8$var$SELECTOR_DATA_TOGGLE$4 = '[data-bs-toggle="collapse"]';
const $9c6c83c6a450e1f8$var$Default$a = {
    parent: null,
    toggle: true
};
const $9c6c83c6a450e1f8$var$DefaultType$a = {
    parent: "(null|element)",
    toggle: "boolean"
};
/**
 * Class definition
 */ class $9c6c83c6a450e1f8$export$78768a9af065a7b extends $9c6c83c6a450e1f8$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isTransitioning = false;
        this._triggerArray = [];
        const toggleList = $9c6c83c6a450e1f8$var$SelectorEngine.find($9c6c83c6a450e1f8$var$SELECTOR_DATA_TOGGLE$4);
        for (const elem of toggleList){
            const selector = $9c6c83c6a450e1f8$var$SelectorEngine.getSelectorFromElement(elem);
            const filterElement = $9c6c83c6a450e1f8$var$SelectorEngine.find(selector).filter((foundElement)=>foundElement === this._element);
            if (selector !== null && filterElement.length) this._triggerArray.push(elem);
        }
        this._initializeChildren();
        if (!this._config.parent) this._addAriaAndCollapsedClass(this._triggerArray, this._isShown());
        if (this._config.toggle) this.toggle();
    }
    // Getters
    static get Default() {
        return $9c6c83c6a450e1f8$var$Default$a;
    }
    static get DefaultType() {
        return $9c6c83c6a450e1f8$var$DefaultType$a;
    }
    static get NAME() {
        return $9c6c83c6a450e1f8$var$NAME$b;
    }
    // Public
    toggle() {
        if (this._isShown()) this.hide();
        else this.show();
    }
    show() {
        if (this._isTransitioning || this._isShown()) return;
        let activeChildren = [];
        // find active children
        if (this._config.parent) activeChildren = this._getFirstLevelChildren($9c6c83c6a450e1f8$var$SELECTOR_ACTIVES).filter((element)=>element !== this._element).map((element)=>$9c6c83c6a450e1f8$export$78768a9af065a7b.getOrCreateInstance(element, {
                toggle: false
            }));
        if (activeChildren.length && activeChildren[0]._isTransitioning) return;
        const startEvent = $9c6c83c6a450e1f8$var$EventHandler.trigger(this._element, $9c6c83c6a450e1f8$var$EVENT_SHOW$6);
        if (startEvent.defaultPrevented) return;
        for (const activeInstance of activeChildren)activeInstance.hide();
        const dimension = this._getDimension();
        this._element.classList.remove($9c6c83c6a450e1f8$var$CLASS_NAME_COLLAPSE);
        this._element.classList.add($9c6c83c6a450e1f8$var$CLASS_NAME_COLLAPSING);
        this._element.style[dimension] = 0;
        this._addAriaAndCollapsedClass(this._triggerArray, true);
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($9c6c83c6a450e1f8$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($9c6c83c6a450e1f8$var$CLASS_NAME_COLLAPSE, $9c6c83c6a450e1f8$var$CLASS_NAME_SHOW$7);
            this._element.style[dimension] = "";
            $9c6c83c6a450e1f8$var$EventHandler.trigger(this._element, $9c6c83c6a450e1f8$var$EVENT_SHOWN$6);
        };
        const capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
        const scrollSize = `scroll${capitalizedDimension}`;
        this._queueCallback(complete, this._element, true);
        this._element.style[dimension] = `${this._element[scrollSize]}px`;
    }
    hide() {
        if (this._isTransitioning || !this._isShown()) return;
        const startEvent = $9c6c83c6a450e1f8$var$EventHandler.trigger(this._element, $9c6c83c6a450e1f8$var$EVENT_HIDE$6);
        if (startEvent.defaultPrevented) return;
        const dimension = this._getDimension();
        this._element.style[dimension] = `${this._element.getBoundingClientRect()[dimension]}px`;
        $9c6c83c6a450e1f8$var$reflow(this._element);
        this._element.classList.add($9c6c83c6a450e1f8$var$CLASS_NAME_COLLAPSING);
        this._element.classList.remove($9c6c83c6a450e1f8$var$CLASS_NAME_COLLAPSE, $9c6c83c6a450e1f8$var$CLASS_NAME_SHOW$7);
        for (const trigger of this._triggerArray){
            const element = $9c6c83c6a450e1f8$var$SelectorEngine.getElementFromSelector(trigger);
            if (element && !this._isShown(element)) this._addAriaAndCollapsedClass([
                trigger
            ], false);
        }
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($9c6c83c6a450e1f8$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($9c6c83c6a450e1f8$var$CLASS_NAME_COLLAPSE);
            $9c6c83c6a450e1f8$var$EventHandler.trigger(this._element, $9c6c83c6a450e1f8$var$EVENT_HIDDEN$6);
        };
        this._element.style[dimension] = "";
        this._queueCallback(complete, this._element, true);
    }
    _isShown(element = this._element) {
        return element.classList.contains($9c6c83c6a450e1f8$var$CLASS_NAME_SHOW$7);
    }
    // Private
    _configAfterMerge(config) {
        config.toggle = Boolean(config.toggle); // Coerce string values
        config.parent = $9c6c83c6a450e1f8$var$getElement(config.parent);
        return config;
    }
    _getDimension() {
        return this._element.classList.contains($9c6c83c6a450e1f8$var$CLASS_NAME_HORIZONTAL) ? $9c6c83c6a450e1f8$var$WIDTH : $9c6c83c6a450e1f8$var$HEIGHT;
    }
    _initializeChildren() {
        if (!this._config.parent) return;
        const children = this._getFirstLevelChildren($9c6c83c6a450e1f8$var$SELECTOR_DATA_TOGGLE$4);
        for (const element of children){
            const selected = $9c6c83c6a450e1f8$var$SelectorEngine.getElementFromSelector(element);
            if (selected) this._addAriaAndCollapsedClass([
                element
            ], this._isShown(selected));
        }
    }
    _getFirstLevelChildren(selector) {
        const children = $9c6c83c6a450e1f8$var$SelectorEngine.find($9c6c83c6a450e1f8$var$CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
        // remove children if greater depth
        return $9c6c83c6a450e1f8$var$SelectorEngine.find(selector, this._config.parent).filter((element)=>!children.includes(element));
    }
    _addAriaAndCollapsedClass(triggerArray, isOpen) {
        if (!triggerArray.length) return;
        for (const element of triggerArray){
            element.classList.toggle($9c6c83c6a450e1f8$var$CLASS_NAME_COLLAPSED, !isOpen);
            element.setAttribute("aria-expanded", isOpen);
        }
    }
    // Static
    static jQueryInterface(config) {
        const _config = {};
        if (typeof config === "string" && /show|hide/.test(config)) _config.toggle = false;
        return this.each(function() {
            const data = $9c6c83c6a450e1f8$export$78768a9af065a7b.getOrCreateInstance(this, _config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $9c6c83c6a450e1f8$var$EventHandler.on(document, $9c6c83c6a450e1f8$var$EVENT_CLICK_DATA_API$4, $9c6c83c6a450e1f8$var$SELECTOR_DATA_TOGGLE$4, function(event) {
    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
    if (event.target.tagName === "A" || event.delegateTarget && event.delegateTarget.tagName === "A") event.preventDefault();
    for (const element of $9c6c83c6a450e1f8$var$SelectorEngine.getMultipleElementsFromSelector(this))$9c6c83c6a450e1f8$export$78768a9af065a7b.getOrCreateInstance(element, {
        toggle: false
    }).toggle();
});
/**
 * jQuery
 */ $9c6c83c6a450e1f8$var$defineJQueryPlugin($9c6c83c6a450e1f8$export$78768a9af065a7b);
/**
 * --------------------------------------------------------------------------
 * Bootstrap dropdown.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $9c6c83c6a450e1f8$var$NAME$a = "dropdown";
const $9c6c83c6a450e1f8$var$DATA_KEY$6 = "bs.dropdown";
const $9c6c83c6a450e1f8$var$EVENT_KEY$6 = `.${$9c6c83c6a450e1f8$var$DATA_KEY$6}`;
const $9c6c83c6a450e1f8$var$DATA_API_KEY$3 = ".data-api";
const $9c6c83c6a450e1f8$var$ESCAPE_KEY$2 = "Escape";
const $9c6c83c6a450e1f8$var$TAB_KEY$1 = "Tab";
const $9c6c83c6a450e1f8$var$ARROW_UP_KEY$1 = "ArrowUp";
const $9c6c83c6a450e1f8$var$ARROW_DOWN_KEY$1 = "ArrowDown";
const $9c6c83c6a450e1f8$var$RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button
const $9c6c83c6a450e1f8$var$EVENT_HIDE$5 = `hide${$9c6c83c6a450e1f8$var$EVENT_KEY$6}`;
const $9c6c83c6a450e1f8$var$EVENT_HIDDEN$5 = `hidden${$9c6c83c6a450e1f8$var$EVENT_KEY$6}`;
const $9c6c83c6a450e1f8$var$EVENT_SHOW$5 = `show${$9c6c83c6a450e1f8$var$EVENT_KEY$6}`;
const $9c6c83c6a450e1f8$var$EVENT_SHOWN$5 = `shown${$9c6c83c6a450e1f8$var$EVENT_KEY$6}`;
const $9c6c83c6a450e1f8$var$EVENT_CLICK_DATA_API$3 = `click${$9c6c83c6a450e1f8$var$EVENT_KEY$6}${$9c6c83c6a450e1f8$var$DATA_API_KEY$3}`;
const $9c6c83c6a450e1f8$var$EVENT_KEYDOWN_DATA_API = `keydown${$9c6c83c6a450e1f8$var$EVENT_KEY$6}${$9c6c83c6a450e1f8$var$DATA_API_KEY$3}`;
const $9c6c83c6a450e1f8$var$EVENT_KEYUP_DATA_API = `keyup${$9c6c83c6a450e1f8$var$EVENT_KEY$6}${$9c6c83c6a450e1f8$var$DATA_API_KEY$3}`;
const $9c6c83c6a450e1f8$var$CLASS_NAME_SHOW$6 = "show";
const $9c6c83c6a450e1f8$var$CLASS_NAME_DROPUP = "dropup";
const $9c6c83c6a450e1f8$var$CLASS_NAME_DROPEND = "dropend";
const $9c6c83c6a450e1f8$var$CLASS_NAME_DROPSTART = "dropstart";
const $9c6c83c6a450e1f8$var$CLASS_NAME_DROPUP_CENTER = "dropup-center";
const $9c6c83c6a450e1f8$var$CLASS_NAME_DROPDOWN_CENTER = "dropdown-center";
const $9c6c83c6a450e1f8$var$SELECTOR_DATA_TOGGLE$3 = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)';
const $9c6c83c6a450e1f8$var$SELECTOR_DATA_TOGGLE_SHOWN = `${$9c6c83c6a450e1f8$var$SELECTOR_DATA_TOGGLE$3}.${$9c6c83c6a450e1f8$var$CLASS_NAME_SHOW$6}`;
const $9c6c83c6a450e1f8$var$SELECTOR_MENU = ".dropdown-menu";
const $9c6c83c6a450e1f8$var$SELECTOR_NAVBAR = ".navbar";
const $9c6c83c6a450e1f8$var$SELECTOR_NAVBAR_NAV = ".navbar-nav";
const $9c6c83c6a450e1f8$var$SELECTOR_VISIBLE_ITEMS = ".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)";
const $9c6c83c6a450e1f8$var$PLACEMENT_TOP = $9c6c83c6a450e1f8$var$isRTL() ? "top-end" : "top-start";
const $9c6c83c6a450e1f8$var$PLACEMENT_TOPEND = $9c6c83c6a450e1f8$var$isRTL() ? "top-start" : "top-end";
const $9c6c83c6a450e1f8$var$PLACEMENT_BOTTOM = $9c6c83c6a450e1f8$var$isRTL() ? "bottom-end" : "bottom-start";
const $9c6c83c6a450e1f8$var$PLACEMENT_BOTTOMEND = $9c6c83c6a450e1f8$var$isRTL() ? "bottom-start" : "bottom-end";
const $9c6c83c6a450e1f8$var$PLACEMENT_RIGHT = $9c6c83c6a450e1f8$var$isRTL() ? "left-start" : "right-start";
const $9c6c83c6a450e1f8$var$PLACEMENT_LEFT = $9c6c83c6a450e1f8$var$isRTL() ? "right-start" : "left-start";
const $9c6c83c6a450e1f8$var$PLACEMENT_TOPCENTER = "top";
const $9c6c83c6a450e1f8$var$PLACEMENT_BOTTOMCENTER = "bottom";
const $9c6c83c6a450e1f8$var$Default$9 = {
    autoClose: true,
    boundary: "clippingParents",
    display: "dynamic",
    offset: [
        0,
        2
    ],
    popperConfig: null,
    reference: "toggle"
};
const $9c6c83c6a450e1f8$var$DefaultType$9 = {
    autoClose: "(boolean|string)",
    boundary: "(string|element)",
    display: "string",
    offset: "(array|string|function)",
    popperConfig: "(null|object|function)",
    reference: "(string|element|object)"
};
/**
 * Class definition
 */ class $9c6c83c6a450e1f8$export$931cbfb6bfb85fc extends $9c6c83c6a450e1f8$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._popper = null;
        this._parent = this._element.parentNode; // dropdown wrapper
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        this._menu = $9c6c83c6a450e1f8$var$SelectorEngine.next(this._element, $9c6c83c6a450e1f8$var$SELECTOR_MENU)[0] || $9c6c83c6a450e1f8$var$SelectorEngine.prev(this._element, $9c6c83c6a450e1f8$var$SELECTOR_MENU)[0] || $9c6c83c6a450e1f8$var$SelectorEngine.findOne($9c6c83c6a450e1f8$var$SELECTOR_MENU, this._parent);
        this._inNavbar = this._detectNavbar();
    }
    // Getters
    static get Default() {
        return $9c6c83c6a450e1f8$var$Default$9;
    }
    static get DefaultType() {
        return $9c6c83c6a450e1f8$var$DefaultType$9;
    }
    static get NAME() {
        return $9c6c83c6a450e1f8$var$NAME$a;
    }
    // Public
    toggle() {
        return this._isShown() ? this.hide() : this.show();
    }
    show() {
        if ($9c6c83c6a450e1f8$var$isDisabled(this._element) || this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        const showEvent = $9c6c83c6a450e1f8$var$EventHandler.trigger(this._element, $9c6c83c6a450e1f8$var$EVENT_SHOW$5, relatedTarget);
        if (showEvent.defaultPrevented) return;
        this._createPopper();
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ("ontouchstart" in document.documentElement && !this._parent.closest($9c6c83c6a450e1f8$var$SELECTOR_NAVBAR_NAV)) for (const element of [].concat(...document.body.children))$9c6c83c6a450e1f8$var$EventHandler.on(element, "mouseover", $9c6c83c6a450e1f8$var$noop);
        this._element.focus();
        this._element.setAttribute("aria-expanded", true);
        this._menu.classList.add($9c6c83c6a450e1f8$var$CLASS_NAME_SHOW$6);
        this._element.classList.add($9c6c83c6a450e1f8$var$CLASS_NAME_SHOW$6);
        $9c6c83c6a450e1f8$var$EventHandler.trigger(this._element, $9c6c83c6a450e1f8$var$EVENT_SHOWN$5, relatedTarget);
    }
    hide() {
        if ($9c6c83c6a450e1f8$var$isDisabled(this._element) || !this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        this._completeHide(relatedTarget);
    }
    dispose() {
        if (this._popper) this._popper.destroy();
        super.dispose();
    }
    update() {
        this._inNavbar = this._detectNavbar();
        if (this._popper) this._popper.update();
    }
    // Private
    _completeHide(relatedTarget) {
        const hideEvent = $9c6c83c6a450e1f8$var$EventHandler.trigger(this._element, $9c6c83c6a450e1f8$var$EVENT_HIDE$5, relatedTarget);
        if (hideEvent.defaultPrevented) return;
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ("ontouchstart" in document.documentElement) for (const element of [].concat(...document.body.children))$9c6c83c6a450e1f8$var$EventHandler.off(element, "mouseover", $9c6c83c6a450e1f8$var$noop);
        if (this._popper) this._popper.destroy();
        this._menu.classList.remove($9c6c83c6a450e1f8$var$CLASS_NAME_SHOW$6);
        this._element.classList.remove($9c6c83c6a450e1f8$var$CLASS_NAME_SHOW$6);
        this._element.setAttribute("aria-expanded", "false");
        $9c6c83c6a450e1f8$var$Manipulator.removeDataAttribute(this._menu, "popper");
        $9c6c83c6a450e1f8$var$EventHandler.trigger(this._element, $9c6c83c6a450e1f8$var$EVENT_HIDDEN$5, relatedTarget);
    }
    _getConfig(config) {
        config = super._getConfig(config);
        if (typeof config.reference === "object" && !$9c6c83c6a450e1f8$var$isElement(config.reference) && typeof config.reference.getBoundingClientRect !== "function") // Popper virtual elements require a getBoundingClientRect method
        throw new TypeError(`${$9c6c83c6a450e1f8$var$NAME$a.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
        return config;
    }
    _createPopper() {
        if (typeof $e2544cfeed0c9093$exports === "undefined") throw new TypeError("Bootstrap's dropdowns require Popper (https://popper.js.org)");
        let referenceElement = this._element;
        if (this._config.reference === "parent") referenceElement = this._parent;
        else if ($9c6c83c6a450e1f8$var$isElement(this._config.reference)) referenceElement = $9c6c83c6a450e1f8$var$getElement(this._config.reference);
        else if (typeof this._config.reference === "object") referenceElement = this._config.reference;
        const popperConfig = this._getPopperConfig();
        this._popper = $e2544cfeed0c9093$exports.createPopper(referenceElement, this._menu, popperConfig);
    }
    _isShown() {
        return this._menu.classList.contains($9c6c83c6a450e1f8$var$CLASS_NAME_SHOW$6);
    }
    _getPlacement() {
        const parentDropdown = this._parent;
        if (parentDropdown.classList.contains($9c6c83c6a450e1f8$var$CLASS_NAME_DROPEND)) return $9c6c83c6a450e1f8$var$PLACEMENT_RIGHT;
        if (parentDropdown.classList.contains($9c6c83c6a450e1f8$var$CLASS_NAME_DROPSTART)) return $9c6c83c6a450e1f8$var$PLACEMENT_LEFT;
        if (parentDropdown.classList.contains($9c6c83c6a450e1f8$var$CLASS_NAME_DROPUP_CENTER)) return $9c6c83c6a450e1f8$var$PLACEMENT_TOPCENTER;
        if (parentDropdown.classList.contains($9c6c83c6a450e1f8$var$CLASS_NAME_DROPDOWN_CENTER)) return $9c6c83c6a450e1f8$var$PLACEMENT_BOTTOMCENTER;
        // We need to trim the value because custom properties can also include spaces
        const isEnd = getComputedStyle(this._menu).getPropertyValue("--bs-position").trim() === "end";
        if (parentDropdown.classList.contains($9c6c83c6a450e1f8$var$CLASS_NAME_DROPUP)) return isEnd ? $9c6c83c6a450e1f8$var$PLACEMENT_TOPEND : $9c6c83c6a450e1f8$var$PLACEMENT_TOP;
        return isEnd ? $9c6c83c6a450e1f8$var$PLACEMENT_BOTTOMEND : $9c6c83c6a450e1f8$var$PLACEMENT_BOTTOM;
    }
    _detectNavbar() {
        return this._element.closest($9c6c83c6a450e1f8$var$SELECTOR_NAVBAR) !== null;
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === "string") return offset.split(",").map((value)=>Number.parseInt(value, 10));
        if (typeof offset === "function") return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _getPopperConfig() {
        const defaultBsPopperConfig = {
            placement: this._getPlacement(),
            modifiers: [
                {
                    name: "preventOverflow",
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: "offset",
                    options: {
                        offset: this._getOffset()
                    }
                }
            ]
        };
        // Disable Popper if we have a static display or Dropdown is in Navbar
        if (this._inNavbar || this._config.display === "static") {
            $9c6c83c6a450e1f8$var$Manipulator.setDataAttribute(this._menu, "popper", "static"); // TODO: v6 remove
            defaultBsPopperConfig.modifiers = [
                {
                    name: "applyStyles",
                    enabled: false
                }
            ];
        }
        return {
            ...defaultBsPopperConfig,
            ...$9c6c83c6a450e1f8$var$execute(this._config.popperConfig, [
                defaultBsPopperConfig
            ])
        };
    }
    _selectMenuItem({ key: key, target: target }) {
        const items = $9c6c83c6a450e1f8$var$SelectorEngine.find($9c6c83c6a450e1f8$var$SELECTOR_VISIBLE_ITEMS, this._menu).filter((element)=>$9c6c83c6a450e1f8$var$isVisible(element));
        if (!items.length) return;
        // if target isn't included in items (e.g. when expanding the dropdown)
        // allow cycling to get the last item in case key equals ARROW_UP_KEY
        $9c6c83c6a450e1f8$var$getNextActiveElement(items, target, key === $9c6c83c6a450e1f8$var$ARROW_DOWN_KEY$1, !items.includes(target)).focus();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $9c6c83c6a450e1f8$export$931cbfb6bfb85fc.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
    static clearMenus(event) {
        if (event.button === $9c6c83c6a450e1f8$var$RIGHT_MOUSE_BUTTON || event.type === "keyup" && event.key !== $9c6c83c6a450e1f8$var$TAB_KEY$1) return;
        const openToggles = $9c6c83c6a450e1f8$var$SelectorEngine.find($9c6c83c6a450e1f8$var$SELECTOR_DATA_TOGGLE_SHOWN);
        for (const toggle of openToggles){
            const context = $9c6c83c6a450e1f8$export$931cbfb6bfb85fc.getInstance(toggle);
            if (!context || context._config.autoClose === false) continue;
            const composedPath = event.composedPath();
            const isMenuTarget = composedPath.includes(context._menu);
            if (composedPath.includes(context._element) || context._config.autoClose === "inside" && !isMenuTarget || context._config.autoClose === "outside" && isMenuTarget) continue;
            // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu
            if (context._menu.contains(event.target) && (event.type === "keyup" && event.key === $9c6c83c6a450e1f8$var$TAB_KEY$1 || /input|select|option|textarea|form/i.test(event.target.tagName))) continue;
            const relatedTarget = {
                relatedTarget: context._element
            };
            if (event.type === "click") relatedTarget.clickEvent = event;
            context._completeHide(relatedTarget);
        }
    }
    static dataApiKeydownHandler(event) {
        // If not an UP | DOWN | ESCAPE key => not a dropdown command
        // If input/textarea && if key is other than ESCAPE => not a dropdown command
        const isInput = /input|textarea/i.test(event.target.tagName);
        const isEscapeEvent = event.key === $9c6c83c6a450e1f8$var$ESCAPE_KEY$2;
        const isUpOrDownEvent = [
            $9c6c83c6a450e1f8$var$ARROW_UP_KEY$1,
            $9c6c83c6a450e1f8$var$ARROW_DOWN_KEY$1
        ].includes(event.key);
        if (!isUpOrDownEvent && !isEscapeEvent) return;
        if (isInput && !isEscapeEvent) return;
        event.preventDefault();
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        const getToggleButton = this.matches($9c6c83c6a450e1f8$var$SELECTOR_DATA_TOGGLE$3) ? this : $9c6c83c6a450e1f8$var$SelectorEngine.prev(this, $9c6c83c6a450e1f8$var$SELECTOR_DATA_TOGGLE$3)[0] || $9c6c83c6a450e1f8$var$SelectorEngine.next(this, $9c6c83c6a450e1f8$var$SELECTOR_DATA_TOGGLE$3)[0] || $9c6c83c6a450e1f8$var$SelectorEngine.findOne($9c6c83c6a450e1f8$var$SELECTOR_DATA_TOGGLE$3, event.delegateTarget.parentNode);
        const instance = $9c6c83c6a450e1f8$export$931cbfb6bfb85fc.getOrCreateInstance(getToggleButton);
        if (isUpOrDownEvent) {
            event.stopPropagation();
            instance.show();
            instance._selectMenuItem(event);
            return;
        }
        if (instance._isShown()) {
            // else is escape and we check if it is shown
            event.stopPropagation();
            instance.hide();
            getToggleButton.focus();
        }
    }
}
/**
 * Data API implementation
 */ $9c6c83c6a450e1f8$var$EventHandler.on(document, $9c6c83c6a450e1f8$var$EVENT_KEYDOWN_DATA_API, $9c6c83c6a450e1f8$var$SELECTOR_DATA_TOGGLE$3, $9c6c83c6a450e1f8$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$9c6c83c6a450e1f8$var$EventHandler.on(document, $9c6c83c6a450e1f8$var$EVENT_KEYDOWN_DATA_API, $9c6c83c6a450e1f8$var$SELECTOR_MENU, $9c6c83c6a450e1f8$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$9c6c83c6a450e1f8$var$EventHandler.on(document, $9c6c83c6a450e1f8$var$EVENT_CLICK_DATA_API$3, $9c6c83c6a450e1f8$export$931cbfb6bfb85fc.clearMenus);
$9c6c83c6a450e1f8$var$EventHandler.on(document, $9c6c83c6a450e1f8$var$EVENT_KEYUP_DATA_API, $9c6c83c6a450e1f8$export$931cbfb6bfb85fc.clearMenus);
$9c6c83c6a450e1f8$var$EventHandler.on(document, $9c6c83c6a450e1f8$var$EVENT_CLICK_DATA_API$3, $9c6c83c6a450e1f8$var$SELECTOR_DATA_TOGGLE$3, function(event) {
    event.preventDefault();
    $9c6c83c6a450e1f8$export$931cbfb6bfb85fc.getOrCreateInstance(this).toggle();
});
/**
 * jQuery
 */ $9c6c83c6a450e1f8$var$defineJQueryPlugin($9c6c83c6a450e1f8$export$931cbfb6bfb85fc);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/backdrop.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $9c6c83c6a450e1f8$var$NAME$9 = "backdrop";
const $9c6c83c6a450e1f8$var$CLASS_NAME_FADE$4 = "fade";
const $9c6c83c6a450e1f8$var$CLASS_NAME_SHOW$5 = "show";
const $9c6c83c6a450e1f8$var$EVENT_MOUSEDOWN = `mousedown.bs.${$9c6c83c6a450e1f8$var$NAME$9}`;
const $9c6c83c6a450e1f8$var$Default$8 = {
    className: "modal-backdrop",
    clickCallback: null,
    isAnimated: false,
    isVisible: true,
    // if false, we use the backdrop helper without adding any element to the dom
    rootElement: "body" // give the choice to place backdrop under different elements
};
const $9c6c83c6a450e1f8$var$DefaultType$8 = {
    className: "string",
    clickCallback: "(function|null)",
    isAnimated: "boolean",
    isVisible: "boolean",
    rootElement: "(element|string)"
};
/**
 * Class definition
 */ class $9c6c83c6a450e1f8$var$Backdrop extends $9c6c83c6a450e1f8$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isAppended = false;
        this._element = null;
    }
    // Getters
    static get Default() {
        return $9c6c83c6a450e1f8$var$Default$8;
    }
    static get DefaultType() {
        return $9c6c83c6a450e1f8$var$DefaultType$8;
    }
    static get NAME() {
        return $9c6c83c6a450e1f8$var$NAME$9;
    }
    // Public
    show(callback) {
        if (!this._config.isVisible) {
            $9c6c83c6a450e1f8$var$execute(callback);
            return;
        }
        this._append();
        const element = this._getElement();
        if (this._config.isAnimated) $9c6c83c6a450e1f8$var$reflow(element);
        element.classList.add($9c6c83c6a450e1f8$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            $9c6c83c6a450e1f8$var$execute(callback);
        });
    }
    hide(callback) {
        if (!this._config.isVisible) {
            $9c6c83c6a450e1f8$var$execute(callback);
            return;
        }
        this._getElement().classList.remove($9c6c83c6a450e1f8$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            this.dispose();
            $9c6c83c6a450e1f8$var$execute(callback);
        });
    }
    dispose() {
        if (!this._isAppended) return;
        $9c6c83c6a450e1f8$var$EventHandler.off(this._element, $9c6c83c6a450e1f8$var$EVENT_MOUSEDOWN);
        this._element.remove();
        this._isAppended = false;
    }
    // Private
    _getElement() {
        if (!this._element) {
            const backdrop = document.createElement("div");
            backdrop.className = this._config.className;
            if (this._config.isAnimated) backdrop.classList.add($9c6c83c6a450e1f8$var$CLASS_NAME_FADE$4);
            this._element = backdrop;
        }
        return this._element;
    }
    _configAfterMerge(config) {
        // use getElement() with the default "body" to get a fresh Element on each instantiation
        config.rootElement = $9c6c83c6a450e1f8$var$getElement(config.rootElement);
        return config;
    }
    _append() {
        if (this._isAppended) return;
        const element = this._getElement();
        this._config.rootElement.append(element);
        $9c6c83c6a450e1f8$var$EventHandler.on(element, $9c6c83c6a450e1f8$var$EVENT_MOUSEDOWN, ()=>{
            $9c6c83c6a450e1f8$var$execute(this._config.clickCallback);
        });
        this._isAppended = true;
    }
    _emulateAnimation(callback) {
        $9c6c83c6a450e1f8$var$executeAfterTransition(callback, this._getElement(), this._config.isAnimated);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/focustrap.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $9c6c83c6a450e1f8$var$NAME$8 = "focustrap";
const $9c6c83c6a450e1f8$var$DATA_KEY$5 = "bs.focustrap";
const $9c6c83c6a450e1f8$var$EVENT_KEY$5 = `.${$9c6c83c6a450e1f8$var$DATA_KEY$5}`;
const $9c6c83c6a450e1f8$var$EVENT_FOCUSIN$2 = `focusin${$9c6c83c6a450e1f8$var$EVENT_KEY$5}`;
const $9c6c83c6a450e1f8$var$EVENT_KEYDOWN_TAB = `keydown.tab${$9c6c83c6a450e1f8$var$EVENT_KEY$5}`;
const $9c6c83c6a450e1f8$var$TAB_KEY = "Tab";
const $9c6c83c6a450e1f8$var$TAB_NAV_FORWARD = "forward";
const $9c6c83c6a450e1f8$var$TAB_NAV_BACKWARD = "backward";
const $9c6c83c6a450e1f8$var$Default$7 = {
    autofocus: true,
    trapElement: null // The element to trap focus inside of
};
const $9c6c83c6a450e1f8$var$DefaultType$7 = {
    autofocus: "boolean",
    trapElement: "element"
};
/**
 * Class definition
 */ class $9c6c83c6a450e1f8$var$FocusTrap extends $9c6c83c6a450e1f8$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isActive = false;
        this._lastTabNavDirection = null;
    }
    // Getters
    static get Default() {
        return $9c6c83c6a450e1f8$var$Default$7;
    }
    static get DefaultType() {
        return $9c6c83c6a450e1f8$var$DefaultType$7;
    }
    static get NAME() {
        return $9c6c83c6a450e1f8$var$NAME$8;
    }
    // Public
    activate() {
        if (this._isActive) return;
        if (this._config.autofocus) this._config.trapElement.focus();
        $9c6c83c6a450e1f8$var$EventHandler.off(document, $9c6c83c6a450e1f8$var$EVENT_KEY$5); // guard against infinite focus loop
        $9c6c83c6a450e1f8$var$EventHandler.on(document, $9c6c83c6a450e1f8$var$EVENT_FOCUSIN$2, (event)=>this._handleFocusin(event));
        $9c6c83c6a450e1f8$var$EventHandler.on(document, $9c6c83c6a450e1f8$var$EVENT_KEYDOWN_TAB, (event)=>this._handleKeydown(event));
        this._isActive = true;
    }
    deactivate() {
        if (!this._isActive) return;
        this._isActive = false;
        $9c6c83c6a450e1f8$var$EventHandler.off(document, $9c6c83c6a450e1f8$var$EVENT_KEY$5);
    }
    // Private
    _handleFocusin(event) {
        const { trapElement: trapElement } = this._config;
        if (event.target === document || event.target === trapElement || trapElement.contains(event.target)) return;
        const elements = $9c6c83c6a450e1f8$var$SelectorEngine.focusableChildren(trapElement);
        if (elements.length === 0) trapElement.focus();
        else if (this._lastTabNavDirection === $9c6c83c6a450e1f8$var$TAB_NAV_BACKWARD) elements[elements.length - 1].focus();
        else elements[0].focus();
    }
    _handleKeydown(event) {
        if (event.key !== $9c6c83c6a450e1f8$var$TAB_KEY) return;
        this._lastTabNavDirection = event.shiftKey ? $9c6c83c6a450e1f8$var$TAB_NAV_BACKWARD : $9c6c83c6a450e1f8$var$TAB_NAV_FORWARD;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/scrollBar.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $9c6c83c6a450e1f8$var$SELECTOR_FIXED_CONTENT = ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top";
const $9c6c83c6a450e1f8$var$SELECTOR_STICKY_CONTENT = ".sticky-top";
const $9c6c83c6a450e1f8$var$PROPERTY_PADDING = "padding-right";
const $9c6c83c6a450e1f8$var$PROPERTY_MARGIN = "margin-right";
/**
 * Class definition
 */ class $9c6c83c6a450e1f8$var$ScrollBarHelper {
    constructor(){
        this._element = document.body;
    }
    // Public
    getWidth() {
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
        const documentWidth = document.documentElement.clientWidth;
        return Math.abs(window.innerWidth - documentWidth);
    }
    hide() {
        const width = this.getWidth();
        this._disableOverFlow();
        // give padding to element to balance the hidden scrollbar width
        this._setElementAttributes(this._element, $9c6c83c6a450e1f8$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth
        this._setElementAttributes($9c6c83c6a450e1f8$var$SELECTOR_FIXED_CONTENT, $9c6c83c6a450e1f8$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        this._setElementAttributes($9c6c83c6a450e1f8$var$SELECTOR_STICKY_CONTENT, $9c6c83c6a450e1f8$var$PROPERTY_MARGIN, (calculatedValue)=>calculatedValue - width);
    }
    reset() {
        this._resetElementAttributes(this._element, "overflow");
        this._resetElementAttributes(this._element, $9c6c83c6a450e1f8$var$PROPERTY_PADDING);
        this._resetElementAttributes($9c6c83c6a450e1f8$var$SELECTOR_FIXED_CONTENT, $9c6c83c6a450e1f8$var$PROPERTY_PADDING);
        this._resetElementAttributes($9c6c83c6a450e1f8$var$SELECTOR_STICKY_CONTENT, $9c6c83c6a450e1f8$var$PROPERTY_MARGIN);
    }
    isOverflowing() {
        return this.getWidth() > 0;
    }
    // Private
    _disableOverFlow() {
        this._saveInitialAttribute(this._element, "overflow");
        this._element.style.overflow = "hidden";
    }
    _setElementAttributes(selector, styleProperty, callback) {
        const scrollbarWidth = this.getWidth();
        const manipulationCallBack = (element)=>{
            if (element !== this._element && window.innerWidth > element.clientWidth + scrollbarWidth) return;
            this._saveInitialAttribute(element, styleProperty);
            const calculatedValue = window.getComputedStyle(element).getPropertyValue(styleProperty);
            element.style.setProperty(styleProperty, `${callback(Number.parseFloat(calculatedValue))}px`);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _saveInitialAttribute(element, styleProperty) {
        const actualValue = element.style.getPropertyValue(styleProperty);
        if (actualValue) $9c6c83c6a450e1f8$var$Manipulator.setDataAttribute(element, styleProperty, actualValue);
    }
    _resetElementAttributes(selector, styleProperty) {
        const manipulationCallBack = (element)=>{
            const value = $9c6c83c6a450e1f8$var$Manipulator.getDataAttribute(element, styleProperty);
            // We only want to remove the property if the value is `null`; the value can also be zero
            if (value === null) {
                element.style.removeProperty(styleProperty);
                return;
            }
            $9c6c83c6a450e1f8$var$Manipulator.removeDataAttribute(element, styleProperty);
            element.style.setProperty(styleProperty, value);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _applyManipulationCallback(selector, callBack) {
        if ($9c6c83c6a450e1f8$var$isElement(selector)) {
            callBack(selector);
            return;
        }
        for (const sel of $9c6c83c6a450e1f8$var$SelectorEngine.find(selector, this._element))callBack(sel);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $9c6c83c6a450e1f8$var$NAME$7 = "modal";
const $9c6c83c6a450e1f8$var$DATA_KEY$4 = "bs.modal";
const $9c6c83c6a450e1f8$var$EVENT_KEY$4 = `.${$9c6c83c6a450e1f8$var$DATA_KEY$4}`;
const $9c6c83c6a450e1f8$var$DATA_API_KEY$2 = ".data-api";
const $9c6c83c6a450e1f8$var$ESCAPE_KEY$1 = "Escape";
const $9c6c83c6a450e1f8$var$EVENT_HIDE$4 = `hide${$9c6c83c6a450e1f8$var$EVENT_KEY$4}`;
const $9c6c83c6a450e1f8$var$EVENT_HIDE_PREVENTED$1 = `hidePrevented${$9c6c83c6a450e1f8$var$EVENT_KEY$4}`;
const $9c6c83c6a450e1f8$var$EVENT_HIDDEN$4 = `hidden${$9c6c83c6a450e1f8$var$EVENT_KEY$4}`;
const $9c6c83c6a450e1f8$var$EVENT_SHOW$4 = `show${$9c6c83c6a450e1f8$var$EVENT_KEY$4}`;
const $9c6c83c6a450e1f8$var$EVENT_SHOWN$4 = `shown${$9c6c83c6a450e1f8$var$EVENT_KEY$4}`;
const $9c6c83c6a450e1f8$var$EVENT_RESIZE$1 = `resize${$9c6c83c6a450e1f8$var$EVENT_KEY$4}`;
const $9c6c83c6a450e1f8$var$EVENT_CLICK_DISMISS = `click.dismiss${$9c6c83c6a450e1f8$var$EVENT_KEY$4}`;
const $9c6c83c6a450e1f8$var$EVENT_MOUSEDOWN_DISMISS = `mousedown.dismiss${$9c6c83c6a450e1f8$var$EVENT_KEY$4}`;
const $9c6c83c6a450e1f8$var$EVENT_KEYDOWN_DISMISS$1 = `keydown.dismiss${$9c6c83c6a450e1f8$var$EVENT_KEY$4}`;
const $9c6c83c6a450e1f8$var$EVENT_CLICK_DATA_API$2 = `click${$9c6c83c6a450e1f8$var$EVENT_KEY$4}${$9c6c83c6a450e1f8$var$DATA_API_KEY$2}`;
const $9c6c83c6a450e1f8$var$CLASS_NAME_OPEN = "modal-open";
const $9c6c83c6a450e1f8$var$CLASS_NAME_FADE$3 = "fade";
const $9c6c83c6a450e1f8$var$CLASS_NAME_SHOW$4 = "show";
const $9c6c83c6a450e1f8$var$CLASS_NAME_STATIC = "modal-static";
const $9c6c83c6a450e1f8$var$OPEN_SELECTOR$1 = ".modal.show";
const $9c6c83c6a450e1f8$var$SELECTOR_DIALOG = ".modal-dialog";
const $9c6c83c6a450e1f8$var$SELECTOR_MODAL_BODY = ".modal-body";
const $9c6c83c6a450e1f8$var$SELECTOR_DATA_TOGGLE$2 = '[data-bs-toggle="modal"]';
const $9c6c83c6a450e1f8$var$Default$6 = {
    backdrop: true,
    focus: true,
    keyboard: true
};
const $9c6c83c6a450e1f8$var$DefaultType$6 = {
    backdrop: "(boolean|string)",
    focus: "boolean",
    keyboard: "boolean"
};
/**
 * Class definition
 */ class $9c6c83c6a450e1f8$export$2b77a92f1a5ad772 extends $9c6c83c6a450e1f8$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._dialog = $9c6c83c6a450e1f8$var$SelectorEngine.findOne($9c6c83c6a450e1f8$var$SELECTOR_DIALOG, this._element);
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._isShown = false;
        this._isTransitioning = false;
        this._scrollBar = new $9c6c83c6a450e1f8$var$ScrollBarHelper();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $9c6c83c6a450e1f8$var$Default$6;
    }
    static get DefaultType() {
        return $9c6c83c6a450e1f8$var$DefaultType$6;
    }
    static get NAME() {
        return $9c6c83c6a450e1f8$var$NAME$7;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown || this._isTransitioning) return;
        const showEvent = $9c6c83c6a450e1f8$var$EventHandler.trigger(this._element, $9c6c83c6a450e1f8$var$EVENT_SHOW$4, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._isTransitioning = true;
        this._scrollBar.hide();
        document.body.classList.add($9c6c83c6a450e1f8$var$CLASS_NAME_OPEN);
        this._adjustDialog();
        this._backdrop.show(()=>this._showElement(relatedTarget));
    }
    hide() {
        if (!this._isShown || this._isTransitioning) return;
        const hideEvent = $9c6c83c6a450e1f8$var$EventHandler.trigger(this._element, $9c6c83c6a450e1f8$var$EVENT_HIDE$4);
        if (hideEvent.defaultPrevented) return;
        this._isShown = false;
        this._isTransitioning = true;
        this._focustrap.deactivate();
        this._element.classList.remove($9c6c83c6a450e1f8$var$CLASS_NAME_SHOW$4);
        this._queueCallback(()=>this._hideModal(), this._element, this._isAnimated());
    }
    dispose() {
        $9c6c83c6a450e1f8$var$EventHandler.off(window, $9c6c83c6a450e1f8$var$EVENT_KEY$4);
        $9c6c83c6a450e1f8$var$EventHandler.off(this._dialog, $9c6c83c6a450e1f8$var$EVENT_KEY$4);
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    handleUpdate() {
        this._adjustDialog();
    }
    // Private
    _initializeBackDrop() {
        return new $9c6c83c6a450e1f8$var$Backdrop({
            isVisible: Boolean(this._config.backdrop),
            // 'static' option will be translated to true, and booleans will keep their value,
            isAnimated: this._isAnimated()
        });
    }
    _initializeFocusTrap() {
        return new $9c6c83c6a450e1f8$var$FocusTrap({
            trapElement: this._element
        });
    }
    _showElement(relatedTarget) {
        // try to append dynamic modal
        if (!document.body.contains(this._element)) document.body.append(this._element);
        this._element.style.display = "block";
        this._element.removeAttribute("aria-hidden");
        this._element.setAttribute("aria-modal", true);
        this._element.setAttribute("role", "dialog");
        this._element.scrollTop = 0;
        const modalBody = $9c6c83c6a450e1f8$var$SelectorEngine.findOne($9c6c83c6a450e1f8$var$SELECTOR_MODAL_BODY, this._dialog);
        if (modalBody) modalBody.scrollTop = 0;
        $9c6c83c6a450e1f8$var$reflow(this._element);
        this._element.classList.add($9c6c83c6a450e1f8$var$CLASS_NAME_SHOW$4);
        const transitionComplete = ()=>{
            if (this._config.focus) this._focustrap.activate();
            this._isTransitioning = false;
            $9c6c83c6a450e1f8$var$EventHandler.trigger(this._element, $9c6c83c6a450e1f8$var$EVENT_SHOWN$4, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(transitionComplete, this._dialog, this._isAnimated());
    }
    _addEventListeners() {
        $9c6c83c6a450e1f8$var$EventHandler.on(this._element, $9c6c83c6a450e1f8$var$EVENT_KEYDOWN_DISMISS$1, (event)=>{
            if (event.key !== $9c6c83c6a450e1f8$var$ESCAPE_KEY$1) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            this._triggerBackdropTransition();
        });
        $9c6c83c6a450e1f8$var$EventHandler.on(window, $9c6c83c6a450e1f8$var$EVENT_RESIZE$1, ()=>{
            if (this._isShown && !this._isTransitioning) this._adjustDialog();
        });
        $9c6c83c6a450e1f8$var$EventHandler.on(this._element, $9c6c83c6a450e1f8$var$EVENT_MOUSEDOWN_DISMISS, (event)=>{
            // a bad trick to segregate clicks that may start inside dialog but end outside, and avoid listen to scrollbar clicks
            $9c6c83c6a450e1f8$var$EventHandler.one(this._element, $9c6c83c6a450e1f8$var$EVENT_CLICK_DISMISS, (event2)=>{
                if (this._element !== event.target || this._element !== event2.target) return;
                if (this._config.backdrop === "static") {
                    this._triggerBackdropTransition();
                    return;
                }
                if (this._config.backdrop) this.hide();
            });
        });
    }
    _hideModal() {
        this._element.style.display = "none";
        this._element.setAttribute("aria-hidden", true);
        this._element.removeAttribute("aria-modal");
        this._element.removeAttribute("role");
        this._isTransitioning = false;
        this._backdrop.hide(()=>{
            document.body.classList.remove($9c6c83c6a450e1f8$var$CLASS_NAME_OPEN);
            this._resetAdjustments();
            this._scrollBar.reset();
            $9c6c83c6a450e1f8$var$EventHandler.trigger(this._element, $9c6c83c6a450e1f8$var$EVENT_HIDDEN$4);
        });
    }
    _isAnimated() {
        return this._element.classList.contains($9c6c83c6a450e1f8$var$CLASS_NAME_FADE$3);
    }
    _triggerBackdropTransition() {
        const hideEvent = $9c6c83c6a450e1f8$var$EventHandler.trigger(this._element, $9c6c83c6a450e1f8$var$EVENT_HIDE_PREVENTED$1);
        if (hideEvent.defaultPrevented) return;
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const initialOverflowY = this._element.style.overflowY;
        // return if the following background transition hasn't yet completed
        if (initialOverflowY === "hidden" || this._element.classList.contains($9c6c83c6a450e1f8$var$CLASS_NAME_STATIC)) return;
        if (!isModalOverflowing) this._element.style.overflowY = "hidden";
        this._element.classList.add($9c6c83c6a450e1f8$var$CLASS_NAME_STATIC);
        this._queueCallback(()=>{
            this._element.classList.remove($9c6c83c6a450e1f8$var$CLASS_NAME_STATIC);
            this._queueCallback(()=>{
                this._element.style.overflowY = initialOverflowY;
            }, this._dialog);
        }, this._dialog);
        this._element.focus();
    }
    /**
   * The following methods are used to handle overflowing modals
   */ _adjustDialog() {
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const scrollbarWidth = this._scrollBar.getWidth();
        const isBodyOverflowing = scrollbarWidth > 0;
        if (isBodyOverflowing && !isModalOverflowing) {
            const property = $9c6c83c6a450e1f8$var$isRTL() ? "paddingLeft" : "paddingRight";
            this._element.style[property] = `${scrollbarWidth}px`;
        }
        if (!isBodyOverflowing && isModalOverflowing) {
            const property = $9c6c83c6a450e1f8$var$isRTL() ? "paddingRight" : "paddingLeft";
            this._element.style[property] = `${scrollbarWidth}px`;
        }
    }
    _resetAdjustments() {
        this._element.style.paddingLeft = "";
        this._element.style.paddingRight = "";
    }
    // Static
    static jQueryInterface(config, relatedTarget) {
        return this.each(function() {
            const data = $9c6c83c6a450e1f8$export$2b77a92f1a5ad772.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config](relatedTarget);
        });
    }
}
/**
 * Data API implementation
 */ $9c6c83c6a450e1f8$var$EventHandler.on(document, $9c6c83c6a450e1f8$var$EVENT_CLICK_DATA_API$2, $9c6c83c6a450e1f8$var$SELECTOR_DATA_TOGGLE$2, function(event) {
    const target = $9c6c83c6a450e1f8$var$SelectorEngine.getElementFromSelector(this);
    if ([
        "A",
        "AREA"
    ].includes(this.tagName)) event.preventDefault();
    $9c6c83c6a450e1f8$var$EventHandler.one(target, $9c6c83c6a450e1f8$var$EVENT_SHOW$4, (showEvent)=>{
        if (showEvent.defaultPrevented) // only register focus restorer if modal will actually get shown
        return;
        $9c6c83c6a450e1f8$var$EventHandler.one(target, $9c6c83c6a450e1f8$var$EVENT_HIDDEN$4, ()=>{
            if ($9c6c83c6a450e1f8$var$isVisible(this)) this.focus();
        });
    });
    // avoid conflict when clicking modal toggler while another one is open
    const alreadyOpen = $9c6c83c6a450e1f8$var$SelectorEngine.findOne($9c6c83c6a450e1f8$var$OPEN_SELECTOR$1);
    if (alreadyOpen) $9c6c83c6a450e1f8$export$2b77a92f1a5ad772.getInstance(alreadyOpen).hide();
    const data = $9c6c83c6a450e1f8$export$2b77a92f1a5ad772.getOrCreateInstance(target);
    data.toggle(this);
});
$9c6c83c6a450e1f8$var$enableDismissTrigger($9c6c83c6a450e1f8$export$2b77a92f1a5ad772);
/**
 * jQuery
 */ $9c6c83c6a450e1f8$var$defineJQueryPlugin($9c6c83c6a450e1f8$export$2b77a92f1a5ad772);
/**
 * --------------------------------------------------------------------------
 * Bootstrap offcanvas.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $9c6c83c6a450e1f8$var$NAME$6 = "offcanvas";
const $9c6c83c6a450e1f8$var$DATA_KEY$3 = "bs.offcanvas";
const $9c6c83c6a450e1f8$var$EVENT_KEY$3 = `.${$9c6c83c6a450e1f8$var$DATA_KEY$3}`;
const $9c6c83c6a450e1f8$var$DATA_API_KEY$1 = ".data-api";
const $9c6c83c6a450e1f8$var$EVENT_LOAD_DATA_API$2 = `load${$9c6c83c6a450e1f8$var$EVENT_KEY$3}${$9c6c83c6a450e1f8$var$DATA_API_KEY$1}`;
const $9c6c83c6a450e1f8$var$ESCAPE_KEY = "Escape";
const $9c6c83c6a450e1f8$var$CLASS_NAME_SHOW$3 = "show";
const $9c6c83c6a450e1f8$var$CLASS_NAME_SHOWING$1 = "showing";
const $9c6c83c6a450e1f8$var$CLASS_NAME_HIDING = "hiding";
const $9c6c83c6a450e1f8$var$CLASS_NAME_BACKDROP = "offcanvas-backdrop";
const $9c6c83c6a450e1f8$var$OPEN_SELECTOR = ".offcanvas.show";
const $9c6c83c6a450e1f8$var$EVENT_SHOW$3 = `show${$9c6c83c6a450e1f8$var$EVENT_KEY$3}`;
const $9c6c83c6a450e1f8$var$EVENT_SHOWN$3 = `shown${$9c6c83c6a450e1f8$var$EVENT_KEY$3}`;
const $9c6c83c6a450e1f8$var$EVENT_HIDE$3 = `hide${$9c6c83c6a450e1f8$var$EVENT_KEY$3}`;
const $9c6c83c6a450e1f8$var$EVENT_HIDE_PREVENTED = `hidePrevented${$9c6c83c6a450e1f8$var$EVENT_KEY$3}`;
const $9c6c83c6a450e1f8$var$EVENT_HIDDEN$3 = `hidden${$9c6c83c6a450e1f8$var$EVENT_KEY$3}`;
const $9c6c83c6a450e1f8$var$EVENT_RESIZE = `resize${$9c6c83c6a450e1f8$var$EVENT_KEY$3}`;
const $9c6c83c6a450e1f8$var$EVENT_CLICK_DATA_API$1 = `click${$9c6c83c6a450e1f8$var$EVENT_KEY$3}${$9c6c83c6a450e1f8$var$DATA_API_KEY$1}`;
const $9c6c83c6a450e1f8$var$EVENT_KEYDOWN_DISMISS = `keydown.dismiss${$9c6c83c6a450e1f8$var$EVENT_KEY$3}`;
const $9c6c83c6a450e1f8$var$SELECTOR_DATA_TOGGLE$1 = '[data-bs-toggle="offcanvas"]';
const $9c6c83c6a450e1f8$var$Default$5 = {
    backdrop: true,
    keyboard: true,
    scroll: false
};
const $9c6c83c6a450e1f8$var$DefaultType$5 = {
    backdrop: "(boolean|string)",
    keyboard: "boolean",
    scroll: "boolean"
};
/**
 * Class definition
 */ class $9c6c83c6a450e1f8$export$591ca0244c9dfcd4 extends $9c6c83c6a450e1f8$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isShown = false;
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $9c6c83c6a450e1f8$var$Default$5;
    }
    static get DefaultType() {
        return $9c6c83c6a450e1f8$var$DefaultType$5;
    }
    static get NAME() {
        return $9c6c83c6a450e1f8$var$NAME$6;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown) return;
        const showEvent = $9c6c83c6a450e1f8$var$EventHandler.trigger(this._element, $9c6c83c6a450e1f8$var$EVENT_SHOW$3, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._backdrop.show();
        if (!this._config.scroll) new $9c6c83c6a450e1f8$var$ScrollBarHelper().hide();
        this._element.setAttribute("aria-modal", true);
        this._element.setAttribute("role", "dialog");
        this._element.classList.add($9c6c83c6a450e1f8$var$CLASS_NAME_SHOWING$1);
        const completeCallBack = ()=>{
            if (!this._config.scroll || this._config.backdrop) this._focustrap.activate();
            this._element.classList.add($9c6c83c6a450e1f8$var$CLASS_NAME_SHOW$3);
            this._element.classList.remove($9c6c83c6a450e1f8$var$CLASS_NAME_SHOWING$1);
            $9c6c83c6a450e1f8$var$EventHandler.trigger(this._element, $9c6c83c6a450e1f8$var$EVENT_SHOWN$3, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(completeCallBack, this._element, true);
    }
    hide() {
        if (!this._isShown) return;
        const hideEvent = $9c6c83c6a450e1f8$var$EventHandler.trigger(this._element, $9c6c83c6a450e1f8$var$EVENT_HIDE$3);
        if (hideEvent.defaultPrevented) return;
        this._focustrap.deactivate();
        this._element.blur();
        this._isShown = false;
        this._element.classList.add($9c6c83c6a450e1f8$var$CLASS_NAME_HIDING);
        this._backdrop.hide();
        const completeCallback = ()=>{
            this._element.classList.remove($9c6c83c6a450e1f8$var$CLASS_NAME_SHOW$3, $9c6c83c6a450e1f8$var$CLASS_NAME_HIDING);
            this._element.removeAttribute("aria-modal");
            this._element.removeAttribute("role");
            if (!this._config.scroll) new $9c6c83c6a450e1f8$var$ScrollBarHelper().reset();
            $9c6c83c6a450e1f8$var$EventHandler.trigger(this._element, $9c6c83c6a450e1f8$var$EVENT_HIDDEN$3);
        };
        this._queueCallback(completeCallback, this._element, true);
    }
    dispose() {
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    // Private
    _initializeBackDrop() {
        const clickCallback = ()=>{
            if (this._config.backdrop === "static") {
                $9c6c83c6a450e1f8$var$EventHandler.trigger(this._element, $9c6c83c6a450e1f8$var$EVENT_HIDE_PREVENTED);
                return;
            }
            this.hide();
        };
        // 'static' option will be translated to true, and booleans will keep their value
        const isVisible = Boolean(this._config.backdrop);
        return new $9c6c83c6a450e1f8$var$Backdrop({
            className: $9c6c83c6a450e1f8$var$CLASS_NAME_BACKDROP,
            isVisible: isVisible,
            isAnimated: true,
            rootElement: this._element.parentNode,
            clickCallback: isVisible ? clickCallback : null
        });
    }
    _initializeFocusTrap() {
        return new $9c6c83c6a450e1f8$var$FocusTrap({
            trapElement: this._element
        });
    }
    _addEventListeners() {
        $9c6c83c6a450e1f8$var$EventHandler.on(this._element, $9c6c83c6a450e1f8$var$EVENT_KEYDOWN_DISMISS, (event)=>{
            if (event.key !== $9c6c83c6a450e1f8$var$ESCAPE_KEY) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            $9c6c83c6a450e1f8$var$EventHandler.trigger(this._element, $9c6c83c6a450e1f8$var$EVENT_HIDE_PREVENTED);
        });
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $9c6c83c6a450e1f8$export$591ca0244c9dfcd4.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $9c6c83c6a450e1f8$var$EventHandler.on(document, $9c6c83c6a450e1f8$var$EVENT_CLICK_DATA_API$1, $9c6c83c6a450e1f8$var$SELECTOR_DATA_TOGGLE$1, function(event) {
    const target = $9c6c83c6a450e1f8$var$SelectorEngine.getElementFromSelector(this);
    if ([
        "A",
        "AREA"
    ].includes(this.tagName)) event.preventDefault();
    if ($9c6c83c6a450e1f8$var$isDisabled(this)) return;
    $9c6c83c6a450e1f8$var$EventHandler.one(target, $9c6c83c6a450e1f8$var$EVENT_HIDDEN$3, ()=>{
        // focus on trigger when it is closed
        if ($9c6c83c6a450e1f8$var$isVisible(this)) this.focus();
    });
    // avoid conflict when clicking a toggler of an offcanvas, while another is open
    const alreadyOpen = $9c6c83c6a450e1f8$var$SelectorEngine.findOne($9c6c83c6a450e1f8$var$OPEN_SELECTOR);
    if (alreadyOpen && alreadyOpen !== target) $9c6c83c6a450e1f8$export$591ca0244c9dfcd4.getInstance(alreadyOpen).hide();
    const data = $9c6c83c6a450e1f8$export$591ca0244c9dfcd4.getOrCreateInstance(target);
    data.toggle(this);
});
$9c6c83c6a450e1f8$var$EventHandler.on(window, $9c6c83c6a450e1f8$var$EVENT_LOAD_DATA_API$2, ()=>{
    for (const selector of $9c6c83c6a450e1f8$var$SelectorEngine.find($9c6c83c6a450e1f8$var$OPEN_SELECTOR))$9c6c83c6a450e1f8$export$591ca0244c9dfcd4.getOrCreateInstance(selector).show();
});
$9c6c83c6a450e1f8$var$EventHandler.on(window, $9c6c83c6a450e1f8$var$EVENT_RESIZE, ()=>{
    for (const element of $9c6c83c6a450e1f8$var$SelectorEngine.find("[aria-modal][class*=show][class*=offcanvas-]"))if (getComputedStyle(element).position !== "fixed") $9c6c83c6a450e1f8$export$591ca0244c9dfcd4.getOrCreateInstance(element).hide();
});
$9c6c83c6a450e1f8$var$enableDismissTrigger($9c6c83c6a450e1f8$export$591ca0244c9dfcd4);
/**
 * jQuery
 */ $9c6c83c6a450e1f8$var$defineJQueryPlugin($9c6c83c6a450e1f8$export$591ca0244c9dfcd4);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/sanitizer.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ // js-docs-start allow-list
const $9c6c83c6a450e1f8$var$ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
const $9c6c83c6a450e1f8$var$DefaultAllowlist = {
    // Global attributes allowed on any supplied element below.
    "*": [
        "class",
        "dir",
        "id",
        "lang",
        "role",
        $9c6c83c6a450e1f8$var$ARIA_ATTRIBUTE_PATTERN
    ],
    a: [
        "target",
        "href",
        "title",
        "rel"
    ],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    dd: [],
    div: [],
    dl: [],
    dt: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: [
        "src",
        "srcset",
        "alt",
        "title",
        "width",
        "height"
    ],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
};
// js-docs-end allow-list
const $9c6c83c6a450e1f8$var$uriAttributes = new Set([
    "background",
    "cite",
    "href",
    "itemtype",
    "longdesc",
    "poster",
    "src",
    "xlink:href"
]);
/**
 * A pattern that recognizes URLs that are safe wrt. XSS in URL navigation
 * contexts.
 *
 * Shout-out to Angular https://github.com/angular/angular/blob/15.2.8/packages/core/src/sanitization/url_sanitizer.ts#L38
 */ // eslint-disable-next-line unicorn/better-regex
const $9c6c83c6a450e1f8$var$SAFE_URL_PATTERN = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i;
const $9c6c83c6a450e1f8$var$allowedAttribute = (attribute, allowedAttributeList)=>{
    const attributeName = attribute.nodeName.toLowerCase();
    if (allowedAttributeList.includes(attributeName)) {
        if ($9c6c83c6a450e1f8$var$uriAttributes.has(attributeName)) return Boolean($9c6c83c6a450e1f8$var$SAFE_URL_PATTERN.test(attribute.nodeValue));
        return true;
    }
    // Check if a regular expression validates the attribute.
    return allowedAttributeList.filter((attributeRegex)=>attributeRegex instanceof RegExp).some((regex)=>regex.test(attributeName));
};
function $9c6c83c6a450e1f8$var$sanitizeHtml(unsafeHtml, allowList, sanitizeFunction) {
    if (!unsafeHtml.length) return unsafeHtml;
    if (sanitizeFunction && typeof sanitizeFunction === "function") return sanitizeFunction(unsafeHtml);
    const domParser = new window.DOMParser();
    const createdDocument = domParser.parseFromString(unsafeHtml, "text/html");
    const elements = [].concat(...createdDocument.body.querySelectorAll("*"));
    for (const element of elements){
        const elementName = element.nodeName.toLowerCase();
        if (!Object.keys(allowList).includes(elementName)) {
            element.remove();
            continue;
        }
        const attributeList = [].concat(...element.attributes);
        const allowedAttributes = [].concat(allowList["*"] || [], allowList[elementName] || []);
        for (const attribute of attributeList)if (!$9c6c83c6a450e1f8$var$allowedAttribute(attribute, allowedAttributes)) element.removeAttribute(attribute.nodeName);
    }
    return createdDocument.body.innerHTML;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/template-factory.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $9c6c83c6a450e1f8$var$NAME$5 = "TemplateFactory";
const $9c6c83c6a450e1f8$var$Default$4 = {
    allowList: $9c6c83c6a450e1f8$var$DefaultAllowlist,
    content: {},
    // { selector : text ,  selector2 : text2 , }
    extraClass: "",
    html: false,
    sanitize: true,
    sanitizeFn: null,
    template: "<div></div>"
};
const $9c6c83c6a450e1f8$var$DefaultType$4 = {
    allowList: "object",
    content: "object",
    extraClass: "(string|function)",
    html: "boolean",
    sanitize: "boolean",
    sanitizeFn: "(null|function)",
    template: "string"
};
const $9c6c83c6a450e1f8$var$DefaultContentType = {
    entry: "(string|element|function|null)",
    selector: "(string|element)"
};
/**
 * Class definition
 */ class $9c6c83c6a450e1f8$var$TemplateFactory extends $9c6c83c6a450e1f8$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
    }
    // Getters
    static get Default() {
        return $9c6c83c6a450e1f8$var$Default$4;
    }
    static get DefaultType() {
        return $9c6c83c6a450e1f8$var$DefaultType$4;
    }
    static get NAME() {
        return $9c6c83c6a450e1f8$var$NAME$5;
    }
    // Public
    getContent() {
        return Object.values(this._config.content).map((config)=>this._resolvePossibleFunction(config)).filter(Boolean);
    }
    hasContent() {
        return this.getContent().length > 0;
    }
    changeContent(content) {
        this._checkContent(content);
        this._config.content = {
            ...this._config.content,
            ...content
        };
        return this;
    }
    toHtml() {
        const templateWrapper = document.createElement("div");
        templateWrapper.innerHTML = this._maybeSanitize(this._config.template);
        for (const [selector, text] of Object.entries(this._config.content))this._setContent(templateWrapper, text, selector);
        const template = templateWrapper.children[0];
        const extraClass = this._resolvePossibleFunction(this._config.extraClass);
        if (extraClass) template.classList.add(...extraClass.split(" "));
        return template;
    }
    // Private
    _typeCheckConfig(config) {
        super._typeCheckConfig(config);
        this._checkContent(config.content);
    }
    _checkContent(arg) {
        for (const [selector, content] of Object.entries(arg))super._typeCheckConfig({
            selector: selector,
            entry: content
        }, $9c6c83c6a450e1f8$var$DefaultContentType);
    }
    _setContent(template, content, selector) {
        const templateElement = $9c6c83c6a450e1f8$var$SelectorEngine.findOne(selector, template);
        if (!templateElement) return;
        content = this._resolvePossibleFunction(content);
        if (!content) {
            templateElement.remove();
            return;
        }
        if ($9c6c83c6a450e1f8$var$isElement(content)) {
            this._putElementInTemplate($9c6c83c6a450e1f8$var$getElement(content), templateElement);
            return;
        }
        if (this._config.html) {
            templateElement.innerHTML = this._maybeSanitize(content);
            return;
        }
        templateElement.textContent = content;
    }
    _maybeSanitize(arg) {
        return this._config.sanitize ? $9c6c83c6a450e1f8$var$sanitizeHtml(arg, this._config.allowList, this._config.sanitizeFn) : arg;
    }
    _resolvePossibleFunction(arg) {
        return $9c6c83c6a450e1f8$var$execute(arg, [
            this
        ]);
    }
    _putElementInTemplate(element, templateElement) {
        if (this._config.html) {
            templateElement.innerHTML = "";
            templateElement.append(element);
            return;
        }
        templateElement.textContent = element.textContent;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap tooltip.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $9c6c83c6a450e1f8$var$NAME$4 = "tooltip";
const $9c6c83c6a450e1f8$var$DISALLOWED_ATTRIBUTES = new Set([
    "sanitize",
    "allowList",
    "sanitizeFn"
]);
const $9c6c83c6a450e1f8$var$CLASS_NAME_FADE$2 = "fade";
const $9c6c83c6a450e1f8$var$CLASS_NAME_MODAL = "modal";
const $9c6c83c6a450e1f8$var$CLASS_NAME_SHOW$2 = "show";
const $9c6c83c6a450e1f8$var$SELECTOR_TOOLTIP_INNER = ".tooltip-inner";
const $9c6c83c6a450e1f8$var$SELECTOR_MODAL = `.${$9c6c83c6a450e1f8$var$CLASS_NAME_MODAL}`;
const $9c6c83c6a450e1f8$var$EVENT_MODAL_HIDE = "hide.bs.modal";
const $9c6c83c6a450e1f8$var$TRIGGER_HOVER = "hover";
const $9c6c83c6a450e1f8$var$TRIGGER_FOCUS = "focus";
const $9c6c83c6a450e1f8$var$TRIGGER_CLICK = "click";
const $9c6c83c6a450e1f8$var$TRIGGER_MANUAL = "manual";
const $9c6c83c6a450e1f8$var$EVENT_HIDE$2 = "hide";
const $9c6c83c6a450e1f8$var$EVENT_HIDDEN$2 = "hidden";
const $9c6c83c6a450e1f8$var$EVENT_SHOW$2 = "show";
const $9c6c83c6a450e1f8$var$EVENT_SHOWN$2 = "shown";
const $9c6c83c6a450e1f8$var$EVENT_INSERTED = "inserted";
const $9c6c83c6a450e1f8$var$EVENT_CLICK$1 = "click";
const $9c6c83c6a450e1f8$var$EVENT_FOCUSIN$1 = "focusin";
const $9c6c83c6a450e1f8$var$EVENT_FOCUSOUT$1 = "focusout";
const $9c6c83c6a450e1f8$var$EVENT_MOUSEENTER = "mouseenter";
const $9c6c83c6a450e1f8$var$EVENT_MOUSELEAVE = "mouseleave";
const $9c6c83c6a450e1f8$var$AttachmentMap = {
    AUTO: "auto",
    TOP: "top",
    RIGHT: $9c6c83c6a450e1f8$var$isRTL() ? "left" : "right",
    BOTTOM: "bottom",
    LEFT: $9c6c83c6a450e1f8$var$isRTL() ? "right" : "left"
};
const $9c6c83c6a450e1f8$var$Default$3 = {
    allowList: $9c6c83c6a450e1f8$var$DefaultAllowlist,
    animation: true,
    boundary: "clippingParents",
    container: false,
    customClass: "",
    delay: 0,
    fallbackPlacements: [
        "top",
        "right",
        "bottom",
        "left"
    ],
    html: false,
    offset: [
        0,
        6
    ],
    placement: "top",
    popperConfig: null,
    sanitize: true,
    sanitizeFn: null,
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    title: "",
    trigger: "hover focus"
};
const $9c6c83c6a450e1f8$var$DefaultType$3 = {
    allowList: "object",
    animation: "boolean",
    boundary: "(string|element)",
    container: "(string|element|boolean)",
    customClass: "(string|function)",
    delay: "(number|object)",
    fallbackPlacements: "array",
    html: "boolean",
    offset: "(array|string|function)",
    placement: "(string|function)",
    popperConfig: "(null|object|function)",
    sanitize: "boolean",
    sanitizeFn: "(null|function)",
    selector: "(string|boolean)",
    template: "string",
    title: "(string|element|function)",
    trigger: "string"
};
/**
 * Class definition
 */ class $9c6c83c6a450e1f8$export$28c660c63b792dea extends $9c6c83c6a450e1f8$var$BaseComponent {
    constructor(element, config){
        if (typeof $e2544cfeed0c9093$exports === "undefined") throw new TypeError("Bootstrap's tooltips require Popper (https://popper.js.org)");
        super(element, config);
        // Private
        this._isEnabled = true;
        this._timeout = 0;
        this._isHovered = null;
        this._activeTrigger = {};
        this._popper = null;
        this._templateFactory = null;
        this._newContent = null;
        // Protected
        this.tip = null;
        this._setListeners();
        if (!this._config.selector) this._fixTitle();
    }
    // Getters
    static get Default() {
        return $9c6c83c6a450e1f8$var$Default$3;
    }
    static get DefaultType() {
        return $9c6c83c6a450e1f8$var$DefaultType$3;
    }
    static get NAME() {
        return $9c6c83c6a450e1f8$var$NAME$4;
    }
    // Public
    enable() {
        this._isEnabled = true;
    }
    disable() {
        this._isEnabled = false;
    }
    toggleEnabled() {
        this._isEnabled = !this._isEnabled;
    }
    toggle() {
        if (!this._isEnabled) return;
        this._activeTrigger.click = !this._activeTrigger.click;
        if (this._isShown()) {
            this._leave();
            return;
        }
        this._enter();
    }
    dispose() {
        clearTimeout(this._timeout);
        $9c6c83c6a450e1f8$var$EventHandler.off(this._element.closest($9c6c83c6a450e1f8$var$SELECTOR_MODAL), $9c6c83c6a450e1f8$var$EVENT_MODAL_HIDE, this._hideModalHandler);
        if (this._element.getAttribute("data-bs-original-title")) this._element.setAttribute("title", this._element.getAttribute("data-bs-original-title"));
        this._disposePopper();
        super.dispose();
    }
    show() {
        if (this._element.style.display === "none") throw new Error("Please use show on visible elements");
        if (!(this._isWithContent() && this._isEnabled)) return;
        const showEvent = $9c6c83c6a450e1f8$var$EventHandler.trigger(this._element, this.constructor.eventName($9c6c83c6a450e1f8$var$EVENT_SHOW$2));
        const shadowRoot = $9c6c83c6a450e1f8$var$findShadowRoot(this._element);
        const isInTheDom = (shadowRoot || this._element.ownerDocument.documentElement).contains(this._element);
        if (showEvent.defaultPrevented || !isInTheDom) return;
        // TODO: v6 remove this or make it optional
        this._disposePopper();
        const tip = this._getTipElement();
        this._element.setAttribute("aria-describedby", tip.getAttribute("id"));
        const { container: container } = this._config;
        if (!this._element.ownerDocument.documentElement.contains(this.tip)) {
            container.append(tip);
            $9c6c83c6a450e1f8$var$EventHandler.trigger(this._element, this.constructor.eventName($9c6c83c6a450e1f8$var$EVENT_INSERTED));
        }
        this._popper = this._createPopper(tip);
        tip.classList.add($9c6c83c6a450e1f8$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ("ontouchstart" in document.documentElement) for (const element of [].concat(...document.body.children))$9c6c83c6a450e1f8$var$EventHandler.on(element, "mouseover", $9c6c83c6a450e1f8$var$noop);
        const complete = ()=>{
            $9c6c83c6a450e1f8$var$EventHandler.trigger(this._element, this.constructor.eventName($9c6c83c6a450e1f8$var$EVENT_SHOWN$2));
            if (this._isHovered === false) this._leave();
            this._isHovered = false;
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    hide() {
        if (!this._isShown()) return;
        const hideEvent = $9c6c83c6a450e1f8$var$EventHandler.trigger(this._element, this.constructor.eventName($9c6c83c6a450e1f8$var$EVENT_HIDE$2));
        if (hideEvent.defaultPrevented) return;
        const tip = this._getTipElement();
        tip.classList.remove($9c6c83c6a450e1f8$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ("ontouchstart" in document.documentElement) for (const element of [].concat(...document.body.children))$9c6c83c6a450e1f8$var$EventHandler.off(element, "mouseover", $9c6c83c6a450e1f8$var$noop);
        this._activeTrigger[$9c6c83c6a450e1f8$var$TRIGGER_CLICK] = false;
        this._activeTrigger[$9c6c83c6a450e1f8$var$TRIGGER_FOCUS] = false;
        this._activeTrigger[$9c6c83c6a450e1f8$var$TRIGGER_HOVER] = false;
        this._isHovered = null; // it is a trick to support manual triggering
        const complete = ()=>{
            if (this._isWithActiveTrigger()) return;
            if (!this._isHovered) this._disposePopper();
            this._element.removeAttribute("aria-describedby");
            $9c6c83c6a450e1f8$var$EventHandler.trigger(this._element, this.constructor.eventName($9c6c83c6a450e1f8$var$EVENT_HIDDEN$2));
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    update() {
        if (this._popper) this._popper.update();
    }
    // Protected
    _isWithContent() {
        return Boolean(this._getTitle());
    }
    _getTipElement() {
        if (!this.tip) this.tip = this._createTipElement(this._newContent || this._getContentForTemplate());
        return this.tip;
    }
    _createTipElement(content) {
        const tip = this._getTemplateFactory(content).toHtml();
        // TODO: remove this check in v6
        if (!tip) return null;
        tip.classList.remove($9c6c83c6a450e1f8$var$CLASS_NAME_FADE$2, $9c6c83c6a450e1f8$var$CLASS_NAME_SHOW$2);
        // TODO: v6 the following can be achieved with CSS only
        tip.classList.add(`bs-${this.constructor.NAME}-auto`);
        const tipId = $9c6c83c6a450e1f8$var$getUID(this.constructor.NAME).toString();
        tip.setAttribute("id", tipId);
        if (this._isAnimated()) tip.classList.add($9c6c83c6a450e1f8$var$CLASS_NAME_FADE$2);
        return tip;
    }
    setContent(content) {
        this._newContent = content;
        if (this._isShown()) {
            this._disposePopper();
            this.show();
        }
    }
    _getTemplateFactory(content) {
        if (this._templateFactory) this._templateFactory.changeContent(content);
        else this._templateFactory = new $9c6c83c6a450e1f8$var$TemplateFactory({
            ...this._config,
            content: // the `content` var has to be after `this._config`
            // to override config.content in case of popover
            content,
            extraClass: this._resolvePossibleFunction(this._config.customClass)
        });
        return this._templateFactory;
    }
    _getContentForTemplate() {
        return {
            [$9c6c83c6a450e1f8$var$SELECTOR_TOOLTIP_INNER]: this._getTitle()
        };
    }
    _getTitle() {
        return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute("data-bs-original-title");
    }
    // Private
    _initializeOnDelegatedTarget(event) {
        return this.constructor.getOrCreateInstance(event.delegateTarget, this._getDelegateConfig());
    }
    _isAnimated() {
        return this._config.animation || this.tip && this.tip.classList.contains($9c6c83c6a450e1f8$var$CLASS_NAME_FADE$2);
    }
    _isShown() {
        return this.tip && this.tip.classList.contains($9c6c83c6a450e1f8$var$CLASS_NAME_SHOW$2);
    }
    _createPopper(tip) {
        const placement = $9c6c83c6a450e1f8$var$execute(this._config.placement, [
            this,
            tip,
            this._element
        ]);
        const attachment = $9c6c83c6a450e1f8$var$AttachmentMap[placement.toUpperCase()];
        return $e2544cfeed0c9093$exports.createPopper(this._element, tip, this._getPopperConfig(attachment));
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === "string") return offset.split(",").map((value)=>Number.parseInt(value, 10));
        if (typeof offset === "function") return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _resolvePossibleFunction(arg) {
        return $9c6c83c6a450e1f8$var$execute(arg, [
            this._element
        ]);
    }
    _getPopperConfig(attachment) {
        const defaultBsPopperConfig = {
            placement: attachment,
            modifiers: [
                {
                    name: "flip",
                    options: {
                        fallbackPlacements: this._config.fallbackPlacements
                    }
                },
                {
                    name: "offset",
                    options: {
                        offset: this._getOffset()
                    }
                },
                {
                    name: "preventOverflow",
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: "arrow",
                    options: {
                        element: `.${this.constructor.NAME}-arrow`
                    }
                },
                {
                    name: "preSetPlacement",
                    enabled: true,
                    phase: "beforeMain",
                    fn: (data)=>{
                        // Pre-set Popper's placement attribute in order to read the arrow sizes properly.
                        // Otherwise, Popper mixes up the width and height dimensions since the initial arrow style is for top placement
                        this._getTipElement().setAttribute("data-popper-placement", data.state.placement);
                    }
                }
            ]
        };
        return {
            ...defaultBsPopperConfig,
            ...$9c6c83c6a450e1f8$var$execute(this._config.popperConfig, [
                defaultBsPopperConfig
            ])
        };
    }
    _setListeners() {
        const triggers = this._config.trigger.split(" ");
        for (const trigger of triggers){
            if (trigger === "click") $9c6c83c6a450e1f8$var$EventHandler.on(this._element, this.constructor.eventName($9c6c83c6a450e1f8$var$EVENT_CLICK$1), this._config.selector, (event)=>{
                const context = this._initializeOnDelegatedTarget(event);
                context.toggle();
            });
            else if (trigger !== $9c6c83c6a450e1f8$var$TRIGGER_MANUAL) {
                const eventIn = trigger === $9c6c83c6a450e1f8$var$TRIGGER_HOVER ? this.constructor.eventName($9c6c83c6a450e1f8$var$EVENT_MOUSEENTER) : this.constructor.eventName($9c6c83c6a450e1f8$var$EVENT_FOCUSIN$1);
                const eventOut = trigger === $9c6c83c6a450e1f8$var$TRIGGER_HOVER ? this.constructor.eventName($9c6c83c6a450e1f8$var$EVENT_MOUSELEAVE) : this.constructor.eventName($9c6c83c6a450e1f8$var$EVENT_FOCUSOUT$1);
                $9c6c83c6a450e1f8$var$EventHandler.on(this._element, eventIn, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === "focusin" ? $9c6c83c6a450e1f8$var$TRIGGER_FOCUS : $9c6c83c6a450e1f8$var$TRIGGER_HOVER] = true;
                    context._enter();
                });
                $9c6c83c6a450e1f8$var$EventHandler.on(this._element, eventOut, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === "focusout" ? $9c6c83c6a450e1f8$var$TRIGGER_FOCUS : $9c6c83c6a450e1f8$var$TRIGGER_HOVER] = context._element.contains(event.relatedTarget);
                    context._leave();
                });
            }
        }
        this._hideModalHandler = ()=>{
            if (this._element) this.hide();
        };
        $9c6c83c6a450e1f8$var$EventHandler.on(this._element.closest($9c6c83c6a450e1f8$var$SELECTOR_MODAL), $9c6c83c6a450e1f8$var$EVENT_MODAL_HIDE, this._hideModalHandler);
    }
    _fixTitle() {
        const title = this._element.getAttribute("title");
        if (!title) return;
        if (!this._element.getAttribute("aria-label") && !this._element.textContent.trim()) this._element.setAttribute("aria-label", title);
        this._element.setAttribute("data-bs-original-title", title); // DO NOT USE IT. Is only for backwards compatibility
        this._element.removeAttribute("title");
    }
    _enter() {
        if (this._isShown() || this._isHovered) {
            this._isHovered = true;
            return;
        }
        this._isHovered = true;
        this._setTimeout(()=>{
            if (this._isHovered) this.show();
        }, this._config.delay.show);
    }
    _leave() {
        if (this._isWithActiveTrigger()) return;
        this._isHovered = false;
        this._setTimeout(()=>{
            if (!this._isHovered) this.hide();
        }, this._config.delay.hide);
    }
    _setTimeout(handler, timeout) {
        clearTimeout(this._timeout);
        this._timeout = setTimeout(handler, timeout);
    }
    _isWithActiveTrigger() {
        return Object.values(this._activeTrigger).includes(true);
    }
    _getConfig(config) {
        const dataAttributes = $9c6c83c6a450e1f8$var$Manipulator.getDataAttributes(this._element);
        for (const dataAttribute of Object.keys(dataAttributes))if ($9c6c83c6a450e1f8$var$DISALLOWED_ATTRIBUTES.has(dataAttribute)) delete dataAttributes[dataAttribute];
        config = {
            ...dataAttributes,
            ...typeof config === "object" && config ? config : {}
        };
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        config.container = config.container === false ? document.body : $9c6c83c6a450e1f8$var$getElement(config.container);
        if (typeof config.delay === "number") config.delay = {
            show: config.delay,
            hide: config.delay
        };
        if (typeof config.title === "number") config.title = config.title.toString();
        if (typeof config.content === "number") config.content = config.content.toString();
        return config;
    }
    _getDelegateConfig() {
        const config = {};
        for (const [key, value] of Object.entries(this._config))if (this.constructor.Default[key] !== value) config[key] = value;
        config.selector = false;
        config.trigger = "manual";
        // In the future can be replaced with:
        // const keysWithDifferentValues = Object.entries(this._config).filter(entry => this.constructor.Default[entry[0]] !== this._config[entry[0]])
        // `Object.fromEntries(keysWithDifferentValues)`
        return config;
    }
    _disposePopper() {
        if (this._popper) {
            this._popper.destroy();
            this._popper = null;
        }
        if (this.tip) {
            this.tip.remove();
            this.tip = null;
        }
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $9c6c83c6a450e1f8$export$28c660c63b792dea.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $9c6c83c6a450e1f8$var$defineJQueryPlugin($9c6c83c6a450e1f8$export$28c660c63b792dea);
/**
 * --------------------------------------------------------------------------
 * Bootstrap popover.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $9c6c83c6a450e1f8$var$NAME$3 = "popover";
const $9c6c83c6a450e1f8$var$SELECTOR_TITLE = ".popover-header";
const $9c6c83c6a450e1f8$var$SELECTOR_CONTENT = ".popover-body";
const $9c6c83c6a450e1f8$var$Default$2 = {
    ...$9c6c83c6a450e1f8$export$28c660c63b792dea.Default,
    content: "",
    offset: [
        0,
        8
    ],
    placement: "right",
    template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
    trigger: "click"
};
const $9c6c83c6a450e1f8$var$DefaultType$2 = {
    ...$9c6c83c6a450e1f8$export$28c660c63b792dea.DefaultType,
    content: "(null|string|element|function)"
};
/**
 * Class definition
 */ class $9c6c83c6a450e1f8$export$5b6b19405a83ff9d extends $9c6c83c6a450e1f8$export$28c660c63b792dea {
    // Getters
    static get Default() {
        return $9c6c83c6a450e1f8$var$Default$2;
    }
    static get DefaultType() {
        return $9c6c83c6a450e1f8$var$DefaultType$2;
    }
    static get NAME() {
        return $9c6c83c6a450e1f8$var$NAME$3;
    }
    // Overrides
    _isWithContent() {
        return this._getTitle() || this._getContent();
    }
    // Private
    _getContentForTemplate() {
        return {
            [$9c6c83c6a450e1f8$var$SELECTOR_TITLE]: this._getTitle(),
            [$9c6c83c6a450e1f8$var$SELECTOR_CONTENT]: this._getContent()
        };
    }
    _getContent() {
        return this._resolvePossibleFunction(this._config.content);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $9c6c83c6a450e1f8$export$5b6b19405a83ff9d.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $9c6c83c6a450e1f8$var$defineJQueryPlugin($9c6c83c6a450e1f8$export$5b6b19405a83ff9d);
/**
 * --------------------------------------------------------------------------
 * Bootstrap scrollspy.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $9c6c83c6a450e1f8$var$NAME$2 = "scrollspy";
const $9c6c83c6a450e1f8$var$DATA_KEY$2 = "bs.scrollspy";
const $9c6c83c6a450e1f8$var$EVENT_KEY$2 = `.${$9c6c83c6a450e1f8$var$DATA_KEY$2}`;
const $9c6c83c6a450e1f8$var$DATA_API_KEY = ".data-api";
const $9c6c83c6a450e1f8$var$EVENT_ACTIVATE = `activate${$9c6c83c6a450e1f8$var$EVENT_KEY$2}`;
const $9c6c83c6a450e1f8$var$EVENT_CLICK = `click${$9c6c83c6a450e1f8$var$EVENT_KEY$2}`;
const $9c6c83c6a450e1f8$var$EVENT_LOAD_DATA_API$1 = `load${$9c6c83c6a450e1f8$var$EVENT_KEY$2}${$9c6c83c6a450e1f8$var$DATA_API_KEY}`;
const $9c6c83c6a450e1f8$var$CLASS_NAME_DROPDOWN_ITEM = "dropdown-item";
const $9c6c83c6a450e1f8$var$CLASS_NAME_ACTIVE$1 = "active";
const $9c6c83c6a450e1f8$var$SELECTOR_DATA_SPY = '[data-bs-spy="scroll"]';
const $9c6c83c6a450e1f8$var$SELECTOR_TARGET_LINKS = "[href]";
const $9c6c83c6a450e1f8$var$SELECTOR_NAV_LIST_GROUP = ".nav, .list-group";
const $9c6c83c6a450e1f8$var$SELECTOR_NAV_LINKS = ".nav-link";
const $9c6c83c6a450e1f8$var$SELECTOR_NAV_ITEMS = ".nav-item";
const $9c6c83c6a450e1f8$var$SELECTOR_LIST_ITEMS = ".list-group-item";
const $9c6c83c6a450e1f8$var$SELECTOR_LINK_ITEMS = `${$9c6c83c6a450e1f8$var$SELECTOR_NAV_LINKS}, ${$9c6c83c6a450e1f8$var$SELECTOR_NAV_ITEMS} > ${$9c6c83c6a450e1f8$var$SELECTOR_NAV_LINKS}, ${$9c6c83c6a450e1f8$var$SELECTOR_LIST_ITEMS}`;
const $9c6c83c6a450e1f8$var$SELECTOR_DROPDOWN = ".dropdown";
const $9c6c83c6a450e1f8$var$SELECTOR_DROPDOWN_TOGGLE$1 = ".dropdown-toggle";
const $9c6c83c6a450e1f8$var$Default$1 = {
    offset: null,
    // TODO: v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: "0px 0px -25%",
    smoothScroll: false,
    target: null,
    threshold: [
        0.1,
        0.5,
        1
    ]
};
const $9c6c83c6a450e1f8$var$DefaultType$1 = {
    offset: "(number|null)",
    // TODO v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: "string",
    smoothScroll: "boolean",
    target: "element",
    threshold: "array"
};
/**
 * Class definition
 */ class $9c6c83c6a450e1f8$export$a6472a5298a374be extends $9c6c83c6a450e1f8$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        // this._element is the observablesContainer and config.target the menu links wrapper
        this._targetLinks = new Map();
        this._observableSections = new Map();
        this._rootElement = getComputedStyle(this._element).overflowY === "visible" ? null : this._element;
        this._activeTarget = null;
        this._observer = null;
        this._previousScrollData = {
            visibleEntryTop: 0,
            parentScrollTop: 0
        };
        this.refresh(); // initialize
    }
    // Getters
    static get Default() {
        return $9c6c83c6a450e1f8$var$Default$1;
    }
    static get DefaultType() {
        return $9c6c83c6a450e1f8$var$DefaultType$1;
    }
    static get NAME() {
        return $9c6c83c6a450e1f8$var$NAME$2;
    }
    // Public
    refresh() {
        this._initializeTargetsAndObservables();
        this._maybeEnableSmoothScroll();
        if (this._observer) this._observer.disconnect();
        else this._observer = this._getNewObserver();
        for (const section of this._observableSections.values())this._observer.observe(section);
    }
    dispose() {
        this._observer.disconnect();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        // TODO: on v6 target should be given explicitly & remove the {target: 'ss-target'} case
        config.target = $9c6c83c6a450e1f8$var$getElement(config.target) || document.body;
        // TODO: v6 Only for backwards compatibility reasons. Use rootMargin only
        config.rootMargin = config.offset ? `${config.offset}px 0px -30%` : config.rootMargin;
        if (typeof config.threshold === "string") config.threshold = config.threshold.split(",").map((value)=>Number.parseFloat(value));
        return config;
    }
    _maybeEnableSmoothScroll() {
        if (!this._config.smoothScroll) return;
        // unregister any previous listeners
        $9c6c83c6a450e1f8$var$EventHandler.off(this._config.target, $9c6c83c6a450e1f8$var$EVENT_CLICK);
        $9c6c83c6a450e1f8$var$EventHandler.on(this._config.target, $9c6c83c6a450e1f8$var$EVENT_CLICK, $9c6c83c6a450e1f8$var$SELECTOR_TARGET_LINKS, (event)=>{
            const observableSection = this._observableSections.get(event.target.hash);
            if (observableSection) {
                event.preventDefault();
                const root = this._rootElement || window;
                const height = observableSection.offsetTop - this._element.offsetTop;
                if (root.scrollTo) {
                    root.scrollTo({
                        top: height,
                        behavior: "smooth"
                    });
                    return;
                }
                // Chrome 60 doesn't support `scrollTo`
                root.scrollTop = height;
            }
        });
    }
    _getNewObserver() {
        const options = {
            root: this._rootElement,
            threshold: this._config.threshold,
            rootMargin: this._config.rootMargin
        };
        return new IntersectionObserver((entries)=>this._observerCallback(entries), options);
    }
    // The logic of selection
    _observerCallback(entries) {
        const targetElement = (entry)=>this._targetLinks.get(`#${entry.target.id}`);
        const activate = (entry)=>{
            this._previousScrollData.visibleEntryTop = entry.target.offsetTop;
            this._process(targetElement(entry));
        };
        const parentScrollTop = (this._rootElement || document.documentElement).scrollTop;
        const userScrollsDown = parentScrollTop >= this._previousScrollData.parentScrollTop;
        this._previousScrollData.parentScrollTop = parentScrollTop;
        for (const entry of entries){
            if (!entry.isIntersecting) {
                this._activeTarget = null;
                this._clearActiveClass(targetElement(entry));
                continue;
            }
            const entryIsLowerThanPrevious = entry.target.offsetTop >= this._previousScrollData.visibleEntryTop;
            // if we are scrolling down, pick the bigger offsetTop
            if (userScrollsDown && entryIsLowerThanPrevious) {
                activate(entry);
                // if parent isn't scrolled, let's keep the first visible item, breaking the iteration
                if (!parentScrollTop) return;
                continue;
            }
            // if we are scrolling up, pick the smallest offsetTop
            if (!userScrollsDown && !entryIsLowerThanPrevious) activate(entry);
        }
    }
    _initializeTargetsAndObservables() {
        this._targetLinks = new Map();
        this._observableSections = new Map();
        const targetLinks = $9c6c83c6a450e1f8$var$SelectorEngine.find($9c6c83c6a450e1f8$var$SELECTOR_TARGET_LINKS, this._config.target);
        for (const anchor of targetLinks){
            // ensure that the anchor has an id and is not disabled
            if (!anchor.hash || $9c6c83c6a450e1f8$var$isDisabled(anchor)) continue;
            const observableSection = $9c6c83c6a450e1f8$var$SelectorEngine.findOne(decodeURI(anchor.hash), this._element);
            // ensure that the observableSection exists & is visible
            if ($9c6c83c6a450e1f8$var$isVisible(observableSection)) {
                this._targetLinks.set(decodeURI(anchor.hash), anchor);
                this._observableSections.set(anchor.hash, observableSection);
            }
        }
    }
    _process(target) {
        if (this._activeTarget === target) return;
        this._clearActiveClass(this._config.target);
        this._activeTarget = target;
        target.classList.add($9c6c83c6a450e1f8$var$CLASS_NAME_ACTIVE$1);
        this._activateParents(target);
        $9c6c83c6a450e1f8$var$EventHandler.trigger(this._element, $9c6c83c6a450e1f8$var$EVENT_ACTIVATE, {
            relatedTarget: target
        });
    }
    _activateParents(target) {
        // Activate dropdown parents
        if (target.classList.contains($9c6c83c6a450e1f8$var$CLASS_NAME_DROPDOWN_ITEM)) {
            $9c6c83c6a450e1f8$var$SelectorEngine.findOne($9c6c83c6a450e1f8$var$SELECTOR_DROPDOWN_TOGGLE$1, target.closest($9c6c83c6a450e1f8$var$SELECTOR_DROPDOWN)).classList.add($9c6c83c6a450e1f8$var$CLASS_NAME_ACTIVE$1);
            return;
        }
        for (const listGroup of $9c6c83c6a450e1f8$var$SelectorEngine.parents(target, $9c6c83c6a450e1f8$var$SELECTOR_NAV_LIST_GROUP))// Set triggered links parents as active
        // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
        for (const item of $9c6c83c6a450e1f8$var$SelectorEngine.prev(listGroup, $9c6c83c6a450e1f8$var$SELECTOR_LINK_ITEMS))item.classList.add($9c6c83c6a450e1f8$var$CLASS_NAME_ACTIVE$1);
    }
    _clearActiveClass(parent) {
        parent.classList.remove($9c6c83c6a450e1f8$var$CLASS_NAME_ACTIVE$1);
        const activeNodes = $9c6c83c6a450e1f8$var$SelectorEngine.find(`${$9c6c83c6a450e1f8$var$SELECTOR_TARGET_LINKS}.${$9c6c83c6a450e1f8$var$CLASS_NAME_ACTIVE$1}`, parent);
        for (const node of activeNodes)node.classList.remove($9c6c83c6a450e1f8$var$CLASS_NAME_ACTIVE$1);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $9c6c83c6a450e1f8$export$a6472a5298a374be.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $9c6c83c6a450e1f8$var$EventHandler.on(window, $9c6c83c6a450e1f8$var$EVENT_LOAD_DATA_API$1, ()=>{
    for (const spy of $9c6c83c6a450e1f8$var$SelectorEngine.find($9c6c83c6a450e1f8$var$SELECTOR_DATA_SPY))$9c6c83c6a450e1f8$export$a6472a5298a374be.getOrCreateInstance(spy);
});
/**
 * jQuery
 */ $9c6c83c6a450e1f8$var$defineJQueryPlugin($9c6c83c6a450e1f8$export$a6472a5298a374be);
/**
 * --------------------------------------------------------------------------
 * Bootstrap tab.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $9c6c83c6a450e1f8$var$NAME$1 = "tab";
const $9c6c83c6a450e1f8$var$DATA_KEY$1 = "bs.tab";
const $9c6c83c6a450e1f8$var$EVENT_KEY$1 = `.${$9c6c83c6a450e1f8$var$DATA_KEY$1}`;
const $9c6c83c6a450e1f8$var$EVENT_HIDE$1 = `hide${$9c6c83c6a450e1f8$var$EVENT_KEY$1}`;
const $9c6c83c6a450e1f8$var$EVENT_HIDDEN$1 = `hidden${$9c6c83c6a450e1f8$var$EVENT_KEY$1}`;
const $9c6c83c6a450e1f8$var$EVENT_SHOW$1 = `show${$9c6c83c6a450e1f8$var$EVENT_KEY$1}`;
const $9c6c83c6a450e1f8$var$EVENT_SHOWN$1 = `shown${$9c6c83c6a450e1f8$var$EVENT_KEY$1}`;
const $9c6c83c6a450e1f8$var$EVENT_CLICK_DATA_API = `click${$9c6c83c6a450e1f8$var$EVENT_KEY$1}`;
const $9c6c83c6a450e1f8$var$EVENT_KEYDOWN = `keydown${$9c6c83c6a450e1f8$var$EVENT_KEY$1}`;
const $9c6c83c6a450e1f8$var$EVENT_LOAD_DATA_API = `load${$9c6c83c6a450e1f8$var$EVENT_KEY$1}`;
const $9c6c83c6a450e1f8$var$ARROW_LEFT_KEY = "ArrowLeft";
const $9c6c83c6a450e1f8$var$ARROW_RIGHT_KEY = "ArrowRight";
const $9c6c83c6a450e1f8$var$ARROW_UP_KEY = "ArrowUp";
const $9c6c83c6a450e1f8$var$ARROW_DOWN_KEY = "ArrowDown";
const $9c6c83c6a450e1f8$var$HOME_KEY = "Home";
const $9c6c83c6a450e1f8$var$END_KEY = "End";
const $9c6c83c6a450e1f8$var$CLASS_NAME_ACTIVE = "active";
const $9c6c83c6a450e1f8$var$CLASS_NAME_FADE$1 = "fade";
const $9c6c83c6a450e1f8$var$CLASS_NAME_SHOW$1 = "show";
const $9c6c83c6a450e1f8$var$CLASS_DROPDOWN = "dropdown";
const $9c6c83c6a450e1f8$var$SELECTOR_DROPDOWN_TOGGLE = ".dropdown-toggle";
const $9c6c83c6a450e1f8$var$SELECTOR_DROPDOWN_MENU = ".dropdown-menu";
const $9c6c83c6a450e1f8$var$NOT_SELECTOR_DROPDOWN_TOGGLE = `:not(${$9c6c83c6a450e1f8$var$SELECTOR_DROPDOWN_TOGGLE})`;
const $9c6c83c6a450e1f8$var$SELECTOR_TAB_PANEL = '.list-group, .nav, [role="tablist"]';
const $9c6c83c6a450e1f8$var$SELECTOR_OUTER = ".nav-item, .list-group-item";
const $9c6c83c6a450e1f8$var$SELECTOR_INNER = `.nav-link${$9c6c83c6a450e1f8$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, .list-group-item${$9c6c83c6a450e1f8$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, [role="tab"]${$9c6c83c6a450e1f8$var$NOT_SELECTOR_DROPDOWN_TOGGLE}`;
const $9c6c83c6a450e1f8$var$SELECTOR_DATA_TOGGLE = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]'; // TODO: could only be `tab` in v6
const $9c6c83c6a450e1f8$var$SELECTOR_INNER_ELEM = `${$9c6c83c6a450e1f8$var$SELECTOR_INNER}, ${$9c6c83c6a450e1f8$var$SELECTOR_DATA_TOGGLE}`;
const $9c6c83c6a450e1f8$var$SELECTOR_DATA_TOGGLE_ACTIVE = `.${$9c6c83c6a450e1f8$var$CLASS_NAME_ACTIVE}[data-bs-toggle="tab"], .${$9c6c83c6a450e1f8$var$CLASS_NAME_ACTIVE}[data-bs-toggle="pill"], .${$9c6c83c6a450e1f8$var$CLASS_NAME_ACTIVE}[data-bs-toggle="list"]`;
/**
 * Class definition
 */ class $9c6c83c6a450e1f8$export$3e41faf802a29e71 extends $9c6c83c6a450e1f8$var$BaseComponent {
    constructor(element){
        super(element);
        this._parent = this._element.closest($9c6c83c6a450e1f8$var$SELECTOR_TAB_PANEL);
        if (!this._parent) return;
        // Set up initial aria attributes
        this._setInitialAttributes(this._parent, this._getChildren());
        $9c6c83c6a450e1f8$var$EventHandler.on(this._element, $9c6c83c6a450e1f8$var$EVENT_KEYDOWN, (event)=>this._keydown(event));
    }
    // Getters
    static get NAME() {
        return $9c6c83c6a450e1f8$var$NAME$1;
    }
    // Public
    show() {
        // Shows this elem and deactivate the active sibling if exists
        const innerElem = this._element;
        if (this._elemIsActive(innerElem)) return;
        // Search for active tab on same parent to deactivate it
        const active = this._getActiveElem();
        const hideEvent = active ? $9c6c83c6a450e1f8$var$EventHandler.trigger(active, $9c6c83c6a450e1f8$var$EVENT_HIDE$1, {
            relatedTarget: innerElem
        }) : null;
        const showEvent = $9c6c83c6a450e1f8$var$EventHandler.trigger(innerElem, $9c6c83c6a450e1f8$var$EVENT_SHOW$1, {
            relatedTarget: active
        });
        if (showEvent.defaultPrevented || hideEvent && hideEvent.defaultPrevented) return;
        this._deactivate(active, innerElem);
        this._activate(innerElem, active);
    }
    // Private
    _activate(element, relatedElem) {
        if (!element) return;
        element.classList.add($9c6c83c6a450e1f8$var$CLASS_NAME_ACTIVE);
        this._activate($9c6c83c6a450e1f8$var$SelectorEngine.getElementFromSelector(element)); // Search and activate/show the proper section
        const complete = ()=>{
            if (element.getAttribute("role") !== "tab") {
                element.classList.add($9c6c83c6a450e1f8$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.removeAttribute("tabindex");
            element.setAttribute("aria-selected", true);
            this._toggleDropDown(element, true);
            $9c6c83c6a450e1f8$var$EventHandler.trigger(element, $9c6c83c6a450e1f8$var$EVENT_SHOWN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($9c6c83c6a450e1f8$var$CLASS_NAME_FADE$1));
    }
    _deactivate(element, relatedElem) {
        if (!element) return;
        element.classList.remove($9c6c83c6a450e1f8$var$CLASS_NAME_ACTIVE);
        element.blur();
        this._deactivate($9c6c83c6a450e1f8$var$SelectorEngine.getElementFromSelector(element)); // Search and deactivate the shown section too
        const complete = ()=>{
            if (element.getAttribute("role") !== "tab") {
                element.classList.remove($9c6c83c6a450e1f8$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.setAttribute("aria-selected", false);
            element.setAttribute("tabindex", "-1");
            this._toggleDropDown(element, false);
            $9c6c83c6a450e1f8$var$EventHandler.trigger(element, $9c6c83c6a450e1f8$var$EVENT_HIDDEN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($9c6c83c6a450e1f8$var$CLASS_NAME_FADE$1));
    }
    _keydown(event) {
        if (![
            $9c6c83c6a450e1f8$var$ARROW_LEFT_KEY,
            $9c6c83c6a450e1f8$var$ARROW_RIGHT_KEY,
            $9c6c83c6a450e1f8$var$ARROW_UP_KEY,
            $9c6c83c6a450e1f8$var$ARROW_DOWN_KEY,
            $9c6c83c6a450e1f8$var$HOME_KEY,
            $9c6c83c6a450e1f8$var$END_KEY
        ].includes(event.key)) return;
        event.stopPropagation(); // stopPropagation/preventDefault both added to support up/down keys without scrolling the page
        event.preventDefault();
        const children = this._getChildren().filter((element)=>!$9c6c83c6a450e1f8$var$isDisabled(element));
        let nextActiveElement;
        if ([
            $9c6c83c6a450e1f8$var$HOME_KEY,
            $9c6c83c6a450e1f8$var$END_KEY
        ].includes(event.key)) nextActiveElement = children[event.key === $9c6c83c6a450e1f8$var$HOME_KEY ? 0 : children.length - 1];
        else {
            const isNext = [
                $9c6c83c6a450e1f8$var$ARROW_RIGHT_KEY,
                $9c6c83c6a450e1f8$var$ARROW_DOWN_KEY
            ].includes(event.key);
            nextActiveElement = $9c6c83c6a450e1f8$var$getNextActiveElement(children, event.target, isNext, true);
        }
        if (nextActiveElement) {
            nextActiveElement.focus({
                preventScroll: true
            });
            $9c6c83c6a450e1f8$export$3e41faf802a29e71.getOrCreateInstance(nextActiveElement).show();
        }
    }
    _getChildren() {
        // collection of inner elements
        return $9c6c83c6a450e1f8$var$SelectorEngine.find($9c6c83c6a450e1f8$var$SELECTOR_INNER_ELEM, this._parent);
    }
    _getActiveElem() {
        return this._getChildren().find((child)=>this._elemIsActive(child)) || null;
    }
    _setInitialAttributes(parent, children) {
        this._setAttributeIfNotExists(parent, "role", "tablist");
        for (const child of children)this._setInitialAttributesOnChild(child);
    }
    _setInitialAttributesOnChild(child) {
        child = this._getInnerElement(child);
        const isActive = this._elemIsActive(child);
        const outerElem = this._getOuterElement(child);
        child.setAttribute("aria-selected", isActive);
        if (outerElem !== child) this._setAttributeIfNotExists(outerElem, "role", "presentation");
        if (!isActive) child.setAttribute("tabindex", "-1");
        this._setAttributeIfNotExists(child, "role", "tab");
        // set attributes to the related panel too
        this._setInitialAttributesOnTargetPanel(child);
    }
    _setInitialAttributesOnTargetPanel(child) {
        const target = $9c6c83c6a450e1f8$var$SelectorEngine.getElementFromSelector(child);
        if (!target) return;
        this._setAttributeIfNotExists(target, "role", "tabpanel");
        if (child.id) this._setAttributeIfNotExists(target, "aria-labelledby", `${child.id}`);
    }
    _toggleDropDown(element, open) {
        const outerElem = this._getOuterElement(element);
        if (!outerElem.classList.contains($9c6c83c6a450e1f8$var$CLASS_DROPDOWN)) return;
        const toggle = (selector, className)=>{
            const element = $9c6c83c6a450e1f8$var$SelectorEngine.findOne(selector, outerElem);
            if (element) element.classList.toggle(className, open);
        };
        toggle($9c6c83c6a450e1f8$var$SELECTOR_DROPDOWN_TOGGLE, $9c6c83c6a450e1f8$var$CLASS_NAME_ACTIVE);
        toggle($9c6c83c6a450e1f8$var$SELECTOR_DROPDOWN_MENU, $9c6c83c6a450e1f8$var$CLASS_NAME_SHOW$1);
        outerElem.setAttribute("aria-expanded", open);
    }
    _setAttributeIfNotExists(element, attribute, value) {
        if (!element.hasAttribute(attribute)) element.setAttribute(attribute, value);
    }
    _elemIsActive(elem) {
        return elem.classList.contains($9c6c83c6a450e1f8$var$CLASS_NAME_ACTIVE);
    }
    // Try to get the inner element (usually the .nav-link)
    _getInnerElement(elem) {
        return elem.matches($9c6c83c6a450e1f8$var$SELECTOR_INNER_ELEM) ? elem : $9c6c83c6a450e1f8$var$SelectorEngine.findOne($9c6c83c6a450e1f8$var$SELECTOR_INNER_ELEM, elem);
    }
    // Try to get the outer element (usually the .nav-item)
    _getOuterElement(elem) {
        return elem.closest($9c6c83c6a450e1f8$var$SELECTOR_OUTER) || elem;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $9c6c83c6a450e1f8$export$3e41faf802a29e71.getOrCreateInstance(this);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $9c6c83c6a450e1f8$var$EventHandler.on(document, $9c6c83c6a450e1f8$var$EVENT_CLICK_DATA_API, $9c6c83c6a450e1f8$var$SELECTOR_DATA_TOGGLE, function(event) {
    if ([
        "A",
        "AREA"
    ].includes(this.tagName)) event.preventDefault();
    if ($9c6c83c6a450e1f8$var$isDisabled(this)) return;
    $9c6c83c6a450e1f8$export$3e41faf802a29e71.getOrCreateInstance(this).show();
});
/**
 * Initialize on focus
 */ $9c6c83c6a450e1f8$var$EventHandler.on(window, $9c6c83c6a450e1f8$var$EVENT_LOAD_DATA_API, ()=>{
    for (const element of $9c6c83c6a450e1f8$var$SelectorEngine.find($9c6c83c6a450e1f8$var$SELECTOR_DATA_TOGGLE_ACTIVE))$9c6c83c6a450e1f8$export$3e41faf802a29e71.getOrCreateInstance(element);
});
/**
 * jQuery
 */ $9c6c83c6a450e1f8$var$defineJQueryPlugin($9c6c83c6a450e1f8$export$3e41faf802a29e71);
/**
 * --------------------------------------------------------------------------
 * Bootstrap toast.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $9c6c83c6a450e1f8$var$NAME = "toast";
const $9c6c83c6a450e1f8$var$DATA_KEY = "bs.toast";
const $9c6c83c6a450e1f8$var$EVENT_KEY = `.${$9c6c83c6a450e1f8$var$DATA_KEY}`;
const $9c6c83c6a450e1f8$var$EVENT_MOUSEOVER = `mouseover${$9c6c83c6a450e1f8$var$EVENT_KEY}`;
const $9c6c83c6a450e1f8$var$EVENT_MOUSEOUT = `mouseout${$9c6c83c6a450e1f8$var$EVENT_KEY}`;
const $9c6c83c6a450e1f8$var$EVENT_FOCUSIN = `focusin${$9c6c83c6a450e1f8$var$EVENT_KEY}`;
const $9c6c83c6a450e1f8$var$EVENT_FOCUSOUT = `focusout${$9c6c83c6a450e1f8$var$EVENT_KEY}`;
const $9c6c83c6a450e1f8$var$EVENT_HIDE = `hide${$9c6c83c6a450e1f8$var$EVENT_KEY}`;
const $9c6c83c6a450e1f8$var$EVENT_HIDDEN = `hidden${$9c6c83c6a450e1f8$var$EVENT_KEY}`;
const $9c6c83c6a450e1f8$var$EVENT_SHOW = `show${$9c6c83c6a450e1f8$var$EVENT_KEY}`;
const $9c6c83c6a450e1f8$var$EVENT_SHOWN = `shown${$9c6c83c6a450e1f8$var$EVENT_KEY}`;
const $9c6c83c6a450e1f8$var$CLASS_NAME_FADE = "fade";
const $9c6c83c6a450e1f8$var$CLASS_NAME_HIDE = "hide"; // @deprecated - kept here only for backwards compatibility
const $9c6c83c6a450e1f8$var$CLASS_NAME_SHOW = "show";
const $9c6c83c6a450e1f8$var$CLASS_NAME_SHOWING = "showing";
const $9c6c83c6a450e1f8$var$DefaultType = {
    animation: "boolean",
    autohide: "boolean",
    delay: "number"
};
const $9c6c83c6a450e1f8$var$Default = {
    animation: true,
    autohide: true,
    delay: 5000
};
/**
 * Class definition
 */ class $9c6c83c6a450e1f8$export$8d8dc7d5f743331b extends $9c6c83c6a450e1f8$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._timeout = null;
        this._hasMouseInteraction = false;
        this._hasKeyboardInteraction = false;
        this._setListeners();
    }
    // Getters
    static get Default() {
        return $9c6c83c6a450e1f8$var$Default;
    }
    static get DefaultType() {
        return $9c6c83c6a450e1f8$var$DefaultType;
    }
    static get NAME() {
        return $9c6c83c6a450e1f8$var$NAME;
    }
    // Public
    show() {
        const showEvent = $9c6c83c6a450e1f8$var$EventHandler.trigger(this._element, $9c6c83c6a450e1f8$var$EVENT_SHOW);
        if (showEvent.defaultPrevented) return;
        this._clearTimeout();
        if (this._config.animation) this._element.classList.add($9c6c83c6a450e1f8$var$CLASS_NAME_FADE);
        const complete = ()=>{
            this._element.classList.remove($9c6c83c6a450e1f8$var$CLASS_NAME_SHOWING);
            $9c6c83c6a450e1f8$var$EventHandler.trigger(this._element, $9c6c83c6a450e1f8$var$EVENT_SHOWN);
            this._maybeScheduleHide();
        };
        this._element.classList.remove($9c6c83c6a450e1f8$var$CLASS_NAME_HIDE); // @deprecated
        $9c6c83c6a450e1f8$var$reflow(this._element);
        this._element.classList.add($9c6c83c6a450e1f8$var$CLASS_NAME_SHOW, $9c6c83c6a450e1f8$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    hide() {
        if (!this.isShown()) return;
        const hideEvent = $9c6c83c6a450e1f8$var$EventHandler.trigger(this._element, $9c6c83c6a450e1f8$var$EVENT_HIDE);
        if (hideEvent.defaultPrevented) return;
        const complete = ()=>{
            this._element.classList.add($9c6c83c6a450e1f8$var$CLASS_NAME_HIDE); // @deprecated
            this._element.classList.remove($9c6c83c6a450e1f8$var$CLASS_NAME_SHOWING, $9c6c83c6a450e1f8$var$CLASS_NAME_SHOW);
            $9c6c83c6a450e1f8$var$EventHandler.trigger(this._element, $9c6c83c6a450e1f8$var$EVENT_HIDDEN);
        };
        this._element.classList.add($9c6c83c6a450e1f8$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    dispose() {
        this._clearTimeout();
        if (this.isShown()) this._element.classList.remove($9c6c83c6a450e1f8$var$CLASS_NAME_SHOW);
        super.dispose();
    }
    isShown() {
        return this._element.classList.contains($9c6c83c6a450e1f8$var$CLASS_NAME_SHOW);
    }
    // Private
    _maybeScheduleHide() {
        if (!this._config.autohide) return;
        if (this._hasMouseInteraction || this._hasKeyboardInteraction) return;
        this._timeout = setTimeout(()=>{
            this.hide();
        }, this._config.delay);
    }
    _onInteraction(event, isInteracting) {
        switch(event.type){
            case "mouseover":
            case "mouseout":
                this._hasMouseInteraction = isInteracting;
                break;
            case "focusin":
            case "focusout":
                this._hasKeyboardInteraction = isInteracting;
                break;
        }
        if (isInteracting) {
            this._clearTimeout();
            return;
        }
        const nextElement = event.relatedTarget;
        if (this._element === nextElement || this._element.contains(nextElement)) return;
        this._maybeScheduleHide();
    }
    _setListeners() {
        $9c6c83c6a450e1f8$var$EventHandler.on(this._element, $9c6c83c6a450e1f8$var$EVENT_MOUSEOVER, (event)=>this._onInteraction(event, true));
        $9c6c83c6a450e1f8$var$EventHandler.on(this._element, $9c6c83c6a450e1f8$var$EVENT_MOUSEOUT, (event)=>this._onInteraction(event, false));
        $9c6c83c6a450e1f8$var$EventHandler.on(this._element, $9c6c83c6a450e1f8$var$EVENT_FOCUSIN, (event)=>this._onInteraction(event, true));
        $9c6c83c6a450e1f8$var$EventHandler.on(this._element, $9c6c83c6a450e1f8$var$EVENT_FOCUSOUT, (event)=>this._onInteraction(event, false));
    }
    _clearTimeout() {
        clearTimeout(this._timeout);
        this._timeout = null;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $9c6c83c6a450e1f8$export$8d8dc7d5f743331b.getOrCreateInstance(this, config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config](this);
            }
        });
    }
}
/**
 * Data API implementation
 */ $9c6c83c6a450e1f8$var$enableDismissTrigger($9c6c83c6a450e1f8$export$8d8dc7d5f743331b);
/**
 * jQuery
 */ $9c6c83c6a450e1f8$var$defineJQueryPlugin($9c6c83c6a450e1f8$export$8d8dc7d5f743331b);


/**
 * Adds useful functions both to SVG.Number and SVG.Point.
 *
 * @module impSVGNumber
 */ 
var $gBhAd = parcelRequire("gBhAd");

var $gBhAd = parcelRequire("gBhAd");

const $429ca25d803b1e0f$export$80fcba011b33afb8 = 0.5;
const $429ca25d803b1e0f$export$1617d35435c603f6 = "var(--bs-red)";
const $429ca25d803b1e0f$export$c19757439fb239a7 = "var(--bs-teal)";
const $429ca25d803b1e0f$export$10606941daa6e712 = 16;
function $429ca25d803b1e0f$export$65961b53e2ba3402() {
    let circle = (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas.circle($429ca25d803b1e0f$export$10606941daa6e712).fill("transparent");
    circle.node.classList.add("pathPoint");
    return circle;
}
function $429ca25d803b1e0f$export$a9cd85b3d0cd1648() {
    let g = (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas.group();
    g.add((0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas.rect(10, 10).fill("transparent").stroke("none"));
    g.add((0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas.rect(5, 5).fill("var(--bs-cyan)").stroke("none").move(2.5, 2.5));
    return g;
}
function $429ca25d803b1e0f$export$5b0dabb733625ce9(n) {
    return n.toLocaleString("en", {
        maximumFractionDigits: 3,
        notation: "standard"
    });
}
function $429ca25d803b1e0f$export$fcb298298cd30496(line1, line2) {
    let l1 = line1 instanceof $gBhAd.Line ? line1.array() : line1;
    let l2 = line2 instanceof $gBhAd.Line ? line2.array() : line2;
    let det = (l1[0][0] - l1[1][0]) * (l2[0][1] - l2[1][1]) - (l1[0][1] - l1[1][1]) * (l2[0][0] - l2[1][0]);
    if (det == 0) return false;
    let t = ((l1[0][0] - l2[0][0]) * (l2[0][1] - l2[1][1]) - (l1[0][1] - l2[0][1]) * (l2[0][0] - l2[1][0])) / det;
    let u = -((l1[0][0] - l1[1][0]) * (l1[0][1] - l2[0][1]) - (l1[0][1] - l1[1][1]) * (l1[0][0] - l2[0][0])) / det;
    return t >= 0 && t <= 1 && u >= 0 && u <= 1;
}
function $429ca25d803b1e0f$export$51318765f3340fac(line, rect) {
    let boxPoints = [
        [
            rect.x,
            rect.y
        ],
        [
            rect.x2,
            rect.y
        ],
        [
            rect.x2,
            rect.y2
        ],
        [
            rect.x,
            rect.y2
        ],
        [
            rect.x,
            rect.y
        ]
    ];
    // line and any line of rect intersect?
    for(let index = 0; index < boxPoints.length - 1; index++){
        if ($429ca25d803b1e0f$export$fcb298298cd30496(line, [
            boxPoints[index],
            boxPoints[index + 1]
        ])) return true;
    }
    // line inside rect?
    if ($429ca25d803b1e0f$export$aedb7b212a60242f(line instanceof $gBhAd.Line ? new $gBhAd.Point(line.cx(), line.cy()) : line[0], rect)) return true;
    return false;
}
function $429ca25d803b1e0f$export$11f7f05b1cf6c7d0(rect1, rect2, rotationDeg1 = 0) {
    if (rotationDeg1 == 0) {
        let l1 = new $gBhAd.Point(rect1.x, rect1.y);
        let r1 = new $gBhAd.Point(rect1.x2, rect1.y2);
        let l2 = new $gBhAd.Point(rect2.x, rect2.y);
        let r2 = new $gBhAd.Point(rect2.x2, rect2.y2);
        // If one rectangle is on left side of other
        if (l1.x > r2.x || l2.x > r1.x) return false;
        // If one rectangle is above other
        if (r1.y < l2.y || r2.y < l1.y) return false;
        return true;
    }
    const rect1Center = new $gBhAd.Point(rect1.cx, rect1.cy);
    // rect2 center inside rect1?
    if ($429ca25d803b1e0f$export$aedb7b212a60242f(new $gBhAd.Point(rect2.cx, rect2.cy).rotate(-rotationDeg1, rect1Center), rect1)) return true;
    let boxPoints = [
        [
            rect1.x,
            rect1.y
        ],
        [
            rect1.x2,
            rect1.y
        ],
        [
            rect1.x2,
            rect1.y2
        ],
        [
            rect1.x,
            rect1.y2
        ]
    ];
    const points = boxPoints.map((point)=>new $gBhAd.Point(point[0], point[1]).rotate(rotationDeg1, rect1Center));
    for(let index = 0; index < points.length - 1; index++){
        const A = points[index];
        const B = points[(index + 1) % points.length];
        if ($429ca25d803b1e0f$export$51318765f3340fac([
            [
                A.x,
                A.y
            ],
            [
                B.x,
                B.y
            ]
        ], rect2)) return true;
    }
}
function $429ca25d803b1e0f$export$aedb7b212a60242f(point, rect) {
    let p = point instanceof $gBhAd.Point ? [
        point.x,
        point.y
    ] : point;
    return p[0] >= rect.x && p[0] <= rect.x2 && p[1] >= rect.y && p[1] <= rect.y2;
}


/**
 * Conversion constants from/to any svg unit.
 *
 * @readonly
 * @enum {ToUnit}
 */ const $d1e874fdf778928a$var$unitConvertMap = {
    px: {
        px: 1,
        in: 1 / 96,
        cm: 127 / 4800,
        mm: 127 / 480,
        pt: 3 / 4,
        pc: 1 / 16
    },
    in: {
        px: 96,
        in: 1,
        cm: 2.54,
        mm: 25.4,
        pt: 72,
        pc: 6
    },
    cm: {
        px: 4800 / 127,
        in: 50 / 127,
        cm: 1,
        mm: 10,
        pt: 3600 / 127,
        pc: 300 / 127
    },
    mm: {
        px: 480 / 127,
        in: 5 / 127,
        cm: 0.1,
        mm: 1,
        pt: 360 / 127,
        pc: 30 / 127
    },
    pt: {
        px: 4 / 3,
        in: 1 / 72,
        cm: 127 / 3600,
        mm: 127 / 360,
        pt: 1,
        pc: 1 / 12
    },
    pc: {
        px: 16,
        in: 1 / 6,
        cm: 127 / 300,
        mm: 127 / 30,
        pt: 12,
        pc: 1
    }
};
/**
 * List of unit names. The unit with the lowest index is the most preferred one.
 *
 * @type {string[]}
 */ const $d1e874fdf778928a$var$unitPriority = [
    "px",
    "in",
    "pt",
    "pc",
    "cm",
    "mm"
];
/**
 * Convert two values to the same unit. The priority for unit is determined using {@link unitPriority}.
 * If the second number is not a instance of {@link SVG.Number}, it is assumed, that both numbers have the same unit.
 *
 * @param {SVG.Number} thisNumber - the first number; this number will be cloned
 * @param {SVG.Number | number} otherNumber - the second number
 * @returns {SVG.Number[]} an array of both numbers
 */ function $d1e874fdf778928a$var$toSameUnit(thisNumber, otherNumber) {
    const thisNumberUnit = thisNumber.unit || "px"; // Empty == "px"
    const otherNumberUnit = otherNumber instanceof $gBhAd.Number ? otherNumber.unit || "px" : "px";
    let numberA = new $gBhAd.Number(thisNumber);
    let numberB;
    if (!(otherNumber instanceof $gBhAd.Number)) numberB = new $gBhAd.Number(otherNumber, thisNumberUnit); // assume same unit
    else if (thisNumberUnit !== otherNumberUnit) {
        const thisNumberPrio = $d1e874fdf778928a$var$unitPriority.indexOf(thisNumberUnit);
        const otherNumberPrio = $d1e874fdf778928a$var$unitPriority.indexOf(otherNumberUnit);
        numberB = new $gBhAd.Number(otherNumber);
        if (thisNumberPrio < otherNumberPrio) numberB = numberB.convertToUnit(thisNumberUnit);
        else numberA = numberA.convertToUnit(otherNumberUnit);
    } else numberB = new $gBhAd.Number(otherNumber);
    return [
        numberA,
        numberB
    ];
}
$gBhAd.extend($gBhAd.Number, {
    /**
     * Convert a SVGNumber to another unit. Does actually change the value.
     *
     * @function convertToUnit
     * @memberof SVG.Number
     * @instance
     * @this {SVG.Number}
     * @param {"px"|"in"|"cm"|"mm"|"pt"|"pc"} unit - the unit to convert to
     * @returns {SVG.Number}
     */ convertToUnit (unit) {
        /** @type {ToUnit} */ const factors = $d1e874fdf778928a$var$unitConvertMap[this.unit || "px"] || null;
        const factor = factors?.[unit] ?? null;
        if (factor !== null) return new $gBhAd.Number(this.value * factor, unit);
        else throw new Error("Invalid unit");
    },
    /**
     * Divides this number by another svg number.
     * Returns a new instance.
     *
     * @this {SVG.Number}
     * @param {SVG.Number|number} number - the divisor
     * @returns {SVG.Number} the result
     */ divide (number) {
        let [thisNumber, otherNumber] = $d1e874fdf778928a$var$toSameUnit(this, number);
        thisNumber.value /= otherNumber.value;
        return thisNumber;
    },
    /**
     * Subtracts another svg number.
     * Returns a new instance.
     *
     * @this {SVG.Number}
     * @param {SVG.Number|number} number - the subtrahend
     * @returns {SVG.Number} the result
     */ minus (number) {
        let [thisNumber, otherNumber] = $d1e874fdf778928a$var$toSameUnit(this, number);
        thisNumber.value -= otherNumber.value;
        return thisNumber;
    },
    /**
     * Calculates the sum of this number and another svg number.
     * Returns a new instance.
     *
     * @this {SVG.Number}
     * @param {SVG.Number|number} number - the other summand
     * @returns {SVG.Number} the result
     */ plus (number) {
        let [thisNumber, otherNumber] = $d1e874fdf778928a$var$toSameUnit(this, number);
        thisNumber.value += otherNumber.value;
        return thisNumber;
    },
    /**
     * Multiplies this number with another svg number.
     * Returns a new instance.
     *
     * @this {SVG.Number}
     * @param {SVG.Number|number} number - the other operand
     * @returns {SVG.Number} the result
     */ times (number) {
        let [thisNumber, otherNumber] = $d1e874fdf778928a$var$toSameUnit(this, number);
        thisNumber.value *= otherNumber.value;
        return thisNumber;
    },
    /**
     * Calculates the exponentiation using this number as base.
     * Returns a new instance.
     *
     * @this {SVG.Number}
     * @param {number} exponent - the exponent
     * @returns {SVG.Number} the result
     */ pow (exponent) {
        let thisNumber = new $gBhAd.Number(this);
        thisNumber.value **= exponent;
        return thisNumber;
    },
    /**
     * Calculates the remainder (modulo) of an division.
     * Returns a new instance.
     *
     * @this {SVG.Number}
     * @param {number} number - the divisor
     * @returns {SVG.Number} the result
     */ mod (number) {
        let thisNumber = new $gBhAd.Number(this);
        thisNumber.value %= number;
        return thisNumber;
    },
    /**
     * Checks if this svg number is greater than the other one.
     *
     * @this {SVG.Number}
     * @param {SVG.Number|number} number - the other number
     * @returns {boolean} the result
     */ gt (number) {
        let [thisNumber, otherNumber] = $d1e874fdf778928a$var$toSameUnit(this, number);
        return thisNumber.value > otherNumber.value;
    },
    /**
     * Checks if this svg number is greater than the other one or equal.
     *
     * @this {SVG.Number}
     * @param {SVG.Number|number} number - the other number
     * @returns {boolean} the result
     */ gte (number) {
        let [thisNumber, otherNumber] = $d1e874fdf778928a$var$toSameUnit(this, number);
        return thisNumber.value >= otherNumber.value;
    },
    /**
     * Checks if this svg number is less than the other one.
     *
     * @this {SVG.Number}
     * @param {SVG.Number|number} number - the other number
     * @returns {boolean} the result
     */ lt (number) {
        let [thisNumber, otherNumber] = $d1e874fdf778928a$var$toSameUnit(this, number);
        return thisNumber.value < otherNumber.value;
    },
    /**
     * Checks if this svg number is less than the other one or equal.
     *
     * @this {SVG.Number}
     * @param {SVG.Number|number} number - the other number
     * @returns {boolean} the result
     */ lte (number) {
        let [thisNumber, otherNumber] = $d1e874fdf778928a$var$toSameUnit(this, number);
        return thisNumber.value <= otherNumber.value;
    },
    /**
     * Checks if this svg number is equal the other one.
     *
     * @this {SVG.Number}
     * @param {SVG.Number|number} number - the other number
     * @returns {boolean} the result
     */ eq (number) {
        let [thisNumber, otherNumber] = $d1e874fdf778928a$var$toSameUnit(this, number);
        return thisNumber.value == otherNumber.value;
    }
});
function $d1e874fdf778928a$export$82fd0165357841b8(nmbr) {
    if (nmbr instanceof $gBhAd.Number) return nmbr.convertToUnit("px").value;
    let num = Number(nmbr);
    if (Number.isNaN(num)) {
        if (typeof nmbr === "string") return new $gBhAd.Number(nmbr).convertToUnit("px").value;
        else if (typeof nmbr === "number") return new $gBhAd.Number(nmbr).convertToUnit("px").value;
        else {
            nmbr.convertToSpecifiedUnits(SVGLength.SVG_LENGTHTYPE_PX);
            return nmbr.value;
        }
    } else return num;
}
$gBhAd.extend($gBhAd.Point, {
    /**
     * Calculate the squared distance of two points.
     *
     * @this {SVG.Point}
     * @param {SVG.Point} other - the other point
     * @returns {number} the squared distance (px^2)
     */ distanceSquared (other) {
        return (this.x - other.x) ** 2 + (this.y - other.y) ** 2;
    },
    /**
     * Calculate the distance of two points.
     *
     * @this {SVG.Point}
     * @param {SVG.Point} other - the other point
     * @returns {number} the squared distance (px)
     */ distance (other) {
        return Math.sqrt((this.x - other.x) ** 2 + (this.y - other.y) ** 2);
    },
    /**
     * Calculate the length of the vector resp. the distance from (0|0).
     *
     * @this {SVG.Point}
     * @returns {number} the squared length (px^2)
     */ absSquared () {
        return this.x ** 2 + this.y ** 2;
    },
    /**
     * Calculate the length of the vector resp. the distance from (0|0).
     *
     * @this {SVG.Point}
     * @returns {number} the length (px)
     */ abs () {
        return Math.sqrt(this.x ** 2 + this.y ** 2);
    },
    /**
     * Subtracts another svg point.
     * Returns a new instance.
     *
     * @this {SVG.Point}
     * @param {SVG.Point|number} other - the subtrahend
     * @returns {SVG.Point} the result
     */ sub (other) {
        if (other instanceof $gBhAd.Point) return new $gBhAd.Point(this.x - other.x, this.y - other.y);
        else return new $gBhAd.Point(this.x - other, this.y - other);
    },
    /**
     * Calculates the sum of this and another svg point.
     * Returns a new instance.
     *
     * @this {SVG.Point}
     * @param {SVG.Point|number} other - the other summand
     * @returns {SVG.Point} the result
     */ add (other) {
        if (other instanceof $gBhAd.Point) return new $gBhAd.Point(this.x + other.x, this.y + other.y);
        else return new $gBhAd.Point(this.x + other, this.y + other);
    },
    /**
     * Calculates the multiplication of this point and another svg point or number (elementwise).
     * Returns a new instance.
     */ mul (other) {
        if (other instanceof $gBhAd.Point) return new $gBhAd.Point(this.x * other.x, this.y * other.y);
        else return new $gBhAd.Point(this.x * other, this.y * other);
    },
    /**
     * Calculates the division of this point and another svg point or number (elementwise).
     * Returns a new instance.
     */ div (other) {
        if (other instanceof $gBhAd.Point) return new $gBhAd.Point(this.x / other.x, this.y / other.y);
        else return new $gBhAd.Point(this.x / other, this.y / other);
    },
    /**
     * calculates the dot product between this point and the other point
     */ dot (other) {
        return this.x * other.x + this.y * other.y;
    },
    /**
     * Rotate the Coordinate around `centerCoord`. The rotation is counter clockwise, like the default mathematical
     * rotation.
     *
     * @this {SVG.Point}
     * @param {number} angle - rotation angle in degrees or radians
     * @param {SVG.Point} [centerCoord] - center of rotation
     * @param {boolean} [inRad=false] - set to `true`, if the angle is in radians
     * @returns {SVG.Point} the result
     */ rotate (angle, centerCoord, inRad = false) {
        let result = centerCoord ? this.sub(centerCoord) : this.clone();
        const oldX = result.x;
        const oldY = result.y;
        const radians = inRad ? angle : Math.PI / 180 * angle, cos = Math.cos(radians), sin = Math.sin(radians);
        result.x = cos * oldX + sin * oldY;
        result.y = -sin * oldX + cos * oldY;
        if (!!centerCoord) {
            result.x += centerCoord.x;
            result.y += centerCoord.y;
        }
        return result;
    },
    /**
     * Checks if to points are equal up to a given epsilon(how far the Xs and Ys can be apart to still count as being equal)
     *
     * @param other the other point
     * @param [eps=1e-7] how far the points can be apart
     * @returns true if the points are equal
     */ eq (other, eps = 1e-7) {
        if (this.x > other.x - eps && this.x < other.x + eps && this.y > other.y - eps && this.y < other.y + eps) return true;
        return false;
    },
    /**
     * Formats the point for usage with (Circui)TikZ.
     *
     * Converts from px to cm and rounds to 2 digits after the decimal point.
     *
     * @this {SVG.Point}
     * @returns {string} the TikZ representation, e.g. "(0.1, 1.23)"
     */ toTikzString () {
        return `(${(0, $429ca25d803b1e0f$export$5b0dabb733625ce9)(this.x * $d1e874fdf778928a$var$unitConvertMap.px.cm)}, ${(0, $429ca25d803b1e0f$export$5b0dabb733625ce9)(-this.y * $d1e874fdf778928a$var$unitConvertMap.px.cm)})`;
    },
    simplifyForJson (digits = 3) {
        let factor = 10 ** digits;
        return new $gBhAd.Point(Math.round(this.x * factor) / factor, Math.round(this.y * factor) / factor);
    }
});
$gBhAd.extend($gBhAd.Color, {
    toTikzString () {
        let color = this.rgb();
        return `{rgb,255:red,${color.r.toFixed(0)};green,${color.g.toFixed(0)};blue,${color.b.toFixed(0)}}`;
    }
});
const $d1e874fdf778928a$export$997d08e24ac70426 = (P, A, B)=>{
    let dir = B.sub(A);
    let t = P.sub(A).dot(dir) / dir.dot(dir);
    return [
        A.add(dir.mul(t)),
        t
    ];
};


/**
 * Functions for waiting on DOM loading/DOM changes applying.
 *
 * @module DOMWatcher
 */ /**
 * Wait for a document load state.
 * Does by default wait for the `"interactive"` state (DOM loaded), but the `targetState` can also be set to
 * `"complete"` (document fully loaded).
 *
 * @param {Document} [doc=document] - the document to check the `readyState`
 * @param {"interactive"|"complete"} [targetState="complete"] - the "minimum" state to wait for
 * @returns {Promise<Document>} the loaded document
 */ async function $fdc5c966c4323314$export$f44c3a30e8ef43c4(doc = document, targetState = "interactive") {
    /** @type {DocumentReadyState[]} */ const targetStates = targetState == "complete" ? [
        "complete"
    ] : [
        "interactive",
        "complete"
    ];
    if (!targetStates.includes(doc.readyState)) // not yet loaded
    return new Promise((resolve)=>{
        const eventListener = (/** @type {Event} */ event)=>{
            if (targetStates.includes(event.target.readyState)) {
                // DOM loaded
                doc.removeEventListener("readystatechange", eventListener);
                resolve(event.target);
            }
        };
        doc.addEventListener("readystatechange", eventListener);
    });
    return doc;
}
async function $fdc5c966c4323314$export$9cdcc5f0c3b8ebcc(id, doc = document) {
    /** @type {HTMLElement|null} */ let element;
    if (id instanceof HTMLElement) element = id;
    else {
        // Minimum document state: DOM loaded
        doc = await $fdc5c966c4323314$export$f44c3a30e8ef43c4(doc, "interactive");
        element = doc.getElementById(id);
        if (!element) return element; // Not found
    }
    // There is no good solution for scripts --> entire document should be loaded completely
    if (element instanceof HTMLScriptElement) return $fdc5c966c4323314$export$f44c3a30e8ef43c4(doc, "complete").then(()=>element);
    const objDocumentStates = [
        "inactive",
        "complete"
    ];
    const SVG_MIME = "image/svg+xml";
    if (!(element instanceof HTMLImageElement || element instanceof HTMLObjectElement) || // element without external source? --> done
    element instanceof HTMLImageElement && element.complete || // <-- for images
    element instanceof HTMLObjectElement && (!element.data || element.type === SVG_MIME && objDocumentStates.includes(element.getSVGDocument?.()?.readyState ?? "") || element.type !== SVG_MIME && objDocumentStates.includes(element.contentDocument?.readyState ?? ""))) return element;
    return new Promise((resolve)=>element.addEventListener("load", ()=>resolve(element), {
            once: true
        }));
}
function $fdc5c966c4323314$export$c8bc7152e4d4827d(element) {
    return new Promise((resolve)=>{
        if (element.children && element.children.length > 0) resolve(element);
        window.requestAnimationFrame(()=>$fdc5c966c4323314$export$c8bc7152e4d4827d(element).then(()=>resolve(element)));
    });
}


/**! 
 * hotkeys-js v3.13.7 
 * A simple micro-library for defining and dispatching keyboard shortcuts. It has no dependencies. 
 * 
 * Copyright (c) 2024 kenny wong <wowohoo@qq.com> 
 * https://github.com/jaywcjlove/hotkeys-js.git 
 * 
 * @website: https://jaywcjlove.github.io/hotkeys-js
 
 * Licensed under the MIT license 
 */ const $29d702d7ef9ce022$var$isff = typeof navigator !== "undefined" ? navigator.userAgent.toLowerCase().indexOf("firefox") > 0 : false;
// 绑定事件
function $29d702d7ef9ce022$var$addEvent(object, event, method, useCapture) {
    if (object.addEventListener) object.addEventListener(event, method, useCapture);
    else if (object.attachEvent) object.attachEvent("on".concat(event), method);
}
function $29d702d7ef9ce022$var$removeEvent(object, event, method, useCapture) {
    if (object.removeEventListener) object.removeEventListener(event, method, useCapture);
    else if (object.detachEvent) object.detachEvent("on".concat(event), method);
}
// 修饰键转换成对应的键码
function $29d702d7ef9ce022$var$getMods(modifier, key) {
    const mods = key.slice(0, key.length - 1);
    for(let i = 0; i < mods.length; i++)mods[i] = modifier[mods[i].toLowerCase()];
    return mods;
}
// 处理传的key字符串转换成数组
function $29d702d7ef9ce022$var$getKeys(key) {
    if (typeof key !== "string") key = "";
    key = key.replace(/\s/g, ""); // 匹配任何空白字符,包括空格、制表符、换页符等等
    const keys = key.split(","); // 同时设置多个快捷键，以','分割
    let index = keys.lastIndexOf("");
    // 快捷键可能包含','，需特殊处理
    for(; index >= 0;){
        keys[index - 1] += ",";
        keys.splice(index, 1);
        index = keys.lastIndexOf("");
    }
    return keys;
}
// 比较修饰键的数组
function $29d702d7ef9ce022$var$compareArray(a1, a2) {
    const arr1 = a1.length >= a2.length ? a1 : a2;
    const arr2 = a1.length >= a2.length ? a2 : a1;
    let isIndex = true;
    for(let i = 0; i < arr1.length; i++)if (arr2.indexOf(arr1[i]) === -1) isIndex = false;
    return isIndex;
}
// Special Keys
const $29d702d7ef9ce022$var$_keyMap = {
    backspace: 8,
    "\u232B": 8,
    tab: 9,
    clear: 12,
    enter: 13,
    "\u21A9": 13,
    return: 13,
    esc: 27,
    escape: 27,
    space: 32,
    left: 37,
    up: 38,
    right: 39,
    down: 40,
    del: 46,
    delete: 46,
    ins: 45,
    insert: 45,
    home: 36,
    end: 35,
    pageup: 33,
    pagedown: 34,
    capslock: 20,
    num_0: 96,
    num_1: 97,
    num_2: 98,
    num_3: 99,
    num_4: 100,
    num_5: 101,
    num_6: 102,
    num_7: 103,
    num_8: 104,
    num_9: 105,
    num_multiply: 106,
    num_add: 107,
    num_enter: 108,
    num_subtract: 109,
    num_decimal: 110,
    num_divide: 111,
    "\u21EA": 20,
    ",": 188,
    ".": 190,
    "/": 191,
    "`": 192,
    "-": $29d702d7ef9ce022$var$isff ? 173 : 189,
    "=": $29d702d7ef9ce022$var$isff ? 61 : 187,
    ";": $29d702d7ef9ce022$var$isff ? 59 : 186,
    "'": 222,
    "[": 219,
    "]": 221,
    "\\": 220
};
// Modifier Keys
const $29d702d7ef9ce022$var$_modifier = {
    // shiftKey
    "\u21E7": 16,
    shift: 16,
    // altKey
    "\u2325": 18,
    alt: 18,
    option: 18,
    // ctrlKey
    "\u2303": 17,
    ctrl: 17,
    control: 17,
    // metaKey
    "\u2318": 91,
    cmd: 91,
    command: 91
};
const $29d702d7ef9ce022$var$modifierMap = {
    16: "shiftKey",
    18: "altKey",
    17: "ctrlKey",
    91: "metaKey",
    shiftKey: 16,
    ctrlKey: 17,
    altKey: 18,
    metaKey: 91
};
const $29d702d7ef9ce022$var$_mods = {
    16: false,
    18: false,
    17: false,
    91: false
};
const $29d702d7ef9ce022$var$_handlers = {};
// F1~F12 special key
for(let k = 1; k < 20; k++)$29d702d7ef9ce022$var$_keyMap["f".concat(k)] = 111 + k;
let $29d702d7ef9ce022$var$_downKeys = []; // 记录摁下的绑定键
let $29d702d7ef9ce022$var$winListendFocus = null; // window是否已经监听了focus事件
let $29d702d7ef9ce022$var$_scope = "all"; // 默认热键范围
const $29d702d7ef9ce022$var$elementEventMap = new Map(); // 已绑定事件的节点记录
// 返回键码
const $29d702d7ef9ce022$var$code = (x)=>$29d702d7ef9ce022$var$_keyMap[x.toLowerCase()] || $29d702d7ef9ce022$var$_modifier[x.toLowerCase()] || x.toUpperCase().charCodeAt(0);
const $29d702d7ef9ce022$var$getKey = (x)=>Object.keys($29d702d7ef9ce022$var$_keyMap).find((k)=>$29d702d7ef9ce022$var$_keyMap[k] === x);
const $29d702d7ef9ce022$var$getModifier = (x)=>Object.keys($29d702d7ef9ce022$var$_modifier).find((k)=>$29d702d7ef9ce022$var$_modifier[k] === x);
// 设置获取当前范围（默认为'所有'）
function $29d702d7ef9ce022$var$setScope(scope) {
    $29d702d7ef9ce022$var$_scope = scope || "all";
}
// 获取当前范围
function $29d702d7ef9ce022$var$getScope() {
    return $29d702d7ef9ce022$var$_scope || "all";
}
// 获取摁下绑定键的键值
function $29d702d7ef9ce022$var$getPressedKeyCodes() {
    return $29d702d7ef9ce022$var$_downKeys.slice(0);
}
function $29d702d7ef9ce022$var$getPressedKeyString() {
    return $29d702d7ef9ce022$var$_downKeys.map((c)=>$29d702d7ef9ce022$var$getKey(c) || $29d702d7ef9ce022$var$getModifier(c) || String.fromCharCode(c));
}
function $29d702d7ef9ce022$var$getAllKeyCodes() {
    const result = [];
    Object.keys($29d702d7ef9ce022$var$_handlers).forEach((k)=>{
        $29d702d7ef9ce022$var$_handlers[k].forEach((_ref)=>{
            let { key: key, scope: scope, mods: mods, shortcut: shortcut } = _ref;
            result.push({
                scope: scope,
                shortcut: shortcut,
                mods: mods,
                keys: key.split("+").map((v)=>$29d702d7ef9ce022$var$code(v))
            });
        });
    });
    return result;
}
// 表单控件控件判断 返回 Boolean
// hotkey is effective only when filter return true
function $29d702d7ef9ce022$var$filter(event) {
    const target = event.target || event.srcElement;
    const { tagName: tagName } = target;
    let flag = true;
    const isInput = tagName === "INPUT" && ![
        "checkbox",
        "radio",
        "range",
        "button",
        "file",
        "reset",
        "submit",
        "color"
    ].includes(target.type);
    // ignore: isContentEditable === 'true', <input> and <textarea> when readOnly state is false, <select>
    if (target.isContentEditable || (isInput || tagName === "TEXTAREA" || tagName === "SELECT") && !target.readOnly) flag = false;
    return flag;
}
// 判断摁下的键是否为某个键，返回true或者false
function $29d702d7ef9ce022$var$isPressed(keyCode) {
    if (typeof keyCode === "string") keyCode = $29d702d7ef9ce022$var$code(keyCode); // 转换成键码
    return $29d702d7ef9ce022$var$_downKeys.indexOf(keyCode) !== -1;
}
// 循环删除handlers中的所有 scope(范围)
function $29d702d7ef9ce022$var$deleteScope(scope, newScope) {
    let handlers;
    let i;
    // 没有指定scope，获取scope
    if (!scope) scope = $29d702d7ef9ce022$var$getScope();
    for(const key in $29d702d7ef9ce022$var$_handlers)if (Object.prototype.hasOwnProperty.call($29d702d7ef9ce022$var$_handlers, key)) {
        handlers = $29d702d7ef9ce022$var$_handlers[key];
        for(i = 0; i < handlers.length;)if (handlers[i].scope === scope) {
            const deleteItems = handlers.splice(i, 1);
            deleteItems.forEach((_ref2)=>{
                let { element: element } = _ref2;
                return $29d702d7ef9ce022$var$removeKeyEvent(element);
            });
        } else i++;
    }
    // 如果scope被删除，将scope重置为all
    if ($29d702d7ef9ce022$var$getScope() === scope) $29d702d7ef9ce022$var$setScope(newScope || "all");
}
// 清除修饰键
function $29d702d7ef9ce022$var$clearModifier(event) {
    let key = event.keyCode || event.which || event.charCode;
    const i = $29d702d7ef9ce022$var$_downKeys.indexOf(key);
    // 从列表中清除按压过的键
    if (i >= 0) $29d702d7ef9ce022$var$_downKeys.splice(i, 1);
    // 特殊处理 cmmand 键，在 cmmand 组合快捷键 keyup 只执行一次的问题
    if (event.key && event.key.toLowerCase() === "meta") $29d702d7ef9ce022$var$_downKeys.splice(0, $29d702d7ef9ce022$var$_downKeys.length);
    // 修饰键 shiftKey altKey ctrlKey (command||metaKey) 清除
    if (key === 93 || key === 224) key = 91;
    if (key in $29d702d7ef9ce022$var$_mods) {
        $29d702d7ef9ce022$var$_mods[key] = false;
        // 将修饰键重置为false
        for(const k in $29d702d7ef9ce022$var$_modifier)if ($29d702d7ef9ce022$var$_modifier[k] === key) $29d702d7ef9ce022$export$2e2bcd8739ae039[k] = false;
    }
}
function $29d702d7ef9ce022$var$unbind(keysInfo) {
    // unbind(), unbind all keys
    if (typeof keysInfo === "undefined") {
        Object.keys($29d702d7ef9ce022$var$_handlers).forEach((key)=>{
            Array.isArray($29d702d7ef9ce022$var$_handlers[key]) && $29d702d7ef9ce022$var$_handlers[key].forEach((info)=>$29d702d7ef9ce022$var$eachUnbind(info));
            delete $29d702d7ef9ce022$var$_handlers[key];
        });
        $29d702d7ef9ce022$var$removeKeyEvent(null);
    } else if (Array.isArray(keysInfo)) // support like : unbind([{key: 'ctrl+a', scope: 's1'}, {key: 'ctrl-a', scope: 's2', splitKey: '-'}])
    keysInfo.forEach((info)=>{
        if (info.key) $29d702d7ef9ce022$var$eachUnbind(info);
    });
    else if (typeof keysInfo === "object") // support like unbind({key: 'ctrl+a, ctrl+b', scope:'abc'})
    {
        if (keysInfo.key) $29d702d7ef9ce022$var$eachUnbind(keysInfo);
    } else if (typeof keysInfo === "string") {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        // support old method
        // eslint-disable-line
        let [scope, method] = args;
        if (typeof scope === "function") {
            method = scope;
            scope = "";
        }
        $29d702d7ef9ce022$var$eachUnbind({
            key: keysInfo,
            scope: scope,
            method: method,
            splitKey: "+"
        });
    }
}
// 解除绑定某个范围的快捷键
const $29d702d7ef9ce022$var$eachUnbind = (_ref3)=>{
    let { key: key, scope: scope, method: method, splitKey: splitKey = "+" } = _ref3;
    const multipleKeys = $29d702d7ef9ce022$var$getKeys(key);
    multipleKeys.forEach((originKey)=>{
        const unbindKeys = originKey.split(splitKey);
        const len = unbindKeys.length;
        const lastKey = unbindKeys[len - 1];
        const keyCode = lastKey === "*" ? "*" : $29d702d7ef9ce022$var$code(lastKey);
        if (!$29d702d7ef9ce022$var$_handlers[keyCode]) return;
        // 判断是否传入范围，没有就获取范围
        if (!scope) scope = $29d702d7ef9ce022$var$getScope();
        const mods = len > 1 ? $29d702d7ef9ce022$var$getMods($29d702d7ef9ce022$var$_modifier, unbindKeys) : [];
        const unbindElements = [];
        $29d702d7ef9ce022$var$_handlers[keyCode] = $29d702d7ef9ce022$var$_handlers[keyCode].filter((record)=>{
            // 通过函数判断，是否解除绑定，函数相等直接返回
            const isMatchingMethod = method ? record.method === method : true;
            const isUnbind = isMatchingMethod && record.scope === scope && $29d702d7ef9ce022$var$compareArray(record.mods, mods);
            if (isUnbind) unbindElements.push(record.element);
            return !isUnbind;
        });
        unbindElements.forEach((element)=>$29d702d7ef9ce022$var$removeKeyEvent(element));
    });
};
// 对监听对应快捷键的回调函数进行处理
function $29d702d7ef9ce022$var$eventHandler(event, handler, scope, element) {
    if (handler.element !== element) return;
    let modifiersMatch;
    // 看它是否在当前范围
    if (handler.scope === scope || handler.scope === "all") {
        // 检查是否匹配修饰符（如果有返回true）
        modifiersMatch = handler.mods.length > 0;
        for(const y in $29d702d7ef9ce022$var$_mods){
            if (Object.prototype.hasOwnProperty.call($29d702d7ef9ce022$var$_mods, y)) {
                if (!$29d702d7ef9ce022$var$_mods[y] && handler.mods.indexOf(+y) > -1 || $29d702d7ef9ce022$var$_mods[y] && handler.mods.indexOf(+y) === -1) modifiersMatch = false;
            }
        }
        // 调用处理程序，如果是修饰键不做处理
        if (handler.mods.length === 0 && !$29d702d7ef9ce022$var$_mods[16] && !$29d702d7ef9ce022$var$_mods[18] && !$29d702d7ef9ce022$var$_mods[17] && !$29d702d7ef9ce022$var$_mods[91] || modifiersMatch || handler.shortcut === "*") {
            handler.keys = [];
            handler.keys = handler.keys.concat($29d702d7ef9ce022$var$_downKeys);
            if (handler.method(event, handler) === false) {
                if (event.preventDefault) event.preventDefault();
                else event.returnValue = false;
                if (event.stopPropagation) event.stopPropagation();
                if (event.cancelBubble) event.cancelBubble = true;
            }
        }
    }
}
// 处理keydown事件
function $29d702d7ef9ce022$var$dispatch(event, element) {
    const asterisk = $29d702d7ef9ce022$var$_handlers["*"];
    let key = event.keyCode || event.which || event.charCode;
    // 表单控件过滤 默认表单控件不触发快捷键
    if (!$29d702d7ef9ce022$export$2e2bcd8739ae039.filter.call(this, event)) return;
    // Gecko(Firefox)的command键值224，在Webkit(Chrome)中保持一致
    // Webkit左右 command 键值不一样
    if (key === 93 || key === 224) key = 91;
    /**
   * Collect bound keys
   * If an Input Method Editor is processing key input and the event is keydown, return 229.
   * https://stackoverflow.com/questions/25043934/is-it-ok-to-ignore-keydown-events-with-keycode-229
   * http://lists.w3.org/Archives/Public/www-dom/2010JulSep/att-0182/keyCode-spec.html
   */ if ($29d702d7ef9ce022$var$_downKeys.indexOf(key) === -1 && key !== 229) $29d702d7ef9ce022$var$_downKeys.push(key);
    /**
   * Jest test cases are required.
   * ===============================
   */ [
        "ctrlKey",
        "altKey",
        "shiftKey",
        "metaKey"
    ].forEach((keyName)=>{
        const keyNum = $29d702d7ef9ce022$var$modifierMap[keyName];
        if (event[keyName] && $29d702d7ef9ce022$var$_downKeys.indexOf(keyNum) === -1) $29d702d7ef9ce022$var$_downKeys.push(keyNum);
        else if (!event[keyName] && $29d702d7ef9ce022$var$_downKeys.indexOf(keyNum) > -1) $29d702d7ef9ce022$var$_downKeys.splice($29d702d7ef9ce022$var$_downKeys.indexOf(keyNum), 1);
        else if (keyName === "metaKey" && event[keyName] && $29d702d7ef9ce022$var$_downKeys.length === 3) /**
       * Fix if Command is pressed:
       * ===============================
       */ {
            if (!(event.ctrlKey || event.shiftKey || event.altKey)) $29d702d7ef9ce022$var$_downKeys = $29d702d7ef9ce022$var$_downKeys.slice($29d702d7ef9ce022$var$_downKeys.indexOf(keyNum));
        }
    });
    /**
   * -------------------------------
   */ if (key in $29d702d7ef9ce022$var$_mods) {
        $29d702d7ef9ce022$var$_mods[key] = true;
        // 将特殊字符的key注册到 hotkeys 上
        for(const k in $29d702d7ef9ce022$var$_modifier)if ($29d702d7ef9ce022$var$_modifier[k] === key) $29d702d7ef9ce022$export$2e2bcd8739ae039[k] = true;
        if (!asterisk) return;
    }
    // 将 modifierMap 里面的修饰键绑定到 event 中
    for(const e in $29d702d7ef9ce022$var$_mods)if (Object.prototype.hasOwnProperty.call($29d702d7ef9ce022$var$_mods, e)) $29d702d7ef9ce022$var$_mods[e] = event[$29d702d7ef9ce022$var$modifierMap[e]];
    /**
   * https://github.com/jaywcjlove/hotkeys/pull/129
   * This solves the issue in Firefox on Windows where hotkeys corresponding to special characters would not trigger.
   * An example of this is ctrl+alt+m on a Swedish keyboard which is used to type μ.
   * Browser support: https://caniuse.com/#feat=keyboardevent-getmodifierstate
   */ if (event.getModifierState && !(event.altKey && !event.ctrlKey) && event.getModifierState("AltGraph")) {
        if ($29d702d7ef9ce022$var$_downKeys.indexOf(17) === -1) $29d702d7ef9ce022$var$_downKeys.push(17);
        if ($29d702d7ef9ce022$var$_downKeys.indexOf(18) === -1) $29d702d7ef9ce022$var$_downKeys.push(18);
        $29d702d7ef9ce022$var$_mods[17] = true;
        $29d702d7ef9ce022$var$_mods[18] = true;
    }
    // 获取范围 默认为 `all`
    const scope = $29d702d7ef9ce022$var$getScope();
    // 对任何快捷键都需要做的处理
    if (asterisk) {
        for(let i = 0; i < asterisk.length; i++)if (asterisk[i].scope === scope && (event.type === "keydown" && asterisk[i].keydown || event.type === "keyup" && asterisk[i].keyup)) $29d702d7ef9ce022$var$eventHandler(event, asterisk[i], scope, element);
    }
    // key 不在 _handlers 中返回
    if (!(key in $29d702d7ef9ce022$var$_handlers)) return;
    const handlerKey = $29d702d7ef9ce022$var$_handlers[key];
    const keyLen = handlerKey.length;
    for(let i = 0; i < keyLen; i++){
        if (event.type === "keydown" && handlerKey[i].keydown || event.type === "keyup" && handlerKey[i].keyup) {
            if (handlerKey[i].key) {
                const record = handlerKey[i];
                const { splitKey: splitKey } = record;
                const keyShortcut = record.key.split(splitKey);
                const _downKeysCurrent = []; // 记录当前按键键值
                for(let a = 0; a < keyShortcut.length; a++)_downKeysCurrent.push($29d702d7ef9ce022$var$code(keyShortcut[a]));
                if (_downKeysCurrent.sort().join("") === $29d702d7ef9ce022$var$_downKeys.sort().join("")) // 找到处理内容
                $29d702d7ef9ce022$var$eventHandler(event, record, scope, element);
            }
        }
    }
}
function $29d702d7ef9ce022$export$2e2bcd8739ae039(key, option, method) {
    $29d702d7ef9ce022$var$_downKeys = [];
    const keys = $29d702d7ef9ce022$var$getKeys(key); // 需要处理的快捷键列表
    let mods = [];
    let scope = "all"; // scope默认为all，所有范围都有效
    let element = document; // 快捷键事件绑定节点
    let i = 0;
    let keyup = false;
    let keydown = true;
    let splitKey = "+";
    let capture = false;
    let single = false; // 单个callback
    // 对为设定范围的判断
    if (method === undefined && typeof option === "function") method = option;
    if (Object.prototype.toString.call(option) === "[object Object]") {
        if (option.scope) scope = option.scope; // eslint-disable-line
        if (option.element) element = option.element; // eslint-disable-line
        if (option.keyup) keyup = option.keyup; // eslint-disable-line
        if (option.keydown !== undefined) keydown = option.keydown; // eslint-disable-line
        if (option.capture !== undefined) capture = option.capture; // eslint-disable-line
        if (typeof option.splitKey === "string") splitKey = option.splitKey; // eslint-disable-line
        if (option.single === true) single = true; // eslint-disable-line
    }
    if (typeof option === "string") scope = option;
    // 如果只允许单个callback，先unbind
    if (single) $29d702d7ef9ce022$var$unbind(key, scope);
    // 对于每个快捷键进行处理
    for(; i < keys.length; i++){
        key = keys[i].split(splitKey); // 按键列表
        mods = [];
        // 如果是组合快捷键取得组合快捷键
        if (key.length > 1) mods = $29d702d7ef9ce022$var$getMods($29d702d7ef9ce022$var$_modifier, key);
        // 将非修饰键转化为键码
        key = key[key.length - 1];
        key = key === "*" ? "*" : $29d702d7ef9ce022$var$code(key); // *表示匹配所有快捷键
        // 判断key是否在_handlers中，不在就赋一个空数组
        if (!(key in $29d702d7ef9ce022$var$_handlers)) $29d702d7ef9ce022$var$_handlers[key] = [];
        $29d702d7ef9ce022$var$_handlers[key].push({
            keyup: keyup,
            keydown: keydown,
            scope: scope,
            mods: mods,
            shortcut: keys[i],
            method: method,
            key: keys[i],
            splitKey: splitKey,
            element: element
        });
    }
    // 在全局document上设置快捷键
    if (typeof element !== "undefined" && window) {
        if (!$29d702d7ef9ce022$var$elementEventMap.has(element)) {
            const keydownListener = function() {
                let event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.event;
                return $29d702d7ef9ce022$var$dispatch(event, element);
            };
            const keyupListenr = function() {
                let event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.event;
                $29d702d7ef9ce022$var$dispatch(event, element);
                $29d702d7ef9ce022$var$clearModifier(event);
            };
            $29d702d7ef9ce022$var$elementEventMap.set(element, {
                keydownListener: keydownListener,
                keyupListenr: keyupListenr,
                capture: capture
            });
            $29d702d7ef9ce022$var$addEvent(element, "keydown", keydownListener, capture);
            $29d702d7ef9ce022$var$addEvent(element, "keyup", keyupListenr, capture);
        }
        if (!$29d702d7ef9ce022$var$winListendFocus) {
            const listener = ()=>{
                $29d702d7ef9ce022$var$_downKeys = [];
            };
            $29d702d7ef9ce022$var$winListendFocus = {
                listener: listener,
                capture: capture
            };
            $29d702d7ef9ce022$var$addEvent(window, "focus", listener, capture);
        }
    }
}
function $29d702d7ef9ce022$var$trigger(shortcut) {
    let scope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "all";
    Object.keys($29d702d7ef9ce022$var$_handlers).forEach((key)=>{
        const dataList = $29d702d7ef9ce022$var$_handlers[key].filter((item)=>item.scope === scope && item.shortcut === shortcut);
        dataList.forEach((data)=>{
            if (data && data.method) data.method();
        });
    });
}
// 销毁事件,unbind之后判断element上是否还有键盘快捷键，如果没有移除监听
function $29d702d7ef9ce022$var$removeKeyEvent(element) {
    const values = Object.values($29d702d7ef9ce022$var$_handlers).flat();
    const findindex = values.findIndex((_ref4)=>{
        let { element: el } = _ref4;
        return el === element;
    });
    if (findindex < 0) {
        const { keydownListener: keydownListener, keyupListenr: keyupListenr, capture: capture } = $29d702d7ef9ce022$var$elementEventMap.get(element) || {};
        if (keydownListener && keyupListenr) {
            $29d702d7ef9ce022$var$removeEvent(element, "keyup", keyupListenr, capture);
            $29d702d7ef9ce022$var$removeEvent(element, "keydown", keydownListener, capture);
            $29d702d7ef9ce022$var$elementEventMap.delete(element);
        }
    }
    if (values.length <= 0 || $29d702d7ef9ce022$var$elementEventMap.size <= 0) {
        // 移除所有的元素上的监听
        const eventKeys = Object.keys($29d702d7ef9ce022$var$elementEventMap);
        eventKeys.forEach((el)=>{
            const { keydownListener: keydownListener, keyupListenr: keyupListenr, capture: capture } = $29d702d7ef9ce022$var$elementEventMap.get(el) || {};
            if (keydownListener && keyupListenr) {
                $29d702d7ef9ce022$var$removeEvent(el, "keyup", keyupListenr, capture);
                $29d702d7ef9ce022$var$removeEvent(el, "keydown", keydownListener, capture);
                $29d702d7ef9ce022$var$elementEventMap.delete(el);
            }
        });
        // 清空 elementEventMap
        $29d702d7ef9ce022$var$elementEventMap.clear();
        // 清空 _handlers
        Object.keys($29d702d7ef9ce022$var$_handlers).forEach((key)=>delete $29d702d7ef9ce022$var$_handlers[key]);
        // 移除window上的focus监听
        if ($29d702d7ef9ce022$var$winListendFocus) {
            const { listener: listener, capture: capture } = $29d702d7ef9ce022$var$winListendFocus;
            $29d702d7ef9ce022$var$removeEvent(window, "focus", listener, capture);
            $29d702d7ef9ce022$var$winListendFocus = null;
        }
    }
}
const $29d702d7ef9ce022$var$_api = {
    getPressedKeyString: $29d702d7ef9ce022$var$getPressedKeyString,
    setScope: $29d702d7ef9ce022$var$setScope,
    getScope: $29d702d7ef9ce022$var$getScope,
    deleteScope: $29d702d7ef9ce022$var$deleteScope,
    getPressedKeyCodes: $29d702d7ef9ce022$var$getPressedKeyCodes,
    getAllKeyCodes: $29d702d7ef9ce022$var$getAllKeyCodes,
    isPressed: $29d702d7ef9ce022$var$isPressed,
    filter: $29d702d7ef9ce022$var$filter,
    trigger: $29d702d7ef9ce022$var$trigger,
    unbind: $29d702d7ef9ce022$var$unbind,
    keyMap: $29d702d7ef9ce022$var$_keyMap,
    modifier: $29d702d7ef9ce022$var$_modifier,
    modifierMap: $29d702d7ef9ce022$var$modifierMap
};
for(const a in $29d702d7ef9ce022$var$_api)if (Object.prototype.hasOwnProperty.call($29d702d7ef9ce022$var$_api, a)) $29d702d7ef9ce022$export$2e2bcd8739ae039[a] = $29d702d7ef9ce022$var$_api[a];
if (typeof window !== "undefined") {
    const _hotkeys = window.hotkeys;
    $29d702d7ef9ce022$export$2e2bcd8739ae039.noConflict = (deep)=>{
        if (deep && window.hotkeys === $29d702d7ef9ce022$export$2e2bcd8739ae039) window.hotkeys = _hotkeys;
        return $29d702d7ef9ce022$export$2e2bcd8739ae039;
    };
    window.hotkeys = $29d702d7ef9ce022$export$2e2bcd8739ae039;
}


var $47d4700db3a3167c$exports = {};
$47d4700db3a3167c$exports = JSON.parse('{"name":"circutikz-pwa","version":"0.6.0","private":"true","description":"A GUI for drawing CircuiTikZ circuits","license":"GPL-3.0-only","author":"Manuel Kirzinger","contributors":[{"name":"Philipp Wiedemann","email":"jan.p.wiedemann@fau.de"},{"name":"Christof Pfannenm\xfcller","email":"christof.pfannenmueller@fau.de"}],"source":"src/pages/index.html","main":"src/scripts/main.js","targets":{"main":false},"scripts":{"build":"parcel build --public-url ./","html-lint":"scripts/validateHTML.mjs","lint":"npm run prettier-lint && npm run html-lint","prepack":"npm run build","prettier-lint":"prettier --check --config .prettierrc --log-level log \'**/*.{js,ts,mjs,cjs,json,jsonc,html,htm,css,scss,xml,xsd,svg}\'","start":"parcel serve --lazy","standalone":"electron-forge start","electron":"npm run build && electron .","package":"electron-forge package","make":"electron-forge make"},"browserslist":"> 0.5%, last 2 versions, not dead","dependencies":{"@prettier/plugin-xml":"^3.4.1","@svgdotjs/svg.draggable.js":"^3.0.4","@svgdotjs/svg.js":"^3.2.4","@svgdotjs/svg.panzoom.js":"^2.1.2","bootstrap":"^5.3.2","electron-squirrel-startup":"^1.0.1","file-saver":"^2.0.5","hotkeys-js":"^3.13.7","mdb-ui-kit":"^6.4.2","prettier":"^3.3.3","sanitize-html":"^2.13.1"},"devDependencies":{"@electron-forge/cli":"^7.5.0","@electron-forge/maker-deb":"^7.5.0","@electron-forge/maker-rpm":"^7.5.0","@electron-forge/maker-squirrel":"^7.5.0","@electron-forge/maker-wix":"^7.5.0","@electron-forge/maker-zip":"^7.5.0","@electron-forge/plugin-auto-unpack-natives":"^7.5.0","@electron-forge/plugin-fuses":"^7.5.0","@electron/fuses":"^1.8.0","@parcel/config-default":"^2.9.3","@parcel/packager-raw-url":"^2.10.3","@parcel/plugin":"^2.9.3","@parcel/transformer-css":"^2.9.3","@parcel/transformer-html":"^2.9.3","@parcel/transformer-js":"^2.9.3","@parcel/transformer-posthtml":"^2.9.3","@parcel/transformer-sass":"^2.9.3","@parcel/transformer-svg":"^2.9.3","@parcel/transformer-typescript-tsc":"^2.12.0","@parcel/transformer-webmanifest":"^2.10.3","@parcel/transformer-xml":"^2.9.3","@types/bootstrap":"^5.2.8","@types/file-saver":"^2.0.7","@types/html-validator":"^5.0.5","electron":"^33.2.0","buffer":"^6.0.3","html-validator":"^6.0.1","parcel":"^2.9.3","posthtml-include":"^1.7.4","sass":"^1.68.0","typescript":"^5.6.3"}}');



var $177c4dcfaec5a17b$export$43660d87cb080eb;
(function(Modes) {
    Modes[Modes["DRAG_PAN"] = 0] = "DRAG_PAN";
    Modes[Modes["COMPONENT"] = 1] = "COMPONENT";
    Modes[Modes["ERASE"] = 2] = "ERASE";
})($177c4dcfaec5a17b$export$43660d87cb080eb || ($177c4dcfaec5a17b$export$43660d87cb080eb = {}));
class $177c4dcfaec5a17b$export$c323639e70153a25 {
    static _instance;
    static get instance() {
        if (!$177c4dcfaec5a17b$export$c323639e70153a25._instance) $177c4dcfaec5a17b$export$c323639e70153a25._instance = new $177c4dcfaec5a17b$export$c323639e70153a25();
        return $177c4dcfaec5a17b$export$c323639e70153a25._instance;
    }
    // controllers
    canvasController;
    symbolsSVG;
    symbols;
    darkMode = true;
    darkModeLast = true;
    currentTheme = "dark";
    tabID = -1;
    mode = $177c4dcfaec5a17b$export$43660d87cb080eb.DRAG_PAN;
    modeSwitchButtons = {
        modeDragPan: null,
        modeDrawLine: null,
        modeEraser: null
    };
    initPromise;
    isInitDone = false;
    circuitComponents = [];
    // instances: ComponentInstance[] = [];
    // lines: Line[] = [];
    static appVersion = "0.0.0";
    isMac = false;
    selectionController;
    /**
     * Init the app.
     */ constructor(){
        $177c4dcfaec5a17b$export$c323639e70153a25._instance = this;
        this.isMac = window.navigator.userAgent.toUpperCase().indexOf("MAC") >= 0;
        this.addSaveStateManagement();
        // dark mode init
        const htmlElement = document.documentElement;
        const switchElement = document.getElementById("darkModeSwitch");
        const defaultTheme = window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
        this.currentTheme = localStorage.getItem("circuitikz-designer-theme") || defaultTheme;
        htmlElement.setAttribute("data-bs-theme", this.currentTheme);
        this.darkModeLast = false;
        this.darkMode = this.currentTheme === "dark";
        switchElement.checked = this.darkMode;
        let mathJaxPromise = this.loadMathJax();
        let canvasPromise = this.initCanvas();
        let symbolsDBPromise = this.initSymbolDB();
        $177c4dcfaec5a17b$export$c323639e70153a25.appVersion = (0, $47d4700db3a3167c$exports.version);
        document.addEventListener("DOMContentLoaded", ()=>{
            for (const element of document.getElementsByClassName("version"))element.textContent = "v" + (0, $47d4700db3a3167c$exports.version);
        });
        this.initModeButtons();
        var isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;
        //enable tooltips globally
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"],[data-bs-toggle-second="tooltip"]');
        if (isMobile) {
            const tooltipList = [
                ...tooltipTriggerList
            ].map((tooltipTriggerEl)=>new (0, $9c6c83c6a450e1f8$export$28c660c63b792dea)(tooltipTriggerEl, {
                    fallbackPlacements: [],
                    trigger: "manual"
                }));
        } else {
            const tooltipList = [
                ...tooltipTriggerList
            ].map((tooltipTriggerEl)=>new (0, $9c6c83c6a450e1f8$export$28c660c63b792dea)(tooltipTriggerEl, {
                    fallbackPlacements: []
                }));
        }
        // init exporting
        (0, $fc0737f7a4e7c327$export$96be6e195c19e554).instance;
        const exportCircuiTikZButton = document.getElementById("exportCircuiTikZButton");
        exportCircuiTikZButton.addEventListener("click", (0, $fc0737f7a4e7c327$export$96be6e195c19e554).instance.exportCircuiTikZ.bind((0, $fc0737f7a4e7c327$export$96be6e195c19e554).instance), {
            passive: true
        });
        const exportSVGButton = document.getElementById("exportSVGButton");
        exportSVGButton.addEventListener("click", (0, $fc0737f7a4e7c327$export$96be6e195c19e554).instance.exportSVG.bind((0, $fc0737f7a4e7c327$export$96be6e195c19e554).instance), {
            passive: true
        });
        // init save and load
        (0, $e74b421401bcd19c$export$e94a9bf0a1c3ce0b).instance;
        const saveButton = document.getElementById("saveButton");
        saveButton.addEventListener("click", (0, $e74b421401bcd19c$export$e94a9bf0a1c3ce0b).instance.save.bind((0, $e74b421401bcd19c$export$e94a9bf0a1c3ce0b).instance), {
            passive: true
        });
        const loadButton = document.getElementById("loadButton");
        loadButton.addEventListener("click", (0, $e74b421401bcd19c$export$e94a9bf0a1c3ce0b).instance.load.bind((0, $e74b421401bcd19c$export$e94a9bf0a1c3ce0b).instance), {
            passive: true
        });
        canvasPromise.then(()=>{
            (0, $7408c040b0c84b17$export$2933b4fdbb8e5219).instance;
            (0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance;
            (0, $49e4d67b0180648f$export$b621f8acc59d25dc).instance;
            (0, $08259c81b533024d$export$c564803d81ad3eaf).instance;
        });
        this.initPromise = Promise.all([
            canvasPromise,
            symbolsDBPromise,
            mathJaxPromise
        ]).then(()=>{
            document.getElementById("loadingSpinner")?.classList.add("d-none");
            (0, $a0a429836785e44a$export$5d153f96fe924d6e).instance;
            this.initAddComponentOffcanvas();
            this.initShortcuts();
            // Prevent "normal" browser menu
            document.getElementById("canvas").addEventListener("contextmenu", (evt)=>evt.preventDefault(), {
                passive: false
            });
            let currentProgress = JSON.parse(localStorage.getItem("circuitikz-designer-saveState"));
            if (Object.keys(currentProgress.currentData[this.tabID]).length > 0) (0, $e74b421401bcd19c$export$e94a9bf0a1c3ce0b).instance.loadFromJSON(currentProgress.currentData[this.tabID]);
            else (0, $815383aeedb00f00$export$897c9ed706d8ea48).addState();
            // prepare symbolDB for colorTheme
            for (const g of this.symbolsSVG.defs().node.querySelectorAll("symbol>g"))this.preprocessSymbolColors(g);
            const htmlElement = document.documentElement;
            const switchElement = document.getElementById("darkModeSwitch");
            switchElement.addEventListener("change", function() {
                if ($177c4dcfaec5a17b$export$c323639e70153a25.instance.darkMode = switchElement.checked) {
                    htmlElement.setAttribute("data-bs-theme", "dark");
                    localStorage.setItem("circuitikz-designer-theme", "dark");
                } else {
                    htmlElement.setAttribute("data-bs-theme", "light");
                    localStorage.setItem("circuitikz-designer-theme", "light");
                }
                $177c4dcfaec5a17b$export$c323639e70153a25.instance.updateTheme();
            });
            $177c4dcfaec5a17b$export$c323639e70153a25.instance.updateTheme();
            (0, $49e4d67b0180648f$export$b621f8acc59d25dc).instance.update();
            this.isInitDone = true;
        });
    }
    async loadMathJax() {
        var promise = new Promise((resolve)=>{
            if (!("MathJax" in window)) window.MathJax = {
                tex: {
                    inlineMath: {
                        "[+]": [
                            [
                                "$",
                                "$"
                            ]
                        ]
                    }
                }
            };
            var script = document.createElement("script");
            script.src = "https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-svg.js";
            document.head.appendChild(script);
            script.addEventListener("load", function() {
                resolve("");
            }, false);
        });
        return promise;
    }
    /**
     * make it possible to open multiple tabs and all with different save States.
     */ addSaveStateManagement() {
        const objname = "circuitikz-designer-saveState";
        const tabname = "circuitikz-designer-tabID";
        let defaultProgress = {
            currentIndices: [],
            currentData: []
        };
        // TODO check if multithreading of tabs can mess with localStorage due to a race condition???
        // load localStorage or default if it doesn't exist
        let storageString = localStorage.getItem(objname);
        let current = storageString ? JSON.parse(storageString) : defaultProgress;
        // load the tab ID if reopening the page was a reload/restore (sessionStorage persists in that case)
        let sessionTabID = sessionStorage.getItem(tabname);
        if (sessionTabID) {
            this.tabID = Number.parseInt(sessionTabID);
            current.currentIndices.push(this.tabID);
        }
        // this is a new tab --> assign tab ID
        if (this.tabID < 0) {
            // populate first available slot
            let index = 0;
            while(current.currentIndices.includes(index))index++;
            this.tabID = index;
            current.currentIndices.push(this.tabID);
        }
        // save the assigned tab ID
        sessionStorage.setItem(tabname, this.tabID.toString());
        // adjust the saveData object to accomodate new data if necessary
        if (current.currentData.length <= this.tabID) current.currentData.push([]);
        // save the current state of tabs
        localStorage.setItem(objname, JSON.stringify(current));
        //TODO get rid of unload events: will be removed from chrome in the future and is currently ignored by many browsers
        // prepare saveState for unloading
        window.addEventListener("beforeunload", (ev)=>{
            (0, $815383aeedb00f00$export$897c9ed706d8ea48).addState();
            let currentProgress = JSON.parse(localStorage.getItem(objname));
            currentProgress.currentIndices.splice(currentProgress.currentIndices.findIndex((value)=>value == $177c4dcfaec5a17b$export$c323639e70153a25.instance.tabID), 1);
            currentProgress.currentData[this.tabID] = (0, $815383aeedb00f00$export$897c9ed706d8ea48).getCurrentState();
            localStorage.setItem(objname, JSON.stringify(currentProgress));
        //use this here if the localStorage is fucked in development
        // localStorage.removeItem(objname)
        // localStorage.removeItem(tabname)
        //TODO add manual way to clear the localStorage
        });
    }
    /**
     * initialises keyboard shortcuts
     */ initShortcuts() {
        // stop reload behaviour
        (0, $29d702d7ef9ce022$export$2e2bcd8739ae039)("ctrl+r,command+r", ()=>false);
        // rotate selection
        (0, $29d702d7ef9ce022$export$2e2bcd8739ae039)("ctrl+r,command+r", ()=>{
            if (this.mode == $177c4dcfaec5a17b$export$43660d87cb080eb.COMPONENT) (0, $08259c81b533024d$export$c564803d81ad3eaf).instance.placeRotate(-90);
            else if ((0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.hasSelection()) {
                (0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.rotateSelection(-90);
                (0, $815383aeedb00f00$export$897c9ed706d8ea48).addState();
            }
            return false;
        });
        (0, $29d702d7ef9ce022$export$2e2bcd8739ae039)("ctrl+shift+r,command+shift+r", ()=>{
            if (this.mode == $177c4dcfaec5a17b$export$43660d87cb080eb.COMPONENT) (0, $08259c81b533024d$export$c564803d81ad3eaf).instance.placeRotate(90);
            else if ((0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.hasSelection()) {
                (0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.rotateSelection(90);
                (0, $815383aeedb00f00$export$897c9ed706d8ea48).addState();
            }
            return false;
        });
        //flip selection
        (0, $29d702d7ef9ce022$export$2e2bcd8739ae039)("shift+x", ()=>{
            if (this.mode == $177c4dcfaec5a17b$export$43660d87cb080eb.COMPONENT) (0, $08259c81b533024d$export$c564803d81ad3eaf).instance.placeFlip(true);
            else if ((0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.hasSelection()) {
                (0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.flipSelection(true);
                (0, $815383aeedb00f00$export$897c9ed706d8ea48).addState();
            }
            return false;
        });
        (0, $29d702d7ef9ce022$export$2e2bcd8739ae039)("shift+y", ()=>{
            if (this.mode == $177c4dcfaec5a17b$export$43660d87cb080eb.COMPONENT) (0, $08259c81b533024d$export$c564803d81ad3eaf).instance.placeFlip(false);
            else if ((0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.hasSelection()) {
                (0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.flipSelection(false);
                (0, $815383aeedb00f00$export$897c9ed706d8ea48).addState();
            }
            return false;
        });
        // select everything
        (0, $29d702d7ef9ce022$export$2e2bcd8739ae039)("ctrl+a,command+a", ()=>{
            (0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.selectAll();
            return false;
        });
        //undo/redo
        (0, $29d702d7ef9ce022$export$2e2bcd8739ae039)("ctrl+z,command+z", ()=>{
            (0, $815383aeedb00f00$export$897c9ed706d8ea48).undo();
            return false;
        });
        (0, $29d702d7ef9ce022$export$2e2bcd8739ae039)("ctrl+y,command+y", ()=>{
            (0, $815383aeedb00f00$export$897c9ed706d8ea48).redo();
            return false;
        });
        document.getElementById("undoButton").addEventListener("click", ()=>(0, $815383aeedb00f00$export$897c9ed706d8ea48).undo());
        document.getElementById("redoButton").addEventListener("click", ()=>(0, $815383aeedb00f00$export$897c9ed706d8ea48).redo());
        //copy/paste
        (0, $29d702d7ef9ce022$export$2e2bcd8739ae039)("ctrl+c,command+c", ()=>{
            (0, $08dc73dda964bc6a$export$726cc87d253ab418).copy();
            return false;
        });
        (0, $29d702d7ef9ce022$export$2e2bcd8739ae039)("ctrl+v,command+v", ()=>{
            (0, $08dc73dda964bc6a$export$726cc87d253ab418).paste();
            return false;
        });
        (0, $29d702d7ef9ce022$export$2e2bcd8739ae039)("ctrl+x,command+x", ()=>{
            (0, $08dc73dda964bc6a$export$726cc87d253ab418).cut();
            return false;
        });
        //save/load
        (0, $29d702d7ef9ce022$export$2e2bcd8739ae039)("ctrl+s,command+s", ()=>{
            (0, $e74b421401bcd19c$export$e94a9bf0a1c3ce0b).instance.save();
            return false;
        });
        (0, $29d702d7ef9ce022$export$2e2bcd8739ae039)("ctrl+o,command+o", ()=>{
            (0, $e74b421401bcd19c$export$e94a9bf0a1c3ce0b).instance.load();
            return false;
        });
        (0, $29d702d7ef9ce022$export$2e2bcd8739ae039)("ctrl+e,command+e", ()=>{
            (0, $fc0737f7a4e7c327$export$96be6e195c19e554).instance.exportCircuiTikZ();
            return false;
        });
        (0, $29d702d7ef9ce022$export$2e2bcd8739ae039)("ctrl+shift+e,command+shift+e", ()=>{
            (0, $fc0737f7a4e7c327$export$96be6e195c19e554).instance.exportSVG();
            return false;
        });
        // mode change
        (0, $29d702d7ef9ce022$export$2e2bcd8739ae039)("q", ()=>{
            document.getElementById("addComponentButton").dispatchEvent(new MouseEvent("click"));
            return false;
        });
        (0, $29d702d7ef9ce022$export$2e2bcd8739ae039)("esc", ()=>{
            this.switchMode($177c4dcfaec5a17b$export$43660d87cb080eb.DRAG_PAN);
            return false;
        });
        (0, $29d702d7ef9ce022$export$2e2bcd8739ae039)("w", ()=>{
            this.switchMode($177c4dcfaec5a17b$export$43660d87cb080eb.DRAG_PAN);
            (0, $08259c81b533024d$export$c564803d81ad3eaf).instance.placeComponent(new (0, $627d261d67c772a8$export$af5ab1b7068ea0e5)());
            return false;
        });
        (0, $29d702d7ef9ce022$export$2e2bcd8739ae039)("del, backspace", ()=>{
            if (!(0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.hasSelection()) this.switchMode($177c4dcfaec5a17b$export$43660d87cb080eb.ERASE);
            else {
                (0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.removeSelection();
                (0, $815383aeedb00f00$export$897c9ed706d8ea48).addState();
            }
            return false;
        });
        (0, $29d702d7ef9ce022$export$2e2bcd8739ae039)("t", ()=>{
            this.switchMode($177c4dcfaec5a17b$export$43660d87cb080eb.DRAG_PAN);
            (0, $08259c81b533024d$export$c564803d81ad3eaf).instance.placeComponent(new (0, $018bdeaffc845dce$export$1b49e7b3b2d7fd39)());
            return false;
        });
        // handle shortcuts for adding components
        // shortcutDict maps the Shortcut key to the title attribute of the html element where the callback can be found
        var shortcutDict = [
            {
                shortcut: "g",
                component: "Ground"
            },
            {
                shortcut: "alt+g,option+g",
                component: "Ground (tailless)"
            },
            {
                shortcut: "r",
                component: "Resistor (american)"
            },
            {
                shortcut: "c",
                component: "Capacitor"
            },
            {
                shortcut: "alt+c,option+c",
                component: "Curved (polarized) capacitor"
            },
            {
                shortcut: "l",
                component: "Inductor (american)"
            },
            {
                shortcut: "alt+l,option+l",
                component: "Inductor (cute)"
            },
            {
                shortcut: "d",
                component: "Empty diode"
            },
            {
                shortcut: "b",
                component: "NPN"
            },
            {
                shortcut: "alt+b,option+b",
                component: "PNP"
            },
            {
                shortcut: "n",
                component: "NMOS"
            },
            {
                shortcut: "alt+n,option+n",
                component: "PMOS"
            },
            {
                shortcut: "x",
                component: "Plain style crossing node"
            },
            {
                shortcut: "alt+x,option+x",
                component: "Jumper-style crossing node"
            },
            {
                shortcut: ".",
                component: "Connected terminal"
            },
            {
                shortcut: "alt+.,option+.",
                component: "Unconnected terminal"
            }
        ];
        // when a valid shortcut button is pressed, simulate a click on the corresponding button for the component
        for (const { shortcut: shortcut, component: component } of shortcutDict)(0, $29d702d7ef9ce022$export$2e2bcd8739ae039)(shortcut, ()=>{
            this.switchMode($177c4dcfaec5a17b$export$43660d87cb080eb.DRAG_PAN); //switch to standard mode to avoid weird states
            var componentButton = document.querySelector('[title="' + component + '"]');
            var clickEvent = new MouseEvent("mouseup", {
                view: window,
                bubbles: true,
                cancelable: true
            });
            componentButton?.dispatchEvent(clickEvent);
        });
    }
    /**
     * Init the canvas controller
     */ async initCanvas() {
        let canvasElement = await (0, $fdc5c966c4323314$export$9cdcc5f0c3b8ebcc)("canvas");
        if (canvasElement) this.canvasController = new (0, $1c90e793f342bb2a$export$88e1240f06a672d2)(new $gBhAd.Svg(canvasElement));
    }
    /**
     * Fetch & parse the symbol(s) svg.
     */ async initSymbolDB() {
        // Fetch symbol DB
        const symbolDBlink = await (0, $fdc5c966c4323314$export$9cdcc5f0c3b8ebcc)("symbolDBlink");
        const response = await fetch(symbolDBlink.href, {
            method: "GET",
            // must match symbolDBlink cors options in order to actually use the preloaded file
            mode: "cors",
            credentials: "same-origin"
        });
        const textContent = await response.text();
        // Parse & add to DOM
        const symbolsDocument = new DOMParser().parseFromString(textContent, "image/svg+xml");
        const symbolsSVGSVGElement = document.adoptNode(symbolsDocument.firstElementChild);
        symbolsSVGSVGElement.style.display = "none";
        symbolsSVGSVGElement.setAttribute("id", "symbolDB");
        document.body.appendChild(symbolsSVGSVGElement);
        // Extract symbols
        this.symbolsSVG = new $gBhAd.Svg(symbolsSVGSVGElement);
        const defs = this.symbolsSVG.defs();
        const symbols = Array.prototype.filter.call(defs.node.children, (def)=>def instanceof SVGSymbolElement);
        // let symbols = defs.children().filter((/** @type {SVG.Element} */def) => def instanceof SVG.Symbol);
        this.symbols = symbols.flatMap((symbol)=>{
            const baseInfo = (0, $c403c181e5389b40$export$5ce304d64fdbcc11).getBaseInformation(symbol);
            if (baseInfo.isNode === baseInfo.isPath) return []; // type not correctly set
            try {
                // if (baseInfo.isNode) return new NodeComponentSymbol(symbol, baseInfo);
                // else return new PathComponentSymbol(symbol, baseInfo);
                return new (0, $c403c181e5389b40$export$5ce304d64fdbcc11)(symbol, baseInfo);
            } catch (e) {
                console.log(e);
                return [];
            }
        });
    }
    /**
     * Init the mode change buttons.
     */ initModeButtons() {
        this.modeSwitchButtons.modeDragPan = document.getElementById("modeDragPan");
        this.modeSwitchButtons.modeDrawLine = document.getElementById("modeDrawLine");
        this.modeSwitchButtons.modeEraser = document.getElementById("modeEraser");
        this.modeSwitchButtons.modeDragPan.addEventListener("click", ()=>this.switchMode($177c4dcfaec5a17b$export$43660d87cb080eb.DRAG_PAN), {
            passive: false
        });
        this.modeSwitchButtons.modeDrawLine.addEventListener("click", ()=>{
            this.switchMode($177c4dcfaec5a17b$export$43660d87cb080eb.DRAG_PAN);
            this.modeSwitchButtons.modeDrawLine.classList.add("selected");
            (0, $08259c81b533024d$export$c564803d81ad3eaf).instance.placeComponent(new (0, $627d261d67c772a8$export$af5ab1b7068ea0e5)());
        }, {
            passive: false
        });
        this.modeSwitchButtons.modeEraser.addEventListener("click", ()=>this.switchMode($177c4dcfaec5a17b$export$43660d87cb080eb.ERASE), {
            passive: false
        });
    }
    addShapeComponentsToOffcanvas(leftOffcanvasAccordion, leftOffcanvasOC) {
        // Add shapes accordion area
        let groupName = "Shapes";
        const collapseGroupID = "collapseGroup-" + groupName.replace(/[^\d\w\-\_]+/gi, "-");
        const accordionGroup = leftOffcanvasAccordion.appendChild(document.createElement("div"));
        accordionGroup.classList.add("accordion-item");
        const accordionItemHeader = accordionGroup.appendChild(document.createElement("h2"));
        accordionItemHeader.classList.add("accordion-header");
        const accordionItemButton = accordionItemHeader.appendChild(document.createElement("button"));
        accordionItemButton.classList.add("accordion-button");
        accordionItemButton.innerText = groupName;
        accordionItemButton.setAttribute("aria-controls", collapseGroupID);
        accordionItemButton.setAttribute("aria-expanded", "true");
        accordionItemButton.setAttribute("data-bs-target", "#" + collapseGroupID);
        accordionItemButton.setAttribute("data-bs-toggle", "collapse");
        accordionItemButton.type = "button";
        const accordionItemCollapse = accordionGroup.appendChild(document.createElement("div"));
        accordionItemCollapse.classList.add("accordion-collapse", "collapse", "show");
        accordionItemCollapse.id = collapseGroupID;
        accordionItemCollapse.setAttribute("data-bs-parent", "#leftOffcanvasAccordion");
        const accordionItemBody = accordionItemCollapse.appendChild(document.createElement("div"));
        accordionItemBody.classList.add("accordion-body", "iconLibAccordionBody");
        //Add rectangle
        {
            const addButton = accordionItemBody.appendChild(document.createElement("div"));
            addButton.classList.add("libComponent");
            addButton.setAttribute("searchData", "rect rectangle");
            addButton.ariaRoleDescription = "button";
            addButton.title = "Rectangle/Text";
            const listener = (ev)=>{
                ev.preventDefault();
                this.switchMode($177c4dcfaec5a17b$export$43660d87cb080eb.COMPONENT);
                if ((0, $08259c81b533024d$export$c564803d81ad3eaf).instance.component) (0, $08259c81b533024d$export$c564803d81ad3eaf).instance.placeCancel();
                let newComponent = new (0, $018bdeaffc845dce$export$1b49e7b3b2d7fd39)();
                (0, $08259c81b533024d$export$c564803d81ad3eaf).instance.placeComponent(newComponent);
                leftOffcanvasOC.hide();
            };
            addButton.addEventListener("mouseup", listener);
            addButton.addEventListener("touchstart", listener, {
                passive: false
            });
            let svgIcon = $gBhAd.SVG().addTo(addButton);
            svgIcon.viewbox(0, 0, 17, 12);
            svgIcon.rect(15, 10).move(1, 1).fill("none").stroke({
                color: (0, $6a68e99136784593$export$fc9982435e9a3643),
                width: 1
            });
        }
        //Add Ellipse
        {
            const addButton = accordionItemBody.appendChild(document.createElement("div"));
            addButton.classList.add("libComponent");
            addButton.setAttribute("searchData", "ellipse circle");
            addButton.ariaRoleDescription = "button";
            addButton.title = "Ellipse";
            const listener = (ev)=>{
                ev.preventDefault();
                this.switchMode($177c4dcfaec5a17b$export$43660d87cb080eb.COMPONENT);
                if ((0, $08259c81b533024d$export$c564803d81ad3eaf).instance.component) (0, $08259c81b533024d$export$c564803d81ad3eaf).instance.placeCancel();
                let newComponent = new (0, $f1cd0bf4955bc259$export$adcbac2b18b5c769)();
                (0, $08259c81b533024d$export$c564803d81ad3eaf).instance.placeComponent(newComponent);
                leftOffcanvasOC.hide();
            };
            addButton.addEventListener("mouseup", listener);
            addButton.addEventListener("touchstart", listener, {
                passive: false
            });
            let svgIcon = $gBhAd.SVG().addTo(addButton);
            svgIcon.viewbox(0, 0, 17, 12);
            svgIcon.ellipse(15, 10).move(1, 1).fill("none").stroke({
                color: (0, $6a68e99136784593$export$fc9982435e9a3643),
                width: 1
            });
        }
        //Add Polygon
        {
            const addButton = accordionItemBody.appendChild(document.createElement("div"));
            addButton.classList.add("libComponent");
            addButton.setAttribute("searchData", "polygon");
            addButton.ariaRoleDescription = "button";
            addButton.title = "Polygon";
            const listener = (ev)=>{
                ev.preventDefault();
                this.switchMode($177c4dcfaec5a17b$export$43660d87cb080eb.COMPONENT);
                if ((0, $08259c81b533024d$export$c564803d81ad3eaf).instance.component) (0, $08259c81b533024d$export$c564803d81ad3eaf).instance.placeCancel();
                let newComponent = new (0, $8fa4f618930e8b82$export$abaf34b597d19c32)();
                (0, $08259c81b533024d$export$c564803d81ad3eaf).instance.placeComponent(newComponent);
                leftOffcanvasOC.hide();
            };
            addButton.addEventListener("mouseup", listener);
            addButton.addEventListener("touchstart", listener, {
                passive: false
            });
            let svgIcon = $gBhAd.SVG().addTo(addButton);
            svgIcon.viewbox(0, 0, 17, 12);
            svgIcon.polygon([
                [
                    1,
                    1
                ],
                [
                    16,
                    1
                ],
                [
                    15,
                    11
                ],
                [
                    11,
                    9
                ],
                [
                    5,
                    11
                ]
            ]).fill("none").stroke({
                color: (0, $6a68e99136784593$export$fc9982435e9a3643),
                width: 1
            });
        }
    }
    /**
     * Init the left add offcanvas.
     */ async initAddComponentOffcanvas() {
        const leftOffcanvas = document.getElementById("leftOffcanvas");
        const leftOffcanvasOC = new (0, $9c6c83c6a450e1f8$export$591ca0244c9dfcd4)(leftOffcanvas);
        document.getElementById("componentFilterInput").addEventListener("input", this.filterComponents);
        const addComponentButton = document.getElementById("addComponentButton");
        addComponentButton.addEventListener("click", ((ev)=>{
            this.switchMode($177c4dcfaec5a17b$export$43660d87cb080eb.DRAG_PAN);
            leftOffcanvasOC.toggle();
            if (leftOffcanvas.classList.contains("showing") && ev.pointerType !== "touch") {
                let searchBar = document.getElementById("componentFilterInput");
                const refocus = ()=>{
                    searchBar.focus();
                    leftOffcanvas.removeEventListener("shown.bs.offcanvas", refocus);
                };
                refocus();
                leftOffcanvas.addEventListener("shown.bs.offcanvas", refocus);
            }
        }).bind(this), {
            passive: true
        });
        const leftOffcanvasAccordion = document.getElementById("leftOffcanvasAccordion");
        const groupedSymbols = this.symbols.reduce((groupedSymbols, symbol)=>{
            const key = symbol.groupName || "Unsorted components";
            let group = groupedSymbols.get(key);
            if (group) group.push(symbol);
            else groupedSymbols.set(key, [
                symbol
            ]);
            return groupedSymbols;
        }, new Map());
        this.addShapeComponentsToOffcanvas(leftOffcanvasAccordion, leftOffcanvasOC);
        for (const [groupName, symbols] of groupedSymbols.entries()){
            const collapseGroupID = "collapseGroup-" + groupName.replace(/[^\d\w\-\_]+/gi, "-");
            const accordionGroup = leftOffcanvasAccordion.appendChild(document.createElement("div"));
            accordionGroup.classList.add("accordion-item");
            const accordionItemHeader = accordionGroup.appendChild(document.createElement("h2"));
            accordionItemHeader.classList.add("accordion-header");
            const accordionItemButton = accordionItemHeader.appendChild(document.createElement("button"));
            accordionItemButton.classList.add("accordion-button", "collapsed");
            accordionItemButton.innerText = groupName;
            accordionItemButton.setAttribute("aria-controls", collapseGroupID);
            accordionItemButton.setAttribute("aria-expanded", "false");
            accordionItemButton.setAttribute("data-bs-target", "#" + collapseGroupID);
            accordionItemButton.setAttribute("data-bs-toggle", "collapse");
            accordionItemButton.type = "button";
            const accordionItemCollapse = accordionGroup.appendChild(document.createElement("div"));
            accordionItemCollapse.classList.add("accordion-collapse", "collapse");
            accordionItemCollapse.id = collapseGroupID;
            accordionItemCollapse.setAttribute("data-bs-parent", "#leftOffcanvasAccordion");
            const accordionItemBody = accordionItemCollapse.appendChild(document.createElement("div"));
            accordionItemBody.classList.add("accordion-body", "iconLibAccordionBody");
            for (const symbol of symbols){
                const addButton = accordionItemBody.appendChild(document.createElement("div"));
                addButton.classList.add("libComponent");
                addButton.setAttribute("searchData", [
                    symbol.tikzName
                ].concat(Array.from(symbol._tikzOptions.keys())).join(" "));
                addButton.ariaRoleDescription = "button";
                addButton.title = symbol.displayName || symbol.tikzName;
                const listener = (ev)=>{
                    ev.preventDefault();
                    this.switchMode($177c4dcfaec5a17b$export$43660d87cb080eb.COMPONENT);
                    if ((0, $08259c81b533024d$export$c564803d81ad3eaf).instance.component) (0, $08259c81b533024d$export$c564803d81ad3eaf).instance.placeCancel();
                    let newComponent;
                    if (symbol.isNodeSymbol) newComponent = new (0, $6bd671163c60be4d$export$a997d0ef89e7a9bb)(symbol);
                    else newComponent = new (0, $f522b793724e8edf$export$e522ece2f5c9b780)(symbol);
                    (0, $08259c81b533024d$export$c564803d81ad3eaf).instance.placeComponent(newComponent);
                    leftOffcanvasOC.hide();
                };
                addButton.addEventListener("mouseup", listener);
                addButton.addEventListener("touchstart", listener, {
                    passive: false
                });
                let svgIcon = $gBhAd.SVG().addTo(addButton);
                if (symbol.viewBox) {
                    let viewBox = new $gBhAd.Box(symbol.viewBox);
                    viewBox.width += symbol.maxStroke;
                    viewBox.height += symbol.maxStroke;
                    viewBox.x -= symbol.maxStroke / 2;
                    viewBox.y -= symbol.maxStroke / 2;
                    svgIcon.viewbox(viewBox).width(viewBox.width).height(viewBox.height);
                }
                svgIcon.use(symbol.id()).stroke((0, $6a68e99136784593$export$fc9982435e9a3643)).fill((0, $6a68e99136784593$export$d3ce5ee02df64eaf)).node.style.color = (0, $6a68e99136784593$export$fc9982435e9a3643);
            }
        }
    }
    /**
     * filter the components in the left OffCanvas to only show what matches the search string (in a new accordeon item)
     */ filterComponents(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        const element = document.getElementById("componentFilterInput");
        const feedbacktext = document.getElementById("invalid-feedback-text");
        let text = element.value;
        let regex = null;
        try {
            regex = new RegExp(text, "i");
            element.classList.remove("is-invalid");
            feedbacktext.classList.add("d-none");
        } catch (e) {
            text = "";
            regex = new RegExp(text, "i");
            element.classList.add("is-invalid");
            feedbacktext.classList.remove("d-none");
        }
        const accordion = document.getElementById("leftOffcanvasAccordion");
        const accordionItems = accordion.getElementsByClassName("accordion-item");
        Array.prototype.forEach.call(accordionItems, (accordionItem, index)=>{
            const libComponents = accordionItem.getElementsByClassName("libComponent");
            let showCount = 0;
            Array.prototype.forEach.call(libComponents, (libComponent)=>{
                if (text) {
                    if (!(regex.test(libComponent.title) || regex.test(libComponent.getAttribute("searchData")))) {
                        libComponent.classList.add("d-none");
                        return;
                    }
                }
                libComponent.classList.remove("d-none");
                showCount++;
            });
            if (showCount === 0) accordionItem.classList.add("d-none");
            else accordionItem.classList.remove("d-none");
            if (text) {
                accordionItem.children[0]?.children[0]?.classList.remove("collapsed");
                accordionItem.children[1]?.classList.add("show");
            } else {
                accordionItem.children[0]?.children[0]?.classList.add("collapsed");
                accordionItem.children[1]?.classList.remove("show");
            }
            if (index === 0) {
                accordionItem.children[0]?.children[0]?.classList.remove("collapsed");
                accordionItem.children[1]?.classList.add("show");
            }
        });
    }
    /**
     * Switches the mode. This deactivates the old controller and activates the new one.
     */ switchMode(newMode) {
        if (newMode == this.mode) return;
        let oldMode = this.mode;
        this.mode = newMode;
        switch(oldMode){
            case $177c4dcfaec5a17b$export$43660d87cb080eb.DRAG_PAN:
                this.modeSwitchButtons.modeDragPan.classList.remove("selected");
                (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.deactivatePanning();
                (0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.deactivateSelection();
                for (const instance of this.circuitComponents)instance.draggable(false);
                break;
            case $177c4dcfaec5a17b$export$43660d87cb080eb.ERASE:
                this.modeSwitchButtons.modeEraser.classList.remove("selected");
                (0, $7408c040b0c84b17$export$2933b4fdbb8e5219).instance.deactivate();
                break;
            case $177c4dcfaec5a17b$export$43660d87cb080eb.COMPONENT:
                this.modeSwitchButtons.modeDragPan.classList.remove("selected");
                this.modeSwitchButtons.modeDrawLine.classList.remove("selected");
                (0, $08259c81b533024d$export$c564803d81ad3eaf).instance.placeCancel();
                (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.deactivatePanning();
                break;
            default:
                break;
        }
        switch(newMode){
            case $177c4dcfaec5a17b$export$43660d87cb080eb.DRAG_PAN:
                this.modeSwitchButtons.modeDragPan.classList.add("selected");
                (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.activatePanning();
                (0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.activateSelection();
                for (const instance of this.circuitComponents)instance.draggable(true);
                break;
            case $177c4dcfaec5a17b$export$43660d87cb080eb.ERASE:
                this.modeSwitchButtons.modeEraser.classList.add("selected");
                (0, $7408c040b0c84b17$export$2933b4fdbb8e5219).instance.activate();
                break;
            case $177c4dcfaec5a17b$export$43660d87cb080eb.COMPONENT:
                this.modeSwitchButtons.modeDragPan.classList.add("selected");
                (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.activatePanning();
                break;
            default:
                break;
        }
    }
    updateTheme() {
        if (this.darkModeLast == this.darkMode) return;
        for (const instance of this.circuitComponents)instance.updateTheme();
        this.darkModeLast = this.darkMode;
    }
    /**
     * add missing fill attributes to all symbol db entries where fill is undefined --> needs explicit setting, otherwise the color theme change does strange things.
     * called once on initialization
     * @param {Element} node
     */ preprocessSymbolColors(node) {
        let elementsWithFill = node.querySelectorAll("[fill]");
        let elementsWithStroke = node.querySelectorAll("[stroke]");
        //this group
        let currentFill = node.getAttribute("fill");
        if (currentFill == "#fff") node.setAttribute("fill", "currentFill");
        let currentStroke = node.getAttribute("stroke");
        if (currentStroke == "#000") node.setAttribute("stroke", "currentStroke");
        for (const element of elementsWithFill){
            let currentFill = element.getAttribute("fill");
            if (currentFill == "#fff") element.setAttribute("fill", "currentFill");
        }
        for (const element of elementsWithStroke){
            let currentStroke = element.getAttribute("stroke");
            if (currentStroke == "#000") element.setAttribute("stroke", "currentStroke");
        }
        this.addFill(node);
    }
    addFill(node) {
        let hasFill = node.getAttribute("fill") !== null;
        if (hasFill) return;
        for (const element of node.children){
            if (element.nodeName === "g") this.addFill(element);
            else if (!element.getAttribute("fill")) element.setAttribute("fill", "currentColor");
        }
    }
    /**
     * Adds a new instance to {@link circuitComponents} and adds its snapping points.
     */ addComponent(circuitComponent) {
        this.circuitComponents.push(circuitComponent);
    }
    /**
     * Removes an instance from {@link instances} and also removes its snapping points.
     */ removeComponent(circuitComponent) {
        const idx = this.circuitComponents.indexOf(circuitComponent);
        if (idx > -1) {
            this.circuitComponents.splice(idx, 1);
            circuitComponent.remove();
        }
    }
}



var $gBhAd = parcelRequire("gBhAd");

var $gBhAd = parcelRequire("gBhAd");
var $7670d3f589dbdf0d$var$normalizeEvent = function normalizeEvent(ev) {
    return ev.touches || [
        {
            clientX: ev.clientX,
            clientY: ev.clientY
        }
    ];
};
(0, $gBhAd.extend)((0, $gBhAd.Svg), {
    panZoom: function panZoom(options) {
        var _options, _options$zoomFactor, _options$zoomMin, _options$zoomMax, _options$wheelZoom, _options$pinchZoom, _options$panning, _options$panButton, _options$oneFingerPan, _options$margins, _options$wheelZoomDel, _options$wheelZoomDel2, _this = this;
        this.off(".panZoom"); // when called with false, disable panZoom
        if (options === false) return this;
        options = (_options = options) != null ? _options : {};
        var zoomFactor = (_options$zoomFactor = options.zoomFactor) != null ? _options$zoomFactor : 2;
        var zoomMin = (_options$zoomMin = options.zoomMin) != null ? _options$zoomMin : Number.MIN_VALUE;
        var zoomMax = (_options$zoomMax = options.zoomMax) != null ? _options$zoomMax : Number.MAX_VALUE;
        var doWheelZoom = (_options$wheelZoom = options.wheelZoom) != null ? _options$wheelZoom : true;
        var doPinchZoom = (_options$pinchZoom = options.pinchZoom) != null ? _options$pinchZoom : true;
        var doPanning = (_options$panning = options.panning) != null ? _options$panning : true;
        var panButton = (_options$panButton = options.panButton) != null ? _options$panButton : 0;
        var oneFingerPan = (_options$oneFingerPan = options.oneFingerPan) != null ? _options$oneFingerPan : false;
        var margins = (_options$margins = options.margins) != null ? _options$margins : false;
        var wheelZoomDeltaModeLinePixels = (_options$wheelZoomDel = options.wheelZoomDeltaModeLinePixels) != null ? _options$wheelZoomDel : 17;
        var wheelZoomDeltaModeScreenPixels = (_options$wheelZoomDel2 = options.wheelZoomDeltaModeScreenPixels) != null ? _options$wheelZoomDel2 : 53;
        var lastP;
        var lastTouches;
        var zoomInProgress = false;
        var viewbox = this.viewbox();
        var restrictToMargins = function restrictToMargins(box) {
            if (!margins) return box;
            var top = margins.top, left = margins.left, bottom = margins.bottom, right = margins.right;
            var _this$attr = _this.attr([
                "width",
                "height"
            ]), width = _this$attr.width, height = _this$attr.height;
            var preserveAspectRatio = _this.node.preserveAspectRatio.baseVal; // The current viewport (exactly what is shown on the screen, what we ultimately want to restrict)
            // is not always exactly the same as current viewbox. They are different when the viewbox aspectRatio and the svg aspectRatio
            // are different and preserveAspectRatio is not "none". These offsets represent the difference in user coordinates
            // between the side of the viewbox and the side of the viewport.
            var viewportLeftOffset = 0;
            var viewportRightOffset = 0;
            var viewportTopOffset = 0;
            var viewportBottomOffset = 0; // preserveAspectRatio none has no offsets
            if (preserveAspectRatio.align !== preserveAspectRatio.SVG_PRESERVEASPECTRATIO_NONE) {
                var svgAspectRatio = width / height;
                var viewboxAspectRatio = viewbox.width / viewbox.height; // when aspectRatios are the same, there are no offsets
                if (viewboxAspectRatio !== svgAspectRatio) {
                    // aspectRatio unknown is like meet because that's the default
                    var isMeet = preserveAspectRatio.meetOrSlice !== preserveAspectRatio.SVG_MEETORSLICE_SLICE;
                    var changedAxis = svgAspectRatio > viewboxAspectRatio ? "width" : "height";
                    var isWidth = changedAxis === "width";
                    var changeHorizontal = isMeet && isWidth || !isMeet && !isWidth;
                    var ratio = changeHorizontal ? svgAspectRatio / viewboxAspectRatio : viewboxAspectRatio / svgAspectRatio;
                    var offset = box[changedAxis] - box[changedAxis] * ratio;
                    if (changeHorizontal) {
                        if (preserveAspectRatio.align === preserveAspectRatio.SVG_PRESERVEASPECTRATIO_XMIDYMIN || preserveAspectRatio.align === preserveAspectRatio.SVG_PRESERVEASPECTRATIO_XMIDYMID || preserveAspectRatio.align === preserveAspectRatio.SVG_PRESERVEASPECTRATIO_XMIDYMAX) {
                            viewportLeftOffset = offset / 2;
                            viewportRightOffset = -offset / 2;
                        } else if (preserveAspectRatio.align === preserveAspectRatio.SVG_PRESERVEASPECTRATIO_XMINYMIN || preserveAspectRatio.align === preserveAspectRatio.SVG_PRESERVEASPECTRATIO_XMINYMID || preserveAspectRatio.align === preserveAspectRatio.SVG_PRESERVEASPECTRATIO_XMINYMAX) viewportRightOffset = -offset;
                        else if (preserveAspectRatio.align === preserveAspectRatio.SVG_PRESERVEASPECTRATIO_XMAXYMIN || preserveAspectRatio.align === preserveAspectRatio.SVG_PRESERVEASPECTRATIO_XMAXYMID || preserveAspectRatio.align === preserveAspectRatio.SVG_PRESERVEASPECTRATIO_XMAXYMAX) viewportLeftOffset = offset;
                    } else {
                        if (preserveAspectRatio.align === preserveAspectRatio.SVG_PRESERVEASPECTRATIO_XMINYMID || preserveAspectRatio.align === preserveAspectRatio.SVG_PRESERVEASPECTRATIO_XMIDYMID || preserveAspectRatio.align === preserveAspectRatio.SVG_PRESERVEASPECTRATIO_XMAXYMID) {
                            viewportTopOffset = offset / 2;
                            viewportBottomOffset = -offset / 2;
                        } else if (preserveAspectRatio.align === preserveAspectRatio.SVG_PRESERVEASPECTRATIO_XMINYMIN || preserveAspectRatio.align === preserveAspectRatio.SVG_PRESERVEASPECTRATIO_XMIDYMIN || preserveAspectRatio.align === preserveAspectRatio.SVG_PRESERVEASPECTRATIO_XMAXYMIN) viewportBottomOffset = -offset;
                        else if (preserveAspectRatio.align === preserveAspectRatio.SVG_PRESERVEASPECTRATIO_XMINYMAX || preserveAspectRatio.align === preserveAspectRatio.SVG_PRESERVEASPECTRATIO_XMIDYMAX || preserveAspectRatio.align === preserveAspectRatio.SVG_PRESERVEASPECTRATIO_XMAXYMAX) viewportTopOffset = offset;
                    }
                }
            } // when box.x == leftLimit, the image is panned to the left,
            // i.e the current box is to the right of the initial viewbox,
            // and only the right part of the initial image is visible, i.e.
            // the right side of the initial viewbox minus left margin (viewbox.x+viewbox.width-left)
            // is aligned with the left side of the viewport (box.x + viewportLeftOffset):
            // viewbox.width + viewbox.x - left = box.x + viewportLeftOffset
            // viewbox.width + viewbox.x - left - viewportLeftOffset = box.x (= leftLimit)
            var leftLimit = viewbox.width + viewbox.x - left - viewportLeftOffset; // when box.x == rightLimit, the image is panned to the right,
            // i.e the current box is to the left of the initial viewbox
            // and only the left part of the initial image is visible, i.e
            // the left side of the initial viewbox plus right margin (viewbox.x + right)
            // is aligned with the right side of the viewport (box.x + box.width + viewportRightOffset)
            // viewbox.x + right = box.x + box.width + viewportRightOffset
            // viewbox.x + right - box.width - viewportRightOffset = box.x (= rightLimit)
            var rightLimit = viewbox.x + right - box.width - viewportRightOffset; // same with top and bottom
            var topLimit = viewbox.height + viewbox.y - top - viewportTopOffset;
            var bottomLimit = viewbox.y + bottom - box.height - viewportBottomOffset;
            box.x = Math.min(leftLimit, Math.max(rightLimit, box.x)); // enforce rightLimit <= box.x <= leftLimit
            box.y = Math.min(topLimit, Math.max(bottomLimit, box.y)); // enforce bottomLimit <= box.y <= topLimit
            return box;
        };
        var wheelZoom = function wheelZoom(ev) {
            ev.preventDefault(); // When wheeling on a mouse,
            // - chrome by default uses deltaY = 53, deltaMode = 0 (pixel)
            // - firefox by default uses deltaY = 3, deltaMode = 1 (line)
            // - chrome and firefox on windows after configuring "One screen at a time"
            //   use deltaY = 1, deltaMode = 2 (screen)
            //
            // Note that when when wheeling on a touchpad, deltaY depends on how fast
            // you swipe, but the deltaMode is still different between the browsers.
            //
            // Normalize everything so that zooming speed is approximately the same in all cases
            var normalizedPixelDeltaY;
            switch(ev.deltaMode){
                case 1:
                    normalizedPixelDeltaY = ev.deltaY * wheelZoomDeltaModeLinePixels;
                    break;
                case 2:
                    normalizedPixelDeltaY = ev.deltaY * wheelZoomDeltaModeScreenPixels;
                    break;
                default:
                    // 0 (already pixels) or new mode (avoid crashing)
                    normalizedPixelDeltaY = ev.deltaY;
                    break;
            }
            var lvl = Math.pow(1 + zoomFactor, -1 * normalizedPixelDeltaY / 100) * this.zoom();
            var p = this.point(ev.clientX, ev.clientY);
            if (lvl > zoomMax) lvl = zoomMax;
            if (lvl < zoomMin) lvl = zoomMin;
            if (this.dispatch("zoom", {
                level: lvl,
                focus: p
            }).defaultPrevented) return this;
            this.zoom(lvl, p);
            if (margins) {
                var box = restrictToMargins(this.viewbox());
                this.viewbox(box);
            }
        };
        var pinchZoomStart = function pinchZoomStart(ev) {
            lastTouches = $7670d3f589dbdf0d$var$normalizeEvent(ev); // Start panning in case only one touch is found
            if (lastTouches.length < 2) {
                if (doPanning && oneFingerPan) panStart.call(this, ev);
                return;
            } // Stop panning for more than one touch
            if (doPanning && oneFingerPan) panStop.call(this, ev);
             // We call it so late, so the user is still able to scroll / reload the page via gesture
            // In case oneFingerPan is not active
            ev.preventDefault();
            if (this.dispatch("pinchZoomStart", {
                event: ev
            }).defaultPrevented) return;
            this.off("touchstart.panZoom", pinchZoomStart);
            zoomInProgress = true;
            (0, $gBhAd.on)(document, "touchmove.panZoom", pinchZoom, this, {
                passive: false
            });
            (0, $gBhAd.on)(document, "touchend.panZoom", pinchZoomStop, this, {
                passive: false
            });
        };
        var pinchZoomStop = function pinchZoomStop(ev) {
            ev.preventDefault();
            var currentTouches = $7670d3f589dbdf0d$var$normalizeEvent(ev);
            if (currentTouches.length > 1) return;
            zoomInProgress = false;
            this.dispatch("pinchZoomEnd", {
                event: ev
            });
            (0, $gBhAd.off)(document, "touchmove.panZoom", pinchZoom);
            (0, $gBhAd.off)(document, "touchend.panZoom", pinchZoomStop);
            this.on("touchstart.panZoom", pinchZoomStart);
            if (currentTouches.length && doPanning && oneFingerPan) panStart.call(this, ev);
        };
        var pinchZoom = function pinchZoom(ev) {
            ev.preventDefault();
            var currentTouches = $7670d3f589dbdf0d$var$normalizeEvent(ev);
            var zoom = this.zoom(); // Distance Formula
            var lastDelta = Math.sqrt(Math.pow(lastTouches[0].clientX - lastTouches[1].clientX, 2) + Math.pow(lastTouches[0].clientY - lastTouches[1].clientY, 2));
            var currentDelta = Math.sqrt(Math.pow(currentTouches[0].clientX - currentTouches[1].clientX, 2) + Math.pow(currentTouches[0].clientY - currentTouches[1].clientY, 2));
            var zoomAmount = lastDelta / currentDelta;
            if (zoom < zoomMin && zoomAmount > 1 || zoom > zoomMax && zoomAmount < 1) zoomAmount = 1;
            var currentFocus = {
                x: currentTouches[0].clientX + 0.5 * (currentTouches[1].clientX - currentTouches[0].clientX),
                y: currentTouches[0].clientY + 0.5 * (currentTouches[1].clientY - currentTouches[0].clientY)
            };
            var lastFocus = {
                x: lastTouches[0].clientX + 0.5 * (lastTouches[1].clientX - lastTouches[0].clientX),
                y: lastTouches[0].clientY + 0.5 * (lastTouches[1].clientY - lastTouches[0].clientY)
            };
            var p = this.point(currentFocus.x, currentFocus.y);
            var focusP = this.point(2 * currentFocus.x - lastFocus.x, 2 * currentFocus.y - lastFocus.y);
            var box = new (0, $gBhAd.Box)(this.viewbox()).transform(new (0, $gBhAd.Matrix)().translate(-focusP.x, -focusP.y).scale(zoomAmount, 0, 0).translate(p.x, p.y));
            restrictToMargins(box);
            this.viewbox(box);
            lastTouches = currentTouches;
            this.dispatch("zoom", {
                box: box,
                focus: focusP
            });
        };
        var panStart = function panStart(ev) {
            var isMouse = ev.type.indexOf("mouse") > -1; // In case panStart is called with touch, ev.button is undefined
            if (isMouse && ev.button !== panButton && ev.which !== panButton + 1) return;
            ev.preventDefault();
            this.off("mousedown.panZoom", panStart);
            lastTouches = $7670d3f589dbdf0d$var$normalizeEvent(ev);
            if (zoomInProgress) return;
            this.dispatch("panStart", {
                event: ev
            });
            lastP = {
                x: lastTouches[0].clientX,
                y: lastTouches[0].clientY
            };
            (0, $gBhAd.on)(document, "touchmove.panZoom mousemove.panZoom", panning, this, {
                passive: false
            });
            (0, $gBhAd.on)(document, "touchend.panZoom mouseup.panZoom", panStop, this, {
                passive: false
            });
        };
        var panStop = function panStop(ev) {
            ev.preventDefault();
            (0, $gBhAd.off)(document, "touchmove.panZoom mousemove.panZoom", panning);
            (0, $gBhAd.off)(document, "touchend.panZoom mouseup.panZoom", panStop);
            this.on("mousedown.panZoom", panStart);
            this.dispatch("panEnd", {
                event: ev
            });
        };
        var panning = function panning(ev) {
            ev.preventDefault();
            var currentTouches = $7670d3f589dbdf0d$var$normalizeEvent(ev);
            var currentP = {
                x: currentTouches[0].clientX,
                y: currentTouches[0].clientY
            };
            var p1 = this.point(currentP.x, currentP.y);
            var p2 = this.point(lastP.x, lastP.y);
            var deltaP = [
                p2.x - p1.x,
                p2.y - p1.y
            ];
            if (!deltaP[0] && !deltaP[1]) return;
            var box = new (0, $gBhAd.Box)(this.viewbox()).transform(new (0, $gBhAd.Matrix)().translate(deltaP[0], deltaP[1]));
            lastP = currentP;
            restrictToMargins(box);
            if (this.dispatch("panning", {
                box: box,
                event: ev
            }).defaultPrevented) return;
            this.viewbox(box);
        };
        if (doWheelZoom) this.on("wheel.panZoom", wheelZoom, this, {
            passive: false
        });
        if (doPinchZoom) this.on("touchstart.panZoom", pinchZoomStart, this, {
            passive: false
        });
        if (doPanning) this.on("mousedown.panZoom", panStart, this, {
            passive: false
        });
        return this;
    }
});



class $1c90e793f342bb2a$export$88e1240f06a672d2 {
    /**
     * Static variable holding the instance.
     */ static instance;
    /**
     * The (root) SVG Element. All lines and components are children of this element.
     */ canvas;
    /**
     * The background (grid)
     */ paper;
    /**
     * The line marking the x axis
     */ xAxis;
    /**
     * The line marking the y axis
     */ yAxis;
    /** Distance between major grid lines
     */ majorGridSizecm = 1;
    /** How many minor grid lines are drawn for every major grid line
     */ majorGridSubdivisions = 4;
    gridVisible = true;
    /**
     * Needed for window size changes to reconstruct the old zoom level.
     */ canvasBounds = null;
    invScreenCTM = null;
    /** zoom parameters; small zoomFactor for more granular control
     */ zoomFactor = 0.1;
    zoomMin = 0.25;
    zoomMax = 10;
    zoomCurrent = 2;
    /**
     * the last point on the canvas
     */ lastCanvasPoint = new $gBhAd.Point(0, 0);
    /**
     * Create the canvas controller.
     * @param {SVG.Svg} canvas - the (wrapped) svg element
     */ constructor(canvas){
        if ($1c90e793f342bb2a$export$88e1240f06a672d2.instance) return;
        $1c90e793f342bb2a$export$88e1240f06a672d2.instance = this;
        this.canvas = canvas;
        this.paper = $gBhAd.SVG("#grid");
        this.xAxis = $gBhAd.SVG("#xAxis");
        this.yAxis = $gBhAd.SVG("#yAxis");
        const panFactor = 20;
        let body = document.getElementsByTagName("body")[0];
        document.addEventListener("keydown", (ev)=>{
            // pan canvas manually/ move selection slightly
            if (ev.key.startsWith("Arrow") && ev.target == body) {
                let direction = new $gBhAd.Point();
                direction.x = ev.key == "ArrowRight" ? 1 : ev.key == "ArrowLeft" ? -1 : 0;
                direction.y = ev.key == "ArrowUp" ? -1 : ev.key == "ArrowDown" ? 1 : 0;
                if ((0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.hasSelection()) (0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.moveSelectionRel(direction.mul(1 / this.zoomCurrent));
                else {
                    //move canvas
                    let currentViewBox = this.canvas.viewbox();
                    let newPos = new $gBhAd.Point(currentViewBox.x, currentViewBox.y).add(direction.mul(panFactor / this.zoomCurrent));
                    // this.canvas.zoom(this.zoomCurrent,newPos)
                    this.canvas.viewbox(newPos.x, newPos.y, currentViewBox.w, currentViewBox.h);
                    this.movePaper({
                        detail: {}
                    });
                }
            }
        });
        // init viewBox
        this.onResizeCanvas();
        // observe page size change
        new ResizeObserver(this.onResizeCanvas.bind(this)).observe(this.canvas.node);
        // init pan & zoom
        this.activatePanning();
        // Drag picture with mouse
        canvas.on("panning", this.movePaper, this, {
            passive: false
        });
        // Mouse wheel OR pinch zoom
        // Wheel zoom is fired before the actual change and has no detail.box and is thus ignored. It will be handled by wheel.panZoom.
        canvas.on("zoom", this.movePaper, this, {
            passive: true
        });
        canvas.on("mousemove", (evt)=>{
            this.lastCanvasPoint = $1c90e793f342bb2a$export$88e1240f06a672d2.eventToPoint(evt, false);
        });
        canvas.on("touchmove", (evt)=>{
            this.lastCanvasPoint = $1c90e793f342bb2a$export$88e1240f06a672d2.eventToPoint(evt, false);
        });
        const oldViewBoxFunction = this.canvas.viewbox;
        this.canvas.viewbox = (...args)=>{
            if (arguments.length > 0) this.invScreenCTM = null;
            return oldViewBoxFunction.apply(this.canvas, args);
        };
        const oldZoomFunction = this.canvas.zoom;
        this.canvas.zoom = (...args)=>{
            if (arguments.length > 0) this.invScreenCTM = null;
            return oldZoomFunction.apply(this.canvas, args);
        };
        // shift whole canvas down such that the origin is in the bottom left corner
        let box = this.canvas.viewbox();
        box.y -= box.h;
        // shift canvas up right to see the axes with the default view
        let moveAmount = Math.max(0.05 * Math.min(box.w, box.h), 10);
        box.x -= moveAmount;
        box.y += moveAmount;
        this.canvas.viewbox(box);
        this.canvas.zoom(this.zoomCurrent, new $gBhAd.Point());
        let gridVisibleToggle = document.getElementById("gridVisible");
        let storage = localStorage.getItem("circuit2tikz-designer-grid");
        if (storage) {
            let gridSettings = JSON.parse(storage);
            if (gridSettings) {
                if (gridSettings.majorGridSizecm && gridSettings.majorGridSubdivisions) this.changeGrid(gridSettings.majorGridSizecm, gridSettings.majorGridSubdivisions);
                this.gridVisible = gridSettings.gridVisible;
                if (!this.gridVisible) this.paper.addClass("d-none");
            }
        } else localStorage.setItem("circuit2tikz-designer-grid", JSON.stringify({
            majorGridSizecm: this.majorGridSizecm,
            majorGridSubdivisions: this.majorGridSubdivisions,
            gridVisible: this.gridVisible
        }));
        gridVisibleToggle.checked = this.gridVisible;
        gridVisibleToggle.addEventListener("change", (ev)=>{
            this.gridVisible = gridVisibleToggle.checked;
            if (this.gridVisible) {
                if (this.paper.hasClass("d-none")) this.paper.removeClass("d-none");
            } else this.paper.addClass("d-none");
            this.saveSettings();
        });
    }
    saveSettings() {
        localStorage.setItem("circuit2tikz-designer-grid", JSON.stringify({
            majorGridSizecm: this.majorGridSizecm,
            majorGridSubdivisions: this.majorGridSubdivisions,
            gridVisible: this.gridVisible
        }));
    }
    moveComponentsForward(components) {
        if ((0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.circuitComponents.length < 2 || components.length == 0) return;
        let idxComps = components.map((c)=>{
            return {
                idx: (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.circuitComponents.findIndex((cc)=>cc === c),
                component: c
            };
        });
        idxComps.sort((a, b)=>a.idx - b.idx).reverse();
        let lastSelectedIndex = (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.circuitComponents.length;
        let switched = false;
        for (const idxComp of idxComps)if (idxComp.idx !== lastSelectedIndex - 1) {
            //switch the components
            let switchComponent = (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.circuitComponents[idxComp.idx + 1];
            idxComp.component.visualization.insertAfter(switchComponent.visualization);
            (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.circuitComponents[idxComp.idx] = switchComponent;
            (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.circuitComponents[idxComp.idx + 1] = idxComp.component;
            lastSelectedIndex = idxComp.idx + 1;
            switched = true;
        } else lastSelectedIndex = idxComp.idx;
        if (switched) (0, $815383aeedb00f00$export$897c9ed706d8ea48).addState();
    }
    moveComponentsBackward(components) {
        if ((0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.circuitComponents.length < 2 || components.length == 0) return;
        let idxComps = components.map((c)=>{
            return {
                idx: (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.circuitComponents.findIndex((cc)=>cc === c),
                component: c
            };
        });
        idxComps.sort((a, b)=>a.idx - b.idx);
        let lastSelectedIndex = -1;
        let switched = false;
        for (const idxComp of idxComps)if (idxComp.idx !== lastSelectedIndex + 1) {
            //switch the components
            let switchComponent = (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.circuitComponents[idxComp.idx - 1];
            idxComp.component.visualization.insertBefore(switchComponent.visualization);
            (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.circuitComponents[idxComp.idx] = switchComponent;
            (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.circuitComponents[idxComp.idx - 1] = idxComp.component;
            lastSelectedIndex = idxComp.idx - 1;
            switched = true;
        } else lastSelectedIndex = idxComp.idx;
        if (switched) (0, $815383aeedb00f00$export$897c9ed706d8ea48).addState();
    }
    componentsToForeground(components) {
        if ((0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.circuitComponents.length < 2 || components.length == 0) return;
        let idxComps = components.map((c)=>{
            return {
                idx: (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.circuitComponents.findIndex((cc)=>cc === c),
                component: c
            };
        });
        idxComps.sort((a, b)=>a.idx - b.idx);
        if (components.length < (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.circuitComponents.length - idxComps[0].idx) {
            for (const idxComp of idxComps){
                idxComp.component.visualization.insertAfter((0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.circuitComponents.at(-1).visualization);
                (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.circuitComponents.push(...(0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.circuitComponents.splice(idxComp.idx, 1));
            }
            (0, $815383aeedb00f00$export$897c9ed706d8ea48).addState();
        }
    }
    componentsToBackground(components) {
        if ((0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.circuitComponents.length < 2 || components.length == 0) return;
        let idxComps = components.map((c)=>{
            return {
                idx: (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.circuitComponents.findIndex((cc)=>cc === c),
                component: c
            };
        });
        idxComps.sort((a, b)=>a.idx - b.idx).reverse();
        if (components.length <= idxComps[0].idx) {
            let offset = 0;
            for (const idxComp of idxComps){
                idxComp.component.visualization.insertBefore((0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.circuitComponents[0].visualization);
                (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.circuitComponents = (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.circuitComponents.splice(idxComp.idx + offset, 1).concat((0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.circuitComponents);
                offset++;
            }
            (0, $815383aeedb00f00$export$897c9ed706d8ea48).addState();
        }
    }
    /**
     * Deactivate the mouse and touch panning feature temporary.
     *
     * Removes listeners from the canvas.
     */ deactivatePanning() {
        // this listener must be inserted after the normal panZoom listeners --> unregister first
        this.canvas.off("wheel.panZoom", this.movePaper);
        // re-init pan & zoom
        this.canvas.panZoom({
            panning: false,
            pinchZoom: true,
            wheelZoom: true,
            panButton: 99,
            oneFingerPan: false,
            zoomFactor: this.zoomFactor,
            zoomMin: this.zoomMin,
            zoomMax: this.zoomMax
        });
        // Listens for same event as svg.panzoom.js, but is added thereafter. Thus this gets called after panzoom is
        // done moving the picture.
        // @param {WheelEvent} evt
        this.canvas.on("wheel.panZoom", this.movePaper, this, {
            passive: true
        });
    }
    /**
     * Activate the mouse and touch panning  feature. The initial state is active. Call this function only, if you
     * previously called {@link deactivatePanning}.
     *
     * Adds listeners to the canvas.
     */ activatePanning() {
        // this listener must be inserted after the normal panZoom listeners --> unregister first
        this.canvas.off("wheel.panZoom", this.movePaper);
        // init pan & zoom
        this.canvas.panZoom({
            panning: true,
            pinchZoom: true,
            wheelZoom: true,
            panButton: 2,
            oneFingerPan: false,
            zoomFactor: this.zoomFactor,
            zoomMin: this.zoomMin,
            zoomMax: this.zoomMax
        });
        // Listens for same event as svg.panzoom.js, but is added thereafter. Thus this gets called after panzoom is
        // done moving the picture.
        // @param {WheelEvent} evt
        this.canvas.on("wheel.panZoom", this.movePaper, this, {
            passive: true
        });
    }
    /**
     * Converts a point from an event to the SVG coordinate system.
     *
     * @param {PointerEvent|MouseEvent|TouchEvent} event
     * @param {boolean} snap if the pointer should check if snapping should be done
     * @returns {SVG.Point}
     */ static eventToPoint(event, snap = true) {
        //                touchstart/-move             touchend             mouse*
        //               /----------------\    /-----------------------\    /---\
        // clientXY = event.touches?.[0] ?? event.changedTouches?.[0] ?? event;
        let clientXY;
        if (window.TouchEvent && event instanceof TouchEvent) {
            let touch = event.touches.item(0) ?? event.changedTouches.item(0);
            clientXY = new $gBhAd.Point(touch.clientX, touch.clientY);
        } else //@ts-ignore
        clientXY = new $gBhAd.Point(event.clientX, event.clientY);
        if (!$1c90e793f342bb2a$export$88e1240f06a672d2.instance.invScreenCTM) $1c90e793f342bb2a$export$88e1240f06a672d2.instance.invScreenCTM = $1c90e793f342bb2a$export$88e1240f06a672d2.instance.canvas.screenCTM().inverseO();
        let pt = new $gBhAd.Point(clientXY.x, clientXY.y).transformO($1c90e793f342bb2a$export$88e1240f06a672d2.instance.invScreenCTM);
        return event instanceof MouseEvent && event.shiftKey || !snap ? pt : (0, $53f326ae950d374f$export$6c6ec69acef94984).instance.snapPoint(pt, undefined);
    }
    /** how the grid should be drawn
     * @param {number} majorSizecm the distance between two major grid lines in cm
     * @param {int} majorSubdivisions how many minor grid lines are drawn per major grid line (>=1)
     */ changeGrid(majorSizecm, majorSubdivisions) {
        this.majorGridSubdivisions = majorSubdivisions;
        this.majorGridSizecm = majorSizecm;
        let minorGridDistance = majorSizecm / majorSubdivisions;
        const snapDistanceNum = new $gBhAd.Number(minorGridDistance, "cm").toString();
        const snapDistancePx = new $gBhAd.Number(minorGridDistance, "cm").convertToUnit("px").value;
        const majorDistanceNum = new $gBhAd.Number(majorSizecm, "cm").toString();
        const majorDistancePx = new $gBhAd.Number(majorSizecm, "cm").convertToUnit("px").value;
        // change small grid
        const minorGrid = document.getElementById("smallGridPattern");
        minorGrid.setAttribute("width", snapDistanceNum);
        minorGrid.setAttribute("height", snapDistanceNum);
        minorGrid.children[0]?.setAttribute("d", `M ${snapDistancePx} 0 L 0 0 0 ${snapDistancePx}`);
        // change large grid
        const majorGrid = document.getElementById("gridPattern");
        majorGrid.setAttribute("width", majorDistanceNum);
        majorGrid.setAttribute("height", majorDistanceNum);
        majorGrid.children[0]?.setAttribute("width", majorDistanceNum);
        majorGrid.children[0]?.setAttribute("height", majorDistanceNum);
        majorGrid.children[1]?.setAttribute("d", `M ${majorDistancePx} 0 L 0 0 0 ${majorDistancePx}`);
        this.saveSettings();
    }
    /**
     * Called if the window/page is resized.
     *
     * Corrects the canvas viewBox. Also calls `#movePaper` to fix the axis.
     */ onResizeCanvas() {
        const newCanvasBounds = this.canvas.node.getBoundingClientRect();
        /** @type {SVG.Box} */ const oldViewbox = this.canvas.viewbox() || new $gBhAd.Box();
        const zoom = !this.canvasBounds ? 1 : Math.max(0.25, Math.min(10, this.canvasBounds.width / oldViewbox.width, this.canvasBounds.height / oldViewbox.height));
        const newViewbox = new $gBhAd.Box(oldViewbox.x, oldViewbox.y, newCanvasBounds.width / zoom, newCanvasBounds.height / zoom);
        this.canvas.viewbox(newViewbox);
        let customEvent = new CustomEvent("", {
            detail: {
                box: newViewbox,
                event: null
            }
        });
        this.movePaper(customEvent); // fixes axis
        this.canvasBounds = newCanvasBounds;
    }
    /**
     * Move paper/grid and axis on zoom/pan.
     */ movePaper(evt) {
        if (evt.detail instanceof Object && "level" in evt.detail) this.zoomCurrent = evt.detail.level;
        let box = this.canvas.viewbox();
        this.paper.move(box.x, box.y);
        this.xAxis.attr({
            x1: box.x,
            x2: box.x2
        });
        this.yAxis.attr({
            y1: box.y,
            y2: box.y2
        });
    }
}



var $gBhAd = parcelRequire("gBhAd");

class $7408c040b0c84b17$export$2933b4fdbb8e5219 {
    static _instance;
    constructor(){
        this.moveStart = this.moveStart.bind(this);
        this.moveListener = this.moveListener.bind(this);
        this.addUndo = this.addUndo.bind(this);
    }
    static get instance() {
        if (!$7408c040b0c84b17$export$2933b4fdbb8e5219._instance) $7408c040b0c84b17$export$2933b4fdbb8e5219._instance = new $7408c040b0c84b17$export$2933b4fdbb8e5219();
        return $7408c040b0c84b17$export$2933b4fdbb8e5219._instance;
    }
    dragging = false;
    didErase = false;
    deactivate() {
        // unregister move listener
        (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas.node.classList.remove("eraseCursor");
        (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas.off("mousedown", this.moveStart);
        (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas.off("touchdown", this.moveStart);
        (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas.off("mousemove", this.moveListener);
        (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas.off("touchmove", this.moveListener);
        (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas.off("mouseup", this.addUndo);
        (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas.off("touchend", this.addUndo);
    }
    activate() {
        (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas.node.classList.add("eraseCursor");
        (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas.on("mousedown", this.moveStart);
        (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas.on("touchstart", this.moveStart);
        (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas.on("mousemove", this.moveListener);
        (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas.on("touchmove", this.moveListener);
        (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas.on("mouseup", this.addUndo);
        (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas.on("touchend", this.addUndo);
    }
    moveStart(event) {
        if (event instanceof MouseEvent && event.button !== 0) return;
        if (window.TouchEvent && event instanceof TouchEvent && event.touches.length !== 1) return;
        this.dragging = true;
    }
    moveListener(event) {
        if (!this.dragging) return;
        if (event instanceof MouseEvent && (event.buttons & 1 || event.type !== "mousemove" && event.button === 0) || window.TouchEvent && event instanceof TouchEvent && window.TouchEvent && event.touches.length === 1) this.findAndErase((0, $1c90e793f342bb2a$export$88e1240f06a672d2).eventToPoint(event, false));
    }
    addUndo(event) {
        if (event instanceof MouseEvent && event.button !== 0) return;
        if (window.TouchEvent && event instanceof TouchEvent && event.touches.length !== 0) return;
        if (this.didErase) {
            (0, $815383aeedb00f00$export$897c9ed706d8ea48).addState();
            this.didErase = false;
        }
        this.dragging = false;
    }
    findAndErase(pos) {
        let intersectionRect = new $gBhAd.Box(pos.x - 5, pos.y - 5, 10, 10);
        for (const component of (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.circuitComponents)if (component.isInsideSelectionRectangle(intersectionRect)) {
            (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.removeComponent(component);
            this.didErase = true;
            break;
        }
    }
}




var $23e83188f10c8284$exports = {};
(function(a, b) {
    if ("function" == typeof define && define.amd) define([], b);
    else b();
})($23e83188f10c8284$exports, function() {
    "use strict";
    function b(a, b) {
        return "undefined" == typeof b ? b = {
            autoBom: !1
        } : "object" != typeof b && (console.warn("Deprecated: Expected third argument to be a object"), b = {
            autoBom: !b
        }), b.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type) ? new Blob([
            "\uFEFF",
            a
        ], {
            type: a.type
        }) : a;
    }
    function c(a, b, c) {
        var d = new XMLHttpRequest;
        d.open("GET", a), d.responseType = "blob", d.onload = function() {
            g(d.response, b, c);
        }, d.onerror = function() {
            console.error("could not download file");
        }, d.send();
    }
    function d(a) {
        var b = new XMLHttpRequest;
        b.open("HEAD", a, !1);
        try {
            b.send();
        } catch (a) {}
        return 200 <= b.status && 299 >= b.status;
    }
    function e(a) {
        try {
            a.dispatchEvent(new MouseEvent("click"));
        } catch (c) {
            var b = document.createEvent("MouseEvents");
            b.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), a.dispatchEvent(b);
        }
    }
    var f = "object" == typeof window && window.window === window ? window : "object" == typeof self && self.self === self ? self : "object" == typeof $parcel$global && $parcel$global.global === $parcel$global ? $parcel$global : void 0, a = f.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent), g = f.saveAs || ("object" != typeof window || window !== f ? function() {} : "download" in HTMLAnchorElement.prototype && !a ? function(b, g, h) {
        var i = f.URL || f.webkitURL, j = document.createElement("a");
        g = g || b.name || "download", j.download = g, j.rel = "noopener", "string" == typeof b ? (j.href = b, j.origin === location.origin ? e(j) : d(j.href) ? c(b, g, h) : e(j, j.target = "_blank")) : (j.href = i.createObjectURL(b), setTimeout(function() {
            i.revokeObjectURL(j.href);
        }, 4E4), setTimeout(function() {
            e(j);
        }, 0));
    } : "msSaveOrOpenBlob" in navigator ? function(f, g, h) {
        if (g = g || f.name || "download", "string" != typeof f) navigator.msSaveOrOpenBlob(b(f, h), g);
        else if (d(f)) c(f, g, h);
        else {
            var i = document.createElement("a");
            i.href = f, i.target = "_blank", setTimeout(function() {
                e(i);
            });
        }
    } : function(b, d, e, g) {
        if (g = g || open("", "_blank"), g && (g.document.title = g.document.body.innerText = "downloading..."), "string" == typeof b) return c(b, d, e);
        var h = "application/octet-stream" === b.type, i = /constructor/i.test(f.HTMLElement) || f.safari, j = /CriOS\/[\d]+/.test(navigator.userAgent);
        if ((j || h && i || a) && "undefined" != typeof FileReader) {
            var k = new FileReader;
            k.onloadend = function() {
                var a = k.result;
                a = j ? a : a.replace(/^data:[^;]*;/, "data:attachment/file;"), g ? g.location.href = a : location = a, g = null;
            }, k.readAsDataURL(b);
        } else {
            var l = f.URL || f.webkitURL, m = l.createObjectURL(b);
            g ? g.location = m : location.href = m, g = null, setTimeout(function() {
                l.revokeObjectURL(m);
            }, 4E4);
        }
    });
    f.saveAs = g.saveAs = g, $23e83188f10c8284$exports = g;
});


var $853c5f70df14f55b$exports = {};
(function(t) {
    function e() {
        var o = t();
        return o.default || o;
    }
    var f;
    $853c5f70df14f55b$exports = e();
})(function() {
    "use strict";
    var yu = Object.create;
    var He = Object.defineProperty;
    var Au = Object.getOwnPropertyDescriptor;
    var Bu = Object.getOwnPropertyNames;
    var wu = Object.getPrototypeOf, _u = Object.prototype.hasOwnProperty;
    var or = (e)=>{
        throw TypeError(e);
    };
    var xu = (e, t)=>()=>(e && (t = e(e = 0)), t);
    var At = (e, t)=>()=>(t || e((t = {
                exports: {}
            }).exports, t), t.exports), We = (e, t)=>{
        for(var r in t)He(e, r, {
            get: t[r],
            enumerable: !0
        });
    }, sr = (e, t, r, n)=>{
        if (t && typeof t == "object" || typeof t == "function") for (let i of Bu(t))!_u.call(e, i) && i !== r && He(e, i, {
            get: ()=>t[i],
            enumerable: !(n = Au(t, i)) || n.enumerable
        });
        return e;
    };
    var Me = (e, t, r)=>(r = e != null ? yu(wu(e)) : {}, sr(t || !e || !e.__esModule ? He(r, "default", {
            value: e,
            enumerable: !0
        }) : r, e)), ar = (e)=>sr(He({}, "__esModule", {
            value: !0
        }), e);
    var vu = (e, t, r)=>t.has(e) || or("Cannot " + r);
    var Dr = (e, t, r)=>t.has(e) ? or("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r);
    var pe = (e, t, r)=>(vu(e, t, "access private method"), r);
    var ot = At((oa, sn)=>{
        "use strict";
        var on = new Proxy(String, {
            get: ()=>on
        });
        sn.exports = on;
    });
    var Tn = {};
    We(Tn, {
        default: ()=>wi,
        shouldHighlight: ()=>Bi
    });
    var Bi, wi, kn = xu(()=>{
        Bi = ()=>!1, wi = String;
    });
    var Pn = At((bD, Xt)=>{
        var g = String, Ln = function() {
            return {
                isColorSupported: !1,
                reset: g,
                bold: g,
                dim: g,
                italic: g,
                underline: g,
                inverse: g,
                hidden: g,
                strikethrough: g,
                black: g,
                red: g,
                green: g,
                yellow: g,
                blue: g,
                magenta: g,
                cyan: g,
                white: g,
                gray: g,
                bgBlack: g,
                bgRed: g,
                bgGreen: g,
                bgYellow: g,
                bgBlue: g,
                bgMagenta: g,
                bgCyan: g,
                bgWhite: g
            };
        };
        Xt.exports = Ln();
        Xt.exports.createColors = Ln;
    });
    var $n = At((Ct)=>{
        "use strict";
        Object.defineProperty(Ct, "__esModule", {
            value: !0
        });
        Ct.codeFrameColumns = Mn;
        Ct.default = Si;
        var In = (kn(), ar(Tn)), Hn = _i(Pn(), !0);
        function Wn(e) {
            if (typeof WeakMap != "function") return null;
            var t = new WeakMap, r = new WeakMap;
            return (Wn = function(n) {
                return n ? r : t;
            })(e);
        }
        function _i(e, t) {
            if (!t && e && e.__esModule) return e;
            if (e === null || typeof e != "object" && typeof e != "function") return {
                default: e
            };
            var r = Wn(t);
            if (r && r.has(e)) return r.get(e);
            var n = {
                __proto__: null
            }, i = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for(var u in e)if (u !== "default" && ({}).hasOwnProperty.call(e, u)) {
                var o = i ? Object.getOwnPropertyDescriptor(e, u) : null;
                o && (o.get || o.set) ? Object.defineProperty(n, u, o) : n[u] = e[u];
            }
            return n.default = e, r && r.set(e, n), n;
        }
        var xi = Hn.default, Rn = (e, t)=>(r)=>e(t(r)), Zt;
        function vi(e) {
            if (e) {
                var t;
                return (t = Zt) != null || (Zt = (0, Hn.createColors)(!0)), Zt;
            }
            return xi;
        }
        var Yn = !1;
        function bi(e) {
            return {
                gutter: e.gray,
                marker: Rn(e.red, e.bold),
                message: Rn(e.red, e.bold)
            };
        }
        var jn = /\r\n|[\n\r\u2028\u2029]/;
        function Oi(e, t, r) {
            let n = Object.assign({
                column: 0,
                line: -1
            }, e.start), i = Object.assign({}, n, e.end), { linesAbove: u = 2, linesBelow: o = 3 } = r || {}, s = n.line, a = n.column, D = i.line, l = i.column, d = Math.max(s - (u + 1), 0), f = Math.min(t.length, D + o);
            s === -1 && (d = 0), D === -1 && (f = t.length);
            let p = D - s, c = {};
            if (p) for(let F = 0; F <= p; F++){
                let m = F + s;
                if (!a) c[m] = !0;
                else if (F === 0) {
                    let E = t[m - 1].length;
                    c[m] = [
                        a,
                        E - a + 1
                    ];
                } else if (F === p) c[m] = [
                    0,
                    l
                ];
                else {
                    let E = t[m - F].length;
                    c[m] = [
                        0,
                        E
                    ];
                }
            }
            else a === l ? a ? c[s] = [
                a,
                0
            ] : c[s] = !0 : c[s] = [
                a,
                l - a
            ];
            return {
                start: d,
                end: f,
                markerLines: c
            };
        }
        function Mn(e, t, r = {}) {
            let n = (r.highlightCode || r.forceColor) && (0, In.shouldHighlight)(r), i = vi(r.forceColor), u = bi(i), o = (F, m)=>n ? F(m) : m, s = e.split(jn), { start: a, end: D, markerLines: l } = Oi(t, s, r), d = t.start && typeof t.start.column == "number", f = String(D).length, c = (n ? (0, In.default)(e, r) : e).split(jn, D).slice(a, D).map((F, m)=>{
                let E = a + 1 + m, w = ` ${` ${E}`.slice(-f)} |`, h = l[E], C = !l[E + 1];
                if (h) {
                    let k = "";
                    if (Array.isArray(h)) {
                        let v = F.slice(0, Math.max(h[0] - 1, 0)).replace(/[^\t]/g, " "), $ = h[1] || 1;
                        k = [
                            `
 `,
                            o(u.gutter, w.replace(/\d/g, " ")),
                            " ",
                            v,
                            o(u.marker, "^").repeat($)
                        ].join(""), C && r.message && (k += " " + o(u.message, r.message));
                    }
                    return [
                        o(u.marker, ">"),
                        o(u.gutter, w),
                        F.length > 0 ? ` ${F}` : "",
                        k
                    ].join("");
                } else return ` ${o(u.gutter, w)}${F.length > 0 ? ` ${F}` : ""}`;
            }).join(`
`);
            return r.message && !d && (c = `${" ".repeat(f + 1)}${r.message}
${c}`), n ? i.reset(c) : c;
        }
        function Si(e, t, r, n = {}) {
            if (!Yn) {
                Yn = !0;
                let u = "Passing lineNumber and colNumber is deprecated to @babel/code-frame. Please use `codeFrameColumns`.";
                {
                    let o = new Error(u);
                    o.name = "DeprecationWarning", console.warn(new Error(u));
                }
            }
            return r = Math.max(r, 0), Mn(e, {
                start: {
                    column: r,
                    line: t
                }
            }, n);
        }
    });
    var po = {};
    We(po, {
        __debug: ()=>fo,
        check: ()=>lo,
        doc: ()=>nr,
        format: ()=>gu,
        formatWithCursor: ()=>Cu,
        getSupportInfo: ()=>co,
        util: ()=>ir,
        version: ()=>fu
    });
    var bu = (e, t, r, n)=>{
        if (!(e && t == null)) return t.replaceAll ? t.replaceAll(r, n) : r.global ? t.replace(r, n) : t.split(r).join(n);
    }, ne = bu;
    function Z() {}
    Z.prototype = {
        diff: function(t, r) {
            var n, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, u = i.callback;
            typeof i == "function" && (u = i, i = {}), this.options = i;
            var o = this;
            function s(h) {
                return u ? (setTimeout(function() {
                    u(void 0, h);
                }, 0), !0) : h;
            }
            t = this.castInput(t), r = this.castInput(r), t = this.removeEmpty(this.tokenize(t)), r = this.removeEmpty(this.tokenize(r));
            var a = r.length, D = t.length, l = 1, d = a + D;
            i.maxEditLength && (d = Math.min(d, i.maxEditLength));
            var f = (n = i.timeout) !== null && n !== void 0 ? n : 1 / 0, p = Date.now() + f, c = [
                {
                    oldPos: -1,
                    lastComponent: void 0
                }
            ], F = this.extractCommon(c[0], r, t, 0);
            if (c[0].oldPos + 1 >= D && F + 1 >= a) return s([
                {
                    value: this.join(r),
                    count: r.length
                }
            ]);
            var m = -1 / 0, E = 1 / 0;
            function A() {
                for(var h = Math.max(m, -l); h <= Math.min(E, l); h += 2){
                    var C = void 0, k = c[h - 1], v = c[h + 1];
                    k && (c[h - 1] = void 0);
                    var $ = !1;
                    if (v) {
                        var ye = v.oldPos - h;
                        $ = v && 0 <= ye && ye < a;
                    }
                    var yt = k && k.oldPos + 1 < D;
                    if (!$ && !yt) {
                        c[h] = void 0;
                        continue;
                    }
                    if (!yt || $ && k.oldPos + 1 < v.oldPos ? C = o.addToPath(v, !0, void 0, 0) : C = o.addToPath(k, void 0, !0, 1), F = o.extractCommon(C, r, t, h), C.oldPos + 1 >= D && F + 1 >= a) return s(Ou(o, C.lastComponent, r, t, o.useLongestToken));
                    c[h] = C, C.oldPos + 1 >= D && (E = Math.min(E, h - 1)), F + 1 >= a && (m = Math.max(m, h + 1));
                }
                l++;
            }
            if (u) (function h() {
                setTimeout(function() {
                    if (l > d || Date.now() > p) return u();
                    A() || h();
                }, 0);
            })();
            else for(; l <= d && Date.now() <= p;){
                var w = A();
                if (w) return w;
            }
        },
        addToPath: function(t, r, n, i) {
            var u = t.lastComponent;
            return u && u.added === r && u.removed === n ? {
                oldPos: t.oldPos + i,
                lastComponent: {
                    count: u.count + 1,
                    added: r,
                    removed: n,
                    previousComponent: u.previousComponent
                }
            } : {
                oldPos: t.oldPos + i,
                lastComponent: {
                    count: 1,
                    added: r,
                    removed: n,
                    previousComponent: u
                }
            };
        },
        extractCommon: function(t, r, n, i) {
            for(var u = r.length, o = n.length, s = t.oldPos, a = s - i, D = 0; a + 1 < u && s + 1 < o && this.equals(r[a + 1], n[s + 1]);)a++, s++, D++;
            return D && (t.lastComponent = {
                count: D,
                previousComponent: t.lastComponent
            }), t.oldPos = s, a;
        },
        equals: function(t, r) {
            return this.options.comparator ? this.options.comparator(t, r) : t === r || this.options.ignoreCase && t.toLowerCase() === r.toLowerCase();
        },
        removeEmpty: function(t) {
            for(var r = [], n = 0; n < t.length; n++)t[n] && r.push(t[n]);
            return r;
        },
        castInput: function(t) {
            return t;
        },
        tokenize: function(t) {
            return t.split("");
        },
        join: function(t) {
            return t.join("");
        }
    };
    function Ou(e, t, r, n, i) {
        for(var u = [], o; t;)u.push(t), o = t.previousComponent, delete t.previousComponent, t = o;
        u.reverse();
        for(var s = 0, a = u.length, D = 0, l = 0; s < a; s++){
            var d = u[s];
            if (d.removed) {
                if (d.value = e.join(n.slice(l, l + d.count)), l += d.count, s && u[s - 1].added) {
                    var p = u[s - 1];
                    u[s - 1] = u[s], u[s] = p;
                }
            } else {
                if (!d.added && i) {
                    var f = r.slice(D, D + d.count);
                    f = f.map(function(F, m) {
                        var E = n[l + m];
                        return E.length > F.length ? E : F;
                    }), d.value = e.join(f);
                } else d.value = e.join(r.slice(D, D + d.count));
                D += d.count, d.added || (l += d.count);
            }
        }
        var c = u[a - 1];
        return a > 1 && typeof c.value == "string" && (c.added || c.removed) && e.equals("", c.value) && (u[a - 2].value += c.value, u.pop()), u;
    }
    var ho = new Z;
    var lr = /^[A-Za-z\xC0-\u02C6\u02C8-\u02D7\u02DE-\u02FF\u1E00-\u1EFF]+$/, cr = /\S/, fr = new Z;
    fr.equals = function(e, t) {
        return this.options.ignoreCase && (e = e.toLowerCase(), t = t.toLowerCase()), e === t || this.options.ignoreWhitespace && !cr.test(e) && !cr.test(t);
    };
    fr.tokenize = function(e) {
        for(var t = e.split(/([^\S\r\n]+|[()[\]{}'"\r\n]|\b)/), r = 0; r < t.length - 1; r++)!t[r + 1] && t[r + 2] && lr.test(t[r]) && lr.test(t[r + 2]) && (t[r] += t[r + 2], t.splice(r + 1, 2), r--);
        return t;
    };
    var pr = new Z;
    pr.tokenize = function(e) {
        this.options.stripTrailingCr && (e = e.replace(/\r\n/g, `
`));
        var t = [], r = e.split(/(\n|\r\n)/);
        r[r.length - 1] || r.pop();
        for(var n = 0; n < r.length; n++){
            var i = r[n];
            n % 2 && !this.options.newlineIsToken ? t[t.length - 1] += i : (this.options.ignoreWhitespace && (i = i.trim()), t.push(i));
        }
        return t;
    };
    var Su = new Z;
    Su.tokenize = function(e) {
        return e.split(/(\S.+?[.!?])(?=\s+|$)/);
    };
    var Nu = new Z;
    Nu.tokenize = function(e) {
        return e.split(/([{}:;,]|\s+)/);
    };
    function $e(e) {
        "@babel/helpers - typeof";
        return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? $e = function(t) {
            return typeof t;
        } : $e = function(t) {
            return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, $e(e);
    }
    var Tu = Object.prototype.toString, Ae = new Z;
    Ae.useLongestToken = !0;
    Ae.tokenize = pr.tokenize;
    Ae.castInput = function(e) {
        var t = this.options, r = t.undefinedReplacement, n = t.stringifyReplacer, i = n === void 0 ? function(u, o) {
            return typeof o > "u" ? r : o;
        } : n;
        return typeof e == "string" ? e : JSON.stringify(Bt(e, null, null, i), i, "  ");
    };
    Ae.equals = function(e, t) {
        return Z.prototype.equals.call(Ae, e.replace(/,([\r\n])/g, "$1"), t.replace(/,([\r\n])/g, "$1"));
    };
    function Bt(e, t, r, n, i) {
        t = t || [], r = r || [], n && (e = n(i, e));
        var u;
        for(u = 0; u < t.length; u += 1)if (t[u] === e) return r[u];
        var o;
        if (Tu.call(e) === "[object Array]") {
            for(t.push(e), o = new Array(e.length), r.push(o), u = 0; u < e.length; u += 1)o[u] = Bt(e[u], t, r, n, i);
            return t.pop(), r.pop(), o;
        }
        if (e && e.toJSON && (e = e.toJSON()), $e(e) === "object" && e !== null) {
            t.push(e), o = {}, r.push(o);
            var s = [], a;
            for(a in e)e.hasOwnProperty(a) && s.push(a);
            for(s.sort(), u = 0; u < s.length; u += 1)a = s[u], o[a] = Bt(e[a], t, r, n, a);
            t.pop(), r.pop();
        } else o = e;
        return o;
    }
    var Ve = new Z;
    Ve.tokenize = function(e) {
        return e.slice();
    };
    Ve.join = Ve.removeEmpty = function(e) {
        return e;
    };
    function dr(e, t, r) {
        return Ve.diff(e, t, r);
    }
    function Fr(e) {
        let t = e.indexOf("\r");
        return t >= 0 ? e.charAt(t + 1) === `
` ? "crlf" : "cr" : "lf";
    }
    function Be(e) {
        switch(e){
            case "cr":
                return "\r";
            case "crlf":
                return `\r
`;
            default:
                return `
`;
        }
    }
    function wt(e, t) {
        let r;
        switch(t){
            case `
`:
                r = /\n/gu;
                break;
            case "\r":
                r = /\r/gu;
                break;
            case `\r
`:
                r = /\r\n/gu;
                break;
            default:
                throw new Error(`Unexpected "eol" ${JSON.stringify(t)}.`);
        }
        let n = e.match(r);
        return n ? n.length : 0;
    }
    function mr(e) {
        return ne(!1, e, /\r\n?/gu, `
`);
    }
    var U = "string", W = "array", z = "cursor", L = "indent", P = "align", I = "trim", _ = "group", S = "fill", x = "if-break", R = "indent-if-break", Y = "line-suffix", j = "line-suffix-boundary", B = "line", N = "label", b = "break-parent", Ue = new Set([
        z,
        L,
        P,
        I,
        _,
        S,
        x,
        R,
        Y,
        j,
        B,
        N,
        b
    ]);
    function ku(e) {
        if (typeof e == "string") return U;
        if (Array.isArray(e)) return W;
        if (!e) return;
        let { type: t } = e;
        if (Ue.has(t)) return t;
    }
    var G = ku;
    var Lu = (e)=>new Intl.ListFormat("en-US", {
            type: "disjunction"
        }).format(e);
    function Pu(e) {
        let t = e === null ? "null" : typeof e;
        if (t !== "string" && t !== "object") return `Unexpected doc '${t}', 
Expected it to be 'string' or 'object'.`;
        if (G(e)) throw new Error("doc is valid.");
        let r = Object.prototype.toString.call(e);
        if (r !== "[object Object]") return `Unexpected doc '${r}'.`;
        let n = Lu([
            ...Ue
        ].map((i)=>`'${i}'`));
        return `Unexpected doc.type '${e.type}'.
Expected it to be ${n}.`;
    }
    var _t = class extends Error {
        name = "InvalidDocError";
        constructor(t){
            super(Pu(t)), this.doc = t;
        }
    }, Q = _t;
    var Er = {};
    function Iu(e, t, r, n) {
        let i = [
            e
        ];
        for(; i.length > 0;){
            let u = i.pop();
            if (u === Er) {
                r(i.pop());
                continue;
            }
            r && i.push(u, Er);
            let o = G(u);
            if (!o) throw new Q(u);
            if ((t == null ? void 0 : t(u)) !== !1) switch(o){
                case W:
                case S:
                    {
                        let s = o === W ? u : u.parts;
                        for(let a = s.length, D = a - 1; D >= 0; --D)i.push(s[D]);
                        break;
                    }
                case x:
                    i.push(u.flatContents, u.breakContents);
                    break;
                case _:
                    if (n && u.expandedStates) for(let s = u.expandedStates.length, a = s - 1; a >= 0; --a)i.push(u.expandedStates[a]);
                    else i.push(u.contents);
                    break;
                case P:
                case L:
                case R:
                case N:
                case Y:
                    i.push(u.contents);
                    break;
                case U:
                case z:
                case I:
                case j:
                case B:
                case b:
                    break;
                default:
                    throw new Q(u);
            }
        }
    }
    var we = Iu;
    var hr = ()=>{}, K = hr, ze = hr;
    function De(e) {
        return K(e), {
            type: L,
            contents: e
        };
    }
    function ae(e, t) {
        return K(t), {
            type: P,
            contents: t,
            n: e
        };
    }
    function xt(e, t = {}) {
        return K(e), ze(t.expandedStates, !0), {
            type: _,
            id: t.id,
            contents: e,
            break: !!t.shouldBreak,
            expandedStates: t.expandedStates
        };
    }
    function Cr(e) {
        return ae(Number.NEGATIVE_INFINITY, e);
    }
    function gr(e) {
        return ae({
            type: "root"
        }, e);
    }
    function yr(e) {
        return ae(-1, e);
    }
    function Ar(e, t) {
        return xt(e[0], {
            ...t,
            expandedStates: e
        });
    }
    function Ge(e) {
        return ze(e), {
            type: S,
            parts: e
        };
    }
    function Br(e, t = "", r = {}) {
        return K(e), t !== "" && K(t), {
            type: x,
            breakContents: e,
            flatContents: t,
            groupId: r.groupId
        };
    }
    function wr(e, t) {
        return K(e), {
            type: R,
            contents: e,
            groupId: t.groupId,
            negate: t.negate
        };
    }
    function _e(e) {
        return K(e), {
            type: Y,
            contents: e
        };
    }
    var _r = {
        type: j
    }, de = {
        type: b
    }, xr = {
        type: I
    }, xe = {
        type: B,
        hard: !0
    }, vt = {
        type: B,
        hard: !0,
        literal: !0
    }, Ke = {
        type: B
    }, vr = {
        type: B,
        soft: !0
    }, q = [
        xe,
        de
    ], qe = [
        vt,
        de
    ], ve = {
        type: z
    };
    function be(e, t) {
        K(e), ze(t);
        let r = [];
        for(let n = 0; n < t.length; n++)n !== 0 && r.push(e), r.push(t[n]);
        return r;
    }
    function Je(e, t, r) {
        K(e);
        let n = e;
        if (t > 0) {
            for(let i = 0; i < Math.floor(t / r); ++i)n = De(n);
            n = ae(t % r, n), n = ae(Number.NEGATIVE_INFINITY, n);
        }
        return n;
    }
    function br(e, t) {
        return K(t), e ? {
            type: N,
            label: e,
            contents: t
        } : t;
    }
    function ee(e) {
        var t;
        if (!e) return "";
        if (Array.isArray(e)) {
            let r = [];
            for (let n of e)if (Array.isArray(n)) r.push(...ee(n));
            else {
                let i = ee(n);
                i !== "" && r.push(i);
            }
            return r;
        }
        return e.type === x ? {
            ...e,
            breakContents: ee(e.breakContents),
            flatContents: ee(e.flatContents)
        } : e.type === _ ? {
            ...e,
            contents: ee(e.contents),
            expandedStates: (t = e.expandedStates) == null ? void 0 : t.map(ee)
        } : e.type === S ? {
            type: "fill",
            parts: e.parts.map(ee)
        } : e.contents ? {
            ...e,
            contents: ee(e.contents)
        } : e;
    }
    function Or(e) {
        let t = Object.create(null), r = new Set;
        return n(ee(e));
        function n(u, o, s) {
            var a, D;
            if (typeof u == "string") return JSON.stringify(u);
            if (Array.isArray(u)) {
                let l = u.map(n).filter(Boolean);
                return l.length === 1 ? l[0] : `[${l.join(", ")}]`;
            }
            if (u.type === B) {
                let l = ((a = s == null ? void 0 : s[o + 1]) == null ? void 0 : a.type) === b;
                return u.literal ? l ? "literalline" : "literallineWithoutBreakParent" : u.hard ? l ? "hardline" : "hardlineWithoutBreakParent" : u.soft ? "softline" : "line";
            }
            if (u.type === b) return ((D = s == null ? void 0 : s[o - 1]) == null ? void 0 : D.type) === B && s[o - 1].hard ? void 0 : "breakParent";
            if (u.type === I) return "trim";
            if (u.type === L) return "indent(" + n(u.contents) + ")";
            if (u.type === P) return u.n === Number.NEGATIVE_INFINITY ? "dedentToRoot(" + n(u.contents) + ")" : u.n < 0 ? "dedent(" + n(u.contents) + ")" : u.n.type === "root" ? "markAsRoot(" + n(u.contents) + ")" : "align(" + JSON.stringify(u.n) + ", " + n(u.contents) + ")";
            if (u.type === x) return "ifBreak(" + n(u.breakContents) + (u.flatContents ? ", " + n(u.flatContents) : "") + (u.groupId ? (u.flatContents ? "" : ', ""') + `, { groupId: ${i(u.groupId)} }` : "") + ")";
            if (u.type === R) {
                let l = [];
                u.negate && l.push("negate: true"), u.groupId && l.push(`groupId: ${i(u.groupId)}`);
                let d = l.length > 0 ? `, { ${l.join(", ")} }` : "";
                return `indentIfBreak(${n(u.contents)}${d})`;
            }
            if (u.type === _) {
                let l = [];
                u.break && u.break !== "propagated" && l.push("shouldBreak: true"), u.id && l.push(`id: ${i(u.id)}`);
                let d = l.length > 0 ? `, { ${l.join(", ")} }` : "";
                return u.expandedStates ? `conditionalGroup([${u.expandedStates.map((f)=>n(f)).join(",")}]${d})` : `group(${n(u.contents)}${d})`;
            }
            if (u.type === S) return `fill([${u.parts.map((l)=>n(l)).join(", ")}])`;
            if (u.type === Y) return "lineSuffix(" + n(u.contents) + ")";
            if (u.type === j) return "lineSuffixBoundary";
            if (u.type === N) return `label(${JSON.stringify(u.label)}, ${n(u.contents)})`;
            throw new Error("Unknown doc type " + u.type);
        }
        function i(u) {
            if (typeof u != "symbol") return JSON.stringify(String(u));
            if (u in t) return t[u];
            let o = u.description || "symbol";
            for(let s = 0;; s++){
                let a = o + (s > 0 ? ` #${s}` : "");
                if (!r.has(a)) return r.add(a), t[u] = `Symbol.for(${JSON.stringify(a)})`;
            }
        }
    }
    var Ru = (e, t, r)=>{
        if (!(e && t == null)) return Array.isArray(t) || typeof t == "string" ? t[r < 0 ? t.length + r : r] : t.at(r);
    }, y = Ru;
    var Sr = ()=>/[#*0-9]\uFE0F?\u20E3|[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23ED-\u23EF\u23F1\u23F2\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A7\u26AA\u26B0\u26B1\u26BD\u26BE\u26C4\u26C8\u26CF\u26D1\u26E9\u26F0-\u26F5\u26F7\u26F8\u26FA\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2757\u2763\u27A1\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B55\u3030\u303D\u3297\u3299]\uFE0F?|[\u261D\u270C\u270D](?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?|[\u270A\u270B](?:\uD83C[\uDFFB-\uDFFF])?|[\u23E9-\u23EC\u23F0\u23F3\u25FD\u2693\u26A1\u26AB\u26C5\u26CE\u26D4\u26EA\u26FD\u2705\u2728\u274C\u274E\u2753-\u2755\u2795-\u2797\u27B0\u27BF\u2B50]|\u26D3\uFE0F?(?:\u200D\uD83D\uDCA5)?|\u26F9(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|\u2764\uFE0F?(?:\u200D(?:\uD83D\uDD25|\uD83E\uDE79))?|\uD83C(?:[\uDC04\uDD70\uDD71\uDD7E\uDD7F\uDE02\uDE37\uDF21\uDF24-\uDF2C\uDF36\uDF7D\uDF96\uDF97\uDF99-\uDF9B\uDF9E\uDF9F\uDFCD\uDFCE\uDFD4-\uDFDF\uDFF5\uDFF7]\uFE0F?|[\uDF85\uDFC2\uDFC7](?:\uD83C[\uDFFB-\uDFFF])?|[\uDFC4\uDFCA](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDFCB\uDFCC](?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDCCF\uDD8E\uDD91-\uDD9A\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF43\uDF45-\uDF4A\uDF4C-\uDF7C\uDF7E-\uDF84\uDF86-\uDF93\uDFA0-\uDFC1\uDFC5\uDFC6\uDFC8\uDFC9\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF8-\uDFFF]|\uDDE6\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF]|\uDDE7\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF]|\uDDE8\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF]|\uDDE9\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF]|\uDDEA\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA]|\uDDEB\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7]|\uDDEC\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE]|\uDDED\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA]|\uDDEE\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9]|\uDDEF\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5]|\uDDF0\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF]|\uDDF1\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE]|\uDDF2\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF]|\uDDF3\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF]|\uDDF4\uD83C\uDDF2|\uDDF5\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE]|\uDDF6\uD83C\uDDE6|\uDDF7\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC]|\uDDF8\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF]|\uDDF9\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF]|\uDDFA\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF]|\uDDFB\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA]|\uDDFC\uD83C[\uDDEB\uDDF8]|\uDDFD\uD83C\uDDF0|\uDDFE\uD83C[\uDDEA\uDDF9]|\uDDFF\uD83C[\uDDE6\uDDF2\uDDFC]|\uDF44(?:\u200D\uD83D\uDFEB)?|\uDF4B(?:\u200D\uD83D\uDFE9)?|\uDFC3(?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D(?:[\u2640\u2642]\uFE0F?(?:\u200D\u27A1\uFE0F?)?|\u27A1\uFE0F?))?|\uDFF3\uFE0F?(?:\u200D(?:\u26A7\uFE0F?|\uD83C\uDF08))?|\uDFF4(?:\u200D\u2620\uFE0F?|\uDB40\uDC67\uDB40\uDC62\uDB40(?:\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDC73\uDB40\uDC63\uDB40\uDC74|\uDC77\uDB40\uDC6C\uDB40\uDC73)\uDB40\uDC7F)?)|\uD83D(?:[\uDC3F\uDCFD\uDD49\uDD4A\uDD6F\uDD70\uDD73\uDD76-\uDD79\uDD87\uDD8A-\uDD8D\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA\uDECB\uDECD-\uDECF\uDEE0-\uDEE5\uDEE9\uDEF0\uDEF3]\uFE0F?|[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC](?:\uD83C[\uDFFB-\uDFFF])?|[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4\uDEB5](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD74\uDD90](?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?|[\uDC00-\uDC07\uDC09-\uDC14\uDC16-\uDC25\uDC27-\uDC3A\uDC3C-\uDC3E\uDC40\uDC44\uDC45\uDC51-\uDC65\uDC6A\uDC79-\uDC7B\uDC7D-\uDC80\uDC84\uDC88-\uDC8E\uDC90\uDC92-\uDCA9\uDCAB-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDDA4\uDDFB-\uDE2D\uDE2F-\uDE34\uDE37-\uDE41\uDE43\uDE44\uDE48-\uDE4A\uDE80-\uDEA2\uDEA4-\uDEB3\uDEB7-\uDEBF\uDEC1-\uDEC5\uDED0-\uDED2\uDED5-\uDED7\uDEDC-\uDEDF\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB\uDFF0]|\uDC08(?:\u200D\u2B1B)?|\uDC15(?:\u200D\uD83E\uDDBA)?|\uDC26(?:\u200D(?:\u2B1B|\uD83D\uDD25))?|\uDC3B(?:\u200D\u2744\uFE0F?)?|\uDC41\uFE0F?(?:\u200D\uD83D\uDDE8\uFE0F?)?|\uDC68(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDC68\uDC69]\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFE])))?))?|\uDC69(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?[\uDC68\uDC69]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?|\uDC69\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?))|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFE])))?))?|\uDC6F(?:\u200D[\u2640\u2642]\uFE0F?)?|\uDD75(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|\uDE2E(?:\u200D\uD83D\uDCA8)?|\uDE35(?:\u200D\uD83D\uDCAB)?|\uDE36(?:\u200D\uD83C\uDF2B\uFE0F?)?|\uDE42(?:\u200D[\u2194\u2195]\uFE0F?)?|\uDEB6(?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D(?:[\u2640\u2642]\uFE0F?(?:\u200D\u27A1\uFE0F?)?|\u27A1\uFE0F?))?)|\uD83E(?:[\uDD0C\uDD0F\uDD18-\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5\uDEC3-\uDEC5\uDEF0\uDEF2-\uDEF8](?:\uD83C[\uDFFB-\uDFFF])?|[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD\uDDCF\uDDD4\uDDD6-\uDDDD](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDDDE\uDDDF](?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD0D\uDD0E\uDD10-\uDD17\uDD20-\uDD25\uDD27-\uDD2F\uDD3A\uDD3F-\uDD45\uDD47-\uDD76\uDD78-\uDDB4\uDDB7\uDDBA\uDDBC-\uDDCC\uDDD0\uDDE0-\uDDFF\uDE70-\uDE7C\uDE80-\uDE88\uDE90-\uDEBD\uDEBF-\uDEC2\uDECE-\uDEDB\uDEE0-\uDEE8]|\uDD3C(?:\u200D[\u2640\u2642]\uFE0F?|\uD83C[\uDFFB-\uDFFF])?|\uDDCE(?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D(?:[\u2640\u2642]\uFE0F?(?:\u200D\u27A1\uFE0F?)?|\u27A1\uFE0F?))?|\uDDD1(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1|\uDDD1\u200D\uD83E\uDDD2(?:\u200D\uD83E\uDDD2)?|\uDDD2(?:\u200D\uD83E\uDDD2)?))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFC-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFD-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFD\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFE]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?))?|\uDEF1(?:\uD83C(?:\uDFFB(?:\u200D\uD83E\uDEF2\uD83C[\uDFFC-\uDFFF])?|\uDFFC(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFD-\uDFFF])?|\uDFFD(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])?|\uDFFE(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFD\uDFFF])?|\uDFFF(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFE])?))?)/g;
    function Nr(e) {
        return e === 12288 || e >= 65281 && e <= 65376 || e >= 65504 && e <= 65510;
    }
    function Tr(e) {
        return e >= 4352 && e <= 4447 || e === 8986 || e === 8987 || e === 9001 || e === 9002 || e >= 9193 && e <= 9196 || e === 9200 || e === 9203 || e === 9725 || e === 9726 || e === 9748 || e === 9749 || e >= 9800 && e <= 9811 || e === 9855 || e === 9875 || e === 9889 || e === 9898 || e === 9899 || e === 9917 || e === 9918 || e === 9924 || e === 9925 || e === 9934 || e === 9940 || e === 9962 || e === 9970 || e === 9971 || e === 9973 || e === 9978 || e === 9981 || e === 9989 || e === 9994 || e === 9995 || e === 10024 || e === 10060 || e === 10062 || e >= 10067 && e <= 10069 || e === 10071 || e >= 10133 && e <= 10135 || e === 10160 || e === 10175 || e === 11035 || e === 11036 || e === 11088 || e === 11093 || e >= 11904 && e <= 11929 || e >= 11931 && e <= 12019 || e >= 12032 && e <= 12245 || e >= 12272 && e <= 12287 || e >= 12289 && e <= 12350 || e >= 12353 && e <= 12438 || e >= 12441 && e <= 12543 || e >= 12549 && e <= 12591 || e >= 12593 && e <= 12686 || e >= 12688 && e <= 12771 || e >= 12783 && e <= 12830 || e >= 12832 && e <= 12871 || e >= 12880 && e <= 19903 || e >= 19968 && e <= 42124 || e >= 42128 && e <= 42182 || e >= 43360 && e <= 43388 || e >= 44032 && e <= 55203 || e >= 63744 && e <= 64255 || e >= 65040 && e <= 65049 || e >= 65072 && e <= 65106 || e >= 65108 && e <= 65126 || e >= 65128 && e <= 65131 || e >= 94176 && e <= 94180 || e === 94192 || e === 94193 || e >= 94208 && e <= 100343 || e >= 100352 && e <= 101589 || e >= 101632 && e <= 101640 || e >= 110576 && e <= 110579 || e >= 110581 && e <= 110587 || e === 110589 || e === 110590 || e >= 110592 && e <= 110882 || e === 110898 || e >= 110928 && e <= 110930 || e === 110933 || e >= 110948 && e <= 110951 || e >= 110960 && e <= 111355 || e === 126980 || e === 127183 || e === 127374 || e >= 127377 && e <= 127386 || e >= 127488 && e <= 127490 || e >= 127504 && e <= 127547 || e >= 127552 && e <= 127560 || e === 127568 || e === 127569 || e >= 127584 && e <= 127589 || e >= 127744 && e <= 127776 || e >= 127789 && e <= 127797 || e >= 127799 && e <= 127868 || e >= 127870 && e <= 127891 || e >= 127904 && e <= 127946 || e >= 127951 && e <= 127955 || e >= 127968 && e <= 127984 || e === 127988 || e >= 127992 && e <= 128062 || e === 128064 || e >= 128066 && e <= 128252 || e >= 128255 && e <= 128317 || e >= 128331 && e <= 128334 || e >= 128336 && e <= 128359 || e === 128378 || e === 128405 || e === 128406 || e === 128420 || e >= 128507 && e <= 128591 || e >= 128640 && e <= 128709 || e === 128716 || e >= 128720 && e <= 128722 || e >= 128725 && e <= 128727 || e >= 128732 && e <= 128735 || e === 128747 || e === 128748 || e >= 128756 && e <= 128764 || e >= 128992 && e <= 129003 || e === 129008 || e >= 129292 && e <= 129338 || e >= 129340 && e <= 129349 || e >= 129351 && e <= 129535 || e >= 129648 && e <= 129660 || e >= 129664 && e <= 129672 || e >= 129680 && e <= 129725 || e >= 129727 && e <= 129733 || e >= 129742 && e <= 129755 || e >= 129760 && e <= 129768 || e >= 129776 && e <= 129784 || e >= 131072 && e <= 196605 || e >= 196608 && e <= 262141;
    }
    var kr = (e)=>!(Nr(e) || Tr(e));
    var Yu = /[^\x20-\x7F]/u;
    function ju(e) {
        if (!e) return 0;
        if (!Yu.test(e)) return e.length;
        e = e.replace(Sr(), "  ");
        let t = 0;
        for (let r of e){
            let n = r.codePointAt(0);
            n <= 31 || n >= 127 && n <= 159 || n >= 768 && n <= 879 || (t += kr(n) ? 1 : 2);
        }
        return t;
    }
    var Oe = ju;
    function Ne(e, t) {
        if (typeof e == "string") return t(e);
        let r = new Map;
        return n(e);
        function n(u) {
            if (r.has(u)) return r.get(u);
            let o = i(u);
            return r.set(u, o), o;
        }
        function i(u) {
            switch(G(u)){
                case W:
                    return t(u.map(n));
                case S:
                    return t({
                        ...u,
                        parts: u.parts.map(n)
                    });
                case x:
                    return t({
                        ...u,
                        breakContents: n(u.breakContents),
                        flatContents: n(u.flatContents)
                    });
                case _:
                    {
                        let { expandedStates: o, contents: s } = u;
                        return o ? (o = o.map(n), s = o[0]) : s = n(s), t({
                            ...u,
                            contents: s,
                            expandedStates: o
                        });
                    }
                case P:
                case L:
                case R:
                case N:
                case Y:
                    return t({
                        ...u,
                        contents: n(u.contents)
                    });
                case U:
                case z:
                case I:
                case j:
                case B:
                case b:
                    return t(u);
                default:
                    throw new Q(u);
            }
        }
    }
    function Xe(e, t, r) {
        let n = r, i = !1;
        function u(o) {
            if (i) return !1;
            let s = t(o);
            s !== void 0 && (i = !0, n = s);
        }
        return we(e, u), n;
    }
    function Hu(e) {
        if (e.type === _ && e.break || e.type === B && e.hard || e.type === b) return !0;
    }
    function Ir(e) {
        return Xe(e, Hu, !1);
    }
    function Lr(e) {
        if (e.length > 0) {
            let t = y(!1, e, -1);
            !t.expandedStates && !t.break && (t.break = "propagated");
        }
        return null;
    }
    function Rr(e) {
        let t = new Set, r = [];
        function n(u) {
            if (u.type === b && Lr(r), u.type === _) {
                if (r.push(u), t.has(u)) return !1;
                t.add(u);
            }
        }
        function i(u) {
            u.type === _ && r.pop().break && Lr(r);
        }
        we(e, n, i, !0);
    }
    function Wu(e) {
        return e.type === B && !e.hard ? e.soft ? "" : " " : e.type === x ? e.flatContents : e;
    }
    function Yr(e) {
        return Ne(e, Wu);
    }
    function Pr(e) {
        for(e = [
            ...e
        ]; e.length >= 2 && y(!1, e, -2).type === B && y(!1, e, -1).type === b;)e.length -= 2;
        if (e.length > 0) {
            let t = Se(y(!1, e, -1));
            e[e.length - 1] = t;
        }
        return e;
    }
    function Se(e) {
        switch(G(e)){
            case L:
            case R:
            case _:
            case Y:
            case N:
                {
                    let t = Se(e.contents);
                    return {
                        ...e,
                        contents: t
                    };
                }
            case x:
                return {
                    ...e,
                    breakContents: Se(e.breakContents),
                    flatContents: Se(e.flatContents)
                };
            case S:
                return {
                    ...e,
                    parts: Pr(e.parts)
                };
            case W:
                return Pr(e);
            case U:
                return e.replace(/[\n\r]*$/u, "");
            case P:
            case z:
            case I:
            case j:
            case B:
            case b:
                break;
            default:
                throw new Q(e);
        }
        return e;
    }
    function Ze(e) {
        return Se($u(e));
    }
    function Mu(e) {
        switch(G(e)){
            case S:
                if (e.parts.every((t)=>t === "")) return "";
                break;
            case _:
                if (!e.contents && !e.id && !e.break && !e.expandedStates) return "";
                if (e.contents.type === _ && e.contents.id === e.id && e.contents.break === e.break && e.contents.expandedStates === e.expandedStates) return e.contents;
                break;
            case P:
            case L:
            case R:
            case Y:
                if (!e.contents) return "";
                break;
            case x:
                if (!e.flatContents && !e.breakContents) return "";
                break;
            case W:
                {
                    let t = [];
                    for (let r of e){
                        if (!r) continue;
                        let [n, ...i] = Array.isArray(r) ? r : [
                            r
                        ];
                        typeof n == "string" && typeof y(!1, t, -1) == "string" ? t[t.length - 1] += n : t.push(n), t.push(...i);
                    }
                    return t.length === 0 ? "" : t.length === 1 ? t[0] : t;
                }
            case U:
            case z:
            case I:
            case j:
            case B:
            case N:
            case b:
                break;
            default:
                throw new Q(e);
        }
        return e;
    }
    function $u(e) {
        return Ne(e, (t)=>Mu(t));
    }
    function jr(e, t = qe) {
        return Ne(e, (r)=>typeof r == "string" ? be(t, r.split(`
`)) : r);
    }
    function Vu(e) {
        if (e.type === B) return !0;
    }
    function Hr(e) {
        return Xe(e, Vu, !1);
    }
    function Qe(e, t) {
        return e.type === N ? {
            ...e,
            contents: t(e.contents)
        } : t(e);
    }
    var H = Symbol("MODE_BREAK"), J = Symbol("MODE_FLAT"), Te = Symbol("cursor");
    function Wr() {
        return {
            value: "",
            length: 0,
            queue: []
        };
    }
    function Uu(e, t) {
        return bt(e, {
            type: "indent"
        }, t);
    }
    function zu(e, t, r) {
        return t === Number.NEGATIVE_INFINITY ? e.root || Wr() : t < 0 ? bt(e, {
            type: "dedent"
        }, r) : t ? t.type === "root" ? {
            ...e,
            root: e
        } : bt(e, {
            type: typeof t == "string" ? "stringAlign" : "numberAlign",
            n: t
        }, r) : e;
    }
    function bt(e, t, r) {
        let n = t.type === "dedent" ? e.queue.slice(0, -1) : [
            ...e.queue,
            t
        ], i = "", u = 0, o = 0, s = 0;
        for (let c of n)switch(c.type){
            case "indent":
                l(), r.useTabs ? a(1) : D(r.tabWidth);
                break;
            case "stringAlign":
                l(), i += c.n, u += c.n.length;
                break;
            case "numberAlign":
                o += 1, s += c.n;
                break;
            default:
                throw new Error(`Unexpected type '${c.type}'`);
        }
        return f(), {
            ...e,
            value: i,
            length: u,
            queue: n
        };
        function a(c) {
            i += "	".repeat(c), u += r.tabWidth * c;
        }
        function D(c) {
            i += " ".repeat(c), u += c;
        }
        function l() {
            r.useTabs ? d() : f();
        }
        function d() {
            o > 0 && a(o), p();
        }
        function f() {
            s > 0 && D(s), p();
        }
        function p() {
            o = 0, s = 0;
        }
    }
    function Ot(e) {
        let t = 0, r = 0, n = e.length;
        e: for(; n--;){
            let i = e[n];
            if (i === Te) {
                r++;
                continue;
            }
            for(let u = i.length - 1; u >= 0; u--){
                let o = i[u];
                if (o === " " || o === "	") t++;
                else {
                    e[n] = i.slice(0, u + 1);
                    break e;
                }
            }
        }
        if (t > 0 || r > 0) for(e.length = n + 1; r-- > 0;)e.push(Te);
        return t;
    }
    function et(e, t, r, n, i, u) {
        if (r === Number.POSITIVE_INFINITY) return !0;
        let o = t.length, s = [
            e
        ], a = [];
        for(; r >= 0;){
            if (s.length === 0) {
                if (o === 0) return !0;
                s.push(t[--o]);
                continue;
            }
            let { mode: D, doc: l } = s.pop(), d = G(l);
            switch(d){
                case U:
                    a.push(l), r -= Oe(l);
                    break;
                case W:
                case S:
                    {
                        let f = d === W ? l : l.parts;
                        for(let p = f.length - 1; p >= 0; p--)s.push({
                            mode: D,
                            doc: f[p]
                        });
                        break;
                    }
                case L:
                case P:
                case R:
                case N:
                    s.push({
                        mode: D,
                        doc: l.contents
                    });
                    break;
                case I:
                    r += Ot(a);
                    break;
                case _:
                    {
                        if (u && l.break) return !1;
                        let f = l.break ? H : D, p = l.expandedStates && f === H ? y(!1, l.expandedStates, -1) : l.contents;
                        s.push({
                            mode: f,
                            doc: p
                        });
                        break;
                    }
                case x:
                    {
                        let p = (l.groupId ? i[l.groupId] || J : D) === H ? l.breakContents : l.flatContents;
                        p && s.push({
                            mode: D,
                            doc: p
                        });
                        break;
                    }
                case B:
                    if (D === H || l.hard) return !0;
                    l.soft || (a.push(" "), r--);
                    break;
                case Y:
                    n = !0;
                    break;
                case j:
                    if (n) return !1;
                    break;
            }
        }
        return !1;
    }
    function Fe(e, t) {
        let r = {}, n = t.printWidth, i = Be(t.endOfLine), u = 0, o = [
            {
                ind: Wr(),
                mode: H,
                doc: e
            }
        ], s = [], a = !1, D = [], l = 0;
        for(Rr(e); o.length > 0;){
            let { ind: f, mode: p, doc: c } = o.pop();
            switch(G(c)){
                case U:
                    {
                        let F = i !== `
` ? ne(!1, c, `
`, i) : c;
                        s.push(F), o.length > 0 && (u += Oe(F));
                        break;
                    }
                case W:
                    for(let F = c.length - 1; F >= 0; F--)o.push({
                        ind: f,
                        mode: p,
                        doc: c[F]
                    });
                    break;
                case z:
                    if (l >= 2) throw new Error("There are too many 'cursor' in doc.");
                    s.push(Te), l++;
                    break;
                case L:
                    o.push({
                        ind: Uu(f, t),
                        mode: p,
                        doc: c.contents
                    });
                    break;
                case P:
                    o.push({
                        ind: zu(f, c.n, t),
                        mode: p,
                        doc: c.contents
                    });
                    break;
                case I:
                    u -= Ot(s);
                    break;
                case _:
                    switch(p){
                        case J:
                            if (!a) {
                                o.push({
                                    ind: f,
                                    mode: c.break ? H : J,
                                    doc: c.contents
                                });
                                break;
                            }
                        case H:
                            {
                                a = !1;
                                let F = {
                                    ind: f,
                                    mode: J,
                                    doc: c.contents
                                }, m = n - u, E = D.length > 0;
                                if (!c.break && et(F, o, m, E, r)) o.push(F);
                                else if (c.expandedStates) {
                                    let A = y(!1, c.expandedStates, -1);
                                    if (c.break) {
                                        o.push({
                                            ind: f,
                                            mode: H,
                                            doc: A
                                        });
                                        break;
                                    } else for(let w = 1; w < c.expandedStates.length + 1; w++)if (w >= c.expandedStates.length) {
                                        o.push({
                                            ind: f,
                                            mode: H,
                                            doc: A
                                        });
                                        break;
                                    } else {
                                        let h = c.expandedStates[w], C = {
                                            ind: f,
                                            mode: J,
                                            doc: h
                                        };
                                        if (et(C, o, m, E, r)) {
                                            o.push(C);
                                            break;
                                        }
                                    }
                                } else o.push({
                                    ind: f,
                                    mode: H,
                                    doc: c.contents
                                });
                                break;
                            }
                    }
                    c.id && (r[c.id] = y(!1, o, -1).mode);
                    break;
                case S:
                    {
                        let F = n - u, { parts: m } = c;
                        if (m.length === 0) break;
                        let [E, A] = m, w = {
                            ind: f,
                            mode: J,
                            doc: E
                        }, h = {
                            ind: f,
                            mode: H,
                            doc: E
                        }, C = et(w, [], F, D.length > 0, r, !0);
                        if (m.length === 1) {
                            C ? o.push(w) : o.push(h);
                            break;
                        }
                        let k = {
                            ind: f,
                            mode: J,
                            doc: A
                        }, v = {
                            ind: f,
                            mode: H,
                            doc: A
                        };
                        if (m.length === 2) {
                            C ? o.push(k, w) : o.push(v, h);
                            break;
                        }
                        m.splice(0, 2);
                        let $ = {
                            ind: f,
                            mode: p,
                            doc: Ge(m)
                        }, ye = m[0];
                        et({
                            ind: f,
                            mode: J,
                            doc: [
                                E,
                                A,
                                ye
                            ]
                        }, [], F, D.length > 0, r, !0) ? o.push($, k, w) : C ? o.push($, v, w) : o.push($, v, h);
                        break;
                    }
                case x:
                case R:
                    {
                        let F = c.groupId ? r[c.groupId] : p;
                        if (F === H) {
                            let m = c.type === x ? c.breakContents : c.negate ? c.contents : De(c.contents);
                            m && o.push({
                                ind: f,
                                mode: p,
                                doc: m
                            });
                        }
                        if (F === J) {
                            let m = c.type === x ? c.flatContents : c.negate ? De(c.contents) : c.contents;
                            m && o.push({
                                ind: f,
                                mode: p,
                                doc: m
                            });
                        }
                        break;
                    }
                case Y:
                    D.push({
                        ind: f,
                        mode: p,
                        doc: c.contents
                    });
                    break;
                case j:
                    D.length > 0 && o.push({
                        ind: f,
                        mode: p,
                        doc: xe
                    });
                    break;
                case B:
                    switch(p){
                        case J:
                            if (c.hard) a = !0;
                            else {
                                c.soft || (s.push(" "), u += 1);
                                break;
                            }
                        case H:
                            if (D.length > 0) {
                                o.push({
                                    ind: f,
                                    mode: p,
                                    doc: c
                                }, ...D.reverse()), D.length = 0;
                                break;
                            }
                            c.literal ? f.root ? (s.push(i, f.root.value), u = f.root.length) : (s.push(i), u = 0) : (u -= Ot(s), s.push(i + f.value), u = f.length);
                            break;
                    }
                    break;
                case N:
                    o.push({
                        ind: f,
                        mode: p,
                        doc: c.contents
                    });
                    break;
                case b:
                    break;
                default:
                    throw new Q(c);
            }
            o.length === 0 && D.length > 0 && (o.push(...D.reverse()), D.length = 0);
        }
        let d = s.indexOf(Te);
        if (d !== -1) {
            let f = s.indexOf(Te, d + 1), p = s.slice(0, d).join(""), c = s.slice(d + 1, f).join(""), F = s.slice(f + 1).join("");
            return {
                formatted: p + c + F,
                cursorNodeStart: p.length,
                cursorNodeText: c
            };
        }
        return {
            formatted: s.join("")
        };
    }
    function Gu(e, t, r = 0) {
        let n = 0;
        for(let i = r; i < e.length; ++i)e[i] === "	" ? n = n + t - n % t : n++;
        return n;
    }
    var me = Gu;
    var te, Nt, tt, St = class {
        constructor(t){
            Dr(this, te);
            this.stack = [
                t
            ];
        }
        get key() {
            let { stack: t, siblings: r } = this;
            return y(!1, t, r === null ? -2 : -4) ?? null;
        }
        get index() {
            return this.siblings === null ? null : y(!1, this.stack, -2);
        }
        get node() {
            return y(!1, this.stack, -1);
        }
        get parent() {
            return this.getNode(1);
        }
        get grandparent() {
            return this.getNode(2);
        }
        get isInArray() {
            return this.siblings !== null;
        }
        get siblings() {
            let { stack: t } = this, r = y(!1, t, -3);
            return Array.isArray(r) ? r : null;
        }
        get next() {
            let { siblings: t } = this;
            return t === null ? null : t[this.index + 1];
        }
        get previous() {
            let { siblings: t } = this;
            return t === null ? null : t[this.index - 1];
        }
        get isFirst() {
            return this.index === 0;
        }
        get isLast() {
            let { siblings: t, index: r } = this;
            return t !== null && r === t.length - 1;
        }
        get isRoot() {
            return this.stack.length === 1;
        }
        get root() {
            return this.stack[0];
        }
        get ancestors() {
            return [
                ...pe(this, te, tt).call(this)
            ];
        }
        getName() {
            let { stack: t } = this, { length: r } = t;
            return r > 1 ? y(!1, t, -2) : null;
        }
        getValue() {
            return y(!1, this.stack, -1);
        }
        getNode(t = 0) {
            let r = pe(this, te, Nt).call(this, t);
            return r === -1 ? null : this.stack[r];
        }
        getParentNode(t = 0) {
            return this.getNode(t + 1);
        }
        call(t, ...r) {
            let { stack: n } = this, { length: i } = n, u = y(!1, n, -1);
            for (let o of r)u = u[o], n.push(o, u);
            try {
                return t(this);
            } finally{
                n.length = i;
            }
        }
        callParent(t, r = 0) {
            let n = pe(this, te, Nt).call(this, r + 1), i = this.stack.splice(n + 1);
            try {
                return t(this);
            } finally{
                this.stack.push(...i);
            }
        }
        each(t, ...r) {
            let { stack: n } = this, { length: i } = n, u = y(!1, n, -1);
            for (let o of r)u = u[o], n.push(o, u);
            try {
                for(let o = 0; o < u.length; ++o)n.push(o, u[o]), t(this, o, u), n.length -= 2;
            } finally{
                n.length = i;
            }
        }
        map(t, ...r) {
            let n = [];
            return this.each((i, u, o)=>{
                n[u] = t(i, u, o);
            }, ...r), n;
        }
        match(...t) {
            let r = this.stack.length - 1, n = null, i = this.stack[r--];
            for (let u of t){
                if (i === void 0) return !1;
                let o = null;
                if (typeof n == "number" && (o = n, n = this.stack[r--], i = this.stack[r--]), u && !u(i, n, o)) return !1;
                n = this.stack[r--], i = this.stack[r--];
            }
            return !0;
        }
        findAncestor(t) {
            for (let r of pe(this, te, tt).call(this))if (t(r)) return r;
        }
        hasAncestor(t) {
            for (let r of pe(this, te, tt).call(this))if (t(r)) return !0;
            return !1;
        }
    };
    te = new WeakSet, Nt = function(t) {
        let { stack: r } = this;
        for(let n = r.length - 1; n >= 0; n -= 2)if (!Array.isArray(r[n]) && --t < 0) return n;
        return -1;
    }, tt = function*() {
        let { stack: t } = this;
        for(let r = t.length - 3; r >= 0; r -= 2){
            let n = t[r];
            Array.isArray(n) || (yield n);
        }
    };
    var Mr = St;
    var $r = new Proxy(()=>{}, {
        get: ()=>$r
    }), ke = $r;
    function Ku(e) {
        return e !== null && typeof e == "object";
    }
    var Vr = Ku;
    function* Tt(e, t) {
        let { getVisitorKeys: r, filter: n = ()=>!0 } = t, i = (u)=>Vr(u) && n(u);
        for (let u of r(e)){
            let o = e[u];
            if (Array.isArray(o)) for (let s of o)i(s) && (yield s);
            else i(o) && (yield o);
        }
    }
    function* Ur(e, t) {
        let r = [
            e
        ];
        for(let n = 0; n < r.length; n++){
            let i = r[n];
            for (let u of Tt(i, t))yield u, r.push(u);
        }
    }
    function Ee(e) {
        return (t, r, n)=>{
            let i = !!(n != null && n.backwards);
            if (r === !1) return !1;
            let { length: u } = t, o = r;
            for(; o >= 0 && o < u;){
                let s = t.charAt(o);
                if (e instanceof RegExp) {
                    if (!e.test(s)) return o;
                } else if (!e.includes(s)) return o;
                i ? o-- : o++;
            }
            return o === -1 || o === u ? o : !1;
        };
    }
    var zr = Ee(/\s/u), T = Ee(" 	"), rt = Ee(",; 	"), nt = Ee(/[^\n\r]/u);
    function qu(e, t, r) {
        let n = !!(r != null && r.backwards);
        if (t === !1) return !1;
        let i = e.charAt(t);
        if (n) {
            if (e.charAt(t - 1) === "\r" && i === `
`) return t - 2;
            if (i === `
` || i === "\r" || i === "\u2028" || i === "\u2029") return t - 1;
        } else {
            if (i === "\r" && e.charAt(t + 1) === `
`) return t + 2;
            if (i === `
` || i === "\r" || i === "\u2028" || i === "\u2029") return t + 1;
        }
        return t;
    }
    var M = qu;
    function Ju(e, t, r = {}) {
        let n = T(e, r.backwards ? t - 1 : t, r), i = M(e, n, r);
        return n !== i;
    }
    var V = Ju;
    function Xu(e) {
        return Array.isArray(e) && e.length > 0;
    }
    var kt = Xu;
    var Gr = new Set([
        "tokens",
        "comments",
        "parent",
        "enclosingNode",
        "precedingNode",
        "followingNode"
    ]), Zu = (e)=>Object.keys(e).filter((t)=>!Gr.has(t));
    function Qu(e) {
        return e ? (t)=>e(t, Gr) : Zu;
    }
    var X = Qu;
    function ei(e) {
        let t = e.type || e.kind || "(unknown type)", r = String(e.name || e.id && (typeof e.id == "object" ? e.id.name : e.id) || e.key && (typeof e.key == "object" ? e.key.name : e.key) || e.value && (typeof e.value == "object" ? "" : String(e.value)) || e.operator || "");
        return r.length > 20 && (r = r.slice(0, 19) + "\u2026"), t + (r ? " " + r : "");
    }
    function Lt(e, t) {
        (e.comments ?? (e.comments = [])).push(t), t.printed = !1, t.nodeDescription = ei(e);
    }
    function ue(e, t) {
        t.leading = !0, t.trailing = !1, Lt(e, t);
    }
    function re(e, t, r) {
        t.leading = !1, t.trailing = !1, r && (t.marker = r), Lt(e, t);
    }
    function ie(e, t) {
        t.leading = !1, t.trailing = !0, Lt(e, t);
    }
    var Pt = new WeakMap;
    function ut(e, t) {
        if (Pt.has(e)) return Pt.get(e);
        let { printer: { getCommentChildNodes: r, canAttachComment: n, getVisitorKeys: i }, locStart: u, locEnd: o } = t;
        if (!n) return [];
        let s = ((r == null ? void 0 : r(e, t)) ?? [
            ...Tt(e, {
                getVisitorKeys: X(i)
            })
        ]).flatMap((a)=>n(a) ? [
                a
            ] : ut(a, t));
        return s.sort((a, D)=>u(a) - u(D) || o(a) - o(D)), Pt.set(e, s), s;
    }
    function qr(e, t, r, n) {
        let { locStart: i, locEnd: u } = r, o = i(t), s = u(t), a = ut(e, r), D, l, d = 0, f = a.length;
        for(; d < f;){
            let p = d + f >> 1, c = a[p], F = i(c), m = u(c);
            if (F <= o && s <= m) return qr(c, t, r, c);
            if (m <= o) {
                D = c, d = p + 1;
                continue;
            }
            if (s <= F) {
                l = c, f = p;
                continue;
            }
            throw new Error("Comment location overlaps with node location");
        }
        if ((n == null ? void 0 : n.type) === "TemplateLiteral") {
            let { quasis: p } = n, c = Rt(p, t, r);
            D && Rt(p, D, r) !== c && (D = null), l && Rt(p, l, r) !== c && (l = null);
        }
        return {
            enclosingNode: n,
            precedingNode: D,
            followingNode: l
        };
    }
    var It = ()=>!1;
    function Jr(e, t) {
        let { comments: r } = e;
        if (delete e.comments, !kt(r) || !t.printer.canAttachComment) return;
        let n = [], { locStart: i, locEnd: u, printer: { experimentalFeatures: { avoidAstMutation: o = !1 } = {}, handleComments: s = {} }, originalText: a } = t, { ownLine: D = It, endOfLine: l = It, remaining: d = It } = s, f = r.map((p, c)=>({
                ...qr(e, p, t),
                comment: p,
                text: a,
                options: t,
                ast: e,
                isLastComment: r.length - 1 === c
            }));
        for (let [p, c] of f.entries()){
            let { comment: F, precedingNode: m, enclosingNode: E, followingNode: A, text: w, options: h, ast: C, isLastComment: k } = c;
            if (h.parser === "json" || h.parser === "json5" || h.parser === "jsonc" || h.parser === "__js_expression" || h.parser === "__ts_expression" || h.parser === "__vue_expression" || h.parser === "__vue_ts_expression") {
                if (i(F) - i(C) <= 0) {
                    ue(C, F);
                    continue;
                }
                if (u(F) - u(C) >= 0) {
                    ie(C, F);
                    continue;
                }
            }
            let v;
            if (o ? v = [
                c
            ] : (F.enclosingNode = E, F.precedingNode = m, F.followingNode = A, v = [
                F,
                w,
                h,
                C,
                k
            ]), ti(w, h, f, p)) F.placement = "ownLine", D(...v) || (A ? ue(A, F) : m ? ie(m, F) : E ? re(E, F) : re(C, F));
            else if (ri(w, h, f, p)) F.placement = "endOfLine", l(...v) || (m ? ie(m, F) : A ? ue(A, F) : E ? re(E, F) : re(C, F));
            else if (F.placement = "remaining", !d(...v)) {
                if (m && A) {
                    let $ = n.length;
                    $ > 0 && n[$ - 1].followingNode !== A && Kr(n, h), n.push(c);
                } else m ? ie(m, F) : A ? ue(A, F) : E ? re(E, F) : re(C, F);
            }
        }
        if (Kr(n, t), !o) for (let p of r)delete p.precedingNode, delete p.enclosingNode, delete p.followingNode;
    }
    var Xr = (e)=>!/[\S\n\u2028\u2029]/u.test(e);
    function ti(e, t, r, n) {
        let { comment: i, precedingNode: u } = r[n], { locStart: o, locEnd: s } = t, a = o(i);
        if (u) for(let D = n - 1; D >= 0; D--){
            let { comment: l, precedingNode: d } = r[D];
            if (d !== u || !Xr(e.slice(s(l), a))) break;
            a = o(l);
        }
        return V(e, a, {
            backwards: !0
        });
    }
    function ri(e, t, r, n) {
        let { comment: i, followingNode: u } = r[n], { locStart: o, locEnd: s } = t, a = s(i);
        if (u) for(let D = n + 1; D < r.length; D++){
            let { comment: l, followingNode: d } = r[D];
            if (d !== u || !Xr(e.slice(a, o(l)))) break;
            a = s(l);
        }
        return V(e, a);
    }
    function Kr(e, t) {
        var s, a;
        let r = e.length;
        if (r === 0) return;
        let { precedingNode: n, followingNode: i } = e[0], u = t.locStart(i), o;
        for(o = r; o > 0; --o){
            let { comment: D, precedingNode: l, followingNode: d } = e[o - 1];
            ke.strictEqual(l, n), ke.strictEqual(d, i);
            let f = t.originalText.slice(t.locEnd(D), u);
            if (((a = (s = t.printer).isGap) == null ? void 0 : a.call(s, f, t)) ?? /^[\s(]*$/u.test(f)) u = t.locStart(D);
            else break;
        }
        for (let [D, { comment: l }] of e.entries())D < o ? ie(n, l) : ue(i, l);
        for (let D of [
            n,
            i
        ])D.comments && D.comments.length > 1 && D.comments.sort((l, d)=>t.locStart(l) - t.locStart(d));
        e.length = 0;
    }
    function Rt(e, t, r) {
        let n = r.locStart(t) - 1;
        for(let i = 1; i < e.length; ++i)if (n < r.locStart(e[i])) return i - 1;
        return 0;
    }
    function ni(e, t) {
        let r = t - 1;
        r = T(e, r, {
            backwards: !0
        }), r = M(e, r, {
            backwards: !0
        }), r = T(e, r, {
            backwards: !0
        });
        let n = M(e, r, {
            backwards: !0
        });
        return r !== n;
    }
    var Le = ni;
    function Zr(e, t) {
        let r = e.node;
        return r.printed = !0, t.printer.printComment(e, t);
    }
    function ui(e, t) {
        var l;
        let r = e.node, n = [
            Zr(e, t)
        ], { printer: i, originalText: u, locStart: o, locEnd: s } = t;
        if ((l = i.isBlockComment) == null ? void 0 : l.call(i, r)) {
            let d = V(u, s(r)) ? V(u, o(r), {
                backwards: !0
            }) ? q : Ke : " ";
            n.push(d);
        } else n.push(q);
        let D = M(u, T(u, s(r)));
        return D !== !1 && V(u, D) && n.push(q), n;
    }
    function ii(e, t, r) {
        var D;
        let n = e.node, i = Zr(e, t), { printer: u, originalText: o, locStart: s } = t, a = (D = u.isBlockComment) == null ? void 0 : D.call(u, n);
        if (r != null && r.hasLineSuffix && !(r != null && r.isBlock) || V(o, s(n), {
            backwards: !0
        })) {
            let l = Le(o, s(n));
            return {
                doc: _e([
                    q,
                    l ? q : "",
                    i
                ]),
                isBlock: a,
                hasLineSuffix: !0
            };
        }
        return !a || r != null && r.hasLineSuffix ? {
            doc: [
                _e([
                    " ",
                    i
                ]),
                de
            ],
            isBlock: a,
            hasLineSuffix: !0
        } : {
            doc: [
                " ",
                i
            ],
            isBlock: a,
            hasLineSuffix: !1
        };
    }
    function oi(e, t) {
        let r = e.node;
        if (!r) return {};
        let n = t[Symbol.for("printedComments")];
        if ((r.comments || []).filter((a)=>!n.has(a)).length === 0) return {
            leading: "",
            trailing: ""
        };
        let u = [], o = [], s;
        return e.each(()=>{
            let a = e.node;
            if (n != null && n.has(a)) return;
            let { leading: D, trailing: l } = a;
            D ? u.push(ui(e, t)) : l && (s = ii(e, t, s), o.push(s.doc));
        }, "comments"), {
            leading: u,
            trailing: o
        };
    }
    function Qr(e, t, r) {
        let { leading: n, trailing: i } = oi(e, r);
        return !n && !i ? t : Qe(t, (u)=>[
                n,
                u,
                i
            ]);
    }
    function en(e) {
        let { [Symbol.for("comments")]: t, [Symbol.for("printedComments")]: r } = e;
        for (let n of t){
            if (!n.printed && !r.has(n)) throw new Error('Comment "' + n.value.trim() + '" was not printed. Please report this error!');
            delete n.printed;
        }
    }
    function si(e) {
        return ()=>{};
    }
    var tn = si;
    var Pe = class extends Error {
        name = "ConfigError";
    }, Ie = class extends Error {
        name = "UndefinedParserError";
    };
    var rn = {
        cursorOffset: {
            category: "Special",
            type: "int",
            default: -1,
            range: {
                start: -1,
                end: 1 / 0,
                step: 1
            },
            description: "Print (to stderr) where a cursor at the given position would move to after formatting.",
            cliCategory: "Editor"
        },
        endOfLine: {
            category: "Global",
            type: "choice",
            default: "lf",
            description: "Which end of line characters to apply.",
            choices: [
                {
                    value: "lf",
                    description: "Line Feed only (\\n), common on Linux and macOS as well as inside git repos"
                },
                {
                    value: "crlf",
                    description: "Carriage Return + Line Feed characters (\\r\\n), common on Windows"
                },
                {
                    value: "cr",
                    description: "Carriage Return character only (\\r), used very rarely"
                },
                {
                    value: "auto",
                    description: `Maintain existing
(mixed values within one file are normalised by looking at what's used after the first line)`
                }
            ]
        },
        filepath: {
            category: "Special",
            type: "path",
            description: "Specify the input filepath. This will be used to do parser inference.",
            cliName: "stdin-filepath",
            cliCategory: "Other",
            cliDescription: "Path to the file to pretend that stdin comes from."
        },
        insertPragma: {
            category: "Special",
            type: "boolean",
            default: !1,
            description: "Insert @format pragma into file's first docblock comment.",
            cliCategory: "Other"
        },
        parser: {
            category: "Global",
            type: "choice",
            default: void 0,
            description: "Which parser to use.",
            exception: (e)=>typeof e == "string" || typeof e == "function",
            choices: [
                {
                    value: "flow",
                    description: "Flow"
                },
                {
                    value: "babel",
                    description: "JavaScript"
                },
                {
                    value: "babel-flow",
                    description: "Flow"
                },
                {
                    value: "babel-ts",
                    description: "TypeScript"
                },
                {
                    value: "typescript",
                    description: "TypeScript"
                },
                {
                    value: "acorn",
                    description: "JavaScript"
                },
                {
                    value: "espree",
                    description: "JavaScript"
                },
                {
                    value: "meriyah",
                    description: "JavaScript"
                },
                {
                    value: "css",
                    description: "CSS"
                },
                {
                    value: "less",
                    description: "Less"
                },
                {
                    value: "scss",
                    description: "SCSS"
                },
                {
                    value: "json",
                    description: "JSON"
                },
                {
                    value: "json5",
                    description: "JSON5"
                },
                {
                    value: "jsonc",
                    description: "JSON with Comments"
                },
                {
                    value: "json-stringify",
                    description: "JSON.stringify"
                },
                {
                    value: "graphql",
                    description: "GraphQL"
                },
                {
                    value: "markdown",
                    description: "Markdown"
                },
                {
                    value: "mdx",
                    description: "MDX"
                },
                {
                    value: "vue",
                    description: "Vue"
                },
                {
                    value: "yaml",
                    description: "YAML"
                },
                {
                    value: "glimmer",
                    description: "Ember / Handlebars"
                },
                {
                    value: "html",
                    description: "HTML"
                },
                {
                    value: "angular",
                    description: "Angular"
                },
                {
                    value: "lwc",
                    description: "Lightning Web Components"
                }
            ]
        },
        plugins: {
            type: "path",
            array: !0,
            default: [
                {
                    value: []
                }
            ],
            category: "Global",
            description: "Add a plugin. Multiple plugins can be passed as separate `--plugin`s.",
            exception: (e)=>typeof e == "string" || typeof e == "object",
            cliName: "plugin",
            cliCategory: "Config"
        },
        printWidth: {
            category: "Global",
            type: "int",
            default: 80,
            description: "The line length where Prettier will try wrap.",
            range: {
                start: 0,
                end: 1 / 0,
                step: 1
            }
        },
        rangeEnd: {
            category: "Special",
            type: "int",
            default: 1 / 0,
            range: {
                start: 0,
                end: 1 / 0,
                step: 1
            },
            description: `Format code ending at a given character offset (exclusive).
The range will extend forwards to the end of the selected statement.`,
            cliCategory: "Editor"
        },
        rangeStart: {
            category: "Special",
            type: "int",
            default: 0,
            range: {
                start: 0,
                end: 1 / 0,
                step: 1
            },
            description: `Format code starting at a given character offset.
The range will extend backwards to the start of the first line containing the selected statement.`,
            cliCategory: "Editor"
        },
        requirePragma: {
            category: "Special",
            type: "boolean",
            default: !1,
            description: `Require either '@prettier' or '@format' to be present in the file's first docblock comment
in order for it to be formatted.`,
            cliCategory: "Other"
        },
        tabWidth: {
            type: "int",
            category: "Global",
            default: 2,
            description: "Number of spaces per indentation level.",
            range: {
                start: 0,
                end: 1 / 0,
                step: 1
            }
        },
        useTabs: {
            category: "Global",
            type: "boolean",
            default: !1,
            description: "Indent with tabs instead of spaces."
        },
        embeddedLanguageFormatting: {
            category: "Global",
            type: "choice",
            default: "auto",
            description: "Control how Prettier formats quoted code embedded in the file.",
            choices: [
                {
                    value: "auto",
                    description: "Format embedded code if Prettier can automatically identify it."
                },
                {
                    value: "off",
                    description: "Never automatically format embedded code."
                }
            ]
        }
    };
    function it({ plugins: e = [], showDeprecated: t = !1 } = {}) {
        let r = e.flatMap((i)=>i.languages ?? []), n = [];
        for (let i of Di(Object.assign({}, ...e.map(({ options: u })=>u), rn)))!t && i.deprecated || (Array.isArray(i.choices) && (t || (i.choices = i.choices.filter((u)=>!u.deprecated)), i.name === "parser" && (i.choices = [
            ...i.choices,
            ...ai(i.choices, r, e)
        ])), i.pluginDefaults = Object.fromEntries(e.filter((u)=>{
            var o;
            return ((o = u.defaultOptions) == null ? void 0 : o[i.name]) !== void 0;
        }).map((u)=>[
                u.name,
                u.defaultOptions[i.name]
            ])), n.push(i));
        return {
            languages: r,
            options: n
        };
    }
    function* ai(e, t, r) {
        let n = new Set(e.map((i)=>i.value));
        for (let i of t)if (i.parsers) {
            for (let u of i.parsers)if (!n.has(u)) {
                n.add(u);
                let o = r.find((a)=>a.parsers && Object.prototype.hasOwnProperty.call(a.parsers, u)), s = i.name;
                o != null && o.name && (s += ` (plugin: ${o.name})`), yield {
                    value: u,
                    description: s
                };
            }
        }
    }
    function Di(e) {
        let t = [];
        for (let [r, n] of Object.entries(e)){
            let i = {
                name: r,
                ...n
            };
            Array.isArray(i.default) && (i.default = y(!1, i.default, -1).value), t.push(i);
        }
        return t;
    }
    var li = (e)=>String(e).split(/[/\\]/u).pop();
    function nn(e, t) {
        if (!t) return;
        let r = li(t).toLowerCase();
        return e.find(({ filenames: n })=>n == null ? void 0 : n.some((i)=>i.toLowerCase() === r)) ?? e.find(({ extensions: n })=>n == null ? void 0 : n.some((i)=>r.endsWith(i)));
    }
    function ci(e, t) {
        if (t) return e.find(({ name: r })=>r.toLowerCase() === t) ?? e.find(({ aliases: r })=>r == null ? void 0 : r.includes(t)) ?? e.find(({ extensions: r })=>r == null ? void 0 : r.includes(`.${t}`));
    }
    function fi(e, t) {
        let r = e.plugins.flatMap((i)=>i.languages ?? []), n = ci(r, t.language) ?? nn(r, t.physicalFile) ?? nn(r, t.file) ?? (t.physicalFile, void 0);
        return n == null ? void 0 : n.parsers[0];
    }
    var un = fi;
    var oe = {
        key: (e)=>/^[$_a-zA-Z][$_a-zA-Z0-9]*$/.test(e) ? e : JSON.stringify(e),
        value (e) {
            if (e === null || typeof e != "object") return JSON.stringify(e);
            if (Array.isArray(e)) return `[${e.map((r)=>oe.value(r)).join(", ")}]`;
            let t = Object.keys(e);
            return t.length === 0 ? "{}" : `{ ${t.map((r)=>`${oe.key(r)}: ${oe.value(e[r])}`).join(", ")} }`;
        },
        pair: ({ key: e, value: t })=>oe.value({
                [e]: t
            })
    };
    var Yt = Me(ot(), 1), an = (e, t, { descriptor: r })=>{
        let n = [
            `${Yt.default.yellow(typeof e == "string" ? r.key(e) : r.pair(e))} is deprecated`
        ];
        return t && n.push(`we now treat it as ${Yt.default.blue(typeof t == "string" ? r.key(t) : r.pair(t))}`), n.join("; ") + ".";
    };
    var le = Me(ot(), 1);
    var st = Symbol.for("vnopts.VALUE_NOT_EXIST"), he = Symbol.for("vnopts.VALUE_UNCHANGED");
    var Dn = " ".repeat(2), cn = (e, t, r)=>{
        let { text: n, list: i } = r.normalizeExpectedResult(r.schemas[e].expected(r)), u = [];
        return n && u.push(ln(e, t, n, r.descriptor)), i && u.push([
            ln(e, t, i.title, r.descriptor)
        ].concat(i.values.map((o)=>fn(o, r.loggerPrintWidth))).join(`
`)), pn(u, r.loggerPrintWidth);
    };
    function ln(e, t, r, n) {
        return [
            `Invalid ${le.default.red(n.key(e))} value.`,
            `Expected ${le.default.blue(r)},`,
            `but received ${t === st ? le.default.gray("nothing") : le.default.red(n.value(t))}.`
        ].join(" ");
    }
    function fn({ text: e, list: t }, r) {
        let n = [];
        return e && n.push(`- ${le.default.blue(e)}`), t && n.push([
            `- ${le.default.blue(t.title)}:`
        ].concat(t.values.map((i)=>fn(i, r - Dn.length).replace(/^|\n/g, `$&${Dn}`))).join(`
`)), pn(n, r);
    }
    function pn(e, t) {
        if (e.length === 1) return e[0];
        let [r, n] = e, [i, u] = e.map((o)=>o.split(`
`, 1)[0].length);
        return i > t && i > u ? n : r;
    }
    var Wt = Me(ot(), 1);
    var jt = [], dn = [];
    function Ht(e, t) {
        if (e === t) return 0;
        let r = e;
        e.length > t.length && (e = t, t = r);
        let n = e.length, i = t.length;
        for(; n > 0 && e.charCodeAt(~-n) === t.charCodeAt(~-i);)n--, i--;
        let u = 0;
        for(; u < n && e.charCodeAt(u) === t.charCodeAt(u);)u++;
        if (n -= u, i -= u, n === 0) return i;
        let o, s, a, D, l = 0, d = 0;
        for(; l < n;)dn[l] = e.charCodeAt(u + l), jt[l] = ++l;
        for(; d < i;)for(o = t.charCodeAt(u + d), a = d++, s = d, l = 0; l < n; l++)D = o === dn[l] ? a : a + 1, a = jt[l], s = jt[l] = a > s ? D > s ? s + 1 : D : D > a ? a + 1 : D;
        return s;
    }
    var at = (e, t, { descriptor: r, logger: n, schemas: i })=>{
        let u = [
            `Ignored unknown option ${Wt.default.yellow(r.pair({
                key: e,
                value: t
            }))}.`
        ], o = Object.keys(i).sort().find((s)=>Ht(e, s) < 3);
        o && u.push(`Did you mean ${Wt.default.blue(r.key(o))}?`), n.warn(u.join(" "));
    };
    var pi = [
        "default",
        "expected",
        "validate",
        "deprecated",
        "forward",
        "redirect",
        "overlap",
        "preprocess",
        "postprocess"
    ];
    function di(e, t) {
        let r = new e(t), n = Object.create(r);
        for (let i of pi)i in t && (n[i] = Fi(t[i], r, O.prototype[i].length));
        return n;
    }
    var O = class {
        static create(t) {
            return di(this, t);
        }
        constructor(t){
            this.name = t.name;
        }
        default(t) {}
        expected(t) {
            return "nothing";
        }
        validate(t, r) {
            return !1;
        }
        deprecated(t, r) {
            return !1;
        }
        forward(t, r) {}
        redirect(t, r) {}
        overlap(t, r, n) {
            return t;
        }
        preprocess(t, r) {
            return t;
        }
        postprocess(t, r) {
            return he;
        }
    };
    function Fi(e, t, r) {
        return typeof e == "function" ? (...n)=>e(...n.slice(0, r - 1), t, ...n.slice(r - 1)) : ()=>e;
    }
    var Dt = class extends O {
        constructor(t){
            super(t), this._sourceName = t.sourceName;
        }
        expected(t) {
            return t.schemas[this._sourceName].expected(t);
        }
        validate(t, r) {
            return r.schemas[this._sourceName].validate(t, r);
        }
        redirect(t, r) {
            return this._sourceName;
        }
    };
    var lt = class extends O {
        expected() {
            return "anything";
        }
        validate() {
            return !0;
        }
    };
    var ct = class extends O {
        constructor({ valueSchema: t, name: r = t.name, ...n }){
            super({
                ...n,
                name: r
            }), this._valueSchema = t;
        }
        expected(t) {
            let { text: r, list: n } = t.normalizeExpectedResult(this._valueSchema.expected(t));
            return {
                text: r && `an array of ${r}`,
                list: n && {
                    title: "an array of the following values",
                    values: [
                        {
                            list: n
                        }
                    ]
                }
            };
        }
        validate(t, r) {
            if (!Array.isArray(t)) return !1;
            let n = [];
            for (let i of t){
                let u = r.normalizeValidateResult(this._valueSchema.validate(i, r), i);
                u !== !0 && n.push(u.value);
            }
            return n.length === 0 ? !0 : {
                value: n
            };
        }
        deprecated(t, r) {
            let n = [];
            for (let i of t){
                let u = r.normalizeDeprecatedResult(this._valueSchema.deprecated(i, r), i);
                u !== !1 && n.push(...u.map(({ value: o })=>({
                        value: [
                            o
                        ]
                    })));
            }
            return n;
        }
        forward(t, r) {
            let n = [];
            for (let i of t){
                let u = r.normalizeForwardResult(this._valueSchema.forward(i, r), i);
                n.push(...u.map(Fn));
            }
            return n;
        }
        redirect(t, r) {
            let n = [], i = [];
            for (let u of t){
                let o = r.normalizeRedirectResult(this._valueSchema.redirect(u, r), u);
                "remain" in o && n.push(o.remain), i.push(...o.redirect.map(Fn));
            }
            return n.length === 0 ? {
                redirect: i
            } : {
                redirect: i,
                remain: n
            };
        }
        overlap(t, r) {
            return t.concat(r);
        }
    };
    function Fn({ from: e, to: t }) {
        return {
            from: [
                e
            ],
            to: t
        };
    }
    var ft = class extends O {
        expected() {
            return "true or false";
        }
        validate(t) {
            return typeof t == "boolean";
        }
    };
    function En(e, t) {
        let r = Object.create(null);
        for (let n of e){
            let i = n[t];
            if (r[i]) throw new Error(`Duplicate ${t} ${JSON.stringify(i)}`);
            r[i] = n;
        }
        return r;
    }
    function hn(e, t) {
        let r = new Map;
        for (let n of e){
            let i = n[t];
            if (r.has(i)) throw new Error(`Duplicate ${t} ${JSON.stringify(i)}`);
            r.set(i, n);
        }
        return r;
    }
    function Cn() {
        let e = Object.create(null);
        return (t)=>{
            let r = JSON.stringify(t);
            return e[r] ? !0 : (e[r] = !0, !1);
        };
    }
    function gn(e, t) {
        let r = [], n = [];
        for (let i of e)t(i) ? r.push(i) : n.push(i);
        return [
            r,
            n
        ];
    }
    function yn(e) {
        return e === Math.floor(e);
    }
    function An(e, t) {
        if (e === t) return 0;
        let r = typeof e, n = typeof t, i = [
            "undefined",
            "object",
            "boolean",
            "number",
            "string"
        ];
        return r !== n ? i.indexOf(r) - i.indexOf(n) : r !== "string" ? Number(e) - Number(t) : e.localeCompare(t);
    }
    function Bn(e) {
        return (...t)=>{
            let r = e(...t);
            return typeof r == "string" ? new Error(r) : r;
        };
    }
    function Mt(e) {
        return e === void 0 ? {} : e;
    }
    function $t(e) {
        if (typeof e == "string") return {
            text: e
        };
        let { text: t, list: r } = e;
        return mi((t || r) !== void 0, "Unexpected `expected` result, there should be at least one field."), r ? {
            text: t,
            list: {
                title: r.title,
                values: r.values.map($t)
            }
        } : {
            text: t
        };
    }
    function Vt(e, t) {
        return e === !0 ? !0 : e === !1 ? {
            value: t
        } : e;
    }
    function Ut(e, t, r = !1) {
        return e === !1 ? !1 : e === !0 ? r ? !0 : [
            {
                value: t
            }
        ] : "value" in e ? [
            e
        ] : e.length === 0 ? !1 : e;
    }
    function mn(e, t) {
        return typeof e == "string" || "key" in e ? {
            from: t,
            to: e
        } : "from" in e ? {
            from: e.from,
            to: e.to
        } : {
            from: t,
            to: e.to
        };
    }
    function pt(e, t) {
        return e === void 0 ? [] : Array.isArray(e) ? e.map((r)=>mn(r, t)) : [
            mn(e, t)
        ];
    }
    function zt(e, t) {
        let r = pt(typeof e == "object" && "redirect" in e ? e.redirect : e, t);
        return r.length === 0 ? {
            remain: t,
            redirect: r
        } : typeof e == "object" && "remain" in e ? {
            remain: e.remain,
            redirect: r
        } : {
            redirect: r
        };
    }
    function mi(e, t) {
        if (!e) throw new Error(t);
    }
    var dt = class extends O {
        constructor(t){
            super(t), this._choices = hn(t.choices.map((r)=>r && typeof r == "object" ? r : {
                    value: r
                }), "value");
        }
        expected({ descriptor: t }) {
            let r = Array.from(this._choices.keys()).map((o)=>this._choices.get(o)).filter(({ hidden: o })=>!o).map((o)=>o.value).sort(An).map(t.value), n = r.slice(0, -2), i = r.slice(-2);
            return {
                text: n.concat(i.join(" or ")).join(", "),
                list: {
                    title: "one of the following values",
                    values: r
                }
            };
        }
        validate(t) {
            return this._choices.has(t);
        }
        deprecated(t) {
            let r = this._choices.get(t);
            return r && r.deprecated ? {
                value: t
            } : !1;
        }
        forward(t) {
            let r = this._choices.get(t);
            return r ? r.forward : void 0;
        }
        redirect(t) {
            let r = this._choices.get(t);
            return r ? r.redirect : void 0;
        }
    };
    var Ft = class extends O {
        expected() {
            return "a number";
        }
        validate(t, r) {
            return typeof t == "number";
        }
    };
    var mt = class extends Ft {
        expected() {
            return "an integer";
        }
        validate(t, r) {
            return r.normalizeValidateResult(super.validate(t, r), t) === !0 && yn(t);
        }
    };
    var Re = class extends O {
        expected() {
            return "a string";
        }
        validate(t) {
            return typeof t == "string";
        }
    };
    var wn = oe, _n = at, xn = cn, vn = an;
    var Et = class {
        constructor(t, r){
            let { logger: n = console, loggerPrintWidth: i = 80, descriptor: u = wn, unknown: o = _n, invalid: s = xn, deprecated: a = vn, missing: D = ()=>!1, required: l = ()=>!1, preprocess: d = (p)=>p, postprocess: f = ()=>he } = r || {};
            this._utils = {
                descriptor: u,
                logger: n || {
                    warn: ()=>{}
                },
                loggerPrintWidth: i,
                schemas: En(t, "name"),
                normalizeDefaultResult: Mt,
                normalizeExpectedResult: $t,
                normalizeDeprecatedResult: Ut,
                normalizeForwardResult: pt,
                normalizeRedirectResult: zt,
                normalizeValidateResult: Vt
            }, this._unknownHandler = o, this._invalidHandler = Bn(s), this._deprecatedHandler = a, this._identifyMissing = (p, c)=>!(p in c) || D(p, c), this._identifyRequired = l, this._preprocess = d, this._postprocess = f, this.cleanHistory();
        }
        cleanHistory() {
            this._hasDeprecationWarned = Cn();
        }
        normalize(t) {
            let r = {}, i = [
                this._preprocess(t, this._utils)
            ], u = ()=>{
                for(; i.length !== 0;){
                    let o = i.shift(), s = this._applyNormalization(o, r);
                    i.push(...s);
                }
            };
            u();
            for (let o of Object.keys(this._utils.schemas)){
                let s = this._utils.schemas[o];
                if (!(o in r)) {
                    let a = Mt(s.default(this._utils));
                    "value" in a && i.push({
                        [o]: a.value
                    });
                }
            }
            u();
            for (let o of Object.keys(this._utils.schemas)){
                if (!(o in r)) continue;
                let s = this._utils.schemas[o], a = r[o], D = s.postprocess(a, this._utils);
                D !== he && (this._applyValidation(D, o, s), r[o] = D);
            }
            return this._applyPostprocess(r), this._applyRequiredCheck(r), r;
        }
        _applyNormalization(t, r) {
            let n = [], { knownKeys: i, unknownKeys: u } = this._partitionOptionKeys(t);
            for (let o of i){
                let s = this._utils.schemas[o], a = s.preprocess(t[o], this._utils);
                this._applyValidation(a, o, s);
                let D = ({ from: p, to: c })=>{
                    n.push(typeof c == "string" ? {
                        [c]: p
                    } : {
                        [c.key]: c.value
                    });
                }, l = ({ value: p, redirectTo: c })=>{
                    let F = Ut(s.deprecated(p, this._utils), a, !0);
                    if (F !== !1) {
                        if (F === !0) this._hasDeprecationWarned(o) || this._utils.logger.warn(this._deprecatedHandler(o, c, this._utils));
                        else for (let { value: m } of F){
                            let E = {
                                key: o,
                                value: m
                            };
                            if (!this._hasDeprecationWarned(E)) {
                                let A = typeof c == "string" ? {
                                    key: c,
                                    value: m
                                } : c;
                                this._utils.logger.warn(this._deprecatedHandler(E, A, this._utils));
                            }
                        }
                    }
                };
                pt(s.forward(a, this._utils), a).forEach(D);
                let f = zt(s.redirect(a, this._utils), a);
                if (f.redirect.forEach(D), "remain" in f) {
                    let p = f.remain;
                    r[o] = o in r ? s.overlap(r[o], p, this._utils) : p, l({
                        value: p
                    });
                }
                for (let { from: p, to: c } of f.redirect)l({
                    value: p,
                    redirectTo: c
                });
            }
            for (let o of u){
                let s = t[o];
                this._applyUnknownHandler(o, s, r, (a, D)=>{
                    n.push({
                        [a]: D
                    });
                });
            }
            return n;
        }
        _applyRequiredCheck(t) {
            for (let r of Object.keys(this._utils.schemas))if (this._identifyMissing(r, t) && this._identifyRequired(r)) throw this._invalidHandler(r, st, this._utils);
        }
        _partitionOptionKeys(t) {
            let [r, n] = gn(Object.keys(t).filter((i)=>!this._identifyMissing(i, t)), (i)=>i in this._utils.schemas);
            return {
                knownKeys: r,
                unknownKeys: n
            };
        }
        _applyValidation(t, r, n) {
            let i = Vt(n.validate(t, this._utils), t);
            if (i !== !0) throw this._invalidHandler(r, i.value, this._utils);
        }
        _applyUnknownHandler(t, r, n, i) {
            let u = this._unknownHandler(t, r, this._utils);
            if (u) for (let o of Object.keys(u)){
                if (this._identifyMissing(o, u)) continue;
                let s = u[o];
                o in this._utils.schemas ? i(o, s) : n[o] = s;
            }
        }
        _applyPostprocess(t) {
            let r = this._postprocess(t, this._utils);
            if (r !== he) {
                if (r.delete) for (let n of r.delete)delete t[n];
                if (r.override) {
                    let { knownKeys: n, unknownKeys: i } = this._partitionOptionKeys(r.override);
                    for (let u of n){
                        let o = r.override[u];
                        this._applyValidation(o, u, this._utils.schemas[u]), t[u] = o;
                    }
                    for (let u of i){
                        let o = r.override[u];
                        this._applyUnknownHandler(u, o, t, (s, a)=>{
                            let D = this._utils.schemas[s];
                            this._applyValidation(a, s, D), t[s] = a;
                        });
                    }
                }
            }
        }
    };
    var Gt;
    function hi(e, t, { logger: r = !1, isCLI: n = !1, passThrough: i = !1, FlagSchema: u, descriptor: o } = {}) {
        if (n) {
            if (!u) throw new Error("'FlagSchema' option is required.");
            if (!o) throw new Error("'descriptor' option is required.");
        } else o = oe;
        let s = i ? Array.isArray(i) ? (f, p)=>i.includes(f) ? {
                [f]: p
            } : void 0 : (f, p)=>({
                [f]: p
            }) : (f, p, c)=>{
            let { _: F, ...m } = c.schemas;
            return at(f, p, {
                ...c,
                schemas: m
            });
        }, a = Ci(t, {
            isCLI: n,
            FlagSchema: u
        }), D = new Et(a, {
            logger: r,
            unknown: s,
            descriptor: o
        }), l = r !== !1;
        l && Gt && (D._hasDeprecationWarned = Gt);
        let d = D.normalize(e);
        return l && (Gt = D._hasDeprecationWarned), d;
    }
    function Ci(e, { isCLI: t, FlagSchema: r }) {
        let n = [];
        t && n.push(lt.create({
            name: "_"
        }));
        for (let i of e)n.push(gi(i, {
            isCLI: t,
            optionInfos: e,
            FlagSchema: r
        })), i.alias && t && n.push(Dt.create({
            name: i.alias,
            sourceName: i.name
        }));
        return n;
    }
    function gi(e, { isCLI: t, optionInfos: r, FlagSchema: n }) {
        let { name: i } = e, u = {
            name: i
        }, o, s = {};
        switch(e.type){
            case "int":
                o = mt, t && (u.preprocess = Number);
                break;
            case "string":
                o = Re;
                break;
            case "choice":
                o = dt, u.choices = e.choices.map((a)=>a != null && a.redirect ? {
                        ...a,
                        redirect: {
                            to: {
                                key: e.name,
                                value: a.redirect
                            }
                        }
                    } : a);
                break;
            case "boolean":
                o = ft;
                break;
            case "flag":
                o = n, u.flags = r.flatMap((a)=>[
                        a.alias,
                        a.description && a.name,
                        a.oppositeDescription && `no-${a.name}`
                    ].filter(Boolean));
                break;
            case "path":
                o = Re;
                break;
            default:
                throw new Error(`Unexpected type ${e.type}`);
        }
        if (e.exception ? u.validate = (a, D, l)=>e.exception(a) || D.validate(a, l) : u.validate = (a, D, l)=>a === void 0 || D.validate(a, l), e.redirect && (s.redirect = (a)=>a ? {
                to: typeof e.redirect == "string" ? e.redirect : {
                    key: e.redirect.option,
                    value: e.redirect.value
                }
            } : void 0), e.deprecated && (s.deprecated = !0), t && !e.array) {
            let a = u.preprocess || ((D)=>D);
            u.preprocess = (D, l, d)=>l.preprocess(a(Array.isArray(D) ? y(!1, D, -1) : D), d);
        }
        return e.array ? ct.create({
            ...t ? {
                preprocess: (a)=>Array.isArray(a) ? a : [
                        a
                    ]
            } : {},
            ...s,
            valueSchema: o.create(u)
        }) : o.create({
            ...u,
            ...s
        });
    }
    var bn = hi;
    var yi = (e, t, r)=>{
        if (!(e && t == null)) {
            if (t.findLast) return t.findLast(r);
            for(let n = t.length - 1; n >= 0; n--){
                let i = t[n];
                if (r(i, n, t)) return i;
            }
        }
    }, Kt = yi;
    function qt(e, t) {
        if (!t) throw new Error("parserName is required.");
        let r = Kt(!1, e, (i)=>i.parsers && Object.prototype.hasOwnProperty.call(i.parsers, t));
        if (r) return r;
        let n = `Couldn't resolve parser "${t}".`;
        throw n += " Plugins must be explicitly added to the standalone bundle.", new Pe(n);
    }
    function On(e, t) {
        if (!t) throw new Error("astFormat is required.");
        let r = Kt(!1, e, (i)=>i.printers && Object.prototype.hasOwnProperty.call(i.printers, t));
        if (r) return r;
        let n = `Couldn't find plugin for AST format "${t}".`;
        throw n += " Plugins must be explicitly added to the standalone bundle.", new Pe(n);
    }
    function ht({ plugins: e, parser: t }) {
        let r = qt(e, t);
        return Jt(r, t);
    }
    function Jt(e, t) {
        let r = e.parsers[t];
        return typeof r == "function" ? r() : r;
    }
    function Sn(e, t) {
        let r = e.printers[t];
        return typeof r == "function" ? r() : r;
    }
    var Nn = {
        astFormat: "estree",
        printer: {},
        originalText: void 0,
        locStart: null,
        locEnd: null
    };
    async function Ai(e, t = {}) {
        var d;
        let r = {
            ...e
        };
        if (!r.parser) {
            if (r.filepath) {
                if (r.parser = un(r, {
                    physicalFile: r.filepath
                }), !r.parser) throw new Ie(`No parser could be inferred for file "${r.filepath}".`);
            } else throw new Ie("No parser and no file path given, couldn't infer a parser.");
        }
        let n = it({
            plugins: e.plugins,
            showDeprecated: !0
        }).options, i = {
            ...Nn,
            ...Object.fromEntries(n.filter((f)=>f.default !== void 0).map((f)=>[
                    f.name,
                    f.default
                ]))
        }, u = qt(r.plugins, r.parser), o = await Jt(u, r.parser);
        r.astFormat = o.astFormat, r.locEnd = o.locEnd, r.locStart = o.locStart;
        let s = (d = u.printers) != null && d[o.astFormat] ? u : On(r.plugins, o.astFormat), a = await Sn(s, o.astFormat);
        r.printer = a;
        let D = s.defaultOptions ? Object.fromEntries(Object.entries(s.defaultOptions).filter(([, f])=>f !== void 0)) : {}, l = {
            ...i,
            ...D
        };
        for (let [f, p] of Object.entries(l))(r[f] === null || r[f] === void 0) && (r[f] = p);
        return r.parser === "json" && (r.trailingComma = "none"), bn(r, n, {
            passThrough: Object.keys(Nn),
            ...t
        });
    }
    var se = Ai;
    var Vn = Me($n(), 1);
    async function Ni(e, t) {
        let r = await ht(t), n = r.preprocess ? r.preprocess(e, t) : e;
        t.originalText = n;
        let i;
        try {
            i = await r.parse(n, t, t);
        } catch (u) {
            Ti(u, e);
        }
        return {
            text: n,
            ast: i
        };
    }
    function Ti(e, t) {
        let { loc: r } = e;
        if (r) {
            let n = (0, Vn.codeFrameColumns)(t, r, {
                highlightCode: !0
            });
            throw e.message += `
` + n, e.codeFrame = n, e;
        }
        throw e;
    }
    var ce = Ni;
    async function Un(e, t, r, n, i) {
        let { embeddedLanguageFormatting: u, printer: { embed: o, hasPrettierIgnore: s = ()=>!1, getVisitorKeys: a } } = r;
        if (!o || u !== "auto") return;
        if (o.length > 2) throw new Error("printer.embed has too many parameters. The API changed in Prettier v3. Please update your plugin. See https://prettier.io/docs/en/plugins.html#optional-embed");
        let D = X(o.getVisitorKeys ?? a), l = [];
        p();
        let d = e.stack;
        for (let { print: c, node: F, pathStack: m } of l)try {
            e.stack = m;
            let E = await c(f, t, e, r);
            E && i.set(F, E);
        } catch (E) {
            if (globalThis.PRETTIER_DEBUG) throw E;
        }
        e.stack = d;
        function f(c, F) {
            return ki(c, F, r, n);
        }
        function p() {
            let { node: c } = e;
            if (c === null || typeof c != "object" || s(e)) return;
            for (let m of D(c))Array.isArray(c[m]) ? e.each(p, m) : e.call(p, m);
            let F = o(e, r);
            if (F) {
                if (typeof F == "function") {
                    l.push({
                        print: F,
                        node: c,
                        pathStack: [
                            ...e.stack
                        ]
                    });
                    return;
                }
                i.set(c, F);
            }
        }
    }
    async function ki(e, t, r, n) {
        let i = await se({
            ...r,
            ...t,
            parentParser: r.parser,
            originalText: e
        }, {
            passThrough: !0
        }), { ast: u } = await ce(e, i), o = await n(u, i);
        return Ze(o);
    }
    function Li(e, t) {
        let { originalText: r, [Symbol.for("comments")]: n, locStart: i, locEnd: u, [Symbol.for("printedComments")]: o } = t, { node: s } = e, a = i(s), D = u(s);
        for (let l of n)i(l) >= a && u(l) <= D && o.add(l);
        return r.slice(a, D);
    }
    var zn = Li;
    async function Ye(e, t) {
        ({ ast: e } = await Qt(e, t));
        let r = new Map, n = new Mr(e), i = tn(t), u = new Map;
        await Un(n, s, t, Ye, u);
        let o = await Gn(n, t, s, void 0, u);
        return en(t), o;
        function s(D, l) {
            return D === void 0 || D === n ? a(l) : Array.isArray(D) ? n.call(()=>a(l), ...D) : n.call(()=>a(l), D);
        }
        function a(D) {
            i(n);
            let l = n.node;
            if (l == null) return "";
            let d = l && typeof l == "object" && D === void 0;
            if (d && r.has(l)) return r.get(l);
            let f = Gn(n, t, s, D, u);
            return d && r.set(l, f), f;
        }
    }
    function Gn(e, t, r, n, i) {
        var a;
        let { node: u } = e, { printer: o } = t, s;
        return (a = o.hasPrettierIgnore) != null && a.call(o, e) ? s = zn(e, t) : i.has(u) ? s = i.get(u) : s = o.print(e, t, r, n), u === t.cursorNode && (s = Qe(s, (D)=>[
                ve,
                D,
                ve
            ])), o.printComment && (!o.willPrintOwnComments || !o.willPrintOwnComments(e, t)) && (s = Qr(e, s, t)), s;
    }
    async function Qt(e, t) {
        let r = e.comments ?? [];
        t[Symbol.for("comments")] = r, t[Symbol.for("tokens")] = e.tokens ?? [], t[Symbol.for("printedComments")] = new Set, Jr(e, t);
        let { printer: { preprocess: n } } = t;
        return e = n ? await n(e, t) : e, {
            ast: e,
            comments: r
        };
    }
    function Pi(e, t) {
        let { cursorOffset: r, locStart: n, locEnd: i } = t, u = X(t.printer.getVisitorKeys), o = (a)=>n(a) <= r && i(a) >= r, s = e;
        for (let a of Ur(e, {
            getVisitorKeys: u,
            filter: o
        }))s = a;
        return s;
    }
    var Kn = Pi;
    function Ii(e, t) {
        let { printer: { massageAstNode: r, getVisitorKeys: n } } = t;
        if (!r) return e;
        let i = X(n), u = r.ignoredProperties ?? new Set;
        return o(e);
        function o(s, a) {
            if (!(s !== null && typeof s == "object")) return s;
            if (Array.isArray(s)) return s.map((f)=>o(f, a)).filter(Boolean);
            let D = {}, l = new Set(i(s));
            for(let f in s)!Object.prototype.hasOwnProperty.call(s, f) || u.has(f) || (l.has(f) ? D[f] = o(s[f], s) : D[f] = s[f]);
            let d = r(s, D, a);
            if (d !== null) return d ?? D;
        }
    }
    var qn = Ii;
    var Ri = (e, t, r)=>{
        if (!(e && t == null)) {
            if (t.findLastIndex) return t.findLastIndex(r);
            for(let n = t.length - 1; n >= 0; n--){
                let i = t[n];
                if (r(i, n, t)) return n;
            }
            return -1;
        }
    }, Jn = Ri;
    var Yi = ({ parser: e })=>e === "json" || e === "json5" || e === "jsonc" || e === "json-stringify";
    function ji(e, t) {
        let r = [
            e.node,
            ...e.parentNodes
        ], n = new Set([
            t.node,
            ...t.parentNodes
        ]);
        return r.find((i)=>Qn.has(i.type) && n.has(i));
    }
    function Xn(e) {
        let t = Jn(!1, e, (r)=>r.type !== "Program" && r.type !== "File");
        return t === -1 ? e : e.slice(0, t + 1);
    }
    function Hi(e, t, { locStart: r, locEnd: n }) {
        let i = e.node, u = t.node;
        if (i === u) return {
            startNode: i,
            endNode: u
        };
        let o = r(e.node);
        for (let a of Xn(t.parentNodes))if (r(a) >= o) u = a;
        else break;
        let s = n(t.node);
        for (let a of Xn(e.parentNodes)){
            if (n(a) <= s) i = a;
            else break;
            if (i === u) break;
        }
        return {
            startNode: i,
            endNode: u
        };
    }
    function er(e, t, r, n, i = [], u) {
        let { locStart: o, locEnd: s } = r, a = o(e), D = s(e);
        if (!(t > D || t < a || u === "rangeEnd" && t === a || u === "rangeStart" && t === D)) {
            for (let l of ut(e, r)){
                let d = er(l, t, r, n, [
                    e,
                    ...i
                ], u);
                if (d) return d;
            }
            if (!n || n(e, i[0])) return {
                node: e,
                parentNodes: i
            };
        }
    }
    function Wi(e, t) {
        return t !== "DeclareExportDeclaration" && e !== "TypeParameterDeclaration" && (e === "Directive" || e === "TypeAlias" || e === "TSExportAssignment" || e.startsWith("Declare") || e.startsWith("TSDeclare") || e.endsWith("Statement") || e.endsWith("Declaration"));
    }
    var Qn = new Set([
        "JsonRoot",
        "ObjectExpression",
        "ArrayExpression",
        "StringLiteral",
        "NumericLiteral",
        "BooleanLiteral",
        "NullLiteral",
        "UnaryExpression",
        "TemplateLiteral"
    ]), Mi = new Set([
        "OperationDefinition",
        "FragmentDefinition",
        "VariableDefinition",
        "TypeExtensionDefinition",
        "ObjectTypeDefinition",
        "FieldDefinition",
        "DirectiveDefinition",
        "EnumTypeDefinition",
        "EnumValueDefinition",
        "InputValueDefinition",
        "InputObjectTypeDefinition",
        "SchemaDefinition",
        "OperationTypeDefinition",
        "InterfaceTypeDefinition",
        "UnionTypeDefinition",
        "ScalarTypeDefinition"
    ]);
    function Zn(e, t, r) {
        if (!t) return !1;
        switch(e.parser){
            case "flow":
            case "babel":
            case "babel-flow":
            case "babel-ts":
            case "typescript":
            case "acorn":
            case "espree":
            case "meriyah":
            case "__babel_estree":
                return Wi(t.type, r == null ? void 0 : r.type);
            case "json":
            case "json5":
            case "jsonc":
            case "json-stringify":
                return Qn.has(t.type);
            case "graphql":
                return Mi.has(t.kind);
            case "vue":
                return t.tag !== "root";
        }
        return !1;
    }
    function eu(e, t, r) {
        let { rangeStart: n, rangeEnd: i, locStart: u, locEnd: o } = t;
        ke.ok(i > n);
        let s = e.slice(n, i).search(/\S/u), a = s === -1;
        if (!a) for(n += s; i > n && !/\S/u.test(e[i - 1]); --i);
        let D = er(r, n, t, (p, c)=>Zn(t, p, c), [], "rangeStart"), l = a ? D : er(r, i, t, (p)=>Zn(t, p), [], "rangeEnd");
        if (!D || !l) return {
            rangeStart: 0,
            rangeEnd: 0
        };
        let d, f;
        if (Yi(t)) {
            let p = ji(D, l);
            d = p, f = p;
        } else ({ startNode: d, endNode: f } = Hi(D, l, t));
        return {
            rangeStart: Math.min(u(d), u(f)),
            rangeEnd: Math.max(o(d), o(f))
        };
    }
    var uu = "\uFEFF", tu = Symbol("cursor");
    async function iu(e, t, r = 0) {
        if (!e || e.trim().length === 0) return {
            formatted: "",
            cursorOffset: -1,
            comments: []
        };
        let { ast: n, text: i } = await ce(e, t);
        t.cursorOffset >= 0 && (t.cursorNode = Kn(n, t));
        let u = await Ye(n, t, r);
        r > 0 && (u = Je([
            q,
            u
        ], r, t.tabWidth));
        let o = Fe(u, t);
        if (r > 0) {
            let a = o.formatted.trim();
            o.cursorNodeStart !== void 0 && (o.cursorNodeStart -= o.formatted.indexOf(a)), o.formatted = a + Be(t.endOfLine);
        }
        let s = t[Symbol.for("comments")];
        if (t.cursorOffset >= 0) {
            let a, D, l, d, f;
            if (t.cursorNode && o.cursorNodeText ? (a = t.locStart(t.cursorNode), D = i.slice(a, t.locEnd(t.cursorNode)), l = t.cursorOffset - a, d = o.cursorNodeStart, f = o.cursorNodeText) : (a = 0, D = i, l = t.cursorOffset, d = 0, f = o.formatted), D === f) return {
                formatted: o.formatted,
                cursorOffset: d + l,
                comments: s
            };
            let p = D.split("");
            p.splice(l, 0, tu);
            let c = f.split(""), F = dr(p, c), m = d;
            for (let E of F)if (E.removed) {
                if (E.value.includes(tu)) break;
            } else m += E.count;
            return {
                formatted: o.formatted,
                cursorOffset: m,
                comments: s
            };
        }
        return {
            formatted: o.formatted,
            cursorOffset: -1,
            comments: s
        };
    }
    async function $i(e, t) {
        let { ast: r, text: n } = await ce(e, t), { rangeStart: i, rangeEnd: u } = eu(n, t, r), o = n.slice(i, u), s = Math.min(i, n.lastIndexOf(`
`, i) + 1), a = n.slice(s, i).match(/^\s*/u)[0], D = me(a, t.tabWidth), l = await iu(o, {
            ...t,
            rangeStart: 0,
            rangeEnd: Number.POSITIVE_INFINITY,
            cursorOffset: t.cursorOffset > i && t.cursorOffset <= u ? t.cursorOffset - i : -1,
            endOfLine: "lf"
        }, D), d = l.formatted.trimEnd(), { cursorOffset: f } = t;
        f > u ? f += d.length - o.length : l.cursorOffset >= 0 && (f = l.cursorOffset + i);
        let p = n.slice(0, i) + d + n.slice(u);
        if (t.endOfLine !== "lf") {
            let c = Be(t.endOfLine);
            f >= 0 && c === `\r
` && (f += wt(p.slice(0, f), `
`)), p = ne(!1, p, `
`, c);
        }
        return {
            formatted: p,
            cursorOffset: f,
            comments: l.comments
        };
    }
    function tr(e, t, r) {
        return typeof t != "number" || Number.isNaN(t) || t < 0 || t > e.length ? r : t;
    }
    function ru(e, t) {
        let { cursorOffset: r, rangeStart: n, rangeEnd: i } = t;
        return r = tr(e, r, -1), n = tr(e, n, 0), i = tr(e, i, e.length), {
            ...t,
            cursorOffset: r,
            rangeStart: n,
            rangeEnd: i
        };
    }
    function ou(e, t) {
        let { cursorOffset: r, rangeStart: n, rangeEnd: i, endOfLine: u } = ru(e, t), o = e.charAt(0) === uu;
        if (o && (e = e.slice(1), r--, n--, i--), u === "auto" && (u = Fr(e)), e.includes("\r")) {
            let s = (a)=>wt(e.slice(0, Math.max(a, 0)), `\r
`);
            r -= s(r), n -= s(n), i -= s(i), e = mr(e);
        }
        return {
            hasBOM: o,
            text: e,
            options: ru(e, {
                ...t,
                cursorOffset: r,
                rangeStart: n,
                rangeEnd: i,
                endOfLine: u
            })
        };
    }
    async function nu(e, t) {
        let r = await ht(t);
        return !r.hasPragma || r.hasPragma(e);
    }
    async function rr(e, t) {
        let { hasBOM: r, text: n, options: i } = ou(e, await se(t));
        if (i.rangeStart >= i.rangeEnd && n !== "" || i.requirePragma && !await nu(n, i)) return {
            formatted: e,
            cursorOffset: t.cursorOffset,
            comments: []
        };
        let u;
        return i.rangeStart > 0 || i.rangeEnd < n.length ? u = await $i(n, i) : (!i.requirePragma && i.insertPragma && i.printer.insertPragma && !await nu(n, i) && (n = i.printer.insertPragma(n)), u = await iu(n, i)), r && (u.formatted = uu + u.formatted, u.cursorOffset >= 0 && u.cursorOffset++), u;
    }
    async function su(e, t, r) {
        let { text: n, options: i } = ou(e, await se(t)), u = await ce(n, i);
        return r && (r.preprocessForPrint && (u.ast = await Qt(u.ast, i)), r.massage && (u.ast = qn(u.ast, i))), u;
    }
    async function au(e, t) {
        t = await se(t);
        let r = await Ye(e, t);
        return Fe(r, t);
    }
    async function Du(e, t) {
        let r = Or(e), { formatted: n } = await rr(r, {
            ...t,
            parser: "__js_expression"
        });
        return n;
    }
    async function lu(e, t) {
        t = await se(t);
        let { ast: r } = await ce(e, t);
        return Ye(r, t);
    }
    async function cu(e, t) {
        return Fe(e, await se(t));
    }
    var nr = {};
    We(nr, {
        builders: ()=>Ui,
        printer: ()=>zi,
        utils: ()=>Gi
    });
    var Ui = {
        join: be,
        line: Ke,
        softline: vr,
        hardline: q,
        literalline: qe,
        group: xt,
        conditionalGroup: Ar,
        fill: Ge,
        lineSuffix: _e,
        lineSuffixBoundary: _r,
        cursor: ve,
        breakParent: de,
        ifBreak: Br,
        trim: xr,
        indent: De,
        indentIfBreak: wr,
        align: ae,
        addAlignmentToDoc: Je,
        markAsRoot: gr,
        dedentToRoot: Cr,
        dedent: yr,
        hardlineWithoutBreakParent: xe,
        literallineWithoutBreakParent: vt,
        label: br,
        concat: (e)=>e
    }, zi = {
        printDocToString: Fe
    }, Gi = {
        willBreak: Ir,
        traverseDoc: we,
        findInDoc: Xe,
        mapDoc: Ne,
        removeLines: Yr,
        stripTrailingHardline: Ze,
        replaceEndOfLine: jr,
        canBreak: Hr
    };
    var fu = "3.3.3";
    var ir = {};
    We(ir, {
        addDanglingComment: ()=>re,
        addLeadingComment: ()=>ue,
        addTrailingComment: ()=>ie,
        getAlignmentSize: ()=>me,
        getIndentSize: ()=>pu,
        getMaxContinuousCount: ()=>du,
        getNextNonSpaceNonCommentCharacter: ()=>Fu,
        getNextNonSpaceNonCommentCharacterIndex: ()=>io,
        getStringWidth: ()=>Oe,
        hasNewline: ()=>V,
        hasNewlineInRange: ()=>mu,
        hasSpaces: ()=>Eu,
        isNextLineEmpty: ()=>Do,
        isNextLineEmptyAfterIndex: ()=>gt,
        isPreviousLineEmpty: ()=>so,
        makeString: ()=>hu,
        skip: ()=>Ee,
        skipEverythingButNewLine: ()=>nt,
        skipInlineComment: ()=>Ce,
        skipNewline: ()=>M,
        skipSpaces: ()=>T,
        skipToLineEnd: ()=>rt,
        skipTrailingComment: ()=>ge,
        skipWhitespace: ()=>zr
    });
    function Ki(e, t) {
        if (t === !1) return !1;
        if (e.charAt(t) === "/" && e.charAt(t + 1) === "*") {
            for(let r = t + 2; r < e.length; ++r)if (e.charAt(r) === "*" && e.charAt(r + 1) === "/") return r + 2;
        }
        return t;
    }
    var Ce = Ki;
    function qi(e, t) {
        return t === !1 ? !1 : e.charAt(t) === "/" && e.charAt(t + 1) === "/" ? nt(e, t) : t;
    }
    var ge = qi;
    function Ji(e, t) {
        let r = null, n = t;
        for(; n !== r;)r = n, n = T(e, n), n = Ce(e, n), n = ge(e, n), n = M(e, n);
        return n;
    }
    var je = Ji;
    function Xi(e, t) {
        let r = null, n = t;
        for(; n !== r;)r = n, n = rt(e, n), n = Ce(e, n), n = T(e, n);
        return n = ge(e, n), n = M(e, n), n !== !1 && V(e, n);
    }
    var gt = Xi;
    function Zi(e, t) {
        let r = e.lastIndexOf(`
`);
        return r === -1 ? 0 : me(e.slice(r + 1).match(/^[\t ]*/u)[0], t);
    }
    var pu = Zi;
    function ur(e) {
        if (typeof e != "string") throw new TypeError("Expected a string");
        return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
    }
    function Qi(e, t) {
        let r = e.match(new RegExp(`(${ur(t)})+`, "gu"));
        return r === null ? 0 : r.reduce((n, i)=>Math.max(n, i.length / t.length), 0);
    }
    var du = Qi;
    function eo(e, t) {
        let r = je(e, t);
        return r === !1 ? "" : e.charAt(r);
    }
    var Fu = eo;
    function to(e, t, r) {
        for(let n = t; n < r; ++n)if (e.charAt(n) === `
`) return !0;
        return !1;
    }
    var mu = to;
    function ro(e, t, r = {}) {
        return T(e, r.backwards ? t - 1 : t, r) !== t;
    }
    var Eu = ro;
    function no(e, t, r) {
        let n = t === '"' ? "'" : '"', u = ne(!1, e, /\\(.)|(["'])/gsu, (o, s, a)=>s === n ? s : a === t ? "\\" + a : a || (r && /^[^\n\r"'0-7\\bfnrt-vx\u2028\u2029]$/u.test(s) ? s : "\\" + s));
        return t + u + t;
    }
    var hu = no;
    function uo(e, t, r) {
        return je(e, r(t));
    }
    function io(e, t) {
        return arguments.length === 2 || typeof t == "number" ? je(e, t) : uo(...arguments);
    }
    function oo(e, t, r) {
        return Le(e, r(t));
    }
    function so(e, t) {
        return arguments.length === 2 || typeof t == "number" ? Le(e, t) : oo(...arguments);
    }
    function ao(e, t, r) {
        return gt(e, r(t));
    }
    function Do(e, t) {
        return arguments.length === 2 || typeof t == "number" ? gt(e, t) : ao(...arguments);
    }
    function fe(e, t = 1) {
        return async (...r)=>{
            let n = r[t] ?? {}, i = n.plugins ?? [];
            return r[t] = {
                ...n,
                plugins: Array.isArray(i) ? i : Object.values(i)
            }, e(...r);
        };
    }
    var Cu = fe(rr);
    async function gu(e, t) {
        let { formatted: r } = await Cu(e, {
            ...t,
            cursorOffset: -1
        });
        return r;
    }
    async function lo(e, t) {
        return await gu(e, t) === e;
    }
    var co = fe(it, 0), fo = {
        parse: fe(su),
        formatAST: fe(au),
        formatDoc: fe(Du),
        printToDoc: fe(lu),
        printDocToString: fe(cu)
    };
    return ar(po);
});



var $gBhAd = parcelRequire("gBhAd");
var $d928dc4e973e7a51$export$2e2bcd8739ae039 = [
    {
        name: "Ant Build System",
        tmScope: "text.xml.ant",
        filenames: [
            "ant.xml",
            "build.xml"
        ],
        codemirrorMode: "xml",
        codemirrorMimeType: "application/xml",
        since: "0.1.0",
        parsers: [
            "xml"
        ],
        linguistLanguageId: 15,
        vscodeLanguageIds: [
            "xml"
        ]
    },
    {
        name: "COLLADA",
        extensions: [
            ".dae"
        ],
        tmScope: "text.xml",
        codemirrorMode: "xml",
        codemirrorMimeType: "text/xml",
        since: "0.1.0",
        parsers: [
            "xml"
        ],
        linguistLanguageId: 49,
        vscodeLanguageIds: [
            "xml"
        ]
    },
    {
        name: "Eagle",
        extensions: [
            ".sch",
            ".brd"
        ],
        tmScope: "text.xml",
        codemirrorMode: "xml",
        codemirrorMimeType: "text/xml",
        since: "0.1.0",
        parsers: [
            "xml"
        ],
        linguistLanguageId: 97,
        vscodeLanguageIds: [
            "xml"
        ]
    },
    {
        name: "Genshi",
        extensions: [
            ".kid"
        ],
        tmScope: "text.xml.genshi",
        aliases: [
            "xml+genshi",
            "xml+kid"
        ],
        codemirrorMode: "xml",
        codemirrorMimeType: "text/xml",
        since: "0.1.0",
        parsers: [
            "xml"
        ],
        linguistLanguageId: 126,
        vscodeLanguageIds: [
            "xml"
        ]
    },
    {
        name: "JetBrains MPS",
        aliases: [
            "mps"
        ],
        extensions: [
            ".mps",
            ".mpl",
            ".msd"
        ],
        codemirrorMode: "xml",
        codemirrorMimeType: "text/xml",
        tmScope: "none",
        since: "0.1.0",
        parsers: [
            "xml"
        ],
        linguistLanguageId: 465165328,
        vscodeLanguageIds: [
            "xml"
        ]
    },
    {
        name: "LabVIEW",
        extensions: [
            ".lvproj",
            ".lvclass",
            ".lvlib"
        ],
        tmScope: "text.xml",
        codemirrorMode: "xml",
        codemirrorMimeType: "text/xml",
        since: "0.1.0",
        parsers: [
            "xml"
        ],
        linguistLanguageId: 194,
        vscodeLanguageIds: [
            "xml"
        ]
    },
    {
        name: "Maven POM",
        group: "XML",
        tmScope: "text.xml.pom",
        filenames: [
            "pom.xml"
        ],
        codemirrorMode: "xml",
        codemirrorMimeType: "text/xml",
        since: "0.1.0",
        parsers: [
            "xml"
        ],
        linguistLanguageId: 226,
        vscodeLanguageIds: [
            "xml"
        ]
    },
    {
        name: "SVG",
        extensions: [
            ".svg"
        ],
        tmScope: "text.xml.svg",
        codemirrorMode: "xml",
        codemirrorMimeType: "text/xml",
        since: "0.1.0",
        parsers: [
            "xml"
        ],
        linguistLanguageId: 337,
        vscodeLanguageIds: [
            "xml"
        ]
    },
    {
        name: "Web Ontology Language",
        extensions: [
            ".owl"
        ],
        tmScope: "text.xml",
        since: "0.1.0",
        parsers: [
            "xml"
        ],
        linguistLanguageId: 394,
        vscodeLanguageIds: [
            "xml"
        ]
    },
    {
        name: "XML",
        tmScope: "text.xml",
        codemirrorMode: "xml",
        codemirrorMimeType: "text/xml",
        aliases: [
            "rss",
            "xsd",
            "wsdl"
        ],
        extensions: [
            ".adml",
            ".admx",
            ".ant",
            ".axaml",
            ".axml",
            ".builds",
            ".ccproj",
            ".ccxml",
            ".clixml",
            ".cproject",
            ".cscfg",
            ".csdef",
            ".csl",
            ".csproj",
            ".ct",
            ".depproj",
            ".dita",
            ".ditamap",
            ".ditaval",
            ".dll.config",
            ".dotsettings",
            ".filters",
            ".fsproj",
            ".fxml",
            ".glade",
            ".gml",
            ".gmx",
            ".grxml",
            ".gst",
            ".hzp",
            ".iml",
            ".inx",
            ".ivy",
            ".jelly",
            ".jsproj",
            ".kml",
            ".launch",
            ".mdpolicy",
            ".mjml",
            ".mm",
            ".mod",
            ".mxml",
            ".natvis",
            ".ncl",
            ".ndproj",
            ".nproj",
            ".nuspec",
            ".odd",
            ".osm",
            ".pkgproj",
            ".pluginspec",
            ".proj",
            ".props",
            ".ps1xml",
            ".psc1",
            ".pt",
            ".qhelp",
            ".rdf",
            ".res",
            ".resx",
            ".rs",
            ".rss",
            ".runsettings",
            ".sch",
            ".scxml",
            ".sfproj",
            ".shproj",
            ".srdf",
            ".storyboard",
            ".sublime-snippet",
            ".sw",
            ".targets",
            ".tml",
            ".ts",
            ".tsx",
            ".typ",
            ".ui",
            ".urdf",
            ".ux",
            ".vbproj",
            ".vcxproj",
            ".vsixmanifest",
            ".vssettings",
            ".vstemplate",
            ".vxml",
            ".wixproj",
            ".workflow",
            ".wsdl",
            ".wsf",
            ".wxi",
            ".wxl",
            ".wxs",
            ".x3d",
            ".xacro",
            ".xaml",
            ".xib",
            ".xlf",
            ".xliff",
            ".xmi",
            ".xml",
            ".xml.dist",
            ".xmp",
            ".xproj",
            ".xsd",
            ".xspec",
            ".xul",
            ".zcml"
        ],
        filenames: [
            ".classpath",
            ".cproject",
            ".project",
            "App.config",
            "NuGet.config",
            "Settings.StyleCop",
            "Web.Debug.config",
            "Web.Release.config",
            "Web.config",
            "packages.config"
        ],
        since: "0.1.0",
        parsers: [
            "xml"
        ],
        linguistLanguageId: 399,
        vscodeLanguageIds: [
            "xml"
        ]
    },
    {
        name: "XML Property List",
        group: "XML",
        extensions: [
            ".plist",
            ".stTheme",
            ".tmCommand",
            ".tmLanguage",
            ".tmPreferences",
            ".tmSnippet",
            ".tmTheme"
        ],
        tmScope: "text.xml.plist",
        codemirrorMode: "xml",
        codemirrorMimeType: "text/xml",
        since: "0.1.0",
        parsers: [
            "xml"
        ],
        linguistLanguageId: 75622871,
        vscodeLanguageIds: [
            "xml"
        ]
    },
    {
        name: "XPages",
        extensions: [
            ".xsp-config",
            ".xsp.metadata"
        ],
        tmScope: "text.xml",
        codemirrorMode: "xml",
        codemirrorMimeType: "text/xml",
        since: "0.1.0",
        parsers: [
            "xml"
        ],
        linguistLanguageId: 400,
        vscodeLanguageIds: [
            "xml"
        ]
    },
    {
        name: "XProc",
        extensions: [
            ".xpl",
            ".xproc"
        ],
        tmScope: "text.xml",
        codemirrorMode: "xml",
        codemirrorMimeType: "text/xml",
        since: "0.1.0",
        parsers: [
            "xml"
        ],
        linguistLanguageId: 401,
        vscodeLanguageIds: [
            "xml"
        ]
    },
    {
        name: "XSLT",
        aliases: [
            "xsl"
        ],
        extensions: [
            ".xslt",
            ".xsl"
        ],
        tmScope: "text.xml.xsl",
        codemirrorMode: "xml",
        codemirrorMimeType: "text/xml",
        since: "0.1.0",
        parsers: [
            "xml"
        ],
        linguistLanguageId: 404,
        vscodeLanguageIds: [
            "xml"
        ]
    }
];


var $2a43f562a1adef32$exports = {};
var $d804cb6b25db1e9b$exports = {};
parcelRequire("33Mmf");
var $hvAWv = parcelRequire("hvAWv");
var $eSJX3 = parcelRequire("eSJX3");
var $d804cb6b25db1e9b$require$createTokenOrg = $hvAWv.createToken;
var $d804cb6b25db1e9b$require$Lexer = $eSJX3.Lexer;
// A little mini DSL for easier lexer definition.
const $d804cb6b25db1e9b$var$fragments = {};
const $d804cb6b25db1e9b$var$f = $d804cb6b25db1e9b$var$fragments;
function $d804cb6b25db1e9b$var$FRAGMENT(name, def) {
    $d804cb6b25db1e9b$var$fragments[name] = typeof def === "string" ? def : def.source;
}
function $d804cb6b25db1e9b$var$makePattern(strings, ...args) {
    let combined = "";
    for(let i = 0; i < strings.length; i++){
        combined += strings[i];
        if (i < args.length) {
            let pattern = args[i];
            // By wrapping in a RegExp (none) capturing group
            // We enabled the safe usage of qualifiers and assertions.
            combined += `(?:${pattern})`;
        }
    }
    return new RegExp(combined);
}
const $d804cb6b25db1e9b$var$tokensArray = [];
const $d804cb6b25db1e9b$var$tokensDictionary = {};
function $d804cb6b25db1e9b$var$createToken(options) {
    const newTokenType = $d804cb6b25db1e9b$require$createTokenOrg(options);
    $d804cb6b25db1e9b$var$tokensArray.push(newTokenType);
    $d804cb6b25db1e9b$var$tokensDictionary[options.name] = newTokenType;
    return newTokenType;
}
$d804cb6b25db1e9b$var$FRAGMENT("NameStartChar", "(:|[a-zA-Z]|_|\\u2070-\\u218F|\\u2C00-\\u2FEF|\\u3001-\\uD7FF|\\uF900-\\uFDCF|\\uFDF0-\\uFFFD)");
$d804cb6b25db1e9b$var$FRAGMENT("NameChar", $d804cb6b25db1e9b$var$makePattern`${$d804cb6b25db1e9b$var$f.NameStartChar}|-|\\.|\\d|\\u00B7||[\\u0300-\\u036F]|[\\u203F-\\u2040]`);
$d804cb6b25db1e9b$var$FRAGMENT("Name", $d804cb6b25db1e9b$var$makePattern`${$d804cb6b25db1e9b$var$f.NameStartChar}(${$d804cb6b25db1e9b$var$f.NameChar})*`);
const $d804cb6b25db1e9b$var$Comment = $d804cb6b25db1e9b$var$createToken({
    name: "Comment",
    pattern: /<!--(.|\r?\n)*?-->/,
    // A Comment may span multiple lines.
    line_breaks: true
});
const $d804cb6b25db1e9b$var$CData = $d804cb6b25db1e9b$var$createToken({
    name: "CData",
    pattern: /<!\[CDATA\[(.|\r?\n)*?]]>/,
    line_breaks: true
});
const $d804cb6b25db1e9b$var$DocType = $d804cb6b25db1e9b$var$createToken({
    name: "DocType",
    pattern: /<!DOCTYPE/,
    push_mode: "INSIDE"
});
const $d804cb6b25db1e9b$var$IgnoredDTD = $d804cb6b25db1e9b$var$createToken({
    name: "DTD",
    pattern: /<!.*?>/,
    group: $d804cb6b25db1e9b$require$Lexer.SKIPPED
});
const $d804cb6b25db1e9b$var$EntityRef = $d804cb6b25db1e9b$var$createToken({
    name: "EntityRef",
    pattern: $d804cb6b25db1e9b$var$makePattern`&${$d804cb6b25db1e9b$var$f.Name};`
});
const $d804cb6b25db1e9b$var$CharRef = $d804cb6b25db1e9b$var$createToken({
    name: "CharRef",
    pattern: /&#\d+;|&#x[a-fA-F0-9]/
});
const $d804cb6b25db1e9b$var$SEA_WS = $d804cb6b25db1e9b$var$createToken({
    name: "SEA_WS",
    pattern: /( |\t|\n|\r\n)+/
});
const $d804cb6b25db1e9b$var$XMLDeclOpen = $d804cb6b25db1e9b$var$createToken({
    name: "XMLDeclOpen",
    pattern: /<\?xml[ \t\r\n]/,
    push_mode: "INSIDE"
});
const $d804cb6b25db1e9b$var$SLASH_OPEN = $d804cb6b25db1e9b$var$createToken({
    name: "SLASH_OPEN",
    pattern: /<\//,
    push_mode: "INSIDE"
});
const $d804cb6b25db1e9b$var$INVALID_SLASH_OPEN = $d804cb6b25db1e9b$var$createToken({
    name: "INVALID_SLASH_OPEN",
    pattern: /<\//,
    categories: [
        $d804cb6b25db1e9b$var$SLASH_OPEN
    ]
});
const $d804cb6b25db1e9b$var$PROCESSING_INSTRUCTION = $d804cb6b25db1e9b$var$createToken({
    name: "PROCESSING_INSTRUCTION",
    pattern: $d804cb6b25db1e9b$var$makePattern`<\\?${$d804cb6b25db1e9b$var$f.Name}.*\\?>`
});
const $d804cb6b25db1e9b$var$OPEN = $d804cb6b25db1e9b$var$createToken({
    name: "OPEN",
    pattern: /</,
    push_mode: "INSIDE"
});
// Meant to avoid skipping '<' token in a partial sequence of elements.
// Example of the problem this solves:
// <
// <from>john</from>
//  - The second '<' will be skipped because in the mode "INSIDE" '<' is not recognized.
//  - This means the AST will include only a single element instead of two
const $d804cb6b25db1e9b$var$INVALID_OPEN_INSIDE = $d804cb6b25db1e9b$var$createToken({
    name: "INVALID_OPEN_INSIDE",
    pattern: /</,
    categories: [
        $d804cb6b25db1e9b$var$OPEN
    ]
});
const $d804cb6b25db1e9b$var$TEXT = $d804cb6b25db1e9b$var$createToken({
    name: "TEXT",
    pattern: /[^<&]+/
});
const $d804cb6b25db1e9b$var$CLOSE = $d804cb6b25db1e9b$var$createToken({
    name: "CLOSE",
    pattern: />/,
    pop_mode: true
});
const $d804cb6b25db1e9b$var$SPECIAL_CLOSE = $d804cb6b25db1e9b$var$createToken({
    name: "SPECIAL_CLOSE",
    pattern: /\?>/,
    pop_mode: true
});
const $d804cb6b25db1e9b$var$SLASH_CLOSE = $d804cb6b25db1e9b$var$createToken({
    name: "SLASH_CLOSE",
    pattern: /\/>/,
    pop_mode: true
});
const $d804cb6b25db1e9b$var$SLASH = $d804cb6b25db1e9b$var$createToken({
    name: "SLASH",
    pattern: /\//
});
const $d804cb6b25db1e9b$var$STRING = $d804cb6b25db1e9b$var$createToken({
    name: "STRING",
    pattern: /"[^<"]*"|'[^<']*'/
});
const $d804cb6b25db1e9b$var$EQUALS = $d804cb6b25db1e9b$var$createToken({
    name: "EQUALS",
    pattern: /=/
});
const $d804cb6b25db1e9b$var$Name = $d804cb6b25db1e9b$var$createToken({
    name: "Name",
    pattern: $d804cb6b25db1e9b$var$makePattern`${$d804cb6b25db1e9b$var$f.Name}`
});
const $d804cb6b25db1e9b$var$S = $d804cb6b25db1e9b$var$createToken({
    name: "S",
    pattern: /[ \t\r\n]/,
    group: $d804cb6b25db1e9b$require$Lexer.SKIPPED
});
const $d804cb6b25db1e9b$var$xmlLexerDefinition = {
    defaultMode: "OUTSIDE",
    modes: {
        OUTSIDE: [
            $d804cb6b25db1e9b$var$Comment,
            $d804cb6b25db1e9b$var$CData,
            $d804cb6b25db1e9b$var$DocType,
            $d804cb6b25db1e9b$var$IgnoredDTD,
            $d804cb6b25db1e9b$var$EntityRef,
            $d804cb6b25db1e9b$var$CharRef,
            $d804cb6b25db1e9b$var$SEA_WS,
            $d804cb6b25db1e9b$var$XMLDeclOpen,
            $d804cb6b25db1e9b$var$SLASH_OPEN,
            $d804cb6b25db1e9b$var$PROCESSING_INSTRUCTION,
            $d804cb6b25db1e9b$var$OPEN,
            $d804cb6b25db1e9b$var$TEXT
        ],
        INSIDE: [
            // Tokens from `OUTSIDE` to improve error recovery behavior
            $d804cb6b25db1e9b$var$Comment,
            $d804cb6b25db1e9b$var$INVALID_SLASH_OPEN,
            $d804cb6b25db1e9b$var$INVALID_OPEN_INSIDE,
            // "Real" `INSIDE` tokens
            $d804cb6b25db1e9b$var$CLOSE,
            $d804cb6b25db1e9b$var$SPECIAL_CLOSE,
            $d804cb6b25db1e9b$var$SLASH_CLOSE,
            $d804cb6b25db1e9b$var$SLASH,
            $d804cb6b25db1e9b$var$EQUALS,
            $d804cb6b25db1e9b$var$STRING,
            $d804cb6b25db1e9b$var$Name,
            $d804cb6b25db1e9b$var$S
        ]
    }
};
const $d804cb6b25db1e9b$var$xmlLexer = new $d804cb6b25db1e9b$require$Lexer($d804cb6b25db1e9b$var$xmlLexerDefinition, {
    // Reducing the amount of position tracking can provide a small performance boost (<10%)
    // Likely best to keep the full info for better error position reporting and
    // to expose "fuller" ITokens from the Lexer.
    positionTracking: "full",
    ensureOptimizations: false,
    // TODO: inspect definitions for XML line terminators
    lineTerminatorCharacters: [
        "\n"
    ],
    lineTerminatorsPattern: /\n|\r\n/g
});
$d804cb6b25db1e9b$exports = {
    xmlLexer: $d804cb6b25db1e9b$var$xmlLexer,
    tokensDictionary: $d804cb6b25db1e9b$var$tokensDictionary
};


var $2a43f562a1adef32$require$xmlLexer = $d804cb6b25db1e9b$exports.xmlLexer;
var $e20293940c698fd1$exports = {};
parcelRequire("33Mmf");
var $5qjkp = parcelRequire("5qjkp");
var $hvAWv = parcelRequire("hvAWv");
var $e20293940c698fd1$require$CstParser = $5qjkp.CstParser;
var $e20293940c698fd1$require$tokenMatcher = $hvAWv.tokenMatcher;

var $e20293940c698fd1$require$t = $d804cb6b25db1e9b$exports.tokensDictionary;
class $e20293940c698fd1$var$Parser extends $e20293940c698fd1$require$CstParser {
    constructor(){
        super($e20293940c698fd1$require$t, {
            maxLookahead: 1,
            recoveryEnabled: true,
            nodeLocationTracking: "full"
        });
        this.deletionRecoveryEnabled = true;
        const $ = this;
        $.RULE("document", ()=>{
            $.OPTION(()=>{
                $.SUBRULE($.prolog);
            });
            $.MANY(()=>{
                $.SUBRULE($.misc);
            });
            $.OPTION2(()=>{
                $.SUBRULE($.docTypeDecl);
            });
            $.MANY2(()=>{
                $.SUBRULE2($.misc);
            });
            $.SUBRULE($.element);
            $.MANY3(()=>{
                $.SUBRULE3($.misc);
            });
        });
        $.RULE("prolog", ()=>{
            $.CONSUME($e20293940c698fd1$require$t.XMLDeclOpen);
            $.MANY(()=>{
                $.SUBRULE($.attribute);
            });
            $.CONSUME($e20293940c698fd1$require$t.SPECIAL_CLOSE);
        });
        // https://www.w3.org/TR/xml/#NT-doctypedecl
        $.RULE("docTypeDecl", ()=>{
            $.CONSUME($e20293940c698fd1$require$t.DocType);
            $.CONSUME($e20293940c698fd1$require$t.Name);
            $.OPTION(()=>{
                $.SUBRULE($.externalID);
            });
            // The internal subSet part is intentionally not implemented because we do not at this
            // time wish to implement a full DTD Parser as part of this project...
            // https://www.w3.org/TR/xml/#NT-intSubset
            $.CONSUME($e20293940c698fd1$require$t.CLOSE);
        });
        $.RULE("externalID", ()=>{
            // Using gates to assert the value of the "Name" Identifiers.
            // We could use Categories to model un-reserved keywords, however I am not sure
            // The added complexity is needed at this time...
            $.OR([
                {
                    GATE: ()=>$.LA(1).image === "SYSTEM",
                    ALT: ()=>{
                        $.CONSUME2($e20293940c698fd1$require$t.Name, {
                            LABEL: "System"
                        });
                        $.CONSUME($e20293940c698fd1$require$t.STRING, {
                            LABEL: "SystemLiteral"
                        });
                    }
                },
                {
                    GATE: ()=>$.LA(1).image === "PUBLIC",
                    ALT: ()=>{
                        $.CONSUME3($e20293940c698fd1$require$t.Name, {
                            LABEL: "Public"
                        });
                        $.CONSUME2($e20293940c698fd1$require$t.STRING, {
                            LABEL: "PubIDLiteral"
                        });
                        $.CONSUME3($e20293940c698fd1$require$t.STRING, {
                            LABEL: "SystemLiteral"
                        });
                    }
                }
            ]);
        });
        $.RULE("content", ()=>{
            $.MANY(()=>{
                $.OR([
                    {
                        ALT: ()=>$.SUBRULE($.element)
                    },
                    {
                        ALT: ()=>$.SUBRULE($.chardata)
                    },
                    {
                        ALT: ()=>$.SUBRULE($.reference)
                    },
                    {
                        ALT: ()=>$.CONSUME($e20293940c698fd1$require$t.CData)
                    },
                    {
                        ALT: ()=>$.CONSUME($e20293940c698fd1$require$t.PROCESSING_INSTRUCTION)
                    },
                    {
                        ALT: ()=>$.CONSUME($e20293940c698fd1$require$t.Comment)
                    }
                ]);
            });
        });
        $.RULE("element", ()=>{
            $.CONSUME($e20293940c698fd1$require$t.OPEN);
            try {
                this.deletionRecoveryEnabled = false;
                // disabling single token deletion here
                // because `<
                //            </note>`
                // will be parsed as: `<note>`
                // and the next element will be lost
                $.CONSUME($e20293940c698fd1$require$t.Name);
            } finally{
                this.deletionRecoveryEnabled = true;
            }
            $.MANY(()=>{
                $.SUBRULE($.attribute);
            });
            $.OR([
                {
                    ALT: ()=>{
                        $.CONSUME($e20293940c698fd1$require$t.CLOSE, {
                            LABEL: "START_CLOSE"
                        });
                        $.SUBRULE($.content);
                        $.CONSUME($e20293940c698fd1$require$t.SLASH_OPEN);
                        $.CONSUME2($e20293940c698fd1$require$t.Name, {
                            LABEL: "END_NAME"
                        });
                        $.CONSUME2($e20293940c698fd1$require$t.CLOSE, {
                            LABEL: "END"
                        });
                    }
                },
                {
                    ALT: ()=>{
                        $.CONSUME($e20293940c698fd1$require$t.SLASH_CLOSE);
                    }
                }
            ]);
        });
        $.RULE("reference", ()=>{
            $.OR([
                {
                    ALT: ()=>$.CONSUME($e20293940c698fd1$require$t.EntityRef)
                },
                {
                    ALT: ()=>$.CONSUME($e20293940c698fd1$require$t.CharRef)
                }
            ]);
        });
        $.RULE("attribute", ()=>{
            $.CONSUME($e20293940c698fd1$require$t.Name);
            try {
                this.deletionRecoveryEnabled = false;
                // disabling single token deletion here
                // because `attrib1 attrib2="666`
                // will be parsed as: `attrib1="666`
                $.CONSUME($e20293940c698fd1$require$t.EQUALS);
                // disabling single token deletion here
                // to avoid new elementName being
                $.CONSUME($e20293940c698fd1$require$t.STRING);
            } finally{
                this.deletionRecoveryEnabled = true;
            }
        });
        $.RULE("chardata", ()=>{
            $.OR([
                {
                    ALT: ()=>$.CONSUME($e20293940c698fd1$require$t.TEXT)
                },
                {
                    ALT: ()=>$.CONSUME($e20293940c698fd1$require$t.SEA_WS)
                }
            ]);
        });
        $.RULE("misc", ()=>{
            $.OR([
                {
                    ALT: ()=>$.CONSUME($e20293940c698fd1$require$t.Comment)
                },
                {
                    ALT: ()=>$.CONSUME($e20293940c698fd1$require$t.PROCESSING_INSTRUCTION)
                },
                {
                    ALT: ()=>$.CONSUME($e20293940c698fd1$require$t.SEA_WS)
                }
            ]);
        });
        this.performSelfAnalysis();
    }
    canRecoverWithSingleTokenDeletion(expectedTokType) {
        if (this.deletionRecoveryEnabled === false) return false;
        return super.canRecoverWithSingleTokenDeletion(expectedTokType);
    }
    // TODO: provide this fix upstream to chevrotain
    // https://github.com/SAP/chevrotain/issues/1055
    /* istanbul ignore next - should be tested as part of Chevrotain */ findReSyncTokenType() {
        const allPossibleReSyncTokTypes = this.flattenFollowSet();
        // this loop will always terminate as EOF is always in the follow stack and also always (virtually) in the input
        let nextToken = this.LA(1);
        let k = 2;
        /* eslint-disable-next-line no-constant-condition -- see above comment */ while(true){
            const foundMatch = allPossibleReSyncTokTypes.find((resyncTokType)=>{
                const canMatch = $e20293940c698fd1$require$tokenMatcher(nextToken, resyncTokType);
                return canMatch;
            });
            if (foundMatch !== undefined) return foundMatch;
            nextToken = this.LA(k);
            k++;
        }
    }
}
// Re-use the same parser instance
const $e20293940c698fd1$var$xmlParser = new $e20293940c698fd1$var$Parser();
$e20293940c698fd1$exports = {
    xmlParser: $e20293940c698fd1$var$xmlParser
};


var $2a43f562a1adef32$require$xmlParser = $e20293940c698fd1$exports.xmlParser;
$2a43f562a1adef32$exports = {
    parse: function parse(text) {
        const lexResult = $2a43f562a1adef32$require$xmlLexer.tokenize(text);
        // setting a new input will RESET the parser instance's state.
        $2a43f562a1adef32$require$xmlParser.input = lexResult.tokens;
        // any top level rule may be used as an entry point
        const cst = $2a43f562a1adef32$require$xmlParser.document();
        return {
            cst: cst,
            tokenVector: lexResult.tokens,
            lexErrors: lexResult.errors,
            parseErrors: $2a43f562a1adef32$require$xmlParser.errors
        };
    },
    BaseXmlCstVisitor: $2a43f562a1adef32$require$xmlParser.getBaseCstVisitorConstructor()
};


function $c9103c5b7fb15be8$var$createError(message, options) {
    // TODO: Use `Error.prototype.cause` when we drop support for Node.js<18.7.0
    // Construct an error similar to the ones thrown by Prettier.
    const error = new SyntaxError(message + " (" + options.loc.start.line + ":" + options.loc.start.column + ")");
    return Object.assign(error, options);
}
function $c9103c5b7fb15be8$var$simplifyCST(node) {
    switch(node.name){
        case "attribute":
            {
                const { Name: Name, EQUALS: EQUALS, STRING: STRING } = node.children;
                return {
                    name: "attribute",
                    Name: Name[0].image,
                    EQUALS: EQUALS[0].image,
                    STRING: STRING[0].image,
                    location: node.location
                };
            }
        case "chardata":
            {
                const { SEA_WS: SEA_WS, TEXT: TEXT } = node.children;
                return {
                    name: "chardata",
                    SEA_WS: SEA_WS ? SEA_WS[0].image : null,
                    TEXT: TEXT ? TEXT[0].image : null,
                    location: node.location
                };
            }
        case "content":
            {
                const { CData: CData, Comment: Comment, chardata: chardata, element: element, PROCESSING_INSTRUCTION: PROCESSING_INSTRUCTION, reference: reference } = node.children;
                return {
                    name: "content",
                    CData: CData || [],
                    Comment: Comment || [],
                    chardata: (chardata || []).map($c9103c5b7fb15be8$var$simplifyCST),
                    element: (element || []).map($c9103c5b7fb15be8$var$simplifyCST),
                    PROCESSING_INSTRUCTION: PROCESSING_INSTRUCTION || [],
                    reference: (reference || []).map($c9103c5b7fb15be8$var$simplifyCST),
                    location: node.location
                };
            }
        case "docTypeDecl":
            {
                const { DocType: DocType, Name: Name, externalID: externalID, CLOSE: CLOSE } = node.children;
                return {
                    name: "docTypeDecl",
                    DocType: DocType[0].image,
                    Name: Name[0].image,
                    externalID: externalID ? $c9103c5b7fb15be8$var$simplifyCST(externalID[0]) : null,
                    CLOSE: CLOSE[0].image,
                    location: node.location
                };
            }
        case "document":
            {
                const { docTypeDecl: docTypeDecl, element: element, misc: misc, prolog: prolog } = node.children;
                return {
                    name: "document",
                    docTypeDecl: docTypeDecl ? $c9103c5b7fb15be8$var$simplifyCST(docTypeDecl[0]) : null,
                    element: element ? $c9103c5b7fb15be8$var$simplifyCST(element[0]) : null,
                    misc: (misc || []).filter((child)=>!child.children.SEA_WS).map($c9103c5b7fb15be8$var$simplifyCST),
                    prolog: prolog ? $c9103c5b7fb15be8$var$simplifyCST(prolog[0]) : null,
                    location: node.location
                };
            }
        case "element":
            {
                const { OPEN: OPEN, Name: Name, attribute: attribute, START_CLOSE: START_CLOSE, content: content, SLASH_OPEN: SLASH_OPEN, END_NAME: END_NAME, END: END, SLASH_CLOSE: SLASH_CLOSE } = node.children;
                return {
                    name: "element",
                    OPEN: OPEN[0].image,
                    Name: Name[0].image,
                    attribute: (attribute || []).map($c9103c5b7fb15be8$var$simplifyCST),
                    START_CLOSE: START_CLOSE ? START_CLOSE[0].image : null,
                    content: content ? $c9103c5b7fb15be8$var$simplifyCST(content[0]) : null,
                    SLASH_OPEN: SLASH_OPEN ? SLASH_OPEN[0].image : null,
                    END_NAME: END_NAME ? END_NAME[0].image : null,
                    END: END ? END[0].image : null,
                    SLASH_CLOSE: SLASH_CLOSE ? SLASH_CLOSE[0].image : null,
                    location: node.location
                };
            }
        case "externalID":
            {
                const { Public: Public, PubIDLiteral: PubIDLiteral, System: System, SystemLiteral: SystemLiteral } = node.children;
                return {
                    name: "externalID",
                    Public: Public ? Public[0].image : null,
                    PubIDLiteral: PubIDLiteral ? PubIDLiteral[0].image : null,
                    System: System ? System[0].image : null,
                    SystemLiteral: SystemLiteral ? SystemLiteral[0].image : null,
                    location: node.location
                };
            }
        case "misc":
            {
                const { Comment: Comment, PROCESSING_INSTRUCTION: PROCESSING_INSTRUCTION, SEA_WS: SEA_WS } = node.children;
                return {
                    name: "misc",
                    Comment: Comment ? Comment[0].image : null,
                    PROCESSING_INSTRUCTION: PROCESSING_INSTRUCTION ? PROCESSING_INSTRUCTION[0].image : null,
                    SEA_WS: SEA_WS ? SEA_WS[0].image : null,
                    location: node.location
                };
            }
        case "prolog":
            {
                const { XMLDeclOpen: XMLDeclOpen, attribute: attribute, SPECIAL_CLOSE: SPECIAL_CLOSE } = node.children;
                return {
                    name: "prolog",
                    XMLDeclOpen: XMLDeclOpen[0].image,
                    attribute: (attribute || []).map($c9103c5b7fb15be8$var$simplifyCST),
                    SPECIAL_CLOSE: SPECIAL_CLOSE[0].image,
                    location: node.location
                };
            }
        case "reference":
            {
                const { CharRef: CharRef, EntityRef: EntityRef } = node.children;
                return {
                    name: "reference",
                    CharRef: CharRef ? CharRef[0].image : null,
                    EntityRef: EntityRef ? EntityRef[0].image : null,
                    location: node.location
                };
            }
        default:
            throw new Error(`Unknown node type: ${node.name}`);
    }
}
const $c9103c5b7fb15be8$var$parser = {
    parse (text) {
        const { lexErrors: lexErrors, parseErrors: parseErrors, cst: cst } = (0, $2a43f562a1adef32$exports.parse)(text);
        // If there are any lexical errors, throw the first of them as an error.
        if (lexErrors.length > 0) {
            const lexError = lexErrors[0];
            throw $c9103c5b7fb15be8$var$createError(lexError.message, {
                loc: {
                    start: {
                        line: lexError.line,
                        column: lexError.column
                    },
                    end: {
                        line: lexError.line,
                        column: lexError.column + lexError.length
                    }
                }
            });
        }
        // If there are any parse errors, throw the first of them as an error.
        if (parseErrors.length > 0) {
            const parseError = parseErrors[0];
            throw $c9103c5b7fb15be8$var$createError(parseError.message, {
                loc: {
                    start: {
                        line: parseError.token.startLine,
                        column: parseError.token.startColumn
                    },
                    end: {
                        line: parseError.token.endLine,
                        column: parseError.token.endColumn
                    }
                }
            });
        }
        // Otherwise return the CST.
        return $c9103c5b7fb15be8$var$simplifyCST(cst);
    },
    astFormat: "xml",
    locStart (node) {
        return node.location.startOffset;
    },
    locEnd (node) {
        return node.location.endOffset;
    }
};
var $c9103c5b7fb15be8$export$2e2bcd8739ae039 = $c9103c5b7fb15be8$var$parser;


var $f14f3ea561049322$exports = {};
(function(factory) {
    function interopModuleDefault() {
        var module1 = factory();
        return module1.default || module1;
    }
    var root;
    $f14f3ea561049322$exports = interopModuleDefault();
})(function() {
    "use strict";
    var __defProp = Object.defineProperty;
    var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
    var __getOwnPropNames = Object.getOwnPropertyNames;
    var __hasOwnProp = Object.prototype.hasOwnProperty;
    var __export = (target, all)=>{
        for(var name in all)__defProp(target, name, {
            get: all[name],
            enumerable: true
        });
    };
    var __copyProps = (to, from, except, desc)=>{
        if (from && typeof from === "object" || typeof from === "function") {
            for (let key of __getOwnPropNames(from))if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                get: ()=>from[key],
                enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
            });
        }
        return to;
    };
    var __toCommonJS = (mod)=>__copyProps(__defProp({}, "__esModule", {
            value: true
        }), mod);
    // src/document/public.js
    var public_exports = {};
    __export(public_exports, {
        builders: ()=>builders,
        printer: ()=>printer,
        utils: ()=>utils
    });
    // src/document/constants.js
    var DOC_TYPE_STRING = "string";
    var DOC_TYPE_ARRAY = "array";
    var DOC_TYPE_CURSOR = "cursor";
    var DOC_TYPE_INDENT = "indent";
    var DOC_TYPE_ALIGN = "align";
    var DOC_TYPE_TRIM = "trim";
    var DOC_TYPE_GROUP = "group";
    var DOC_TYPE_FILL = "fill";
    var DOC_TYPE_IF_BREAK = "if-break";
    var DOC_TYPE_INDENT_IF_BREAK = "indent-if-break";
    var DOC_TYPE_LINE_SUFFIX = "line-suffix";
    var DOC_TYPE_LINE_SUFFIX_BOUNDARY = "line-suffix-boundary";
    var DOC_TYPE_LINE = "line";
    var DOC_TYPE_LABEL = "label";
    var DOC_TYPE_BREAK_PARENT = "break-parent";
    var VALID_OBJECT_DOC_TYPES = /* @__PURE__ */ new Set([
        DOC_TYPE_CURSOR,
        DOC_TYPE_INDENT,
        DOC_TYPE_ALIGN,
        DOC_TYPE_TRIM,
        DOC_TYPE_GROUP,
        DOC_TYPE_FILL,
        DOC_TYPE_IF_BREAK,
        DOC_TYPE_INDENT_IF_BREAK,
        DOC_TYPE_LINE_SUFFIX,
        DOC_TYPE_LINE_SUFFIX_BOUNDARY,
        DOC_TYPE_LINE,
        DOC_TYPE_LABEL,
        DOC_TYPE_BREAK_PARENT
    ]);
    // src/document/utils/get-doc-type.js
    function getDocType(doc) {
        if (typeof doc === "string") return DOC_TYPE_STRING;
        if (Array.isArray(doc)) return DOC_TYPE_ARRAY;
        if (!doc) return;
        const { type: type } = doc;
        if (VALID_OBJECT_DOC_TYPES.has(type)) return type;
    }
    var get_doc_type_default = getDocType;
    // src/document/invalid-doc-error.js
    var disjunctionListFormat = (list)=>new Intl.ListFormat("en-US", {
            type: "disjunction"
        }).format(list);
    function getDocErrorMessage(doc) {
        const type = doc === null ? "null" : typeof doc;
        if (type !== "string" && type !== "object") return `Unexpected doc '${type}', 
Expected it to be 'string' or 'object'.`;
        if (get_doc_type_default(doc)) throw new Error("doc is valid.");
        const objectType = Object.prototype.toString.call(doc);
        if (objectType !== "[object Object]") return `Unexpected doc '${objectType}'.`;
        const EXPECTED_TYPE_VALUES = disjunctionListFormat([
            ...VALID_OBJECT_DOC_TYPES
        ].map((type2)=>`'${type2}'`));
        return `Unexpected doc.type '${doc.type}'.
Expected it to be ${EXPECTED_TYPE_VALUES}.`;
    }
    var InvalidDocError = class extends Error {
        name = "InvalidDocError";
        constructor(doc){
            super(getDocErrorMessage(doc));
            this.doc = doc;
        }
    };
    var invalid_doc_error_default = InvalidDocError;
    // src/document/utils/traverse-doc.js
    var traverseDocOnExitStackMarker = {};
    function traverseDoc(doc, onEnter, onExit, shouldTraverseConditionalGroups) {
        const docsStack = [
            doc
        ];
        while(docsStack.length > 0){
            const doc2 = docsStack.pop();
            if (doc2 === traverseDocOnExitStackMarker) {
                onExit(docsStack.pop());
                continue;
            }
            if (onExit) docsStack.push(doc2, traverseDocOnExitStackMarker);
            const docType = get_doc_type_default(doc2);
            if (!docType) throw new invalid_doc_error_default(doc2);
            if ((onEnter == null ? void 0 : onEnter(doc2)) === false) continue;
            switch(docType){
                case DOC_TYPE_ARRAY:
                case DOC_TYPE_FILL:
                    {
                        const parts = docType === DOC_TYPE_ARRAY ? doc2 : doc2.parts;
                        for(let ic = parts.length, i = ic - 1; i >= 0; --i)docsStack.push(parts[i]);
                        break;
                    }
                case DOC_TYPE_IF_BREAK:
                    docsStack.push(doc2.flatContents, doc2.breakContents);
                    break;
                case DOC_TYPE_GROUP:
                    if (shouldTraverseConditionalGroups && doc2.expandedStates) for(let ic = doc2.expandedStates.length, i = ic - 1; i >= 0; --i)docsStack.push(doc2.expandedStates[i]);
                    else docsStack.push(doc2.contents);
                    break;
                case DOC_TYPE_ALIGN:
                case DOC_TYPE_INDENT:
                case DOC_TYPE_INDENT_IF_BREAK:
                case DOC_TYPE_LABEL:
                case DOC_TYPE_LINE_SUFFIX:
                    docsStack.push(doc2.contents);
                    break;
                case DOC_TYPE_STRING:
                case DOC_TYPE_CURSOR:
                case DOC_TYPE_TRIM:
                case DOC_TYPE_LINE_SUFFIX_BOUNDARY:
                case DOC_TYPE_LINE:
                case DOC_TYPE_BREAK_PARENT:
                    break;
                default:
                    throw new invalid_doc_error_default(doc2);
            }
        }
    }
    var traverse_doc_default = traverseDoc;
    // src/document/utils/assert-doc.js
    var noop = ()=>{};
    var assertDoc = noop;
    var assertDocArray = noop;
    // src/document/builders.js
    function indent(contents) {
        assertDoc(contents);
        return {
            type: DOC_TYPE_INDENT,
            contents: contents
        };
    }
    function align(widthOrString, contents) {
        assertDoc(contents);
        return {
            type: DOC_TYPE_ALIGN,
            contents: contents,
            n: widthOrString
        };
    }
    function group(contents, opts = {}) {
        assertDoc(contents);
        assertDocArray(opts.expandedStates, /* optional */ true);
        return {
            type: DOC_TYPE_GROUP,
            id: opts.id,
            contents: contents,
            break: Boolean(opts.shouldBreak),
            expandedStates: opts.expandedStates
        };
    }
    function dedentToRoot(contents) {
        return align(Number.NEGATIVE_INFINITY, contents);
    }
    function markAsRoot(contents) {
        return align({
            type: "root"
        }, contents);
    }
    function dedent(contents) {
        return align(-1, contents);
    }
    function conditionalGroup(states, opts) {
        return group(states[0], {
            ...opts,
            expandedStates: states
        });
    }
    function fill(parts) {
        assertDocArray(parts);
        return {
            type: DOC_TYPE_FILL,
            parts: parts
        };
    }
    function ifBreak(breakContents, flatContents = "", opts = {}) {
        assertDoc(breakContents);
        if (flatContents !== "") assertDoc(flatContents);
        return {
            type: DOC_TYPE_IF_BREAK,
            breakContents: breakContents,
            flatContents: flatContents,
            groupId: opts.groupId
        };
    }
    function indentIfBreak(contents, opts) {
        assertDoc(contents);
        return {
            type: DOC_TYPE_INDENT_IF_BREAK,
            contents: contents,
            groupId: opts.groupId,
            negate: opts.negate
        };
    }
    function lineSuffix(contents) {
        assertDoc(contents);
        return {
            type: DOC_TYPE_LINE_SUFFIX,
            contents: contents
        };
    }
    var lineSuffixBoundary = {
        type: DOC_TYPE_LINE_SUFFIX_BOUNDARY
    };
    var breakParent = {
        type: DOC_TYPE_BREAK_PARENT
    };
    var trim = {
        type: DOC_TYPE_TRIM
    };
    var hardlineWithoutBreakParent = {
        type: DOC_TYPE_LINE,
        hard: true
    };
    var literallineWithoutBreakParent = {
        type: DOC_TYPE_LINE,
        hard: true,
        literal: true
    };
    var line = {
        type: DOC_TYPE_LINE
    };
    var softline = {
        type: DOC_TYPE_LINE,
        soft: true
    };
    var hardline = [
        hardlineWithoutBreakParent,
        breakParent
    ];
    var literalline = [
        literallineWithoutBreakParent,
        breakParent
    ];
    var cursor = {
        type: DOC_TYPE_CURSOR
    };
    function join(separator, docs) {
        assertDoc(separator);
        assertDocArray(docs);
        const parts = [];
        for(let i = 0; i < docs.length; i++){
            if (i !== 0) parts.push(separator);
            parts.push(docs[i]);
        }
        return parts;
    }
    function addAlignmentToDoc(doc, size, tabWidth) {
        assertDoc(doc);
        let aligned = doc;
        if (size > 0) {
            for(let i = 0; i < Math.floor(size / tabWidth); ++i)aligned = indent(aligned);
            aligned = align(size % tabWidth, aligned);
            aligned = align(Number.NEGATIVE_INFINITY, aligned);
        }
        return aligned;
    }
    function label(label2, contents) {
        assertDoc(contents);
        return label2 ? {
            type: DOC_TYPE_LABEL,
            label: label2,
            contents: contents
        } : contents;
    }
    // scripts/build/shims/at.js
    var at = (isOptionalObject, object, index)=>{
        if (isOptionalObject && (object === void 0 || object === null)) return;
        if (Array.isArray(object) || typeof object === "string") return object[index < 0 ? object.length + index : index];
        return object.at(index);
    };
    var at_default = at;
    // scripts/build/shims/string-replace-all.js
    var stringReplaceAll = (isOptionalObject, original, pattern, replacement)=>{
        if (isOptionalObject && (original === void 0 || original === null)) return;
        if (original.replaceAll) return original.replaceAll(pattern, replacement);
        if (pattern.global) return original.replace(pattern, replacement);
        return original.split(pattern).join(replacement);
    };
    var string_replace_all_default = stringReplaceAll;
    // src/common/end-of-line.js
    function convertEndOfLineToChars(value) {
        switch(value){
            case "cr":
                return "\r";
            case "crlf":
                return "\r\n";
            default:
                return "\n";
        }
    }
    // node_modules/emoji-regex/index.mjs
    var emoji_regex_default = ()=>{
        return /[#*0-9]\uFE0F?\u20E3|[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23ED-\u23EF\u23F1\u23F2\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A7\u26AA\u26B0\u26B1\u26BD\u26BE\u26C4\u26C8\u26CF\u26D1\u26E9\u26F0-\u26F5\u26F7\u26F8\u26FA\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2757\u2763\u27A1\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B55\u3030\u303D\u3297\u3299]\uFE0F?|[\u261D\u270C\u270D](?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?|[\u270A\u270B](?:\uD83C[\uDFFB-\uDFFF])?|[\u23E9-\u23EC\u23F0\u23F3\u25FD\u2693\u26A1\u26AB\u26C5\u26CE\u26D4\u26EA\u26FD\u2705\u2728\u274C\u274E\u2753-\u2755\u2795-\u2797\u27B0\u27BF\u2B50]|\u26D3\uFE0F?(?:\u200D\uD83D\uDCA5)?|\u26F9(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|\u2764\uFE0F?(?:\u200D(?:\uD83D\uDD25|\uD83E\uDE79))?|\uD83C(?:[\uDC04\uDD70\uDD71\uDD7E\uDD7F\uDE02\uDE37\uDF21\uDF24-\uDF2C\uDF36\uDF7D\uDF96\uDF97\uDF99-\uDF9B\uDF9E\uDF9F\uDFCD\uDFCE\uDFD4-\uDFDF\uDFF5\uDFF7]\uFE0F?|[\uDF85\uDFC2\uDFC7](?:\uD83C[\uDFFB-\uDFFF])?|[\uDFC4\uDFCA](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDFCB\uDFCC](?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDCCF\uDD8E\uDD91-\uDD9A\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF43\uDF45-\uDF4A\uDF4C-\uDF7C\uDF7E-\uDF84\uDF86-\uDF93\uDFA0-\uDFC1\uDFC5\uDFC6\uDFC8\uDFC9\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF8-\uDFFF]|\uDDE6\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF]|\uDDE7\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF]|\uDDE8\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF]|\uDDE9\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF]|\uDDEA\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA]|\uDDEB\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7]|\uDDEC\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE]|\uDDED\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA]|\uDDEE\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9]|\uDDEF\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5]|\uDDF0\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF]|\uDDF1\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE]|\uDDF2\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF]|\uDDF3\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF]|\uDDF4\uD83C\uDDF2|\uDDF5\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE]|\uDDF6\uD83C\uDDE6|\uDDF7\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC]|\uDDF8\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF]|\uDDF9\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF]|\uDDFA\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF]|\uDDFB\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA]|\uDDFC\uD83C[\uDDEB\uDDF8]|\uDDFD\uD83C\uDDF0|\uDDFE\uD83C[\uDDEA\uDDF9]|\uDDFF\uD83C[\uDDE6\uDDF2\uDDFC]|\uDF44(?:\u200D\uD83D\uDFEB)?|\uDF4B(?:\u200D\uD83D\uDFE9)?|\uDFC3(?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D(?:[\u2640\u2642]\uFE0F?(?:\u200D\u27A1\uFE0F?)?|\u27A1\uFE0F?))?|\uDFF3\uFE0F?(?:\u200D(?:\u26A7\uFE0F?|\uD83C\uDF08))?|\uDFF4(?:\u200D\u2620\uFE0F?|\uDB40\uDC67\uDB40\uDC62\uDB40(?:\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDC73\uDB40\uDC63\uDB40\uDC74|\uDC77\uDB40\uDC6C\uDB40\uDC73)\uDB40\uDC7F)?)|\uD83D(?:[\uDC3F\uDCFD\uDD49\uDD4A\uDD6F\uDD70\uDD73\uDD76-\uDD79\uDD87\uDD8A-\uDD8D\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA\uDECB\uDECD-\uDECF\uDEE0-\uDEE5\uDEE9\uDEF0\uDEF3]\uFE0F?|[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC](?:\uD83C[\uDFFB-\uDFFF])?|[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4\uDEB5](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD74\uDD90](?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?|[\uDC00-\uDC07\uDC09-\uDC14\uDC16-\uDC25\uDC27-\uDC3A\uDC3C-\uDC3E\uDC40\uDC44\uDC45\uDC51-\uDC65\uDC6A\uDC79-\uDC7B\uDC7D-\uDC80\uDC84\uDC88-\uDC8E\uDC90\uDC92-\uDCA9\uDCAB-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDDA4\uDDFB-\uDE2D\uDE2F-\uDE34\uDE37-\uDE41\uDE43\uDE44\uDE48-\uDE4A\uDE80-\uDEA2\uDEA4-\uDEB3\uDEB7-\uDEBF\uDEC1-\uDEC5\uDED0-\uDED2\uDED5-\uDED7\uDEDC-\uDEDF\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB\uDFF0]|\uDC08(?:\u200D\u2B1B)?|\uDC15(?:\u200D\uD83E\uDDBA)?|\uDC26(?:\u200D(?:\u2B1B|\uD83D\uDD25))?|\uDC3B(?:\u200D\u2744\uFE0F?)?|\uDC41\uFE0F?(?:\u200D\uD83D\uDDE8\uFE0F?)?|\uDC68(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDC68\uDC69]\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFE])))?))?|\uDC69(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?[\uDC68\uDC69]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?|\uDC69\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?))|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFE])))?))?|\uDC6F(?:\u200D[\u2640\u2642]\uFE0F?)?|\uDD75(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|\uDE2E(?:\u200D\uD83D\uDCA8)?|\uDE35(?:\u200D\uD83D\uDCAB)?|\uDE36(?:\u200D\uD83C\uDF2B\uFE0F?)?|\uDE42(?:\u200D[\u2194\u2195]\uFE0F?)?|\uDEB6(?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D(?:[\u2640\u2642]\uFE0F?(?:\u200D\u27A1\uFE0F?)?|\u27A1\uFE0F?))?)|\uD83E(?:[\uDD0C\uDD0F\uDD18-\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5\uDEC3-\uDEC5\uDEF0\uDEF2-\uDEF8](?:\uD83C[\uDFFB-\uDFFF])?|[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD\uDDCF\uDDD4\uDDD6-\uDDDD](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDDDE\uDDDF](?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD0D\uDD0E\uDD10-\uDD17\uDD20-\uDD25\uDD27-\uDD2F\uDD3A\uDD3F-\uDD45\uDD47-\uDD76\uDD78-\uDDB4\uDDB7\uDDBA\uDDBC-\uDDCC\uDDD0\uDDE0-\uDDFF\uDE70-\uDE7C\uDE80-\uDE88\uDE90-\uDEBD\uDEBF-\uDEC2\uDECE-\uDEDB\uDEE0-\uDEE8]|\uDD3C(?:\u200D[\u2640\u2642]\uFE0F?|\uD83C[\uDFFB-\uDFFF])?|\uDDCE(?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D(?:[\u2640\u2642]\uFE0F?(?:\u200D\u27A1\uFE0F?)?|\u27A1\uFE0F?))?|\uDDD1(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1|\uDDD1\u200D\uD83E\uDDD2(?:\u200D\uD83E\uDDD2)?|\uDDD2(?:\u200D\uD83E\uDDD2)?))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFC-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFD-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFD\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFE]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?))?|\uDEF1(?:\uD83C(?:\uDFFB(?:\u200D\uD83E\uDEF2\uD83C[\uDFFC-\uDFFF])?|\uDFFC(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFD-\uDFFF])?|\uDFFD(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])?|\uDFFE(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFD\uDFFF])?|\uDFFF(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFE])?))?)/g;
    };
    // node_modules/get-east-asian-width/lookup.js
    function isFullWidth(x) {
        return x === 12288 || x >= 65281 && x <= 65376 || x >= 65504 && x <= 65510;
    }
    function isWide(x) {
        return x >= 4352 && x <= 4447 || x === 8986 || x === 8987 || x === 9001 || x === 9002 || x >= 9193 && x <= 9196 || x === 9200 || x === 9203 || x === 9725 || x === 9726 || x === 9748 || x === 9749 || x >= 9800 && x <= 9811 || x === 9855 || x === 9875 || x === 9889 || x === 9898 || x === 9899 || x === 9917 || x === 9918 || x === 9924 || x === 9925 || x === 9934 || x === 9940 || x === 9962 || x === 9970 || x === 9971 || x === 9973 || x === 9978 || x === 9981 || x === 9989 || x === 9994 || x === 9995 || x === 10024 || x === 10060 || x === 10062 || x >= 10067 && x <= 10069 || x === 10071 || x >= 10133 && x <= 10135 || x === 10160 || x === 10175 || x === 11035 || x === 11036 || x === 11088 || x === 11093 || x >= 11904 && x <= 11929 || x >= 11931 && x <= 12019 || x >= 12032 && x <= 12245 || x >= 12272 && x <= 12287 || x >= 12289 && x <= 12350 || x >= 12353 && x <= 12438 || x >= 12441 && x <= 12543 || x >= 12549 && x <= 12591 || x >= 12593 && x <= 12686 || x >= 12688 && x <= 12771 || x >= 12783 && x <= 12830 || x >= 12832 && x <= 12871 || x >= 12880 && x <= 19903 || x >= 19968 && x <= 42124 || x >= 42128 && x <= 42182 || x >= 43360 && x <= 43388 || x >= 44032 && x <= 55203 || x >= 63744 && x <= 64255 || x >= 65040 && x <= 65049 || x >= 65072 && x <= 65106 || x >= 65108 && x <= 65126 || x >= 65128 && x <= 65131 || x >= 94176 && x <= 94180 || x === 94192 || x === 94193 || x >= 94208 && x <= 100343 || x >= 100352 && x <= 101589 || x >= 101632 && x <= 101640 || x >= 110576 && x <= 110579 || x >= 110581 && x <= 110587 || x === 110589 || x === 110590 || x >= 110592 && x <= 110882 || x === 110898 || x >= 110928 && x <= 110930 || x === 110933 || x >= 110948 && x <= 110951 || x >= 110960 && x <= 111355 || x === 126980 || x === 127183 || x === 127374 || x >= 127377 && x <= 127386 || x >= 127488 && x <= 127490 || x >= 127504 && x <= 127547 || x >= 127552 && x <= 127560 || x === 127568 || x === 127569 || x >= 127584 && x <= 127589 || x >= 127744 && x <= 127776 || x >= 127789 && x <= 127797 || x >= 127799 && x <= 127868 || x >= 127870 && x <= 127891 || x >= 127904 && x <= 127946 || x >= 127951 && x <= 127955 || x >= 127968 && x <= 127984 || x === 127988 || x >= 127992 && x <= 128062 || x === 128064 || x >= 128066 && x <= 128252 || x >= 128255 && x <= 128317 || x >= 128331 && x <= 128334 || x >= 128336 && x <= 128359 || x === 128378 || x === 128405 || x === 128406 || x === 128420 || x >= 128507 && x <= 128591 || x >= 128640 && x <= 128709 || x === 128716 || x >= 128720 && x <= 128722 || x >= 128725 && x <= 128727 || x >= 128732 && x <= 128735 || x === 128747 || x === 128748 || x >= 128756 && x <= 128764 || x >= 128992 && x <= 129003 || x === 129008 || x >= 129292 && x <= 129338 || x >= 129340 && x <= 129349 || x >= 129351 && x <= 129535 || x >= 129648 && x <= 129660 || x >= 129664 && x <= 129672 || x >= 129680 && x <= 129725 || x >= 129727 && x <= 129733 || x >= 129742 && x <= 129755 || x >= 129760 && x <= 129768 || x >= 129776 && x <= 129784 || x >= 131072 && x <= 196605 || x >= 196608 && x <= 262141;
    }
    // node_modules/get-east-asian-width/index.js
    var _isNarrowWidth = (codePoint)=>!(isFullWidth(codePoint) || isWide(codePoint));
    // src/utils/get-string-width.js
    var notAsciiRegex = /[^\x20-\x7F]/u;
    function getStringWidth(text) {
        if (!text) return 0;
        if (!notAsciiRegex.test(text)) return text.length;
        text = text.replace(emoji_regex_default(), "  ");
        let width = 0;
        for (const character of text){
            const codePoint = character.codePointAt(0);
            if (codePoint <= 31 || codePoint >= 127 && codePoint <= 159) continue;
            if (codePoint >= 768 && codePoint <= 879) continue;
            width += _isNarrowWidth(codePoint) ? 1 : 2;
        }
        return width;
    }
    var get_string_width_default = getStringWidth;
    // src/document/utils.js
    function mapDoc(doc, cb) {
        if (typeof doc === "string") return cb(doc);
        const mapped = /* @__PURE__ */ new Map();
        return rec(doc);
        function rec(doc2) {
            if (mapped.has(doc2)) return mapped.get(doc2);
            const result = process2(doc2);
            mapped.set(doc2, result);
            return result;
        }
        function process2(doc2) {
            switch(get_doc_type_default(doc2)){
                case DOC_TYPE_ARRAY:
                    return cb(doc2.map(rec));
                case DOC_TYPE_FILL:
                    return cb({
                        ...doc2,
                        parts: doc2.parts.map(rec)
                    });
                case DOC_TYPE_IF_BREAK:
                    return cb({
                        ...doc2,
                        breakContents: rec(doc2.breakContents),
                        flatContents: rec(doc2.flatContents)
                    });
                case DOC_TYPE_GROUP:
                    {
                        let { expandedStates: expandedStates, contents: contents } = doc2;
                        if (expandedStates) {
                            expandedStates = expandedStates.map(rec);
                            contents = expandedStates[0];
                        } else contents = rec(contents);
                        return cb({
                            ...doc2,
                            contents: contents,
                            expandedStates: expandedStates
                        });
                    }
                case DOC_TYPE_ALIGN:
                case DOC_TYPE_INDENT:
                case DOC_TYPE_INDENT_IF_BREAK:
                case DOC_TYPE_LABEL:
                case DOC_TYPE_LINE_SUFFIX:
                    return cb({
                        ...doc2,
                        contents: rec(doc2.contents)
                    });
                case DOC_TYPE_STRING:
                case DOC_TYPE_CURSOR:
                case DOC_TYPE_TRIM:
                case DOC_TYPE_LINE_SUFFIX_BOUNDARY:
                case DOC_TYPE_LINE:
                case DOC_TYPE_BREAK_PARENT:
                    return cb(doc2);
                default:
                    throw new invalid_doc_error_default(doc2);
            }
        }
    }
    function findInDoc(doc, fn, defaultValue) {
        let result = defaultValue;
        let shouldSkipFurtherProcessing = false;
        function findInDocOnEnterFn(doc2) {
            if (shouldSkipFurtherProcessing) return false;
            const maybeResult = fn(doc2);
            if (maybeResult !== void 0) {
                shouldSkipFurtherProcessing = true;
                result = maybeResult;
            }
        }
        traverse_doc_default(doc, findInDocOnEnterFn);
        return result;
    }
    function willBreakFn(doc) {
        if (doc.type === DOC_TYPE_GROUP && doc.break) return true;
        if (doc.type === DOC_TYPE_LINE && doc.hard) return true;
        if (doc.type === DOC_TYPE_BREAK_PARENT) return true;
    }
    function willBreak(doc) {
        return findInDoc(doc, willBreakFn, false);
    }
    function breakParentGroup(groupStack) {
        if (groupStack.length > 0) {
            const parentGroup = at_default(/* isOptionalObject */ false, groupStack, -1);
            if (!parentGroup.expandedStates && !parentGroup.break) parentGroup.break = "propagated";
        }
        return null;
    }
    function propagateBreaks(doc) {
        const alreadyVisitedSet = /* @__PURE__ */ new Set();
        const groupStack = [];
        function propagateBreaksOnEnterFn(doc2) {
            if (doc2.type === DOC_TYPE_BREAK_PARENT) breakParentGroup(groupStack);
            if (doc2.type === DOC_TYPE_GROUP) {
                groupStack.push(doc2);
                if (alreadyVisitedSet.has(doc2)) return false;
                alreadyVisitedSet.add(doc2);
            }
        }
        function propagateBreaksOnExitFn(doc2) {
            if (doc2.type === DOC_TYPE_GROUP) {
                const group2 = groupStack.pop();
                if (group2.break) breakParentGroup(groupStack);
            }
        }
        traverse_doc_default(doc, propagateBreaksOnEnterFn, propagateBreaksOnExitFn, /* shouldTraverseConditionalGroups */ true);
    }
    function removeLinesFn(doc) {
        if (doc.type === DOC_TYPE_LINE && !doc.hard) return doc.soft ? "" : " ";
        if (doc.type === DOC_TYPE_IF_BREAK) return doc.flatContents;
        return doc;
    }
    function removeLines(doc) {
        return mapDoc(doc, removeLinesFn);
    }
    function stripTrailingHardlineFromParts(parts) {
        parts = [
            ...parts
        ];
        while(parts.length >= 2 && at_default(/* isOptionalObject */ false, parts, -2).type === DOC_TYPE_LINE && at_default(/* isOptionalObject */ false, parts, -1).type === DOC_TYPE_BREAK_PARENT)parts.length -= 2;
        if (parts.length > 0) {
            const lastPart = stripTrailingHardlineFromDoc(at_default(/* isOptionalObject */ false, parts, -1));
            parts[parts.length - 1] = lastPart;
        }
        return parts;
    }
    function stripTrailingHardlineFromDoc(doc) {
        switch(get_doc_type_default(doc)){
            case DOC_TYPE_INDENT:
            case DOC_TYPE_INDENT_IF_BREAK:
            case DOC_TYPE_GROUP:
            case DOC_TYPE_LINE_SUFFIX:
            case DOC_TYPE_LABEL:
                {
                    const contents = stripTrailingHardlineFromDoc(doc.contents);
                    return {
                        ...doc,
                        contents: contents
                    };
                }
            case DOC_TYPE_IF_BREAK:
                return {
                    ...doc,
                    breakContents: stripTrailingHardlineFromDoc(doc.breakContents),
                    flatContents: stripTrailingHardlineFromDoc(doc.flatContents)
                };
            case DOC_TYPE_FILL:
                return {
                    ...doc,
                    parts: stripTrailingHardlineFromParts(doc.parts)
                };
            case DOC_TYPE_ARRAY:
                return stripTrailingHardlineFromParts(doc);
            case DOC_TYPE_STRING:
                return doc.replace(/[\n\r]*$/u, "");
            case DOC_TYPE_ALIGN:
            case DOC_TYPE_CURSOR:
            case DOC_TYPE_TRIM:
            case DOC_TYPE_LINE_SUFFIX_BOUNDARY:
            case DOC_TYPE_LINE:
            case DOC_TYPE_BREAK_PARENT:
                break;
            default:
                throw new invalid_doc_error_default(doc);
        }
        return doc;
    }
    function stripTrailingHardline(doc) {
        return stripTrailingHardlineFromDoc(cleanDoc(doc));
    }
    function cleanDocFn(doc) {
        switch(get_doc_type_default(doc)){
            case DOC_TYPE_FILL:
                if (doc.parts.every((part)=>part === "")) return "";
                break;
            case DOC_TYPE_GROUP:
                if (!doc.contents && !doc.id && !doc.break && !doc.expandedStates) return "";
                if (doc.contents.type === DOC_TYPE_GROUP && doc.contents.id === doc.id && doc.contents.break === doc.break && doc.contents.expandedStates === doc.expandedStates) return doc.contents;
                break;
            case DOC_TYPE_ALIGN:
            case DOC_TYPE_INDENT:
            case DOC_TYPE_INDENT_IF_BREAK:
            case DOC_TYPE_LINE_SUFFIX:
                if (!doc.contents) return "";
                break;
            case DOC_TYPE_IF_BREAK:
                if (!doc.flatContents && !doc.breakContents) return "";
                break;
            case DOC_TYPE_ARRAY:
                {
                    const parts = [];
                    for (const part of doc){
                        if (!part) continue;
                        const [currentPart, ...restParts] = Array.isArray(part) ? part : [
                            part
                        ];
                        if (typeof currentPart === "string" && typeof at_default(/* isOptionalObject */ false, parts, -1) === "string") parts[parts.length - 1] += currentPart;
                        else parts.push(currentPart);
                        parts.push(...restParts);
                    }
                    if (parts.length === 0) return "";
                    if (parts.length === 1) return parts[0];
                    return parts;
                }
            case DOC_TYPE_STRING:
            case DOC_TYPE_CURSOR:
            case DOC_TYPE_TRIM:
            case DOC_TYPE_LINE_SUFFIX_BOUNDARY:
            case DOC_TYPE_LINE:
            case DOC_TYPE_LABEL:
            case DOC_TYPE_BREAK_PARENT:
                break;
            default:
                throw new invalid_doc_error_default(doc);
        }
        return doc;
    }
    function cleanDoc(doc) {
        return mapDoc(doc, (currentDoc)=>cleanDocFn(currentDoc));
    }
    function replaceEndOfLine(doc, replacement = literalline) {
        return mapDoc(doc, (currentDoc)=>typeof currentDoc === "string" ? join(replacement, currentDoc.split("\n")) : currentDoc);
    }
    function canBreakFn(doc) {
        if (doc.type === DOC_TYPE_LINE) return true;
    }
    function canBreak(doc) {
        return findInDoc(doc, canBreakFn, false);
    }
    // src/document/printer.js
    var MODE_BREAK = Symbol("MODE_BREAK");
    var MODE_FLAT = Symbol("MODE_FLAT");
    var CURSOR_PLACEHOLDER = Symbol("cursor");
    function rootIndent() {
        return {
            value: "",
            length: 0,
            queue: []
        };
    }
    function makeIndent(ind, options) {
        return generateInd(ind, {
            type: "indent"
        }, options);
    }
    function makeAlign(indent2, widthOrDoc, options) {
        if (widthOrDoc === Number.NEGATIVE_INFINITY) return indent2.root || rootIndent();
        if (widthOrDoc < 0) return generateInd(indent2, {
            type: "dedent"
        }, options);
        if (!widthOrDoc) return indent2;
        if (widthOrDoc.type === "root") return {
            ...indent2,
            root: indent2
        };
        const alignType = typeof widthOrDoc === "string" ? "stringAlign" : "numberAlign";
        return generateInd(indent2, {
            type: alignType,
            n: widthOrDoc
        }, options);
    }
    function generateInd(ind, newPart, options) {
        const queue = newPart.type === "dedent" ? ind.queue.slice(0, -1) : [
            ...ind.queue,
            newPart
        ];
        let value = "";
        let length = 0;
        let lastTabs = 0;
        let lastSpaces = 0;
        for (const part of queue)switch(part.type){
            case "indent":
                flush();
                if (options.useTabs) addTabs(1);
                else addSpaces(options.tabWidth);
                break;
            case "stringAlign":
                flush();
                value += part.n;
                length += part.n.length;
                break;
            case "numberAlign":
                lastTabs += 1;
                lastSpaces += part.n;
                break;
            default:
                throw new Error(`Unexpected type '${part.type}'`);
        }
        flushSpaces();
        return {
            ...ind,
            value: value,
            length: length,
            queue: queue
        };
        function addTabs(count) {
            value += "	".repeat(count);
            length += options.tabWidth * count;
        }
        function addSpaces(count) {
            value += " ".repeat(count);
            length += count;
        }
        function flush() {
            if (options.useTabs) flushTabs();
            else flushSpaces();
        }
        function flushTabs() {
            if (lastTabs > 0) addTabs(lastTabs);
            resetLast();
        }
        function flushSpaces() {
            if (lastSpaces > 0) addSpaces(lastSpaces);
            resetLast();
        }
        function resetLast() {
            lastTabs = 0;
            lastSpaces = 0;
        }
    }
    function trim2(out) {
        let trimCount = 0;
        let cursorCount = 0;
        let outIndex = out.length;
        outer: while(outIndex--){
            const last = out[outIndex];
            if (last === CURSOR_PLACEHOLDER) {
                cursorCount++;
                continue;
            }
            for(let charIndex = last.length - 1; charIndex >= 0; charIndex--){
                const char = last[charIndex];
                if (char === " " || char === "	") trimCount++;
                else {
                    out[outIndex] = last.slice(0, charIndex + 1);
                    break outer;
                }
            }
        }
        if (trimCount > 0 || cursorCount > 0) {
            out.length = outIndex + 1;
            while(cursorCount-- > 0)out.push(CURSOR_PLACEHOLDER);
        }
        return trimCount;
    }
    function fits(next, restCommands, width, hasLineSuffix, groupModeMap, mustBeFlat) {
        if (width === Number.POSITIVE_INFINITY) return true;
        let restIdx = restCommands.length;
        const cmds = [
            next
        ];
        const out = [];
        while(width >= 0){
            if (cmds.length === 0) {
                if (restIdx === 0) return true;
                cmds.push(restCommands[--restIdx]);
                continue;
            }
            const { mode: mode, doc: doc } = cmds.pop();
            const docType = get_doc_type_default(doc);
            switch(docType){
                case DOC_TYPE_STRING:
                    out.push(doc);
                    width -= get_string_width_default(doc);
                    break;
                case DOC_TYPE_ARRAY:
                case DOC_TYPE_FILL:
                    {
                        const parts = docType === DOC_TYPE_ARRAY ? doc : doc.parts;
                        for(let i = parts.length - 1; i >= 0; i--)cmds.push({
                            mode: mode,
                            doc: parts[i]
                        });
                        break;
                    }
                case DOC_TYPE_INDENT:
                case DOC_TYPE_ALIGN:
                case DOC_TYPE_INDENT_IF_BREAK:
                case DOC_TYPE_LABEL:
                    cmds.push({
                        mode: mode,
                        doc: doc.contents
                    });
                    break;
                case DOC_TYPE_TRIM:
                    width += trim2(out);
                    break;
                case DOC_TYPE_GROUP:
                    {
                        if (mustBeFlat && doc.break) return false;
                        const groupMode = doc.break ? MODE_BREAK : mode;
                        const contents = doc.expandedStates && groupMode === MODE_BREAK ? at_default(/* isOptionalObject */ false, doc.expandedStates, -1) : doc.contents;
                        cmds.push({
                            mode: groupMode,
                            doc: contents
                        });
                        break;
                    }
                case DOC_TYPE_IF_BREAK:
                    {
                        const groupMode = doc.groupId ? groupModeMap[doc.groupId] || MODE_FLAT : mode;
                        const contents = groupMode === MODE_BREAK ? doc.breakContents : doc.flatContents;
                        if (contents) cmds.push({
                            mode: mode,
                            doc: contents
                        });
                        break;
                    }
                case DOC_TYPE_LINE:
                    if (mode === MODE_BREAK || doc.hard) return true;
                    if (!doc.soft) {
                        out.push(" ");
                        width--;
                    }
                    break;
                case DOC_TYPE_LINE_SUFFIX:
                    hasLineSuffix = true;
                    break;
                case DOC_TYPE_LINE_SUFFIX_BOUNDARY:
                    if (hasLineSuffix) return false;
                    break;
            }
        }
        return false;
    }
    function printDocToString(doc, options) {
        const groupModeMap = {};
        const width = options.printWidth;
        const newLine = convertEndOfLineToChars(options.endOfLine);
        let pos = 0;
        const cmds = [
            {
                ind: rootIndent(),
                mode: MODE_BREAK,
                doc: doc
            }
        ];
        const out = [];
        let shouldRemeasure = false;
        const lineSuffix2 = [];
        let printedCursorCount = 0;
        propagateBreaks(doc);
        while(cmds.length > 0){
            const { ind: ind, mode: mode, doc: doc2 } = cmds.pop();
            switch(get_doc_type_default(doc2)){
                case DOC_TYPE_STRING:
                    {
                        const formatted = newLine !== "\n" ? string_replace_all_default(/* isOptionalObject */ false, doc2, "\n", newLine) : doc2;
                        out.push(formatted);
                        if (cmds.length > 0) pos += get_string_width_default(formatted);
                        break;
                    }
                case DOC_TYPE_ARRAY:
                    for(let i = doc2.length - 1; i >= 0; i--)cmds.push({
                        ind: ind,
                        mode: mode,
                        doc: doc2[i]
                    });
                    break;
                case DOC_TYPE_CURSOR:
                    if (printedCursorCount >= 2) throw new Error("There are too many 'cursor' in doc.");
                    out.push(CURSOR_PLACEHOLDER);
                    printedCursorCount++;
                    break;
                case DOC_TYPE_INDENT:
                    cmds.push({
                        ind: makeIndent(ind, options),
                        mode: mode,
                        doc: doc2.contents
                    });
                    break;
                case DOC_TYPE_ALIGN:
                    cmds.push({
                        ind: makeAlign(ind, doc2.n, options),
                        mode: mode,
                        doc: doc2.contents
                    });
                    break;
                case DOC_TYPE_TRIM:
                    pos -= trim2(out);
                    break;
                case DOC_TYPE_GROUP:
                    switch(mode){
                        case MODE_FLAT:
                            if (!shouldRemeasure) {
                                cmds.push({
                                    ind: ind,
                                    mode: doc2.break ? MODE_BREAK : MODE_FLAT,
                                    doc: doc2.contents
                                });
                                break;
                            }
                        case MODE_BREAK:
                            {
                                shouldRemeasure = false;
                                const next = {
                                    ind: ind,
                                    mode: MODE_FLAT,
                                    doc: doc2.contents
                                };
                                const rem = width - pos;
                                const hasLineSuffix = lineSuffix2.length > 0;
                                if (!doc2.break && fits(next, cmds, rem, hasLineSuffix, groupModeMap)) cmds.push(next);
                                else if (doc2.expandedStates) {
                                    const mostExpanded = at_default(/* isOptionalObject */ false, doc2.expandedStates, -1);
                                    if (doc2.break) {
                                        cmds.push({
                                            ind: ind,
                                            mode: MODE_BREAK,
                                            doc: mostExpanded
                                        });
                                        break;
                                    } else {
                                        for(let i = 1; i < doc2.expandedStates.length + 1; i++)if (i >= doc2.expandedStates.length) {
                                            cmds.push({
                                                ind: ind,
                                                mode: MODE_BREAK,
                                                doc: mostExpanded
                                            });
                                            break;
                                        } else {
                                            const state = doc2.expandedStates[i];
                                            const cmd = {
                                                ind: ind,
                                                mode: MODE_FLAT,
                                                doc: state
                                            };
                                            if (fits(cmd, cmds, rem, hasLineSuffix, groupModeMap)) {
                                                cmds.push(cmd);
                                                break;
                                            }
                                        }
                                    }
                                } else cmds.push({
                                    ind: ind,
                                    mode: MODE_BREAK,
                                    doc: doc2.contents
                                });
                                break;
                            }
                    }
                    if (doc2.id) groupModeMap[doc2.id] = at_default(/* isOptionalObject */ false, cmds, -1).mode;
                    break;
                case DOC_TYPE_FILL:
                    {
                        const rem = width - pos;
                        const { parts: parts } = doc2;
                        if (parts.length === 0) break;
                        const [content, whitespace] = parts;
                        const contentFlatCmd = {
                            ind: ind,
                            mode: MODE_FLAT,
                            doc: content
                        };
                        const contentBreakCmd = {
                            ind: ind,
                            mode: MODE_BREAK,
                            doc: content
                        };
                        const contentFits = fits(contentFlatCmd, [], rem, lineSuffix2.length > 0, groupModeMap, true);
                        if (parts.length === 1) {
                            if (contentFits) cmds.push(contentFlatCmd);
                            else cmds.push(contentBreakCmd);
                            break;
                        }
                        const whitespaceFlatCmd = {
                            ind: ind,
                            mode: MODE_FLAT,
                            doc: whitespace
                        };
                        const whitespaceBreakCmd = {
                            ind: ind,
                            mode: MODE_BREAK,
                            doc: whitespace
                        };
                        if (parts.length === 2) {
                            if (contentFits) cmds.push(whitespaceFlatCmd, contentFlatCmd);
                            else cmds.push(whitespaceBreakCmd, contentBreakCmd);
                            break;
                        }
                        parts.splice(0, 2);
                        const remainingCmd = {
                            ind: ind,
                            mode: mode,
                            doc: fill(parts)
                        };
                        const secondContent = parts[0];
                        const firstAndSecondContentFlatCmd = {
                            ind: ind,
                            mode: MODE_FLAT,
                            doc: [
                                content,
                                whitespace,
                                secondContent
                            ]
                        };
                        const firstAndSecondContentFits = fits(firstAndSecondContentFlatCmd, [], rem, lineSuffix2.length > 0, groupModeMap, true);
                        if (firstAndSecondContentFits) cmds.push(remainingCmd, whitespaceFlatCmd, contentFlatCmd);
                        else if (contentFits) cmds.push(remainingCmd, whitespaceBreakCmd, contentFlatCmd);
                        else cmds.push(remainingCmd, whitespaceBreakCmd, contentBreakCmd);
                        break;
                    }
                case DOC_TYPE_IF_BREAK:
                case DOC_TYPE_INDENT_IF_BREAK:
                    {
                        const groupMode = doc2.groupId ? groupModeMap[doc2.groupId] : mode;
                        if (groupMode === MODE_BREAK) {
                            const breakContents = doc2.type === DOC_TYPE_IF_BREAK ? doc2.breakContents : doc2.negate ? doc2.contents : indent(doc2.contents);
                            if (breakContents) cmds.push({
                                ind: ind,
                                mode: mode,
                                doc: breakContents
                            });
                        }
                        if (groupMode === MODE_FLAT) {
                            const flatContents = doc2.type === DOC_TYPE_IF_BREAK ? doc2.flatContents : doc2.negate ? indent(doc2.contents) : doc2.contents;
                            if (flatContents) cmds.push({
                                ind: ind,
                                mode: mode,
                                doc: flatContents
                            });
                        }
                        break;
                    }
                case DOC_TYPE_LINE_SUFFIX:
                    lineSuffix2.push({
                        ind: ind,
                        mode: mode,
                        doc: doc2.contents
                    });
                    break;
                case DOC_TYPE_LINE_SUFFIX_BOUNDARY:
                    if (lineSuffix2.length > 0) cmds.push({
                        ind: ind,
                        mode: mode,
                        doc: hardlineWithoutBreakParent
                    });
                    break;
                case DOC_TYPE_LINE:
                    switch(mode){
                        case MODE_FLAT:
                            if (!doc2.hard) {
                                if (!doc2.soft) {
                                    out.push(" ");
                                    pos += 1;
                                }
                                break;
                            } else shouldRemeasure = true;
                        case MODE_BREAK:
                            if (lineSuffix2.length > 0) {
                                cmds.push({
                                    ind: ind,
                                    mode: mode,
                                    doc: doc2
                                }, ...lineSuffix2.reverse());
                                lineSuffix2.length = 0;
                                break;
                            }
                            if (doc2.literal) {
                                if (ind.root) {
                                    out.push(newLine, ind.root.value);
                                    pos = ind.root.length;
                                } else {
                                    out.push(newLine);
                                    pos = 0;
                                }
                            } else {
                                pos -= trim2(out);
                                out.push(newLine + ind.value);
                                pos = ind.length;
                            }
                            break;
                    }
                    break;
                case DOC_TYPE_LABEL:
                    cmds.push({
                        ind: ind,
                        mode: mode,
                        doc: doc2.contents
                    });
                    break;
                case DOC_TYPE_BREAK_PARENT:
                    break;
                default:
                    throw new invalid_doc_error_default(doc2);
            }
            if (cmds.length === 0 && lineSuffix2.length > 0) {
                cmds.push(...lineSuffix2.reverse());
                lineSuffix2.length = 0;
            }
        }
        const cursorPlaceholderIndex = out.indexOf(CURSOR_PLACEHOLDER);
        if (cursorPlaceholderIndex !== -1) {
            const otherCursorPlaceholderIndex = out.indexOf(CURSOR_PLACEHOLDER, cursorPlaceholderIndex + 1);
            const beforeCursor = out.slice(0, cursorPlaceholderIndex).join("");
            const aroundCursor = out.slice(cursorPlaceholderIndex + 1, otherCursorPlaceholderIndex).join("");
            const afterCursor = out.slice(otherCursorPlaceholderIndex + 1).join("");
            return {
                formatted: beforeCursor + aroundCursor + afterCursor,
                cursorNodeStart: beforeCursor.length,
                cursorNodeText: aroundCursor
            };
        }
        return {
            formatted: out.join("")
        };
    }
    // src/document/public.js
    var builders = {
        join: join,
        line: line,
        softline: softline,
        hardline: hardline,
        literalline: literalline,
        group: group,
        conditionalGroup: conditionalGroup,
        fill: fill,
        lineSuffix: lineSuffix,
        lineSuffixBoundary: lineSuffixBoundary,
        cursor: cursor,
        breakParent: breakParent,
        ifBreak: ifBreak,
        trim: trim,
        indent: indent,
        indentIfBreak: indentIfBreak,
        align: align,
        addAlignmentToDoc: addAlignmentToDoc,
        markAsRoot: markAsRoot,
        dedentToRoot: dedentToRoot,
        dedent: dedent,
        hardlineWithoutBreakParent: hardlineWithoutBreakParent,
        literallineWithoutBreakParent: literallineWithoutBreakParent,
        label: label,
        // TODO: Remove this in v4
        concat: (parts)=>parts
    };
    var printer = {
        printDocToString: printDocToString
    };
    var utils = {
        willBreak: willBreak,
        traverseDoc: traverse_doc_default,
        findInDoc: findInDoc,
        mapDoc: mapDoc,
        removeLines: removeLines,
        stripTrailingHardline: stripTrailingHardline,
        replaceEndOfLine: replaceEndOfLine,
        canBreak: canBreak
    };
    return __toCommonJS(public_exports);
});



const { dedentToRoot: $e73259e3ae8a21b4$var$dedentToRoot, group: $e73259e3ae8a21b4$var$group, hardline: $e73259e3ae8a21b4$var$hardline, indent: $e73259e3ae8a21b4$var$indent, join: $e73259e3ae8a21b4$var$join, line: $e73259e3ae8a21b4$var$line, literalline: $e73259e3ae8a21b4$var$literalline, softline: $e73259e3ae8a21b4$var$softline } = $f14f3ea561049322$exports.builders;
// Get the start and end element tags from the current node on the tree
function $e73259e3ae8a21b4$var$getElementTags(path, opts, print) {
    const node = path.getValue();
    const { OPEN: OPEN, Name: Name, attribute: attribute, START_CLOSE: START_CLOSE, SLASH_OPEN: SLASH_OPEN, END_NAME: END_NAME, END: END } = node;
    const parts = [
        OPEN,
        Name
    ];
    if (attribute.length > 0) parts.push($e73259e3ae8a21b4$var$indent([
        $e73259e3ae8a21b4$var$line,
        $e73259e3ae8a21b4$var$join($e73259e3ae8a21b4$var$line, path.map(print, "attribute"))
    ]));
    if (!opts.bracketSameLine) parts.push($e73259e3ae8a21b4$var$softline);
    return {
        openTag: $e73259e3ae8a21b4$var$group([
            ...parts,
            START_CLOSE
        ]),
        closeTag: $e73259e3ae8a21b4$var$group([
            SLASH_OPEN,
            END_NAME,
            END
        ])
    };
}
// Returns the value of the type tag if there is one, otherwise returns null.
function $e73259e3ae8a21b4$var$getTagType(attributes) {
    for (const attribute of attributes)if (attribute.Name === "type") {
        const value = attribute.STRING;
        if (value.startsWith('"text/') && value.endsWith('"')) return value.slice(6, -1);
    }
    return null;
}
// Get the name of the parser that is represented by the given element node,
// return null if a matching parser cannot be found
function $e73259e3ae8a21b4$var$getParser(node, opts) {
    const { Name: Name, attribute: attribute } = node;
    let parser = Name.toLowerCase();
    // We don't want to deal with some weird recursive parser situation, so we
    // need to explicitly call out the XML parser here and just return null
    if (parser === "xml") return null;
    // If this is a style tag or a script tag with a text/xxx type then we will
    // use xxx as the name of the parser
    if ((parser === "style" || parser === "script") && attribute.length > 0) parser = $e73259e3ae8a21b4$var$getTagType(attribute);
    // If the name of the parser is "javascript", then we're going to switch over
    // to the babel parser.
    if (parser === "javascript") parser = "babel";
    // If there is a plugin that has a parser that matches the name of this
    // element, then we're going to assume that's correct for embedding and go
    // ahead and switch to that parser
    if (opts.plugins.some((plugin)=>typeof plugin !== "string" && plugin.parsers && Object.prototype.hasOwnProperty.call(plugin.parsers, parser))) return parser;
    return null;
}
// Get the source string that will be passed into the embedded parser from the
// content of the inside of the element node
function $e73259e3ae8a21b4$var$getSource(content) {
    return content.chardata.map((node)=>{
        const { SEA_WS: SEA_WS, TEXT: TEXT } = node;
        const image = SEA_WS || TEXT;
        return {
            offset: node.location.startOffset,
            printed: image
        };
    }).sort(({ offset: offset })=>offset).map(({ printed: printed })=>printed).join("");
}
function $e73259e3ae8a21b4$var$embed(path, opts) {
    const node = path.getValue();
    // If the node isn't an element node, then skip
    if (node.name !== "element") return;
    // If the name of the node does not correspond to the name of a parser that
    // prettier knows about, then skip
    const parser = $e73259e3ae8a21b4$var$getParser(node, opts);
    if (!parser) return;
    // If the node is self-closing, then skip
    if (!node.content) return;
    // If the node does not actually contain content, or it contains any content
    // that is not just plain text, then skip.
    const content = node.content;
    if (content.chardata.length === 0 || content.CData.length > 0 || content.Comment.length > 0 || content.element.length > 0 || content.PROCESSING_INSTRUCTION.length > 0 || content.reference.length > 0) return;
    return async function(textToDoc, print) {
        // Get the open and close tags of this element, then return the properly
        // formatted content enclosed within them
        const { openTag: openTag, closeTag: closeTag } = $e73259e3ae8a21b4$var$getElementTags(path, opts, print);
        const docNode = await textToDoc($e73259e3ae8a21b4$var$getSource(content), {
            parser: parser
        });
        return $e73259e3ae8a21b4$var$group([
            openTag,
            $e73259e3ae8a21b4$var$literalline,
            $e73259e3ae8a21b4$var$dedentToRoot($f14f3ea561049322$exports.utils.replaceEndOfLine(docNode)),
            $e73259e3ae8a21b4$var$hardline,
            closeTag
        ]);
    };
}
var $e73259e3ae8a21b4$export$2e2bcd8739ae039 = $e73259e3ae8a21b4$var$embed;


const { fill: $e1913a02d16fc190$var$fill, group: $e1913a02d16fc190$var$group, hardline: $e1913a02d16fc190$var$hardline, indent: $e1913a02d16fc190$var$indent, join: $e1913a02d16fc190$var$join, line: $e1913a02d16fc190$var$line, literalline: $e1913a02d16fc190$var$literalline, softline: $e1913a02d16fc190$var$softline } = $f14f3ea561049322$exports.builders;
const $e1913a02d16fc190$var$ignoreStartComment = "<!-- prettier-ignore-start -->";
const $e1913a02d16fc190$var$ignoreEndComment = "<!-- prettier-ignore-end -->";
function $e1913a02d16fc190$var$hasIgnoreRanges(comments) {
    if (comments.length === 0) return false;
    comments.sort((left, right)=>left.startOffset - right.startOffset);
    let startFound = false;
    for(let idx = 0; idx < comments.length; idx += 1){
        if (comments[idx].image === $e1913a02d16fc190$var$ignoreStartComment) startFound = true;
        else if (startFound && comments[idx].image === $e1913a02d16fc190$var$ignoreEndComment) return true;
    }
    return false;
}
function $e1913a02d16fc190$var$isWhitespaceIgnorable(opts, name, attributes, content) {
    // If the whitespace sensitivity setting is "strict", then we can't ignore the
    // whitespace.
    if (opts.xmlWhitespaceSensitivity === "strict") return false;
    // If we have an xsl:text element, then we cannot ignore the whitespace.
    if (name === "xsl:text") return false;
    // If there is an xml:space attribute set to "preserve", then we can't ignore
    // the whitespace.
    if (attributes.some((attribute)=>attribute && attribute.Name === "xml:space" && attribute.STRING.slice(1, -1) === "preserve")) return false;
    // If there are character data nodes in the content, then we can't ignore the
    // whitespace.
    if (content.CData.length > 0) return false;
    // If there are comments in the content and the comments are ignore ranges,
    // then we can't ignore the whitespace.
    if ($e1913a02d16fc190$var$hasIgnoreRanges(content.Comment)) return false;
    // Otherwise we can.
    return true;
}
function $e1913a02d16fc190$var$printIToken(path) {
    const node = path.getValue();
    return {
        offset: node.startOffset,
        startLine: node.startLine,
        endLine: node.endLine,
        printed: node.image
    };
}
function $e1913a02d16fc190$var$printAttribute(path, opts, print) {
    const { Name: Name, EQUALS: EQUALS, STRING: STRING } = path.getValue();
    let attributeValue;
    if (opts.xmlQuoteAttributes === "double") {
        const content = STRING.slice(1, -1).replaceAll('"', "&quot;");
        attributeValue = `"${content}"`;
    } else if (opts.xmlQuoteAttributes === "single") {
        const content = STRING.slice(1, -1).replaceAll("'", "&apos;");
        attributeValue = `'${content}'`;
    } else // preserve
    attributeValue = STRING;
    return [
        Name,
        EQUALS,
        attributeValue
    ];
}
function $e1913a02d16fc190$var$printCharData(path, opts, print) {
    const { SEA_WS: SEA_WS, TEXT: TEXT } = path.getValue();
    const image = SEA_WS || TEXT;
    return image.split(/(\n)/g).map((value, index)=>index % 2 === 0 ? value : $e1913a02d16fc190$var$literalline);
}
function $e1913a02d16fc190$var$printContentFragments(path, print) {
    return [
        ...path.map($e1913a02d16fc190$var$printIToken, "CData"),
        ...path.map($e1913a02d16fc190$var$printIToken, "Comment"),
        ...path.map((charDataPath)=>({
                offset: charDataPath.getValue().location.startOffset,
                printed: print(charDataPath)
            }), "chardata"),
        ...path.map((elementPath)=>({
                offset: elementPath.getValue().location.startOffset,
                printed: print(elementPath)
            }), "element"),
        ...path.map($e1913a02d16fc190$var$printIToken, "PROCESSING_INSTRUCTION"),
        ...path.map((referencePath)=>{
            const referenceNode = referencePath.getValue();
            return {
                offset: referenceNode.location.startOffset,
                printed: print(referencePath)
            };
        }, "reference")
    ];
}
function $e1913a02d16fc190$var$printContent(path, opts, print) {
    let fragments = $e1913a02d16fc190$var$printContentFragments(path, print);
    const { Comment: Comment } = path.getValue();
    if ($e1913a02d16fc190$var$hasIgnoreRanges(Comment)) {
        Comment.sort((left, right)=>left.startOffset - right.startOffset);
        const ignoreRanges = [];
        let ignoreStart = null;
        // Build up a list of ignored ranges from the original text based on
        // the special prettier-ignore-* comments
        Comment.forEach((comment)=>{
            if (comment.image === $e1913a02d16fc190$var$ignoreStartComment) ignoreStart = comment;
            else if (ignoreStart && comment.image === $e1913a02d16fc190$var$ignoreEndComment) {
                ignoreRanges.push({
                    start: ignoreStart.startOffset,
                    end: comment.endOffset
                });
                ignoreStart = null;
            }
        });
        // Filter the printed children to only include the ones that are
        // outside of each of the ignored ranges
        fragments = fragments.filter((fragment)=>ignoreRanges.every(({ start: start, end: end })=>fragment.offset < start || fragment.offset > end));
        // Push each of the ignored ranges into the child list as its own
        // element so that the original content is still included
        ignoreRanges.forEach(({ start: start, end: end })=>{
            const content = opts.originalText.slice(start, end + 1);
            fragments.push({
                offset: start,
                printed: $f14f3ea561049322$exports.utils.replaceEndOfLine(content)
            });
        });
    }
    fragments.sort((left, right)=>left.offset - right.offset);
    return $e1913a02d16fc190$var$group(fragments.map(({ printed: printed })=>printed));
}
function $e1913a02d16fc190$var$printDocTypeDecl(path, opts, print) {
    const { DocType: DocType, Name: Name, externalID: externalID, CLOSE: CLOSE } = path.getValue();
    const parts = [
        DocType,
        " ",
        Name
    ];
    if (externalID) parts.push(" ", path.call(print, "externalID"));
    return $e1913a02d16fc190$var$group([
        ...parts,
        CLOSE
    ]);
}
function $e1913a02d16fc190$var$printDocument(path, opts, print) {
    const { docTypeDecl: docTypeDecl, element: element, misc: misc, prolog: prolog } = path.getValue();
    const fragments = [];
    if (docTypeDecl) fragments.push({
        offset: docTypeDecl.location.startOffset,
        printed: path.call(print, "docTypeDecl")
    });
    if (prolog) fragments.push({
        offset: prolog.location.startOffset,
        printed: path.call(print, "prolog")
    });
    path.each((miscPath)=>{
        const misc = miscPath.getValue();
        fragments.push({
            offset: misc.location.startOffset,
            printed: print(miscPath)
        });
    }, "misc");
    if (element) fragments.push({
        offset: element.location.startOffset,
        printed: path.call(print, "element")
    });
    fragments.sort((left, right)=>left.offset - right.offset);
    return [
        $e1913a02d16fc190$var$join($e1913a02d16fc190$var$hardline, fragments.map(({ printed: printed })=>printed)),
        $e1913a02d16fc190$var$hardline
    ];
}
function $e1913a02d16fc190$var$printCharDataPreserve(path, print) {
    let prevLocation;
    const response = [];
    path.each((charDataPath)=>{
        const chardata = charDataPath.getValue();
        const location = chardata.location;
        const content = print(charDataPath);
        if (prevLocation && location.startColumn && prevLocation.endColumn && location.startLine === prevLocation.endLine && location.startColumn === prevLocation.endColumn + 1) {
            // continuation of previous fragment
            const prevFragment = response[response.length - 1];
            prevFragment.endLine = location.endLine;
            prevFragment.printed = $e1913a02d16fc190$var$group([
                prevFragment.printed,
                content
            ]);
        } else response.push({
            offset: location.startOffset,
            startLine: location.startLine,
            endLine: location.endLine,
            printed: content,
            whitespace: true
        });
        prevLocation = location;
    }, "chardata");
    return response;
}
function $e1913a02d16fc190$var$printCharDataIgnore(path) {
    const response = [];
    path.each((charDataPath)=>{
        const chardata = charDataPath.getValue();
        if (!chardata.TEXT) return;
        const content = chardata.TEXT.replaceAll(/^[\t\n\r\s]+|[\t\n\r\s]+$/g, "");
        const printed = $e1913a02d16fc190$var$group(content.split(/(\n)/g).map((value)=>{
            if (value === "\n") return $e1913a02d16fc190$var$literalline;
            return $e1913a02d16fc190$var$fill(value.split(/\b( +)\b/g).map((segment, index)=>index % 2 === 0 ? segment : $e1913a02d16fc190$var$line));
        }));
        const location = chardata.location;
        response.push({
            offset: location.startOffset,
            startLine: location.startLine,
            endLine: location.endLine,
            printed: printed
        });
    }, "chardata");
    return response;
}
function $e1913a02d16fc190$var$printElementFragments(path, opts, print) {
    const children = path.getValue();
    let response = [];
    response = response.concat(path.map($e1913a02d16fc190$var$printIToken, "Comment"));
    if (children.chardata.length > 0) {
        if (children.chardata.some((chardata)=>!!chardata.TEXT) && opts.xmlWhitespaceSensitivity === "preserve") response = response.concat($e1913a02d16fc190$var$printCharDataPreserve(path, print));
        else response = response.concat($e1913a02d16fc190$var$printCharDataIgnore(path, print));
    }
    response = response.concat(path.map((elementPath)=>{
        const location = elementPath.getValue().location;
        return {
            offset: location.startOffset,
            startLine: location.startLine,
            endLine: location.endLine,
            printed: print(elementPath)
        };
    }, "element"));
    response = response.concat(path.map($e1913a02d16fc190$var$printIToken, "PROCESSING_INSTRUCTION"));
    response = response.concat(path.map((referencePath)=>{
        const referenceNode = referencePath.getValue();
        return {
            type: "reference",
            offset: referenceNode.location.startOffset,
            startLine: referenceNode.location.startLine,
            endLine: referenceNode.location.endLine,
            printed: print(referencePath)
        };
    }, "reference"));
    return response;
}
function $e1913a02d16fc190$var$printElement(path, opts, print) {
    const { OPEN: OPEN, Name: Name, attribute: attribute, START_CLOSE: START_CLOSE, content: content, SLASH_OPEN: SLASH_OPEN, END_NAME: END_NAME, END: END, SLASH_CLOSE: SLASH_CLOSE } = path.getValue();
    const parts = [
        OPEN,
        Name
    ];
    if (attribute.length > 0) {
        const attributes = path.map((attributePath)=>({
                node: attributePath.getValue(),
                printed: print(attributePath)
            }), "attribute");
        if (opts.xmlSortAttributesByKey) attributes.sort((left, right)=>{
            const leftAttr = left.node.Name;
            const rightAttr = right.node.Name;
            // Check if the attributes are xmlns.
            if (leftAttr === "xmlns") return -1;
            if (rightAttr === "xmlns") return 1;
            // Check if they are both in namespaces.
            if (leftAttr.includes(":") && rightAttr.includes(":")) {
                const [leftNS, leftKey] = leftAttr.split(":");
                const [rightNS, rightKey] = rightAttr.split(":");
                // If namespaces are equal, compare keys
                if (leftNS === rightNS) return leftKey.localeCompare(rightKey);
                // Handle the 1 but not both being an xmlns
                if (leftNS === "xmlns") return -1;
                if (rightNS === "xmlns") return 1;
                return leftNS.localeCompare(rightNS);
            }
            // Check if the attributes have namespaces.
            if (leftAttr.includes(":")) return -1;
            if (rightAttr.includes(":")) return 1;
            return leftAttr.localeCompare(rightAttr);
        });
        const separator = opts.singleAttributePerLine ? $e1913a02d16fc190$var$hardline : $e1913a02d16fc190$var$line;
        parts.push($e1913a02d16fc190$var$indent([
            $e1913a02d16fc190$var$line,
            $e1913a02d16fc190$var$join(separator, attributes.map(({ printed: printed })=>printed))
        ]));
    }
    // Determine the value that will go between the <, name, and attributes
    // of an element and the /> of an element.
    let space;
    if (opts.bracketSameLine) space = opts.xmlSelfClosingSpace ? " " : "";
    else space = opts.xmlSelfClosingSpace ? $e1913a02d16fc190$var$line : $e1913a02d16fc190$var$softline;
    if (SLASH_CLOSE) return $e1913a02d16fc190$var$group([
        ...parts,
        space,
        SLASH_CLOSE
    ]);
    if (content.chardata.length === 0 && content.CData.length === 0 && content.Comment.length === 0 && content.element.length === 0 && content.PROCESSING_INSTRUCTION.length === 0 && content.reference.length === 0) return $e1913a02d16fc190$var$group([
        ...parts,
        space,
        "/>"
    ]);
    const openTag = $e1913a02d16fc190$var$group([
        ...parts,
        opts.bracketSameLine ? "" : $e1913a02d16fc190$var$softline,
        START_CLOSE
    ]);
    const closeTag = $e1913a02d16fc190$var$group([
        SLASH_OPEN,
        END_NAME,
        END
    ]);
    if ($e1913a02d16fc190$var$isWhitespaceIgnorable(opts, Name, attribute, content)) {
        const fragments = path.call((childrenPath)=>$e1913a02d16fc190$var$printElementFragments(childrenPath, opts, print), "content");
        fragments.sort((left, right)=>left.offset - right.offset);
        if (opts.xmlWhitespaceSensitivity === "preserve" && fragments.some(({ whitespace: whitespace })=>whitespace)) return $e1913a02d16fc190$var$group([
            openTag,
            fragments.map(({ printed: printed })=>printed),
            closeTag
        ]);
        if (fragments.length === 0) return $e1913a02d16fc190$var$group([
            ...parts,
            space,
            "/>"
        ]);
        // If the only content of this tag is chardata, then use a softline so
        // that we won't necessarily break (to allow <foo>bar</foo>).
        if (fragments.length === 1 && content.chardata.filter((chardata)=>chardata.TEXT).length === 1) return $e1913a02d16fc190$var$group([
            openTag,
            $e1913a02d16fc190$var$indent([
                $e1913a02d16fc190$var$softline,
                fragments[0].printed
            ]),
            $e1913a02d16fc190$var$softline,
            closeTag
        ]);
        let delimiter = $e1913a02d16fc190$var$hardline;
        // If the only content is both chardata and references, then use a softline
        // so that we won't necessarily break.
        if (fragments.length === content.chardata.filter((chardata)=>chardata.TEXT).length + content.reference.length) delimiter = " ";
        const docs = [
            $e1913a02d16fc190$var$hardline
        ];
        let lastLine = fragments[0].startLine;
        fragments.forEach((node, index)=>{
            if (index !== 0) {
                if (node.startLine - lastLine >= 2) docs.push($e1913a02d16fc190$var$hardline, $e1913a02d16fc190$var$hardline);
                else docs.push(delimiter);
            }
            docs.push(node.printed);
            lastLine = node.endLine;
        });
        return $e1913a02d16fc190$var$group([
            openTag,
            $e1913a02d16fc190$var$indent(docs),
            $e1913a02d16fc190$var$hardline,
            closeTag
        ]);
    }
    return $e1913a02d16fc190$var$group([
        openTag,
        $e1913a02d16fc190$var$indent(path.call(print, "content")),
        closeTag
    ]);
}
function $e1913a02d16fc190$var$printExternalID(path, opts, print) {
    const { Public: Public, PubIDLiteral: PubIDLiteral, System: System, SystemLiteral: SystemLiteral } = path.getValue();
    if (System) return $e1913a02d16fc190$var$group([
        System,
        $e1913a02d16fc190$var$indent([
            $e1913a02d16fc190$var$line,
            SystemLiteral
        ])
    ]);
    return $e1913a02d16fc190$var$group([
        $e1913a02d16fc190$var$group([
            Public,
            $e1913a02d16fc190$var$indent([
                $e1913a02d16fc190$var$line,
                PubIDLiteral
            ])
        ]),
        $e1913a02d16fc190$var$indent([
            $e1913a02d16fc190$var$line,
            SystemLiteral
        ])
    ]);
}
function $e1913a02d16fc190$var$printMisc(path, opts, print) {
    const { Comment: Comment, PROCESSING_INSTRUCTION: PROCESSING_INSTRUCTION, SEA_WS: SEA_WS } = path.getValue();
    return Comment || PROCESSING_INSTRUCTION || SEA_WS;
}
function $e1913a02d16fc190$var$printProlog(path, opts, print) {
    const { XMLDeclOpen: XMLDeclOpen, attribute: attribute, SPECIAL_CLOSE: SPECIAL_CLOSE } = path.getValue();
    const parts = [
        XMLDeclOpen
    ];
    if (attribute) parts.push($e1913a02d16fc190$var$indent([
        $e1913a02d16fc190$var$softline,
        $e1913a02d16fc190$var$join($e1913a02d16fc190$var$line, path.map(print, "attribute"))
    ]));
    return $e1913a02d16fc190$var$group([
        ...parts,
        opts.xmlSelfClosingSpace ? $e1913a02d16fc190$var$line : $e1913a02d16fc190$var$softline,
        SPECIAL_CLOSE
    ]);
}
function $e1913a02d16fc190$var$printReference(path, opts, print) {
    const { CharRef: CharRef, EntityRef: EntityRef } = path.getValue();
    return CharRef || EntityRef;
}
const $e1913a02d16fc190$var$printer = {
    getVisitorKeys (node, nonTraversableKeys) {
        return Object.keys(node).filter((key)=>key !== "location" && key !== "tokenType");
    },
    embed: $e73259e3ae8a21b4$export$2e2bcd8739ae039,
    print (path, opts, print) {
        const node = path.getValue();
        switch(node.name){
            case "attribute":
                return $e1913a02d16fc190$var$printAttribute(path, opts, print);
            case "chardata":
                return $e1913a02d16fc190$var$printCharData(path, opts, print);
            case "content":
                return $e1913a02d16fc190$var$printContent(path, opts, print);
            case "docTypeDecl":
                return $e1913a02d16fc190$var$printDocTypeDecl(path, opts, print);
            case "document":
                return $e1913a02d16fc190$var$printDocument(path, opts, print);
            case "element":
                return $e1913a02d16fc190$var$printElement(path, opts, print);
            case "externalID":
                return $e1913a02d16fc190$var$printExternalID(path, opts, print);
            case "misc":
                return $e1913a02d16fc190$var$printMisc(path, opts, print);
            case "prolog":
                return $e1913a02d16fc190$var$printProlog(path, opts, print);
            case "reference":
                return $e1913a02d16fc190$var$printReference(path, opts, print);
            default:
                throw new Error(`Unknown node type: ${node.name}`);
        }
    }
};
var $e1913a02d16fc190$export$2e2bcd8739ae039 = $e1913a02d16fc190$var$printer;


const $baa411a10c2db108$var$plugin = {
    languages: $d928dc4e973e7a51$export$2e2bcd8739ae039,
    parsers: {
        xml: (0, $c9103c5b7fb15be8$export$2e2bcd8739ae039)
    },
    printers: {
        xml: (0, $e1913a02d16fc190$export$2e2bcd8739ae039)
    },
    options: {
        xmlSelfClosingSpace: {
            type: "boolean",
            category: "XML",
            default: true,
            description: "Adds a space before self-closing tags.",
            since: "1.1.0"
        },
        xmlWhitespaceSensitivity: {
            type: "choice",
            category: "XML",
            default: "strict",
            description: "How to handle whitespaces in XML.",
            choices: [
                {
                    value: "strict",
                    description: "Whitespaces are considered sensitive in all elements."
                },
                {
                    value: "preserve",
                    description: "Whitespaces within text nodes in XML elements and attributes are considered sensitive."
                },
                {
                    value: "ignore",
                    description: "Whitespaces are considered insensitive in all elements."
                }
            ],
            since: "0.6.0"
        },
        xmlSortAttributesByKey: {
            type: "boolean",
            category: "XML",
            default: false,
            description: "Orders XML attributes by key alphabetically while prioritizing xmlns attributes."
        },
        xmlQuoteAttributes: {
            type: "choice",
            category: "XML",
            default: "preserve",
            description: "How to handle whitespaces in XML.",
            choices: [
                {
                    value: "preserve",
                    description: "Quotes in attribute values will be preserved as written."
                },
                {
                    value: "single",
                    description: "Quotes in attribute values will be converted to consistent single quotes and other quotes in the string will be escaped."
                },
                {
                    value: "double",
                    description: "Quotes in attribute values will be converted to consistent double quotes and other quotes in the string will be escaped."
                }
            ]
        }
    },
    defaultOptions: {
        printWidth: 80,
        tabWidth: 2
    }
};
var $baa411a10c2db108$export$2e2bcd8739ae039 = $baa411a10c2db108$var$plugin;


var $fc0737f7a4e7c327$require$parserXML = $baa411a10c2db108$export$2e2bcd8739ae039;
class $fc0737f7a4e7c327$export$96be6e195c19e554 {
    static _instance;
    static get instance() {
        if (!$fc0737f7a4e7c327$export$96be6e195c19e554._instance) $fc0737f7a4e7c327$export$96be6e195c19e554._instance = new $fc0737f7a4e7c327$export$96be6e195c19e554();
        return $fc0737f7a4e7c327$export$96be6e195c19e554._instance;
    }
    modalElement;
    modal;
    heading;
    exportedContent;
    fileBasename;
    fileExtension;
    fileExtensionDropdown;
    copyButton;
    saveButton;
    copyTooltip;
    defaultDisplay;
    usedIDs;
    createExportID(prefix = "N") {
        let currentID;
        if (this.usedIDs.has(prefix)) {
            currentID = this.usedIDs.get(prefix);
            currentID++;
        } else currentID = 1;
        while(this.isIDUsed(prefix + currentID))currentID++;
        this.usedIDs.set(prefix, currentID);
        return prefix + currentID;
    }
    isIDUsed(id) {
        for (const component of (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.circuitComponents){
            // check if another component with the same name already exists
            if (component instanceof (0, $d4d1133581bf36e7$export$63512bbf9a12b35d) && component.name.value == id) return true;
        }
        return false;
    }
    /**
     * Init the ExportController
     */ constructor(){
        this.modalElement = document.getElementById("exportModal");
        this.modal = new (0, $9c6c83c6a450e1f8$export$2b77a92f1a5ad772)(this.modalElement);
        this.heading = document.getElementById("exportModalLabel");
        this.exportedContent = document.getElementById("exportedContent");
        this.fileBasename = document.getElementById("exportModalFileBasename");
        this.fileExtension = document.getElementById("exportModalFileExtension");
        this.fileExtensionDropdown = document.getElementById("exportModalFileExtensionDropdown");
        this.copyButton = document.getElementById("copyExportedContent");
        this.saveButton = document.getElementById("exportModalSave");
        this.defaultDisplay = this.exportedContent.parentElement.style.display;
        let copyButtonDefaultTooltipText = "Copy to clipboard!";
        this.copyButton.addEventListener("hidden.bs.tooltip", (evt)=>{
            this.copyButton.setAttribute("data-bs-title", copyButtonDefaultTooltipText);
            this.copyTooltip.dispose();
            this.copyTooltip = new (0, $9c6c83c6a450e1f8$export$28c660c63b792dea)(this.copyButton);
        });
        this.copyButton.setAttribute("data-bs-toggle", "tooltip");
        this.copyButton.setAttribute("data-bs-title", copyButtonDefaultTooltipText);
        this.copyTooltip = new (0, $9c6c83c6a450e1f8$export$28c660c63b792dea)(this.copyButton);
        this.usedIDs = new Map();
    }
    exportJSON(text) {
        this.heading.textContent = "Save JSON";
        // create extension select list
        const extensions = [
            ".json",
            ".txt"
        ];
        this.exportedContent.rows = Math.max(text.split("\n").length, 2);
        this.exportedContent.value = text;
        this.export(extensions);
    }
    /**
     * Shows the exportModal with the CitcuiTikZ code.
     */ exportCircuiTikZ() {
        this.heading.innerHTML = "Export CircuiTi<i>k</i>Z code";
        this.exportedContent.parentElement.style.display = this.defaultDisplay;
        // create extension select list
        const extensions = [
            ".tikz",
            ".tex",
            ".pgf"
        ];
        // actually export/create the string
        {
            let circuitElements = [];
            let requiredTikzLibraries = new Set();
            for (const circuitElement of (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.circuitComponents){
                circuitElement.requiredTikzLibraries().forEach((item)=>requiredTikzLibraries.add(item));
                circuitElements.push("	" + circuitElement.toTikzString());
            }
            let libraryStr = requiredTikzLibraries.size > 0 ? "\\usetikzlibrary{" + requiredTikzLibraries.values().toArray().join(", ") + "}" : "";
            let arr = [
                "\\begin{tikzpicture}",
                "	% Paths, nodes and wires:",
                ...circuitElements,
                "\\end{tikzpicture}"
            ];
            if (libraryStr) arr = [
                libraryStr
            ].concat(arr);
            this.exportedContent.rows = arr.length;
            this.exportedContent.value = arr.join("\n");
        }
        this.usedIDs.clear();
        this.export(extensions);
    }
    /**
     * Shows the exportModal with the SVG code.
     */ exportSVG() {
        this.heading.textContent = "Export SVG";
        this.exportedContent.parentElement.style.display = this.defaultDisplay;
        // prepare selection and bounding box
        (0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.selectAll();
        (0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.deactivateSelection();
        let colorTheme = (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.darkMode;
        (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.darkMode = false;
        (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.updateTheme();
        //Get the canvas
        let svgObj = new $gBhAd.Svg();
        svgObj.node.style.fontSize = "10pt";
        svgObj.node.style.overflow = "visible";
        // get all used node/symbol names
        let defsMap = new Map();
        let components = [];
        for (const instance of (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.circuitComponents)components.push(instance.toSVG(defsMap));
        // add to defs
        if (defsMap.size > 0) {
            const defs = new $gBhAd.Defs();
            for (const element of defsMap)defs.add(element[1]);
            svgObj.add(defs);
        }
        for (const component of components)svgObj.add(component);
        // bounding box to include all elements
        let bbox = svgObj.bbox();
        if (bbox) {
            //make bbox 2px larger in every direction to not cut of tiny bits of some objects
            bbox.x -= 2;
            bbox.y -= 2;
            bbox.width += 4;
            bbox.height += 4;
            svgObj.viewbox(bbox);
        }
        // convert to text and make pretty
        let tempDiv = document.createElement("div");
        tempDiv.appendChild(svgObj.node);
        tempDiv.innerHTML = tempDiv.innerHTML.replaceAll((0, $6a68e99136784593$export$fc9982435e9a3643), "#000").replaceAll((0, $6a68e99136784593$export$d3ce5ee02df64eaf), "#fff");
        $853c5f70df14f55b$exports.format(tempDiv.innerHTML.replaceAll("<br>", "<br/>"), {
            parser: "xml",
            plugins: [
                $fc0737f7a4e7c327$require$parserXML
            ],
            tabWidth: 4,
            singleAttributePerLine: true,
            xmlWhitespaceSensitivity: "preserve"
        }).then((textContent)=>{
            this.exportedContent.rows = textContent.split("\n").length;
            this.exportedContent.value = textContent;
            const extensions = [
                ".svg",
                ".txt"
            ];
            this.export(extensions);
            (0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.activateSelection();
            tempDiv.remove();
        });
        (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.darkMode = colorTheme;
        (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.updateTheme();
    }
    export(extensions) {
        // copy text and adjust tooltip for feedback
        const copyText = ()=>{
            navigator.clipboard.writeText(this.exportedContent.value).then(()=>{
                this.copyButton.setAttribute("data-bs-title", "Copied!");
                this.copyTooltip.dispose();
                this.copyTooltip = new (0, $9c6c83c6a450e1f8$export$28c660c63b792dea)(this.copyButton);
                this.copyTooltip.show();
            });
        };
        // create listeners
        const saveFile = (()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($23e83188f10c8284$exports))).saveAs(new Blob([
                this.exportedContent.value
            ], {
                type: "text/x-tex;charset=utf-8"
            }), (this.fileBasename.value.trim() || "Circuit") + this.fileExtension.value);
        }).bind(this);
        const hideListener = (()=>{
            this.exportedContent.value = ""; // free memory
            this.copyButton.removeEventListener("click", copyText);
            this.saveButton.removeEventListener("click", saveFile);
            this.fileExtensionDropdown.replaceChildren();
            // "once" is not always supported:
            this.modalElement.removeEventListener("hidden.bs.modal", hideListener);
        }).bind(this);
        this.modalElement.addEventListener("hidden.bs.modal", hideListener, {
            passive: true,
            once: true
        });
        // create extension select list
        this.fileExtension.value = extensions[0];
        this.fileExtensionDropdown.replaceChildren(...extensions.map((ext)=>{
            const link = document.createElement("a");
            link.textContent = ext;
            link.classList.add("dropdown-item");
            link.addEventListener("click", ()=>this.fileExtension.value = ext, {
                passive: true
            });
            const listElement = document.createElement("li");
            listElement.appendChild(link);
            return listElement;
        }));
        // add listeners & show modal
        this.copyButton.addEventListener("click", copyText, {
            passive: true
        });
        this.saveButton.addEventListener("click", saveFile, {
            passive: true
        });
        this.modal.show();
    }
}




class $e74b421401bcd19c$export$e94a9bf0a1c3ce0b {
    static _instance;
    static get instance() {
        if (!$e74b421401bcd19c$export$e94a9bf0a1c3ce0b._instance) $e74b421401bcd19c$export$e94a9bf0a1c3ce0b._instance = new $e74b421401bcd19c$export$e94a9bf0a1c3ce0b();
        return $e74b421401bcd19c$export$e94a9bf0a1c3ce0b._instance;
    }
    loadModal;
    modalElement;
    loadInput;
    loadMessage;
    loadButton;
    loadArea;
    loadAreaBackground;
    constructor(){
        this.modalElement = document.getElementById("loadModal");
        this.loadModal = new (0, $9c6c83c6a450e1f8$export$2b77a92f1a5ad772)(this.modalElement);
        this.loadInput = document.getElementById("file-input");
        this.loadMessage = document.getElementById("load-message");
        this.loadButton = document.getElementById("loadJSONButton");
        this.loadArea = document.getElementById("dragdroparea");
        this.loadAreaBackground = document.getElementById("dragdropbackground");
        const opacity0 = ()=>{
            this.loadAreaBackground.style.opacity = "0";
        };
        this.loadArea.addEventListener("dragenter", (ev)=>{
            this.loadAreaBackground.style.opacity = "0.3";
        });
        this.loadArea.addEventListener("dragleave", opacity0);
        this.loadArea.addEventListener("drop", opacity0);
    }
    save() {
        let components = [];
        for (const component of (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.circuitComponents)components.push(component.toJson());
        (0, $fc0737f7a4e7c327$export$96be6e195c19e554).instance.exportJSON(JSON.stringify(components, null, 4));
    }
    load() {
        //open modal for file selection
        this.loadModal.show();
        const changeText = (()=>{
            let file = this.loadInput.files[0];
            if (file) this.loadMessage.textContent = this.loadInput.value.split("\\").pop();
            else this.loadMessage.textContent = "No file selected";
        }).bind(this);
        const loadFile = (()=>{
            let file = this.loadInput.files[0];
            if (file) {
                var reader = new FileReader();
                reader.readAsText(file, "UTF-8");
                reader.onload = (evt)=>{
                    let inputstring = evt.target.result instanceof ArrayBuffer ? "" : evt.target.result;
                    this.loadFromJSON(JSON.parse(inputstring), true);
                    this.loadModal.hide();
                };
                reader.onerror = (evt)=>{
                    this.loadMessage.textContent = "error reading file";
                };
            }
        }).bind(this);
        this.loadInput.addEventListener("change", changeText);
        this.loadButton.addEventListener("click", loadFile);
        const hideListener = (()=>{
            this.loadInput.removeEventListener("change", changeText);
            this.loadButton.removeEventListener("click", loadFile);
            // "once" is not always supported:
            this.modalElement.removeEventListener("hidden.bs.modal", hideListener);
        }).bind(this);
        this.modalElement.addEventListener("hidden.bs.modal", hideListener, {
            passive: true,
            once: true
        });
    }
    loadFromJSON(obj, selectComponents = false) {
        //delete current state if necessary
        if (document.getElementById("loadCheckRemove").checked) {
            (0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.selectAll();
            (0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.removeSelection();
        }
        let components = [];
        if (obj.nodes || obj.paths || obj.lines) {
            for (const node of obj.nodes)components.push((0, $6bd671163c60be4d$export$a997d0ef89e7a9bb).fromJson(node));
            for (const path of obj.paths)components.push((0, $f522b793724e8edf$export$e522ece2f5c9b780).fromJson(path));
            for (const line of obj.lines)components.push((0, $627d261d67c772a8$export$af5ab1b7068ea0e5).fromJson(line));
        } else for (const component of obj){
            let c = $e74b421401bcd19c$export$e94a9bf0a1c3ce0b.fromJson(component);
            components.push(c);
            c.updateTheme();
        }
        if (selectComponents) {
            (0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.deactivateSelection();
            (0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.activateSelection();
            (0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.selectComponents(components, (0, $28c7e05d96c1a267$export$91484609d16ec765).RESET);
        }
        (0, $815383aeedb00f00$export$897c9ed706d8ea48).addState();
    }
    static fromJson(saveJson) {
        switch(saveJson.type){
            case "node":
                return (0, $6bd671163c60be4d$export$a997d0ef89e7a9bb).fromJson(saveJson);
            case "path":
                return (0, $f522b793724e8edf$export$e522ece2f5c9b780).fromJson(saveJson);
            case "wire":
                return (0, $627d261d67c772a8$export$af5ab1b7068ea0e5).fromJson(saveJson);
            case "rect":
                return (0, $018bdeaffc845dce$export$1b49e7b3b2d7fd39).fromJson(saveJson);
            case "ellipse":
                return (0, $f1cd0bf4955bc259$export$adcbac2b18b5c769).fromJson(saveJson);
            case "polygon":
                return (0, $8fa4f618930e8b82$export$abaf34b597d19c32).fromJson(saveJson);
            case "group":
                return (0, $33fd6c292c111484$export$450247cd99a94b80).fromJson(saveJson);
            default:
                throw new Error("type " + saveJson.type + " not known");
        }
    }
}



var $gBhAd = parcelRequire("gBhAd");

var $28c7e05d96c1a267$export$91484609d16ec765;
(function(SelectionMode) {
    SelectionMode[SelectionMode["RESET"] = 0] = "RESET";
    SelectionMode[SelectionMode["ADD"] = 1] = "ADD";
    SelectionMode[SelectionMode["SUB"] = 2] = "SUB";
})($28c7e05d96c1a267$export$91484609d16ec765 || ($28c7e05d96c1a267$export$91484609d16ec765 = {}));
var $28c7e05d96c1a267$export$7a30a6e87919c32;
(function(AlignmentMode) {
    AlignmentMode[AlignmentMode["START"] = -1] = "START";
    AlignmentMode[AlignmentMode["CENTER"] = 0] = "CENTER";
    AlignmentMode[AlignmentMode["END"] = 1] = "END";
})($28c7e05d96c1a267$export$7a30a6e87919c32 || ($28c7e05d96c1a267$export$7a30a6e87919c32 = {}));
var $28c7e05d96c1a267$export$5326e0f768237f28;
(function(DistributionMode) {
    DistributionMode[DistributionMode["CENTER"] = 0] = "CENTER";
    DistributionMode[DistributionMode["SPACE"] = 1] = "SPACE";
})($28c7e05d96c1a267$export$5326e0f768237f28 || ($28c7e05d96c1a267$export$5326e0f768237f28 = {}));
class $28c7e05d96c1a267$export$3c9dea9cd39918a3 {
    static _instance;
    selectionMode;
    selectionStartPosition;
    selectionRectangle;
    currentlyDragging;
    currentlySelectedComponents = [];
    selectionEnabled;
    referenceComponent;
    constructor(){
        this.selectionStartPosition = new $gBhAd.Point();
        this.selectionRectangle = (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas.rect(0, 0).move(0, 0);
        this.selectionRectangle.stroke({
            width: 0.5,
            color: (0, $6a68e99136784593$export$fc9982435e9a3643)
        }).fill("none").id("selectionRectangle");
        this.selectionEnabled = true;
        this.currentlyDragging = false;
        this.selectionMode = $28c7e05d96c1a267$export$91484609d16ec765.RESET;
        this.selectionStart = this.selectionStart.bind(this);
        this.selectionMove = this.selectionMove.bind(this);
        this.selectionEnd = this.selectionEnd.bind(this);
        (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas.on("mousedown", this.selectionStart);
        (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas.on("touchstart", this.selectionStart);
        (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas.on("mousemove", this.selectionMove);
        (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas.on("touchmove", this.selectionMove);
        (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas.on("mouseup", this.selectionEnd);
        (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas.on("touchend", this.selectionEnd);
    }
    selectionStart(evt) {
        if (!this.selectionEnabled || this.currentlyDragging) return;
        if (evt instanceof MouseEvent && evt.button !== 0) return;
        evt.preventDefault();
        let shift = evt.shiftKey; //||evt.detail.shiftKey
        let ctrl = evt.ctrlKey || (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.isMac && evt.metaKey || (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.isMac && evt.metaKey;
        if (shift) {
            if (ctrl) this.selectionMode = $28c7e05d96c1a267$export$91484609d16ec765.RESET;
            else this.selectionMode = $28c7e05d96c1a267$export$91484609d16ec765.ADD;
        } else if (ctrl) this.selectionMode = $28c7e05d96c1a267$export$91484609d16ec765.SUB;
        else this.selectionMode = $28c7e05d96c1a267$export$91484609d16ec765.RESET;
        this.currentlyDragging = true;
        this.selectionStartPosition = (0, $1c90e793f342bb2a$export$88e1240f06a672d2).eventToPoint(evt, false);
        (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas.put(this.selectionRectangle); // bring to front
        this.selectionRectangle.move(this.selectionStartPosition.x, this.selectionStartPosition.y);
    }
    selectionMove(evt) {
        if (!this.selectionEnabled || !this.currentlyDragging) return;
        if (evt instanceof MouseEvent && evt.button !== 0) return;
        if (window.TouchEvent && evt instanceof TouchEvent && evt.touches.length > 1) {
            this.currentlyDragging = false;
            this.selectionRectangle.size(0, 0).move(0, 0);
            this.viewSelection(true);
            return;
        }
        let pt = (0, $1c90e793f342bb2a$export$88e1240f06a672d2).eventToPoint(evt, false);
        let dx = pt.x - this.selectionStartPosition.x;
        let dy = pt.y - this.selectionStartPosition.y;
        let moveX = this.selectionStartPosition.x;
        let moveY = this.selectionStartPosition.y;
        if (dx < 0) {
            moveX += dx;
            dx = -dx;
        }
        if (dy < 0) {
            moveY += dy;
            dy = -dy;
        }
        this.selectionRectangle.move(moveX, moveY);
        this.selectionRectangle.attr("width", dx);
        this.selectionRectangle.attr("height", dy);
        this.previewSelection();
    }
    selectionEnd(evt) {
        if (!this.selectionEnabled) return;
        if (evt instanceof MouseEvent && evt.button !== 0) return;
        if (window.TouchEvent && evt instanceof TouchEvent && evt.touches.length > 0) return;
        if (this.currentlyDragging) {
            this.updateSelectionWithRectangle();
            this.currentlyDragging = false;
            this.selectionRectangle.size(0, 0);
        }
        let pt = (0, $1c90e793f342bb2a$export$88e1240f06a672d2).eventToPoint(evt, false);
        if (pt.x == this.selectionStartPosition.x && pt.y == this.selectionStartPosition.y) {
            // clicked on canvas
            this.selectionRectangle.move(pt.x, pt.y).size(0, 0);
            this.updateSelectionWithRectangle();
        }
        (0, $49e4d67b0180648f$export$b621f8acc59d25dc).instance.update();
    }
    static get instance() {
        if (!$28c7e05d96c1a267$export$3c9dea9cd39918a3._instance) $28c7e05d96c1a267$export$3c9dea9cd39918a3._instance = new $28c7e05d96c1a267$export$3c9dea9cd39918a3();
        return $28c7e05d96c1a267$export$3c9dea9cd39918a3._instance;
    }
    updateSelectionWithRectangle() {
        let selectionBox = this.selectionRectangle.bbox();
        let components = (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.circuitComponents.filter((comp)=>comp.isInsideSelectionRectangle(selectionBox));
        this.selectComponents(components, this.selectionMode);
    }
    previewSelection() {
        let selectionBox = this.selectionRectangle.bbox();
        if (this.selectionMode == $28c7e05d96c1a267$export$91484609d16ec765.RESET) for (const component of (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.circuitComponents)component.viewSelected(component.isInsideSelectionRectangle(selectionBox));
        else if (this.selectionMode == $28c7e05d96c1a267$export$91484609d16ec765.ADD) for (const component of (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.circuitComponents)component.viewSelected(component.isSelected || component.isInsideSelectionRectangle(selectionBox));
        else if (this.selectionMode == $28c7e05d96c1a267$export$91484609d16ec765.SUB) for (const component of (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.circuitComponents)component.viewSelected(component.isSelected && !component.isInsideSelectionRectangle(selectionBox));
    }
    activateSelection() {
        this.selectionEnabled = true;
    }
    deactivateSelection() {
        this.selectionEnabled = false;
        this.selectionRectangle.attr("width", 0);
        this.selectionRectangle.attr("height", 0);
        this.selectionMode = $28c7e05d96c1a267$export$91484609d16ec765.RESET;
        for (const component of (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.circuitComponents){
            component.isSelected = false;
            component.viewSelected(false);
        }
    }
    viewSelection(show = true) {
        for (const component of (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.circuitComponents)component.viewSelected(show && component.isSelected);
    }
    selectComponents(components, mode) {
        if (mode == $28c7e05d96c1a267$export$91484609d16ec765.RESET) {
            for (const component of (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.circuitComponents)component.isSelected = false;
            for (const component of components)component.isSelected = true;
        } else if (mode == $28c7e05d96c1a267$export$91484609d16ec765.ADD) for (const component of components)component.isSelected = true;
        else if (mode == $28c7e05d96c1a267$export$91484609d16ec765.SUB) for (const component of components)component.isSelected = false;
        this.currentlySelectedComponents.splice(0);
        this.currentlySelectedComponents.push(...(0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.circuitComponents.filter((comp)=>comp.isSelected));
        this.viewSelection();
        (0, $49e4d67b0180648f$export$b621f8acc59d25dc).instance.update();
    }
    selectAll() {
        this.currentlySelectedComponents.splice(0);
        this.currentlySelectedComponents.push(...(0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.circuitComponents);
        for (const component of (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.circuitComponents)component.isSelected = true;
        this.viewSelection();
        (0, $49e4d67b0180648f$export$b621f8acc59d25dc).instance.update();
    }
    getOverallBoundingBox() {
        let bbox = null;
        for (const component of this.currentlySelectedComponents)if (component.isSelected) {
            if (bbox == null) bbox = component.bbox;
            else bbox = bbox.merge(component.bbox);
        }
        return bbox;
    }
    /**
     *
     * @param {Number} angleDeg rotation in degrees (only 90 degree multiples, also negative)
     */ rotateSelection(angleDeg) {
        //get overall center
        if (!this.hasSelection()) return;
        let overallBBox = this.getOverallBoundingBox();
        let overallCenter = new $gBhAd.Point(overallBBox.cx, overallBBox.cy);
        //rotate all components/lines individually around their center
        //get individual center and rotate that around overall center
        //move individual components/lines to new rotated center
        for (const component of this.currentlySelectedComponents){
            component.rotate(angleDeg);
            let move = component.position.rotate(angleDeg, overallCenter, false);
            component.moveTo(move);
            component.recalculateSnappingPoints();
        }
    }
    /**
     *
     * @param {boolean} horizontal if flipping horizontally or vertically
     */ flipSelection(horizontal) {
        //get overall center
        if (!this.hasSelection()) return;
        let overallBBox = this.getOverallBoundingBox();
        let overallCenter = new $gBhAd.Point(overallBBox.cx, overallBBox.cy);
        let flipX = horizontal ? 0 : -2;
        let flipY = horizontal ? -2 : 0;
        //flip all components/lines individually at their center
        //get individual center and flip that at overall center
        //move individual components/lines to new flipped center
        for (const component of this.currentlySelectedComponents){
            let diffToCenter = component.position.sub(overallCenter);
            component.flip(horizontal);
            component.moveRel(new $gBhAd.Point(diffToCenter.x * flipX, diffToCenter.y * flipY));
        }
    }
    /**
     * move the selection by delta
     * @param {SVG.Point} delta the amount to move the selection by
     */ moveSelectionRel(delta) {
        for (const element of this.currentlySelectedComponents)element.moveRel(delta);
    }
    /**
     * move the center of the selection to the new position
     * @param position the new position
     */ moveSelectionTo(position) {
        let overallBBox = this.getOverallBoundingBox();
        let overallCenter = new $gBhAd.Point(overallBBox.cx, overallBBox.cy);
        this.moveSelectionRel(position.sub(overallCenter));
    }
    removeSelection() {
        for (const component of this.currentlySelectedComponents)(0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.removeComponent(component);
        this.currentlySelectedComponents = [];
        (0, $49e4d67b0180648f$export$b621f8acc59d25dc).instance.update();
    }
    /**
     * checks if anything is selected
     */ hasSelection() {
        return this.currentlySelectedComponents.length > 0;
    }
    setReference(component) {
        if (component == this.referenceComponent) {
            component.isSelected = false;
            component.isSelected = true;
            component.viewSelected(true);
        } else {
            component.setAsSelectionReference();
            this.referenceComponent = component;
        }
    }
    alignSelection(mode, horizontal) {
        let selectionBBox = this.getOverallBoundingBox();
        let selectionCenter = new $gBhAd.Point(selectionBBox.cx, selectionBBox.cy);
        let halfSelectionSize = new $gBhAd.Point(selectionBBox.w / 2, selectionBBox.h / 2);
        let direction = horizontal ? new $gBhAd.Point(1, 0) : new $gBhAd.Point(0, 1);
        let referencePosition;
        if (this.referenceComponent) {
            let elementBBox = this.referenceComponent.bbox;
            let elementHalfSize = new $gBhAd.Point(elementBBox.w / 2, elementBBox.h / 2);
            referencePosition = new $gBhAd.Point(elementBBox.cx, elementBBox.cy).add(elementHalfSize.mul(direction).mul(mode));
        } else referencePosition = selectionCenter.add(halfSelectionSize.mul(direction).mul(mode));
        for (const element of this.currentlySelectedComponents){
            let elementBBox = element.bbox;
            let elementHalfSize = new $gBhAd.Point(elementBBox.w / 2, elementBBox.h / 2);
            let elementReferencePoint = new $gBhAd.Point(elementBBox.cx, elementBBox.cy).add(elementHalfSize.mul(direction).mul(mode));
            let delta = referencePosition.sub(elementReferencePoint).mul(direction);
            element.moveRel(delta);
        }
        (0, $815383aeedb00f00$export$897c9ed706d8ea48).addState();
    }
    distributeSelection(mode, horizontal) {
        if (this.currentlySelectedComponents.length < 2) return;
        let direction = horizontal ? new $gBhAd.Point(1, 0) : new $gBhAd.Point(0, 1);
        let refPos;
        let bboxes = this.currentlySelectedComponents.map((c)=>{
            let bbox = c.bbox;
            if (c == this.referenceComponent) refPos = c.position;
            return {
                box: bbox,
                component: c
            };
        });
        bboxes.sort((a, b)=>{
            let diff = new $gBhAd.Point(a.box.cx - b.box.cx, a.box.cy - b.box.cy);
            return horizontal ? diff.x : diff.y;
        });
        let shouldUndo = false;
        let zeroVector = new $gBhAd.Point();
        if (mode == $28c7e05d96c1a267$export$5326e0f768237f28.CENTER) {
            let totalSpace = new $gBhAd.Point(bboxes.at(-1).box.cx - bboxes[0].box.cx, bboxes.at(-1).box.cy - bboxes[0].box.cy);
            const start = new $gBhAd.Point(bboxes[0].box.cx, bboxes[0].box.cy);
            const increment = totalSpace.div(this.currentlySelectedComponents.length - 1);
            for(let index = 1; index < bboxes.length - 1; index++){
                const bbox = bboxes[index];
                const newPosDiff = start.add(increment.mul(index)).sub(new $gBhAd.Point(bbox.box.cx, bbox.box.cy)).mul(direction);
                if (!shouldUndo && !newPosDiff.eq(zeroVector)) shouldUndo = true;
                bbox.component.moveRel(newPosDiff);
            }
        } else {
            let selectionBBox = this.getOverallBoundingBox();
            let availableSpacing = new $gBhAd.Point(selectionBBox.w, selectionBBox.h);
            bboxes.forEach((value)=>{
                availableSpacing.x -= value.box.w;
                availableSpacing.y -= value.box.h;
            });
            availableSpacing.x = availableSpacing.x < 0 ? 0 : availableSpacing.x;
            availableSpacing.y = availableSpacing.y < 0 ? 0 : availableSpacing.y;
            availableSpacing = availableSpacing.div(this.currentlySelectedComponents.length - 1);
            let lastPos = new $gBhAd.Point(bboxes[0].box.x2, bboxes[0].box.y2);
            for(let index = 1; index < bboxes.length; index++){
                const bbox = bboxes[index];
                lastPos = lastPos.add(availableSpacing).add(new $gBhAd.Point(bbox.box.w, bbox.box.h));
                const newPosDiff = lastPos.sub(new $gBhAd.Point(bbox.box.x2, bbox.box.y2)).mul(direction);
                if (!shouldUndo && !newPosDiff.eq(zeroVector)) shouldUndo = true;
                bbox.component.moveRel(newPosDiff);
            }
        }
        if (refPos) {
            let refResetDiff = refPos.sub(this.referenceComponent.position);
            for (const element of this.currentlySelectedComponents)element.moveRel(refResetDiff);
            if (!shouldUndo && !refResetDiff.eq(zeroVector)) shouldUndo = true;
        }
        if (shouldUndo) (0, $815383aeedb00f00$export$897c9ed706d8ea48).addState();
    }
}



class $815383aeedb00f00$export$897c9ed706d8ea48 {
    static states = [];
    static currentIndex = -1;
    //TODO discuss if selections should be remembered or not???
    static addState() {
        // get json object
        let currentState = [];
        for (const component of (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.circuitComponents){
            let componentObject = component.toJson();
            componentObject.selected = component.isSelected;
            currentState.push(componentObject);
        }
        let shouldAddState = true;
        if ($815383aeedb00f00$export$897c9ed706d8ea48.states.length > 0) {
            let compareState = $815383aeedb00f00$export$897c9ed706d8ea48.states.at($815383aeedb00f00$export$897c9ed706d8ea48.currentIndex);
            if (JSON.stringify(compareState) == JSON.stringify(currentState)) // This and the last state are identical -> no new state
            // sometimes needed for more complicated scenarios
            shouldAddState = false;
        }
        // push state on stack
        if (shouldAddState) {
            $815383aeedb00f00$export$897c9ed706d8ea48.states = $815383aeedb00f00$export$897c9ed706d8ea48.states.slice(0, $815383aeedb00f00$export$897c9ed706d8ea48.currentIndex + 1);
            $815383aeedb00f00$export$897c9ed706d8ea48.states.push(currentState);
            $815383aeedb00f00$export$897c9ed706d8ea48.currentIndex = $815383aeedb00f00$export$897c9ed706d8ea48.states.length - 1;
        }
    }
    static getCurrentState() {
        return $815383aeedb00f00$export$897c9ed706d8ea48.states[$815383aeedb00f00$export$897c9ed706d8ea48.currentIndex];
    }
    static undo() {
        $815383aeedb00f00$export$897c9ed706d8ea48.currentIndex -= 1;
        if ($815383aeedb00f00$export$897c9ed706d8ea48.currentIndex < 0) {
            $815383aeedb00f00$export$897c9ed706d8ea48.currentIndex = 0;
            return;
        }
        $815383aeedb00f00$export$897c9ed706d8ea48.loadState();
    }
    static redo() {
        $815383aeedb00f00$export$897c9ed706d8ea48.currentIndex += 1;
        if ($815383aeedb00f00$export$897c9ed706d8ea48.currentIndex >= $815383aeedb00f00$export$897c9ed706d8ea48.states.length) {
            $815383aeedb00f00$export$897c9ed706d8ea48.currentIndex = $815383aeedb00f00$export$897c9ed706d8ea48.states.length - 1;
            return;
        }
        $815383aeedb00f00$export$897c9ed706d8ea48.loadState();
    }
    static loadState() {
        // remove all components
        while((0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.circuitComponents.length > 0)(0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.removeComponent((0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.circuitComponents[0]);
        // load state
        let state = $815383aeedb00f00$export$897c9ed706d8ea48.states[$815383aeedb00f00$export$897c9ed706d8ea48.currentIndex];
        let components = [];
        for (const component of state){
            let initalializedComponenent = (0, $e74b421401bcd19c$export$e94a9bf0a1c3ce0b).fromJson(component);
            if (component.selected) components.push(initalializedComponenent);
        }
        if (components.length > 0) (0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.selectComponents(components, (0, $28c7e05d96c1a267$export$91484609d16ec765).RESET);
    }
}



var $gBhAd = parcelRequire("gBhAd");

class $08dc73dda964bc6a$export$726cc87d253ab418 {
    static clipboard = null;
    static copy() {
        if ((0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.hasSelection()) {
            let components = [];
            for (const component of (0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.currentlySelectedComponents){
                let componentObject = component.toJson();
                if (Object.hasOwn(componentObject, "name")) componentObject.name = "";
                components.push(componentObject);
            }
            let bbox = (0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.getOverallBoundingBox();
            $08dc73dda964bc6a$export$726cc87d253ab418.clipboard = {
                components: components,
                selectionPos: new (0, $gBhAd.Point)(bbox.cx, bbox.cy)
            };
        }
    }
    static paste() {
        if ($08dc73dda964bc6a$export$726cc87d253ab418.clipboard && Object.keys($08dc73dda964bc6a$export$726cc87d253ab418.clipboard).length === 0) return;
        (0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.deactivateSelection();
        (0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.activateSelection();
        let allComponents = [];
        for (const component of $08dc73dda964bc6a$export$726cc87d253ab418.clipboard.components)allComponents.push((0, $e74b421401bcd19c$export$e94a9bf0a1c3ce0b).fromJson(component));
        if (allComponents.length > 0) (0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.selectComponents(allComponents, (0, $28c7e05d96c1a267$export$91484609d16ec765).RESET);
        (0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.moveSelectionTo($08dc73dda964bc6a$export$726cc87d253ab418.clipboard.selectionPos.add(new (0, $gBhAd.Point)(20, 20)));
        (0, $815383aeedb00f00$export$897c9ed706d8ea48).addState();
    }
    static cut() {
        if ((0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.hasSelection()) {
            $08dc73dda964bc6a$export$726cc87d253ab418.copy();
            for (const component of (0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.currentlySelectedComponents)(0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.removeComponent(component);
            (0, $815383aeedb00f00$export$897c9ed706d8ea48).addState();
        }
    }
}



class $49e4d67b0180648f$export$b621f8acc59d25dc {
    static _instance;
    static get instance() {
        if (!$49e4d67b0180648f$export$b621f8acc59d25dc._instance) $49e4d67b0180648f$export$b621f8acc59d25dc._instance = new $49e4d67b0180648f$export$b621f8acc59d25dc();
        return $49e4d67b0180648f$export$b621f8acc59d25dc._instance;
    }
    gridProperties;
    propertiesEntries;
    propertiesTitle;
    constructor(){
        this.propertiesTitle = document.getElementById("propertiesTitle");
        this.gridProperties = document.getElementById("grid-properties");
        this.propertiesEntries = document.getElementById("propertiesEntries");
    }
    update() {
        let components = (0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.currentlySelectedComponents;
        this.clearForm();
        if (components.length > 1) this.setMultiForm(components);
        else if (components.length === 1) this.setForm(components[0]);
        else this.setFormGrid();
    }
    setMultiForm(components) {
        //TODO multicomponent edit
        this.propertiesEntries.classList.remove("d-none");
        this.propertiesTitle.innerText = "Selection";
        let rows = [];
        let positioning = new (0, $995311ad94412d30$export$d4fc42aa08871cc3)(2, [
            [
                "Rotate 90\xb0 CW",
                "rotate_right"
            ],
            [
                "Rotate 90\xb0 CCW",
                "rotate_left"
            ],
            [
                "Rotate 45\xb0 CW",
                "rotate_right"
            ],
            [
                "Rotate 45\xb0 CCW",
                "rotate_left"
            ],
            [
                "Flip vertically",
                [
                    "flip",
                    "rotateText"
                ]
            ],
            [
                "Flip horizontally",
                "flip"
            ]
        ], [
            (ev)=>{
                (0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.rotateSelection(-90);
                (0, $815383aeedb00f00$export$897c9ed706d8ea48).addState();
            },
            (ev)=>{
                (0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.rotateSelection(90);
                (0, $815383aeedb00f00$export$897c9ed706d8ea48).addState();
            },
            (ev)=>{
                (0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.rotateSelection(-45);
                (0, $815383aeedb00f00$export$897c9ed706d8ea48).addState();
            },
            (ev)=>{
                (0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.rotateSelection(45);
                (0, $815383aeedb00f00$export$897c9ed706d8ea48).addState();
            },
            (ev)=>{
                (0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.flipSelection(true);
                (0, $815383aeedb00f00$export$897c9ed706d8ea48).addState();
            },
            (ev)=>{
                (0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.flipSelection(false);
                (0, $815383aeedb00f00$export$897c9ed706d8ea48).addState();
            }
        ]);
        rows.push(positioning.buildHTML());
        rows.push(new (0, $c66494ce03e8372a$export$4de04f378a8de0fe)("Ordering").buildHTML());
        let ordering = new (0, $995311ad94412d30$export$d4fc42aa08871cc3)(2, [
            [
                "Foreground",
                ""
            ],
            [
                "Background",
                ""
            ],
            [
                "Forward",
                ""
            ],
            [
                "Backward",
                ""
            ]
        ], [
            (ev)=>(0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.componentsToForeground((0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.currentlySelectedComponents),
            (ev)=>(0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.componentsToBackground((0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.currentlySelectedComponents),
            (ev)=>(0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.moveComponentsForward((0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.currentlySelectedComponents),
            (ev)=>(0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.moveComponentsBackward((0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.currentlySelectedComponents)
        ]);
        rows.push(ordering.buildHTML());
        rows.push(new (0, $c66494ce03e8372a$export$4de04f378a8de0fe)("Grouping").buildHTML());
        let grouping = new (0, $995311ad94412d30$export$d4fc42aa08871cc3)(1, [
            [
                "Group",
                ""
            ]
        ], [
            (ev)=>(0, $33fd6c292c111484$export$450247cd99a94b80).group((0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.currentlySelectedComponents)
        ]);
        rows.push(grouping.buildHTML());
        rows.push(new (0, $c66494ce03e8372a$export$4de04f378a8de0fe)("Align").buildHTML());
        let alignment = new (0, $995311ad94412d30$export$d4fc42aa08871cc3)(3, [
            [
                "",
                "align_horizontal_left"
            ],
            [
                "",
                "align_horizontal_center"
            ],
            [
                "",
                "align_horizontal_right"
            ],
            [
                "",
                "align_vertical_top"
            ],
            [
                "",
                "align_vertical_center"
            ],
            [
                "",
                "align_vertical_bottom"
            ]
        ], [
            (ev)=>(0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.alignSelection((0, $28c7e05d96c1a267$export$7a30a6e87919c32).START, true),
            (ev)=>(0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.alignSelection((0, $28c7e05d96c1a267$export$7a30a6e87919c32).CENTER, true),
            (ev)=>(0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.alignSelection((0, $28c7e05d96c1a267$export$7a30a6e87919c32).END, true),
            (ev)=>(0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.alignSelection((0, $28c7e05d96c1a267$export$7a30a6e87919c32).START, false),
            (ev)=>(0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.alignSelection((0, $28c7e05d96c1a267$export$7a30a6e87919c32).CENTER, false),
            (ev)=>(0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.alignSelection((0, $28c7e05d96c1a267$export$7a30a6e87919c32).END, false)
        ]);
        rows.push(alignment.buildHTML());
        rows.push(new (0, $c66494ce03e8372a$export$4de04f378a8de0fe)("Distribute").buildHTML());
        let distribute = new (0, $995311ad94412d30$export$d4fc42aa08871cc3)(2, [
            [
                "Center",
                "horizontal_distribute"
            ],
            [
                "Spacing",
                "align_justify_space_even"
            ],
            [
                "Center",
                "vertical_distribute"
            ],
            [
                "Spacing",
                "align_space_even"
            ]
        ], [
            (ev)=>(0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.distributeSelection((0, $28c7e05d96c1a267$export$5326e0f768237f28).CENTER, true),
            (ev)=>(0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.distributeSelection((0, $28c7e05d96c1a267$export$5326e0f768237f28).SPACE, true),
            (ev)=>(0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.distributeSelection((0, $28c7e05d96c1a267$export$5326e0f768237f28).CENTER, false),
            (ev)=>(0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.distributeSelection((0, $28c7e05d96c1a267$export$5326e0f768237f28).SPACE, false)
        ]);
        rows.push(distribute.buildHTML());
        this.propertiesEntries.append(...rows);
    }
    setForm(component) {
        this.propertiesEntries.classList.remove("d-none");
        this.propertiesTitle.innerText = component.displayName;
        this.propertiesEntries.append(...component.propertiesHTMLRows);
    }
    setFormGrid() {
        this.gridProperties.classList.remove("d-none");
        this.propertiesTitle.innerText = "Grid settings";
        let minorSlider = document.getElementById("minorSliderInput");
        minorSlider.value = (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.majorGridSubdivisions.toString();
        let majorSlider = document.getElementById("majorSliderInput");
        majorSlider.value = (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.majorGridSizecm.toString();
        minorSlider.addEventListener("input", (ev)=>{
            this.changeGrid((0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.majorGridSizecm, Number.parseFloat(minorSlider.value));
        });
        majorSlider.addEventListener("input", (ev)=>{
            this.changeGrid(Number.parseFloat(majorSlider.value), (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.majorGridSubdivisions);
        });
        this.changeGrid((0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.majorGridSizecm, (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.majorGridSubdivisions);
    //TODO add reset viewport button but save the viewport in localstorage
    }
    changeGrid(majorSizecm, majorSubdivisions) {
        (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.changeGrid(majorSizecm, majorSubdivisions);
        let majorLabel = document.getElementById("majorLabel");
        majorLabel.innerText = majorSizecm + " cm";
        let minorLabel = document.getElementById("minorLabel");
        minorLabel.innerText = majorSubdivisions.toString();
        let gridInfo = document.getElementById("gridInfo");
        gridInfo.innerText = (majorSizecm / majorSubdivisions).toLocaleString(undefined, {
            maximumFractionDigits: 2
        }) + " cm";
    }
    clearForm() {
        this.propertiesTitle.innerText = "Properties";
        this.gridProperties.classList.add("d-none");
        this.propertiesEntries.classList.add("d-none");
        this.propertiesEntries.innerText = "";
        while(this.propertiesEntries.lastElementChild)this.propertiesEntries.removeChild(this.propertiesEntries.lastElementChild);
    }
}



class $62b9e9b060ea5e43$export$9cd791b14633436b {
    _value;
    get value() {
        return this._value;
    }
    set value(newVal) {
        this._value = newVal;
    }
    changeListeners;
    constructor(initialValue){
        // make sure to be in drag_pan mode when changing any value
        this.changeListeners = [
            (ev)=>{
                (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.switchMode((0, $177c4dcfaec5a17b$export$43660d87cb080eb).DRAG_PAN);
            }
        ];
        if (initialValue !== undefined) this._value = initialValue;
    }
    getRow() {
        let row = document.createElement("div");
        row.classList.add("row", "g-2", "my-2");
        return row;
    }
    addChangeListener(changeListener) {
        this.changeListeners.push(changeListener);
    }
    removeChangeListener(changeListener) {
        let idx = this.changeListeners.findIndex((val)=>val == changeListener);
        if (idx >= 0) {
            this.changeListeners.splice(idx, 1);
            return true;
        }
        return false;
    }
    updateValue(newVal, updateHTML = false) {
        if (this.eq(newVal, this.value)) return;
        let lastValue = this.value;
        this._value = newVal;
        let changeEvent = {
            previousValue: lastValue,
            value: this._value
        };
        if (updateHTML) this.updateHTML();
        for (const element of this.changeListeners)element(changeEvent);
    }
}



class $155dcbbe154f2d95$export$2b4dce27390864c7 extends (0, $62b9e9b060ea5e43$export$9cd791b14633436b) {
    checkBox;
    label;
    constructor(label, initialValue){
        super(initialValue);
        this.label = label;
    }
    eq(first, second) {
        return first == second;
    }
    buildHTML() {
        let row = this.getRow();
        let col = document.createElement("div");
        col.classList.add("col-12", "my-0");
        let checkBoxContainerX = document.createElement("div");
        checkBoxContainerX.classList.add("form-check", "form-switch");
        {
            this.checkBox = document.createElement("input");
            this.checkBox.classList.add("form-check-input");
            this.checkBox.setAttribute("type", "checkbox");
            this.checkBox.setAttribute("role", "switch");
            this.checkBox.checked = this.value;
            checkBoxContainerX.appendChild(this.checkBox);
            let labelElementX = document.createElement("label");
            labelElementX.classList.add("form-check-label");
            labelElementX.innerHTML = this.label ?? "CheckBox";
            checkBoxContainerX.appendChild(labelElementX);
        }
        col.appendChild(checkBoxContainerX);
        this.checkBox.addEventListener("change", (ev)=>{
            this.updateValue(this.checkBox.checked);
            (0, $815383aeedb00f00$export$897c9ed706d8ea48).addState();
        });
        row.appendChild(col);
        return row;
    }
    updateHTML() {
        if (this.checkBox) this.checkBox.checked = this.value;
    }
}



class $e40ab772a0133b83$export$cb4430aa1f2c59e4 extends (0, $62b9e9b060ea5e43$export$9cd791b14633436b) {
    label;
    selectElement;
    choiceOptions;
    constructor(label, choiceOptions, initialValue){
        super(initialValue);
        this.label = label;
        this.choiceOptions = choiceOptions;
    }
    eq(first, second) {
        return first.key == second.key;
    }
    buildHTML() {
        let row = this.getRow();
        let col = document.createElement("div");
        col.classList.add("col-12", "input-group", "my-0");
        {
            let anchorLabel = document.createElement("label");
            anchorLabel.classList.add("input-group-text");
            anchorLabel.innerHTML = this.label;
            col.appendChild(anchorLabel);
            this.selectElement = document.createElement("select");
            this.selectElement.classList.add("form-select");
            this.selectElement.name = "anchor";
            for(let index = 0; index < this.choiceOptions.length; index++){
                const labelKey = this.choiceOptions[index].key;
                const labelName = this.choiceOptions[index].name;
                let optionElement = document.createElement("option");
                optionElement.value = labelKey;
                optionElement.innerHTML = labelName;
                optionElement.selected = this.value ? labelKey == this.value.key : false;
                this.selectElement.appendChild(optionElement);
            }
            this.selectElement.addEventListener("change", (ev)=>{
                this.updateValue(this.choiceOptions.find((el)=>el.key == this.selectElement.value));
                (0, $815383aeedb00f00$export$897c9ed706d8ea48).addState();
            });
            col.appendChild(this.selectElement);
        }
        row.appendChild(col);
        return row;
    }
    updateHTML() {
        if (this.selectElement) for (const optionElement of this.selectElement.children)optionElement.selected = optionElement.value == this.value.key;
    }
}



class $6e17b8b34300d085$export$352e63445db76668 extends (0, $62b9e9b060ea5e43$export$9cd791b14633436b) {
    input;
    invalidDiv;
    label;
    constructor(label, initalValue){
        super(initalValue);
        this.label = label;
    }
    buildHTML() {
        let row = this.getRow();
        let inputDiv = document.createElement("div");
        inputDiv.classList.add("col", "col-md-12", "my-0", "input-group", "has-validation");
        {
            let labelSpan = document.createElement("span");
            labelSpan.classList.add("input-group-text");
            labelSpan.innerHTML = this.label ?? "";
            inputDiv.appendChild(labelSpan);
            this.input = document.createElement("input");
            this.input.classList.add("form-control");
            this.input.setAttribute("type", "text");
            this.input.value = this.value ?? "";
            inputDiv.appendChild(this.input);
            this.invalidDiv = document.createElement("div");
            this.invalidDiv.classList.add("col-12", "invalid-feedback", "d-none");
            inputDiv.appendChild(this.invalidDiv);
        }
        row.appendChild(inputDiv);
        let previousState = "";
        this.input.addEventListener("focusin", (ev)=>{
            previousState = this.value ?? "";
        });
        this.input.addEventListener("input", (ev)=>{
            this.updateValue(this.input.value);
        });
        this.input.addEventListener("focusout", (ev)=>{
            if (this.value && previousState !== this.value) (0, $815383aeedb00f00$export$897c9ed706d8ea48).addState();
        });
        return row;
    }
    changeInvalidStatus(msg) {
        if (this.invalidDiv) {
            if (msg === "") {
                this.input.classList.remove("is-invalid");
                this.invalidDiv.classList.add("d-none");
                this.invalidDiv.innerHTML = "";
            } else {
                this.input.classList.add("is-invalid");
                this.input.classList.add("is-invalid");
                this.invalidDiv.classList.remove("d-none");
                this.invalidDiv.innerHTML = "Invalid! " + msg;
            }
        }
    }
    updateHTML() {
        if (this.input) this.input.value = this.value;
    }
    eq(first, second) {
        return first == second;
    }
}



var $91fe648caba28c6f$exports = {};
var $6fcae538d5f03b31$exports = {};
"use strict";
var $6fcae538d5f03b31$var$__createBinding = $6fcae538d5f03b31$exports && $6fcae538d5f03b31$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6fcae538d5f03b31$var$__setModuleDefault = $6fcae538d5f03b31$exports && $6fcae538d5f03b31$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $6fcae538d5f03b31$var$__importStar = $6fcae538d5f03b31$exports && $6fcae538d5f03b31$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $6fcae538d5f03b31$var$__createBinding(result, mod, k);
    }
    $6fcae538d5f03b31$var$__setModuleDefault(result, mod);
    return result;
};
var $6fcae538d5f03b31$var$__importDefault = $6fcae538d5f03b31$exports && $6fcae538d5f03b31$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($6fcae538d5f03b31$exports, "__esModule", {
    value: true
});
$6fcae538d5f03b31$exports.decodeXML = $6fcae538d5f03b31$exports.decodeHTMLStrict = $6fcae538d5f03b31$exports.decodeHTMLAttribute = $6fcae538d5f03b31$exports.decodeHTML = $6fcae538d5f03b31$exports.determineBranch = $6fcae538d5f03b31$exports.EntityDecoder = $6fcae538d5f03b31$exports.DecodingMode = $6fcae538d5f03b31$exports.BinTrieFlags = $6fcae538d5f03b31$exports.fromCodePoint = $6fcae538d5f03b31$exports.replaceCodePoint = $6fcae538d5f03b31$exports.decodeCodePoint = $6fcae538d5f03b31$exports.xmlDecodeTree = $6fcae538d5f03b31$exports.htmlDecodeTree = void 0;

var $6fcae538d5f03b31$var$decode_data_html_js_1 = $6fcae538d5f03b31$var$__importDefault((parcelRequire("3r7fb")));
$6fcae538d5f03b31$exports.htmlDecodeTree = $6fcae538d5f03b31$var$decode_data_html_js_1.default;

var $6fcae538d5f03b31$var$decode_data_xml_js_1 = $6fcae538d5f03b31$var$__importDefault((parcelRequire("l1aB5")));
$6fcae538d5f03b31$exports.xmlDecodeTree = $6fcae538d5f03b31$var$decode_data_xml_js_1.default;

var $6fcae538d5f03b31$var$decode_codepoint_js_1 = $6fcae538d5f03b31$var$__importStar((parcelRequire("5Sc3b")));
$6fcae538d5f03b31$exports.decodeCodePoint = $6fcae538d5f03b31$var$decode_codepoint_js_1.default;

Object.defineProperty($6fcae538d5f03b31$exports, "replaceCodePoint", {
    enumerable: true,
    get: function() {
        return (parcelRequire("5Sc3b")).replaceCodePoint;
    }
});
Object.defineProperty($6fcae538d5f03b31$exports, "fromCodePoint", {
    enumerable: true,
    get: function() {
        return (parcelRequire("5Sc3b")).fromCodePoint;
    }
});
var $6fcae538d5f03b31$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["NUM"] = 35] = "NUM";
    CharCodes[CharCodes["SEMI"] = 59] = "SEMI";
    CharCodes[CharCodes["EQUALS"] = 61] = "EQUALS";
    CharCodes[CharCodes["ZERO"] = 48] = "ZERO";
    CharCodes[CharCodes["NINE"] = 57] = "NINE";
    CharCodes[CharCodes["LOWER_A"] = 97] = "LOWER_A";
    CharCodes[CharCodes["LOWER_F"] = 102] = "LOWER_F";
    CharCodes[CharCodes["LOWER_X"] = 120] = "LOWER_X";
    CharCodes[CharCodes["LOWER_Z"] = 122] = "LOWER_Z";
    CharCodes[CharCodes["UPPER_A"] = 65] = "UPPER_A";
    CharCodes[CharCodes["UPPER_F"] = 70] = "UPPER_F";
    CharCodes[CharCodes["UPPER_Z"] = 90] = "UPPER_Z";
})($6fcae538d5f03b31$var$CharCodes || ($6fcae538d5f03b31$var$CharCodes = {}));
/** Bit that needs to be set to convert an upper case ASCII character to lower case */ var $6fcae538d5f03b31$var$TO_LOWER_BIT = 32;
var $6fcae538d5f03b31$var$BinTrieFlags;
(function(BinTrieFlags) {
    BinTrieFlags[BinTrieFlags["VALUE_LENGTH"] = 49152] = "VALUE_LENGTH";
    BinTrieFlags[BinTrieFlags["BRANCH_LENGTH"] = 16256] = "BRANCH_LENGTH";
    BinTrieFlags[BinTrieFlags["JUMP_TABLE"] = 127] = "JUMP_TABLE";
})($6fcae538d5f03b31$var$BinTrieFlags = $6fcae538d5f03b31$exports.BinTrieFlags || ($6fcae538d5f03b31$exports.BinTrieFlags = {}));
function $6fcae538d5f03b31$var$isNumber(code) {
    return code >= $6fcae538d5f03b31$var$CharCodes.ZERO && code <= $6fcae538d5f03b31$var$CharCodes.NINE;
}
function $6fcae538d5f03b31$var$isHexadecimalCharacter(code) {
    return code >= $6fcae538d5f03b31$var$CharCodes.UPPER_A && code <= $6fcae538d5f03b31$var$CharCodes.UPPER_F || code >= $6fcae538d5f03b31$var$CharCodes.LOWER_A && code <= $6fcae538d5f03b31$var$CharCodes.LOWER_F;
}
function $6fcae538d5f03b31$var$isAsciiAlphaNumeric(code) {
    return code >= $6fcae538d5f03b31$var$CharCodes.UPPER_A && code <= $6fcae538d5f03b31$var$CharCodes.UPPER_Z || code >= $6fcae538d5f03b31$var$CharCodes.LOWER_A && code <= $6fcae538d5f03b31$var$CharCodes.LOWER_Z || $6fcae538d5f03b31$var$isNumber(code);
}
/**
 * Checks if the given character is a valid end character for an entity in an attribute.
 *
 * Attribute values that aren't terminated properly aren't parsed, and shouldn't lead to a parser error.
 * See the example in https://html.spec.whatwg.org/multipage/parsing.html#named-character-reference-state
 */ function $6fcae538d5f03b31$var$isEntityInAttributeInvalidEnd(code) {
    return code === $6fcae538d5f03b31$var$CharCodes.EQUALS || $6fcae538d5f03b31$var$isAsciiAlphaNumeric(code);
}
var $6fcae538d5f03b31$var$EntityDecoderState;
(function(EntityDecoderState) {
    EntityDecoderState[EntityDecoderState["EntityStart"] = 0] = "EntityStart";
    EntityDecoderState[EntityDecoderState["NumericStart"] = 1] = "NumericStart";
    EntityDecoderState[EntityDecoderState["NumericDecimal"] = 2] = "NumericDecimal";
    EntityDecoderState[EntityDecoderState["NumericHex"] = 3] = "NumericHex";
    EntityDecoderState[EntityDecoderState["NamedEntity"] = 4] = "NamedEntity";
})($6fcae538d5f03b31$var$EntityDecoderState || ($6fcae538d5f03b31$var$EntityDecoderState = {}));
var $6fcae538d5f03b31$var$DecodingMode;
(function(DecodingMode) {
    /** Entities in text nodes that can end with any character. */ DecodingMode[DecodingMode["Legacy"] = 0] = "Legacy";
    /** Only allow entities terminated with a semicolon. */ DecodingMode[DecodingMode["Strict"] = 1] = "Strict";
    /** Entities in attributes have limitations on ending characters. */ DecodingMode[DecodingMode["Attribute"] = 2] = "Attribute";
})($6fcae538d5f03b31$var$DecodingMode = $6fcae538d5f03b31$exports.DecodingMode || ($6fcae538d5f03b31$exports.DecodingMode = {}));
/**
 * Token decoder with support of writing partial entities.
 */ var $6fcae538d5f03b31$var$EntityDecoder = /** @class */ function() {
    function EntityDecoder(/** The tree used to decode entities. */ decodeTree, /**
     * The function that is called when a codepoint is decoded.
     *
     * For multi-byte named entities, this will be called multiple times,
     * with the second codepoint, and the same `consumed` value.
     *
     * @param codepoint The decoded codepoint.
     * @param consumed The number of bytes consumed by the decoder.
     */ emitCodePoint, /** An object that is used to produce errors. */ errors) {
        this.decodeTree = decodeTree;
        this.emitCodePoint = emitCodePoint;
        this.errors = errors;
        /** The current state of the decoder. */ this.state = $6fcae538d5f03b31$var$EntityDecoderState.EntityStart;
        /** Characters that were consumed while parsing an entity. */ this.consumed = 1;
        /**
         * The result of the entity.
         *
         * Either the result index of a numeric entity, or the codepoint of a
         * numeric entity.
         */ this.result = 0;
        /** The current index in the decode tree. */ this.treeIndex = 0;
        /** The number of characters that were consumed in excess. */ this.excess = 1;
        /** The mode in which the decoder is operating. */ this.decodeMode = $6fcae538d5f03b31$var$DecodingMode.Strict;
    }
    /** Resets the instance to make it reusable. */ EntityDecoder.prototype.startEntity = function(decodeMode) {
        this.decodeMode = decodeMode;
        this.state = $6fcae538d5f03b31$var$EntityDecoderState.EntityStart;
        this.result = 0;
        this.treeIndex = 0;
        this.excess = 1;
        this.consumed = 1;
    };
    /**
     * Write an entity to the decoder. This can be called multiple times with partial entities.
     * If the entity is incomplete, the decoder will return -1.
     *
     * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
     * entity is incomplete, and resume when the next string is written.
     *
     * @param string The string containing the entity (or a continuation of the entity).
     * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.write = function(str, offset) {
        switch(this.state){
            case $6fcae538d5f03b31$var$EntityDecoderState.EntityStart:
                if (str.charCodeAt(offset) === $6fcae538d5f03b31$var$CharCodes.NUM) {
                    this.state = $6fcae538d5f03b31$var$EntityDecoderState.NumericStart;
                    this.consumed += 1;
                    return this.stateNumericStart(str, offset + 1);
                }
                this.state = $6fcae538d5f03b31$var$EntityDecoderState.NamedEntity;
                return this.stateNamedEntity(str, offset);
            case $6fcae538d5f03b31$var$EntityDecoderState.NumericStart:
                return this.stateNumericStart(str, offset);
            case $6fcae538d5f03b31$var$EntityDecoderState.NumericDecimal:
                return this.stateNumericDecimal(str, offset);
            case $6fcae538d5f03b31$var$EntityDecoderState.NumericHex:
                return this.stateNumericHex(str, offset);
            case $6fcae538d5f03b31$var$EntityDecoderState.NamedEntity:
                return this.stateNamedEntity(str, offset);
        }
    };
    /**
     * Switches between the numeric decimal and hexadecimal states.
     *
     * Equivalent to the `Numeric character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.stateNumericStart = function(str, offset) {
        if (offset >= str.length) return -1;
        if ((str.charCodeAt(offset) | $6fcae538d5f03b31$var$TO_LOWER_BIT) === $6fcae538d5f03b31$var$CharCodes.LOWER_X) {
            this.state = $6fcae538d5f03b31$var$EntityDecoderState.NumericHex;
            this.consumed += 1;
            return this.stateNumericHex(str, offset + 1);
        }
        this.state = $6fcae538d5f03b31$var$EntityDecoderState.NumericDecimal;
        return this.stateNumericDecimal(str, offset);
    };
    EntityDecoder.prototype.addToNumericResult = function(str, start, end, base) {
        if (start !== end) {
            var digitCount = end - start;
            this.result = this.result * Math.pow(base, digitCount) + parseInt(str.substr(start, digitCount), base);
            this.consumed += digitCount;
        }
    };
    /**
     * Parses a hexadecimal numeric entity.
     *
     * Equivalent to the `Hexademical character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.stateNumericHex = function(str, offset) {
        var startIdx = offset;
        while(offset < str.length){
            var char = str.charCodeAt(offset);
            if ($6fcae538d5f03b31$var$isNumber(char) || $6fcae538d5f03b31$var$isHexadecimalCharacter(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 16);
                return this.emitNumericEntity(char, 3);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 16);
        return -1;
    };
    /**
     * Parses a decimal numeric entity.
     *
     * Equivalent to the `Decimal character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.stateNumericDecimal = function(str, offset) {
        var startIdx = offset;
        while(offset < str.length){
            var char = str.charCodeAt(offset);
            if ($6fcae538d5f03b31$var$isNumber(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 10);
                return this.emitNumericEntity(char, 2);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 10);
        return -1;
    };
    /**
     * Validate and emit a numeric entity.
     *
     * Implements the logic from the `Hexademical character reference start
     * state` and `Numeric character reference end state` in the HTML spec.
     *
     * @param lastCp The last code point of the entity. Used to see if the
     *               entity was terminated with a semicolon.
     * @param expectedLength The minimum number of characters that should be
     *                       consumed. Used to validate that at least one digit
     *                       was consumed.
     * @returns The number of characters that were consumed.
     */ EntityDecoder.prototype.emitNumericEntity = function(lastCp, expectedLength) {
        var _a;
        // Ensure we consumed at least one digit.
        if (this.consumed <= expectedLength) {
            (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
            return 0;
        }
        // Figure out if this is a legit end of the entity
        if (lastCp === $6fcae538d5f03b31$var$CharCodes.SEMI) this.consumed += 1;
        else if (this.decodeMode === $6fcae538d5f03b31$var$DecodingMode.Strict) return 0;
        this.emitCodePoint((0, $6fcae538d5f03b31$var$decode_codepoint_js_1.replaceCodePoint)(this.result), this.consumed);
        if (this.errors) {
            if (lastCp !== $6fcae538d5f03b31$var$CharCodes.SEMI) this.errors.missingSemicolonAfterCharacterReference();
            this.errors.validateNumericCharacterReference(this.result);
        }
        return this.consumed;
    };
    /**
     * Parses a named entity.
     *
     * Equivalent to the `Named character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.stateNamedEntity = function(str, offset) {
        var decodeTree = this.decodeTree;
        var current = decodeTree[this.treeIndex];
        // The mask is the number of bytes of the value, including the current byte.
        var valueLength = (current & $6fcae538d5f03b31$var$BinTrieFlags.VALUE_LENGTH) >> 14;
        for(; offset < str.length; offset++, this.excess++){
            var char = str.charCodeAt(offset);
            this.treeIndex = $6fcae538d5f03b31$var$determineBranch(decodeTree, current, this.treeIndex + Math.max(1, valueLength), char);
            if (this.treeIndex < 0) return this.result === 0 || // If we are parsing an attribute
            this.decodeMode === $6fcae538d5f03b31$var$DecodingMode.Attribute && // We shouldn't have consumed any characters after the entity,
            (valueLength === 0 || // And there should be no invalid characters.
            $6fcae538d5f03b31$var$isEntityInAttributeInvalidEnd(char)) ? 0 : this.emitNotTerminatedNamedEntity();
            current = decodeTree[this.treeIndex];
            valueLength = (current & $6fcae538d5f03b31$var$BinTrieFlags.VALUE_LENGTH) >> 14;
            // If the branch is a value, store it and continue
            if (valueLength !== 0) {
                // If the entity is terminated by a semicolon, we are done.
                if (char === $6fcae538d5f03b31$var$CharCodes.SEMI) return this.emitNamedEntityData(this.treeIndex, valueLength, this.consumed + this.excess);
                // If we encounter a non-terminated (legacy) entity while parsing strictly, then ignore it.
                if (this.decodeMode !== $6fcae538d5f03b31$var$DecodingMode.Strict) {
                    this.result = this.treeIndex;
                    this.consumed += this.excess;
                    this.excess = 0;
                }
            }
        }
        return -1;
    };
    /**
     * Emit a named entity that was not terminated with a semicolon.
     *
     * @returns The number of characters consumed.
     */ EntityDecoder.prototype.emitNotTerminatedNamedEntity = function() {
        var _a;
        var _b = this, result = _b.result, decodeTree = _b.decodeTree;
        var valueLength = (decodeTree[result] & $6fcae538d5f03b31$var$BinTrieFlags.VALUE_LENGTH) >> 14;
        this.emitNamedEntityData(result, valueLength, this.consumed);
        (_a = this.errors) === null || _a === void 0 || _a.missingSemicolonAfterCharacterReference();
        return this.consumed;
    };
    /**
     * Emit a named entity.
     *
     * @param result The index of the entity in the decode tree.
     * @param valueLength The number of bytes in the entity.
     * @param consumed The number of characters consumed.
     *
     * @returns The number of characters consumed.
     */ EntityDecoder.prototype.emitNamedEntityData = function(result, valueLength, consumed) {
        var decodeTree = this.decodeTree;
        this.emitCodePoint(valueLength === 1 ? decodeTree[result] & ~$6fcae538d5f03b31$var$BinTrieFlags.VALUE_LENGTH : decodeTree[result + 1], consumed);
        if (valueLength === 3) // For multi-byte values, we need to emit the second byte.
        this.emitCodePoint(decodeTree[result + 2], consumed);
        return consumed;
    };
    /**
     * Signal to the parser that the end of the input was reached.
     *
     * Remaining data will be emitted and relevant errors will be produced.
     *
     * @returns The number of characters consumed.
     */ EntityDecoder.prototype.end = function() {
        var _a;
        switch(this.state){
            case $6fcae538d5f03b31$var$EntityDecoderState.NamedEntity:
                // Emit a named entity if we have one.
                return this.result !== 0 && (this.decodeMode !== $6fcae538d5f03b31$var$DecodingMode.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
            // Otherwise, emit a numeric entity if we have one.
            case $6fcae538d5f03b31$var$EntityDecoderState.NumericDecimal:
                return this.emitNumericEntity(0, 2);
            case $6fcae538d5f03b31$var$EntityDecoderState.NumericHex:
                return this.emitNumericEntity(0, 3);
            case $6fcae538d5f03b31$var$EntityDecoderState.NumericStart:
                (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
                return 0;
            case $6fcae538d5f03b31$var$EntityDecoderState.EntityStart:
                // Return 0 if we have no entity.
                return 0;
        }
    };
    return EntityDecoder;
}();
$6fcae538d5f03b31$exports.EntityDecoder = $6fcae538d5f03b31$var$EntityDecoder;
/**
 * Creates a function that decodes entities in a string.
 *
 * @param decodeTree The decode tree.
 * @returns A function that decodes entities in a string.
 */ function $6fcae538d5f03b31$var$getDecoder(decodeTree) {
    var ret = "";
    var decoder = new $6fcae538d5f03b31$var$EntityDecoder(decodeTree, function(str) {
        return ret += (0, $6fcae538d5f03b31$var$decode_codepoint_js_1.fromCodePoint)(str);
    });
    return function decodeWithTrie(str, decodeMode) {
        var lastIndex = 0;
        var offset = 0;
        while((offset = str.indexOf("&", offset)) >= 0){
            ret += str.slice(lastIndex, offset);
            decoder.startEntity(decodeMode);
            var len = decoder.write(str, // Skip the "&"
            offset + 1);
            if (len < 0) {
                lastIndex = offset + decoder.end();
                break;
            }
            lastIndex = offset + len;
            // If `len` is 0, skip the current `&` and continue.
            offset = len === 0 ? lastIndex + 1 : lastIndex;
        }
        var result = ret + str.slice(lastIndex);
        // Make sure we don't keep a reference to the final string.
        ret = "";
        return result;
    };
}
/**
 * Determines the branch of the current node that is taken given the current
 * character. This function is used to traverse the trie.
 *
 * @param decodeTree The trie.
 * @param current The current node.
 * @param nodeIdx The index right after the current node and its value.
 * @param char The current character.
 * @returns The index of the next node, or -1 if no branch is taken.
 */ function $6fcae538d5f03b31$var$determineBranch(decodeTree, current, nodeIdx, char) {
    var branchCount = (current & $6fcae538d5f03b31$var$BinTrieFlags.BRANCH_LENGTH) >> 7;
    var jumpOffset = current & $6fcae538d5f03b31$var$BinTrieFlags.JUMP_TABLE;
    // Case 1: Single branch encoded in jump offset
    if (branchCount === 0) return jumpOffset !== 0 && char === jumpOffset ? nodeIdx : -1;
    // Case 2: Multiple branches encoded in jump table
    if (jumpOffset) {
        var value = char - jumpOffset;
        return value < 0 || value >= branchCount ? -1 : decodeTree[nodeIdx + value] - 1;
    }
    // Case 3: Multiple branches encoded in dictionary
    // Binary search for the character.
    var lo = nodeIdx;
    var hi = lo + branchCount - 1;
    while(lo <= hi){
        var mid = lo + hi >>> 1;
        var midVal = decodeTree[mid];
        if (midVal < char) lo = mid + 1;
        else if (midVal > char) hi = mid - 1;
        else return decodeTree[mid + branchCount];
    }
    return -1;
}
$6fcae538d5f03b31$exports.determineBranch = $6fcae538d5f03b31$var$determineBranch;
var $6fcae538d5f03b31$var$htmlDecoder = $6fcae538d5f03b31$var$getDecoder($6fcae538d5f03b31$var$decode_data_html_js_1.default);
var $6fcae538d5f03b31$var$xmlDecoder = $6fcae538d5f03b31$var$getDecoder($6fcae538d5f03b31$var$decode_data_xml_js_1.default);
/**
 * Decodes an HTML string.
 *
 * @param str The string to decode.
 * @param mode The decoding mode.
 * @returns The decoded string.
 */ function $6fcae538d5f03b31$var$decodeHTML(str, mode) {
    if (mode === void 0) mode = $6fcae538d5f03b31$var$DecodingMode.Legacy;
    return $6fcae538d5f03b31$var$htmlDecoder(str, mode);
}
$6fcae538d5f03b31$exports.decodeHTML = $6fcae538d5f03b31$var$decodeHTML;
/**
 * Decodes an HTML string in an attribute.
 *
 * @param str The string to decode.
 * @returns The decoded string.
 */ function $6fcae538d5f03b31$var$decodeHTMLAttribute(str) {
    return $6fcae538d5f03b31$var$htmlDecoder(str, $6fcae538d5f03b31$var$DecodingMode.Attribute);
}
$6fcae538d5f03b31$exports.decodeHTMLAttribute = $6fcae538d5f03b31$var$decodeHTMLAttribute;
/**
 * Decodes an HTML string, requiring all entities to be terminated by a semicolon.
 *
 * @param str The string to decode.
 * @returns The decoded string.
 */ function $6fcae538d5f03b31$var$decodeHTMLStrict(str) {
    return $6fcae538d5f03b31$var$htmlDecoder(str, $6fcae538d5f03b31$var$DecodingMode.Strict);
}
$6fcae538d5f03b31$exports.decodeHTMLStrict = $6fcae538d5f03b31$var$decodeHTMLStrict;
/**
 * Decodes an XML string, requiring all entities to be terminated by a semicolon.
 *
 * @param str The string to decode.
 * @returns The decoded string.
 */ function $6fcae538d5f03b31$var$decodeXML(str) {
    return $6fcae538d5f03b31$var$xmlDecoder(str, $6fcae538d5f03b31$var$DecodingMode.Strict);
}
$6fcae538d5f03b31$exports.decodeXML = $6fcae538d5f03b31$var$decodeXML;


var $3ae552344e829693$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["Tab"] = 9] = "Tab";
    CharCodes[CharCodes["NewLine"] = 10] = "NewLine";
    CharCodes[CharCodes["FormFeed"] = 12] = "FormFeed";
    CharCodes[CharCodes["CarriageReturn"] = 13] = "CarriageReturn";
    CharCodes[CharCodes["Space"] = 32] = "Space";
    CharCodes[CharCodes["ExclamationMark"] = 33] = "ExclamationMark";
    CharCodes[CharCodes["Number"] = 35] = "Number";
    CharCodes[CharCodes["Amp"] = 38] = "Amp";
    CharCodes[CharCodes["SingleQuote"] = 39] = "SingleQuote";
    CharCodes[CharCodes["DoubleQuote"] = 34] = "DoubleQuote";
    CharCodes[CharCodes["Dash"] = 45] = "Dash";
    CharCodes[CharCodes["Slash"] = 47] = "Slash";
    CharCodes[CharCodes["Zero"] = 48] = "Zero";
    CharCodes[CharCodes["Nine"] = 57] = "Nine";
    CharCodes[CharCodes["Semi"] = 59] = "Semi";
    CharCodes[CharCodes["Lt"] = 60] = "Lt";
    CharCodes[CharCodes["Eq"] = 61] = "Eq";
    CharCodes[CharCodes["Gt"] = 62] = "Gt";
    CharCodes[CharCodes["Questionmark"] = 63] = "Questionmark";
    CharCodes[CharCodes["UpperA"] = 65] = "UpperA";
    CharCodes[CharCodes["LowerA"] = 97] = "LowerA";
    CharCodes[CharCodes["UpperF"] = 70] = "UpperF";
    CharCodes[CharCodes["LowerF"] = 102] = "LowerF";
    CharCodes[CharCodes["UpperZ"] = 90] = "UpperZ";
    CharCodes[CharCodes["LowerZ"] = 122] = "LowerZ";
    CharCodes[CharCodes["LowerX"] = 120] = "LowerX";
    CharCodes[CharCodes["OpeningSquareBracket"] = 91] = "OpeningSquareBracket";
})($3ae552344e829693$var$CharCodes || ($3ae552344e829693$var$CharCodes = {}));
/** All the states the tokenizer can be in. */ var $3ae552344e829693$var$State;
(function(State) {
    State[State["Text"] = 1] = "Text";
    State[State["BeforeTagName"] = 2] = "BeforeTagName";
    State[State["InTagName"] = 3] = "InTagName";
    State[State["InSelfClosingTag"] = 4] = "InSelfClosingTag";
    State[State["BeforeClosingTagName"] = 5] = "BeforeClosingTagName";
    State[State["InClosingTagName"] = 6] = "InClosingTagName";
    State[State["AfterClosingTagName"] = 7] = "AfterClosingTagName";
    // Attributes
    State[State["BeforeAttributeName"] = 8] = "BeforeAttributeName";
    State[State["InAttributeName"] = 9] = "InAttributeName";
    State[State["AfterAttributeName"] = 10] = "AfterAttributeName";
    State[State["BeforeAttributeValue"] = 11] = "BeforeAttributeValue";
    State[State["InAttributeValueDq"] = 12] = "InAttributeValueDq";
    State[State["InAttributeValueSq"] = 13] = "InAttributeValueSq";
    State[State["InAttributeValueNq"] = 14] = "InAttributeValueNq";
    // Declarations
    State[State["BeforeDeclaration"] = 15] = "BeforeDeclaration";
    State[State["InDeclaration"] = 16] = "InDeclaration";
    // Processing instructions
    State[State["InProcessingInstruction"] = 17] = "InProcessingInstruction";
    // Comments & CDATA
    State[State["BeforeComment"] = 18] = "BeforeComment";
    State[State["CDATASequence"] = 19] = "CDATASequence";
    State[State["InSpecialComment"] = 20] = "InSpecialComment";
    State[State["InCommentLike"] = 21] = "InCommentLike";
    // Special tags
    State[State["BeforeSpecialS"] = 22] = "BeforeSpecialS";
    State[State["SpecialStartSequence"] = 23] = "SpecialStartSequence";
    State[State["InSpecialTag"] = 24] = "InSpecialTag";
    State[State["BeforeEntity"] = 25] = "BeforeEntity";
    State[State["BeforeNumericEntity"] = 26] = "BeforeNumericEntity";
    State[State["InNamedEntity"] = 27] = "InNamedEntity";
    State[State["InNumericEntity"] = 28] = "InNumericEntity";
    State[State["InHexEntity"] = 29] = "InHexEntity";
})($3ae552344e829693$var$State || ($3ae552344e829693$var$State = {}));
function $3ae552344e829693$var$isWhitespace(c) {
    return c === $3ae552344e829693$var$CharCodes.Space || c === $3ae552344e829693$var$CharCodes.NewLine || c === $3ae552344e829693$var$CharCodes.Tab || c === $3ae552344e829693$var$CharCodes.FormFeed || c === $3ae552344e829693$var$CharCodes.CarriageReturn;
}
function $3ae552344e829693$var$isEndOfTagSection(c) {
    return c === $3ae552344e829693$var$CharCodes.Slash || c === $3ae552344e829693$var$CharCodes.Gt || $3ae552344e829693$var$isWhitespace(c);
}
function $3ae552344e829693$var$isNumber(c) {
    return c >= $3ae552344e829693$var$CharCodes.Zero && c <= $3ae552344e829693$var$CharCodes.Nine;
}
function $3ae552344e829693$var$isASCIIAlpha(c) {
    return c >= $3ae552344e829693$var$CharCodes.LowerA && c <= $3ae552344e829693$var$CharCodes.LowerZ || c >= $3ae552344e829693$var$CharCodes.UpperA && c <= $3ae552344e829693$var$CharCodes.UpperZ;
}
function $3ae552344e829693$var$isHexDigit(c) {
    return c >= $3ae552344e829693$var$CharCodes.UpperA && c <= $3ae552344e829693$var$CharCodes.UpperF || c >= $3ae552344e829693$var$CharCodes.LowerA && c <= $3ae552344e829693$var$CharCodes.LowerF;
}
var $3ae552344e829693$export$cbf5509cea2ad22;
(function(QuoteType) {
    QuoteType[QuoteType["NoValue"] = 0] = "NoValue";
    QuoteType[QuoteType["Unquoted"] = 1] = "Unquoted";
    QuoteType[QuoteType["Single"] = 2] = "Single";
    QuoteType[QuoteType["Double"] = 3] = "Double";
})($3ae552344e829693$export$cbf5509cea2ad22 || ($3ae552344e829693$export$cbf5509cea2ad22 = {}));
/**
 * Sequences used to match longer strings.
 *
 * We don't have `Script`, `Style`, or `Title` here. Instead, we re-use the *End
 * sequences with an increased offset.
 */ const $3ae552344e829693$var$Sequences = {
    Cdata: new Uint8Array([
        0x43,
        0x44,
        0x41,
        0x54,
        0x41,
        0x5b
    ]),
    CdataEnd: new Uint8Array([
        0x5d,
        0x5d,
        0x3e
    ]),
    CommentEnd: new Uint8Array([
        0x2d,
        0x2d,
        0x3e
    ]),
    ScriptEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x73,
        0x63,
        0x72,
        0x69,
        0x70,
        0x74
    ]),
    StyleEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x73,
        0x74,
        0x79,
        0x6c,
        0x65
    ]),
    TitleEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x74,
        0x69,
        0x74,
        0x6c,
        0x65
    ])
};
class $3ae552344e829693$export$2e2bcd8739ae039 {
    constructor({ xmlMode: xmlMode = false, decodeEntities: decodeEntities = true }, cbs){
        this.cbs = cbs;
        /** The current state the tokenizer is in. */ this.state = $3ae552344e829693$var$State.Text;
        /** The read buffer. */ this.buffer = "";
        /** The beginning of the section that is currently being read. */ this.sectionStart = 0;
        /** The index within the buffer that we are currently looking at. */ this.index = 0;
        /** Some behavior, eg. when decoding entities, is done while we are in another state. This keeps track of the other state type. */ this.baseState = $3ae552344e829693$var$State.Text;
        /** For special parsing behavior inside of script and style tags. */ this.isSpecial = false;
        /** Indicates whether the tokenizer has been paused. */ this.running = true;
        /** The offset of the current buffer. */ this.offset = 0;
        this.currentSequence = undefined;
        this.sequenceIndex = 0;
        this.trieIndex = 0;
        this.trieCurrent = 0;
        /** For named entities, the index of the value. For numeric entities, the code point. */ this.entityResult = 0;
        this.entityExcess = 0;
        this.xmlMode = xmlMode;
        this.decodeEntities = decodeEntities;
        this.entityTrie = xmlMode ? (0, $6fcae538d5f03b31$exports.xmlDecodeTree) : (0, $6fcae538d5f03b31$exports.htmlDecodeTree);
    }
    reset() {
        this.state = $3ae552344e829693$var$State.Text;
        this.buffer = "";
        this.sectionStart = 0;
        this.index = 0;
        this.baseState = $3ae552344e829693$var$State.Text;
        this.currentSequence = undefined;
        this.running = true;
        this.offset = 0;
    }
    write(chunk) {
        this.offset += this.buffer.length;
        this.buffer = chunk;
        this.parse();
    }
    end() {
        if (this.running) this.finish();
    }
    pause() {
        this.running = false;
    }
    resume() {
        this.running = true;
        if (this.index < this.buffer.length + this.offset) this.parse();
    }
    /**
     * The current index within all of the written data.
     */ getIndex() {
        return this.index;
    }
    /**
     * The start of the current section.
     */ getSectionStart() {
        return this.sectionStart;
    }
    stateText(c) {
        if (c === $3ae552344e829693$var$CharCodes.Lt || !this.decodeEntities && this.fastForwardTo($3ae552344e829693$var$CharCodes.Lt)) {
            if (this.index > this.sectionStart) this.cbs.ontext(this.sectionStart, this.index);
            this.state = $3ae552344e829693$var$State.BeforeTagName;
            this.sectionStart = this.index;
        } else if (this.decodeEntities && c === $3ae552344e829693$var$CharCodes.Amp) this.state = $3ae552344e829693$var$State.BeforeEntity;
    }
    stateSpecialStartSequence(c) {
        const isEnd = this.sequenceIndex === this.currentSequence.length;
        const isMatch = isEnd ? $3ae552344e829693$var$isEndOfTagSection(c) : (c | 0x20) === this.currentSequence[this.sequenceIndex];
        if (!isMatch) this.isSpecial = false;
        else if (!isEnd) {
            this.sequenceIndex++;
            return;
        }
        this.sequenceIndex = 0;
        this.state = $3ae552344e829693$var$State.InTagName;
        this.stateInTagName(c);
    }
    /** Look for an end tag. For <title> tags, also decode entities. */ stateInSpecialTag(c) {
        if (this.sequenceIndex === this.currentSequence.length) {
            if (c === $3ae552344e829693$var$CharCodes.Gt || $3ae552344e829693$var$isWhitespace(c)) {
                const endOfText = this.index - this.currentSequence.length;
                if (this.sectionStart < endOfText) {
                    // Spoof the index so that reported locations match up.
                    const actualIndex = this.index;
                    this.index = endOfText;
                    this.cbs.ontext(this.sectionStart, endOfText);
                    this.index = actualIndex;
                }
                this.isSpecial = false;
                this.sectionStart = endOfText + 2; // Skip over the `</`
                this.stateInClosingTagName(c);
                return; // We are done; skip the rest of the function.
            }
            this.sequenceIndex = 0;
        }
        if ((c | 0x20) === this.currentSequence[this.sequenceIndex]) this.sequenceIndex += 1;
        else if (this.sequenceIndex === 0) {
            if (this.currentSequence === $3ae552344e829693$var$Sequences.TitleEnd) // We have to parse entities in <title> tags.
            {
                if (this.decodeEntities && c === $3ae552344e829693$var$CharCodes.Amp) this.state = $3ae552344e829693$var$State.BeforeEntity;
            } else if (this.fastForwardTo($3ae552344e829693$var$CharCodes.Lt)) // Outside of <title> tags, we can fast-forward.
            this.sequenceIndex = 1;
        } else // If we see a `<`, set the sequence index to 1; useful for eg. `<</script>`.
        this.sequenceIndex = Number(c === $3ae552344e829693$var$CharCodes.Lt);
    }
    stateCDATASequence(c) {
        if (c === $3ae552344e829693$var$Sequences.Cdata[this.sequenceIndex]) {
            if (++this.sequenceIndex === $3ae552344e829693$var$Sequences.Cdata.length) {
                this.state = $3ae552344e829693$var$State.InCommentLike;
                this.currentSequence = $3ae552344e829693$var$Sequences.CdataEnd;
                this.sequenceIndex = 0;
                this.sectionStart = this.index + 1;
            }
        } else {
            this.sequenceIndex = 0;
            this.state = $3ae552344e829693$var$State.InDeclaration;
            this.stateInDeclaration(c); // Reconsume the character
        }
    }
    /**
     * When we wait for one specific character, we can speed things up
     * by skipping through the buffer until we find it.
     *
     * @returns Whether the character was found.
     */ fastForwardTo(c) {
        while(++this.index < this.buffer.length + this.offset){
            if (this.buffer.charCodeAt(this.index - this.offset) === c) return true;
        }
        /*
         * We increment the index at the end of the `parse` loop,
         * so set it to `buffer.length - 1` here.
         *
         * TODO: Refactor `parse` to increment index before calling states.
         */ this.index = this.buffer.length + this.offset - 1;
        return false;
    }
    /**
     * Comments and CDATA end with `-->` and `]]>`.
     *
     * Their common qualities are:
     * - Their end sequences have a distinct character they start with.
     * - That character is then repeated, so we have to check multiple repeats.
     * - All characters but the start character of the sequence can be skipped.
     */ stateInCommentLike(c) {
        if (c === this.currentSequence[this.sequenceIndex]) {
            if (++this.sequenceIndex === this.currentSequence.length) {
                if (this.currentSequence === $3ae552344e829693$var$Sequences.CdataEnd) this.cbs.oncdata(this.sectionStart, this.index, 2);
                else this.cbs.oncomment(this.sectionStart, this.index, 2);
                this.sequenceIndex = 0;
                this.sectionStart = this.index + 1;
                this.state = $3ae552344e829693$var$State.Text;
            }
        } else if (this.sequenceIndex === 0) // Fast-forward to the first character of the sequence
        {
            if (this.fastForwardTo(this.currentSequence[0])) this.sequenceIndex = 1;
        } else if (c !== this.currentSequence[this.sequenceIndex - 1]) // Allow long sequences, eg. --->, ]]]>
        this.sequenceIndex = 0;
    }
    /**
     * HTML only allows ASCII alpha characters (a-z and A-Z) at the beginning of a tag name.
     *
     * XML allows a lot more characters here (@see https://www.w3.org/TR/REC-xml/#NT-NameStartChar).
     * We allow anything that wouldn't end the tag.
     */ isTagStartChar(c) {
        return this.xmlMode ? !$3ae552344e829693$var$isEndOfTagSection(c) : $3ae552344e829693$var$isASCIIAlpha(c);
    }
    startSpecial(sequence, offset) {
        this.isSpecial = true;
        this.currentSequence = sequence;
        this.sequenceIndex = offset;
        this.state = $3ae552344e829693$var$State.SpecialStartSequence;
    }
    stateBeforeTagName(c) {
        if (c === $3ae552344e829693$var$CharCodes.ExclamationMark) {
            this.state = $3ae552344e829693$var$State.BeforeDeclaration;
            this.sectionStart = this.index + 1;
        } else if (c === $3ae552344e829693$var$CharCodes.Questionmark) {
            this.state = $3ae552344e829693$var$State.InProcessingInstruction;
            this.sectionStart = this.index + 1;
        } else if (this.isTagStartChar(c)) {
            const lower = c | 0x20;
            this.sectionStart = this.index;
            if (!this.xmlMode && lower === $3ae552344e829693$var$Sequences.TitleEnd[2]) this.startSpecial($3ae552344e829693$var$Sequences.TitleEnd, 3);
            else this.state = !this.xmlMode && lower === $3ae552344e829693$var$Sequences.ScriptEnd[2] ? $3ae552344e829693$var$State.BeforeSpecialS : $3ae552344e829693$var$State.InTagName;
        } else if (c === $3ae552344e829693$var$CharCodes.Slash) this.state = $3ae552344e829693$var$State.BeforeClosingTagName;
        else {
            this.state = $3ae552344e829693$var$State.Text;
            this.stateText(c);
        }
    }
    stateInTagName(c) {
        if ($3ae552344e829693$var$isEndOfTagSection(c)) {
            this.cbs.onopentagname(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.state = $3ae552344e829693$var$State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        }
    }
    stateBeforeClosingTagName(c) {
        if ($3ae552344e829693$var$isWhitespace(c)) ;
        else if (c === $3ae552344e829693$var$CharCodes.Gt) this.state = $3ae552344e829693$var$State.Text;
        else {
            this.state = this.isTagStartChar(c) ? $3ae552344e829693$var$State.InClosingTagName : $3ae552344e829693$var$State.InSpecialComment;
            this.sectionStart = this.index;
        }
    }
    stateInClosingTagName(c) {
        if (c === $3ae552344e829693$var$CharCodes.Gt || $3ae552344e829693$var$isWhitespace(c)) {
            this.cbs.onclosetag(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.state = $3ae552344e829693$var$State.AfterClosingTagName;
            this.stateAfterClosingTagName(c);
        }
    }
    stateAfterClosingTagName(c) {
        // Skip everything until ">"
        if (c === $3ae552344e829693$var$CharCodes.Gt || this.fastForwardTo($3ae552344e829693$var$CharCodes.Gt)) {
            this.state = $3ae552344e829693$var$State.Text;
            this.baseState = $3ae552344e829693$var$State.Text;
            this.sectionStart = this.index + 1;
        }
    }
    stateBeforeAttributeName(c) {
        if (c === $3ae552344e829693$var$CharCodes.Gt) {
            this.cbs.onopentagend(this.index);
            if (this.isSpecial) {
                this.state = $3ae552344e829693$var$State.InSpecialTag;
                this.sequenceIndex = 0;
            } else this.state = $3ae552344e829693$var$State.Text;
            this.baseState = this.state;
            this.sectionStart = this.index + 1;
        } else if (c === $3ae552344e829693$var$CharCodes.Slash) this.state = $3ae552344e829693$var$State.InSelfClosingTag;
        else if (!$3ae552344e829693$var$isWhitespace(c)) {
            this.state = $3ae552344e829693$var$State.InAttributeName;
            this.sectionStart = this.index;
        }
    }
    stateInSelfClosingTag(c) {
        if (c === $3ae552344e829693$var$CharCodes.Gt) {
            this.cbs.onselfclosingtag(this.index);
            this.state = $3ae552344e829693$var$State.Text;
            this.baseState = $3ae552344e829693$var$State.Text;
            this.sectionStart = this.index + 1;
            this.isSpecial = false; // Reset special state, in case of self-closing special tags
        } else if (!$3ae552344e829693$var$isWhitespace(c)) {
            this.state = $3ae552344e829693$var$State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        }
    }
    stateInAttributeName(c) {
        if (c === $3ae552344e829693$var$CharCodes.Eq || $3ae552344e829693$var$isEndOfTagSection(c)) {
            this.cbs.onattribname(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.state = $3ae552344e829693$var$State.AfterAttributeName;
            this.stateAfterAttributeName(c);
        }
    }
    stateAfterAttributeName(c) {
        if (c === $3ae552344e829693$var$CharCodes.Eq) this.state = $3ae552344e829693$var$State.BeforeAttributeValue;
        else if (c === $3ae552344e829693$var$CharCodes.Slash || c === $3ae552344e829693$var$CharCodes.Gt) {
            this.cbs.onattribend($3ae552344e829693$export$cbf5509cea2ad22.NoValue, this.index);
            this.state = $3ae552344e829693$var$State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        } else if (!$3ae552344e829693$var$isWhitespace(c)) {
            this.cbs.onattribend($3ae552344e829693$export$cbf5509cea2ad22.NoValue, this.index);
            this.state = $3ae552344e829693$var$State.InAttributeName;
            this.sectionStart = this.index;
        }
    }
    stateBeforeAttributeValue(c) {
        if (c === $3ae552344e829693$var$CharCodes.DoubleQuote) {
            this.state = $3ae552344e829693$var$State.InAttributeValueDq;
            this.sectionStart = this.index + 1;
        } else if (c === $3ae552344e829693$var$CharCodes.SingleQuote) {
            this.state = $3ae552344e829693$var$State.InAttributeValueSq;
            this.sectionStart = this.index + 1;
        } else if (!$3ae552344e829693$var$isWhitespace(c)) {
            this.sectionStart = this.index;
            this.state = $3ae552344e829693$var$State.InAttributeValueNq;
            this.stateInAttributeValueNoQuotes(c); // Reconsume token
        }
    }
    handleInAttributeValue(c, quote) {
        if (c === quote || !this.decodeEntities && this.fastForwardTo(quote)) {
            this.cbs.onattribdata(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.cbs.onattribend(quote === $3ae552344e829693$var$CharCodes.DoubleQuote ? $3ae552344e829693$export$cbf5509cea2ad22.Double : $3ae552344e829693$export$cbf5509cea2ad22.Single, this.index);
            this.state = $3ae552344e829693$var$State.BeforeAttributeName;
        } else if (this.decodeEntities && c === $3ae552344e829693$var$CharCodes.Amp) {
            this.baseState = this.state;
            this.state = $3ae552344e829693$var$State.BeforeEntity;
        }
    }
    stateInAttributeValueDoubleQuotes(c) {
        this.handleInAttributeValue(c, $3ae552344e829693$var$CharCodes.DoubleQuote);
    }
    stateInAttributeValueSingleQuotes(c) {
        this.handleInAttributeValue(c, $3ae552344e829693$var$CharCodes.SingleQuote);
    }
    stateInAttributeValueNoQuotes(c) {
        if ($3ae552344e829693$var$isWhitespace(c) || c === $3ae552344e829693$var$CharCodes.Gt) {
            this.cbs.onattribdata(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.cbs.onattribend($3ae552344e829693$export$cbf5509cea2ad22.Unquoted, this.index);
            this.state = $3ae552344e829693$var$State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        } else if (this.decodeEntities && c === $3ae552344e829693$var$CharCodes.Amp) {
            this.baseState = this.state;
            this.state = $3ae552344e829693$var$State.BeforeEntity;
        }
    }
    stateBeforeDeclaration(c) {
        if (c === $3ae552344e829693$var$CharCodes.OpeningSquareBracket) {
            this.state = $3ae552344e829693$var$State.CDATASequence;
            this.sequenceIndex = 0;
        } else this.state = c === $3ae552344e829693$var$CharCodes.Dash ? $3ae552344e829693$var$State.BeforeComment : $3ae552344e829693$var$State.InDeclaration;
    }
    stateInDeclaration(c) {
        if (c === $3ae552344e829693$var$CharCodes.Gt || this.fastForwardTo($3ae552344e829693$var$CharCodes.Gt)) {
            this.cbs.ondeclaration(this.sectionStart, this.index);
            this.state = $3ae552344e829693$var$State.Text;
            this.sectionStart = this.index + 1;
        }
    }
    stateInProcessingInstruction(c) {
        if (c === $3ae552344e829693$var$CharCodes.Gt || this.fastForwardTo($3ae552344e829693$var$CharCodes.Gt)) {
            this.cbs.onprocessinginstruction(this.sectionStart, this.index);
            this.state = $3ae552344e829693$var$State.Text;
            this.sectionStart = this.index + 1;
        }
    }
    stateBeforeComment(c) {
        if (c === $3ae552344e829693$var$CharCodes.Dash) {
            this.state = $3ae552344e829693$var$State.InCommentLike;
            this.currentSequence = $3ae552344e829693$var$Sequences.CommentEnd;
            // Allow short comments (eg. <!-->)
            this.sequenceIndex = 2;
            this.sectionStart = this.index + 1;
        } else this.state = $3ae552344e829693$var$State.InDeclaration;
    }
    stateInSpecialComment(c) {
        if (c === $3ae552344e829693$var$CharCodes.Gt || this.fastForwardTo($3ae552344e829693$var$CharCodes.Gt)) {
            this.cbs.oncomment(this.sectionStart, this.index, 0);
            this.state = $3ae552344e829693$var$State.Text;
            this.sectionStart = this.index + 1;
        }
    }
    stateBeforeSpecialS(c) {
        const lower = c | 0x20;
        if (lower === $3ae552344e829693$var$Sequences.ScriptEnd[3]) this.startSpecial($3ae552344e829693$var$Sequences.ScriptEnd, 4);
        else if (lower === $3ae552344e829693$var$Sequences.StyleEnd[3]) this.startSpecial($3ae552344e829693$var$Sequences.StyleEnd, 4);
        else {
            this.state = $3ae552344e829693$var$State.InTagName;
            this.stateInTagName(c); // Consume the token again
        }
    }
    stateBeforeEntity(c) {
        // Start excess with 1 to include the '&'
        this.entityExcess = 1;
        this.entityResult = 0;
        if (c === $3ae552344e829693$var$CharCodes.Number) this.state = $3ae552344e829693$var$State.BeforeNumericEntity;
        else if (c === $3ae552344e829693$var$CharCodes.Amp) ;
        else {
            this.trieIndex = 0;
            this.trieCurrent = this.entityTrie[0];
            this.state = $3ae552344e829693$var$State.InNamedEntity;
            this.stateInNamedEntity(c);
        }
    }
    stateInNamedEntity(c) {
        this.entityExcess += 1;
        this.trieIndex = (0, $6fcae538d5f03b31$exports.determineBranch)(this.entityTrie, this.trieCurrent, this.trieIndex + 1, c);
        if (this.trieIndex < 0) {
            this.emitNamedEntity();
            this.index--;
            return;
        }
        this.trieCurrent = this.entityTrie[this.trieIndex];
        const masked = this.trieCurrent & (0, $6fcae538d5f03b31$exports.BinTrieFlags).VALUE_LENGTH;
        // If the branch is a value, store it and continue
        if (masked) {
            // The mask is the number of bytes of the value, including the current byte.
            const valueLength = (masked >> 14) - 1;
            // If we have a legacy entity while parsing strictly, just skip the number of bytes
            if (!this.allowLegacyEntity() && c !== $3ae552344e829693$var$CharCodes.Semi) this.trieIndex += valueLength;
            else {
                // Add 1 as we have already incremented the excess
                const entityStart = this.index - this.entityExcess + 1;
                if (entityStart > this.sectionStart) this.emitPartial(this.sectionStart, entityStart);
                // If this is a surrogate pair, consume the next two bytes
                this.entityResult = this.trieIndex;
                this.trieIndex += valueLength;
                this.entityExcess = 0;
                this.sectionStart = this.index + 1;
                if (valueLength === 0) this.emitNamedEntity();
            }
        }
    }
    emitNamedEntity() {
        this.state = this.baseState;
        if (this.entityResult === 0) return;
        const valueLength = (this.entityTrie[this.entityResult] & (0, $6fcae538d5f03b31$exports.BinTrieFlags).VALUE_LENGTH) >> 14;
        switch(valueLength){
            case 1:
                this.emitCodePoint(this.entityTrie[this.entityResult] & ~(0, $6fcae538d5f03b31$exports.BinTrieFlags).VALUE_LENGTH);
                break;
            case 2:
                this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
                break;
            case 3:
                this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
                this.emitCodePoint(this.entityTrie[this.entityResult + 2]);
        }
    }
    stateBeforeNumericEntity(c) {
        if ((c | 0x20) === $3ae552344e829693$var$CharCodes.LowerX) {
            this.entityExcess++;
            this.state = $3ae552344e829693$var$State.InHexEntity;
        } else {
            this.state = $3ae552344e829693$var$State.InNumericEntity;
            this.stateInNumericEntity(c);
        }
    }
    emitNumericEntity(strict) {
        const entityStart = this.index - this.entityExcess - 1;
        const numberStart = entityStart + 2 + Number(this.state === $3ae552344e829693$var$State.InHexEntity);
        if (numberStart !== this.index) {
            // Emit leading data if any
            if (entityStart > this.sectionStart) this.emitPartial(this.sectionStart, entityStart);
            this.sectionStart = this.index + Number(strict);
            this.emitCodePoint((0, $6fcae538d5f03b31$exports.replaceCodePoint)(this.entityResult));
        }
        this.state = this.baseState;
    }
    stateInNumericEntity(c) {
        if (c === $3ae552344e829693$var$CharCodes.Semi) this.emitNumericEntity(true);
        else if ($3ae552344e829693$var$isNumber(c)) {
            this.entityResult = this.entityResult * 10 + (c - $3ae552344e829693$var$CharCodes.Zero);
            this.entityExcess++;
        } else {
            if (this.allowLegacyEntity()) this.emitNumericEntity(false);
            else this.state = this.baseState;
            this.index--;
        }
    }
    stateInHexEntity(c) {
        if (c === $3ae552344e829693$var$CharCodes.Semi) this.emitNumericEntity(true);
        else if ($3ae552344e829693$var$isNumber(c)) {
            this.entityResult = this.entityResult * 16 + (c - $3ae552344e829693$var$CharCodes.Zero);
            this.entityExcess++;
        } else if ($3ae552344e829693$var$isHexDigit(c)) {
            this.entityResult = this.entityResult * 16 + ((c | 0x20) - $3ae552344e829693$var$CharCodes.LowerA + 10);
            this.entityExcess++;
        } else {
            if (this.allowLegacyEntity()) this.emitNumericEntity(false);
            else this.state = this.baseState;
            this.index--;
        }
    }
    allowLegacyEntity() {
        return !this.xmlMode && (this.baseState === $3ae552344e829693$var$State.Text || this.baseState === $3ae552344e829693$var$State.InSpecialTag);
    }
    /**
     * Remove data that has already been consumed from the buffer.
     */ cleanup() {
        // If we are inside of text or attributes, emit what we already have.
        if (this.running && this.sectionStart !== this.index) {
            if (this.state === $3ae552344e829693$var$State.Text || this.state === $3ae552344e829693$var$State.InSpecialTag && this.sequenceIndex === 0) {
                this.cbs.ontext(this.sectionStart, this.index);
                this.sectionStart = this.index;
            } else if (this.state === $3ae552344e829693$var$State.InAttributeValueDq || this.state === $3ae552344e829693$var$State.InAttributeValueSq || this.state === $3ae552344e829693$var$State.InAttributeValueNq) {
                this.cbs.onattribdata(this.sectionStart, this.index);
                this.sectionStart = this.index;
            }
        }
    }
    shouldContinue() {
        return this.index < this.buffer.length + this.offset && this.running;
    }
    /**
     * Iterates through the buffer, calling the function corresponding to the current state.
     *
     * States that are more likely to be hit are higher up, as a performance improvement.
     */ parse() {
        while(this.shouldContinue()){
            const c = this.buffer.charCodeAt(this.index - this.offset);
            switch(this.state){
                case $3ae552344e829693$var$State.Text:
                    this.stateText(c);
                    break;
                case $3ae552344e829693$var$State.SpecialStartSequence:
                    this.stateSpecialStartSequence(c);
                    break;
                case $3ae552344e829693$var$State.InSpecialTag:
                    this.stateInSpecialTag(c);
                    break;
                case $3ae552344e829693$var$State.CDATASequence:
                    this.stateCDATASequence(c);
                    break;
                case $3ae552344e829693$var$State.InAttributeValueDq:
                    this.stateInAttributeValueDoubleQuotes(c);
                    break;
                case $3ae552344e829693$var$State.InAttributeName:
                    this.stateInAttributeName(c);
                    break;
                case $3ae552344e829693$var$State.InCommentLike:
                    this.stateInCommentLike(c);
                    break;
                case $3ae552344e829693$var$State.InSpecialComment:
                    this.stateInSpecialComment(c);
                    break;
                case $3ae552344e829693$var$State.BeforeAttributeName:
                    this.stateBeforeAttributeName(c);
                    break;
                case $3ae552344e829693$var$State.InTagName:
                    this.stateInTagName(c);
                    break;
                case $3ae552344e829693$var$State.InClosingTagName:
                    this.stateInClosingTagName(c);
                    break;
                case $3ae552344e829693$var$State.BeforeTagName:
                    this.stateBeforeTagName(c);
                    break;
                case $3ae552344e829693$var$State.AfterAttributeName:
                    this.stateAfterAttributeName(c);
                    break;
                case $3ae552344e829693$var$State.InAttributeValueSq:
                    this.stateInAttributeValueSingleQuotes(c);
                    break;
                case $3ae552344e829693$var$State.BeforeAttributeValue:
                    this.stateBeforeAttributeValue(c);
                    break;
                case $3ae552344e829693$var$State.BeforeClosingTagName:
                    this.stateBeforeClosingTagName(c);
                    break;
                case $3ae552344e829693$var$State.AfterClosingTagName:
                    this.stateAfterClosingTagName(c);
                    break;
                case $3ae552344e829693$var$State.BeforeSpecialS:
                    this.stateBeforeSpecialS(c);
                    break;
                case $3ae552344e829693$var$State.InAttributeValueNq:
                    this.stateInAttributeValueNoQuotes(c);
                    break;
                case $3ae552344e829693$var$State.InSelfClosingTag:
                    this.stateInSelfClosingTag(c);
                    break;
                case $3ae552344e829693$var$State.InDeclaration:
                    this.stateInDeclaration(c);
                    break;
                case $3ae552344e829693$var$State.BeforeDeclaration:
                    this.stateBeforeDeclaration(c);
                    break;
                case $3ae552344e829693$var$State.BeforeComment:
                    this.stateBeforeComment(c);
                    break;
                case $3ae552344e829693$var$State.InProcessingInstruction:
                    this.stateInProcessingInstruction(c);
                    break;
                case $3ae552344e829693$var$State.InNamedEntity:
                    this.stateInNamedEntity(c);
                    break;
                case $3ae552344e829693$var$State.BeforeEntity:
                    this.stateBeforeEntity(c);
                    break;
                case $3ae552344e829693$var$State.InHexEntity:
                    this.stateInHexEntity(c);
                    break;
                case $3ae552344e829693$var$State.InNumericEntity:
                    this.stateInNumericEntity(c);
                    break;
                default:
                    // `this._state === State.BeforeNumericEntity`
                    this.stateBeforeNumericEntity(c);
            }
            this.index++;
        }
        this.cleanup();
    }
    finish() {
        if (this.state === $3ae552344e829693$var$State.InNamedEntity) this.emitNamedEntity();
        // If there is remaining data, emit it in a reasonable way
        if (this.sectionStart < this.index) this.handleTrailingData();
        this.cbs.onend();
    }
    /** Handle any trailing data. */ handleTrailingData() {
        const endIndex = this.buffer.length + this.offset;
        if (this.state === $3ae552344e829693$var$State.InCommentLike) {
            if (this.currentSequence === $3ae552344e829693$var$Sequences.CdataEnd) this.cbs.oncdata(this.sectionStart, endIndex, 0);
            else this.cbs.oncomment(this.sectionStart, endIndex, 0);
        } else if (this.state === $3ae552344e829693$var$State.InNumericEntity && this.allowLegacyEntity()) this.emitNumericEntity(false);
        else if (this.state === $3ae552344e829693$var$State.InHexEntity && this.allowLegacyEntity()) this.emitNumericEntity(false);
        else if (this.state === $3ae552344e829693$var$State.InTagName || this.state === $3ae552344e829693$var$State.BeforeAttributeName || this.state === $3ae552344e829693$var$State.BeforeAttributeValue || this.state === $3ae552344e829693$var$State.AfterAttributeName || this.state === $3ae552344e829693$var$State.InAttributeName || this.state === $3ae552344e829693$var$State.InAttributeValueSq || this.state === $3ae552344e829693$var$State.InAttributeValueDq || this.state === $3ae552344e829693$var$State.InAttributeValueNq || this.state === $3ae552344e829693$var$State.InClosingTagName) ;
        else this.cbs.ontext(this.sectionStart, endIndex);
    }
    emitPartial(start, endIndex) {
        if (this.baseState !== $3ae552344e829693$var$State.Text && this.baseState !== $3ae552344e829693$var$State.InSpecialTag) this.cbs.onattribdata(start, endIndex);
        else this.cbs.ontext(start, endIndex);
    }
    emitCodePoint(cp) {
        if (this.baseState !== $3ae552344e829693$var$State.Text && this.baseState !== $3ae552344e829693$var$State.InSpecialTag) this.cbs.onattribentity(cp);
        else this.cbs.ontextentity(cp);
    }
}



const $0ab8478bff8d2345$var$formTags = new Set([
    "input",
    "option",
    "optgroup",
    "select",
    "button",
    "datalist",
    "textarea"
]);
const $0ab8478bff8d2345$var$pTag = new Set([
    "p"
]);
const $0ab8478bff8d2345$var$tableSectionTags = new Set([
    "thead",
    "tbody"
]);
const $0ab8478bff8d2345$var$ddtTags = new Set([
    "dd",
    "dt"
]);
const $0ab8478bff8d2345$var$rtpTags = new Set([
    "rt",
    "rp"
]);
const $0ab8478bff8d2345$var$openImpliesClose = new Map([
    [
        "tr",
        new Set([
            "tr",
            "th",
            "td"
        ])
    ],
    [
        "th",
        new Set([
            "th"
        ])
    ],
    [
        "td",
        new Set([
            "thead",
            "th",
            "td"
        ])
    ],
    [
        "body",
        new Set([
            "head",
            "link",
            "script"
        ])
    ],
    [
        "li",
        new Set([
            "li"
        ])
    ],
    [
        "p",
        $0ab8478bff8d2345$var$pTag
    ],
    [
        "h1",
        $0ab8478bff8d2345$var$pTag
    ],
    [
        "h2",
        $0ab8478bff8d2345$var$pTag
    ],
    [
        "h3",
        $0ab8478bff8d2345$var$pTag
    ],
    [
        "h4",
        $0ab8478bff8d2345$var$pTag
    ],
    [
        "h5",
        $0ab8478bff8d2345$var$pTag
    ],
    [
        "h6",
        $0ab8478bff8d2345$var$pTag
    ],
    [
        "select",
        $0ab8478bff8d2345$var$formTags
    ],
    [
        "input",
        $0ab8478bff8d2345$var$formTags
    ],
    [
        "output",
        $0ab8478bff8d2345$var$formTags
    ],
    [
        "button",
        $0ab8478bff8d2345$var$formTags
    ],
    [
        "datalist",
        $0ab8478bff8d2345$var$formTags
    ],
    [
        "textarea",
        $0ab8478bff8d2345$var$formTags
    ],
    [
        "option",
        new Set([
            "option"
        ])
    ],
    [
        "optgroup",
        new Set([
            "optgroup",
            "option"
        ])
    ],
    [
        "dd",
        $0ab8478bff8d2345$var$ddtTags
    ],
    [
        "dt",
        $0ab8478bff8d2345$var$ddtTags
    ],
    [
        "address",
        $0ab8478bff8d2345$var$pTag
    ],
    [
        "article",
        $0ab8478bff8d2345$var$pTag
    ],
    [
        "aside",
        $0ab8478bff8d2345$var$pTag
    ],
    [
        "blockquote",
        $0ab8478bff8d2345$var$pTag
    ],
    [
        "details",
        $0ab8478bff8d2345$var$pTag
    ],
    [
        "div",
        $0ab8478bff8d2345$var$pTag
    ],
    [
        "dl",
        $0ab8478bff8d2345$var$pTag
    ],
    [
        "fieldset",
        $0ab8478bff8d2345$var$pTag
    ],
    [
        "figcaption",
        $0ab8478bff8d2345$var$pTag
    ],
    [
        "figure",
        $0ab8478bff8d2345$var$pTag
    ],
    [
        "footer",
        $0ab8478bff8d2345$var$pTag
    ],
    [
        "form",
        $0ab8478bff8d2345$var$pTag
    ],
    [
        "header",
        $0ab8478bff8d2345$var$pTag
    ],
    [
        "hr",
        $0ab8478bff8d2345$var$pTag
    ],
    [
        "main",
        $0ab8478bff8d2345$var$pTag
    ],
    [
        "nav",
        $0ab8478bff8d2345$var$pTag
    ],
    [
        "ol",
        $0ab8478bff8d2345$var$pTag
    ],
    [
        "pre",
        $0ab8478bff8d2345$var$pTag
    ],
    [
        "section",
        $0ab8478bff8d2345$var$pTag
    ],
    [
        "table",
        $0ab8478bff8d2345$var$pTag
    ],
    [
        "ul",
        $0ab8478bff8d2345$var$pTag
    ],
    [
        "rt",
        $0ab8478bff8d2345$var$rtpTags
    ],
    [
        "rp",
        $0ab8478bff8d2345$var$rtpTags
    ],
    [
        "tbody",
        $0ab8478bff8d2345$var$tableSectionTags
    ],
    [
        "tfoot",
        $0ab8478bff8d2345$var$tableSectionTags
    ]
]);
const $0ab8478bff8d2345$var$voidElements = new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
]);
const $0ab8478bff8d2345$var$foreignContextElements = new Set([
    "math",
    "svg"
]);
const $0ab8478bff8d2345$var$htmlIntegrationElements = new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignobject",
    "desc",
    "title"
]);
const $0ab8478bff8d2345$var$reNameEnd = /\s|\//;
class $0ab8478bff8d2345$export$7acfa6ed01010e37 {
    constructor(cbs, options = {}){
        var _a, _b, _c, _d, _e;
        this.options = options;
        /** The start index of the last event. */ this.startIndex = 0;
        /** The end index of the last event. */ this.endIndex = 0;
        /**
         * Store the start index of the current open tag,
         * so we can update the start index for attributes.
         */ this.openTagStart = 0;
        this.tagname = "";
        this.attribname = "";
        this.attribvalue = "";
        this.attribs = null;
        this.stack = [];
        this.foreignContext = [];
        this.buffers = [];
        this.bufferOffset = 0;
        /** The index of the last written buffer. Used when resuming after a `pause()`. */ this.writeIndex = 0;
        /** Indicates whether the parser has finished running / `.end` has been called. */ this.ended = false;
        this.cbs = cbs !== null && cbs !== void 0 ? cbs : {};
        this.lowerCaseTagNames = (_a = options.lowerCaseTags) !== null && _a !== void 0 ? _a : !options.xmlMode;
        this.lowerCaseAttributeNames = (_b = options.lowerCaseAttributeNames) !== null && _b !== void 0 ? _b : !options.xmlMode;
        this.tokenizer = new ((_c = options.Tokenizer) !== null && _c !== void 0 ? _c : (0, $3ae552344e829693$export$2e2bcd8739ae039))(this.options, this);
        (_e = (_d = this.cbs).onparserinit) === null || _e === void 0 || _e.call(_d, this);
    }
    // Tokenizer event handlers
    /** @internal */ ontext(start, endIndex) {
        var _a, _b;
        const data = this.getSlice(start, endIndex);
        this.endIndex = endIndex - 1;
        (_b = (_a = this.cbs).ontext) === null || _b === void 0 || _b.call(_a, data);
        this.startIndex = endIndex;
    }
    /** @internal */ ontextentity(cp) {
        var _a, _b;
        /*
         * Entities can be emitted on the character, or directly after.
         * We use the section start here to get accurate indices.
         */ const index = this.tokenizer.getSectionStart();
        this.endIndex = index - 1;
        (_b = (_a = this.cbs).ontext) === null || _b === void 0 || _b.call(_a, (0, $6fcae538d5f03b31$exports.fromCodePoint)(cp));
        this.startIndex = index;
    }
    isVoidElement(name) {
        return !this.options.xmlMode && $0ab8478bff8d2345$var$voidElements.has(name);
    }
    /** @internal */ onopentagname(start, endIndex) {
        this.endIndex = endIndex;
        let name = this.getSlice(start, endIndex);
        if (this.lowerCaseTagNames) name = name.toLowerCase();
        this.emitOpenTag(name);
    }
    emitOpenTag(name) {
        var _a, _b, _c, _d;
        this.openTagStart = this.startIndex;
        this.tagname = name;
        const impliesClose = !this.options.xmlMode && $0ab8478bff8d2345$var$openImpliesClose.get(name);
        if (impliesClose) while(this.stack.length > 0 && impliesClose.has(this.stack[this.stack.length - 1])){
            const element = this.stack.pop();
            (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 || _b.call(_a, element, true);
        }
        if (!this.isVoidElement(name)) {
            this.stack.push(name);
            if ($0ab8478bff8d2345$var$foreignContextElements.has(name)) this.foreignContext.push(true);
            else if ($0ab8478bff8d2345$var$htmlIntegrationElements.has(name)) this.foreignContext.push(false);
        }
        (_d = (_c = this.cbs).onopentagname) === null || _d === void 0 || _d.call(_c, name);
        if (this.cbs.onopentag) this.attribs = {};
    }
    endOpenTag(isImplied) {
        var _a, _b;
        this.startIndex = this.openTagStart;
        if (this.attribs) {
            (_b = (_a = this.cbs).onopentag) === null || _b === void 0 || _b.call(_a, this.tagname, this.attribs, isImplied);
            this.attribs = null;
        }
        if (this.cbs.onclosetag && this.isVoidElement(this.tagname)) this.cbs.onclosetag(this.tagname, true);
        this.tagname = "";
    }
    /** @internal */ onopentagend(endIndex) {
        this.endIndex = endIndex;
        this.endOpenTag(false);
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ onclosetag(start, endIndex) {
        var _a, _b, _c, _d, _e, _f;
        this.endIndex = endIndex;
        let name = this.getSlice(start, endIndex);
        if (this.lowerCaseTagNames) name = name.toLowerCase();
        if ($0ab8478bff8d2345$var$foreignContextElements.has(name) || $0ab8478bff8d2345$var$htmlIntegrationElements.has(name)) this.foreignContext.pop();
        if (!this.isVoidElement(name)) {
            const pos = this.stack.lastIndexOf(name);
            if (pos !== -1) {
                if (this.cbs.onclosetag) {
                    let count = this.stack.length - pos;
                    while(count--)// We know the stack has sufficient elements.
                    this.cbs.onclosetag(this.stack.pop(), count !== 0);
                } else this.stack.length = pos;
            } else if (!this.options.xmlMode && name === "p") {
                // Implicit open before close
                this.emitOpenTag("p");
                this.closeCurrentTag(true);
            }
        } else if (!this.options.xmlMode && name === "br") {
            // We can't use `emitOpenTag` for implicit open, as `br` would be implicitly closed.
            (_b = (_a = this.cbs).onopentagname) === null || _b === void 0 || _b.call(_a, "br");
            (_d = (_c = this.cbs).onopentag) === null || _d === void 0 || _d.call(_c, "br", {}, true);
            (_f = (_e = this.cbs).onclosetag) === null || _f === void 0 || _f.call(_e, "br", false);
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ onselfclosingtag(endIndex) {
        this.endIndex = endIndex;
        if (this.options.xmlMode || this.options.recognizeSelfClosing || this.foreignContext[this.foreignContext.length - 1]) {
            this.closeCurrentTag(false);
            // Set `startIndex` for next node
            this.startIndex = endIndex + 1;
        } else // Ignore the fact that the tag is self-closing.
        this.onopentagend(endIndex);
    }
    closeCurrentTag(isOpenImplied) {
        var _a, _b;
        const name = this.tagname;
        this.endOpenTag(isOpenImplied);
        // Self-closing tags will be on the top of the stack
        if (this.stack[this.stack.length - 1] === name) {
            // If the opening tag isn't implied, the closing tag has to be implied.
            (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 || _b.call(_a, name, !isOpenImplied);
            this.stack.pop();
        }
    }
    /** @internal */ onattribname(start, endIndex) {
        this.startIndex = start;
        const name = this.getSlice(start, endIndex);
        this.attribname = this.lowerCaseAttributeNames ? name.toLowerCase() : name;
    }
    /** @internal */ onattribdata(start, endIndex) {
        this.attribvalue += this.getSlice(start, endIndex);
    }
    /** @internal */ onattribentity(cp) {
        this.attribvalue += (0, $6fcae538d5f03b31$exports.fromCodePoint)(cp);
    }
    /** @internal */ onattribend(quote, endIndex) {
        var _a, _b;
        this.endIndex = endIndex;
        (_b = (_a = this.cbs).onattribute) === null || _b === void 0 || _b.call(_a, this.attribname, this.attribvalue, quote === (0, $3ae552344e829693$export$cbf5509cea2ad22).Double ? '"' : quote === (0, $3ae552344e829693$export$cbf5509cea2ad22).Single ? "'" : quote === (0, $3ae552344e829693$export$cbf5509cea2ad22).NoValue ? undefined : null);
        if (this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname)) this.attribs[this.attribname] = this.attribvalue;
        this.attribvalue = "";
    }
    getInstructionName(value) {
        const index = value.search($0ab8478bff8d2345$var$reNameEnd);
        let name = index < 0 ? value : value.substr(0, index);
        if (this.lowerCaseTagNames) name = name.toLowerCase();
        return name;
    }
    /** @internal */ ondeclaration(start, endIndex) {
        this.endIndex = endIndex;
        const value = this.getSlice(start, endIndex);
        if (this.cbs.onprocessinginstruction) {
            const name = this.getInstructionName(value);
            this.cbs.onprocessinginstruction(`!${name}`, `!${value}`);
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ onprocessinginstruction(start, endIndex) {
        this.endIndex = endIndex;
        const value = this.getSlice(start, endIndex);
        if (this.cbs.onprocessinginstruction) {
            const name = this.getInstructionName(value);
            this.cbs.onprocessinginstruction(`?${name}`, `?${value}`);
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ oncomment(start, endIndex, offset) {
        var _a, _b, _c, _d;
        this.endIndex = endIndex;
        (_b = (_a = this.cbs).oncomment) === null || _b === void 0 || _b.call(_a, this.getSlice(start, endIndex - offset));
        (_d = (_c = this.cbs).oncommentend) === null || _d === void 0 || _d.call(_c);
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ oncdata(start, endIndex, offset) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        this.endIndex = endIndex;
        const value = this.getSlice(start, endIndex - offset);
        if (this.options.xmlMode || this.options.recognizeCDATA) {
            (_b = (_a = this.cbs).oncdatastart) === null || _b === void 0 || _b.call(_a);
            (_d = (_c = this.cbs).ontext) === null || _d === void 0 || _d.call(_c, value);
            (_f = (_e = this.cbs).oncdataend) === null || _f === void 0 || _f.call(_e);
        } else {
            (_h = (_g = this.cbs).oncomment) === null || _h === void 0 || _h.call(_g, `[CDATA[${value}]]`);
            (_k = (_j = this.cbs).oncommentend) === null || _k === void 0 || _k.call(_j);
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    }
    /** @internal */ onend() {
        var _a, _b;
        if (this.cbs.onclosetag) {
            // Set the end index for all remaining tags
            this.endIndex = this.startIndex;
            for(let index = this.stack.length; index > 0; this.cbs.onclosetag(this.stack[--index], true));
        }
        (_b = (_a = this.cbs).onend) === null || _b === void 0 || _b.call(_a);
    }
    /**
     * Resets the parser to a blank state, ready to parse a new HTML document
     */ reset() {
        var _a, _b, _c, _d;
        (_b = (_a = this.cbs).onreset) === null || _b === void 0 || _b.call(_a);
        this.tokenizer.reset();
        this.tagname = "";
        this.attribname = "";
        this.attribs = null;
        this.stack.length = 0;
        this.startIndex = 0;
        this.endIndex = 0;
        (_d = (_c = this.cbs).onparserinit) === null || _d === void 0 || _d.call(_c, this);
        this.buffers.length = 0;
        this.bufferOffset = 0;
        this.writeIndex = 0;
        this.ended = false;
    }
    /**
     * Resets the parser, then parses a complete document and
     * pushes it to the handler.
     *
     * @param data Document to parse.
     */ parseComplete(data) {
        this.reset();
        this.end(data);
    }
    getSlice(start, end) {
        while(start - this.bufferOffset >= this.buffers[0].length)this.shiftBuffer();
        let slice = this.buffers[0].slice(start - this.bufferOffset, end - this.bufferOffset);
        while(end - this.bufferOffset > this.buffers[0].length){
            this.shiftBuffer();
            slice += this.buffers[0].slice(0, end - this.bufferOffset);
        }
        return slice;
    }
    shiftBuffer() {
        this.bufferOffset += this.buffers[0].length;
        this.writeIndex--;
        this.buffers.shift();
    }
    /**
     * Parses a chunk of data and calls the corresponding callbacks.
     *
     * @param chunk Chunk to parse.
     */ write(chunk) {
        var _a, _b;
        if (this.ended) {
            (_b = (_a = this.cbs).onerror) === null || _b === void 0 || _b.call(_a, new Error(".write() after done!"));
            return;
        }
        this.buffers.push(chunk);
        if (this.tokenizer.running) {
            this.tokenizer.write(chunk);
            this.writeIndex++;
        }
    }
    /**
     * Parses the end of the buffer and clears the stack, calls onend.
     *
     * @param chunk Optional final chunk to parse.
     */ end(chunk) {
        var _a, _b;
        if (this.ended) {
            (_b = (_a = this.cbs).onerror) === null || _b === void 0 || _b.call(_a, new Error(".end() after done!"));
            return;
        }
        if (chunk) this.write(chunk);
        this.ended = true;
        this.tokenizer.end();
    }
    /**
     * Pauses parsing. The parser won't emit events until `resume` is called.
     */ pause() {
        this.tokenizer.pause();
    }
    /**
     * Resumes parsing after `pause` was called.
     */ resume() {
        this.tokenizer.resume();
        while(this.tokenizer.running && this.writeIndex < this.buffers.length)this.tokenizer.write(this.buffers[this.writeIndex++]);
        if (this.ended) this.tokenizer.end();
    }
    /**
     * Alias of `write`, for backwards compatibility.
     *
     * @param chunk Chunk to parse.
     * @deprecated
     */ parseChunk(chunk) {
        this.write(chunk);
    }
    /**
     * Alias of `end`, for backwards compatibility.
     *
     * @param chunk Optional final chunk to parse.
     * @deprecated
     */ done(chunk) {
        this.end(chunk);
    }
}


/** Types of elements found in htmlparser2's DOM */ var $39ef1bdf59853755$export$b992dc138d950e31;
(function(ElementType) {
    /** Type for the root element of a document */ ElementType["Root"] = "root";
    /** Type for Text */ ElementType["Text"] = "text";
    /** Type for <? ... ?> */ ElementType["Directive"] = "directive";
    /** Type for <!-- ... --> */ ElementType["Comment"] = "comment";
    /** Type for <script> tags */ ElementType["Script"] = "script";
    /** Type for <style> tags */ ElementType["Style"] = "style";
    /** Type for Any tag */ ElementType["Tag"] = "tag";
    /** Type for <![CDATA[ ... ]]> */ ElementType["CDATA"] = "cdata";
    /** Type for <!doctype ...> */ ElementType["Doctype"] = "doctype";
})($39ef1bdf59853755$export$b992dc138d950e31 || ($39ef1bdf59853755$export$b992dc138d950e31 = {}));
function $39ef1bdf59853755$export$3bf645f08efe3292(elem) {
    return elem.type === $39ef1bdf59853755$export$b992dc138d950e31.Tag || elem.type === $39ef1bdf59853755$export$b992dc138d950e31.Script || elem.type === $39ef1bdf59853755$export$b992dc138d950e31.Style;
}
const $39ef1bdf59853755$export$be92b6f5f03c0fe9 = $39ef1bdf59853755$export$b992dc138d950e31.Root;
const $39ef1bdf59853755$export$5f1af8db9871e1d6 = $39ef1bdf59853755$export$b992dc138d950e31.Text;
const $39ef1bdf59853755$export$befdefbdce210f91 = $39ef1bdf59853755$export$b992dc138d950e31.Directive;
const $39ef1bdf59853755$export$4d299b491347818a = $39ef1bdf59853755$export$b992dc138d950e31.Comment;
const $39ef1bdf59853755$export$2f8b47a141e57afc = $39ef1bdf59853755$export$b992dc138d950e31.Script;
const $39ef1bdf59853755$export$d9e45bc13d335801 = $39ef1bdf59853755$export$b992dc138d950e31.Style;
const $39ef1bdf59853755$export$3288d34c523a1192 = $39ef1bdf59853755$export$b992dc138d950e31.Tag;
const $39ef1bdf59853755$export$1f8b8f7e5c763232 = $39ef1bdf59853755$export$b992dc138d950e31.CDATA;
const $39ef1bdf59853755$export$31b44af36ff2c60f = $39ef1bdf59853755$export$b992dc138d950e31.Doctype;



class $48930c390439f17e$export$85c928794f8d04d4 {
    constructor(){
        /** Parent of the node */ this.parent = null;
        /** Previous sibling */ this.prev = null;
        /** Next sibling */ this.next = null;
        /** The start index of the node. Requires `withStartIndices` on the handler to be `true. */ this.startIndex = null;
        /** The end index of the node. Requires `withEndIndices` on the handler to be `true. */ this.endIndex = null;
    }
    // Read-write aliases for properties
    /**
     * Same as {@link parent}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get parentNode() {
        return this.parent;
    }
    set parentNode(parent) {
        this.parent = parent;
    }
    /**
     * Same as {@link prev}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get previousSibling() {
        return this.prev;
    }
    set previousSibling(prev) {
        this.prev = prev;
    }
    /**
     * Same as {@link next}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get nextSibling() {
        return this.next;
    }
    set nextSibling(next) {
        this.next = next;
    }
    /**
     * Clone this node, and optionally its children.
     *
     * @param recursive Clone child nodes as well.
     * @returns A clone of the node.
     */ cloneNode(recursive = false) {
        return $48930c390439f17e$export$ae8e35ea29ddac22(this, recursive);
    }
}
class $48930c390439f17e$export$c3569d91cd44d357 extends $48930c390439f17e$export$85c928794f8d04d4 {
    /**
     * @param data The content of the data node
     */ constructor(data){
        super();
        this.data = data;
    }
    /**
     * Same as {@link data}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get nodeValue() {
        return this.data;
    }
    set nodeValue(data) {
        this.data = data;
    }
}
class $48930c390439f17e$export$5f1af8db9871e1d6 extends $48930c390439f17e$export$c3569d91cd44d357 {
    constructor(){
        super(...arguments);
        this.type = (0, $39ef1bdf59853755$export$b992dc138d950e31).Text;
    }
    get nodeType() {
        return 3;
    }
}
class $48930c390439f17e$export$4d299b491347818a extends $48930c390439f17e$export$c3569d91cd44d357 {
    constructor(){
        super(...arguments);
        this.type = (0, $39ef1bdf59853755$export$b992dc138d950e31).Comment;
    }
    get nodeType() {
        return 8;
    }
}
class $48930c390439f17e$export$9269dce19ee35e96 extends $48930c390439f17e$export$c3569d91cd44d357 {
    constructor(name, data){
        super(data);
        this.name = name;
        this.type = (0, $39ef1bdf59853755$export$b992dc138d950e31).Directive;
    }
    get nodeType() {
        return 1;
    }
}
class $48930c390439f17e$export$62be934f90997196 extends $48930c390439f17e$export$85c928794f8d04d4 {
    /**
     * @param children Children of the node. Only certain node types can have children.
     */ constructor(children){
        super();
        this.children = children;
    }
    // Aliases
    /** First child of the node. */ get firstChild() {
        var _a;
        return (_a = this.children[0]) !== null && _a !== void 0 ? _a : null;
    }
    /** Last child of the node. */ get lastChild() {
        return this.children.length > 0 ? this.children[this.children.length - 1] : null;
    }
    /**
     * Same as {@link children}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get childNodes() {
        return this.children;
    }
    set childNodes(children) {
        this.children = children;
    }
}
class $48930c390439f17e$export$1f8b8f7e5c763232 extends $48930c390439f17e$export$62be934f90997196 {
    constructor(){
        super(...arguments);
        this.type = (0, $39ef1bdf59853755$export$b992dc138d950e31).CDATA;
    }
    get nodeType() {
        return 4;
    }
}
class $48930c390439f17e$export$b34a105447964f9f extends $48930c390439f17e$export$62be934f90997196 {
    constructor(){
        super(...arguments);
        this.type = (0, $39ef1bdf59853755$export$b992dc138d950e31).Root;
    }
    get nodeType() {
        return 9;
    }
}
class $48930c390439f17e$export$db77ccec0bb4ccac extends $48930c390439f17e$export$62be934f90997196 {
    /**
     * @param name Name of the tag, eg. `div`, `span`.
     * @param attribs Object mapping attribute names to attribute values.
     * @param children Children of the node.
     */ constructor(name, attribs, children = [], type = name === "script" ? (0, $39ef1bdf59853755$export$b992dc138d950e31).Script : name === "style" ? (0, $39ef1bdf59853755$export$b992dc138d950e31).Style : (0, $39ef1bdf59853755$export$b992dc138d950e31).Tag){
        super(children);
        this.name = name;
        this.attribs = attribs;
        this.type = type;
    }
    get nodeType() {
        return 1;
    }
    // DOM Level 1 aliases
    /**
     * Same as {@link name}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get tagName() {
        return this.name;
    }
    set tagName(name) {
        this.name = name;
    }
    get attributes() {
        return Object.keys(this.attribs).map((name)=>{
            var _a, _b;
            return {
                name: name,
                value: this.attribs[name],
                namespace: (_a = this["x-attribsNamespace"]) === null || _a === void 0 ? void 0 : _a[name],
                prefix: (_b = this["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name]
            };
        });
    }
}
function $48930c390439f17e$export$3bf645f08efe3292(node) {
    return (0, $39ef1bdf59853755$export$3bf645f08efe3292)(node);
}
function $48930c390439f17e$export$c2d65aed98d39b56(node) {
    return node.type === (0, $39ef1bdf59853755$export$b992dc138d950e31).CDATA;
}
function $48930c390439f17e$export$1879817ac5c922b7(node) {
    return node.type === (0, $39ef1bdf59853755$export$b992dc138d950e31).Text;
}
function $48930c390439f17e$export$3ab01370f5e64ac8(node) {
    return node.type === (0, $39ef1bdf59853755$export$b992dc138d950e31).Comment;
}
function $48930c390439f17e$export$4b5d79f26e0e3ad5(node) {
    return node.type === (0, $39ef1bdf59853755$export$b992dc138d950e31).Directive;
}
function $48930c390439f17e$export$62858bae88b53fd0(node) {
    return node.type === (0, $39ef1bdf59853755$export$b992dc138d950e31).Root;
}
function $48930c390439f17e$export$bd5ff50f0e53d41c(node) {
    return Object.prototype.hasOwnProperty.call(node, "children");
}
function $48930c390439f17e$export$ae8e35ea29ddac22(node, recursive = false) {
    let result;
    if ($48930c390439f17e$export$1879817ac5c922b7(node)) result = new $48930c390439f17e$export$5f1af8db9871e1d6(node.data);
    else if ($48930c390439f17e$export$3ab01370f5e64ac8(node)) result = new $48930c390439f17e$export$4d299b491347818a(node.data);
    else if ($48930c390439f17e$export$3bf645f08efe3292(node)) {
        const children = recursive ? $48930c390439f17e$var$cloneChildren(node.children) : [];
        const clone = new $48930c390439f17e$export$db77ccec0bb4ccac(node.name, {
            ...node.attribs
        }, children);
        children.forEach((child)=>child.parent = clone);
        if (node.namespace != null) clone.namespace = node.namespace;
        if (node["x-attribsNamespace"]) clone["x-attribsNamespace"] = {
            ...node["x-attribsNamespace"]
        };
        if (node["x-attribsPrefix"]) clone["x-attribsPrefix"] = {
            ...node["x-attribsPrefix"]
        };
        result = clone;
    } else if ($48930c390439f17e$export$c2d65aed98d39b56(node)) {
        const children = recursive ? $48930c390439f17e$var$cloneChildren(node.children) : [];
        const clone = new $48930c390439f17e$export$1f8b8f7e5c763232(children);
        children.forEach((child)=>child.parent = clone);
        result = clone;
    } else if ($48930c390439f17e$export$62858bae88b53fd0(node)) {
        const children = recursive ? $48930c390439f17e$var$cloneChildren(node.children) : [];
        const clone = new $48930c390439f17e$export$b34a105447964f9f(children);
        children.forEach((child)=>child.parent = clone);
        if (node["x-mode"]) clone["x-mode"] = node["x-mode"];
        result = clone;
    } else if ($48930c390439f17e$export$4b5d79f26e0e3ad5(node)) {
        const instruction = new $48930c390439f17e$export$9269dce19ee35e96(node.name, node.data);
        if (node["x-name"] != null) {
            instruction["x-name"] = node["x-name"];
            instruction["x-publicId"] = node["x-publicId"];
            instruction["x-systemId"] = node["x-systemId"];
        }
        result = instruction;
    } else throw new Error(`Not implemented yet: ${node.type}`);
    result.startIndex = node.startIndex;
    result.endIndex = node.endIndex;
    if (node.sourceCodeLocation != null) result.sourceCodeLocation = node.sourceCodeLocation;
    return result;
}
function $48930c390439f17e$var$cloneChildren(childs) {
    const children = childs.map((child)=>$48930c390439f17e$export$ae8e35ea29ddac22(child, true));
    for(let i = 1; i < children.length; i++){
        children[i].prev = children[i - 1];
        children[i - 1].next = children[i];
    }
    return children;
}


// Default options
const $07850bf084fc48f7$var$defaultOpts = {
    withStartIndices: false,
    withEndIndices: false,
    xmlMode: false
};
class $07850bf084fc48f7$export$ff8ccbac9225de62 {
    /**
     * @param callback Called once parsing has completed.
     * @param options Settings for the handler.
     * @param elementCB Callback whenever a tag is closed.
     */ constructor(callback, options, elementCB){
        /** The elements of the DOM */ this.dom = [];
        /** The root element for the DOM */ this.root = new (0, $48930c390439f17e$export$b34a105447964f9f)(this.dom);
        /** Indicated whether parsing has been completed. */ this.done = false;
        /** Stack of open tags. */ this.tagStack = [
            this.root
        ];
        /** A data node that is still being written to. */ this.lastNode = null;
        /** Reference to the parser instance. Used for location information. */ this.parser = null;
        // Make it possible to skip arguments, for backwards-compatibility
        if (typeof options === "function") {
            elementCB = options;
            options = $07850bf084fc48f7$var$defaultOpts;
        }
        if (typeof callback === "object") {
            options = callback;
            callback = undefined;
        }
        this.callback = callback !== null && callback !== void 0 ? callback : null;
        this.options = options !== null && options !== void 0 ? options : $07850bf084fc48f7$var$defaultOpts;
        this.elementCB = elementCB !== null && elementCB !== void 0 ? elementCB : null;
    }
    onparserinit(parser) {
        this.parser = parser;
    }
    // Resets the handler back to starting state
    onreset() {
        this.dom = [];
        this.root = new (0, $48930c390439f17e$export$b34a105447964f9f)(this.dom);
        this.done = false;
        this.tagStack = [
            this.root
        ];
        this.lastNode = null;
        this.parser = null;
    }
    // Signals the handler that parsing is done
    onend() {
        if (this.done) return;
        this.done = true;
        this.parser = null;
        this.handleCallback(null);
    }
    onerror(error) {
        this.handleCallback(error);
    }
    onclosetag() {
        this.lastNode = null;
        const elem = this.tagStack.pop();
        if (this.options.withEndIndices) elem.endIndex = this.parser.endIndex;
        if (this.elementCB) this.elementCB(elem);
    }
    onopentag(name, attribs) {
        const type = this.options.xmlMode ? (0, $39ef1bdf59853755$export$b992dc138d950e31).Tag : undefined;
        const element = new (0, $48930c390439f17e$export$db77ccec0bb4ccac)(name, attribs, undefined, type);
        this.addNode(element);
        this.tagStack.push(element);
    }
    ontext(data) {
        const { lastNode: lastNode } = this;
        if (lastNode && lastNode.type === (0, $39ef1bdf59853755$export$b992dc138d950e31).Text) {
            lastNode.data += data;
            if (this.options.withEndIndices) lastNode.endIndex = this.parser.endIndex;
        } else {
            const node = new (0, $48930c390439f17e$export$5f1af8db9871e1d6)(data);
            this.addNode(node);
            this.lastNode = node;
        }
    }
    oncomment(data) {
        if (this.lastNode && this.lastNode.type === (0, $39ef1bdf59853755$export$b992dc138d950e31).Comment) {
            this.lastNode.data += data;
            return;
        }
        const node = new (0, $48930c390439f17e$export$4d299b491347818a)(data);
        this.addNode(node);
        this.lastNode = node;
    }
    oncommentend() {
        this.lastNode = null;
    }
    oncdatastart() {
        const text = new (0, $48930c390439f17e$export$5f1af8db9871e1d6)("");
        const node = new (0, $48930c390439f17e$export$1f8b8f7e5c763232)([
            text
        ]);
        this.addNode(node);
        text.parent = node;
        this.lastNode = text;
    }
    oncdataend() {
        this.lastNode = null;
    }
    onprocessinginstruction(name, data) {
        const node = new (0, $48930c390439f17e$export$9269dce19ee35e96)(name, data);
        this.addNode(node);
    }
    handleCallback(error) {
        if (typeof this.callback === "function") this.callback(error, this.dom);
        else if (error) throw error;
    }
    addNode(node) {
        const parent = this.tagStack[this.tagStack.length - 1];
        const previousSibling = parent.children[parent.children.length - 1];
        if (this.options.withStartIndices) node.startIndex = this.parser.startIndex;
        if (this.options.withEndIndices) node.endIndex = this.parser.endIndex;
        parent.children.push(node);
        if (previousSibling) {
            node.prev = previousSibling;
            previousSibling.next = node;
        }
        node.parent = parent;
        this.lastNode = null;
    }
}
var $07850bf084fc48f7$export$2e2bcd8739ae039 = $07850bf084fc48f7$export$ff8ccbac9225de62;





/*
 * Module dependencies
 */ 
// Generated using scripts/write-decode-map.ts
var $3325d032405f9469$export$2e2bcd8739ae039 = new Uint16Array(// prettier-ignore
'\u1D41<\xd5\u0131\u028A\u049D\u057B\u05D0\u0675\u06DE\u07A2\u07D6\u080F\u0A4A\u0A91\u0DA1\u0E6D\u0F09\u0F26\u10CA\u1228\u12E1\u1415\u149D\u14C3\u14DF\u1525\0\0\0\0\0\0\u156B\u16CD\u198D\u1C12\u1DDD\u1F7E\u2060\u21B0\u228D\u23C0\u23FB\u2442\u2824\u2912\u2D08\u2E48\u2FCE\u3016\u32BA\u3639\u37AC\u38FE\u3A28\u3A71\u3AE0\u3B2E\u0800EMabcfglmnoprstu\\bfms\x7f\x84\x8b\x90\x95\x98\xa6\xb3\xb9\xc8\xcflig\u803B\xc6\u40C6P\u803B&\u4026cute\u803B\xc1\u40C1reve;\u4102\u0100iyx}rc\u803B\xc2\u40C2;\u4410r;\uC000\ud835\udd04rave\u803B\xc0\u40C0pha;\u4391acr;\u4100d;\u6A53\u0100gp\x9d\xa1on;\u4104f;\uC000\ud835\udd38plyFunction;\u6061ing\u803B\xc5\u40C5\u0100cs\xbe\xc3r;\uC000\ud835\udc9cign;\u6254ilde\u803B\xc3\u40C3ml\u803B\xc4\u40C4\u0400aceforsu\xe5\xfb\xfe\u0117\u011C\u0122\u0127\u012A\u0100cr\xea\xf2kslash;\u6216\u0176\xf6\xf8;\u6AE7ed;\u6306y;\u4411\u0180crt\u0105\u010B\u0114ause;\u6235noullis;\u612Ca;\u4392r;\uC000\ud835\udd05pf;\uC000\ud835\udd39eve;\u42D8c\xf2\u0113mpeq;\u624E\u0700HOacdefhilorsu\u014D\u0151\u0156\u0180\u019E\u01A2\u01B5\u01B7\u01BA\u01DC\u0215\u0273\u0278\u027Ecy;\u4427PY\u803B\xa9\u40A9\u0180cpy\u015D\u0162\u017Aute;\u4106\u0100;i\u0167\u0168\u62D2talDifferentialD;\u6145leys;\u612D\u0200aeio\u0189\u018E\u0194\u0198ron;\u410Cdil\u803B\xc7\u40C7rc;\u4108nint;\u6230ot;\u410A\u0100dn\u01A7\u01ADilla;\u40B8terDot;\u40B7\xf2\u017Fi;\u43A7rcle\u0200DMPT\u01C7\u01CB\u01D1\u01D6ot;\u6299inus;\u6296lus;\u6295imes;\u6297o\u0100cs\u01E2\u01F8kwiseContourIntegral;\u6232eCurly\u0100DQ\u0203\u020FoubleQuote;\u601Duote;\u6019\u0200lnpu\u021E\u0228\u0247\u0255on\u0100;e\u0225\u0226\u6237;\u6A74\u0180git\u022F\u0236\u023Aruent;\u6261nt;\u622FourIntegral;\u622E\u0100fr\u024C\u024E;\u6102oduct;\u6210nterClockwiseContourIntegral;\u6233oss;\u6A2Fcr;\uC000\ud835\udc9ep\u0100;C\u0284\u0285\u62D3ap;\u624D\u0580DJSZacefios\u02A0\u02AC\u02B0\u02B4\u02B8\u02CB\u02D7\u02E1\u02E6\u0333\u048D\u0100;o\u0179\u02A5trahd;\u6911cy;\u4402cy;\u4405cy;\u440F\u0180grs\u02BF\u02C4\u02C7ger;\u6021r;\u61A1hv;\u6AE4\u0100ay\u02D0\u02D5ron;\u410E;\u4414l\u0100;t\u02DD\u02DE\u6207a;\u4394r;\uC000\ud835\udd07\u0100af\u02EB\u0327\u0100cm\u02F0\u0322ritical\u0200ADGT\u0300\u0306\u0316\u031Ccute;\u40B4o\u0174\u030B\u030D;\u42D9bleAcute;\u42DDrave;\u4060ilde;\u42DCond;\u62C4ferentialD;\u6146\u0470\u033D\0\0\0\u0342\u0354\0\u0405f;\uC000\ud835\udd3b\u0180;DE\u0348\u0349\u034D\u40A8ot;\u60DCqual;\u6250ble\u0300CDLRUV\u0363\u0372\u0382\u03CF\u03E2\u03F8ontourIntegra\xec\u0239o\u0274\u0379\0\0\u037B\xbb\u0349nArrow;\u61D3\u0100eo\u0387\u03A4ft\u0180ART\u0390\u0396\u03A1rrow;\u61D0ightArrow;\u61D4e\xe5\u02CAng\u0100LR\u03AB\u03C4eft\u0100AR\u03B3\u03B9rrow;\u67F8ightArrow;\u67FAightArrow;\u67F9ight\u0100AT\u03D8\u03DErrow;\u61D2ee;\u62A8p\u0241\u03E9\0\0\u03EFrrow;\u61D1ownArrow;\u61D5erticalBar;\u6225n\u0300ABLRTa\u0412\u042A\u0430\u045E\u047F\u037Crrow\u0180;BU\u041D\u041E\u0422\u6193ar;\u6913pArrow;\u61F5reve;\u4311eft\u02D2\u043A\0\u0446\0\u0450ightVector;\u6950eeVector;\u695Eector\u0100;B\u0459\u045A\u61BDar;\u6956ight\u01D4\u0467\0\u0471eeVector;\u695Fector\u0100;B\u047A\u047B\u61C1ar;\u6957ee\u0100;A\u0486\u0487\u62A4rrow;\u61A7\u0100ct\u0492\u0497r;\uC000\ud835\udc9frok;\u4110\u0800NTacdfglmopqstux\u04BD\u04C0\u04C4\u04CB\u04DE\u04E2\u04E7\u04EE\u04F5\u0521\u052F\u0536\u0552\u055D\u0560\u0565G;\u414AH\u803B\xd0\u40D0cute\u803B\xc9\u40C9\u0180aiy\u04D2\u04D7\u04DCron;\u411Arc\u803B\xca\u40CA;\u442Dot;\u4116r;\uC000\ud835\udd08rave\u803B\xc8\u40C8ement;\u6208\u0100ap\u04FA\u04FEcr;\u4112ty\u0253\u0506\0\0\u0512mallSquare;\u65FBerySmallSquare;\u65AB\u0100gp\u0526\u052Aon;\u4118f;\uC000\ud835\udd3csilon;\u4395u\u0100ai\u053C\u0549l\u0100;T\u0542\u0543\u6A75ilde;\u6242librium;\u61CC\u0100ci\u0557\u055Ar;\u6130m;\u6A73a;\u4397ml\u803B\xcb\u40CB\u0100ip\u056A\u056Fsts;\u6203onentialE;\u6147\u0280cfios\u0585\u0588\u058D\u05B2\u05CCy;\u4424r;\uC000\ud835\udd09lled\u0253\u0597\0\0\u05A3mallSquare;\u65FCerySmallSquare;\u65AA\u0370\u05BA\0\u05BF\0\0\u05C4f;\uC000\ud835\udd3dAll;\u6200riertrf;\u6131c\xf2\u05CB\u0600JTabcdfgorst\u05E8\u05EC\u05EF\u05FA\u0600\u0612\u0616\u061B\u061D\u0623\u066C\u0672cy;\u4403\u803B>\u403Emma\u0100;d\u05F7\u05F8\u4393;\u43DCreve;\u411E\u0180eiy\u0607\u060C\u0610dil;\u4122rc;\u411C;\u4413ot;\u4120r;\uC000\ud835\udd0a;\u62D9pf;\uC000\ud835\udd3eeater\u0300EFGLST\u0635\u0644\u064E\u0656\u065B\u0666qual\u0100;L\u063E\u063F\u6265ess;\u62DBullEqual;\u6267reater;\u6AA2ess;\u6277lantEqual;\u6A7Eilde;\u6273cr;\uC000\ud835\udca2;\u626B\u0400Aacfiosu\u0685\u068B\u0696\u069B\u069E\u06AA\u06BE\u06CARDcy;\u442A\u0100ct\u0690\u0694ek;\u42C7;\u405Eirc;\u4124r;\u610ClbertSpace;\u610B\u01F0\u06AF\0\u06B2f;\u610DizontalLine;\u6500\u0100ct\u06C3\u06C5\xf2\u06A9rok;\u4126mp\u0144\u06D0\u06D8ownHum\xf0\u012Fqual;\u624F\u0700EJOacdfgmnostu\u06FA\u06FE\u0703\u0707\u070E\u071A\u071E\u0721\u0728\u0744\u0778\u078B\u078F\u0795cy;\u4415lig;\u4132cy;\u4401cute\u803B\xcd\u40CD\u0100iy\u0713\u0718rc\u803B\xce\u40CE;\u4418ot;\u4130r;\u6111rave\u803B\xcc\u40CC\u0180;ap\u0720\u072F\u073F\u0100cg\u0734\u0737r;\u412AinaryI;\u6148lie\xf3\u03DD\u01F4\u0749\0\u0762\u0100;e\u074D\u074E\u622C\u0100gr\u0753\u0758ral;\u622Bsection;\u62C2isible\u0100CT\u076C\u0772omma;\u6063imes;\u6062\u0180gpt\u077F\u0783\u0788on;\u412Ef;\uC000\ud835\udd40a;\u4399cr;\u6110ilde;\u4128\u01EB\u079A\0\u079Ecy;\u4406l\u803B\xcf\u40CF\u0280cfosu\u07AC\u07B7\u07BC\u07C2\u07D0\u0100iy\u07B1\u07B5rc;\u4134;\u4419r;\uC000\ud835\udd0dpf;\uC000\ud835\udd41\u01E3\u07C7\0\u07CCr;\uC000\ud835\udca5rcy;\u4408kcy;\u4404\u0380HJacfos\u07E4\u07E8\u07EC\u07F1\u07FD\u0802\u0808cy;\u4425cy;\u440Cppa;\u439A\u0100ey\u07F6\u07FBdil;\u4136;\u441Ar;\uC000\ud835\udd0epf;\uC000\ud835\udd42cr;\uC000\ud835\udca6\u0580JTaceflmost\u0825\u0829\u082C\u0850\u0863\u09B3\u09B8\u09C7\u09CD\u0A37\u0A47cy;\u4409\u803B<\u403C\u0280cmnpr\u0837\u083C\u0841\u0844\u084Dute;\u4139bda;\u439Bg;\u67EAlacetrf;\u6112r;\u619E\u0180aey\u0857\u085C\u0861ron;\u413Ddil;\u413B;\u441B\u0100fs\u0868\u0970t\u0500ACDFRTUVar\u087E\u08A9\u08B1\u08E0\u08E6\u08FC\u092F\u095B\u0390\u096A\u0100nr\u0883\u088FgleBracket;\u67E8row\u0180;BR\u0899\u089A\u089E\u6190ar;\u61E4ightArrow;\u61C6eiling;\u6308o\u01F5\u08B7\0\u08C3bleBracket;\u67E6n\u01D4\u08C8\0\u08D2eeVector;\u6961ector\u0100;B\u08DB\u08DC\u61C3ar;\u6959loor;\u630Aight\u0100AV\u08EF\u08F5rrow;\u6194ector;\u694E\u0100er\u0901\u0917e\u0180;AV\u0909\u090A\u0910\u62A3rrow;\u61A4ector;\u695Aiangle\u0180;BE\u0924\u0925\u0929\u62B2ar;\u69CFqual;\u62B4p\u0180DTV\u0937\u0942\u094CownVector;\u6951eeVector;\u6960ector\u0100;B\u0956\u0957\u61BFar;\u6958ector\u0100;B\u0965\u0966\u61BCar;\u6952ight\xe1\u039Cs\u0300EFGLST\u097E\u098B\u0995\u099D\u09A2\u09ADqualGreater;\u62DAullEqual;\u6266reater;\u6276ess;\u6AA1lantEqual;\u6A7Dilde;\u6272r;\uC000\ud835\udd0f\u0100;e\u09BD\u09BE\u62D8ftarrow;\u61DAidot;\u413F\u0180npw\u09D4\u0A16\u0A1Bg\u0200LRlr\u09DE\u09F7\u0A02\u0A10eft\u0100AR\u09E6\u09ECrrow;\u67F5ightArrow;\u67F7ightArrow;\u67F6eft\u0100ar\u03B3\u0A0Aight\xe1\u03BFight\xe1\u03CAf;\uC000\ud835\udd43er\u0100LR\u0A22\u0A2CeftArrow;\u6199ightArrow;\u6198\u0180cht\u0A3E\u0A40\u0A42\xf2\u084C;\u61B0rok;\u4141;\u626A\u0400acefiosu\u0A5A\u0A5D\u0A60\u0A77\u0A7C\u0A85\u0A8B\u0A8Ep;\u6905y;\u441C\u0100dl\u0A65\u0A6FiumSpace;\u605Flintrf;\u6133r;\uC000\ud835\udd10nusPlus;\u6213pf;\uC000\ud835\udd44c\xf2\u0A76;\u439C\u0480Jacefostu\u0AA3\u0AA7\u0AAD\u0AC0\u0B14\u0B19\u0D91\u0D97\u0D9Ecy;\u440Acute;\u4143\u0180aey\u0AB4\u0AB9\u0ABEron;\u4147dil;\u4145;\u441D\u0180gsw\u0AC7\u0AF0\u0B0Eative\u0180MTV\u0AD3\u0ADF\u0AE8ediumSpace;\u600Bhi\u0100cn\u0AE6\u0AD8\xeb\u0AD9eryThi\xee\u0AD9ted\u0100GL\u0AF8\u0B06reaterGreate\xf2\u0673essLes\xf3\u0A48Line;\u400Ar;\uC000\ud835\udd11\u0200Bnpt\u0B22\u0B28\u0B37\u0B3Areak;\u6060BreakingSpace;\u40A0f;\u6115\u0680;CDEGHLNPRSTV\u0B55\u0B56\u0B6A\u0B7C\u0BA1\u0BEB\u0C04\u0C5E\u0C84\u0CA6\u0CD8\u0D61\u0D85\u6AEC\u0100ou\u0B5B\u0B64ngruent;\u6262pCap;\u626DoubleVerticalBar;\u6226\u0180lqx\u0B83\u0B8A\u0B9Bement;\u6209ual\u0100;T\u0B92\u0B93\u6260ilde;\uC000\u2242\u0338ists;\u6204reater\u0380;EFGLST\u0BB6\u0BB7\u0BBD\u0BC9\u0BD3\u0BD8\u0BE5\u626Fqual;\u6271ullEqual;\uC000\u2267\u0338reater;\uC000\u226B\u0338ess;\u6279lantEqual;\uC000\u2A7E\u0338ilde;\u6275ump\u0144\u0BF2\u0BFDownHump;\uC000\u224E\u0338qual;\uC000\u224F\u0338e\u0100fs\u0C0A\u0C27tTriangle\u0180;BE\u0C1A\u0C1B\u0C21\u62EAar;\uC000\u29CF\u0338qual;\u62ECs\u0300;EGLST\u0C35\u0C36\u0C3C\u0C44\u0C4B\u0C58\u626Equal;\u6270reater;\u6278ess;\uC000\u226A\u0338lantEqual;\uC000\u2A7D\u0338ilde;\u6274ested\u0100GL\u0C68\u0C79reaterGreater;\uC000\u2AA2\u0338essLess;\uC000\u2AA1\u0338recedes\u0180;ES\u0C92\u0C93\u0C9B\u6280qual;\uC000\u2AAF\u0338lantEqual;\u62E0\u0100ei\u0CAB\u0CB9verseElement;\u620CghtTriangle\u0180;BE\u0CCB\u0CCC\u0CD2\u62EBar;\uC000\u29D0\u0338qual;\u62ED\u0100qu\u0CDD\u0D0CuareSu\u0100bp\u0CE8\u0CF9set\u0100;E\u0CF0\u0CF3\uC000\u228F\u0338qual;\u62E2erset\u0100;E\u0D03\u0D06\uC000\u2290\u0338qual;\u62E3\u0180bcp\u0D13\u0D24\u0D4Eset\u0100;E\u0D1B\u0D1E\uC000\u2282\u20D2qual;\u6288ceeds\u0200;EST\u0D32\u0D33\u0D3B\u0D46\u6281qual;\uC000\u2AB0\u0338lantEqual;\u62E1ilde;\uC000\u227F\u0338erset\u0100;E\u0D58\u0D5B\uC000\u2283\u20D2qual;\u6289ilde\u0200;EFT\u0D6E\u0D6F\u0D75\u0D7F\u6241qual;\u6244ullEqual;\u6247ilde;\u6249erticalBar;\u6224cr;\uC000\ud835\udca9ilde\u803B\xd1\u40D1;\u439D\u0700Eacdfgmoprstuv\u0DBD\u0DC2\u0DC9\u0DD5\u0DDB\u0DE0\u0DE7\u0DFC\u0E02\u0E20\u0E22\u0E32\u0E3F\u0E44lig;\u4152cute\u803B\xd3\u40D3\u0100iy\u0DCE\u0DD3rc\u803B\xd4\u40D4;\u441Eblac;\u4150r;\uC000\ud835\udd12rave\u803B\xd2\u40D2\u0180aei\u0DEE\u0DF2\u0DF6cr;\u414Cga;\u43A9cron;\u439Fpf;\uC000\ud835\udd46enCurly\u0100DQ\u0E0E\u0E1AoubleQuote;\u601Cuote;\u6018;\u6A54\u0100cl\u0E27\u0E2Cr;\uC000\ud835\udcaaash\u803B\xd8\u40D8i\u016C\u0E37\u0E3Cde\u803B\xd5\u40D5es;\u6A37ml\u803B\xd6\u40D6er\u0100BP\u0E4B\u0E60\u0100ar\u0E50\u0E53r;\u603Eac\u0100ek\u0E5A\u0E5C;\u63DEet;\u63B4arenthesis;\u63DC\u0480acfhilors\u0E7F\u0E87\u0E8A\u0E8F\u0E92\u0E94\u0E9D\u0EB0\u0EFCrtialD;\u6202y;\u441Fr;\uC000\ud835\udd13i;\u43A6;\u43A0usMinus;\u40B1\u0100ip\u0EA2\u0EADncareplan\xe5\u069Df;\u6119\u0200;eio\u0EB9\u0EBA\u0EE0\u0EE4\u6ABBcedes\u0200;EST\u0EC8\u0EC9\u0ECF\u0EDA\u627Aqual;\u6AAFlantEqual;\u627Cilde;\u627Eme;\u6033\u0100dp\u0EE9\u0EEEuct;\u620Fortion\u0100;a\u0225\u0EF9l;\u621D\u0100ci\u0F01\u0F06r;\uC000\ud835\udcab;\u43A8\u0200Ufos\u0F11\u0F16\u0F1B\u0F1FOT\u803B"\u4022r;\uC000\ud835\udd14pf;\u611Acr;\uC000\ud835\udcac\u0600BEacefhiorsu\u0F3E\u0F43\u0F47\u0F60\u0F73\u0FA7\u0FAA\u0FAD\u1096\u10A9\u10B4\u10BEarr;\u6910G\u803B\xae\u40AE\u0180cnr\u0F4E\u0F53\u0F56ute;\u4154g;\u67EBr\u0100;t\u0F5C\u0F5D\u61A0l;\u6916\u0180aey\u0F67\u0F6C\u0F71ron;\u4158dil;\u4156;\u4420\u0100;v\u0F78\u0F79\u611Cerse\u0100EU\u0F82\u0F99\u0100lq\u0F87\u0F8Eement;\u620Builibrium;\u61CBpEquilibrium;\u696Fr\xbb\u0F79o;\u43A1ght\u0400ACDFTUVa\u0FC1\u0FEB\u0FF3\u1022\u1028\u105B\u1087\u03D8\u0100nr\u0FC6\u0FD2gleBracket;\u67E9row\u0180;BL\u0FDC\u0FDD\u0FE1\u6192ar;\u61E5eftArrow;\u61C4eiling;\u6309o\u01F5\u0FF9\0\u1005bleBracket;\u67E7n\u01D4\u100A\0\u1014eeVector;\u695Dector\u0100;B\u101D\u101E\u61C2ar;\u6955loor;\u630B\u0100er\u102D\u1043e\u0180;AV\u1035\u1036\u103C\u62A2rrow;\u61A6ector;\u695Biangle\u0180;BE\u1050\u1051\u1055\u62B3ar;\u69D0qual;\u62B5p\u0180DTV\u1063\u106E\u1078ownVector;\u694FeeVector;\u695Cector\u0100;B\u1082\u1083\u61BEar;\u6954ector\u0100;B\u1091\u1092\u61C0ar;\u6953\u0100pu\u109B\u109Ef;\u611DndImplies;\u6970ightarrow;\u61DB\u0100ch\u10B9\u10BCr;\u611B;\u61B1leDelayed;\u69F4\u0680HOacfhimoqstu\u10E4\u10F1\u10F7\u10FD\u1119\u111E\u1151\u1156\u1161\u1167\u11B5\u11BB\u11BF\u0100Cc\u10E9\u10EEHcy;\u4429y;\u4428FTcy;\u442Ccute;\u415A\u0280;aeiy\u1108\u1109\u110E\u1113\u1117\u6ABCron;\u4160dil;\u415Erc;\u415C;\u4421r;\uC000\ud835\udd16ort\u0200DLRU\u112A\u1134\u113E\u1149ownArrow\xbb\u041EeftArrow\xbb\u089AightArrow\xbb\u0FDDpArrow;\u6191gma;\u43A3allCircle;\u6218pf;\uC000\ud835\udd4a\u0272\u116D\0\0\u1170t;\u621Aare\u0200;ISU\u117B\u117C\u1189\u11AF\u65A1ntersection;\u6293u\u0100bp\u118F\u119Eset\u0100;E\u1197\u1198\u628Fqual;\u6291erset\u0100;E\u11A8\u11A9\u6290qual;\u6292nion;\u6294cr;\uC000\ud835\udcaear;\u62C6\u0200bcmp\u11C8\u11DB\u1209\u120B\u0100;s\u11CD\u11CE\u62D0et\u0100;E\u11CD\u11D5qual;\u6286\u0100ch\u11E0\u1205eeds\u0200;EST\u11ED\u11EE\u11F4\u11FF\u627Bqual;\u6AB0lantEqual;\u627Dilde;\u627FTh\xe1\u0F8C;\u6211\u0180;es\u1212\u1213\u1223\u62D1rset\u0100;E\u121C\u121D\u6283qual;\u6287et\xbb\u1213\u0580HRSacfhiors\u123E\u1244\u1249\u1255\u125E\u1271\u1276\u129F\u12C2\u12C8\u12D1ORN\u803B\xde\u40DEADE;\u6122\u0100Hc\u124E\u1252cy;\u440By;\u4426\u0100bu\u125A\u125C;\u4009;\u43A4\u0180aey\u1265\u126A\u126Fron;\u4164dil;\u4162;\u4422r;\uC000\ud835\udd17\u0100ei\u127B\u1289\u01F2\u1280\0\u1287efore;\u6234a;\u4398\u0100cn\u128E\u1298kSpace;\uC000\u205F\u200ASpace;\u6009lde\u0200;EFT\u12AB\u12AC\u12B2\u12BC\u623Cqual;\u6243ullEqual;\u6245ilde;\u6248pf;\uC000\ud835\udd4bipleDot;\u60DB\u0100ct\u12D6\u12DBr;\uC000\ud835\udcafrok;\u4166\u0AE1\u12F7\u130E\u131A\u1326\0\u132C\u1331\0\0\0\0\0\u1338\u133D\u1377\u1385\0\u13FF\u1404\u140A\u1410\u0100cr\u12FB\u1301ute\u803B\xda\u40DAr\u0100;o\u1307\u1308\u619Fcir;\u6949r\u01E3\u1313\0\u1316y;\u440Eve;\u416C\u0100iy\u131E\u1323rc\u803B\xdb\u40DB;\u4423blac;\u4170r;\uC000\ud835\udd18rave\u803B\xd9\u40D9acr;\u416A\u0100di\u1341\u1369er\u0100BP\u1348\u135D\u0100ar\u134D\u1350r;\u405Fac\u0100ek\u1357\u1359;\u63DFet;\u63B5arenthesis;\u63DDon\u0100;P\u1370\u1371\u62C3lus;\u628E\u0100gp\u137B\u137Fon;\u4172f;\uC000\ud835\udd4c\u0400ADETadps\u1395\u13AE\u13B8\u13C4\u03E8\u13D2\u13D7\u13F3rrow\u0180;BD\u1150\u13A0\u13A4ar;\u6912ownArrow;\u61C5ownArrow;\u6195quilibrium;\u696Eee\u0100;A\u13CB\u13CC\u62A5rrow;\u61A5own\xe1\u03F3er\u0100LR\u13DE\u13E8eftArrow;\u6196ightArrow;\u6197i\u0100;l\u13F9\u13FA\u43D2on;\u43A5ing;\u416Ecr;\uC000\ud835\udcb0ilde;\u4168ml\u803B\xdc\u40DC\u0480Dbcdefosv\u1427\u142C\u1430\u1433\u143E\u1485\u148A\u1490\u1496ash;\u62ABar;\u6AEBy;\u4412ash\u0100;l\u143B\u143C\u62A9;\u6AE6\u0100er\u1443\u1445;\u62C1\u0180bty\u144C\u1450\u147Aar;\u6016\u0100;i\u144F\u1455cal\u0200BLST\u1461\u1465\u146A\u1474ar;\u6223ine;\u407Ceparator;\u6758ilde;\u6240ThinSpace;\u600Ar;\uC000\ud835\udd19pf;\uC000\ud835\udd4dcr;\uC000\ud835\udcb1dash;\u62AA\u0280cefos\u14A7\u14AC\u14B1\u14B6\u14BCirc;\u4174dge;\u62C0r;\uC000\ud835\udd1apf;\uC000\ud835\udd4ecr;\uC000\ud835\udcb2\u0200fios\u14CB\u14D0\u14D2\u14D8r;\uC000\ud835\udd1b;\u439Epf;\uC000\ud835\udd4fcr;\uC000\ud835\udcb3\u0480AIUacfosu\u14F1\u14F5\u14F9\u14FD\u1504\u150F\u1514\u151A\u1520cy;\u442Fcy;\u4407cy;\u442Ecute\u803B\xdd\u40DD\u0100iy\u1509\u150Drc;\u4176;\u442Br;\uC000\ud835\udd1cpf;\uC000\ud835\udd50cr;\uC000\ud835\udcb4ml;\u4178\u0400Hacdefos\u1535\u1539\u153F\u154B\u154F\u155D\u1560\u1564cy;\u4416cute;\u4179\u0100ay\u1544\u1549ron;\u417D;\u4417ot;\u417B\u01F2\u1554\0\u155BoWidt\xe8\u0AD9a;\u4396r;\u6128pf;\u6124cr;\uC000\ud835\udcb5\u0BE1\u1583\u158A\u1590\0\u15B0\u15B6\u15BF\0\0\0\0\u15C6\u15DB\u15EB\u165F\u166D\0\u1695\u169B\u16B2\u16B9\0\u16BEcute\u803B\xe1\u40E1reve;\u4103\u0300;Ediuy\u159C\u159D\u15A1\u15A3\u15A8\u15AD\u623E;\uC000\u223E\u0333;\u623Frc\u803B\xe2\u40E2te\u80BB\xb4\u0306;\u4430lig\u803B\xe6\u40E6\u0100;r\xb2\u15BA;\uC000\ud835\udd1erave\u803B\xe0\u40E0\u0100ep\u15CA\u15D6\u0100fp\u15CF\u15D4sym;\u6135\xe8\u15D3ha;\u43B1\u0100ap\u15DFc\u0100cl\u15E4\u15E7r;\u4101g;\u6A3F\u0264\u15F0\0\0\u160A\u0280;adsv\u15FA\u15FB\u15FF\u1601\u1607\u6227nd;\u6A55;\u6A5Clope;\u6A58;\u6A5A\u0380;elmrsz\u1618\u1619\u161B\u161E\u163F\u164F\u1659\u6220;\u69A4e\xbb\u1619sd\u0100;a\u1625\u1626\u6221\u0461\u1630\u1632\u1634\u1636\u1638\u163A\u163C\u163E;\u69A8;\u69A9;\u69AA;\u69AB;\u69AC;\u69AD;\u69AE;\u69AFt\u0100;v\u1645\u1646\u621Fb\u0100;d\u164C\u164D\u62BE;\u699D\u0100pt\u1654\u1657h;\u6222\xbb\xb9arr;\u637C\u0100gp\u1663\u1667on;\u4105f;\uC000\ud835\udd52\u0380;Eaeiop\u12C1\u167B\u167D\u1682\u1684\u1687\u168A;\u6A70cir;\u6A6F;\u624Ad;\u624Bs;\u4027rox\u0100;e\u12C1\u1692\xf1\u1683ing\u803B\xe5\u40E5\u0180cty\u16A1\u16A6\u16A8r;\uC000\ud835\udcb6;\u402Amp\u0100;e\u12C1\u16AF\xf1\u0288ilde\u803B\xe3\u40E3ml\u803B\xe4\u40E4\u0100ci\u16C2\u16C8onin\xf4\u0272nt;\u6A11\u0800Nabcdefiklnoprsu\u16ED\u16F1\u1730\u173C\u1743\u1748\u1778\u177D\u17E0\u17E6\u1839\u1850\u170D\u193D\u1948\u1970ot;\u6AED\u0100cr\u16F6\u171Ek\u0200ceps\u1700\u1705\u170D\u1713ong;\u624Cpsilon;\u43F6rime;\u6035im\u0100;e\u171A\u171B\u623Dq;\u62CD\u0176\u1722\u1726ee;\u62BDed\u0100;g\u172C\u172D\u6305e\xbb\u172Drk\u0100;t\u135C\u1737brk;\u63B6\u0100oy\u1701\u1741;\u4431quo;\u601E\u0280cmprt\u1753\u175B\u1761\u1764\u1768aus\u0100;e\u010A\u0109ptyv;\u69B0s\xe9\u170Cno\xf5\u0113\u0180ahw\u176F\u1771\u1773;\u43B2;\u6136een;\u626Cr;\uC000\ud835\udd1fg\u0380costuvw\u178D\u179D\u17B3\u17C1\u17D5\u17DB\u17DE\u0180aiu\u1794\u1796\u179A\xf0\u0760rc;\u65EFp\xbb\u1371\u0180dpt\u17A4\u17A8\u17ADot;\u6A00lus;\u6A01imes;\u6A02\u0271\u17B9\0\0\u17BEcup;\u6A06ar;\u6605riangle\u0100du\u17CD\u17D2own;\u65BDp;\u65B3plus;\u6A04e\xe5\u1444\xe5\u14ADarow;\u690D\u0180ako\u17ED\u1826\u1835\u0100cn\u17F2\u1823k\u0180lst\u17FA\u05AB\u1802ozenge;\u69EBriangle\u0200;dlr\u1812\u1813\u1818\u181D\u65B4own;\u65BEeft;\u65C2ight;\u65B8k;\u6423\u01B1\u182B\0\u1833\u01B2\u182F\0\u1831;\u6592;\u65914;\u6593ck;\u6588\u0100eo\u183E\u184D\u0100;q\u1843\u1846\uC000=\u20E5uiv;\uC000\u2261\u20E5t;\u6310\u0200ptwx\u1859\u185E\u1867\u186Cf;\uC000\ud835\udd53\u0100;t\u13CB\u1863om\xbb\u13CCtie;\u62C8\u0600DHUVbdhmptuv\u1885\u1896\u18AA\u18BB\u18D7\u18DB\u18EC\u18FF\u1905\u190A\u1910\u1921\u0200LRlr\u188E\u1890\u1892\u1894;\u6557;\u6554;\u6556;\u6553\u0280;DUdu\u18A1\u18A2\u18A4\u18A6\u18A8\u6550;\u6566;\u6569;\u6564;\u6567\u0200LRlr\u18B3\u18B5\u18B7\u18B9;\u655D;\u655A;\u655C;\u6559\u0380;HLRhlr\u18CA\u18CB\u18CD\u18CF\u18D1\u18D3\u18D5\u6551;\u656C;\u6563;\u6560;\u656B;\u6562;\u655Fox;\u69C9\u0200LRlr\u18E4\u18E6\u18E8\u18EA;\u6555;\u6552;\u6510;\u650C\u0280;DUdu\u06BD\u18F7\u18F9\u18FB\u18FD;\u6565;\u6568;\u652C;\u6534inus;\u629Flus;\u629Eimes;\u62A0\u0200LRlr\u1919\u191B\u191D\u191F;\u655B;\u6558;\u6518;\u6514\u0380;HLRhlr\u1930\u1931\u1933\u1935\u1937\u1939\u193B\u6502;\u656A;\u6561;\u655E;\u653C;\u6524;\u651C\u0100ev\u0123\u1942bar\u803B\xa6\u40A6\u0200ceio\u1951\u1956\u195A\u1960r;\uC000\ud835\udcb7mi;\u604Fm\u0100;e\u171A\u171Cl\u0180;bh\u1968\u1969\u196B\u405C;\u69C5sub;\u67C8\u016C\u1974\u197El\u0100;e\u1979\u197A\u6022t\xbb\u197Ap\u0180;Ee\u012F\u1985\u1987;\u6AAE\u0100;q\u06DC\u06DB\u0CE1\u19A7\0\u19E8\u1A11\u1A15\u1A32\0\u1A37\u1A50\0\0\u1AB4\0\0\u1AC1\0\0\u1B21\u1B2E\u1B4D\u1B52\0\u1BFD\0\u1C0C\u0180cpr\u19AD\u19B2\u19DDute;\u4107\u0300;abcds\u19BF\u19C0\u19C4\u19CA\u19D5\u19D9\u6229nd;\u6A44rcup;\u6A49\u0100au\u19CF\u19D2p;\u6A4Bp;\u6A47ot;\u6A40;\uC000\u2229\uFE00\u0100eo\u19E2\u19E5t;\u6041\xee\u0693\u0200aeiu\u19F0\u19FB\u1A01\u1A05\u01F0\u19F5\0\u19F8s;\u6A4Don;\u410Ddil\u803B\xe7\u40E7rc;\u4109ps\u0100;s\u1A0C\u1A0D\u6A4Cm;\u6A50ot;\u410B\u0180dmn\u1A1B\u1A20\u1A26il\u80BB\xb8\u01ADptyv;\u69B2t\u8100\xa2;e\u1A2D\u1A2E\u40A2r\xe4\u01B2r;\uC000\ud835\udd20\u0180cei\u1A3D\u1A40\u1A4Dy;\u4447ck\u0100;m\u1A47\u1A48\u6713ark\xbb\u1A48;\u43C7r\u0380;Ecefms\u1A5F\u1A60\u1A62\u1A6B\u1AA4\u1AAA\u1AAE\u65CB;\u69C3\u0180;el\u1A69\u1A6A\u1A6D\u42C6q;\u6257e\u0261\u1A74\0\0\u1A88rrow\u0100lr\u1A7C\u1A81eft;\u61BAight;\u61BB\u0280RSacd\u1A92\u1A94\u1A96\u1A9A\u1A9F\xbb\u0F47;\u64C8st;\u629Birc;\u629Aash;\u629Dnint;\u6A10id;\u6AEFcir;\u69C2ubs\u0100;u\u1ABB\u1ABC\u6663it\xbb\u1ABC\u02EC\u1AC7\u1AD4\u1AFA\0\u1B0Aon\u0100;e\u1ACD\u1ACE\u403A\u0100;q\xc7\xc6\u026D\u1AD9\0\0\u1AE2a\u0100;t\u1ADE\u1ADF\u402C;\u4040\u0180;fl\u1AE8\u1AE9\u1AEB\u6201\xee\u1160e\u0100mx\u1AF1\u1AF6ent\xbb\u1AE9e\xf3\u024D\u01E7\u1AFE\0\u1B07\u0100;d\u12BB\u1B02ot;\u6A6Dn\xf4\u0246\u0180fry\u1B10\u1B14\u1B17;\uC000\ud835\udd54o\xe4\u0254\u8100\xa9;s\u0155\u1B1Dr;\u6117\u0100ao\u1B25\u1B29rr;\u61B5ss;\u6717\u0100cu\u1B32\u1B37r;\uC000\ud835\udcb8\u0100bp\u1B3C\u1B44\u0100;e\u1B41\u1B42\u6ACF;\u6AD1\u0100;e\u1B49\u1B4A\u6AD0;\u6AD2dot;\u62EF\u0380delprvw\u1B60\u1B6C\u1B77\u1B82\u1BAC\u1BD4\u1BF9arr\u0100lr\u1B68\u1B6A;\u6938;\u6935\u0270\u1B72\0\0\u1B75r;\u62DEc;\u62DFarr\u0100;p\u1B7F\u1B80\u61B6;\u693D\u0300;bcdos\u1B8F\u1B90\u1B96\u1BA1\u1BA5\u1BA8\u622Arcap;\u6A48\u0100au\u1B9B\u1B9Ep;\u6A46p;\u6A4Aot;\u628Dr;\u6A45;\uC000\u222A\uFE00\u0200alrv\u1BB5\u1BBF\u1BDE\u1BE3rr\u0100;m\u1BBC\u1BBD\u61B7;\u693Cy\u0180evw\u1BC7\u1BD4\u1BD8q\u0270\u1BCE\0\0\u1BD2re\xe3\u1B73u\xe3\u1B75ee;\u62CEedge;\u62CFen\u803B\xa4\u40A4earrow\u0100lr\u1BEE\u1BF3eft\xbb\u1B80ight\xbb\u1BBDe\xe4\u1BDD\u0100ci\u1C01\u1C07onin\xf4\u01F7nt;\u6231lcty;\u632D\u0980AHabcdefhijlorstuwz\u1C38\u1C3B\u1C3F\u1C5D\u1C69\u1C75\u1C8A\u1C9E\u1CAC\u1CB7\u1CFB\u1CFF\u1D0D\u1D7B\u1D91\u1DAB\u1DBB\u1DC6\u1DCDr\xf2\u0381ar;\u6965\u0200glrs\u1C48\u1C4D\u1C52\u1C54ger;\u6020eth;\u6138\xf2\u1133h\u0100;v\u1C5A\u1C5B\u6010\xbb\u090A\u016B\u1C61\u1C67arow;\u690Fa\xe3\u0315\u0100ay\u1C6E\u1C73ron;\u410F;\u4434\u0180;ao\u0332\u1C7C\u1C84\u0100gr\u02BF\u1C81r;\u61CAtseq;\u6A77\u0180glm\u1C91\u1C94\u1C98\u803B\xb0\u40B0ta;\u43B4ptyv;\u69B1\u0100ir\u1CA3\u1CA8sht;\u697F;\uC000\ud835\udd21ar\u0100lr\u1CB3\u1CB5\xbb\u08DC\xbb\u101E\u0280aegsv\u1CC2\u0378\u1CD6\u1CDC\u1CE0m\u0180;os\u0326\u1CCA\u1CD4nd\u0100;s\u0326\u1CD1uit;\u6666amma;\u43DDin;\u62F2\u0180;io\u1CE7\u1CE8\u1CF8\u40F7de\u8100\xf7;o\u1CE7\u1CF0ntimes;\u62C7n\xf8\u1CF7cy;\u4452c\u026F\u1D06\0\0\u1D0Arn;\u631Eop;\u630D\u0280lptuw\u1D18\u1D1D\u1D22\u1D49\u1D55lar;\u4024f;\uC000\ud835\udd55\u0280;emps\u030B\u1D2D\u1D37\u1D3D\u1D42q\u0100;d\u0352\u1D33ot;\u6251inus;\u6238lus;\u6214quare;\u62A1blebarwedg\xe5\xfan\u0180adh\u112E\u1D5D\u1D67ownarrow\xf3\u1C83arpoon\u0100lr\u1D72\u1D76ef\xf4\u1CB4igh\xf4\u1CB6\u0162\u1D7F\u1D85karo\xf7\u0F42\u026F\u1D8A\0\0\u1D8Ern;\u631Fop;\u630C\u0180cot\u1D98\u1DA3\u1DA6\u0100ry\u1D9D\u1DA1;\uC000\ud835\udcb9;\u4455l;\u69F6rok;\u4111\u0100dr\u1DB0\u1DB4ot;\u62F1i\u0100;f\u1DBA\u1816\u65BF\u0100ah\u1DC0\u1DC3r\xf2\u0429a\xf2\u0FA6angle;\u69A6\u0100ci\u1DD2\u1DD5y;\u445Fgrarr;\u67FF\u0900Dacdefglmnopqrstux\u1E01\u1E09\u1E19\u1E38\u0578\u1E3C\u1E49\u1E61\u1E7E\u1EA5\u1EAF\u1EBD\u1EE1\u1F2A\u1F37\u1F44\u1F4E\u1F5A\u0100Do\u1E06\u1D34o\xf4\u1C89\u0100cs\u1E0E\u1E14ute\u803B\xe9\u40E9ter;\u6A6E\u0200aioy\u1E22\u1E27\u1E31\u1E36ron;\u411Br\u0100;c\u1E2D\u1E2E\u6256\u803B\xea\u40EAlon;\u6255;\u444Dot;\u4117\u0100Dr\u1E41\u1E45ot;\u6252;\uC000\ud835\udd22\u0180;rs\u1E50\u1E51\u1E57\u6A9Aave\u803B\xe8\u40E8\u0100;d\u1E5C\u1E5D\u6A96ot;\u6A98\u0200;ils\u1E6A\u1E6B\u1E72\u1E74\u6A99nters;\u63E7;\u6113\u0100;d\u1E79\u1E7A\u6A95ot;\u6A97\u0180aps\u1E85\u1E89\u1E97cr;\u4113ty\u0180;sv\u1E92\u1E93\u1E95\u6205et\xbb\u1E93p\u01001;\u1E9D\u1EA4\u0133\u1EA1\u1EA3;\u6004;\u6005\u6003\u0100gs\u1EAA\u1EAC;\u414Bp;\u6002\u0100gp\u1EB4\u1EB8on;\u4119f;\uC000\ud835\udd56\u0180als\u1EC4\u1ECE\u1ED2r\u0100;s\u1ECA\u1ECB\u62D5l;\u69E3us;\u6A71i\u0180;lv\u1EDA\u1EDB\u1EDF\u43B5on\xbb\u1EDB;\u43F5\u0200csuv\u1EEA\u1EF3\u1F0B\u1F23\u0100io\u1EEF\u1E31rc\xbb\u1E2E\u0269\u1EF9\0\0\u1EFB\xed\u0548ant\u0100gl\u1F02\u1F06tr\xbb\u1E5Dess\xbb\u1E7A\u0180aei\u1F12\u1F16\u1F1Als;\u403Dst;\u625Fv\u0100;D\u0235\u1F20D;\u6A78parsl;\u69E5\u0100Da\u1F2F\u1F33ot;\u6253rr;\u6971\u0180cdi\u1F3E\u1F41\u1EF8r;\u612Fo\xf4\u0352\u0100ah\u1F49\u1F4B;\u43B7\u803B\xf0\u40F0\u0100mr\u1F53\u1F57l\u803B\xeb\u40EBo;\u60AC\u0180cip\u1F61\u1F64\u1F67l;\u4021s\xf4\u056E\u0100eo\u1F6C\u1F74ctatio\xee\u0559nential\xe5\u0579\u09E1\u1F92\0\u1F9E\0\u1FA1\u1FA7\0\0\u1FC6\u1FCC\0\u1FD3\0\u1FE6\u1FEA\u2000\0\u2008\u205Allingdotse\xf1\u1E44y;\u4444male;\u6640\u0180ilr\u1FAD\u1FB3\u1FC1lig;\u8000\uFB03\u0269\u1FB9\0\0\u1FBDg;\u8000\uFB00ig;\u8000\uFB04;\uC000\ud835\udd23lig;\u8000\uFB01lig;\uC000fj\u0180alt\u1FD9\u1FDC\u1FE1t;\u666Dig;\u8000\uFB02ns;\u65B1of;\u4192\u01F0\u1FEE\0\u1FF3f;\uC000\ud835\udd57\u0100ak\u05BF\u1FF7\u0100;v\u1FFC\u1FFD\u62D4;\u6AD9artint;\u6A0D\u0100ao\u200C\u2055\u0100cs\u2011\u2052\u03B1\u201A\u2030\u2038\u2045\u2048\0\u2050\u03B2\u2022\u2025\u2027\u202A\u202C\0\u202E\u803B\xbd\u40BD;\u6153\u803B\xbc\u40BC;\u6155;\u6159;\u615B\u01B3\u2034\0\u2036;\u6154;\u6156\u02B4\u203E\u2041\0\0\u2043\u803B\xbe\u40BE;\u6157;\u615C5;\u6158\u01B6\u204C\0\u204E;\u615A;\u615D8;\u615El;\u6044wn;\u6322cr;\uC000\ud835\udcbb\u0880Eabcdefgijlnorstv\u2082\u2089\u209F\u20A5\u20B0\u20B4\u20F0\u20F5\u20FA\u20FF\u2103\u2112\u2138\u0317\u213E\u2152\u219E\u0100;l\u064D\u2087;\u6A8C\u0180cmp\u2090\u2095\u209Dute;\u41F5ma\u0100;d\u209C\u1CDA\u43B3;\u6A86reve;\u411F\u0100iy\u20AA\u20AErc;\u411D;\u4433ot;\u4121\u0200;lqs\u063E\u0642\u20BD\u20C9\u0180;qs\u063E\u064C\u20C4lan\xf4\u0665\u0200;cdl\u0665\u20D2\u20D5\u20E5c;\u6AA9ot\u0100;o\u20DC\u20DD\u6A80\u0100;l\u20E2\u20E3\u6A82;\u6A84\u0100;e\u20EA\u20ED\uC000\u22DB\uFE00s;\u6A94r;\uC000\ud835\udd24\u0100;g\u0673\u061Bmel;\u6137cy;\u4453\u0200;Eaj\u065A\u210C\u210E\u2110;\u6A92;\u6AA5;\u6AA4\u0200Eaes\u211B\u211D\u2129\u2134;\u6269p\u0100;p\u2123\u2124\u6A8Arox\xbb\u2124\u0100;q\u212E\u212F\u6A88\u0100;q\u212E\u211Bim;\u62E7pf;\uC000\ud835\udd58\u0100ci\u2143\u2146r;\u610Am\u0180;el\u066B\u214E\u2150;\u6A8E;\u6A90\u8300>;cdlqr\u05EE\u2160\u216A\u216E\u2173\u2179\u0100ci\u2165\u2167;\u6AA7r;\u6A7Aot;\u62D7Par;\u6995uest;\u6A7C\u0280adels\u2184\u216A\u2190\u0656\u219B\u01F0\u2189\0\u218Epro\xf8\u209Er;\u6978q\u0100lq\u063F\u2196les\xf3\u2088i\xed\u066B\u0100en\u21A3\u21ADrtneqq;\uC000\u2269\uFE00\xc5\u21AA\u0500Aabcefkosy\u21C4\u21C7\u21F1\u21F5\u21FA\u2218\u221D\u222F\u2268\u227Dr\xf2\u03A0\u0200ilmr\u21D0\u21D4\u21D7\u21DBrs\xf0\u1484f\xbb\u2024il\xf4\u06A9\u0100dr\u21E0\u21E4cy;\u444A\u0180;cw\u08F4\u21EB\u21EFir;\u6948;\u61ADar;\u610Firc;\u4125\u0180alr\u2201\u220E\u2213rts\u0100;u\u2209\u220A\u6665it\xbb\u220Alip;\u6026con;\u62B9r;\uC000\ud835\udd25s\u0100ew\u2223\u2229arow;\u6925arow;\u6926\u0280amopr\u223A\u223E\u2243\u225E\u2263rr;\u61FFtht;\u623Bk\u0100lr\u2249\u2253eftarrow;\u61A9ightarrow;\u61AAf;\uC000\ud835\udd59bar;\u6015\u0180clt\u226F\u2274\u2278r;\uC000\ud835\udcbdas\xe8\u21F4rok;\u4127\u0100bp\u2282\u2287ull;\u6043hen\xbb\u1C5B\u0AE1\u22A3\0\u22AA\0\u22B8\u22C5\u22CE\0\u22D5\u22F3\0\0\u22F8\u2322\u2367\u2362\u237F\0\u2386\u23AA\u23B4cute\u803B\xed\u40ED\u0180;iy\u0771\u22B0\u22B5rc\u803B\xee\u40EE;\u4438\u0100cx\u22BC\u22BFy;\u4435cl\u803B\xa1\u40A1\u0100fr\u039F\u22C9;\uC000\ud835\udd26rave\u803B\xec\u40EC\u0200;ino\u073E\u22DD\u22E9\u22EE\u0100in\u22E2\u22E6nt;\u6A0Ct;\u622Dfin;\u69DCta;\u6129lig;\u4133\u0180aop\u22FE\u231A\u231D\u0180cgt\u2305\u2308\u2317r;\u412B\u0180elp\u071F\u230F\u2313in\xe5\u078Ear\xf4\u0720h;\u4131f;\u62B7ed;\u41B5\u0280;cfot\u04F4\u232C\u2331\u233D\u2341are;\u6105in\u0100;t\u2338\u2339\u621Eie;\u69DDdo\xf4\u2319\u0280;celp\u0757\u234C\u2350\u235B\u2361al;\u62BA\u0100gr\u2355\u2359er\xf3\u1563\xe3\u234Darhk;\u6A17rod;\u6A3C\u0200cgpt\u236F\u2372\u2376\u237By;\u4451on;\u412Ff;\uC000\ud835\udd5aa;\u43B9uest\u803B\xbf\u40BF\u0100ci\u238A\u238Fr;\uC000\ud835\udcben\u0280;Edsv\u04F4\u239B\u239D\u23A1\u04F3;\u62F9ot;\u62F5\u0100;v\u23A6\u23A7\u62F4;\u62F3\u0100;i\u0777\u23AElde;\u4129\u01EB\u23B8\0\u23BCcy;\u4456l\u803B\xef\u40EF\u0300cfmosu\u23CC\u23D7\u23DC\u23E1\u23E7\u23F5\u0100iy\u23D1\u23D5rc;\u4135;\u4439r;\uC000\ud835\udd27ath;\u4237pf;\uC000\ud835\udd5b\u01E3\u23EC\0\u23F1r;\uC000\ud835\udcbfrcy;\u4458kcy;\u4454\u0400acfghjos\u240B\u2416\u2422\u2427\u242D\u2431\u2435\u243Bppa\u0100;v\u2413\u2414\u43BA;\u43F0\u0100ey\u241B\u2420dil;\u4137;\u443Ar;\uC000\ud835\udd28reen;\u4138cy;\u4445cy;\u445Cpf;\uC000\ud835\udd5ccr;\uC000\ud835\udcc0\u0B80ABEHabcdefghjlmnoprstuv\u2470\u2481\u2486\u248D\u2491\u250E\u253D\u255A\u2580\u264E\u265E\u2665\u2679\u267D\u269A\u26B2\u26D8\u275D\u2768\u278B\u27C0\u2801\u2812\u0180art\u2477\u247A\u247Cr\xf2\u09C6\xf2\u0395ail;\u691Barr;\u690E\u0100;g\u0994\u248B;\u6A8Bar;\u6962\u0963\u24A5\0\u24AA\0\u24B1\0\0\0\0\0\u24B5\u24BA\0\u24C6\u24C8\u24CD\0\u24F9ute;\u413Amptyv;\u69B4ra\xee\u084Cbda;\u43BBg\u0180;dl\u088E\u24C1\u24C3;\u6991\xe5\u088E;\u6A85uo\u803B\xab\u40ABr\u0400;bfhlpst\u0899\u24DE\u24E6\u24E9\u24EB\u24EE\u24F1\u24F5\u0100;f\u089D\u24E3s;\u691Fs;\u691D\xeb\u2252p;\u61ABl;\u6939im;\u6973l;\u61A2\u0180;ae\u24FF\u2500\u2504\u6AABil;\u6919\u0100;s\u2509\u250A\u6AAD;\uC000\u2AAD\uFE00\u0180abr\u2515\u2519\u251Drr;\u690Crk;\u6772\u0100ak\u2522\u252Cc\u0100ek\u2528\u252A;\u407B;\u405B\u0100es\u2531\u2533;\u698Bl\u0100du\u2539\u253B;\u698F;\u698D\u0200aeuy\u2546\u254B\u2556\u2558ron;\u413E\u0100di\u2550\u2554il;\u413C\xec\u08B0\xe2\u2529;\u443B\u0200cqrs\u2563\u2566\u256D\u257Da;\u6936uo\u0100;r\u0E19\u1746\u0100du\u2572\u2577har;\u6967shar;\u694Bh;\u61B2\u0280;fgqs\u258B\u258C\u0989\u25F3\u25FF\u6264t\u0280ahlrt\u2598\u25A4\u25B7\u25C2\u25E8rrow\u0100;t\u0899\u25A1a\xe9\u24F6arpoon\u0100du\u25AF\u25B4own\xbb\u045Ap\xbb\u0966eftarrows;\u61C7ight\u0180ahs\u25CD\u25D6\u25DErrow\u0100;s\u08F4\u08A7arpoon\xf3\u0F98quigarro\xf7\u21F0hreetimes;\u62CB\u0180;qs\u258B\u0993\u25FAlan\xf4\u09AC\u0280;cdgs\u09AC\u260A\u260D\u261D\u2628c;\u6AA8ot\u0100;o\u2614\u2615\u6A7F\u0100;r\u261A\u261B\u6A81;\u6A83\u0100;e\u2622\u2625\uC000\u22DA\uFE00s;\u6A93\u0280adegs\u2633\u2639\u263D\u2649\u264Bppro\xf8\u24C6ot;\u62D6q\u0100gq\u2643\u2645\xf4\u0989gt\xf2\u248C\xf4\u099Bi\xed\u09B2\u0180ilr\u2655\u08E1\u265Asht;\u697C;\uC000\ud835\udd29\u0100;E\u099C\u2663;\u6A91\u0161\u2669\u2676r\u0100du\u25B2\u266E\u0100;l\u0965\u2673;\u696Alk;\u6584cy;\u4459\u0280;acht\u0A48\u2688\u268B\u2691\u2696r\xf2\u25C1orne\xf2\u1D08ard;\u696Bri;\u65FA\u0100io\u269F\u26A4dot;\u4140ust\u0100;a\u26AC\u26AD\u63B0che\xbb\u26AD\u0200Eaes\u26BB\u26BD\u26C9\u26D4;\u6268p\u0100;p\u26C3\u26C4\u6A89rox\xbb\u26C4\u0100;q\u26CE\u26CF\u6A87\u0100;q\u26CE\u26BBim;\u62E6\u0400abnoptwz\u26E9\u26F4\u26F7\u271A\u272F\u2741\u2747\u2750\u0100nr\u26EE\u26F1g;\u67ECr;\u61FDr\xeb\u08C1g\u0180lmr\u26FF\u270D\u2714eft\u0100ar\u09E6\u2707ight\xe1\u09F2apsto;\u67FCight\xe1\u09FDparrow\u0100lr\u2725\u2729ef\xf4\u24EDight;\u61AC\u0180afl\u2736\u2739\u273Dr;\u6985;\uC000\ud835\udd5dus;\u6A2Dimes;\u6A34\u0161\u274B\u274Fst;\u6217\xe1\u134E\u0180;ef\u2757\u2758\u1800\u65CAnge\xbb\u2758ar\u0100;l\u2764\u2765\u4028t;\u6993\u0280achmt\u2773\u2776\u277C\u2785\u2787r\xf2\u08A8orne\xf2\u1D8Car\u0100;d\u0F98\u2783;\u696D;\u600Eri;\u62BF\u0300achiqt\u2798\u279D\u0A40\u27A2\u27AE\u27BBquo;\u6039r;\uC000\ud835\udcc1m\u0180;eg\u09B2\u27AA\u27AC;\u6A8D;\u6A8F\u0100bu\u252A\u27B3o\u0100;r\u0E1F\u27B9;\u601Arok;\u4142\u8400<;cdhilqr\u082B\u27D2\u2639\u27DC\u27E0\u27E5\u27EA\u27F0\u0100ci\u27D7\u27D9;\u6AA6r;\u6A79re\xe5\u25F2mes;\u62C9arr;\u6976uest;\u6A7B\u0100Pi\u27F5\u27F9ar;\u6996\u0180;ef\u2800\u092D\u181B\u65C3r\u0100du\u2807\u280Dshar;\u694Ahar;\u6966\u0100en\u2817\u2821rtneqq;\uC000\u2268\uFE00\xc5\u281E\u0700Dacdefhilnopsu\u2840\u2845\u2882\u288E\u2893\u28A0\u28A5\u28A8\u28DA\u28E2\u28E4\u0A83\u28F3\u2902Dot;\u623A\u0200clpr\u284E\u2852\u2863\u287Dr\u803B\xaf\u40AF\u0100et\u2857\u2859;\u6642\u0100;e\u285E\u285F\u6720se\xbb\u285F\u0100;s\u103B\u2868to\u0200;dlu\u103B\u2873\u2877\u287Bow\xee\u048Cef\xf4\u090F\xf0\u13D1ker;\u65AE\u0100oy\u2887\u288Cmma;\u6A29;\u443Cash;\u6014asuredangle\xbb\u1626r;\uC000\ud835\udd2ao;\u6127\u0180cdn\u28AF\u28B4\u28C9ro\u803B\xb5\u40B5\u0200;acd\u1464\u28BD\u28C0\u28C4s\xf4\u16A7ir;\u6AF0ot\u80BB\xb7\u01B5us\u0180;bd\u28D2\u1903\u28D3\u6212\u0100;u\u1D3C\u28D8;\u6A2A\u0163\u28DE\u28E1p;\u6ADB\xf2\u2212\xf0\u0A81\u0100dp\u28E9\u28EEels;\u62A7f;\uC000\ud835\udd5e\u0100ct\u28F8\u28FDr;\uC000\ud835\udcc2pos\xbb\u159D\u0180;lm\u2909\u290A\u290D\u43BCtimap;\u62B8\u0C00GLRVabcdefghijlmoprstuvw\u2942\u2953\u297E\u2989\u2998\u29DA\u29E9\u2A15\u2A1A\u2A58\u2A5D\u2A83\u2A95\u2AA4\u2AA8\u2B04\u2B07\u2B44\u2B7F\u2BAE\u2C34\u2C67\u2C7C\u2CE9\u0100gt\u2947\u294B;\uC000\u22D9\u0338\u0100;v\u2950\u0BCF\uC000\u226B\u20D2\u0180elt\u295A\u2972\u2976ft\u0100ar\u2961\u2967rrow;\u61CDightarrow;\u61CE;\uC000\u22D8\u0338\u0100;v\u297B\u0C47\uC000\u226A\u20D2ightarrow;\u61CF\u0100Dd\u298E\u2993ash;\u62AFash;\u62AE\u0280bcnpt\u29A3\u29A7\u29AC\u29B1\u29CCla\xbb\u02DEute;\u4144g;\uC000\u2220\u20D2\u0280;Eiop\u0D84\u29BC\u29C0\u29C5\u29C8;\uC000\u2A70\u0338d;\uC000\u224B\u0338s;\u4149ro\xf8\u0D84ur\u0100;a\u29D3\u29D4\u666El\u0100;s\u29D3\u0B38\u01F3\u29DF\0\u29E3p\u80BB\xa0\u0B37mp\u0100;e\u0BF9\u0C00\u0280aeouy\u29F4\u29FE\u2A03\u2A10\u2A13\u01F0\u29F9\0\u29FB;\u6A43on;\u4148dil;\u4146ng\u0100;d\u0D7E\u2A0Aot;\uC000\u2A6D\u0338p;\u6A42;\u443Dash;\u6013\u0380;Aadqsx\u0B92\u2A29\u2A2D\u2A3B\u2A41\u2A45\u2A50rr;\u61D7r\u0100hr\u2A33\u2A36k;\u6924\u0100;o\u13F2\u13F0ot;\uC000\u2250\u0338ui\xf6\u0B63\u0100ei\u2A4A\u2A4Ear;\u6928\xed\u0B98ist\u0100;s\u0BA0\u0B9Fr;\uC000\ud835\udd2b\u0200Eest\u0BC5\u2A66\u2A79\u2A7C\u0180;qs\u0BBC\u2A6D\u0BE1\u0180;qs\u0BBC\u0BC5\u2A74lan\xf4\u0BE2i\xed\u0BEA\u0100;r\u0BB6\u2A81\xbb\u0BB7\u0180Aap\u2A8A\u2A8D\u2A91r\xf2\u2971rr;\u61AEar;\u6AF2\u0180;sv\u0F8D\u2A9C\u0F8C\u0100;d\u2AA1\u2AA2\u62FC;\u62FAcy;\u445A\u0380AEadest\u2AB7\u2ABA\u2ABE\u2AC2\u2AC5\u2AF6\u2AF9r\xf2\u2966;\uC000\u2266\u0338rr;\u619Ar;\u6025\u0200;fqs\u0C3B\u2ACE\u2AE3\u2AEFt\u0100ar\u2AD4\u2AD9rro\xf7\u2AC1ightarro\xf7\u2A90\u0180;qs\u0C3B\u2ABA\u2AEAlan\xf4\u0C55\u0100;s\u0C55\u2AF4\xbb\u0C36i\xed\u0C5D\u0100;r\u0C35\u2AFEi\u0100;e\u0C1A\u0C25i\xe4\u0D90\u0100pt\u2B0C\u2B11f;\uC000\ud835\udd5f\u8180\xac;in\u2B19\u2B1A\u2B36\u40ACn\u0200;Edv\u0B89\u2B24\u2B28\u2B2E;\uC000\u22F9\u0338ot;\uC000\u22F5\u0338\u01E1\u0B89\u2B33\u2B35;\u62F7;\u62F6i\u0100;v\u0CB8\u2B3C\u01E1\u0CB8\u2B41\u2B43;\u62FE;\u62FD\u0180aor\u2B4B\u2B63\u2B69r\u0200;ast\u0B7B\u2B55\u2B5A\u2B5Flle\xec\u0B7Bl;\uC000\u2AFD\u20E5;\uC000\u2202\u0338lint;\u6A14\u0180;ce\u0C92\u2B70\u2B73u\xe5\u0CA5\u0100;c\u0C98\u2B78\u0100;e\u0C92\u2B7D\xf1\u0C98\u0200Aait\u2B88\u2B8B\u2B9D\u2BA7r\xf2\u2988rr\u0180;cw\u2B94\u2B95\u2B99\u619B;\uC000\u2933\u0338;\uC000\u219D\u0338ghtarrow\xbb\u2B95ri\u0100;e\u0CCB\u0CD6\u0380chimpqu\u2BBD\u2BCD\u2BD9\u2B04\u0B78\u2BE4\u2BEF\u0200;cer\u0D32\u2BC6\u0D37\u2BC9u\xe5\u0D45;\uC000\ud835\udcc3ort\u026D\u2B05\0\0\u2BD6ar\xe1\u2B56m\u0100;e\u0D6E\u2BDF\u0100;q\u0D74\u0D73su\u0100bp\u2BEB\u2BED\xe5\u0CF8\xe5\u0D0B\u0180bcp\u2BF6\u2C11\u2C19\u0200;Ees\u2BFF\u2C00\u0D22\u2C04\u6284;\uC000\u2AC5\u0338et\u0100;e\u0D1B\u2C0Bq\u0100;q\u0D23\u2C00c\u0100;e\u0D32\u2C17\xf1\u0D38\u0200;Ees\u2C22\u2C23\u0D5F\u2C27\u6285;\uC000\u2AC6\u0338et\u0100;e\u0D58\u2C2Eq\u0100;q\u0D60\u2C23\u0200gilr\u2C3D\u2C3F\u2C45\u2C47\xec\u0BD7lde\u803B\xf1\u40F1\xe7\u0C43iangle\u0100lr\u2C52\u2C5Ceft\u0100;e\u0C1A\u2C5A\xf1\u0C26ight\u0100;e\u0CCB\u2C65\xf1\u0CD7\u0100;m\u2C6C\u2C6D\u43BD\u0180;es\u2C74\u2C75\u2C79\u4023ro;\u6116p;\u6007\u0480DHadgilrs\u2C8F\u2C94\u2C99\u2C9E\u2CA3\u2CB0\u2CB6\u2CD3\u2CE3ash;\u62ADarr;\u6904p;\uC000\u224D\u20D2ash;\u62AC\u0100et\u2CA8\u2CAC;\uC000\u2265\u20D2;\uC000>\u20D2nfin;\u69DE\u0180Aet\u2CBD\u2CC1\u2CC5rr;\u6902;\uC000\u2264\u20D2\u0100;r\u2CCA\u2CCD\uC000<\u20D2ie;\uC000\u22B4\u20D2\u0100At\u2CD8\u2CDCrr;\u6903rie;\uC000\u22B5\u20D2im;\uC000\u223C\u20D2\u0180Aan\u2CF0\u2CF4\u2D02rr;\u61D6r\u0100hr\u2CFA\u2CFDk;\u6923\u0100;o\u13E7\u13E5ear;\u6927\u1253\u1A95\0\0\0\0\0\0\0\0\0\0\0\0\0\u2D2D\0\u2D38\u2D48\u2D60\u2D65\u2D72\u2D84\u1B07\0\0\u2D8D\u2DAB\0\u2DC8\u2DCE\0\u2DDC\u2E19\u2E2B\u2E3E\u2E43\u0100cs\u2D31\u1A97ute\u803B\xf3\u40F3\u0100iy\u2D3C\u2D45r\u0100;c\u1A9E\u2D42\u803B\xf4\u40F4;\u443E\u0280abios\u1AA0\u2D52\u2D57\u01C8\u2D5Alac;\u4151v;\u6A38old;\u69BClig;\u4153\u0100cr\u2D69\u2D6Dir;\u69BF;\uC000\ud835\udd2c\u036F\u2D79\0\0\u2D7C\0\u2D82n;\u42DBave\u803B\xf2\u40F2;\u69C1\u0100bm\u2D88\u0DF4ar;\u69B5\u0200acit\u2D95\u2D98\u2DA5\u2DA8r\xf2\u1A80\u0100ir\u2D9D\u2DA0r;\u69BEoss;\u69BBn\xe5\u0E52;\u69C0\u0180aei\u2DB1\u2DB5\u2DB9cr;\u414Dga;\u43C9\u0180cdn\u2DC0\u2DC5\u01CDron;\u43BF;\u69B6pf;\uC000\ud835\udd60\u0180ael\u2DD4\u2DD7\u01D2r;\u69B7rp;\u69B9\u0380;adiosv\u2DEA\u2DEB\u2DEE\u2E08\u2E0D\u2E10\u2E16\u6228r\xf2\u1A86\u0200;efm\u2DF7\u2DF8\u2E02\u2E05\u6A5Dr\u0100;o\u2DFE\u2DFF\u6134f\xbb\u2DFF\u803B\xaa\u40AA\u803B\xba\u40BAgof;\u62B6r;\u6A56lope;\u6A57;\u6A5B\u0180clo\u2E1F\u2E21\u2E27\xf2\u2E01ash\u803B\xf8\u40F8l;\u6298i\u016C\u2E2F\u2E34de\u803B\xf5\u40F5es\u0100;a\u01DB\u2E3As;\u6A36ml\u803B\xf6\u40F6bar;\u633D\u0AE1\u2E5E\0\u2E7D\0\u2E80\u2E9D\0\u2EA2\u2EB9\0\0\u2ECB\u0E9C\0\u2F13\0\0\u2F2B\u2FBC\0\u2FC8r\u0200;ast\u0403\u2E67\u2E72\u0E85\u8100\xb6;l\u2E6D\u2E6E\u40B6le\xec\u0403\u0269\u2E78\0\0\u2E7Bm;\u6AF3;\u6AFDy;\u443Fr\u0280cimpt\u2E8B\u2E8F\u2E93\u1865\u2E97nt;\u4025od;\u402Eil;\u6030enk;\u6031r;\uC000\ud835\udd2d\u0180imo\u2EA8\u2EB0\u2EB4\u0100;v\u2EAD\u2EAE\u43C6;\u43D5ma\xf4\u0A76ne;\u660E\u0180;tv\u2EBF\u2EC0\u2EC8\u43C0chfork\xbb\u1FFD;\u43D6\u0100au\u2ECF\u2EDFn\u0100ck\u2ED5\u2EDDk\u0100;h\u21F4\u2EDB;\u610E\xf6\u21F4s\u0480;abcdemst\u2EF3\u2EF4\u1908\u2EF9\u2EFD\u2F04\u2F06\u2F0A\u2F0E\u402Bcir;\u6A23ir;\u6A22\u0100ou\u1D40\u2F02;\u6A25;\u6A72n\u80BB\xb1\u0E9Dim;\u6A26wo;\u6A27\u0180ipu\u2F19\u2F20\u2F25ntint;\u6A15f;\uC000\ud835\udd61nd\u803B\xa3\u40A3\u0500;Eaceinosu\u0EC8\u2F3F\u2F41\u2F44\u2F47\u2F81\u2F89\u2F92\u2F7E\u2FB6;\u6AB3p;\u6AB7u\xe5\u0ED9\u0100;c\u0ECE\u2F4C\u0300;acens\u0EC8\u2F59\u2F5F\u2F66\u2F68\u2F7Eppro\xf8\u2F43urlye\xf1\u0ED9\xf1\u0ECE\u0180aes\u2F6F\u2F76\u2F7Approx;\u6AB9qq;\u6AB5im;\u62E8i\xed\u0EDFme\u0100;s\u2F88\u0EAE\u6032\u0180Eas\u2F78\u2F90\u2F7A\xf0\u2F75\u0180dfp\u0EEC\u2F99\u2FAF\u0180als\u2FA0\u2FA5\u2FAAlar;\u632Eine;\u6312urf;\u6313\u0100;t\u0EFB\u2FB4\xef\u0EFBrel;\u62B0\u0100ci\u2FC0\u2FC5r;\uC000\ud835\udcc5;\u43C8ncsp;\u6008\u0300fiopsu\u2FDA\u22E2\u2FDF\u2FE5\u2FEB\u2FF1r;\uC000\ud835\udd2epf;\uC000\ud835\udd62rime;\u6057cr;\uC000\ud835\udcc6\u0180aeo\u2FF8\u3009\u3013t\u0100ei\u2FFE\u3005rnion\xf3\u06B0nt;\u6A16st\u0100;e\u3010\u3011\u403F\xf1\u1F19\xf4\u0F14\u0A80ABHabcdefhilmnoprstux\u3040\u3051\u3055\u3059\u30E0\u310E\u312B\u3147\u3162\u3172\u318E\u3206\u3215\u3224\u3229\u3258\u326E\u3272\u3290\u32B0\u32B7\u0180art\u3047\u304A\u304Cr\xf2\u10B3\xf2\u03DDail;\u691Car\xf2\u1C65ar;\u6964\u0380cdenqrt\u3068\u3075\u3078\u307F\u308F\u3094\u30CC\u0100eu\u306D\u3071;\uC000\u223D\u0331te;\u4155i\xe3\u116Emptyv;\u69B3g\u0200;del\u0FD1\u3089\u308B\u308D;\u6992;\u69A5\xe5\u0FD1uo\u803B\xbb\u40BBr\u0580;abcfhlpstw\u0FDC\u30AC\u30AF\u30B7\u30B9\u30BC\u30BE\u30C0\u30C3\u30C7\u30CAp;\u6975\u0100;f\u0FE0\u30B4s;\u6920;\u6933s;\u691E\xeb\u225D\xf0\u272El;\u6945im;\u6974l;\u61A3;\u619D\u0100ai\u30D1\u30D5il;\u691Ao\u0100;n\u30DB\u30DC\u6236al\xf3\u0F1E\u0180abr\u30E7\u30EA\u30EEr\xf2\u17E5rk;\u6773\u0100ak\u30F3\u30FDc\u0100ek\u30F9\u30FB;\u407D;\u405D\u0100es\u3102\u3104;\u698Cl\u0100du\u310A\u310C;\u698E;\u6990\u0200aeuy\u3117\u311C\u3127\u3129ron;\u4159\u0100di\u3121\u3125il;\u4157\xec\u0FF2\xe2\u30FA;\u4440\u0200clqs\u3134\u3137\u313D\u3144a;\u6937dhar;\u6969uo\u0100;r\u020E\u020Dh;\u61B3\u0180acg\u314E\u315F\u0F44l\u0200;ips\u0F78\u3158\u315B\u109Cn\xe5\u10BBar\xf4\u0FA9t;\u65AD\u0180ilr\u3169\u1023\u316Esht;\u697D;\uC000\ud835\udd2f\u0100ao\u3177\u3186r\u0100du\u317D\u317F\xbb\u047B\u0100;l\u1091\u3184;\u696C\u0100;v\u318B\u318C\u43C1;\u43F1\u0180gns\u3195\u31F9\u31FCht\u0300ahlrst\u31A4\u31B0\u31C2\u31D8\u31E4\u31EErrow\u0100;t\u0FDC\u31ADa\xe9\u30C8arpoon\u0100du\u31BB\u31BFow\xee\u317Ep\xbb\u1092eft\u0100ah\u31CA\u31D0rrow\xf3\u0FEAarpoon\xf3\u0551ightarrows;\u61C9quigarro\xf7\u30CBhreetimes;\u62CCg;\u42DAingdotse\xf1\u1F32\u0180ahm\u320D\u3210\u3213r\xf2\u0FEAa\xf2\u0551;\u600Foust\u0100;a\u321E\u321F\u63B1che\xbb\u321Fmid;\u6AEE\u0200abpt\u3232\u323D\u3240\u3252\u0100nr\u3237\u323Ag;\u67EDr;\u61FEr\xeb\u1003\u0180afl\u3247\u324A\u324Er;\u6986;\uC000\ud835\udd63us;\u6A2Eimes;\u6A35\u0100ap\u325D\u3267r\u0100;g\u3263\u3264\u4029t;\u6994olint;\u6A12ar\xf2\u31E3\u0200achq\u327B\u3280\u10BC\u3285quo;\u603Ar;\uC000\ud835\udcc7\u0100bu\u30FB\u328Ao\u0100;r\u0214\u0213\u0180hir\u3297\u329B\u32A0re\xe5\u31F8mes;\u62CAi\u0200;efl\u32AA\u1059\u1821\u32AB\u65B9tri;\u69CEluhar;\u6968;\u611E\u0D61\u32D5\u32DB\u32DF\u332C\u3338\u3371\0\u337A\u33A4\0\0\u33EC\u33F0\0\u3428\u3448\u345A\u34AD\u34B1\u34CA\u34F1\0\u3616\0\0\u3633cute;\u415Bqu\xef\u27BA\u0500;Eaceinpsy\u11ED\u32F3\u32F5\u32FF\u3302\u330B\u330F\u331F\u3326\u3329;\u6AB4\u01F0\u32FA\0\u32FC;\u6AB8on;\u4161u\xe5\u11FE\u0100;d\u11F3\u3307il;\u415Frc;\u415D\u0180Eas\u3316\u3318\u331B;\u6AB6p;\u6ABAim;\u62E9olint;\u6A13i\xed\u1204;\u4441ot\u0180;be\u3334\u1D47\u3335\u62C5;\u6A66\u0380Aacmstx\u3346\u334A\u3357\u335B\u335E\u3363\u336Drr;\u61D8r\u0100hr\u3350\u3352\xeb\u2228\u0100;o\u0A36\u0A34t\u803B\xa7\u40A7i;\u403Bwar;\u6929m\u0100in\u3369\xf0nu\xf3\xf1t;\u6736r\u0100;o\u3376\u2055\uC000\ud835\udd30\u0200acoy\u3382\u3386\u3391\u33A0rp;\u666F\u0100hy\u338B\u338Fcy;\u4449;\u4448rt\u026D\u3399\0\0\u339Ci\xe4\u1464ara\xec\u2E6F\u803B\xad\u40AD\u0100gm\u33A8\u33B4ma\u0180;fv\u33B1\u33B2\u33B2\u43C3;\u43C2\u0400;deglnpr\u12AB\u33C5\u33C9\u33CE\u33D6\u33DE\u33E1\u33E6ot;\u6A6A\u0100;q\u12B1\u12B0\u0100;E\u33D3\u33D4\u6A9E;\u6AA0\u0100;E\u33DB\u33DC\u6A9D;\u6A9Fe;\u6246lus;\u6A24arr;\u6972ar\xf2\u113D\u0200aeit\u33F8\u3408\u340F\u3417\u0100ls\u33FD\u3404lsetm\xe9\u336Ahp;\u6A33parsl;\u69E4\u0100dl\u1463\u3414e;\u6323\u0100;e\u341C\u341D\u6AAA\u0100;s\u3422\u3423\u6AAC;\uC000\u2AAC\uFE00\u0180flp\u342E\u3433\u3442tcy;\u444C\u0100;b\u3438\u3439\u402F\u0100;a\u343E\u343F\u69C4r;\u633Ff;\uC000\ud835\udd64a\u0100dr\u344D\u0402es\u0100;u\u3454\u3455\u6660it\xbb\u3455\u0180csu\u3460\u3479\u349F\u0100au\u3465\u346Fp\u0100;s\u1188\u346B;\uC000\u2293\uFE00p\u0100;s\u11B4\u3475;\uC000\u2294\uFE00u\u0100bp\u347F\u348F\u0180;es\u1197\u119C\u3486et\u0100;e\u1197\u348D\xf1\u119D\u0180;es\u11A8\u11AD\u3496et\u0100;e\u11A8\u349D\xf1\u11AE\u0180;af\u117B\u34A6\u05B0r\u0165\u34AB\u05B1\xbb\u117Car\xf2\u1148\u0200cemt\u34B9\u34BE\u34C2\u34C5r;\uC000\ud835\udcc8tm\xee\xf1i\xec\u3415ar\xe6\u11BE\u0100ar\u34CE\u34D5r\u0100;f\u34D4\u17BF\u6606\u0100an\u34DA\u34EDight\u0100ep\u34E3\u34EApsilo\xee\u1EE0h\xe9\u2EAFs\xbb\u2852\u0280bcmnp\u34FB\u355E\u1209\u358B\u358E\u0480;Edemnprs\u350E\u350F\u3511\u3515\u351E\u3523\u352C\u3531\u3536\u6282;\u6AC5ot;\u6ABD\u0100;d\u11DA\u351Aot;\u6AC3ult;\u6AC1\u0100Ee\u3528\u352A;\u6ACB;\u628Alus;\u6ABFarr;\u6979\u0180eiu\u353D\u3552\u3555t\u0180;en\u350E\u3545\u354Bq\u0100;q\u11DA\u350Feq\u0100;q\u352B\u3528m;\u6AC7\u0100bp\u355A\u355C;\u6AD5;\u6AD3c\u0300;acens\u11ED\u356C\u3572\u3579\u357B\u3326ppro\xf8\u32FAurlye\xf1\u11FE\xf1\u11F3\u0180aes\u3582\u3588\u331Bppro\xf8\u331Aq\xf1\u3317g;\u666A\u0680123;Edehlmnps\u35A9\u35AC\u35AF\u121C\u35B2\u35B4\u35C0\u35C9\u35D5\u35DA\u35DF\u35E8\u35ED\u803B\xb9\u40B9\u803B\xb2\u40B2\u803B\xb3\u40B3;\u6AC6\u0100os\u35B9\u35BCt;\u6ABEub;\u6AD8\u0100;d\u1222\u35C5ot;\u6AC4s\u0100ou\u35CF\u35D2l;\u67C9b;\u6AD7arr;\u697Bult;\u6AC2\u0100Ee\u35E4\u35E6;\u6ACC;\u628Blus;\u6AC0\u0180eiu\u35F4\u3609\u360Ct\u0180;en\u121C\u35FC\u3602q\u0100;q\u1222\u35B2eq\u0100;q\u35E7\u35E4m;\u6AC8\u0100bp\u3611\u3613;\u6AD4;\u6AD6\u0180Aan\u361C\u3620\u362Drr;\u61D9r\u0100hr\u3626\u3628\xeb\u222E\u0100;o\u0A2B\u0A29war;\u692Alig\u803B\xdf\u40DF\u0BE1\u3651\u365D\u3660\u12CE\u3673\u3679\0\u367E\u36C2\0\0\0\0\0\u36DB\u3703\0\u3709\u376C\0\0\0\u3787\u0272\u3656\0\0\u365Bget;\u6316;\u43C4r\xeb\u0E5F\u0180aey\u3666\u366B\u3670ron;\u4165dil;\u4163;\u4442lrec;\u6315r;\uC000\ud835\udd31\u0200eiko\u3686\u369D\u36B5\u36BC\u01F2\u368B\0\u3691e\u01004f\u1284\u1281a\u0180;sv\u3698\u3699\u369B\u43B8ym;\u43D1\u0100cn\u36A2\u36B2k\u0100as\u36A8\u36AEppro\xf8\u12C1im\xbb\u12ACs\xf0\u129E\u0100as\u36BA\u36AE\xf0\u12C1rn\u803B\xfe\u40FE\u01EC\u031F\u36C6\u22E7es\u8180\xd7;bd\u36CF\u36D0\u36D8\u40D7\u0100;a\u190F\u36D5r;\u6A31;\u6A30\u0180eps\u36E1\u36E3\u3700\xe1\u2A4D\u0200;bcf\u0486\u36EC\u36F0\u36F4ot;\u6336ir;\u6AF1\u0100;o\u36F9\u36FC\uC000\ud835\udd65rk;\u6ADA\xe1\u3362rime;\u6034\u0180aip\u370F\u3712\u3764d\xe5\u1248\u0380adempst\u3721\u374D\u3740\u3751\u3757\u375C\u375Fngle\u0280;dlqr\u3730\u3731\u3736\u3740\u3742\u65B5own\xbb\u1DBBeft\u0100;e\u2800\u373E\xf1\u092E;\u625Cight\u0100;e\u32AA\u374B\xf1\u105Aot;\u65ECinus;\u6A3Alus;\u6A39b;\u69CDime;\u6A3Bezium;\u63E2\u0180cht\u3772\u377D\u3781\u0100ry\u3777\u377B;\uC000\ud835\udcc9;\u4446cy;\u445Brok;\u4167\u0100io\u378B\u378Ex\xf4\u1777head\u0100lr\u3797\u37A0eftarro\xf7\u084Fightarrow\xbb\u0F5D\u0900AHabcdfghlmoprstuw\u37D0\u37D3\u37D7\u37E4\u37F0\u37FC\u380E\u381C\u3823\u3834\u3851\u385D\u386B\u38A9\u38CC\u38D2\u38EA\u38F6r\xf2\u03EDar;\u6963\u0100cr\u37DC\u37E2ute\u803B\xfa\u40FA\xf2\u1150r\u01E3\u37EA\0\u37EDy;\u445Eve;\u416D\u0100iy\u37F5\u37FArc\u803B\xfb\u40FB;\u4443\u0180abh\u3803\u3806\u380Br\xf2\u13ADlac;\u4171a\xf2\u13C3\u0100ir\u3813\u3818sht;\u697E;\uC000\ud835\udd32rave\u803B\xf9\u40F9\u0161\u3827\u3831r\u0100lr\u382C\u382E\xbb\u0957\xbb\u1083lk;\u6580\u0100ct\u3839\u384D\u026F\u383F\0\0\u384Arn\u0100;e\u3845\u3846\u631Cr\xbb\u3846op;\u630Fri;\u65F8\u0100al\u3856\u385Acr;\u416B\u80BB\xa8\u0349\u0100gp\u3862\u3866on;\u4173f;\uC000\ud835\udd66\u0300adhlsu\u114B\u3878\u387D\u1372\u3891\u38A0own\xe1\u13B3arpoon\u0100lr\u3888\u388Cef\xf4\u382Digh\xf4\u382Fi\u0180;hl\u3899\u389A\u389C\u43C5\xbb\u13FAon\xbb\u389Aparrows;\u61C8\u0180cit\u38B0\u38C4\u38C8\u026F\u38B6\0\0\u38C1rn\u0100;e\u38BC\u38BD\u631Dr\xbb\u38BDop;\u630Eng;\u416Fri;\u65F9cr;\uC000\ud835\udcca\u0180dir\u38D9\u38DD\u38E2ot;\u62F0lde;\u4169i\u0100;f\u3730\u38E8\xbb\u1813\u0100am\u38EF\u38F2r\xf2\u38A8l\u803B\xfc\u40FCangle;\u69A7\u0780ABDacdeflnoprsz\u391C\u391F\u3929\u392D\u39B5\u39B8\u39BD\u39DF\u39E4\u39E8\u39F3\u39F9\u39FD\u3A01\u3A20r\xf2\u03F7ar\u0100;v\u3926\u3927\u6AE8;\u6AE9as\xe8\u03E1\u0100nr\u3932\u3937grt;\u699C\u0380eknprst\u34E3\u3946\u394B\u3952\u395D\u3964\u3996app\xe1\u2415othin\xe7\u1E96\u0180hir\u34EB\u2EC8\u3959op\xf4\u2FB5\u0100;h\u13B7\u3962\xef\u318D\u0100iu\u3969\u396Dgm\xe1\u33B3\u0100bp\u3972\u3984setneq\u0100;q\u397D\u3980\uC000\u228A\uFE00;\uC000\u2ACB\uFE00setneq\u0100;q\u398F\u3992\uC000\u228B\uFE00;\uC000\u2ACC\uFE00\u0100hr\u399B\u399Fet\xe1\u369Ciangle\u0100lr\u39AA\u39AFeft\xbb\u0925ight\xbb\u1051y;\u4432ash\xbb\u1036\u0180elr\u39C4\u39D2\u39D7\u0180;be\u2DEA\u39CB\u39CFar;\u62BBq;\u625Alip;\u62EE\u0100bt\u39DC\u1468a\xf2\u1469r;\uC000\ud835\udd33tr\xe9\u39AEsu\u0100bp\u39EF\u39F1\xbb\u0D1C\xbb\u0D59pf;\uC000\ud835\udd67ro\xf0\u0EFBtr\xe9\u39B4\u0100cu\u3A06\u3A0Br;\uC000\ud835\udccb\u0100bp\u3A10\u3A18n\u0100Ee\u3980\u3A16\xbb\u397En\u0100Ee\u3992\u3A1E\xbb\u3990igzag;\u699A\u0380cefoprs\u3A36\u3A3B\u3A56\u3A5B\u3A54\u3A61\u3A6Airc;\u4175\u0100di\u3A40\u3A51\u0100bg\u3A45\u3A49ar;\u6A5Fe\u0100;q\u15FA\u3A4F;\u6259erp;\u6118r;\uC000\ud835\udd34pf;\uC000\ud835\udd68\u0100;e\u1479\u3A66at\xe8\u1479cr;\uC000\ud835\udccc\u0AE3\u178E\u3A87\0\u3A8B\0\u3A90\u3A9B\0\0\u3A9D\u3AA8\u3AAB\u3AAF\0\0\u3AC3\u3ACE\0\u3AD8\u17DC\u17DFtr\xe9\u17D1r;\uC000\ud835\udd35\u0100Aa\u3A94\u3A97r\xf2\u03C3r\xf2\u09F6;\u43BE\u0100Aa\u3AA1\u3AA4r\xf2\u03B8r\xf2\u09EBa\xf0\u2713is;\u62FB\u0180dpt\u17A4\u3AB5\u3ABE\u0100fl\u3ABA\u17A9;\uC000\ud835\udd69im\xe5\u17B2\u0100Aa\u3AC7\u3ACAr\xf2\u03CEr\xf2\u0A01\u0100cq\u3AD2\u17B8r;\uC000\ud835\udccd\u0100pt\u17D6\u3ADCr\xe9\u17D4\u0400acefiosu\u3AF0\u3AFD\u3B08\u3B0C\u3B11\u3B15\u3B1B\u3B21c\u0100uy\u3AF6\u3AFBte\u803B\xfd\u40FD;\u444F\u0100iy\u3B02\u3B06rc;\u4177;\u444Bn\u803B\xa5\u40A5r;\uC000\ud835\udd36cy;\u4457pf;\uC000\ud835\udd6acr;\uC000\ud835\udcce\u0100cm\u3B26\u3B29y;\u444El\u803B\xff\u40FF\u0500acdefhiosw\u3B42\u3B48\u3B54\u3B58\u3B64\u3B69\u3B6D\u3B74\u3B7A\u3B80cute;\u417A\u0100ay\u3B4D\u3B52ron;\u417E;\u4437ot;\u417C\u0100et\u3B5D\u3B61tr\xe6\u155Fa;\u43B6r;\uC000\ud835\udd37cy;\u4436grarr;\u61DDpf;\uC000\ud835\udd6bcr;\uC000\ud835\udccf\u0100jn\u3B85\u3B87;\u600Dj;\u600C'.split("").map((c)=>c.charCodeAt(0)));


// Generated using scripts/write-decode-map.ts
var $5fa531f21e7c1935$export$2e2bcd8739ae039 = new Uint16Array(// prettier-ignore
"\u0200aglq	\x15\x18\x1b\u026D\x0f\0\0\x12p;\u4026os;\u4027t;\u403Et;\u403Cuot;\u4022".split("").map((c)=>c.charCodeAt(0)));


// Adapted from https://github.com/mathiasbynens/he/blob/36afe179392226cf1b6ccdb16ebbb7a5a844d93a/src/he.js#L106-L134
var $06c7ff312a574685$var$_a;
const $06c7ff312a574685$var$decodeMap = new Map([
    [
        0,
        65533
    ],
    // C1 Unicode control character reference replacements
    [
        128,
        8364
    ],
    [
        130,
        8218
    ],
    [
        131,
        402
    ],
    [
        132,
        8222
    ],
    [
        133,
        8230
    ],
    [
        134,
        8224
    ],
    [
        135,
        8225
    ],
    [
        136,
        710
    ],
    [
        137,
        8240
    ],
    [
        138,
        352
    ],
    [
        139,
        8249
    ],
    [
        140,
        338
    ],
    [
        142,
        381
    ],
    [
        145,
        8216
    ],
    [
        146,
        8217
    ],
    [
        147,
        8220
    ],
    [
        148,
        8221
    ],
    [
        149,
        8226
    ],
    [
        150,
        8211
    ],
    [
        151,
        8212
    ],
    [
        152,
        732
    ],
    [
        153,
        8482
    ],
    [
        154,
        353
    ],
    [
        155,
        8250
    ],
    [
        156,
        339
    ],
    [
        158,
        382
    ],
    [
        159,
        376
    ]
]);
const $06c7ff312a574685$export$73bfc63873071f74 = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
($06c7ff312a574685$var$_a = String.fromCodePoint) !== null && $06c7ff312a574685$var$_a !== void 0 ? $06c7ff312a574685$var$_a : function(codePoint) {
    let output = "";
    if (codePoint > 0xffff) {
        codePoint -= 0x10000;
        output += String.fromCharCode(codePoint >>> 10 & 0x3ff | 0xd800);
        codePoint = 0xdc00 | codePoint & 0x3ff;
    }
    output += String.fromCharCode(codePoint);
    return output;
};
function $06c7ff312a574685$export$b978ab756102108a(codePoint) {
    var _a;
    if (codePoint >= 0xd800 && codePoint <= 0xdfff || codePoint > 0x10ffff) return 0xfffd;
    return (_a = $06c7ff312a574685$var$decodeMap.get(codePoint)) !== null && _a !== void 0 ? _a : codePoint;
}
function $06c7ff312a574685$export$2e2bcd8739ae039(codePoint) {
    return $06c7ff312a574685$export$73bfc63873071f74($06c7ff312a574685$export$b978ab756102108a(codePoint));
}


var $4cc47c481cd52694$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["NUM"] = 35] = "NUM";
    CharCodes[CharCodes["SEMI"] = 59] = "SEMI";
    CharCodes[CharCodes["EQUALS"] = 61] = "EQUALS";
    CharCodes[CharCodes["ZERO"] = 48] = "ZERO";
    CharCodes[CharCodes["NINE"] = 57] = "NINE";
    CharCodes[CharCodes["LOWER_A"] = 97] = "LOWER_A";
    CharCodes[CharCodes["LOWER_F"] = 102] = "LOWER_F";
    CharCodes[CharCodes["LOWER_X"] = 120] = "LOWER_X";
    CharCodes[CharCodes["LOWER_Z"] = 122] = "LOWER_Z";
    CharCodes[CharCodes["UPPER_A"] = 65] = "UPPER_A";
    CharCodes[CharCodes["UPPER_F"] = 70] = "UPPER_F";
    CharCodes[CharCodes["UPPER_Z"] = 90] = "UPPER_Z";
})($4cc47c481cd52694$var$CharCodes || ($4cc47c481cd52694$var$CharCodes = {}));
/** Bit that needs to be set to convert an upper case ASCII character to lower case */ const $4cc47c481cd52694$var$TO_LOWER_BIT = 32;
var $4cc47c481cd52694$export$6a4325c613e0faec;
(function(BinTrieFlags) {
    BinTrieFlags[BinTrieFlags["VALUE_LENGTH"] = 49152] = "VALUE_LENGTH";
    BinTrieFlags[BinTrieFlags["BRANCH_LENGTH"] = 16256] = "BRANCH_LENGTH";
    BinTrieFlags[BinTrieFlags["JUMP_TABLE"] = 127] = "JUMP_TABLE";
})($4cc47c481cd52694$export$6a4325c613e0faec || ($4cc47c481cd52694$export$6a4325c613e0faec = {}));
function $4cc47c481cd52694$var$isNumber(code) {
    return code >= $4cc47c481cd52694$var$CharCodes.ZERO && code <= $4cc47c481cd52694$var$CharCodes.NINE;
}
function $4cc47c481cd52694$var$isHexadecimalCharacter(code) {
    return code >= $4cc47c481cd52694$var$CharCodes.UPPER_A && code <= $4cc47c481cd52694$var$CharCodes.UPPER_F || code >= $4cc47c481cd52694$var$CharCodes.LOWER_A && code <= $4cc47c481cd52694$var$CharCodes.LOWER_F;
}
function $4cc47c481cd52694$var$isAsciiAlphaNumeric(code) {
    return code >= $4cc47c481cd52694$var$CharCodes.UPPER_A && code <= $4cc47c481cd52694$var$CharCodes.UPPER_Z || code >= $4cc47c481cd52694$var$CharCodes.LOWER_A && code <= $4cc47c481cd52694$var$CharCodes.LOWER_Z || $4cc47c481cd52694$var$isNumber(code);
}
/**
 * Checks if the given character is a valid end character for an entity in an attribute.
 *
 * Attribute values that aren't terminated properly aren't parsed, and shouldn't lead to a parser error.
 * See the example in https://html.spec.whatwg.org/multipage/parsing.html#named-character-reference-state
 */ function $4cc47c481cd52694$var$isEntityInAttributeInvalidEnd(code) {
    return code === $4cc47c481cd52694$var$CharCodes.EQUALS || $4cc47c481cd52694$var$isAsciiAlphaNumeric(code);
}
var $4cc47c481cd52694$var$EntityDecoderState;
(function(EntityDecoderState) {
    EntityDecoderState[EntityDecoderState["EntityStart"] = 0] = "EntityStart";
    EntityDecoderState[EntityDecoderState["NumericStart"] = 1] = "NumericStart";
    EntityDecoderState[EntityDecoderState["NumericDecimal"] = 2] = "NumericDecimal";
    EntityDecoderState[EntityDecoderState["NumericHex"] = 3] = "NumericHex";
    EntityDecoderState[EntityDecoderState["NamedEntity"] = 4] = "NamedEntity";
})($4cc47c481cd52694$var$EntityDecoderState || ($4cc47c481cd52694$var$EntityDecoderState = {}));
var $4cc47c481cd52694$export$8c8f129ce60f53c;
(function(DecodingMode) {
    /** Entities in text nodes that can end with any character. */ DecodingMode[DecodingMode["Legacy"] = 0] = "Legacy";
    /** Only allow entities terminated with a semicolon. */ DecodingMode[DecodingMode["Strict"] = 1] = "Strict";
    /** Entities in attributes have limitations on ending characters. */ DecodingMode[DecodingMode["Attribute"] = 2] = "Attribute";
})($4cc47c481cd52694$export$8c8f129ce60f53c || ($4cc47c481cd52694$export$8c8f129ce60f53c = {}));
class $4cc47c481cd52694$export$15263a93ff7ec8ba {
    constructor(/** The tree used to decode entities. */ decodeTree, /**
     * The function that is called when a codepoint is decoded.
     *
     * For multi-byte named entities, this will be called multiple times,
     * with the second codepoint, and the same `consumed` value.
     *
     * @param codepoint The decoded codepoint.
     * @param consumed The number of bytes consumed by the decoder.
     */ emitCodePoint, /** An object that is used to produce errors. */ errors){
        this.decodeTree = decodeTree;
        this.emitCodePoint = emitCodePoint;
        this.errors = errors;
        /** The current state of the decoder. */ this.state = $4cc47c481cd52694$var$EntityDecoderState.EntityStart;
        /** Characters that were consumed while parsing an entity. */ this.consumed = 1;
        /**
         * The result of the entity.
         *
         * Either the result index of a numeric entity, or the codepoint of a
         * numeric entity.
         */ this.result = 0;
        /** The current index in the decode tree. */ this.treeIndex = 0;
        /** The number of characters that were consumed in excess. */ this.excess = 1;
        /** The mode in which the decoder is operating. */ this.decodeMode = $4cc47c481cd52694$export$8c8f129ce60f53c.Strict;
    }
    /** Resets the instance to make it reusable. */ startEntity(decodeMode) {
        this.decodeMode = decodeMode;
        this.state = $4cc47c481cd52694$var$EntityDecoderState.EntityStart;
        this.result = 0;
        this.treeIndex = 0;
        this.excess = 1;
        this.consumed = 1;
    }
    /**
     * Write an entity to the decoder. This can be called multiple times with partial entities.
     * If the entity is incomplete, the decoder will return -1.
     *
     * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
     * entity is incomplete, and resume when the next string is written.
     *
     * @param string The string containing the entity (or a continuation of the entity).
     * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ write(str, offset) {
        switch(this.state){
            case $4cc47c481cd52694$var$EntityDecoderState.EntityStart:
                if (str.charCodeAt(offset) === $4cc47c481cd52694$var$CharCodes.NUM) {
                    this.state = $4cc47c481cd52694$var$EntityDecoderState.NumericStart;
                    this.consumed += 1;
                    return this.stateNumericStart(str, offset + 1);
                }
                this.state = $4cc47c481cd52694$var$EntityDecoderState.NamedEntity;
                return this.stateNamedEntity(str, offset);
            case $4cc47c481cd52694$var$EntityDecoderState.NumericStart:
                return this.stateNumericStart(str, offset);
            case $4cc47c481cd52694$var$EntityDecoderState.NumericDecimal:
                return this.stateNumericDecimal(str, offset);
            case $4cc47c481cd52694$var$EntityDecoderState.NumericHex:
                return this.stateNumericHex(str, offset);
            case $4cc47c481cd52694$var$EntityDecoderState.NamedEntity:
                return this.stateNamedEntity(str, offset);
        }
    }
    /**
     * Switches between the numeric decimal and hexadecimal states.
     *
     * Equivalent to the `Numeric character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericStart(str, offset) {
        if (offset >= str.length) return -1;
        if ((str.charCodeAt(offset) | $4cc47c481cd52694$var$TO_LOWER_BIT) === $4cc47c481cd52694$var$CharCodes.LOWER_X) {
            this.state = $4cc47c481cd52694$var$EntityDecoderState.NumericHex;
            this.consumed += 1;
            return this.stateNumericHex(str, offset + 1);
        }
        this.state = $4cc47c481cd52694$var$EntityDecoderState.NumericDecimal;
        return this.stateNumericDecimal(str, offset);
    }
    addToNumericResult(str, start, end, base) {
        if (start !== end) {
            const digitCount = end - start;
            this.result = this.result * Math.pow(base, digitCount) + parseInt(str.substr(start, digitCount), base);
            this.consumed += digitCount;
        }
    }
    /**
     * Parses a hexadecimal numeric entity.
     *
     * Equivalent to the `Hexademical character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericHex(str, offset) {
        const startIdx = offset;
        while(offset < str.length){
            const char = str.charCodeAt(offset);
            if ($4cc47c481cd52694$var$isNumber(char) || $4cc47c481cd52694$var$isHexadecimalCharacter(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 16);
                return this.emitNumericEntity(char, 3);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 16);
        return -1;
    }
    /**
     * Parses a decimal numeric entity.
     *
     * Equivalent to the `Decimal character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericDecimal(str, offset) {
        const startIdx = offset;
        while(offset < str.length){
            const char = str.charCodeAt(offset);
            if ($4cc47c481cd52694$var$isNumber(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 10);
                return this.emitNumericEntity(char, 2);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 10);
        return -1;
    }
    /**
     * Validate and emit a numeric entity.
     *
     * Implements the logic from the `Hexademical character reference start
     * state` and `Numeric character reference end state` in the HTML spec.
     *
     * @param lastCp The last code point of the entity. Used to see if the
     *               entity was terminated with a semicolon.
     * @param expectedLength The minimum number of characters that should be
     *                       consumed. Used to validate that at least one digit
     *                       was consumed.
     * @returns The number of characters that were consumed.
     */ emitNumericEntity(lastCp, expectedLength) {
        var _a;
        // Ensure we consumed at least one digit.
        if (this.consumed <= expectedLength) {
            (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
            return 0;
        }
        // Figure out if this is a legit end of the entity
        if (lastCp === $4cc47c481cd52694$var$CharCodes.SEMI) this.consumed += 1;
        else if (this.decodeMode === $4cc47c481cd52694$export$8c8f129ce60f53c.Strict) return 0;
        this.emitCodePoint((0, $06c7ff312a574685$export$b978ab756102108a)(this.result), this.consumed);
        if (this.errors) {
            if (lastCp !== $4cc47c481cd52694$var$CharCodes.SEMI) this.errors.missingSemicolonAfterCharacterReference();
            this.errors.validateNumericCharacterReference(this.result);
        }
        return this.consumed;
    }
    /**
     * Parses a named entity.
     *
     * Equivalent to the `Named character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNamedEntity(str, offset) {
        const { decodeTree: decodeTree } = this;
        let current = decodeTree[this.treeIndex];
        // The mask is the number of bytes of the value, including the current byte.
        let valueLength = (current & $4cc47c481cd52694$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
        for(; offset < str.length; offset++, this.excess++){
            const char = str.charCodeAt(offset);
            this.treeIndex = $4cc47c481cd52694$export$44c08d99945e6276(decodeTree, current, this.treeIndex + Math.max(1, valueLength), char);
            if (this.treeIndex < 0) return this.result === 0 || // If we are parsing an attribute
            this.decodeMode === $4cc47c481cd52694$export$8c8f129ce60f53c.Attribute && // We shouldn't have consumed any characters after the entity,
            (valueLength === 0 || // And there should be no invalid characters.
            $4cc47c481cd52694$var$isEntityInAttributeInvalidEnd(char)) ? 0 : this.emitNotTerminatedNamedEntity();
            current = decodeTree[this.treeIndex];
            valueLength = (current & $4cc47c481cd52694$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
            // If the branch is a value, store it and continue
            if (valueLength !== 0) {
                // If the entity is terminated by a semicolon, we are done.
                if (char === $4cc47c481cd52694$var$CharCodes.SEMI) return this.emitNamedEntityData(this.treeIndex, valueLength, this.consumed + this.excess);
                // If we encounter a non-terminated (legacy) entity while parsing strictly, then ignore it.
                if (this.decodeMode !== $4cc47c481cd52694$export$8c8f129ce60f53c.Strict) {
                    this.result = this.treeIndex;
                    this.consumed += this.excess;
                    this.excess = 0;
                }
            }
        }
        return -1;
    }
    /**
     * Emit a named entity that was not terminated with a semicolon.
     *
     * @returns The number of characters consumed.
     */ emitNotTerminatedNamedEntity() {
        var _a;
        const { result: result, decodeTree: decodeTree } = this;
        const valueLength = (decodeTree[result] & $4cc47c481cd52694$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
        this.emitNamedEntityData(result, valueLength, this.consumed);
        (_a = this.errors) === null || _a === void 0 || _a.missingSemicolonAfterCharacterReference();
        return this.consumed;
    }
    /**
     * Emit a named entity.
     *
     * @param result The index of the entity in the decode tree.
     * @param valueLength The number of bytes in the entity.
     * @param consumed The number of characters consumed.
     *
     * @returns The number of characters consumed.
     */ emitNamedEntityData(result, valueLength, consumed) {
        const { decodeTree: decodeTree } = this;
        this.emitCodePoint(valueLength === 1 ? decodeTree[result] & ~$4cc47c481cd52694$export$6a4325c613e0faec.VALUE_LENGTH : decodeTree[result + 1], consumed);
        if (valueLength === 3) // For multi-byte values, we need to emit the second byte.
        this.emitCodePoint(decodeTree[result + 2], consumed);
        return consumed;
    }
    /**
     * Signal to the parser that the end of the input was reached.
     *
     * Remaining data will be emitted and relevant errors will be produced.
     *
     * @returns The number of characters consumed.
     */ end() {
        var _a;
        switch(this.state){
            case $4cc47c481cd52694$var$EntityDecoderState.NamedEntity:
                // Emit a named entity if we have one.
                return this.result !== 0 && (this.decodeMode !== $4cc47c481cd52694$export$8c8f129ce60f53c.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
            // Otherwise, emit a numeric entity if we have one.
            case $4cc47c481cd52694$var$EntityDecoderState.NumericDecimal:
                return this.emitNumericEntity(0, 2);
            case $4cc47c481cd52694$var$EntityDecoderState.NumericHex:
                return this.emitNumericEntity(0, 3);
            case $4cc47c481cd52694$var$EntityDecoderState.NumericStart:
                (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
                return 0;
            case $4cc47c481cd52694$var$EntityDecoderState.EntityStart:
                // Return 0 if we have no entity.
                return 0;
        }
    }
}
/**
 * Creates a function that decodes entities in a string.
 *
 * @param decodeTree The decode tree.
 * @returns A function that decodes entities in a string.
 */ function $4cc47c481cd52694$var$getDecoder(decodeTree) {
    let ret = "";
    const decoder = new $4cc47c481cd52694$export$15263a93ff7ec8ba(decodeTree, (str)=>ret += (0, $06c7ff312a574685$export$73bfc63873071f74)(str));
    return function decodeWithTrie(str, decodeMode) {
        let lastIndex = 0;
        let offset = 0;
        while((offset = str.indexOf("&", offset)) >= 0){
            ret += str.slice(lastIndex, offset);
            decoder.startEntity(decodeMode);
            const len = decoder.write(str, // Skip the "&"
            offset + 1);
            if (len < 0) {
                lastIndex = offset + decoder.end();
                break;
            }
            lastIndex = offset + len;
            // If `len` is 0, skip the current `&` and continue.
            offset = len === 0 ? lastIndex + 1 : lastIndex;
        }
        const result = ret + str.slice(lastIndex);
        // Make sure we don't keep a reference to the final string.
        ret = "";
        return result;
    };
}
function $4cc47c481cd52694$export$44c08d99945e6276(decodeTree, current, nodeIdx, char) {
    const branchCount = (current & $4cc47c481cd52694$export$6a4325c613e0faec.BRANCH_LENGTH) >> 7;
    const jumpOffset = current & $4cc47c481cd52694$export$6a4325c613e0faec.JUMP_TABLE;
    // Case 1: Single branch encoded in jump offset
    if (branchCount === 0) return jumpOffset !== 0 && char === jumpOffset ? nodeIdx : -1;
    // Case 2: Multiple branches encoded in jump table
    if (jumpOffset) {
        const value = char - jumpOffset;
        return value < 0 || value >= branchCount ? -1 : decodeTree[nodeIdx + value] - 1;
    }
    // Case 3: Multiple branches encoded in dictionary
    // Binary search for the character.
    let lo = nodeIdx;
    let hi = lo + branchCount - 1;
    while(lo <= hi){
        const mid = lo + hi >>> 1;
        const midVal = decodeTree[mid];
        if (midVal < char) lo = mid + 1;
        else if (midVal > char) hi = mid - 1;
        else return decodeTree[mid + branchCount];
    }
    return -1;
}
const $4cc47c481cd52694$var$htmlDecoder = $4cc47c481cd52694$var$getDecoder((0, $3325d032405f9469$export$2e2bcd8739ae039));
const $4cc47c481cd52694$var$xmlDecoder = $4cc47c481cd52694$var$getDecoder((0, $5fa531f21e7c1935$export$2e2bcd8739ae039));
function $4cc47c481cd52694$export$f045cb747ce77a19(str, mode = $4cc47c481cd52694$export$8c8f129ce60f53c.Legacy) {
    return $4cc47c481cd52694$var$htmlDecoder(str, mode);
}
function $4cc47c481cd52694$export$49f5e8089adb006a(str) {
    return $4cc47c481cd52694$var$htmlDecoder(str, $4cc47c481cd52694$export$8c8f129ce60f53c.Attribute);
}
function $4cc47c481cd52694$export$da52f4371b3f37de(str) {
    return $4cc47c481cd52694$var$htmlDecoder(str, $4cc47c481cd52694$export$8c8f129ce60f53c.Strict);
}
function $4cc47c481cd52694$export$88e3b9643a8bd06e(str) {
    return $4cc47c481cd52694$var$xmlDecoder(str, $4cc47c481cd52694$export$8c8f129ce60f53c.Strict);
}


// Generated using scripts/write-encode-map.ts
function $ea0da353c9e2246b$var$restoreDiff(arr) {
    for(let i = 1; i < arr.length; i++)arr[i][0] += arr[i - 1][0] + 1;
    return arr;
}
var // prettier-ignore
$ea0da353c9e2246b$export$2e2bcd8739ae039 = new Map(/* #__PURE__ */ $ea0da353c9e2246b$var$restoreDiff([
    [
        9,
        "&Tab;"
    ],
    [
        0,
        "&NewLine;"
    ],
    [
        22,
        "&excl;"
    ],
    [
        0,
        "&quot;"
    ],
    [
        0,
        "&num;"
    ],
    [
        0,
        "&dollar;"
    ],
    [
        0,
        "&percnt;"
    ],
    [
        0,
        "&amp;"
    ],
    [
        0,
        "&apos;"
    ],
    [
        0,
        "&lpar;"
    ],
    [
        0,
        "&rpar;"
    ],
    [
        0,
        "&ast;"
    ],
    [
        0,
        "&plus;"
    ],
    [
        0,
        "&comma;"
    ],
    [
        1,
        "&period;"
    ],
    [
        0,
        "&sol;"
    ],
    [
        10,
        "&colon;"
    ],
    [
        0,
        "&semi;"
    ],
    [
        0,
        {
            v: "&lt;",
            n: 8402,
            o: "&nvlt;"
        }
    ],
    [
        0,
        {
            v: "&equals;",
            n: 8421,
            o: "&bne;"
        }
    ],
    [
        0,
        {
            v: "&gt;",
            n: 8402,
            o: "&nvgt;"
        }
    ],
    [
        0,
        "&quest;"
    ],
    [
        0,
        "&commat;"
    ],
    [
        26,
        "&lbrack;"
    ],
    [
        0,
        "&bsol;"
    ],
    [
        0,
        "&rbrack;"
    ],
    [
        0,
        "&Hat;"
    ],
    [
        0,
        "&lowbar;"
    ],
    [
        0,
        "&DiacriticalGrave;"
    ],
    [
        5,
        {
            n: 106,
            o: "&fjlig;"
        }
    ],
    [
        20,
        "&lbrace;"
    ],
    [
        0,
        "&verbar;"
    ],
    [
        0,
        "&rbrace;"
    ],
    [
        34,
        "&nbsp;"
    ],
    [
        0,
        "&iexcl;"
    ],
    [
        0,
        "&cent;"
    ],
    [
        0,
        "&pound;"
    ],
    [
        0,
        "&curren;"
    ],
    [
        0,
        "&yen;"
    ],
    [
        0,
        "&brvbar;"
    ],
    [
        0,
        "&sect;"
    ],
    [
        0,
        "&die;"
    ],
    [
        0,
        "&copy;"
    ],
    [
        0,
        "&ordf;"
    ],
    [
        0,
        "&laquo;"
    ],
    [
        0,
        "&not;"
    ],
    [
        0,
        "&shy;"
    ],
    [
        0,
        "&circledR;"
    ],
    [
        0,
        "&macr;"
    ],
    [
        0,
        "&deg;"
    ],
    [
        0,
        "&PlusMinus;"
    ],
    [
        0,
        "&sup2;"
    ],
    [
        0,
        "&sup3;"
    ],
    [
        0,
        "&acute;"
    ],
    [
        0,
        "&micro;"
    ],
    [
        0,
        "&para;"
    ],
    [
        0,
        "&centerdot;"
    ],
    [
        0,
        "&cedil;"
    ],
    [
        0,
        "&sup1;"
    ],
    [
        0,
        "&ordm;"
    ],
    [
        0,
        "&raquo;"
    ],
    [
        0,
        "&frac14;"
    ],
    [
        0,
        "&frac12;"
    ],
    [
        0,
        "&frac34;"
    ],
    [
        0,
        "&iquest;"
    ],
    [
        0,
        "&Agrave;"
    ],
    [
        0,
        "&Aacute;"
    ],
    [
        0,
        "&Acirc;"
    ],
    [
        0,
        "&Atilde;"
    ],
    [
        0,
        "&Auml;"
    ],
    [
        0,
        "&angst;"
    ],
    [
        0,
        "&AElig;"
    ],
    [
        0,
        "&Ccedil;"
    ],
    [
        0,
        "&Egrave;"
    ],
    [
        0,
        "&Eacute;"
    ],
    [
        0,
        "&Ecirc;"
    ],
    [
        0,
        "&Euml;"
    ],
    [
        0,
        "&Igrave;"
    ],
    [
        0,
        "&Iacute;"
    ],
    [
        0,
        "&Icirc;"
    ],
    [
        0,
        "&Iuml;"
    ],
    [
        0,
        "&ETH;"
    ],
    [
        0,
        "&Ntilde;"
    ],
    [
        0,
        "&Ograve;"
    ],
    [
        0,
        "&Oacute;"
    ],
    [
        0,
        "&Ocirc;"
    ],
    [
        0,
        "&Otilde;"
    ],
    [
        0,
        "&Ouml;"
    ],
    [
        0,
        "&times;"
    ],
    [
        0,
        "&Oslash;"
    ],
    [
        0,
        "&Ugrave;"
    ],
    [
        0,
        "&Uacute;"
    ],
    [
        0,
        "&Ucirc;"
    ],
    [
        0,
        "&Uuml;"
    ],
    [
        0,
        "&Yacute;"
    ],
    [
        0,
        "&THORN;"
    ],
    [
        0,
        "&szlig;"
    ],
    [
        0,
        "&agrave;"
    ],
    [
        0,
        "&aacute;"
    ],
    [
        0,
        "&acirc;"
    ],
    [
        0,
        "&atilde;"
    ],
    [
        0,
        "&auml;"
    ],
    [
        0,
        "&aring;"
    ],
    [
        0,
        "&aelig;"
    ],
    [
        0,
        "&ccedil;"
    ],
    [
        0,
        "&egrave;"
    ],
    [
        0,
        "&eacute;"
    ],
    [
        0,
        "&ecirc;"
    ],
    [
        0,
        "&euml;"
    ],
    [
        0,
        "&igrave;"
    ],
    [
        0,
        "&iacute;"
    ],
    [
        0,
        "&icirc;"
    ],
    [
        0,
        "&iuml;"
    ],
    [
        0,
        "&eth;"
    ],
    [
        0,
        "&ntilde;"
    ],
    [
        0,
        "&ograve;"
    ],
    [
        0,
        "&oacute;"
    ],
    [
        0,
        "&ocirc;"
    ],
    [
        0,
        "&otilde;"
    ],
    [
        0,
        "&ouml;"
    ],
    [
        0,
        "&div;"
    ],
    [
        0,
        "&oslash;"
    ],
    [
        0,
        "&ugrave;"
    ],
    [
        0,
        "&uacute;"
    ],
    [
        0,
        "&ucirc;"
    ],
    [
        0,
        "&uuml;"
    ],
    [
        0,
        "&yacute;"
    ],
    [
        0,
        "&thorn;"
    ],
    [
        0,
        "&yuml;"
    ],
    [
        0,
        "&Amacr;"
    ],
    [
        0,
        "&amacr;"
    ],
    [
        0,
        "&Abreve;"
    ],
    [
        0,
        "&abreve;"
    ],
    [
        0,
        "&Aogon;"
    ],
    [
        0,
        "&aogon;"
    ],
    [
        0,
        "&Cacute;"
    ],
    [
        0,
        "&cacute;"
    ],
    [
        0,
        "&Ccirc;"
    ],
    [
        0,
        "&ccirc;"
    ],
    [
        0,
        "&Cdot;"
    ],
    [
        0,
        "&cdot;"
    ],
    [
        0,
        "&Ccaron;"
    ],
    [
        0,
        "&ccaron;"
    ],
    [
        0,
        "&Dcaron;"
    ],
    [
        0,
        "&dcaron;"
    ],
    [
        0,
        "&Dstrok;"
    ],
    [
        0,
        "&dstrok;"
    ],
    [
        0,
        "&Emacr;"
    ],
    [
        0,
        "&emacr;"
    ],
    [
        2,
        "&Edot;"
    ],
    [
        0,
        "&edot;"
    ],
    [
        0,
        "&Eogon;"
    ],
    [
        0,
        "&eogon;"
    ],
    [
        0,
        "&Ecaron;"
    ],
    [
        0,
        "&ecaron;"
    ],
    [
        0,
        "&Gcirc;"
    ],
    [
        0,
        "&gcirc;"
    ],
    [
        0,
        "&Gbreve;"
    ],
    [
        0,
        "&gbreve;"
    ],
    [
        0,
        "&Gdot;"
    ],
    [
        0,
        "&gdot;"
    ],
    [
        0,
        "&Gcedil;"
    ],
    [
        1,
        "&Hcirc;"
    ],
    [
        0,
        "&hcirc;"
    ],
    [
        0,
        "&Hstrok;"
    ],
    [
        0,
        "&hstrok;"
    ],
    [
        0,
        "&Itilde;"
    ],
    [
        0,
        "&itilde;"
    ],
    [
        0,
        "&Imacr;"
    ],
    [
        0,
        "&imacr;"
    ],
    [
        2,
        "&Iogon;"
    ],
    [
        0,
        "&iogon;"
    ],
    [
        0,
        "&Idot;"
    ],
    [
        0,
        "&imath;"
    ],
    [
        0,
        "&IJlig;"
    ],
    [
        0,
        "&ijlig;"
    ],
    [
        0,
        "&Jcirc;"
    ],
    [
        0,
        "&jcirc;"
    ],
    [
        0,
        "&Kcedil;"
    ],
    [
        0,
        "&kcedil;"
    ],
    [
        0,
        "&kgreen;"
    ],
    [
        0,
        "&Lacute;"
    ],
    [
        0,
        "&lacute;"
    ],
    [
        0,
        "&Lcedil;"
    ],
    [
        0,
        "&lcedil;"
    ],
    [
        0,
        "&Lcaron;"
    ],
    [
        0,
        "&lcaron;"
    ],
    [
        0,
        "&Lmidot;"
    ],
    [
        0,
        "&lmidot;"
    ],
    [
        0,
        "&Lstrok;"
    ],
    [
        0,
        "&lstrok;"
    ],
    [
        0,
        "&Nacute;"
    ],
    [
        0,
        "&nacute;"
    ],
    [
        0,
        "&Ncedil;"
    ],
    [
        0,
        "&ncedil;"
    ],
    [
        0,
        "&Ncaron;"
    ],
    [
        0,
        "&ncaron;"
    ],
    [
        0,
        "&napos;"
    ],
    [
        0,
        "&ENG;"
    ],
    [
        0,
        "&eng;"
    ],
    [
        0,
        "&Omacr;"
    ],
    [
        0,
        "&omacr;"
    ],
    [
        2,
        "&Odblac;"
    ],
    [
        0,
        "&odblac;"
    ],
    [
        0,
        "&OElig;"
    ],
    [
        0,
        "&oelig;"
    ],
    [
        0,
        "&Racute;"
    ],
    [
        0,
        "&racute;"
    ],
    [
        0,
        "&Rcedil;"
    ],
    [
        0,
        "&rcedil;"
    ],
    [
        0,
        "&Rcaron;"
    ],
    [
        0,
        "&rcaron;"
    ],
    [
        0,
        "&Sacute;"
    ],
    [
        0,
        "&sacute;"
    ],
    [
        0,
        "&Scirc;"
    ],
    [
        0,
        "&scirc;"
    ],
    [
        0,
        "&Scedil;"
    ],
    [
        0,
        "&scedil;"
    ],
    [
        0,
        "&Scaron;"
    ],
    [
        0,
        "&scaron;"
    ],
    [
        0,
        "&Tcedil;"
    ],
    [
        0,
        "&tcedil;"
    ],
    [
        0,
        "&Tcaron;"
    ],
    [
        0,
        "&tcaron;"
    ],
    [
        0,
        "&Tstrok;"
    ],
    [
        0,
        "&tstrok;"
    ],
    [
        0,
        "&Utilde;"
    ],
    [
        0,
        "&utilde;"
    ],
    [
        0,
        "&Umacr;"
    ],
    [
        0,
        "&umacr;"
    ],
    [
        0,
        "&Ubreve;"
    ],
    [
        0,
        "&ubreve;"
    ],
    [
        0,
        "&Uring;"
    ],
    [
        0,
        "&uring;"
    ],
    [
        0,
        "&Udblac;"
    ],
    [
        0,
        "&udblac;"
    ],
    [
        0,
        "&Uogon;"
    ],
    [
        0,
        "&uogon;"
    ],
    [
        0,
        "&Wcirc;"
    ],
    [
        0,
        "&wcirc;"
    ],
    [
        0,
        "&Ycirc;"
    ],
    [
        0,
        "&ycirc;"
    ],
    [
        0,
        "&Yuml;"
    ],
    [
        0,
        "&Zacute;"
    ],
    [
        0,
        "&zacute;"
    ],
    [
        0,
        "&Zdot;"
    ],
    [
        0,
        "&zdot;"
    ],
    [
        0,
        "&Zcaron;"
    ],
    [
        0,
        "&zcaron;"
    ],
    [
        19,
        "&fnof;"
    ],
    [
        34,
        "&imped;"
    ],
    [
        63,
        "&gacute;"
    ],
    [
        65,
        "&jmath;"
    ],
    [
        142,
        "&circ;"
    ],
    [
        0,
        "&caron;"
    ],
    [
        16,
        "&breve;"
    ],
    [
        0,
        "&DiacriticalDot;"
    ],
    [
        0,
        "&ring;"
    ],
    [
        0,
        "&ogon;"
    ],
    [
        0,
        "&DiacriticalTilde;"
    ],
    [
        0,
        "&dblac;"
    ],
    [
        51,
        "&DownBreve;"
    ],
    [
        127,
        "&Alpha;"
    ],
    [
        0,
        "&Beta;"
    ],
    [
        0,
        "&Gamma;"
    ],
    [
        0,
        "&Delta;"
    ],
    [
        0,
        "&Epsilon;"
    ],
    [
        0,
        "&Zeta;"
    ],
    [
        0,
        "&Eta;"
    ],
    [
        0,
        "&Theta;"
    ],
    [
        0,
        "&Iota;"
    ],
    [
        0,
        "&Kappa;"
    ],
    [
        0,
        "&Lambda;"
    ],
    [
        0,
        "&Mu;"
    ],
    [
        0,
        "&Nu;"
    ],
    [
        0,
        "&Xi;"
    ],
    [
        0,
        "&Omicron;"
    ],
    [
        0,
        "&Pi;"
    ],
    [
        0,
        "&Rho;"
    ],
    [
        1,
        "&Sigma;"
    ],
    [
        0,
        "&Tau;"
    ],
    [
        0,
        "&Upsilon;"
    ],
    [
        0,
        "&Phi;"
    ],
    [
        0,
        "&Chi;"
    ],
    [
        0,
        "&Psi;"
    ],
    [
        0,
        "&ohm;"
    ],
    [
        7,
        "&alpha;"
    ],
    [
        0,
        "&beta;"
    ],
    [
        0,
        "&gamma;"
    ],
    [
        0,
        "&delta;"
    ],
    [
        0,
        "&epsi;"
    ],
    [
        0,
        "&zeta;"
    ],
    [
        0,
        "&eta;"
    ],
    [
        0,
        "&theta;"
    ],
    [
        0,
        "&iota;"
    ],
    [
        0,
        "&kappa;"
    ],
    [
        0,
        "&lambda;"
    ],
    [
        0,
        "&mu;"
    ],
    [
        0,
        "&nu;"
    ],
    [
        0,
        "&xi;"
    ],
    [
        0,
        "&omicron;"
    ],
    [
        0,
        "&pi;"
    ],
    [
        0,
        "&rho;"
    ],
    [
        0,
        "&sigmaf;"
    ],
    [
        0,
        "&sigma;"
    ],
    [
        0,
        "&tau;"
    ],
    [
        0,
        "&upsi;"
    ],
    [
        0,
        "&phi;"
    ],
    [
        0,
        "&chi;"
    ],
    [
        0,
        "&psi;"
    ],
    [
        0,
        "&omega;"
    ],
    [
        7,
        "&thetasym;"
    ],
    [
        0,
        "&Upsi;"
    ],
    [
        2,
        "&phiv;"
    ],
    [
        0,
        "&piv;"
    ],
    [
        5,
        "&Gammad;"
    ],
    [
        0,
        "&digamma;"
    ],
    [
        18,
        "&kappav;"
    ],
    [
        0,
        "&rhov;"
    ],
    [
        3,
        "&epsiv;"
    ],
    [
        0,
        "&backepsilon;"
    ],
    [
        10,
        "&IOcy;"
    ],
    [
        0,
        "&DJcy;"
    ],
    [
        0,
        "&GJcy;"
    ],
    [
        0,
        "&Jukcy;"
    ],
    [
        0,
        "&DScy;"
    ],
    [
        0,
        "&Iukcy;"
    ],
    [
        0,
        "&YIcy;"
    ],
    [
        0,
        "&Jsercy;"
    ],
    [
        0,
        "&LJcy;"
    ],
    [
        0,
        "&NJcy;"
    ],
    [
        0,
        "&TSHcy;"
    ],
    [
        0,
        "&KJcy;"
    ],
    [
        1,
        "&Ubrcy;"
    ],
    [
        0,
        "&DZcy;"
    ],
    [
        0,
        "&Acy;"
    ],
    [
        0,
        "&Bcy;"
    ],
    [
        0,
        "&Vcy;"
    ],
    [
        0,
        "&Gcy;"
    ],
    [
        0,
        "&Dcy;"
    ],
    [
        0,
        "&IEcy;"
    ],
    [
        0,
        "&ZHcy;"
    ],
    [
        0,
        "&Zcy;"
    ],
    [
        0,
        "&Icy;"
    ],
    [
        0,
        "&Jcy;"
    ],
    [
        0,
        "&Kcy;"
    ],
    [
        0,
        "&Lcy;"
    ],
    [
        0,
        "&Mcy;"
    ],
    [
        0,
        "&Ncy;"
    ],
    [
        0,
        "&Ocy;"
    ],
    [
        0,
        "&Pcy;"
    ],
    [
        0,
        "&Rcy;"
    ],
    [
        0,
        "&Scy;"
    ],
    [
        0,
        "&Tcy;"
    ],
    [
        0,
        "&Ucy;"
    ],
    [
        0,
        "&Fcy;"
    ],
    [
        0,
        "&KHcy;"
    ],
    [
        0,
        "&TScy;"
    ],
    [
        0,
        "&CHcy;"
    ],
    [
        0,
        "&SHcy;"
    ],
    [
        0,
        "&SHCHcy;"
    ],
    [
        0,
        "&HARDcy;"
    ],
    [
        0,
        "&Ycy;"
    ],
    [
        0,
        "&SOFTcy;"
    ],
    [
        0,
        "&Ecy;"
    ],
    [
        0,
        "&YUcy;"
    ],
    [
        0,
        "&YAcy;"
    ],
    [
        0,
        "&acy;"
    ],
    [
        0,
        "&bcy;"
    ],
    [
        0,
        "&vcy;"
    ],
    [
        0,
        "&gcy;"
    ],
    [
        0,
        "&dcy;"
    ],
    [
        0,
        "&iecy;"
    ],
    [
        0,
        "&zhcy;"
    ],
    [
        0,
        "&zcy;"
    ],
    [
        0,
        "&icy;"
    ],
    [
        0,
        "&jcy;"
    ],
    [
        0,
        "&kcy;"
    ],
    [
        0,
        "&lcy;"
    ],
    [
        0,
        "&mcy;"
    ],
    [
        0,
        "&ncy;"
    ],
    [
        0,
        "&ocy;"
    ],
    [
        0,
        "&pcy;"
    ],
    [
        0,
        "&rcy;"
    ],
    [
        0,
        "&scy;"
    ],
    [
        0,
        "&tcy;"
    ],
    [
        0,
        "&ucy;"
    ],
    [
        0,
        "&fcy;"
    ],
    [
        0,
        "&khcy;"
    ],
    [
        0,
        "&tscy;"
    ],
    [
        0,
        "&chcy;"
    ],
    [
        0,
        "&shcy;"
    ],
    [
        0,
        "&shchcy;"
    ],
    [
        0,
        "&hardcy;"
    ],
    [
        0,
        "&ycy;"
    ],
    [
        0,
        "&softcy;"
    ],
    [
        0,
        "&ecy;"
    ],
    [
        0,
        "&yucy;"
    ],
    [
        0,
        "&yacy;"
    ],
    [
        1,
        "&iocy;"
    ],
    [
        0,
        "&djcy;"
    ],
    [
        0,
        "&gjcy;"
    ],
    [
        0,
        "&jukcy;"
    ],
    [
        0,
        "&dscy;"
    ],
    [
        0,
        "&iukcy;"
    ],
    [
        0,
        "&yicy;"
    ],
    [
        0,
        "&jsercy;"
    ],
    [
        0,
        "&ljcy;"
    ],
    [
        0,
        "&njcy;"
    ],
    [
        0,
        "&tshcy;"
    ],
    [
        0,
        "&kjcy;"
    ],
    [
        1,
        "&ubrcy;"
    ],
    [
        0,
        "&dzcy;"
    ],
    [
        7074,
        "&ensp;"
    ],
    [
        0,
        "&emsp;"
    ],
    [
        0,
        "&emsp13;"
    ],
    [
        0,
        "&emsp14;"
    ],
    [
        1,
        "&numsp;"
    ],
    [
        0,
        "&puncsp;"
    ],
    [
        0,
        "&ThinSpace;"
    ],
    [
        0,
        "&hairsp;"
    ],
    [
        0,
        "&NegativeMediumSpace;"
    ],
    [
        0,
        "&zwnj;"
    ],
    [
        0,
        "&zwj;"
    ],
    [
        0,
        "&lrm;"
    ],
    [
        0,
        "&rlm;"
    ],
    [
        0,
        "&dash;"
    ],
    [
        2,
        "&ndash;"
    ],
    [
        0,
        "&mdash;"
    ],
    [
        0,
        "&horbar;"
    ],
    [
        0,
        "&Verbar;"
    ],
    [
        1,
        "&lsquo;"
    ],
    [
        0,
        "&CloseCurlyQuote;"
    ],
    [
        0,
        "&lsquor;"
    ],
    [
        1,
        "&ldquo;"
    ],
    [
        0,
        "&CloseCurlyDoubleQuote;"
    ],
    [
        0,
        "&bdquo;"
    ],
    [
        1,
        "&dagger;"
    ],
    [
        0,
        "&Dagger;"
    ],
    [
        0,
        "&bull;"
    ],
    [
        2,
        "&nldr;"
    ],
    [
        0,
        "&hellip;"
    ],
    [
        9,
        "&permil;"
    ],
    [
        0,
        "&pertenk;"
    ],
    [
        0,
        "&prime;"
    ],
    [
        0,
        "&Prime;"
    ],
    [
        0,
        "&tprime;"
    ],
    [
        0,
        "&backprime;"
    ],
    [
        3,
        "&lsaquo;"
    ],
    [
        0,
        "&rsaquo;"
    ],
    [
        3,
        "&oline;"
    ],
    [
        2,
        "&caret;"
    ],
    [
        1,
        "&hybull;"
    ],
    [
        0,
        "&frasl;"
    ],
    [
        10,
        "&bsemi;"
    ],
    [
        7,
        "&qprime;"
    ],
    [
        7,
        {
            v: "&MediumSpace;",
            n: 8202,
            o: "&ThickSpace;"
        }
    ],
    [
        0,
        "&NoBreak;"
    ],
    [
        0,
        "&af;"
    ],
    [
        0,
        "&InvisibleTimes;"
    ],
    [
        0,
        "&ic;"
    ],
    [
        72,
        "&euro;"
    ],
    [
        46,
        "&tdot;"
    ],
    [
        0,
        "&DotDot;"
    ],
    [
        37,
        "&complexes;"
    ],
    [
        2,
        "&incare;"
    ],
    [
        4,
        "&gscr;"
    ],
    [
        0,
        "&hamilt;"
    ],
    [
        0,
        "&Hfr;"
    ],
    [
        0,
        "&Hopf;"
    ],
    [
        0,
        "&planckh;"
    ],
    [
        0,
        "&hbar;"
    ],
    [
        0,
        "&imagline;"
    ],
    [
        0,
        "&Ifr;"
    ],
    [
        0,
        "&lagran;"
    ],
    [
        0,
        "&ell;"
    ],
    [
        1,
        "&naturals;"
    ],
    [
        0,
        "&numero;"
    ],
    [
        0,
        "&copysr;"
    ],
    [
        0,
        "&weierp;"
    ],
    [
        0,
        "&Popf;"
    ],
    [
        0,
        "&Qopf;"
    ],
    [
        0,
        "&realine;"
    ],
    [
        0,
        "&real;"
    ],
    [
        0,
        "&reals;"
    ],
    [
        0,
        "&rx;"
    ],
    [
        3,
        "&trade;"
    ],
    [
        1,
        "&integers;"
    ],
    [
        2,
        "&mho;"
    ],
    [
        0,
        "&zeetrf;"
    ],
    [
        0,
        "&iiota;"
    ],
    [
        2,
        "&bernou;"
    ],
    [
        0,
        "&Cayleys;"
    ],
    [
        1,
        "&escr;"
    ],
    [
        0,
        "&Escr;"
    ],
    [
        0,
        "&Fouriertrf;"
    ],
    [
        1,
        "&Mellintrf;"
    ],
    [
        0,
        "&order;"
    ],
    [
        0,
        "&alefsym;"
    ],
    [
        0,
        "&beth;"
    ],
    [
        0,
        "&gimel;"
    ],
    [
        0,
        "&daleth;"
    ],
    [
        12,
        "&CapitalDifferentialD;"
    ],
    [
        0,
        "&dd;"
    ],
    [
        0,
        "&ee;"
    ],
    [
        0,
        "&ii;"
    ],
    [
        10,
        "&frac13;"
    ],
    [
        0,
        "&frac23;"
    ],
    [
        0,
        "&frac15;"
    ],
    [
        0,
        "&frac25;"
    ],
    [
        0,
        "&frac35;"
    ],
    [
        0,
        "&frac45;"
    ],
    [
        0,
        "&frac16;"
    ],
    [
        0,
        "&frac56;"
    ],
    [
        0,
        "&frac18;"
    ],
    [
        0,
        "&frac38;"
    ],
    [
        0,
        "&frac58;"
    ],
    [
        0,
        "&frac78;"
    ],
    [
        49,
        "&larr;"
    ],
    [
        0,
        "&ShortUpArrow;"
    ],
    [
        0,
        "&rarr;"
    ],
    [
        0,
        "&darr;"
    ],
    [
        0,
        "&harr;"
    ],
    [
        0,
        "&updownarrow;"
    ],
    [
        0,
        "&nwarr;"
    ],
    [
        0,
        "&nearr;"
    ],
    [
        0,
        "&LowerRightArrow;"
    ],
    [
        0,
        "&LowerLeftArrow;"
    ],
    [
        0,
        "&nlarr;"
    ],
    [
        0,
        "&nrarr;"
    ],
    [
        1,
        {
            v: "&rarrw;",
            n: 824,
            o: "&nrarrw;"
        }
    ],
    [
        0,
        "&Larr;"
    ],
    [
        0,
        "&Uarr;"
    ],
    [
        0,
        "&Rarr;"
    ],
    [
        0,
        "&Darr;"
    ],
    [
        0,
        "&larrtl;"
    ],
    [
        0,
        "&rarrtl;"
    ],
    [
        0,
        "&LeftTeeArrow;"
    ],
    [
        0,
        "&mapstoup;"
    ],
    [
        0,
        "&map;"
    ],
    [
        0,
        "&DownTeeArrow;"
    ],
    [
        1,
        "&hookleftarrow;"
    ],
    [
        0,
        "&hookrightarrow;"
    ],
    [
        0,
        "&larrlp;"
    ],
    [
        0,
        "&looparrowright;"
    ],
    [
        0,
        "&harrw;"
    ],
    [
        0,
        "&nharr;"
    ],
    [
        1,
        "&lsh;"
    ],
    [
        0,
        "&rsh;"
    ],
    [
        0,
        "&ldsh;"
    ],
    [
        0,
        "&rdsh;"
    ],
    [
        1,
        "&crarr;"
    ],
    [
        0,
        "&cularr;"
    ],
    [
        0,
        "&curarr;"
    ],
    [
        2,
        "&circlearrowleft;"
    ],
    [
        0,
        "&circlearrowright;"
    ],
    [
        0,
        "&leftharpoonup;"
    ],
    [
        0,
        "&DownLeftVector;"
    ],
    [
        0,
        "&RightUpVector;"
    ],
    [
        0,
        "&LeftUpVector;"
    ],
    [
        0,
        "&rharu;"
    ],
    [
        0,
        "&DownRightVector;"
    ],
    [
        0,
        "&dharr;"
    ],
    [
        0,
        "&dharl;"
    ],
    [
        0,
        "&RightArrowLeftArrow;"
    ],
    [
        0,
        "&udarr;"
    ],
    [
        0,
        "&LeftArrowRightArrow;"
    ],
    [
        0,
        "&leftleftarrows;"
    ],
    [
        0,
        "&upuparrows;"
    ],
    [
        0,
        "&rightrightarrows;"
    ],
    [
        0,
        "&ddarr;"
    ],
    [
        0,
        "&leftrightharpoons;"
    ],
    [
        0,
        "&Equilibrium;"
    ],
    [
        0,
        "&nlArr;"
    ],
    [
        0,
        "&nhArr;"
    ],
    [
        0,
        "&nrArr;"
    ],
    [
        0,
        "&DoubleLeftArrow;"
    ],
    [
        0,
        "&DoubleUpArrow;"
    ],
    [
        0,
        "&DoubleRightArrow;"
    ],
    [
        0,
        "&dArr;"
    ],
    [
        0,
        "&DoubleLeftRightArrow;"
    ],
    [
        0,
        "&DoubleUpDownArrow;"
    ],
    [
        0,
        "&nwArr;"
    ],
    [
        0,
        "&neArr;"
    ],
    [
        0,
        "&seArr;"
    ],
    [
        0,
        "&swArr;"
    ],
    [
        0,
        "&lAarr;"
    ],
    [
        0,
        "&rAarr;"
    ],
    [
        1,
        "&zigrarr;"
    ],
    [
        6,
        "&larrb;"
    ],
    [
        0,
        "&rarrb;"
    ],
    [
        15,
        "&DownArrowUpArrow;"
    ],
    [
        7,
        "&loarr;"
    ],
    [
        0,
        "&roarr;"
    ],
    [
        0,
        "&hoarr;"
    ],
    [
        0,
        "&forall;"
    ],
    [
        0,
        "&comp;"
    ],
    [
        0,
        {
            v: "&part;",
            n: 824,
            o: "&npart;"
        }
    ],
    [
        0,
        "&exist;"
    ],
    [
        0,
        "&nexist;"
    ],
    [
        0,
        "&empty;"
    ],
    [
        1,
        "&Del;"
    ],
    [
        0,
        "&Element;"
    ],
    [
        0,
        "&NotElement;"
    ],
    [
        1,
        "&ni;"
    ],
    [
        0,
        "&notni;"
    ],
    [
        2,
        "&prod;"
    ],
    [
        0,
        "&coprod;"
    ],
    [
        0,
        "&sum;"
    ],
    [
        0,
        "&minus;"
    ],
    [
        0,
        "&MinusPlus;"
    ],
    [
        0,
        "&dotplus;"
    ],
    [
        1,
        "&Backslash;"
    ],
    [
        0,
        "&lowast;"
    ],
    [
        0,
        "&compfn;"
    ],
    [
        1,
        "&radic;"
    ],
    [
        2,
        "&prop;"
    ],
    [
        0,
        "&infin;"
    ],
    [
        0,
        "&angrt;"
    ],
    [
        0,
        {
            v: "&ang;",
            n: 8402,
            o: "&nang;"
        }
    ],
    [
        0,
        "&angmsd;"
    ],
    [
        0,
        "&angsph;"
    ],
    [
        0,
        "&mid;"
    ],
    [
        0,
        "&nmid;"
    ],
    [
        0,
        "&DoubleVerticalBar;"
    ],
    [
        0,
        "&NotDoubleVerticalBar;"
    ],
    [
        0,
        "&and;"
    ],
    [
        0,
        "&or;"
    ],
    [
        0,
        {
            v: "&cap;",
            n: 65024,
            o: "&caps;"
        }
    ],
    [
        0,
        {
            v: "&cup;",
            n: 65024,
            o: "&cups;"
        }
    ],
    [
        0,
        "&int;"
    ],
    [
        0,
        "&Int;"
    ],
    [
        0,
        "&iiint;"
    ],
    [
        0,
        "&conint;"
    ],
    [
        0,
        "&Conint;"
    ],
    [
        0,
        "&Cconint;"
    ],
    [
        0,
        "&cwint;"
    ],
    [
        0,
        "&ClockwiseContourIntegral;"
    ],
    [
        0,
        "&awconint;"
    ],
    [
        0,
        "&there4;"
    ],
    [
        0,
        "&becaus;"
    ],
    [
        0,
        "&ratio;"
    ],
    [
        0,
        "&Colon;"
    ],
    [
        0,
        "&dotminus;"
    ],
    [
        1,
        "&mDDot;"
    ],
    [
        0,
        "&homtht;"
    ],
    [
        0,
        {
            v: "&sim;",
            n: 8402,
            o: "&nvsim;"
        }
    ],
    [
        0,
        {
            v: "&backsim;",
            n: 817,
            o: "&race;"
        }
    ],
    [
        0,
        {
            v: "&ac;",
            n: 819,
            o: "&acE;"
        }
    ],
    [
        0,
        "&acd;"
    ],
    [
        0,
        "&VerticalTilde;"
    ],
    [
        0,
        "&NotTilde;"
    ],
    [
        0,
        {
            v: "&eqsim;",
            n: 824,
            o: "&nesim;"
        }
    ],
    [
        0,
        "&sime;"
    ],
    [
        0,
        "&NotTildeEqual;"
    ],
    [
        0,
        "&cong;"
    ],
    [
        0,
        "&simne;"
    ],
    [
        0,
        "&ncong;"
    ],
    [
        0,
        "&ap;"
    ],
    [
        0,
        "&nap;"
    ],
    [
        0,
        "&ape;"
    ],
    [
        0,
        {
            v: "&apid;",
            n: 824,
            o: "&napid;"
        }
    ],
    [
        0,
        "&backcong;"
    ],
    [
        0,
        {
            v: "&asympeq;",
            n: 8402,
            o: "&nvap;"
        }
    ],
    [
        0,
        {
            v: "&bump;",
            n: 824,
            o: "&nbump;"
        }
    ],
    [
        0,
        {
            v: "&bumpe;",
            n: 824,
            o: "&nbumpe;"
        }
    ],
    [
        0,
        {
            v: "&doteq;",
            n: 824,
            o: "&nedot;"
        }
    ],
    [
        0,
        "&doteqdot;"
    ],
    [
        0,
        "&efDot;"
    ],
    [
        0,
        "&erDot;"
    ],
    [
        0,
        "&Assign;"
    ],
    [
        0,
        "&ecolon;"
    ],
    [
        0,
        "&ecir;"
    ],
    [
        0,
        "&circeq;"
    ],
    [
        1,
        "&wedgeq;"
    ],
    [
        0,
        "&veeeq;"
    ],
    [
        1,
        "&triangleq;"
    ],
    [
        2,
        "&equest;"
    ],
    [
        0,
        "&ne;"
    ],
    [
        0,
        {
            v: "&Congruent;",
            n: 8421,
            o: "&bnequiv;"
        }
    ],
    [
        0,
        "&nequiv;"
    ],
    [
        1,
        {
            v: "&le;",
            n: 8402,
            o: "&nvle;"
        }
    ],
    [
        0,
        {
            v: "&ge;",
            n: 8402,
            o: "&nvge;"
        }
    ],
    [
        0,
        {
            v: "&lE;",
            n: 824,
            o: "&nlE;"
        }
    ],
    [
        0,
        {
            v: "&gE;",
            n: 824,
            o: "&ngE;"
        }
    ],
    [
        0,
        {
            v: "&lnE;",
            n: 65024,
            o: "&lvertneqq;"
        }
    ],
    [
        0,
        {
            v: "&gnE;",
            n: 65024,
            o: "&gvertneqq;"
        }
    ],
    [
        0,
        {
            v: "&ll;",
            n: new Map(/* #__PURE__ */ $ea0da353c9e2246b$var$restoreDiff([
                [
                    824,
                    "&nLtv;"
                ],
                [
                    7577,
                    "&nLt;"
                ]
            ]))
        }
    ],
    [
        0,
        {
            v: "&gg;",
            n: new Map(/* #__PURE__ */ $ea0da353c9e2246b$var$restoreDiff([
                [
                    824,
                    "&nGtv;"
                ],
                [
                    7577,
                    "&nGt;"
                ]
            ]))
        }
    ],
    [
        0,
        "&between;"
    ],
    [
        0,
        "&NotCupCap;"
    ],
    [
        0,
        "&nless;"
    ],
    [
        0,
        "&ngt;"
    ],
    [
        0,
        "&nle;"
    ],
    [
        0,
        "&nge;"
    ],
    [
        0,
        "&lesssim;"
    ],
    [
        0,
        "&GreaterTilde;"
    ],
    [
        0,
        "&nlsim;"
    ],
    [
        0,
        "&ngsim;"
    ],
    [
        0,
        "&LessGreater;"
    ],
    [
        0,
        "&gl;"
    ],
    [
        0,
        "&NotLessGreater;"
    ],
    [
        0,
        "&NotGreaterLess;"
    ],
    [
        0,
        "&pr;"
    ],
    [
        0,
        "&sc;"
    ],
    [
        0,
        "&prcue;"
    ],
    [
        0,
        "&sccue;"
    ],
    [
        0,
        "&PrecedesTilde;"
    ],
    [
        0,
        {
            v: "&scsim;",
            n: 824,
            o: "&NotSucceedsTilde;"
        }
    ],
    [
        0,
        "&NotPrecedes;"
    ],
    [
        0,
        "&NotSucceeds;"
    ],
    [
        0,
        {
            v: "&sub;",
            n: 8402,
            o: "&NotSubset;"
        }
    ],
    [
        0,
        {
            v: "&sup;",
            n: 8402,
            o: "&NotSuperset;"
        }
    ],
    [
        0,
        "&nsub;"
    ],
    [
        0,
        "&nsup;"
    ],
    [
        0,
        "&sube;"
    ],
    [
        0,
        "&supe;"
    ],
    [
        0,
        "&NotSubsetEqual;"
    ],
    [
        0,
        "&NotSupersetEqual;"
    ],
    [
        0,
        {
            v: "&subne;",
            n: 65024,
            o: "&varsubsetneq;"
        }
    ],
    [
        0,
        {
            v: "&supne;",
            n: 65024,
            o: "&varsupsetneq;"
        }
    ],
    [
        1,
        "&cupdot;"
    ],
    [
        0,
        "&UnionPlus;"
    ],
    [
        0,
        {
            v: "&sqsub;",
            n: 824,
            o: "&NotSquareSubset;"
        }
    ],
    [
        0,
        {
            v: "&sqsup;",
            n: 824,
            o: "&NotSquareSuperset;"
        }
    ],
    [
        0,
        "&sqsube;"
    ],
    [
        0,
        "&sqsupe;"
    ],
    [
        0,
        {
            v: "&sqcap;",
            n: 65024,
            o: "&sqcaps;"
        }
    ],
    [
        0,
        {
            v: "&sqcup;",
            n: 65024,
            o: "&sqcups;"
        }
    ],
    [
        0,
        "&CirclePlus;"
    ],
    [
        0,
        "&CircleMinus;"
    ],
    [
        0,
        "&CircleTimes;"
    ],
    [
        0,
        "&osol;"
    ],
    [
        0,
        "&CircleDot;"
    ],
    [
        0,
        "&circledcirc;"
    ],
    [
        0,
        "&circledast;"
    ],
    [
        1,
        "&circleddash;"
    ],
    [
        0,
        "&boxplus;"
    ],
    [
        0,
        "&boxminus;"
    ],
    [
        0,
        "&boxtimes;"
    ],
    [
        0,
        "&dotsquare;"
    ],
    [
        0,
        "&RightTee;"
    ],
    [
        0,
        "&dashv;"
    ],
    [
        0,
        "&DownTee;"
    ],
    [
        0,
        "&bot;"
    ],
    [
        1,
        "&models;"
    ],
    [
        0,
        "&DoubleRightTee;"
    ],
    [
        0,
        "&Vdash;"
    ],
    [
        0,
        "&Vvdash;"
    ],
    [
        0,
        "&VDash;"
    ],
    [
        0,
        "&nvdash;"
    ],
    [
        0,
        "&nvDash;"
    ],
    [
        0,
        "&nVdash;"
    ],
    [
        0,
        "&nVDash;"
    ],
    [
        0,
        "&prurel;"
    ],
    [
        1,
        "&LeftTriangle;"
    ],
    [
        0,
        "&RightTriangle;"
    ],
    [
        0,
        {
            v: "&LeftTriangleEqual;",
            n: 8402,
            o: "&nvltrie;"
        }
    ],
    [
        0,
        {
            v: "&RightTriangleEqual;",
            n: 8402,
            o: "&nvrtrie;"
        }
    ],
    [
        0,
        "&origof;"
    ],
    [
        0,
        "&imof;"
    ],
    [
        0,
        "&multimap;"
    ],
    [
        0,
        "&hercon;"
    ],
    [
        0,
        "&intcal;"
    ],
    [
        0,
        "&veebar;"
    ],
    [
        1,
        "&barvee;"
    ],
    [
        0,
        "&angrtvb;"
    ],
    [
        0,
        "&lrtri;"
    ],
    [
        0,
        "&bigwedge;"
    ],
    [
        0,
        "&bigvee;"
    ],
    [
        0,
        "&bigcap;"
    ],
    [
        0,
        "&bigcup;"
    ],
    [
        0,
        "&diam;"
    ],
    [
        0,
        "&sdot;"
    ],
    [
        0,
        "&sstarf;"
    ],
    [
        0,
        "&divideontimes;"
    ],
    [
        0,
        "&bowtie;"
    ],
    [
        0,
        "&ltimes;"
    ],
    [
        0,
        "&rtimes;"
    ],
    [
        0,
        "&leftthreetimes;"
    ],
    [
        0,
        "&rightthreetimes;"
    ],
    [
        0,
        "&backsimeq;"
    ],
    [
        0,
        "&curlyvee;"
    ],
    [
        0,
        "&curlywedge;"
    ],
    [
        0,
        "&Sub;"
    ],
    [
        0,
        "&Sup;"
    ],
    [
        0,
        "&Cap;"
    ],
    [
        0,
        "&Cup;"
    ],
    [
        0,
        "&fork;"
    ],
    [
        0,
        "&epar;"
    ],
    [
        0,
        "&lessdot;"
    ],
    [
        0,
        "&gtdot;"
    ],
    [
        0,
        {
            v: "&Ll;",
            n: 824,
            o: "&nLl;"
        }
    ],
    [
        0,
        {
            v: "&Gg;",
            n: 824,
            o: "&nGg;"
        }
    ],
    [
        0,
        {
            v: "&leg;",
            n: 65024,
            o: "&lesg;"
        }
    ],
    [
        0,
        {
            v: "&gel;",
            n: 65024,
            o: "&gesl;"
        }
    ],
    [
        2,
        "&cuepr;"
    ],
    [
        0,
        "&cuesc;"
    ],
    [
        0,
        "&NotPrecedesSlantEqual;"
    ],
    [
        0,
        "&NotSucceedsSlantEqual;"
    ],
    [
        0,
        "&NotSquareSubsetEqual;"
    ],
    [
        0,
        "&NotSquareSupersetEqual;"
    ],
    [
        2,
        "&lnsim;"
    ],
    [
        0,
        "&gnsim;"
    ],
    [
        0,
        "&precnsim;"
    ],
    [
        0,
        "&scnsim;"
    ],
    [
        0,
        "&nltri;"
    ],
    [
        0,
        "&NotRightTriangle;"
    ],
    [
        0,
        "&nltrie;"
    ],
    [
        0,
        "&NotRightTriangleEqual;"
    ],
    [
        0,
        "&vellip;"
    ],
    [
        0,
        "&ctdot;"
    ],
    [
        0,
        "&utdot;"
    ],
    [
        0,
        "&dtdot;"
    ],
    [
        0,
        "&disin;"
    ],
    [
        0,
        "&isinsv;"
    ],
    [
        0,
        "&isins;"
    ],
    [
        0,
        {
            v: "&isindot;",
            n: 824,
            o: "&notindot;"
        }
    ],
    [
        0,
        "&notinvc;"
    ],
    [
        0,
        "&notinvb;"
    ],
    [
        1,
        {
            v: "&isinE;",
            n: 824,
            o: "&notinE;"
        }
    ],
    [
        0,
        "&nisd;"
    ],
    [
        0,
        "&xnis;"
    ],
    [
        0,
        "&nis;"
    ],
    [
        0,
        "&notnivc;"
    ],
    [
        0,
        "&notnivb;"
    ],
    [
        6,
        "&barwed;"
    ],
    [
        0,
        "&Barwed;"
    ],
    [
        1,
        "&lceil;"
    ],
    [
        0,
        "&rceil;"
    ],
    [
        0,
        "&LeftFloor;"
    ],
    [
        0,
        "&rfloor;"
    ],
    [
        0,
        "&drcrop;"
    ],
    [
        0,
        "&dlcrop;"
    ],
    [
        0,
        "&urcrop;"
    ],
    [
        0,
        "&ulcrop;"
    ],
    [
        0,
        "&bnot;"
    ],
    [
        1,
        "&profline;"
    ],
    [
        0,
        "&profsurf;"
    ],
    [
        1,
        "&telrec;"
    ],
    [
        0,
        "&target;"
    ],
    [
        5,
        "&ulcorn;"
    ],
    [
        0,
        "&urcorn;"
    ],
    [
        0,
        "&dlcorn;"
    ],
    [
        0,
        "&drcorn;"
    ],
    [
        2,
        "&frown;"
    ],
    [
        0,
        "&smile;"
    ],
    [
        9,
        "&cylcty;"
    ],
    [
        0,
        "&profalar;"
    ],
    [
        7,
        "&topbot;"
    ],
    [
        6,
        "&ovbar;"
    ],
    [
        1,
        "&solbar;"
    ],
    [
        60,
        "&angzarr;"
    ],
    [
        51,
        "&lmoustache;"
    ],
    [
        0,
        "&rmoustache;"
    ],
    [
        2,
        "&OverBracket;"
    ],
    [
        0,
        "&bbrk;"
    ],
    [
        0,
        "&bbrktbrk;"
    ],
    [
        37,
        "&OverParenthesis;"
    ],
    [
        0,
        "&UnderParenthesis;"
    ],
    [
        0,
        "&OverBrace;"
    ],
    [
        0,
        "&UnderBrace;"
    ],
    [
        2,
        "&trpezium;"
    ],
    [
        4,
        "&elinters;"
    ],
    [
        59,
        "&blank;"
    ],
    [
        164,
        "&circledS;"
    ],
    [
        55,
        "&boxh;"
    ],
    [
        1,
        "&boxv;"
    ],
    [
        9,
        "&boxdr;"
    ],
    [
        3,
        "&boxdl;"
    ],
    [
        3,
        "&boxur;"
    ],
    [
        3,
        "&boxul;"
    ],
    [
        3,
        "&boxvr;"
    ],
    [
        7,
        "&boxvl;"
    ],
    [
        7,
        "&boxhd;"
    ],
    [
        7,
        "&boxhu;"
    ],
    [
        7,
        "&boxvh;"
    ],
    [
        19,
        "&boxH;"
    ],
    [
        0,
        "&boxV;"
    ],
    [
        0,
        "&boxdR;"
    ],
    [
        0,
        "&boxDr;"
    ],
    [
        0,
        "&boxDR;"
    ],
    [
        0,
        "&boxdL;"
    ],
    [
        0,
        "&boxDl;"
    ],
    [
        0,
        "&boxDL;"
    ],
    [
        0,
        "&boxuR;"
    ],
    [
        0,
        "&boxUr;"
    ],
    [
        0,
        "&boxUR;"
    ],
    [
        0,
        "&boxuL;"
    ],
    [
        0,
        "&boxUl;"
    ],
    [
        0,
        "&boxUL;"
    ],
    [
        0,
        "&boxvR;"
    ],
    [
        0,
        "&boxVr;"
    ],
    [
        0,
        "&boxVR;"
    ],
    [
        0,
        "&boxvL;"
    ],
    [
        0,
        "&boxVl;"
    ],
    [
        0,
        "&boxVL;"
    ],
    [
        0,
        "&boxHd;"
    ],
    [
        0,
        "&boxhD;"
    ],
    [
        0,
        "&boxHD;"
    ],
    [
        0,
        "&boxHu;"
    ],
    [
        0,
        "&boxhU;"
    ],
    [
        0,
        "&boxHU;"
    ],
    [
        0,
        "&boxvH;"
    ],
    [
        0,
        "&boxVh;"
    ],
    [
        0,
        "&boxVH;"
    ],
    [
        19,
        "&uhblk;"
    ],
    [
        3,
        "&lhblk;"
    ],
    [
        3,
        "&block;"
    ],
    [
        8,
        "&blk14;"
    ],
    [
        0,
        "&blk12;"
    ],
    [
        0,
        "&blk34;"
    ],
    [
        13,
        "&square;"
    ],
    [
        8,
        "&blacksquare;"
    ],
    [
        0,
        "&EmptyVerySmallSquare;"
    ],
    [
        1,
        "&rect;"
    ],
    [
        0,
        "&marker;"
    ],
    [
        2,
        "&fltns;"
    ],
    [
        1,
        "&bigtriangleup;"
    ],
    [
        0,
        "&blacktriangle;"
    ],
    [
        0,
        "&triangle;"
    ],
    [
        2,
        "&blacktriangleright;"
    ],
    [
        0,
        "&rtri;"
    ],
    [
        3,
        "&bigtriangledown;"
    ],
    [
        0,
        "&blacktriangledown;"
    ],
    [
        0,
        "&dtri;"
    ],
    [
        2,
        "&blacktriangleleft;"
    ],
    [
        0,
        "&ltri;"
    ],
    [
        6,
        "&loz;"
    ],
    [
        0,
        "&cir;"
    ],
    [
        32,
        "&tridot;"
    ],
    [
        2,
        "&bigcirc;"
    ],
    [
        8,
        "&ultri;"
    ],
    [
        0,
        "&urtri;"
    ],
    [
        0,
        "&lltri;"
    ],
    [
        0,
        "&EmptySmallSquare;"
    ],
    [
        0,
        "&FilledSmallSquare;"
    ],
    [
        8,
        "&bigstar;"
    ],
    [
        0,
        "&star;"
    ],
    [
        7,
        "&phone;"
    ],
    [
        49,
        "&female;"
    ],
    [
        1,
        "&male;"
    ],
    [
        29,
        "&spades;"
    ],
    [
        2,
        "&clubs;"
    ],
    [
        1,
        "&hearts;"
    ],
    [
        0,
        "&diamondsuit;"
    ],
    [
        3,
        "&sung;"
    ],
    [
        2,
        "&flat;"
    ],
    [
        0,
        "&natural;"
    ],
    [
        0,
        "&sharp;"
    ],
    [
        163,
        "&check;"
    ],
    [
        3,
        "&cross;"
    ],
    [
        8,
        "&malt;"
    ],
    [
        21,
        "&sext;"
    ],
    [
        33,
        "&VerticalSeparator;"
    ],
    [
        25,
        "&lbbrk;"
    ],
    [
        0,
        "&rbbrk;"
    ],
    [
        84,
        "&bsolhsub;"
    ],
    [
        0,
        "&suphsol;"
    ],
    [
        28,
        "&LeftDoubleBracket;"
    ],
    [
        0,
        "&RightDoubleBracket;"
    ],
    [
        0,
        "&lang;"
    ],
    [
        0,
        "&rang;"
    ],
    [
        0,
        "&Lang;"
    ],
    [
        0,
        "&Rang;"
    ],
    [
        0,
        "&loang;"
    ],
    [
        0,
        "&roang;"
    ],
    [
        7,
        "&longleftarrow;"
    ],
    [
        0,
        "&longrightarrow;"
    ],
    [
        0,
        "&longleftrightarrow;"
    ],
    [
        0,
        "&DoubleLongLeftArrow;"
    ],
    [
        0,
        "&DoubleLongRightArrow;"
    ],
    [
        0,
        "&DoubleLongLeftRightArrow;"
    ],
    [
        1,
        "&longmapsto;"
    ],
    [
        2,
        "&dzigrarr;"
    ],
    [
        258,
        "&nvlArr;"
    ],
    [
        0,
        "&nvrArr;"
    ],
    [
        0,
        "&nvHarr;"
    ],
    [
        0,
        "&Map;"
    ],
    [
        6,
        "&lbarr;"
    ],
    [
        0,
        "&bkarow;"
    ],
    [
        0,
        "&lBarr;"
    ],
    [
        0,
        "&dbkarow;"
    ],
    [
        0,
        "&drbkarow;"
    ],
    [
        0,
        "&DDotrahd;"
    ],
    [
        0,
        "&UpArrowBar;"
    ],
    [
        0,
        "&DownArrowBar;"
    ],
    [
        2,
        "&Rarrtl;"
    ],
    [
        2,
        "&latail;"
    ],
    [
        0,
        "&ratail;"
    ],
    [
        0,
        "&lAtail;"
    ],
    [
        0,
        "&rAtail;"
    ],
    [
        0,
        "&larrfs;"
    ],
    [
        0,
        "&rarrfs;"
    ],
    [
        0,
        "&larrbfs;"
    ],
    [
        0,
        "&rarrbfs;"
    ],
    [
        2,
        "&nwarhk;"
    ],
    [
        0,
        "&nearhk;"
    ],
    [
        0,
        "&hksearow;"
    ],
    [
        0,
        "&hkswarow;"
    ],
    [
        0,
        "&nwnear;"
    ],
    [
        0,
        "&nesear;"
    ],
    [
        0,
        "&seswar;"
    ],
    [
        0,
        "&swnwar;"
    ],
    [
        8,
        {
            v: "&rarrc;",
            n: 824,
            o: "&nrarrc;"
        }
    ],
    [
        1,
        "&cudarrr;"
    ],
    [
        0,
        "&ldca;"
    ],
    [
        0,
        "&rdca;"
    ],
    [
        0,
        "&cudarrl;"
    ],
    [
        0,
        "&larrpl;"
    ],
    [
        2,
        "&curarrm;"
    ],
    [
        0,
        "&cularrp;"
    ],
    [
        7,
        "&rarrpl;"
    ],
    [
        2,
        "&harrcir;"
    ],
    [
        0,
        "&Uarrocir;"
    ],
    [
        0,
        "&lurdshar;"
    ],
    [
        0,
        "&ldrushar;"
    ],
    [
        2,
        "&LeftRightVector;"
    ],
    [
        0,
        "&RightUpDownVector;"
    ],
    [
        0,
        "&DownLeftRightVector;"
    ],
    [
        0,
        "&LeftUpDownVector;"
    ],
    [
        0,
        "&LeftVectorBar;"
    ],
    [
        0,
        "&RightVectorBar;"
    ],
    [
        0,
        "&RightUpVectorBar;"
    ],
    [
        0,
        "&RightDownVectorBar;"
    ],
    [
        0,
        "&DownLeftVectorBar;"
    ],
    [
        0,
        "&DownRightVectorBar;"
    ],
    [
        0,
        "&LeftUpVectorBar;"
    ],
    [
        0,
        "&LeftDownVectorBar;"
    ],
    [
        0,
        "&LeftTeeVector;"
    ],
    [
        0,
        "&RightTeeVector;"
    ],
    [
        0,
        "&RightUpTeeVector;"
    ],
    [
        0,
        "&RightDownTeeVector;"
    ],
    [
        0,
        "&DownLeftTeeVector;"
    ],
    [
        0,
        "&DownRightTeeVector;"
    ],
    [
        0,
        "&LeftUpTeeVector;"
    ],
    [
        0,
        "&LeftDownTeeVector;"
    ],
    [
        0,
        "&lHar;"
    ],
    [
        0,
        "&uHar;"
    ],
    [
        0,
        "&rHar;"
    ],
    [
        0,
        "&dHar;"
    ],
    [
        0,
        "&luruhar;"
    ],
    [
        0,
        "&ldrdhar;"
    ],
    [
        0,
        "&ruluhar;"
    ],
    [
        0,
        "&rdldhar;"
    ],
    [
        0,
        "&lharul;"
    ],
    [
        0,
        "&llhard;"
    ],
    [
        0,
        "&rharul;"
    ],
    [
        0,
        "&lrhard;"
    ],
    [
        0,
        "&udhar;"
    ],
    [
        0,
        "&duhar;"
    ],
    [
        0,
        "&RoundImplies;"
    ],
    [
        0,
        "&erarr;"
    ],
    [
        0,
        "&simrarr;"
    ],
    [
        0,
        "&larrsim;"
    ],
    [
        0,
        "&rarrsim;"
    ],
    [
        0,
        "&rarrap;"
    ],
    [
        0,
        "&ltlarr;"
    ],
    [
        1,
        "&gtrarr;"
    ],
    [
        0,
        "&subrarr;"
    ],
    [
        1,
        "&suplarr;"
    ],
    [
        0,
        "&lfisht;"
    ],
    [
        0,
        "&rfisht;"
    ],
    [
        0,
        "&ufisht;"
    ],
    [
        0,
        "&dfisht;"
    ],
    [
        5,
        "&lopar;"
    ],
    [
        0,
        "&ropar;"
    ],
    [
        4,
        "&lbrke;"
    ],
    [
        0,
        "&rbrke;"
    ],
    [
        0,
        "&lbrkslu;"
    ],
    [
        0,
        "&rbrksld;"
    ],
    [
        0,
        "&lbrksld;"
    ],
    [
        0,
        "&rbrkslu;"
    ],
    [
        0,
        "&langd;"
    ],
    [
        0,
        "&rangd;"
    ],
    [
        0,
        "&lparlt;"
    ],
    [
        0,
        "&rpargt;"
    ],
    [
        0,
        "&gtlPar;"
    ],
    [
        0,
        "&ltrPar;"
    ],
    [
        3,
        "&vzigzag;"
    ],
    [
        1,
        "&vangrt;"
    ],
    [
        0,
        "&angrtvbd;"
    ],
    [
        6,
        "&ange;"
    ],
    [
        0,
        "&range;"
    ],
    [
        0,
        "&dwangle;"
    ],
    [
        0,
        "&uwangle;"
    ],
    [
        0,
        "&angmsdaa;"
    ],
    [
        0,
        "&angmsdab;"
    ],
    [
        0,
        "&angmsdac;"
    ],
    [
        0,
        "&angmsdad;"
    ],
    [
        0,
        "&angmsdae;"
    ],
    [
        0,
        "&angmsdaf;"
    ],
    [
        0,
        "&angmsdag;"
    ],
    [
        0,
        "&angmsdah;"
    ],
    [
        0,
        "&bemptyv;"
    ],
    [
        0,
        "&demptyv;"
    ],
    [
        0,
        "&cemptyv;"
    ],
    [
        0,
        "&raemptyv;"
    ],
    [
        0,
        "&laemptyv;"
    ],
    [
        0,
        "&ohbar;"
    ],
    [
        0,
        "&omid;"
    ],
    [
        0,
        "&opar;"
    ],
    [
        1,
        "&operp;"
    ],
    [
        1,
        "&olcross;"
    ],
    [
        0,
        "&odsold;"
    ],
    [
        1,
        "&olcir;"
    ],
    [
        0,
        "&ofcir;"
    ],
    [
        0,
        "&olt;"
    ],
    [
        0,
        "&ogt;"
    ],
    [
        0,
        "&cirscir;"
    ],
    [
        0,
        "&cirE;"
    ],
    [
        0,
        "&solb;"
    ],
    [
        0,
        "&bsolb;"
    ],
    [
        3,
        "&boxbox;"
    ],
    [
        3,
        "&trisb;"
    ],
    [
        0,
        "&rtriltri;"
    ],
    [
        0,
        {
            v: "&LeftTriangleBar;",
            n: 824,
            o: "&NotLeftTriangleBar;"
        }
    ],
    [
        0,
        {
            v: "&RightTriangleBar;",
            n: 824,
            o: "&NotRightTriangleBar;"
        }
    ],
    [
        11,
        "&iinfin;"
    ],
    [
        0,
        "&infintie;"
    ],
    [
        0,
        "&nvinfin;"
    ],
    [
        4,
        "&eparsl;"
    ],
    [
        0,
        "&smeparsl;"
    ],
    [
        0,
        "&eqvparsl;"
    ],
    [
        5,
        "&blacklozenge;"
    ],
    [
        8,
        "&RuleDelayed;"
    ],
    [
        1,
        "&dsol;"
    ],
    [
        9,
        "&bigodot;"
    ],
    [
        0,
        "&bigoplus;"
    ],
    [
        0,
        "&bigotimes;"
    ],
    [
        1,
        "&biguplus;"
    ],
    [
        1,
        "&bigsqcup;"
    ],
    [
        5,
        "&iiiint;"
    ],
    [
        0,
        "&fpartint;"
    ],
    [
        2,
        "&cirfnint;"
    ],
    [
        0,
        "&awint;"
    ],
    [
        0,
        "&rppolint;"
    ],
    [
        0,
        "&scpolint;"
    ],
    [
        0,
        "&npolint;"
    ],
    [
        0,
        "&pointint;"
    ],
    [
        0,
        "&quatint;"
    ],
    [
        0,
        "&intlarhk;"
    ],
    [
        10,
        "&pluscir;"
    ],
    [
        0,
        "&plusacir;"
    ],
    [
        0,
        "&simplus;"
    ],
    [
        0,
        "&plusdu;"
    ],
    [
        0,
        "&plussim;"
    ],
    [
        0,
        "&plustwo;"
    ],
    [
        1,
        "&mcomma;"
    ],
    [
        0,
        "&minusdu;"
    ],
    [
        2,
        "&loplus;"
    ],
    [
        0,
        "&roplus;"
    ],
    [
        0,
        "&Cross;"
    ],
    [
        0,
        "&timesd;"
    ],
    [
        0,
        "&timesbar;"
    ],
    [
        1,
        "&smashp;"
    ],
    [
        0,
        "&lotimes;"
    ],
    [
        0,
        "&rotimes;"
    ],
    [
        0,
        "&otimesas;"
    ],
    [
        0,
        "&Otimes;"
    ],
    [
        0,
        "&odiv;"
    ],
    [
        0,
        "&triplus;"
    ],
    [
        0,
        "&triminus;"
    ],
    [
        0,
        "&tritime;"
    ],
    [
        0,
        "&intprod;"
    ],
    [
        2,
        "&amalg;"
    ],
    [
        0,
        "&capdot;"
    ],
    [
        1,
        "&ncup;"
    ],
    [
        0,
        "&ncap;"
    ],
    [
        0,
        "&capand;"
    ],
    [
        0,
        "&cupor;"
    ],
    [
        0,
        "&cupcap;"
    ],
    [
        0,
        "&capcup;"
    ],
    [
        0,
        "&cupbrcap;"
    ],
    [
        0,
        "&capbrcup;"
    ],
    [
        0,
        "&cupcup;"
    ],
    [
        0,
        "&capcap;"
    ],
    [
        0,
        "&ccups;"
    ],
    [
        0,
        "&ccaps;"
    ],
    [
        2,
        "&ccupssm;"
    ],
    [
        2,
        "&And;"
    ],
    [
        0,
        "&Or;"
    ],
    [
        0,
        "&andand;"
    ],
    [
        0,
        "&oror;"
    ],
    [
        0,
        "&orslope;"
    ],
    [
        0,
        "&andslope;"
    ],
    [
        1,
        "&andv;"
    ],
    [
        0,
        "&orv;"
    ],
    [
        0,
        "&andd;"
    ],
    [
        0,
        "&ord;"
    ],
    [
        1,
        "&wedbar;"
    ],
    [
        6,
        "&sdote;"
    ],
    [
        3,
        "&simdot;"
    ],
    [
        2,
        {
            v: "&congdot;",
            n: 824,
            o: "&ncongdot;"
        }
    ],
    [
        0,
        "&easter;"
    ],
    [
        0,
        "&apacir;"
    ],
    [
        0,
        {
            v: "&apE;",
            n: 824,
            o: "&napE;"
        }
    ],
    [
        0,
        "&eplus;"
    ],
    [
        0,
        "&pluse;"
    ],
    [
        0,
        "&Esim;"
    ],
    [
        0,
        "&Colone;"
    ],
    [
        0,
        "&Equal;"
    ],
    [
        1,
        "&ddotseq;"
    ],
    [
        0,
        "&equivDD;"
    ],
    [
        0,
        "&ltcir;"
    ],
    [
        0,
        "&gtcir;"
    ],
    [
        0,
        "&ltquest;"
    ],
    [
        0,
        "&gtquest;"
    ],
    [
        0,
        {
            v: "&leqslant;",
            n: 824,
            o: "&nleqslant;"
        }
    ],
    [
        0,
        {
            v: "&geqslant;",
            n: 824,
            o: "&ngeqslant;"
        }
    ],
    [
        0,
        "&lesdot;"
    ],
    [
        0,
        "&gesdot;"
    ],
    [
        0,
        "&lesdoto;"
    ],
    [
        0,
        "&gesdoto;"
    ],
    [
        0,
        "&lesdotor;"
    ],
    [
        0,
        "&gesdotol;"
    ],
    [
        0,
        "&lap;"
    ],
    [
        0,
        "&gap;"
    ],
    [
        0,
        "&lne;"
    ],
    [
        0,
        "&gne;"
    ],
    [
        0,
        "&lnap;"
    ],
    [
        0,
        "&gnap;"
    ],
    [
        0,
        "&lEg;"
    ],
    [
        0,
        "&gEl;"
    ],
    [
        0,
        "&lsime;"
    ],
    [
        0,
        "&gsime;"
    ],
    [
        0,
        "&lsimg;"
    ],
    [
        0,
        "&gsiml;"
    ],
    [
        0,
        "&lgE;"
    ],
    [
        0,
        "&glE;"
    ],
    [
        0,
        "&lesges;"
    ],
    [
        0,
        "&gesles;"
    ],
    [
        0,
        "&els;"
    ],
    [
        0,
        "&egs;"
    ],
    [
        0,
        "&elsdot;"
    ],
    [
        0,
        "&egsdot;"
    ],
    [
        0,
        "&el;"
    ],
    [
        0,
        "&eg;"
    ],
    [
        2,
        "&siml;"
    ],
    [
        0,
        "&simg;"
    ],
    [
        0,
        "&simlE;"
    ],
    [
        0,
        "&simgE;"
    ],
    [
        0,
        {
            v: "&LessLess;",
            n: 824,
            o: "&NotNestedLessLess;"
        }
    ],
    [
        0,
        {
            v: "&GreaterGreater;",
            n: 824,
            o: "&NotNestedGreaterGreater;"
        }
    ],
    [
        1,
        "&glj;"
    ],
    [
        0,
        "&gla;"
    ],
    [
        0,
        "&ltcc;"
    ],
    [
        0,
        "&gtcc;"
    ],
    [
        0,
        "&lescc;"
    ],
    [
        0,
        "&gescc;"
    ],
    [
        0,
        "&smt;"
    ],
    [
        0,
        "&lat;"
    ],
    [
        0,
        {
            v: "&smte;",
            n: 65024,
            o: "&smtes;"
        }
    ],
    [
        0,
        {
            v: "&late;",
            n: 65024,
            o: "&lates;"
        }
    ],
    [
        0,
        "&bumpE;"
    ],
    [
        0,
        {
            v: "&PrecedesEqual;",
            n: 824,
            o: "&NotPrecedesEqual;"
        }
    ],
    [
        0,
        {
            v: "&sce;",
            n: 824,
            o: "&NotSucceedsEqual;"
        }
    ],
    [
        2,
        "&prE;"
    ],
    [
        0,
        "&scE;"
    ],
    [
        0,
        "&precneqq;"
    ],
    [
        0,
        "&scnE;"
    ],
    [
        0,
        "&prap;"
    ],
    [
        0,
        "&scap;"
    ],
    [
        0,
        "&precnapprox;"
    ],
    [
        0,
        "&scnap;"
    ],
    [
        0,
        "&Pr;"
    ],
    [
        0,
        "&Sc;"
    ],
    [
        0,
        "&subdot;"
    ],
    [
        0,
        "&supdot;"
    ],
    [
        0,
        "&subplus;"
    ],
    [
        0,
        "&supplus;"
    ],
    [
        0,
        "&submult;"
    ],
    [
        0,
        "&supmult;"
    ],
    [
        0,
        "&subedot;"
    ],
    [
        0,
        "&supedot;"
    ],
    [
        0,
        {
            v: "&subE;",
            n: 824,
            o: "&nsubE;"
        }
    ],
    [
        0,
        {
            v: "&supE;",
            n: 824,
            o: "&nsupE;"
        }
    ],
    [
        0,
        "&subsim;"
    ],
    [
        0,
        "&supsim;"
    ],
    [
        2,
        {
            v: "&subnE;",
            n: 65024,
            o: "&varsubsetneqq;"
        }
    ],
    [
        0,
        {
            v: "&supnE;",
            n: 65024,
            o: "&varsupsetneqq;"
        }
    ],
    [
        2,
        "&csub;"
    ],
    [
        0,
        "&csup;"
    ],
    [
        0,
        "&csube;"
    ],
    [
        0,
        "&csupe;"
    ],
    [
        0,
        "&subsup;"
    ],
    [
        0,
        "&supsub;"
    ],
    [
        0,
        "&subsub;"
    ],
    [
        0,
        "&supsup;"
    ],
    [
        0,
        "&suphsub;"
    ],
    [
        0,
        "&supdsub;"
    ],
    [
        0,
        "&forkv;"
    ],
    [
        0,
        "&topfork;"
    ],
    [
        0,
        "&mlcp;"
    ],
    [
        8,
        "&Dashv;"
    ],
    [
        1,
        "&Vdashl;"
    ],
    [
        0,
        "&Barv;"
    ],
    [
        0,
        "&vBar;"
    ],
    [
        0,
        "&vBarv;"
    ],
    [
        1,
        "&Vbar;"
    ],
    [
        0,
        "&Not;"
    ],
    [
        0,
        "&bNot;"
    ],
    [
        0,
        "&rnmid;"
    ],
    [
        0,
        "&cirmid;"
    ],
    [
        0,
        "&midcir;"
    ],
    [
        0,
        "&topcir;"
    ],
    [
        0,
        "&nhpar;"
    ],
    [
        0,
        "&parsim;"
    ],
    [
        9,
        {
            v: "&parsl;",
            n: 8421,
            o: "&nparsl;"
        }
    ],
    [
        44343,
        {
            n: new Map(/* #__PURE__ */ $ea0da353c9e2246b$var$restoreDiff([
                [
                    56476,
                    "&Ascr;"
                ],
                [
                    1,
                    "&Cscr;"
                ],
                [
                    0,
                    "&Dscr;"
                ],
                [
                    2,
                    "&Gscr;"
                ],
                [
                    2,
                    "&Jscr;"
                ],
                [
                    0,
                    "&Kscr;"
                ],
                [
                    2,
                    "&Nscr;"
                ],
                [
                    0,
                    "&Oscr;"
                ],
                [
                    0,
                    "&Pscr;"
                ],
                [
                    0,
                    "&Qscr;"
                ],
                [
                    1,
                    "&Sscr;"
                ],
                [
                    0,
                    "&Tscr;"
                ],
                [
                    0,
                    "&Uscr;"
                ],
                [
                    0,
                    "&Vscr;"
                ],
                [
                    0,
                    "&Wscr;"
                ],
                [
                    0,
                    "&Xscr;"
                ],
                [
                    0,
                    "&Yscr;"
                ],
                [
                    0,
                    "&Zscr;"
                ],
                [
                    0,
                    "&ascr;"
                ],
                [
                    0,
                    "&bscr;"
                ],
                [
                    0,
                    "&cscr;"
                ],
                [
                    0,
                    "&dscr;"
                ],
                [
                    1,
                    "&fscr;"
                ],
                [
                    1,
                    "&hscr;"
                ],
                [
                    0,
                    "&iscr;"
                ],
                [
                    0,
                    "&jscr;"
                ],
                [
                    0,
                    "&kscr;"
                ],
                [
                    0,
                    "&lscr;"
                ],
                [
                    0,
                    "&mscr;"
                ],
                [
                    0,
                    "&nscr;"
                ],
                [
                    1,
                    "&pscr;"
                ],
                [
                    0,
                    "&qscr;"
                ],
                [
                    0,
                    "&rscr;"
                ],
                [
                    0,
                    "&sscr;"
                ],
                [
                    0,
                    "&tscr;"
                ],
                [
                    0,
                    "&uscr;"
                ],
                [
                    0,
                    "&vscr;"
                ],
                [
                    0,
                    "&wscr;"
                ],
                [
                    0,
                    "&xscr;"
                ],
                [
                    0,
                    "&yscr;"
                ],
                [
                    0,
                    "&zscr;"
                ],
                [
                    52,
                    "&Afr;"
                ],
                [
                    0,
                    "&Bfr;"
                ],
                [
                    1,
                    "&Dfr;"
                ],
                [
                    0,
                    "&Efr;"
                ],
                [
                    0,
                    "&Ffr;"
                ],
                [
                    0,
                    "&Gfr;"
                ],
                [
                    2,
                    "&Jfr;"
                ],
                [
                    0,
                    "&Kfr;"
                ],
                [
                    0,
                    "&Lfr;"
                ],
                [
                    0,
                    "&Mfr;"
                ],
                [
                    0,
                    "&Nfr;"
                ],
                [
                    0,
                    "&Ofr;"
                ],
                [
                    0,
                    "&Pfr;"
                ],
                [
                    0,
                    "&Qfr;"
                ],
                [
                    1,
                    "&Sfr;"
                ],
                [
                    0,
                    "&Tfr;"
                ],
                [
                    0,
                    "&Ufr;"
                ],
                [
                    0,
                    "&Vfr;"
                ],
                [
                    0,
                    "&Wfr;"
                ],
                [
                    0,
                    "&Xfr;"
                ],
                [
                    0,
                    "&Yfr;"
                ],
                [
                    1,
                    "&afr;"
                ],
                [
                    0,
                    "&bfr;"
                ],
                [
                    0,
                    "&cfr;"
                ],
                [
                    0,
                    "&dfr;"
                ],
                [
                    0,
                    "&efr;"
                ],
                [
                    0,
                    "&ffr;"
                ],
                [
                    0,
                    "&gfr;"
                ],
                [
                    0,
                    "&hfr;"
                ],
                [
                    0,
                    "&ifr;"
                ],
                [
                    0,
                    "&jfr;"
                ],
                [
                    0,
                    "&kfr;"
                ],
                [
                    0,
                    "&lfr;"
                ],
                [
                    0,
                    "&mfr;"
                ],
                [
                    0,
                    "&nfr;"
                ],
                [
                    0,
                    "&ofr;"
                ],
                [
                    0,
                    "&pfr;"
                ],
                [
                    0,
                    "&qfr;"
                ],
                [
                    0,
                    "&rfr;"
                ],
                [
                    0,
                    "&sfr;"
                ],
                [
                    0,
                    "&tfr;"
                ],
                [
                    0,
                    "&ufr;"
                ],
                [
                    0,
                    "&vfr;"
                ],
                [
                    0,
                    "&wfr;"
                ],
                [
                    0,
                    "&xfr;"
                ],
                [
                    0,
                    "&yfr;"
                ],
                [
                    0,
                    "&zfr;"
                ],
                [
                    0,
                    "&Aopf;"
                ],
                [
                    0,
                    "&Bopf;"
                ],
                [
                    1,
                    "&Dopf;"
                ],
                [
                    0,
                    "&Eopf;"
                ],
                [
                    0,
                    "&Fopf;"
                ],
                [
                    0,
                    "&Gopf;"
                ],
                [
                    1,
                    "&Iopf;"
                ],
                [
                    0,
                    "&Jopf;"
                ],
                [
                    0,
                    "&Kopf;"
                ],
                [
                    0,
                    "&Lopf;"
                ],
                [
                    0,
                    "&Mopf;"
                ],
                [
                    1,
                    "&Oopf;"
                ],
                [
                    3,
                    "&Sopf;"
                ],
                [
                    0,
                    "&Topf;"
                ],
                [
                    0,
                    "&Uopf;"
                ],
                [
                    0,
                    "&Vopf;"
                ],
                [
                    0,
                    "&Wopf;"
                ],
                [
                    0,
                    "&Xopf;"
                ],
                [
                    0,
                    "&Yopf;"
                ],
                [
                    1,
                    "&aopf;"
                ],
                [
                    0,
                    "&bopf;"
                ],
                [
                    0,
                    "&copf;"
                ],
                [
                    0,
                    "&dopf;"
                ],
                [
                    0,
                    "&eopf;"
                ],
                [
                    0,
                    "&fopf;"
                ],
                [
                    0,
                    "&gopf;"
                ],
                [
                    0,
                    "&hopf;"
                ],
                [
                    0,
                    "&iopf;"
                ],
                [
                    0,
                    "&jopf;"
                ],
                [
                    0,
                    "&kopf;"
                ],
                [
                    0,
                    "&lopf;"
                ],
                [
                    0,
                    "&mopf;"
                ],
                [
                    0,
                    "&nopf;"
                ],
                [
                    0,
                    "&oopf;"
                ],
                [
                    0,
                    "&popf;"
                ],
                [
                    0,
                    "&qopf;"
                ],
                [
                    0,
                    "&ropf;"
                ],
                [
                    0,
                    "&sopf;"
                ],
                [
                    0,
                    "&topf;"
                ],
                [
                    0,
                    "&uopf;"
                ],
                [
                    0,
                    "&vopf;"
                ],
                [
                    0,
                    "&wopf;"
                ],
                [
                    0,
                    "&xopf;"
                ],
                [
                    0,
                    "&yopf;"
                ],
                [
                    0,
                    "&zopf;"
                ]
            ]))
        }
    ],
    [
        8906,
        "&fflig;"
    ],
    [
        0,
        "&filig;"
    ],
    [
        0,
        "&fllig;"
    ],
    [
        0,
        "&ffilig;"
    ],
    [
        0,
        "&ffllig;"
    ]
]));


const $394da76bcf6713c1$export$5699810ce3244ab8 = /["&'<>$\x80-\uFFFF]/g;
const $394da76bcf6713c1$var$xmlCodeMap = new Map([
    [
        34,
        "&quot;"
    ],
    [
        38,
        "&amp;"
    ],
    [
        39,
        "&apos;"
    ],
    [
        60,
        "&lt;"
    ],
    [
        62,
        "&gt;"
    ]
]);
const $394da76bcf6713c1$export$e02688b8085d016b = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
String.prototype.codePointAt != null ? (str, index)=>str.codePointAt(index) : (c, index)=>(c.charCodeAt(index) & 0xfc00) === 0xd800 ? (c.charCodeAt(index) - 0xd800) * 0x400 + c.charCodeAt(index + 1) - 0xdc00 + 0x10000 : c.charCodeAt(index);
function $394da76bcf6713c1$export$18855ec5be97da16(str) {
    let ret = "";
    let lastIdx = 0;
    let match;
    while((match = $394da76bcf6713c1$export$5699810ce3244ab8.exec(str)) !== null){
        const i = match.index;
        const char = str.charCodeAt(i);
        const next = $394da76bcf6713c1$var$xmlCodeMap.get(char);
        if (next !== undefined) {
            ret += str.substring(lastIdx, i) + next;
            lastIdx = i + 1;
        } else {
            ret += `${str.substring(lastIdx, i)}&#x${$394da76bcf6713c1$export$e02688b8085d016b(str, i).toString(16)};`;
            // Increase by 1 if we have a surrogate pair
            lastIdx = $394da76bcf6713c1$export$5699810ce3244ab8.lastIndex += Number((char & 0xfc00) === 0xd800);
        }
    }
    return ret + str.substr(lastIdx);
}
const $394da76bcf6713c1$export$4e7f196112fea3c5 = $394da76bcf6713c1$export$18855ec5be97da16;
/**
 * Creates a function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 *
 * @param regex Regular expression to match characters to escape.
 * @param map Map of characters to escape to their entities.
 *
 * @returns Function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 */ function $394da76bcf6713c1$var$getEscaper(regex, map) {
    return function escape(data) {
        let match;
        let lastIdx = 0;
        let result = "";
        while(match = regex.exec(data)){
            if (lastIdx !== match.index) result += data.substring(lastIdx, match.index);
            // We know that this character will be in the map.
            result += map.get(match[0].charCodeAt(0));
            // Every match will be of length 1
            lastIdx = match.index + 1;
        }
        return result + data.substring(lastIdx);
    };
}
const $394da76bcf6713c1$export$9e081872deefdcb0 = $394da76bcf6713c1$var$getEscaper(/[&<>'"]/g, $394da76bcf6713c1$var$xmlCodeMap);
const $394da76bcf6713c1$export$30330f3d5eb70e11 = $394da76bcf6713c1$var$getEscaper(/["&\u00A0]/g, new Map([
    [
        34,
        "&quot;"
    ],
    [
        38,
        "&amp;"
    ],
    [
        160,
        "&nbsp;"
    ]
]));
const $394da76bcf6713c1$export$96e6fc3a139b2555 = $394da76bcf6713c1$var$getEscaper(/[&<>\u00A0]/g, new Map([
    [
        38,
        "&amp;"
    ],
    [
        60,
        "&lt;"
    ],
    [
        62,
        "&gt;"
    ],
    [
        160,
        "&nbsp;"
    ]
]));


const $60b200cb04e615e8$var$htmlReplacer = /[\t\n!-,./:-@[-`\f{-}$\x80-\uFFFF]/g;
function $60b200cb04e615e8$export$f9d6449b9af28dc1(data) {
    return $60b200cb04e615e8$var$encodeHTMLTrieRe($60b200cb04e615e8$var$htmlReplacer, data);
}
function $60b200cb04e615e8$export$e6e86c76506f1190(data) {
    return $60b200cb04e615e8$var$encodeHTMLTrieRe((0, $394da76bcf6713c1$export$5699810ce3244ab8), data);
}
function $60b200cb04e615e8$var$encodeHTMLTrieRe(regExp, str) {
    let ret = "";
    let lastIdx = 0;
    let match;
    while((match = regExp.exec(str)) !== null){
        const i = match.index;
        ret += str.substring(lastIdx, i);
        const char = str.charCodeAt(i);
        let next = (0, $ea0da353c9e2246b$export$2e2bcd8739ae039).get(char);
        if (typeof next === "object") {
            // We are in a branch. Try to match the next char.
            if (i + 1 < str.length) {
                const nextChar = str.charCodeAt(i + 1);
                const value = typeof next.n === "number" ? next.n === nextChar ? next.o : undefined : next.n.get(nextChar);
                if (value !== undefined) {
                    ret += value;
                    lastIdx = regExp.lastIndex += 1;
                    continue;
                }
            }
            next = next.v;
        }
        // We might have a tree node without a value; skip and use a numeric entity.
        if (next !== undefined) {
            ret += next;
            lastIdx = i + 1;
        } else {
            const cp = (0, $394da76bcf6713c1$export$e02688b8085d016b)(str, i);
            ret += `&#x${cp.toString(16)};`;
            // Increase by 1 if we have a surrogate pair
            lastIdx = regExp.lastIndex += Number(cp !== char);
        }
    }
    return ret + str.substr(lastIdx);
}



var $6e7e4af436ee9636$export$b8c86583d9718b50;
(function(EntityLevel) {
    /** Support only XML entities. */ EntityLevel[EntityLevel["XML"] = 0] = "XML";
    /** Support HTML entities, which are a superset of XML entities. */ EntityLevel[EntityLevel["HTML"] = 1] = "HTML";
})($6e7e4af436ee9636$export$b8c86583d9718b50 || ($6e7e4af436ee9636$export$b8c86583d9718b50 = {}));
var $6e7e4af436ee9636$export$1851b20d614eb756;
(function(EncodingMode) {
    /**
     * The output is UTF-8 encoded. Only characters that need escaping within
     * XML will be escaped.
     */ EncodingMode[EncodingMode["UTF8"] = 0] = "UTF8";
    /**
     * The output consists only of ASCII characters. Characters that need
     * escaping within HTML, and characters that aren't ASCII characters will
     * be escaped.
     */ EncodingMode[EncodingMode["ASCII"] = 1] = "ASCII";
    /**
     * Encode all characters that have an equivalent entity, as well as all
     * characters that are not ASCII characters.
     */ EncodingMode[EncodingMode["Extensive"] = 2] = "Extensive";
    /**
     * Encode all characters that have to be escaped in HTML attributes,
     * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
     */ EncodingMode[EncodingMode["Attribute"] = 3] = "Attribute";
    /**
     * Encode all characters that have to be escaped in HTML text,
     * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
     */ EncodingMode[EncodingMode["Text"] = 4] = "Text";
})($6e7e4af436ee9636$export$1851b20d614eb756 || ($6e7e4af436ee9636$export$1851b20d614eb756 = {}));
function $6e7e4af436ee9636$export$2f872c0f2117be69(data, options = $6e7e4af436ee9636$export$b8c86583d9718b50.XML) {
    const level = typeof options === "number" ? options : options.level;
    if (level === $6e7e4af436ee9636$export$b8c86583d9718b50.HTML) {
        const mode = typeof options === "object" ? options.mode : undefined;
        return (0, $4cc47c481cd52694$export$f045cb747ce77a19)(data, mode);
    }
    return (0, $4cc47c481cd52694$export$88e3b9643a8bd06e)(data);
}
function $6e7e4af436ee9636$export$c94669f4c7d36be4(data, options = $6e7e4af436ee9636$export$b8c86583d9718b50.XML) {
    var _a;
    const opts = typeof options === "number" ? {
        level: options
    } : options;
    (_a = opts.mode) !== null && _a !== void 0 ? _a : opts.mode = (0, $4cc47c481cd52694$export$8c8f129ce60f53c).Strict;
    return $6e7e4af436ee9636$export$2f872c0f2117be69(data, opts);
}
function $6e7e4af436ee9636$export$c564cdbbe6da493(data, options = $6e7e4af436ee9636$export$b8c86583d9718b50.XML) {
    const opts = typeof options === "number" ? {
        level: options
    } : options;
    // Mode `UTF8` just escapes XML entities
    if (opts.mode === $6e7e4af436ee9636$export$1851b20d614eb756.UTF8) return (0, $394da76bcf6713c1$export$9e081872deefdcb0)(data);
    if (opts.mode === $6e7e4af436ee9636$export$1851b20d614eb756.Attribute) return (0, $394da76bcf6713c1$export$30330f3d5eb70e11)(data);
    if (opts.mode === $6e7e4af436ee9636$export$1851b20d614eb756.Text) return (0, $394da76bcf6713c1$export$96e6fc3a139b2555)(data);
    if (opts.level === $6e7e4af436ee9636$export$b8c86583d9718b50.HTML) {
        if (opts.mode === $6e7e4af436ee9636$export$1851b20d614eb756.ASCII) return (0, $60b200cb04e615e8$export$e6e86c76506f1190)(data);
        return (0, $60b200cb04e615e8$export$f9d6449b9af28dc1)(data);
    }
    // ASCII and Extensive are equivalent
    return (0, $394da76bcf6713c1$export$18855ec5be97da16)(data);
}


const $8ff5fe6bfc874c4a$export$82b917442d249e05 = new Map([
    "altGlyph",
    "altGlyphDef",
    "altGlyphItem",
    "animateColor",
    "animateMotion",
    "animateTransform",
    "clipPath",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "foreignObject",
    "glyphRef",
    "linearGradient",
    "radialGradient",
    "textPath"
].map((val)=>[
        val.toLowerCase(),
        val
    ]));
const $8ff5fe6bfc874c4a$export$b4cfbfd90280b005 = new Map([
    "definitionURL",
    "attributeName",
    "attributeType",
    "baseFrequency",
    "baseProfile",
    "calcMode",
    "clipPathUnits",
    "diffuseConstant",
    "edgeMode",
    "filterUnits",
    "glyphRef",
    "gradientTransform",
    "gradientUnits",
    "kernelMatrix",
    "kernelUnitLength",
    "keyPoints",
    "keySplines",
    "keyTimes",
    "lengthAdjust",
    "limitingConeAngle",
    "markerHeight",
    "markerUnits",
    "markerWidth",
    "maskContentUnits",
    "maskUnits",
    "numOctaves",
    "pathLength",
    "patternContentUnits",
    "patternTransform",
    "patternUnits",
    "pointsAtX",
    "pointsAtY",
    "pointsAtZ",
    "preserveAlpha",
    "preserveAspectRatio",
    "primitiveUnits",
    "refX",
    "refY",
    "repeatCount",
    "repeatDur",
    "requiredExtensions",
    "requiredFeatures",
    "specularConstant",
    "specularExponent",
    "spreadMethod",
    "startOffset",
    "stdDeviation",
    "stitchTiles",
    "surfaceScale",
    "systemLanguage",
    "tableValues",
    "targetX",
    "targetY",
    "textLength",
    "viewBox",
    "viewTarget",
    "xChannelSelector",
    "yChannelSelector",
    "zoomAndPan"
].map((val)=>[
        val.toLowerCase(),
        val
    ]));


const $289a0c4c7fc0d0e7$var$unencodedElements = new Set([
    "style",
    "script",
    "xmp",
    "iframe",
    "noembed",
    "noframes",
    "plaintext",
    "noscript"
]);
function $289a0c4c7fc0d0e7$var$replaceQuotes(value) {
    return value.replace(/"/g, "&quot;");
}
/**
 * Format attributes
 */ function $289a0c4c7fc0d0e7$var$formatAttributes(attributes, opts) {
    var _a;
    if (!attributes) return;
    const encode = ((_a = opts.encodeEntities) !== null && _a !== void 0 ? _a : opts.decodeEntities) === false ? $289a0c4c7fc0d0e7$var$replaceQuotes : opts.xmlMode || opts.encodeEntities !== "utf8" ? (0, $394da76bcf6713c1$export$18855ec5be97da16) : (0, $394da76bcf6713c1$export$30330f3d5eb70e11);
    return Object.keys(attributes).map((key)=>{
        var _a, _b;
        const value = (_a = attributes[key]) !== null && _a !== void 0 ? _a : "";
        if (opts.xmlMode === "foreign") /* Fix up mixed-case attribute names */ key = (_b = (0, $8ff5fe6bfc874c4a$export$b4cfbfd90280b005).get(key)) !== null && _b !== void 0 ? _b : key;
        if (!opts.emptyAttrs && !opts.xmlMode && value === "") return key;
        return `${key}="${encode(value)}"`;
    }).join(" ");
}
/**
 * Self-enclosing tags
 */ const $289a0c4c7fc0d0e7$var$singleTag = new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
]);
function $289a0c4c7fc0d0e7$export$b3890eb0ae9dca99(node, options = {}) {
    const nodes = "length" in node ? node : [
        node
    ];
    let output = "";
    for(let i = 0; i < nodes.length; i++)output += $289a0c4c7fc0d0e7$var$renderNode(nodes[i], options);
    return output;
}
var $289a0c4c7fc0d0e7$export$2e2bcd8739ae039 = $289a0c4c7fc0d0e7$export$b3890eb0ae9dca99;
function $289a0c4c7fc0d0e7$var$renderNode(node, options) {
    switch(node.type){
        case $39ef1bdf59853755$export$be92b6f5f03c0fe9:
            return $289a0c4c7fc0d0e7$export$b3890eb0ae9dca99(node.children, options);
        // @ts-expect-error We don't use `Doctype` yet
        case $39ef1bdf59853755$export$31b44af36ff2c60f:
        case $39ef1bdf59853755$export$befdefbdce210f91:
            return $289a0c4c7fc0d0e7$var$renderDirective(node);
        case $39ef1bdf59853755$export$4d299b491347818a:
            return $289a0c4c7fc0d0e7$var$renderComment(node);
        case $39ef1bdf59853755$export$1f8b8f7e5c763232:
            return $289a0c4c7fc0d0e7$var$renderCdata(node);
        case $39ef1bdf59853755$export$2f8b47a141e57afc:
        case $39ef1bdf59853755$export$d9e45bc13d335801:
        case $39ef1bdf59853755$export$3288d34c523a1192:
            return $289a0c4c7fc0d0e7$var$renderTag(node, options);
        case $39ef1bdf59853755$export$5f1af8db9871e1d6:
            return $289a0c4c7fc0d0e7$var$renderText(node, options);
    }
}
const $289a0c4c7fc0d0e7$var$foreignModeIntegrationPoints = new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignObject",
    "desc",
    "title"
]);
const $289a0c4c7fc0d0e7$var$foreignElements = new Set([
    "svg",
    "math"
]);
function $289a0c4c7fc0d0e7$var$renderTag(elem, opts) {
    var _a;
    // Handle SVG / MathML in HTML
    if (opts.xmlMode === "foreign") {
        /* Fix up mixed-case element names */ elem.name = (_a = (0, $8ff5fe6bfc874c4a$export$82b917442d249e05).get(elem.name)) !== null && _a !== void 0 ? _a : elem.name;
        /* Exit foreign mode at integration points */ if (elem.parent && $289a0c4c7fc0d0e7$var$foreignModeIntegrationPoints.has(elem.parent.name)) opts = {
            ...opts,
            xmlMode: false
        };
    }
    if (!opts.xmlMode && $289a0c4c7fc0d0e7$var$foreignElements.has(elem.name)) opts = {
        ...opts,
        xmlMode: "foreign"
    };
    let tag = `<${elem.name}`;
    const attribs = $289a0c4c7fc0d0e7$var$formatAttributes(elem.attribs, opts);
    if (attribs) tag += ` ${attribs}`;
    if (elem.children.length === 0 && (opts.xmlMode ? opts.selfClosingTags !== false : opts.selfClosingTags && $289a0c4c7fc0d0e7$var$singleTag.has(elem.name))) {
        if (!opts.xmlMode) tag += " ";
        tag += "/>";
    } else {
        tag += ">";
        if (elem.children.length > 0) tag += $289a0c4c7fc0d0e7$export$b3890eb0ae9dca99(elem.children, opts);
        if (opts.xmlMode || !$289a0c4c7fc0d0e7$var$singleTag.has(elem.name)) tag += `</${elem.name}>`;
    }
    return tag;
}
function $289a0c4c7fc0d0e7$var$renderDirective(elem) {
    return `<${elem.data}>`;
}
function $289a0c4c7fc0d0e7$var$renderText(elem, opts) {
    var _a;
    let data = elem.data || "";
    // If entities weren't decoded, no need to encode them back
    if (((_a = opts.encodeEntities) !== null && _a !== void 0 ? _a : opts.decodeEntities) !== false && !(!opts.xmlMode && elem.parent && $289a0c4c7fc0d0e7$var$unencodedElements.has(elem.parent.name))) data = opts.xmlMode || opts.encodeEntities !== "utf8" ? (0, $394da76bcf6713c1$export$18855ec5be97da16)(data) : (0, $394da76bcf6713c1$export$96e6fc3a139b2555)(data);
    return data;
}
function $289a0c4c7fc0d0e7$var$renderCdata(elem) {
    return `<![CDATA[${elem.children[0].data}]]>`;
}
function $289a0c4c7fc0d0e7$var$renderComment(elem) {
    return `<!--${elem.data}-->`;
}



function $3c56d7623a1e72c9$export$39484b727cc2f324(node, options) {
    return (0, $289a0c4c7fc0d0e7$export$2e2bcd8739ae039)(node, options);
}
function $3c56d7623a1e72c9$export$7ed15b4d2218408(node, options) {
    return (0, $48930c390439f17e$export$bd5ff50f0e53d41c)(node) ? node.children.map((node)=>$3c56d7623a1e72c9$export$39484b727cc2f324(node, options)).join("") : "";
}
function $3c56d7623a1e72c9$export$c72d34660a162238(node) {
    if (Array.isArray(node)) return node.map($3c56d7623a1e72c9$export$c72d34660a162238).join("");
    if ((0, $48930c390439f17e$export$3bf645f08efe3292)(node)) return node.name === "br" ? "\n" : $3c56d7623a1e72c9$export$c72d34660a162238(node.children);
    if ((0, $48930c390439f17e$export$c2d65aed98d39b56)(node)) return $3c56d7623a1e72c9$export$c72d34660a162238(node.children);
    if ((0, $48930c390439f17e$export$1879817ac5c922b7)(node)) return node.data;
    return "";
}
function $3c56d7623a1e72c9$export$e0e0794250e9118f(node) {
    if (Array.isArray(node)) return node.map($3c56d7623a1e72c9$export$e0e0794250e9118f).join("");
    if ((0, $48930c390439f17e$export$bd5ff50f0e53d41c)(node) && !(0, $48930c390439f17e$export$3ab01370f5e64ac8)(node)) return $3c56d7623a1e72c9$export$e0e0794250e9118f(node.children);
    if ((0, $48930c390439f17e$export$1879817ac5c922b7)(node)) return node.data;
    return "";
}
function $3c56d7623a1e72c9$export$5864bc2a45f1eb81(node) {
    if (Array.isArray(node)) return node.map($3c56d7623a1e72c9$export$5864bc2a45f1eb81).join("");
    if ((0, $48930c390439f17e$export$bd5ff50f0e53d41c)(node) && (node.type === (0, $39ef1bdf59853755$export$b992dc138d950e31).Tag || (0, $48930c390439f17e$export$c2d65aed98d39b56)(node))) return $3c56d7623a1e72c9$export$5864bc2a45f1eb81(node.children);
    if ((0, $48930c390439f17e$export$1879817ac5c922b7)(node)) return node.data;
    return "";
}



function $bdbe3f4d19afd94e$export$f8cf48ee793b41be(elem) {
    return (0, $48930c390439f17e$export$bd5ff50f0e53d41c)(elem) ? elem.children : [];
}
function $bdbe3f4d19afd94e$export$58081aedf094d85b(elem) {
    return elem.parent || null;
}
function $bdbe3f4d19afd94e$export$f312c3733b79ac0d(elem) {
    const parent = $bdbe3f4d19afd94e$export$58081aedf094d85b(elem);
    if (parent != null) return $bdbe3f4d19afd94e$export$f8cf48ee793b41be(parent);
    const siblings = [
        elem
    ];
    let { prev: prev, next: next } = elem;
    while(prev != null){
        siblings.unshift(prev);
        ({ prev: prev } = prev);
    }
    while(next != null){
        siblings.push(next);
        ({ next: next } = next);
    }
    return siblings;
}
function $bdbe3f4d19afd94e$export$1e335898aa11b111(elem, name) {
    var _a;
    return (_a = elem.attribs) === null || _a === void 0 ? void 0 : _a[name];
}
function $bdbe3f4d19afd94e$export$aa37f90c17957f38(elem, name) {
    return elem.attribs != null && Object.prototype.hasOwnProperty.call(elem.attribs, name) && elem.attribs[name] != null;
}
function $bdbe3f4d19afd94e$export$7d9f7e9c1c02b41e(elem) {
    return elem.name;
}
function $bdbe3f4d19afd94e$export$9be3779649ef9cc7(elem) {
    let { next: next } = elem;
    while(next !== null && !(0, $48930c390439f17e$export$3bf645f08efe3292)(next))({ next: next } = next);
    return next;
}
function $bdbe3f4d19afd94e$export$c8bafb6e59c0b8e(elem) {
    let { prev: prev } = elem;
    while(prev !== null && !(0, $48930c390439f17e$export$3bf645f08efe3292)(prev))({ prev: prev } = prev);
    return prev;
}


/**
 * Remove an element from the dom
 *
 * @category Manipulation
 * @param elem The element to be removed
 */ function $0f7e9bf9254b859b$export$f883456a56996078(elem) {
    if (elem.prev) elem.prev.next = elem.next;
    if (elem.next) elem.next.prev = elem.prev;
    if (elem.parent) {
        const childs = elem.parent.children;
        const childsIndex = childs.lastIndexOf(elem);
        if (childsIndex >= 0) childs.splice(childsIndex, 1);
    }
    elem.next = null;
    elem.prev = null;
    elem.parent = null;
}
function $0f7e9bf9254b859b$export$2dfe578f95754f6a(elem, replacement) {
    const prev = replacement.prev = elem.prev;
    if (prev) prev.next = replacement;
    const next = replacement.next = elem.next;
    if (next) next.prev = replacement;
    const parent = replacement.parent = elem.parent;
    if (parent) {
        const childs = parent.children;
        childs[childs.lastIndexOf(elem)] = replacement;
        elem.parent = null;
    }
}
function $0f7e9bf9254b859b$export$1b8e57c9ea42f1d2(parent, child) {
    $0f7e9bf9254b859b$export$f883456a56996078(child);
    child.next = null;
    child.parent = parent;
    if (parent.children.push(child) > 1) {
        const sibling = parent.children[parent.children.length - 2];
        sibling.next = child;
        child.prev = sibling;
    } else child.prev = null;
}
function $0f7e9bf9254b859b$export$10d8903dec122b9d(elem, next) {
    $0f7e9bf9254b859b$export$f883456a56996078(next);
    const { parent: parent } = elem;
    const currNext = elem.next;
    next.next = currNext;
    next.prev = elem;
    elem.next = next;
    next.parent = parent;
    if (currNext) {
        currNext.prev = next;
        if (parent) {
            const childs = parent.children;
            childs.splice(childs.lastIndexOf(currNext), 0, next);
        }
    } else if (parent) parent.children.push(next);
}
function $0f7e9bf9254b859b$export$47b51e6d100007bc(parent, child) {
    $0f7e9bf9254b859b$export$f883456a56996078(child);
    child.parent = parent;
    child.prev = null;
    if (parent.children.unshift(child) !== 1) {
        const sibling = parent.children[1];
        sibling.prev = child;
        child.next = sibling;
    } else child.next = null;
}
function $0f7e9bf9254b859b$export$68159836694e22c1(elem, prev) {
    $0f7e9bf9254b859b$export$f883456a56996078(prev);
    const { parent: parent } = elem;
    if (parent) {
        const childs = parent.children;
        childs.splice(childs.indexOf(elem), 0, prev);
    }
    if (elem.prev) elem.prev.next = prev;
    prev.parent = parent;
    prev.prev = elem.prev;
    prev.next = elem;
    elem.prev = prev;
}



function $5e069fae0cf4dc43$export$3dea766d36a8935f(test, node, recurse = true, limit = Infinity) {
    return $5e069fae0cf4dc43$export$71aa6c912b956294(test, Array.isArray(node) ? node : [
        node
    ], recurse, limit);
}
function $5e069fae0cf4dc43$export$71aa6c912b956294(test, nodes, recurse, limit) {
    const result = [];
    /** Stack of the arrays we are looking at. */ const nodeStack = [
        nodes
    ];
    /** Stack of the indices within the arrays. */ const indexStack = [
        0
    ];
    for(;;){
        // First, check if the current array has any more elements to look at.
        if (indexStack[0] >= nodeStack[0].length) {
            // If we have no more arrays to look at, we are done.
            if (indexStack.length === 1) return result;
            // Otherwise, remove the current array from the stack.
            nodeStack.shift();
            indexStack.shift();
            continue;
        }
        const elem = nodeStack[0][indexStack[0]++];
        if (test(elem)) {
            result.push(elem);
            if (--limit <= 0) return result;
        }
        if (recurse && (0, $48930c390439f17e$export$bd5ff50f0e53d41c)(elem) && elem.children.length > 0) {
            /*
             * Add the children to the stack. We are depth-first, so this is
             * the next array we look at.
             */ indexStack.unshift(0);
            nodeStack.unshift(elem.children);
        }
    }
}
function $5e069fae0cf4dc43$export$ac03a862904ce329(test, nodes) {
    return nodes.find(test);
}
function $5e069fae0cf4dc43$export$a541876d5d7daf90(test, nodes, recurse = true) {
    let elem = null;
    for(let i = 0; i < nodes.length && !elem; i++){
        const node = nodes[i];
        if (!(0, $48930c390439f17e$export$3bf645f08efe3292)(node)) continue;
        else if (test(node)) elem = node;
        else if (recurse && node.children.length > 0) elem = $5e069fae0cf4dc43$export$a541876d5d7daf90(test, node.children, true);
    }
    return elem;
}
function $5e069fae0cf4dc43$export$9d99dce58ac4a31b(test, nodes) {
    return nodes.some((checked)=>(0, $48930c390439f17e$export$3bf645f08efe3292)(checked) && (test(checked) || $5e069fae0cf4dc43$export$9d99dce58ac4a31b(test, checked.children)));
}
function $5e069fae0cf4dc43$export$18200ea6c8035394(test, nodes) {
    const result = [];
    const nodeStack = [
        nodes
    ];
    const indexStack = [
        0
    ];
    for(;;){
        if (indexStack[0] >= nodeStack[0].length) {
            if (nodeStack.length === 1) return result;
            // Otherwise, remove the current array from the stack.
            nodeStack.shift();
            indexStack.shift();
            continue;
        }
        const elem = nodeStack[0][indexStack[0]++];
        if (!(0, $48930c390439f17e$export$3bf645f08efe3292)(elem)) continue;
        if (test(elem)) result.push(elem);
        if (elem.children.length > 0) {
            indexStack.unshift(0);
            nodeStack.unshift(elem.children);
        }
    }
}




/**
 * A map of functions to check nodes against.
 */ const $ec171af7a55f0492$var$Checks = {
    tag_name (name) {
        if (typeof name === "function") return (elem)=>(0, $48930c390439f17e$export$3bf645f08efe3292)(elem) && name(elem.name);
        else if (name === "*") return 0, $48930c390439f17e$export$3bf645f08efe3292;
        return (elem)=>(0, $48930c390439f17e$export$3bf645f08efe3292)(elem) && elem.name === name;
    },
    tag_type (type) {
        if (typeof type === "function") return (elem)=>type(elem.type);
        return (elem)=>elem.type === type;
    },
    tag_contains (data) {
        if (typeof data === "function") return (elem)=>(0, $48930c390439f17e$export$1879817ac5c922b7)(elem) && data(elem.data);
        return (elem)=>(0, $48930c390439f17e$export$1879817ac5c922b7)(elem) && elem.data === data;
    }
};
/**
 * Returns a function to check whether a node has an attribute with a particular
 * value.
 *
 * @param attrib Attribute to check.
 * @param value Attribute value to look for.
 * @returns A function to check whether the a node has an attribute with a
 *   particular value.
 */ function $ec171af7a55f0492$var$getAttribCheck(attrib, value) {
    if (typeof value === "function") return (elem)=>(0, $48930c390439f17e$export$3bf645f08efe3292)(elem) && value(elem.attribs[attrib]);
    return (elem)=>(0, $48930c390439f17e$export$3bf645f08efe3292)(elem) && elem.attribs[attrib] === value;
}
/**
 * Returns a function that returns `true` if either of the input functions
 * returns `true` for a node.
 *
 * @param a First function to combine.
 * @param b Second function to combine.
 * @returns A function taking a node and returning `true` if either of the input
 *   functions returns `true` for the node.
 */ function $ec171af7a55f0492$var$combineFuncs(a, b) {
    return (elem)=>a(elem) || b(elem);
}
/**
 * Returns a function that executes all checks in `options` and returns `true`
 * if any of them match a node.
 *
 * @param options An object describing nodes to look for.
 * @returns A function that executes all checks in `options` and returns `true`
 *   if any of them match a node.
 */ function $ec171af7a55f0492$var$compileTest(options) {
    const funcs = Object.keys(options).map((key)=>{
        const value = options[key];
        return Object.prototype.hasOwnProperty.call($ec171af7a55f0492$var$Checks, key) ? $ec171af7a55f0492$var$Checks[key](value) : $ec171af7a55f0492$var$getAttribCheck(key, value);
    });
    return funcs.length === 0 ? null : funcs.reduce($ec171af7a55f0492$var$combineFuncs);
}
function $ec171af7a55f0492$export$7b31db6b5a0b2f32(options, node) {
    const test = $ec171af7a55f0492$var$compileTest(options);
    return test ? test(node) : true;
}
function $ec171af7a55f0492$export$73eac51a39d6b0eb(options, nodes, recurse, limit = Infinity) {
    const test = $ec171af7a55f0492$var$compileTest(options);
    return test ? (0, $5e069fae0cf4dc43$export$3dea766d36a8935f)(test, nodes, recurse, limit) : [];
}
function $ec171af7a55f0492$export$83595b84fc78b9b4(id, nodes, recurse = true) {
    if (!Array.isArray(nodes)) nodes = [
        nodes
    ];
    return (0, $5e069fae0cf4dc43$export$a541876d5d7daf90)($ec171af7a55f0492$var$getAttribCheck("id", id), nodes, recurse);
}
function $ec171af7a55f0492$export$af941c3c7c3b40f5(tagName, nodes, recurse = true, limit = Infinity) {
    return (0, $5e069fae0cf4dc43$export$3dea766d36a8935f)($ec171af7a55f0492$var$Checks["tag_name"](tagName), nodes, recurse, limit);
}
function $ec171af7a55f0492$export$f5d981e30be5545b(type, nodes, recurse = true, limit = Infinity) {
    return (0, $5e069fae0cf4dc43$export$3dea766d36a8935f)($ec171af7a55f0492$var$Checks["tag_type"](type), nodes, recurse, limit);
}



function $75186c289dfc7a81$export$171dc294232ebeef(nodes) {
    let idx = nodes.length;
    /*
     * Check if each node (or one of its ancestors) is already contained in the
     * array.
     */ while(--idx >= 0){
        const node = nodes[idx];
        /*
         * Remove the node if it is not unique.
         * We are going through the array from the end, so we only
         * have to check nodes that preceed the node under consideration in the array.
         */ if (idx > 0 && nodes.lastIndexOf(node, idx - 1) >= 0) {
            nodes.splice(idx, 1);
            continue;
        }
        for(let ancestor = node.parent; ancestor; ancestor = ancestor.parent)if (nodes.includes(ancestor)) {
            nodes.splice(idx, 1);
            break;
        }
    }
    return nodes;
}
var $75186c289dfc7a81$export$406a59d989e8005a;
(function(DocumentPosition) {
    DocumentPosition[DocumentPosition["DISCONNECTED"] = 1] = "DISCONNECTED";
    DocumentPosition[DocumentPosition["PRECEDING"] = 2] = "PRECEDING";
    DocumentPosition[DocumentPosition["FOLLOWING"] = 4] = "FOLLOWING";
    DocumentPosition[DocumentPosition["CONTAINS"] = 8] = "CONTAINS";
    DocumentPosition[DocumentPosition["CONTAINED_BY"] = 16] = "CONTAINED_BY";
})($75186c289dfc7a81$export$406a59d989e8005a || ($75186c289dfc7a81$export$406a59d989e8005a = {}));
function $75186c289dfc7a81$export$17303b8fea718ecc(nodeA, nodeB) {
    const aParents = [];
    const bParents = [];
    if (nodeA === nodeB) return 0;
    let current = (0, $48930c390439f17e$export$bd5ff50f0e53d41c)(nodeA) ? nodeA : nodeA.parent;
    while(current){
        aParents.unshift(current);
        current = current.parent;
    }
    current = (0, $48930c390439f17e$export$bd5ff50f0e53d41c)(nodeB) ? nodeB : nodeB.parent;
    while(current){
        bParents.unshift(current);
        current = current.parent;
    }
    const maxIdx = Math.min(aParents.length, bParents.length);
    let idx = 0;
    while(idx < maxIdx && aParents[idx] === bParents[idx])idx++;
    if (idx === 0) return $75186c289dfc7a81$export$406a59d989e8005a.DISCONNECTED;
    const sharedParent = aParents[idx - 1];
    const siblings = sharedParent.children;
    const aSibling = aParents[idx];
    const bSibling = bParents[idx];
    if (siblings.indexOf(aSibling) > siblings.indexOf(bSibling)) {
        if (sharedParent === nodeB) return $75186c289dfc7a81$export$406a59d989e8005a.FOLLOWING | $75186c289dfc7a81$export$406a59d989e8005a.CONTAINED_BY;
        return $75186c289dfc7a81$export$406a59d989e8005a.FOLLOWING;
    }
    if (sharedParent === nodeA) return $75186c289dfc7a81$export$406a59d989e8005a.PRECEDING | $75186c289dfc7a81$export$406a59d989e8005a.CONTAINS;
    return $75186c289dfc7a81$export$406a59d989e8005a.PRECEDING;
}
function $75186c289dfc7a81$export$1c267319665a7e7e(nodes) {
    nodes = nodes.filter((node, i, arr)=>!arr.includes(node, i + 1));
    nodes.sort((a, b)=>{
        const relative = $75186c289dfc7a81$export$17303b8fea718ecc(a, b);
        if (relative & $75186c289dfc7a81$export$406a59d989e8005a.PRECEDING) return -1;
        else if (relative & $75186c289dfc7a81$export$406a59d989e8005a.FOLLOWING) return 1;
        return 0;
    });
    return nodes;
}




function $6183d13d8d85d0b5$export$ad32138c9e09ad4(doc) {
    const feedRoot = $6183d13d8d85d0b5$var$getOneElement($6183d13d8d85d0b5$var$isValidFeed, doc);
    return !feedRoot ? null : feedRoot.name === "feed" ? $6183d13d8d85d0b5$var$getAtomFeed(feedRoot) : $6183d13d8d85d0b5$var$getRssFeed(feedRoot);
}
/**
 * Parse an Atom feed.
 *
 * @param feedRoot The root of the feed.
 * @returns The parsed feed.
 */ function $6183d13d8d85d0b5$var$getAtomFeed(feedRoot) {
    var _a;
    const childs = feedRoot.children;
    const feed = {
        type: "atom",
        items: (0, $ec171af7a55f0492$export$af941c3c7c3b40f5)("entry", childs).map((item)=>{
            var _a;
            const { children: children } = item;
            const entry = {
                media: $6183d13d8d85d0b5$var$getMediaElements(children)
            };
            $6183d13d8d85d0b5$var$addConditionally(entry, "id", "id", children);
            $6183d13d8d85d0b5$var$addConditionally(entry, "title", "title", children);
            const href = (_a = $6183d13d8d85d0b5$var$getOneElement("link", children)) === null || _a === void 0 ? void 0 : _a.attribs["href"];
            if (href) entry.link = href;
            const description = $6183d13d8d85d0b5$var$fetch("summary", children) || $6183d13d8d85d0b5$var$fetch("content", children);
            if (description) entry.description = description;
            const pubDate = $6183d13d8d85d0b5$var$fetch("updated", children);
            if (pubDate) entry.pubDate = new Date(pubDate);
            return entry;
        })
    };
    $6183d13d8d85d0b5$var$addConditionally(feed, "id", "id", childs);
    $6183d13d8d85d0b5$var$addConditionally(feed, "title", "title", childs);
    const href = (_a = $6183d13d8d85d0b5$var$getOneElement("link", childs)) === null || _a === void 0 ? void 0 : _a.attribs["href"];
    if (href) feed.link = href;
    $6183d13d8d85d0b5$var$addConditionally(feed, "description", "subtitle", childs);
    const updated = $6183d13d8d85d0b5$var$fetch("updated", childs);
    if (updated) feed.updated = new Date(updated);
    $6183d13d8d85d0b5$var$addConditionally(feed, "author", "email", childs, true);
    return feed;
}
/**
 * Parse a RSS feed.
 *
 * @param feedRoot The root of the feed.
 * @returns The parsed feed.
 */ function $6183d13d8d85d0b5$var$getRssFeed(feedRoot) {
    var _a, _b;
    const childs = (_b = (_a = $6183d13d8d85d0b5$var$getOneElement("channel", feedRoot.children)) === null || _a === void 0 ? void 0 : _a.children) !== null && _b !== void 0 ? _b : [];
    const feed = {
        type: feedRoot.name.substr(0, 3),
        id: "",
        items: (0, $ec171af7a55f0492$export$af941c3c7c3b40f5)("item", feedRoot.children).map((item)=>{
            const { children: children } = item;
            const entry = {
                media: $6183d13d8d85d0b5$var$getMediaElements(children)
            };
            $6183d13d8d85d0b5$var$addConditionally(entry, "id", "guid", children);
            $6183d13d8d85d0b5$var$addConditionally(entry, "title", "title", children);
            $6183d13d8d85d0b5$var$addConditionally(entry, "link", "link", children);
            $6183d13d8d85d0b5$var$addConditionally(entry, "description", "description", children);
            const pubDate = $6183d13d8d85d0b5$var$fetch("pubDate", children) || $6183d13d8d85d0b5$var$fetch("dc:date", children);
            if (pubDate) entry.pubDate = new Date(pubDate);
            return entry;
        })
    };
    $6183d13d8d85d0b5$var$addConditionally(feed, "title", "title", childs);
    $6183d13d8d85d0b5$var$addConditionally(feed, "link", "link", childs);
    $6183d13d8d85d0b5$var$addConditionally(feed, "description", "description", childs);
    const updated = $6183d13d8d85d0b5$var$fetch("lastBuildDate", childs);
    if (updated) feed.updated = new Date(updated);
    $6183d13d8d85d0b5$var$addConditionally(feed, "author", "managingEditor", childs, true);
    return feed;
}
const $6183d13d8d85d0b5$var$MEDIA_KEYS_STRING = [
    "url",
    "type",
    "lang"
];
const $6183d13d8d85d0b5$var$MEDIA_KEYS_INT = [
    "fileSize",
    "bitrate",
    "framerate",
    "samplingrate",
    "channels",
    "duration",
    "height",
    "width"
];
/**
 * Get all media elements of a feed item.
 *
 * @param where Nodes to search in.
 * @returns Media elements.
 */ function $6183d13d8d85d0b5$var$getMediaElements(where) {
    return (0, $ec171af7a55f0492$export$af941c3c7c3b40f5)("media:content", where).map((elem)=>{
        const { attribs: attribs } = elem;
        const media = {
            medium: attribs["medium"],
            isDefault: !!attribs["isDefault"]
        };
        for (const attrib of $6183d13d8d85d0b5$var$MEDIA_KEYS_STRING)if (attribs[attrib]) media[attrib] = attribs[attrib];
        for (const attrib of $6183d13d8d85d0b5$var$MEDIA_KEYS_INT)if (attribs[attrib]) media[attrib] = parseInt(attribs[attrib], 10);
        if (attribs["expression"]) media.expression = attribs["expression"];
        return media;
    });
}
/**
 * Get one element by tag name.
 *
 * @param tagName Tag name to look for
 * @param node Node to search in
 * @returns The element or null
 */ function $6183d13d8d85d0b5$var$getOneElement(tagName, node) {
    return (0, $ec171af7a55f0492$export$af941c3c7c3b40f5)(tagName, node, true, 1)[0];
}
/**
 * Get the text content of an element with a certain tag name.
 *
 * @param tagName Tag name to look for.
 * @param where Node to search in.
 * @param recurse Whether to recurse into child nodes.
 * @returns The text content of the element.
 */ function $6183d13d8d85d0b5$var$fetch(tagName, where, recurse = false) {
    return (0, $3c56d7623a1e72c9$export$e0e0794250e9118f)((0, $ec171af7a55f0492$export$af941c3c7c3b40f5)(tagName, where, recurse, 1)).trim();
}
/**
 * Adds a property to an object if it has a value.
 *
 * @param obj Object to be extended
 * @param prop Property name
 * @param tagName Tag name that contains the conditionally added property
 * @param where Element to search for the property
 * @param recurse Whether to recurse into child nodes.
 */ function $6183d13d8d85d0b5$var$addConditionally(obj, prop, tagName, where, recurse = false) {
    const val = $6183d13d8d85d0b5$var$fetch(tagName, where, recurse);
    if (val) obj[prop] = val;
}
/**
 * Checks if an element is a feed root node.
 *
 * @param value The name of the element to check.
 * @returns Whether an element is a feed root node.
 */ function $6183d13d8d85d0b5$var$isValidFeed(value) {
    return value === "rss" || value === "feed" || value === "rdf:RDF";
}





function $3bc039c9d3883970$export$b6a9369736b19f4d(data, options) {
    const handler = new (0, $07850bf084fc48f7$export$ff8ccbac9225de62)(undefined, options);
    new (0, $0ab8478bff8d2345$export$7acfa6ed01010e37)(handler, options).end(data);
    return handler.root;
}
function $3bc039c9d3883970$export$d66b332881d9723f(data, options) {
    return $3bc039c9d3883970$export$b6a9369736b19f4d(data, options).children;
}
function $3bc039c9d3883970$export$2bbd0317573b00fc(callback, options, elementCallback) {
    const handler = new (0, $07850bf084fc48f7$export$ff8ccbac9225de62)(callback, options, elementCallback);
    return new (0, $0ab8478bff8d2345$export$7acfa6ed01010e37)(handler, options);
}
const $3bc039c9d3883970$var$parseFeedDefaultOptions = {
    xmlMode: true
};
function $3bc039c9d3883970$export$5267abf679cd576b(feed, options = $3bc039c9d3883970$var$parseFeedDefaultOptions) {
    return (0, $6183d13d8d85d0b5$export$ad32138c9e09ad4)($3bc039c9d3883970$export$d66b332881d9723f(feed, options));
}


var $5c0b5ed16124b0da$exports = {};
"use strict";
$5c0b5ed16124b0da$exports = (string)=>{
    if (typeof string !== "string") throw new TypeError("Expected a string");
    // Escape characters with special meaning either inside or outside character sets.
    // Use a simple backslash escape when it’s always valid, and a \unnnn escape when the simpler form would be disallowed by Unicode patterns’ stricter grammar.
    return string.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
};


/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */ function $0d8650ea05fb345a$var$isObject(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $0d8650ea05fb345a$export$53b83ca8eaab0383(o) {
    var ctor, prot;
    if ($0d8650ea05fb345a$var$isObject(o) === false) return false;
    // If has modified constructor
    ctor = o.constructor;
    if (ctor === undefined) return true;
    // If has modified prototype
    prot = ctor.prototype;
    if ($0d8650ea05fb345a$var$isObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (prot.hasOwnProperty("isPrototypeOf") === false) return false;
    // Most likely a plain Object
    return true;
}


var $91fe648caba28c6f$require$isPlainObject = $0d8650ea05fb345a$export$53b83ca8eaab0383;
var $5cbac2c2bd2e19a5$exports = {};
"use strict";
var $5cbac2c2bd2e19a5$var$isMergeableObject = function isMergeableObject(value) {
    return $5cbac2c2bd2e19a5$var$isNonNullObject(value) && !$5cbac2c2bd2e19a5$var$isSpecial(value);
};
function $5cbac2c2bd2e19a5$var$isNonNullObject(value) {
    return !!value && typeof value === "object";
}
function $5cbac2c2bd2e19a5$var$isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === "[object RegExp]" || stringValue === "[object Date]" || $5cbac2c2bd2e19a5$var$isReactElement(value);
}
// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var $5cbac2c2bd2e19a5$var$canUseSymbol = typeof Symbol === "function" && Symbol.for;
var $5cbac2c2bd2e19a5$var$REACT_ELEMENT_TYPE = $5cbac2c2bd2e19a5$var$canUseSymbol ? Symbol.for("react.element") : 0xeac7;
function $5cbac2c2bd2e19a5$var$isReactElement(value) {
    return value.$$typeof === $5cbac2c2bd2e19a5$var$REACT_ELEMENT_TYPE;
}
function $5cbac2c2bd2e19a5$var$emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function $5cbac2c2bd2e19a5$var$cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? $5cbac2c2bd2e19a5$var$deepmerge($5cbac2c2bd2e19a5$var$emptyTarget(value), value, options) : value;
}
function $5cbac2c2bd2e19a5$var$defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return $5cbac2c2bd2e19a5$var$cloneUnlessOtherwiseSpecified(element, options);
    });
}
function $5cbac2c2bd2e19a5$var$getMergeFunction(key, options) {
    if (!options.customMerge) return $5cbac2c2bd2e19a5$var$deepmerge;
    var customMerge = options.customMerge(key);
    return typeof customMerge === "function" ? customMerge : $5cbac2c2bd2e19a5$var$deepmerge;
}
function $5cbac2c2bd2e19a5$var$getEnumerableOwnPropertySymbols(target) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function(symbol) {
        return Object.propertyIsEnumerable.call(target, symbol);
    }) : [];
}
function $5cbac2c2bd2e19a5$var$getKeys(target) {
    return Object.keys(target).concat($5cbac2c2bd2e19a5$var$getEnumerableOwnPropertySymbols(target));
}
function $5cbac2c2bd2e19a5$var$propertyIsOnObject(object, property) {
    try {
        return property in object;
    } catch (_) {
        return false;
    }
}
// Protects from prototype poisoning and unexpected merging up the prototype chain.
function $5cbac2c2bd2e19a5$var$propertyIsUnsafe(target, key) {
    return $5cbac2c2bd2e19a5$var$propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
     && !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
     && Object.propertyIsEnumerable.call(target, key) // and also unsafe if they're nonenumerable.
    );
}
function $5cbac2c2bd2e19a5$var$mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) $5cbac2c2bd2e19a5$var$getKeys(target).forEach(function(key) {
        destination[key] = $5cbac2c2bd2e19a5$var$cloneUnlessOtherwiseSpecified(target[key], options);
    });
    $5cbac2c2bd2e19a5$var$getKeys(source).forEach(function(key) {
        if ($5cbac2c2bd2e19a5$var$propertyIsUnsafe(target, key)) return;
        if ($5cbac2c2bd2e19a5$var$propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) destination[key] = $5cbac2c2bd2e19a5$var$getMergeFunction(key, options)(target[key], source[key], options);
        else destination[key] = $5cbac2c2bd2e19a5$var$cloneUnlessOtherwiseSpecified(source[key], options);
    });
    return destination;
}
function $5cbac2c2bd2e19a5$var$deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || $5cbac2c2bd2e19a5$var$defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || $5cbac2c2bd2e19a5$var$isMergeableObject;
    // cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
    // implementations can use it. The caller may not replace it.
    options.cloneUnlessOtherwiseSpecified = $5cbac2c2bd2e19a5$var$cloneUnlessOtherwiseSpecified;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return $5cbac2c2bd2e19a5$var$cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return $5cbac2c2bd2e19a5$var$mergeObject(target, source, options);
}
$5cbac2c2bd2e19a5$var$deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) throw new Error("first argument should be an array");
    return array.reduce(function(prev, next) {
        return $5cbac2c2bd2e19a5$var$deepmerge(prev, next, options);
    }, {});
};
var $5cbac2c2bd2e19a5$var$deepmerge_1 = $5cbac2c2bd2e19a5$var$deepmerge;
$5cbac2c2bd2e19a5$exports = $5cbac2c2bd2e19a5$var$deepmerge_1;


var $247239ca062bd0d8$exports = {};
/**
 * Srcset Parser
 *
 * By Alex Bell |  MIT License
 *
 * JS Parser for the string value that appears in markup <img srcset="here">
 *
 * @returns Array [{url: _, d: _, w: _, h:_}, ...]
 *
 * Based super duper closely on the reference algorithm at:
 * https://html.spec.whatwg.org/multipage/embedded-content.html#parse-a-srcset-attribute
 *
 * Most comments are copied in directly from the spec
 * (except for comments in parens).
 */ (function(root, factory) {
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([], factory);
    else if (0, $247239ca062bd0d8$exports) // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    $247239ca062bd0d8$exports = factory();
    else // Browser globals (root is window)
    root.parseSrcset = factory();
})($247239ca062bd0d8$exports, function() {
    // 1. Let input be the value passed to this algorithm.
    return function(input) {
        // UTILITY FUNCTIONS
        // Manual is faster than RegEx
        // http://bjorn.tipling.com/state-and-regular-expressions-in-javascript
        // http://jsperf.com/whitespace-character/5
        function isSpace(c) {
            return c === " " || // space
            c === "	" || // horizontal tab
            c === "\n" || // new line
            c === "\f" || // form feed
            c === "\r"; // carriage return
        }
        function collectCharacters(regEx) {
            var chars, match = regEx.exec(input.substring(pos));
            if (match) {
                chars = match[0];
                pos += chars.length;
                return chars;
            }
        }
        var inputLength = input.length, // (Don't use \s, to avoid matching non-breaking space)
        regexLeadingSpaces = /^[ \t\n\r\u000c]+/, regexLeadingCommasOrSpaces = /^[, \t\n\r\u000c]+/, regexLeadingNotSpaces = /^[^ \t\n\r\u000c]+/, regexTrailingCommas = /[,]+$/, regexNonNegativeInteger = /^\d+$/, // ( Positive or negative or unsigned integers or decimals, without or without exponents.
        // Must include at least one digit.
        // According to spec tests any decimal point must be followed by a digit.
        // No leading plus sign is allowed.)
        // https://html.spec.whatwg.org/multipage/infrastructure.html#valid-floating-point-number
        regexFloatingPoint = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/, url, descriptors, currentDescriptor, state, c, // 2. Let position be a pointer into input, initially pointing at the start
        //    of the string.
        pos = 0, // 3. Let candidates be an initially empty source set.
        candidates = [];
        // 4. Splitting loop: Collect a sequence of characters that are space
        //    characters or U+002C COMMA characters. If any U+002C COMMA characters
        //    were collected, that is a parse error.
        while(true){
            collectCharacters(regexLeadingCommasOrSpaces);
            // 5. If position is past the end of input, return candidates and abort these steps.
            if (pos >= inputLength) return candidates; // (we're done, this is the sole return path)
            // 6. Collect a sequence of characters that are not space characters,
            //    and let that be url.
            url = collectCharacters(regexLeadingNotSpaces);
            // 7. Let descriptors be a new empty list.
            descriptors = [];
            // 8. If url ends with a U+002C COMMA character (,), follow these substeps:
            //		(1). Remove all trailing U+002C COMMA characters from url. If this removed
            //         more than one character, that is a parse error.
            if (url.slice(-1) === ",") {
                url = url.replace(regexTrailingCommas, "");
                // (Jump ahead to step 9 to skip tokenization and just push the candidate).
                parseDescriptors();
            //	Otherwise, follow these substeps:
            } else tokenize();
             // (close else of step 8)
        // 16. Return to the step labeled splitting loop.
        } // (Close of big while loop.)
        /**
		 * Tokenizes descriptor properties prior to parsing
		 * Returns undefined.
		 */ function tokenize() {
            // 8.1. Descriptor tokeniser: Skip whitespace
            collectCharacters(regexLeadingSpaces);
            // 8.2. Let current descriptor be the empty string.
            currentDescriptor = "";
            // 8.3. Let state be in descriptor.
            state = "in descriptor";
            while(true){
                // 8.4. Let c be the character at position.
                c = input.charAt(pos);
                //  Do the following depending on the value of state.
                //  For the purpose of this step, "EOF" is a special character representing
                //  that position is past the end of input.
                // In descriptor
                if (state === "in descriptor") {
                    // Do the following, depending on the value of c:
                    // Space character
                    // If current descriptor is not empty, append current descriptor to
                    // descriptors and let current descriptor be the empty string.
                    // Set state to after descriptor.
                    if (isSpace(c)) {
                        if (currentDescriptor) {
                            descriptors.push(currentDescriptor);
                            currentDescriptor = "";
                            state = "after descriptor";
                        }
                    } else if (c === ",") {
                        pos += 1;
                        if (currentDescriptor) descriptors.push(currentDescriptor);
                        parseDescriptors();
                        return;
                    // U+0028 LEFT PARENTHESIS (()
                    // Append c to current descriptor. Set state to in parens.
                    } else if (c === "(") {
                        currentDescriptor = currentDescriptor + c;
                        state = "in parens";
                    // EOF
                    // If current descriptor is not empty, append current descriptor to
                    // descriptors. Jump to the step labeled descriptor parser.
                    } else if (c === "") {
                        if (currentDescriptor) descriptors.push(currentDescriptor);
                        parseDescriptors();
                        return;
                    // Anything else
                    // Append c to current descriptor.
                    } else currentDescriptor = currentDescriptor + c;
                // (end "in descriptor"
                // In parens
                } else if (state === "in parens") {
                    // U+0029 RIGHT PARENTHESIS ())
                    // Append c to current descriptor. Set state to in descriptor.
                    if (c === ")") {
                        currentDescriptor = currentDescriptor + c;
                        state = "in descriptor";
                    // EOF
                    // Append current descriptor to descriptors. Jump to the step labeled
                    // descriptor parser.
                    } else if (c === "") {
                        descriptors.push(currentDescriptor);
                        parseDescriptors();
                        return;
                    // Anything else
                    // Append c to current descriptor.
                    } else currentDescriptor = currentDescriptor + c;
                // After descriptor
                } else if (state === "after descriptor") {
                    // Do the following, depending on the value of c:
                    // Space character: Stay in this state.
                    if (isSpace(c)) ;
                    else if (c === "") {
                        parseDescriptors();
                        return;
                    // Anything else
                    // Set state to in descriptor. Set position to the previous character in input.
                    } else {
                        state = "in descriptor";
                        pos -= 1;
                    }
                }
                // Advance position to the next character in input.
                pos += 1;
            // Repeat this step.
            } // (close while true loop)
        }
        /**
		 * Adds descriptor properties to a candidate, pushes to the candidates array
		 * @return undefined
		 */ // Declared outside of the while loop so that it's only created once.
        function parseDescriptors() {
            // 9. Descriptor parser: Let error be no.
            var pError = false, // 10. Let width be absent.
            // 11. Let density be absent.
            // 12. Let future-compat-h be absent. (We're implementing it now as h)
            w, d, h, i, candidate = {}, desc, lastChar, value, intVal, floatVal;
            // 13. For each descriptor in descriptors, run the appropriate set of steps
            // from the following list:
            for(i = 0; i < descriptors.length; i++){
                desc = descriptors[i];
                lastChar = desc[desc.length - 1];
                value = desc.substring(0, desc.length - 1);
                intVal = parseInt(value, 10);
                floatVal = parseFloat(value);
                // If the descriptor consists of a valid non-negative integer followed by
                // a U+0077 LATIN SMALL LETTER W character
                if (regexNonNegativeInteger.test(value) && lastChar === "w") {
                    // If width and density are not both absent, then let error be yes.
                    if (w || d) pError = true;
                    // Apply the rules for parsing non-negative integers to the descriptor.
                    // If the result is zero, let error be yes.
                    // Otherwise, let width be the result.
                    if (intVal === 0) pError = true;
                    else w = intVal;
                // If the descriptor consists of a valid floating-point number followed by
                // a U+0078 LATIN SMALL LETTER X character
                } else if (regexFloatingPoint.test(value) && lastChar === "x") {
                    // If width, density and future-compat-h are not all absent, then let error
                    // be yes.
                    if (w || d || h) pError = true;
                    // Apply the rules for parsing floating-point number values to the descriptor.
                    // If the result is less than zero, let error be yes. Otherwise, let density
                    // be the result.
                    if (floatVal < 0) pError = true;
                    else d = floatVal;
                // If the descriptor consists of a valid non-negative integer followed by
                // a U+0068 LATIN SMALL LETTER H character
                } else if (regexNonNegativeInteger.test(value) && lastChar === "h") {
                    // If height and density are not both absent, then let error be yes.
                    if (h || d) pError = true;
                    // Apply the rules for parsing non-negative integers to the descriptor.
                    // If the result is zero, let error be yes. Otherwise, let future-compat-h
                    // be the result.
                    if (intVal === 0) pError = true;
                    else h = intVal;
                // Anything else, Let error be yes.
                } else pError = true;
            } // (close step 13 for loop)
            // 15. If error is still no, then append a new image source to candidates whose
            // URL is url, associated with a width width if not absent and a pixel
            // density density if not absent. Otherwise, there is a parse error.
            if (!pError) {
                candidate.url = url;
                if (w) candidate.w = w;
                if (d) candidate.d = d;
                if (h) candidate.h = h;
                candidates.push(candidate);
            } else if (console && console.log) console.log("Invalid srcset descriptor found in '" + input + "' at '" + desc + "'.");
        } // (close parseDescriptors fn)
    };
});


var $9af66cd8f3989a70$exports = {};
"use strict";
var $9db5b2301a1fe865$exports = {};
"use strict";
var $077837afef8c72ce$exports = {};
"use strict";
var $70788577d80df9f2$exports = {};
"use strict";
var $ec13b6f08b41b54b$exports = {};
"use strict";
var $11b90bf6793089bc$exports = {};
"use strict";
var $6598c9645a06302d$exports = {};
var $6598c9645a06302d$var$x = String;
var $6598c9645a06302d$var$create = function() {
    return {
        isColorSupported: false,
        reset: $6598c9645a06302d$var$x,
        bold: $6598c9645a06302d$var$x,
        dim: $6598c9645a06302d$var$x,
        italic: $6598c9645a06302d$var$x,
        underline: $6598c9645a06302d$var$x,
        inverse: $6598c9645a06302d$var$x,
        hidden: $6598c9645a06302d$var$x,
        strikethrough: $6598c9645a06302d$var$x,
        black: $6598c9645a06302d$var$x,
        red: $6598c9645a06302d$var$x,
        green: $6598c9645a06302d$var$x,
        yellow: $6598c9645a06302d$var$x,
        blue: $6598c9645a06302d$var$x,
        magenta: $6598c9645a06302d$var$x,
        cyan: $6598c9645a06302d$var$x,
        white: $6598c9645a06302d$var$x,
        gray: $6598c9645a06302d$var$x,
        bgBlack: $6598c9645a06302d$var$x,
        bgRed: $6598c9645a06302d$var$x,
        bgGreen: $6598c9645a06302d$var$x,
        bgYellow: $6598c9645a06302d$var$x,
        bgBlue: $6598c9645a06302d$var$x,
        bgMagenta: $6598c9645a06302d$var$x,
        bgCyan: $6598c9645a06302d$var$x,
        bgWhite: $6598c9645a06302d$var$x,
        blackBright: $6598c9645a06302d$var$x,
        redBright: $6598c9645a06302d$var$x,
        greenBright: $6598c9645a06302d$var$x,
        yellowBright: $6598c9645a06302d$var$x,
        blueBright: $6598c9645a06302d$var$x,
        magentaBright: $6598c9645a06302d$var$x,
        cyanBright: $6598c9645a06302d$var$x,
        whiteBright: $6598c9645a06302d$var$x,
        bgBlackBright: $6598c9645a06302d$var$x,
        bgRedBright: $6598c9645a06302d$var$x,
        bgGreenBright: $6598c9645a06302d$var$x,
        bgYellowBright: $6598c9645a06302d$var$x,
        bgBlueBright: $6598c9645a06302d$var$x,
        bgMagentaBright: $6598c9645a06302d$var$x,
        bgCyanBright: $6598c9645a06302d$var$x,
        bgWhiteBright: $6598c9645a06302d$var$x
    };
};
$6598c9645a06302d$exports = $6598c9645a06302d$var$create();
$6598c9645a06302d$exports.createColors = $6598c9645a06302d$var$create;


var $4293c27bcfbce771$exports = {};
"use strict";


class $11b90bf6793089bc$var$CssSyntaxError extends Error {
    constructor(message, line, column, source, file, plugin){
        super(message);
        this.name = "CssSyntaxError";
        this.reason = message;
        if (file) this.file = file;
        if (source) this.source = source;
        if (plugin) this.plugin = plugin;
        if (typeof line !== "undefined" && typeof column !== "undefined") {
            if (typeof line === "number") {
                this.line = line;
                this.column = column;
            } else {
                this.line = line.line;
                this.column = line.column;
                this.endLine = column.line;
                this.endColumn = column.column;
            }
        }
        this.setMessage();
        if (Error.captureStackTrace) Error.captureStackTrace(this, $11b90bf6793089bc$var$CssSyntaxError);
    }
    setMessage() {
        this.message = this.plugin ? this.plugin + ": " : "";
        this.message += this.file ? this.file : "<css input>";
        if (typeof this.line !== "undefined") this.message += ":" + this.line + ":" + this.column;
        this.message += ": " + this.reason;
    }
    showSourceCode(color) {
        if (!this.source) return "";
        let css = this.source;
        if (color == null) color = $6598c9645a06302d$exports.isColorSupported;
        let aside = (text)=>text;
        let mark = (text)=>text;
        let highlight = (text)=>text;
        if (color) {
            let { bold: bold, gray: gray, red: red } = $6598c9645a06302d$exports.createColors(true);
            mark = (text)=>bold(red(text));
            aside = (text)=>gray(text);
            if ($4293c27bcfbce771$exports) highlight = (text)=>$4293c27bcfbce771$exports(text);
        }
        let lines = css.split(/\r?\n/);
        let start = Math.max(this.line - 3, 0);
        let end = Math.min(this.line + 2, lines.length);
        let maxWidth = String(end).length;
        return lines.slice(start, end).map((line, index)=>{
            let number = start + 1 + index;
            let gutter = " " + (" " + number).slice(-maxWidth) + " | ";
            if (number === this.line) {
                if (line.length > 160) {
                    let padding = 20;
                    let subLineStart = Math.max(0, this.column - padding);
                    let subLineEnd = Math.max(this.column + padding, this.endColumn + padding);
                    let subLine = line.slice(subLineStart, subLineEnd);
                    let spacing = aside(gutter.replace(/\d/g, " ")) + line.slice(0, Math.min(this.column - 1, padding - 1)).replace(/[^\t]/g, " ");
                    return mark(">") + aside(gutter) + highlight(subLine) + "\n " + spacing + mark("^");
                }
                let spacing = aside(gutter.replace(/\d/g, " ")) + line.slice(0, this.column - 1).replace(/[^\t]/g, " ");
                return mark(">") + aside(gutter) + highlight(line) + "\n " + spacing + mark("^");
            }
            return " " + aside(gutter) + highlight(line);
        }).join("\n");
    }
    toString() {
        let code = this.showSourceCode();
        if (code) code = "\n\n" + code + "\n";
        return this.name + ": " + this.message + code;
    }
}
$11b90bf6793089bc$exports = $11b90bf6793089bc$var$CssSyntaxError;
$11b90bf6793089bc$var$CssSyntaxError.default = $11b90bf6793089bc$var$CssSyntaxError;


var $dd1dce35c3d83d92$exports = {};
"use strict";
const $dd1dce35c3d83d92$var$DEFAULT_RAW = {
    after: "\n",
    beforeClose: "\n",
    beforeComment: "\n",
    beforeDecl: "\n",
    beforeOpen: " ",
    beforeRule: "\n",
    colon: ": ",
    commentLeft: " ",
    commentRight: " ",
    emptyBody: "",
    indent: "    ",
    semicolon: false
};
function $dd1dce35c3d83d92$var$capitalize(str) {
    return str[0].toUpperCase() + str.slice(1);
}
class $dd1dce35c3d83d92$var$Stringifier {
    constructor(builder){
        this.builder = builder;
    }
    atrule(node, semicolon) {
        let name = "@" + node.name;
        let params = node.params ? this.rawValue(node, "params") : "";
        if (typeof node.raws.afterName !== "undefined") name += node.raws.afterName;
        else if (params) name += " ";
        if (node.nodes) this.block(node, name + params);
        else {
            let end = (node.raws.between || "") + (semicolon ? ";" : "");
            this.builder(name + params + end, node);
        }
    }
    beforeAfter(node, detect) {
        let value;
        if (node.type === "decl") value = this.raw(node, null, "beforeDecl");
        else if (node.type === "comment") value = this.raw(node, null, "beforeComment");
        else if (detect === "before") value = this.raw(node, null, "beforeRule");
        else value = this.raw(node, null, "beforeClose");
        let buf = node.parent;
        let depth = 0;
        while(buf && buf.type !== "root"){
            depth += 1;
            buf = buf.parent;
        }
        if (value.includes("\n")) {
            let indent = this.raw(node, null, "indent");
            if (indent.length) for(let step = 0; step < depth; step++)value += indent;
        }
        return value;
    }
    block(node, start) {
        let between = this.raw(node, "between", "beforeOpen");
        this.builder(start + between + "{", node, "start");
        let after;
        if (node.nodes && node.nodes.length) {
            this.body(node);
            after = this.raw(node, "after");
        } else after = this.raw(node, "after", "emptyBody");
        if (after) this.builder(after);
        this.builder("}", node, "end");
    }
    body(node) {
        let last = node.nodes.length - 1;
        while(last > 0){
            if (node.nodes[last].type !== "comment") break;
            last -= 1;
        }
        let semicolon = this.raw(node, "semicolon");
        for(let i = 0; i < node.nodes.length; i++){
            let child = node.nodes[i];
            let before = this.raw(child, "before");
            if (before) this.builder(before);
            this.stringify(child, last !== i || semicolon);
        }
    }
    comment(node) {
        let left = this.raw(node, "left", "commentLeft");
        let right = this.raw(node, "right", "commentRight");
        this.builder("/*" + left + node.text + right + "*/", node);
    }
    decl(node, semicolon) {
        let between = this.raw(node, "between", "colon");
        let string = node.prop + between + this.rawValue(node, "value");
        if (node.important) string += node.raws.important || " !important";
        if (semicolon) string += ";";
        this.builder(string, node);
    }
    document(node) {
        this.body(node);
    }
    raw(node, own, detect) {
        let value;
        if (!detect) detect = own;
        // Already had
        if (own) {
            value = node.raws[own];
            if (typeof value !== "undefined") return value;
        }
        let parent = node.parent;
        if (detect === "before") {
            // Hack for first rule in CSS
            if (!parent || parent.type === "root" && parent.first === node) return "";
            // `root` nodes in `document` should use only their own raws
            if (parent && parent.type === "document") return "";
        }
        // Floating child without parent
        if (!parent) return $dd1dce35c3d83d92$var$DEFAULT_RAW[detect];
        // Detect style by other nodes
        let root = node.root();
        if (!root.rawCache) root.rawCache = {};
        if (typeof root.rawCache[detect] !== "undefined") return root.rawCache[detect];
        if (detect === "before" || detect === "after") return this.beforeAfter(node, detect);
        else {
            let method = "raw" + $dd1dce35c3d83d92$var$capitalize(detect);
            if (this[method]) value = this[method](root, node);
            else root.walk((i)=>{
                value = i.raws[own];
                if (typeof value !== "undefined") return false;
            });
        }
        if (typeof value === "undefined") value = $dd1dce35c3d83d92$var$DEFAULT_RAW[detect];
        root.rawCache[detect] = value;
        return value;
    }
    rawBeforeClose(root) {
        let value;
        root.walk((i)=>{
            if (i.nodes && i.nodes.length > 0) {
                if (typeof i.raws.after !== "undefined") {
                    value = i.raws.after;
                    if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                    return false;
                }
            }
        });
        if (value) value = value.replace(/\S/g, "");
        return value;
    }
    rawBeforeComment(root, node) {
        let value;
        root.walkComments((i)=>{
            if (typeof i.raws.before !== "undefined") {
                value = i.raws.before;
                if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                return false;
            }
        });
        if (typeof value === "undefined") value = this.raw(node, null, "beforeDecl");
        else if (value) value = value.replace(/\S/g, "");
        return value;
    }
    rawBeforeDecl(root, node) {
        let value;
        root.walkDecls((i)=>{
            if (typeof i.raws.before !== "undefined") {
                value = i.raws.before;
                if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                return false;
            }
        });
        if (typeof value === "undefined") value = this.raw(node, null, "beforeRule");
        else if (value) value = value.replace(/\S/g, "");
        return value;
    }
    rawBeforeOpen(root) {
        let value;
        root.walk((i)=>{
            if (i.type !== "decl") {
                value = i.raws.between;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    }
    rawBeforeRule(root) {
        let value;
        root.walk((i)=>{
            if (i.nodes && (i.parent !== root || root.first !== i)) {
                if (typeof i.raws.before !== "undefined") {
                    value = i.raws.before;
                    if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                    return false;
                }
            }
        });
        if (value) value = value.replace(/\S/g, "");
        return value;
    }
    rawColon(root) {
        let value;
        root.walkDecls((i)=>{
            if (typeof i.raws.between !== "undefined") {
                value = i.raws.between.replace(/[^\s:]/g, "");
                return false;
            }
        });
        return value;
    }
    rawEmptyBody(root) {
        let value;
        root.walk((i)=>{
            if (i.nodes && i.nodes.length === 0) {
                value = i.raws.after;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    }
    rawIndent(root) {
        if (root.raws.indent) return root.raws.indent;
        let value;
        root.walk((i)=>{
            let p = i.parent;
            if (p && p !== root && p.parent && p.parent === root) {
                if (typeof i.raws.before !== "undefined") {
                    let parts = i.raws.before.split("\n");
                    value = parts[parts.length - 1];
                    value = value.replace(/\S/g, "");
                    return false;
                }
            }
        });
        return value;
    }
    rawSemicolon(root) {
        let value;
        root.walk((i)=>{
            if (i.nodes && i.nodes.length && i.last.type === "decl") {
                value = i.raws.semicolon;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    }
    rawValue(node, prop) {
        let value = node[prop];
        let raw = node.raws[prop];
        if (raw && raw.value === value) return raw.raw;
        return value;
    }
    root(node) {
        this.body(node);
        if (node.raws.after) this.builder(node.raws.after);
    }
    rule(node) {
        this.block(node, this.rawValue(node, "selector"));
        if (node.raws.ownSemicolon) this.builder(node.raws.ownSemicolon, node, "end");
    }
    stringify(node, semicolon) {
        /* c8 ignore start */ if (!this[node.type]) throw new Error("Unknown AST node type " + node.type + ". " + "Maybe you need to change PostCSS stringifier.");
        /* c8 ignore stop */ this[node.type](node, semicolon);
    }
}
$dd1dce35c3d83d92$exports = $dd1dce35c3d83d92$var$Stringifier;
$dd1dce35c3d83d92$var$Stringifier.default = $dd1dce35c3d83d92$var$Stringifier;


var $37a935064d256e88$exports = {};
"use strict";

function $37a935064d256e88$var$stringify(node, builder) {
    let str = new $dd1dce35c3d83d92$exports(builder);
    str.stringify(node);
}
$37a935064d256e88$exports = $37a935064d256e88$var$stringify;
$37a935064d256e88$var$stringify.default = $37a935064d256e88$var$stringify;


var $e499001c8f740c05$export$ae5e7911ce0728f9;
var $e499001c8f740c05$export$94fa0a6beb22f989;
"use strict";
$e499001c8f740c05$export$ae5e7911ce0728f9 = Symbol("isClean");
$e499001c8f740c05$export$94fa0a6beb22f989 = Symbol("my");


var $ec13b6f08b41b54b$require$isClean = $e499001c8f740c05$export$ae5e7911ce0728f9;
var $ec13b6f08b41b54b$require$my = $e499001c8f740c05$export$94fa0a6beb22f989;
function $ec13b6f08b41b54b$var$cloneNode(obj, parent) {
    let cloned = new obj.constructor();
    for(let i in obj){
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        if (i === "proxyCache") continue;
        let value = obj[i];
        let type = typeof value;
        if (i === "parent" && type === "object") {
            if (parent) cloned[i] = parent;
        } else if (i === "source") cloned[i] = value;
        else if (Array.isArray(value)) cloned[i] = value.map((j)=>$ec13b6f08b41b54b$var$cloneNode(j, cloned));
        else {
            if (type === "object" && value !== null) value = $ec13b6f08b41b54b$var$cloneNode(value);
            cloned[i] = value;
        }
    }
    return cloned;
}
class $ec13b6f08b41b54b$var$Node {
    constructor(defaults = {}){
        this.raws = {};
        this[$ec13b6f08b41b54b$require$isClean] = false;
        this[$ec13b6f08b41b54b$require$my] = true;
        for(let name in defaults)if (name === "nodes") {
            this.nodes = [];
            for (let node of defaults[name])if (typeof node.clone === "function") this.append(node.clone());
            else this.append(node);
        } else this[name] = defaults[name];
    }
    addToError(error) {
        error.postcssNode = this;
        if (error.stack && this.source && /\n\s{4}at /.test(error.stack)) {
            let s = this.source;
            error.stack = error.stack.replace(/\n\s{4}at /, `$&${s.input.from}:${s.start.line}:${s.start.column}$&`);
        }
        return error;
    }
    after(add) {
        this.parent.insertAfter(this, add);
        return this;
    }
    assign(overrides = {}) {
        for(let name in overrides)this[name] = overrides[name];
        return this;
    }
    before(add) {
        this.parent.insertBefore(this, add);
        return this;
    }
    cleanRaws(keepBetween) {
        delete this.raws.before;
        delete this.raws.after;
        if (!keepBetween) delete this.raws.between;
    }
    clone(overrides = {}) {
        let cloned = $ec13b6f08b41b54b$var$cloneNode(this);
        for(let name in overrides)cloned[name] = overrides[name];
        return cloned;
    }
    cloneAfter(overrides = {}) {
        let cloned = this.clone(overrides);
        this.parent.insertAfter(this, cloned);
        return cloned;
    }
    cloneBefore(overrides = {}) {
        let cloned = this.clone(overrides);
        this.parent.insertBefore(this, cloned);
        return cloned;
    }
    error(message, opts = {}) {
        if (this.source) {
            let { end: end, start: start } = this.rangeBy(opts);
            return this.source.input.error(message, {
                column: start.column,
                line: start.line
            }, {
                column: end.column,
                line: end.line
            }, opts);
        }
        return new $11b90bf6793089bc$exports(message);
    }
    getProxyProcessor() {
        return {
            get (node, prop) {
                if (prop === "proxyOf") return node;
                else if (prop === "root") return ()=>node.root().toProxy();
                else return node[prop];
            },
            set (node, prop, value) {
                if (node[prop] === value) return true;
                node[prop] = value;
                if (prop === "prop" || prop === "value" || prop === "name" || prop === "params" || prop === "important" || /* c8 ignore next */ prop === "text") node.markDirty();
                return true;
            }
        };
    }
    /* c8 ignore next 3 */ markClean() {
        this[$ec13b6f08b41b54b$require$isClean] = true;
    }
    markDirty() {
        if (this[$ec13b6f08b41b54b$require$isClean]) {
            this[$ec13b6f08b41b54b$require$isClean] = false;
            let next = this;
            while(next = next.parent)next[$ec13b6f08b41b54b$require$isClean] = false;
        }
    }
    next() {
        if (!this.parent) return undefined;
        let index = this.parent.index(this);
        return this.parent.nodes[index + 1];
    }
    positionBy(opts, stringRepresentation) {
        let pos = this.source.start;
        if (opts.index) pos = this.positionInside(opts.index, stringRepresentation);
        else if (opts.word) {
            stringRepresentation = this.toString();
            let index = stringRepresentation.indexOf(opts.word);
            if (index !== -1) pos = this.positionInside(index, stringRepresentation);
        }
        return pos;
    }
    positionInside(index, stringRepresentation) {
        let string = stringRepresentation || this.toString();
        let column = this.source.start.column;
        let line = this.source.start.line;
        for(let i = 0; i < index; i++)if (string[i] === "\n") {
            column = 1;
            line += 1;
        } else column += 1;
        return {
            column: column,
            line: line
        };
    }
    prev() {
        if (!this.parent) return undefined;
        let index = this.parent.index(this);
        return this.parent.nodes[index - 1];
    }
    rangeBy(opts) {
        let start = {
            column: this.source.start.column,
            line: this.source.start.line
        };
        let end = this.source.end ? {
            column: this.source.end.column + 1,
            line: this.source.end.line
        } : {
            column: start.column + 1,
            line: start.line
        };
        if (opts.word) {
            let stringRepresentation = this.toString();
            let index = stringRepresentation.indexOf(opts.word);
            if (index !== -1) {
                start = this.positionInside(index, stringRepresentation);
                end = this.positionInside(index + opts.word.length, stringRepresentation);
            }
        } else {
            if (opts.start) start = {
                column: opts.start.column,
                line: opts.start.line
            };
            else if (opts.index) start = this.positionInside(opts.index);
            if (opts.end) end = {
                column: opts.end.column,
                line: opts.end.line
            };
            else if (typeof opts.endIndex === "number") end = this.positionInside(opts.endIndex);
            else if (opts.index) end = this.positionInside(opts.index + 1);
        }
        if (end.line < start.line || end.line === start.line && end.column <= start.column) end = {
            column: start.column + 1,
            line: start.line
        };
        return {
            end: end,
            start: start
        };
    }
    raw(prop, defaultType) {
        let str = new $dd1dce35c3d83d92$exports();
        return str.raw(this, prop, defaultType);
    }
    remove() {
        if (this.parent) this.parent.removeChild(this);
        this.parent = undefined;
        return this;
    }
    replaceWith(...nodes) {
        if (this.parent) {
            let bookmark = this;
            let foundSelf = false;
            for (let node of nodes){
                if (node === this) foundSelf = true;
                else if (foundSelf) {
                    this.parent.insertAfter(bookmark, node);
                    bookmark = node;
                } else this.parent.insertBefore(bookmark, node);
            }
            if (!foundSelf) this.remove();
        }
        return this;
    }
    root() {
        let result = this;
        while(result.parent && result.parent.type !== "document")result = result.parent;
        return result;
    }
    toJSON(_, inputs) {
        let fixed = {};
        let emitInputs = inputs == null;
        inputs = inputs || new Map();
        let inputsNextIndex = 0;
        for(let name in this){
            if (!Object.prototype.hasOwnProperty.call(this, name)) continue;
            if (name === "parent" || name === "proxyCache") continue;
            let value = this[name];
            if (Array.isArray(value)) fixed[name] = value.map((i)=>{
                if (typeof i === "object" && i.toJSON) return i.toJSON(null, inputs);
                else return i;
            });
            else if (typeof value === "object" && value.toJSON) fixed[name] = value.toJSON(null, inputs);
            else if (name === "source") {
                let inputId = inputs.get(value.input);
                if (inputId == null) {
                    inputId = inputsNextIndex;
                    inputs.set(value.input, inputsNextIndex);
                    inputsNextIndex++;
                }
                fixed[name] = {
                    end: value.end,
                    inputId: inputId,
                    start: value.start
                };
            } else fixed[name] = value;
        }
        if (emitInputs) fixed.inputs = [
            ...inputs.keys()
        ].map((input)=>input.toJSON());
        return fixed;
    }
    toProxy() {
        if (!this.proxyCache) this.proxyCache = new Proxy(this, this.getProxyProcessor());
        return this.proxyCache;
    }
    toString(stringifier = $37a935064d256e88$exports) {
        if (stringifier.stringify) stringifier = stringifier.stringify;
        let result = "";
        stringifier(this, (i)=>{
            result += i;
        });
        return result;
    }
    warn(result, text, opts) {
        let data = {
            node: this
        };
        for(let i in opts)data[i] = opts[i];
        return result.warn(text, data);
    }
    get proxyOf() {
        return this;
    }
}
$ec13b6f08b41b54b$exports = $ec13b6f08b41b54b$var$Node;
$ec13b6f08b41b54b$var$Node.default = $ec13b6f08b41b54b$var$Node;


class $70788577d80df9f2$var$Comment extends $ec13b6f08b41b54b$exports {
    constructor(defaults){
        super(defaults);
        this.type = "comment";
    }
}
$70788577d80df9f2$exports = $70788577d80df9f2$var$Comment;
$70788577d80df9f2$var$Comment.default = $70788577d80df9f2$var$Comment;


var $ad246cc249f10bad$exports = {};
"use strict";

class $ad246cc249f10bad$var$Declaration extends $ec13b6f08b41b54b$exports {
    constructor(defaults){
        if (defaults && typeof defaults.value !== "undefined" && typeof defaults.value !== "string") defaults = {
            ...defaults,
            value: String(defaults.value)
        };
        super(defaults);
        this.type = "decl";
    }
    get variable() {
        return this.prop.startsWith("--") || this.prop[0] === "$";
    }
}
$ad246cc249f10bad$exports = $ad246cc249f10bad$var$Declaration;
$ad246cc249f10bad$var$Declaration.default = $ad246cc249f10bad$var$Declaration;




var $077837afef8c72ce$require$isClean = $e499001c8f740c05$export$ae5e7911ce0728f9;
var $077837afef8c72ce$require$my = $e499001c8f740c05$export$94fa0a6beb22f989;
let $077837afef8c72ce$var$AtRule, $077837afef8c72ce$var$parse, $077837afef8c72ce$var$Root, $077837afef8c72ce$var$Rule;
function $077837afef8c72ce$var$cleanSource(nodes) {
    return nodes.map((i)=>{
        if (i.nodes) i.nodes = $077837afef8c72ce$var$cleanSource(i.nodes);
        delete i.source;
        return i;
    });
}
function $077837afef8c72ce$var$markTreeDirty(node) {
    node[$077837afef8c72ce$require$isClean] = false;
    if (node.proxyOf.nodes) for (let i of node.proxyOf.nodes)$077837afef8c72ce$var$markTreeDirty(i);
}
class $077837afef8c72ce$var$Container extends $ec13b6f08b41b54b$exports {
    append(...children) {
        for (let child of children){
            let nodes = this.normalize(child, this.last);
            for (let node of nodes)this.proxyOf.nodes.push(node);
        }
        this.markDirty();
        return this;
    }
    cleanRaws(keepBetween) {
        super.cleanRaws(keepBetween);
        if (this.nodes) for (let node of this.nodes)node.cleanRaws(keepBetween);
    }
    each(callback) {
        if (!this.proxyOf.nodes) return undefined;
        let iterator = this.getIterator();
        let index, result;
        while(this.indexes[iterator] < this.proxyOf.nodes.length){
            index = this.indexes[iterator];
            result = callback(this.proxyOf.nodes[index], index);
            if (result === false) break;
            this.indexes[iterator] += 1;
        }
        delete this.indexes[iterator];
        return result;
    }
    every(condition) {
        return this.nodes.every(condition);
    }
    getIterator() {
        if (!this.lastEach) this.lastEach = 0;
        if (!this.indexes) this.indexes = {};
        this.lastEach += 1;
        let iterator = this.lastEach;
        this.indexes[iterator] = 0;
        return iterator;
    }
    getProxyProcessor() {
        return {
            get (node, prop) {
                if (prop === "proxyOf") return node;
                else if (!node[prop]) return node[prop];
                else if (prop === "each" || typeof prop === "string" && prop.startsWith("walk")) return (...args)=>{
                    return node[prop](...args.map((i)=>{
                        if (typeof i === "function") return (child, index)=>i(child.toProxy(), index);
                        else return i;
                    }));
                };
                else if (prop === "every" || prop === "some") return (cb)=>{
                    return node[prop]((child, ...other)=>cb(child.toProxy(), ...other));
                };
                else if (prop === "root") return ()=>node.root().toProxy();
                else if (prop === "nodes") return node.nodes.map((i)=>i.toProxy());
                else if (prop === "first" || prop === "last") return node[prop].toProxy();
                else return node[prop];
            },
            set (node, prop, value) {
                if (node[prop] === value) return true;
                node[prop] = value;
                if (prop === "name" || prop === "params" || prop === "selector") node.markDirty();
                return true;
            }
        };
    }
    index(child) {
        if (typeof child === "number") return child;
        if (child.proxyOf) child = child.proxyOf;
        return this.proxyOf.nodes.indexOf(child);
    }
    insertAfter(exist, add) {
        let existIndex = this.index(exist);
        let nodes = this.normalize(add, this.proxyOf.nodes[existIndex]).reverse();
        existIndex = this.index(exist);
        for (let node of nodes)this.proxyOf.nodes.splice(existIndex + 1, 0, node);
        let index;
        for(let id in this.indexes){
            index = this.indexes[id];
            if (existIndex < index) this.indexes[id] = index + nodes.length;
        }
        this.markDirty();
        return this;
    }
    insertBefore(exist, add) {
        let existIndex = this.index(exist);
        let type = existIndex === 0 ? "prepend" : false;
        let nodes = this.normalize(add, this.proxyOf.nodes[existIndex], type).reverse();
        existIndex = this.index(exist);
        for (let node of nodes)this.proxyOf.nodes.splice(existIndex, 0, node);
        let index;
        for(let id in this.indexes){
            index = this.indexes[id];
            if (existIndex <= index) this.indexes[id] = index + nodes.length;
        }
        this.markDirty();
        return this;
    }
    normalize(nodes, sample) {
        if (typeof nodes === "string") nodes = $077837afef8c72ce$var$cleanSource($077837afef8c72ce$var$parse(nodes).nodes);
        else if (typeof nodes === "undefined") nodes = [];
        else if (Array.isArray(nodes)) {
            nodes = nodes.slice(0);
            for (let i of nodes)if (i.parent) i.parent.removeChild(i, "ignore");
        } else if (nodes.type === "root" && this.type !== "document") {
            nodes = nodes.nodes.slice(0);
            for (let i of nodes)if (i.parent) i.parent.removeChild(i, "ignore");
        } else if (nodes.type) nodes = [
            nodes
        ];
        else if (nodes.prop) {
            if (typeof nodes.value === "undefined") throw new Error("Value field is missed in node creation");
            else if (typeof nodes.value !== "string") nodes.value = String(nodes.value);
            nodes = [
                new $ad246cc249f10bad$exports(nodes)
            ];
        } else if (nodes.selector || nodes.selectors) nodes = [
            new $077837afef8c72ce$var$Rule(nodes)
        ];
        else if (nodes.name) nodes = [
            new $077837afef8c72ce$var$AtRule(nodes)
        ];
        else if (nodes.text) nodes = [
            new $70788577d80df9f2$exports(nodes)
        ];
        else throw new Error("Unknown node type in node creation");
        let processed = nodes.map((i)=>{
            /* c8 ignore next */ if (!i[$077837afef8c72ce$require$my]) $077837afef8c72ce$var$Container.rebuild(i);
            i = i.proxyOf;
            if (i.parent) i.parent.removeChild(i);
            if (i[$077837afef8c72ce$require$isClean]) $077837afef8c72ce$var$markTreeDirty(i);
            if (!i.raws) i.raws = {};
            if (typeof i.raws.before === "undefined") {
                if (sample && typeof sample.raws.before !== "undefined") i.raws.before = sample.raws.before.replace(/\S/g, "");
            }
            i.parent = this.proxyOf;
            return i;
        });
        return processed;
    }
    prepend(...children) {
        children = children.reverse();
        for (let child of children){
            let nodes = this.normalize(child, this.first, "prepend").reverse();
            for (let node of nodes)this.proxyOf.nodes.unshift(node);
            for(let id in this.indexes)this.indexes[id] = this.indexes[id] + nodes.length;
        }
        this.markDirty();
        return this;
    }
    push(child) {
        child.parent = this;
        this.proxyOf.nodes.push(child);
        return this;
    }
    removeAll() {
        for (let node of this.proxyOf.nodes)node.parent = undefined;
        this.proxyOf.nodes = [];
        this.markDirty();
        return this;
    }
    removeChild(child) {
        child = this.index(child);
        this.proxyOf.nodes[child].parent = undefined;
        this.proxyOf.nodes.splice(child, 1);
        let index;
        for(let id in this.indexes){
            index = this.indexes[id];
            if (index >= child) this.indexes[id] = index - 1;
        }
        this.markDirty();
        return this;
    }
    replaceValues(pattern, opts, callback) {
        if (!callback) {
            callback = opts;
            opts = {};
        }
        this.walkDecls((decl)=>{
            if (opts.props && !opts.props.includes(decl.prop)) return;
            if (opts.fast && !decl.value.includes(opts.fast)) return;
            decl.value = decl.value.replace(pattern, callback);
        });
        this.markDirty();
        return this;
    }
    some(condition) {
        return this.nodes.some(condition);
    }
    walk(callback) {
        return this.each((child, i)=>{
            let result;
            try {
                result = callback(child, i);
            } catch (e) {
                throw child.addToError(e);
            }
            if (result !== false && child.walk) result = child.walk(callback);
            return result;
        });
    }
    walkAtRules(name, callback) {
        if (!callback) {
            callback = name;
            return this.walk((child, i)=>{
                if (child.type === "atrule") return callback(child, i);
            });
        }
        if (name instanceof RegExp) return this.walk((child, i)=>{
            if (child.type === "atrule" && name.test(child.name)) return callback(child, i);
        });
        return this.walk((child, i)=>{
            if (child.type === "atrule" && child.name === name) return callback(child, i);
        });
    }
    walkComments(callback) {
        return this.walk((child, i)=>{
            if (child.type === "comment") return callback(child, i);
        });
    }
    walkDecls(prop, callback) {
        if (!callback) {
            callback = prop;
            return this.walk((child, i)=>{
                if (child.type === "decl") return callback(child, i);
            });
        }
        if (prop instanceof RegExp) return this.walk((child, i)=>{
            if (child.type === "decl" && prop.test(child.prop)) return callback(child, i);
        });
        return this.walk((child, i)=>{
            if (child.type === "decl" && child.prop === prop) return callback(child, i);
        });
    }
    walkRules(selector, callback) {
        if (!callback) {
            callback = selector;
            return this.walk((child, i)=>{
                if (child.type === "rule") return callback(child, i);
            });
        }
        if (selector instanceof RegExp) return this.walk((child, i)=>{
            if (child.type === "rule" && selector.test(child.selector)) return callback(child, i);
        });
        return this.walk((child, i)=>{
            if (child.type === "rule" && child.selector === selector) return callback(child, i);
        });
    }
    get first() {
        if (!this.proxyOf.nodes) return undefined;
        return this.proxyOf.nodes[0];
    }
    get last() {
        if (!this.proxyOf.nodes) return undefined;
        return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
    }
}
$077837afef8c72ce$var$Container.registerParse = (dependant)=>{
    $077837afef8c72ce$var$parse = dependant;
};
$077837afef8c72ce$var$Container.registerRule = (dependant)=>{
    $077837afef8c72ce$var$Rule = dependant;
};
$077837afef8c72ce$var$Container.registerAtRule = (dependant)=>{
    $077837afef8c72ce$var$AtRule = dependant;
};
$077837afef8c72ce$var$Container.registerRoot = (dependant)=>{
    $077837afef8c72ce$var$Root = dependant;
};
$077837afef8c72ce$exports = $077837afef8c72ce$var$Container;
$077837afef8c72ce$var$Container.default = $077837afef8c72ce$var$Container;
/* c8 ignore start */ $077837afef8c72ce$var$Container.rebuild = (node)=>{
    if (node.type === "atrule") Object.setPrototypeOf(node, $077837afef8c72ce$var$AtRule.prototype);
    else if (node.type === "rule") Object.setPrototypeOf(node, $077837afef8c72ce$var$Rule.prototype);
    else if (node.type === "decl") Object.setPrototypeOf(node, $ad246cc249f10bad$exports.prototype);
    else if (node.type === "comment") Object.setPrototypeOf(node, $70788577d80df9f2$exports.prototype);
    else if (node.type === "root") Object.setPrototypeOf(node, $077837afef8c72ce$var$Root.prototype);
    node[$077837afef8c72ce$require$my] = true;
    if (node.nodes) node.nodes.forEach((child)=>{
        $077837afef8c72ce$var$Container.rebuild(child);
    });
} /* c8 ignore stop */ ;


class $9db5b2301a1fe865$var$AtRule extends $077837afef8c72ce$exports {
    constructor(defaults){
        super(defaults);
        this.type = "atrule";
    }
    append(...children) {
        if (!this.proxyOf.nodes) this.nodes = [];
        return super.append(...children);
    }
    prepend(...children) {
        if (!this.proxyOf.nodes) this.nodes = [];
        return super.prepend(...children);
    }
}
$9db5b2301a1fe865$exports = $9db5b2301a1fe865$var$AtRule;
$9db5b2301a1fe865$var$AtRule.default = $9db5b2301a1fe865$var$AtRule;
$077837afef8c72ce$exports.registerAtRule($9db5b2301a1fe865$var$AtRule);






var $cf27b66cf5c233cc$exports = {};
"use strict";

let $cf27b66cf5c233cc$var$LazyResult, $cf27b66cf5c233cc$var$Processor;
class $cf27b66cf5c233cc$var$Document extends $077837afef8c72ce$exports {
    constructor(defaults){
        // type needs to be passed to super, otherwise child roots won't be normalized correctly
        super({
            type: "document",
            ...defaults
        });
        if (!this.nodes) this.nodes = [];
    }
    toResult(opts = {}) {
        let lazy = new $cf27b66cf5c233cc$var$LazyResult(new $cf27b66cf5c233cc$var$Processor(), this, opts);
        return lazy.stringify();
    }
}
$cf27b66cf5c233cc$var$Document.registerLazyResult = (dependant)=>{
    $cf27b66cf5c233cc$var$LazyResult = dependant;
};
$cf27b66cf5c233cc$var$Document.registerProcessor = (dependant)=>{
    $cf27b66cf5c233cc$var$Processor = dependant;
};
$cf27b66cf5c233cc$exports = $cf27b66cf5c233cc$var$Document;
$cf27b66cf5c233cc$var$Document.default = $cf27b66cf5c233cc$var$Document;


var $3a4e8172d018cea5$exports = {};
"use strict";



var $adcb8c4bd8e49310$exports = {};
"use strict";
let $80f01919ebf1d788$var$urlAlphabet = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
let $80f01919ebf1d788$export$62e99e5c9f473d7f = (alphabet, defaultSize = 21)=>{
    return (size = defaultSize)=>{
        let id = "";
        let i = size;
        while(i--)id += alphabet[Math.random() * alphabet.length | 0];
        return id;
    };
};
let $80f01919ebf1d788$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $80f01919ebf1d788$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};


var $adcb8c4bd8e49310$require$nanoid = $80f01919ebf1d788$export$ac4959f4f1338dfc;

var $adcb8c4bd8e49310$require$isAbsolute = $4293c27bcfbce771$exports.isAbsolute;
var $adcb8c4bd8e49310$require$resolve = $4293c27bcfbce771$exports.resolve;

var $adcb8c4bd8e49310$require$SourceMapConsumer = $4293c27bcfbce771$exports.SourceMapConsumer;
var $adcb8c4bd8e49310$require$SourceMapGenerator = $4293c27bcfbce771$exports.SourceMapGenerator;

var $adcb8c4bd8e49310$require$fileURLToPath = $4293c27bcfbce771$exports.fileURLToPath;
var $adcb8c4bd8e49310$require$pathToFileURL = $4293c27bcfbce771$exports.pathToFileURL;

var $2d4c41abbc04486f$exports = {};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $d4ecdbf520e63dca$export$a143d493d941bafc;
var $d4ecdbf520e63dca$export$e4cf37d7f6fb9e0a;
var $d4ecdbf520e63dca$export$f99ded8fe4b79145;
var $d4ecdbf520e63dca$export$599f31c3813fae4d;
"use strict";
var $034686670a8a195b$export$a48f0734ac7c2329;
var $034686670a8a195b$export$d622b2ad8d90c771;
var $034686670a8a195b$export$6100ba28696e12de;
"use strict";
$034686670a8a195b$export$a48f0734ac7c2329 = $034686670a8a195b$var$byteLength;
$034686670a8a195b$export$d622b2ad8d90c771 = $034686670a8a195b$var$toByteArray;
$034686670a8a195b$export$6100ba28696e12de = $034686670a8a195b$var$fromByteArray;
var $034686670a8a195b$var$lookup = [];
var $034686670a8a195b$var$revLookup = [];
var $034686670a8a195b$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $034686670a8a195b$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $034686670a8a195b$var$i = 0, $034686670a8a195b$var$len = $034686670a8a195b$var$code.length; $034686670a8a195b$var$i < $034686670a8a195b$var$len; ++$034686670a8a195b$var$i){
    $034686670a8a195b$var$lookup[$034686670a8a195b$var$i] = $034686670a8a195b$var$code[$034686670a8a195b$var$i];
    $034686670a8a195b$var$revLookup[$034686670a8a195b$var$code.charCodeAt($034686670a8a195b$var$i)] = $034686670a8a195b$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$034686670a8a195b$var$revLookup["-".charCodeAt(0)] = 62;
$034686670a8a195b$var$revLookup["_".charCodeAt(0)] = 63;
function $034686670a8a195b$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $034686670a8a195b$var$byteLength(b64) {
    var lens = $034686670a8a195b$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $034686670a8a195b$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $034686670a8a195b$var$toByteArray(b64) {
    var tmp;
    var lens = $034686670a8a195b$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $034686670a8a195b$var$Arr($034686670a8a195b$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $034686670a8a195b$var$revLookup[b64.charCodeAt(i)] << 18 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $034686670a8a195b$var$revLookup[b64.charCodeAt(i)] << 2 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $034686670a8a195b$var$revLookup[b64.charCodeAt(i)] << 10 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $034686670a8a195b$var$tripletToBase64(num) {
    return $034686670a8a195b$var$lookup[num >> 18 & 0x3F] + $034686670a8a195b$var$lookup[num >> 12 & 0x3F] + $034686670a8a195b$var$lookup[num >> 6 & 0x3F] + $034686670a8a195b$var$lookup[num & 0x3F];
}
function $034686670a8a195b$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($034686670a8a195b$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $034686670a8a195b$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($034686670a8a195b$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($034686670a8a195b$var$lookup[tmp >> 2] + $034686670a8a195b$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($034686670a8a195b$var$lookup[tmp >> 10] + $034686670a8a195b$var$lookup[tmp >> 4 & 0x3F] + $034686670a8a195b$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $454af19f7384844b$export$aafa59e2e03f2942;
var $454af19f7384844b$export$68d8715fc104d294;
$454af19f7384844b$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$454af19f7384844b$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $d4ecdbf520e63dca$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$d4ecdbf520e63dca$export$a143d493d941bafc = $d4ecdbf520e63dca$var$Buffer;
$d4ecdbf520e63dca$export$e4cf37d7f6fb9e0a = $d4ecdbf520e63dca$var$SlowBuffer;
$d4ecdbf520e63dca$export$f99ded8fe4b79145 = 50;
const $d4ecdbf520e63dca$var$K_MAX_LENGTH = 0x7fffffff;
$d4ecdbf520e63dca$export$599f31c3813fae4d = $d4ecdbf520e63dca$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $d4ecdbf520e63dca$var$Buffer.TYPED_ARRAY_SUPPORT = $d4ecdbf520e63dca$var$typedArraySupport();
if (!$d4ecdbf520e63dca$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $d4ecdbf520e63dca$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($d4ecdbf520e63dca$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($d4ecdbf520e63dca$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $d4ecdbf520e63dca$var$createBuffer(length) {
    if (length > $d4ecdbf520e63dca$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $d4ecdbf520e63dca$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $d4ecdbf520e63dca$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $d4ecdbf520e63dca$var$allocUnsafe(arg);
    }
    return $d4ecdbf520e63dca$var$from(arg, encodingOrOffset, length);
}
$d4ecdbf520e63dca$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $d4ecdbf520e63dca$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $d4ecdbf520e63dca$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $d4ecdbf520e63dca$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($d4ecdbf520e63dca$var$isInstance(value, ArrayBuffer) || value && $d4ecdbf520e63dca$var$isInstance(value.buffer, ArrayBuffer)) return $d4ecdbf520e63dca$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($d4ecdbf520e63dca$var$isInstance(value, SharedArrayBuffer) || value && $d4ecdbf520e63dca$var$isInstance(value.buffer, SharedArrayBuffer))) return $d4ecdbf520e63dca$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $d4ecdbf520e63dca$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $d4ecdbf520e63dca$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $d4ecdbf520e63dca$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $d4ecdbf520e63dca$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $d4ecdbf520e63dca$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($d4ecdbf520e63dca$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($d4ecdbf520e63dca$var$Buffer, Uint8Array);
function $d4ecdbf520e63dca$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $d4ecdbf520e63dca$var$alloc(size, fill, encoding) {
    $d4ecdbf520e63dca$var$assertSize(size);
    if (size <= 0) return $d4ecdbf520e63dca$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $d4ecdbf520e63dca$var$createBuffer(size).fill(fill, encoding) : $d4ecdbf520e63dca$var$createBuffer(size).fill(fill);
    return $d4ecdbf520e63dca$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $d4ecdbf520e63dca$var$Buffer.alloc = function(size, fill, encoding) {
    return $d4ecdbf520e63dca$var$alloc(size, fill, encoding);
};
function $d4ecdbf520e63dca$var$allocUnsafe(size) {
    $d4ecdbf520e63dca$var$assertSize(size);
    return $d4ecdbf520e63dca$var$createBuffer(size < 0 ? 0 : $d4ecdbf520e63dca$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $d4ecdbf520e63dca$var$Buffer.allocUnsafe = function(size) {
    return $d4ecdbf520e63dca$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $d4ecdbf520e63dca$var$Buffer.allocUnsafeSlow = function(size) {
    return $d4ecdbf520e63dca$var$allocUnsafe(size);
};
function $d4ecdbf520e63dca$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$d4ecdbf520e63dca$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $d4ecdbf520e63dca$var$byteLength(string, encoding) | 0;
    let buf = $d4ecdbf520e63dca$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $d4ecdbf520e63dca$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $d4ecdbf520e63dca$var$checked(array.length) | 0;
    const buf = $d4ecdbf520e63dca$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $d4ecdbf520e63dca$var$fromArrayView(arrayView) {
    if ($d4ecdbf520e63dca$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $d4ecdbf520e63dca$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $d4ecdbf520e63dca$var$fromArrayLike(arrayView);
}
function $d4ecdbf520e63dca$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $d4ecdbf520e63dca$var$Buffer.prototype);
    return buf;
}
function $d4ecdbf520e63dca$var$fromObject(obj) {
    if ($d4ecdbf520e63dca$var$Buffer.isBuffer(obj)) {
        const len = $d4ecdbf520e63dca$var$checked(obj.length) | 0;
        const buf = $d4ecdbf520e63dca$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $d4ecdbf520e63dca$var$numberIsNaN(obj.length)) return $d4ecdbf520e63dca$var$createBuffer(0);
        return $d4ecdbf520e63dca$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $d4ecdbf520e63dca$var$fromArrayLike(obj.data);
}
function $d4ecdbf520e63dca$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $d4ecdbf520e63dca$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $d4ecdbf520e63dca$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $d4ecdbf520e63dca$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $d4ecdbf520e63dca$var$Buffer.alloc(+length);
}
$d4ecdbf520e63dca$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $d4ecdbf520e63dca$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$d4ecdbf520e63dca$var$Buffer.compare = function compare(a, b) {
    if ($d4ecdbf520e63dca$var$isInstance(a, Uint8Array)) a = $d4ecdbf520e63dca$var$Buffer.from(a, a.offset, a.byteLength);
    if ($d4ecdbf520e63dca$var$isInstance(b, Uint8Array)) b = $d4ecdbf520e63dca$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(a) || !$d4ecdbf520e63dca$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$d4ecdbf520e63dca$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$d4ecdbf520e63dca$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $d4ecdbf520e63dca$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $d4ecdbf520e63dca$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($d4ecdbf520e63dca$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(buf)) buf = $d4ecdbf520e63dca$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $d4ecdbf520e63dca$var$byteLength(string, encoding) {
    if ($d4ecdbf520e63dca$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $d4ecdbf520e63dca$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $d4ecdbf520e63dca$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $d4ecdbf520e63dca$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $d4ecdbf520e63dca$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$d4ecdbf520e63dca$var$Buffer.byteLength = $d4ecdbf520e63dca$var$byteLength;
function $d4ecdbf520e63dca$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $d4ecdbf520e63dca$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $d4ecdbf520e63dca$var$utf8Slice(this, start, end);
        case "ascii":
            return $d4ecdbf520e63dca$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $d4ecdbf520e63dca$var$latin1Slice(this, start, end);
        case "base64":
            return $d4ecdbf520e63dca$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $d4ecdbf520e63dca$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$d4ecdbf520e63dca$var$Buffer.prototype._isBuffer = true;
function $d4ecdbf520e63dca$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$d4ecdbf520e63dca$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$d4ecdbf520e63dca$var$swap(this, i, i + 1);
    return this;
};
$d4ecdbf520e63dca$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $d4ecdbf520e63dca$var$swap(this, i, i + 3);
        $d4ecdbf520e63dca$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$d4ecdbf520e63dca$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $d4ecdbf520e63dca$var$swap(this, i, i + 7);
        $d4ecdbf520e63dca$var$swap(this, i + 1, i + 6);
        $d4ecdbf520e63dca$var$swap(this, i + 2, i + 5);
        $d4ecdbf520e63dca$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$d4ecdbf520e63dca$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $d4ecdbf520e63dca$var$utf8Slice(this, 0, length);
    return $d4ecdbf520e63dca$var$slowToString.apply(this, arguments);
};
$d4ecdbf520e63dca$var$Buffer.prototype.toLocaleString = $d4ecdbf520e63dca$var$Buffer.prototype.toString;
$d4ecdbf520e63dca$var$Buffer.prototype.equals = function equals(b) {
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $d4ecdbf520e63dca$var$Buffer.compare(this, b) === 0;
};
$d4ecdbf520e63dca$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $d4ecdbf520e63dca$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($d4ecdbf520e63dca$var$customInspectSymbol) $d4ecdbf520e63dca$var$Buffer.prototype[$d4ecdbf520e63dca$var$customInspectSymbol] = $d4ecdbf520e63dca$var$Buffer.prototype.inspect;
$d4ecdbf520e63dca$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($d4ecdbf520e63dca$var$isInstance(target, Uint8Array)) target = $d4ecdbf520e63dca$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $d4ecdbf520e63dca$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($d4ecdbf520e63dca$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $d4ecdbf520e63dca$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($d4ecdbf520e63dca$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $d4ecdbf520e63dca$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $d4ecdbf520e63dca$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $d4ecdbf520e63dca$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$d4ecdbf520e63dca$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $d4ecdbf520e63dca$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$d4ecdbf520e63dca$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $d4ecdbf520e63dca$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $d4ecdbf520e63dca$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($d4ecdbf520e63dca$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $d4ecdbf520e63dca$var$utf8Write(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $d4ecdbf520e63dca$var$asciiWrite(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$asciiToBytes(string), buf, offset, length);
}
function $d4ecdbf520e63dca$var$base64Write(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$base64ToBytes(string), buf, offset, length);
}
function $d4ecdbf520e63dca$var$ucs2Write(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$d4ecdbf520e63dca$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $d4ecdbf520e63dca$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $d4ecdbf520e63dca$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $d4ecdbf520e63dca$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $d4ecdbf520e63dca$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $d4ecdbf520e63dca$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$d4ecdbf520e63dca$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $d4ecdbf520e63dca$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $034686670a8a195b$export$6100ba28696e12de(buf);
    else return $034686670a8a195b$export$6100ba28696e12de(buf.slice(start, end));
}
function $d4ecdbf520e63dca$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $d4ecdbf520e63dca$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $d4ecdbf520e63dca$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $d4ecdbf520e63dca$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $d4ecdbf520e63dca$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $d4ecdbf520e63dca$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $d4ecdbf520e63dca$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $d4ecdbf520e63dca$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $d4ecdbf520e63dca$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $d4ecdbf520e63dca$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $d4ecdbf520e63dca$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$d4ecdbf520e63dca$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $d4ecdbf520e63dca$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $d4ecdbf520e63dca$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$d4ecdbf520e63dca$var$Buffer.prototype.readUintLE = $d4ecdbf520e63dca$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUintBE = $d4ecdbf520e63dca$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint8 = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint16LE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint16BE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint32LE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint32BE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readBigUInt64LE = $d4ecdbf520e63dca$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $d4ecdbf520e63dca$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $d4ecdbf520e63dca$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$d4ecdbf520e63dca$var$Buffer.prototype.readBigUInt64BE = $d4ecdbf520e63dca$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $d4ecdbf520e63dca$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $d4ecdbf520e63dca$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$d4ecdbf520e63dca$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$d4ecdbf520e63dca$var$Buffer.prototype.readBigInt64LE = $d4ecdbf520e63dca$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $d4ecdbf520e63dca$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $d4ecdbf520e63dca$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$d4ecdbf520e63dca$var$Buffer.prototype.readBigInt64BE = $d4ecdbf520e63dca$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $d4ecdbf520e63dca$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $d4ecdbf520e63dca$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$d4ecdbf520e63dca$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return $454af19f7384844b$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return $454af19f7384844b$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 8, this.length);
    return $454af19f7384844b$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 8, this.length);
    return $454af19f7384844b$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $d4ecdbf520e63dca$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeUintLE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUintBE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint8 = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint16LE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint16BE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint32LE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint32BE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $d4ecdbf520e63dca$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $d4ecdbf520e63dca$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $d4ecdbf520e63dca$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $d4ecdbf520e63dca$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeBigUInt64LE = $d4ecdbf520e63dca$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $d4ecdbf520e63dca$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$d4ecdbf520e63dca$var$Buffer.prototype.writeBigUInt64BE = $d4ecdbf520e63dca$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $d4ecdbf520e63dca$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$d4ecdbf520e63dca$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeBigInt64LE = $d4ecdbf520e63dca$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $d4ecdbf520e63dca$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$d4ecdbf520e63dca$var$Buffer.prototype.writeBigInt64BE = $d4ecdbf520e63dca$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $d4ecdbf520e63dca$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $d4ecdbf520e63dca$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $d4ecdbf520e63dca$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $454af19f7384844b$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeFloat(this, value, offset, true, noAssert);
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeFloat(this, value, offset, false, noAssert);
};
function $d4ecdbf520e63dca$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $454af19f7384844b$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeDouble(this, value, offset, true, noAssert);
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$d4ecdbf520e63dca$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$d4ecdbf520e63dca$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$d4ecdbf520e63dca$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $d4ecdbf520e63dca$var$Buffer.isBuffer(val) ? val : $d4ecdbf520e63dca$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $d4ecdbf520e63dca$var$errors = {};
function $d4ecdbf520e63dca$var$E(sym, getMessage, Base) {
    $d4ecdbf520e63dca$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$d4ecdbf520e63dca$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$d4ecdbf520e63dca$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$d4ecdbf520e63dca$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $d4ecdbf520e63dca$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $d4ecdbf520e63dca$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $d4ecdbf520e63dca$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $d4ecdbf520e63dca$var$checkBounds(buf, offset, byteLength) {
    $d4ecdbf520e63dca$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $d4ecdbf520e63dca$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $d4ecdbf520e63dca$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $d4ecdbf520e63dca$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $d4ecdbf520e63dca$var$checkBounds(buf, offset, byteLength);
}
function $d4ecdbf520e63dca$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $d4ecdbf520e63dca$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $d4ecdbf520e63dca$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $d4ecdbf520e63dca$var$validateNumber(value, type);
        throw new $d4ecdbf520e63dca$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $d4ecdbf520e63dca$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $d4ecdbf520e63dca$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $d4ecdbf520e63dca$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $d4ecdbf520e63dca$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($d4ecdbf520e63dca$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $d4ecdbf520e63dca$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $d4ecdbf520e63dca$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $d4ecdbf520e63dca$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $d4ecdbf520e63dca$var$base64ToBytes(str) {
    return $034686670a8a195b$export$d622b2ad8d90c771($d4ecdbf520e63dca$var$base64clean(str));
}
function $d4ecdbf520e63dca$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $d4ecdbf520e63dca$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $d4ecdbf520e63dca$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $d4ecdbf520e63dca$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $d4ecdbf520e63dca$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $d4ecdbf520e63dca$var$BufferBigIntNotDefined : fn;
}
function $d4ecdbf520e63dca$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}


var $2d4c41abbc04486f$require$Buffer = $d4ecdbf520e63dca$export$a143d493d941bafc;
"use strict";

var $2d4c41abbc04486f$require$existsSync = $4293c27bcfbce771$exports.existsSync;
var $2d4c41abbc04486f$require$readFileSync = $4293c27bcfbce771$exports.readFileSync;

var $2d4c41abbc04486f$require$dirname = $4293c27bcfbce771$exports.dirname;
var $2d4c41abbc04486f$require$join = $4293c27bcfbce771$exports.join;

var $2d4c41abbc04486f$require$SourceMapConsumer = $4293c27bcfbce771$exports.SourceMapConsumer;
var $2d4c41abbc04486f$require$SourceMapGenerator = $4293c27bcfbce771$exports.SourceMapGenerator;
function $2d4c41abbc04486f$var$fromBase64(str) {
    if ($2d4c41abbc04486f$require$Buffer) return $2d4c41abbc04486f$require$Buffer.from(str, "base64").toString();
    else /* c8 ignore next 2 */ return window.atob(str);
}
class $2d4c41abbc04486f$var$PreviousMap {
    constructor(css, opts){
        if (opts.map === false) return;
        this.loadAnnotation(css);
        this.inline = this.startWith(this.annotation, "data:");
        let prev = opts.map ? opts.map.prev : undefined;
        let text = this.loadMap(opts.from, prev);
        if (!this.mapFile && opts.from) this.mapFile = opts.from;
        if (this.mapFile) this.root = $2d4c41abbc04486f$require$dirname(this.mapFile);
        if (text) this.text = text;
    }
    consumer() {
        if (!this.consumerCache) this.consumerCache = new $2d4c41abbc04486f$require$SourceMapConsumer(this.text);
        return this.consumerCache;
    }
    decodeInline(text) {
        let baseCharsetUri = /^data:application\/json;charset=utf-?8;base64,/;
        let baseUri = /^data:application\/json;base64,/;
        let charsetUri = /^data:application\/json;charset=utf-?8,/;
        let uri = /^data:application\/json,/;
        let uriMatch = text.match(charsetUri) || text.match(uri);
        if (uriMatch) return decodeURIComponent(text.substr(uriMatch[0].length));
        let baseUriMatch = text.match(baseCharsetUri) || text.match(baseUri);
        if (baseUriMatch) return $2d4c41abbc04486f$var$fromBase64(text.substr(baseUriMatch[0].length));
        let encoding = text.match(/data:application\/json;([^,]+),/)[1];
        throw new Error("Unsupported source map encoding " + encoding);
    }
    getAnnotationURL(sourceMapString) {
        return sourceMapString.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
    }
    isMap(map) {
        if (typeof map !== "object") return false;
        return typeof map.mappings === "string" || typeof map._mappings === "string" || Array.isArray(map.sections);
    }
    loadAnnotation(css) {
        let comments = css.match(/\/\*\s*# sourceMappingURL=/g);
        if (!comments) return;
        // sourceMappingURLs from comments, strings, etc.
        let start = css.lastIndexOf(comments.pop());
        let end = css.indexOf("*/", start);
        if (start > -1 && end > -1) // Locate the last sourceMappingURL to avoid pickin
        this.annotation = this.getAnnotationURL(css.substring(start, end));
    }
    loadFile(path) {
        this.root = $2d4c41abbc04486f$require$dirname(path);
        if ($2d4c41abbc04486f$require$existsSync(path)) {
            this.mapFile = path;
            return $2d4c41abbc04486f$require$readFileSync(path, "utf-8").toString().trim();
        }
    }
    loadMap(file, prev) {
        if (prev === false) return false;
        if (prev) {
            if (typeof prev === "string") return prev;
            else if (typeof prev === "function") {
                let prevPath = prev(file);
                if (prevPath) {
                    let map = this.loadFile(prevPath);
                    if (!map) throw new Error("Unable to load previous source map: " + prevPath.toString());
                    return map;
                }
            } else if (prev instanceof $2d4c41abbc04486f$require$SourceMapConsumer) return $2d4c41abbc04486f$require$SourceMapGenerator.fromSourceMap(prev).toString();
            else if (prev instanceof $2d4c41abbc04486f$require$SourceMapGenerator) return prev.toString();
            else if (this.isMap(prev)) return JSON.stringify(prev);
            else throw new Error("Unsupported previous source map format: " + prev.toString());
        } else if (this.inline) return this.decodeInline(this.annotation);
        else if (this.annotation) {
            let map = this.annotation;
            if (file) map = $2d4c41abbc04486f$require$join($2d4c41abbc04486f$require$dirname(file), map);
            return this.loadFile(map);
        }
    }
    startWith(string, start) {
        if (!string) return false;
        return string.substr(0, start.length) === start;
    }
    withContent() {
        return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
    }
}
$2d4c41abbc04486f$exports = $2d4c41abbc04486f$var$PreviousMap;
$2d4c41abbc04486f$var$PreviousMap.default = $2d4c41abbc04486f$var$PreviousMap;



let $adcb8c4bd8e49310$var$fromOffsetCache = Symbol("fromOffsetCache");
let $adcb8c4bd8e49310$var$sourceMapAvailable = Boolean($adcb8c4bd8e49310$require$SourceMapConsumer && $adcb8c4bd8e49310$require$SourceMapGenerator);
let $adcb8c4bd8e49310$var$pathAvailable = Boolean($adcb8c4bd8e49310$require$resolve && $adcb8c4bd8e49310$require$isAbsolute);
class $adcb8c4bd8e49310$var$Input {
    constructor(css, opts = {}){
        if (css === null || typeof css === "undefined" || typeof css === "object" && !css.toString) throw new Error(`PostCSS received ${css} instead of CSS string`);
        this.css = css.toString();
        if (this.css[0] === "\uFEFF" || this.css[0] === "\uFFFE") {
            this.hasBOM = true;
            this.css = this.css.slice(1);
        } else this.hasBOM = false;
        if (opts.from) {
            if (!$adcb8c4bd8e49310$var$pathAvailable || /^\w+:\/\//.test(opts.from) || $adcb8c4bd8e49310$require$isAbsolute(opts.from)) this.file = opts.from;
            else this.file = $adcb8c4bd8e49310$require$resolve(opts.from);
        }
        if ($adcb8c4bd8e49310$var$pathAvailable && $adcb8c4bd8e49310$var$sourceMapAvailable) {
            let map = new $2d4c41abbc04486f$exports(this.css, opts);
            if (map.text) {
                this.map = map;
                let file = map.consumer().file;
                if (!this.file && file) this.file = this.mapResolve(file);
            }
        }
        if (!this.file) this.id = "<input css " + $adcb8c4bd8e49310$require$nanoid(6) + ">";
        if (this.map) this.map.file = this.from;
    }
    error(message, line, column, opts = {}) {
        let endColumn, endLine, result;
        if (line && typeof line === "object") {
            let start = line;
            let end = column;
            if (typeof start.offset === "number") {
                let pos = this.fromOffset(start.offset);
                line = pos.line;
                column = pos.col;
            } else {
                line = start.line;
                column = start.column;
            }
            if (typeof end.offset === "number") {
                let pos = this.fromOffset(end.offset);
                endLine = pos.line;
                endColumn = pos.col;
            } else {
                endLine = end.line;
                endColumn = end.column;
            }
        } else if (!column) {
            let pos = this.fromOffset(line);
            line = pos.line;
            column = pos.col;
        }
        let origin = this.origin(line, column, endLine, endColumn);
        if (origin) result = new $11b90bf6793089bc$exports(message, origin.endLine === undefined ? origin.line : {
            column: origin.column,
            line: origin.line
        }, origin.endLine === undefined ? origin.column : {
            column: origin.endColumn,
            line: origin.endLine
        }, origin.source, origin.file, opts.plugin);
        else result = new $11b90bf6793089bc$exports(message, endLine === undefined ? line : {
            column: column,
            line: line
        }, endLine === undefined ? column : {
            column: endColumn,
            line: endLine
        }, this.css, this.file, opts.plugin);
        result.input = {
            column: column,
            endColumn: endColumn,
            endLine: endLine,
            line: line,
            source: this.css
        };
        if (this.file) {
            if ($adcb8c4bd8e49310$require$pathToFileURL) result.input.url = $adcb8c4bd8e49310$require$pathToFileURL(this.file).toString();
            result.input.file = this.file;
        }
        return result;
    }
    fromOffset(offset) {
        let lastLine, lineToIndex;
        if (!this[$adcb8c4bd8e49310$var$fromOffsetCache]) {
            let lines = this.css.split("\n");
            lineToIndex = new Array(lines.length);
            let prevIndex = 0;
            for(let i = 0, l = lines.length; i < l; i++){
                lineToIndex[i] = prevIndex;
                prevIndex += lines[i].length + 1;
            }
            this[$adcb8c4bd8e49310$var$fromOffsetCache] = lineToIndex;
        } else lineToIndex = this[$adcb8c4bd8e49310$var$fromOffsetCache];
        lastLine = lineToIndex[lineToIndex.length - 1];
        let min = 0;
        if (offset >= lastLine) min = lineToIndex.length - 1;
        else {
            let max = lineToIndex.length - 2;
            let mid;
            while(min < max){
                mid = min + (max - min >> 1);
                if (offset < lineToIndex[mid]) max = mid - 1;
                else if (offset >= lineToIndex[mid + 1]) min = mid + 1;
                else {
                    min = mid;
                    break;
                }
            }
        }
        return {
            col: offset - lineToIndex[min] + 1,
            line: min + 1
        };
    }
    mapResolve(file) {
        if (/^\w+:\/\//.test(file)) return file;
        return $adcb8c4bd8e49310$require$resolve(this.map.consumer().sourceRoot || this.map.root || ".", file);
    }
    origin(line, column, endLine, endColumn) {
        if (!this.map) return false;
        let consumer = this.map.consumer();
        let from = consumer.originalPositionFor({
            column: column,
            line: line
        });
        if (!from.source) return false;
        let to;
        if (typeof endLine === "number") to = consumer.originalPositionFor({
            column: endColumn,
            line: endLine
        });
        let fromUrl;
        if ($adcb8c4bd8e49310$require$isAbsolute(from.source)) fromUrl = $adcb8c4bd8e49310$require$pathToFileURL(from.source);
        else fromUrl = new URL(from.source, this.map.consumer().sourceRoot || $adcb8c4bd8e49310$require$pathToFileURL(this.map.mapFile));
        let result = {
            column: from.column,
            endColumn: to && to.column,
            endLine: to && to.line,
            line: from.line,
            url: fromUrl.toString()
        };
        if (fromUrl.protocol === "file:") {
            if ($adcb8c4bd8e49310$require$fileURLToPath) result.file = $adcb8c4bd8e49310$require$fileURLToPath(fromUrl);
            else /* c8 ignore next 2 */ throw new Error(`file: protocol is not available in this PostCSS build`);
        }
        let source = consumer.sourceContentFor(from.source);
        if (source) result.source = source;
        return result;
    }
    toJSON() {
        let json = {};
        for (let name of [
            "hasBOM",
            "css",
            "file",
            "id"
        ])if (this[name] != null) json[name] = this[name];
        if (this.map) {
            json.map = {
                ...this.map
            };
            if (json.map.consumerCache) json.map.consumerCache = undefined;
        }
        return json;
    }
    get from() {
        return this.file || this.id;
    }
}
$adcb8c4bd8e49310$exports = $adcb8c4bd8e49310$var$Input;
$adcb8c4bd8e49310$var$Input.default = $adcb8c4bd8e49310$var$Input;
if ($4293c27bcfbce771$exports && $4293c27bcfbce771$exports.registerInput) $4293c27bcfbce771$exports.registerInput($adcb8c4bd8e49310$var$Input);



var $8268821f68b0ec50$exports = {};
"use strict";

let $8268821f68b0ec50$var$LazyResult, $8268821f68b0ec50$var$Processor;
class $8268821f68b0ec50$var$Root extends $077837afef8c72ce$exports {
    constructor(defaults){
        super(defaults);
        this.type = "root";
        if (!this.nodes) this.nodes = [];
    }
    normalize(child, sample, type) {
        let nodes = super.normalize(child);
        if (sample) {
            if (type === "prepend") {
                if (this.nodes.length > 1) sample.raws.before = this.nodes[1].raws.before;
                else delete sample.raws.before;
            } else if (this.first !== sample) for (let node of nodes)node.raws.before = sample.raws.before;
        }
        return nodes;
    }
    removeChild(child, ignore) {
        let index = this.index(child);
        if (!ignore && index === 0 && this.nodes.length > 1) this.nodes[1].raws.before = this.nodes[index].raws.before;
        return super.removeChild(child);
    }
    toResult(opts = {}) {
        let lazy = new $8268821f68b0ec50$var$LazyResult(new $8268821f68b0ec50$var$Processor(), this, opts);
        return lazy.stringify();
    }
}
$8268821f68b0ec50$var$Root.registerLazyResult = (dependant)=>{
    $8268821f68b0ec50$var$LazyResult = dependant;
};
$8268821f68b0ec50$var$Root.registerProcessor = (dependant)=>{
    $8268821f68b0ec50$var$Processor = dependant;
};
$8268821f68b0ec50$exports = $8268821f68b0ec50$var$Root;
$8268821f68b0ec50$var$Root.default = $8268821f68b0ec50$var$Root;
$077837afef8c72ce$exports.registerRoot($8268821f68b0ec50$var$Root);


var $2416b279c131361a$exports = {};
"use strict";

var $5a9bb9fdfdb0262a$exports = {};
"use strict";
let $5a9bb9fdfdb0262a$var$list = {
    comma (string) {
        return $5a9bb9fdfdb0262a$var$list.split(string, [
            ","
        ], true);
    },
    space (string) {
        let spaces = [
            " ",
            "\n",
            "	"
        ];
        return $5a9bb9fdfdb0262a$var$list.split(string, spaces);
    },
    split (string, separators, last) {
        let array = [];
        let current = "";
        let split = false;
        let func = 0;
        let inQuote = false;
        let prevQuote = "";
        let escape = false;
        for (let letter of string){
            if (escape) escape = false;
            else if (letter === "\\") escape = true;
            else if (inQuote) {
                if (letter === prevQuote) inQuote = false;
            } else if (letter === '"' || letter === "'") {
                inQuote = true;
                prevQuote = letter;
            } else if (letter === "(") func += 1;
            else if (letter === ")") {
                if (func > 0) func -= 1;
            } else if (func === 0) {
                if (separators.includes(letter)) split = true;
            }
            if (split) {
                if (current !== "") array.push(current.trim());
                current = "";
                split = false;
            } else current += letter;
        }
        if (last || current !== "") array.push(current.trim());
        return array;
    }
};
$5a9bb9fdfdb0262a$exports = $5a9bb9fdfdb0262a$var$list;
$5a9bb9fdfdb0262a$var$list.default = $5a9bb9fdfdb0262a$var$list;


class $2416b279c131361a$var$Rule extends $077837afef8c72ce$exports {
    constructor(defaults){
        super(defaults);
        this.type = "rule";
        if (!this.nodes) this.nodes = [];
    }
    get selectors() {
        return $5a9bb9fdfdb0262a$exports.comma(this.selector);
    }
    set selectors(values) {
        let match = this.selector ? this.selector.match(/,\s*/) : null;
        let sep = match ? match[0] : "," + this.raw("between", "beforeOpen");
        this.selector = values.join(sep);
    }
}
$2416b279c131361a$exports = $2416b279c131361a$var$Rule;
$2416b279c131361a$var$Rule.default = $2416b279c131361a$var$Rule;
$077837afef8c72ce$exports.registerRule($2416b279c131361a$var$Rule);


function $3a4e8172d018cea5$var$fromJSON(json, inputs) {
    if (Array.isArray(json)) return json.map((n)=>$3a4e8172d018cea5$var$fromJSON(n));
    let { inputs: ownInputs, ...defaults } = json;
    if (ownInputs) {
        inputs = [];
        for (let input of ownInputs){
            let inputHydrated = {
                ...input,
                __proto__: $adcb8c4bd8e49310$exports.prototype
            };
            if (inputHydrated.map) inputHydrated.map = {
                ...inputHydrated.map,
                __proto__: $2d4c41abbc04486f$exports.prototype
            };
            inputs.push(inputHydrated);
        }
    }
    if (defaults.nodes) defaults.nodes = json.nodes.map((n)=>$3a4e8172d018cea5$var$fromJSON(n, inputs));
    if (defaults.source) {
        let { inputId: inputId, ...source } = defaults.source;
        defaults.source = source;
        if (inputId != null) defaults.source.input = inputs[inputId];
    }
    if (defaults.type === "root") return new $8268821f68b0ec50$exports(defaults);
    else if (defaults.type === "decl") return new $ad246cc249f10bad$exports(defaults);
    else if (defaults.type === "rule") return new $2416b279c131361a$exports(defaults);
    else if (defaults.type === "comment") return new $70788577d80df9f2$exports(defaults);
    else if (defaults.type === "atrule") return new $9db5b2301a1fe865$exports(defaults);
    else throw new Error("Unknown node type: " + json.type);
}
$3a4e8172d018cea5$exports = $3a4e8172d018cea5$var$fromJSON;
$3a4e8172d018cea5$var$fromJSON.default = $3a4e8172d018cea5$var$fromJSON;



var $b37c9102a1d65a3a$exports = {};
"use strict";


var $ad00c369e31031af$exports = {};

var $ad00c369e31031af$require$Buffer = $d4ecdbf520e63dca$export$a143d493d941bafc;
"use strict";

var $ad00c369e31031af$require$dirname = $4293c27bcfbce771$exports.dirname;
var $ad00c369e31031af$require$relative = $4293c27bcfbce771$exports.relative;
var $ad00c369e31031af$require$resolve = $4293c27bcfbce771$exports.resolve;
var $ad00c369e31031af$require$sep = $4293c27bcfbce771$exports.sep;

var $ad00c369e31031af$require$SourceMapConsumer = $4293c27bcfbce771$exports.SourceMapConsumer;
var $ad00c369e31031af$require$SourceMapGenerator = $4293c27bcfbce771$exports.SourceMapGenerator;

var $ad00c369e31031af$require$pathToFileURL = $4293c27bcfbce771$exports.pathToFileURL;

let $ad00c369e31031af$var$sourceMapAvailable = Boolean($ad00c369e31031af$require$SourceMapConsumer && $ad00c369e31031af$require$SourceMapGenerator);
let $ad00c369e31031af$var$pathAvailable = Boolean($ad00c369e31031af$require$dirname && $ad00c369e31031af$require$resolve && $ad00c369e31031af$require$relative && $ad00c369e31031af$require$sep);
class $ad00c369e31031af$var$MapGenerator {
    constructor(stringify, root, opts, cssString){
        this.stringify = stringify;
        this.mapOpts = opts.map || {};
        this.root = root;
        this.opts = opts;
        this.css = cssString;
        this.originalCSS = cssString;
        this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute;
        this.memoizedFileURLs = new Map();
        this.memoizedPaths = new Map();
        this.memoizedURLs = new Map();
    }
    addAnnotation() {
        let content;
        if (this.isInline()) content = "data:application/json;base64," + this.toBase64(this.map.toString());
        else if (typeof this.mapOpts.annotation === "string") content = this.mapOpts.annotation;
        else if (typeof this.mapOpts.annotation === "function") content = this.mapOpts.annotation(this.opts.to, this.root);
        else content = this.outputFile() + ".map";
        let eol = "\n";
        if (this.css.includes("\r\n")) eol = "\r\n";
        this.css += eol + "/*# sourceMappingURL=" + content + " */";
    }
    applyPrevMaps() {
        for (let prev of this.previous()){
            let from = this.toUrl(this.path(prev.file));
            let root = prev.root || $ad00c369e31031af$require$dirname(prev.file);
            let map;
            if (this.mapOpts.sourcesContent === false) {
                map = new $ad00c369e31031af$require$SourceMapConsumer(prev.text);
                if (map.sourcesContent) map.sourcesContent = null;
            } else map = prev.consumer();
            this.map.applySourceMap(map, from, this.toUrl(this.path(root)));
        }
    }
    clearAnnotation() {
        if (this.mapOpts.annotation === false) return;
        if (this.root) {
            let node;
            for(let i = this.root.nodes.length - 1; i >= 0; i--){
                node = this.root.nodes[i];
                if (node.type !== "comment") continue;
                if (node.text.startsWith("# sourceMappingURL=")) this.root.removeChild(i);
            }
        } else if (this.css) this.css = this.css.replace(/\n*\/\*#[\S\s]*?\*\/$/gm, "");
    }
    generate() {
        this.clearAnnotation();
        if ($ad00c369e31031af$var$pathAvailable && $ad00c369e31031af$var$sourceMapAvailable && this.isMap()) return this.generateMap();
        else {
            let result = "";
            this.stringify(this.root, (i)=>{
                result += i;
            });
            return [
                result
            ];
        }
    }
    generateMap() {
        if (this.root) this.generateString();
        else if (this.previous().length === 1) {
            let prev = this.previous()[0].consumer();
            prev.file = this.outputFile();
            this.map = $ad00c369e31031af$require$SourceMapGenerator.fromSourceMap(prev, {
                ignoreInvalidMapping: true
            });
        } else {
            this.map = new $ad00c369e31031af$require$SourceMapGenerator({
                file: this.outputFile(),
                ignoreInvalidMapping: true
            });
            this.map.addMapping({
                generated: {
                    column: 0,
                    line: 1
                },
                original: {
                    column: 0,
                    line: 1
                },
                source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
            });
        }
        if (this.isSourcesContent()) this.setSourcesContent();
        if (this.root && this.previous().length > 0) this.applyPrevMaps();
        if (this.isAnnotation()) this.addAnnotation();
        if (this.isInline()) return [
            this.css
        ];
        else return [
            this.css,
            this.map
        ];
    }
    generateString() {
        this.css = "";
        this.map = new $ad00c369e31031af$require$SourceMapGenerator({
            file: this.outputFile(),
            ignoreInvalidMapping: true
        });
        let line = 1;
        let column = 1;
        let noSource = "<no source>";
        let mapping = {
            generated: {
                column: 0,
                line: 0
            },
            original: {
                column: 0,
                line: 0
            },
            source: ""
        };
        let last, lines;
        this.stringify(this.root, (str, node, type)=>{
            this.css += str;
            if (node && type !== "end") {
                mapping.generated.line = line;
                mapping.generated.column = column - 1;
                if (node.source && node.source.start) {
                    mapping.source = this.sourcePath(node);
                    mapping.original.line = node.source.start.line;
                    mapping.original.column = node.source.start.column - 1;
                    this.map.addMapping(mapping);
                } else {
                    mapping.source = noSource;
                    mapping.original.line = 1;
                    mapping.original.column = 0;
                    this.map.addMapping(mapping);
                }
            }
            lines = str.match(/\n/g);
            if (lines) {
                line += lines.length;
                last = str.lastIndexOf("\n");
                column = str.length - last;
            } else column += str.length;
            if (node && type !== "start") {
                let p = node.parent || {
                    raws: {}
                };
                let childless = node.type === "decl" || node.type === "atrule" && !node.nodes;
                if (!childless || node !== p.last || p.raws.semicolon) {
                    if (node.source && node.source.end) {
                        mapping.source = this.sourcePath(node);
                        mapping.original.line = node.source.end.line;
                        mapping.original.column = node.source.end.column - 1;
                        mapping.generated.line = line;
                        mapping.generated.column = column - 2;
                        this.map.addMapping(mapping);
                    } else {
                        mapping.source = noSource;
                        mapping.original.line = 1;
                        mapping.original.column = 0;
                        mapping.generated.line = line;
                        mapping.generated.column = column - 1;
                        this.map.addMapping(mapping);
                    }
                }
            }
        });
    }
    isAnnotation() {
        if (this.isInline()) return true;
        if (typeof this.mapOpts.annotation !== "undefined") return this.mapOpts.annotation;
        if (this.previous().length) return this.previous().some((i)=>i.annotation);
        return true;
    }
    isInline() {
        if (typeof this.mapOpts.inline !== "undefined") return this.mapOpts.inline;
        let annotation = this.mapOpts.annotation;
        if (typeof annotation !== "undefined" && annotation !== true) return false;
        if (this.previous().length) return this.previous().some((i)=>i.inline);
        return true;
    }
    isMap() {
        if (typeof this.opts.map !== "undefined") return !!this.opts.map;
        return this.previous().length > 0;
    }
    isSourcesContent() {
        if (typeof this.mapOpts.sourcesContent !== "undefined") return this.mapOpts.sourcesContent;
        if (this.previous().length) return this.previous().some((i)=>i.withContent());
        return true;
    }
    outputFile() {
        if (this.opts.to) return this.path(this.opts.to);
        else if (this.opts.from) return this.path(this.opts.from);
        else return "to.css";
    }
    path(file) {
        if (this.mapOpts.absolute) return file;
        if (file.charCodeAt(0) === 60 /* `<` */ ) return file;
        if (/^\w+:\/\//.test(file)) return file;
        let cached = this.memoizedPaths.get(file);
        if (cached) return cached;
        let from = this.opts.to ? $ad00c369e31031af$require$dirname(this.opts.to) : ".";
        if (typeof this.mapOpts.annotation === "string") from = $ad00c369e31031af$require$dirname($ad00c369e31031af$require$resolve(from, this.mapOpts.annotation));
        let path = $ad00c369e31031af$require$relative(from, file);
        this.memoizedPaths.set(file, path);
        return path;
    }
    previous() {
        if (!this.previousMaps) {
            this.previousMaps = [];
            if (this.root) this.root.walk((node)=>{
                if (node.source && node.source.input.map) {
                    let map = node.source.input.map;
                    if (!this.previousMaps.includes(map)) this.previousMaps.push(map);
                }
            });
            else {
                let input = new $adcb8c4bd8e49310$exports(this.originalCSS, this.opts);
                if (input.map) this.previousMaps.push(input.map);
            }
        }
        return this.previousMaps;
    }
    setSourcesContent() {
        let already = {};
        if (this.root) this.root.walk((node)=>{
            if (node.source) {
                let from = node.source.input.from;
                if (from && !already[from]) {
                    already[from] = true;
                    let fromUrl = this.usesFileUrls ? this.toFileUrl(from) : this.toUrl(this.path(from));
                    this.map.setSourceContent(fromUrl, node.source.input.css);
                }
            }
        });
        else if (this.css) {
            let from = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
            this.map.setSourceContent(from, this.css);
        }
    }
    sourcePath(node) {
        if (this.mapOpts.from) return this.toUrl(this.mapOpts.from);
        else if (this.usesFileUrls) return this.toFileUrl(node.source.input.from);
        else return this.toUrl(this.path(node.source.input.from));
    }
    toBase64(str) {
        if ($ad00c369e31031af$require$Buffer) return $ad00c369e31031af$require$Buffer.from(str).toString("base64");
        else return window.btoa(unescape(encodeURIComponent(str)));
    }
    toFileUrl(path) {
        let cached = this.memoizedFileURLs.get(path);
        if (cached) return cached;
        if ($ad00c369e31031af$require$pathToFileURL) {
            let fileURL = $ad00c369e31031af$require$pathToFileURL(path).toString();
            this.memoizedFileURLs.set(path, fileURL);
            return fileURL;
        } else throw new Error("`map.absolute` option is not available in this PostCSS build");
    }
    toUrl(path) {
        let cached = this.memoizedURLs.get(path);
        if (cached) return cached;
        if ($ad00c369e31031af$require$sep === "\\") path = path.replace(/\\/g, "/");
        let url = encodeURI(path).replace(/[#?]/g, encodeURIComponent);
        this.memoizedURLs.set(path, url);
        return url;
    }
}
$ad00c369e31031af$exports = $ad00c369e31031af$var$MapGenerator;


var $418ab21aea8bc340$exports = {};
"use strict";


var $19499e11fc876a3e$exports = {};
"use strict";





var $0ad72a19bc8f2e53$exports = {};
"use strict";
const $0ad72a19bc8f2e53$var$SINGLE_QUOTE = "'".charCodeAt(0);
const $0ad72a19bc8f2e53$var$DOUBLE_QUOTE = '"'.charCodeAt(0);
const $0ad72a19bc8f2e53$var$BACKSLASH = "\\".charCodeAt(0);
const $0ad72a19bc8f2e53$var$SLASH = "/".charCodeAt(0);
const $0ad72a19bc8f2e53$var$NEWLINE = "\n".charCodeAt(0);
const $0ad72a19bc8f2e53$var$SPACE = " ".charCodeAt(0);
const $0ad72a19bc8f2e53$var$FEED = "\f".charCodeAt(0);
const $0ad72a19bc8f2e53$var$TAB = "	".charCodeAt(0);
const $0ad72a19bc8f2e53$var$CR = "\r".charCodeAt(0);
const $0ad72a19bc8f2e53$var$OPEN_SQUARE = "[".charCodeAt(0);
const $0ad72a19bc8f2e53$var$CLOSE_SQUARE = "]".charCodeAt(0);
const $0ad72a19bc8f2e53$var$OPEN_PARENTHESES = "(".charCodeAt(0);
const $0ad72a19bc8f2e53$var$CLOSE_PARENTHESES = ")".charCodeAt(0);
const $0ad72a19bc8f2e53$var$OPEN_CURLY = "{".charCodeAt(0);
const $0ad72a19bc8f2e53$var$CLOSE_CURLY = "}".charCodeAt(0);
const $0ad72a19bc8f2e53$var$SEMICOLON = ";".charCodeAt(0);
const $0ad72a19bc8f2e53$var$ASTERISK = "*".charCodeAt(0);
const $0ad72a19bc8f2e53$var$COLON = ":".charCodeAt(0);
const $0ad72a19bc8f2e53$var$AT = "@".charCodeAt(0);
const $0ad72a19bc8f2e53$var$RE_AT_END = /[\t\n\f\r "#'()/;[\\\]{}]/g;
const $0ad72a19bc8f2e53$var$RE_WORD_END = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g;
const $0ad72a19bc8f2e53$var$RE_BAD_BRACKET = /.[\r\n"'(/\\]/;
const $0ad72a19bc8f2e53$var$RE_HEX_ESCAPE = /[\da-f]/i;
$0ad72a19bc8f2e53$exports = function tokenizer(input, options = {}) {
    let css = input.css.valueOf();
    let ignore = options.ignoreErrors;
    let code, content, escape, next, quote;
    let currentToken, escaped, escapePos, n, prev;
    let length = css.length;
    let pos = 0;
    let buffer = [];
    let returned = [];
    function position() {
        return pos;
    }
    function unclosed(what) {
        throw input.error("Unclosed " + what, pos);
    }
    function endOfFile() {
        return returned.length === 0 && pos >= length;
    }
    function nextToken(opts) {
        if (returned.length) return returned.pop();
        if (pos >= length) return;
        let ignoreUnclosed = opts ? opts.ignoreUnclosed : false;
        code = css.charCodeAt(pos);
        switch(code){
            case $0ad72a19bc8f2e53$var$NEWLINE:
            case $0ad72a19bc8f2e53$var$SPACE:
            case $0ad72a19bc8f2e53$var$TAB:
            case $0ad72a19bc8f2e53$var$CR:
            case $0ad72a19bc8f2e53$var$FEED:
                next = pos;
                do {
                    next += 1;
                    code = css.charCodeAt(next);
                }while (code === $0ad72a19bc8f2e53$var$SPACE || code === $0ad72a19bc8f2e53$var$NEWLINE || code === $0ad72a19bc8f2e53$var$TAB || code === $0ad72a19bc8f2e53$var$CR || code === $0ad72a19bc8f2e53$var$FEED);
                currentToken = [
                    "space",
                    css.slice(pos, next)
                ];
                pos = next - 1;
                break;
            case $0ad72a19bc8f2e53$var$OPEN_SQUARE:
            case $0ad72a19bc8f2e53$var$CLOSE_SQUARE:
            case $0ad72a19bc8f2e53$var$OPEN_CURLY:
            case $0ad72a19bc8f2e53$var$CLOSE_CURLY:
            case $0ad72a19bc8f2e53$var$COLON:
            case $0ad72a19bc8f2e53$var$SEMICOLON:
            case $0ad72a19bc8f2e53$var$CLOSE_PARENTHESES:
                {
                    let controlChar = String.fromCharCode(code);
                    currentToken = [
                        controlChar,
                        controlChar,
                        pos
                    ];
                    break;
                }
            case $0ad72a19bc8f2e53$var$OPEN_PARENTHESES:
                prev = buffer.length ? buffer.pop()[1] : "";
                n = css.charCodeAt(pos + 1);
                if (prev === "url" && n !== $0ad72a19bc8f2e53$var$SINGLE_QUOTE && n !== $0ad72a19bc8f2e53$var$DOUBLE_QUOTE && n !== $0ad72a19bc8f2e53$var$SPACE && n !== $0ad72a19bc8f2e53$var$NEWLINE && n !== $0ad72a19bc8f2e53$var$TAB && n !== $0ad72a19bc8f2e53$var$FEED && n !== $0ad72a19bc8f2e53$var$CR) {
                    next = pos;
                    do {
                        escaped = false;
                        next = css.indexOf(")", next + 1);
                        if (next === -1) {
                            if (ignore || ignoreUnclosed) {
                                next = pos;
                                break;
                            } else unclosed("bracket");
                        }
                        escapePos = next;
                        while(css.charCodeAt(escapePos - 1) === $0ad72a19bc8f2e53$var$BACKSLASH){
                            escapePos -= 1;
                            escaped = !escaped;
                        }
                    }while (escaped);
                    currentToken = [
                        "brackets",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    pos = next;
                } else {
                    next = css.indexOf(")", pos + 1);
                    content = css.slice(pos, next + 1);
                    if (next === -1 || $0ad72a19bc8f2e53$var$RE_BAD_BRACKET.test(content)) currentToken = [
                        "(",
                        "(",
                        pos
                    ];
                    else {
                        currentToken = [
                            "brackets",
                            content,
                            pos,
                            next
                        ];
                        pos = next;
                    }
                }
                break;
            case $0ad72a19bc8f2e53$var$SINGLE_QUOTE:
            case $0ad72a19bc8f2e53$var$DOUBLE_QUOTE:
                quote = code === $0ad72a19bc8f2e53$var$SINGLE_QUOTE ? "'" : '"';
                next = pos;
                do {
                    escaped = false;
                    next = css.indexOf(quote, next + 1);
                    if (next === -1) {
                        if (ignore || ignoreUnclosed) {
                            next = pos + 1;
                            break;
                        } else unclosed("string");
                    }
                    escapePos = next;
                    while(css.charCodeAt(escapePos - 1) === $0ad72a19bc8f2e53$var$BACKSLASH){
                        escapePos -= 1;
                        escaped = !escaped;
                    }
                }while (escaped);
                currentToken = [
                    "string",
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            case $0ad72a19bc8f2e53$var$AT:
                $0ad72a19bc8f2e53$var$RE_AT_END.lastIndex = pos + 1;
                $0ad72a19bc8f2e53$var$RE_AT_END.test(css);
                if ($0ad72a19bc8f2e53$var$RE_AT_END.lastIndex === 0) next = css.length - 1;
                else next = $0ad72a19bc8f2e53$var$RE_AT_END.lastIndex - 2;
                currentToken = [
                    "at-word",
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            case $0ad72a19bc8f2e53$var$BACKSLASH:
                next = pos;
                escape = true;
                while(css.charCodeAt(next + 1) === $0ad72a19bc8f2e53$var$BACKSLASH){
                    next += 1;
                    escape = !escape;
                }
                code = css.charCodeAt(next + 1);
                if (escape && code !== $0ad72a19bc8f2e53$var$SLASH && code !== $0ad72a19bc8f2e53$var$SPACE && code !== $0ad72a19bc8f2e53$var$NEWLINE && code !== $0ad72a19bc8f2e53$var$TAB && code !== $0ad72a19bc8f2e53$var$CR && code !== $0ad72a19bc8f2e53$var$FEED) {
                    next += 1;
                    if ($0ad72a19bc8f2e53$var$RE_HEX_ESCAPE.test(css.charAt(next))) {
                        while($0ad72a19bc8f2e53$var$RE_HEX_ESCAPE.test(css.charAt(next + 1)))next += 1;
                        if (css.charCodeAt(next + 1) === $0ad72a19bc8f2e53$var$SPACE) next += 1;
                    }
                }
                currentToken = [
                    "word",
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            default:
                if (code === $0ad72a19bc8f2e53$var$SLASH && css.charCodeAt(pos + 1) === $0ad72a19bc8f2e53$var$ASTERISK) {
                    next = css.indexOf("*/", pos + 2) + 1;
                    if (next === 0) {
                        if (ignore || ignoreUnclosed) next = css.length;
                        else unclosed("comment");
                    }
                    currentToken = [
                        "comment",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    pos = next;
                } else {
                    $0ad72a19bc8f2e53$var$RE_WORD_END.lastIndex = pos + 1;
                    $0ad72a19bc8f2e53$var$RE_WORD_END.test(css);
                    if ($0ad72a19bc8f2e53$var$RE_WORD_END.lastIndex === 0) next = css.length - 1;
                    else next = $0ad72a19bc8f2e53$var$RE_WORD_END.lastIndex - 2;
                    currentToken = [
                        "word",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    buffer.push(currentToken);
                    pos = next;
                }
                break;
        }
        pos++;
        return currentToken;
    }
    function back(token) {
        returned.push(token);
    }
    return {
        back: back,
        endOfFile: endOfFile,
        nextToken: nextToken,
        position: position
    };
};


const $19499e11fc876a3e$var$SAFE_COMMENT_NEIGHBOR = {
    empty: true,
    space: true
};
function $19499e11fc876a3e$var$findLastWithPosition(tokens) {
    for(let i = tokens.length - 1; i >= 0; i--){
        let token = tokens[i];
        let pos = token[3] || token[2];
        if (pos) return pos;
    }
}
class $19499e11fc876a3e$var$Parser {
    constructor(input){
        this.input = input;
        this.root = new $8268821f68b0ec50$exports();
        this.current = this.root;
        this.spaces = "";
        this.semicolon = false;
        this.createTokenizer();
        this.root.source = {
            input: input,
            start: {
                column: 1,
                line: 1,
                offset: 0
            }
        };
    }
    atrule(token) {
        let node = new $9db5b2301a1fe865$exports();
        node.name = token[1].slice(1);
        if (node.name === "") this.unnamedAtrule(node, token);
        this.init(node, token[2]);
        let type;
        let prev;
        let shift;
        let last = false;
        let open = false;
        let params = [];
        let brackets = [];
        while(!this.tokenizer.endOfFile()){
            token = this.tokenizer.nextToken();
            type = token[0];
            if (type === "(" || type === "[") brackets.push(type === "(" ? ")" : "]");
            else if (type === "{" && brackets.length > 0) brackets.push("}");
            else if (type === brackets[brackets.length - 1]) brackets.pop();
            if (brackets.length === 0) {
                if (type === ";") {
                    node.source.end = this.getPosition(token[2]);
                    node.source.end.offset++;
                    this.semicolon = true;
                    break;
                } else if (type === "{") {
                    open = true;
                    break;
                } else if (type === "}") {
                    if (params.length > 0) {
                        shift = params.length - 1;
                        prev = params[shift];
                        while(prev && prev[0] === "space")prev = params[--shift];
                        if (prev) {
                            node.source.end = this.getPosition(prev[3] || prev[2]);
                            node.source.end.offset++;
                        }
                    }
                    this.end(token);
                    break;
                } else params.push(token);
            } else params.push(token);
            if (this.tokenizer.endOfFile()) {
                last = true;
                break;
            }
        }
        node.raws.between = this.spacesAndCommentsFromEnd(params);
        if (params.length) {
            node.raws.afterName = this.spacesAndCommentsFromStart(params);
            this.raw(node, "params", params);
            if (last) {
                token = params[params.length - 1];
                node.source.end = this.getPosition(token[3] || token[2]);
                node.source.end.offset++;
                this.spaces = node.raws.between;
                node.raws.between = "";
            }
        } else {
            node.raws.afterName = "";
            node.params = "";
        }
        if (open) {
            node.nodes = [];
            this.current = node;
        }
    }
    checkMissedSemicolon(tokens) {
        let colon = this.colon(tokens);
        if (colon === false) return;
        let founded = 0;
        let token;
        for(let j = colon - 1; j >= 0; j--){
            token = tokens[j];
            if (token[0] !== "space") {
                founded += 1;
                if (founded === 2) break;
            }
        }
        // If the token is a word, e.g. `!important`, `red` or any other valid property's value.
        // Then we need to return the colon after that word token. [3] is the "end" colon of that word.
        // And because we need it after that one we do +1 to get the next one.
        throw this.input.error("Missed semicolon", token[0] === "word" ? token[3] + 1 : token[2]);
    }
    colon(tokens) {
        let brackets = 0;
        let prev, token, type;
        for (let [i, element] of tokens.entries()){
            token = element;
            type = token[0];
            if (type === "(") brackets += 1;
            if (type === ")") brackets -= 1;
            if (brackets === 0 && type === ":") {
                if (!prev) this.doubleColon(token);
                else if (prev[0] === "word" && prev[1] === "progid") continue;
                else return i;
            }
            prev = token;
        }
        return false;
    }
    comment(token) {
        let node = new $70788577d80df9f2$exports();
        this.init(node, token[2]);
        node.source.end = this.getPosition(token[3] || token[2]);
        node.source.end.offset++;
        let text = token[1].slice(2, -2);
        if (/^\s*$/.test(text)) {
            node.text = "";
            node.raws.left = text;
            node.raws.right = "";
        } else {
            let match = text.match(/^(\s*)([^]*\S)(\s*)$/);
            node.text = match[2];
            node.raws.left = match[1];
            node.raws.right = match[3];
        }
    }
    createTokenizer() {
        this.tokenizer = $0ad72a19bc8f2e53$exports(this.input);
    }
    decl(tokens, customProperty) {
        let node = new $ad246cc249f10bad$exports();
        this.init(node, tokens[0][2]);
        let last = tokens[tokens.length - 1];
        if (last[0] === ";") {
            this.semicolon = true;
            tokens.pop();
        }
        node.source.end = this.getPosition(last[3] || last[2] || $19499e11fc876a3e$var$findLastWithPosition(tokens));
        node.source.end.offset++;
        while(tokens[0][0] !== "word"){
            if (tokens.length === 1) this.unknownWord(tokens);
            node.raws.before += tokens.shift()[1];
        }
        node.source.start = this.getPosition(tokens[0][2]);
        node.prop = "";
        while(tokens.length){
            let type = tokens[0][0];
            if (type === ":" || type === "space" || type === "comment") break;
            node.prop += tokens.shift()[1];
        }
        node.raws.between = "";
        let token;
        while(tokens.length){
            token = tokens.shift();
            if (token[0] === ":") {
                node.raws.between += token[1];
                break;
            } else {
                if (token[0] === "word" && /\w/.test(token[1])) this.unknownWord([
                    token
                ]);
                node.raws.between += token[1];
            }
        }
        if (node.prop[0] === "_" || node.prop[0] === "*") {
            node.raws.before += node.prop[0];
            node.prop = node.prop.slice(1);
        }
        let firstSpaces = [];
        let next;
        while(tokens.length){
            next = tokens[0][0];
            if (next !== "space" && next !== "comment") break;
            firstSpaces.push(tokens.shift());
        }
        this.precheckMissedSemicolon(tokens);
        for(let i = tokens.length - 1; i >= 0; i--){
            token = tokens[i];
            if (token[1].toLowerCase() === "!important") {
                node.important = true;
                let string = this.stringFrom(tokens, i);
                string = this.spacesFromEnd(tokens) + string;
                if (string !== " !important") node.raws.important = string;
                break;
            } else if (token[1].toLowerCase() === "important") {
                let cache = tokens.slice(0);
                let str = "";
                for(let j = i; j > 0; j--){
                    let type = cache[j][0];
                    if (str.trim().startsWith("!") && type !== "space") break;
                    str = cache.pop()[1] + str;
                }
                if (str.trim().startsWith("!")) {
                    node.important = true;
                    node.raws.important = str;
                    tokens = cache;
                }
            }
            if (token[0] !== "space" && token[0] !== "comment") break;
        }
        let hasWord = tokens.some((i)=>i[0] !== "space" && i[0] !== "comment");
        if (hasWord) {
            node.raws.between += firstSpaces.map((i)=>i[1]).join("");
            firstSpaces = [];
        }
        this.raw(node, "value", firstSpaces.concat(tokens), customProperty);
        if (node.value.includes(":") && !customProperty) this.checkMissedSemicolon(tokens);
    }
    doubleColon(token) {
        throw this.input.error("Double colon", {
            offset: token[2]
        }, {
            offset: token[2] + token[1].length
        });
    }
    emptyRule(token) {
        let node = new $2416b279c131361a$exports();
        this.init(node, token[2]);
        node.selector = "";
        node.raws.between = "";
        this.current = node;
    }
    end(token) {
        if (this.current.nodes && this.current.nodes.length) this.current.raws.semicolon = this.semicolon;
        this.semicolon = false;
        this.current.raws.after = (this.current.raws.after || "") + this.spaces;
        this.spaces = "";
        if (this.current.parent) {
            this.current.source.end = this.getPosition(token[2]);
            this.current.source.end.offset++;
            this.current = this.current.parent;
        } else this.unexpectedClose(token);
    }
    endFile() {
        if (this.current.parent) this.unclosedBlock();
        if (this.current.nodes && this.current.nodes.length) this.current.raws.semicolon = this.semicolon;
        this.current.raws.after = (this.current.raws.after || "") + this.spaces;
        this.root.source.end = this.getPosition(this.tokenizer.position());
    }
    freeSemicolon(token) {
        this.spaces += token[1];
        if (this.current.nodes) {
            let prev = this.current.nodes[this.current.nodes.length - 1];
            if (prev && prev.type === "rule" && !prev.raws.ownSemicolon) {
                prev.raws.ownSemicolon = this.spaces;
                this.spaces = "";
            }
        }
    }
    // Helpers
    getPosition(offset) {
        let pos = this.input.fromOffset(offset);
        return {
            column: pos.col,
            line: pos.line,
            offset: offset
        };
    }
    init(node, offset) {
        this.current.push(node);
        node.source = {
            input: this.input,
            start: this.getPosition(offset)
        };
        node.raws.before = this.spaces;
        this.spaces = "";
        if (node.type !== "comment") this.semicolon = false;
    }
    other(start) {
        let end = false;
        let type = null;
        let colon = false;
        let bracket = null;
        let brackets = [];
        let customProperty = start[1].startsWith("--");
        let tokens = [];
        let token = start;
        while(token){
            type = token[0];
            tokens.push(token);
            if (type === "(" || type === "[") {
                if (!bracket) bracket = token;
                brackets.push(type === "(" ? ")" : "]");
            } else if (customProperty && colon && type === "{") {
                if (!bracket) bracket = token;
                brackets.push("}");
            } else if (brackets.length === 0) {
                if (type === ";") {
                    if (colon) {
                        this.decl(tokens, customProperty);
                        return;
                    } else break;
                } else if (type === "{") {
                    this.rule(tokens);
                    return;
                } else if (type === "}") {
                    this.tokenizer.back(tokens.pop());
                    end = true;
                    break;
                } else if (type === ":") colon = true;
            } else if (type === brackets[brackets.length - 1]) {
                brackets.pop();
                if (brackets.length === 0) bracket = null;
            }
            token = this.tokenizer.nextToken();
        }
        if (this.tokenizer.endOfFile()) end = true;
        if (brackets.length > 0) this.unclosedBracket(bracket);
        if (end && colon) {
            if (!customProperty) while(tokens.length){
                token = tokens[tokens.length - 1][0];
                if (token !== "space" && token !== "comment") break;
                this.tokenizer.back(tokens.pop());
            }
            this.decl(tokens, customProperty);
        } else this.unknownWord(tokens);
    }
    parse() {
        let token;
        while(!this.tokenizer.endOfFile()){
            token = this.tokenizer.nextToken();
            switch(token[0]){
                case "space":
                    this.spaces += token[1];
                    break;
                case ";":
                    this.freeSemicolon(token);
                    break;
                case "}":
                    this.end(token);
                    break;
                case "comment":
                    this.comment(token);
                    break;
                case "at-word":
                    this.atrule(token);
                    break;
                case "{":
                    this.emptyRule(token);
                    break;
                default:
                    this.other(token);
                    break;
            }
        }
        this.endFile();
    }
    precheckMissedSemicolon() {
    // Hook for Safe Parser
    }
    raw(node, prop, tokens, customProperty) {
        let token, type;
        let length = tokens.length;
        let value = "";
        let clean = true;
        let next, prev;
        for(let i = 0; i < length; i += 1){
            token = tokens[i];
            type = token[0];
            if (type === "space" && i === length - 1 && !customProperty) clean = false;
            else if (type === "comment") {
                prev = tokens[i - 1] ? tokens[i - 1][0] : "empty";
                next = tokens[i + 1] ? tokens[i + 1][0] : "empty";
                if (!$19499e11fc876a3e$var$SAFE_COMMENT_NEIGHBOR[prev] && !$19499e11fc876a3e$var$SAFE_COMMENT_NEIGHBOR[next]) {
                    if (value.slice(-1) === ",") clean = false;
                    else value += token[1];
                } else clean = false;
            } else value += token[1];
        }
        if (!clean) {
            let raw = tokens.reduce((all, i)=>all + i[1], "");
            node.raws[prop] = {
                raw: raw,
                value: value
            };
        }
        node[prop] = value;
    }
    rule(tokens) {
        tokens.pop();
        let node = new $2416b279c131361a$exports();
        this.init(node, tokens[0][2]);
        node.raws.between = this.spacesAndCommentsFromEnd(tokens);
        this.raw(node, "selector", tokens);
        this.current = node;
    }
    spacesAndCommentsFromEnd(tokens) {
        let lastTokenType;
        let spaces = "";
        while(tokens.length){
            lastTokenType = tokens[tokens.length - 1][0];
            if (lastTokenType !== "space" && lastTokenType !== "comment") break;
            spaces = tokens.pop()[1] + spaces;
        }
        return spaces;
    }
    // Errors
    spacesAndCommentsFromStart(tokens) {
        let next;
        let spaces = "";
        while(tokens.length){
            next = tokens[0][0];
            if (next !== "space" && next !== "comment") break;
            spaces += tokens.shift()[1];
        }
        return spaces;
    }
    spacesFromEnd(tokens) {
        let lastTokenType;
        let spaces = "";
        while(tokens.length){
            lastTokenType = tokens[tokens.length - 1][0];
            if (lastTokenType !== "space") break;
            spaces = tokens.pop()[1] + spaces;
        }
        return spaces;
    }
    stringFrom(tokens, from) {
        let result = "";
        for(let i = from; i < tokens.length; i++)result += tokens[i][1];
        tokens.splice(from, tokens.length - from);
        return result;
    }
    unclosedBlock() {
        let pos = this.current.source.start;
        throw this.input.error("Unclosed block", pos.line, pos.column);
    }
    unclosedBracket(bracket) {
        throw this.input.error("Unclosed bracket", {
            offset: bracket[2]
        }, {
            offset: bracket[2] + 1
        });
    }
    unexpectedClose(token) {
        throw this.input.error("Unexpected }", {
            offset: token[2]
        }, {
            offset: token[2] + 1
        });
    }
    unknownWord(tokens) {
        throw this.input.error("Unknown word", {
            offset: tokens[0][2]
        }, {
            offset: tokens[0][2] + tokens[0][1].length
        });
    }
    unnamedAtrule(node, token) {
        throw this.input.error("At-rule without name", {
            offset: token[2]
        }, {
            offset: token[2] + token[1].length
        });
    }
}
$19499e11fc876a3e$exports = $19499e11fc876a3e$var$Parser;


function $418ab21aea8bc340$var$parse(css, opts) {
    let input = new $adcb8c4bd8e49310$exports(css, opts);
    let parser = new $19499e11fc876a3e$exports(input);
    try {
        parser.parse();
    } catch (e) {
        throw e;
    }
    return parser.root;
}
$418ab21aea8bc340$exports = $418ab21aea8bc340$var$parse;
$418ab21aea8bc340$var$parse.default = $418ab21aea8bc340$var$parse;
$077837afef8c72ce$exports.registerParse($418ab21aea8bc340$var$parse);


var $c632a59e44d1d8f0$exports = {};
"use strict";
var $ea653218131f0fe6$exports = {};
"use strict";
class $ea653218131f0fe6$var$Warning {
    constructor(text, opts = {}){
        this.type = "warning";
        this.text = text;
        if (opts.node && opts.node.source) {
            let range = opts.node.rangeBy(opts);
            this.line = range.start.line;
            this.column = range.start.column;
            this.endLine = range.end.line;
            this.endColumn = range.end.column;
        }
        for(let opt in opts)this[opt] = opts[opt];
    }
    toString() {
        if (this.node) return this.node.error(this.text, {
            index: this.index,
            plugin: this.plugin,
            word: this.word
        }).message;
        if (this.plugin) return this.plugin + ": " + this.text;
        return this.text;
    }
}
$ea653218131f0fe6$exports = $ea653218131f0fe6$var$Warning;
$ea653218131f0fe6$var$Warning.default = $ea653218131f0fe6$var$Warning;


class $c632a59e44d1d8f0$var$Result {
    constructor(processor, root, opts){
        this.processor = processor;
        this.messages = [];
        this.root = root;
        this.opts = opts;
        this.css = undefined;
        this.map = undefined;
    }
    toString() {
        return this.css;
    }
    warn(text, opts = {}) {
        if (!opts.plugin) {
            if (this.lastPlugin && this.lastPlugin.postcssPlugin) opts.plugin = this.lastPlugin.postcssPlugin;
        }
        let warning = new $ea653218131f0fe6$exports(text, opts);
        this.messages.push(warning);
        return warning;
    }
    warnings() {
        return this.messages.filter((i)=>i.type === "warning");
    }
    get content() {
        return this.css;
    }
}
$c632a59e44d1d8f0$exports = $c632a59e44d1d8f0$var$Result;
$c632a59e44d1d8f0$var$Result.default = $c632a59e44d1d8f0$var$Result;





var $b37c9102a1d65a3a$require$isClean = $e499001c8f740c05$export$ae5e7911ce0728f9;
var $b37c9102a1d65a3a$require$my = $e499001c8f740c05$export$94fa0a6beb22f989;
var $02e95fbc0a59fed4$exports = {};
/* eslint-disable no-console */ "use strict";
let $02e95fbc0a59fed4$var$printed = {};
$02e95fbc0a59fed4$exports = function warnOnce(message) {
    if ($02e95fbc0a59fed4$var$printed[message]) return;
    $02e95fbc0a59fed4$var$printed[message] = true;
    if (typeof console !== "undefined" && console.warn) console.warn(message);
};


const $b37c9102a1d65a3a$var$TYPE_TO_CLASS_NAME = {
    atrule: "AtRule",
    comment: "Comment",
    decl: "Declaration",
    document: "Document",
    root: "Root",
    rule: "Rule"
};
const $b37c9102a1d65a3a$var$PLUGIN_PROPS = {
    AtRule: true,
    AtRuleExit: true,
    Comment: true,
    CommentExit: true,
    Declaration: true,
    DeclarationExit: true,
    Document: true,
    DocumentExit: true,
    Once: true,
    OnceExit: true,
    postcssPlugin: true,
    prepare: true,
    Root: true,
    RootExit: true,
    Rule: true,
    RuleExit: true
};
const $b37c9102a1d65a3a$var$NOT_VISITORS = {
    Once: true,
    postcssPlugin: true,
    prepare: true
};
const $b37c9102a1d65a3a$var$CHILDREN = 0;
function $b37c9102a1d65a3a$var$isPromise(obj) {
    return typeof obj === "object" && typeof obj.then === "function";
}
function $b37c9102a1d65a3a$var$getEvents(node) {
    let key = false;
    let type = $b37c9102a1d65a3a$var$TYPE_TO_CLASS_NAME[node.type];
    if (node.type === "decl") key = node.prop.toLowerCase();
    else if (node.type === "atrule") key = node.name.toLowerCase();
    if (key && node.append) return [
        type,
        type + "-" + key,
        $b37c9102a1d65a3a$var$CHILDREN,
        type + "Exit",
        type + "Exit-" + key
    ];
    else if (key) return [
        type,
        type + "-" + key,
        type + "Exit",
        type + "Exit-" + key
    ];
    else if (node.append) return [
        type,
        $b37c9102a1d65a3a$var$CHILDREN,
        type + "Exit"
    ];
    else return [
        type,
        type + "Exit"
    ];
}
function $b37c9102a1d65a3a$var$toStack(node) {
    let events;
    if (node.type === "document") events = [
        "Document",
        $b37c9102a1d65a3a$var$CHILDREN,
        "DocumentExit"
    ];
    else if (node.type === "root") events = [
        "Root",
        $b37c9102a1d65a3a$var$CHILDREN,
        "RootExit"
    ];
    else events = $b37c9102a1d65a3a$var$getEvents(node);
    return {
        eventIndex: 0,
        events: events,
        iterator: 0,
        node: node,
        visitorIndex: 0,
        visitors: []
    };
}
function $b37c9102a1d65a3a$var$cleanMarks(node) {
    node[$b37c9102a1d65a3a$require$isClean] = false;
    if (node.nodes) node.nodes.forEach((i)=>$b37c9102a1d65a3a$var$cleanMarks(i));
    return node;
}
let $b37c9102a1d65a3a$var$postcss = {};
class $b37c9102a1d65a3a$var$LazyResult {
    constructor(processor, css, opts){
        this.stringified = false;
        this.processed = false;
        let root;
        if (typeof css === "object" && css !== null && (css.type === "root" || css.type === "document")) root = $b37c9102a1d65a3a$var$cleanMarks(css);
        else if (css instanceof $b37c9102a1d65a3a$var$LazyResult || css instanceof $c632a59e44d1d8f0$exports) {
            root = $b37c9102a1d65a3a$var$cleanMarks(css.root);
            if (css.map) {
                if (typeof opts.map === "undefined") opts.map = {};
                if (!opts.map.inline) opts.map.inline = false;
                opts.map.prev = css.map;
            }
        } else {
            let parser = $418ab21aea8bc340$exports;
            if (opts.syntax) parser = opts.syntax.parse;
            if (opts.parser) parser = opts.parser;
            if (parser.parse) parser = parser.parse;
            try {
                root = parser(css, opts);
            } catch (error) {
                this.processed = true;
                this.error = error;
            }
            if (root && !root[$b37c9102a1d65a3a$require$my]) /* c8 ignore next 2 */ $077837afef8c72ce$exports.rebuild(root);
        }
        this.result = new $c632a59e44d1d8f0$exports(processor, root, opts);
        this.helpers = {
            ...$b37c9102a1d65a3a$var$postcss,
            postcss: $b37c9102a1d65a3a$var$postcss,
            result: this.result
        };
        this.plugins = this.processor.plugins.map((plugin)=>{
            if (typeof plugin === "object" && plugin.prepare) return {
                ...plugin,
                ...plugin.prepare(this.result)
            };
            else return plugin;
        });
    }
    async() {
        if (this.error) return Promise.reject(this.error);
        if (this.processed) return Promise.resolve(this.result);
        if (!this.processing) this.processing = this.runAsync();
        return this.processing;
    }
    catch(onRejected) {
        return this.async().catch(onRejected);
    }
    finally(onFinally) {
        return this.async().then(onFinally, onFinally);
    }
    getAsyncError() {
        throw new Error("Use process(css).then(cb) to work with async plugins");
    }
    handleError(error, node) {
        let plugin = this.result.lastPlugin;
        try {
            if (node) node.addToError(error);
            this.error = error;
            if (error.name === "CssSyntaxError" && !error.plugin) {
                error.plugin = plugin.postcssPlugin;
                error.setMessage();
            } else plugin.postcssVersion;
        } catch (err) {
            /* c8 ignore next 3 */ // eslint-disable-next-line no-console
            if (console && console.error) console.error(err);
        }
        return error;
    }
    prepareVisitors() {
        this.listeners = {};
        let add = (plugin, type, cb)=>{
            if (!this.listeners[type]) this.listeners[type] = [];
            this.listeners[type].push([
                plugin,
                cb
            ]);
        };
        for (let plugin of this.plugins){
            if (typeof plugin === "object") for(let event in plugin){
                if (!$b37c9102a1d65a3a$var$PLUGIN_PROPS[event] && /^[A-Z]/.test(event)) throw new Error(`Unknown event ${event} in ${plugin.postcssPlugin}. ` + `Try to update PostCSS (${this.processor.version} now).`);
                if (!$b37c9102a1d65a3a$var$NOT_VISITORS[event]) {
                    if (typeof plugin[event] === "object") {
                        for(let filter in plugin[event])if (filter === "*") add(plugin, event, plugin[event][filter]);
                        else add(plugin, event + "-" + filter.toLowerCase(), plugin[event][filter]);
                    } else if (typeof plugin[event] === "function") add(plugin, event, plugin[event]);
                }
            }
        }
        this.hasListener = Object.keys(this.listeners).length > 0;
    }
    async runAsync() {
        this.plugin = 0;
        for(let i = 0; i < this.plugins.length; i++){
            let plugin = this.plugins[i];
            let promise = this.runOnRoot(plugin);
            if ($b37c9102a1d65a3a$var$isPromise(promise)) try {
                await promise;
            } catch (error) {
                throw this.handleError(error);
            }
        }
        this.prepareVisitors();
        if (this.hasListener) {
            let root = this.result.root;
            while(!root[$b37c9102a1d65a3a$require$isClean]){
                root[$b37c9102a1d65a3a$require$isClean] = true;
                let stack = [
                    $b37c9102a1d65a3a$var$toStack(root)
                ];
                while(stack.length > 0){
                    let promise = this.visitTick(stack);
                    if ($b37c9102a1d65a3a$var$isPromise(promise)) try {
                        await promise;
                    } catch (e) {
                        let node = stack[stack.length - 1].node;
                        throw this.handleError(e, node);
                    }
                }
            }
            if (this.listeners.OnceExit) for (let [plugin, visitor] of this.listeners.OnceExit){
                this.result.lastPlugin = plugin;
                try {
                    if (root.type === "document") {
                        let roots = root.nodes.map((subRoot)=>visitor(subRoot, this.helpers));
                        await Promise.all(roots);
                    } else await visitor(root, this.helpers);
                } catch (e) {
                    throw this.handleError(e);
                }
            }
        }
        this.processed = true;
        return this.stringify();
    }
    runOnRoot(plugin) {
        this.result.lastPlugin = plugin;
        try {
            if (typeof plugin === "object" && plugin.Once) {
                if (this.result.root.type === "document") {
                    let roots = this.result.root.nodes.map((root)=>plugin.Once(root, this.helpers));
                    if ($b37c9102a1d65a3a$var$isPromise(roots[0])) return Promise.all(roots);
                    return roots;
                }
                return plugin.Once(this.result.root, this.helpers);
            } else if (typeof plugin === "function") return plugin(this.result.root, this.result);
        } catch (error) {
            throw this.handleError(error);
        }
    }
    stringify() {
        if (this.error) throw this.error;
        if (this.stringified) return this.result;
        this.stringified = true;
        this.sync();
        let opts = this.result.opts;
        let str = $37a935064d256e88$exports;
        if (opts.syntax) str = opts.syntax.stringify;
        if (opts.stringifier) str = opts.stringifier;
        if (str.stringify) str = str.stringify;
        let map = new $ad00c369e31031af$exports(str, this.result.root, this.result.opts);
        let data = map.generate();
        this.result.css = data[0];
        this.result.map = data[1];
        return this.result;
    }
    sync() {
        if (this.error) throw this.error;
        if (this.processed) return this.result;
        this.processed = true;
        if (this.processing) throw this.getAsyncError();
        for (let plugin of this.plugins){
            let promise = this.runOnRoot(plugin);
            if ($b37c9102a1d65a3a$var$isPromise(promise)) throw this.getAsyncError();
        }
        this.prepareVisitors();
        if (this.hasListener) {
            let root = this.result.root;
            while(!root[$b37c9102a1d65a3a$require$isClean]){
                root[$b37c9102a1d65a3a$require$isClean] = true;
                this.walkSync(root);
            }
            if (this.listeners.OnceExit) {
                if (root.type === "document") for (let subRoot of root.nodes)this.visitSync(this.listeners.OnceExit, subRoot);
                else this.visitSync(this.listeners.OnceExit, root);
            }
        }
        return this.result;
    }
    then(onFulfilled, onRejected) {
        return this.async().then(onFulfilled, onRejected);
    }
    toString() {
        return this.css;
    }
    visitSync(visitors, node) {
        for (let [plugin, visitor] of visitors){
            this.result.lastPlugin = plugin;
            let promise;
            try {
                promise = visitor(node, this.helpers);
            } catch (e) {
                throw this.handleError(e, node.proxyOf);
            }
            if (node.type !== "root" && node.type !== "document" && !node.parent) return true;
            if ($b37c9102a1d65a3a$var$isPromise(promise)) throw this.getAsyncError();
        }
    }
    visitTick(stack) {
        let visit = stack[stack.length - 1];
        let { node: node, visitors: visitors } = visit;
        if (node.type !== "root" && node.type !== "document" && !node.parent) {
            stack.pop();
            return;
        }
        if (visitors.length > 0 && visit.visitorIndex < visitors.length) {
            let [plugin, visitor] = visitors[visit.visitorIndex];
            visit.visitorIndex += 1;
            if (visit.visitorIndex === visitors.length) {
                visit.visitors = [];
                visit.visitorIndex = 0;
            }
            this.result.lastPlugin = plugin;
            try {
                return visitor(node.toProxy(), this.helpers);
            } catch (e) {
                throw this.handleError(e, node);
            }
        }
        if (visit.iterator !== 0) {
            let iterator = visit.iterator;
            let child;
            while(child = node.nodes[node.indexes[iterator]]){
                node.indexes[iterator] += 1;
                if (!child[$b37c9102a1d65a3a$require$isClean]) {
                    child[$b37c9102a1d65a3a$require$isClean] = true;
                    stack.push($b37c9102a1d65a3a$var$toStack(child));
                    return;
                }
            }
            visit.iterator = 0;
            delete node.indexes[iterator];
        }
        let events = visit.events;
        while(visit.eventIndex < events.length){
            let event = events[visit.eventIndex];
            visit.eventIndex += 1;
            if (event === $b37c9102a1d65a3a$var$CHILDREN) {
                if (node.nodes && node.nodes.length) {
                    node[$b37c9102a1d65a3a$require$isClean] = true;
                    visit.iterator = node.getIterator();
                }
                return;
            } else if (this.listeners[event]) {
                visit.visitors = this.listeners[event];
                return;
            }
        }
        stack.pop();
    }
    walkSync(node) {
        node[$b37c9102a1d65a3a$require$isClean] = true;
        let events = $b37c9102a1d65a3a$var$getEvents(node);
        for (let event of events){
            if (event === $b37c9102a1d65a3a$var$CHILDREN) {
                if (node.nodes) node.each((child)=>{
                    if (!child[$b37c9102a1d65a3a$require$isClean]) this.walkSync(child);
                });
            } else {
                let visitors = this.listeners[event];
                if (visitors) {
                    if (this.visitSync(visitors, node.toProxy())) return;
                }
            }
        }
    }
    warnings() {
        return this.sync().warnings();
    }
    get content() {
        return this.stringify().content;
    }
    get css() {
        return this.stringify().css;
    }
    get map() {
        return this.stringify().map;
    }
    get messages() {
        return this.sync().messages;
    }
    get opts() {
        return this.result.opts;
    }
    get processor() {
        return this.result.processor;
    }
    get root() {
        return this.sync().root;
    }
    get [Symbol.toStringTag]() {
        return "LazyResult";
    }
}
$b37c9102a1d65a3a$var$LazyResult.registerPostcss = (dependant)=>{
    $b37c9102a1d65a3a$var$postcss = dependant;
};
$b37c9102a1d65a3a$exports = $b37c9102a1d65a3a$var$LazyResult;
$b37c9102a1d65a3a$var$LazyResult.default = $b37c9102a1d65a3a$var$LazyResult;
$8268821f68b0ec50$exports.registerLazyResult($b37c9102a1d65a3a$var$LazyResult);
$cf27b66cf5c233cc$exports.registerLazyResult($b37c9102a1d65a3a$var$LazyResult);





var $577e0f8d377f8252$exports = {};
"use strict";


var $3d176b5d646307fd$exports = {};
"use strict";





class $3d176b5d646307fd$var$NoWorkResult {
    constructor(processor, css, opts){
        css = css.toString();
        this.stringified = false;
        this._processor = processor;
        this._css = css;
        this._opts = opts;
        this._map = undefined;
        let root;
        let str = $37a935064d256e88$exports;
        this.result = new $c632a59e44d1d8f0$exports(this._processor, root, this._opts);
        this.result.css = css;
        let self = this;
        Object.defineProperty(this.result, "root", {
            get () {
                return self.root;
            }
        });
        let map = new $ad00c369e31031af$exports(str, root, this._opts, css);
        if (map.isMap()) {
            let [generatedCSS, generatedMap] = map.generate();
            if (generatedCSS) this.result.css = generatedCSS;
            if (generatedMap) this.result.map = generatedMap;
        } else {
            map.clearAnnotation();
            this.result.css = map.css;
        }
    }
    async() {
        if (this.error) return Promise.reject(this.error);
        return Promise.resolve(this.result);
    }
    catch(onRejected) {
        return this.async().catch(onRejected);
    }
    finally(onFinally) {
        return this.async().then(onFinally, onFinally);
    }
    sync() {
        if (this.error) throw this.error;
        return this.result;
    }
    then(onFulfilled, onRejected) {
        return this.async().then(onFulfilled, onRejected);
    }
    toString() {
        return this._css;
    }
    warnings() {
        return [];
    }
    get content() {
        return this.result.css;
    }
    get css() {
        return this.result.css;
    }
    get map() {
        return this.result.map;
    }
    get messages() {
        return [];
    }
    get opts() {
        return this.result.opts;
    }
    get processor() {
        return this.result.processor;
    }
    get root() {
        if (this._root) return this._root;
        let root;
        let parser = $418ab21aea8bc340$exports;
        try {
            root = parser(this._css, this._opts);
        } catch (error) {
            this.error = error;
        }
        if (this.error) throw this.error;
        else {
            this._root = root;
            return root;
        }
    }
    get [Symbol.toStringTag]() {
        return "NoWorkResult";
    }
}
$3d176b5d646307fd$exports = $3d176b5d646307fd$var$NoWorkResult;
$3d176b5d646307fd$var$NoWorkResult.default = $3d176b5d646307fd$var$NoWorkResult;



class $577e0f8d377f8252$var$Processor {
    constructor(plugins = []){
        this.version = "8.4.47";
        this.plugins = this.normalize(plugins);
    }
    normalize(plugins) {
        let normalized = [];
        for (let i of plugins){
            if (i.postcss === true) i = i();
            else if (i.postcss) i = i.postcss;
            if (typeof i === "object" && Array.isArray(i.plugins)) normalized = normalized.concat(i.plugins);
            else if (typeof i === "object" && i.postcssPlugin) normalized.push(i);
            else if (typeof i === "function") normalized.push(i);
            else if (typeof i === "object" && (i.parse || i.stringify)) ;
            else throw new Error(i + " is not a PostCSS plugin");
        }
        return normalized;
    }
    process(css, opts = {}) {
        if (!this.plugins.length && !opts.parser && !opts.stringifier && !opts.syntax) return new $3d176b5d646307fd$exports(this, css, opts);
        else return new $b37c9102a1d65a3a$exports(this, css, opts);
    }
    use(plugin) {
        this.plugins = this.plugins.concat(this.normalize([
            plugin
        ]));
        return this;
    }
}
$577e0f8d377f8252$exports = $577e0f8d377f8252$var$Processor;
$577e0f8d377f8252$var$Processor.default = $577e0f8d377f8252$var$Processor;
$8268821f68b0ec50$exports.registerProcessor($577e0f8d377f8252$var$Processor);
$cf27b66cf5c233cc$exports.registerProcessor($577e0f8d377f8252$var$Processor);







function $9af66cd8f3989a70$var$postcss(...plugins) {
    if (plugins.length === 1 && Array.isArray(plugins[0])) plugins = plugins[0];
    return new $577e0f8d377f8252$exports(plugins);
}
$9af66cd8f3989a70$var$postcss.plugin = function plugin(name, initializer) {
    let warningPrinted = false;
    function creator(...args) {
        // eslint-disable-next-line no-console
        if (console && console.warn && !warningPrinted) {
            warningPrinted = true;
            // eslint-disable-next-line no-console
            console.warn(name + ": postcss.plugin was deprecated. Migration guide:\n" + "https://evilmartians.com/chronicles/postcss-8-plugin-migration");
        }
        let transformer = initializer(...args);
        transformer.postcssPlugin = name;
        transformer.postcssVersion = new $577e0f8d377f8252$exports().version;
        return transformer;
    }
    let cache;
    Object.defineProperty(creator, "postcss", {
        get () {
            if (!cache) cache = creator();
            return cache;
        }
    });
    creator.process = function(css, processOpts, pluginOpts) {
        return $9af66cd8f3989a70$var$postcss([
            creator(pluginOpts)
        ]).process(css, processOpts);
    };
    return creator;
};
$9af66cd8f3989a70$var$postcss.stringify = $37a935064d256e88$exports;
$9af66cd8f3989a70$var$postcss.parse = $418ab21aea8bc340$exports;
$9af66cd8f3989a70$var$postcss.fromJSON = $3a4e8172d018cea5$exports;
$9af66cd8f3989a70$var$postcss.list = $5a9bb9fdfdb0262a$exports;
$9af66cd8f3989a70$var$postcss.comment = (defaults)=>new $70788577d80df9f2$exports(defaults);
$9af66cd8f3989a70$var$postcss.atRule = (defaults)=>new $9db5b2301a1fe865$exports(defaults);
$9af66cd8f3989a70$var$postcss.decl = (defaults)=>new $ad246cc249f10bad$exports(defaults);
$9af66cd8f3989a70$var$postcss.rule = (defaults)=>new $2416b279c131361a$exports(defaults);
$9af66cd8f3989a70$var$postcss.root = (defaults)=>new $8268821f68b0ec50$exports(defaults);
$9af66cd8f3989a70$var$postcss.document = (defaults)=>new $cf27b66cf5c233cc$exports(defaults);
$9af66cd8f3989a70$var$postcss.CssSyntaxError = $11b90bf6793089bc$exports;
$9af66cd8f3989a70$var$postcss.Declaration = $ad246cc249f10bad$exports;
$9af66cd8f3989a70$var$postcss.Container = $077837afef8c72ce$exports;
$9af66cd8f3989a70$var$postcss.Processor = $577e0f8d377f8252$exports;
$9af66cd8f3989a70$var$postcss.Document = $cf27b66cf5c233cc$exports;
$9af66cd8f3989a70$var$postcss.Comment = $70788577d80df9f2$exports;
$9af66cd8f3989a70$var$postcss.Warning = $ea653218131f0fe6$exports;
$9af66cd8f3989a70$var$postcss.AtRule = $9db5b2301a1fe865$exports;
$9af66cd8f3989a70$var$postcss.Result = $c632a59e44d1d8f0$exports;
$9af66cd8f3989a70$var$postcss.Input = $adcb8c4bd8e49310$exports;
$9af66cd8f3989a70$var$postcss.Rule = $2416b279c131361a$exports;
$9af66cd8f3989a70$var$postcss.Root = $8268821f68b0ec50$exports;
$9af66cd8f3989a70$var$postcss.Node = $ec13b6f08b41b54b$exports;
$b37c9102a1d65a3a$exports.registerPostcss($9af66cd8f3989a70$var$postcss);
$9af66cd8f3989a70$exports = $9af66cd8f3989a70$var$postcss;
$9af66cd8f3989a70$var$postcss.default = $9af66cd8f3989a70$var$postcss;


var $91fe648caba28c6f$require$postcssParse = $9af66cd8f3989a70$exports.parse;
// Tags that can conceivably represent stand-alone media.
const $91fe648caba28c6f$var$mediaTags = [
    "img",
    "audio",
    "video",
    "picture",
    "svg",
    "object",
    "map",
    "iframe",
    "embed"
];
// Tags that are inherently vulnerable to being used in XSS attacks.
const $91fe648caba28c6f$var$vulnerableTags = [
    "script",
    "style"
];
function $91fe648caba28c6f$var$each(obj, cb) {
    if (obj) Object.keys(obj).forEach(function(key) {
        cb(obj[key], key);
    });
}
// Avoid false positives with .__proto__, .hasOwnProperty, etc.
function $91fe648caba28c6f$var$has(obj, key) {
    return ({}).hasOwnProperty.call(obj, key);
}
// Returns those elements of `a` for which `cb(a)` returns truthy
function $91fe648caba28c6f$var$filter(a, cb) {
    const n = [];
    $91fe648caba28c6f$var$each(a, function(v) {
        if (cb(v)) n.push(v);
    });
    return n;
}
function $91fe648caba28c6f$var$isEmptyObject(obj) {
    for(const key in obj){
        if ($91fe648caba28c6f$var$has(obj, key)) return false;
    }
    return true;
}
function $91fe648caba28c6f$var$stringifySrcset(parsedSrcset) {
    return parsedSrcset.map(function(part) {
        if (!part.url) throw new Error("URL missing");
        return part.url + (part.w ? ` ${part.w}w` : "") + (part.h ? ` ${part.h}h` : "") + (part.d ? ` ${part.d}x` : "");
    }).join(", ");
}
$91fe648caba28c6f$exports = $91fe648caba28c6f$var$sanitizeHtml;
// A valid attribute name.
// We use a tolerant definition based on the set of strings defined by
// html.spec.whatwg.org/multipage/parsing.html#before-attribute-name-state
// and html.spec.whatwg.org/multipage/parsing.html#attribute-name-state .
// The characters accepted are ones which can be appended to the attribute
// name buffer without triggering a parse error:
//   * unexpected-equals-sign-before-attribute-name
//   * unexpected-null-character
//   * unexpected-character-in-attribute-name
// We exclude the empty string because it's impossible to get to the after
// attribute name state with an empty attribute name buffer.
const $91fe648caba28c6f$var$VALID_HTML_ATTRIBUTE_NAME = /^[^\0\t\n\f\r /<=>]+$/;
// Ignore the _recursing flag; it's there for recursive
// invocation as a guard against this exploit:
// https://github.com/fb55/htmlparser2/issues/105
function $91fe648caba28c6f$var$sanitizeHtml(html, options, _recursing) {
    if (html == null) return "";
    if (typeof html === "number") html = html.toString();
    let result = "";
    // Used for hot swapping the result variable with an empty string in order to "capture" the text written to it.
    let tempResult = "";
    function Frame(tag, attribs) {
        const that = this;
        this.tag = tag;
        this.attribs = attribs || {};
        this.tagPosition = result.length;
        this.text = ""; // Node inner text
        this.mediaChildren = [];
        this.updateParentNodeText = function() {
            if (stack.length) {
                const parentFrame = stack[stack.length - 1];
                parentFrame.text += that.text;
            }
        };
        this.updateParentNodeMediaChildren = function() {
            if (stack.length && $91fe648caba28c6f$var$mediaTags.includes(this.tag)) {
                const parentFrame = stack[stack.length - 1];
                parentFrame.mediaChildren.push(this.tag);
            }
        };
    }
    options = Object.assign({}, $91fe648caba28c6f$var$sanitizeHtml.defaults, options);
    options.parser = Object.assign({}, $91fe648caba28c6f$var$htmlParserDefaults, options.parser);
    const tagAllowed = function(name) {
        return options.allowedTags === false || (options.allowedTags || []).indexOf(name) > -1;
    };
    // vulnerableTags
    $91fe648caba28c6f$var$vulnerableTags.forEach(function(tag) {
        if (tagAllowed(tag) && !options.allowVulnerableTags) console.warn(`

\u{26A0}\u{FE0F} Your \`allowedTags\` option includes, \`${tag}\`, which is inherently\nvulnerable to XSS attacks. Please remove it from \`allowedTags\`.\nOr, to disable this warning, add the \`allowVulnerableTags\` option\nand ensure you are accounting for this risk.\n\n`);
    });
    // Tags that contain something other than HTML, or where discarding
    // the text when the tag is disallowed makes sense for other reasons.
    // If we are not allowing these tags, we should drop their content too.
    // For other tags you would drop the tag but keep its content.
    const nonTextTagsArray = options.nonTextTags || [
        "script",
        "style",
        "textarea",
        "option"
    ];
    let allowedAttributesMap;
    let allowedAttributesGlobMap;
    if (options.allowedAttributes) {
        allowedAttributesMap = {};
        allowedAttributesGlobMap = {};
        $91fe648caba28c6f$var$each(options.allowedAttributes, function(attributes, tag) {
            allowedAttributesMap[tag] = [];
            const globRegex = [];
            attributes.forEach(function(obj) {
                if (typeof obj === "string" && obj.indexOf("*") >= 0) globRegex.push($5c0b5ed16124b0da$exports(obj).replace(/\\\*/g, ".*"));
                else allowedAttributesMap[tag].push(obj);
            });
            if (globRegex.length) allowedAttributesGlobMap[tag] = new RegExp("^(" + globRegex.join("|") + ")$");
        });
    }
    const allowedClassesMap = {};
    const allowedClassesGlobMap = {};
    const allowedClassesRegexMap = {};
    $91fe648caba28c6f$var$each(options.allowedClasses, function(classes, tag) {
        // Implicitly allows the class attribute
        if (allowedAttributesMap) {
            if (!$91fe648caba28c6f$var$has(allowedAttributesMap, tag)) allowedAttributesMap[tag] = [];
            allowedAttributesMap[tag].push("class");
        }
        allowedClassesMap[tag] = classes;
        if (Array.isArray(classes)) {
            const globRegex = [];
            allowedClassesMap[tag] = [];
            allowedClassesRegexMap[tag] = [];
            classes.forEach(function(obj) {
                if (typeof obj === "string" && obj.indexOf("*") >= 0) globRegex.push($5c0b5ed16124b0da$exports(obj).replace(/\\\*/g, ".*"));
                else if (obj instanceof RegExp) allowedClassesRegexMap[tag].push(obj);
                else allowedClassesMap[tag].push(obj);
            });
            if (globRegex.length) allowedClassesGlobMap[tag] = new RegExp("^(" + globRegex.join("|") + ")$");
        }
    });
    const transformTagsMap = {};
    let transformTagsAll;
    $91fe648caba28c6f$var$each(options.transformTags, function(transform, tag) {
        let transFun;
        if (typeof transform === "function") transFun = transform;
        else if (typeof transform === "string") transFun = $91fe648caba28c6f$var$sanitizeHtml.simpleTransform(transform);
        if (tag === "*") transformTagsAll = transFun;
        else transformTagsMap[tag] = transFun;
    });
    let depth;
    let stack;
    let skipMap;
    let transformMap;
    let skipText;
    let skipTextDepth;
    let addedText = false;
    initializeState();
    const parser = new $0ab8478bff8d2345$export$7acfa6ed01010e37({
        onopentag: function(name, attribs) {
            // If `enforceHtmlBoundary` is `true` and this has found the opening
            // `html` tag, reset the state.
            if (options.enforceHtmlBoundary && name === "html") initializeState();
            if (skipText) {
                skipTextDepth++;
                return;
            }
            const frame = new Frame(name, attribs);
            stack.push(frame);
            let skip = false;
            const hasText = !!frame.text;
            let transformedTag;
            if ($91fe648caba28c6f$var$has(transformTagsMap, name)) {
                transformedTag = transformTagsMap[name](name, attribs);
                frame.attribs = attribs = transformedTag.attribs;
                if (transformedTag.text !== undefined) frame.innerText = transformedTag.text;
                if (name !== transformedTag.tagName) {
                    frame.name = name = transformedTag.tagName;
                    transformMap[depth] = transformedTag.tagName;
                }
            }
            if (transformTagsAll) {
                transformedTag = transformTagsAll(name, attribs);
                frame.attribs = attribs = transformedTag.attribs;
                if (name !== transformedTag.tagName) {
                    frame.name = name = transformedTag.tagName;
                    transformMap[depth] = transformedTag.tagName;
                }
            }
            if (!tagAllowed(name) || options.disallowedTagsMode === "recursiveEscape" && !$91fe648caba28c6f$var$isEmptyObject(skipMap) || options.nestingLimit != null && depth >= options.nestingLimit) {
                skip = true;
                skipMap[depth] = true;
                if (options.disallowedTagsMode === "discard" || options.disallowedTagsMode === "completelyDiscard") {
                    if (nonTextTagsArray.indexOf(name) !== -1) {
                        skipText = true;
                        skipTextDepth = 1;
                    }
                }
                skipMap[depth] = true;
            }
            depth++;
            if (skip) {
                if (options.disallowedTagsMode === "discard" || options.disallowedTagsMode === "completelyDiscard") // We want the contents but not this tag
                return;
                tempResult = result;
                result = "";
            }
            result += "<" + name;
            if (name === "script") {
                if (options.allowedScriptHostnames || options.allowedScriptDomains) frame.innerText = "";
            }
            if (!allowedAttributesMap || $91fe648caba28c6f$var$has(allowedAttributesMap, name) || allowedAttributesMap["*"]) $91fe648caba28c6f$var$each(attribs, function(value, a) {
                if (!$91fe648caba28c6f$var$VALID_HTML_ATTRIBUTE_NAME.test(a)) {
                    // This prevents part of an attribute name in the output from being
                    // interpreted as the end of an attribute, or end of a tag.
                    delete frame.attribs[a];
                    return;
                }
                // If the value is empty, check if the attribute is in the allowedEmptyAttributes array.
                // If it is not in the allowedEmptyAttributes array, and it is a known non-boolean attribute, delete it
                // List taken from https://html.spec.whatwg.org/multipage/indices.html#attributes-3
                if (value === "" && !options.allowedEmptyAttributes.includes(a) && (options.nonBooleanAttributes.includes(a) || options.nonBooleanAttributes.includes("*"))) {
                    delete frame.attribs[a];
                    return;
                }
                // check allowedAttributesMap for the element and attribute and modify the value
                // as necessary if there are specific values defined.
                let passedAllowedAttributesMapCheck = false;
                if (!allowedAttributesMap || $91fe648caba28c6f$var$has(allowedAttributesMap, name) && allowedAttributesMap[name].indexOf(a) !== -1 || allowedAttributesMap["*"] && allowedAttributesMap["*"].indexOf(a) !== -1 || $91fe648caba28c6f$var$has(allowedAttributesGlobMap, name) && allowedAttributesGlobMap[name].test(a) || allowedAttributesGlobMap["*"] && allowedAttributesGlobMap["*"].test(a)) passedAllowedAttributesMapCheck = true;
                else if (allowedAttributesMap && allowedAttributesMap[name]) {
                    for (const o of allowedAttributesMap[name])if ($91fe648caba28c6f$require$isPlainObject(o) && o.name && o.name === a) {
                        passedAllowedAttributesMapCheck = true;
                        let newValue = "";
                        if (o.multiple === true) {
                            // verify the values that are allowed
                            const splitStrArray = value.split(" ");
                            for (const s of splitStrArray)if (o.values.indexOf(s) !== -1) {
                                if (newValue === "") newValue = s;
                                else newValue += " " + s;
                            }
                        } else if (o.values.indexOf(value) >= 0) // verified an allowed value matches the entire attribute value
                        newValue = value;
                        value = newValue;
                    }
                }
                if (passedAllowedAttributesMapCheck) {
                    if (options.allowedSchemesAppliedToAttributes.indexOf(a) !== -1) {
                        if (naughtyHref(name, value)) {
                            delete frame.attribs[a];
                            return;
                        }
                    }
                    if (name === "script" && a === "src") {
                        let allowed = true;
                        try {
                            const parsed = parseUrl(value);
                            if (options.allowedScriptHostnames || options.allowedScriptDomains) {
                                const allowedHostname = (options.allowedScriptHostnames || []).find(function(hostname) {
                                    return hostname === parsed.url.hostname;
                                });
                                const allowedDomain = (options.allowedScriptDomains || []).find(function(domain) {
                                    return parsed.url.hostname === domain || parsed.url.hostname.endsWith(`.${domain}`);
                                });
                                allowed = allowedHostname || allowedDomain;
                            }
                        } catch (e) {
                            allowed = false;
                        }
                        if (!allowed) {
                            delete frame.attribs[a];
                            return;
                        }
                    }
                    if (name === "iframe" && a === "src") {
                        let allowed = true;
                        try {
                            const parsed = parseUrl(value);
                            if (parsed.isRelativeUrl) // default value of allowIframeRelativeUrls is true
                            // unless allowedIframeHostnames or allowedIframeDomains specified
                            allowed = $91fe648caba28c6f$var$has(options, "allowIframeRelativeUrls") ? options.allowIframeRelativeUrls : !options.allowedIframeHostnames && !options.allowedIframeDomains;
                            else if (options.allowedIframeHostnames || options.allowedIframeDomains) {
                                const allowedHostname = (options.allowedIframeHostnames || []).find(function(hostname) {
                                    return hostname === parsed.url.hostname;
                                });
                                const allowedDomain = (options.allowedIframeDomains || []).find(function(domain) {
                                    return parsed.url.hostname === domain || parsed.url.hostname.endsWith(`.${domain}`);
                                });
                                allowed = allowedHostname || allowedDomain;
                            }
                        } catch (e) {
                            // Unparseable iframe src
                            allowed = false;
                        }
                        if (!allowed) {
                            delete frame.attribs[a];
                            return;
                        }
                    }
                    if (a === "srcset") try {
                        let parsed = $247239ca062bd0d8$exports(value);
                        parsed.forEach(function(value) {
                            if (naughtyHref("srcset", value.url)) value.evil = true;
                        });
                        parsed = $91fe648caba28c6f$var$filter(parsed, function(v) {
                            return !v.evil;
                        });
                        if (!parsed.length) {
                            delete frame.attribs[a];
                            return;
                        } else {
                            value = $91fe648caba28c6f$var$stringifySrcset($91fe648caba28c6f$var$filter(parsed, function(v) {
                                return !v.evil;
                            }));
                            frame.attribs[a] = value;
                        }
                    } catch (e) {
                        // Unparseable srcset
                        delete frame.attribs[a];
                        return;
                    }
                    if (a === "class") {
                        const allowedSpecificClasses = allowedClassesMap[name];
                        const allowedWildcardClasses = allowedClassesMap["*"];
                        const allowedSpecificClassesGlob = allowedClassesGlobMap[name];
                        const allowedSpecificClassesRegex = allowedClassesRegexMap[name];
                        const allowedWildcardClassesRegex = allowedClassesRegexMap["*"];
                        const allowedWildcardClassesGlob = allowedClassesGlobMap["*"];
                        const allowedClassesGlobs = [
                            allowedSpecificClassesGlob,
                            allowedWildcardClassesGlob
                        ].concat(allowedSpecificClassesRegex, allowedWildcardClassesRegex).filter(function(t) {
                            return t;
                        });
                        if (allowedSpecificClasses && allowedWildcardClasses) value = filterClasses(value, $5cbac2c2bd2e19a5$exports(allowedSpecificClasses, allowedWildcardClasses), allowedClassesGlobs);
                        else value = filterClasses(value, allowedSpecificClasses || allowedWildcardClasses, allowedClassesGlobs);
                        if (!value.length) {
                            delete frame.attribs[a];
                            return;
                        }
                    }
                    if (a === "style") {
                        if (options.parseStyleAttributes) try {
                            const abstractSyntaxTree = $91fe648caba28c6f$require$postcssParse(name + " {" + value + "}", {
                                map: false
                            });
                            const filteredAST = filterCss(abstractSyntaxTree, options.allowedStyles);
                            value = stringifyStyleAttributes(filteredAST);
                            if (value.length === 0) {
                                delete frame.attribs[a];
                                return;
                            }
                        } catch (e) {
                            if (typeof window !== "undefined") console.warn('Failed to parse "' + name + " {" + value + "}" + "\", If you're running this in a browser, we recommend to disable style parsing: options.parseStyleAttributes: false, since this only works in a node environment due to a postcss dependency, More info: https://github.com/apostrophecms/sanitize-html/issues/547");
                            delete frame.attribs[a];
                            return;
                        }
                        else if (options.allowedStyles) throw new Error("allowedStyles option cannot be used together with parseStyleAttributes: false.");
                    }
                    result += " " + a;
                    if (value && value.length) result += '="' + escapeHtml(value, true) + '"';
                    else if (options.allowedEmptyAttributes.includes(a)) result += '=""';
                } else delete frame.attribs[a];
            });
            if (options.selfClosing.indexOf(name) !== -1) result += " />";
            else {
                result += ">";
                if (frame.innerText && !hasText && !options.textFilter) {
                    result += escapeHtml(frame.innerText);
                    addedText = true;
                }
            }
            if (skip) {
                result = tempResult + escapeHtml(result);
                tempResult = "";
            }
        },
        ontext: function(text) {
            if (skipText) return;
            const lastFrame = stack[stack.length - 1];
            let tag;
            if (lastFrame) {
                tag = lastFrame.tag;
                // If inner text was set by transform function then let's use it
                text = lastFrame.innerText !== undefined ? lastFrame.innerText : text;
            }
            if (options.disallowedTagsMode === "completelyDiscard" && !tagAllowed(tag)) text = "";
            else if ((options.disallowedTagsMode === "discard" || options.disallowedTagsMode === "completelyDiscard") && (tag === "script" || tag === "style")) // htmlparser2 gives us these as-is. Escaping them ruins the content. Allowing
            // script tags is, by definition, game over for XSS protection, so if that's
            // your concern, don't allow them. The same is essentially true for style tags
            // which have their own collection of XSS vectors.
            result += text;
            else {
                const escaped = escapeHtml(text, false);
                if (options.textFilter && !addedText) result += options.textFilter(escaped, tag);
                else if (!addedText) result += escaped;
            }
            if (stack.length) {
                const frame = stack[stack.length - 1];
                frame.text += text;
            }
        },
        onclosetag: function(name, isImplied) {
            if (skipText) {
                skipTextDepth--;
                if (!skipTextDepth) skipText = false;
                else return;
            }
            const frame = stack.pop();
            if (!frame) // Do not crash on bad markup
            return;
            if (frame.tag !== name) {
                // Another case of bad markup.
                // Push to stack, so that it will be used in future closing tags.
                stack.push(frame);
                return;
            }
            skipText = options.enforceHtmlBoundary ? name === "html" : false;
            depth--;
            const skip = skipMap[depth];
            if (skip) {
                delete skipMap[depth];
                if (options.disallowedTagsMode === "discard" || options.disallowedTagsMode === "completelyDiscard") {
                    frame.updateParentNodeText();
                    return;
                }
                tempResult = result;
                result = "";
            }
            if (transformMap[depth]) {
                name = transformMap[depth];
                delete transformMap[depth];
            }
            if (options.exclusiveFilter && options.exclusiveFilter(frame)) {
                result = result.substr(0, frame.tagPosition);
                return;
            }
            frame.updateParentNodeMediaChildren();
            frame.updateParentNodeText();
            if (// Already output />
            options.selfClosing.indexOf(name) !== -1 || // Escaped tag, closing tag is implied
            isImplied && !tagAllowed(name) && [
                "escape",
                "recursiveEscape"
            ].indexOf(options.disallowedTagsMode) >= 0) {
                if (skip) {
                    result = tempResult;
                    tempResult = "";
                }
                return;
            }
            result += "</" + name + ">";
            if (skip) {
                result = tempResult + escapeHtml(result);
                tempResult = "";
            }
            addedText = false;
        }
    }, options.parser);
    parser.write(html);
    parser.end();
    return result;
    function initializeState() {
        result = "";
        depth = 0;
        stack = [];
        skipMap = {};
        transformMap = {};
        skipText = false;
        skipTextDepth = 0;
    }
    function escapeHtml(s, quote) {
        if (typeof s !== "string") s = s + "";
        if (options.parser.decodeEntities) {
            s = s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
            if (quote) s = s.replace(/"/g, "&quot;");
        }
        // TODO: this is inadequate because it will pass `&0;`. This approach
        // will not work, each & must be considered with regard to whether it
        // is followed by a 100% syntactically valid entity or not, and escaped
        // if it is not. If this bothers you, don't set parser.decodeEntities
        // to false. (The default is true.)
        s = s.replace(/&(?![a-zA-Z0-9#]{1,20};)/g, "&amp;") // Match ampersands not part of existing HTML entity
        .replace(/</g, "&lt;").replace(/>/g, "&gt;");
        if (quote) s = s.replace(/"/g, "&quot;");
        return s;
    }
    function naughtyHref(name, href) {
        // Browsers ignore character codes of 32 (space) and below in a surprising
        // number of situations. Start reading here:
        // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet#Embedded_tab
        // eslint-disable-next-line no-control-regex
        href = href.replace(/[\x00-\x20]+/g, "");
        // Clobber any comments in URLs, which the browser might
        // interpret inside an XML data island, allowing
        // a javascript: URL to be snuck through
        while(true){
            const firstIndex = href.indexOf("<!--");
            if (firstIndex === -1) break;
            const lastIndex = href.indexOf("-->", firstIndex + 4);
            if (lastIndex === -1) break;
            href = href.substring(0, firstIndex) + href.substring(lastIndex + 3);
        }
        // Case insensitive so we don't get faked out by JAVASCRIPT #1
        // Allow more characters after the first so we don't get faked
        // out by certain schemes browsers accept
        const matches = href.match(/^([a-zA-Z][a-zA-Z0-9.\-+]*):/);
        if (!matches) {
            // Protocol-relative URL starting with any combination of '/' and '\'
            if (href.match(/^[/\\]{2}/)) return !options.allowProtocolRelative;
            // No scheme
            return false;
        }
        const scheme = matches[1].toLowerCase();
        if ($91fe648caba28c6f$var$has(options.allowedSchemesByTag, name)) return options.allowedSchemesByTag[name].indexOf(scheme) === -1;
        return !options.allowedSchemes || options.allowedSchemes.indexOf(scheme) === -1;
    }
    function parseUrl(value) {
        value = value.replace(/^(\w+:)?\s*[\\/]\s*[\\/]/, "$1//");
        if (value.startsWith("relative:")) // An attempt to exploit our workaround for base URLs being
        // mandatory for relative URL validation in the WHATWG
        // URL parser, reject it
        throw new Error("relative: exploit attempt");
        // naughtyHref is in charge of whether protocol relative URLs
        // are cool. Here we are concerned just with allowed hostnames and
        // whether to allow relative URLs.
        //
        // Build a placeholder "base URL" against which any reasonable
        // relative URL may be parsed successfully
        let base = "relative://relative-site";
        for(let i = 0; i < 100; i++)base += `/${i}`;
        const parsed = new URL(value, base);
        const isRelativeUrl = parsed && parsed.hostname === "relative-site" && parsed.protocol === "relative:";
        return {
            isRelativeUrl: isRelativeUrl,
            url: parsed
        };
    }
    /**
   * Filters user input css properties by allowlisted regex attributes.
   * Modifies the abstractSyntaxTree object.
   *
   * @param {object} abstractSyntaxTree  - Object representation of CSS attributes.
   * @property {array[Declaration]} abstractSyntaxTree.nodes[0] - Each object cointains prop and value key, i.e { prop: 'color', value: 'red' }.
   * @param {object} allowedStyles       - Keys are properties (i.e color), value is list of permitted regex rules (i.e /green/i).
   * @return {object}                    - The modified tree.
   */ function filterCss(abstractSyntaxTree, allowedStyles) {
        if (!allowedStyles) return abstractSyntaxTree;
        const astRules = abstractSyntaxTree.nodes[0];
        let selectedRule;
        // Merge global and tag-specific styles into new AST.
        if (allowedStyles[astRules.selector] && allowedStyles["*"]) selectedRule = $5cbac2c2bd2e19a5$exports(allowedStyles[astRules.selector], allowedStyles["*"]);
        else selectedRule = allowedStyles[astRules.selector] || allowedStyles["*"];
        if (selectedRule) abstractSyntaxTree.nodes[0].nodes = astRules.nodes.reduce(filterDeclarations(selectedRule), []);
        return abstractSyntaxTree;
    }
    /**
   * Extracts the style attributes from an AbstractSyntaxTree and formats those
   * values in the inline style attribute format.
   *
   * @param  {AbstractSyntaxTree} filteredAST
   * @return {string}             - Example: "color:yellow;text-align:center !important;font-family:helvetica;"
   */ function stringifyStyleAttributes(filteredAST) {
        return filteredAST.nodes[0].nodes.reduce(function(extractedAttributes, attrObject) {
            extractedAttributes.push(`${attrObject.prop}:${attrObject.value}${attrObject.important ? " !important" : ""}`);
            return extractedAttributes;
        }, []).join(";");
    }
    /**
    * Filters the existing attributes for the given property. Discards any attributes
    * which don't match the allowlist.
    *
    * @param  {object} selectedRule             - Example: { color: red, font-family: helvetica }
    * @param  {array} allowedDeclarationsList   - List of declarations which pass the allowlist.
    * @param  {object} attributeObject          - Object representing the current css property.
    * @property {string} attributeObject.type   - Typically 'declaration'.
    * @property {string} attributeObject.prop   - The CSS property, i.e 'color'.
    * @property {string} attributeObject.value  - The corresponding value to the css property, i.e 'red'.
    * @return {function}                        - When used in Array.reduce, will return an array of Declaration objects
    */ function filterDeclarations(selectedRule) {
        return function(allowedDeclarationsList, attributeObject) {
            // If this property is allowlisted...
            if ($91fe648caba28c6f$var$has(selectedRule, attributeObject.prop)) {
                const matchesRegex = selectedRule[attributeObject.prop].some(function(regularExpression) {
                    return regularExpression.test(attributeObject.value);
                });
                if (matchesRegex) allowedDeclarationsList.push(attributeObject);
            }
            return allowedDeclarationsList;
        };
    }
    function filterClasses(classes, allowed, allowedGlobs) {
        if (!allowed) // The class attribute is allowed without filtering on this tag
        return classes;
        classes = classes.split(/\s+/);
        return classes.filter(function(clss) {
            return allowed.indexOf(clss) !== -1 || allowedGlobs.some(function(glob) {
                return glob.test(clss);
            });
        }).join(" ");
    }
}
// Defaults are accessible to you so that you can use them as a starting point
// programmatically if you wish
const $91fe648caba28c6f$var$htmlParserDefaults = {
    decodeEntities: true
};
$91fe648caba28c6f$var$sanitizeHtml.defaults = {
    allowedTags: [
        // Sections derived from MDN element categories and limited to the more
        // benign categories.
        // https://developer.mozilla.org/en-US/docs/Web/HTML/Element
        // Content sectioning
        "address",
        "article",
        "aside",
        "footer",
        "header",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "hgroup",
        "main",
        "nav",
        "section",
        // Text content
        "blockquote",
        "dd",
        "div",
        "dl",
        "dt",
        "figcaption",
        "figure",
        "hr",
        "li",
        "main",
        "ol",
        "p",
        "pre",
        "ul",
        // Inline text semantics
        "a",
        "abbr",
        "b",
        "bdi",
        "bdo",
        "br",
        "cite",
        "code",
        "data",
        "dfn",
        "em",
        "i",
        "kbd",
        "mark",
        "q",
        "rb",
        "rp",
        "rt",
        "rtc",
        "ruby",
        "s",
        "samp",
        "small",
        "span",
        "strong",
        "sub",
        "sup",
        "time",
        "u",
        "var",
        "wbr",
        // Table content
        "caption",
        "col",
        "colgroup",
        "table",
        "tbody",
        "td",
        "tfoot",
        "th",
        "thead",
        "tr"
    ],
    // Tags that cannot be boolean
    nonBooleanAttributes: [
        "abbr",
        "accept",
        "accept-charset",
        "accesskey",
        "action",
        "allow",
        "alt",
        "as",
        "autocapitalize",
        "autocomplete",
        "blocking",
        "charset",
        "cite",
        "class",
        "color",
        "cols",
        "colspan",
        "content",
        "contenteditable",
        "coords",
        "crossorigin",
        "data",
        "datetime",
        "decoding",
        "dir",
        "dirname",
        "download",
        "draggable",
        "enctype",
        "enterkeyhint",
        "fetchpriority",
        "for",
        "form",
        "formaction",
        "formenctype",
        "formmethod",
        "formtarget",
        "headers",
        "height",
        "hidden",
        "high",
        "href",
        "hreflang",
        "http-equiv",
        "id",
        "imagesizes",
        "imagesrcset",
        "inputmode",
        "integrity",
        "is",
        "itemid",
        "itemprop",
        "itemref",
        "itemtype",
        "kind",
        "label",
        "lang",
        "list",
        "loading",
        "low",
        "max",
        "maxlength",
        "media",
        "method",
        "min",
        "minlength",
        "name",
        "nonce",
        "optimum",
        "pattern",
        "ping",
        "placeholder",
        "popover",
        "popovertarget",
        "popovertargetaction",
        "poster",
        "preload",
        "referrerpolicy",
        "rel",
        "rows",
        "rowspan",
        "sandbox",
        "scope",
        "shape",
        "size",
        "sizes",
        "slot",
        "span",
        "spellcheck",
        "src",
        "srcdoc",
        "srclang",
        "srcset",
        "start",
        "step",
        "style",
        "tabindex",
        "target",
        "title",
        "translate",
        "type",
        "usemap",
        "value",
        "width",
        "wrap",
        // Event handlers
        "onauxclick",
        "onafterprint",
        "onbeforematch",
        "onbeforeprint",
        "onbeforeunload",
        "onbeforetoggle",
        "onblur",
        "oncancel",
        "oncanplay",
        "oncanplaythrough",
        "onchange",
        "onclick",
        "onclose",
        "oncontextlost",
        "oncontextmenu",
        "oncontextrestored",
        "oncopy",
        "oncuechange",
        "oncut",
        "ondblclick",
        "ondrag",
        "ondragend",
        "ondragenter",
        "ondragleave",
        "ondragover",
        "ondragstart",
        "ondrop",
        "ondurationchange",
        "onemptied",
        "onended",
        "onerror",
        "onfocus",
        "onformdata",
        "onhashchange",
        "oninput",
        "oninvalid",
        "onkeydown",
        "onkeypress",
        "onkeyup",
        "onlanguagechange",
        "onload",
        "onloadeddata",
        "onloadedmetadata",
        "onloadstart",
        "onmessage",
        "onmessageerror",
        "onmousedown",
        "onmouseenter",
        "onmouseleave",
        "onmousemove",
        "onmouseout",
        "onmouseover",
        "onmouseup",
        "onoffline",
        "ononline",
        "onpagehide",
        "onpageshow",
        "onpaste",
        "onpause",
        "onplay",
        "onplaying",
        "onpopstate",
        "onprogress",
        "onratechange",
        "onreset",
        "onresize",
        "onrejectionhandled",
        "onscroll",
        "onscrollend",
        "onsecuritypolicyviolation",
        "onseeked",
        "onseeking",
        "onselect",
        "onslotchange",
        "onstalled",
        "onstorage",
        "onsubmit",
        "onsuspend",
        "ontimeupdate",
        "ontoggle",
        "onunhandledrejection",
        "onunload",
        "onvolumechange",
        "onwaiting",
        "onwheel"
    ],
    disallowedTagsMode: "discard",
    allowedAttributes: {
        a: [
            "href",
            "name",
            "target"
        ],
        // We don't currently allow img itself by default, but
        // these attributes would make sense if we did.
        img: [
            "src",
            "srcset",
            "alt",
            "title",
            "width",
            "height",
            "loading"
        ]
    },
    allowedEmptyAttributes: [
        "alt"
    ],
    // Lots of these won't come up by default because we don't allow them
    selfClosing: [
        "img",
        "br",
        "hr",
        "area",
        "base",
        "basefont",
        "input",
        "link",
        "meta"
    ],
    // URL schemes we permit
    allowedSchemes: [
        "http",
        "https",
        "ftp",
        "mailto",
        "tel"
    ],
    allowedSchemesByTag: {},
    allowedSchemesAppliedToAttributes: [
        "href",
        "src",
        "cite"
    ],
    allowProtocolRelative: true,
    enforceHtmlBoundary: false,
    parseStyleAttributes: true
};
$91fe648caba28c6f$var$sanitizeHtml.simpleTransform = function(newTagName, newAttribs, merge) {
    merge = merge === undefined ? true : merge;
    newAttribs = newAttribs || {};
    return function(tagName, attribs) {
        let attrib;
        if (merge) for(attrib in newAttribs)attribs[attrib] = newAttribs[attrib];
        else attribs = newAttribs;
        return {
            tagName: newTagName,
            attribs: attribs
        };
    };
};


const $e31ac52a2c203df3$export$67baea80019ff381 = [
    {
        key: "tiny",
        name: "tiny",
        size: 5
    },
    {
        key: "scriptsize",
        name: "scriptsize",
        size: 7
    },
    {
        key: "footnotesize",
        name: "footnotesize",
        size: 8
    },
    {
        key: "small",
        name: "small",
        size: 9
    },
    {
        key: "normalsize",
        name: "normalsize",
        size: 10
    },
    {
        key: "large",
        name: "large",
        size: 12
    },
    {
        key: "Large",
        name: "Large",
        size: 14.4
    },
    {
        key: "LARGE",
        name: "LARGE",
        size: 17.28
    },
    {
        key: "huge",
        name: "huge",
        size: 20.74
    },
    {
        key: "Huge",
        name: "Huge",
        size: 24.88
    }
];
const $e31ac52a2c203df3$export$f827a56aa9dbfe62 = $e31ac52a2c203df3$export$67baea80019ff381[4];
var $e31ac52a2c203df3$export$3720eb13f948f394;
(function(TextAlign) {
    TextAlign[TextAlign["LEFT"] = 0] = "LEFT";
    TextAlign[TextAlign["CENTER"] = 1] = "CENTER";
    TextAlign[TextAlign["RIGHT"] = 2] = "RIGHT";
    TextAlign[TextAlign["JUSTIFY"] = 3] = "JUSTIFY";
})($e31ac52a2c203df3$export$3720eb13f948f394 || ($e31ac52a2c203df3$export$3720eb13f948f394 = {}));
class $e31ac52a2c203df3$export$1855b4e3beb52fd6 extends (0, $62b9e9b060ea5e43$export$9cd791b14633436b) {
    input;
    alignLeft;
    alignCenter;
    alignRight;
    alignJustify;
    justifyStart;
    justifyCenter;
    justifyEnd;
    constructor(initalValue){
        super(initalValue);
    }
    buildHTML() {
        let rowTextArea = this.getRow();
        //font size
        //align top-bottom, left-right
        let inputDiv = document.createElement("div");
        inputDiv.classList.add("col-12", "mt-0");
        this.input = document.createElement("textArea");
        this.input.classList.add("form-control");
        this.input.value = this.value.text ?? "";
        inputDiv.appendChild(this.input);
        rowTextArea.appendChild(inputDiv);
        let previousState;
        this.input.addEventListener("focusin", (ev)=>{
            previousState = this.value;
        });
        this.input.addEventListener("input", (ev)=>{
            this.update();
        });
        this.input.addEventListener("focusout", (ev)=>{
            if (this.value && previousState !== this.value) (0, $815383aeedb00f00$export$897c9ed706d8ea48).addState();
        });
        const btnLabelClasses = [
            "btn",
            "btn-outline-secondary",
            "fs-5",
            "material-symbols-outlined",
            "d-flex",
            "align-items-center",
            "justify-content-center",
            "px-1",
            "flex-grow-1"
        ];
        let alignDiv = document.createElement("div");
        alignDiv.classList.add("col-12", "input-group");
        {
            let labelAlign = document.createElement("span");
            labelAlign.classList.add("col-4", "input-group-text");
            labelAlign.innerHTML = "Align";
            alignDiv.appendChild(labelAlign);
            //left
            this.alignLeft = document.createElement("input");
            this.alignLeft.classList.add("btn-check");
            this.alignLeft.type = "radio";
            this.alignLeft.name = "align";
            this.alignLeft.id = "alignLeft";
            this.alignLeft.checked = true;
            this.alignLeft.addEventListener("change", (ev)=>{
                this.update();
                (0, $815383aeedb00f00$export$897c9ed706d8ea48).addState();
            });
            alignDiv.appendChild(this.alignLeft);
            let alignLeftLabel = document.createElement("label");
            alignLeftLabel.classList.add(...btnLabelClasses);
            alignLeftLabel.innerHTML = "format_align_left";
            alignLeftLabel.setAttribute("for", "alignLeft");
            alignDiv.appendChild(alignLeftLabel);
            //center
            this.alignCenter = document.createElement("input");
            this.alignCenter.classList.add("btn-check");
            this.alignCenter.type = "radio";
            this.alignCenter.name = "align";
            this.alignCenter.id = "alignCenter";
            this.alignCenter.addEventListener("change", (ev)=>{
                this.update();
                (0, $815383aeedb00f00$export$897c9ed706d8ea48).addState();
            });
            alignDiv.appendChild(this.alignCenter);
            let alignCenterLabel = document.createElement("label");
            alignCenterLabel.classList.add(...btnLabelClasses);
            alignCenterLabel.innerHTML = "format_align_center";
            alignCenterLabel.setAttribute("for", "alignCenter");
            alignDiv.appendChild(alignCenterLabel);
            //right
            this.alignRight = document.createElement("input");
            this.alignRight.classList.add("btn-check");
            this.alignRight.type = "radio";
            this.alignRight.name = "align";
            this.alignRight.id = "alignRight";
            this.alignRight.addEventListener("change", (ev)=>{
                this.update();
                (0, $815383aeedb00f00$export$897c9ed706d8ea48).addState();
            });
            alignDiv.appendChild(this.alignRight);
            let alignRightLabel = document.createElement("label");
            alignRightLabel.classList.add(...btnLabelClasses);
            alignRightLabel.innerHTML = "format_align_right";
            alignRightLabel.setAttribute("for", "alignRight");
            alignDiv.appendChild(alignRightLabel);
            //justify
            this.alignJustify = document.createElement("input");
            this.alignJustify.classList.add("btn-check");
            this.alignJustify.type = "radio";
            this.alignJustify.name = "align";
            this.alignJustify.id = "alignJustify";
            this.alignJustify.addEventListener("change", (ev)=>{
                this.update();
                (0, $815383aeedb00f00$export$897c9ed706d8ea48).addState();
            });
            alignDiv.appendChild(this.alignJustify);
            let alignJustifyLabel = document.createElement("label");
            alignJustifyLabel.classList.add(...btnLabelClasses);
            alignJustifyLabel.innerHTML = "format_align_justify";
            alignJustifyLabel.setAttribute("for", "alignJustify");
            alignDiv.appendChild(alignJustifyLabel);
        }
        rowTextArea.appendChild(alignDiv);
        let justifyDiv = document.createElement("div");
        justifyDiv.classList.add("col-12", "input-group");
        {
            let labelAlign = document.createElement("span");
            labelAlign.classList.add("col-4", "input-group-text");
            labelAlign.innerHTML = "Justify";
            justifyDiv.appendChild(labelAlign);
            //left
            this.justifyStart = document.createElement("input");
            this.justifyStart.classList.add("btn-check");
            this.justifyStart.type = "radio";
            this.justifyStart.name = "justify";
            this.justifyStart.id = "justifyStart";
            this.justifyStart.checked = true;
            this.justifyStart.addEventListener("change", (ev)=>{
                this.update();
                (0, $815383aeedb00f00$export$897c9ed706d8ea48).addState();
            });
            justifyDiv.appendChild(this.justifyStart);
            let justifyStartLabel = document.createElement("label");
            justifyStartLabel.classList.add(...btnLabelClasses);
            justifyStartLabel.innerHTML = "vertical_align_top";
            justifyStartLabel.setAttribute("for", "justifyStart");
            justifyDiv.appendChild(justifyStartLabel);
            //center
            this.justifyCenter = document.createElement("input");
            this.justifyCenter.classList.add("btn-check");
            this.justifyCenter.type = "radio";
            this.justifyCenter.name = "justify";
            this.justifyCenter.id = "justifyCenter";
            this.justifyCenter.addEventListener("change", (ev)=>{
                this.update();
                (0, $815383aeedb00f00$export$897c9ed706d8ea48).addState();
            });
            justifyDiv.appendChild(this.justifyCenter);
            let justifyCenterLabel = document.createElement("label");
            justifyCenterLabel.classList.add(...btnLabelClasses);
            justifyCenterLabel.innerHTML = "vertical_align_center";
            justifyCenterLabel.setAttribute("for", "justifyCenter");
            justifyDiv.appendChild(justifyCenterLabel);
            //right
            this.justifyEnd = document.createElement("input");
            this.justifyEnd.classList.add("btn-check");
            this.justifyEnd.type = "radio";
            this.justifyEnd.name = "justify";
            this.justifyEnd.id = "justifyEnd";
            this.justifyEnd.addEventListener("change", (ev)=>{
                this.update();
                (0, $815383aeedb00f00$export$897c9ed706d8ea48).addState();
            });
            justifyDiv.appendChild(this.justifyEnd);
            let justifyEndLabel = document.createElement("label");
            justifyEndLabel.classList.add(...btnLabelClasses);
            justifyEndLabel.innerHTML = "vertical_align_bottom";
            justifyEndLabel.setAttribute("for", "justifyEnd");
            justifyDiv.appendChild(justifyEndLabel);
        }
        rowTextArea.appendChild(justifyDiv);
        return rowTextArea;
    }
    update() {
        let sanitizedText = (0, (/*@__PURE__*/$parcel$interopDefault($91fe648caba28c6f$exports)))(this.input.value, {
            allowedTags: [],
            allowedAttributes: {}
        });
        let data = {
            text: sanitizedText,
            align: this.alignLeft.checked ? $e31ac52a2c203df3$export$3720eb13f948f394.LEFT : this.alignCenter.checked ? $e31ac52a2c203df3$export$3720eb13f948f394.CENTER : this.alignRight.checked ? $e31ac52a2c203df3$export$3720eb13f948f394.RIGHT : $e31ac52a2c203df3$export$3720eb13f948f394.JUSTIFY,
            justify: this.justifyStart.checked ? -1 : this.justifyCenter.checked ? 0 : 1
        };
        this.updateValue(data);
    }
    updateHTML() {
        if (this.input) {
            this.input.value = this.value.text;
            switch(this.value.align){
                case $e31ac52a2c203df3$export$3720eb13f948f394.LEFT:
                    this.alignLeft.checked = true;
                    break;
                case $e31ac52a2c203df3$export$3720eb13f948f394.CENTER:
                    this.alignCenter.checked = true;
                    break;
                case $e31ac52a2c203df3$export$3720eb13f948f394.RIGHT:
                    this.alignRight.checked = true;
                    break;
                case $e31ac52a2c203df3$export$3720eb13f948f394.JUSTIFY:
                    this.alignJustify.checked = true;
                    break;
                default:
                    break;
            }
            switch(this.value.justify){
                case -1:
                    this.justifyStart.checked = true;
                    break;
                case 0:
                    this.justifyCenter.checked = true;
                    break;
                case 1:
                    this.justifyEnd.checked = true;
                    break;
                default:
                    break;
            }
        }
    }
    eq(first, second) {
        return first.text == second.text && first.align == second.align && first.justify == second.justify;
    }
}



class $7a449c719f5814b3$export$12d4a743130a3a26 extends (0, $62b9e9b060ea5e43$export$9cd791b14633436b) {
    valueElement;
    labelElement;
    labelString;
    constructor(label, initalValue){
        super(initalValue);
        this.labelString = label;
    }
    buildHTML() {
        let row = document.createElement("div");
        row.classList.add("row", "mx-0", "my-2", "border", "border-info-subtle", "bg-info-subtle", "text-info-emphasis", "rounded");
        this.labelElement = document.createElement("span");
        this.labelElement.classList.add("text-start", "col-auto", "me-3");
        this.labelElement.innerHTML = this.labelString ?? "Label";
        row.appendChild(this.labelElement);
        this.valueElement = document.createElement("span");
        this.valueElement.classList.add("text-end", "col");
        this.valueElement.innerHTML = this.value ?? "";
        row.appendChild(this.valueElement);
        return row;
    }
    eq(first, second) {
        return first == second;
    }
    updateHTML() {
        if (this.valueElement) this.valueElement.innerHTML = this.value ?? "";
    }
}



class $91f3ab848a30d416$export$121cd37e94b7c5cb extends (0, $62b9e9b060ea5e43$export$9cd791b14633436b) {
    componentReference;
    constructor(componentReference){
        super();
        this.componentReference = componentReference;
    }
    buildHTML() {
        let row = this.getRow();
        let frontDiv = document.createElement("div");
        frontDiv.classList.add("col-6", "mt-0");
        let bringFront = document.createElement("button");
        bringFront.classList.add("w-100", "btn", "btn-primary");
        bringFront.innerHTML = "Bring to front";
        frontDiv.appendChild(bringFront);
        row.appendChild(frontDiv);
        let backDiv = document.createElement("div");
        backDiv.classList.add("col-6", "mt-0");
        let pushBack = document.createElement("button");
        pushBack.classList.add("w-100", "btn", "btn-primary");
        pushBack.innerHTML = "Push to back";
        backDiv.appendChild(pushBack);
        row.appendChild(backDiv);
        bringFront.addEventListener("click", (ev)=>{
            (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.componentsToForeground([
                this.componentReference
            ]);
        });
        pushBack.addEventListener("click", (ev)=>{
            (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.componentsToBackground([
                this.componentReference
            ]);
        });
        return row;
    }
    eq(first, second) {
        return true;
    }
    updateHTML() {}
}



class $995311ad94412d30$export$d4fc42aa08871cc3 extends (0, $62b9e9b060ea5e43$export$9cd791b14633436b) {
    buttonsPerRow;
    labels;
    callbacks;
    materialSymbols;
    constructor(buttonsPerRow, labels, callbacks, materialSymbols = false){
        super();
        if (labels.length !== callbacks.length) throw new Error("every button has to have a callback and a label");
        this.buttonsPerRow = buttonsPerRow;
        this.labels = labels;
        this.callbacks = callbacks;
        this.materialSymbols = materialSymbols;
    }
    eq(first, second) {
        return false;
    }
    buildHTML() {
        let row = this.getRow();
        for(let index = 0; index < this.labels.length; index++){
            const label = this.labels[index];
            const callback = this.callbacks[index];
            let col = document.createElement("div");
            col.classList.add("col-" + Math.round(12 / this.buttonsPerRow).toFixed(0));
            let button = document.createElement("button");
            button.classList.add("w-100", "btn", "btn-primary", "d-flex", "align-items-center", "justify-content-center", "gap-1");
            if (this.materialSymbols) button.classList.add("material-symbols-outlined");
            let labelSymbol = typeof label[1] == "string" ? label[1] : label[1][0];
            let labelSymbolClasses;
            if (typeof label[1] == "string") {
                labelSymbol = label[1];
                labelSymbolClasses = [];
            } else {
                labelSymbol = label[1][0];
                labelSymbolClasses = label[1][1].split(",");
            }
            if (labelSymbol) {
                let spanMat = document.createElement("span");
                if (labelSymbolClasses.length > 0) spanMat.classList.add("material-symbols-outlined", ...labelSymbolClasses);
                else spanMat.classList.add("material-symbols-outlined");
                spanMat.innerHTML = labelSymbol;
                button.appendChild(spanMat);
            }
            if (label[0]) {
                let spanMat = document.createElement("span");
                spanMat.innerHTML = label[0];
                button.appendChild(spanMat);
            }
            button.addEventListener("click", callback);
            col.appendChild(button);
            row.appendChild(col);
        }
        return row;
    }
    updateHTML() {}
}



class $5d2a441813f0d40b$export$bf18630312dd3447 extends (0, $62b9e9b060ea5e43$export$9cd791b14633436b) {
    input;
    constructor(initialValue){
        super(initialValue ?? "");
    }
    eq(first, second) {
        return first == second;
    }
    buildHTML() {
        let row = this.getRow();
        let col = document.createElement("div");
        col.classList.add("col", "col-md-12", "col-xxl", "my-0", "input-group");
        {
            let formulaSpan1 = document.createElement("span");
            formulaSpan1.classList.add("input-group-text");
            formulaSpan1.innerHTML = "$";
            col.appendChild(formulaSpan1);
            this.input = document.createElement("input");
            this.input.classList.add("form-control");
            this.input.type = "text";
            this.input.value = this.value ?? "";
            col.appendChild(this.input);
            let formulaSpan2 = document.createElement("div");
            formulaSpan2.classList.add("input-group-text");
            formulaSpan2.innerHTML = "$";
            col.appendChild(formulaSpan2);
            let previousState = "";
            this.input.addEventListener("focusin", (ev)=>{
                previousState = this.value ?? "";
            });
            this.input.addEventListener("input", (ev)=>{
                this.updateValue(this.input.value);
            });
            this.input.addEventListener("focusout", (ev)=>{
                if (this.value && previousState !== this.value) (0, $815383aeedb00f00$export$897c9ed706d8ea48).addState();
            });
        }
        row.appendChild(col);
        return row;
    }
    updateHTML() {
        if (this.input) this.input.value = this.value;
    }
}



var $gBhAd = parcelRequire("gBhAd");

class $f6aed19036c0382b$export$59215b46c4e8abd5 extends (0, $62b9e9b060ea5e43$export$9cd791b14633436b) {
    eq(first, second) {
        return first.eq(second);
    }
    min;
    max;
    step;
    label;
    sliderInput;
    numberInput;
    unitLabel;
    fractionDigits;
    integerDigits;
    restrictToRange;
    constructor(label, min, max, step, initalValue, restrictToRange = false){
        super(initalValue);
        this.label = label;
        this.min = min;
        this.max = max;
        this.step = step;
        this.restrictToRange = restrictToRange;
        if (step > 0) {
            this.fractionDigits = 0;
            let stepTemp = step;
            while(stepTemp < 1){
                stepTemp *= 10;
                this.fractionDigits += 1;
            }
        }
        this.integerDigits = 1;
        let maxDigits = Math.max(Math.abs(min), Math.abs(max));
        while(maxDigits > 1){
            this.integerDigits += 1;
            maxDigits /= 10;
        }
    }
    buildHTML() {
        let row = this.getRow();
        let col = document.createElement("div");
        col.classList.add("col-12", "my-0", "input-group");
        let distanceLabel = document.createElement("label");
        distanceLabel.classList.add("input-group-text", "fs-6");
        distanceLabel.innerHTML = this.label;
        distanceLabel.setAttribute("for", "labelDistanceSlider");
        col.appendChild(distanceLabel);
        this.sliderInput = document.createElement("input");
        this.sliderInput.classList.add("form-range", "w-25", "flex-grow-1", "h-100", "px-2", "border");
        this.sliderInput.id = "labelDistanceSlider";
        this.sliderInput.type = "range";
        this.sliderInput.min = this.min.toString();
        this.sliderInput.max = this.max.toString();
        this.sliderInput.step = this.step.toString();
        this.sliderInput.value = this.value.value.toString();
        col.appendChild(this.sliderInput);
        this.numberInput = document.createElement("input");
        this.numberInput.classList.add("form-control", "fs-6");
        this.numberInput.type = "number";
        this.numberInput.value = this.value.value.toString();
        this.numberInput.min = this.min.toString();
        this.numberInput.max = this.max.toString();
        this.numberInput.step = this.step.toString();
        col.appendChild(this.numberInput);
        let sliderChanged = ()=>{
            this.updateValue(new $gBhAd.Number(Number.parseFloat(this.sliderInput.value), this.value.unit));
            this.updateNumberInput();
        };
        let numberChanged = ()=>{
            let newValue = Number.parseFloat(this.numberInput.value);
            if (!isNaN(newValue)) {
                if (this.restrictToRange) {
                    newValue = newValue < this.min ? this.min : newValue;
                    newValue = newValue > this.max ? this.max : newValue;
                }
                this.updateValue(new $gBhAd.Number(newValue, this.value.unit));
                this.updateSliderInput();
            }
        };
        this.numberInput.addEventListener("input", numberChanged);
        this.numberInput.addEventListener("focusout", ()=>{
            this.updateNumberInput();
            (0, $815383aeedb00f00$export$897c9ed706d8ea48).addState();
        });
        this.sliderInput.addEventListener("input", sliderChanged);
        this.sliderInput.addEventListener("change", ()=>{
            (0, $815383aeedb00f00$export$897c9ed706d8ea48).addState();
        });
        if (this.value.unit) {
            this.unitLabel = distanceLabel.cloneNode(true);
            this.unitLabel.innerText = this.value.unit;
            col.appendChild(this.unitLabel);
        }
        this.updateNumberInput();
        this.updateSliderInput();
        row.appendChild(col);
        return row;
    }
    updateNumberInput() {
        this.numberInput.value = this.value.value.toString();
        if (this.unitLabel) this.unitLabel.innerText = this.value.unit;
    }
    updateSliderInput() {
        this.sliderInput.value = this.value.value.toString();
        if (this.unitLabel) this.unitLabel.innerText = this.value.unit;
    }
    updateHTML() {
        if (this.sliderInput) {
            this.updateSliderInput();
            this.updateNumberInput();
        }
    }
}



class $c66494ce03e8372a$export$4de04f378a8de0fe extends (0, $62b9e9b060ea5e43$export$9cd791b14633436b) {
    labelElement;
    eq(first, second) {
        return first == second;
    }
    buildHTML() {
        this.labelElement = document.createElement("span");
        this.labelElement.classList.add("col-12", "form-label", "mb-0", "fw-bold");
        this.labelElement.innerHTML = this.value ?? "";
        let row = this.getRow();
        row.appendChild(this.labelElement);
        return row;
    }
    updateHTML() {
        if (this.labelElement) this.labelElement.innerHTML = this.value;
    }
}



var $gBhAd = parcelRequire("gBhAd");


class $9195d5109ba85630$export$40ae678e65d951f2 extends (0, $62b9e9b060ea5e43$export$9cd791b14633436b) {
    label;
    input;
    nullable;
    enabler;
    constructor(label, initialValue, nullable = true){
        super(initialValue);
        this.label = label;
        this.nullable = nullable;
    }
    eq(first, second) {
        if (first == null && second == null || first === second) return true;
        if (first == null) return false;
        if (second == null) return false;
        let f = first.rgb();
        let s = second.rgb();
        return f.r == s.r && f.g == s.g && f.b == s.b;
    }
    buildHTML() {
        let row = this.getRow();
        let col = document.createElement("div");
        col.classList.add("col-12", "input-group", "my-0");
        {
            let labelElement = document.createElement("label");
            labelElement.classList.add("input-group-text");
            labelElement.innerHTML = this.label ?? "Choose color";
            col.appendChild(labelElement);
            if (this.nullable) {
                let enablerDiv = document.createElement("div");
                enablerDiv.classList.add("input-group-text");
                this.enabler = document.createElement("input");
                this.enabler.classList.add("form-check-input", "mt-0");
                this.enabler.setAttribute("type", "checkbox");
                this.enabler.checked = this.value !== null;
                this.enabler.addEventListener("change", (ev)=>{
                    this.updateValue(this.enabler.checked ? new $gBhAd.Color(this.input.value, "rgb") : null);
                    (0, $815383aeedb00f00$export$897c9ed706d8ea48).addState();
                });
                enablerDiv.appendChild(this.enabler);
                col.appendChild(enablerDiv);
            }
            this.input = document.createElement("input");
            this.input.classList.add("form-control", "form-control-color");
            this.input.value = this.value ? this.value.toString() : "";
            this.input.setAttribute("type", "color");
            this.input.addEventListener("input", (ev)=>{
                if (this.nullable) this.updateValue(this.enabler.checked ? new $gBhAd.Color(this.input.value, "rgb") : null);
                else this.updateValue(new $gBhAd.Color(this.input.value, "rgb"));
            });
            this.input.addEventListener("change", (ev)=>{
                (0, $815383aeedb00f00$export$897c9ed706d8ea48).addState();
            });
            col.appendChild(this.input);
        }
        row.appendChild(col);
        return row;
    }
    updateHTML() {
        if (this.value) this.input.value = this.value.toString();
        if (this.enabler) this.enabler.checked = this.value != null;
    }
}



var $gBhAd = parcelRequire("gBhAd");

var $gBhAd = parcelRequire("gBhAd");
const $d3f4ddb3e9ef991e$var$getCoordsFromEvent = (ev)=>{
    if (ev.changedTouches) ev = ev.changedTouches[0];
    return {
        x: ev.clientX,
        y: ev.clientY
    };
};
// Creates handler, saves it
class $d3f4ddb3e9ef991e$var$DragHandler {
    constructor(el){
        el.remember("_draggable", this);
        this.el = el;
        this.drag = this.drag.bind(this);
        this.startDrag = this.startDrag.bind(this);
        this.endDrag = this.endDrag.bind(this);
    }
    // Enables or disabled drag based on input
    init(enabled) {
        if (enabled) {
            this.el.on("mousedown.drag", this.startDrag);
            this.el.on("touchstart.drag", this.startDrag, {
                passive: false
            });
        } else {
            this.el.off("mousedown.drag");
            this.el.off("touchstart.drag");
        }
    }
    // Start dragging
    startDrag(ev) {
        const isMouse = !ev.type.indexOf("mouse");
        // Check for left button
        if (isMouse && ev.which !== 1 && ev.buttons !== 0) return;
        // Fire beforedrag event
        if (this.el.dispatch("beforedrag", {
            event: ev,
            handler: this
        }).defaultPrevented) return;
        // Prevent browser drag behavior as soon as possible
        ev.preventDefault();
        // Prevent propagation to a parent that might also have dragging enabled
        ev.stopPropagation();
        // Make sure that start events are unbound so that one element
        // is only dragged by one input only
        this.init(false);
        this.box = this.el.bbox();
        this.lastClick = this.el.point($d3f4ddb3e9ef991e$var$getCoordsFromEvent(ev));
        const eventMove = (isMouse ? "mousemove" : "touchmove") + ".drag";
        const eventEnd = (isMouse ? "mouseup" : "touchend") + ".drag";
        // Bind drag and end events to window
        (0, $gBhAd.on)(window, eventMove, this.drag, this, {
            passive: false
        });
        (0, $gBhAd.on)(window, eventEnd, this.endDrag, this, {
            passive: false
        });
        // Fire dragstart event
        this.el.fire("dragstart", {
            event: ev,
            handler: this,
            box: this.box
        });
    }
    // While dragging
    drag(ev) {
        const { box: box, lastClick: lastClick } = this;
        const currentClick = this.el.point($d3f4ddb3e9ef991e$var$getCoordsFromEvent(ev));
        const dx = currentClick.x - lastClick.x;
        const dy = currentClick.y - lastClick.y;
        if (!dx && !dy) return box;
        const x = box.x + dx;
        const y = box.y + dy;
        this.box = new (0, $gBhAd.Box)(x, y, box.w, box.h);
        this.lastClick = currentClick;
        if (this.el.dispatch("dragmove", {
            event: ev,
            handler: this,
            box: this.box
        }).defaultPrevented) return;
        this.move(x, y);
    }
    move(x, y) {
        // Svg elements bbox depends on their content even though they have
        // x, y, width and height - strange!
        // Thats why we handle them the same as groups
        if (this.el.type === "svg") (0, $gBhAd.G).prototype.move.call(this.el, x, y);
        else this.el.move(x, y);
    }
    endDrag(ev) {
        // final drag
        this.drag(ev);
        // fire dragend event
        this.el.fire("dragend", {
            event: ev,
            handler: this,
            box: this.box
        });
        // unbind events
        (0, $gBhAd.off)(window, "mousemove.drag");
        (0, $gBhAd.off)(window, "touchmove.drag");
        (0, $gBhAd.off)(window, "mouseup.drag");
        (0, $gBhAd.off)(window, "touchend.drag");
        // Rebind initial Events
        this.init(true);
    }
}
(0, $gBhAd.extend)((0, $gBhAd.Element), {
    draggable (enable = true) {
        const dragHandler = this.remember("_draggable") || new $d3f4ddb3e9ef991e$var$DragHandler(this);
        dragHandler.init(enable);
        return this;
    }
});




const $6a68e99136784593$export$c226b2b8dec3909c = /[\t\r\n\v.,:;()-]/;
const $6a68e99136784593$export$550f784d253b75ba = [
    {
        key: "default",
        name: "default",
        direction: new $gBhAd.Point(NaN, NaN)
    },
    {
        key: "center",
        name: "center",
        direction: new $gBhAd.Point()
    },
    {
        key: "north",
        name: "north",
        direction: new $gBhAd.Point(0, -1),
        pointer: "ns-resize"
    },
    {
        key: "south",
        name: "south",
        direction: new $gBhAd.Point(0, 1),
        pointer: "ns-resize"
    },
    {
        key: "east",
        name: "east",
        direction: new $gBhAd.Point(1, 0),
        pointer: "ew-resize"
    },
    {
        key: "west",
        name: "west",
        direction: new $gBhAd.Point(-1, 0),
        pointer: "ew-resize"
    },
    {
        key: "northeast",
        name: "north east",
        direction: new $gBhAd.Point(1, -1),
        pointer: "nesw-resize"
    },
    {
        key: "northwest",
        name: "north west",
        direction: new $gBhAd.Point(-1, -1),
        pointer: "nwse-resize"
    },
    {
        key: "southeast",
        name: "south east",
        direction: new $gBhAd.Point(1, 1),
        pointer: "nwse-resize"
    },
    {
        key: "southwest",
        name: "south west",
        direction: new $gBhAd.Point(-1, 1),
        pointer: "nesw-resize"
    }
];
const $6a68e99136784593$export$362db847193ed989 = $6a68e99136784593$export$550f784d253b75ba[0];
function $6a68e99136784593$export$8d3d621ce1a1b8e0(direction) {
    let minValue = Infinity;
    let minPointer = "move";
    $6a68e99136784593$export$550f784d253b75ba.slice(2).forEach((item)=>{
        const diffLength = item.direction.sub(direction).absSquared();
        if (diffLength < minValue) {
            minValue = diffLength;
            minPointer = item.pointer;
        }
    });
    return minPointer;
}
const $6a68e99136784593$export$fc9982435e9a3643 = "var(--bs-emphasis-color)";
const $6a68e99136784593$export$d3ce5ee02df64eaf = "var(--bs-body-bg)";
class $6a68e99136784593$export$c15be3828826f6ee {
    /**
     * the position of the circuit component
     */ position;
    /**
     * The vector from the upper left corner of the component visualization to the reference position of the component
     */ relPosition;
    /**
     * the current rotation angle in degrees
     */ rotationDeg = 0;
    /**
     * all properties, which should be able to be edited in the properties window have to be included here
     */ propertiesHTMLRows = [];
    /**
     * the name of the component (e.g. "Resistor", "Wire" or "Transformer")
     */ displayName;
    /**
     * What will be used as the reference name in the tikz code (e.g. "\node[] (name) at (0,0){};"").
     * Not used for all components, e.g. wire
     */ name;
    parentGroup = null;
    /**
     * If the component is currently selected by the selection controller
     */ _isSelected = false;
    get isSelected() {
        return this._isSelected;
    }
    set isSelected(value) {
        if (!value) {
            this.isSelectionReference = false;
            (0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.referenceComponent = null;
        }
        this._isSelected = value;
    }
    isResizing = false;
    /**
     * the cached bounding box of the component. Useful for example for the selection controller
     */ _bbox;
    /**
     * getter for the cached bounding box
     */ get bbox() {
        return this._bbox;
    }
    /**
     * the SVG.js Element which represents the visualization/graphics of the component on the canvas. Should probably always be a group containing more svg components
     */ visualization;
    selectionElement = null;
    /**
     * A List of all the Snapping points of this component
     */ snappingPoints;
    mathJaxLabel;
    labelRendering;
    labelDistance;
    labelColor;
    /**
     * The default constructor giving basic functionality. Never call this directly (only via super() in the constructor of the derived class).
     */ constructor(){
        this.position = new $gBhAd.Point();
        this.relPosition = new $gBhAd.Point();
        //every time a component is initialized, it should be added to the component list for housekeeping
        (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.addComponent(this);
        this.selectionElement = (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas.rect(0, 0).hide();
        this.selectionElement.node.classList.add("selectionElement");
        this.visualization = (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas.group();
        this.displayName = "Circuit Component";
        this.addPositioning();
        this.addZOrdering();
    }
    /**
     * Add z-index ordering to the properties window
     */ addZOrdering() {
        // all components should receive the possiblity to change their draw order/z order/depth
        let ordering = new (0, $995311ad94412d30$export$d4fc42aa08871cc3)(2, [
            [
                "Foreground",
                ""
            ],
            [
                "Background",
                ""
            ],
            [
                "Forward",
                ""
            ],
            [
                "Backward",
                ""
            ]
        ], [
            (ev)=>(0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.componentsToForeground([
                    this
                ]),
            (ev)=>(0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.componentsToBackground([
                    this
                ]),
            (ev)=>(0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.moveComponentsForward([
                    this
                ]),
            (ev)=>(0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.moveComponentsBackward([
                    this
                ])
        ]);
        this.propertiesHTMLRows.push(new (0, $c66494ce03e8372a$export$4de04f378a8de0fe)("Ordering").buildHTML());
        this.propertiesHTMLRows.push(ordering.buildHTML());
    }
    /**
     * Add rotation and flipping to the properties window
     */ addPositioning() {
        let positioning = new (0, $995311ad94412d30$export$d4fc42aa08871cc3)(2, [
            [
                "Rotate 90\xb0 CW",
                "rotate_right"
            ],
            [
                "Rotate 90\xb0 CCW",
                "rotate_left"
            ],
            [
                "Rotate 45\xb0 CW",
                "rotate_right"
            ],
            [
                "Rotate 45\xb0 CCW ",
                "rotate_left"
            ],
            [
                "Flip vertically",
                [
                    "flip",
                    "rotateText"
                ]
            ],
            [
                "Flip horizontally",
                "flip"
            ]
        ], [
            (ev)=>{
                this.rotate(-90);
                (0, $815383aeedb00f00$export$897c9ed706d8ea48).addState();
            },
            (ev)=>{
                this.rotate(90);
                (0, $815383aeedb00f00$export$897c9ed706d8ea48).addState();
            },
            (ev)=>{
                this.rotate(-45);
                (0, $815383aeedb00f00$export$897c9ed706d8ea48).addState();
            },
            (ev)=>{
                this.rotate(45);
                (0, $815383aeedb00f00$export$897c9ed706d8ea48).addState();
            },
            (ev)=>{
                this.flip(true);
                (0, $815383aeedb00f00$export$897c9ed706d8ea48).addState();
            },
            (ev)=>{
                this.flip(false);
                (0, $815383aeedb00f00$export$897c9ed706d8ea48).addState();
            }
        ]);
        this.propertiesHTMLRows.push(positioning.buildHTML());
    }
    /**
     * Add the property for the tikz name to the properties window
     */ addName() {
        this.name = new (0, $6e17b8b34300d085$export$352e63445db76668)("Name", "");
        this.name.addChangeListener((ev)=>{
            if (ev.value === "") {
                // no name is always valid
                this.name.changeInvalidStatus("");
                return;
            }
            if (ev.value.match($6a68e99136784593$export$c226b2b8dec3909c)) {
                // check if characters are valid
                this.name.changeInvalidStatus("Contains forbidden characters!");
                return;
            }
            for (const component of (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.circuitComponents){
                // check if another component with the same name already exists
                if (component != this && component.name) {
                    if (ev.value !== "" && component.name.value == ev.value) {
                        this.name.updateValue(ev.previousValue, false);
                        this.name.changeInvalidStatus("Name is already taken!");
                        return;
                    }
                }
            }
            this.name.changeInvalidStatus("");
        });
        this.propertiesHTMLRows.push(new (0, $c66494ce03e8372a$export$4de04f378a8de0fe)("TikZ name").buildHTML());
        this.propertiesHTMLRows.push(this.name.buildHTML());
    }
    /**
     * Move the component by the specified delta, i.e. the new position = old position + delta
     * @param delta by how much the component should be moved
     */ moveRel(delta) {
        this.moveTo(this.position.add(delta));
    }
    /**
     * update the graphics corresponding to the component selection visualization
     */ recalculateSelectionVisuals() {
        if (this.selectionElement) {
            let box = this.visualization.bbox().transform(this.getTransformMatrix());
            this.selectionElement.size(box.w, box.h);
            this.selectionElement.center(this.position.x, this.position.y);
        }
    }
    /**
     * Show or hide the selection visualization of the component. This has to be distinct from the actual selection state due to how the selection controller works
     * @param show if the component should appear selected or not
     */ viewSelected(show) {
        if (show) {
            (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas.put(this.selectionElement);
            this.selectionElement.show();
            this.selectionElement.stroke({
                width: (0, $429ca25d803b1e0f$export$80fcba011b33afb8),
                color: this.isSelectionReference ? (0, $429ca25d803b1e0f$export$c19757439fb239a7) : (0, $429ca25d803b1e0f$export$1617d35435c603f6),
                dasharray: "4, 2"
            }).fill("none");
            this.recalculateSelectionVisuals();
        } else this.selectionElement.hide();
    }
    isSelectionReference = false;
    setAsSelectionReference() {
        if ((0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.referenceComponent) {
            (0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.referenceComponent.isSelectionReference = false;
            (0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.referenceComponent.viewSelected((0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.referenceComponent.isSelected);
        }
        this.isSelectionReference = true;
        this.viewSelected(true);
    }
    /**
     * Checks if the component is inside the selection visualization. The default implementation is a rect-rect intersection check between the selection rectangle and the component bounding box. Override this for a more sophisticated check
     * @param selectionRectangle where the current selection is requested
     * @returns true if the selection rectangle encompases (a part of) the component
     */ isInsideSelectionRectangle(selectionRectangle) {
        return (0, $429ca25d803b1e0f$export$11f7f05b1cf6c7d0)(this.bbox, selectionRectangle);
    }
    /**
     * update the visuals to comply with dark/light mode
     */ updateTheme() {
        let labelColor = $6a68e99136784593$export$fc9982435e9a3643;
        if (this.labelColor && this.labelColor.value) labelColor = this.labelColor.value.toString();
        this.labelRendering?.fill(labelColor);
    }
    /**
     * helper method to always be between -180 and 180 degrees.
     */ simplifyRotationAngle() {
        // modulo with extra steps since js modulo is weird for negative numbers
        this.rotationDeg = ((this.rotationDeg + 180) % 360 + 360) % 360 - 180;
    }
    /**
     * Convert a ComponentSaveObject to a component. Calling CircuitComponent.fromJson(A.{@link toJson}()) should essentially produce an exact copy of the component "A". Override this in your subclass!
     * @param saveObject An object of a derived type of ComponentSaveOject, which encompasses all information necessary to initalize this component type
     */ static fromJson(saveObject) {
        throw new Error("fromJson not implemented on " + typeof this + ". Implement in derived class");
    }
    /**
     * Obtain the transformation matrix which transforms an object from the component reference to the world reference
     * @returns the transformation matrix
     */ getTransformMatrix() {
        return new $gBhAd.Matrix(this.visualization.transform());
    }
    /**
     * Update the position of all snapping points associated with this component.
     * @param matrix which matrix to use. probably the one returned by {@link getTransformMatrix}
     */ recalculateSnappingPoints(matrix) {
        for (const snappingPoint of this.snappingPoints)snappingPoint.recalculate(matrix);
    }
    // component placement code
    /**
     * if the component is finished placing down/creating
     */ finishedPlacing = false;
    /**
     * Override this if the component can be rotated while placing down. @see CircuitComponent.rotate for details
     * @param angleDeg how far to rotate
     */ placeRotate(angleDeg) {}
    /**
     * Override this if the component can be flipped while placing down. @see CircuitComponent.flip for details
     * @param horizontal on which axis to rotate
     */ placeFlip(horizontal) {}
    /**
     * Generate a label visualization via mathjax
     * @param label the data for which to generate the label visualization
     * @returns a Promise<void>
     */ async generateLabelRender() {
        // @ts-ignore
        window.MathJax.texReset();
        // @ts-ignore
        return window.MathJax.tex2svgPromise(this.mathJaxLabel.value, {}).then((node)=>{
            // mathjax renders the text via an svg container. That container also contains definitions and SVG.Use elements. get that container
            let svgElement = new $gBhAd.Svg(node.querySelector("svg"));
            // if a previous label was rendered, remove everything concerning that rendering
            if (this.labelRendering) {
                let removeIDs = new Set();
                for (const element of this.labelRendering.find("use"))removeIDs.add(element.node.getAttribute("xlink:href"));
                for (const id of removeIDs)(0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas.find(id)[0]?.remove();
            }
            // move the label definitions to the overall definitions of the canvas
            let backgroundDefs = (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas.findOne("#backgroundDefs");
            let defs = svgElement.findOne("defs");
            for (const def of defs.children())backgroundDefs.put(def);
            defs.remove();
            //1.545 magic number (how large 1em, i.e. font size, is in terms of ex) for the font used in MathJax.
            //6.5 = normal font size for tikz??? This should be 10pt for the normalsize in latex? If measuring via 2 lines 1 cm apart(28.34pt), you need 6.5pt to match up with the tikz rendering!?
            let expt = 1 / 1.545 * 6.5;
            //convert width and height from ex to pt via expt and then to px
            let widthStr = svgElement.node.getAttribute("width");
            let width = new $gBhAd.Number(new $gBhAd.Number(widthStr).value * expt, "pt").convertToUnit("px");
            let heightStr = svgElement.node.getAttribute("height");
            let height = new $gBhAd.Number(new $gBhAd.Number(heightStr).value * expt, "pt").convertToUnit("px");
            let size = new $gBhAd.Point(width.value, height.value);
            // remove unnecessary data
            for (const elementGroup of svgElement.find("use"))elementGroup.node.removeAttribute("data-c");
            let groupElements = svgElement.find("g");
            for (const elementGroup of groupElements)elementGroup.node.removeAttribute("data-mml-node");
            // remove unnecessary svg groups
            for (const elementGroup of groupElements){
                let children = elementGroup.children();
                if (children.length == 1 && !elementGroup.node.hasAttributes()) {
                    elementGroup.parent().put(children[0]);
                    elementGroup.remove();
                } else if (elementGroup.fill() == "currentColor") elementGroup.fill("inherit");
            }
            //remove background of mathjax error message
            for (const elementGroup of svgElement.find("rect"))if (elementGroup.node.hasAttribute("data-background")) elementGroup.remove();
            // the current rendering svg viewbox
            let svgViewBox = svgElement.viewbox();
            // scale such that px size is actually correct for rendering
            let scale = size.div(new $gBhAd.Point(svgViewBox.w, svgViewBox.h));
            //move the rendering to local 0,0
            let translate = new $gBhAd.Point(-svgViewBox.x, -svgViewBox.y).mul(scale);
            let m = new $gBhAd.Matrix({
                scaleX: scale.x,
                scaleY: scale.y,
                translateX: translate.x,
                translateY: translate.y
            });
            // add all symbol components to a group
            let transformGroup = new $gBhAd.G();
            for (const child of svgElement.children())transformGroup.add(child);
            // apply the transformation --> the symbol is now at the origin with the correct size and no rotation
            transformGroup.transform(m);
            // remove the current label and substitute with a new group element
            this.labelRendering?.remove();
            let rendering = new $gBhAd.G();
            rendering.addClass("pointerNone");
            rendering.add(transformGroup);
            // add the label rendering to the visualization element
            this.visualization.add(rendering);
            this.labelRendering = rendering;
            this.update();
            this.updateTheme();
        });
    }
    requiredTikzLibraries() {
        return [];
    }
}



var $gBhAd = parcelRequire("gBhAd");

class $d4d1133581bf36e7$export$63512bbf9a12b35d extends (0, $6a68e99136784593$export$c15be3828826f6ee) {
    referenceSymbol;
    /**
     * which static symbol is used from the symbol database (i.e. src/data/symbols.svg)
     */ symbolUse;
    //the untransformed bounding box of the symbol use
    symbolBBox;
    scaleProperty;
    scaleState;
    /**
     * The reference to the symbol library component. Has metadata of the symbol
     * @param symbol which static symbol from the symbols.svg library to use
     */ constructor(symbol){
        super();
        this.displayName = symbol.displayName;
        this.referenceSymbol = symbol;
        this.symbolUse = (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas.use(symbol);
        this.symbolUse.fill((0, $6a68e99136784593$export$d3ce5ee02df64eaf));
        this.symbolUse.stroke((0, $6a68e99136784593$export$fc9982435e9a3643));
        this.symbolUse.node.style.color = (0, $6a68e99136784593$export$fc9982435e9a3643);
        this.symbolBBox = this.referenceSymbol.viewBox;
        this.scaleState = new $gBhAd.Point(1, 1);
        this.scaleProperty = new (0, $f6aed19036c0382b$export$59215b46c4e8abd5)("Scale", 0.1, 10, 0.01, new $gBhAd.Number(1), true);
        this.scaleProperty.addChangeListener((ev)=>{
            this.scaleState = new $gBhAd.Point(Math.sign(this.scaleState.x) * ev.value.value, Math.sign(this.scaleState.y) * ev.value.value);
            this.update();
        });
        this.propertiesHTMLRows.push(this.scaleProperty.buildHTML());
    }
    addInfo() {
        this.propertiesHTMLRows.push(new (0, $c66494ce03e8372a$export$4de04f378a8de0fe)("Info").buildHTML());
        // the tikz id of the component. e.g. "nmos" in "\node[nmos] at (0,0){};"
        this.propertiesHTMLRows.push(new (0, $7a449c719f5814b3$export$12d4a743130a3a26)("ID", this.referenceSymbol.tikzName).buildHTML());
        // if options are used for the component, they will also be shown
        let tikzOptions = Array.from(this.referenceSymbol._tikzOptions.keys()).join(", ");
        if (tikzOptions && tikzOptions.length > 0) this.propertiesHTMLRows.push(new (0, $7a449c719f5814b3$export$12d4a743130a3a26)("Options", tikzOptions).buildHTML());
    }
    toSVG(defs) {
        let symbolID = this.referenceSymbol.id();
        if (!defs.has(symbolID)) {
            const symbol = this.referenceSymbol.clone(true, false);
            symbol.removeElement(symbol.find("metadata")[0]);
            symbol.removeElement(symbol.find('ellipse[stroke="none"][fill="transparent"]')[0]);
            defs.set(symbolID, symbol);
        }
        this.labelRendering?.addClass("labelRendering");
        const copiedSVG = this.visualization.clone(true);
        if (this.labelRendering) {
            this.labelRendering.removeClass("labelRendering");
            if (!this.mathJaxLabel.value) copiedSVG.removeElement(copiedSVG.find(".labelRendering")[0]);
            else for (const use of copiedSVG.find(".labelRendering")[0].find("use")){
                const id = use.node.getAttribute("xlink:href");
                if (!defs.has(id)) defs.set(id, (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas.find(id)[0].clone(true, false));
            }
            copiedSVG.findOne(".labelRendering")?.removeClass("labelRendering");
        }
        return copiedSVG;
    }
}




class $08259c81b533024d$export$c564803d81ad3eaf {
    //singleton
    static _instance;
    /**
     * the currently placing component
     */ _component;
    get component() {
        return this._component;
    }
    constructor(){
        this.placeStep = this.placeStep.bind(this);
        this.placeMove = this.placeMove.bind(this);
        this.placeFinish = this.placeFinish.bind(this);
    }
    static get instance() {
        return $08259c81b533024d$export$c564803d81ad3eaf._instance ?? ($08259c81b533024d$export$c564803d81ad3eaf._instance = new $08259c81b533024d$export$c564803d81ad3eaf());
    }
    static pointFromEvent(ev) {
        let pt = (0, $1c90e793f342bb2a$export$88e1240f06a672d2).eventToPoint(ev, false);
        // let pt:SVG.Point = new SVG.Point(ev.clientX, ev.clientY).transform(component.visualization.screenCTM().inverseO())
        if (!ev.shiftKey) pt = (0, $53f326ae950d374f$export$6c6ec69acef94984).instance.snapPoint(pt, $08259c81b533024d$export$c564803d81ad3eaf.instance.component);
        return pt;
    }
    /**
     * Initiate one placement step
     * @param ev which event is responsible for the placement step
     */ placeStep(ev) {
        if (ev instanceof MouseEvent && ev.button !== 0) return;
        if (window.TouchEvent && ev instanceof TouchEvent && ev.touches.length !== 0) return;
        let pt = $08259c81b533024d$export$c564803d81ad3eaf.pointFromEvent(ev);
        if (this.component.placeStep(pt, ev)) this.placeFinish(ev);
        (0, $53f326ae950d374f$export$6c6ec69acef94984).instance.recalculateAdditionalSnapPoints();
    }
    /**
     * Move the cursor/pointer/... while placing a component
     * @param ev which event is responsible for the movement
     */ placeMove(ev) {
        let pt = $08259c81b533024d$export$c564803d81ad3eaf.pointFromEvent(ev);
        this.component.placeMove(pt, ev);
        (0, $53f326ae950d374f$export$6c6ec69acef94984).instance.recalculateAdditionalSnapPoints();
    }
    /**
     * Rotate the component while placing
     * @param angleDeg angle in degrees
     */ placeRotate(angleDeg) {
        if (this.component) this.component.placeRotate(angleDeg);
    }
    /**
     * Flip the component while placing
     * @param horizontal which axis to flip at
     */ placeFlip(horizontal) {
        if (this.component) this.component.placeFlip(horizontal);
    }
    /**
     * (Force) finish the component placement
     */ placeFinish(ev) {
        if (this.component) {
            this.component.placeFinish();
            this.cleanUp();
            (0, $815383aeedb00f00$export$897c9ed706d8ea48).addState();
            // restart component placement for just finished component
            if (window.TouchEvent && !(ev instanceof TouchEvent)) this.placeComponent(this.component.copyForPlacement());
            else {
                this._component = null;
                (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.switchMode((0, $177c4dcfaec5a17b$export$43660d87cb080eb).DRAG_PAN);
            }
        }
    }
    /**
     * cancel the component placement
     * @param ev which event is responsible for the cancellastion
     */ placeCancel(ev) {
        let component = this.component;
        if (component) {
            component.placeFinish();
            (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.removeComponent(component);
            this._component = null;
        }
        this.cleanUp();
        (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.switchMode((0, $177c4dcfaec5a17b$export$43660d87cb080eb).DRAG_PAN);
    }
    /**
     * Get rid of now not needed event listeners
     */ cleanUp() {
        (0, $53f326ae950d374f$export$6c6ec69acef94984).instance.hideSnapPoints();
        //remove event listeners
        let canvas = (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas;
        canvas.off("mousemove", this.placeMove);
        canvas.off("touchmove", this.placeMove);
        canvas.off("mouseup", this.placeStep);
        canvas.off("touchend", this.placeStep);
        // canvas.off("dblclick",this.placeFinish)
        (0, $29d702d7ef9ce022$export$2e2bcd8739ae039).unbind("enter", this.placeFinish);
    }
    /**
     * Place a new Component. The component should be an initialized instance of a CircuitComponent
     * @param component which component to place
     */ placeComponent(component) {
        (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.switchMode((0, $177c4dcfaec5a17b$export$43660d87cb080eb).COMPONENT);
        this._component = component;
        (0, $53f326ae950d374f$export$6c6ec69acef94984).instance.updateSnapPoints(component, false);
        (0, $53f326ae950d374f$export$6c6ec69acef94984).instance.showSnapPoints();
        (0, $49e4d67b0180648f$export$b621f8acc59d25dc).instance.update();
        // add event listeners to canvas
        let canvas = (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas;
        canvas.on("mousemove", this.placeMove);
        canvas.on("touchmove", this.placeMove);
        canvas.on("mouseup", this.placeStep);
        canvas.on("touchend", this.placeStep);
        // canvas.on("dblclick",this.placeFinish)
        (0, $29d702d7ef9ce022$export$2e2bcd8739ae039)("enter", {
            keyup: false,
            keydown: true
        }, this.placeFinish);
        // move once to actually place the component at the mouse position
        this.component.placeMove((0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.lastCanvasPoint);
        (0, $53f326ae950d374f$export$6c6ec69acef94984).instance.recalculateAdditionalSnapPoints();
    }
}



var $gBhAd = parcelRequire("gBhAd");

/**
 * Useful functions for traversing an DOM or XML tree.
 * @module xmlHelper
 */ //-- Helper functions
/**
 * Searches a child node by name and by an additional filter if present.
 *
 * @param {Element} root - the root node to find the child
 * @param {string} tagName - the name of the xml tag to find; compared ignoring case
 * @param {string} [namespaceURI] - compare the namespace; case sensitive
 * @param {function(Element): boolean} [additionalFilter] - filter function returning true if node matches the criteria
 * @returns {Element|null} the found node or null if not found
 */ function $83b954acf0eb1e25$export$924335e4648042a8(root, tagName, namespaceURI, additionalFilter = null) {
    tagName = tagName.toLowerCase();
    return Array.prototype.find.call(root.children, (node)=>// node.nodeType === Node.ELEMENT_NODE && // node instanceof Element; not needed if .children is used
        (namespaceURI ? tagName == node.localName.toLowerCase() && namespaceURI == node.namespaceURI : node.tagName.toLowerCase() === tagName) && (!additionalFilter || additionalFilter(node)));
}
function $83b954acf0eb1e25$export$ded8fccd39a29608(root, tagName, namespaceURI, additionalFilter = null) {
    return Array.prototype.filter.call(/** @type {HTMLCollection} */ root.children, (/** @type {Element} */ node)=>(namespaceURI ? tagName == node.localName.toLowerCase() && namespaceURI == node.namespaceURI : node.tagName.toLowerCase() === tagName) && (!additionalFilter || additionalFilter(node)));
}



const $c403c181e5389b40$var$METADATA_NAMESPACE_URI = "urn:uuid:c93d8327-175d-40b7-bdf7-03205e4f8fc3";
class $c403c181e5389b40$export$5ce304d64fdbcc11 extends $gBhAd.Symbol {
    svgMetadataElement;
    /**
     * what the component is called
     */ displayName;
    /**
     * the tikz id
     */ tikzName;
    /**
     * in which group the symbol is located
     */ groupName;
    /**
     * the delta of the component position relative to the upper left corner of the symbol
     */ relMid;
    viewBox;
    isNodeSymbol;
    /**
     * which tikz options where used for this symbol
     */ _tikzOptions;
    _pins = [];
    _additionalAnchors = [];
    /**
     * where the text should be placed
     */ _textPosition = null;
    _defaultAnchor = null;
    maxStroke = 0;
    /**
     * Creates a new symbol from a `SVGSymbolElement`.
     *
     * @param {SVGSymbolElement} symbolElement - the element containing the symbol & metadata
     * @param {SymbolBaseInformation} [baseInformation] - base information if already extracted using {@link getBaseInformation}
     * @throws {Error} if the XML structure lacks the required metadata
     */ constructor(symbolElement, baseInformation){
        super(symbolElement);
        // parse information in componentInformation attributes, if not done already
        if (!baseInformation) baseInformation = $c403c181e5389b40$export$5ce304d64fdbcc11.getBaseInformation(symbolElement);
        if (!baseInformation.svgMetadataElement || !baseInformation.displayName || !baseInformation.tikzName) throw new Error("Missing metadata for creating the component");
        this.isNodeSymbol = baseInformation.isNode;
        this.svgMetadataElement = baseInformation.svgMetadataElement;
        this.displayName = baseInformation.displayName;
        this.tikzName = baseInformation.tikzName;
        this.groupName = baseInformation.groupName;
        this.relMid = baseInformation.mid;
        this.viewBox = baseInformation.viewBox;
        this.maxStroke = baseInformation.maxStroke;
        // parse additional options (key, value or just key)
        let tikzOptions = baseInformation.componentInformation && (0, $83b954acf0eb1e25$export$924335e4648042a8)(baseInformation.componentInformation, "tikzOptions", $c403c181e5389b40$var$METADATA_NAMESPACE_URI);
        let tikzOptionArray = tikzOptions ? (0, $83b954acf0eb1e25$export$ded8fccd39a29608)(tikzOptions, "option", $c403c181e5389b40$var$METADATA_NAMESPACE_URI) : [];
        this._tikzOptions = new Map(tikzOptionArray.map((rawOption)=>{
            const key = rawOption?.getAttribute("key") ?? null;
            const value = rawOption?.getAttribute("value") ?? null;
            return [
                key,
                value
            ];
        }));
        // parse pins & anchors
        let pins = baseInformation.componentInformation && (0, $83b954acf0eb1e25$export$924335e4648042a8)(baseInformation.componentInformation, "pins", $c403c181e5389b40$var$METADATA_NAMESPACE_URI);
        let pinArray = pins ? (0, $83b954acf0eb1e25$export$ded8fccd39a29608)(pins, "pin", $c403c181e5389b40$var$METADATA_NAMESPACE_URI) : [];
        this._pins = pinArray.map(this.parseAnchor, this);
        let additionalAnchors = baseInformation.componentInformation && (0, $83b954acf0eb1e25$export$924335e4648042a8)(baseInformation.componentInformation, "additionalAnchors", $c403c181e5389b40$var$METADATA_NAMESPACE_URI);
        let additionalAnchorArray = additionalAnchors ? (0, $83b954acf0eb1e25$export$ded8fccd39a29608)(additionalAnchors, "anchor", $c403c181e5389b40$var$METADATA_NAMESPACE_URI) : [];
        this._additionalAnchors = additionalAnchorArray.map(this.parseAnchor, this);
        this._textPosition = this._additionalAnchors.find((tikzanchor)=>{
            tikzanchor.name;
        }) ?? this._defaultAnchor;
    }
    /**
     * Extract base information/metadata of a `SVGSymbolElement`.
     * @param {SVGSymbolElement} symbolElement - the element to extract the information from
     * @returns {SymbolBaseInformation} the extracted information
     */ static getBaseInformation(symbolElement) {
        /** @type {?SVGMetadataElement} */ const svgMetadataElement = Array.prototype.find.call(symbolElement.children, (e)=>e instanceof SVGMetadataElement) ?? null;
        // parse symbol
        const componentInformation = svgMetadataElement && (0, $83b954acf0eb1e25$export$924335e4648042a8)(svgMetadataElement, "componentinformation", $c403c181e5389b40$var$METADATA_NAMESPACE_URI);
        // parse information in componentInformation attributes
        const isNode = componentInformation?.getAttribute("type") === "node";
        const isPath = componentInformation?.getAttribute("type") === "path";
        const tikzName = componentInformation?.getAttribute("tikzName") ?? null;
        const displayName = componentInformation?.getAttribute("displayName") ?? tikzName;
        const shapeName = componentInformation?.getAttribute("shapeName") ?? null;
        const groupName = componentInformation?.getAttribute("groupName") ?? null;
        let maxStroke = 0;
        if (symbolElement.id) {
            // udpate the bbox for a tighter fit
            symbolElement.querySelectorAll("[stroke-width]").forEach((item)=>{
                let strokeWidth = Number.parseFloat(item.getAttribute("stroke-width"));
                maxStroke = strokeWidth > maxStroke ? strokeWidth : maxStroke;
            });
            let use = (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas.use(symbolElement.id);
            let usenode = use.node;
            const domrect = usenode.getBBox({
                stroke: true
            });
            use.remove();
            let box = new $gBhAd.Box(domrect.x, domrect.y, domrect.width, domrect.height);
            componentInformation.setAttribute("viewBox", box.toString());
        }
        const mid = new $gBhAd.Point((0, $d1e874fdf778928a$export$82fd0165357841b8)(componentInformation?.getAttribute("refX") || 0), (0, $d1e874fdf778928a$export$82fd0165357841b8)(componentInformation?.getAttribute("refY") || 0));
        let viewBox;
        if (componentInformation?.hasAttribute("viewBox")) viewBox = new $gBhAd.Box(componentInformation.getAttribute("viewBox"));
        else if (symbolElement.hasAttribute("viewBox")) viewBox = new $gBhAd.Box(symbolElement.getAttribute("viewBox"));
        else viewBox = null;
        return {
            svgMetadataElement: svgMetadataElement,
            componentInformation: componentInformation,
            isNode: isNode,
            isPath: isPath,
            displayName: displayName,
            tikzName: tikzName,
            shapeName: shapeName,
            groupName: groupName,
            mid: mid,
            viewBox: viewBox,
            maxStroke: maxStroke
        };
    }
    /**
     * Parses an anchor (pin, anchor and textPosition). If `isDefault` is set, `this.defaultAnchor` will be set.
     *
     * @param {Element} anchorElement - the element to parse
     * @returns {TikZAnchor} the parsed anchor
     */ parseAnchor(anchorElement) {
        const numberRegEx = /^(\d*\.)?\d+$/; // "1", ".1", "1.1"; but not "1."
        let anchor = {
            name: anchorElement.getAttribute("anchorName") || anchorElement.getAttribute("anchorname") || undefined,
            x: new $gBhAd.Number(anchorElement.getAttribute("x")),
            y: new $gBhAd.Number(anchorElement.getAttribute("y")),
            isDefault: Boolean(anchorElement.getAttribute("isDefault")) || Boolean(anchorElement.getAttribute("isdefault")) || false
        };
        if (typeof anchor.x === "string" && numberRegEx.test(anchor.x)) anchor.x = new $gBhAd.Number(anchor.x);
        if (typeof anchor.y === "string" && numberRegEx.test(anchor.y)) anchor.y = new $gBhAd.Number(anchor.y);
        if (typeof anchor.isDefault !== "boolean") anchor.isDefault = anchor.isDefault === "true";
        anchor.point = new $gBhAd.Point((0, $d1e874fdf778928a$export$82fd0165357841b8)(anchor.x), (0, $d1e874fdf778928a$export$82fd0165357841b8)(anchor.y));
        if (anchor.isDefault) this._defaultAnchor = anchor;
        return anchor;
    }
    /**
     * Serializes the CircuiTikZ-options in the syntax "keyWithoutValue, keyWith=Value, ...".
     *
     * @returns {string} - the serialized options
     */ serializeTikzOptions() {
        return Array.from(this._tikzOptions.entries(), ([key, value])=>value ? key + "=" + value : key).join(", ");
    }
}



var $gBhAd = parcelRequire("gBhAd");


class $6bd671163c60be4d$export$a997d0ef89e7a9bb extends (0, $d4d1133581bf36e7$export$63512bbf9a12b35d) {
    anchorChoice;
    positionChoice;
    constructor(symbol){
        super(symbol);
        this.position = new $gBhAd.Point();
        this.relPosition = symbol.relMid;
        this.visualization.add(this.symbolUse);
        this.rotationDeg = 0;
        //label section
        this.propertiesHTMLRows.push(new (0, $c66494ce03e8372a$export$4de04f378a8de0fe)("Label").buildHTML());
        this.mathJaxLabel = new (0, $5d2a441813f0d40b$export$bf18630312dd3447)();
        this.mathJaxLabel.addChangeListener((ev)=>this.generateLabelRender());
        this.propertiesHTMLRows.push(this.mathJaxLabel.buildHTML());
        this.anchorChoice = new (0, $e40ab772a0133b83$export$cb4430aa1f2c59e4)("Anchor", (0, $6a68e99136784593$export$550f784d253b75ba), (0, $6a68e99136784593$export$362db847193ed989));
        this.anchorChoice.addChangeListener((ev)=>this.updateLabelPosition());
        this.propertiesHTMLRows.push(this.anchorChoice.buildHTML());
        this.positionChoice = new (0, $e40ab772a0133b83$export$cb4430aa1f2c59e4)("Position", (0, $6a68e99136784593$export$550f784d253b75ba), (0, $6a68e99136784593$export$362db847193ed989));
        this.positionChoice.addChangeListener((ev)=>this.updateLabelPosition());
        this.propertiesHTMLRows.push(this.positionChoice.buildHTML());
        this.labelDistance = new (0, $f6aed19036c0382b$export$59215b46c4e8abd5)("Gap", -0.5, 1, 0.01, new $gBhAd.Number(0.12, "cm"));
        this.labelDistance.addChangeListener((ev)=>this.updateLabelPosition());
        this.propertiesHTMLRows.push(this.labelDistance.buildHTML());
        this.labelColor = new (0, $9195d5109ba85630$export$40ae678e65d951f2)("Color", null);
        this.labelColor.addChangeListener((ev)=>{
            this.updateTheme();
        });
        this.propertiesHTMLRows.push(this.labelColor.buildHTML());
        this.addName();
        this.addInfo();
        this.snappingPoints = symbol._pins.map((pin)=>new (0, $817613c536c3a4d7$export$a1e3a3b1875fcddc)(this, pin.name, pin.point.add(this.referenceSymbol.relMid)));
    }
    getTransformMatrix() {
        const symbolRel = this.referenceSymbol.relMid;
        return new $gBhAd.Matrix({
            scaleX: this.scaleState.x,
            scaleY: this.scaleState.y,
            translate: [
                -symbolRel.x,
                -symbolRel.y
            ],
            origin: [
                symbolRel.x,
                symbolRel.y
            ]
        }).lmultiply(new $gBhAd.Matrix({
            rotate: -this.rotationDeg,
            translate: [
                this.position.x,
                this.position.y
            ]
        }));
    }
    recalculateSnappingPoints() {
        super.recalculateSnappingPoints();
    }
    getSnappingInfo() {
        return {
            trackedSnappingPoints: this.snappingPoints,
            additionalSnappingPoints: [
                new (0, $817613c536c3a4d7$export$a1e3a3b1875fcddc)(this, "center", this.referenceSymbol.relMid)
            ]
        };
    }
    update() {
        let m = this.getTransformMatrix();
        this.symbolUse.transform(m);
        this._bbox = this.symbolBBox.transform(m);
        this.updateLabelPosition();
        this.relPosition = this.position.sub(new $gBhAd.Point(this._bbox.x, this._bbox.y));
        this.recalculateSelectionVisuals();
        this.recalculateSnappingPoints();
    }
    recalculateSelectionVisuals() {
        if (this.selectionElement.visible()) {
            // use the saved position instead of the bounding box (bbox position fails in safari)
            let bbox = this.symbolBBox;
            let maxStroke = this.referenceSymbol.maxStroke;
            this.selectionElement.size(bbox.w + maxStroke + (0, $429ca25d803b1e0f$export$80fcba011b33afb8), bbox.h + maxStroke + (0, $429ca25d803b1e0f$export$80fcba011b33afb8)).transform(this.getTransformMatrix().multiply(new $gBhAd.Matrix({
                translate: [
                    bbox.x - ((0, $429ca25d803b1e0f$export$80fcba011b33afb8) + maxStroke) / 2,
                    bbox.y - ((0, $429ca25d803b1e0f$export$80fcba011b33afb8) + maxStroke) / 2
                ]
            })));
        }
    }
    moveTo(position) {
        this.position = position.clone();
        this.update();
    }
    rotate(angleDeg) {
        this.rotationDeg += angleDeg;
        this.simplifyRotationAngle();
        this.update();
    }
    flip(horizontal) {
        if (horizontal) {
            this.scaleState.y *= -1;
            this.rotationDeg *= -1;
        } else {
            this.scaleState.y *= -1;
            this.rotationDeg = 180 - this.rotationDeg;
        }
        this.simplifyRotationAngle();
        this.update();
    }
    toJson() {
        let data = {
            type: "node",
            id: this.referenceSymbol.node.id,
            position: this.position.simplifyForJson()
        };
        if (this.rotationDeg !== 0) data.rotation = this.rotationDeg;
        if (this.scaleState && (this.scaleState.x != 1 || this.scaleState.y != 1)) data.scale = this.scaleState;
        if (this.name.value) data.name = this.name.value;
        if (this.mathJaxLabel.value) {
            let labelWithoutRender = {
                value: this.mathJaxLabel.value,
                anchor: this.anchorChoice.value.key,
                position: this.positionChoice.value.key,
                distance: this.labelDistance.value ?? undefined,
                color: this.labelColor.value ? this.labelColor.value.toString() : undefined
            };
            data.label = labelWithoutRender;
        }
        return data;
    }
    toTikzString() {
        const optionsString = this.referenceSymbol.serializeTikzOptions();
        let id = this.name.value;
        if (!id && this.mathJaxLabel.value) id = (0, $fc0737f7a4e7c327$export$96be6e195c19e554).instance.createExportID("N");
        let labelNodeStr = "";
        if (this.mathJaxLabel.value) {
            let labelStr = "anchor=" + this.labelPos.name;
            let labelDist = this.labelDistance.value.convertToUnit("cm");
            if (!isNaN(this.labelPos.direction.absSquared())) labelDist = labelDist.minus(0.12);
            let labelShift = this.labelPos.direction.mul(-labelDist.value);
            let posShift = "";
            if (labelShift.x !== 0) posShift += "xshift=" + (0, $429ca25d803b1e0f$export$5b0dabb733625ce9)(labelShift.x) + "cm";
            if (labelShift.y !== 0) {
                posShift += posShift == "" ? "" : ", ";
                posShift += "yshift=" + (0, $429ca25d803b1e0f$export$5b0dabb733625ce9)(-labelShift.y) + "cm";
            }
            posShift = posShift == "" ? "" : "[" + posShift + "]";
            let pos = (0, $6a68e99136784593$export$362db847193ed989).name;
            if (this.positionChoice.value.key != "default") {
                let newdir = this.positionChoice.value.direction.transform(new $gBhAd.Matrix({
                    rotate: this.rotationDeg,
                    scaleX: this.scaleState.x,
                    scaleY: this.scaleState.y
                }));
                newdir = new $gBhAd.Point(Math.round(newdir.x), Math.round(newdir.y));
                pos = (0, $6a68e99136784593$export$550f784d253b75ba).find((item)=>item.direction.eq(newdir)).name;
            }
            let posStr = this.positionChoice.value.key == (0, $6a68e99136784593$export$362db847193ed989).key ? id + ".text" : id + "." + pos;
            let latexStr = this.mathJaxLabel.value ? "$" + this.mathJaxLabel.value + "$" : "";
            latexStr = latexStr && this.labelColor.value ? "\\textcolor" + this.labelColor.value.toTikzString() + "{" + latexStr + "}" : latexStr;
            labelNodeStr = " node[" + labelStr + "] at (" + posShift + posStr + "){" + latexStr + "}";
        }
        //don't change the order of scale and rotate!!! otherwise tikz render and UI are not the same
        return "\\draw node[" + this.referenceSymbol.tikzName + (optionsString ? ", " + optionsString : "") + (this.rotationDeg !== 0 ? `, rotate=${this.rotationDeg}` : "") + (this.scaleState.x != 1 ? `, xscale=${this.scaleState.x}` : "") + (this.scaleState.y != 1 ? `, yscale=${this.scaleState.y}` : "") + "] " + (id ? "(" + id + ") " : "") + "at " + this.position.toTikzString() + " {}" + labelNodeStr + ";";
    }
    remove() {
        (0, $c9646859e7f18723$export$b3f9f45765e2792d).snapDrag(this, false);
        this.selectionElement?.remove();
        this.visualization.remove();
        this.viewSelected(false);
        this.labelRendering?.remove();
    }
    draggable(drag) {
        if (drag) this.visualization.node.classList.add("draggable");
        else this.visualization.node.classList.remove("draggable");
        (0, $c9646859e7f18723$export$b3f9f45765e2792d).snapDrag(this, drag, this.symbolUse);
    }
    resizable(resize) {
        throw new Error("Method not implemented.");
    }
    recalculateResizePoints() {
        throw new Error("Method not implemented.");
    }
    placeMove(pos) {
        this.moveTo(pos);
    }
    placeRotate(angleDeg) {
        this.rotate(angleDeg);
    }
    placeFlip(horizontal) {
        this.flip(horizontal);
    }
    placeStep(pos) {
        this.moveTo(pos);
        return true;
    }
    placeFinish() {
        // make draggable
        this.draggable(true);
        this.update();
        this.finishedPlacing = true;
    }
    static fromJson(saveObject) {
        let symbol = (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.symbols.find((value, index, symbols)=>value.node.id == saveObject.id);
        let nodeComponent = new $6bd671163c60be4d$export$a997d0ef89e7a9bb(symbol);
        nodeComponent.moveTo(new $gBhAd.Point(saveObject.position));
        if (saveObject.rotation) nodeComponent.rotationDeg = saveObject.rotation;
        if (saveObject.scale) {
            nodeComponent.scaleState = new $gBhAd.Point(saveObject.scale);
            nodeComponent.scaleProperty.updateValue(new $gBhAd.Number(Math.abs(saveObject.scale.x)), true);
        }
        if (saveObject.name) nodeComponent.name.updateValue(saveObject.name, true);
        if (saveObject.label) {
            if (Object.hasOwn(saveObject.label, "value")) {
                nodeComponent.labelDistance.value = saveObject.label.distance ? new $gBhAd.Number(saveObject.label.distance) : new $gBhAd.Number(0);
                nodeComponent.labelDistance.updateHTML();
                nodeComponent.anchorChoice.value = saveObject.label.anchor ? (0, $6a68e99136784593$export$550f784d253b75ba).find((item)=>item.key == saveObject.label.anchor) : (0, $6a68e99136784593$export$362db847193ed989);
                nodeComponent.anchorChoice.updateHTML();
                nodeComponent.positionChoice.value = saveObject.label.position ? (0, $6a68e99136784593$export$550f784d253b75ba).find((item)=>item.key == saveObject.label.position) : (0, $6a68e99136784593$export$362db847193ed989);
                nodeComponent.positionChoice.updateHTML();
                nodeComponent.mathJaxLabel.value = saveObject.label.value;
                nodeComponent.mathJaxLabel.updateHTML();
                nodeComponent.labelColor.value = saveObject.label.color ? new $gBhAd.Color(saveObject.label.color) : null;
                nodeComponent.labelColor.updateHTML();
                nodeComponent.generateLabelRender();
            } else //@ts-ignore
            nodeComponent.mathJaxLabel.value = saveObject.label;
        }
        nodeComponent.placeFinish();
        return nodeComponent;
    }
    copyForPlacement() {
        let newComponent = new $6bd671163c60be4d$export$a997d0ef89e7a9bb(this.referenceSymbol);
        newComponent.rotationDeg = this.rotationDeg;
        newComponent.scaleState = new $gBhAd.Point(this.scaleState);
        return newComponent;
    }
    labelPos;
    updateLabelPosition() {
        if (!this.mathJaxLabel.value || !this.labelRendering) return;
        let labelSVG = this.labelRendering;
        let transformMatrix = this.getTransformMatrix();
        // get relevant positions and bounding boxes
        let textPosNoTrans;
        if (this.positionChoice.value.key == (0, $6a68e99136784593$export$362db847193ed989).key) textPosNoTrans = this.referenceSymbol._textPosition.point.add(this.referenceSymbol.relMid);
        else {
            let bboxHalfSize = new $gBhAd.Point(this.symbolBBox.w / 2, this.symbolBBox.h / 2);
            textPosNoTrans = bboxHalfSize.add(bboxHalfSize.mul(this.positionChoice.value.direction));
        }
        let textPos = textPosNoTrans.transform(transformMatrix);
        let labelBBox = labelSVG.bbox();
        // calculate where on the label the anchor point should be
        let labelRef;
        let labelDist = this.labelDistance.value.convertToUnit("px").value ?? 0;
        if (this.anchorChoice.value.key == (0, $6a68e99136784593$export$362db847193ed989).key) {
            let clamp = function(value, min, max) {
                if (value < min) return min;
                else if (value > max) return max;
                else return value;
            };
            let useBBox = this.symbolUse.bbox();
            let horizontalTextPosition = clamp(Math.round(2 * (useBBox.cx - textPosNoTrans.x) / useBBox.w), -1, 1);
            let verticalTextPosition = clamp(Math.round(2 * (useBBox.cy - textPosNoTrans.y) / useBBox.h), -1, 1);
            labelRef = new $gBhAd.Point(horizontalTextPosition, verticalTextPosition).rotate(this.rotationDeg);
            labelRef.x = Math.round(labelRef.x);
            labelRef.y = Math.round(labelRef.y);
            //reset to center before actually checking where it should go
            this.labelPos = (0, $6a68e99136784593$export$550f784d253b75ba).find((item)=>item.direction.eq(labelRef));
        } else {
            this.labelPos = this.anchorChoice.value;
            labelRef = this.labelPos.direction;
        }
        let ref = labelRef.add(1).div(2).mul(new $gBhAd.Point(labelBBox.w, labelBBox.h)).add(labelRef.mul(labelDist));
        // acutally move the label
        let movePos = textPos.sub(ref);
        labelSVG.transform(new $gBhAd.Matrix({
            translate: [
                movePos.x,
                movePos.y
            ]
        }));
    }
}



var $gBhAd = parcelRequire("gBhAd");


class $f522b793724e8edf$export$e522ece2f5c9b780 extends (0, $d4d1133581bf36e7$export$63512bbf9a12b35d) {
    posStart;
    posEnd;
    startLine;
    endLine;
    dragStartLine;
    dragEndLine;
    relSymbolStart;
    relSymbolEnd;
    pointsPlaced = 0;
    startSVG;
    endSVG;
    mirror;
    invert;
    labelSide;
    constructor(symbol){
        super(symbol);
        (0, $a0a429836785e44a$export$5d153f96fe924d6e).instance.visible = true;
        let startPinIndex = symbol._pins.findIndex((value)=>value.name === "START");
        let endPinIndex = symbol._pins.findIndex((value)=>value.name === "END");
        this.relSymbolStart = symbol._pins.at(startPinIndex).point;
        this.relSymbolEnd = symbol._pins.at(endPinIndex).point;
        this.startLine = (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas.line().fill("none").stroke({
            color: (0, $6a68e99136784593$export$fc9982435e9a3643),
            width: 0.5
        });
        this.endLine = this.startLine.clone(true);
        this.dragStartLine = (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas.line().fill("none").stroke({
            width: (0, $429ca25d803b1e0f$export$10606941daa6e712),
            color: "transparent"
        });
        this.dragEndLine = this.dragStartLine.clone(true);
        this.visualization.add(this.symbolUse);
        this.visualization.add(this.startLine);
        this.visualization.add(this.endLine);
        this.visualization.add(this.dragStartLine);
        this.visualization.add(this.dragEndLine);
        this.visualization.hide();
        //label section
        this.propertiesHTMLRows.push(new (0, $c66494ce03e8372a$export$4de04f378a8de0fe)("Label").buildHTML());
        this.mathJaxLabel = new (0, $5d2a441813f0d40b$export$bf18630312dd3447)();
        this.mathJaxLabel.addChangeListener((ev)=>this.generateLabelRender());
        this.propertiesHTMLRows.push(this.mathJaxLabel.buildHTML());
        this.labelDistance = new (0, $f6aed19036c0382b$export$59215b46c4e8abd5)("Gap", -0.5, 1, 0.01, new $gBhAd.Number(0.12, "cm"));
        this.labelDistance.addChangeListener((ev)=>this.updateLabelPosition());
        this.propertiesHTMLRows.push(this.labelDistance.buildHTML());
        this.labelColor = new (0, $9195d5109ba85630$export$40ae678e65d951f2)("Color", null);
        this.labelColor.addChangeListener((ev)=>{
            this.updateTheme();
        });
        this.propertiesHTMLRows.push(this.labelColor.buildHTML());
        this.labelSide = new (0, $155dcbbe154f2d95$export$2b4dce27390864c7)("Switch side");
        this.labelSide.addChangeListener((ev)=>this.updateLabelPosition());
        this.propertiesHTMLRows.push(this.labelSide.buildHTML());
        this.propertiesHTMLRows.push(new (0, $c66494ce03e8372a$export$4de04f378a8de0fe)("Symbol Orientation").buildHTML());
        this.mirror = new (0, $155dcbbe154f2d95$export$2b4dce27390864c7)("Mirror", false);
        this.mirror.addChangeListener((ev)=>{
            this.scaleState.y *= -1;
            this.update();
        });
        this.propertiesHTMLRows.push(this.mirror.buildHTML());
        this.invert = new (0, $155dcbbe154f2d95$export$2b4dce27390864c7)("Invert", false);
        this.invert.addChangeListener((ev)=>{
            this.scaleState.x *= -1;
            this.update();
        });
        this.propertiesHTMLRows.push(this.invert.buildHTML());
        this.addName();
        this.addInfo();
        this.snappingPoints = [
            new (0, $817613c536c3a4d7$export$a1e3a3b1875fcddc)(this, null, new $gBhAd.Point(0, 0)),
            new (0, $817613c536c3a4d7$export$a1e3a3b1875fcddc)(this, null, new $gBhAd.Point(0, 0)),
            ...this.referenceSymbol._pins.filter((_, index)=>!(index == startPinIndex || index == endPinIndex)).map((pin)=>new (0, $817613c536c3a4d7$export$a1e3a3b1875fcddc)(this, pin.name, pin.point.add(this.referenceSymbol.relMid)))
        ];
    }
    moveTo(position) {
        let diff = position.sub(this.position);
        this.posStart = diff.add(this.posStart);
        this.posEnd = diff.add(this.posEnd);
        this.update();
    }
    moveStartTo(position) {
        this.posStart = position;
        this.update();
    }
    moveEndTo(position) {
        this.posEnd = position;
        this.update();
    }
    rotate(angleDeg) {
        this.posStart = this.posStart.rotate(angleDeg, this.position);
        this.posEnd = this.posEnd.rotate(angleDeg, this.position);
        this.update();
    }
    flip(horizontal) {
        let newPos1 = new $gBhAd.Point(this.posStart.x, this.posEnd.y);
        let newPos2 = new $gBhAd.Point(this.posEnd.x, this.posStart.y);
        if (horizontal) {
            this.posStart = newPos1;
            this.posEnd = newPos2;
        } else {
            this.posStart = newPos2;
            this.posEnd = newPos1;
        }
        this.mirror.updateValue(!this.mirror.value, true);
        this.update();
    }
    recalculateSnappingPoints() {
        const inverseTransform = this.getTransformMatrix().inverse();
        this.snappingPoints[0].updateRelPosition(this.posStart.transform(inverseTransform));
        this.snappingPoints[1].updateRelPosition(this.posEnd.transform(inverseTransform));
        super.recalculateSnappingPoints();
    }
    getSnappingInfo() {
        if (this.finishedPlacing) return {
            trackedSnappingPoints: this.snappingPoints,
            additionalSnappingPoints: []
        };
        else return {
            trackedSnappingPoints: [],
            additionalSnappingPoints: this.pointsPlaced > 0 ? [
                new (0, $817613c536c3a4d7$export$a1e3a3b1875fcddc)(this, "", new $gBhAd.Point())
            ] : []
        };
    }
    update() {
        this.position = this.posStart.add(this.posEnd).div(2);
        const angle = Math.atan2(this.posStart.y - this.posEnd.y, this.posEnd.x - this.posStart.x);
        this.rotationDeg = angle * 180 / Math.PI;
        let m = this.getTransformMatrix();
        this.symbolUse.transform(m);
        let startEnd = this.relSymbolStart.add(this.referenceSymbol.relMid).transform(m);
        let endStart = this.relSymbolEnd.add(this.referenceSymbol.relMid).transform(m);
        if (this.invert.value) {
            let switchPos = startEnd;
            startEnd = endStart;
            endStart = switchPos;
        }
        this.recalculateResizePoints();
        this.startLine.plot(this.posStart.x, this.posStart.y, startEnd.x, startEnd.y);
        this.endLine.plot(this.posEnd.x, this.posEnd.y, endStart.x, endStart.y);
        this.dragStartLine.plot(this.posStart.x, this.posStart.y, startEnd.x, startEnd.y);
        this.dragEndLine.plot(this.posEnd.x, this.posEnd.y, endStart.x, endStart.y);
        this.updateLabelPosition();
        this._bbox = this.visualization.bbox();
        this.relPosition = this.position.sub(new $gBhAd.Point(this._bbox.x, this._bbox.y));
        this.recalculateSelectionVisuals();
        this.recalculateSnappingPoints();
    }
    recalculateSelectionVisuals() {
        if (this.selectionElement) {
            // use the saved position instead of the bounding box (bbox position fails in safari)
            let bbox = this.symbolBBox;
            this.selectionElement.size(bbox.w + (0, $429ca25d803b1e0f$export$80fcba011b33afb8), bbox.h + (0, $429ca25d803b1e0f$export$80fcba011b33afb8)).transform(this.getTransformMatrix());
        }
    }
    viewSelected(show) {
        super.viewSelected(show);
        if (show) {
            // also paint the lines leading to the symbol
            this.startLine.stroke(this.isSelectionReference ? (0, $429ca25d803b1e0f$export$c19757439fb239a7) : (0, $429ca25d803b1e0f$export$1617d35435c603f6));
            this.endLine.stroke(this.isSelectionReference ? (0, $429ca25d803b1e0f$export$c19757439fb239a7) : (0, $429ca25d803b1e0f$export$1617d35435c603f6));
        } else {
            this.startLine.stroke((0, $6a68e99136784593$export$fc9982435e9a3643));
            this.endLine.stroke((0, $6a68e99136784593$export$fc9982435e9a3643));
        }
        this.resizable(this.isSelected && show && (0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.currentlySelectedComponents.length == 1);
    }
    getTransformMatrix() {
        const symbolRel = this.referenceSymbol.relMid;
        return new $gBhAd.Matrix({
            scaleX: this.scaleState.x,
            scaleY: this.scaleState.y,
            translate: [
                -symbolRel.x,
                -symbolRel.y
            ],
            origin: [
                symbolRel.x,
                symbolRel.y
            ]
        }).lmultiply(new $gBhAd.Matrix({
            rotate: -this.rotationDeg,
            translate: [
                this.position.x,
                this.position.y
            ]
        }));
    }
    isInsideSelectionRectangle(selectionRectangle) {
        if (this.pointsPlaced < 2) return false;
        // if 1 of the 2 lines hanging of the symbol intersect the selection rect -> should select
        if ((0, $429ca25d803b1e0f$export$51318765f3340fac)(this.startLine, selectionRectangle) || (0, $429ca25d803b1e0f$export$51318765f3340fac)(this.endLine, selectionRectangle)) return true;
        const bbox = this.symbolBBox;
        // get the corner points of the bounding box and rotate each of them to their proper positions
        const transform = this.getTransformMatrix();
        const boxPoints = [
            new $gBhAd.Point(bbox.x, bbox.y).transform(transform),
            new $gBhAd.Point(bbox.x2, bbox.y).transform(transform),
            new $gBhAd.Point(bbox.x2, bbox.y2).transform(transform),
            new $gBhAd.Point(bbox.x, bbox.y2).transform(transform)
        ];
        // if all of these points are inside the selection rect -> should select
        if (boxPoints.map((value)=>(0, $429ca25d803b1e0f$export$aedb7b212a60242f)(value, selectionRectangle)).every((value)=>value)) return true;
        //necessary to check if the complete selection rect is inside the component
        let selectionRectInside = true;
        // if at least one line defined by 2 of the 4 corner points intersects the selection rect -> should select
        for(let index = 0; index < boxPoints.length; index++){
            const p1 = boxPoints[index];
            const p2 = boxPoints[(index + 1) % boxPoints.length];
            if ((0, $429ca25d803b1e0f$export$51318765f3340fac)([
                [
                    p1.x,
                    p1.y
                ],
                [
                    p2.x,
                    p2.y
                ]
            ], selectionRectangle)) return true;
            else selectionRectInside = selectionRectInside && p2.sub(p1).rotate(-90).dot(new $gBhAd.Point(selectionRectangle.cx, selectionRectangle.cy).sub(p1)) > 0;
        }
        // no intersection between the selection rect and the component or selection rect inside component
        return selectionRectInside;
    }
    toJson() {
        let data = {
            type: "path",
            id: this.referenceSymbol.node.id,
            start: this.posStart.simplifyForJson(),
            end: this.posEnd.simplifyForJson()
        };
        if (this.name.value) data.name = this.name.value;
        data.label = {
            value: this.mathJaxLabel.value ?? undefined,
            otherSide: this.labelSide.value ? true : undefined,
            distance: this.labelDistance.value.value != 0 ? this.labelDistance.value : undefined,
            color: this.labelColor.value ? this.labelColor.value.toString() : undefined
        };
        if (this.scaleState && (this.scaleState.x != 1 || this.scaleState.y != 1)) data.scale = this.scaleState;
        return data;
    }
    toTikzString() {
        let distStr = (0, $429ca25d803b1e0f$export$5b0dabb733625ce9)(this.labelDistance.value.convertToUnit("cm").minus(0.1).value) + "cm";
        let shouldDist = this.labelDistance.value && distStr != "0.0cm";
        const scaleFactor = this.scaleProperty.value.value != 1 ? new $gBhAd.Number(this.scaleProperty.value.value * 1.4, "cm") : undefined;
        let latexStr = this.mathJaxLabel.value ? "$" + this.mathJaxLabel.value + "$" : "";
        latexStr = latexStr && this.labelColor.value ? "\\textcolor" + this.labelColor.value.toTikzString() + "{" + latexStr + "}" : latexStr;
        return "\\draw " + this.posStart.toTikzString() + " to[" + this.referenceSymbol.tikzName + (this.name.value === "" ? "" : ", name=" + this.name.value) + (this.mathJaxLabel.value !== "" ? ", l" + (this.labelSide.value ? "_" : "") + "={" + latexStr + "}" + (shouldDist ? ", label distance=" + distStr : "") : "") + (this.mirror.value ? ", mirror" : "") + (this.invert.value ? ", invert" : "") + (scaleFactor ? ",/tikz/circuitikz/bipoles/length=" + scaleFactor.value.toPrecision(3) + scaleFactor.unit : "") + "] " + this.posEnd.toTikzString() + ";";
    }
    toSVG(defs) {
        const copiedSVG = super.toSVG(defs);
        for (const line of copiedSVG.find("line.draggable"))copiedSVG.removeElement(line);
        return copiedSVG;
    }
    remove() {
        (0, $c9646859e7f18723$export$b3f9f45765e2792d).snapDrag(this, false);
        if (this.startSVG) {
            (0, $c9646859e7f18723$export$946b192100cb98a7).snapDrag(this, this.startSVG, false);
            this.startSVG.remove();
        }
        if (this.endSVG) {
            (0, $c9646859e7f18723$export$946b192100cb98a7).snapDrag(this, this.endSVG, false);
            this.endSVG.remove();
        }
        this.selectionElement?.remove();
        this.resizable(false);
        this.visualization.remove();
        this.viewSelected(false);
        this.labelRendering?.remove();
    }
    draggable(drag) {
        if (drag) {
            this.symbolUse.node.classList.add("draggable");
            this.dragStartLine.node.classList.add("draggable");
            this.dragEndLine.node.classList.add("draggable");
        } else {
            this.symbolUse.node.classList.remove("draggable");
            this.dragStartLine.node.classList.add("draggable");
            this.dragEndLine.node.classList.add("draggable");
        }
        (0, $c9646859e7f18723$export$b3f9f45765e2792d).snapDrag(this, drag);
    }
    recalculateResizePoints() {
        this.startSVG?.center(this.posStart.x, this.posStart.y);
        this.endSVG?.center(this.posEnd.x, this.posEnd.y);
    }
    resizable(resize) {
        if (this.isResizing == resize) return;
        this.isResizing = resize;
        if (resize) {
            this.startSVG = (0, $429ca25d803b1e0f$export$a9cd85b3d0cd1648)();
            this.startSVG.node.style.cursor = "move";
            this.endSVG = (0, $429ca25d803b1e0f$export$a9cd85b3d0cd1648)();
            this.endSVG.node.style.cursor = "move";
            let startPos;
            let endPos;
            (0, $c9646859e7f18723$export$946b192100cb98a7).snapDrag(this, this.startSVG, true, {
                dragStart: (pos)=>{
                    startPos = this.posStart;
                },
                dragMove: (pos)=>{
                    this.moveStartTo(pos);
                },
                dragEnd: ()=>{
                    return startPos.eq(this.posStart);
                }
            });
            (0, $c9646859e7f18723$export$946b192100cb98a7).snapDrag(this, this.endSVG, true, {
                dragStart: (pos)=>{
                    endPos = this.posEnd;
                },
                dragMove: (pos)=>{
                    this.moveEndTo(pos);
                },
                dragEnd: ()=>{
                    return endPos.eq(this.posEnd);
                }
            });
        } else {
            (0, $c9646859e7f18723$export$946b192100cb98a7).snapDrag(this, this.startSVG, false);
            (0, $c9646859e7f18723$export$946b192100cb98a7).snapDrag(this, this.endSVG, false);
            this.startSVG?.remove();
            this.endSVG?.remove();
        }
        this.update();
    }
    placeMove(pos) {
        (0, $a0a429836785e44a$export$5d153f96fe924d6e).instance.moveTo(pos);
        if (this.pointsPlaced == 1) this.moveEndTo(pos);
    }
    placeStep(pos) {
        if (this.pointsPlaced == 0) {
            this.visualization.show();
            this.posStart = pos;
        }
        this.pointsPlaced += 1;
        this.placeMove(pos);
        return this.pointsPlaced > 1;
    }
    placeFinish() {
        while(!this.finishedPlacing)this.finishedPlacing = this.placeStep((0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.lastCanvasPoint);
        this.finishedPlacing = true;
        (0, $a0a429836785e44a$export$5d153f96fe924d6e).instance.visible = false;
        (0, $53f326ae950d374f$export$6c6ec69acef94984).instance.hideSnapPoints();
        this.update();
        this.draggable(true);
    }
    copyForPlacement() {
        return new $f522b793724e8edf$export$e522ece2f5c9b780(this.referenceSymbol);
    }
    static fromJson(saveObject) {
        let symbol = (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.symbols.find((value, index, symbols)=>value.node.id == saveObject.id);
        let pathComponent = new $f522b793724e8edf$export$e522ece2f5c9b780(symbol);
        pathComponent.posStart = new $gBhAd.Point(saveObject.start);
        pathComponent.posEnd = new $gBhAd.Point(saveObject.end);
        pathComponent.pointsPlaced = 2;
        if (saveObject.scale) {
            pathComponent.scaleState = new $gBhAd.Point(saveObject.scale);
            pathComponent.scaleProperty.updateValue(new $gBhAd.Number(Math.abs(saveObject.scale.x)), true);
        }
        pathComponent.mirror.value = pathComponent.scaleState.y < 0;
        pathComponent.mirror.updateHTML();
        pathComponent.invert.value = pathComponent.scaleState.x < 0;
        pathComponent.invert.updateHTML();
        pathComponent.scaleProperty.value = new $gBhAd.Number(Math.abs(pathComponent.scaleState.x));
        pathComponent.scaleProperty.updateHTML();
        if (saveObject.name) {
            pathComponent.name.value = saveObject.name;
            pathComponent.name.updateHTML();
        }
        if (saveObject.label) {
            pathComponent.labelSide.value = saveObject.label.otherSide ?? false;
            pathComponent.labelSide.updateHTML();
            pathComponent.labelDistance.value = saveObject.label.distance ? new $gBhAd.Number(saveObject.label.distance) : new $gBhAd.Number(0, "cm");
            pathComponent.labelDistance.updateHTML();
            pathComponent.mathJaxLabel.value = saveObject.label.value;
            pathComponent.mathJaxLabel.updateHTML();
            pathComponent.labelColor.value = saveObject.label.color ? new $gBhAd.Color(saveObject.label.color) : null;
            pathComponent.labelColor.updateHTML();
            pathComponent.generateLabelRender();
        }
        pathComponent.placeFinish();
        pathComponent.visualization.show();
        return pathComponent;
    }
    updateLabelPosition() {
        if (!this.mathJaxLabel || !this.labelRendering) return;
        let labelSVG = this.labelRendering;
        // breaking points where the label is parallel to the path or to the x axis. in degrees
        const breakVertical = 70;
        const breakHorizontal = 21;
        let pathDiff = this.posEnd.sub(this.posStart);
        // the bounding boxes for the label and the symbol
        let labelBBox = labelSVG.bbox();
        let symbolBBox = this.symbolUse.bbox();
        // the nominal reference point of the label (bottom center)
        let labelRef = new $gBhAd.Point(labelBBox.w / 2, labelBBox.h);
        // the rotation angle of the label (not always identical to the path rotation angle)
        let rotAngle = this.rotationDeg;
        if (rotAngle > 90) {
            // upper left quadrant -> don't show label upside down -> rotate the label by additional 180 deg
            rotAngle -= 180;
            // the label reference point should now be the top center
            labelRef.y = 0;
        } else if (rotAngle < -90) {
            // lower left quadrant -> don't show label upside down -> rotate the label by additional 180 deg
            rotAngle += 180;
            // the label reference point should now be the top center
            labelRef.y = 0;
        }
        // mirroring the symbol should not impact the label except from shifting its position to stay close to the symbol (only relevant for asymetric symbols)
        let referenceoffsetY = this.scaleState.y < 0 ? this.referenceSymbol.relMid.y - symbolBBox.h : -this.referenceSymbol.relMid.y;
        // nominally the reference point of the symbol is its center (w.r.t. the x coordinate for a path which is horizontal)
        let referenceOffsetX = 0;
        let otherSide = this.labelSide.value;
        let other = otherSide ? -1 : 1;
        if (otherSide) {
            labelRef.y = labelBBox.h - labelRef.y;
            referenceoffsetY += symbolBBox.h;
        }
        // if the path is close to horizontal or vertical according to the break points
        let nearHorizontal = Math.abs(this.rotationDeg) < breakHorizontal || Math.abs(this.rotationDeg) > 180 - breakHorizontal;
        let nearVertical = Math.abs(this.rotationDeg) > breakVertical && Math.abs(this.rotationDeg) < 180 - breakVertical;
        if (nearHorizontal) {
            // the label should not be rotated w.r.t. the x axis
            rotAngle = 0;
            //the offset where the rotation pivot point should lie (for both label and symbol)
            let horizontalOffset = Math.min(labelBBox.w, symbolBBox.w) * Math.sign(this.rotationDeg) / 2;
            referenceOffsetX = horizontalOffset * Math.sign(pathDiff.x) * other;
            labelRef.x += horizontalOffset * other;
        } else if (nearVertical) {
            // the label should not be rotated w.r.t. the x axis
            rotAngle = 0;
            let right = this.rotationDeg > 0 ? Math.sign(90 - this.rotationDeg) : Math.sign(this.rotationDeg + 90);
            let up = Math.sign(this.rotationDeg);
            //the offset where the rotation pivot point should lie (for both label and symbol)
            let verticalOffset = Math.min(labelBBox.h, symbolBBox.w) / 2;
            referenceOffsetX = -verticalOffset * right * up * other;
            labelRef = new $gBhAd.Point(labelBBox.w / 2 * (1 + up * other), labelBBox.h / 2 + verticalOffset * other * right);
        }
        referenceoffsetY -= other * (this.labelDistance.value ? this.labelDistance.value.convertToUnit("px").value : 0);
        // where the anchor point of the symbol is located relative to the midAbs point
        let referenceOffset = new $gBhAd.Point(referenceOffsetX, referenceoffsetY).transform(new $gBhAd.Matrix({
            rotate: -this.rotationDeg
        }));
        // acutally move and rotate the label to the correct position
        let compRef = this.position.add(referenceOffset);
        let movePos = compRef.sub(labelRef);
        labelSVG.transform({
            rotate: -rotAngle,
            ox: labelRef.x,
            oy: labelRef.y,
            translate: [
                movePos.x,
                movePos.y
            ]
        });
    }
}



var $gBhAd = parcelRequire("gBhAd");


var $gBhAd = parcelRequire("gBhAd");

class $c9646859e7f18723$export$b3f9f45765e2792d {
    componentReference;
    element;
    startedDragging = false;
    didDrag = false;
    constructor(componentReference, element){
        this.componentReference = componentReference;
        this.element = element;
        this.element.remember("_snapDragHandler", this);
        this.element.draggable(true);
        this.element.on("dragstart", this.dragStart, this, {
            passive: true
        });
        this.element.on("dragmove.namespace", this.dragMove, this);
        this.element.on("dragend", this.dragEnd, this, {
            passive: true
        });
    }
    static snapDrag(componentReference, enable, element = componentReference.visualization) {
        let snapDragHandler = element.remember("_snapDragHandler") ?? (enable ? new $c9646859e7f18723$export$b3f9f45765e2792d(componentReference, element) : null);
        if (enable === false && snapDragHandler) {
            // enable === false --> not undefined
            // if the snapDragHandler gets removed while currently moving, this means that the component placement is cancelled, i.e. no state should be added
            if (snapDragHandler.startedDragging) snapDragHandler.dragEnd(null, false);
            snapDragHandler.removeHandler();
            return null;
        }
        return snapDragHandler;
    }
    removeHandler() {
        this.element.off("dragstart", this.dragStart);
        this.element.off("dragmove.namespace", this.dragMove);
        this.element.off("dragend", this.dragEnd);
        this.element.draggable(false);
        this.element.forget("_snapDragHandler");
        this.element.forget("_draggable");
    }
    dragOffset;
    dragStart(ev) {
        this.startedDragging = true;
        this.element.node.classList.add("dragging");
        this.element.parent().node.classList.add("dragging");
        this.dragOffset = this.componentReference.position.sub((0, $1c90e793f342bb2a$export$88e1240f06a672d2).eventToPoint(ev.detail.event, false));
        let parent = this.componentReference;
        while(parent.parentGroup)parent = parent.parentGroup;
        (0, $53f326ae950d374f$export$6c6ec69acef94984).instance.updateSnapPoints(parent, false);
    }
    dragMove(ev) {
        if (!this.didDrag) // only show snapping points if actually moving
        (0, $53f326ae950d374f$export$6c6ec69acef94984).instance.showSnapPoints();
        this.didDrag = true;
        ev.preventDefault();
        const draggedPoint = (0, $1c90e793f342bb2a$export$88e1240f06a672d2).eventToPoint(ev.detail.event, false).add(this.dragOffset);
        // calculate where the selection/component should be placed
        let shiftKey = ev.detail.event.shiftKey;
        let destination = shiftKey ? draggedPoint : (0, $53f326ae950d374f$export$6c6ec69acef94984).instance.snapPoint(draggedPoint, this.componentReference);
        let parent = this.componentReference;
        while(parent.parentGroup)parent = parent.parentGroup;
        if (parent.isSelected) //move the whole selection to the destination
        (0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.moveSelectionRel(destination.sub(this.componentReference.position));
        else parent.moveTo(destination.add(parent.position.sub(this.componentReference.position)));
        (0, $53f326ae950d374f$export$6c6ec69acef94984).instance.recalculateAdditionalSnapPoints();
    }
    dragEnd(ev, trackState = true) {
        if (!this.startedDragging) return;
        let parent = this.componentReference;
        while(parent.parentGroup)parent = parent.parentGroup;
        if (!this.didDrag) {
            // didn't move at all -> essentially clicked the component --> select the component instead; no Undo state
            let ctrlCommand = ev.detail.event.ctrlKey || (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.isMac && ev.detail.event.metaKey;
            let selectionMode = ev.detail.event.shiftKey ? (0, $28c7e05d96c1a267$export$91484609d16ec765).ADD : ctrlCommand ? (0, $28c7e05d96c1a267$export$91484609d16ec765).SUB : (0, $28c7e05d96c1a267$export$91484609d16ec765).RESET;
            if (selectionMode == (0, $28c7e05d96c1a267$export$91484609d16ec765).RESET && (0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.currentlySelectedComponents.includes(parent) && (0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.currentlySelectedComponents.length > 1) (0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.setReference(parent);
            else (0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.selectComponents([
                parent
            ], selectionMode);
            trackState = false;
        }
        // reset drag states
        this.didDrag = false;
        this.startedDragging = false;
        this.element.node.classList.remove("dragging");
        this.element.parent().node.classList.remove("dragging");
        (0, $53f326ae950d374f$export$6c6ec69acef94984).instance.hideSnapPoints();
        if (window.TouchEvent && ev.detail?.event instanceof TouchEvent) {
            const clientXY = ev.detail.event.touches?.[0] ?? ev.detail.event.changedTouches?.[0];
            const contextMenuEvent = new PointerEvent("contextmenu", {
                clientX: clientXY.clientX,
                clientY: clientXY.clientY
            });
            Promise.resolve().then(()=>this.element.node.dispatchEvent(contextMenuEvent));
        }
        // only recalculate snapping points after movement is done! (since they are part of the movement which would lead to eratic behaviour)
        if (parent.isSelected) for (const component of (0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.currentlySelectedComponents)component.recalculateSnappingPoints();
        else parent.recalculateSnappingPoints();
        if (trackState) (0, $815383aeedb00f00$export$897c9ed706d8ea48).addState();
    }
}
class $c9646859e7f18723$export$946b192100cb98a7 {
    dragCallbacks;
    element;
    componentReference;
    startedDragging = false;
    didDrag = false;
    constructor(componentReference, element, callbacks){
        this.element = element;
        this.componentReference = componentReference;
        this.dragCallbacks = callbacks;
        this.element.remember("_adjustDragHandler", this);
        this.element.draggable(true);
        this.element.on("dragstart", this.dragStart, this, {
            passive: true
        });
        this.element.on("dragmove.namespace", this.dragMove, this);
        this.element.on("dragend", this.dragEnd, this, {
            passive: true
        });
    }
    static snapDrag(componentReference, element, enable, callbacks = {}) {
        let adjustDragHandler = element.remember("_adjustDragHandler") ?? (enable ? new $c9646859e7f18723$export$946b192100cb98a7(componentReference, element, callbacks) : null);
        if (enable === false && adjustDragHandler) {
            // enable === false --> not undefined
            // if the snapDragHandler gets removed while currently moving, this means that the component placement is cancelled, i.e. no state should be added
            if (adjustDragHandler.startedDragging) adjustDragHandler.dragEnd(null, false);
            adjustDragHandler.removeHandler();
            return null;
        }
        return adjustDragHandler;
    }
    /**
     * Remove the handler and deactivate `draggable` feature.
     */ removeHandler() {
        this.element.off("dragstart", this.dragStart);
        this.element.off("dragmove.namespace", this.dragMove);
        this.element.off("dragend", this.dragEnd);
        this.element.draggable(false);
        this.element.forget("_adjustDragHandler");
        this.element.forget("_draggable");
    }
    //- listener -------------------------------------------------------------------------------------------------------
    /**
     * Listener for the "dragstart" event. Changes the cursor symbol using the class "dragging".
     * @param {DragEvent} event
     */ dragStart(event) {
        this.startedDragging = true;
        this.element.node.classList.add("dragging");
        this.element.parent().node.classList.add("dragging");
        (0, $53f326ae950d374f$export$6c6ec69acef94984).instance.updateSnapPoints(this.componentReference, true);
        if (this.dragCallbacks && this.dragCallbacks.dragStart) {
            const draggedPoint = new $gBhAd.Point(event.detail.box.cx, event.detail.box.cy);
            let shiftKey = event.detail.event.shiftKey;
            let destination = shiftKey ? draggedPoint : (0, $53f326ae950d374f$export$6c6ec69acef94984).instance.snapPoint(draggedPoint, this.componentReference);
            this.dragCallbacks.dragStart(destination, event.detail.event);
            (0, $53f326ae950d374f$export$6c6ec69acef94984).instance.recalculateAdditionalSnapPoints();
        }
    }
    /**
     * Handler for the dragging event. Alters the default behavior to enable snapping to grid and to other components.
     *
     * @private
     * @param {DragEvent} event - the dragging event.
     */ dragMove(event) {
        event.preventDefault();
        if (window.TouchEvent && event.detail.event instanceof TouchEvent && event.detail.event.touches.length > 1) {
            this.didDrag = true;
            this.dragEnd(event, true);
            return;
        }
        if (!this.didDrag) // only show snapping points if actually moving
        (0, $53f326ae950d374f$export$6c6ec69acef94984).instance.showSnapPoints();
        this.didDrag = true;
        const draggedPoint = new $gBhAd.Point(event.detail.box.cx, event.detail.box.cy);
        let shiftKey = event.detail.event.shiftKey;
        let destination = shiftKey ? draggedPoint : (0, $53f326ae950d374f$export$6c6ec69acef94984).instance.snapPoint(draggedPoint, this.componentReference);
        if (this.dragCallbacks && this.dragCallbacks.dragMove) this.dragCallbacks.dragMove(destination, event.detail.event);
        (0, $53f326ae950d374f$export$6c6ec69acef94984).instance.recalculateAdditionalSnapPoints();
    }
    /**
     * Listener for the "dragend" event. Undo the cursor change from {@link "#dragStart"}.
     * @param {DragEvent} event
     */ dragEnd(event, trackState = true) {
        if (!this.startedDragging) return;
        if (!this.didDrag) {
            // didn't move at all -> essentially clicked the component --> select the component instead
            let ctrlCommand = event.detail.event.ctrlKey || (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.isMac && event.detail.event.metaKey;
            let selectionMode = event.detail.event.shiftKey ? (0, $28c7e05d96c1a267$export$91484609d16ec765).ADD : ctrlCommand ? (0, $28c7e05d96c1a267$export$91484609d16ec765).SUB : (0, $28c7e05d96c1a267$export$91484609d16ec765).RESET;
            if (selectionMode == (0, $28c7e05d96c1a267$export$91484609d16ec765).RESET && (0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.currentlySelectedComponents.includes(this.componentReference) && (0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.currentlySelectedComponents.length > 1) (0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.setReference(this.componentReference);
            else (0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.selectComponents([
                this.componentReference
            ], selectionMode);
            trackState = false;
        }
        this.didDrag = false;
        this.startedDragging = false;
        this.element.node.classList.remove("dragging");
        this.element.parent().node.classList.remove("dragging");
        (0, $53f326ae950d374f$export$6c6ec69acef94984).instance.hideSnapPoints();
        let shouldUndo = false;
        if (this.dragCallbacks && this.dragCallbacks.dragEnd) shouldUndo = this.dragCallbacks.dragEnd();
        this.componentReference.recalculateSnappingPoints();
        if (trackState && shouldUndo) (0, $815383aeedb00f00$export$897c9ed706d8ea48).addState();
    }
}



var $627d261d67c772a8$export$a57ac5b86e4c8f9c;
(function(WireDirection) {
    WireDirection["Straight"] = "--";
    WireDirection["HV"] = "-|";
    WireDirection["VH"] = "|-";
})($627d261d67c772a8$export$a57ac5b86e4c8f9c || ($627d261d67c772a8$export$a57ac5b86e4c8f9c = {}));
const $627d261d67c772a8$export$3d0a7339dcfb6ff4 = [
    {
        key: "none",
        name: "none",
        tikz: "",
        setBack: 0
    },
    {
        key: "stealth",
        name: "stealth",
        tikz: "stealth",
        setBack: 0.5
    },
    {
        key: "stealthR",
        name: "stealth reversed",
        tikz: "stealth reversed",
        setBack: 0.5
    },
    {
        key: "latex",
        name: "latex",
        tikz: "latex",
        setBack: 0.5
    },
    {
        key: "latexR",
        name: "latex reversed",
        tikz: "latex reversed",
        setBack: 0.5
    },
    {
        key: "to",
        name: "to",
        tikz: "to",
        setBack: 0.1,
        strokeFactor: 0.7,
        refXY: new $gBhAd.Point(-1, -0.6)
    },
    {
        key: "toR",
        name: "to reversed",
        tikz: "to reversed",
        setBack: 0.4,
        strokeFactor: 0.7,
        refXY: new $gBhAd.Point(-1, -0.6)
    },
    {
        key: "line",
        name: "line",
        tikz: "|",
        setBack: 0,
        strokeFactor: 1,
        refXY: new $gBhAd.Point(-0.5, -0.5)
    }
];
const $627d261d67c772a8$export$e5f2277f022ff030 = $627d261d67c772a8$export$3d0a7339dcfb6ff4[0];
class $627d261d67c772a8$export$af5ab1b7068ea0e5 extends (0, $6a68e99136784593$export$c15be3828826f6ee) {
    strokeInfo;
    strokeColorProperty;
    strokeOpacityProperty;
    strokeWidthProperty;
    strokeStyleProperty;
    /**
     * the corner points when drawing
     */ cornerPoints;
    /**
     * the wire directions when drawing
     */ wireDirections;
    // useful for placing
    previousPlacingDirection = new $gBhAd.Point(1, 0);
    // essentially the main visualisation
    wire;
    // a wider copy of wire, but invisible, Meant for dragging the wire
    draggableWire;
    // the svg elements where adjusting the wire is possible
    adjustmentPoints = [];
    arrowEnd;
    arrowStart;
    startArrowElement;
    endArrowElement;
    static arrowSymbols;
    constructor(){
        super();
        this.cornerPoints = [];
        this.wireDirections = [];
        (0, $a0a429836785e44a$export$5d153f96fe924d6e).instance.visible = true;
        this.displayName = "Wire";
        this.scaleState = new $gBhAd.Point(1, 1);
        this.strokeInfo = {
            color: "default",
            opacity: 1,
            width: new $gBhAd.Number("0.4pt"),
            style: (0, $f7d52ac80405fb45$export$3f7ff86cb0e40ba1).key
        };
        this.wire = (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas.polyline();
        this.wire.fill("none");
        this.draggableWire = (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas.polyline();
        this.draggableWire.attr({
            fill: "none",
            stroke: "transparent",
            "stroke-width": (0, $429ca25d803b1e0f$export$10606941daa6e712)
        });
        this.visualization.add(this.wire);
        this.visualization.add(this.draggableWire);
        this.snappingPoints = [];
        this.propertiesHTMLRows.push(new (0, $c66494ce03e8372a$export$4de04f378a8de0fe)("Arrows").buildHTML());
        this.arrowStart = new (0, $e40ab772a0133b83$export$cb4430aa1f2c59e4)("Start", $627d261d67c772a8$export$3d0a7339dcfb6ff4, $627d261d67c772a8$export$e5f2277f022ff030);
        this.arrowStart.addChangeListener((ev)=>{
            this.updateArrowTypesAndColors();
            this.update();
        });
        this.propertiesHTMLRows.push(this.arrowStart.buildHTML());
        this.arrowEnd = new (0, $e40ab772a0133b83$export$cb4430aa1f2c59e4)("End", $627d261d67c772a8$export$3d0a7339dcfb6ff4, $627d261d67c772a8$export$e5f2277f022ff030);
        this.arrowEnd.addChangeListener((ev)=>{
            this.updateArrowTypesAndColors();
            this.update();
        });
        this.propertiesHTMLRows.push(this.arrowEnd.buildHTML());
        this.propertiesHTMLRows.push(new (0, $c66494ce03e8372a$export$4de04f378a8de0fe)("Stroke").buildHTML());
        this.strokeOpacityProperty = new (0, $f6aed19036c0382b$export$59215b46c4e8abd5)("Opacity", 0, 100, 1, new $gBhAd.Number(this.strokeInfo.opacity * 100, "%"));
        this.strokeOpacityProperty.addChangeListener((ev)=>{
            this.strokeInfo.opacity = ev.value.value / 100;
            this.updateTheme();
            this.updateArrowTypesAndColors();
            this.update();
        });
        this.strokeColorProperty = new (0, $9195d5109ba85630$export$40ae678e65d951f2)("Color", null);
        this.strokeColorProperty.addChangeListener((ev)=>{
            if (ev.value == null) {
                this.strokeInfo.color = "default";
                this.strokeInfo.opacity = 1;
            } else {
                this.strokeInfo.color = ev.value.toRgb();
                this.strokeInfo.opacity = this.strokeOpacityProperty.value.value / 100;
            }
            this.updateTheme();
            this.updateArrowTypesAndColors();
            this.update();
        });
        this.strokeWidthProperty = new (0, $f6aed19036c0382b$export$59215b46c4e8abd5)("Width", 0, 10, 0.1, this.strokeInfo.width);
        this.strokeWidthProperty.addChangeListener((ev)=>{
            this.strokeInfo.width = ev.value;
            this.update();
            this.updateTheme();
        });
        this.strokeStyleProperty = new (0, $e40ab772a0133b83$export$cb4430aa1f2c59e4)("Style", (0, $f7d52ac80405fb45$export$18afec4cf520d708), (0, $f7d52ac80405fb45$export$3f7ff86cb0e40ba1));
        this.strokeStyleProperty.addChangeListener((ev)=>{
            this.strokeInfo.style = ev.value.key;
            this.updateTheme();
        });
        this.propertiesHTMLRows.push(this.strokeColorProperty.buildHTML());
        this.propertiesHTMLRows.push(this.strokeOpacityProperty.buildHTML());
        this.propertiesHTMLRows.push(this.strokeWidthProperty.buildHTML());
        this.propertiesHTMLRows.push(this.strokeStyleProperty.buildHTML());
        this.updateTheme();
        if (!$627d261d67c772a8$export$af5ab1b7068ea0e5.arrowSymbols) {
            $627d261d67c772a8$export$af5ab1b7068ea0e5.arrowSymbols = new Map();
            for (const tip of $627d261d67c772a8$export$3d0a7339dcfb6ff4)$627d261d67c772a8$export$af5ab1b7068ea0e5.arrowSymbols.set(tip.key, document.getElementById(tip.key));
        }
    }
    lineWidthToArrowScale() {
        let scale = this.strokeInfo.width.convertToUnit("pt").value * 4.5 + 2.8; // magic numbers for converting the line width to the scale value
        return scale;
    }
    updateArrowTypesAndColors() {
        let arrowColor = this.strokeInfo.color;
        if (arrowColor == "default") arrowColor = (0, $6a68e99136784593$export$fc9982435e9a3643);
        this.startArrowElement?.remove();
        this.startArrowElement = null;
        if (this.arrowStart.value.key != $627d261d67c772a8$export$e5f2277f022ff030.key) {
            this.startArrowElement = (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas.group();
            this.startArrowElement.addTo(this.visualization);
            this.startArrowElement.stroke({
                color: arrowColor,
                opacity: this.strokeInfo.opacity
            });
            this.startArrowElement.fill({
                color: arrowColor,
                opacity: this.strokeInfo.opacity
            });
            const arrowPath = document.getElementById(this.arrowStart.value.key);
            for (const element of arrowPath.children)this.startArrowElement.node.append(element.cloneNode(true));
        }
        this.endArrowElement?.remove();
        this.endArrowElement = null;
        if (this.arrowEnd.value.key != $627d261d67c772a8$export$e5f2277f022ff030.key) {
            this.endArrowElement = (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas.group();
            this.endArrowElement.addTo(this.visualization);
            this.endArrowElement.stroke({
                color: arrowColor,
                opacity: this.strokeInfo.opacity
            });
            this.endArrowElement.fill({
                color: arrowColor,
                opacity: this.strokeInfo.opacity
            });
            const arrowPath = document.getElementById(this.arrowEnd.value.key);
            for (const element of arrowPath.children)this.endArrowElement.node.append(element.cloneNode(true));
        }
    }
    updateArrowTransforms(startArrowReference, endArrowReference) {
        const scale = this.lineWidthToArrowScale();
        const strokeWidth = this.strokeInfo.width.convertToUnit("px").value / scale;
        const transformMatrix = this.getTransformMatrix();
        if (this.arrowStart.value.key != $627d261d67c772a8$export$e5f2277f022ff030.key) {
            let wireDirection = this.cornerPoints.at(0).sub(startArrowReference);
            let rotationAngleDeg = Math.atan2(wireDirection.y, wireDirection.x) * 180 / Math.PI;
            let refXY = this.arrowStart.value.refXY ?? new $gBhAd.Point(-1, -0.5);
            this.startArrowElement.transform(new $gBhAd.Matrix({
                translate: this.cornerPoints.at(0).toArray(),
                rotate: rotationAngleDeg,
                scale: [
                    scale,
                    scale
                ]
            }).multiply({
                translate: refXY.toArray()
            }).lmultiply(transformMatrix));
            this.startArrowElement.attr("stroke-width", strokeWidth * (this.arrowStart.value.strokeFactor ?? 0));
        }
        if (this.arrowEnd.value.key != $627d261d67c772a8$export$e5f2277f022ff030.key) {
            let wireDirection = this.cornerPoints.at(-1).sub(endArrowReference);
            let rotationAngleDeg = Math.atan2(wireDirection.y, wireDirection.x) * 180 / Math.PI;
            let refXY = this.arrowEnd.value.refXY ?? new $gBhAd.Point(-1, -0.5);
            this.endArrowElement.transform(new $gBhAd.Matrix({
                translate: this.cornerPoints.at(-1).toArray(),
                rotate: rotationAngleDeg,
                scale: [
                    scale,
                    scale
                ]
            }).multiply({
                translate: refXY.toArray()
            }).lmultiply(transformMatrix));
            this.endArrowElement.attr("stroke-width", strokeWidth * (this.arrowEnd.value.strokeFactor ?? 0));
        }
    }
    updateTheme() {
        let strokeColor = this.strokeInfo.color;
        if (strokeColor == "default") strokeColor = (0, $6a68e99136784593$export$fc9982435e9a3643);
        this.wire.stroke({
            color: strokeColor,
            opacity: this.strokeInfo.opacity,
            width: this.strokeInfo.opacity == 0 ? 0 : this.strokeInfo.width.convertToUnit("px").value,
            dasharray: this.strokeStyleProperty.value.dasharray.map((factor)=>this.strokeInfo.width.times(factor).toString()).join(" ")
        });
    }
    recalculateSnappingPoints() {
        super.recalculateSnappingPoints(this.getTransformMatrix());
    }
    getSnappingInfo() {
        if (this.finishedPlacing) // only snap to the snapping points
        return {
            trackedSnappingPoints: this.snappingPoints,
            additionalSnappingPoints: []
        };
        else // only snap the cursor
        return {
            trackedSnappingPoints: [],
            additionalSnappingPoints: this.cornerPoints.length > 0 ? [
                new (0, $817613c536c3a4d7$export$a1e3a3b1875fcddc)(this, "center", new $gBhAd.Point())
            ] : []
        };
    }
    draggable(drag) {
        if (drag) this.draggableWire.node.classList.add("draggable");
        else this.draggableWire.node.classList.remove("draggable");
        // actually enable/disable dragging for the wire itself. This should be done with the draggable wire
        (0, $c9646859e7f18723$export$b3f9f45765e2792d).snapDrag(this, drag, this.draggableWire);
    }
    resizable(resize) {
        if (resize == this.isResizing) return;
        this.isResizing = resize;
        if (resize) {
            // pre calculate the direction of the wire as a vector from the wiredirection objects
            let dirs = [];
            for(let index = 0; index < this.wireDirections.length; index++){
                let rel = this.cornerPoints[index + 1].sub(this.cornerPoints[index]);
                dirs[index] = this.wireDirections[index] == $627d261d67c772a8$export$a57ac5b86e4c8f9c.VH ? new $gBhAd.Point(0, Math.sign(rel.y)) : new $gBhAd.Point(Math.sign(rel.x), 0);
            }
            // add dragging to all corner points
            for(let index = 0; index < this.cornerPoints.length; index++){
                const element = (0, $429ca25d803b1e0f$export$a9cd85b3d0cd1648)();
                element.node.style.cursor = "move";
                this.adjustmentPoints.push(element);
                let startPos;
                (0, $c9646859e7f18723$export$946b192100cb98a7).snapDrag(this, element, resize, {
                    dragStart: (pos)=>{
                        startPos = this.cornerPoints[index];
                    },
                    dragMove: (pos, ev)=>{
                        pos = pos.transform(this.getTransformMatrix().inverse());
                        if (ev && (ev.ctrlKey || (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.isMac && ev.metaKey)) {
                            // wires from and to this point should be straight
                            if (index > 0) this.wireDirections[index - 1] = $627d261d67c772a8$export$a57ac5b86e4c8f9c.Straight;
                            if (index < this.wireDirections.length) this.wireDirections[index] = $627d261d67c772a8$export$a57ac5b86e4c8f9c.Straight;
                        } else {
                            // change the wire direction if necessary
                            if (index > 0) {
                                // from the last point to this point
                                dirs[index - 1] = this.directionVecFromPos(pos.sub(this.cornerPoints[index - 1]), dirs[index - 1]);
                                this.wireDirections[index - 1] = this.wireDirectionFromDirectionVec(dirs[index - 1], ev);
                            }
                            if (index < this.adjustmentPoints.length - 1) {
                                // from this point to the next point
                                let rel = pos.sub(this.cornerPoints[index + 1]);
                                dirs[index] = this.directionVecFromPos(rel, dirs[index]);
                                let dir = dirs[index].x != 0 ? new $gBhAd.Point(0, rel.y) : new $gBhAd.Point(rel.x, 0);
                                this.wireDirections[index] = this.wireDirectionFromDirectionVec(dir, ev);
                            }
                        }
                        this.cornerPoints[index].x = pos.x;
                        this.cornerPoints[index].y = pos.y;
                        this.update();
                    },
                    dragEnd: ()=>{
                        const bbox = $627d261d67c772a8$export$af5ab1b7068ea0e5.bboxFromPoints(this.cornerPoints);
                        const delta = new $gBhAd.Point(bbox.cx, bbox.cy);
                        this.cornerPoints = this.cornerPoints.map((point)=>point.sub(delta));
                        this.position = this.position.add(delta.transform(new $gBhAd.Matrix({
                            rotate: -this.rotationDeg,
                            scaleY: this.scaleState.y
                        })));
                        this.update();
                        return this.cornerPoints[index].eq(startPos.sub(delta));
                    }
                });
            }
            this.update();
        } else {
            for (const point of this.adjustmentPoints){
                (0, $c9646859e7f18723$export$946b192100cb98a7).snapDrag(this, point, false);
                point.remove();
            }
            this.adjustmentPoints = [];
        }
    }
    recalculateResizePoints() {
        const transformMatrix = this.getTransformMatrix();
        for(let index = 0; index < this.adjustmentPoints.length; index++){
            const viz = this.adjustmentPoints[index];
            const point = this.cornerPoints[index].transform(transformMatrix);
            viz.center(point.x, point.y);
        }
    }
    getTransformMatrix() {
        return new $gBhAd.Matrix({
            rotate: -this.rotationDeg,
            origin: [
                0,
                0
            ],
            scale: [
                this.scaleState.x,
                this.scaleState.y
            ],
            translate: [
                this.position.x,
                this.position.y
            ]
        });
    }
    moveTo(position) {
        this.position = position;
        this.update();
    }
    rotate(angleDeg) {
        this.rotationDeg += angleDeg;
        this.simplifyRotationAngle();
        this.update();
    }
    scaleState;
    flip(horizontal) {
        this.scaleState.y *= -1;
        this.rotationDeg = (horizontal ? 0 : 180) - this.rotationDeg;
        this.simplifyRotationAngle();
        this.update();
    }
    static bboxFromPoints(points) {
        let min = new $gBhAd.Point(Infinity, Infinity);
        let max = new $gBhAd.Point(-Infinity, -Infinity);
        points.forEach((point)=>{
            if (min.x > point.x) min.x = point.x;
            if (min.y > point.y) min.y = point.y;
            if (max.x < point.x) max.x = point.x;
            if (max.y < point.y) max.y = point.y;
        });
        return new $gBhAd.Box(min.x, min.y, max.x - min.x, max.y - min.y);
    }
    update() {
        // generate all the points in the wire from the corner points and the wire directions
        let pointArray = this.pointsFromCornerPoints();
        let startArrowRef = pointArray.at(1).clone();
        startArrowRef = startArrowRef.eq(this.cornerPoints.at(0)) ? (pointArray.at(2) ?? new $gBhAd.Point()).clone() : startArrowRef;
        let endArrowRef = pointArray.at(-2).clone();
        endArrowRef = endArrowRef.eq(this.cornerPoints.at(-1)) ? (pointArray.at(-3) ?? new $gBhAd.Point()).clone() : endArrowRef;
        // first update the relative positions of the snapping points w.r.t. the wire, i.e. the start and end positions
        let pointsNoArrow = pointArray.map((point)=>point.clone());
        // adjust end points for arrow heads
        const arrowSize = this.lineWidthToArrowScale();
        if (this.arrowStart.value.key !== $627d261d67c772a8$export$e5f2277f022ff030.key) {
            let firstRef = pointArray[1].sub(pointArray[0]);
            let firstRefLength = firstRef.abs();
            if (firstRefLength > 0) pointArray[0] = pointArray[0].add(firstRef.div(firstRefLength).mul(arrowSize * this.arrowStart.value.setBack));
        }
        if (this.arrowEnd.value.key !== $627d261d67c772a8$export$e5f2277f022ff030.key) {
            let numPoints = pointArray.length - 1;
            let secondRef = pointArray[numPoints - 1].sub(pointArray[numPoints]);
            let secondRefLength = secondRef.abs();
            if (secondRefLength > 0) pointArray[numPoints] = pointArray[numPoints].add(secondRef.div(secondRefLength).mul(arrowSize * this.arrowEnd.value.setBack));
        }
        //update arrows. has to be done before bbox calculation, otherwise, the arrow tips are not shown in the bounding box
        this.updateArrowTransforms(startArrowRef, endArrowRef);
        // actually plot the points
        let transformMatrix = this.getTransformMatrix();
        let plotPoints = new $gBhAd.PointArray(pointArray.map((val)=>val.toArray()));
        this.wire.clear();
        this.wire.plot(plotPoints);
        this.wire.transform(transformMatrix);
        this.draggableWire.clear();
        this.draggableWire.plot(plotPoints);
        this.draggableWire.transform(transformMatrix);
        //recalculate the bounding box and position
        this._bbox = $627d261d67c772a8$export$af5ab1b7068ea0e5.bboxFromPoints(this.cornerPoints).transform(transformMatrix);
        this.relPosition = this.position.sub(new $gBhAd.Point(this._bbox.x, this._bbox.y));
        //recalculate the snapping point offsets
        if (this.snappingPoints.length == pointsNoArrow.length) //update the existing snap points
        for(let index = 0; index < this.snappingPoints.length; index++){
            const snapPoint = this.snappingPoints[index];
            const point = pointsNoArrow[index];
            snapPoint.updateRelPosition(point);
        }
        else // a point was added -> redo snap points
        this.snappingPoints = pointsNoArrow.map((point, idx)=>new (0, $817613c536c3a4d7$export$a1e3a3b1875fcddc)(this, idx == 0 ? "START" : idx == pointsNoArrow.length - 1 ? "END" : "", point));
        // update visuals
        this.recalculateSelectionVisuals();
        this.recalculateSnappingPoints();
        this.recalculateResizePoints();
    }
    pointsFromCornerPoints() {
        let pointArray = [
            this.cornerPoints[0].clone()
        ];
        for(let index = 0; index < this.wireDirections.length; index++){
            const direction = this.wireDirections[index];
            const previousPoint = this.cornerPoints[index];
            const point = this.cornerPoints[index + 1];
            if (direction == $627d261d67c772a8$export$a57ac5b86e4c8f9c.HV && previousPoint.x != point.x && previousPoint.y != point.y) pointArray.push(new $gBhAd.Point(point.x, previousPoint.y));
            else if (direction == $627d261d67c772a8$export$a57ac5b86e4c8f9c.VH && previousPoint.x != point.x && previousPoint.y != point.y) pointArray.push(new $gBhAd.Point(previousPoint.x, point.y));
            pointArray.push(point.clone());
        }
        return pointArray;
    }
    recalculateSelectionVisuals() {
        if (this.selectionElement) {
            const transformMatrix = this.getTransformMatrix();
            const transformMatrixInv = transformMatrix.inverse();
            let bbox = $627d261d67c772a8$export$af5ab1b7068ea0e5.bboxFromPoints(this.cornerPoints);
            const strokeWidth = this.strokeInfo.width.convertToUnit("px").value;
            bbox = new $gBhAd.Box(bbox.x - strokeWidth / 2, bbox.y - strokeWidth / 2, bbox.w + strokeWidth, bbox.h + strokeWidth);
            if (this.startArrowElement) {
                const currentTransform = new $gBhAd.Matrix(this.startArrowElement.transform());
                const arrowTransform = currentTransform.lmultiply(transformMatrixInv);
                const startBBox = this.startArrowElement.bbox().transform(arrowTransform);
                bbox = bbox.merge(startBBox);
            }
            if (this.endArrowElement) {
                const currentTransform = new $gBhAd.Matrix(this.endArrowElement.transform());
                const arrowTransform = currentTransform.lmultiply(transformMatrixInv);
                const endBBox = this.endArrowElement.bbox().transform(arrowTransform);
                bbox = bbox.merge(endBBox);
            }
            this.selectionElement.size(bbox.width, bbox.height);
            this.selectionElement.center(bbox.cx, bbox.cy);
            this.selectionElement.transform(transformMatrix);
        }
    }
    isInsideSelectionRectangle(selectionRectangle) {
        //essentially check each wire segment via a wire rect intersection
        const transformMatrix = this.getTransformMatrix();
        let pointsArray = this.pointsFromCornerPoints().map((point)=>point.transform(transformMatrix));
        for(let idx = 0; idx < pointsArray.length - 1; idx++){
            const p1 = pointsArray[idx];
            const p2 = pointsArray[idx + 1];
            if ((0, $429ca25d803b1e0f$export$aedb7b212a60242f)(p1, selectionRectangle)) return true;
            if ((0, $429ca25d803b1e0f$export$51318765f3340fac)([
                [
                    p1.x,
                    p1.y
                ],
                [
                    p2.x,
                    p2.y
                ]
            ], selectionRectangle)) return true;
        }
        return false;
    }
    viewSelected(show) {
        super.viewSelected(show);
        this.resizable(this.isSelected && show && (0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.currentlySelectedComponents.length == 1);
    }
    toJson() {
        let others = [];
        for(let index = 0; index < this.wireDirections.length; index++){
            let segment = {
                endPoint: this.cornerPoints[index + 1].add(this.position).simplifyForJson(),
                direction: this.wireDirections[index]
            };
            others.push(segment);
        }
        let data = {
            type: "wire",
            start: this.cornerPoints[0].add(this.position).simplifyForJson(),
            segments: others
        };
        if (this.rotationDeg) data.rotationDeg = this.rotationDeg;
        if (this.scaleState.y != 1) data.flip = true;
        let stroke = {};
        let shouldStroke = false;
        if (this.strokeInfo.color != "default") {
            stroke.color = this.strokeInfo.color;
            shouldStroke = true;
        }
        if (this.strokeInfo.opacity != 1) {
            stroke.opacity = this.strokeInfo.opacity;
            shouldStroke = true;
        }
        if (!this.strokeInfo.width.eq(new $gBhAd.Number("0.4pt"))) {
            stroke.width = this.strokeInfo.width;
            shouldStroke = true;
        }
        if (this.strokeInfo.style != (0, $f7d52ac80405fb45$export$3f7ff86cb0e40ba1).key) {
            stroke.style = this.strokeInfo.style;
            shouldStroke = true;
        }
        if (shouldStroke) data.stroke = stroke;
        if (this.arrowStart.value.key !== $627d261d67c772a8$export$e5f2277f022ff030.key) data.startArrow = this.arrowStart.value.key;
        if (this.arrowEnd.value.key !== $627d261d67c772a8$export$e5f2277f022ff030.key) data.endArrow = this.arrowEnd.value.key;
        return data;
    }
    toTikzString() {
        let drawOptions = [];
        if (this.arrowStart.value.key !== $627d261d67c772a8$export$e5f2277f022ff030.key) {
            drawOptions.push(this.arrowStart.value.tikz);
            drawOptions.push("-");
        }
        if (this.arrowEnd.value.key !== $627d261d67c772a8$export$e5f2277f022ff030.key) {
            if (drawOptions.length == 0) drawOptions.push("-");
            drawOptions.push(this.arrowEnd.value.tikz);
        }
        let optionsArray = drawOptions.length > 0 ? [
            drawOptions.join("")
        ] : [];
        if (this.strokeInfo.opacity > 0) {
            if (this.strokeInfo.color !== "default") {
                let c = new $gBhAd.Color(this.strokeInfo.color);
                optionsArray.push("draw=" + c.toTikzString());
            }
            if (this.strokeInfo.opacity != 1) optionsArray.push("draw opacity=" + this.strokeInfo.opacity.toString());
            let width = this.strokeInfo.width.convertToUnit("pt").value;
            if (width != 0.4) optionsArray.push("line width=" + width + "pt");
            if (this.strokeInfo.style && this.strokeInfo.style != (0, $f7d52ac80405fb45$export$3f7ff86cb0e40ba1).key) optionsArray.push((0, $f7d52ac80405fb45$export$dfe11f4b6a1fc336)(this.strokeInfo.width, (0, $f7d52ac80405fb45$export$18afec4cf520d708).find((item)=>item.key == this.strokeInfo.style).dasharray));
        }
        let optionsArrayStr = optionsArray.length > 0 ? "[" + optionsArray.join(", ") + "]" : "";
        const transformMatrix = this.getTransformMatrix();
        let outString = "\\draw" + optionsArrayStr + " ";
        if ((this.rotationDeg + 180) % 90 != 0) {
            // add points between corner points
            let pointArray = this.pointsFromCornerPoints().map((point)=>point.transform(transformMatrix));
            outString += pointArray[0].toTikzString();
            for(let index = 1; index < pointArray.length; index++)outString += " -- " + pointArray[index].toTikzString();
        } else {
            let pointArray = this.cornerPoints.map((point)=>point.transform(transformMatrix));
            outString += pointArray[0].toTikzString();
            for(let index = 0; index < this.wireDirections.length; index++){
                const previousPoint = pointArray[index];
                const point = pointArray[index + 1];
                let dir = this.wireDirections[index];
                if (dir == $627d261d67c772a8$export$a57ac5b86e4c8f9c.HV && previousPoint.y == point.y) dir = $627d261d67c772a8$export$a57ac5b86e4c8f9c.Straight;
                if (dir == $627d261d67c772a8$export$a57ac5b86e4c8f9c.VH && previousPoint.x == point.x) dir = $627d261d67c772a8$export$a57ac5b86e4c8f9c.Straight;
                if (!dir) dir = $627d261d67c772a8$export$a57ac5b86e4c8f9c.Straight;
                outString += " " + dir + " " + point.toTikzString();
            }
        }
        return outString + ";";
    }
    toSVG(defs) {
        if (this.arrowStart.value != $627d261d67c772a8$export$e5f2277f022ff030) {
            const id = this.arrowStart.value.key;
            if (!defs.has(id)) {
                const marker = document.getElementById(id).cloneNode(true);
                defs.set(id, new $gBhAd.Element(marker));
            }
        }
        if (this.arrowEnd.value != $627d261d67c772a8$export$e5f2277f022ff030) {
            const id = this.arrowEnd.value.key;
            if (!defs.has(id)) {
                const marker = document.getElementById(id).cloneNode(true);
                defs.set(id, new $gBhAd.Element(marker));
            }
        }
        const copiedSVG = this.visualization.clone(true);
        copiedSVG.removeElement(copiedSVG.find("polyline.draggable")[0]);
        return copiedSVG;
    }
    copyForPlacement() {
        return new $627d261d67c772a8$export$af5ab1b7068ea0e5();
    }
    remove() {
        this.visualization.remove();
        this.viewSelected(false);
        this.selectionElement?.remove();
        if (this.finishedPlacing) this.draggable(false);
    }
    placeMove(pos, ev) {
        //only move the last corner point in the array
        (0, $a0a429836785e44a$export$5d153f96fe924d6e).instance.moveTo(pos);
        if (this.placingPoints.length > 1) {
            let previousPoint = this.placingPoints.at(-2);
            let relToPreviousPoint = pos.sub(previousPoint);
            this.previousPlacingDirection = this.directionVecFromPos(relToPreviousPoint, this.previousPlacingDirection);
            this.wireDirections[this.wireDirections.length - 1] = this.wireDirectionFromDirectionVec(this.previousPlacingDirection, ev);
            this.placingPoints[this.placingPoints.length - 1] = pos;
            let bbox = $627d261d67c772a8$export$af5ab1b7068ea0e5.bboxFromPoints(this.placingPoints);
            this.position = new $gBhAd.Point(bbox.cx, bbox.cy);
            // this.size = new SVG.Point(bbox.w, bbox.h)
            this.cornerPoints = this.placingPoints.map((point)=>point.sub(this.position));
            this.update();
        }
    }
    /**
     * This essentially adjusts the wire direction if necessary. If the cursor crosses the axis perpendicular to the previous initial direction of the wire segment, this axis should now be the initial direction of the wire segment
     * @param relPos the current position relative to the position of the previous point
     * @param lastDirection in which direction the wire was previously starting
     * @returns the adjusted direction
     */ directionVecFromPos(relPos, lastDirection) {
        var dir = lastDirection.clone();
        if (relPos.y != 0 && relPos.x * lastDirection.x < 0) {
            dir.x = 0;
            dir.y = Math.sign(relPos.y);
        } else if (relPos.x != 0 && relPos.y * lastDirection.y < 0) {
            dir.x = Math.sign(relPos.x);
            dir.y = 0;
        }
        return dir;
    }
    wireDirectionFromDirectionVec(directionVec, ev) {
        if (ev && (ev.ctrlKey || (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.isMac && ev.metaKey)) return $627d261d67c772a8$export$a57ac5b86e4c8f9c.Straight;
        else if (directionVec.x != 0) return $627d261d67c772a8$export$a57ac5b86e4c8f9c.HV;
        else if (directionVec.y != 0) return $627d261d67c772a8$export$a57ac5b86e4c8f9c.VH;
    }
    placingPoints = [];
    placeStep(pos) {
        if (this.finishedPlacing) return true;
        if (this.cornerPoints.length > 0) {
            //if there already exists a wire, check if the same point was placed twice --> if so, the wire placement should end
            let previousPoint = this.placingPoints.at(-2); // there is never only one corner point in the array
            if (pos.eq(previousPoint)) return true;
        } else {
            this.placingPoints.push(pos.clone());
            this.updateTheme();
            (0, $a0a429836785e44a$export$5d153f96fe924d6e).instance.visible = false;
        }
        this.placingPoints.push(pos);
        this.wireDirections.push($627d261d67c772a8$export$a57ac5b86e4c8f9c.HV);
        this.previousPlacingDirection.x = 1;
        this.previousPlacingDirection.y = 0;
        this.placeMove(pos);
        return false;
    }
    placeFinish() {
        if (this.finishedPlacing) //was already called
        return;
        (0, $a0a429836785e44a$export$5d153f96fe924d6e).instance.visible = false;
        // remove the point which was currently being placed (not actually part of the wire)
        if (this.placingPoints.length == 0) this.placeStep(new $gBhAd.Point());
        this.placingPoints.pop();
        this.wireDirections.pop();
        if (this.placingPoints.length >= 2 && this.placingPoints.at(-1).eq(this.placingPoints.at(-2))) {
            this.placingPoints.pop();
            this.wireDirections.pop();
        }
        if (this.placingPoints.length < 2) {
            // if not event 2 corner points --> not a wire
            (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.removeComponent(this);
            return;
        }
        let bbox = $627d261d67c772a8$export$af5ab1b7068ea0e5.bboxFromPoints(this.placingPoints);
        if (this.position.eq(new $gBhAd.Point())) this.position = new $gBhAd.Point(bbox.cx, bbox.cy);
        // this.size = new SVG.Point(bbox.w, bbox.h)
        this.cornerPoints = this.placingPoints.map((point)=>point.sub(this.position));
        // this.snappingPoints = [
        // 	new SnapPoint(this, "START", this.cornerPoints[0].sub(this.position)),
        // 	new SnapPoint(this, "END", this.cornerPoints.at(-1).sub(this.position)),
        // ]
        this.draggable(true);
        this.updateArrowTypesAndColors();
        this.update();
        this.updateTheme();
        this.finishedPlacing = true;
    }
    static fromJson(saveObject) {
        let wireComponent = new $627d261d67c772a8$export$af5ab1b7068ea0e5();
        wireComponent.placingPoints.push(new $gBhAd.Point(saveObject.start));
        if (Object.hasOwn(saveObject, "segments")) for (const segment of saveObject.segments){
            wireComponent.placingPoints.push(new $gBhAd.Point(segment.endPoint));
            wireComponent.wireDirections.push(segment.direction);
        }
        else // @ts-ignore: backwards compatibility
        for (const point of saveObject.others){
            let dir = point.dir == 0 ? $627d261d67c772a8$export$a57ac5b86e4c8f9c.Straight : point.dir == 1 ? $627d261d67c772a8$export$a57ac5b86e4c8f9c.HV : $627d261d67c772a8$export$a57ac5b86e4c8f9c.VH;
            // @ts-ignore: backwards compatibility
            wireComponent.placingPoints.push(new $gBhAd.Point(point.x, point.y));
            wireComponent.wireDirections.push(dir);
        }
        wireComponent.placingPoints.push(new $gBhAd.Point());
        wireComponent.wireDirections.push($627d261d67c772a8$export$a57ac5b86e4c8f9c.Straight);
        wireComponent.placeFinish();
        wireComponent.scaleState.y = saveObject.flip ? -1 : 1;
        wireComponent.rotationDeg = saveObject.rotationDeg ?? 0;
        if (saveObject.stroke) {
            if (saveObject.stroke.color) {
                wireComponent.strokeInfo.color = saveObject.stroke.color;
                wireComponent.strokeColorProperty.value = new $gBhAd.Color(saveObject.stroke.color);
                wireComponent.strokeColorProperty.updateHTML();
            }
            if (saveObject.stroke.opacity != undefined) {
                wireComponent.strokeInfo.opacity = saveObject.stroke.opacity;
                wireComponent.strokeOpacityProperty.value = new $gBhAd.Number(saveObject.stroke.opacity * 100, "%");
                wireComponent.strokeOpacityProperty.updateHTML();
            }
            if (saveObject.stroke.width) {
                wireComponent.strokeInfo.width = new $gBhAd.Number(saveObject.stroke.width);
                wireComponent.strokeWidthProperty.value = wireComponent.strokeInfo.width;
                wireComponent.strokeWidthProperty.updateHTML();
            }
            if (saveObject.stroke.style) {
                wireComponent.strokeInfo.style = saveObject.stroke.style;
                wireComponent.strokeStyleProperty.value = (0, $f7d52ac80405fb45$export$18afec4cf520d708).find((item)=>item.key == saveObject.stroke.style);
                wireComponent.strokeStyleProperty.updateHTML();
            }
        }
        if (saveObject.startArrow) {
            wireComponent.arrowStart.value = $627d261d67c772a8$export$3d0a7339dcfb6ff4.find((item)=>item.key == saveObject.startArrow);
            wireComponent.arrowStart.updateHTML();
        }
        if (saveObject.endArrow) {
            wireComponent.arrowEnd.value = $627d261d67c772a8$export$3d0a7339dcfb6ff4.find((item)=>item.key == saveObject.endArrow);
            wireComponent.arrowEnd.updateHTML();
        }
        wireComponent.updateArrowTypesAndColors();
        wireComponent.updateTheme();
        wireComponent.update();
        return wireComponent;
    }
    updateLabelPosition() {
    //not needed for wires
    }
}



var $gBhAd = parcelRequire("gBhAd");


const $f7d52ac80405fb45$export$18afec4cf520d708 = [
    {
        key: "solid",
        name: "solid",
        dasharray: [
            1,
            0
        ]
    },
    {
        key: "dotted",
        name: "dotted",
        dasharray: [
            1,
            4
        ]
    },
    {
        key: "denselydotted",
        name: "densely dotted",
        dasharray: [
            1,
            2
        ]
    },
    {
        key: "looselydotted",
        name: "loosely dotted",
        dasharray: [
            1,
            8
        ]
    },
    {
        key: "dashed",
        name: "dashed",
        dasharray: [
            4,
            4
        ]
    },
    {
        key: "denselydashed",
        name: "densely dashed",
        dasharray: [
            4,
            2
        ]
    },
    {
        key: "looselydashed",
        name: "loosely dashed",
        dasharray: [
            4,
            8
        ]
    },
    {
        key: "dashdot",
        name: "dash dot",
        dasharray: [
            4,
            2,
            1,
            2
        ]
    },
    {
        key: "denselydashdot",
        name: "densely dash dot",
        dasharray: [
            4,
            1,
            1,
            1
        ]
    },
    {
        key: "looselydashdot",
        name: "loosely dash dot",
        dasharray: [
            4,
            4,
            1,
            4
        ]
    },
    {
        key: "dashdotdot",
        name: "dash dot dot",
        dasharray: [
            4,
            2,
            1,
            2,
            1,
            2
        ]
    },
    {
        key: "denselydashdotdot",
        name: "densely dash dot dot",
        dasharray: [
            4,
            1,
            1,
            1,
            1,
            1
        ]
    },
    {
        key: "looselydashdotdot",
        name: "loosely dash dot dot",
        dasharray: [
            4,
            4,
            1,
            4,
            1,
            4
        ]
    }
];
const $f7d52ac80405fb45$export$3f7ff86cb0e40ba1 = $f7d52ac80405fb45$export$18afec4cf520d708[0];
const $f7d52ac80405fb45$export$dfe11f4b6a1fc336 = (linewidth, dasharray)=>{
    let pattern = [];
    for(let index = 0; index < dasharray.length - 1; index += 2){
        const onElement = dasharray[index];
        const offElement = dasharray[index + 1];
        pattern.push("on " + linewidth.times(onElement).toString());
        pattern.push("off " + linewidth.times(offElement).toString());
    }
    return "dash pattern={" + pattern.join(" ") + "}";
};
class $f7d52ac80405fb45$export$a3fdc93f4064d151 extends (0, $6a68e99136784593$export$c15be3828826f6ee) {
    strokeInfo;
    fillInfo;
    shapeVisualization;
    size;
    dragElement;
    resizeVisualizations;
    fillColorProperty;
    fillOpacityProperty;
    strokeColorProperty;
    strokeOpacityProperty;
    strokeWidthProperty;
    strokeStyleProperty;
    anchorChoice;
    positionChoice;
    placePoint;
    constructor(){
        super();
        this.resizeVisualizations = new Map();
        this.fillInfo = {
            color: "default",
            opacity: 0
        };
        this.strokeInfo = {
            color: "default",
            opacity: 1,
            width: new $gBhAd.Number("1pt"),
            style: $f7d52ac80405fb45$export$3f7ff86cb0e40ba1.key
        };
        //add color property
        this.propertiesHTMLRows.push(new (0, $c66494ce03e8372a$export$4de04f378a8de0fe)("Fill").buildHTML());
        this.fillOpacityProperty = new (0, $f6aed19036c0382b$export$59215b46c4e8abd5)("Opacity", 0, 100, 1, new $gBhAd.Number(this.fillInfo.opacity * 100, "%"));
        this.fillOpacityProperty.addChangeListener((ev)=>{
            this.fillInfo.opacity = ev.value.value / 100;
            this.updateTheme();
        });
        this.fillColorProperty = new (0, $9195d5109ba85630$export$40ae678e65d951f2)("Color", null);
        this.fillColorProperty.addChangeListener((ev)=>{
            if (ev.value == null) {
                this.fillInfo.color = "default";
                this.fillInfo.opacity = 0;
            } else {
                this.fillInfo.color = ev.value.toRgb();
                this.fillInfo.opacity = this.fillOpacityProperty.value.value / 100;
            }
            this.updateTheme();
        });
        this.propertiesHTMLRows.push(this.fillColorProperty.buildHTML());
        this.propertiesHTMLRows.push(this.fillOpacityProperty.buildHTML());
        this.propertiesHTMLRows.push(new (0, $c66494ce03e8372a$export$4de04f378a8de0fe)("Stroke").buildHTML());
        this.strokeOpacityProperty = new (0, $f6aed19036c0382b$export$59215b46c4e8abd5)("Opacity", 0, 100, 1, new $gBhAd.Number(this.strokeInfo.opacity * 100, "%"));
        this.strokeOpacityProperty.addChangeListener((ev)=>{
            this.strokeInfo.opacity = ev.value.value / 100;
            this.updateTheme();
        });
        this.strokeColorProperty = new (0, $9195d5109ba85630$export$40ae678e65d951f2)("Color", null);
        this.strokeColorProperty.addChangeListener((ev)=>{
            if (ev.value == null) {
                this.strokeInfo.color = "default";
                this.strokeInfo.opacity = 1;
            } else {
                this.strokeInfo.color = ev.value.toRgb();
                this.strokeInfo.opacity = this.strokeOpacityProperty.value.value / 100;
            }
            this.updateTheme();
        });
        this.strokeWidthProperty = new (0, $f6aed19036c0382b$export$59215b46c4e8abd5)("Width", 0, 10, 0.1, this.strokeInfo.width);
        this.strokeWidthProperty.addChangeListener((ev)=>{
            this.strokeInfo.width = ev.value;
            this.update();
            this.updateTheme();
        });
        this.strokeStyleProperty = new (0, $e40ab772a0133b83$export$cb4430aa1f2c59e4)("Style", $f7d52ac80405fb45$export$18afec4cf520d708, $f7d52ac80405fb45$export$3f7ff86cb0e40ba1);
        this.strokeStyleProperty.addChangeListener((ev)=>{
            this.strokeInfo.style = ev.value.key;
            this.updateTheme();
        });
        this.propertiesHTMLRows.push(this.strokeColorProperty.buildHTML());
        this.propertiesHTMLRows.push(this.strokeOpacityProperty.buildHTML());
        this.propertiesHTMLRows.push(this.strokeWidthProperty.buildHTML());
        this.propertiesHTMLRows.push(this.strokeStyleProperty.buildHTML());
        //label section
        this.propertiesHTMLRows.push(new (0, $c66494ce03e8372a$export$4de04f378a8de0fe)("Label").buildHTML());
        this.mathJaxLabel = new (0, $5d2a441813f0d40b$export$bf18630312dd3447)();
        this.mathJaxLabel.addChangeListener((ev)=>this.generateLabelRender());
        this.propertiesHTMLRows.push(this.mathJaxLabel.buildHTML());
        this.anchorChoice = new (0, $e40ab772a0133b83$export$cb4430aa1f2c59e4)("Anchor", (0, $6a68e99136784593$export$550f784d253b75ba), (0, $6a68e99136784593$export$362db847193ed989));
        this.anchorChoice.addChangeListener((ev)=>this.updateLabelPosition());
        this.propertiesHTMLRows.push(this.anchorChoice.buildHTML());
        this.positionChoice = new (0, $e40ab772a0133b83$export$cb4430aa1f2c59e4)("Position", (0, $6a68e99136784593$export$550f784d253b75ba), (0, $6a68e99136784593$export$362db847193ed989));
        this.positionChoice.addChangeListener((ev)=>this.updateLabelPosition());
        this.propertiesHTMLRows.push(this.positionChoice.buildHTML());
        this.labelDistance = new (0, $f6aed19036c0382b$export$59215b46c4e8abd5)("Gap", -0.5, 1, 0.01, new $gBhAd.Number(0.12, "cm"));
        this.labelDistance.addChangeListener((ev)=>this.updateLabelPosition());
        this.propertiesHTMLRows.push(this.labelDistance.buildHTML());
        this.labelColor = new (0, $9195d5109ba85630$export$40ae678e65d951f2)("Color", null);
        this.labelColor.addChangeListener((ev)=>{
            this.updateTheme();
        });
        this.propertiesHTMLRows.push(this.labelColor.buildHTML());
        (0, $a0a429836785e44a$export$5d153f96fe924d6e).instance.visible = true;
        this.snappingPoints = [];
        (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas.add(this.visualization);
    }
    getTransformMatrix() {
        return new $gBhAd.Matrix({
            rotate: -this.rotationDeg,
            origin: [
                this.position.x,
                this.position.y
            ]
        });
    }
    moveTo(position) {
        this.position = position;
        this.update();
    }
    rotate(angleDeg) {
        this.rotationDeg += angleDeg;
        this.simplifyRotationAngle();
        this.update();
    }
    flip(horizontal) {
        this.rotationDeg = (horizontal ? 0 : 180) - this.rotationDeg;
        this.simplifyRotationAngle();
        this.update();
    }
    update() {
        let strokeWidth = this.strokeInfo.width.convertToUnit("px").value;
        let transformMatrix = this.getTransformMatrix();
        this.dragElement.size(this.size.x, this.size.y).center(this.position.x, this.position.y);
        this.dragElement.transform(transformMatrix);
        this.shapeVisualization.size(this.size.x < strokeWidth ? 0 : this.size.x - strokeWidth, this.size.y < strokeWidth ? 0 : this.size.y - strokeWidth);
        this.shapeVisualization.center(this.position.x, this.position.y);
        this.shapeVisualization.transform(transformMatrix);
        this._bbox = this.dragElement.bbox().transform(transformMatrix);
        this.relPosition = this.position.sub(new $gBhAd.Point(this.bbox.x, this.bbox.y));
        this.recalculateSelectionVisuals();
        this.recalculateSnappingPoints();
        this.recalculateResizePoints();
        this.updateLabelPosition();
    }
    recalculateSelectionVisuals() {
        if (this.selectionElement) {
            let lineWidth = (0, $429ca25d803b1e0f$export$80fcba011b33afb8);
            this.selectionElement.size(this.size.x + lineWidth, this.size.y + lineWidth).center(this.position.x, this.position.y).transform(this.getTransformMatrix());
        }
    }
    updateTheme() {
        let strokeColor = this.strokeInfo.color;
        if (strokeColor == "default") strokeColor = (0, $6a68e99136784593$export$fc9982435e9a3643);
        let fillColor = this.fillInfo.color;
        if (fillColor == "default") fillColor = "none";
        this.shapeVisualization.stroke({
            color: strokeColor,
            opacity: this.strokeInfo.opacity,
            width: this.strokeInfo.opacity == 0 ? 0 : this.strokeInfo.width.convertToUnit("px").value,
            dasharray: this.strokeStyleProperty.value.dasharray.map((factor)=>this.strokeInfo.width.times(factor).toString()).join(" ")
        });
        this.shapeVisualization.fill({
            color: fillColor,
            opacity: this.fillInfo.opacity
        });
        let labelColor = (0, $6a68e99136784593$export$fc9982435e9a3643);
        if (this.labelColor.value) labelColor = this.labelColor.value.toString();
        this.labelRendering?.fill(labelColor);
    }
    remove() {
        for (const [dir, viz] of this.resizeVisualizations){
            (0, $c9646859e7f18723$export$946b192100cb98a7).snapDrag(this, viz, false);
            viz.remove();
        }
        (0, $c9646859e7f18723$export$b3f9f45765e2792d).snapDrag(this, false);
        this.visualization.remove();
        this.draggable(false);
        this.resizable(false);
        this.viewSelected(false);
        this.selectionElement?.remove();
    }
    getSnappingInfo() {
        return {
            trackedSnappingPoints: this.snappingPoints,
            additionalSnappingPoints: []
        };
    }
    viewSelected(show) {
        super.viewSelected(show);
        this.resizable(this.isSelected && show && (0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.currentlySelectedComponents.length == 1);
    }
    draggable(drag) {
        if (drag) this.dragElement.node.classList.add("draggable");
        else this.dragElement.node.classList.remove("draggable");
        (0, $c9646859e7f18723$export$b3f9f45765e2792d).snapDrag(this, drag, this.dragElement);
    }
    placeMove(pos, ev) {
        if (!this.placePoint) // not started placing
        (0, $a0a429836785e44a$export$5d153f96fe924d6e).instance.moveTo(pos);
        else {
            let secondPoint;
            if (ev && ev.ctrlKey) {
                // get point on one of the two diagonals
                let diff = pos.sub(this.placePoint);
                if (diff.x * diff.y < 0) secondPoint = new $gBhAd.Point(pos.x - pos.y, pos.y - pos.x).add(this.placePoint.x + this.placePoint.y).div(2);
                else secondPoint = new $gBhAd.Point(this.placePoint.x - this.placePoint.y, this.placePoint.y - this.placePoint.x).add(pos.x + pos.y).div(2);
            } else secondPoint = pos;
            this.position = this.placePoint.add(secondPoint).div(2);
            this.size = new $gBhAd.Point(Math.abs(secondPoint.x - this.placePoint.x), Math.abs(secondPoint.y - this.placePoint.y));
            this.update();
        }
    }
    placeStep(pos, ev) {
        if (this.finishedPlacing) return true;
        if (!this.placePoint) {
            this.placePoint = pos;
            this.position = pos;
            this.size = new $gBhAd.Point();
            this.shapeVisualization.show();
            this.updateTheme();
            (0, $a0a429836785e44a$export$5d153f96fe924d6e).instance.visible = false;
            return false;
        }
        this.placeMove(pos, ev);
        return true;
    }
    placeFinish() {
        if (this.finishedPlacing) return;
        if (!this.placePoint) this.placeStep(new $gBhAd.Point());
        this.finishedPlacing = true;
        this.update();
        this.draggable(true);
        this.shapeVisualization.show();
        this.updateTheme();
        (0, $a0a429836785e44a$export$5d153f96fe924d6e).instance.visible = false;
    }
    toSVG(defs) {
        if (this.labelRendering) {
            const backgroundDefs = (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas.findOne("#backgroundDefs");
            for (const element of this.labelRendering.find("use")){
                const id = element.node.getAttribute("xlink:href");
                if (!defs.has(id)) {
                    const symbol = backgroundDefs.findOne(id);
                    defs.set(id, symbol.clone(true, false));
                }
            }
        }
        this.labelRendering?.addClass("labelRendering");
        const copiedSVG = this.visualization.clone(true);
        if (this.labelRendering) {
            if (!this.mathJaxLabel.value) copiedSVG.removeElement(copiedSVG.find(".labelRendering")[0]);
            this.labelRendering.removeClass("labelRendering");
            copiedSVG.findOne(".labelRendering")?.removeClass("labelRendering");
        }
        copiedSVG.removeElement(copiedSVG.find(".draggable")[0]);
        const viz = copiedSVG.findOne('[fill-opacity="0"][stroke-opacity="0"]');
        viz?.remove();
        return copiedSVG;
    }
}



var $gBhAd = parcelRequire("gBhAd");


class $018bdeaffc845dce$export$1b49e7b3b2d7fd39 extends (0, $f7d52ac80405fb45$export$a3fdc93f4064d151) {
    textAreaProperty;
    textInnerSep;
    textFontSize;
    textColor;
    textSVG;
    textDiv;
    constructor(){
        super();
        this.displayName = "Rectangle";
        this.shapeVisualization = (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas.rect(0, 0);
        this.shapeVisualization.hide();
        this.dragElement = (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas.rect(0, 0);
        this.dragElement.attr({
            fill: "transparent",
            stroke: "none"
        });
        this.visualization.add(this.shapeVisualization);
        this.visualization.add(this.dragElement);
        this.propertiesHTMLRows.push(new (0, $c66494ce03e8372a$export$4de04f378a8de0fe)("Text").buildHTML());
        this.textAreaProperty = new (0, $e31ac52a2c203df3$export$1855b4e3beb52fd6)({
            text: "",
            align: (0, $e31ac52a2c203df3$export$3720eb13f948f394).LEFT,
            justify: -1
        });
        this.textAreaProperty.addChangeListener((ev)=>{
            this.update();
        });
        this.propertiesHTMLRows.push(this.textAreaProperty.buildHTML());
        this.textFontSize = new (0, $e40ab772a0133b83$export$cb4430aa1f2c59e4)("Fontsize", (0, $e31ac52a2c203df3$export$67baea80019ff381), (0, $e31ac52a2c203df3$export$f827a56aa9dbfe62));
        this.textFontSize.addChangeListener((ev)=>{
            this.update();
        });
        this.propertiesHTMLRows.push(this.textFontSize.buildHTML());
        this.textInnerSep = new (0, $f6aed19036c0382b$export$59215b46c4e8abd5)("Inner sep", 0, 10, 0.1, new $gBhAd.Number(5, "pt"));
        this.textInnerSep.addChangeListener((ev)=>{
            this.update();
        });
        this.propertiesHTMLRows.push(this.textInnerSep.buildHTML());
        this.textColor = new (0, $9195d5109ba85630$export$40ae678e65d951f2)("Color", null);
        this.textColor.addChangeListener((ev)=>{
            this.updateText();
        });
        this.propertiesHTMLRows.push(this.textColor.buildHTML());
        this.addName();
        this.selectionElement = (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas.rect(0, 0).hide();
    }
    recalculateSnappingPoints(matrix) {
        let relPositions = [];
        let halfSize = this.size.div(2);
        for (const anchor of (0, $6a68e99136784593$export$550f784d253b75ba)){
            if (anchor.key == (0, $6a68e99136784593$export$362db847193ed989).key) continue;
            relPositions.push({
                relPos: halfSize.mul(anchor.direction),
                anchorname: anchor.name
            });
        }
        if (!this.snappingPoints || this.snappingPoints.length == 0) for (const element of relPositions)this.snappingPoints.push(new (0, $817613c536c3a4d7$export$a1e3a3b1875fcddc)(this, element.anchorname, element.relPos.add(this.position)));
        else for(let index = 0; index < relPositions.length; index++){
            const relPos = relPositions[index].relPos;
            const snappingPoint = this.snappingPoints[index];
            snappingPoint.updateRelPosition(relPos.add(this.position));
            snappingPoint.recalculate();
        }
    }
    isInsideSelectionRectangle(selectionRectangle) {
        const rect = new $gBhAd.Box(this.position.x - this.size.x / 2, this.position.y - this.size.y / 2, this.size.x, this.size.y);
        return (0, $429ca25d803b1e0f$export$11f7f05b1cf6c7d0)(rect, selectionRectangle, this.rotationDeg);
    }
    recalculateResizePoints() {
        let halfsize = this.size.div(2);
        for (const [dir, viz] of this.resizeVisualizations){
            let pos = this.position.add(halfsize.mul(dir.direction).rotate(this.rotationDeg));
            viz.center(pos.x, pos.y);
        }
    }
    resizable(resize) {
        // general method: work with positions in non rotated reference frame (rotation of rotated positions has to be compensated --> inverse transform Matrix). Rotation is done in update via the transformMatrix
        if (resize == this.isResizing) return;
        this.isResizing = resize;
        if (resize) {
            let originalPos;
            let originalSize;
            let transformMatrixInv;
            const getInitialDim = ()=>{
                originalPos = this.position.clone();
                originalSize = this.size.clone();
                transformMatrixInv = this.getTransformMatrix().inverse();
            };
            for (const direction of (0, $6a68e99136784593$export$550f784d253b75ba)){
                if (direction.key == (0, $6a68e99136784593$export$362db847193ed989).key || direction.key == "center") continue;
                const directionTransformed = direction.direction.rotate(this.rotationDeg);
                let viz = (0, $429ca25d803b1e0f$export$a9cd85b3d0cd1648)();
                viz.node.style.cursor = (0, $6a68e99136784593$export$8d3d621ce1a1b8e0)(directionTransformed);
                this.resizeVisualizations.set(direction, viz);
                let startPoint;
                let oppositePoint;
                (0, $c9646859e7f18723$export$946b192100cb98a7).snapDrag(this, viz, true, {
                    dragStart: (pos)=>{
                        getInitialDim();
                        startPoint = originalPos.add(direction.direction.mul(originalSize).div(2));
                        oppositePoint = originalPos.add(direction.direction.mul(originalSize).div(-2));
                    },
                    dragMove: (pos, ev)=>{
                        pos = pos.transform(transformMatrixInv);
                        if (ev && ev.ctrlKey && direction.direction.x * direction.direction.y != 0) {
                            // get closest point on one of the two diagonals
                            let diff = pos.sub(oppositePoint);
                            if (diff.x * diff.y < 0) pos = new $gBhAd.Point(pos.x - pos.y, pos.y - pos.x).add(oppositePoint.x + oppositePoint.y).div(2);
                            else pos = new $gBhAd.Point(oppositePoint.x - oppositePoint.y, oppositePoint.y - oppositePoint.x).add(pos.x + pos.y).div(2);
                        }
                        let dirAbs = new $gBhAd.Point(Math.abs(direction.direction.x), Math.abs(direction.direction.y));
                        let delta = pos.sub(startPoint);
                        this.size.x = direction.direction.x ? Math.abs(pos.x - oppositePoint.x) : originalSize.x;
                        this.size.y = direction.direction.y ? Math.abs(pos.y - oppositePoint.y) : originalSize.y;
                        this.position = originalPos.add(delta.mul(dirAbs.div(2)).rotate(this.rotationDeg));
                        this.update();
                    },
                    dragEnd: ()=>{
                        return true;
                    }
                });
            }
            this.update();
        } else {
            for (const [dir, viz] of this.resizeVisualizations){
                (0, $c9646859e7f18723$export$946b192100cb98a7).snapDrag(this, viz, false);
                viz.remove();
            }
            this.resizeVisualizations.clear();
        }
    }
    update() {
        super.update();
        this.updateText();
    }
    toJson() {
        let data = {
            type: "rect",
            position: this.position.simplifyForJson(),
            size: this.size.simplifyForJson()
        };
        if (this.rotationDeg) data.rotationDeg = this.rotationDeg;
        let fill = {};
        let shouldFill = false;
        if (this.fillInfo.color != "default") {
            fill.color = this.fillInfo.color;
            shouldFill = true;
        }
        if (this.fillInfo.opacity != 0) {
            fill.opacity = this.fillInfo.opacity;
            shouldFill = true;
        }
        if (shouldFill) data.fill = fill;
        let stroke = {};
        let shouldStroke = false;
        if (this.strokeInfo.color != "default") {
            stroke.color = this.strokeInfo.color;
            shouldStroke = true;
        }
        if (this.strokeInfo.opacity != 1) {
            stroke.opacity = this.strokeInfo.opacity;
            shouldStroke = true;
        }
        if (!this.strokeInfo.width.eq(new $gBhAd.Number("1pt"))) {
            stroke.width = this.strokeInfo.width;
            shouldStroke = true;
        }
        if (this.strokeInfo.style != (0, $f7d52ac80405fb45$export$3f7ff86cb0e40ba1).key) {
            stroke.style = this.strokeInfo.style;
            shouldStroke = true;
        }
        if (shouldStroke) data.stroke = stroke;
        if (this.mathJaxLabel.value) {
            let labelWithoutRender = {
                value: this.mathJaxLabel.value,
                anchor: this.anchorChoice.value.key,
                position: this.positionChoice.value.key,
                distance: this.labelDistance.value ?? undefined,
                color: this.labelColor.value ? this.labelColor.value.toString() : undefined
            };
            data.label = labelWithoutRender;
        }
        if (this.textAreaProperty.value && this.textAreaProperty.value.text !== "") {
            let textData = {
                text: this.textAreaProperty.value.text
            };
            if (this.textAreaProperty.value.align !== (0, $e31ac52a2c203df3$export$3720eb13f948f394).LEFT) textData.align = this.textAreaProperty.value.align;
            if (this.textAreaProperty.value.justify !== -1) textData.justify = this.textAreaProperty.value.justify;
            if (this.textFontSize.value.key !== (0, $e31ac52a2c203df3$export$f827a56aa9dbfe62).key) textData.fontSize = this.textFontSize.value.key;
            if (this.textInnerSep.value.value !== 5) textData.innerSep = this.textInnerSep.value;
            if (this.textColor.value) textData.color = this.textColor.value.toString();
            data.text = textData;
        }
        return data;
    }
    static fromJson(saveObject) {
        let rectComponent = new $018bdeaffc845dce$export$1b49e7b3b2d7fd39();
        rectComponent.position = new $gBhAd.Point(saveObject.position);
        rectComponent.placePoint = rectComponent.position;
        rectComponent.size = new $gBhAd.Point(saveObject.size);
        rectComponent.rotationDeg = saveObject.rotationDeg ?? 0;
        if (saveObject.fill) {
            if (saveObject.fill.color) {
                rectComponent.fillInfo.color = saveObject.fill.color;
                rectComponent.fillColorProperty.value = new $gBhAd.Color(saveObject.fill.color);
                rectComponent.fillColorProperty.updateHTML();
            }
            if (saveObject.fill.opacity != undefined) {
                rectComponent.fillInfo.opacity = saveObject.fill.opacity;
                rectComponent.fillOpacityProperty.value = new $gBhAd.Number(saveObject.fill.opacity * 100, "%");
                rectComponent.fillOpacityProperty.updateHTML();
            }
        }
        if (saveObject.stroke) {
            if (saveObject.stroke.color) {
                rectComponent.strokeInfo.color = saveObject.stroke.color;
                rectComponent.strokeColorProperty.value = new $gBhAd.Color(saveObject.stroke.color);
                rectComponent.strokeColorProperty.updateHTML();
            }
            if (saveObject.stroke.opacity != undefined) {
                rectComponent.strokeInfo.opacity = saveObject.stroke.opacity;
                rectComponent.strokeOpacityProperty.value = new $gBhAd.Number(saveObject.stroke.opacity * 100, "%");
                rectComponent.strokeOpacityProperty.updateHTML();
            }
            if (saveObject.stroke.width) {
                rectComponent.strokeInfo.width = new $gBhAd.Number(saveObject.stroke.width);
                rectComponent.strokeWidthProperty.value = rectComponent.strokeInfo.width;
                rectComponent.strokeWidthProperty.updateHTML();
            }
            if (saveObject.stroke.style) {
                rectComponent.strokeInfo.style = saveObject.stroke.style;
                rectComponent.strokeStyleProperty.value = (0, $f7d52ac80405fb45$export$18afec4cf520d708).find((item)=>item.key == saveObject.stroke.style);
                rectComponent.strokeStyleProperty.updateHTML();
            }
        }
        if (saveObject.label) {
            rectComponent.labelDistance.value = saveObject.label.distance ? new $gBhAd.Number(saveObject.label.distance) : new $gBhAd.Number(0);
            rectComponent.labelDistance.updateHTML();
            rectComponent.anchorChoice.value = saveObject.label.anchor ? (0, $6a68e99136784593$export$550f784d253b75ba).find((item)=>item.key == saveObject.label.anchor) : (0, $6a68e99136784593$export$362db847193ed989);
            rectComponent.anchorChoice.updateHTML();
            rectComponent.positionChoice.value = saveObject.label.position ? (0, $6a68e99136784593$export$550f784d253b75ba).find((item)=>item.key == saveObject.label.position) : (0, $6a68e99136784593$export$362db847193ed989);
            rectComponent.positionChoice.updateHTML();
            rectComponent.mathJaxLabel.value = saveObject.label.value;
            rectComponent.mathJaxLabel.updateHTML();
            rectComponent.labelColor.value = saveObject.label.color ? new $gBhAd.Color(saveObject.label.color) : null;
            rectComponent.labelColor.updateHTML();
            rectComponent.generateLabelRender();
        }
        if (saveObject.text) {
            let text = {
                text: saveObject.text.text,
                align: saveObject.text.align ?? (0, $e31ac52a2c203df3$export$3720eb13f948f394).LEFT,
                justify: saveObject.text.justify ?? -1
            };
            rectComponent.textAreaProperty.value = text;
            rectComponent.textAreaProperty.updateHTML();
            rectComponent.textFontSize.value = saveObject.text.fontSize ? (0, $e31ac52a2c203df3$export$67baea80019ff381).find((item)=>item.key == saveObject.text.fontSize) : (0, $e31ac52a2c203df3$export$f827a56aa9dbfe62);
            rectComponent.textFontSize.updateHTML();
            rectComponent.textInnerSep.value = saveObject.text.innerSep ? new $gBhAd.Number(saveObject.text.innerSep) : new $gBhAd.Number("5pt");
            rectComponent.textInnerSep.updateHTML();
            rectComponent.textColor.value = saveObject.text.color ? new $gBhAd.Color(saveObject.text.color) : null;
            rectComponent.textColor.updateHTML();
        }
        rectComponent.placeFinish();
        rectComponent.updateTheme();
        return rectComponent;
    }
    toTikzString() {
        let optionsArray = [
            "shape=rectangle"
        ];
        if (this.fillInfo.opacity > 0) {
            if (this.fillInfo.color !== "default") {
                let c = new $gBhAd.Color(this.fillInfo.color);
                optionsArray.push("fill=" + c.toTikzString());
            }
            if (this.fillInfo.opacity != 1) optionsArray.push("fill opacity=" + this.fillInfo.opacity.toString());
        }
        if (this.strokeInfo.opacity > 0) {
            if (this.strokeInfo.color !== "default") {
                let c = new $gBhAd.Color(this.strokeInfo.color);
                optionsArray.push("draw=" + c.toTikzString());
            } else optionsArray.push("draw");
            if (this.strokeInfo.opacity != 1) optionsArray.push("draw opacity=" + this.strokeInfo.opacity.toString());
            let width = this.strokeInfo.width.convertToUnit("pt").value;
            if (width != 0.4) optionsArray.push("line width=" + width + "pt");
            if (this.strokeInfo.style && this.strokeInfo.style != (0, $f7d52ac80405fb45$export$3f7ff86cb0e40ba1).key) optionsArray.push((0, $f7d52ac80405fb45$export$dfe11f4b6a1fc336)(this.strokeInfo.width, (0, $f7d52ac80405fb45$export$18afec4cf520d708).find((item)=>item.key == this.strokeInfo.style).dasharray));
        }
        let strokeWidth = this.strokeInfo.width.convertToUnit("px").value;
        optionsArray.push("inner sep=0");
        optionsArray.push("minimum width=" + (0, $429ca25d803b1e0f$export$5b0dabb733625ce9)(new $gBhAd.Number(this.size.x - strokeWidth, "px").convertToUnit("cm").value) + "cm");
        optionsArray.push("minimum height=" + (0, $429ca25d803b1e0f$export$5b0dabb733625ce9)(new $gBhAd.Number(this.size.y - strokeWidth, "px").convertToUnit("cm").value) + "cm");
        if (this.rotationDeg != 0) optionsArray.push(`rotate=${this.rotationDeg}`);
        let id = this.name.value;
        if (!id && this.mathJaxLabel.value) id = (0, $fc0737f7a4e7c327$export$96be6e195c19e554).instance.createExportID("Rect");
        let textStr = "";
        if (this.textAreaProperty.value.text) {
            //treat justify like left aligned
            let alignDir = this.textAreaProperty.value.align == (0, $e31ac52a2c203df3$export$3720eb13f948f394).JUSTIFY ? -1 : this.textAreaProperty.value.align - 1;
            let dir = new $gBhAd.Point(alignDir, this.textAreaProperty.value.justify);
            // which anchor and position corresponds to the direction?
            let anchor = (0, $6a68e99136784593$export$550f784d253b75ba).find((item)=>item.direction.eq(dir)).name;
            let pos = this.position.add(dir.mul(this.size.div(2)).rotate(this.rotationDeg));
            // text dimensions
            let innerSep = this.textInnerSep.value.plus(this.strokeInfo.width.times(0.5));
            let textWidth = new $gBhAd.Number(this.size.x, "px").minus(this.strokeInfo.width.plus(this.textInnerSep.value).times(2)).convertToUnit("cm");
            let fontStr = this.textFontSize.value.key == (0, $e31ac52a2c203df3$export$f827a56aa9dbfe62).key ? "" : `\\${this.textFontSize.value.name} `;
            let options = `[anchor=${anchor}, align=${this.textAreaProperty.value.align == (0, $e31ac52a2c203df3$export$3720eb13f948f394).LEFT ? "left" : this.textAreaProperty.value.align == (0, $e31ac52a2c203df3$export$3720eb13f948f394).CENTER ? "center" : this.textAreaProperty.value.align == (0, $e31ac52a2c203df3$export$3720eb13f948f394).RIGHT ? "right" : "justify"}, text width=${(0, $429ca25d803b1e0f$export$5b0dabb733625ce9)(textWidth.value)}cm, inner sep=${innerSep.toString()}${this.rotationDeg != 0 ? ", rotate=" + this.rotationDeg : ""}]`;
            let latexStr = `${fontStr}${this.textAreaProperty.value.text.replaceAll("\n", "\\\\")}`;
            latexStr = this.textColor.value ? "\\textcolor" + this.textColor.value.toTikzString() + "{" + latexStr + "}" : latexStr;
            textStr = ` node ${options} at ${pos.toTikzString()}{${latexStr}}`;
        }
        let labelNodeStr = "";
        if (this.mathJaxLabel.value) {
            let labelStr = "anchor=" + this.labelPos.name;
            let labelDist = this.labelDistance.value.convertToUnit("cm");
            let anchorDir = this.anchorChoice.value.key == (0, $6a68e99136784593$export$362db847193ed989).key ? new $gBhAd.Point() : this.anchorChoice.value.direction;
            let labelShift = anchorDir.mul(-labelDist.value);
            let posShift = "";
            if (labelShift.x !== 0) posShift += "xshift=" + (0, $429ca25d803b1e0f$export$5b0dabb733625ce9)(labelShift.x) + "cm";
            if (labelShift.y !== 0) {
                posShift += posShift == "" ? "" : ", ";
                posShift += "yshift=" + (0, $429ca25d803b1e0f$export$5b0dabb733625ce9)(-labelShift.y) + "cm";
            }
            posShift = posShift == "" ? "" : "[" + posShift + "]";
            let posStr = this.positionChoice.value.key == (0, $6a68e99136784593$export$362db847193ed989).key ? id + ".center" : id + "." + this.positionChoice.value.name;
            let latexStr = this.mathJaxLabel.value ? "$" + this.mathJaxLabel.value + "$" : "";
            latexStr = latexStr && this.labelColor.value ? "\\textcolor" + this.labelColor.value.toTikzString() + "{" + latexStr + "}" : latexStr;
            labelNodeStr = " node[" + labelStr + "] at (" + posShift + posStr + "){" + latexStr + "}";
        }
        let optionsStr = optionsArray.length > 0 ? `[${optionsArray.join(", ")}]` : "";
        return `\\node${optionsStr}${id ? "(" + id + ")" : ""} at ${this.position.toTikzString()}{}${textStr}${labelNodeStr};`;
    }
    copyForPlacement() {
        return new $018bdeaffc845dce$export$1b49e7b3b2d7fd39();
    }
    labelPos;
    updateLabelPosition() {
        if (!this.mathJaxLabel.value || !this.labelRendering) return;
        let labelSVG = this.labelRendering;
        let transformMatrix = this.getTransformMatrix();
        let bbox = new $gBhAd.Box(this.position.x - this.size.x / 2, this.position.y - this.size.y / 2, this.size.x, this.size.y);
        // get relevant positions and bounding boxes
        let textPos = this.position;
        let textPosNoTrans = this.position;
        if (this.positionChoice.value.key != (0, $6a68e99136784593$export$362db847193ed989).key) {
            let bboxHalfSize = this.size.div(2);
            textPosNoTrans = this.position.add(bboxHalfSize.mul(this.positionChoice.value.direction));
            textPos = textPosNoTrans.transform(transformMatrix);
        }
        let labelBBox = labelSVG.bbox();
        // calculate where on the label the anchor point should be
        let labelRef;
        let labelDist = this.labelDistance.value.convertToUnit("px").value ?? 0;
        if (this.anchorChoice.value.key == (0, $6a68e99136784593$export$362db847193ed989).key) {
            let clamp = function(value, min, max) {
                if (value < min) return min;
                else if (value > max) return max;
                else return value;
            };
            let horizontalTextPosition = clamp(Math.round(2 * (bbox.cx - textPosNoTrans.x) / bbox.w), -1, 1);
            let verticalTextPosition = clamp(Math.round(2 * (bbox.cy - textPosNoTrans.y) / bbox.h), -1, 1);
            labelRef = new $gBhAd.Point(horizontalTextPosition, verticalTextPosition).rotate(this.rotationDeg);
            labelRef.x = Math.round(labelRef.x);
            labelRef.y = Math.round(labelRef.y);
            this.labelPos = (0, $6a68e99136784593$export$550f784d253b75ba).find((item)=>item.direction.eq(labelRef));
        } else {
            this.labelPos = this.anchorChoice.value;
            labelRef = this.labelPos.direction;
        }
        let ref = labelRef.add(1).div(2).mul(new $gBhAd.Point(labelBBox.w, labelBBox.h)).add(labelRef.mul(labelDist));
        // actually move the label
        let movePos = textPos.sub(ref);
        labelSVG.transform(new $gBhAd.Matrix({
            translate: [
                movePos.x,
                movePos.y
            ]
        }));
    }
    updateText() {
        this.textSVG?.remove();
        if (this.textAreaProperty.value.text) {
            let textData = {
                text: this.textAreaProperty.value.text
            };
            textData.align = this.textAreaProperty.value.align;
            textData.justify = this.textAreaProperty.value.justify;
            textData.fontSize = this.textFontSize.value.key;
            textData.color = this.textColor.value?.toString() ?? "var(--bs-emphasis-color)";
            const innerSep = this.textInnerSep.value.convertToUnit("px").value;
            let strokeWidth = this.strokeInfo.width.convertToUnit("px").value;
            let w = this.size.x - strokeWidth * 2 - 2 * innerSep;
            let h = this.size.y - strokeWidth * 2 - 2 * innerSep;
            const textPos = this.position.sub(new $gBhAd.Point(w > 0 ? w : 0, h > 0 ? h : 0).div(2));
            const textBox = new $gBhAd.Box(textPos.x, textPos.y, w > 0 ? w : 0, h > 0 ? h : 0);
            this.textSVG = (0, $763663756c59a47c$export$828e7be55b645f77)(textData, textBox);
            let transformMatrix = new $gBhAd.Matrix({
                rotate: -this.rotationDeg,
                origin: [
                    this.position.x,
                    this.position.y
                ]
            });
            this.textSVG.transform(transformMatrix);
            this.textSVG.node.style.pointerEvents = "none";
            this.visualization.add(this.textSVG);
        }
    }
}



var $gBhAd = parcelRequire("gBhAd");


class $f1cd0bf4955bc259$export$adcbac2b18b5c769 extends (0, $f7d52ac80405fb45$export$a3fdc93f4064d151) {
    get isCircle() {
        return Math.abs(this.size.x - this.size.y) < 1e-5;
    }
    constructor(){
        super();
        this.addName();
        this.displayName = "Ellipse";
        this.shapeVisualization = (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas.ellipse(0, 0);
        this.shapeVisualization.hide();
        this.dragElement = (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas.ellipse(0, 0);
        this.dragElement.attr({
            fill: "transparent",
            stroke: "none"
        });
        this.visualization.add(this.shapeVisualization);
        this.visualization.add(this.dragElement);
    }
    recalculateSnappingPoints(matrix) {
        let relPositions = [];
        let halfSize = this.size.div(2);
        for (const anchor of (0, $6a68e99136784593$export$550f784d253b75ba)){
            if (anchor.key == (0, $6a68e99136784593$export$362db847193ed989).key) continue;
            let dirLength = anchor.direction.abs();
            dirLength = dirLength == 0 ? 1 : dirLength;
            relPositions.push({
                relPos: halfSize.mul(anchor.direction.div(dirLength)),
                anchorname: anchor.name
            });
            if (dirLength > 1) relPositions.push({
                relPos: halfSize.mul(anchor.direction),
                anchorname: ""
            });
        }
        if (!this.snappingPoints || this.snappingPoints.length == 0) for (const element of relPositions)this.snappingPoints.push(new (0, $817613c536c3a4d7$export$a1e3a3b1875fcddc)(this, element.anchorname, element.relPos.add(this.position)));
        else for(let index = 0; index < relPositions.length; index++){
            const relPos = relPositions[index].relPos;
            const snappingPoint = this.snappingPoints[index];
            snappingPoint.updateRelPosition(relPos.add(this.position));
            snappingPoint.recalculate();
        }
    }
    recalculateResizePoints() {
        let halfsize = this.size.div(2);
        for (const [dir, viz] of this.resizeVisualizations){
            let pos = this.position.add(halfsize.mul(dir.direction).rotate(this.rotationDeg));
            viz.center(pos.x, pos.y);
        }
    }
    resizable(resize) {
        if (resize == this.isResizing) return;
        this.isResizing = resize;
        if (resize) {
            let originalPos;
            let originalSize;
            let transformMatrixInv;
            const getInitialDim = ()=>{
                originalPos = this.position.clone();
                originalSize = this.size.clone();
                transformMatrixInv = this.getTransformMatrix().inverse();
            };
            for (const direction of (0, $6a68e99136784593$export$550f784d253b75ba)){
                if (direction.key == (0, $6a68e99136784593$export$362db847193ed989).key || direction.key == "center") continue;
                const directionTransformed = direction.direction.rotate(this.rotationDeg);
                let viz = (0, $429ca25d803b1e0f$export$a9cd85b3d0cd1648)();
                viz.node.style.cursor = (0, $6a68e99136784593$export$8d3d621ce1a1b8e0)(directionTransformed);
                this.resizeVisualizations.set(direction, viz);
                let startPoint;
                let oppositePoint;
                (0, $c9646859e7f18723$export$946b192100cb98a7).snapDrag(this, viz, true, {
                    dragStart: (pos)=>{
                        getInitialDim();
                        startPoint = originalPos.add(direction.direction.mul(originalSize).div(2));
                        oppositePoint = originalPos.add(direction.direction.mul(originalSize).div(-2));
                    },
                    dragMove: (pos, ev)=>{
                        pos = pos.transform(transformMatrixInv);
                        if (ev && ev.ctrlKey && direction.direction.x * direction.direction.y != 0) {
                            // get closest point on one of the two diagonals
                            let diff = pos.sub(oppositePoint);
                            if (diff.x * diff.y < 0) pos = new $gBhAd.Point(pos.x - pos.y, pos.y - pos.x).add(oppositePoint.x + oppositePoint.y).div(2);
                            else pos = new $gBhAd.Point(oppositePoint.x - oppositePoint.y, oppositePoint.y - oppositePoint.x).add(pos.x + pos.y).div(2);
                        }
                        let dirAbs = new $gBhAd.Point(Math.abs(direction.direction.x), Math.abs(direction.direction.y));
                        let delta = pos.sub(startPoint);
                        this.size.x = direction.direction.x ? Math.abs(pos.x - oppositePoint.x) : originalSize.x;
                        this.size.y = direction.direction.y ? Math.abs(pos.y - oppositePoint.y) : originalSize.y;
                        this.position = originalPos.add(delta.mul(dirAbs.div(2)).rotate(this.rotationDeg));
                        this.update();
                    },
                    dragEnd: ()=>{
                        return true;
                    }
                });
            }
            this.update();
        } else {
            for (const [dir, viz] of this.resizeVisualizations){
                (0, $c9646859e7f18723$export$946b192100cb98a7).snapDrag(this, viz, false);
                viz.remove();
            }
            this.resizeVisualizations.clear();
        }
    }
    toJson() {
        let data = {
            type: "ellipse",
            position: this.position.simplifyForJson(),
            size: this.size.simplifyForJson()
        };
        if (this.rotationDeg) data.rotationDeg = this.rotationDeg;
        let fill = {};
        let shouldFill = false;
        if (this.fillInfo.color != "default") {
            fill.color = this.fillInfo.color;
            shouldFill = true;
        }
        if (this.fillInfo.opacity != 0) {
            fill.opacity = this.fillInfo.opacity;
            shouldFill = true;
        }
        if (shouldFill) data.fill = fill;
        let stroke = {};
        let shouldStroke = false;
        if (this.strokeInfo.color != "default") {
            stroke.color = this.strokeInfo.color;
            shouldStroke = true;
        }
        if (this.strokeInfo.opacity != 1) {
            stroke.opacity = this.strokeInfo.opacity;
            shouldStroke = true;
        }
        if (!this.strokeInfo.width.eq(new $gBhAd.Number("1pt"))) {
            stroke.width = this.strokeInfo.width;
            shouldStroke = true;
        }
        if (this.strokeInfo.style != (0, $f7d52ac80405fb45$export$3f7ff86cb0e40ba1).key) {
            stroke.style = this.strokeInfo.style;
            shouldStroke = true;
        }
        if (shouldStroke) data.stroke = stroke;
        if (this.mathJaxLabel.value) {
            let labelWithoutRender = {
                value: this.mathJaxLabel.value,
                anchor: this.anchorChoice.value.key,
                position: this.positionChoice.value.key,
                distance: this.labelDistance.value ?? undefined,
                color: this.labelColor.value ? this.labelColor.value.toString() : undefined
            };
            data.label = labelWithoutRender;
        }
        return data;
    }
    static fromJson(saveObject) {
        let ellipseComponent = new $f1cd0bf4955bc259$export$adcbac2b18b5c769();
        ellipseComponent.position = new $gBhAd.Point(saveObject.position);
        ellipseComponent.placePoint = saveObject.position;
        ellipseComponent.size = new $gBhAd.Point(saveObject.size);
        ellipseComponent.rotationDeg = saveObject.rotationDeg ?? 0;
        if (saveObject.fill) {
            if (saveObject.fill.color) {
                ellipseComponent.fillInfo.color = saveObject.fill.color;
                ellipseComponent.fillColorProperty.value = new $gBhAd.Color(saveObject.fill.color);
                ellipseComponent.fillColorProperty.updateHTML();
            }
            if (saveObject.fill.opacity != undefined) {
                ellipseComponent.fillInfo.opacity = saveObject.fill.opacity;
                ellipseComponent.fillOpacityProperty.value = new $gBhAd.Number(saveObject.fill.opacity * 100, "%");
                ellipseComponent.fillOpacityProperty.updateHTML();
            }
        }
        if (saveObject.stroke) {
            if (saveObject.stroke.color) {
                ellipseComponent.strokeInfo.color = saveObject.stroke.color;
                ellipseComponent.strokeColorProperty.value = new $gBhAd.Color(saveObject.stroke.color);
                ellipseComponent.strokeColorProperty.updateHTML();
            }
            if (saveObject.stroke.opacity != undefined) {
                ellipseComponent.strokeInfo.opacity = saveObject.stroke.opacity;
                ellipseComponent.strokeOpacityProperty.value = new $gBhAd.Number(saveObject.stroke.opacity * 100, "%");
                ellipseComponent.strokeOpacityProperty.updateHTML();
            }
            if (saveObject.stroke.width) {
                ellipseComponent.strokeInfo.width = new $gBhAd.Number(saveObject.stroke.width);
                ellipseComponent.strokeWidthProperty.value = ellipseComponent.strokeInfo.width;
                ellipseComponent.strokeWidthProperty.updateHTML();
            }
            if (saveObject.stroke.style) {
                ellipseComponent.strokeInfo.style = saveObject.stroke.style;
                ellipseComponent.strokeStyleProperty.value = (0, $f7d52ac80405fb45$export$18afec4cf520d708).find((item)=>item.key == saveObject.stroke.style);
                ellipseComponent.strokeStyleProperty.updateHTML();
            }
        }
        if (saveObject.label) {
            ellipseComponent.labelDistance.value = saveObject.label.distance ? new $gBhAd.Number(saveObject.label.distance) : new $gBhAd.Number(0);
            ellipseComponent.labelDistance.updateHTML();
            ellipseComponent.anchorChoice.value = saveObject.label.anchor ? (0, $6a68e99136784593$export$550f784d253b75ba).find((item)=>item.key == saveObject.label.anchor) : (0, $6a68e99136784593$export$362db847193ed989);
            ellipseComponent.anchorChoice.updateHTML();
            ellipseComponent.positionChoice.value = saveObject.label.position ? (0, $6a68e99136784593$export$550f784d253b75ba).find((item)=>item.key == saveObject.label.position) : (0, $6a68e99136784593$export$362db847193ed989);
            ellipseComponent.positionChoice.updateHTML();
            ellipseComponent.mathJaxLabel.value = saveObject.label.value;
            ellipseComponent.mathJaxLabel.updateHTML();
            ellipseComponent.labelColor.value = saveObject.label.color ? new $gBhAd.Color(saveObject.label.color) : null;
            ellipseComponent.labelColor.updateHTML();
            ellipseComponent.generateLabelRender();
        }
        ellipseComponent.placeFinish();
        ellipseComponent.updateTheme();
        return ellipseComponent;
    }
    toTikzString() {
        let optionsArray = [];
        if (this.isCircle) optionsArray.push("shape=circle");
        else optionsArray.push("shape=ellipse");
        if (this.fillInfo.opacity > 0) {
            if (this.fillInfo.color !== "default") {
                let c = new $gBhAd.Color(this.fillInfo.color);
                optionsArray.push("fill=" + c.toTikzString());
            }
            if (this.fillInfo.opacity != 1) optionsArray.push("fill opacity=" + this.fillInfo.opacity.toString());
        }
        if (this.strokeInfo.opacity > 0) {
            if (this.strokeInfo.color !== "default") {
                let c = new $gBhAd.Color(this.strokeInfo.color);
                optionsArray.push("draw=" + c.toTikzString());
            } else optionsArray.push("draw");
            if (this.strokeInfo.opacity != 1) optionsArray.push("draw opacity=" + this.strokeInfo.opacity.toString());
            let width = this.strokeInfo.width.convertToUnit("pt").value;
            if (width != 0.4) optionsArray.push("line width=" + width + "pt");
            if (this.strokeInfo.style != (0, $f7d52ac80405fb45$export$3f7ff86cb0e40ba1).key) optionsArray.push((0, $f7d52ac80405fb45$export$dfe11f4b6a1fc336)(this.strokeInfo.width, (0, $f7d52ac80405fb45$export$18afec4cf520d708).find((item)=>item.key == this.strokeInfo.style).dasharray));
        }
        let strokeWidth = this.strokeInfo.width.convertToUnit("px").value;
        optionsArray.push("inner sep=0");
        optionsArray.push("minimum width=" + (0, $429ca25d803b1e0f$export$5b0dabb733625ce9)(new $gBhAd.Number(this.size.x - strokeWidth, "px").convertToUnit("cm").value) + "cm");
        if (!this.isCircle) optionsArray.push("minimum height=" + (0, $429ca25d803b1e0f$export$5b0dabb733625ce9)(new $gBhAd.Number(this.size.y - strokeWidth, "px").convertToUnit("cm").value) + "cm");
        if (this.rotationDeg != 0) optionsArray.push(`rotate=${this.rotationDeg}`);
        let id = this.name.value;
        if (!id && this.mathJaxLabel.value) id = (0, $fc0737f7a4e7c327$export$96be6e195c19e554).instance.createExportID("Ellipse");
        let labelNodeStr = "";
        if (this.mathJaxLabel.value) {
            let labelStr = "anchor=" + this.labelPos.name;
            let labelDist = this.labelDistance.value.convertToUnit("cm");
            let norm = this.labelPos.direction.abs();
            norm = norm == 0 ? 1 : norm;
            let labelShift = this.labelPos.direction.mul(-labelDist.value / norm);
            let posShift = "";
            if (labelShift.x !== 0) posShift += "xshift=" + (0, $429ca25d803b1e0f$export$5b0dabb733625ce9)(labelShift.x) + "cm";
            if (labelShift.y !== 0) {
                posShift += posShift == "" ? "" : ", ";
                posShift += "yshift=" + (0, $429ca25d803b1e0f$export$5b0dabb733625ce9)(-labelShift.y) + "cm";
            }
            posShift = posShift == "" ? "" : "[" + posShift + "]";
            let posStr = this.positionChoice.value.key == (0, $6a68e99136784593$export$362db847193ed989).key ? id + ".center" : id + "." + this.positionChoice.value.name;
            let latexStr = this.mathJaxLabel.value ? "$" + this.mathJaxLabel.value + "$" : "";
            latexStr = latexStr && this.labelColor.value ? "\\textcolor" + this.labelColor.value.toTikzString() + "{" + latexStr + "}" : latexStr;
            labelNodeStr = " node[" + labelStr + "] at (" + posShift + posStr + "){" + latexStr + "}";
        }
        let optionsStr = optionsArray.length > 0 ? `[${optionsArray.join(", ")}]` : "";
        return `\\node${optionsStr}${id ? "(" + id + ")" : ""} at ${this.position.toTikzString()}{}${labelNodeStr};`;
    }
    requiredTikzLibraries() {
        return this.isCircle ? [] : [
            "shapes.geometric"
        ];
    }
    isInsideSelectionRectangle(selectionRectangle) {
        if ((0, $429ca25d803b1e0f$export$aedb7b212a60242f)(this.position, selectionRectangle)) // if the center of the ellipse is inside the rectangle -> done
        return true;
        //the corner points of the selection rectangle
        let boxPoints = [
            [
                selectionRectangle.x,
                selectionRectangle.y
            ],
            [
                selectionRectangle.x2,
                selectionRectangle.y
            ],
            [
                selectionRectangle.x2,
                selectionRectangle.y2
            ],
            [
                selectionRectangle.x,
                selectionRectangle.y2
            ]
        ];
        // apply transformation, which transforms the ellipse into a unit circle at the origin, to the box points -> the box points now describe some rotated parallelogram instead of a rectangle. this essentially transforms the calculation to an easier problem
        const points = boxPoints.map((point)=>new $gBhAd.Point(point[0], point[1]).sub(this.position).rotate(-this.rotationDeg).div(this.size.div(2)));
        for(let index = 0; index < points.length - 1; index++){
            const A = points[index];
            const B = points[(index + 1) % points.length];
            if (A.absSquared() <= 1 || B.absSquared() <= 1) // at least one corner point of the parallelogram is in the unit circle -> collision
            return true;
            // from here: no corner point of the current line segment is in the unit circle -> check if line segement cuts through the unit circle
            const AB = B.sub(A);
            const AC = A.mul(-1);
            // t*AB is the projection of AC onto AB, i.e. the closest point of the line described by A and B to the origin
            const t = AC.dot(AB) / AB.absSquared();
            if (t <= 1 && t >= 0) {
                // the closest point of the line through A and B to the origin lies on the line segment AB -> collision possible
                const P = A.add(AB.mul(t));
                if (P.absSquared() <= 1) // the closest point lies inside the unit circle -> collision
                return true;
            }
        }
        return false;
    }
    copyForPlacement() {
        return new $f1cd0bf4955bc259$export$adcbac2b18b5c769();
    }
    labelPos;
    updateLabelPosition() {
        if (!this.mathJaxLabel.value || !this.labelRendering) return;
        let labelSVG = this.labelRendering;
        let transformMatrix = this.getTransformMatrix();
        let useBBox = this.bbox.transform(transformMatrix);
        // get relevant positions and bounding boxes
        let textPos;
        if (this.positionChoice.value.key == (0, $6a68e99136784593$export$362db847193ed989).key) textPos = new $gBhAd.Point(this.bbox.cx, this.bbox.cy);
        else {
            let bboxHalfSize = new $gBhAd.Point(useBBox.w / 2, useBBox.h / 2);
            textPos = this.position.add(bboxHalfSize.mul(this.positionChoice.value.direction.div(this.positionChoice.value.direction.abs())));
        }
        let labelBBox = labelSVG.bbox();
        // calculate where on the label the anchor point should be
        let labelRef;
        let labelDist = this.labelDistance.value.convertToUnit("px").value ?? 0;
        if (this.anchorChoice.value.key == (0, $6a68e99136784593$export$362db847193ed989).key) {
            let clamp = function(value, min, max) {
                if (value < min) return min;
                else if (value > max) return max;
                else return value;
            };
            let horizontalTextPosition = clamp(Math.round(2 * (useBBox.cx - textPos.x) / useBBox.w), -1, 1);
            let verticalTextPosition = clamp(Math.round(2 * (useBBox.cy - textPos.y) / useBBox.h), -1, 1);
            labelRef = new $gBhAd.Point(horizontalTextPosition, verticalTextPosition);
            this.labelPos = (0, $6a68e99136784593$export$550f784d253b75ba).find((item)=>item.direction.eq(labelRef));
        } else {
            this.labelPos = this.anchorChoice.value;
            labelRef = this.labelPos.direction;
        }
        let ref = labelRef.add(1).div(2).mul(new $gBhAd.Point(labelBBox.w, labelBBox.h)).add(labelRef.mul(labelDist));
        // acutally move the label
        let movePos = textPos.sub(ref);
        labelSVG.transform(new $gBhAd.Matrix({
            translate: [
                movePos.x,
                movePos.y
            ]
        }));
    }
}



var $gBhAd = parcelRequire("gBhAd");


class $8fa4f618930e8b82$export$abaf34b597d19c32 extends (0, $f7d52ac80405fb45$export$a3fdc93f4064d151) {
    points = [];
    constructor(){
        super();
        this.addName();
        this.displayName = "Polygon";
        this.position = new $gBhAd.Point();
        this.shapeVisualization = (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas.polygon();
        this.shapeVisualization.hide();
        this.dragElement = (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas.polygon();
        this.dragElement.attr({
            fill: "transparent",
            stroke: "none"
        });
        this.visualization.add(this.shapeVisualization);
        this.visualization.add(this.dragElement);
    }
    recalculateSnappingPoints(matrix) {
        let relPositions = [];
        let halfSize = this.size.div(2);
        for (const anchor of (0, $6a68e99136784593$export$550f784d253b75ba)){
            if (anchor.key == (0, $6a68e99136784593$export$362db847193ed989).key) continue;
            let dirLength = anchor.direction.abs();
            dirLength = dirLength == 0 ? 1 : dirLength;
            relPositions.push({
                relPos: halfSize.mul(anchor.direction),
                anchorname: anchor.name
            });
        }
        for(let index = 0; index < this.points.length; index++){
            const p1 = this.points[index];
            const p2 = this.points[(index + 1) % this.points.length];
            relPositions.push({
                relPos: p1,
                anchorname: ""
            });
            relPositions.push({
                relPos: p1.add(p2).div(2),
                anchorname: ""
            });
        }
        if (!this.snappingPoints || this.snappingPoints.length != relPositions.length) {
            this.snappingPoints.forEach((snapPoint)=>snapPoint.show(false));
            this.snappingPoints = [];
            for (const element of relPositions)this.snappingPoints.push(new (0, $817613c536c3a4d7$export$a1e3a3b1875fcddc)(this, element.anchorname, element.relPos.add(this.position)));
        } else for(let index = 0; index < relPositions.length; index++){
            const relPos = relPositions[index].relPos;
            const snappingPoint = this.snappingPoints[index];
            snappingPoint.updateRelPosition(relPos);
            snappingPoint.recalculate();
        }
    }
    static bboxFromPoints(points) {
        let minX = Number.MAX_VALUE;
        let maxX = -Number.MAX_VALUE;
        let minY = Number.MAX_VALUE;
        let maxY = -Number.MAX_VALUE;
        for (const point of points){
            if (point.x < minX) minX = point.x;
            if (point.y < minY) minY = point.y;
            if (point.x > maxX) maxX = point.x;
            if (point.y > maxY) maxY = point.y;
        }
        return new $gBhAd.Box(minX, minY, maxX - minX, maxY - minY);
    }
    recalculateResizePoints() {
        if (this.resizeViz.length == this.points.length) {
            const transformMatrix = this.getTransformMatrix();
            for(let index = 0; index < this.points.length; index++){
                const point = this.points[index].transform(transformMatrix);
                const viz = this.resizeViz[index];
                viz.center(point.x, point.y);
            }
        }
    }
    resizeViz = [];
    resizable(resize) {
        if (resize == this.isResizing) return;
        this.isResizing = resize;
        if (resize) {
            // let originalPos: SVG.Point
            // let originalSize: SVG.Point
            let transformMatrixInv;
            const getInitialDim = ()=>{
                // originalPos = this.position.clone()
                // originalSize = this.size.clone()
                transformMatrixInv = this.getTransformMatrix().inverse();
            };
            for(let index = 0; index < this.points.length; index++){
                const point = this.points[index];
                let viz = (0, $429ca25d803b1e0f$export$a9cd85b3d0cd1648)();
                viz.node.style.cursor = "move";
                this.resizeViz.push(viz);
                let startPoint;
                let posOffset = new $gBhAd.Point();
                (0, $c9646859e7f18723$export$946b192100cb98a7).snapDrag(this, viz, true, {
                    dragStart: (pos)=>{
                        getInitialDim();
                        startPoint = new $gBhAd.Point(point);
                    },
                    dragMove: (pos, ev)=>{
                        pos = pos.transform(transformMatrixInv);
                        const transformMatrix = this.getTransformMatrix().lmultiply({
                            translate: [
                                -this.position.x,
                                -this.position.y
                            ]
                        });
                        pos = pos.add(posOffset);
                        this.points[index] = pos;
                        const bbox = $8fa4f618930e8b82$export$abaf34b597d19c32.bboxFromPoints(this.points);
                        const posDelta = new $gBhAd.Point(bbox.cx, bbox.cy);
                        posOffset = posOffset.sub(posDelta);
                        for(let index = 0; index < this.points.length; index++){
                            const point = this.points[index];
                            this.points[index] = point.sub(posDelta);
                        }
                        this.position = this.position.add(posDelta.transform(transformMatrix));
                        startPoint = pos;
                        this.update();
                    },
                    dragEnd: ()=>{
                        return true;
                    }
                });
            }
            this.update();
        } else {
            for (const viz of this.resizeViz){
                (0, $c9646859e7f18723$export$946b192100cb98a7).snapDrag(this, viz, false);
                viz.remove();
            }
            this.resizeViz = [];
        }
    }
    toJson() {
        let data = {
            type: "polygon",
            points: this.points.map((point)=>point.add(this.position))
        };
        if (this.rotationDeg) data.rotationDeg = this.rotationDeg;
        if (this.scaleState.x != 1 || this.scaleState.y != 1) data.scale = this.scaleState;
        let fill = {};
        let shouldFill = false;
        if (this.fillInfo.color != "default") {
            fill.color = this.fillInfo.color;
            shouldFill = true;
        }
        if (this.fillInfo.opacity != 0) {
            fill.opacity = this.fillInfo.opacity;
            shouldFill = true;
        }
        if (shouldFill) data.fill = fill;
        let stroke = {};
        let shouldStroke = false;
        if (this.strokeInfo.color != "default") {
            stroke.color = this.strokeInfo.color;
            shouldStroke = true;
        }
        if (this.strokeInfo.opacity != 1) {
            stroke.opacity = this.strokeInfo.opacity;
            shouldStroke = true;
        }
        if (!this.strokeInfo.width.eq(new $gBhAd.Number("1pt"))) {
            stroke.width = this.strokeInfo.width;
            shouldStroke = true;
        }
        if (this.strokeInfo.style != (0, $f7d52ac80405fb45$export$3f7ff86cb0e40ba1).key) {
            stroke.style = this.strokeInfo.style;
            shouldStroke = true;
        }
        if (shouldStroke) data.stroke = stroke;
        if (this.mathJaxLabel.value) {
            let labelWithoutRender = {
                value: this.mathJaxLabel.value,
                anchor: this.anchorChoice.value.key,
                position: this.positionChoice.value.key,
                distance: this.labelDistance.value ?? undefined,
                color: this.labelColor.value ? this.labelColor.value.toString() : undefined
            };
            data.label = labelWithoutRender;
        }
        return data;
    }
    static fromJson(saveObject) {
        let polygonComponent = new $8fa4f618930e8b82$export$abaf34b597d19c32();
        polygonComponent.placingPoints = saveObject.points.map((point)=>new $gBhAd.Point(point)).concat(new $gBhAd.Point(saveObject.points.at(-1)));
        polygonComponent.placeFinish();
        polygonComponent.rotationDeg = saveObject.rotationDeg ?? 0;
        polygonComponent.scaleState = saveObject.scale ?? new $gBhAd.Point(1, 1);
        if (saveObject.fill) {
            if (saveObject.fill.color) {
                polygonComponent.fillInfo.color = saveObject.fill.color;
                polygonComponent.fillColorProperty.value = new $gBhAd.Color(saveObject.fill.color);
                polygonComponent.fillColorProperty.updateHTML();
            }
            if (saveObject.fill.opacity != undefined) {
                polygonComponent.fillInfo.opacity = saveObject.fill.opacity;
                polygonComponent.fillOpacityProperty.value = new $gBhAd.Number(saveObject.fill.opacity * 100, "%");
                polygonComponent.fillOpacityProperty.updateHTML();
            }
        }
        if (saveObject.stroke) {
            if (saveObject.stroke.color) {
                polygonComponent.strokeInfo.color = saveObject.stroke.color;
                polygonComponent.strokeColorProperty.value = new $gBhAd.Color(saveObject.stroke.color);
                polygonComponent.strokeColorProperty.updateHTML();
            }
            if (saveObject.stroke.opacity != undefined) {
                polygonComponent.strokeInfo.opacity = saveObject.stroke.opacity;
                polygonComponent.strokeOpacityProperty.value = new $gBhAd.Number(saveObject.stroke.opacity * 100, "%");
                polygonComponent.strokeOpacityProperty.updateHTML();
            }
            if (saveObject.stroke.width) {
                polygonComponent.strokeInfo.width = new $gBhAd.Number(saveObject.stroke.width);
                polygonComponent.strokeWidthProperty.value = polygonComponent.strokeInfo.width;
                polygonComponent.strokeWidthProperty.updateHTML();
            }
            if (saveObject.stroke.style) {
                polygonComponent.strokeInfo.style = saveObject.stroke.style;
                polygonComponent.strokeStyleProperty.value = (0, $f7d52ac80405fb45$export$18afec4cf520d708).find((item)=>item.key == saveObject.stroke.style);
                polygonComponent.strokeStyleProperty.updateHTML();
            }
        }
        if (saveObject.label) {
            polygonComponent.labelDistance.value = saveObject.label.distance ? new $gBhAd.Number(saveObject.label.distance) : new $gBhAd.Number(0);
            polygonComponent.labelDistance.updateHTML();
            polygonComponent.anchorChoice.value = saveObject.label.anchor ? (0, $6a68e99136784593$export$550f784d253b75ba).find((item)=>item.key == saveObject.label.anchor) : (0, $6a68e99136784593$export$362db847193ed989);
            polygonComponent.anchorChoice.updateHTML();
            polygonComponent.positionChoice.value = saveObject.label.position ? (0, $6a68e99136784593$export$550f784d253b75ba).find((item)=>item.key == saveObject.label.position) : (0, $6a68e99136784593$export$362db847193ed989);
            polygonComponent.positionChoice.updateHTML();
            polygonComponent.mathJaxLabel.value = saveObject.label.value;
            polygonComponent.mathJaxLabel.updateHTML();
            polygonComponent.labelColor.value = saveObject.label.color ? new $gBhAd.Color(saveObject.label.color) : null;
            polygonComponent.labelColor.updateHTML();
            polygonComponent.generateLabelRender();
        }
        polygonComponent.updateTheme();
        polygonComponent.update();
        return polygonComponent;
    }
    toTikzString() {
        let optionsArray = [];
        if (this.fillInfo.opacity > 0) {
            if (this.fillInfo.color !== "default") {
                let c = new $gBhAd.Color(this.fillInfo.color);
                optionsArray.push("fill=" + c.toTikzString());
            }
            if (this.fillInfo.opacity != 1) optionsArray.push("fill opacity=" + this.fillInfo.opacity.toString());
        }
        if (this.strokeInfo.opacity > 0) {
            if (this.strokeInfo.color !== "default") {
                let c = new $gBhAd.Color(this.strokeInfo.color);
                optionsArray.push("draw=" + c.toTikzString());
            } else optionsArray.push("draw");
            if (this.strokeInfo.opacity != 1) optionsArray.push("draw opacity=" + this.strokeInfo.opacity.toString());
            let width = this.strokeInfo.width.convertToUnit("pt").value;
            if (width != 0.4) optionsArray.push("line width=" + width + "pt");
            if (this.strokeInfo.style != (0, $f7d52ac80405fb45$export$3f7ff86cb0e40ba1).key) optionsArray.push((0, $f7d52ac80405fb45$export$dfe11f4b6a1fc336)(this.strokeInfo.width, (0, $f7d52ac80405fb45$export$18afec4cf520d708).find((item)=>item.key == this.strokeInfo.style).dasharray));
        }
        let id = this.name.value;
        if (!id && this.mathJaxLabel.value) id = (0, $fc0737f7a4e7c327$export$96be6e195c19e554).instance.createExportID("Ellipse");
        let labelNodeStr = "";
        if (this.mathJaxLabel.value) {
            let labelStr = "anchor=" + this.labelPos.name;
            let labelDist = this.labelDistance.value.convertToUnit("cm");
            let norm = this.labelPos.direction.abs();
            norm = norm == 0 ? 1 : norm;
            let labelShift = this.labelPos.direction.mul(-labelDist.value / norm);
            let posStr = this.textPos.add(labelShift).toTikzString();
            let latexStr = this.mathJaxLabel.value ? "$" + this.mathJaxLabel.value + "$" : "";
            latexStr = latexStr && this.labelColor.value ? "\\textcolor" + this.labelColor.value.toTikzString() + "{" + latexStr + "}" : latexStr;
            labelNodeStr = " node[" + labelStr + "] at " + posStr + "{" + latexStr + "}";
        }
        const transformMatrix = this.getTransformMatrix();
        let pointsStr = this.points.map((point)=>point.transform(transformMatrix).toTikzString()).concat([
            "cycle"
        ]).join(" -- ");
        let optionsStr = optionsArray.length > 0 ? `[${optionsArray.join(", ")}]` : "";
        return `\\path${optionsStr} ${pointsStr} ${labelNodeStr};`;
    }
    requiredTikzLibraries() {
        return [];
    }
    isInsideSelectionRectangle(selectionRectangle) {
        const transformMatrix = this.getTransformMatrix();
        let points = this.points.map((point)=>point.transform(transformMatrix));
        for(let idx = 0; idx < points.length; idx++){
            const p1 = points[idx];
            const p2 = points[(idx + 1) % points.length];
            if ((0, $429ca25d803b1e0f$export$51318765f3340fac)(new $gBhAd.Line().plot(p1.x, p1.y, p2.x, p2.y), selectionRectangle)) return true;
        }
        // TODO selection rectangle inside polygon?
        return false;
    }
    scaleState = new $gBhAd.Point(1, 1);
    flip(horizontal) {
        this.scaleState.y *= -1;
        this.rotationDeg = (horizontal ? 0 : 180) - this.rotationDeg;
        this.simplifyRotationAngle();
        this.update();
    }
    getTransformMatrix() {
        return new $gBhAd.Matrix({
            rotate: -this.rotationDeg,
            origin: [
                0,
                0
            ],
            scale: [
                this.scaleState.x,
                this.scaleState.y
            ],
            translate: [
                this.position.x,
                this.position.y
            ]
        });
    }
    update() {
        let strokeWidth = this.strokeInfo.width.convertToUnit("px").value;
        let transformMatrix = this.getTransformMatrix();
        let pointsArray = this.points.map((point)=>point.toArray());
        const bbox = $8fa4f618930e8b82$export$abaf34b597d19c32.bboxFromPoints(this.points);
        this.size = new $gBhAd.Point(bbox.w, bbox.h);
        this._bbox = bbox.transform(transformMatrix);
        this.dragElement.plot(pointsArray);
        this.dragElement.size(this.size.x, this.size.y);
        this.dragElement.transform(transformMatrix);
        this.shapeVisualization.plot(pointsArray);
        this.shapeVisualization.size(this.size.x < strokeWidth ? 0 : this.size.x - strokeWidth, this.size.y < strokeWidth ? 0 : this.size.y - strokeWidth);
        this.shapeVisualization.transform(transformMatrix);
        this.relPosition = this.position.sub(new $gBhAd.Point(this.bbox.x, this.bbox.y));
        this.recalculateSelectionVisuals();
        this.recalculateSnappingPoints();
        this.recalculateResizePoints();
        this.updateLabelPosition();
    }
    recalculateSelectionVisuals() {
        if (this.selectionElement) {
            let lineWidth = (0, $429ca25d803b1e0f$export$80fcba011b33afb8);
            this.selectionElement.size(this.size.x + lineWidth, this.size.y + lineWidth).center(0, 0).transform(this.getTransformMatrix());
        }
    }
    placeMove(pos, ev) {
        if (this.placingPoints.length < 1) // not started placing
        (0, $a0a429836785e44a$export$5d153f96fe924d6e).instance.moveTo(pos);
        else {
            let placePoint = this.placingPoints.at(-2);
            let secondPoint;
            if (ev && ev.ctrlKey) {
                // get point on one of the two diagonals
                let diff = pos.sub(placePoint);
                if (diff.x * diff.y < 0) secondPoint = new $gBhAd.Point(pos.x - pos.y, pos.y - pos.x).add(placePoint.x + placePoint.y).div(2);
                else secondPoint = new $gBhAd.Point(placePoint.x - placePoint.y, placePoint.y - placePoint.x).add(pos.x + pos.y).div(2);
            } else secondPoint = pos;
            this.placingPoints[this.placingPoints.length - 1] = secondPoint;
            let bbox = $8fa4f618930e8b82$export$abaf34b597d19c32.bboxFromPoints(this.placingPoints);
            this.position = new $gBhAd.Point(bbox.cx, bbox.cy);
            this.size = new $gBhAd.Point(bbox.w, bbox.h);
            this.points = this.placingPoints.map((point)=>point.sub(this.position));
            this.update();
        }
    }
    placingPoints = [];
    placeStep(pos, ev) {
        if (this.finishedPlacing) return true;
        if (this.points.length == 0) {
            this.placingPoints.push(pos.clone());
            this.shapeVisualization.show();
            this.updateTheme();
            (0, $a0a429836785e44a$export$5d153f96fe924d6e).instance.visible = false;
        } else {
            if (this.placingPoints.at(-2).eq(pos)) return true;
        }
        this.placingPoints.push(pos);
        this.placeMove(pos, ev);
        return false;
    }
    placeFinish() {
        if (this.finishedPlacing) return;
        if (this.placingPoints.length == 0) this.placeStep(new $gBhAd.Point());
        this.placingPoints.pop();
        if (this.placingPoints.length >= 2 && this.placingPoints.at(-1).eq(this.placingPoints.at(-2))) this.placingPoints.pop();
        if (this.placingPoints.length < 2) {
            // if not even 2 corner points -> no polygon, delete
            (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.removeComponent(this);
            return;
        }
        let bbox = $8fa4f618930e8b82$export$abaf34b597d19c32.bboxFromPoints(this.placingPoints);
        this.position = new $gBhAd.Point(bbox.cx, bbox.cy);
        this.size = new $gBhAd.Point(bbox.w, bbox.h);
        this.points = this.placingPoints.map((point)=>point.sub(this.position));
        this.finishedPlacing = true;
        this.update();
        this.draggable(true);
        this.shapeVisualization.show();
        this.updateTheme();
        (0, $a0a429836785e44a$export$5d153f96fe924d6e).instance.visible = false;
        this.update();
    }
    copyForPlacement() {
        return new $8fa4f618930e8b82$export$abaf34b597d19c32();
    }
    labelPos;
    textPos;
    updateLabelPosition() {
        if (!this.mathJaxLabel.value || !this.labelRendering) return;
        let labelSVG = this.labelRendering;
        // get relevant positions and bounding boxes
        let transformMatrix = this.getTransformMatrix();
        let bbox = $8fa4f618930e8b82$export$abaf34b597d19c32.bboxFromPoints(this.points);
        this.textPos = new $gBhAd.Point(this.bbox.cx, this.bbox.cy);
        let textPosNoTrans = new $gBhAd.Point();
        if (this.positionChoice.value.key != (0, $6a68e99136784593$export$362db847193ed989).key) {
            let bboxHalfSize = new $gBhAd.Point(bbox.w / 2, bbox.h / 2);
            textPosNoTrans = bboxHalfSize.mul(this.positionChoice.value.direction);
            this.textPos = textPosNoTrans.transform(transformMatrix);
        }
        let labelBBox = labelSVG.bbox();
        // calculate where on the label the anchor point should be
        let labelRef;
        let labelDist = this.labelDistance.value.convertToUnit("px").value ?? 0;
        if (this.anchorChoice.value.key == (0, $6a68e99136784593$export$362db847193ed989).key) {
            let clamp = function(value, min = -1, max = 1) {
                if (value < min) return min;
                else if (value > max) return max;
                else return value;
            };
            let horizontalTextPosition = clamp(Math.round(2 * (bbox.cx - textPosNoTrans.x) / bbox.w));
            let verticalTextPosition = clamp(Math.round(2 * (bbox.cy - textPosNoTrans.y) / bbox.h));
            labelRef = new $gBhAd.Point(horizontalTextPosition, verticalTextPosition).rotate(this.rotationDeg);
            labelRef.x = Math.round(labelRef.x);
            labelRef.y = Math.round(labelRef.y);
            this.labelPos = (0, $6a68e99136784593$export$550f784d253b75ba).find((item)=>item.direction.eq(labelRef));
        } else {
            this.labelPos = this.anchorChoice.value;
            labelRef = this.labelPos.direction;
        }
        let ref = labelRef.add(1).div(2).mul(new $gBhAd.Point(labelBBox.w, labelBBox.h)).add(labelRef.mul(labelDist));
        // acutally move the label
        let movePos = this.textPos.sub(ref);
        labelSVG.transform(new $gBhAd.Matrix({
            translate: [
                movePos.x,
                movePos.y
            ]
        }));
    }
}



var $gBhAd = parcelRequire("gBhAd");


class $33fd6c292c111484$export$450247cd99a94b80 extends (0, $6a68e99136784593$export$c15be3828826f6ee) {
    groupedComponents = [];
    constructor(components){
        super();
        (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.circuitComponents.pop(); // add later at specific index instead
        this.displayName = "Group";
        this.snappingPoints = [];
        this.groupedComponents.push(...components);
        const idx = this.visualization.parent().index(components[0].visualization);
        this.visualization.parent().add(this.visualization, idx);
        let firstIndex = -1;
        for (const component of components){
            const idx = (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.circuitComponents.indexOf(component);
            firstIndex = firstIndex < 0 ? idx : firstIndex;
            (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.circuitComponents.splice(idx, 1);
            component.parentGroup = this;
            component.viewSelected(false);
            this.visualization.add(component.visualization);
        }
        (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.circuitComponents.splice(firstIndex, 0, this); // added here
        this.propertiesHTMLRows.push(new (0, $c66494ce03e8372a$export$4de04f378a8de0fe)("Grouping").buildHTML());
        let grouping = new (0, $995311ad94412d30$export$d4fc42aa08871cc3)(1, [
            [
                "Ungroup",
                ""
            ]
        ], [
            (ev)=>this.ungroup()
        ]);
        this.propertiesHTMLRows.push(grouping.buildHTML());
        this.update();
        (0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.selectComponents([
            this
        ], (0, $28c7e05d96c1a267$export$91484609d16ec765).RESET);
        this.snappingPoints = this.groupedComponents.map((component)=>component.snappingPoints).flat();
    }
    static group(circuitComponents) {
        new $33fd6c292c111484$export$450247cd99a94b80(circuitComponents);
        (0, $815383aeedb00f00$export$897c9ed706d8ea48).addState();
    }
    ungroup() {
        const idx = (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.circuitComponents.indexOf(this);
        (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.circuitComponents.splice(idx, 1, ...this.groupedComponents);
        const parent = this.visualization.parent();
        const currentIdx = parent.index(this.visualization);
        for(let index = 0; index < this.groupedComponents.length; index++){
            const component = this.groupedComponents[index];
            component.parentGroup = null;
            parent.add(component.visualization, currentIdx + index);
        }
        (0, $28c7e05d96c1a267$export$3c9dea9cd39918a3).instance.selectComponents(this.groupedComponents, (0, $28c7e05d96c1a267$export$91484609d16ec765).RESET);
        this.groupedComponents = [];
        this.remove();
        (0, $815383aeedb00f00$export$897c9ed706d8ea48).addState();
    }
    isInsideSelectionRectangle(selectionRectangle) {
        return (0, $429ca25d803b1e0f$export$11f7f05b1cf6c7d0)(this._bbox, selectionRectangle);
    }
    getSnappingInfo() {
        return {
            additionalSnappingPoints: [],
            trackedSnappingPoints: this.snappingPoints
        };
    }
    draggable(drag) {
        for (const element of this.groupedComponents)element.draggable(drag);
    }
    resizable(resize) {
        for (const element of this.groupedComponents)element.resizable(resize);
    }
    recalculateResizePoints() {
    //No resizing for now
    }
    moveTo(position) {
        const rel = position.sub(this.position);
        for (const component of this.groupedComponents)component.moveRel(rel);
        this.update();
    }
    rotate(angleDeg) {
        for (const element of this.groupedComponents){
            element.moveTo(element.position.rotate(angleDeg, this.position));
            element.rotate(angleDeg);
        }
        this.update();
    }
    flip(horizontal) {
        for (const element of this.groupedComponents){
            const moveRel = element.position.sub(this.position).mul(new $gBhAd.Point(horizontal ? 0 : -2, horizontal ? -2 : 0));
            element.moveRel(moveRel);
            element.flip(horizontal);
        }
        this.update();
    }
    update() {
        this._bbox = undefined;
        for (const component of this.groupedComponents)if (this._bbox) this._bbox = this._bbox.merge(component.bbox);
        else this._bbox = component.bbox;
        this.position = new $gBhAd.Point(this._bbox.cx, this._bbox.cy);
        this.relPosition = this.position.sub(new $gBhAd.Point(this._bbox.x, this._bbox.y));
        this.recalculateSelectionVisuals();
    }
    recalculateSelectionVisuals() {
        if (this.selectionElement) {
            let box = this.bbox;
            this.selectionElement.size(box.w, box.h);
            this.selectionElement.center(this.position.x, this.position.y);
        }
    }
    toJson() {
        let componentSaveObjects = [];
        for (const component of this.groupedComponents)componentSaveObjects.push(component.toJson());
        let saveObject = {
            type: "group",
            components: componentSaveObjects
        };
        return saveObject;
    }
    static fromJson(saveObject) {
        let components = [];
        for (const saveObj of saveObject.components)components.push((0, $e74b421401bcd19c$export$e94a9bf0a1c3ce0b).fromJson(saveObj));
        return new $33fd6c292c111484$export$450247cd99a94b80(components);
    }
    toTikzString() {
        let outStr = [];
        for (const component of this.groupedComponents)outStr.push(component.toTikzString());
        return outStr.join("\n");
    }
    toSVG(defs) {
        let group = new $gBhAd.G();
        for (const element of this.groupedComponents)group.add(element.toSVG(defs));
        return group;
    }
    copyForPlacement() {
        //not needed
        return;
    }
    remove() {
        this.viewSelected(false);
        this.selectionElement?.remove();
        for (const component of this.groupedComponents)component.remove();
        this.visualization.remove();
    }
    placeMove(pos, ev) {
        //not needed
        return;
    }
    placeStep(pos, ev) {
        //not needed
        return;
    }
    placeFinish() {
        //not needed
        return;
    }
    updateLabelPosition() {
        //not needed
        return;
    }
}



/**
 * @module snapController
 */ 
var $gBhAd = parcelRequire("gBhAd");

class $53f326ae950d374f$export$6c6ec69acef94984 {
    static _instance;
    static get instance() {
        if (!$53f326ae950d374f$export$6c6ec69acef94984._instance) $53f326ae950d374f$export$6c6ec69acef94984._instance = new $53f326ae950d374f$export$6c6ec69acef94984();
        return $53f326ae950d374f$export$6c6ec69acef94984._instance;
    }
    fixedSnapPoints = [];
    movingSnapPoints = [];
    additionalSnapPoints = [];
    whereSnap = [];
    constructor(){}
    recalculateAdditionalSnapPoints() {
        this.additionalSnapPoints.forEach((snapPoint)=>snapPoint.recalculate());
    }
    updateSnapPoints(currentComponent, adjustOnly = false) {
        //reset
        this.fixedSnapPoints.forEach((snapPoint)=>snapPoint.show(false));
        this.movingSnapPoints.forEach((snapPoint)=>snapPoint.show(false));
        this.additionalSnapPoints.forEach((snapPoint)=>snapPoint.show(false));
        this.fixedSnapPoints = [];
        this.movingSnapPoints = [];
        this.additionalSnapPoints = [];
        if (currentComponent) {
            if (currentComponent.isSelected && !adjustOnly) {
                for (const component of (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.circuitComponents)if (component.isSelected) {
                    if (currentComponent === component) {
                        let snappingInfo = component.getSnappingInfo();
                        this.movingSnapPoints.push(...snappingInfo.trackedSnappingPoints);
                        this.additionalSnapPoints.push(...snappingInfo.additionalSnappingPoints);
                    } else this.movingSnapPoints.push(...component.snappingPoints);
                } else this.fixedSnapPoints.push(...component.snappingPoints);
            } else for (const component of (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.circuitComponents){
                if (component !== currentComponent) this.fixedSnapPoints.push(...component.snappingPoints);
                else if (!adjustOnly) {
                    let snappingInfo = component.getSnappingInfo();
                    this.movingSnapPoints.push(...snappingInfo.trackedSnappingPoints);
                    this.additionalSnapPoints.push(...snappingInfo.additionalSnappingPoints);
                }
            }
        } else for (const component of (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance.circuitComponents)this.fixedSnapPoints.push(...component.snappingPoints);
        if (this.whereSnap.length > 0) this.showSnapPoints();
        else this.hideSnapPoints();
    }
    /**
     * show the snap points on the canvas (doesn't show grid points)
     */ showSnapPoints() {
        this.fixedSnapPoints.forEach((snapPoint)=>{
            snapPoint.show(true, false);
        });
        this.movingSnapPoints.forEach((snapPoint)=>{
            snapPoint.show(true, true);
        });
        this.additionalSnapPoints.forEach((snapPoint)=>{
            snapPoint.show(true, true);
        });
    }
    /**
     * hide the snap points again
     */ hideSnapPoints() {
        // remove all the snap point visualizations from the svg canvas
        this.fixedSnapPoints.forEach((snapPoint)=>{
            snapPoint.show(false);
        });
        this.movingSnapPoints.forEach((snapPoint)=>{
            snapPoint.show(false);
        });
        this.additionalSnapPoints.forEach((snapPoint)=>{
            snapPoint.show(false);
        });
        while(this.whereSnap.length > 0)this.whereSnap.pop().remove();
    }
    /**
     * Snap a point to the grid or one of the added snap points.
     * Calculations done in px since the node snap points are defined in px
     */ snapPoint(pos, component) {
        // 1. Calculate grid snap points
        const canvasController = (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance;
        let gridSpacing = new $gBhAd.Number(canvasController.majorGridSizecm / canvasController.majorGridSubdivisions, "cm").convertToUnit("px").value;
        // take zoom level into account (canvas.screenctm().a): zoomed in means smaller maximum distance
        const maxSnapDistance = new $gBhAd.Number(1, "cm").convertToUnit("px").value / (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas.node.getScreenCTM().a;
        const maxSnapDistance2 = maxSnapDistance * maxSnapDistance;
        let relSnapPoints = this.movingSnapPoints.map((snapPoint)=>snapPoint.relToComponentAnchor().add(snapPoint.componentReference.position).sub(component.position));
        if (this.additionalSnapPoints) relSnapPoints.push(...this.additionalSnapPoints.map((snapPoint)=>snapPoint.relToComponentAnchor()));
        if (relSnapPoints.length < 1) relSnapPoints.push(new $gBhAd.Point());
        const movingSnapPoints = relSnapPoints.map((point)=>pos.add(point));
        if (!(0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.gridVisible) // effectively only snap the origin
        gridSpacing = 1e9;
        // directly calculate the closest grid snapping point to each possible relSnapPoint and filter which is closest overall
        let distStruct = movingSnapPoints.reduce(/**
         * @param {DistStruct} prevVal - helper struct for finding snap point with lowest dist. to a grid point
         * @param {SVG.Point} movSnapPoint - possible point to snap to (grid)
         * @returns {DistStruct}
         */ (prevVal, movSnapPoint)=>{
            const x = Math.round(movSnapPoint.x / gridSpacing) * gridSpacing;
            const y = Math.round(movSnapPoint.y / gridSpacing) * gridSpacing;
            const gridPoint = new $gBhAd.Point(x, y);
            return this.reduceSinglePointPair(movSnapPoint, gridPoint, prevVal, maxSnapDistance2);
        }, {
            dist: Number.MAX_VALUE,
            snapPoints: []
        });
        // 2. calculate bounds where a closer point could lie
        let relSnapPointsMinX = relSnapPoints[0].x, relSnapPointsMaxX = relSnapPoints[0].x, relSnapPointsMinY = relSnapPoints[0].y, relSnapPointsMaxY = relSnapPoints[0].y;
        for (const point of relSnapPoints){
            if (point.x < relSnapPointsMinX) relSnapPointsMinX = point.x;
            else if (point.x > relSnapPointsMaxX) relSnapPointsMaxX = point.x;
            if (point.y < relSnapPointsMinY) relSnapPointsMinY = point.y;
            else if (point.y > relSnapPointsMaxY) relSnapPointsMaxY = point.y;
        }
        const xMin = relSnapPointsMinX + pos.x - maxSnapDistance;
        const yMin = relSnapPointsMinY + pos.y - maxSnapDistance;
        const xMax = relSnapPointsMaxX + pos.x + maxSnapDistance;
        const yMax = relSnapPointsMaxY + pos.y + maxSnapDistance;
        // 3. filter remaining snap points
        const filteredFixSnapPoints = this.fixedSnapPoints.filter((point)=>point.x >= xMin && point.x <= xMax && point.y >= yMin && point.y <= yMax);
        // 4. snap to non grid points
        if (filteredFixSnapPoints.length > 0) distStruct = this.getSnapDistStruct(movingSnapPoints, filteredFixSnapPoints, distStruct);
        // 5. Calculate snapped point using vector
        if (distStruct.snapPoints.length == 0) distStruct.vector = new $gBhAd.Point();
        else this.positionSnapPoints(distStruct.snapPoints);
        return distStruct.vector.add(pos);
    }
    positionSnapPoints(positions) {
        while(positions.length < this.whereSnap.length)this.whereSnap.pop().remove();
        while(positions.length > this.whereSnap.length)this.whereSnap.push((0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas.circle(4).fill("none").stroke({
            color: "var(--bs-yellow)"
        }));
        for(let index = 0; index < positions.length; index++){
            const position = positions[index];
            const snap = this.whereSnap[index];
            snap.center(position.x, position.y);
        }
    }
    /**
     * Snap absolute points to absolute positions. The point with the lowest distance is returned with its additional
     * information ({@link DistStruct}). As this function supports multiple possible (moving) snap points, the returned
     * vector should be used for moving the object to the snapped position.
     */ getSnapDistStruct(movingSnapPoints, fixedSnapPoints, initialDistStruct, maxSnapDistance2) {
        if (!initialDistStruct) initialDistStruct = {
            dist: Number.MAX_VALUE,
            snapPoints: []
        };
        if (!maxSnapDistance2) maxSnapDistance2 = Number.MAX_VALUE;
        return movingSnapPoints.reduce((prevVal, movSnapPoint)=>fixedSnapPoints.reduce((prevVal, fixSnapPoint)=>{
                return this.reduceSinglePointPair(movSnapPoint, fixSnapPoint, prevVal, maxSnapDistance2);
            }, prevVal), initialDistStruct);
    }
    reduceSinglePointPair(movingSnapPoint, fixedSnapPoint, previousDist, maxSnapDistance2) {
        const vector = fixedSnapPoint.sub(movingSnapPoint);
        // check if the already established move vector makes the current point pair intersect, i.e. the vectors are the same
        if (previousDist.vector?.eq(vector, 1e-2)) {
            //if so, we are done and add the point to the array
            previousDist.snapPoints.push(fixedSnapPoint);
            return previousDist;
        }
        const squaredDistance = vector.absSquared();
        if (squaredDistance > previousDist.dist || squaredDistance > maxSnapDistance2) return previousDist;
        previousDist.dist = squaredDistance;
        previousDist.vector = vector;
        previousDist.snapPoints = [
            fixedSnapPoint
        ];
        return previousDist;
    }
}


/**
 * @module snapCursorController
 */ 
var $gBhAd = parcelRequire("gBhAd");

class $a0a429836785e44a$export$5d153f96fe924d6e {
    static _instance;
    static get instance() {
        if (!$a0a429836785e44a$export$5d153f96fe924d6e._instance) $a0a429836785e44a$export$5d153f96fe924d6e._instance = new $a0a429836785e44a$export$5d153f96fe924d6e();
        return $a0a429836785e44a$export$5d153f96fe924d6e._instance;
    }
    #cursorViewBox;
    cursor;
    /**
     * Called only once by index.js. Use {@link controller} to get the instance.
     *
     * @param {SVG.Container} container
     */ constructor(){
        const cursorSymbol = new $gBhAd.Symbol(document.getElementById("snapCursor"));
        this.cursor = (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas.use(cursorSymbol);
        this.cursor.id("snapCursorUse");
        this.#cursorViewBox = cursorSymbol.viewbox();
        this.cursor.width(this.#cursorViewBox.width);
        this.cursor.height(this.#cursorViewBox.height);
        // CanvasController.instance.canvas.add(this.cursor);
        this.cursor.hide();
    }
    /**
     * Moves the cursor to a new position.
     *
     * @param {SVG.Point} position - the new position
     */ moveTo(position) {
        this.cursor.move(position.x - this.#cursorViewBox.cx, position.y - this.#cursorViewBox.cy);
    }
    /**
     * Show or hide the cursor.
     *
     * @param {boolean} b - the visibility
     */ set visible(b) {
        if (b) this.cursor.show();
        else this.cursor.hide();
    }
    /**
     * Get the visibility.
     *
     * @returns {boolean} the visibility
     */ get visible() {
        return this.cursor.visible();
    }
}


/**
 * @module snapPoint
 */ 
var $gBhAd = parcelRequire("gBhAd");


class $817613c536c3a4d7$export$a1e3a3b1875fcddc extends $gBhAd.Point {
    componentReference;
    anchorName;
    relPosition;
    element;
    constructor(componentReference, anchorName, relPosition){
        super();
        this.componentReference = componentReference;
        this.anchorName = anchorName;
        this.relPosition = relPosition;
        this.recalculate();
    }
    recalculate(transformMatrix = this.componentReference.getTransformMatrix()) {
        const point = this.relPosition.transform(transformMatrix);
        this.x = point.x;
        this.y = point.y;
        if (this.element) this.element.center(this.x, this.y);
    }
    updateRelPosition(relPosition) {
        this.relPosition = relPosition;
    }
    relToComponentAnchor() {
        return this.sub(this.componentReference.position);
    }
    show(show = true, moving = false) {
        if (show) {
            if (!this.element) {
                const container = (0, $1c90e793f342bb2a$export$88e1240f06a672d2).instance.canvas;
                this.element = container.circle(4).fill("none").stroke({
                    color: moving ? "var(--bs-cyan)" : (0, $429ca25d803b1e0f$export$1617d35435c603f6),
                    width: 1
                });
                container.add(this.element);
                this.element.center(this.x, this.y);
            }
        } else {
            this.element?.remove();
            this.element = null;
        }
    }
}



var $gBhAd = parcelRequire("gBhAd");

function $763663756c59a47c$export$828e7be55b645f77(text, textBox) {
    const fontSize = (0, $e31ac52a2c203df3$export$67baea80019ff381).find((fs)=>fs.key == text.fontSize).size.toString() + "pt";
    const explicitLines = text.text.split("\n").map((line)=>line.trim());
    const lines = explicitLines.map((line)=>$763663756c59a47c$var$wrapLabel(line, fontSize, textBox.w)).flat(2);
    let tspans = [];
    for(let index = 0; index < lines.length; index++){
        const line = lines[index];
        const remainingLineSpace = textBox.w - line.width;
        const xoffset = text.align == (0, $e31ac52a2c203df3$export$3720eb13f948f394).RIGHT ? remainingLineSpace : text.align == (0, $e31ac52a2c203df3$export$3720eb13f948f394).CENTER ? remainingLineSpace / 2 : 0;
        let dy = "";
        if (tspans.length == 0) {
            if (text.justify == 1) dy = ` dy="-${lines.length * 1.2}em"`;
            else if (text.justify == 0) dy = ` dy="-${(1.2 * lines.length / 2).toPrecision(3)}em"`;
        } else dy = ' dy="1.2em"';
        let blockFormat = "";
        if (text.align == (0, $e31ac52a2c203df3$export$3720eb13f948f394).JUSTIFY && index < lines.length - 1) {
            const words = line.text.split(" ");
            if (words.length > 1) blockFormat = ` word-spacing="${remainingLineSpace / (words.length - 1)}px"`;
        }
        tspans.push(`<tspan x="${textBox.x + xoffset}"${blockFormat} baseline-shift="-0.85em"${dy}>${line.text}</tspan>`);
    }
    const textPos = new $gBhAd.Point(textBox.x, text.justify == -1 ? textBox.y : text.justify == 1 ? textBox.y2 : textBox.cy);
    let svgText = new $gBhAd.Text();
    svgText.move(textPos.x, textPos.y);
    svgText.fill(text.color == "default" ? "black" : text.color);
    svgText.node.innerHTML = tspans.join("\n");
    svgText.attr("font-family", "Times New Roman");
    svgText.stroke("none");
    svgText.attr("font-size", fontSize);
    return svgText;
}
function $763663756c59a47c$var$wrapLabel(label, fontSize, maxWidth) {
    const words = label.split(" ");
    const completedLines = [];
    let nextLine = "";
    words.forEach((word, index)=>{
        const wordLength = $763663756c59a47c$var$getTextWidth(`${word} `, fontSize);
        const nextLineLength = $763663756c59a47c$var$getTextWidth(nextLine, fontSize);
        if (wordLength > maxWidth) {
            const { hyphenatedStrings: hyphenatedStrings, remainingWord: remainingWord } = $763663756c59a47c$var$breakString(word, fontSize, maxWidth);
            completedLines.push({
                text: nextLine,
                width: nextLineLength
            }, ...hyphenatedStrings);
            nextLine = remainingWord;
        } else if (nextLineLength + wordLength >= maxWidth) {
            completedLines.push({
                text: nextLine,
                width: nextLineLength
            });
            nextLine = word;
        } else nextLine = [
            nextLine,
            word
        ].filter(Boolean).join(" ");
        const currentWord = index + 1;
        const isLastWord = currentWord === words.length;
        if (isLastWord) completedLines.push({
            text: nextLine,
            width: $763663756c59a47c$var$getTextWidth(nextLine, fontSize)
        });
    });
    return completedLines.filter((line)=>line.text !== "");
}
function $763663756c59a47c$var$breakString(word, fontSize, maxWidth, hyphenCharacter = "-") {
    const characters = word.split("");
    const lines = [];
    let currentLine = "";
    characters.forEach((character, index)=>{
        const nextLine = `${currentLine}${character}`;
        const lineWidth = $763663756c59a47c$var$getTextWidth(nextLine, fontSize);
        if (lineWidth >= maxWidth) {
            const currentCharacter = index + 1;
            const isLastLine = characters.length === currentCharacter;
            const hyphenatedNextLine = `${nextLine}${hyphenCharacter}`;
            lines.push({
                text: isLastLine ? nextLine : hyphenatedNextLine,
                width: lineWidth
            });
            currentLine = "";
        } else currentLine = nextLine;
    });
    return {
        hyphenatedStrings: lines,
        remainingWord: currentLine
    };
}
function $763663756c59a47c$var$getTextWidth(text, fontSize) {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    context.font = `${fontSize} "Times New Roman"`;
    return context.measureText(text).width;
}




// @ts-ignore
window.mainController = (0, $177c4dcfaec5a17b$export$c323639e70153a25).instance;


//# sourceMappingURL=index.a82547ac.js.map
